import { createElement as _ } from 'react';
export const Icon3DGlasses = /*#__PURE__*/ (() => {
        function Icon3DGlassesSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 7h-20c-1.103 0-2 0.897-2 2v7c0 1.103 0.897 2 2 2h6.541c0.584 0 1.137-0.253 1.519-0.697l1.941-2.266 1.941 2.266c0.381 0.444 0.934 0.7 1.519 0.7h6.541c1.103 0 2-0.897 2-2v-7.003c0-1.103-0.897-2-2-2zM22 16h-6.541l-1.941-2.266c-0.381-0.444-0.934-0.697-1.519-0.697 0 0 0 0 0 0-0.584 0-1.137 0.253-1.519 0.697l-1.941 2.266c0 0 0 0 0 0h-6.541v-7h20v7z" }),
_('path', { d: "M3.5 15h4c0.156 0 0.306-0.075 0.4-0.2l3-4c0.113-0.15 0.131-0.353 0.047-0.525-0.084-0.169-0.259-0.275-0.447-0.275h-7c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5zM4 11h5.5l-2.25 3h-3.25v-3z" }),
_('path', { d: "M16.1 14.8c0.094 0.125 0.244 0.2 0.4 0.2h4c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5h-7c-0.191 0-0.363 0.106-0.447 0.275s-0.066 0.372 0.047 0.525l3 4zM20 11v3h-3.25l-2.25-3h5.5z" })
            );
        }
        function Icon3DGlasses({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Icon3DGlassesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Icon3DGlasses.SVG = Icon3DGlassesSVG;
        return Icon3DGlasses;
    })();
export const Accessibility = /*#__PURE__*/ (() => {
        function AccessibilitySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 7c1.103 0 2-0.897 2-2s-0.897-2-2-2c-1.103 0-2 0.897-2 2s0.897 2 2 2zM12 4c0.55 0 1 0.45 1 1s-0.45 1-1 1c-0.55 0-1-0.45-1-1s0.45-1 1-1z" }),
_('path', { d: "M18.316 7.95l-0.631-1.9-5.684 1.897-5.684-1.897-0.631 1.9 5.316 1.772v3.972l-4.078 5.994 1.656 1.125 3.422-5.034 3.422 5.034 1.656-1.125-4.078-5.994v-3.972z" }),
_('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.816s-2.384-1.966-3.816-2.572c-1.478-0.622-3.050-0.941-4.669-0.941s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.816 2.572s-1.966 2.384-2.572 3.816c-0.622 1.478-0.941 3.050-0.941 4.669s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.816s2.384 1.966 3.816 2.572c1.481 0.625 3.050 0.944 4.672 0.944 1.619 0 3.191-0.319 4.672-0.944 1.428-0.603 2.712-1.469 3.816-2.572s1.966-2.384 2.572-3.816c0.625-1.481 0.944-3.050 0.944-4.672-0.006-1.619-0.325-3.191-0.95-4.672zM12 23c-6.066 0-11-4.934-11-11s4.934-11 11-11c6.066 0 11 4.934 11 11s-4.934 11-11 11z" })
            );
        }
        function Accessibility({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AccessibilitySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Accessibility.SVG = AccessibilitySVG;
        return Accessibility;
    })();
export const Aim = /*#__PURE__*/ (() => {
    function AimSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 11h-2.050c-0.225-2.294-1.228-4.419-2.881-6.072-1.65-1.65-3.775-2.653-6.069-2.878v-2.050h-2v2.050c-2.294 0.225-4.419 1.228-6.072 2.881-1.65 1.65-2.653 3.775-2.878 6.069h-2.050v2h2.050c0.225 2.294 1.228 4.419 2.881 6.072 1.65 1.65 3.778 2.653 6.072 2.881v2.047h2v-2.050c2.294-0.225 4.419-1.228 6.072-2.881 1.65-1.65 2.653-3.778 2.881-6.072h2.044v-1.997zM19.938 11h-2.022c-0.422-2.509-2.409-4.494-4.916-4.916v-2.022c3.612 0.453 6.484 3.325 6.937 6.938zM11 11h-3.9c0.4-1.956 1.944-3.5 3.9-3.9v3.9zM11 13v3.9c-1.956-0.4-3.5-1.944-3.9-3.9h3.9zM13 13h3.9c-0.4 1.956-1.944 3.5-3.9 3.9v-3.9zM13 11v-3.9c1.956 0.4 3.5 1.944 3.9 3.9h-3.9zM11 4.062v2.022c-2.509 0.422-4.494 2.409-4.916 4.916h-2.022c0.453-3.612 3.325-6.484 6.938-6.938zM4.062 13h2.022c0.422 2.509 2.409 4.494 4.916 4.916v2.022c-3.612-0.453-6.484-3.325-6.938-6.937zM13 19.938v-2.022c2.509-0.422 4.494-2.409 4.916-4.916h2.022c-0.453 3.612-3.325 6.484-6.937 6.937z" })
        );
    }
    function Aim({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AimSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Aim.SVG = AimSVG;
    return Aim;
})();
export const AirplaneCross = /*#__PURE__*/ (() => {
        function AirplaneCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 13.5c0-2.528-1.45-4.722-3.563-5.797l1.022-0.981c0.003-0.003 0.009-0.009 0.012-0.012 0.513-0.513 1.287-1.659 1.797-2.666 0.322-0.631 0.537-1.197 0.644-1.675 0.181-0.819 0.053-1.459-0.387-1.9-0.438-0.438-1.075-0.566-1.894-0.384-0.478 0.106-1.041 0.322-1.675 0.644-1.006 0.509-2.15 1.281-2.663 1.794-0.006 0.006-0.009 0.009-0.016 0.016l-1.297 1.347c-1.831-0.456-7.625-1.806-12.547-1.884 0 0-0.003 0-0.003 0-0.534-0.006-1.059 0.206-1.437 0.588l-1.7 1.706c-0.241 0.241-0.344 0.591-0.269 0.925s0.312 0.606 0.634 0.722l1.975 0.719-0.841 0.841 0.706 0.706 1.172-1.172 1.162 0.422-1.041 1.044 0.706 0.706 1.375-1.372 1.163 0.422-1.244 1.244 0.706 0.706 1.572-1.572 2.209 0.803-6.288 7.125-3.134 0.447c-0.375 0.053-0.687 0.316-0.806 0.675s-0.025 0.756 0.241 1.022l5 5c0.191 0.191 0.447 0.294 0.706 0.294 0.106 0 0.213-0.016 0.316-0.050 0.359-0.119 0.619-0.431 0.675-0.806l0.447-3.138 4.197-3.703c0.956 1.994 2.903 3.428 5.197 3.663l0.131 0.363-1.169 1.172 0.706 0.706 0.841-0.841 0.719 1.975c0.116 0.322 0.391 0.559 0.722 0.634 0.072 0.016 0.144 0.025 0.216 0.025 0.263 0 0.519-0.103 0.706-0.294l1.703-1.703c0.378-0.378 0.594-0.903 0.588-1.437 0 0 0-0.003 0-0.003-0.012-0.706-0.050-1.469-0.116-2.266 1.306-1.191 2.122-2.9 2.122-4.797zM2.816 4.597l0.594-0.594c5.553 0.087 12.563 1.944 12.631 1.962 0.353 0.094 0.728-0.009 0.978-0.272l1.691-1.759c0.234-0.231 0.95-0.766 1.825-1.247 0.638-0.353 1.097-0.531 1.394-0.616-0.084 0.297-0.262 0.753-0.616 1.391-0.484 0.875-1.019 1.591-1.25 1.825l-1.756 1.694c-0.022 0.019-0.041 0.041-0.059 0.063-0.244-0.028-0.494-0.044-0.747-0.044-1.753 0-3.344 0.697-4.516 1.828-0.003-0.025-0.009-0.050-0.016-0.075-0.081-0.322-0.316-0.581-0.628-0.694l-9.525-3.462zM5.838 18.75c-0.178 0.156-0.294 0.372-0.328 0.609l-0.216 1.519-2.172-2.172 1.519-0.216c0.234-0.034 0.45-0.15 0.609-0.328l6.191-7.019c-0.284 0.731-0.441 1.525-0.441 2.356 0 0.225 0.012 0.447 0.034 0.666l-5.197 4.584zM12 13.5c0-3.031 2.469-5.5 5.5-5.5s5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5zM19.997 20.591l-0.594 0.594-0.487-1.341c0.359-0.081 0.709-0.191 1.044-0.328 0.019 0.372 0.031 0.731 0.038 1.075z" }),
_('path', { d: "M19.5 16.206l0.706-0.706-2-2 2-2-0.706-0.706-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2z" })
            );
        }
        function AirplaneCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AirplaneCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        AirplaneCross.SVG = AirplaneCrossSVG;
        return AirplaneCross;
    })();
export const Airplane = /*#__PURE__*/ (() => {
    function AirplaneSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.528 0.472c0 0 0-0.003 0 0-0.441-0.441-1.078-0.569-1.897-0.387-0.478 0.106-1.041 0.322-1.675 0.644-1.006 0.509-2.15 1.281-2.663 1.794-0.006 0.006-0.009 0.009-0.016 0.016l-1.297 1.347c-1.831-0.456-7.625-1.806-12.547-1.884 0 0-0.003 0-0.003 0-0.534-0.006-1.059 0.206-1.437 0.588l-1.7 1.706c-0.241 0.241-0.344 0.591-0.269 0.925s0.312 0.606 0.634 0.722l1.975 0.719-0.841 0.841 0.706 0.706 1.172-1.172 1.162 0.422-1.041 1.044 0.706 0.706 1.375-1.372 1.163 0.422-1.244 1.244 0.706 0.706 1.572-1.572 2.209 0.803-6.288 7.125-3.134 0.447c-0.375 0.053-0.687 0.316-0.806 0.675s-0.025 0.756 0.241 1.022l5 5c0.191 0.191 0.447 0.294 0.706 0.294 0.106 0 0.213-0.016 0.316-0.050 0.359-0.119 0.619-0.431 0.675-0.806l0.447-3.138 7.125-6.284 0.803 2.209-1.572 1.569 0.706 0.706 1.241-1.241 0.422 1.166-1.369 1.369 0.706 0.706 1.044-1.041 0.422 1.163-1.172 1.172 0.706 0.706 0.841-0.841 0.719 1.975c0.116 0.322 0.391 0.559 0.722 0.634 0.334 0.075 0.681-0.028 0.925-0.269l1.703-1.703c0.378-0.378 0.594-0.903 0.588-1.437 0 0 0-0.003 0-0.003-0.078-4.922-1.425-10.716-1.884-12.547l1.347-1.297c0.003-0.003 0.009-0.009 0.012-0.012 0.513-0.513 1.287-1.659 1.797-2.666 0.322-0.631 0.537-1.197 0.644-1.675 0.188-0.816 0.056-1.456-0.384-1.894zM21.316 3.462c-0.484 0.875-1.019 1.591-1.25 1.825l-1.756 1.694c-0.263 0.253-0.366 0.628-0.272 0.978 0.019 0.069 1.875 7.072 1.962 12.631l-0.594 0.594-3.466-9.525c-0.113-0.309-0.372-0.547-0.694-0.628-0.081-0.022-0.166-0.031-0.247-0.031-0.241 0-0.478 0.087-0.663 0.25l-8.5 7.5c-0.178 0.156-0.294 0.372-0.328 0.609l-0.216 1.519-2.172-2.172 1.519-0.216c0.234-0.034 0.45-0.15 0.609-0.328l7.5-8.5c0.219-0.247 0.3-0.588 0.219-0.909s-0.316-0.581-0.628-0.694l-9.525-3.462 0.594-0.594c5.553 0.087 12.563 1.944 12.631 1.962 0.353 0.094 0.728-0.009 0.978-0.272l1.691-1.759c0.234-0.231 0.95-0.766 1.825-1.247 0.638-0.353 1.097-0.531 1.394-0.616-0.084 0.297-0.262 0.753-0.612 1.391z" })
        );
    }
    function Airplane({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AirplaneSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Airplane.SVG = AirplaneSVG;
    return Airplane;
})();
export const AlarmCheck = /*#__PURE__*/ (() => {
        function AlarmCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.072 5.928c-1.891-1.887-4.4-2.928-7.072-2.928s-5.181 1.041-7.072 2.928c-1.887 1.891-2.928 4.4-2.928 7.072 0 2.572 0.966 4.997 2.725 6.862l-2.681 2.681 1.416 1.416 2.781-2.781c1.672 1.184 3.666 1.822 5.759 1.822s4.088-0.637 5.763-1.825l2.781 2.781 1.416-1.416-2.681-2.681c1.756-1.863 2.722-4.287 2.722-6.859 0-2.672-1.041-5.181-2.928-7.072zM4 13c0-4.413 3.588-8 8-8s8 3.588 8 8c0 4.413-3.588 8-8 8s-8-3.588-8-8z" }),
_('path', { d: "M7.853 2.053c0.094-0.094 0.147-0.222 0.147-0.353s-0.053-0.259-0.147-0.353c-1.794-1.791-4.713-1.791-6.503 0-0.869 0.869-1.35 2.025-1.35 3.253s0.478 2.384 1.35 3.253c0.094 0.094 0.222 0.147 0.353 0.147s0.259-0.053 0.353-0.147l5.797-5.8zM2.056 2.053c0.7-0.7 1.622-1.050 2.544-1.050 0.766 0 1.528 0.241 2.169 0.722l-5.041 5.044c-1.066-1.409-0.956-3.431 0.328-4.716z" }),
_('path', { d: "M22.653 1.35c-0.869-0.869-2.025-1.35-3.253-1.35s-2.384 0.478-3.253 1.35c-0.094 0.094-0.147 0.222-0.147 0.353s0.053 0.259 0.147 0.353l5.8 5.797c0.094 0.094 0.222 0.147 0.353 0.147v0c0.131 0 0.259-0.053 0.353-0.147 0.869-0.869 1.347-2.025 1.347-3.253 0.003-1.228-0.478-2.381-1.347-3.25zM22.275 6.769l-5.044-5.041c0.622-0.472 1.375-0.725 2.169-0.725 0.963 0 1.866 0.375 2.547 1.056 0.681 0.678 1.056 1.581 1.053 2.544 0 0.791-0.253 1.544-0.725 2.166z" }),
_('path', { d: "M9.997 14.584l-2.541-2.544-1.416 1.413 3.247 3.25c0.188 0.188 0.441 0.294 0.706 0.294v0c0.266 0 0.519-0.106 0.706-0.294l6.253-6.25-1.413-1.416-5.544 5.547z" })
            );
        }
        function AlarmCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AlarmCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        AlarmCheck.SVG = AlarmCheckSVG;
        return AlarmCheck;
    })();
export const AlarmCross = /*#__PURE__*/ (() => {
        function AlarmCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.072 5.928c-1.891-1.887-4.4-2.928-7.072-2.928s-5.181 1.041-7.072 2.928c-1.887 1.891-2.928 4.4-2.928 7.072 0 2.572 0.966 4.997 2.725 6.862l-2.681 2.681 1.416 1.416 2.781-2.781c1.672 1.184 3.666 1.822 5.759 1.822s4.088-0.637 5.763-1.825l2.781 2.781 1.416-1.416-2.681-2.681c1.756-1.863 2.722-4.287 2.722-6.859 0-2.672-1.041-5.181-2.928-7.072zM4 13c0-4.413 3.588-8 8-8s8 3.588 8 8c0 4.413-3.588 8-8 8s-8-3.588-8-8z" }),
_('path', { d: "M7.853 2.053c0.094-0.094 0.147-0.222 0.147-0.353s-0.053-0.259-0.147-0.353c-1.794-1.791-4.713-1.791-6.503 0-0.869 0.869-1.35 2.025-1.35 3.253s0.478 2.384 1.35 3.253c0.094 0.094 0.222 0.147 0.353 0.147s0.259-0.053 0.353-0.147l5.797-5.8zM2.056 2.053c0.7-0.7 1.622-1.050 2.544-1.050 0.766 0 1.528 0.241 2.169 0.722l-5.041 5.044c-1.066-1.409-0.956-3.431 0.328-4.716z" }),
_('path', { d: "M22.653 1.35c-0.869-0.869-2.025-1.35-3.253-1.35s-2.384 0.478-3.253 1.35c-0.094 0.094-0.147 0.222-0.147 0.353s0.053 0.259 0.147 0.353l5.8 5.797c0.094 0.094 0.222 0.147 0.353 0.147v0c0.131 0 0.259-0.053 0.353-0.147 0.869-0.869 1.347-2.025 1.347-3.253 0.003-1.228-0.478-2.381-1.347-3.25zM22.275 6.769l-5.044-5.041c0.622-0.472 1.375-0.725 2.169-0.725 0.963 0 1.866 0.375 2.547 1.056 0.681 0.678 1.056 1.581 1.053 2.544 0 0.791-0.253 1.544-0.725 2.166z" }),
_('path', { d: "M14.544 9.044l-2.544 2.541-2.544-2.541-1.413 1.413 2.541 2.544-2.541 2.544 1.413 1.413 2.544-2.541 2.544 2.541 1.413-1.413-2.541-2.544 2.541-2.544z" })
            );
        }
        function AlarmCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AlarmCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        AlarmCross.SVG = AlarmCrossSVG;
        return AlarmCross;
    })();
export const AlarmMinus = /*#__PURE__*/ (() => {
        function AlarmMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.072 5.928c-1.891-1.887-4.4-2.928-7.072-2.928s-5.181 1.041-7.072 2.928c-1.887 1.891-2.928 4.4-2.928 7.072 0 2.572 0.966 4.997 2.725 6.862l-2.681 2.681 1.416 1.416 2.781-2.781c1.672 1.184 3.666 1.822 5.759 1.822s4.088-0.637 5.763-1.825l2.781 2.781 1.416-1.416-2.681-2.681c1.756-1.863 2.722-4.287 2.722-6.859 0-2.672-1.041-5.181-2.928-7.072zM4 13c0-4.413 3.588-8 8-8s8 3.588 8 8c0 4.413-3.588 8-8 8s-8-3.588-8-8z" }),
_('path', { d: "M7.853 2.053c0.094-0.094 0.147-0.222 0.147-0.353s-0.053-0.259-0.147-0.353c-1.794-1.791-4.713-1.791-6.503 0-0.869 0.869-1.35 2.025-1.35 3.253s0.478 2.384 1.35 3.253c0.094 0.094 0.222 0.147 0.353 0.147s0.259-0.053 0.353-0.147l5.797-5.8zM2.056 2.053c0.7-0.7 1.622-1.050 2.544-1.050 0.766 0 1.528 0.241 2.169 0.722l-5.041 5.044c-1.066-1.409-0.956-3.431 0.328-4.716z" }),
_('path', { d: "M22.653 1.35c-0.869-0.869-2.025-1.35-3.253-1.35s-2.384 0.478-3.253 1.35c-0.094 0.094-0.147 0.222-0.147 0.353s0.053 0.259 0.147 0.353l5.8 5.797c0.094 0.094 0.222 0.147 0.353 0.147v0c0.131 0 0.259-0.053 0.353-0.147 0.869-0.869 1.347-2.025 1.347-3.253 0.003-1.228-0.478-2.381-1.347-3.25zM22.275 6.769l-5.044-5.041c0.622-0.472 1.375-0.725 2.169-0.725 0.963 0 1.866 0.375 2.547 1.056 0.681 0.678 1.056 1.581 1.053 2.544 0 0.791-0.253 1.544-0.725 2.166z" }),
_('path', { d: "M8 12h8v2h-8v-2z" })
            );
        }
        function AlarmMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AlarmMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        AlarmMinus.SVG = AlarmMinusSVG;
        return AlarmMinus;
    })();
export const AlarmPlus = /*#__PURE__*/ (() => {
        function AlarmPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.072 5.928c-1.891-1.887-4.4-2.928-7.072-2.928s-5.181 1.041-7.072 2.928c-1.887 1.891-2.928 4.4-2.928 7.072 0 2.572 0.966 4.997 2.725 6.862l-2.681 2.681 1.416 1.416 2.781-2.781c1.672 1.184 3.666 1.822 5.759 1.822s4.088-0.637 5.763-1.825l2.781 2.781 1.416-1.416-2.681-2.681c1.756-1.863 2.722-4.287 2.722-6.859 0-2.672-1.041-5.181-2.928-7.072zM4 13c0-4.413 3.588-8 8-8s8 3.588 8 8c0 4.413-3.588 8-8 8s-8-3.588-8-8z" }),
_('path', { d: "M7.853 2.053c0.094-0.094 0.147-0.222 0.147-0.353s-0.053-0.259-0.147-0.353c-1.794-1.791-4.713-1.791-6.503 0-0.869 0.869-1.35 2.025-1.35 3.253s0.478 2.384 1.35 3.253c0.094 0.094 0.222 0.147 0.353 0.147s0.259-0.053 0.353-0.147l5.797-5.8zM2.056 2.053c0.7-0.7 1.622-1.050 2.544-1.050 0.766 0 1.528 0.241 2.169 0.722l-5.041 5.044c-1.066-1.409-0.956-3.431 0.328-4.716z" }),
_('path', { d: "M22.653 1.35c-0.869-0.869-2.025-1.35-3.253-1.35s-2.384 0.478-3.253 1.35c-0.094 0.094-0.147 0.222-0.147 0.353s0.053 0.259 0.147 0.353l5.8 5.797c0.094 0.094 0.222 0.147 0.353 0.147v0c0.131 0 0.259-0.053 0.353-0.147 0.869-0.869 1.347-2.025 1.347-3.253 0.003-1.228-0.478-2.381-1.347-3.25zM22.275 6.769l-5.044-5.041c0.622-0.472 1.375-0.725 2.169-0.725 0.963 0 1.866 0.375 2.547 1.056 0.681 0.678 1.056 1.581 1.053 2.544 0 0.791-0.253 1.544-0.725 2.166z" }),
_('path', { d: "M13 9h-2v3h-3v2h3v3h2v-3h3v-2h-3z" })
            );
        }
        function AlarmPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AlarmPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        AlarmPlus.SVG = AlarmPlusSVG;
        return AlarmPlus;
    })();
export const Alarm = /*#__PURE__*/ (() => {
        function AlarmSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 4c-2.672 0-5.181 1.041-7.072 2.928-1.887 1.891-2.928 4.4-2.928 7.072s1.041 5.181 2.928 7.072c1.891 1.887 4.4 2.928 7.072 2.928s5.181-1.041 7.072-2.928c1.887-1.891 2.928-4.4 2.928-7.072s-1.041-5.181-2.928-7.072c-1.891-1.887-4.4-2.928-7.072-2.928zM12 22c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M16.5 8.794l-4.241 4.241c-0.081-0.022-0.169-0.034-0.259-0.034-0.147 0-0.288 0.031-0.413 0.091l-3.203-2.288-0.581 0.813 3.203 2.287c-0.003 0.031-0.003 0.063-0.003 0.097 0 0.55 0.45 1 1 1s1-0.45 1-1c0-0.091-0.012-0.175-0.034-0.259l4.238-4.241-0.706-0.706z" }),
_('path', { d: "M22.65 1.347c-1.791-1.791-4.709-1.791-6.503 0-0.094 0.094-0.147 0.222-0.147 0.353s0.053 0.259 0.147 0.353l5.797 5.8c0.094 0.094 0.222 0.147 0.353 0.147 0 0 0 0 0 0 0.131 0 0.259-0.053 0.353-0.147 0.869-0.869 1.35-2.025 1.35-3.253s-0.481-2.384-1.35-3.253zM22.272 6.769l-5.041-5.044c1.409-1.062 3.428-0.953 4.713 0.328 1.284 1.284 1.394 3.306 0.328 4.716z" }),
_('path', { d: "M7.853 2.056c0.094-0.094 0.147-0.222 0.147-0.353s-0.053-0.259-0.147-0.353c-0.869-0.869-2.025-1.35-3.253-1.35s-2.384 0.481-3.253 1.35c-0.869 0.869-1.35 2.025-1.347 3.253 0 1.228 0.478 2.381 1.347 3.25 0.094 0.094 0.222 0.147 0.353 0.147v0c0.131 0 0.259-0.053 0.353-0.147l5.8-5.797zM2.053 2.056c0.703-0.703 1.625-1.053 2.547-1.053 0.766 0 1.528 0.241 2.169 0.725l-5.044 5.041c-1.062-1.409-0.953-3.431 0.328-4.713z" })
            );
        }
        function Alarm({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AlarmSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Alarm.SVG = AlarmSVG;
        return Alarm;
    })();
export const Alarm2 = /*#__PURE__*/ (() => {
        function Alarm2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.072 5.928c-1.891-1.887-4.4-2.928-7.072-2.928s-5.181 1.041-7.072 2.928c-1.887 1.891-2.928 4.4-2.928 7.072 0 2.572 0.966 4.997 2.725 6.862l-2.681 2.681 1.416 1.416 2.781-2.781c1.672 1.184 3.666 1.822 5.759 1.822s4.088-0.637 5.763-1.825l2.781 2.781 1.416-1.416-2.681-2.681c1.756-1.863 2.722-4.287 2.722-6.859 0-2.672-1.041-5.181-2.928-7.072zM4 13c0-4.413 3.588-8 8-8s8 3.588 8 8c0 4.413-3.588 8-8 8s-8-3.588-8-8z" }),
_('path', { d: "M7.853 2.053c0.094-0.094 0.147-0.222 0.147-0.353s-0.053-0.259-0.147-0.353c-1.794-1.791-4.713-1.791-6.503 0-0.869 0.869-1.35 2.025-1.35 3.253s0.478 2.384 1.35 3.253c0.094 0.094 0.222 0.147 0.353 0.147s0.259-0.053 0.353-0.147l5.797-5.8zM2.056 2.053c0.7-0.7 1.622-1.050 2.544-1.050 0.766 0 1.528 0.241 2.169 0.722l-5.041 5.044c-1.066-1.409-0.956-3.431 0.328-4.716z" }),
_('path', { d: "M22.653 1.35c-0.869-0.869-2.025-1.35-3.253-1.35s-2.384 0.478-3.253 1.35c-0.094 0.094-0.147 0.222-0.147 0.353s0.053 0.259 0.147 0.353l5.8 5.797c0.094 0.094 0.222 0.147 0.353 0.147v0c0.131 0 0.259-0.053 0.353-0.147 0.869-0.869 1.347-2.025 1.347-3.253 0.003-1.228-0.478-2.381-1.347-3.25zM22.275 6.769l-5.044-5.041c0.622-0.472 1.375-0.725 2.169-0.725 0.963 0 1.866 0.375 2.547 1.056 0.681 0.678 1.056 1.581 1.053 2.544 0 0.791-0.253 1.544-0.725 2.166z" }),
_('path', { d: "M11.909 12.912l-4.662-2.072-0.406 0.912 4.956 2.203c0.066 0.028 0.134 0.044 0.203 0.044 0.119 0 0.237-0.044 0.331-0.125l4.875-4.331-0.666-0.747-4.631 4.116z" })
            );
        }
        function Alarm2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Alarm2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Alarm2.SVG = Alarm2SVG;
        return Alarm2;
    })();
export const Album = /*#__PURE__*/ (() => {
        function AlbumSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 5c0-1.103-0.897-2-2-2 0-1.103-0.897-2-2-2h-8c-1.103 0-2 0.897-2 2-1.103 0-2 0.897-2 2-1.103 0-2 0.897-2 2v14c0 1.103 0.897 2 2 2h16c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM8 2h8c0.55 0 1 0.45 1 1h-10c0-0.55 0.45-1 1-1zM6 4h12c0.55 0 1 0.45 1 1h-14c0-0.55 0.45-1 1-1zM20 21h-16v-14h16v14c0 0 0 0 0 0z" }),
_('path', { d: "M16 11.5c0-0.237-0.169-0.444-0.403-0.491l-5-1c-0.147-0.028-0.3 0.009-0.416 0.103s-0.184 0.237-0.184 0.387v3.634c-0.353-0.125-0.769-0.166-1.188-0.109-1.113 0.15-1.906 0.916-1.803 1.741 0.041 0.325 0.213 0.612 0.497 0.834 0.334 0.256 0.806 0.397 1.309 0.397 0.122 0 0.247-0.009 0.372-0.025 1.056-0.144 1.825-0.841 1.812-1.616v-4.247l4 0.8v3.225c-0.353-0.125-0.769-0.166-1.188-0.109-1.113 0.15-1.906 0.916-1.803 1.741 0.041 0.325 0.213 0.612 0.497 0.834 0.334 0.256 0.806 0.397 1.309 0.397 0.122 0 0.247-0.009 0.372-0.025 1.056-0.144 1.822-0.841 1.812-1.616v-4.856zM9.053 15.984c-0.369 0.050-0.734-0.019-0.938-0.172-0.047-0.038-0.106-0.094-0.116-0.162-0.025-0.197 0.341-0.547 0.947-0.631 0.081-0.009 0.159-0.016 0.241-0.016 0.281 0 0.541 0.069 0.697 0.191 0.047 0.037 0.106 0.094 0.116 0.162 0.022 0.194-0.344 0.544-0.947 0.628zM14.053 16.984c-0.369 0.050-0.734-0.019-0.938-0.172-0.047-0.038-0.106-0.094-0.116-0.162-0.025-0.197 0.341-0.547 0.947-0.631 0.081-0.009 0.159-0.016 0.241-0.016 0.281 0 0.541 0.069 0.697 0.191 0.047 0.038 0.106 0.094 0.116 0.162 0.022 0.194-0.344 0.544-0.947 0.628z" })
            );
        }
        function Album({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AlbumSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Album.SVG = AlbumSVG;
        return Album;
    })();
export const Alien = /*#__PURE__*/ (() => {
        function AlienSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.072 2.928c-1.891-1.887-4.4-2.928-7.072-2.928s-5.181 1.041-7.072 2.928c-1.887 1.891-2.928 4.4-2.928 7.072 0 2.709 1.069 6.116 2.787 8.891 0.928 1.497 1.972 2.697 3.1 3.569 1.325 1.022 2.709 1.541 4.113 1.541s2.787-0.519 4.113-1.541c1.128-0.872 2.172-2.072 3.1-3.569 1.719-2.775 2.787-6.181 2.787-8.891 0-2.672-1.041-5.181-2.928-7.072zM12 22c-4.263 0-8-7.478-8-12 0-4.413 3.588-8 8-8s8 3.588 8 8c0 4.522-3.738 12-8 12z" }),
_('path', { d: "M11 13.5c0-2.219-0.578-3.719-1.766-4.591-1.094-0.8-2.5-0.909-3.734-0.909-0.275 0-0.5 0.225-0.5 0.5 0 2.053 0.506 3.484 1.55 4.378 0.891 0.766 2.147 1.122 3.95 1.122 0.275 0 0.5-0.225 0.5-0.5zM6.012 9.009c0.931 0.031 1.903 0.175 2.631 0.706 0.828 0.606 1.272 1.681 1.347 3.275-2.294-0.097-3.831-0.909-3.978-3.981z" }),
_('path', { d: "M18.5 8c-1.234 0-2.641 0.109-3.734 0.909-1.188 0.872-1.766 2.372-1.766 4.591 0 0.275 0.225 0.5 0.5 0.5 1.803 0 3.059-0.356 3.95-1.122 1.044-0.894 1.55-2.325 1.55-4.378 0-0.275-0.225-0.5-0.5-0.5zM14.013 12.991c0.075-1.594 0.519-2.666 1.347-3.275 0.725-0.531 1.7-0.675 2.631-0.706-0.15 3.072-1.688 3.884-3.978 3.981z" }),
_('path', { d: "M10 17h4v1h-4v-1z" })
            );
        }
        function Alien({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AlienSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Alien.SVG = AlienSVG;
        return Alien;
    })();
export const AlignBottom = /*#__PURE__*/ (() => {
        function AlignBottomSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 20h6c1.103 0 2-0.897 2-2v-8c0-1.103-0.897-2-2-2h-6c-1.103 0-2 0.897-2 2v8c0 1.103 0.897 2 2 2zM14 10h6v8l-6 0.003c0 0 0 0 0-0.003v-8z" }),
_('path', { d: "M2.5 20h7c0.275 0 0.5-0.225 0.5-0.5v-18c0-0.275-0.225-0.5-0.5-0.5h-7c-0.275 0-0.5 0.225-0.5 0.5v18c0 0.275 0.225 0.5 0.5 0.5zM3 2h6v17h-6v-17z" }),
_('path', { d: "M0 22h24v1h-24v-1z" })
            );
        }
        function AlignBottom({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AlignBottomSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        AlignBottom.SVG = AlignBottomSVG;
        return AlignBottom;
    })();
export const AlignCenterHorizontal = /*#__PURE__*/ (() => {
    function AlignCenterHorizontalSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 12h-2v-3c0-1.103-0.897-2-2-2h-6c-1.103 0-2 0.897-2 2v3h-2v-8.5c0-0.275-0.225-0.5-0.5-0.5h-7c-0.275 0-0.5 0.225-0.5 0.5v8.5h-2v1h2v8.5c0 0.275 0.225 0.5 0.5 0.5h7c0.275 0 0.5-0.225 0.5-0.5v-8.5h2v3c0 1.103 0.897 2 2 2h6c1.103 0 2-0.897 2-2v-3h2v-1zM3 4h6v8h-6v-8zM9 21h-6v-8h6v8zM13.997 9c0 0 0.003 0 0 0h6.003v3h-6l-0.003-3zM20 16h-6v-3h6v3z" })
        );
    }
    function AlignCenterHorizontal({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AlignCenterHorizontalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    AlignCenterHorizontal.SVG = AlignCenterHorizontalSVG;
    return AlignCenterHorizontal;
})();
export const AlignCenterVertical = /*#__PURE__*/ (() => {
    function AlignCenterVerticalSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.5 14h-8.5v-2h3c1.103 0 2-0.897 2-2v-6c0-1.103-0.897-2-2-2h-3v-2h-1v2h-3c-1.103 0-2 0.897-2 2v6c0 1.103 0.897 2 2 2h3v2h-8.5c-0.275 0-0.5 0.225-0.5 0.5v7c0 0.275 0.225 0.5 0.5 0.5h8.5v2h1v-2h8.5c0.275 0 0.5-0.225 0.5-0.5v-7c0-0.275-0.225-0.5-0.5-0.5zM15 4l0.003 6c0 0 0 0-0.003 0h-3v-6h3zM8 10v-6h3v6h-3zM3 21v-6h8v6h-8zM20 21h-8v-6h8v6z" })
        );
    }
    function AlignCenterVertical({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AlignCenterVerticalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    AlignCenterVertical.SVG = AlignCenterVerticalSVG;
    return AlignCenterVertical;
})();
export const AlignLeft = /*#__PURE__*/ (() => {
        function AlignLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 12h8c1.103 0 2-0.897 2-2v-6c0-1.103-0.897-2-2-2h-8c-1.103 0-2 0.897-2 2v6c0 1.103 0.897 2 2 2zM6 4h8v6h-8v-6c-0.003 0 0 0 0 0z" }),
_('path', { d: "M22.5 14h-18c-0.275 0-0.5 0.225-0.5 0.5v7c0 0.275 0.225 0.5 0.5 0.5h18c0.275 0 0.5-0.225 0.5-0.5v-7c0-0.275-0.225-0.5-0.5-0.5zM22 21h-17v-6h17v6z" }),
_('path', { d: "M1 0h1v24h-1v-24z" })
            );
        }
        function AlignLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AlignLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        AlignLeft.SVG = AlignLeftSVG;
        return AlignLeft;
    })();
export const AlignRight = /*#__PURE__*/ (() => {
        function AlignRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 2h-8c-1.103 0-2 0.897-2 2v6c0 1.103 0.897 2 2 2h8c1.103 0 2-0.897 2-2v-6c0-1.103-0.897-2-2-2zM18 10h-8v-6h8v6c0.003 0 0 0 0 0z" }),
_('path', { d: "M19.5 14h-18c-0.275 0-0.5 0.225-0.5 0.5v7c0 0.275 0.225 0.5 0.5 0.5h18c0.275 0 0.5-0.225 0.5-0.5v-7c0-0.275-0.225-0.5-0.5-0.5zM19 21h-17v-6h17v6z" }),
_('path', { d: "M22 0h1v24h-1v-24z" })
            );
        }
        function AlignRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AlignRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        AlignRight.SVG = AlignRightSVG;
        return AlignRight;
    })();
export const AlignTop = /*#__PURE__*/ (() => {
        function AlignTopSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 4h-6c-1.103 0-2 0.897-2 2v8c0 1.103 0.897 2 2 2h6c1.103 0 2-0.897 2-2v-8c0-1.103-0.897-2-2-2zM20 14h-6l-0.003-8c0 0 0 0 0.003 0h6v8z" }),
_('path', { d: "M9.5 4h-7c-0.275 0-0.5 0.225-0.5 0.5v18c0 0.275 0.225 0.5 0.5 0.5h7c0.275 0 0.5-0.225 0.5-0.5v-18c0-0.275-0.225-0.5-0.5-0.5zM9 22h-6v-17h6v17z" }),
_('path', { d: "M0 1h24v1h-24v-1z" })
            );
        }
        function AlignTop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AlignTopSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        AlignTop.SVG = AlignTopSVG;
        return AlignTop;
    })();
export const Ambulance = /*#__PURE__*/ (() => {
        function AmbulanceSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.793 2.501l0.707-0.707 1.708 1.708-0.707 0.707-1.708-1.708z" }),
_('path', { d: "M16 0h1v3h-1v-3z" }),
_('path', { d: "M18.793 3.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M22.894 11.831l-1.15-0.575-1.575-3.147c-0.341-0.684-1.025-1.106-1.788-1.106h-0.381v-0.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5v0.5c-0.363 0-0.706 0.097-1 0.269-0.294-0.172-0.637-0.269-1-0.269h-11c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h1.5v-0.003c0.456 0.606 1.184 1.003 2 1.003s1.544-0.394 2-1h5.5c0.363 0 0.706-0.097 1-0.269 0.294 0.172 0.638 0.269 1 0.269h1.5v-0.003c0.456 0.606 1.184 1.003 2 1.003s1.544-0.394 2-1.003v0.003h1.5c1.103 0 2-0.897 2-2v-5.384c0-0.75-0.434-1.453-1.106-1.788zM19.881 12h-2.881v-1h2.381l0.5 1zM16 6.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v0.5h-1v-0.5zM5.5 21c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM7.95 19c-0.231-1.141-1.244-2-2.45-2s-2.219 0.859-2.45 2h-1.050v-10h11v10h-5.050zM18.5 21c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM20.95 19c-0.231-1.141-1.244-2-2.45-2s-2.219 0.859-2.45 2h-1.050v-10h3.381c0 0 0 0 0 0l0.5 1h-2.381c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h4.263l1.238 0.619v1.381h-1v1h1v3h-1.050z" }),
_('path', { d: "M9 11h-1v2h-2v1h2v2h1v-2h2v-1h-2z" })
            );
        }
        function Ambulance({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AmbulanceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ambulance.SVG = AmbulanceSVG;
        return Ambulance;
    })();
export const Anchor = /*#__PURE__*/ (() => {
    function AnchorSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.847 13.597c-0.597-0.944-1.219-1.378-1.287-1.425-0.306-0.206-0.703-0.225-1.028-0.053-0.325 0.175-0.531 0.513-0.531 0.881v1c0 2.438-0.678 6.416-5 6.941v-10.941h3v-2h-3v-2.172c1.162-0.412 2-1.525 2-2.828 0-1.653-1.347-3-3-3s-3 1.347-3 3c0 1.303 0.837 2.416 2 2.828v2.172h-3v2h3v10.941c-4.322-0.525-5-4.503-5-6.941v-1c0-0.369-0.203-0.709-0.531-0.881-0.325-0.175-0.722-0.153-1.028 0.053-0.069 0.047-0.694 0.481-1.287 1.425-0.525 0.834-1.153 2.275-1.153 4.403h2c0-0.619 0.063-1.194 0.184-1.722 0.269 1.572 0.831 2.928 1.662 3.994 0.681 0.875 1.538 1.55 2.547 2.009 0.781 0.356 1.653 0.581 2.606 0.672v1.047h2v-1.047c0.95-0.091 1.825-0.316 2.606-0.672 1.009-0.459 1.866-1.134 2.547-2.009 0.828-1.066 1.391-2.422 1.662-3.994 0.125 0.528 0.184 1.103 0.184 1.722h2c0-2.128-0.628-3.569-1.153-4.403zM10 3c0-1.103 0.897-2 2-2s2 0.897 2 2-0.897 2-2 2c-1.103 0-2-0.897-2-2z" })
        );
    }
    function Anchor({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AnchorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Anchor.SVG = AnchorSVG;
    return Anchor;
})();
export const Angle = /*#__PURE__*/ (() => {
        function AngleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 19h-11.381c-0.275-1.228-0.694-2.422-1.263-3.569-0.566-1.144-1.272-2.222-2.094-3.206l8.734-9.809-1.494-1.331-8.622 9.684c-0.3-0.278-0.609-0.547-0.928-0.8l-0.391-0.312-0.622 0.781 0.391 0.312c0.306 0.244 0.603 0.5 0.888 0.762l-6.966 7.822c-0.262 0.294-0.328 0.716-0.166 1.075s0.519 0.591 0.912 0.591h10.925c0.050 0.494 0.075 0.997 0.075 1.5v0.5h1v-0.5c0-0.503-0.022-1.003-0.069-1.5h11.069v-2zM3.228 19l5.366-6.025c1.45 1.756 2.472 3.813 2.997 6.025h-8.363z" }),
_('path', { d: "M16 10c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2c0-1.103-0.897-2-2-2zM16 13c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
            );
        }
        function Angle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AngleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Angle.SVG = AngleSVG;
        return Angle;
    })();
export const Angle2 = /*#__PURE__*/ (() => {
        function Angle2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 19h-11.381c-0.275-1.228-0.694-2.422-1.263-3.569-0.566-1.144-1.272-2.222-2.094-3.206l8.734-9.809-1.494-1.331-8.622 9.684c-0.3-0.278-0.609-0.547-0.928-0.8l-0.391-0.312-0.622 0.781 0.391 0.312c0.306 0.244 0.603 0.5 0.888 0.762l-6.966 7.822c-0.262 0.294-0.328 0.716-0.166 1.075s0.519 0.591 0.912 0.591h10.925c0.050 0.494 0.075 0.997 0.075 1.5v0.5h1v-0.5c0-0.503-0.022-1.003-0.069-1.5h11.069v-2zM3.228 19l5.366-6.025c1.45 1.756 2.472 3.813 2.997 6.025h-8.363z" }),
_('path', { d: "M16.781 10.65c-0.175-0.297-0.537-0.65-1.281-0.65h-0.5v1h0.5c0.328 0 0.394 0.113 0.419 0.153 0.059 0.1 0.216 0.522-0.234 1.741-0.269 0.728-0.616 1.353-0.619 1.359-0.128 0.231-0.056 0.519 0.162 0.663 0.084 0.053 0.178 0.081 0.272 0.081 0.153 0 0.303-0.069 0.4-0.2l1.109-1.478c-0.022 0.416 0.050 0.756 0.209 1.028 0.175 0.297 0.537 0.65 1.281 0.65h0.5v-1h-0.5c-0.328 0-0.394-0.113-0.419-0.153-0.059-0.1-0.216-0.522 0.234-1.741 0.269-0.728 0.616-1.353 0.619-1.359 0.128-0.231 0.056-0.519-0.162-0.663-0.222-0.144-0.516-0.091-0.672 0.119l-1.109 1.478c0.022-0.416-0.047-0.756-0.209-1.028z" }),
_('path', { d: "M21.5 11c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM21.5 9c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" })
            );
        }
        function Angle2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Angle2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Angle2.SVG = Angle2SVG;
        return Angle2;
    })();
export const Angry = /*#__PURE__*/ (() => {
        function AngrySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M17.541 13.281c-1.516-0.825-3.484-1.281-5.541-1.281s-4.028 0.456-5.541 1.281c-0.744 0.406-1.338 0.878-1.759 1.403-0.466 0.578-0.7 1.188-0.7 1.816 0 0.275 0.225 0.5 0.5 0.5h15c0.275 0 0.5-0.225 0.5-0.5 0-0.628-0.234-1.237-0.7-1.816-0.422-0.525-1.012-0.997-1.759-1.403zM14 13.156v2.844h-4v-2.844c0.644-0.103 1.316-0.156 2-0.156s1.356 0.053 2 0.156zM6.938 14.159c0.612-0.334 1.309-0.6 2.063-0.794v2.634h-3.916c0.225-0.656 0.872-1.306 1.853-1.841zM15 16v-2.634c0.753 0.194 1.45 0.459 2.063 0.794 0.981 0.534 1.628 1.184 1.85 1.841h-3.912z" }),
_('path', { d: "M7.381 7.503c-0.237 0.266-0.381 0.616-0.381 0.997 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.181-0.031-0.356-0.091-0.516 0.194 0.009 0.394 0.016 0.591 0.016h0.5v-1h-0.5c-1.437 0-2.816-0.325-3.784-0.894l-0.431-0.253-0.506 0.863 0.431 0.253c0.356 0.209 0.747 0.387 1.172 0.534zM8.5 9c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M14.094 7.981c-0.059 0.162-0.094 0.337-0.094 0.519 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.387-0.147-0.741-0.387-1.006 0.413-0.147 0.794-0.322 1.141-0.525l0.431-0.253-0.506-0.862-0.431 0.253c-0.969 0.569-2.347 0.894-3.784 0.894h-0.5v1h0.5c0.213 0 0.422-0.006 0.631-0.019zM15.5 9c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" })
            );
        }
        function Angry({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AngrySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Angry.SVG = AngrySVG;
        return Angry;
    })();
export const Antenna = /*#__PURE__*/ (() => {
        function AntennaSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8.341 6.553l-0.791-0.612-0.306 0.397c-1.666 2.156-1.666 5.169 0 7.328l0.306 0.397 0.791-0.612-0.306-0.397c-1.388-1.797-1.388-4.306 0-6.103l0.306-0.397z" }),
_('path', { d: "M5.9 4.825l0.325-0.381-0.762-0.647-0.325 0.381c-1.375 1.619-2.134 3.687-2.134 5.822s0.759 4.203 2.137 5.822l0.325 0.381 0.762-0.647-0.325-0.381c-2.55-2.997-2.55-7.35-0.003-10.35z" }),
_('path', { d: "M3.759 2.716l0.331-0.375-0.75-0.663-0.331 0.375c-4.013 4.531-4.013 11.362 0 15.894l0.331 0.375 0.75-0.663-0.331-0.375c-3.678-4.153-3.678-10.416 0-14.569z" }),
_('path', { d: "M12 7c-1.653 0-3 1.347-3 3 0 1.303 0.837 2.416 2 2.828v9.172h2v-9.172c1.162-0.413 2-1.525 2-2.828 0-1.653-1.347-3-3-3zM12 11c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M16.753 6.337l-0.306-0.397-0.791 0.612 0.306 0.397c1.391 1.797 1.391 4.306 0 6.103l-0.306 0.397 0.791 0.612 0.306-0.397c1.666-2.156 1.666-5.172 0-7.328z" }),
_('path', { d: "M18.862 4.175l-0.325-0.381-0.762 0.647 0.325 0.381c2.55 3 2.547 7.353-0.003 10.353l-0.325 0.381 0.762 0.647 0.325-0.381c1.378-1.619 2.137-3.687 2.137-5.822 0.003-2.134-0.756-4.203-2.134-5.825z" }),
_('path', { d: "M20.991 2.053l-0.331-0.375-0.75 0.663 0.331 0.375c3.678 4.153 3.678 10.416 0 14.569l-0.331 0.375 0.75 0.663 0.331-0.375c4.012-4.531 4.012-11.363 0-15.894z" })
            );
        }
        function Antenna({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AntennaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Antenna.SVG = AntennaSVG;
        return Antenna;
    })();
export const Anvil = /*#__PURE__*/ (() => {
    function AnvilSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21 10c0.378 0 0.725-0.213 0.894-0.553l2-4c0.156-0.309 0.138-0.678-0.044-0.972s-0.503-0.475-0.85-0.475h-15c-0.738 0-1.384 0.403-1.731 1h-5.269c-0.553 0-1 0.447-1 1 0 0.788 0.181 1.516 0.541 2.163 0.35 0.631 0.859 1.172 1.512 1.606 1.209 0.806 2.922 1.231 4.947 1.231h0.5c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5h-0.5c-1.103 0-2 0.897-2 2v1.5c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-1.5c0-1.103-0.897-2-2-2-1.653 0-3-1.347-3-3s1.347-3 3-3zM3.159 8.103c-0.459-0.306-0.781-0.672-0.966-1.103h4.806v2c-1.631 0-2.959-0.309-3.841-0.897zM21 19h-14v-1h14v1zM16 13c0 1.125 0.372 2.163 1.003 3h-5.763c0.481-0.716 0.759-1.575 0.759-2.5 0-2.313-1.753-4.222-4-4.472v-3.028h13.381l-1.019 2.041c-2.456 0.316-4.362 2.419-4.362 4.959z" })
        );
    }
    function Anvil({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AnvilSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Anvil.SVG = AnvilSVG;
    return Anvil;
})();
export const AppleCheck = /*#__PURE__*/ (() => {
        function AppleCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1.2 8.275c0.684-0.912 1.662-1.644 2.906-2.172 1.5-0.641 3.384-0.997 5.734-1.081 0.003-0.009 0.006-0.019 0.012-0.028 0.772-1.837 1.928-2.862 3.356-2.988 0.194-0.291 0.569-0.778 1.153-1.197 0.822-0.588 2.225-1.156 4.256-0.55 1.672 0.5 3.125 1.537 4.206 2.991 0.819 1.103 1.137 2.053 1.15 2.094 0.075 0.228-0.022 0.475-0.228 0.594-0.078 0.044-0.162 0.066-0.244 0.066-0.144 0-0.281-0.059-0.381-0.175-0.922-1.078-1.713-1.659-2.419-1.775-0.597-0.097-1.122 0.134-1.728 0.4-0.681 0.3-1.456 0.641-2.425 0.513-1.025-0.138-2.059-0.762-3.25-1.959-1.069 0.097-1.828 0.944-2.347 1.997 0.016 0 0.031 0 0.047 0 2.319 0 4.244 0.444 5.722 1.316 0.903 0.534 1.631 1.228 2.166 2.066 0.563 0.878 0.916 1.919 1.050 3.094 2.381 0.963 4.062 3.3 4.062 6.022 0 3.584-2.916 6.5-6.5 6.5-1.291 0-2.491-0.378-3.503-1.028-1.266 0.681-2.609 1.028-3.997 1.028-2.769 0-5.344-1.338-7.25-3.766-1.747-2.228-2.75-5.178-2.75-8.097 0-1.503 0.403-2.803 1.2-3.863zM18.572 3.537c0.569-0.25 1.156-0.509 1.844-0.509 0.144 0 0.294 0.012 0.447 0.038 0.225 0.037 0.447 0.1 0.675 0.194-0.731-0.806-1.769-1.609-3.203-2.037-2.459-0.738-3.75 0.581-4.2 1.203 2.156 2.116 3.219 1.65 4.437 1.113zM23 17.5c0-3.031-2.469-5.5-5.5-5.5s-5.5 2.469-5.5 5.5 2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5zM10 22c0.819 0 1.622-0.159 2.397-0.478-0.875-1.106-1.397-2.503-1.397-4.022 0-3.584 2.916-6.5 6.5-6.5 0.113 0 0.225 0.003 0.334 0.009-0.297-1.325-1-2.303-2.131-2.972-1.162-0.687-2.747-1.038-4.703-1.038-0.253 0-0.497 0.003-0.738 0.009-0.181 0.794-0.262 1.528-0.262 1.991v0.006c0.722 0 1.441-0.3 2.187-0.897l0.391-0.312 0.625 0.781-0.391 0.312c-0.919 0.738-1.866 1.109-2.813 1.109s-1.894-0.375-2.813-1.109l-0.391-0.312 0.625-0.781 0.391 0.312c0.403 0.322 0.8 0.559 1.191 0.706 0.016-0.409 0.078-1.041 0.225-1.763-4.859 0.312-7.228 1.981-7.228 5.084 0 4.763 3.216 9.862 8 9.862z" }),
_('path', { d: "M16.5 18.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4z" })
            );
        }
        function AppleCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AppleCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        AppleCheck.SVG = AppleCheckSVG;
        return AppleCheck;
    })();
export const Apple = /*#__PURE__*/ (() => {
        function AppleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1.2 8.275c0.684-0.912 1.662-1.644 2.906-2.172 1.503-0.641 3.387-0.997 5.734-1.081 0.003-0.009 0.006-0.019 0.012-0.028 0.772-1.837 1.928-2.862 3.356-2.984 0.194-0.291 0.569-0.778 1.153-1.197 0.822-0.588 2.228-1.159 4.259-0.55 1.672 0.5 3.125 1.534 4.206 2.991 0.816 1.1 1.134 2.050 1.147 2.091 0.075 0.228-0.022 0.475-0.231 0.594-0.078 0.044-0.162 0.066-0.244 0.066-0.144 0-0.281-0.059-0.381-0.175-0.922-1.078-1.713-1.659-2.419-1.775-0.597-0.097-1.122 0.134-1.728 0.4-0.681 0.3-1.456 0.641-2.425 0.513-1.025-0.138-2.059-0.762-3.25-1.959-1.069 0.097-1.828 0.944-2.347 1.997 0.016 0 0.031 0 0.047 0 2.503 0 4.541 0.513 6.056 1.525 0.931 0.622 1.653 1.434 2.15 2.409 0.528 1.041 0.797 2.278 0.797 3.675 0 2.581-1.028 5.419-2.753 7.587-1.95 2.45-4.522 3.8-7.247 3.8-2.769 0-5.344-1.338-7.25-3.766-1.747-2.228-2.75-5.178-2.75-8.094 0-1.506 0.403-2.803 1.2-3.866zM18.572 3.537c0.569-0.25 1.156-0.509 1.844-0.509 0.144 0 0.294 0.012 0.447 0.038 0.225 0.037 0.453 0.103 0.681 0.197-0.884-0.984-1.962-1.669-3.209-2.044-2.459-0.738-3.75 0.581-4.2 1.206 2.156 2.116 3.219 1.65 4.437 1.113zM10 22c2.103 0 4.119-1.081 5.681-3.047 1.453-1.828 2.319-4.197 2.319-6.344 0-3.722-2.356-5.609-7-5.609-0.253 0-0.497 0.003-0.738 0.009-0.181 0.794-0.263 1.528-0.263 1.991v0.006c0.722 0 1.441-0.3 2.187-0.897l0.391-0.312 0.625 0.781-0.391 0.312c-0.922 0.738-1.866 1.109-2.813 1.109s-1.891-0.372-2.812-1.109l-0.391-0.312 0.625-0.781 0.391 0.312c0.403 0.322 0.8 0.559 1.191 0.706 0.016-0.409 0.078-1.041 0.225-1.762-1.775 0.112-3.203 0.406-4.338 0.891-1.972 0.841-2.891 2.175-2.891 4.197 0 4.759 3.216 9.859 8 9.859z" }),
_('path', { d: "M15.959 11.578c0.028 0.169 0.041 0.359 0.041 0.559 0 1.425-0.334 2.859-0.966 4.141l-0.222 0.447 0.897 0.444 0.222-0.447c0.7-1.419 1.069-3.003 1.069-4.584 0-0.256-0.019-0.497-0.053-0.719l-0.078-0.494-0.987 0.156 0.078 0.497z" })
            );
        }
        function Apple({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AppleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Apple.SVG = AppleSVG;
        return Apple;
    })();
export const Apps = /*#__PURE__*/ (() => {
        function AppsSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21 1h-6c-1.103 0-2 0.897-2 2v6c0 1.103 0.897 2 2 2h6c1.103 0 2-0.897 2-2v-6c0-1.103-0.897-2-2-2zM21 9h-6v-6h6v6z" }),
_('path', { d: "M22.5 13h-9c-0.275 0-0.5 0.225-0.5 0.5v9c0 0.275 0.225 0.5 0.5 0.5h9c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.225-0.5-0.5-0.5zM22 22h-8v-8h8v8z" }),
_('path', { d: "M10.5 13h-9c-0.275 0-0.5 0.225-0.5 0.5v9c0 0.275 0.225 0.5 0.5 0.5h9c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.225-0.5-0.5-0.5zM10 22h-8v-8h8v8z" }),
_('path', { d: "M10.5 1h-9c-0.275 0-0.5 0.225-0.5 0.5v9c0 0.275 0.225 0.5 0.5 0.5h9c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.225-0.5-0.5-0.5zM10 10h-8v-8h8v8z" })
            );
        }
        function Apps({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AppsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Apps.SVG = AppsSVG;
        return Apps;
    })();
export const Apps2 = /*#__PURE__*/ (() => {
        function Apps2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 17h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM5 21h-2v-2h2v2z" }),
_('path', { d: "M13 17h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM13 21h-2v-2h2v2z" }),
_('path', { d: "M13 9h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM13 13h-2v-2h2v2z" }),
_('path', { d: "M21 17h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM21 21h-2v-2h2v2z" }),
_('path', { d: "M21 9h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM21 13h-2v-2h2v2z" }),
_('path', { d: "M21 1h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM21 5h-2v-2h2v2z" })
            );
        }
        function Apps2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Apps2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Apps2.SVG = Apps2SVG;
        return Apps2;
    })();
export const Apps3 = /*#__PURE__*/ (() => {
        function Apps3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 17h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM5 21h-2v-2h2v2z" }),
_('path', { d: "M13 17h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM13 21h-2v-2h2v2z" }),
_('path', { d: "M13 9h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM13 13h-2v-2h2v2z" }),
_('path', { d: "M21 17h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM21 21h-2v-2h2v2z" }),
_('path', { d: "M21 9h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM21 13h-2v-2h2v2z" }),
_('path', { d: "M21 1h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM21 5h-2v-2h2v2z" }),
_('path', { d: "M2.5 14h3c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5zM3 11h2v2h-2v-2z" }),
_('path', { d: "M2.5 6h3c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5zM3 3h2v2h-2v-2z" }),
_('path', { d: "M10.5 6h3c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5zM11 3h2v2h-2v-2z" })
            );
        }
        function Apps3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Apps3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Apps3.SVG = Apps3SVG;
        return Apps3;
    })();
export const Apps4 = /*#__PURE__*/ (() => {
        function Apps4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 17h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM5 21h-2v-2h2v2z" }),
_('path', { d: "M5 9h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM5 13h-2v-2h2v2z" }),
_('path', { d: "M5 1h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM5 5h-2v-2h2v2z" }),
_('path', { d: "M13 17h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM13 21h-2v-2h2v2z" }),
_('path', { d: "M13 9h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM13 13h-2v-2h2v2z" }),
_('path', { d: "M13 1h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM13 5h-2v-2h2v2z" }),
_('path', { d: "M21 17h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM21 21h-2v-2h2v2z" }),
_('path', { d: "M21 9h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM21 13h-2v-2h2v2z" }),
_('path', { d: "M21 1h-2c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM21 5h-2v-2h2v2z" })
            );
        }
        function Apps4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Apps4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Apps4.SVG = Apps4SVG;
        return Apps4;
    })();
export const Archery = /*#__PURE__*/ (() => {
    function ArcherySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.853 21.147l-3-3c-0.094-0.094-0.222-0.147-0.353-0.147h-1.794l-6-6 8.831-8.831c0.856-0.413 1.669-0.963 2.419-1.713l-1.413-1.413c-1.847 1.847-4.344 2.187-6.987 2.547-1.528 0.209-3.112 0.422-4.672 0.931-1.647 0.537-3.034 1.331-4.231 2.425l-2.309-2.309 1.378-0.691c0.175-0.087 0.284-0.272 0.275-0.469s-0.131-0.372-0.312-0.444l-5-2c-0.184-0.072-0.397-0.028-0.537 0.112s-0.184 0.353-0.112 0.537l2 5c0.072 0.184 0.247 0.306 0.444 0.312 0.006 0 0.012 0 0.022 0 0.188 0 0.363-0.106 0.447-0.275l0.691-1.378 2.309 2.309c-1.094 1.194-1.891 2.584-2.425 4.231-0.509 1.559-0.722 3.141-0.931 4.672-0.359 2.644-0.7 5.138-2.547 6.987l1.416 1.416c0.75-0.75 1.3-1.563 1.713-2.419l8.828-8.834 6 6v1.794c0 0.131 0.053 0.259 0.147 0.353l3 3c0.097 0.097 0.225 0.147 0.353 0.147 0.066 0 0.128-0.012 0.191-0.038 0.188-0.078 0.309-0.259 0.309-0.462v-1.5h1.5c0.203 0 0.384-0.122 0.462-0.309s0.034-0.4-0.109-0.544zM15.825 4.572c1.172-0.159 2.359-0.322 3.513-0.616l-7.338 7.338-3.931-3.931c2.275-2.047 4.941-2.409 7.756-2.791zM3.053 3.275l-0.503 1.006-1.153-2.884 2.884 1.153-1.003 0.503c-0.1 0.047-0.178 0.125-0.225 0.222zM3.956 19.338c0.297-1.153 0.456-2.341 0.616-3.513 0.381-2.816 0.744-5.481 2.791-7.756l3.931 3.931-7.338 7.338zM21.5 21c-0.275 0-0.5 0.225-0.5 0.5v0.794l-2-2v-1.294h1.294l2 2h-0.794z" })
        );
    }
    function Archery({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArcherySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Archery.SVG = ArcherySVG;
    return Archery;
})();
export const ArrowDownCircle = /*#__PURE__*/ (() => {
        function ArrowDownCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M13 14.584v-8.584h-2v8.584l-2.544-2.544-1.416 1.416 4.25 4.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l4.25-4.25-1.416-1.416-2.538 2.544z" })
            );
        }
        function ArrowDownCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ArrowDownCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ArrowDownCircle.SVG = ArrowDownCircleSVG;
        return ArrowDownCircle;
    })();
export const ArrowDownSquare = /*#__PURE__*/ (() => {
        function ArrowDownSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M12 18c0.256 0 0.513-0.097 0.706-0.294l4.25-4.25-1.416-1.416-2.541 2.544v-8.584h-2v8.584l-2.544-2.544-1.416 1.416 4.25 4.25c0.197 0.197 0.453 0.294 0.709 0.294z" })
            );
        }
        function ArrowDownSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ArrowDownSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ArrowDownSquare.SVG = ArrowDownSquareSVG;
        return ArrowDownSquare;
    })();
export const ArrowDown = /*#__PURE__*/ (() => {
    function ArrowDownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18.544 15.044l-5.544 5.541v-20.584h-2v20.584l-5.544-5.541-1.416 1.416 7.25 7.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l7.25-7.25-1.409-1.416z" })
        );
    }
    function ArrowDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDown.SVG = ArrowDownSVG;
    return ArrowDown;
})();
export const ArrowLeftCircle = /*#__PURE__*/ (() => {
        function ArrowLeftCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M11.956 8.456l-1.416-1.416-4.25 4.25c-0.391 0.391-0.391 1.025 0 1.416l4.25 4.25 1.416-1.416-2.541-2.541h8.584v-2h-8.584l2.541-2.544z" })
            );
        }
        function ArrowLeftCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ArrowLeftCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ArrowLeftCircle.SVG = ArrowLeftCircleSVG;
        return ArrowLeftCircle;
    })();
export const ArrowLeftSquare = /*#__PURE__*/ (() => {
        function ArrowLeftSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M10.544 16.956l1.416-1.416-2.544-2.541h8.584v-2h-8.584l2.544-2.544-1.416-1.416-4.25 4.25c-0.391 0.391-0.391 1.025 0 1.416l4.25 4.25z" })
            );
        }
        function ArrowLeftSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ArrowLeftSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ArrowLeftSquare.SVG = ArrowLeftSquareSVG;
        return ArrowLeftSquare;
    })();
export const ArrowLeft = /*#__PURE__*/ (() => {
    function ArrowLeftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 11h-20.584l5.544-5.544-1.416-1.416-7.25 7.25c-0.391 0.391-0.391 1.025 0 1.416l7.25 7.25 1.416-1.416-5.544-5.541h20.584v-2z" })
        );
    }
    function ArrowLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowLeft.SVG = ArrowLeftSVG;
    return ArrowLeft;
})();
export const ArrowNe = /*#__PURE__*/ (() => {
    function ArrowNeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20 3h-10v2h7.584l-14.541 14.544 1.416 1.416 14.541-14.544v7.584h2v-10c0-0.553-0.447-1-1-1z" })
        );
    }
    function ArrowNe({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowNeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowNe.SVG = ArrowNeSVG;
    return ArrowNe;
})();
export const ArrowNw = /*#__PURE__*/ (() => {
    function ArrowNwSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 3h10v2h-7.584l14.541 14.544-1.416 1.416-14.541-14.544v7.584h-2v-10c0-0.553 0.447-1 1-1z" })
        );
    }
    function ArrowNw({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowNwSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowNw.SVG = ArrowNwSVG;
    return ArrowNw;
})();
export const ArrowRightCircle = /*#__PURE__*/ (() => {
        function ArrowRightCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M12.044 8.456l2.544 2.544h-8.587v2h8.584l-2.544 2.544 1.416 1.416 4.25-4.25c0.188-0.188 0.294-0.441 0.294-0.706s-0.106-0.519-0.294-0.706l-4.25-4.25-1.413 1.409z" })
            );
        }
        function ArrowRightCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ArrowRightCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ArrowRightCircle.SVG = ArrowRightCircleSVG;
        return ArrowRightCircle;
    })();
export const ArrowRightSquare = /*#__PURE__*/ (() => {
        function ArrowRightSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M12.044 15.544l1.416 1.416 4.25-4.25c0.391-0.391 0.391-1.025 0-1.416l-4.25-4.25-1.416 1.416 2.544 2.544h-8.587v2h8.584l-2.541 2.541z" })
            );
        }
        function ArrowRightSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ArrowRightSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ArrowRightSquare.SVG = ArrowRightSquareSVG;
        return ArrowRightSquare;
    })();
export const ArrowRight = /*#__PURE__*/ (() => {
    function ArrowRightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.706 11.294l-7.25-7.25-1.416 1.416 5.544 5.541h-20.584v2h20.584l-5.541 5.544 1.416 1.416 7.25-7.25c0.387-0.394 0.387-1.025-0.003-1.416z" })
        );
    }
    function ArrowRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowRight.SVG = ArrowRightSVG;
    return ArrowRight;
})();
export const ArrowSe = /*#__PURE__*/ (() => {
    function ArrowSeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20 21h-10v-2h7.584l-14.541-14.544 1.416-1.416 14.541 14.544v-7.584h2v10c0 0.553-0.447 1-1 1z" })
        );
    }
    function ArrowSe({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowSeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowSe.SVG = ArrowSeSVG;
    return ArrowSe;
})();
export const ArrowSw = /*#__PURE__*/ (() => {
    function ArrowSwSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 21h10v-2h-7.584l14.541-14.544-1.416-1.416-14.541 14.544v-7.584h-2v10c0 0.553 0.447 1 1 1z" })
        );
    }
    function ArrowSw({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowSwSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowSw.SVG = ArrowSwSVG;
    return ArrowSw;
})();
export const ArrowUpCircle = /*#__PURE__*/ (() => {
        function ArrowUpCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M11.294 6.294l-4.25 4.25 1.416 1.416 2.544-2.544v8.584h2v-8.587l2.544 2.544 1.416-1.416-4.25-4.25c-0.397-0.387-1.028-0.387-1.419 0.003z" })
            );
        }
        function ArrowUpCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ArrowUpCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ArrowUpCircle.SVG = ArrowUpCircleSVG;
        return ArrowUpCircle;
    })();
export const ArrowUpSquare = /*#__PURE__*/ (() => {
        function ArrowUpSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M11 9.416v8.584h2v-8.584l2.544 2.544 1.416-1.416-4.25-4.25c-0.391-0.391-1.025-0.391-1.416 0l-4.25 4.25 1.416 1.416 2.541-2.544z" })
            );
        }
        function ArrowUpSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ArrowUpSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ArrowUpSquare.SVG = ArrowUpSquareSVG;
        return ArrowUpSquare;
    })();
export const ArrowUp = /*#__PURE__*/ (() => {
    function ArrowUpSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19.956 7.544l-7.25-7.25c-0.391-0.391-1.025-0.391-1.416 0l-7.25 7.25 1.416 1.416 5.544-5.544v20.584h2v-20.584l5.544 5.544 1.413-1.416z" })
        );
    }
    function ArrowUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUp.SVG = ArrowUpSVG;
    return ArrowUp;
})();
export const AtSign = /*#__PURE__*/ (() => {
    function AtSignSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944h5v-2h-5c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10v0.5c0 1.378-1.122 2.5-2.5 2.5s-2.5-1.122-2.5-2.5v-5.5h-2v1.003c-0.837-0.628-1.875-1.003-3-1.003-2.756 0-5 2.244-5 5s2.244 5 5 5c1.559 0 2.953-0.719 3.872-1.841 0.819 1.116 2.141 1.841 3.628 1.841 2.481 0 4.5-2.019 4.5-4.5v-0.5c0-1.619-0.319-3.191-0.944-4.672zM12 15c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" })
        );
    }
    function AtSign({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AtSignSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    AtSign.SVG = AtSignSVG;
    return AtSign;
})();
export const Atom = /*#__PURE__*/ (() => {
        function AtomSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 6c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zM12 16c-2.206 0-4-1.794-4-4s1.794-4 4-4c2.206 0 4 1.794 4 4s-1.794 4-4 4z" }),
_('path', { d: "M13 9h-2v2h-2v2h2v2h2v-2h2v-2h-2z" }),
_('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.816s-2.384-1.966-3.816-2.572c-1.478-0.622-3.050-0.941-4.669-0.941-2.238 0-4.406 0.616-6.297 1.784-0.6-0.491-1.369-0.784-2.203-0.784-1.931 0-3.5 1.569-3.5 3.5 0 0.991 0.413 1.887 1.078 2.525-0.716 1.563-1.078 3.234-1.078 4.975 0 1.619 0.319 3.191 0.944 4.672 0.603 1.428 1.469 2.712 2.572 3.816s2.384 1.966 3.816 2.572c1.481 0.625 3.050 0.944 4.672 0.944 1.619 0 3.191-0.319 4.672-0.944 1.428-0.603 2.712-1.469 3.816-2.572s1.966-2.384 2.572-3.816c0.625-1.481 0.944-3.050 0.944-4.672-0.006-1.619-0.325-3.191-0.95-4.672zM1 4.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5-2.5-1.122-2.5-2.5zM12 23c-6.066 0-11-4.934-11-11 0-1.528 0.306-3 0.909-4.384 0.475 0.247 1.019 0.384 1.591 0.384 1.931 0 3.5-1.569 3.5-3.5 0-0.728-0.225-1.406-0.606-1.966 1.694-1.006 3.619-1.534 5.606-1.534 6.066 0 11 4.934 11 11s-4.934 11-11 11z" }),
_('path', { d: "M2 4h3v1h-3v-1z" })
            );
        }
        function Atom({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AtomSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Atom.SVG = AtomSVG;
        return Atom;
    })();
export const Axe = /*#__PURE__*/ (() => {
    function AxeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.269 17.731l-9.625-9.625c0.372-0.397 0.772-0.813 1.212-1.253 0.194-0.194 0.194-0.513 0-0.706l-4-4c-0.194-0.194-0.513-0.194-0.706 0-0.438 0.438-0.856 0.841-1.253 1.212l-0.625-0.625c-0.475-0.475-1.103-0.734-1.772-0.734s-1.297 0.259-1.769 0.731c-0.472 0.472-0.731 1.1-0.731 1.769s0.259 1.297 0.731 1.769l0.184 0.184c-1.703 0.994-3.022 1.259-4.516 1.556-0.141 0.028-0.262 0.116-0.334 0.241s-0.087 0.272-0.041 0.409c0.687 2.066 1.737 3.813 3.122 5.197 1.381 1.381 3.131 2.431 5.197 3.122 0.050 0.016 0.106 0.025 0.159 0.025 0.087 0 0.175-0.022 0.25-0.069 0.125-0.072 0.213-0.194 0.241-0.334 0.297-1.494 0.563-2.813 1.556-4.516l9.184 9.184c0.484 0.488 1.125 0.731 1.766 0.731s1.281-0.244 1.769-0.731c0.472-0.472 0.731-1.1 0.731-1.769s-0.259-1.297-0.731-1.769zM10.5 3.206l3.294 3.294c-2.106 2.147-3.497 3.906-4.356 5.512-0.259 0.487-0.469 0.953-0.637 1.4-2.5-1-4.216-2.712-5.212-5.213 0.45-0.172 0.916-0.378 1.4-0.637 1.606-0.859 3.366-2.25 5.512-4.356zM6.147 4.853c-0.128-0.128-0.147-0.275-0.147-0.353s0.019-0.225 0.147-0.353c0.128-0.128 0.275-0.147 0.353-0.147s0.225 0.019 0.353 0.147l0.537 0.537c-0.272 0.225-0.534 0.434-0.787 0.628l-0.456-0.459zM8.125 15.837c-3.356-1.269-5.694-3.606-6.963-6.963 0.478-0.1 0.966-0.209 1.472-0.356 0.553 1.403 1.319 2.6 2.284 3.562 0.966 0.966 2.159 1.731 3.563 2.284-0.147 0.506-0.256 0.994-0.356 1.472zM21.853 19.853c-0.194 0.194-0.513 0.194-0.706 0l-9.459-9.456c0.194-0.253 0.4-0.516 0.628-0.788l9.537 9.537c0.197 0.194 0.197 0.513 0 0.706z" })
        );
    }
    function Axe({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AxeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Axe.SVG = AxeSVG;
    return Axe;
})();
export const Axe2 = /*#__PURE__*/ (() => {
    function Axe2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.269 19.731l-9.294-9.294c1.394-0.819 2.744-1.081 4.144-1.353 0.159-0.031 0.319-0.063 0.478-0.094 0.141-0.028 0.263-0.116 0.334-0.241s0.087-0.272 0.041-0.409c-0.687-2.066-1.737-3.813-3.122-5.194-1.378-1.381-3.128-2.431-5.191-3.122-0.138-0.047-0.284-0.031-0.409 0.041s-0.213 0.194-0.241 0.334c-0.031 0.159-0.063 0.319-0.094 0.478-0.272 1.403-0.534 2.75-1.353 4.144l-0.294-0.294c-0.972-0.972-2.556-0.972-3.534-0.003-0.472 0.478-0.734 1.106-0.734 1.775 0 0.666 0.259 1.294 0.731 1.769l0.294 0.294c-1.394 0.819-2.744 1.081-4.144 1.353-0.159 0.031-0.319 0.063-0.478 0.094-0.141 0.028-0.262 0.116-0.334 0.241s-0.087 0.272-0.041 0.409c0.687 2.066 1.737 3.813 3.122 5.194 1.381 1.381 3.131 2.431 5.194 3.122 0.050 0.019 0.106 0.025 0.159 0.025 0.087 0 0.175-0.022 0.25-0.069 0.125-0.072 0.213-0.194 0.241-0.334 0.031-0.159 0.063-0.319 0.094-0.478 0.272-1.403 0.534-2.753 1.356-4.147l9.294 9.294c0.487 0.487 1.125 0.728 1.766 0.728s1.281-0.244 1.769-0.728c0.969-0.972 0.972-2.556-0.003-3.534zM11.288 11.288c-1.419 1.419-2.134 2.778-2.572 4.097-2.431-0.991-4.106-2.666-5.097-5.097 1.319-0.434 2.675-1.153 4.097-2.572 1.419-1.419 2.134-2.778 2.572-4.097 2.431 0.991 4.106 2.666 5.097 5.097-1.319 0.434-2.678 1.153-4.097 2.572zM10.878 1.166c3.397 1.275 5.681 3.559 6.956 6.956-0.491 0.097-0.987 0.194-1.488 0.319-0.55-1.384-1.313-2.566-2.266-3.522-0.953-0.953-2.137-1.716-3.522-2.266 0.125-0.503 0.225-0.997 0.319-1.488zM6.15 6.856c-0.097-0.097-0.147-0.222-0.15-0.359 0-0.078 0.019-0.225 0.144-0.35 0.197-0.197 0.516-0.197 0.709-0.003l0.497 0.497c-0.109 0.119-0.225 0.241-0.347 0.363s-0.241 0.237-0.363 0.347l-0.491-0.494zM8.122 17.834c-3.397-1.275-5.681-3.559-6.956-6.956 0.491-0.097 0.987-0.194 1.488-0.319 0.55 1.384 1.312 2.566 2.266 3.522 0.953 0.953 2.137 1.716 3.522 2.266-0.125 0.503-0.225 0.997-0.319 1.488zM21.856 21.85c-0.197 0.197-0.516 0.197-0.709 0.003l-9.5-9.5c0.109-0.119 0.225-0.241 0.344-0.359 0.122-0.122 0.241-0.237 0.363-0.347l9.497 9.494c0.2 0.2 0.2 0.516 0.006 0.709z" })
        );
    }
    function Axe2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Axe2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Axe2.SVG = Axe2SVG;
    return Axe2;
})();
export const BabyBottle = /*#__PURE__*/ (() => {
        function BabyBottleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16.956 7.041c0.031-0.178 0.044-0.359 0.044-0.541 0-0.859-0.347-1.641-1.003-2.256-0.503-0.472-1.172-0.847-1.997-1.116v-1.128c0-1.103-0.897-2-2-2s-2 0.897-2 2v1.128c-0.825 0.269-1.497 0.644-1.997 1.116-0.656 0.616-1.003 1.397-1.003 2.256 0 0.181 0.016 0.363 0.044 0.541-1.162 0.216-2.044 1.234-2.044 2.459v1c0 0.816 0.394 1.544 1 2v9c0 1.378 1.122 2.5 2.5 2.5h7c1.378 0 2.5-1.122 2.5-2.5v-9c0.606-0.456 1-1.181 1-2v-1c0-1.222-0.884-2.244-2.044-2.459zM10.622 3.984c0.219-0.053 0.378-0.253 0.378-0.484v-1.5c0-0.55 0.45-1 1-1s1 0.45 1 1v1.5c0 0.184 0.1 0.353 0.266 0.441 0.034 0.019 0.072 0.034 0.109 0.044 0.984 0.272 2.625 0.959 2.625 2.516 0 0.169-0.019 0.334-0.056 0.5h-7.887c-0.038-0.166-0.056-0.331-0.056-0.5 0-1.556 1.638-2.241 2.622-2.516zM7 9.5c0-0.275 0.225-0.5 0.5-0.5h9c0.275 0 0.5 0.225 0.5 0.5v1c0 0.275-0.225 0.5-0.5 0.5h-9c-0.275 0-0.5-0.225-0.5-0.5v-1zM15.5 22h-7c-0.275 0-0.5-0.225-0.5-0.5v-8.5h8v8.5c0 0.275-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M9 14h4v1h-4v-1z" }),
_('path', { d: "M9 16h2v1h-2v-1z" }),
_('path', { d: "M9 18h2v1h-2v-1z" }),
_('path', { d: "M9 20h4v1h-4v-1z" })
            );
        }
        function BabyBottle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BabyBottleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BabyBottle.SVG = BabyBottleSVG;
        return BabyBottle;
    })();
export const BabyCrying = /*#__PURE__*/ (() => {
        function BabyCryingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.044 11.406c-0.478-0.559-1.1-0.975-1.791-1.206-1.531-3.731-5.184-6.2-9.253-6.2-0.553 0-1.072-0.169-1.456-0.478-0.35-0.281-0.544-0.644-0.544-1.022s0.194-0.744 0.544-1.022c0.384-0.309 0.903-0.478 1.456-0.478 0.609 0 1 0.297 1 0.5s-0.391 0.5-1 0.5v1c1.122 0 2-0.659 2-1.5s-0.878-1.5-2-1.5c-0.781 0-1.519 0.247-2.081 0.697-0.591 0.475-0.919 1.116-0.919 1.803 0 0.656 0.297 1.269 0.837 1.737-3.159 0.7-5.838 2.909-7.091 5.962-0.691 0.228-1.313 0.644-1.791 1.206-0.616 0.722-0.956 1.644-0.956 2.594s0.341 1.872 0.956 2.594c0.478 0.559 1.1 0.975 1.791 1.206 1.531 3.731 5.184 6.2 9.253 6.2s7.722-2.469 9.253-6.2c0.691-0.228 1.313-0.644 1.791-1.206 0.616-0.722 0.956-1.644 0.956-2.594s-0.341-1.872-0.956-2.594zM20.334 15.975c-0.359 0.063-0.656 0.312-0.778 0.656-1.116 3.209-4.153 5.369-7.556 5.369s-6.441-2.159-7.559-5.369c-0.119-0.344-0.419-0.597-0.778-0.656-0.963-0.166-1.662-0.997-1.662-1.975s0.7-1.809 1.666-1.975c0.359-0.063 0.656-0.312 0.778-0.656 1.116-3.209 4.153-5.369 7.556-5.369s6.441 2.159 7.559 5.369c0.119 0.344 0.419 0.597 0.778 0.656 0.966 0.162 1.666 0.994 1.666 1.975s-0.703 1.809-1.669 1.975z" }),
_('path', { d: "M14.766 15.825c-0.744-0.531-1.728-0.825-2.766-0.825s-2.022 0.294-2.766 0.825c-0.797 0.569-1.234 1.341-1.234 2.175s0.438 1.606 1.234 2.175c0.744 0.531 1.728 0.825 2.766 0.825s2.022-0.294 2.766-0.825c0.797-0.569 1.234-1.341 1.234-2.175s-0.438-1.606-1.234-2.175zM13 16.116v0.884h-1v-1c0.347 0 0.684 0.041 1 0.116zM14.184 19.359c-0.578 0.413-1.353 0.641-2.184 0.641s-1.606-0.228-2.184-0.641c-0.525-0.375-0.816-0.859-0.816-1.359s0.291-0.984 0.816-1.359c0.337-0.241 0.741-0.419 1.184-0.525v1.384c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-0.981c0.063 0.038 0.125 0.078 0.184 0.122 0.525 0.375 0.816 0.859 0.816 1.359s-0.291 0.984-0.816 1.359z" }),
_('path', { d: "M16.172 10.725l-0.447-0.894-2.447 1.225c-0.181 0.091-0.291 0.281-0.275 0.481s0.15 0.375 0.341 0.438l3.475 1.159 0.316-0.95-2.331-0.778 1.369-0.681z" }),
_('path', { d: "M11 11.534c0.016-0.203-0.094-0.394-0.275-0.481l-2.447-1.225-0.447 0.894 1.369 0.684-2.328 0.775 0.316 0.95 3.475-1.159c0.188-0.063 0.322-0.234 0.337-0.438z" })
            );
        }
        function BabyCrying({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BabyCryingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BabyCrying.SVG = BabyCryingSVG;
        return BabyCrying;
    })();
export const BabyCrying2 = /*#__PURE__*/ (() => {
        function BabyCrying2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.044 11.406c-0.478-0.559-1.1-0.975-1.791-1.203-0.45-1.097-1.087-2.097-1.9-2.978l-0.003 0.003c-0.094-0.103-0.188-0.203-0.284-0.3-0.031-0.303-0.066-0.619-0.066-0.925 0-0.309 0.034-0.622 0.066-0.928 0.075-0.709 0.141-1.325-0.231-1.741-0.2-0.222-0.478-0.334-0.834-0.334-1.338 0-2.313 0.666-3.169 1.25-0.4 0.275-0.784 0.537-1.144 0.675-0.356-0.556-0.978-0.925-1.688-0.925-0.553 0-1.072-0.169-1.456-0.478-0.35-0.281-0.544-0.644-0.544-1.022s0.194-0.744 0.544-1.022c0.384-0.309 0.903-0.478 1.456-0.478 0.609 0 1 0.297 1 0.5s-0.391 0.5-1 0.5v1c1.122 0 2-0.659 2-1.5s-0.878-1.5-2-1.5c-0.781 0-1.519 0.247-2.081 0.697-0.591 0.475-0.919 1.116-0.919 1.803s0.328 1.328 0.919 1.803c0.178 0.144 0.375 0.266 0.588 0.366-0.072 0.078-0.134 0.166-0.194 0.256-0.359-0.141-0.744-0.403-1.144-0.675-0.856-0.584-1.831-1.25-3.169-1.25-0.356 0-0.634 0.113-0.834 0.334-0.375 0.416-0.309 1.028-0.231 1.741 0.031 0.303 0.066 0.619 0.066 0.928 0 0.306-0.034 0.622-0.066 0.925-0.097 0.097-0.191 0.197-0.284 0.3l-0.003-0.003c-0.813 0.881-1.45 1.881-1.9 2.978-0.691 0.228-1.313 0.644-1.791 1.203-0.616 0.722-0.956 1.644-0.956 2.594s0.341 1.872 0.956 2.594c0.478 0.559 1.1 0.975 1.791 1.206 1.531 3.731 5.184 6.2 9.253 6.2s7.722-2.469 9.253-6.2c0.691-0.228 1.313-0.644 1.791-1.206 0.616-0.722 0.956-1.644 0.956-2.594s-0.341-1.872-0.956-2.594zM15.394 5.075c0.775-0.528 1.575-1.075 2.606-1.075 0.050 0 0.081 0.006 0.094 0.009 0.066 0.138 0.012 0.628-0.022 0.956-0.034 0.316-0.072 0.672-0.072 1.034s0.038 0.719 0.072 1.034c0.034 0.328 0.087 0.819 0.022 0.956-0.016 0.003-0.044 0.009-0.094 0.009-1.028 0-1.831-0.547-2.606-1.075-0.469-0.319-0.916-0.625-1.4-0.803 0.003-0.041 0.003-0.081 0.003-0.122s0-0.081-0.003-0.122c0.484-0.175 0.934-0.481 1.4-0.803zM13 6c0 0.55-0.45 1-1 1s-1-0.45-1-1 0.45-1 1-1c0.55 0 1 0.45 1 1zM5.928 4.966c-0.034-0.328-0.087-0.819-0.022-0.956 0.016-0.003 0.044-0.009 0.094-0.009 1.028 0 1.831 0.547 2.606 1.075 0.469 0.319 0.916 0.625 1.4 0.803-0.003 0.041-0.003 0.081-0.003 0.122s0 0.081 0.003 0.122c-0.481 0.175-0.931 0.481-1.4 0.803-0.775 0.528-1.578 1.075-2.606 1.075-0.050 0-0.081-0.006-0.094-0.009-0.066-0.138-0.012-0.628 0.022-0.956 0.034-0.316 0.072-0.672 0.072-1.034s-0.037-0.719-0.072-1.034zM20.334 15.975c-0.359 0.063-0.656 0.312-0.778 0.656-1.116 3.209-4.153 5.369-7.556 5.369s-6.441-2.159-7.559-5.369c-0.119-0.344-0.419-0.597-0.778-0.656-0.963-0.166-1.662-0.997-1.662-1.975s0.7-1.809 1.666-1.975c0.359-0.063 0.656-0.312 0.778-0.656 0.303-0.872 0.747-1.672 1.325-2.388 0.075 0.012 0.15 0.019 0.234 0.019 1.338 0 2.313-0.666 3.169-1.25 0.4-0.275 0.784-0.534 1.144-0.675 0.356 0.556 0.978 0.925 1.688 0.925 0.706 0 1.331-0.369 1.688-0.925 0.359 0.141 0.744 0.403 1.144 0.675 0.859 0.588 1.831 1.25 3.169 1.25 0.081 0 0.159-0.006 0.234-0.019 0.578 0.716 1.022 1.516 1.325 2.388 0.119 0.344 0.419 0.597 0.778 0.656 0.966 0.162 1.666 0.994 1.666 1.975-0.006 0.978-0.706 1.809-1.672 1.975z" }),
_('path', { d: "M14.766 15.825c-0.744-0.531-1.728-0.825-2.766-0.825s-2.022 0.294-2.766 0.825c-0.797 0.569-1.234 1.341-1.234 2.175s0.438 1.606 1.234 2.175c0.744 0.531 1.728 0.825 2.766 0.825s2.022-0.294 2.766-0.825c0.797-0.569 1.234-1.341 1.234-2.175s-0.438-1.606-1.234-2.175zM13 16.116v0.884h-1v-1c0.347 0 0.684 0.041 1 0.116zM14.184 19.359c-0.578 0.413-1.353 0.641-2.184 0.641s-1.606-0.228-2.184-0.641c-0.525-0.375-0.816-0.859-0.816-1.359s0.291-0.984 0.816-1.359c0.337-0.241 0.741-0.419 1.184-0.525v1.384c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-0.981c0.063 0.038 0.125 0.078 0.184 0.122 0.525 0.375 0.816 0.859 0.816 1.359s-0.291 0.984-0.816 1.359z" }),
_('path', { d: "M16.172 10.725l-0.447-0.894-2.447 1.225c-0.181 0.091-0.291 0.281-0.275 0.481s0.15 0.375 0.341 0.438l3.475 1.159 0.316-0.95-2.331-0.778 1.369-0.681z" }),
_('path', { d: "M11 11.534c0.016-0.203-0.094-0.394-0.275-0.481l-2.447-1.225-0.447 0.894 1.369 0.684-2.328 0.775 0.316 0.95 3.475-1.159c0.188-0.063 0.322-0.234 0.337-0.438z" })
            );
        }
        function BabyCrying2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BabyCrying2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BabyCrying2.SVG = BabyCrying2SVG;
        return BabyCrying2;
    })();
export const BabySmile = /*#__PURE__*/ (() => {
        function BabySmileSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.044 11.406c-0.478-0.559-1.1-0.975-1.791-1.206-1.531-3.731-5.184-6.2-9.253-6.2-0.553 0-1.072-0.169-1.456-0.478-0.35-0.281-0.544-0.644-0.544-1.022s0.194-0.744 0.544-1.022c0.384-0.309 0.903-0.478 1.456-0.478 0.609 0 1 0.297 1 0.5s-0.391 0.5-1 0.5v1c1.122 0 2-0.659 2-1.5s-0.878-1.5-2-1.5c-0.781 0-1.519 0.247-2.081 0.697-0.591 0.475-0.919 1.116-0.919 1.803 0 0.656 0.297 1.269 0.837 1.737-3.159 0.7-5.838 2.909-7.091 5.962-0.691 0.228-1.313 0.644-1.791 1.206-0.616 0.722-0.956 1.644-0.956 2.594s0.341 1.872 0.956 2.594c0.478 0.559 1.1 0.975 1.791 1.206 1.531 3.731 5.184 6.2 9.253 6.2s7.722-2.469 9.253-6.2c0.691-0.228 1.313-0.644 1.791-1.206 0.616-0.722 0.956-1.644 0.956-2.594s-0.341-1.872-0.956-2.594zM20.334 15.975c-0.359 0.063-0.656 0.312-0.778 0.656-1.116 3.209-4.153 5.369-7.556 5.369s-6.441-2.159-7.559-5.369c-0.119-0.344-0.419-0.597-0.778-0.656-0.963-0.166-1.662-0.997-1.662-1.975s0.7-1.809 1.666-1.975c0.359-0.063 0.656-0.312 0.778-0.656 1.116-3.209 4.153-5.369 7.556-5.369s6.441 2.159 7.559 5.369c0.119 0.344 0.419 0.597 0.778 0.656 0.966 0.162 1.666 0.994 1.666 1.975s-0.703 1.809-1.669 1.975z" }),
_('path', { d: "M9 13c0-0.55-0.45-1-1-1s-1 0.45-1 1 0.45 1 1 1 1-0.45 1-1zM8 13v0c0 0 0 0 0 0z" }),
_('path', { d: "M16 12c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM16 13c0 0 0 0 0 0v0z" }),
_('path', { d: "M12 19c-1.653 0-3-1.347-3-3h-1c0 2.206 1.794 4 4 4s4-1.794 4-4h-1c0 1.653-1.347 3-3 3z" })
            );
        }
        function BabySmile({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BabySmileSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BabySmile.SVG = BabySmileSVG;
        return BabySmile;
    })();
export const BabyTongue = /*#__PURE__*/ (() => {
        function BabyTongueSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.044 11.406c-0.478-0.559-1.1-0.975-1.791-1.206-1.531-3.731-5.184-6.2-9.253-6.2-0.553 0-1.072-0.169-1.456-0.478-0.35-0.281-0.544-0.644-0.544-1.022s0.194-0.744 0.544-1.022c0.384-0.309 0.903-0.478 1.456-0.478 0.609 0 1 0.297 1 0.5s-0.391 0.5-1 0.5v1c1.122 0 2-0.659 2-1.5s-0.878-1.5-2-1.5c-0.781 0-1.519 0.247-2.081 0.697-0.591 0.475-0.919 1.116-0.919 1.803 0 0.656 0.297 1.269 0.837 1.737-3.159 0.7-5.838 2.909-7.091 5.962-0.691 0.228-1.313 0.644-1.791 1.206-0.616 0.722-0.956 1.644-0.956 2.594s0.341 1.872 0.956 2.594c0.478 0.559 1.1 0.975 1.791 1.206 1.531 3.731 5.184 6.2 9.253 6.2s7.722-2.469 9.253-6.2c0.691-0.228 1.313-0.644 1.791-1.206 0.616-0.722 0.956-1.644 0.956-2.594s-0.341-1.872-0.956-2.594zM20.334 15.975c-0.359 0.063-0.656 0.312-0.778 0.656-1.116 3.209-4.153 5.369-7.556 5.369s-6.441-2.159-7.559-5.369c-0.119-0.344-0.419-0.597-0.778-0.656-0.963-0.166-1.662-0.997-1.662-1.975s0.7-1.809 1.666-1.975c0.359-0.063 0.656-0.312 0.778-0.656 1.116-3.209 4.153-5.369 7.556-5.369s6.441 2.159 7.559 5.369c0.119 0.344 0.419 0.597 0.778 0.656 0.966 0.162 1.666 0.994 1.666 1.975s-0.703 1.809-1.669 1.975z" }),
_('path', { d: "M8 14c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM8 13v0c0 0 0 0 0 0z" }),
_('path', { d: "M16 14c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM16 13v0c0 0 0 0 0 0z" }),
_('path', { d: "M16.297 16.044c-2.85 1.269-5.744 1.269-8.594 0l-0.456-0.203-0.406 0.912 0.456 0.203c0.897 0.4 1.8 0.684 2.703 0.853v1.191c0 1.103 0.897 2 2 2s2-0.897 2-2v-1.191c0.903-0.169 1.806-0.453 2.703-0.853l0.456-0.203-0.406-0.912-0.456 0.203zM13 19c0 0.55-0.45 1-1 1s-1-0.45-1-1v-1.050c0.334 0.031 0.666 0.047 1 0.047s0.666-0.016 1-0.047v1.050z" })
            );
        }
        function BabyTongue({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BabyTongueSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BabyTongue.SVG = BabyTongueSVG;
        return BabyTongue;
    })();
export const BabyTongue2 = /*#__PURE__*/ (() => {
        function BabyTongue2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 14c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM8 13v0c0 0 0 0 0 0z" }),
_('path', { d: "M16 14c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM16 13v0c0 0 0 0 0 0z" }),
_('path', { d: "M23.044 11.406c-0.478-0.559-1.1-0.975-1.791-1.203-0.45-1.097-1.087-2.097-1.9-2.978l-0.003 0.003c-0.094-0.103-0.188-0.203-0.284-0.3-0.031-0.303-0.066-0.619-0.066-0.925 0-0.309 0.034-0.622 0.066-0.928 0.075-0.709 0.141-1.325-0.231-1.741-0.2-0.222-0.478-0.334-0.834-0.334-1.338 0-2.313 0.666-3.169 1.25-0.4 0.275-0.784 0.537-1.144 0.675-0.356-0.556-0.978-0.925-1.688-0.925-0.553 0-1.072-0.169-1.456-0.478-0.35-0.281-0.544-0.644-0.544-1.022s0.194-0.744 0.544-1.022c0.384-0.309 0.903-0.478 1.456-0.478 0.609 0 1 0.297 1 0.5s-0.391 0.5-1 0.5v1c1.122 0 2-0.659 2-1.5s-0.878-1.5-2-1.5c-0.781 0-1.519 0.247-2.081 0.697-0.591 0.475-0.919 1.116-0.919 1.803s0.328 1.328 0.919 1.803c0.178 0.144 0.375 0.266 0.588 0.366-0.072 0.078-0.134 0.166-0.194 0.256-0.359-0.141-0.744-0.403-1.144-0.675-0.856-0.584-1.831-1.25-3.169-1.25-0.356 0-0.634 0.113-0.834 0.334-0.375 0.416-0.309 1.028-0.231 1.741 0.031 0.303 0.066 0.619 0.066 0.928 0 0.306-0.034 0.622-0.066 0.925-0.097 0.097-0.191 0.197-0.284 0.3l-0.003-0.003c-0.813 0.881-1.45 1.881-1.9 2.978-0.691 0.228-1.313 0.644-1.791 1.203-0.616 0.722-0.956 1.644-0.956 2.594s0.341 1.872 0.956 2.594c0.478 0.559 1.1 0.975 1.791 1.206 1.531 3.731 5.184 6.2 9.253 6.2s7.722-2.469 9.253-6.2c0.691-0.228 1.313-0.644 1.791-1.206 0.616-0.722 0.956-1.644 0.956-2.594s-0.341-1.872-0.956-2.594zM15.394 5.075c0.775-0.528 1.575-1.075 2.606-1.075 0.050 0 0.081 0.006 0.094 0.009 0.066 0.138 0.012 0.628-0.022 0.956-0.034 0.316-0.072 0.672-0.072 1.034s0.038 0.719 0.072 1.034c0.034 0.328 0.087 0.819 0.022 0.956-0.016 0.003-0.044 0.009-0.094 0.009-1.028 0-1.831-0.547-2.606-1.075-0.469-0.319-0.916-0.625-1.4-0.803 0.003-0.041 0.003-0.081 0.003-0.122s0-0.081-0.003-0.122c0.484-0.175 0.934-0.481 1.4-0.803zM13 6c0 0.55-0.45 1-1 1s-1-0.45-1-1 0.45-1 1-1c0.55 0 1 0.45 1 1zM5.928 4.966c-0.034-0.328-0.087-0.819-0.022-0.956 0.016-0.003 0.044-0.009 0.094-0.009 1.028 0 1.831 0.547 2.606 1.075 0.469 0.319 0.916 0.625 1.4 0.803-0.003 0.041-0.003 0.081-0.003 0.122s0 0.081 0.003 0.122c-0.481 0.175-0.931 0.481-1.4 0.803-0.775 0.528-1.578 1.075-2.606 1.075-0.050 0-0.081-0.006-0.094-0.009-0.066-0.138-0.012-0.628 0.022-0.956 0.034-0.316 0.072-0.672 0.072-1.034s-0.037-0.719-0.072-1.034zM20.334 15.975c-0.359 0.063-0.656 0.312-0.778 0.656-1.116 3.209-4.153 5.369-7.556 5.369s-6.441-2.159-7.559-5.369c-0.119-0.344-0.419-0.597-0.778-0.656-0.963-0.166-1.662-0.997-1.662-1.975s0.7-1.809 1.666-1.975c0.359-0.063 0.656-0.312 0.778-0.656 0.303-0.872 0.747-1.672 1.325-2.388 0.075 0.012 0.15 0.019 0.234 0.019 1.338 0 2.313-0.666 3.169-1.25 0.4-0.275 0.784-0.534 1.144-0.675 0.356 0.556 0.978 0.925 1.688 0.925 0.706 0 1.331-0.369 1.688-0.925 0.359 0.141 0.744 0.403 1.144 0.675 0.859 0.588 1.831 1.25 3.169 1.25 0.081 0 0.159-0.006 0.234-0.019 0.578 0.716 1.022 1.516 1.325 2.388 0.119 0.344 0.419 0.597 0.778 0.656 0.966 0.162 1.666 0.994 1.666 1.975-0.006 0.978-0.706 1.809-1.672 1.975z" }),
_('path', { d: "M16.297 16.044c-2.85 1.269-5.744 1.269-8.594 0l-0.456-0.203-0.406 0.912 0.456 0.203c0.897 0.4 1.8 0.684 2.703 0.853v1.191c0 1.103 0.897 2 2 2s2-0.897 2-2v-1.191c0.903-0.169 1.806-0.453 2.703-0.853l0.456-0.203-0.406-0.912-0.456 0.203zM13 19c0 0.55-0.45 1-1 1s-1-0.45-1-1v-1.050c0.334 0.031 0.666 0.047 1 0.047s0.666-0.016 1-0.047v1.050z" })
            );
        }
        function BabyTongue2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BabyTongue2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BabyTongue2.SVG = BabyTongue2SVG;
        return BabyTongue2;
    })();
export const Baby = /*#__PURE__*/ (() => {
        function BabySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.044 11.403c-0.478-0.559-1.1-0.975-1.791-1.203-1.531-3.731-5.184-6.2-9.253-6.2-0.553 0-1.072-0.169-1.456-0.475-0.35-0.281-0.544-0.644-0.544-1.025s0.194-0.744 0.544-1.025c0.384-0.306 0.903-0.475 1.456-0.475 0.609 0 1 0.297 1 0.5s-0.391 0.5-1 0.5v1c1.122 0 2-0.659 2-1.5s-0.878-1.5-2-1.5c-0.781 0-1.519 0.247-2.081 0.697-0.591 0.472-0.919 1.113-0.919 1.803 0 0.656 0.297 1.269 0.837 1.737-3.162 0.7-5.838 2.909-7.091 5.963-0.691 0.228-1.313 0.644-1.791 1.203-0.616 0.725-0.956 1.647-0.956 2.597s0.341 1.872 0.956 2.597c0.478 0.559 1.1 0.975 1.791 1.203 1.531 3.731 5.184 6.2 9.253 6.2s7.722-2.469 9.253-6.2c0.691-0.228 1.313-0.644 1.791-1.203 0.616-0.722 0.956-1.644 0.956-2.597s-0.341-1.872-0.956-2.597zM20.337 15.972c-0.359 0.059-0.659 0.312-0.778 0.656-1.119 3.213-4.156 5.372-7.559 5.372s-6.441-2.159-7.559-5.372c-0.119-0.344-0.419-0.597-0.778-0.656-0.963-0.162-1.662-0.991-1.662-1.972s0.7-1.809 1.662-1.972c0.359-0.059 0.659-0.312 0.778-0.656 1.119-3.213 4.156-5.372 7.559-5.372s6.441 2.159 7.559 5.372c0.119 0.344 0.419 0.597 0.778 0.656 0.963 0.162 1.662 0.991 1.662 1.972s-0.7 1.809-1.662 1.972z" }),
_('path', { d: "M14 20c0-0.159-0.019-0.316-0.053-0.466 0.669-0.372 1.053-0.925 1.053-1.534 0-1.122-1.319-2-3-2s-3 0.878-3 2c0 0.612 0.387 1.166 1.053 1.534-0.034 0.15-0.053 0.303-0.053 0.466 0 1.103 0.897 2 2 2s2-0.897 2-2zM10 18c0-0.472 0.856-1 2-1s2 0.528 2 1c0 0.228-0.197 0.466-0.525 0.653-0.366-0.403-0.891-0.653-1.475-0.653s-1.109 0.25-1.475 0.653c-0.328-0.188-0.525-0.425-0.525-0.653zM12 21c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M8 12c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM8 13c0 0 0 0 0 0v0z" }),
_('path', { d: "M16 12c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM16 13c0 0 0 0 0 0v0z" })
            );
        }
        function Baby({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BabySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Baby.SVG = BabySVG;
        return Baby;
    })();
export const Baby2 = /*#__PURE__*/ (() => {
        function Baby2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 20c0-0.159-0.019-0.316-0.053-0.466 0.669-0.369 1.053-0.922 1.053-1.534 0-1.122-1.319-2-3-2s-3 0.878-3 2c0 0.609 0.387 1.162 1.056 1.534-0.034 0.15-0.056 0.306-0.056 0.466 0 1.103 0.897 2 2 2s2-0.897 2-2zM10 18c0-0.472 0.856-1 2-1s2 0.528 2 1c0 0.228-0.197 0.466-0.525 0.65-0.366-0.4-0.891-0.65-1.475-0.65s-1.109 0.25-1.475 0.65c-0.328-0.188-0.525-0.425-0.525-0.65zM12 21c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M8 12c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM8 13c0 0 0 0 0 0v0z" }),
_('path', { d: "M16 12c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM16 13c0 0 0 0 0 0v0z" }),
_('path', { d: "M23.044 11.406c-0.478-0.559-1.1-0.975-1.791-1.203-0.45-1.097-1.087-2.097-1.9-2.978l-0.003 0.003c-0.094-0.103-0.188-0.203-0.284-0.3-0.031-0.303-0.066-0.619-0.066-0.925 0-0.309 0.034-0.622 0.066-0.928 0.075-0.709 0.141-1.325-0.231-1.741-0.2-0.222-0.478-0.334-0.834-0.334-1.338 0-2.313 0.666-3.169 1.25-0.4 0.275-0.784 0.537-1.144 0.675-0.356-0.556-0.978-0.925-1.688-0.925-0.553 0-1.072-0.169-1.456-0.478-0.35-0.281-0.544-0.644-0.544-1.022s0.194-0.744 0.544-1.022c0.384-0.309 0.903-0.478 1.456-0.478 0.609 0 1 0.297 1 0.5s-0.391 0.5-1 0.5v1c1.122 0 2-0.659 2-1.5s-0.878-1.5-2-1.5c-0.781 0-1.519 0.247-2.081 0.697-0.591 0.475-0.919 1.116-0.919 1.803s0.328 1.328 0.919 1.803c0.178 0.144 0.375 0.266 0.588 0.366-0.072 0.078-0.134 0.166-0.194 0.256-0.359-0.141-0.744-0.403-1.144-0.675-0.856-0.584-1.831-1.25-3.169-1.25-0.356 0-0.634 0.113-0.834 0.334-0.375 0.416-0.309 1.028-0.231 1.741 0.031 0.303 0.066 0.619 0.066 0.928 0 0.306-0.034 0.622-0.066 0.925-0.097 0.097-0.191 0.197-0.284 0.3l-0.003-0.003c-0.813 0.881-1.45 1.881-1.9 2.978-0.691 0.228-1.313 0.644-1.791 1.203-0.616 0.722-0.956 1.644-0.956 2.594s0.341 1.872 0.956 2.594c0.478 0.559 1.1 0.975 1.791 1.206 1.531 3.731 5.184 6.2 9.253 6.2s7.722-2.469 9.253-6.2c0.691-0.228 1.313-0.644 1.791-1.206 0.616-0.722 0.956-1.644 0.956-2.594s-0.341-1.872-0.956-2.594zM15.394 5.075c0.775-0.528 1.575-1.075 2.606-1.075 0.050 0 0.081 0.006 0.094 0.009 0.066 0.138 0.012 0.628-0.022 0.956-0.034 0.316-0.072 0.672-0.072 1.034s0.038 0.719 0.072 1.034c0.034 0.328 0.087 0.819 0.022 0.956-0.016 0.003-0.044 0.009-0.094 0.009-1.028 0-1.831-0.547-2.606-1.075-0.469-0.319-0.916-0.625-1.4-0.803 0.003-0.041 0.003-0.081 0.003-0.122s0-0.081-0.003-0.122c0.484-0.175 0.934-0.481 1.4-0.803zM13 6c0 0.55-0.45 1-1 1s-1-0.45-1-1 0.45-1 1-1c0.55 0 1 0.45 1 1zM5.928 4.966c-0.034-0.328-0.087-0.819-0.022-0.956 0.016-0.003 0.044-0.009 0.094-0.009 1.028 0 1.831 0.547 2.606 1.075 0.469 0.319 0.916 0.625 1.4 0.803-0.003 0.041-0.003 0.081-0.003 0.122s0 0.081 0.003 0.122c-0.481 0.175-0.931 0.481-1.4 0.803-0.775 0.528-1.578 1.075-2.606 1.075-0.050 0-0.081-0.006-0.094-0.009-0.066-0.138-0.012-0.628 0.022-0.956 0.034-0.316 0.072-0.672 0.072-1.034s-0.037-0.719-0.072-1.034zM20.334 15.975c-0.359 0.063-0.656 0.312-0.778 0.656-1.116 3.209-4.153 5.369-7.556 5.369s-6.441-2.159-7.559-5.369c-0.119-0.344-0.419-0.597-0.778-0.656-0.963-0.166-1.662-0.997-1.662-1.975s0.7-1.809 1.666-1.975c0.359-0.063 0.656-0.312 0.778-0.656 0.303-0.872 0.747-1.672 1.325-2.388 0.075 0.012 0.15 0.019 0.234 0.019 1.338 0 2.313-0.666 3.169-1.25 0.4-0.275 0.784-0.534 1.144-0.675 0.356 0.556 0.978 0.925 1.688 0.925 0.706 0 1.331-0.369 1.688-0.925 0.359 0.141 0.744 0.403 1.144 0.675 0.859 0.588 1.831 1.25 3.169 1.25 0.081 0 0.159-0.006 0.234-0.019 0.578 0.716 1.022 1.516 1.325 2.388 0.119 0.344 0.419 0.597 0.778 0.656 0.966 0.162 1.666 0.994 1.666 1.975-0.006 0.978-0.706 1.809-1.672 1.975z" })
            );
        }
        function Baby2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Baby2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Baby2.SVG = Baby2SVG;
        return Baby2;
    })();
export const Baby3 = /*#__PURE__*/ (() => {
        function Baby3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 13c0-0.55-0.45-1-1-1s-1 0.45-1 1 0.45 1 1 1 1-0.45 1-1zM8 13v0c0 0 0 0 0 0z" }),
_('path', { d: "M16 12c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM16 13c0 0 0 0 0 0v0z" }),
_('path', { d: "M23.044 11.406c-0.478-0.559-1.1-0.975-1.791-1.203-0.45-1.097-1.087-2.097-1.9-2.978l-0.003 0.003c-0.094-0.103-0.188-0.203-0.284-0.3-0.031-0.303-0.066-0.619-0.066-0.925 0-0.309 0.034-0.622 0.066-0.928 0.075-0.709 0.141-1.325-0.231-1.741-0.2-0.222-0.478-0.334-0.834-0.334-1.338 0-2.313 0.666-3.169 1.25-0.4 0.275-0.784 0.537-1.144 0.675-0.356-0.556-0.978-0.925-1.688-0.925-0.553 0-1.072-0.169-1.456-0.478-0.35-0.281-0.544-0.644-0.544-1.022s0.194-0.744 0.544-1.022c0.384-0.309 0.903-0.478 1.456-0.478 0.609 0 1 0.297 1 0.5s-0.391 0.5-1 0.5v1c1.122 0 2-0.659 2-1.5s-0.878-1.5-2-1.5c-0.781 0-1.519 0.247-2.081 0.697-0.591 0.475-0.919 1.116-0.919 1.803s0.328 1.328 0.919 1.803c0.178 0.144 0.375 0.266 0.588 0.366-0.072 0.078-0.134 0.166-0.194 0.256-0.359-0.141-0.744-0.403-1.144-0.675-0.856-0.584-1.831-1.25-3.169-1.25-0.356 0-0.634 0.113-0.834 0.334-0.375 0.416-0.309 1.028-0.231 1.741 0.031 0.303 0.066 0.619 0.066 0.928 0 0.306-0.034 0.622-0.066 0.925-0.097 0.097-0.191 0.197-0.284 0.3l-0.003-0.003c-0.813 0.881-1.45 1.881-1.9 2.978-0.691 0.228-1.313 0.644-1.791 1.203-0.616 0.722-0.956 1.644-0.956 2.594s0.341 1.872 0.956 2.594c0.478 0.559 1.1 0.975 1.791 1.206 1.531 3.731 5.184 6.2 9.253 6.2s7.722-2.469 9.253-6.2c0.691-0.228 1.313-0.644 1.791-1.206 0.616-0.722 0.956-1.644 0.956-2.594s-0.341-1.872-0.956-2.594zM15.394 5.075c0.775-0.528 1.575-1.075 2.606-1.075 0.050 0 0.081 0.006 0.094 0.009 0.066 0.138 0.012 0.628-0.022 0.956-0.034 0.316-0.072 0.672-0.072 1.034s0.038 0.719 0.072 1.034c0.034 0.328 0.087 0.819 0.022 0.956-0.016 0.003-0.044 0.009-0.094 0.009-1.028 0-1.831-0.547-2.606-1.075-0.469-0.319-0.916-0.625-1.4-0.803 0.003-0.041 0.003-0.081 0.003-0.122s0-0.081-0.003-0.122c0.484-0.175 0.934-0.481 1.4-0.803zM13 6c0 0.55-0.45 1-1 1s-1-0.45-1-1 0.45-1 1-1c0.55 0 1 0.45 1 1zM5.928 4.966c-0.034-0.328-0.087-0.819-0.022-0.956 0.016-0.003 0.044-0.009 0.094-0.009 1.028 0 1.831 0.547 2.606 1.075 0.469 0.319 0.916 0.625 1.4 0.803-0.003 0.041-0.003 0.081-0.003 0.122s0 0.081 0.003 0.122c-0.481 0.175-0.931 0.481-1.4 0.803-0.775 0.528-1.578 1.075-2.606 1.075-0.050 0-0.081-0.006-0.094-0.009-0.066-0.138-0.012-0.628 0.022-0.956 0.034-0.316 0.072-0.672 0.072-1.034s-0.037-0.719-0.072-1.034zM20.334 15.975c-0.359 0.063-0.656 0.312-0.778 0.656-1.116 3.209-4.153 5.369-7.556 5.369s-6.441-2.159-7.559-5.369c-0.119-0.344-0.419-0.597-0.778-0.656-0.963-0.166-1.662-0.997-1.662-1.975s0.7-1.809 1.666-1.975c0.359-0.063 0.656-0.312 0.778-0.656 0.303-0.872 0.747-1.672 1.325-2.388 0.075 0.012 0.15 0.019 0.234 0.019 1.338 0 2.313-0.666 3.169-1.25 0.4-0.275 0.784-0.534 1.144-0.675 0.356 0.556 0.978 0.925 1.688 0.925 0.706 0 1.331-0.369 1.688-0.925 0.359 0.141 0.744 0.403 1.144 0.675 0.859 0.588 1.831 1.25 3.169 1.25 0.081 0 0.159-0.006 0.234-0.019 0.578 0.716 1.022 1.516 1.325 2.388 0.119 0.344 0.419 0.597 0.778 0.656 0.966 0.162 1.666 0.994 1.666 1.975-0.006 0.978-0.706 1.809-1.672 1.975z" }),
_('path', { d: "M12 19c-1.653 0-3-1.347-3-3h-1c0 2.206 1.794 4 4 4s4-1.794 4-4h-1c0 1.653-1.347 3-3 3z" })
            );
        }
        function Baby3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Baby3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Baby3.SVG = Baby3SVG;
        return Baby3;
    })();
export const BackwardCircle = /*#__PURE__*/ (() => {
        function BackwardCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M15.744 9.063c-0.159-0.087-0.353-0.084-0.506 0.012l-3.237 2.022v-1.597c0-0.181-0.1-0.35-0.256-0.438-0.159-0.087-0.353-0.084-0.506 0.012l-4 2.5c-0.147 0.091-0.234 0.253-0.234 0.425s0.087 0.331 0.234 0.425l4 2.5c0.081 0.050 0.172 0.075 0.266 0.075 0.084 0 0.166-0.022 0.244-0.063 0.159-0.087 0.256-0.256 0.256-0.438v-1.597l3.234 2.022c0.081 0.050 0.172 0.075 0.266 0.075 0.084 0 0.166-0.022 0.244-0.063 0.159-0.087 0.256-0.256 0.256-0.438v-5c-0.003-0.181-0.103-0.35-0.259-0.438zM11 13.597l-2.556-1.597 2.556-1.597v3.194zM15 13.597l-2.556-1.597 2.556-1.597v3.194z" })
            );
        }
        function BackwardCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BackwardCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BackwardCircle.SVG = BackwardCircleSVG;
        return BackwardCircle;
    })();
export const BackwardSquare = /*#__PURE__*/ (() => {
        function BackwardSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M7.234 12.425l4 2.5c0.081 0.050 0.172 0.075 0.266 0.075 0.084 0 0.166-0.022 0.244-0.063 0.159-0.087 0.256-0.256 0.256-0.438v-1.597l3.234 2.022c0.081 0.050 0.172 0.075 0.266 0.075 0.084 0 0.166-0.022 0.244-0.063 0.159-0.087 0.256-0.256 0.256-0.438v-5c0-0.181-0.1-0.35-0.256-0.438-0.159-0.087-0.353-0.084-0.506 0.012l-3.237 2.022v-1.597c0-0.181-0.1-0.35-0.256-0.438-0.159-0.087-0.353-0.084-0.506 0.012l-4 2.5c-0.147 0.091-0.234 0.253-0.234 0.425s0.084 0.331 0.231 0.425zM15 10.403v3.197l-2.556-1.6 2.556-1.597zM11 10.403v3.197l-2.556-1.6 2.556-1.597z" })
            );
        }
        function BackwardSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BackwardSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BackwardSquare.SVG = BackwardSquareSVG;
        return BackwardSquare;
    })();
export const Backward = /*#__PURE__*/ (() => {
    function BackwardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.462 4.113c-0.331-0.172-0.731-0.147-1.034 0.069l-9.428 6.597v-5.778c0-0.372-0.206-0.716-0.537-0.888s-0.731-0.147-1.034 0.069l-10 7c-0.269 0.188-0.428 0.494-0.428 0.819s0.159 0.631 0.425 0.819l10 7c0.172 0.119 0.372 0.181 0.575 0.181 0.159 0 0.316-0.038 0.462-0.113 0.331-0.172 0.537-0.516 0.537-0.888v-5.778l9.425 6.6c0.172 0.119 0.372 0.181 0.575 0.181 0.159 0 0.316-0.038 0.462-0.113 0.331-0.172 0.537-0.516 0.537-0.888v-14.003c0-0.372-0.206-0.716-0.537-0.888zM10 17.078l-7.256-5.078 7.256-5.078v10.156zM21 17.078l-7.256-5.078 7.256-5.078v10.156z" })
        );
    }
    function Backward({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BackwardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Backward.SVG = BackwardSVG;
    return Backward;
})();
export const Baffled = /*#__PURE__*/ (() => {
        function BaffledSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M17.047 13.291c-0.753 1.647-1.478 2.553-2.15 2.691-0.697 0.141-1.466-0.559-2.281-1.303-0.963-0.878-2.056-1.875-3.369-1.644-1.122 0.197-2.134 1.225-3.191 3.234l-0.231 0.444 0.884 0.466 0.231-0.444c0.875-1.666 1.706-2.578 2.478-2.712 0.828-0.147 1.65 0.603 2.522 1.397 0.963 0.878 1.959 1.788 3.156 1.544 1.031-0.209 1.941-1.244 2.859-3.253l0.209-0.453-0.909-0.416-0.209 0.45z" }),
_('path', { d: "M8.5 10c1.378 0 2.5-1.122 2.5-2.5s-1.122-2.5-2.5-2.5-2.5 1.122-2.5 2.5 1.122 2.5 2.5 2.5zM8.5 6c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5z" }),
_('path', { d: "M15.5 10c1.378 0 2.5-1.122 2.5-2.5s-1.122-2.5-2.5-2.5-2.5 1.122-2.5 2.5 1.122 2.5 2.5 2.5zM15.5 6c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5z" }),
_('path', { d: "M9 7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M16 7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Baffled({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BaffledSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Baffled.SVG = BaffledSVG;
        return Baffled;
    })();
export const BagCheck = /*#__PURE__*/ (() => {
        function BagCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.394 11.281l-0.397-6.344c-0.034-0.528-0.469-0.938-0.997-0.938h-3.447c-0.166-0.606-0.378-1.169-0.631-1.672-0.75-1.503-1.788-2.328-2.922-2.328s-2.172 0.825-2.922 2.328c-0.253 0.503-0.462 1.069-0.631 1.672h-3.447c-0.528 0-0.966 0.409-0.997 0.938l-1 16c-0.019 0.275 0.081 0.547 0.269 0.747s0.453 0.316 0.728 0.316h9.813c1.184 1.231 2.847 2 4.688 2 3.584 0 6.5-2.916 6.5-6.5 0-2.925-1.944-5.406-4.606-6.219zM7.972 2.775c0.566-1.128 1.303-1.775 2.028-1.775s1.462 0.647 2.028 1.775c0.188 0.375 0.35 0.784 0.484 1.225h-5.025c0.138-0.441 0.297-0.853 0.484-1.225zM3.941 6h2.138c-0.050 0.488-0.078 0.991-0.078 1.5v1.5h1v-1.5c0-0.513 0.028-1.016 0.084-1.5h5.834c0.056 0.484 0.084 0.987 0.084 1.5v1.5h1v-1.5c0-0.509-0.025-1.012-0.078-1.5h2.137l0.312 5c-3.528 0.069-6.375 2.959-6.375 6.5 0 0.884 0.178 1.731 0.5 2.5h-7.434l0.875-14zM16.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M15.5 18.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4z" })
            );
        }
        function BagCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BagCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BagCheck.SVG = BagCheckSVG;
        return BagCheck;
    })();
export const BagCheckout = /*#__PURE__*/ (() => {
        function BagCheckoutSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.394 11.281l-0.397-6.344c-0.034-0.528-0.469-0.938-0.997-0.938h-3.447c-0.166-0.606-0.378-1.169-0.631-1.672-0.75-1.503-1.788-2.328-2.922-2.328s-2.172 0.825-2.922 2.328c-0.253 0.503-0.462 1.069-0.631 1.672h-3.447c-0.528 0-0.966 0.409-0.997 0.938l-1 16c-0.019 0.275 0.081 0.547 0.269 0.747s0.453 0.316 0.728 0.316h9.813c1.184 1.231 2.847 2 4.688 2 3.584 0 6.5-2.916 6.5-6.5 0-2.925-1.944-5.406-4.606-6.219zM7.972 2.775c0.566-1.128 1.303-1.775 2.028-1.775s1.462 0.647 2.028 1.775c0.188 0.375 0.35 0.784 0.484 1.225h-5.025c0.138-0.441 0.297-0.853 0.484-1.225zM3.941 6h2.138c-0.050 0.488-0.078 0.991-0.078 1.5v1.5h1v-1.5c0-0.513 0.028-1.016 0.084-1.5h5.834c0.056 0.484 0.084 0.987 0.084 1.5v1.5h1v-1.5c0-0.509-0.025-1.012-0.078-1.5h2.137l0.312 5c-3.528 0.069-6.375 2.959-6.375 6.5 0 0.884 0.178 1.731 0.5 2.5h-7.434l0.875-14zM16.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.847 17.138l-2.45-2.347-0.691 0.722 1.55 1.484h-5.256v1h5.294l-1.5 1.5 0.706 0.706 2.353-2.353c0.094-0.094 0.147-0.225 0.147-0.359s-0.056-0.259-0.153-0.353z" })
            );
        }
        function BagCheckout({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BagCheckoutSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BagCheckout.SVG = BagCheckoutSVG;
        return BagCheckout;
    })();
export const BagCross = /*#__PURE__*/ (() => {
        function BagCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.394 11.281l-0.397-6.344c-0.034-0.528-0.469-0.938-0.997-0.938h-3.447c-0.166-0.606-0.378-1.169-0.631-1.672-0.75-1.503-1.788-2.328-2.922-2.328s-2.172 0.825-2.922 2.328c-0.253 0.503-0.462 1.069-0.631 1.672h-3.447c-0.528 0-0.966 0.409-0.997 0.938l-1 16c-0.019 0.275 0.081 0.547 0.269 0.747s0.453 0.316 0.728 0.316h9.813c1.184 1.231 2.847 2 4.688 2 3.584 0 6.5-2.916 6.5-6.5 0-2.925-1.944-5.406-4.606-6.219zM7.972 2.775c0.566-1.128 1.303-1.775 2.028-1.775s1.462 0.647 2.028 1.775c0.188 0.375 0.35 0.784 0.484 1.225h-5.025c0.138-0.441 0.297-0.853 0.484-1.225zM3.941 6h2.138c-0.050 0.488-0.078 0.991-0.078 1.5v1.5h1v-1.5c0-0.513 0.028-1.016 0.084-1.5h5.834c0.056 0.484 0.084 0.987 0.084 1.5v1.5h1v-1.5c0-0.509-0.025-1.012-0.078-1.5h2.137l0.312 5c-3.528 0.069-6.375 2.959-6.375 6.5 0 0.884 0.178 1.731 0.5 2.5h-7.434l0.875-14zM16.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18.5 14.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function BagCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BagCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BagCross.SVG = BagCrossSVG;
        return BagCross;
    })();
export const BagFull = /*#__PURE__*/ (() => {
        function BagFullSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.997 21.938l-1-16c-0.034-0.528-0.469-0.938-0.997-0.938h-1.294l-3.853-3.853c-0.194-0.194-0.513-0.194-0.706 0l-2.147 2.147-1.147-1.147c-0.194-0.194-0.513-0.194-0.706 0l-2.853 2.853h-1.294c-0.528 0-0.966 0.409-0.997 0.938l-1 16c-0.019 0.275 0.081 0.547 0.269 0.747s0.453 0.316 0.728 0.316h16c0.275 0 0.541-0.116 0.728-0.316 0.191-0.2 0.288-0.472 0.269-0.747zM13.5 2.206l2.794 2.794h-5.588l2.794-2.794zM9.5 3.206l0.794 0.794-1 1h-1.584l1.791-1.794zM5.066 21l0.875-14h12.122l0.875 14h-13.872z" }),
_('path', { d: "M15 10.5c0 3.038-1.347 5.509-3 5.509s-3-2.472-3-5.509v-1.5h-1v1.5c0 1.728 0.387 3.341 1.094 4.538 0.747 1.269 1.781 1.969 2.906 1.969s2.159-0.7 2.906-1.969c0.706-1.197 1.094-2.809 1.094-4.538v-1.5h-1v1.5z" })
            );
        }
        function BagFull({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BagFullSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BagFull.SVG = BagFullSVG;
        return BagFull;
    })();
export const BagMinus = /*#__PURE__*/ (() => {
        function BagMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.394 11.281l-0.397-6.344c-0.034-0.528-0.469-0.938-0.997-0.938h-3.447c-0.166-0.606-0.378-1.169-0.631-1.672-0.75-1.503-1.788-2.328-2.922-2.328s-2.172 0.825-2.922 2.328c-0.253 0.503-0.462 1.069-0.631 1.672h-3.447c-0.528 0-0.966 0.409-0.997 0.938l-1 16c-0.019 0.275 0.081 0.547 0.269 0.747s0.453 0.316 0.728 0.316h9.813c1.184 1.231 2.847 2 4.688 2 3.584 0 6.5-2.916 6.5-6.5 0-2.925-1.944-5.406-4.606-6.219zM7.972 2.775c0.566-1.128 1.303-1.775 2.028-1.775s1.462 0.647 2.028 1.775c0.188 0.375 0.35 0.784 0.484 1.225h-5.025c0.138-0.441 0.297-0.853 0.484-1.225zM3.941 6h2.138c-0.050 0.488-0.078 0.991-0.078 1.5v1.5h1v-1.5c0-0.513 0.028-1.016 0.084-1.5h5.834c0.056 0.484 0.084 0.987 0.084 1.5v1.5h1v-1.5c0-0.509-0.025-1.012-0.078-1.5h2.137l0.312 5c-3.528 0.069-6.375 2.959-6.375 6.5 0 0.884 0.178 1.731 0.5 2.5h-7.434l0.875-14zM16.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M14 17h5v1h-5v-1z" })
            );
        }
        function BagMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BagMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BagMinus.SVG = BagMinusSVG;
        return BagMinus;
    })();
export const BagPlus = /*#__PURE__*/ (() => {
        function BagPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.394 11.281l-0.397-6.344c-0.034-0.528-0.469-0.938-0.997-0.938h-3.447c-0.166-0.606-0.378-1.169-0.631-1.672-0.75-1.503-1.788-2.328-2.922-2.328s-2.172 0.825-2.922 2.328c-0.253 0.503-0.462 1.069-0.631 1.672h-3.447c-0.528 0-0.966 0.409-0.997 0.938l-1 16c-0.019 0.275 0.081 0.547 0.269 0.747s0.453 0.316 0.728 0.316h9.813c1.184 1.231 2.847 2 4.688 2 3.584 0 6.5-2.916 6.5-6.5 0-2.925-1.944-5.406-4.606-6.219zM7.972 2.775c0.566-1.128 1.303-1.775 2.028-1.775s1.462 0.647 2.028 1.775c0.188 0.375 0.35 0.784 0.484 1.225h-5.025c0.138-0.441 0.297-0.853 0.484-1.225zM3.941 6h2.138c-0.050 0.488-0.078 0.991-0.078 1.5v1.5h1v-1.5c0-0.513 0.028-1.016 0.084-1.5h5.834c0.056 0.484 0.084 0.987 0.084 1.5v1.5h1v-1.5c0-0.509-0.025-1.012-0.078-1.5h2.137l0.312 5c-3.528 0.069-6.375 2.959-6.375 6.5 0 0.884 0.178 1.731 0.5 2.5h-7.434l0.875-14zM16.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17 15h-1v2h-2v1h2v2h1v-2h2v-1h-2z" })
            );
        }
        function BagPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BagPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BagPlus.SVG = BagPlusSVG;
        return BagPlus;
    })();
export const Bag = /*#__PURE__*/ (() => {
    function BagSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.997 21.938l-1-16c-0.034-0.528-0.469-0.938-0.997-0.938h-3.447c-0.166-0.606-0.378-1.169-0.631-1.672-0.75-1.5-1.788-2.328-2.922-2.328s-2.172 0.825-2.922 2.328c-0.253 0.503-0.462 1.069-0.631 1.672h-3.447c-0.528 0-0.966 0.409-0.997 0.938l-1 16c-0.019 0.275 0.081 0.547 0.269 0.747s0.453 0.316 0.728 0.316h16c0.275 0 0.541-0.116 0.728-0.316 0.191-0.2 0.288-0.472 0.269-0.747zM9.972 3.775c0.566-1.128 1.303-1.775 2.028-1.775s1.462 0.647 2.028 1.775c0.188 0.375 0.35 0.784 0.484 1.225h-5.025c0.138-0.441 0.297-0.853 0.484-1.225zM5.066 21l0.875-14h2.138c-0.050 0.487-0.078 0.991-0.078 1.5v1.5h1v-1.5c0-0.513 0.028-1.016 0.084-1.5h5.834c0.056 0.484 0.084 0.987 0.084 1.5v1.5h1v-1.5c0-0.509-0.025-1.013-0.078-1.5h2.137l0.875 14h-13.872z" })
        );
    }
    function Bag({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BagSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bag.SVG = BagSVG;
    return Bag;
})();
export const Balance = /*#__PURE__*/ (() => {
    function BalanceSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.5 13h-0.669l-2.572-6h0.741v-2h-8v-1.269c0.597-0.347 1-0.994 1-1.731 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 0.738 0.403 1.384 1 1.731v1.269h-8v2h0.741l-2.572 6h-0.669c-0.275 0-0.5 0.225-0.5 0.5v0.5c0 1.097 0.488 2.122 1.375 2.881 0.844 0.722 1.953 1.119 3.125 1.119s2.284-0.397 3.125-1.119c0.888-0.759 1.375-1.781 1.375-2.881v-0.5c0-0.275-0.225-0.5-0.5-0.5h-0.669l-2.572-6h5.741v13h-2c-1.103 0-2 0.897-2 2h-1v2h12v-2h-1c0-1.103-0.897-2-2-2h-2v-13h5.741l-2.572 6h-0.669c-0.275 0-0.5 0.225-0.5 0.5v0.5c0 1.097 0.487 2.122 1.375 2.881 0.844 0.722 1.953 1.119 3.125 1.119s2.284-0.397 3.125-1.119c0.888-0.759 1.375-1.781 1.375-2.881v-0.5c0-0.275-0.225-0.5-0.5-0.5zM12 1c0.55 0 1 0.45 1 1s-0.45 1-1 1c-0.55 0-1-0.45-1-1s0.45-1 1-1zM6.325 15.363c-0.481 0.413-1.128 0.638-1.825 0.638s-1.344-0.228-1.825-0.638c-0.434-0.375-0.675-0.856-0.675-1.362h5c0 0.506-0.241 0.987-0.675 1.362zM2.259 13l2.241-5.231 2.241 5.231h-4.481zM16 22h-8c0-0.55 0.45-1 1-1h6c0.55 0 1 0.45 1 1zM19.5 7.769l2.241 5.231h-4.481l2.241-5.231zM21.325 15.363c-0.481 0.413-1.128 0.638-1.825 0.638s-1.344-0.228-1.825-0.638c-0.434-0.375-0.675-0.856-0.675-1.362h5c0 0.506-0.241 0.987-0.675 1.362z" })
        );
    }
    function Balance({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BalanceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Balance.SVG = BalanceSVG;
    return Balance;
})();
export const Balloon = /*#__PURE__*/ (() => {
        function BalloonSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 0c-3.309 0-6 2.691-6 6 0 1.869 0.637 4.047 1.706 5.828 0.541 0.9 1.172 1.656 1.828 2.191 0.387 0.316 0.781 0.553 1.178 0.719-0.572 0.841-0.791 1.547-0.684 2.184 0.153 0.934 0.966 1.453 1.681 1.913 0.609 0.391 1.188 0.759 1.278 1.294 0.087 0.494-0.209 1.191-0.881 2.069l-0.303 0.397 0.794 0.606 0.303-0.397c0.872-1.141 1.212-2.047 1.072-2.85-0.169-0.966-0.997-1.494-1.725-1.962-0.594-0.381-1.153-0.738-1.234-1.234-0.031-0.194 0.003-0.422 0.103-0.684 0.225 0.547 0.759 0.928 1.384 0.928 0.828 0 1.5-0.672 1.5-1.5 0-0.356-0.125-0.684-0.334-0.944 0.269-0.144 0.537-0.325 0.8-0.541 0.656-0.534 1.287-1.291 1.828-2.191 1.069-1.778 1.706-3.956 1.706-5.825 0-3.309-2.691-6-6-6zM12.5 16c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5zM14.581 10.797c-0.816 1.359-1.806 2.203-2.581 2.203s-1.766-0.844-2.581-2.203c-0.875-1.459-1.419-3.297-1.419-4.797 0-2.206 1.794-4 4-4s4 1.794 4 4c0 1.5-0.544 3.338-1.419 4.797z" }),
_('path', { d: "M12 3v1c1.103 0 2 0.897 2 2v1h1v-1c0-1.653-1.347-3-3-3z" })
            );
        }
        function Balloon({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BalloonSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Balloon.SVG = BalloonSVG;
        return Balloon;
    })();
export const Bandage = /*#__PURE__*/ (() => {
        function BandageSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.241 1.756c-1.131-1.134-2.641-1.759-4.244-1.759s-3.109 0.625-4.244 1.756l-12 12c-1.131 1.134-1.756 2.644-1.756 4.244 0 1.603 0.625 3.109 1.756 4.244 1.134 1.134 2.644 1.759 4.244 1.759 1.603 0 3.109-0.625 4.244-1.756l12-12c1.134-1.134 1.759-2.644 1.759-4.247 0-1.6-0.625-3.109-1.759-4.241zM20.828 8.828l-12 12c-0.756 0.756-1.759 1.172-2.828 1.172s-2.072-0.416-2.828-1.172c-0.756-0.756-1.172-1.759-1.172-2.828s0.416-2.072 1.172-2.828l12-12c0.756-0.756 1.759-1.172 2.828-1.172s2.072 0.416 2.828 1.172c0.756 0.756 1.172 1.759 1.172 2.828 0 1.066-0.416 2.072-1.172 2.828z" }),
_('path', { d: "M13 8.003c-0.803 0-1.556 0.312-2.122 0.878l-2 2c-0.566 0.566-0.878 1.319-0.878 2.122s0.312 1.556 0.878 2.122c0.569 0.563 1.322 0.875 2.122 0.875 0.803 0 1.556-0.312 2.122-0.878l2-2c0.566-0.566 0.878-1.319 0.878-2.122s-0.312-1.556-0.878-2.122c-0.566-0.563-1.319-0.875-2.122-0.875zM14.416 12.416l-2 2c-0.378 0.378-0.878 0.584-1.416 0.584-0.534 0-1.038-0.206-1.413-0.584s-0.584-0.878-0.584-1.413c0-0.534 0.206-1.038 0.584-1.413l2-2c0.378-0.378 0.878-0.584 1.413-0.584s1.038 0.206 1.413 0.584c0.378 0.378 0.584 0.878 0.584 1.413 0.003 0.534-0.203 1.034-0.581 1.413z" }),
_('path', { d: "M19 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M20 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M20 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M18 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M18 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M16 5.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M6 15.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M5 17.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M5 19.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M7 17.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M7 19.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M9 18.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Bandage({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BandageSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bandage.SVG = BandageSVG;
        return Bandage;
    })();
export const Bandages = /*#__PURE__*/ (() => {
        function BandagesSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 8.003c-0.803 0-1.556 0.312-2.122 0.878l-2 2c-0.566 0.566-0.878 1.319-0.878 2.122s0.312 1.556 0.878 2.122c0.569 0.563 1.322 0.875 2.122 0.875 0.803 0 1.556-0.312 2.122-0.878l2-2c0.566-0.566 0.878-1.319 0.878-2.122s-0.312-1.556-0.878-2.122c-0.566-0.563-1.319-0.875-2.122-0.875zM14.416 12.416l-2 2c-0.378 0.378-0.878 0.584-1.416 0.584-0.534 0-1.038-0.206-1.413-0.584s-0.584-0.878-0.584-1.413c0-0.534 0.206-1.038 0.584-1.413l2-2c0.378-0.378 0.878-0.584 1.413-0.584s1.038 0.206 1.413 0.584c0.378 0.378 0.584 0.878 0.584 1.413 0.003 0.534-0.203 1.034-0.581 1.413z" }),
_('path', { d: "M22.244 13.759l-1.759-1.759 1.756-1.756c1.134-1.134 1.759-2.644 1.759-4.247s-0.625-3.109-1.756-4.244c-1.134-1.131-2.644-1.756-4.247-1.756s-3.109 0.625-4.244 1.756l-1.753 1.759-1.756-1.756c-2.341-2.341-6.147-2.341-8.487 0s-2.341 6.147 0 8.487l1.756 1.756-1.756 1.756c-1.134 1.131-1.759 2.641-1.759 4.241 0 1.603 0.625 3.109 1.756 4.244 1.134 1.134 2.644 1.759 4.244 1.759 1.603 0 3.109-0.625 4.244-1.756l1.756-1.756 1.759 1.759c1.169 1.169 2.706 1.756 4.244 1.756s3.072-0.584 4.244-1.756c2.341-2.341 2.341-6.15 0-8.487zM3.169 8.828c-1.559-1.559-1.559-4.097 0-5.656s4.097-1.559 5.656 0l1.756 1.756-5.656 5.656-1.756-1.756zM8.828 20.828c-0.756 0.756-1.759 1.172-2.828 1.172s-2.072-0.416-2.828-1.172c-0.756-0.756-1.172-1.759-1.172-2.828s0.416-2.072 1.172-2.828l12-12c0.756-0.756 1.759-1.172 2.828-1.172s2.072 0.416 2.828 1.172c0.756 0.756 1.172 1.759 1.172 2.828s-0.416 2.072-1.172 2.828l-12 12zM20.831 20.831c-1.559 1.559-4.097 1.559-5.656 0l-1.759-1.759 5.656-5.656 1.759 1.759c1.559 1.556 1.559 4.097 0 5.656z" }),
_('path', { d: "M19 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M20 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M20 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M18 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M18 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M16 5.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M6 15.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M5 17.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M5 19.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M7 17.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M7 19.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M9 18.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M16 18.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M18 19.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M20 19.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M18 17.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M20 17.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M19 15.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M9 5.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M7 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M5 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M7 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M5 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M6 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Bandages({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BandagesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bandages.SVG = BandagesSVG;
        return Bandages;
    })();
export const Barcode = /*#__PURE__*/ (() => {
        function BarcodeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 5h1v14h-1v-14z" }),
_('path', { d: "M2 5h2v14h-2v-14z" }),
_('path', { d: "M5 5h1v14h-1v-14z" }),
_('path', { d: "M7 5h1v14h-1v-14z" }),
_('path', { d: "M9 5h2v14h-2v-14z" }),
_('path', { d: "M23 5h1v14h-1v-14z" }),
_('path', { d: "M18 5h2v14h-2v-14z" }),
_('path', { d: "M21 5h1v14h-1v-14z" }),
_('path', { d: "M16 5h1v14h-1v-14z" }),
_('path', { d: "M14 5h1v14h-1v-14z" }),
_('path', { d: "M12 5h1v14h-1v-14z" })
            );
        }
        function Barcode({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BarcodeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Barcode.SVG = BarcodeSVG;
        return Barcode;
    })();
export const Barcode2 = /*#__PURE__*/ (() => {
        function Barcode2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 5h1v14h-1v-14z" }),
_('path', { d: "M2 5h2v11h-2v-11z" }),
_('path', { d: "M5 5h1v11h-1v-11z" }),
_('path', { d: "M7 5h1v11h-1v-11z" }),
_('path', { d: "M9 5h2v11h-2v-11z" }),
_('path', { d: "M23 5h1v14h-1v-14z" }),
_('path', { d: "M18 5h2v11h-2v-11z" }),
_('path', { d: "M21 5h1v11h-1v-11z" }),
_('path', { d: "M16 5h1v11h-1v-11z" }),
_('path', { d: "M14 5h1v11h-1v-11z" }),
_('path', { d: "M12 5h1v11h-1v-11z" }),
_('path', { d: "M2 17h20v1h-20v-1z" })
            );
        }
        function Barcode2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Barcode2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Barcode2.SVG = Barcode2SVG;
        return Barcode2;
    })();
export const Barcode3 = /*#__PURE__*/ (() => {
        function Barcode3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 5h1v11h-1v-11z" }),
_('path', { d: "M2 5h2v11h-2v-11z" }),
_('path', { d: "M5 5h1v11h-1v-11z" }),
_('path', { d: "M7 5h1v11h-1v-11z" }),
_('path', { d: "M9 5h2v11h-2v-11z" }),
_('path', { d: "M23 5h1v11h-1v-11z" }),
_('path', { d: "M18 5h2v11h-2v-11z" }),
_('path', { d: "M21 5h1v11h-1v-11z" }),
_('path', { d: "M16 5h1v11h-1v-11z" }),
_('path', { d: "M14 5h1v11h-1v-11z" }),
_('path', { d: "M12 5h1v11h-1v-11z" }),
_('path', { d: "M0 17h1v2h-1v-2z" }),
_('path', { d: "M2 17h2v2h-2v-2z" }),
_('path', { d: "M5 17h1v2h-1v-2z" }),
_('path', { d: "M7 17h1v2h-1v-2z" }),
_('path', { d: "M9 17h2v2h-2v-2z" }),
_('path', { d: "M23 17h1v2h-1v-2z" }),
_('path', { d: "M18 17h2v2h-2v-2z" }),
_('path', { d: "M21 17h1v2h-1v-2z" }),
_('path', { d: "M16 17h1v2h-1v-2z" }),
_('path', { d: "M14 17h1v2h-1v-2z" }),
_('path', { d: "M12 17h1v2h-1v-2z" })
            );
        }
        function Barcode3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Barcode3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Barcode3.SVG = Barcode3SVG;
        return Barcode3;
    })();
export const BaseballBat = /*#__PURE__*/ (() => {
        function BaseballBatSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.559 19.853l-0.413-0.413c-0.45-0.45-1.113-0.553-1.662-0.312-3.831-3.862-5.369-5.981-6.994-8.222-1.778-2.45-3.619-4.984-8.516-9.881-0.663-0.663-1.541-1.025-2.475-1.025s-1.812 0.363-2.475 1.025c-0.663 0.663-1.025 1.541-1.025 2.475s0.363 1.812 1.025 2.475c4.897 4.897 7.431 6.734 9.881 8.516 2.241 1.625 4.359 3.162 8.219 6.997-0.241 0.55-0.134 1.212 0.312 1.662v0l0.412 0.413c0.294 0.294 0.678 0.438 1.059 0.438 0.384 0 0.769-0.147 1.059-0.438l1.587-1.584c0.591-0.588 0.591-1.541 0.003-2.125zM12.081 12.872c-2.388-1.734-4.856-3.525-9.644-8.309-0.281-0.284-0.438-0.663-0.438-1.062s0.156-0.778 0.441-1.059c0.281-0.284 0.659-0.441 1.059-0.441s0.778 0.156 1.059 0.441c4.784 4.784 6.578 7.253 8.309 9.644 0.759 1.044 1.497 2.066 2.447 3.237-1.169-0.953-2.187-1.694-3.234-2.45zM22.853 21.269l-1.584 1.584c-0.194 0.194-0.513 0.194-0.706 0l-0.413-0.413c-0.194-0.194-0.194-0.513 0-0.706l1.584-1.584c0.194-0.194 0.513-0.194 0.706 0l0.413 0.413c0.197 0.194 0.197 0.509 0 0.706z" }),
_('path', { d: "M2.5 16c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.122-2.5-2.5-2.5zM2.5 20c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" })
            );
        }
        function BaseballBat({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BaseballBatSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BaseballBat.SVG = BaseballBatSVG;
        return BaseballBat;
    })();
export const Baseball = /*#__PURE__*/ (() => {
    function BaseballSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM4.188 5.766c0.506 0.259 0.975 0.578 1.397 0.944l-0.791 0.791 0.706 0.706 0.787-0.787c0.556 0.644 0.997 1.391 1.291 2.194l-1.709 0.569 0.316 0.95 1.669-0.556c0.097 0.462 0.147 0.941 0.147 1.425s-0.050 0.963-0.147 1.425l-1.669-0.556-0.316 0.95 1.709 0.569c-0.294 0.806-0.731 1.55-1.291 2.194l-0.787-0.788-0.706 0.706 0.791 0.791c-0.422 0.366-0.891 0.684-1.397 0.944-1.369-1.709-2.187-3.878-2.187-6.234s0.819-4.525 2.187-6.234zM12 22c-2.787 0-5.316-1.147-7.131-2.994 0.509-0.281 0.987-0.619 1.425-1.003l1.206 1.206 0.706-0.706-1.206-1.209c0.181-0.206 0.356-0.425 0.519-0.653 0.428-0.603 0.769-1.253 1.016-1.938l1.284 0.428 0.316-0.95-1.322-0.441c0.125-0.566 0.191-1.15 0.191-1.744s-0.066-1.175-0.191-1.744l1.322-0.441-0.316-0.95-1.287 0.434c-0.247-0.684-0.584-1.334-1.016-1.938-0.162-0.228-0.334-0.444-0.519-0.653l1.206-1.206-0.703-0.706-1.206 1.206c-0.438-0.384-0.912-0.722-1.425-1.003 1.816-1.85 4.344-2.997 7.131-2.997s5.316 1.147 7.131 2.994c-0.509 0.281-0.987 0.619-1.425 1.003l-1.206-1.203-0.706 0.706 1.206 1.206c-0.181 0.206-0.356 0.425-0.519 0.653-0.428 0.603-0.769 1.253-1.016 1.938l-1.284-0.428-0.316 0.95 1.322 0.441c-0.125 0.566-0.191 1.15-0.191 1.744s0.066 1.175 0.191 1.744l-1.322 0.441 0.316 0.95 1.284-0.428c0.247 0.684 0.584 1.334 1.016 1.938 0.162 0.228 0.334 0.444 0.519 0.653l-1.206 1.2 0.706 0.706 1.206-1.206c0.438 0.384 0.912 0.722 1.425 1.003-1.816 1.85-4.344 2.997-7.131 2.997zM19.812 18.234c-0.506-0.259-0.975-0.578-1.397-0.944l0.791-0.791-0.706-0.706-0.788 0.787c-0.556-0.644-0.997-1.391-1.291-2.194l1.709-0.569-0.316-0.95-1.669 0.556c-0.097-0.462-0.147-0.941-0.147-1.425s0.050-0.963 0.147-1.425l1.669 0.556 0.316-0.95-1.709-0.569c0.294-0.806 0.731-1.55 1.291-2.194l0.788 0.788 0.706-0.706-0.791-0.791c0.422-0.366 0.891-0.684 1.397-0.944 1.369 1.709 2.187 3.878 2.187 6.234s-0.819 4.525-2.187 6.234z" })
        );
    }
    function Baseball({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BaseballSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Baseball.SVG = BaseballSVG;
    return Baseball;
})();
export const Basket = /*#__PURE__*/ (() => {
    function BasketSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 9h-3.294l-5.853-5.853c0.097-0.2 0.147-0.419 0.147-0.647 0-0.4-0.156-0.778-0.441-1.059-0.281-0.284-0.659-0.441-1.059-0.441s-0.778 0.156-1.059 0.441v0c-0.284 0.281-0.441 0.659-0.441 1.059s0.156 0.778 0.441 1.059c0.284 0.284 0.659 0.441 1.059 0.441 0.228 0 0.447-0.050 0.647-0.147l5.147 5.147h-14.587l5.147-5.147c0.203 0.097 0.425 0.147 0.647 0.147 0.384 0 0.769-0.147 1.059-0.438 0.584-0.584 0.584-1.537 0-2.122s-1.537-0.584-2.122 0c-0.462 0.459-0.559 1.15-0.294 1.706l-5.85 5.853h-3.294v2h1.688l2.334 11.203c0.097 0.462 0.506 0.797 0.978 0.797h14c0.475 0 0.881-0.331 0.978-0.797l2.334-11.203h1.688v-2zM13.147 2.853c-0.094-0.094-0.147-0.219-0.147-0.353s0.053-0.259 0.147-0.353v0c0.094-0.094 0.219-0.147 0.353-0.147s0.259 0.053 0.353 0.147c0.094 0.094 0.147 0.219 0.147 0.353s-0.053 0.259-0.147 0.353c-0.094 0.094-0.219 0.147-0.353 0.147s-0.259-0.053-0.353-0.147zM10.147 2.147c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.194 0.194 0.194 0.513 0 0.706s-0.513 0.194-0.706 0c-0.197-0.194-0.197-0.513 0-0.706zM11 13v-2h2v2h-2zM13 14v2h-2v-2h2zM10 13h-2v-2h2v2zM10 14v2h-2v-2h2zM7 16h-2.228l-0.416-2h2.644v2zM4.981 17h2.019v2h-1.603l-0.416-2zM8 17h2v2h-2v-2zM11 17h2v2h-2v-2zM14 17h2v2h-2v-2zM17 17h2.019l-0.416 2h-1.603v-2zM17 16v-2h2.644l-0.416 2h-2.228zM16 16h-2v-2h2v2zM14 13v-2h2v2h-2zM7 11v2h-2.853l-0.416-2h3.269zM5.813 21l-0.209-1h12.791l-0.209 1h-12.372zM19.853 13h-2.853v-2h3.269l-0.416 2z" })
        );
    }
    function Basket({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BasketSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Basket.SVG = BasketSVG;
    return Basket;
})();
export const Basketball = /*#__PURE__*/ (() => {
    function BasketballSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM22 12c0 0.047 0 0.094 0 0.141-0.45-0.863-0.987-1.678-1.512-2.478-0.372-0.566-0.738-1.119-1.072-1.684 0.709 0.025 1.334 0.119 1.859 0.281 0.466 1.156 0.725 2.419 0.725 3.741zM20.716 7.1c-0.556-0.097-1.175-0.138-1.847-0.128-0.453-0.922-0.778-1.891-0.859-2.963 1.1 0.831 2.025 1.884 2.706 3.091zM16.987 3.334c-0.025 1.372 0.303 2.578 0.803 3.694-0.047 0.003-0.097 0.009-0.147 0.012-0.322 0.031-0.656 0.072-1 0.122-0.184-0.516-0.387-1.013-0.606-1.481-0.712-1.534-1.566-2.737-2.525-3.566 1.25 0.191 2.422 0.612 3.475 1.219zM11.456 2.016c1.406 0.519 2.675 1.931 3.675 4.087 0.184 0.397 0.356 0.809 0.513 1.234-0.625 0.122-1.272 0.275-1.934 0.453-0.166-0.525-0.403-1.009-0.703-1.444-0.859-1.238-2.209-2.019-3.903-2.256-1.056-0.15-2.231-0.078-3.469 0.2 1.6-1.322 3.616-2.156 5.822-2.275zM4.184 5.769c3.55-1.316 6.588-0.891 8.003 1.15 0.237 0.344 0.425 0.728 0.563 1.15-0.278 0.084-0.563 0.175-0.844 0.269-3.681 1.228-7.253 3.069-9.813 5.034-0.063-0.447-0.094-0.906-0.094-1.372 0-2.353 0.819-4.519 2.184-6.231zM2.309 14.475c2.466-1.991 6.197-3.947 9.909-5.187 0.247-0.084 0.497-0.162 0.741-0.237 0.128 1.031 0.006 2.213-0.372 3.478-0.769 2.566-2.562 5.447-5.194 8.35-2.494-1.303-4.372-3.622-5.084-6.403zM8.35 21.309c1.275-1.428 2.353-2.853 3.216-4.241 0.909-1.469 1.578-2.9 1.984-4.256 0.391-1.3 0.537-2.519 0.441-3.625-0.012-0.144-0.028-0.284-0.050-0.422 0.7-0.191 1.381-0.35 2.034-0.472 1.313 4.219 1.416 9.422 0.144 12.822-1.263 0.569-2.653 0.884-4.119 0.884-1.287 0-2.519-0.244-3.65-0.691zM17.388 20.422c0.525-1.9 0.731-4.203 0.578-6.644-0.125-1.969-0.469-3.903-1-5.65 0.266-0.038 0.525-0.069 0.775-0.091 0.181-0.019 0.359-0.031 0.534-0.041 0.419 0.766 0.9 1.494 1.375 2.216 0.856 1.3 1.672 2.541 2.119 3.928-0.575 2.628-2.184 4.872-4.381 6.281z" })
        );
    }
    function Basketball({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BasketballSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Basketball.SVG = BasketballSVG;
    return Basketball;
})();
export const BathroomScale = /*#__PURE__*/ (() => {
        function BathroomScaleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 18h5v1h-5v-1z" }),
_('path', { d: "M5 14h5v1h-5v-1z" }),
_('path', { d: "M5 12h5v1h-5v-1z" }),
_('path', { d: "M14 18h5v1h-5v-1z" }),
_('path', { d: "M14 14h5v1h-5v-1z" }),
_('path', { d: "M14 12h5v1h-5v-1z" }),
_('path', { d: "M5 16h5v1h-5v-1z" }),
_('path', { d: "M14 16h5v1h-5v-1z" }),
_('path', { d: "M9.125 9.828c0.094 0.109 0.231 0.172 0.375 0.172h5c0.144 0 0.281-0.063 0.375-0.172l2-2.281c0.087-0.103 0.134-0.234 0.122-0.369-0.009-0.134-0.075-0.259-0.178-0.344-1.512-1.25-3.044-1.834-4.819-1.834s-3.306 0.584-4.819 1.834c-0.103 0.087-0.169 0.209-0.178 0.344s0.034 0.269 0.122 0.369l2 2.281zM12 6c1.394 0 2.575 0.4 3.775 1.287l-1.5 1.713h-1.437l0.216-1.941-0.994-0.109-0.228 2.053h-2.103l-1.5-1.713c1.197-0.891 2.378-1.291 3.772-1.291z" }),
_('path', { d: "M19 1h-14c-2.206 0-4 1.794-4 4v14c0 2.206 1.794 4 4 4h14c2.206 0 4-1.794 4-4v-14c0-2.206-1.794-4-4-4zM21 19c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14c1.103 0 2 0.897 2 2v14z" })
            );
        }
        function BathroomScale({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BathroomScaleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BathroomScale.SVG = BathroomScaleSVG;
        return BathroomScale;
    })();
export const Bathtub = /*#__PURE__*/ (() => {
        function BathtubSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.178 12.984l-0.356-1.969c-1.272 0.231-2.544 0.422-3.822 0.572v-9.588c0-1.103-0.897-2-2-2h-4c-1.103 0-2 0.897-2 2h-1c-1.103 0-2 0.897-2 2v0.5c0 0.275 0.225 0.5 0.5 0.5h6c0.275 0 0.5-0.225 0.5-0.5v-0.5c0-1.103-0.897-2-2-2h-1c0-0.55 0.45-1 1-1h4c0.55 0 1 0.45 1 1v9.694c-5.606 0.563-11.244 0.334-16.822-0.678l-0.356 1.969c0.397 0.072 0.797 0.141 1.194 0.206l0.553 4.431c0.247 1.969 1.625 3.556 3.431 4.141v0.241c0 0.55-0.45 1-1 1v1c1.103 0 2-0.897 2-2v-0.028c0.175 0.019 0.353 0.028 0.531 0.028h8.937c0.178 0 0.356-0.009 0.531-0.028v0.028c0 1.103 0.897 2 2 2v-1c-0.55 0-1-0.45-1-1v-0.241c1.806-0.584 3.184-2.172 3.431-4.141l0.553-4.431c0.4-0.066 0.797-0.134 1.194-0.206zM13 3c0.55 0 1 0.45 1 1h-5c0-0.55 0.45-1 1-1h3zM19.447 17.372c-0.188 1.497-1.466 2.628-2.978 2.628h-8.937c-1.509 0-2.791-1.131-2.978-2.628l-0.484-3.884c2.644 0.341 5.3 0.513 7.931 0.513s5.287-0.172 7.931-0.513l-0.484 3.884z" }),
_('path', { d: "M7.829 8.724l1.448-2.896 0.894 0.447-1.448 2.896-0.894-0.447z" }),
_('path', { d: "M12.828 6.276l0.894-0.447 1.448 2.896-0.894 0.447-1.448-2.896z" }),
_('path', { d: "M11 7h1v3h-1v-3z" })
            );
        }
        function Bathtub({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BathtubSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bathtub.SVG = BathtubSVG;
        return Bathtub;
    })();
export const Battery10 = /*#__PURE__*/ (() => {
        function Battery10SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 8h-1v-1c0-1.103-0.897-2-2-2h-17c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM19 17h-17v-10l17-0.003c0 0 0 0 0 0.003v10zM22 14h-1v-4h1v4z" }),
_('path', { d: "M3 8h1v8h-1v-8z" })
            );
        }
        function Battery10({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Battery10SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Battery10.SVG = Battery10SVG;
        return Battery10;
    })();
export const Battery100 = /*#__PURE__*/ (() => {
        function Battery100SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 8h-1v-1c0-1.103-0.897-2-2-2h-17c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM19 17h-17v-10l17-0.003c0 0 0 0 0 0.003v10zM22 14h-1v-4h1v4z" }),
_('path', { d: "M3 8h1v8h-1v-8zM5 16h1v-8h-1v8zM7 16h1v-8h-1v8zM9 16h1v-8h-1v8zM11 16h1v-8h-1v8zM13 16h1v-8h-1v8zM15 16h1v-8h-1v8zM17 16h1v-8h-1v8z" })
            );
        }
        function Battery100({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Battery100SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Battery100.SVG = Battery100SVG;
        return Battery100;
    })();
export const Battery25 = /*#__PURE__*/ (() => {
        function Battery25SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 8h-1v-1c0-1.103-0.897-2-2-2h-17c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM19 17h-17v-10l17-0.003c0 0 0 0 0 0.003v10zM22 14h-1v-4h1v4z" }),
_('path', { d: "M3 8h1v8h-1v-8zM5 16h1v-8h-1v8z" })
            );
        }
        function Battery25({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Battery25SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Battery25.SVG = Battery25SVG;
        return Battery25;
    })();
export const Battery40 = /*#__PURE__*/ (() => {
        function Battery40SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 8h-1v-1c0-1.103-0.897-2-2-2h-17c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM19 17h-17v-10l17-0.003c0 0 0 0 0 0.003v10zM22 14h-1v-4h1v4z" }),
_('path', { d: "M3 8h1v8h-1v-8zM5 16h1v-8h-1v8zM7 16h1v-8h-1v8z" })
            );
        }
        function Battery40({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Battery40SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Battery40.SVG = Battery40SVG;
        return Battery40;
    })();
export const Battery50 = /*#__PURE__*/ (() => {
        function Battery50SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 8h-1v-1c0-1.103-0.897-2-2-2h-17c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM19 17h-17v-10l17-0.003c0 0 0 0 0 0.003v10zM22 14h-1v-4h1v4z" }),
_('path', { d: "M3 8h1v8h-1v-8zM5 16h1v-8h-1v8zM7 16h1v-8h-1v8zM9 16h1v-8h-1v8z" })
            );
        }
        function Battery50({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Battery50SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Battery50.SVG = Battery50SVG;
        return Battery50;
    })();
export const Battery60 = /*#__PURE__*/ (() => {
        function Battery60SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 8h-1v-1c0-1.103-0.897-2-2-2h-17c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM19 17h-17v-10l17-0.003c0 0 0 0 0 0.003v10zM22 14h-1v-4h1v4z" }),
_('path', { d: "M3 8h1v8h-1v-8zM5 16h1v-8h-1v8zM7 16h1v-8h-1v8zM9 16h1v-8h-1v8zM11 16h1v-8h-1v8z" })
            );
        }
        function Battery60({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Battery60SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Battery60.SVG = Battery60SVG;
        return Battery60;
    })();
export const Battery75 = /*#__PURE__*/ (() => {
        function Battery75SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 8h-1v-1c0-1.103-0.897-2-2-2h-17c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM19 17h-17v-10l17-0.003c0 0 0 0 0 0.003v10zM22 14h-1v-4h1v4z" }),
_('path', { d: "M3 8h1v8h-1v-8zM5 16h1v-8h-1v8zM7 16h1v-8h-1v8zM9 16h1v-8h-1v8zM11 16h1v-8h-1v8zM13 16h1v-8h-1v8z" })
            );
        }
        function Battery75({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Battery75SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Battery75.SVG = Battery75SVG;
        return Battery75;
    })();
export const Battery90 = /*#__PURE__*/ (() => {
        function Battery90SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 8h-1v-1c0-1.103-0.897-2-2-2h-17c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM19 17h-17v-10l17-0.003c0 0 0 0 0 0.003v10zM22 14h-1v-4h1v4z" }),
_('path', { d: "M3 8h1v8h-1v-8zM5 16h1v-8h-1v8zM7 16h1v-8h-1v8zM9 16h1v-8h-1v8zM11 16h1v-8h-1v8zM13 16h1v-8h-1v8zM15 16h1v-8h-1v8z" })
            );
        }
        function Battery90({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Battery90SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Battery90.SVG = Battery90SVG;
        return Battery90;
    })();
export const BatteryBolt = /*#__PURE__*/ (() => {
        function BatteryBoltSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 8h-1v-1c0-1.103-0.897-2-2-2h-4v2h4v10h-6v2h6c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM22 14h-1v-4h1v4z" }),
_('path', { d: "M2 7h6v-2h-6c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h4v-2h-4v-10z" }),
_('path', { d: "M14.941 10.266c-0.087-0.162-0.256-0.266-0.441-0.266h-2.409l0.903-5.419c0.038-0.231-0.091-0.459-0.309-0.547s-0.469-0.009-0.6 0.188l-6 9c-0.103 0.153-0.112 0.35-0.025 0.513s0.256 0.266 0.441 0.266h2.409l-0.903 5.419c-0.038 0.231 0.091 0.459 0.309 0.547 0.059 0.025 0.122 0.034 0.184 0.034 0.162 0 0.322-0.081 0.416-0.222l6-9c0.103-0.153 0.112-0.35 0.025-0.513zM9.375 17.284l0.616-3.703c0.025-0.144-0.016-0.294-0.113-0.406s-0.234-0.178-0.381-0.178h-2.066l4.194-6.281-0.616 3.703c-0.025 0.144 0.016 0.294 0.113 0.406 0.094 0.113 0.234 0.178 0.381 0.178h2.066l-4.194 6.281z" })
            );
        }
        function BatteryBolt({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BatteryBoltSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BatteryBolt.SVG = BatteryBoltSVG;
        return BatteryBolt;
    })();
export const BatteryCheck = /*#__PURE__*/ (() => {
        function BatteryCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 10h-1v-1c0-1.103-0.897-2-2-2h-2.5c-0.981-2.347-3.3-4-6-4s-5.019 1.653-6 4h-2.5c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM10.5 4c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM19 19h-17v-10h2.019c-0.012 0.166-0.019 0.331-0.019 0.5 0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5c0-0.169-0.006-0.334-0.019-0.5h2.019v10zM22 16h-1v-4h1v4z" }),
_('path', { d: "M9.5 12c0.128 0 0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147z" })
            );
        }
        function BatteryCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BatteryCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BatteryCheck.SVG = BatteryCheckSVG;
        return BatteryCheck;
    })();
export const BatteryCross = /*#__PURE__*/ (() => {
        function BatteryCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 10h-1v-1c0-1.103-0.897-2-2-2h-2.5c-0.981-2.347-3.3-4-6-4s-5.019 1.653-6 4h-2.5c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM10.5 4c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM19 19h-17v-10h2.019c-0.012 0.166-0.019 0.331-0.019 0.5 0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5c0-0.169-0.006-0.334-0.019-0.5h2.019v10zM22 16h-1v-4h1v4z" }),
_('path', { d: "M8.5 12.206l2-2 2 2 0.706-0.706-2-2 2-2-0.706-0.706-2 2-2-2-0.706 0.706 2 2-2 2z" })
            );
        }
        function BatteryCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BatteryCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BatteryCross.SVG = BatteryCrossSVG;
        return BatteryCross;
    })();
export const BatteryDroplet = /*#__PURE__*/ (() => {
        function BatteryDropletSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 8h-1v-1c0-1.103-0.897-2-2-2h-5v2h5v10h-3v2h3c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM22 14h-1v-4h1v4z" }),
_('path', { d: "M2 7h5v-2h-5c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h3v-2h-3v-10z" }),
_('path', { d: "M10.994 4.428c-0.034-0.247-0.247-0.428-0.494-0.428s-0.459 0.181-0.494 0.428c-0.175 1.203-0.928 2.581-1.725 4.038-1.069 1.953-2.281 4.169-2.281 6.438 0 1.312 0.422 2.556 1.188 3.5 0.834 1.031 2.013 1.597 3.312 1.597 1.303 0 2.478-0.566 3.312-1.597 0.766-0.944 1.188-2.187 1.188-3.5 0-2.269-1.212-4.484-2.281-6.438-0.797-1.456-1.55-2.834-1.725-4.038zM10.5 19c-2.272 0-3.5-2.112-3.5-4.097 0-2.013 1.097-4.019 2.159-5.956 0.503-0.919 0.987-1.806 1.341-2.669 0.353 0.863 0.837 1.75 1.341 2.669 1.062 1.941 2.159 3.944 2.159 5.956 0 1.984-1.228 4.097-3.5 4.097z" }),
_('path', { d: "M10.5 17h0.5v1h-0.5c-0.691 0-1.331-0.328-1.803-0.919-0.45-0.563-0.697-1.3-0.697-2.081h1c0 0.553 0.169 1.072 0.475 1.456 0.281 0.35 0.647 0.544 1.025 0.544z" })
            );
        }
        function BatteryDroplet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BatteryDropletSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BatteryDroplet.SVG = BatteryDropletSVG;
        return BatteryDroplet;
    })();
export const BatteryEmpty = /*#__PURE__*/ (() => {
    function BatteryEmptySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 8h-1v-1c0-1.103-0.897-2-2-2h-17c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM19 17h-17v-10l17-0.003c0 0 0 0 0 0.003v10zM22 14h-1v-4h1v4z" })
        );
    }
    function BatteryEmpty({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BatteryEmptySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BatteryEmpty.SVG = BatteryEmptySVG;
    return BatteryEmpty;
})();
export const BatteryPlug10 = /*#__PURE__*/ (() => {
        function BatteryPlug10SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 10h-1v-1c0-1.103-0.897-2-2-2v12h-17v-11h7.034c0.244 1.694 1.703 3 3.466 3h0.5v1h1v-2h3v-1h-3v-3h3v-1h-3v-2h-1v1h-0.5c-1.759 0-3.222 1.306-3.466 3h-7.034c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM12.5 5h0.5v5h-0.5c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5zM22 16h-1v-4h1v4z" }),
_('path', { d: "M3 10h1v8h-1v-8z" })
            );
        }
        function BatteryPlug10({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BatteryPlug10SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BatteryPlug10.SVG = BatteryPlug10SVG;
        return BatteryPlug10;
    })();
export const BatteryPlug100 = /*#__PURE__*/ (() => {
        function BatteryPlug100SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 10h-1v-1c0-1.103-0.897-2-2-2v12h-17v-11h7.034c0.244 1.694 1.703 3 3.466 3h0.5v1h1v-2h3v-1h-3v-3h3v-1h-3v-2h-1v1h-0.5c-1.759 0-3.222 1.306-3.466 3h-7.034c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM12.5 5h0.5v5h-0.5c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5zM22 16h-1v-4h1v4z" }),
_('path', { d: "M3 18v-8h1v8h-1zM6 18v-8h-1v8h1zM8 18v-8h-1v8h1zM10 18v-6h-1v6h1zM12 18v-5h-1v5h1zM13 18h1v-4h-1v4zM16 18v-5h-1v5h1zM17 18h1v-6h-1v6z" })
            );
        }
        function BatteryPlug100({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BatteryPlug100SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BatteryPlug100.SVG = BatteryPlug100SVG;
        return BatteryPlug100;
    })();
export const BatteryPlug25 = /*#__PURE__*/ (() => {
        function BatteryPlug25SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 10h-1v-1c0-1.103-0.897-2-2-2v12h-17v-11h7.034c0.244 1.694 1.703 3 3.466 3h0.5v1h1v-2h3v-1h-3v-3h3v-1h-3v-2h-1v1h-0.5c-1.759 0-3.222 1.306-3.466 3h-7.034c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM12.5 5h0.5v5h-0.5c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5zM22 16h-1v-4h1v4z" }),
_('path', { d: "M3 18v-8h1v8h-1zM6 18v-8h-1v8h1z" })
            );
        }
        function BatteryPlug25({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BatteryPlug25SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BatteryPlug25.SVG = BatteryPlug25SVG;
        return BatteryPlug25;
    })();
export const BatteryPlug40 = /*#__PURE__*/ (() => {
        function BatteryPlug40SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 10h-1v-1c0-1.103-0.897-2-2-2v12h-17v-11h7.034c0.244 1.694 1.703 3 3.466 3h0.5v1h1v-2h3v-1h-3v-3h3v-1h-3v-2h-1v1h-0.5c-1.759 0-3.222 1.306-3.466 3h-7.034c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM12.5 5h0.5v5h-0.5c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5zM22 16h-1v-4h1v4z" }),
_('path', { d: "M3 18v-8h1v8h-1zM6 18v-8h-1v8h1zM8 18v-8h-1v8h1z" })
            );
        }
        function BatteryPlug40({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BatteryPlug40SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BatteryPlug40.SVG = BatteryPlug40SVG;
        return BatteryPlug40;
    })();
export const BatteryPlug50 = /*#__PURE__*/ (() => {
        function BatteryPlug50SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 10h-1v-1c0-1.103-0.897-2-2-2v12h-17v-11h7.034c0.244 1.694 1.703 3 3.466 3h0.5v1h1v-2h3v-1h-3v-3h3v-1h-3v-2h-1v1h-0.5c-1.759 0-3.222 1.306-3.466 3h-7.034c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM12.5 5h0.5v5h-0.5c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5zM22 16h-1v-4h1v4z" }),
_('path', { d: "M3 18v-8h1v8h-1zM6 18v-8h-1v8h1zM8 18v-8h-1v8h1zM10 18v-6h-1v6h1z" })
            );
        }
        function BatteryPlug50({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BatteryPlug50SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BatteryPlug50.SVG = BatteryPlug50SVG;
        return BatteryPlug50;
    })();
export const BatteryPlug60 = /*#__PURE__*/ (() => {
        function BatteryPlug60SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 10h-1v-1c0-1.103-0.897-2-2-2v12h-17v-11h7.034c0.244 1.694 1.703 3 3.466 3h0.5v1h1v-2h3v-1h-3v-3h3v-1h-3v-2h-1v1h-0.5c-1.759 0-3.222 1.306-3.466 3h-7.034c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM12.5 5h0.5v5h-0.5c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5zM22 16h-1v-4h1v4z" }),
_('path', { d: "M3 18v-8h1v8h-1zM6 18v-8h-1v8h1zM8 18v-8h-1v8h1zM10 18v-6h-1v6h1zM12 18v-5h-1v5h1z" })
            );
        }
        function BatteryPlug60({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BatteryPlug60SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BatteryPlug60.SVG = BatteryPlug60SVG;
        return BatteryPlug60;
    })();
export const BatteryPlug75 = /*#__PURE__*/ (() => {
        function BatteryPlug75SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 10h-1v-1c0-1.103-0.897-2-2-2v12h-17v-11h7.034c0.244 1.694 1.703 3 3.466 3h0.5v1h1v-2h3v-1h-3v-3h3v-1h-3v-2h-1v1h-0.5c-1.759 0-3.222 1.306-3.466 3h-7.034c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM12.5 5h0.5v5h-0.5c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5zM22 16h-1v-4h1v4z" }),
_('path', { d: "M3 18v-8h1v8h-1zM6 18v-8h-1v8h1zM8 18v-8h-1v8h1zM10 18v-6h-1v6h1zM12 18v-5h-1v5h1zM13 18h1v-4h-1v4z" })
            );
        }
        function BatteryPlug75({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BatteryPlug75SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BatteryPlug75.SVG = BatteryPlug75SVG;
        return BatteryPlug75;
    })();
export const BatteryPlug90 = /*#__PURE__*/ (() => {
        function BatteryPlug90SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 10h-1v-1c0-1.103-0.897-2-2-2v12h-17v-11h7.034c0.244 1.694 1.703 3 3.466 3h0.5v1h1v-2h3v-1h-3v-3h3v-1h-3v-2h-1v1h-0.5c-1.759 0-3.222 1.306-3.466 3h-7.034c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM12.5 5h0.5v5h-0.5c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5zM22 16h-1v-4h1v4z" }),
_('path', { d: "M3 18v-8h1v8h-1zM6 18v-8h-1v8h1zM8 18v-8h-1v8h1zM10 18v-6h-1v6h1zM12 18v-5h-1v5h1zM13 18h1v-4h-1v4zM16 18v-5h-1v5h1z" })
            );
        }
        function BatteryPlug90({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BatteryPlug90SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BatteryPlug90.SVG = BatteryPlug90SVG;
        return BatteryPlug90;
    })();
export const BatteryPlug = /*#__PURE__*/ (() => {
        function BatteryPlugSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 8h-1v-1c0-1.103-0.897-2-2-2v12h-10v2h10c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM22 14h-1v-4h1v4z" }),
_('path', { d: "M2 7h4v-2h-4c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h2v-2h-2v-10z" }),
_('path', { d: "M9.969 15c1.672 0 3.031-1.359 3.031-3.031v-0.003c1.694-0.244 3-1.703 3-3.466v-0.5h1v-1h-2v-3h-1v3h-3v-3h-1v3h-2v1h1v0.5c0 1.759 1.306 3.222 3 3.466v0.003c0 1.119-0.912 2.031-2.031 2.031h-0.938c-1.672 0-3.031 1.359-3.031 3.031v2.969h1v-2.969c0-1.119 0.912-2.031 2.031-2.031h0.938zM10 8.5v-0.5h5v0.5c0 1.378-1.122 2.5-2.5 2.5s-2.5-1.122-2.5-2.5z" })
            );
        }
        function BatteryPlug({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BatteryPlugSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BatteryPlug.SVG = BatteryPlugSVG;
        return BatteryPlug;
    })();
export const BatteryPlug2 = /*#__PURE__*/ (() => {
    function BatteryPlug2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 10h-1v-1c0-1.103-0.897-2-2-2v12h-17v-11h7.034c0.244 1.694 1.703 3 3.466 3h0.5v1h1v-2h3v-1h-3v-3h3v-1h-3v-2h-1v1h-0.5c-1.759 0-3.222 1.306-3.466 3h-7.034c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM12.5 5h0.5v5h-0.5c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5zM22 16h-1v-4h1v4z" })
        );
    }
    function BatteryPlug2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BatteryPlug2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BatteryPlug2.SVG = BatteryPlug2SVG;
    return BatteryPlug2;
})();
export const BatteryPlus = /*#__PURE__*/ (() => {
        function BatteryPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 10h-1v-1c0-1.103-0.897-2-2-2h-2.5c-0.981-2.347-3.3-4-6-4s-5.019 1.653-6 4h-2.5c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM10.5 4c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM19 19h-17v-10h2.019c-0.012 0.166-0.019 0.331-0.019 0.5 0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5c0-0.169-0.006-0.334-0.019-0.5h2.019v10zM22 16h-1v-4h1v4z" }),
_('path', { d: "M10 12h1v-2h2v-1h-2v-2h-1v2h-2v1h2z" })
            );
        }
        function BatteryPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BatteryPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BatteryPlus.SVG = BatteryPlusSVG;
        return BatteryPlus;
    })();
export const BatteryQuestion = /*#__PURE__*/ (() => {
        function BatteryQuestionSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 10h-1v-1c0-1.103-0.897-2-2-2h-2.5c-0.981-2.347-3.3-4-6-4s-5.019 1.653-6 4h-2.5c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM10.5 4c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM19 19h-17v-10h2.019c-0.012 0.166-0.019 0.331-0.019 0.5 0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5c0-0.169-0.006-0.334-0.019-0.5h2.019v10zM22 16h-1v-4h1v4z" }),
_('path', { d: "M10 13h1v1h-1v-1z" }),
_('path', { d: "M9 8.5c0-1.103 0.809-1.497 1.503-1.497 0.4 0 0.788 0.125 1.062 0.344 0.288 0.228 0.434 0.531 0.434 0.903 0 0.713-0.434 1.084-0.941 1.519-0.497 0.425-1.059 0.906-1.059 1.731v0.5h1v-0.5c0-0.347 0.256-0.584 0.709-0.972 0.575-0.491 1.291-1.103 1.291-2.278 0-1.459-1.287-2.247-2.497-2.247-1.206 0-2.503 0.781-2.503 2.497v0.5h1v-0.5z" })
            );
        }
        function BatteryQuestion({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BatteryQuestionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BatteryQuestion.SVG = BatteryQuestionSVG;
        return BatteryQuestion;
    })();
export const BatteryWarning = /*#__PURE__*/ (() => {
        function BatteryWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 9h-1v-1c0-1.103-0.897-2-2-2h-6.575l-0.584-1.169c-0.25-0.506-0.778-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-0.584 1.172h-6.575c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h17c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM10.053 5.275c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006zM19 18h-17v-10h5.575l-2.412 4.828c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h8c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672l-2.419-4.828h5.575v10zM22 15h-1v-4h1v4z" }),
_('path', { d: "M10 12h1v1h-1v-1z" }),
_('path', { d: "M10 7h1v4h-1v-4z" })
            );
        }
        function BatteryWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BatteryWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BatteryWarning.SVG = BatteryWarningSVG;
        return BatteryWarning;
    })();
export const Beaker = /*#__PURE__*/ (() => {
        function BeakerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.997 0h-18.997v2c1.103 0 2 0.897 2 2v17.5c0 1.378 1.122 2.5 2.5 2.5h11c1.378 0 2.5-1.122 2.5-2.5v-19.5h0.997v-2zM17.5 22h-11c-0.275 0-0.5-0.225-0.5-0.5v-2.766c0.506 0.175 1.028 0.266 1.572 0.266 0.431 0 0.878-0.056 1.341-0.166 1.137-0.272 2.244-0.841 3.316-1.388 1.975-1.012 3.847-1.972 5.772-1.103v5.156c0 0.275-0.225 0.5-0.5 0.5zM18 15.266c-0.906-0.316-1.866-0.347-2.913-0.1-1.137 0.272-2.244 0.841-3.316 1.387-1.975 1.013-3.847 1.972-5.772 1.103v-13.656c0-0.728-0.197-1.413-0.537-2h12.537v13.266z" }),
_('path', { d: "M7 5h4v1h-4v-1z" }),
_('path', { d: "M7 7h2v1h-2v-1z" }),
_('path', { d: "M7 9h2v1h-2v-1z" }),
_('path', { d: "M7 11h4v1h-4v-1z" }),
_('path', { d: "M7 13h2v1h-2v-1z" }),
_('path', { d: "M7 15h2v1h-2v-1z" })
            );
        }
        function Beaker({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BeakerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Beaker.SVG = BeakerSVG;
        return Beaker;
    })();
export const BedCheck = /*#__PURE__*/ (() => {
        function BedCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 9.5c0-3.584-2.916-6.5-6.5-6.5s-6.5 2.916-6.5 6.5c0 0.884 0.178 1.731 0.5 2.5h-2.503c-0.028-1.984-0.712-3.65-1.959-4.731-1.162-1.009-2.747-1.441-4.381-1.203-0.225-0.734-0.6-1.459-1.222-2.044l-1.369 1.456c0.934 0.878 0.934 2.666 0.934 3.522v12h2v-2h18v2h2v-8.041c0.634-1 1-2.187 1-3.459zM17.5 4c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM14.041 15h-11.041v-0.5c0-0.828 0.672-1.5 1.5-1.5h7.525c0.516 0.806 1.206 1.491 2.016 2zM4.5 12c-0.563 0-1.081 0.188-1.5 0.5v-2.425c0.203 0.328 0.438 0.634 0.697 0.916 0.359 0.387 0.759 0.725 1.2 1.006h-0.397zM6.381 8.025c1.019 0.884 1.584 2.278 1.616 3.959-3.063-0.231-4.794-2.594-4.981-4.953 1.269-0.134 2.478 0.219 3.366 0.994zM3 17v-1h18v1h-18z" }),
_('path', { d: "M16.5 12c0.128 0 0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147z" })
            );
        }
        function BedCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BedCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BedCheck.SVG = BedCheckSVG;
        return BedCheck;
    })();
export const BedCross = /*#__PURE__*/ (() => {
        function BedCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 9.5c0-3.584-2.916-6.5-6.5-6.5s-6.5 2.916-6.5 6.5c0 0.884 0.178 1.731 0.5 2.5h-2.503c-0.028-1.984-0.712-3.65-1.959-4.731-1.162-1.009-2.747-1.441-4.381-1.203-0.225-0.734-0.6-1.459-1.222-2.044l-1.369 1.456c0.934 0.878 0.934 2.666 0.934 3.522v12h2v-2h18v2h2v-8.041c0.634-1 1-2.187 1-3.459zM17.5 4c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM14.041 15h-11.041v-0.5c0-0.828 0.672-1.5 1.5-1.5h7.525c0.516 0.806 1.206 1.491 2.016 2zM4.5 12c-0.563 0-1.081 0.188-1.5 0.5v-2.425c0.203 0.328 0.438 0.634 0.697 0.916 0.359 0.387 0.759 0.725 1.2 1.006h-0.397zM6.381 8.025c1.019 0.884 1.584 2.278 1.616 3.959-3.063-0.231-4.794-2.594-4.981-4.953 1.269-0.134 2.478 0.219 3.366 0.994zM3 17v-1h18v1h-18z" }),
_('path', { d: "M15.5 12.206l2-2 2 2 0.706-0.706-2-2 2-2-0.706-0.706-2 2-2-2-0.706 0.706 2 2-2 2z" })
            );
        }
        function BedCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BedCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BedCross.SVG = BedCrossSVG;
        return BedCross;
    })();
export const BedTime = /*#__PURE__*/ (() => {
        function BedTimeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 9.5c0-3.584-2.916-6.5-6.5-6.5s-6.5 2.916-6.5 6.5c0 0.884 0.178 1.731 0.5 2.5h-2.503c-0.028-1.984-0.712-3.65-1.959-4.731-1.162-1.009-2.747-1.441-4.381-1.203-0.225-0.734-0.6-1.459-1.222-2.044l-1.369 1.456c0.934 0.878 0.934 2.666 0.934 3.522v12h2v-2h18v2h2v-8.041c0.634-1 1-2.187 1-3.459zM17 4.022v1.978h1v-1.978c2.634 0.237 4.737 2.344 4.978 4.978h-1.978v1h1.978c-0.237 2.634-2.344 4.737-4.978 4.978v-1.978h-1v1.978c-2.634-0.237-4.737-2.344-4.978-4.978h1.978v-1h-1.978c0.241-2.634 2.344-4.737 4.978-4.978zM14.041 15h-11.041v-0.5c0-0.828 0.672-1.5 1.5-1.5h7.525c0.516 0.806 1.206 1.491 2.016 2zM4.5 12c-0.563 0-1.081 0.188-1.5 0.5v-2.425c0.203 0.328 0.438 0.634 0.697 0.916 0.359 0.387 0.759 0.725 1.2 1.006h-0.397zM6.381 8.025c1.019 0.884 1.584 2.278 1.616 3.959-3.063-0.231-4.794-2.594-4.981-4.953 1.269-0.134 2.478 0.219 3.366 0.994zM3 17v-1h18v1h-18z" }),
_('path', { d: "M17.5 11c0.016 0 0.034 0 0.050-0.003 0.15-0.016 0.284-0.097 0.366-0.219l2.278-3.416-0.831-0.556-1.938 2.909-1.925-1.922-0.706 0.706 2.353 2.353c0.094 0.094 0.222 0.147 0.353 0.147z" })
            );
        }
        function BedTime({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BedTimeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BedTime.SVG = BedTimeSVG;
        return BedTime;
    })();
export const Bed = /*#__PURE__*/ (() => {
    function BedSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.587 7c-1.069 0.944-1.587 2.253-1.587 4v0.5c-0.419-0.316-0.938-0.5-1.5-0.5h-10.503c-0.028-1.984-0.713-3.65-1.959-4.731-1.162-1.009-2.747-1.441-4.381-1.203-0.225-0.734-0.6-1.459-1.222-2.044l-1.369 1.456c0.934 0.881 0.934 2.666 0.934 3.522v12h2v-2h18v2h2v-9c0-1.156 0.291-1.95 0.912-2.5l-1.325-1.5zM3 15h18v1h-18v-1zM21 13.5v0.5h-18v-0.5c0-0.828 0.672-1.5 1.5-1.5h15c0.828 0 1.5 0.672 1.5 1.5zM4.5 11c-0.563 0-1.081 0.188-1.5 0.5v-2.425c0.203 0.328 0.438 0.634 0.697 0.916 0.359 0.387 0.759 0.725 1.2 1.006h-0.397zM6.381 7.025c1.019 0.884 1.584 2.278 1.616 3.959-3.063-0.231-4.794-2.594-4.981-4.953 1.269-0.134 2.478 0.219 3.366 0.994z" })
        );
    }
    function Bed({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bed.SVG = BedSVG;
    return Bed;
})();
export const BellMinus = /*#__PURE__*/ (() => {
        function BellMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 7h-5v1h5v-1z" }),
_('path', { d: "M1.653 17.063c1.069-0.394 1.666-1.15 2-2.525 0.347-1.434 0.347-3.334 0.347-5.538 0-1.603 0.625-3.109 1.756-4.244 0.647-0.647 1.419-1.128 2.256-1.422 0.025-0.462 0.091-0.925 0.262-1.306 0.306-0.681 0.884-1.028 1.725-1.028s1.419 0.347 1.725 1.028c0.113 0.253 0.181 0.541 0.219 0.841 1.175-1.156 2.784-1.869 4.556-1.869 3.584 0 6.5 2.916 6.5 6.5s-2.916 6.5-6.5 6.5c-0.087 0-0.175-0.003-0.266-0.006 0.297 1.725 0.934 2.634 2.109 3.069 0.394 0.144 0.653 0.519 0.653 0.938v2c0 0.553-0.447 1-1 1h-6c0 1.103-0.897 2-2 2s-2-0.897-2-2h-6c-0.553 0-1-0.447-1-1v-2c0.003-0.419 0.266-0.794 0.656-0.938zM10 2c-0.578 0-0.863 0.184-0.959 1.075 0.312-0.050 0.634-0.075 0.959-0.075 0.322 0 0.644 0.025 0.959 0.078-0.097-0.894-0.381-1.078-0.959-1.078zM22 7.5c0-3.031-2.469-5.5-5.5-5.5s-5.5 2.469-5.5 5.5 2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5zM10 22c0.55 0 1-0.45 1-1h-2c0 0.55 0.45 1 1 1zM3 19h14v-0.353c-0.822-0.438-1.472-1.072-1.934-1.894-0.466-0.831-0.756-1.847-0.909-3.191-2.428-0.944-4.156-3.306-4.156-6.063 0-0.169 0.006-0.334 0.019-0.5h-0.019c-1.103 0-2 0.897-2 2v2h-1v-2c0-1.653 1.347-3 3-3h0.175c0.078-0.334 0.184-0.659 0.312-0.972-0.162-0.019-0.325-0.028-0.487-0.028-2.206 0-4 1.794-4 4 0 2.331 0 4.344-0.403 6.009-0.422 1.747-1.275 2.944-2.597 3.641v0.35z" })
            );
        }
        function BellMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BellMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BellMinus.SVG = BellMinusSVG;
        return BellMinus;
    })();
export const BellMusic = /*#__PURE__*/ (() => {
        function BellMusicSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1.653 17.063c1.069-0.394 1.666-1.15 2-2.525 0.347-1.434 0.347-3.334 0.347-5.538 0-1.603 0.625-3.109 1.756-4.244 0.647-0.647 1.419-1.128 2.256-1.422 0.025-0.462 0.091-0.925 0.262-1.306 0.306-0.681 0.884-1.028 1.725-1.028s1.419 0.347 1.725 1.028c0.113 0.253 0.181 0.541 0.219 0.841 1.175-1.156 2.784-1.869 4.556-1.869 3.584 0 6.5 2.916 6.5 6.5s-2.916 6.5-6.5 6.5c-0.087 0-0.175-0.003-0.266-0.006 0.297 1.725 0.934 2.634 2.109 3.069 0.394 0.144 0.653 0.519 0.653 0.938v2c0 0.553-0.447 1-1 1h-6c0 1.103-0.897 2-2 2s-2-0.897-2-2h-6c-0.553 0-1-0.447-1-1v-2c0.003-0.419 0.266-0.794 0.656-0.938zM10 2c-0.578 0-0.863 0.184-0.959 1.075 0.312-0.050 0.634-0.075 0.959-0.075 0.322 0 0.644 0.025 0.959 0.078-0.097-0.894-0.381-1.078-0.959-1.078zM22 7.5c0-3.031-2.469-5.5-5.5-5.5s-5.5 2.469-5.5 5.5 2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5zM10 22c0.55 0 1-0.45 1-1h-2c0 0.55 0.45 1 1 1zM3 19h14v-0.353c-0.822-0.438-1.472-1.072-1.934-1.894-0.466-0.831-0.756-1.847-0.909-3.191-2.428-0.944-4.156-3.306-4.156-6.063 0-0.169 0.006-0.334 0.019-0.5h-0.019c-1.103 0-2 0.897-2 2v2h-1v-2c0-1.653 1.347-3 3-3h0.175c0.078-0.334 0.184-0.659 0.312-0.972-0.162-0.019-0.325-0.028-0.487-0.028-2.206 0-4 1.794-4 4 0 2.331 0 4.344-0.403 6.009-0.422 1.747-1.275 2.944-2.597 3.641v0.35z" }),
_('path', { d: "M18 4h-1v4.131c-0.353-0.125-0.762-0.162-1.191-0.103-1.109 0.156-1.903 0.922-1.803 1.747 0.041 0.328 0.213 0.616 0.5 0.837 0.334 0.256 0.803 0.397 1.303 0.397 0.125 0 0.253-0.009 0.381-0.028 1.047-0.147 1.812-0.837 1.809-1.606v0-3.141c0.531 0.475 1.231 0.766 2 0.766v-1c-1.103 0-2-0.897-2-2zM16.050 9.991c-0.366 0.050-0.731-0.016-0.934-0.172-0.050-0.037-0.109-0.097-0.116-0.166-0.025-0.197 0.341-0.55 0.947-0.634 0.087-0.012 0.172-0.019 0.253-0.019 0.319 0 0.553 0.091 0.681 0.188 0.072 0.053 0.109 0.109 0.116 0.166v0c0.025 0.197-0.341 0.55-0.947 0.638z" })
            );
        }
        function BellMusic({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BellMusicSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BellMusic.SVG = BellMusicSVG;
        return BellMusic;
    })();
export const BellPlus = /*#__PURE__*/ (() => {
        function BellPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 5h1v2h2v1h-2v2h-1v-2h-2v-1h2z" }),
_('path', { d: "M1.653 17.063c1.069-0.394 1.666-1.15 2-2.525 0.347-1.434 0.347-3.334 0.347-5.538 0-1.603 0.625-3.109 1.756-4.244 0.647-0.647 1.419-1.128 2.256-1.422 0.025-0.462 0.091-0.925 0.262-1.306 0.306-0.681 0.884-1.028 1.725-1.028s1.419 0.347 1.725 1.028c0.113 0.253 0.181 0.541 0.219 0.841 1.175-1.156 2.784-1.869 4.556-1.869 3.584 0 6.5 2.916 6.5 6.5s-2.916 6.5-6.5 6.5c-0.087 0-0.178-0.003-0.266-0.006 0.3 1.725 0.938 2.634 2.109 3.066 0.394 0.144 0.653 0.519 0.653 0.938v2c0 0.553-0.447 1-1 1h-6c0 1.103-0.897 2-2 2s-2-0.897-2-2h-6c-0.553 0-1-0.447-1-1v-2c0.003-0.416 0.266-0.791 0.656-0.934zM10 2c-0.578 0-0.863 0.184-0.959 1.075 0.312-0.050 0.634-0.075 0.959-0.075 0.322 0 0.644 0.025 0.959 0.075-0.097-0.891-0.381-1.075-0.959-1.075zM22 7.5c0-3.031-2.469-5.5-5.5-5.5s-5.5 2.469-5.5 5.5 2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5zM10 22c0.55 0 1-0.45 1-1h-2c0 0.55 0.45 1 1 1zM3 19h14v-0.353c-0.822-0.434-1.472-1.072-1.934-1.894-0.466-0.828-0.756-1.847-0.912-3.191-2.428-0.944-4.156-3.306-4.156-6.063 0-0.169 0.006-0.334 0.019-0.5h-0.019c-1.103 0-2 0.897-2 2v2h-1v-2c0-1.653 1.347-3 3-3h0.175c0.078-0.334 0.184-0.659 0.312-0.972-0.162-0.019-0.325-0.028-0.488-0.028-2.206 0-4 1.794-4 4 0 2.331 0 4.344-0.403 6.009-0.422 1.747-1.275 2.944-2.597 3.641v0.35z" })
            );
        }
        function BellPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BellPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BellPlus.SVG = BellPlusSVG;
        return BellPlus;
    })();
export const BellRinging = /*#__PURE__*/ (() => {
        function BellRingingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 12c0 1.103 0.897 2 2 2s2-0.897 2-2c0-1.103-0.897-2-2-2s-2 0.897-2 2zM13 12c0 0.55-0.45 1-1 1s-1-0.45-1-1c0-0.55 0.45-1 1-1s1 0.45 1 1z" }),
_('path', { d: "M12 8v-1c-2.756 0-5 2.244-5 5h1c0-2.206 1.794-4 4-4z" }),
_('path', { d: "M23.109 6.663c0.537-0.359 0.891-0.972 0.891-1.662 0-1.103-0.897-2-2-2s-2 0.897-2 2 0.897 2 2 2c0.053 0 0.109-0.003 0.162-0.006 1.625 3.716 0.834 8.097-2.019 11.009-0.091 0.094-0.144 0.219-0.144 0.35v0.647h-1v-3.119c0.653-1.175 1-2.5 1-3.881 0-2.137-0.831-4.147-2.344-5.656-1.512-1.512-3.519-2.344-5.656-2.344s-4.147 0.831-5.656 2.344c-1.512 1.512-2.344 3.519-2.344 5.656 0 1.381 0.347 2.706 1 3.881v6.119c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-2h1.5c0.275 0 0.5-0.225 0.5-0.5v-0.947c1.488-1.575 2.469-3.537 2.841-5.688 0.366-2.106 0.112-4.241-0.731-6.203zM21 5c0-0.55 0.45-1 1-1s1 0.45 1 1-0.45 1-1 1-1-0.45-1-1zM12 6c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6zM7 22v-3.753c1.416 1.137 3.159 1.753 5 1.753s3.584-0.619 5-1.753v3.753h-10z" }),
_('path', { d: "M1.793 3.54l0.696-0.718 2.718 2.638-0.696 0.718-2.718-2.638z" }),
_('path', { d: "M4.829 1.307l0.894-0.447 1.448 2.896-0.894 0.447-1.448-2.896z" }),
_('path', { d: "M0.828 6.723l0.447-0.894 2.896 1.448-0.447 0.894-2.896-1.448z" })
            );
        }
        function BellRinging({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BellRingingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BellRinging.SVG = BellRingingSVG;
        return BellRinging;
    })();
export const BellRinging2 = /*#__PURE__*/ (() => {
        function BellRinging2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.347 18.063c-1.069-0.394-1.666-1.15-2-2.525-0.347-1.434-0.347-3.334-0.347-5.538 0-1.603-0.625-3.109-1.756-4.244-0.647-0.647-1.419-1.128-2.256-1.422-0.025-0.462-0.091-0.925-0.263-1.306-0.306-0.681-0.884-1.028-1.725-1.028s-1.419 0.347-1.725 1.028c-0.172 0.381-0.237 0.844-0.262 1.306-0.841 0.294-1.609 0.775-2.256 1.422-1.131 1.134-1.756 2.641-1.756 4.244 0 2.203 0 4.103-0.347 5.538-0.334 1.375-0.931 2.131-2 2.525-0.394 0.144-0.653 0.519-0.653 0.938v2c0 0.553 0.447 1 1 1h6c0 1.103 0.897 2 2 2s2-0.897 2-2h6c0.553 0 1-0.447 1-1v-2c0-0.419-0.263-0.794-0.653-0.938zM12 3c0.578 0 0.862 0.184 0.959 1.075-0.316-0.050-0.634-0.075-0.959-0.075s-0.647 0.025-0.959 0.075c0.097-0.891 0.381-1.075 0.959-1.075zM12 23c-0.55 0-1-0.45-1-1h2c0 0.55-0.45 1-1 1zM19 20h-14v-0.353c1.322-0.697 2.175-1.894 2.597-3.641 0.403-1.662 0.403-3.675 0.403-6.006 0-2.206 1.794-4 4-4s4 1.794 4 4c0 2.331 0 4.344 0.403 6.009 0.422 1.747 1.275 2.944 2.597 3.641v0.35z" }),
_('path', { d: "M9 10v2h1v-2c0-1.103 0.897-2 2-2v-1c-1.653 0-3 1.347-3 3z" }),
_('path', { d: "M17.825 3.138l-0.381-0.325-0.647 0.762 0.381 0.325c1.794 1.525 2.822 3.747 2.822 6.1v2h1v-2c0-2.647-1.156-5.147-3.175-6.863z" }),
_('path', { d: "M3 12h1v-2c0-2.353 1.028-4.575 2.825-6.1l0.381-0.325-0.647-0.762-0.381 0.325c-2.022 1.716-3.178 4.216-3.178 6.863v2z" }),
_('path', { d: "M22.906 4.988c-0.7-1.522-1.697-2.862-2.956-3.978l-0.375-0.331-0.663 0.75 0.375 0.331c2.359 2.088 3.713 5.091 3.713 8.241v2h1v-2c0-1.75-0.369-3.434-1.094-5.013z" }),
_('path', { d: "M4.716 1.759l0.375-0.331-0.663-0.75-0.375 0.331c-1.263 1.116-2.256 2.453-2.959 3.978-0.725 1.575-1.094 3.262-1.094 5.013v2h1v-2c0-3.15 1.353-6.153 3.716-8.241z" })
            );
        }
        function BellRinging2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BellRinging2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BellRinging2.SVG = BellRinging2SVG;
        return BellRinging2;
    })();
export const BellSnooze = /*#__PURE__*/ (() => {
        function BellSnoozeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.853 6.853c0.144-0.144 0.184-0.359 0.109-0.544-0.078-0.188-0.259-0.309-0.462-0.309h-3.5v1h2.294l-2.147 2.147c-0.144 0.144-0.184 0.359-0.109 0.544 0.078 0.188 0.259 0.309 0.462 0.309h3.5v-1h-2.294l2.147-2.147z" }),
_('path', { d: "M21.963 12.309c-0.078-0.188-0.259-0.309-0.462-0.309h-3.5v1h2.294l-2.147 2.147c-0.144 0.144-0.184 0.359-0.109 0.544s0.259 0.309 0.462 0.309h3.5v-1h-2.294l2.147-2.147c0.144-0.144 0.188-0.356 0.109-0.544z" }),
_('path', { d: "M17.037 3.691c0.078 0.188 0.259 0.309 0.462 0.309h3.5v-1h-2.294l2.147-2.147c0.144-0.144 0.184-0.359 0.109-0.544-0.078-0.188-0.259-0.309-0.462-0.309h-3.5v1h2.294l-2.147 2.147c-0.144 0.144-0.188 0.356-0.109 0.544z" }),
_('path', { d: "M18.347 18.063c-1.069-0.394-1.666-1.15-2-2.525-0.347-1.434-0.347-3.334-0.347-5.538 0-1.603-0.625-3.109-1.756-4.244-0.647-0.647-1.419-1.128-2.256-1.422-0.025-0.462-0.091-0.925-0.262-1.306-0.306-0.681-0.884-1.028-1.725-1.028s-1.419 0.347-1.725 1.028c-0.172 0.381-0.237 0.844-0.262 1.306-0.841 0.294-1.609 0.775-2.256 1.422-1.131 1.134-1.756 2.641-1.756 4.244 0 2.203 0 4.103-0.347 5.538-0.334 1.375-0.931 2.131-2 2.525-0.391 0.144-0.653 0.519-0.653 0.938v2c0 0.553 0.447 1 1 1h6c0 1.103 0.897 2 2 2s2-0.897 2-2h6c0.553 0 1-0.447 1-1v-2c0-0.419-0.263-0.794-0.653-0.938zM10 3c0.578 0 0.862 0.184 0.959 1.075-0.316-0.050-0.634-0.075-0.959-0.075s-0.647 0.025-0.959 0.075c0.097-0.891 0.381-1.075 0.959-1.075zM10 23c-0.55 0-1-0.45-1-1h2c0 0.55-0.45 1-1 1zM17 20h-14v-0.353c1.322-0.697 2.175-1.894 2.597-3.641 0.403-1.662 0.403-3.675 0.403-6.006 0-2.206 1.794-4 4-4s4 1.794 4 4c0 2.331 0 4.344 0.403 6.009 0.422 1.747 1.275 2.944 2.597 3.641v0.35z" }),
_('path', { d: "M7 10v2h1v-2c0-1.103 0.897-2 2-2v-1c-1.653 0-3 1.347-3 3z" })
            );
        }
        function BellSnooze({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BellSnoozeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BellSnooze.SVG = BellSnoozeSVG;
        return BellSnooze;
    })();
export const BellWarning = /*#__PURE__*/ (() => {
        function BellWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 9h-1v1h1v-1z" }),
_('path', { d: "M18 4h-1v4h1v-4z" }),
_('path', { d: "M1.653 17.063c1.069-0.394 1.666-1.15 2-2.525 0.347-1.434 0.347-3.334 0.347-5.538 0-1.603 0.625-3.109 1.756-4.244 0.647-0.647 1.419-1.128 2.256-1.422 0.025-0.462 0.091-0.925 0.262-1.306 0.306-0.681 0.884-1.028 1.725-1.028s1.419 0.347 1.725 1.028c0.172 0.381 0.237 0.847 0.263 1.306 0.981 0.344 1.863 0.938 2.553 1.737l1.619-3.241c0.25-0.506 0.775-0.831 1.341-0.831s1.091 0.325 1.341 0.828l4 7.997c0.103 0.206 0.159 0.438 0.159 0.672 0 0.828-0.672 1.5-1.5 1.5h-5.459c0.047 1.091 0.169 2.334 0.531 3.269 0.356 0.919 0.906 1.472 1.775 1.794 0.394 0.144 0.653 0.519 0.653 0.938v2c0 0.553-0.447 1-1 1h-6c0 1.103-0.897 2-2 2s-2-0.897-2-2h-6c-0.553 0-1-0.447-1-1v-2c0-0.416 0.262-0.791 0.653-0.934zM10 2c-0.578 0-0.863 0.184-0.959 1.075 0.312-0.050 0.634-0.075 0.959-0.075s0.647 0.025 0.959 0.075c-0.097-0.891-0.381-1.075-0.959-1.075zM22 10.5c0-0.078-0.019-0.153-0.050-0.219l-4.003-8.006c-0.081-0.166-0.256-0.275-0.447-0.275s-0.363 0.109-0.447 0.278l-4.003 8.003c-0.034 0.066-0.050 0.141-0.050 0.219 0 0.275 0.225 0.5 0.5 0.5h8c0.275 0 0.5-0.225 0.5-0.5zM10 22c0.55 0 1-0.45 1-1h-2c0 0.55 0.45 1 1 1zM13.328 6.778c-0.747-1.116-1.984-1.778-3.328-1.778-2.206 0-4 1.794-4 4 0 2.331 0 4.344-0.403 6.009-0.422 1.747-1.275 2.944-2.597 3.641v0.35h14v-0.35c-1.062-0.559-1.816-1.434-2.291-2.656-0.387-1-0.594-2.212-0.669-3.994h-0.541c-0.828 0-1.5-0.672-1.5-1.5 0-0.234 0.056-0.466 0.159-0.672l1.362-2.722c-0.059-0.112-0.125-0.225-0.194-0.328z" }),
_('path', { d: "M10 6v1c-1.103 0-2 0.897-2 2v2h-1v-2c0-1.653 1.347-3 3-3z" })
            );
        }
        function BellWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BellWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BellWarning.SVG = BellWarningSVG;
        return BellWarning;
    })();
export const Bell = /*#__PURE__*/ (() => {
        function BellSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 10c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2c-1.103 0-2 0.897-2 2zM11 10c0 0.55-0.45 1-1 1s-1-0.45-1-1 0.45-1 1-1 1 0.45 1 1z" }),
_('path', { d: "M10 6v-1c-2.756 0-5 2.244-5 5h1c0-2.206 1.794-4 4-4z" }),
_('path', { d: "M21.109 4.662c0.537-0.359 0.891-0.969 0.891-1.662 0-1.103-0.897-2-2-2s-2 0.897-2 2 0.897 2 2 2c0.053 0 0.109-0.003 0.162-0.006 1.625 3.716 0.834 8.097-2.019 11.009-0.091 0.094-0.144 0.219-0.144 0.35v0.647h-1v-3.119c0.653-1.175 1-2.5 1-3.881 0-2.137-0.831-4.147-2.344-5.656-1.512-1.512-3.519-2.344-5.656-2.344s-4.147 0.831-5.656 2.344c-1.512 1.512-2.344 3.519-2.344 5.656 0 1.381 0.347 2.706 1 3.881v6.119c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-2h1.5c0.275 0 0.5-0.225 0.5-0.5v-0.947c1.488-1.575 2.469-3.537 2.841-5.688 0.366-2.106 0.113-4.241-0.731-6.203zM19 3c0-0.55 0.45-1 1-1s1 0.45 1 1-0.45 1-1 1-1-0.45-1-1zM10 4c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6zM5 20v-3.753c1.416 1.137 3.159 1.753 5 1.753s3.584-0.619 5-1.753v3.753h-10z" })
            );
        }
        function Bell({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BellSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bell.SVG = BellSVG;
        return Bell;
    })();
export const Bell2 = /*#__PURE__*/ (() => {
        function Bell2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.653 17.063c1.069-0.394 1.666-1.15 2-2.525 0.347-1.434 0.347-3.334 0.347-5.538 0-1.603 0.625-3.109 1.756-4.244 0.647-0.647 1.419-1.128 2.256-1.422 0.025-0.462 0.091-0.925 0.262-1.306 0.306-0.681 0.884-1.028 1.725-1.028s1.419 0.347 1.725 1.028c0.172 0.381 0.237 0.844 0.262 1.306 0.841 0.294 1.609 0.775 2.256 1.422 1.131 1.134 1.756 2.641 1.756 4.244 0 2.203 0 4.103 0.347 5.538 0.334 1.375 0.931 2.131 2 2.525 0.394 0.144 0.653 0.519 0.653 0.938v2c0 0.553-0.447 1-1 1h-6c0 1.103-0.897 2-2 2s-2-0.897-2-2h-6c-0.553 0-1-0.447-1-1v-2c0-0.419 0.262-0.794 0.653-0.938zM12 2c-0.578 0-0.863 0.184-0.959 1.075 0.312-0.050 0.634-0.075 0.959-0.075s0.647 0.025 0.959 0.075c-0.097-0.891-0.381-1.075-0.959-1.075zM12 22c0.55 0 1-0.45 1-1h-2c0 0.55 0.45 1 1 1zM5 19h14v-0.353c-1.322-0.697-2.175-1.894-2.597-3.641-0.403-1.662-0.403-3.675-0.403-6.006 0-2.206-1.794-4-4-4s-4 1.794-4 4c0 2.331 0 4.344-0.403 6.009-0.422 1.747-1.275 2.944-2.597 3.641v0.35z" }),
_('path', { d: "M12 6v1c-1.103 0-2 0.897-2 2v2h-1v-2c0-1.653 1.347-3 3-3z" })
            );
        }
        function Bell2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Bell2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bell2.SVG = Bell2SVG;
        return Bell2;
    })();
export const BezierCurve = /*#__PURE__*/ (() => {
    function BezierCurveSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.5 17c-0.231 0-0.45 0.053-0.647 0.147l-4.359-4.359c-0.4-0.703-0.891-1.394-1.494-2.106v-2.181c0-0.275-0.225-0.5-0.5-0.5h-2.184c-0.709-0.603-1.4-1.097-2.106-1.494l-4.356-4.359c0.094-0.197 0.147-0.416 0.147-0.647 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5c0.231 0 0.45-0.053 0.647-0.147l2.65 2.65c-1.231-0.344-2.616-0.503-4.297-0.503h-0.5v-0.5c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-0.5h0.5c3.35 0 5.319 0.656 7.5 2.506v1.994c0 0.275 0.225 0.5 0.5 0.5h1.994c1.85 2.181 2.506 4.15 2.506 7.5v0.5h-0.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-0.5v-0.5c0-1.681-0.159-3.066-0.503-4.294l2.65 2.65c-0.094 0.197-0.147 0.416-0.147 0.647 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5-0.672-1.503-1.5-1.503zM3 7h-2v-2h2v2zM19 23h-2v-2h2v2zM5.5 2c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5zM13 9h2v2h-2v-2zM22.5 19c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" })
        );
    }
    function BezierCurve({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BezierCurveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BezierCurve.SVG = BezierCurveSVG;
    return BezierCurve;
})();
export const BezierCurve2 = /*#__PURE__*/ (() => {
    function BezierCurve2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.5 20h-0.5v-10.084c0.581-0.206 1-0.762 1-1.416 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.653 0.419 1.209 1 1.416v6.012c-0.594-1.113-1.456-2.019-2.594-2.728-2.041-1.275-4.681-1.737-7.231-2.184-2.472-0.431-4.809-0.841-6.519-1.909-1.697-1.059-2.544-2.691-2.644-5.106h0.488c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h0.5v10.084c-0.581 0.206-1 0.762-1 1.416 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.653-0.419-1.209-1-1.416v-6.012c0.594 1.113 1.456 2.019 2.594 2.728 2.041 1.275 4.681 1.737 7.231 2.184 2.472 0.431 4.809 0.841 6.519 1.909 1.697 1.059 2.544 2.691 2.644 5.106h-0.488c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5zM1 1h2v2h-2v-2zM1.5 16c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5zM22.5 8c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM23 23h-2v-2h2v2z" })
        );
    }
    function BezierCurve2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BezierCurve2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BezierCurve2.SVG = BezierCurve2SVG;
    return BezierCurve2;
})();
export const BicycleRiding = /*#__PURE__*/ (() => {
        function BicycleRidingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 6c1.103 0 2-0.897 2-2s-0.897-2-2-2c-1.103 0-2 0.897-2 2s0.897 2 2 2zM13 3c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M14.209 10.453c1.294 0.484 2.706 0.547 3.791 0.547v-2c-2.978 0-4.444-0.681-5.063-2.347-0.116-0.316-0.384-0.55-0.712-0.628-0.328-0.075-0.672 0.019-0.916 0.25-1.619 1.544-2.691 3.328-3.275 5.459-0.119 0.438 0.069 0.9 0.459 1.128 1.325 0.775 2.422 1.563 3.334 2.4l-1.766 4.631 1.869 0.713 2-5.25c0.141-0.369 0.053-0.781-0.225-1.062-0.969-0.972-2.125-1.875-3.522-2.747 0.372-1.050 0.9-1.994 1.6-2.853 0.594 0.791 1.403 1.381 2.425 1.759z" }),
_('path', { d: "M19.5 13c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5 4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5zM19.5 21c-1.931 0-3.5-1.569-3.5-3.5s1.569-3.5 3.5-3.5 3.5 1.569 3.5 3.5-1.569 3.5-3.5 3.5z" }),
_('path', { d: "M4.5 13c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5 4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5zM4.5 21c-1.931 0-3.5-1.569-3.5-3.5s1.569-3.5 3.5-3.5 3.5 1.569 3.5 3.5-1.569 3.5-3.5 3.5z" })
            );
        }
        function BicycleRiding({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BicycleRidingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BicycleRiding.SVG = BicycleRidingSVG;
        return BicycleRiding;
    })();
export const Bicycle = /*#__PURE__*/ (() => {
    function BicycleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18.5 10c-0.441 0-0.869 0.053-1.278 0.15-0.191-0.953-0.253-1.784-0.191-2.503 0.141-1.619 0.922-2.456 1.669-3.059 0.019-0.016 0.038-0.031 0.053-0.050 0.247-0.269 0.312-0.659 0.166-0.991-0.147-0.334-0.466-0.544-0.834-0.544h-3.084v1h2.844c-0.8 0.694-1.65 1.731-1.809 3.559-0.012 0.144-0.022 0.291-0.025 0.441h-8.009v-1h2v-1h-4v1h1v1.431l-0.475 1.666c-0.331-0.063-0.675-0.097-1.025-0.097-3.031-0.003-5.5 2.466-5.5 5.497s2.469 5.5 5.5 5.5c2.866 0 5.225-2.2 5.478-5h2.044c0.253 2.8 2.613 5 5.478 5 3.031 0 5.5-2.469 5.5-5.5s-2.469-5.5-5.5-5.5zM7.878 9h0.381l4.716 6h-1.994c-0.191-2.116-1.587-3.888-3.491-4.628l0.387-1.372zM6.931 12.306c1.072 0.484 1.859 1.491 2.031 2.694h-2.8l0.769-2.694zM5.5 19c-1.931 0-3.5-1.569-3.5-3.5s1.569-3.5 3.5-3.5c0.159 0 0.316 0.009 0.472 0.031l-0.953 3.331c-0.044 0.15-0.012 0.312 0.081 0.438s0.244 0.2 0.4 0.2h3.466c-0.244 1.694-1.706 3-3.466 3zM13.278 13.772l-3.75-4.772h6.519c0.041 0.462 0.116 0.953 0.225 1.472-1.406 0.625-2.506 1.825-2.994 3.3zM18.5 19c-1.931 0-3.5-1.569-3.5-3.5 0-1.313 0.725-2.459 1.797-3.056 0.319 0.994 0.731 2.078 1.244 3.256l0.2 0.459 0.916-0.4-0.2-0.459c-0.509-1.172-0.919-2.244-1.228-3.216 0.247-0.056 0.503-0.084 0.769-0.084 1.931 0 3.5 1.569 3.5 3.5s-1.566 3.5-3.497 3.5z" })
        );
    }
    function Bicycle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BicycleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bicycle.SVG = BicycleSVG;
    return Bicycle;
})();
export const BillDollar = /*#__PURE__*/ (() => {
        function BillDollarSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 5c-5.416 0-8.050-0.478-10.841-0.984-2.75-0.5-5.591-1.016-11.159-1.016-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1 5.388 0 8.019 0.478 10.803 0.981 2.753 0.503 5.603 1.019 11.197 1.019 0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM22 10c-1.653 0-3-1.347-3-3v-0.103c0.903 0.050 1.894 0.084 3 0.097v3.006zM2 5.006c1.116 0.012 2.103 0.047 2.997 0.1-0.053 1.606-1.378 2.894-2.997 2.894v-2.994zM2 14c1.653 0 3 1.347 3 3v0.103c-0.903-0.050-1.894-0.084-3-0.1v-3.003zM6 17.169v-0.169c0-2.206-1.794-4-4-4v-4c2.147 0 3.906-1.7 3.997-3.828 2.359 0.184 4.053 0.491 5.806 0.809 1.784 0.325 3.612 0.656 6.197 0.85v0.169c0 2.206 1.794 4 4 4v4c-2.147 0-3.906 1.703-3.997 3.828-2.378-0.184-4.081-0.494-5.844-0.813-1.778-0.322-3.594-0.653-6.159-0.847zM22 18.994c-1.113-0.012-2.103-0.047-2.997-0.1 0.056-1.606 1.378-2.894 2.997-2.894v2.994z" }),
_('path', { d: "M12 7h-1v2h-0.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h2c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-3.5v1h2v2h1v-2h0.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-2c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3.5v-1h-2v-2z" }),
_('path', { d: "M19 14c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM19 13v0c0 0 0 0 0 0z" }),
_('path', { d: "M5 10c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM5 11c0 0 0 0 0 0v0z" })
            );
        }
        function BillDollar({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BillDollarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BillDollar.SVG = BillDollarSVG;
        return BillDollar;
    })();
export const BillEuro = /*#__PURE__*/ (() => {
        function BillEuroSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 5c-5.416 0-8.050-0.478-10.841-0.984-2.75-0.5-5.591-1.016-11.159-1.016-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1 5.388 0 8.019 0.478 10.803 0.981 2.753 0.503 5.603 1.019 11.197 1.019 0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM22 10c-1.653 0-3-1.347-3-3v-0.103c0.903 0.050 1.894 0.084 3 0.097v3.006zM2 5.006c1.116 0.012 2.103 0.047 2.997 0.1-0.053 1.606-1.378 2.894-2.997 2.894v-2.994zM2 14c1.653 0 3 1.347 3 3v0.103c-0.903-0.050-1.894-0.084-3-0.1v-3.003zM6 17.169v-0.169c0-2.206-1.794-4-4-4v-4c2.147 0 3.906-1.7 3.997-3.828 2.359 0.184 4.053 0.491 5.806 0.809 1.784 0.325 3.612 0.656 6.197 0.85v0.169c0 2.206 1.794 4 4 4v4c-2.147 0-3.906 1.703-3.997 3.828-2.378-0.184-4.081-0.494-5.844-0.813-1.778-0.322-3.594-0.653-6.159-0.847zM22 18.994c-1.113-0.012-2.103-0.047-2.997-0.1 0.056-1.606 1.378-2.894 2.997-2.894v2.994z" }),
_('path', { d: "M19 14c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM19 13v0c0 0 0 0 0 0z" }),
_('path', { d: "M5 10c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM5 11c0 0 0 0 0 0v0z" }),
_('path', { d: "M12.5 9c1.081 0 1.541 0.709 1.569 0.756l0.25 0.428 0.862-0.503-0.253-0.431c-0.031-0.050-0.747-1.247-2.431-1.247-1.512 0-2.688 0.775-3.209 2h-1.287v1h1.028c-0.019 0.162-0.028 0.328-0.028 0.5s0.009 0.338 0.028 0.5h-1.028v1h1.291c0.519 1.225 1.697 2 3.209 2 1.684 0 2.403-1.197 2.431-1.247l0.253-0.431-0.862-0.503-0.25 0.428c-0.028 0.047-0.487 0.756-1.569 0.756-0.928 0-1.656-0.369-2.081-1h2.578v-1h-2.962c-0.025-0.159-0.038-0.325-0.038-0.5s0.012-0.341 0.038-0.5h2.962v-1h-2.581c0.425-0.638 1.153-1.006 2.081-1.006z" })
            );
        }
        function BillEuro({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BillEuroSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BillEuro.SVG = BillEuroSVG;
        return BillEuro;
    })();
export const BillPound = /*#__PURE__*/ (() => {
        function BillPoundSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 5c-5.416 0-8.050-0.478-10.841-0.984-2.75-0.5-5.591-1.016-11.159-1.016-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1 5.388 0 8.019 0.478 10.803 0.981 2.753 0.503 5.603 1.019 11.197 1.019 0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM22 10c-1.653 0-3-1.347-3-3v-0.103c0.903 0.050 1.894 0.084 3 0.097v3.006zM2 5.006c1.116 0.012 2.103 0.047 2.997 0.1-0.053 1.606-1.378 2.894-2.997 2.894v-2.994zM2 14c1.653 0 3 1.347 3 3v0.103c-0.903-0.050-1.894-0.084-3-0.1v-3.003zM6 17.169v-0.169c0-2.206-1.794-4-4-4v-4c2.147 0 3.906-1.7 3.997-3.828 2.359 0.184 4.053 0.491 5.806 0.809 1.784 0.325 3.612 0.656 6.197 0.85v0.169c0 2.206 1.794 4 4 4v4c-2.147 0-3.906 1.703-3.997 3.828-2.378-0.184-4.081-0.494-5.844-0.813-1.778-0.322-3.594-0.653-6.159-0.847zM22 18.994c-1.113-0.012-2.103-0.047-2.997-0.1 0.056-1.606 1.378-2.894 2.997-2.894v2.994z" }),
_('path', { d: "M10.497 9.356c-0.247 0.494-0.35 1.062-0.406 1.644h-1.091v1h1.025c-0.091 1.544-0.253 2-1.025 2v1h5v-1h-3.328c0.019-0.037 0.034-0.075 0.050-0.112 0.222-0.537 0.266-1.194 0.303-1.887h1.975v-1h-1.9c0.134-1.259 0.488-2 1.9-2h1v-1h-1c-1.212 0-2.053 0.456-2.503 1.356z" }),
_('path', { d: "M19 14c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM19 13v0c0 0 0 0 0 0z" }),
_('path', { d: "M5 10c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM5 11c0 0 0 0 0 0v0z" })
            );
        }
        function BillPound({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BillPoundSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BillPound.SVG = BillPoundSVG;
        return BillPound;
    })();
export const BillRuble = /*#__PURE__*/ (() => {
        function BillRubleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 5c-5.416 0-8.050-0.478-10.841-0.984-2.75-0.5-5.591-1.016-11.159-1.016-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1 5.388 0 8.019 0.478 10.803 0.981 2.753 0.503 5.603 1.019 11.197 1.019 0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM22 10c-1.653 0-3-1.347-3-3v-0.103c0.903 0.050 1.894 0.084 3 0.097v3.006zM2 5.006c1.116 0.012 2.103 0.047 2.997 0.1-0.053 1.606-1.378 2.894-2.997 2.894v-2.994zM2 14c1.653 0 3 1.347 3 3v0.103c-0.903-0.050-1.894-0.084-3-0.1v-3.003zM6 17.169v-0.169c0-2.206-1.794-4-4-4v-4c2.147 0 3.906-1.7 3.997-3.828 2.359 0.184 4.053 0.491 5.806 0.809 1.784 0.325 3.612 0.656 6.197 0.85v0.169c0 2.206 1.794 4 4 4v4c-2.147 0-3.906 1.703-3.997 3.828-2.378-0.184-4.081-0.494-5.844-0.813-1.778-0.322-3.594-0.653-6.159-0.847zM22 18.994c-1.113-0.012-2.103-0.047-2.997-0.1 0.056-1.606 1.378-2.894 2.997-2.894v2.994z" }),
_('path', { d: "M12 8h-1.5c-0.275 0-0.5 0.225-0.5 0.5v2.5h-1v1h1v1h-1v1h1v1h1v-1h2v-1h-2v-1h1c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12 11h-1v-2h1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M19 14c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM19 13v0c0 0 0 0 0 0z" }),
_('path', { d: "M5 10c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM5 11c0 0 0 0 0 0v0z" })
            );
        }
        function BillRuble({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BillRubleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BillRuble.SVG = BillRubleSVG;
        return BillRuble;
    })();
export const BillStackDollar = /*#__PURE__*/ (() => {
        function BillStackDollarSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 2c-5.416 0-8.050-0.478-10.841-0.984-2.75-0.5-5.591-1.016-11.159-1.016-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1 5.388 0 8.019 0.478 10.803 0.981 2.753 0.503 5.603 1.019 11.197 1.019 0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM22 7c-1.653 0-3-1.347-3-3v-0.103c0.903 0.050 1.894 0.084 3 0.097v3.006zM2 2.006c1.116 0.012 2.103 0.047 2.997 0.1-0.053 1.606-1.378 2.894-2.997 2.894v-2.994zM2 11c1.653 0 3 1.347 3 3v0.103c-0.903-0.050-1.894-0.084-3-0.1v-3.003zM6 14.169v-0.169c0-2.206-1.794-4-4-4v-4c2.147 0 3.906-1.7 3.997-3.828 2.359 0.184 4.053 0.491 5.806 0.809 1.784 0.325 3.612 0.656 6.197 0.85v0.169c0 2.206 1.794 4 4 4v4c-2.147 0-3.906 1.703-3.997 3.828-2.378-0.184-4.081-0.494-5.844-0.813-1.778-0.322-3.594-0.653-6.159-0.847zM22 15.994c-1.113-0.012-2.103-0.047-2.997-0.1 0.056-1.606 1.378-2.894 2.997-2.894v2.994z" }),
_('path', { d: "M12.069 19.006c-2.725-0.494-5.544-1.006-11.069-1.006h-1v1h1c5.434 0 8.209 0.503 10.891 0.991 2.734 0.497 5.559 1.009 11.109 1.009h1v-1h-1c-5.459 0-8.241-0.506-10.931-0.994z" }),
_('path', { d: "M12.069 22.006c-2.725-0.494-5.544-1.006-11.069-1.006h-1v1h1c5.434 0 8.209 0.503 10.891 0.991 2.734 0.497 5.559 1.009 11.109 1.009h1v-1h-1c-5.459 0-8.241-0.506-10.931-0.994z" }),
_('path', { d: "M19 11c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM19 10v0c0 0 0 0 0 0z" }),
_('path', { d: "M5 7c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM5 8c0 0 0 0 0 0v0z" }),
_('path', { d: "M12 4h-1v2h-0.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h2c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-3.5v1h2v2h1v-2h0.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-2c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3.5v-1h-2v-2z" })
            );
        }
        function BillStackDollar({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BillStackDollarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BillStackDollar.SVG = BillStackDollarSVG;
        return BillStackDollar;
    })();
export const BillStackEuro = /*#__PURE__*/ (() => {
        function BillStackEuroSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 2c-5.416 0-8.050-0.478-10.841-0.984-2.75-0.5-5.591-1.016-11.159-1.016-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1 5.388 0 8.019 0.478 10.803 0.981 2.753 0.503 5.603 1.019 11.197 1.019 0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM22 7c-1.653 0-3-1.347-3-3v-0.103c0.903 0.050 1.894 0.084 3 0.097v3.006zM2 2.006c1.116 0.012 2.103 0.047 2.997 0.1-0.053 1.606-1.378 2.894-2.997 2.894v-2.994zM2 11c1.653 0 3 1.347 3 3v0.103c-0.903-0.050-1.894-0.084-3-0.1v-3.003zM6 14.169v-0.169c0-2.206-1.794-4-4-4v-4c2.147 0 3.906-1.7 3.997-3.828 2.359 0.184 4.053 0.491 5.806 0.809 1.784 0.325 3.612 0.656 6.197 0.85v0.169c0 2.206 1.794 4 4 4v4c-2.147 0-3.906 1.703-3.997 3.828-2.378-0.184-4.081-0.494-5.844-0.813-1.778-0.322-3.594-0.653-6.159-0.847zM22 15.994c-1.113-0.012-2.103-0.047-2.997-0.1 0.056-1.606 1.378-2.894 2.997-2.894v2.994z" }),
_('path', { d: "M12.069 19.006c-2.725-0.494-5.544-1.006-11.069-1.006h-1v1h1c5.434 0 8.209 0.503 10.891 0.991 2.734 0.497 5.559 1.009 11.109 1.009h1v-1h-1c-5.459 0-8.241-0.506-10.931-0.994z" }),
_('path', { d: "M12.069 22.006c-2.725-0.494-5.544-1.006-11.069-1.006h-1v1h1c5.434 0 8.209 0.503 10.891 0.991 2.734 0.497 5.559 1.009 11.109 1.009h1v-1h-1c-5.459 0-8.241-0.506-10.931-0.994z" }),
_('path', { d: "M19 11c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM19 10v0c0 0 0 0 0 0z" }),
_('path', { d: "M5 7c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM5 8c0 0 0 0 0 0v0z" }),
_('path', { d: "M12.5 6c1.081 0 1.544 0.712 1.572 0.756l0.25 0.428 0.862-0.506-0.253-0.431c-0.031-0.050-0.75-1.247-2.431-1.247-1.512 0-2.688 0.775-3.209 2h-1.291v1h1.028c-0.019 0.162-0.028 0.328-0.028 0.5s0.009 0.337 0.028 0.5h-1.028v1h1.291c0.519 1.225 1.697 2 3.209 2 1.684 0 2.403-1.197 2.431-1.247l0.253-0.431-0.862-0.506-0.253 0.431c-0.003 0.006-0.469 0.753-1.569 0.753-0.928 0-1.656-0.369-2.081-1h2.581v-1h-2.963c-0.025-0.159-0.037-0.325-0.037-0.5s0.012-0.341 0.037-0.5h2.963v-1h-2.581c0.425-0.631 1.153-1 2.081-1z" })
            );
        }
        function BillStackEuro({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BillStackEuroSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BillStackEuro.SVG = BillStackEuroSVG;
        return BillStackEuro;
    })();
export const BillStackPound = /*#__PURE__*/ (() => {
        function BillStackPoundSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 2c-5.416 0-8.050-0.478-10.841-0.984-2.75-0.5-5.591-1.016-11.159-1.016-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1 5.388 0 8.019 0.478 10.803 0.981 2.753 0.503 5.603 1.019 11.197 1.019 0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM22 7c-1.653 0-3-1.347-3-3v-0.103c0.903 0.050 1.894 0.084 3 0.097v3.006zM2 2.006c1.116 0.012 2.103 0.047 2.997 0.1-0.053 1.606-1.378 2.894-2.997 2.894v-2.994zM2 11c1.653 0 3 1.347 3 3v0.103c-0.903-0.050-1.894-0.084-3-0.1v-3.003zM6 14.169v-0.169c0-2.206-1.794-4-4-4v-4c2.147 0 3.906-1.7 3.997-3.828 2.359 0.184 4.053 0.491 5.806 0.809 1.784 0.325 3.612 0.656 6.197 0.85v0.169c0 2.206 1.794 4 4 4v4c-2.147 0-3.906 1.703-3.997 3.828-2.378-0.184-4.081-0.494-5.844-0.813-1.778-0.322-3.594-0.653-6.159-0.847zM22 15.994c-1.113-0.012-2.103-0.047-2.997-0.1 0.056-1.606 1.378-2.894 2.997-2.894v2.994z" }),
_('path', { d: "M12.069 19.006c-2.725-0.494-5.544-1.006-11.069-1.006h-1v1h1c5.434 0 8.209 0.503 10.891 0.991 2.734 0.497 5.559 1.009 11.109 1.009h1v-1h-1c-5.459 0-8.241-0.506-10.931-0.994z" }),
_('path', { d: "M12.069 22.006c-2.725-0.494-5.544-1.006-11.069-1.006h-1v1h1c5.434 0 8.209 0.503 10.891 0.991 2.734 0.497 5.559 1.009 11.109 1.009h1v-1h-1c-5.459 0-8.241-0.506-10.931-0.994z" }),
_('path', { d: "M10.497 6.356c-0.247 0.494-0.35 1.062-0.406 1.644h-1.091v1h1.025c-0.091 1.544-0.253 2-1.025 2v1h5v-1h-3.328c0.019-0.037 0.034-0.075 0.050-0.112 0.222-0.537 0.266-1.194 0.303-1.887h1.975v-1h-1.9c0.134-1.259 0.488-2 1.9-2h1v-1h-1c-1.212 0-2.053 0.456-2.503 1.356z" }),
_('path', { d: "M19 11c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM19 10v0c0 0 0 0 0 0z" }),
_('path', { d: "M5 7c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM5 8c0 0 0 0 0 0v0z" })
            );
        }
        function BillStackPound({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BillStackPoundSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BillStackPound.SVG = BillStackPoundSVG;
        return BillStackPound;
    })();
export const BillStackRuble = /*#__PURE__*/ (() => {
        function BillStackRubleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 2c-5.416 0-8.050-0.478-10.841-0.984-2.75-0.5-5.591-1.016-11.159-1.016-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1 5.388 0 8.019 0.478 10.803 0.981 2.753 0.503 5.603 1.019 11.197 1.019 0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM22 7c-1.653 0-3-1.347-3-3v-0.103c0.903 0.050 1.894 0.084 3 0.097v3.006zM2 2.006c1.116 0.012 2.103 0.047 2.997 0.1-0.053 1.606-1.378 2.894-2.997 2.894v-2.994zM2 11c1.653 0 3 1.347 3 3v0.103c-0.903-0.050-1.894-0.084-3-0.1v-3.003zM6 14.169v-0.169c0-2.206-1.794-4-4-4v-4c2.147 0 3.906-1.7 3.997-3.828 2.359 0.184 4.053 0.491 5.806 0.809 1.784 0.325 3.612 0.656 6.197 0.85v0.169c0 2.206 1.794 4 4 4v4c-2.147 0-3.906 1.703-3.997 3.828-2.378-0.184-4.081-0.494-5.844-0.813-1.778-0.322-3.594-0.653-6.159-0.847zM22 15.994c-1.113-0.012-2.103-0.047-2.997-0.1 0.056-1.606 1.378-2.894 2.997-2.894v2.994z" }),
_('path', { d: "M12.069 19.006c-2.725-0.494-5.544-1.006-11.069-1.006h-1v1h1c5.434 0 8.209 0.503 10.891 0.991 2.734 0.497 5.559 1.009 11.109 1.009h1v-1h-1c-5.459 0-8.241-0.506-10.931-0.994z" }),
_('path', { d: "M12.069 22.006c-2.725-0.494-5.544-1.006-11.069-1.006h-1v1h1c5.434 0 8.209 0.503 10.891 0.991 2.734 0.497 5.559 1.009 11.109 1.009h1v-1h-1c-5.459 0-8.241-0.506-10.931-0.994z" }),
_('path', { d: "M12 5h-1.5c-0.275 0-0.5 0.225-0.5 0.5v2.5h-1v1h1v1h-1v1h1v1h1v-1h2v-1h-2v-1h1c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12 8h-1v-2h1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M19 11c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM19 10v0c0 0 0 0 0 0z" }),
_('path', { d: "M5 7c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM5 8c0 0 0 0 0 0v0z" })
            );
        }
        function BillStackRuble({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BillStackRubleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BillStackRuble.SVG = BillStackRubleSVG;
        return BillStackRuble;
    })();
export const BillStackYen = /*#__PURE__*/ (() => {
        function BillStackYenSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 2c-5.416 0-8.050-0.478-10.841-0.984-2.75-0.5-5.591-1.016-11.159-1.016-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1 5.388 0 8.019 0.478 10.803 0.981 2.753 0.503 5.603 1.019 11.197 1.019 0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM22 7c-1.653 0-3-1.347-3-3v-0.103c0.903 0.050 1.894 0.084 3 0.097v3.006zM2 2.006c1.116 0.012 2.103 0.047 2.997 0.1-0.053 1.606-1.378 2.894-2.997 2.894v-2.994zM2 11c1.653 0 3 1.347 3 3v0.103c-0.903-0.050-1.894-0.084-3-0.1v-3.003zM6 14.169v-0.169c0-2.206-1.794-4-4-4v-4c2.147 0 3.906-1.7 3.997-3.828 2.359 0.184 4.053 0.491 5.806 0.809 1.784 0.325 3.612 0.656 6.197 0.85v0.169c0 2.206 1.794 4 4 4v4c-2.147 0-3.906 1.703-3.997 3.828-2.378-0.184-4.081-0.494-5.844-0.813-1.778-0.322-3.594-0.653-6.159-0.847zM22 15.994c-1.113-0.012-2.103-0.047-2.997-0.1 0.056-1.606 1.378-2.894 2.997-2.894v2.994z" }),
_('path', { d: "M12.069 19.006c-2.725-0.494-5.544-1.006-11.069-1.006h-1v1h1c5.434 0 8.209 0.503 10.891 0.991 2.734 0.497 5.559 1.009 11.109 1.009h1v-1h-1c-5.459 0-8.241-0.506-10.931-0.994z" }),
_('path', { d: "M12.069 22.006c-2.725-0.494-5.544-1.006-11.069-1.006h-1v1h1c5.434 0 8.209 0.503 10.891 0.991 2.734 0.497 5.559 1.009 11.109 1.009h1v-1h-1c-5.459 0-8.241-0.506-10.931-0.994z" }),
_('path', { d: "M14.206 5.5l-0.706-0.706-2 2-2-2-0.706 0.706 2.206 2.206v0.294h-2v1h2v1h-2v1h2v1h1v-1h2v-1h-2v-1h2v-1h-2v-0.294z" }),
_('path', { d: "M19 11c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM19 10v0c0 0 0 0 0 0z" }),
_('path', { d: "M5 7c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM5 8c0 0 0 0 0 0v0z" })
            );
        }
        function BillStackYen({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BillStackYenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BillStackYen.SVG = BillStackYenSVG;
        return BillStackYen;
    })();
export const BillStack = /*#__PURE__*/ (() => {
        function BillStackSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 2c-5.416 0-8.050-0.478-10.841-0.984-2.75-0.5-5.591-1.016-11.159-1.016-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1 5.388 0 8.019 0.478 10.803 0.981 2.753 0.503 5.603 1.019 11.197 1.019 0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM22 7c-1.653 0-3-1.347-3-3v-0.103c0.903 0.050 1.894 0.084 3 0.097v3.006zM2 2.006c1.116 0.012 2.103 0.047 2.997 0.1-0.053 1.606-1.378 2.894-2.997 2.894v-2.994zM2 11c1.653 0 3 1.347 3 3v0.103c-0.903-0.050-1.894-0.084-3-0.1v-3.003zM6 14.169v-0.169c0-2.206-1.794-4-4-4v-4c2.147 0 3.906-1.7 3.997-3.828 2.359 0.184 4.053 0.491 5.806 0.809 1.784 0.325 3.612 0.656 6.197 0.85v0.169c0 2.206 1.794 4 4 4v4c-2.147 0-3.906 1.703-3.997 3.828-2.378-0.184-4.081-0.494-5.844-0.813-1.778-0.322-3.594-0.653-6.159-0.847zM22 15.994c-1.113-0.012-2.103-0.047-2.997-0.1 0.056-1.606 1.378-2.894 2.997-2.894v2.994z" }),
_('path', { d: "M12.069 19.006c-2.725-0.494-5.544-1.006-11.069-1.006h-1v1h1c5.434 0 8.209 0.503 10.891 0.991 2.734 0.497 5.559 1.009 11.109 1.009h1v-1h-1c-5.459 0-8.241-0.506-10.931-0.994z" }),
_('path', { d: "M12.069 22.006c-2.725-0.494-5.544-1.006-11.069-1.006h-1v1h1c5.434 0 8.209 0.503 10.891 0.991 2.734 0.497 5.559 1.009 11.109 1.009h1v-1h-1c-5.459 0-8.241-0.506-10.931-0.994z" }),
_('path', { d: "M12 5c-0.834 0-1.606 0.438-2.175 1.234-0.531 0.744-0.825 1.728-0.825 2.766s0.294 2.022 0.825 2.766c0.569 0.797 1.341 1.234 2.175 1.234s1.606-0.438 2.175-1.234c0.531-0.744 0.825-1.728 0.825-2.766s-0.294-2.022-0.825-2.766c-0.569-0.797-1.341-1.234-2.175-1.234zM13.359 11.184c-0.375 0.525-0.859 0.816-1.359 0.816-0.503 0-0.984-0.291-1.359-0.816-0.413-0.578-0.641-1.353-0.641-2.184s0.228-1.606 0.641-2.184c0.375-0.525 0.859-0.816 1.359-0.816 0.503 0 0.984 0.291 1.359 0.816 0.413 0.578 0.641 1.353 0.641 2.184s-0.228 1.606-0.641 2.184z" }),
_('path', { d: "M19 11c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM19 10v0c0 0 0 0 0 0z" }),
_('path', { d: "M5 7c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM5 8c0 0 0 0 0 0v0z" })
            );
        }
        function BillStack({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BillStackSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BillStack.SVG = BillStackSVG;
        return BillStack;
    })();
export const BillYen = /*#__PURE__*/ (() => {
        function BillYenSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 5c-5.416 0-8.050-0.478-10.841-0.984-2.75-0.5-5.591-1.016-11.159-1.016-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1 5.388 0 8.019 0.478 10.803 0.981 2.753 0.503 5.603 1.019 11.197 1.019 0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM22 10c-1.653 0-3-1.347-3-3v-0.103c0.903 0.050 1.894 0.084 3 0.097v3.006zM2 5.006c1.116 0.012 2.103 0.047 2.997 0.1-0.053 1.606-1.378 2.894-2.997 2.894v-2.994zM2 14c1.653 0 3 1.347 3 3v0.103c-0.903-0.050-1.894-0.084-3-0.1v-3.003zM6 17.169v-0.169c0-2.206-1.794-4-4-4v-4c2.147 0 3.906-1.7 3.997-3.828 2.359 0.184 4.053 0.491 5.806 0.809 1.784 0.325 3.612 0.656 6.197 0.85v0.169c0 2.206 1.794 4 4 4v4c-2.147 0-3.906 1.703-3.997 3.828-2.378-0.184-4.081-0.494-5.844-0.813-1.778-0.322-3.594-0.653-6.159-0.847zM22 18.994c-1.113-0.012-2.103-0.047-2.997-0.1 0.056-1.606 1.378-2.894 2.997-2.894v2.994z" }),
_('path', { d: "M14.206 9.5l-0.706-0.706-2 2-2-2-0.706 0.706 2.206 2.206v0.294h-2v1h2v1h-2v1h2v1h1v-1h2v-1h-2v-1h2v-1h-2v-0.294z" }),
_('path', { d: "M19 14c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM19 13v0c0 0 0 0 0 0z" }),
_('path', { d: "M5 10c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM5 11c0 0 0 0 0 0v0z" })
            );
        }
        function BillYen({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BillYenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BillYen.SVG = BillYenSVG;
        return BillYen;
    })();
export const Bill = /*#__PURE__*/ (() => {
        function BillSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.991 6.856c-0.044-0.312-0.234-0.584-0.509-0.734l-11-6c-0.391-0.213-0.872-0.144-1.188 0.172-2.497 2.497-3.772 4.938-5.125 7.522-1.403 2.684-2.856 5.459-5.875 8.478-0.222 0.222-0.328 0.537-0.281 0.85 0.044 0.312 0.234 0.584 0.513 0.734l11 6c0.15 0.081 0.316 0.122 0.478 0.122 0.259 0 0.516-0.1 0.706-0.294 3.234-3.234 4.759-6.147 6.231-8.966 1.278-2.444 2.487-4.756 4.769-7.034 0.222-0.222 0.325-0.537 0.281-0.85zM12.191 2.244l2.731 1.491c-0.747 0.797-1.8 1.266-2.922 1.266-0.597 0-1.172-0.128-1.697-0.375 0.544-0.803 1.156-1.594 1.887-2.381zM4.303 14.744c0.45 0.659 0.697 1.441 0.697 2.256 0 0.331-0.041 0.659-0.122 0.978l-2.253-1.231c0.625-0.681 1.178-1.347 1.678-2.003zM11.813 21.759l-2.734-1.491c0.747-0.8 1.8-1.269 2.922-1.269 0.625 0 1.237 0.147 1.791 0.422-0.575 0.766-1.225 1.544-1.978 2.337zM17.169 13.816c-0.813 1.556-1.644 3.144-2.787 4.791-0.725-0.397-1.544-0.606-2.381-0.606-1.491 0-2.881 0.663-3.822 1.775l-2.4-1.306c0.144-0.475 0.222-0.969 0.222-1.469 0-1.137-0.384-2.225-1.078-3.103 1.253-1.784 2.144-3.488 3.019-5.156 0.584-1.116 1.153-2.203 1.816-3.272 0.694 0.347 1.463 0.531 2.244 0.531 1.491 0 2.881-0.663 3.822-1.775l2.397 1.309c-0.144 0.475-0.222 0.969-0.222 1.469 0 1.194 0.419 2.328 1.175 3.222-0.741 1.175-1.366 2.366-2.003 3.591zM19.756 9.341c-0.487-0.675-0.756-1.488-0.756-2.341 0-0.331 0.041-0.659 0.122-0.978l2.262 1.234c-0.616 0.697-1.15 1.388-1.628 2.084z" }),
_('path', { d: "M12 9c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM12 14c-1.103 0-2-0.897-2-2s0.897-2 2-2c1.103 0 2 0.897 2 2s-0.897 2-2 2z" })
            );
        }
        function Bill({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BillSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bill.SVG = BillSVG;
        return Bill;
    })();
export const Bill2 = /*#__PURE__*/ (() => {
        function Bill2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 5c-5.416 0-8.050-0.478-10.841-0.984-2.75-0.5-5.591-1.016-11.159-1.016-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1 5.388 0 8.019 0.478 10.803 0.981 2.753 0.503 5.603 1.019 11.197 1.019 0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM22 10c-1.653 0-3-1.347-3-3v-0.103c0.903 0.050 1.894 0.084 3 0.097v3.006zM2 5.006c1.116 0.012 2.103 0.047 2.997 0.1-0.053 1.606-1.378 2.894-2.997 2.894v-2.994zM2 14c1.653 0 3 1.347 3 3v0.103c-0.903-0.050-1.894-0.084-3-0.1v-3.003zM6 17.169v-0.169c0-2.206-1.794-4-4-4v-4c2.147 0 3.906-1.7 3.997-3.828 2.359 0.184 4.053 0.491 5.806 0.809 1.784 0.325 3.612 0.656 6.197 0.85v0.169c0 2.206 1.794 4 4 4v4c-2.147 0-3.906 1.703-3.997 3.828-2.378-0.184-4.081-0.494-5.844-0.813-1.778-0.322-3.594-0.653-6.159-0.847zM22 18.994c-1.113-0.012-2.103-0.047-2.997-0.1 0.056-1.606 1.378-2.894 2.997-2.894v2.994z" }),
_('path', { d: "M12 8c-0.834 0-1.606 0.438-2.175 1.234-0.531 0.744-0.825 1.728-0.825 2.766s0.294 2.022 0.825 2.766c0.569 0.797 1.341 1.234 2.175 1.234s1.606-0.438 2.175-1.234c0.531-0.744 0.825-1.728 0.825-2.766s-0.294-2.022-0.825-2.766c-0.569-0.797-1.341-1.234-2.175-1.234zM13.359 14.184c-0.375 0.525-0.859 0.816-1.359 0.816-0.503 0-0.984-0.291-1.359-0.816-0.413-0.578-0.641-1.353-0.641-2.184s0.228-1.606 0.641-2.184c0.375-0.525 0.859-0.816 1.359-0.816 0.503 0 0.984 0.291 1.359 0.816 0.413 0.578 0.641 1.353 0.641 2.184s-0.228 1.606-0.641 2.184z" }),
_('path', { d: "M19 14c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM19 13v0c0 0 0 0 0 0z" }),
_('path', { d: "M5 10c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM5 11c0 0 0 0 0 0v0z" })
            );
        }
        function Bill2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Bill2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bill2.SVG = Bill2SVG;
        return Bill2;
    })();
export const Binoculars = /*#__PURE__*/ (() => {
        function BinocularsSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.484 14.172v0l-3.803-8.134c-0.003-0.006-0.006-0.012-0.009-0.022-0.406-0.866-1.147-1.516-2.022-1.822l-0.847-1.441c-0.003-0.003-0.006-0.009-0.009-0.012-0.269-0.456-0.766-0.741-1.294-0.741-0.828 0-1.5 0.672-1.5 1.5v1.553c-0.619 0.631-1 1.497-1 2.447v0.769c-0.294-0.172-0.638-0.269-1-0.269s-0.706 0.097-1 0.269v-0.769c0-0.95-0.381-1.816-1-2.447v-1.553c0-0.828-0.672-1.5-1.5-1.5-0.528 0-1.025 0.284-1.294 0.741-0.003 0.003-0.006 0.009-0.009 0.012l-0.847 1.441c-0.878 0.306-1.619 0.956-2.022 1.822-0.003 0.006-0.006 0.012-0.009 0.019l-3.803 8.138c-0.331 0.709-0.516 1.497-0.516 2.328 0 3.031 2.469 5.5 5.5 5.5 2.956 0 5.375-2.344 5.494-5.272 0.297 0.172 0.638 0.272 1.006 0.272 0.366 0 0.709-0.1 1.006-0.272 0.119 2.928 2.538 5.272 5.494 5.272 3.031 0 5.5-2.469 5.5-5.5 0-0.831-0.184-1.619-0.516-2.328zM19.875 11.175c-0.441-0.113-0.9-0.175-1.375-0.175-1.328 0-2.547 0.472-3.5 1.259v-4.759c0-0.828 0.672-1.5 1.5-1.5 0.575 0 1.103 0.334 1.353 0.85 0.003 0.006 0.006 0.009 0.006 0.016l2.016 4.309zM15.5 3c0.175 0 0.334 0.087 0.425 0.237 0.003 0.003 0.003 0.006 0.006 0.009l0.444 0.756c-0.491 0.019-0.956 0.138-1.375 0.334v-0.837c0-0.275 0.225-0.5 0.5-0.5zM12 9c0.55 0 1 0.45 1 1v3.269c-0.294-0.172-0.638-0.269-1-0.269s-0.706 0.097-1 0.269v-3.269c0-0.55 0.45-1 1-1zM8.075 3.237c0.091-0.15 0.25-0.237 0.425-0.237 0.275 0 0.5 0.225 0.5 0.5v0.837c-0.419-0.2-0.884-0.319-1.375-0.334l0.444-0.756c0.003-0.003 0.003-0.006 0.006-0.009zM6.141 6.866c0.003-0.006 0.003-0.009 0.006-0.016 0.25-0.516 0.778-0.85 1.353-0.85 0.828 0 1.5 0.672 1.5 1.5v4.759c-0.953-0.787-2.172-1.259-3.5-1.259-0.475 0-0.934 0.059-1.375 0.175l2.016-4.309zM5.5 20c-1.931 0-3.5-1.569-3.5-3.5s1.569-3.5 3.5-3.5 3.5 1.569 3.5 3.5-1.569 3.5-3.5 3.5zM12 16c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1zM18.5 20c-1.931 0-3.5-1.569-3.5-3.5s1.569-3.5 3.5-3.5 3.5 1.569 3.5 3.5-1.569 3.5-3.5 3.5z" }),
_('path', { d: "M4 16.5v-0.5h-1v0.5c0 1.378 1.122 2.5 2.5 2.5h0.5v-1h-0.5c-0.828 0-1.5-0.672-1.5-1.5z" }),
_('path', { d: "M17 16.5v-0.5h-1v0.5c0 1.378 1.122 2.5 2.5 2.5h0.5v-1h-0.5c-0.828 0-1.5-0.672-1.5-1.5z" })
            );
        }
        function Binoculars({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BinocularsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Binoculars.SVG = BinocularsSVG;
        return Binoculars;
    })();
export const Binoculars2 = /*#__PURE__*/ (() => {
    function Binoculars2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.325 13.222c-0.681-1.419-1.325-2.759-1.325-4.222v-4c0-1.103-0.897-2-2-2v-2.5c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v2.769c-0.597 0.347-1 0.994-1 1.731h-2c0-0.738-0.403-1.384-1-1.731v-2.769c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v2.5c-1.103 0-2 0.897-2 2v4c0 1.462-0.644 2.803-1.325 4.222-0.784 1.634-1.675 3.484-1.675 5.778v3c0 1.103 0.897 2 2 2h6c1.103 0 2-0.897 2-2v-8h2v8c0 1.103 0.897 2 2 2h6c1.103 0 2-0.897 2-2v-3c0-2.294-0.891-4.144-1.675-5.778zM19.525 14.091c0.759 1.578 1.475 3.072 1.475 4.909h-6v-14h3v4c0 1.919 0.775 3.531 1.525 5.091zM15 1h2v2h-2v-2zM14 6v7h-4v-7h4zM7 1h2v2h-2v-2zM4.475 14.091c0.75-1.559 1.525-3.172 1.525-5.091v-4h3v14h-6c0-1.837 0.716-3.331 1.475-4.909zM3 22v-2h6v2h-6zM15 22v-2h6v2h-6z" })
        );
    }
    function Binoculars2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Binoculars2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Binoculars2.SVG = Binoculars2SVG;
    return Binoculars2;
})();
export const Blog = /*#__PURE__*/ (() => {
        function BlogSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.706 9.294c-0.341-0.341-0.872-0.391-1.269-0.119-1.406 0.956-3.75 2.281-5.725 2.869-0.387 0.116-0.669 0.453-0.709 0.856-0.231 2.303-1.406 6.65-2.9 9.656-0.191 0.384-0.116 0.847 0.188 1.153 0.191 0.191 0.447 0.294 0.706 0.294 0.15 0 0.303-0.034 0.444-0.103 3.006-1.494 7.353-2.669 9.656-2.9 0.403-0.041 0.741-0.322 0.856-0.709 0.594-1.978 1.919-4.322 2.875-5.728 0.269-0.397 0.219-0.928-0.119-1.269l-4.003-4zM10.247 19.087c-1.225 0.178-2.763 0.525-4.331 0.987-0.641 0.188-1.272 0.391-1.881 0.6l3.819-3.819c0.197 0.094 0.416 0.147 0.647 0.147 0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5c0 0.231 0.053 0.45 0.147 0.647l-3.819 3.816c0.213-0.609 0.412-1.241 0.6-1.881 0.459-1.569 0.809-3.106 0.987-4.331 1.722-0.606 3.584-1.609 4.953-2.472l2.853 2.853c-0.866 1.369-1.869 3.228-2.475 4.953zM8 15.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5z" }),
_('path', { d: "M12 6v1c2.756 0 5 2.244 5 5h1c0-3.309-2.691-6-6-6z" }),
_('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.816s-2.384-1.966-3.816-2.572c-1.478-0.622-3.050-0.941-4.669-0.941v1c6.066 0 11 4.934 11 11h1c0-1.619-0.319-3.191-0.944-4.672z" }),
_('path', { d: "M12 3v1c4.413 0 8 3.588 8 8h1c0-2.403-0.938-4.666-2.637-6.363-1.697-1.7-3.959-2.637-6.363-2.637z" })
            );
        }
        function Blog({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BlogSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Blog.SVG = BlogSVG;
        return Blog;
    })();
export const Boat = /*#__PURE__*/ (() => {
    function BoatSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.878 15.525c-0.197-0.366-0.603-0.572-1.016-0.516l-11.862 1.619v-0.709l10.591-1.925c0.138-0.025 0.259-0.106 0.334-0.225s0.097-0.263 0.059-0.4c-0.553-2.009-1.5-3.806-2.809-5.341-1.047-1.225-2.325-2.284-3.8-3.147-1.897-1.109-3.612-1.603-4.375-1.784v-2.597c0-0.275-0.225-0.5-0.5-0.5-1.028 0-1.847 0.528-2.641 1.041-0.762 0.494-1.481 0.959-2.359 0.959-0.241 0-0.447 0.169-0.491 0.406-0.047 0.234 0.081 0.469 0.306 0.559 0.1 0.041 2.303 0.909 4.684 1.025v1.419c-1.5 3.894-6.837 10.713-6.894 10.781-0.125 0.159-0.141 0.381-0.041 0.559 0.091 0.156 0.256 0.25 0.434 0.25 0.025 0 0.047-0.003 0.072-0.006l6.428-0.919v0.687l-9.134 1.247c-0.319 0.044-0.6 0.237-0.75 0.525-0.15 0.284-0.153 0.625-0.009 0.916l2 4c0.169 0.337 0.516 0.55 0.894 0.55h12c0.047 0 0.097-0.003 0.144-0.009 1.697-0.247 3.1-0.872 4.297-1.913 1.041-0.906 1.8-1.994 2.603-3.144 0.528-0.756 1.072-1.538 1.713-2.281 0.272-0.312 0.322-0.762 0.122-1.128zM14.869 5.744c2.981 1.744 4.994 4.219 5.994 7.362l-8.794 1.6c0.356-0.572 0.616-1.294 0.769-2.153 0.272-1.525 0.2-3.469-0.2-5.334-0.241-1.134-0.578-2.128-0.975-2.9 0.828 0.262 1.978 0.706 3.206 1.425zM11.853 12.378c-0.122 0.691-0.369 1.522-0.853 2.106v-9.219c0.778 1.847 1.263 4.816 0.853 7.113zM8.403 1.881c0.537-0.347 1.053-0.681 1.597-0.819v1.922c-0.981-0.053-1.944-0.247-2.709-0.444 0.397-0.197 0.766-0.434 1.113-0.659zM10 7.759v7.309l-5.356 0.766c1.253-1.666 3.784-5.131 5.356-8.075zM20.403 17.791c-1.469 2.103-2.628 3.772-5.478 4.209h-11.306l-1.1-2.197 18.213-2.484c-0.109 0.159-0.219 0.316-0.328 0.472z" })
        );
    }
    function Boat({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BoatSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Boat.SVG = BoatSVG;
    return Boat;
})();
export const Bold = /*#__PURE__*/ (() => {
    function BoldSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16.1 11.653c1.163-1.009 1.9-2.497 1.9-4.153 0-3.031-2.469-5.5-5.5-5.5h-6.5c-0.553 0-1 0.447-1 1v18c0 0.553 0.447 1 1 1h7.5c3.031 0 5.5-2.469 5.5-5.5 0-2.094-1.175-3.916-2.9-4.847zM7 4h5.5c1.931 0 3.5 1.569 3.5 3.5s-1.569 3.5-3.5 3.5h-5.5v-7zM13.5 20h-6.5v-7h6.5c1.931 0 3.5 1.569 3.5 3.5s-1.569 3.5-3.5 3.5z" })
        );
    }
    function Bold({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BoldSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bold.SVG = BoldSVG;
    return Bold;
})();
export const Bomb = /*#__PURE__*/ (() => {
        function BombSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.784 6.159c0.206-0.494 0.206-1.038 0.003-1.531s-0.588-0.881-1.078-1.088l-0.825-0.344c0.534-0.844 1.409-1.313 2.353-1.191 0.719 0.094 1.378 0.541 1.856 1.259 0.594 0.891 0.906 2.184 0.906 3.734h1c0-1.775-0.363-3.216-1.075-4.287-0.641-0.963-1.55-1.563-2.559-1.694-0.825-0.109-1.666 0.109-2.359 0.609-0.428 0.309-0.784 0.709-1.056 1.181l-1.009-0.422c-1.019-0.425-2.194 0.056-2.616 1.075l-1.062 2.541c-1.488 0.041-2.934 0.472-4.219 1.259-1.522 0.934-2.694 2.303-3.384 3.956-0.878 2.094-0.884 4.406-0.022 6.506 0.859 2.103 2.491 3.744 4.587 4.619 1.056 0.441 2.169 0.663 3.278 0.663 1.094 0 2.184-0.213 3.225-0.641 2.1-0.859 3.741-2.487 4.616-4.584 1.294-3.097 0.634-6.656-1.625-9.078l1.066-2.544zM11.169 4.234c0-0.003 0.003-0.003 0 0l2.769 1.153c0 0 0 0.003 0 0.003l-1.219 2.909c-0.416-0.281-0.859-0.522-1.325-0.716-0.469-0.197-0.95-0.344-1.444-0.441l1.219-2.909zM14.5 17.009c-1.044 2.491-3.462 3.994-6.006 3.994-0.834 0-1.681-0.162-2.497-0.503-1.603-0.672-2.85-1.925-3.509-3.531s-0.653-3.375 0.016-4.978c1.013-2.425 3.397-3.994 6.003-3.994 0.066 0 0.131 0 0.197 0.003v0.003c0.794 0.025 1.569 0.194 2.306 0.503 0.684 0.284 1.306 0.678 1.853 1.175 0 0 0 0 0 0 0.022 0.022 0.044 0.041 0.069 0.063 0.012 0.009 0.022 0.022 0.034 0.031 1.959 1.853 2.578 4.741 1.534 7.234z" }),
_('path', { d: "M16.793 9.5l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M17.828 12.725l1.448-2.896 0.894 0.447-1.448 2.896-0.894-0.447z" }),
_('path', { d: "M20.828 10.276l0.894-0.447 1.448 2.896-0.894 0.447-1.448-2.896z" }),
_('path', { d: "M20.793 7.501l0.707-0.707 1.708 1.708-0.707 0.707-1.708-1.708z" }),
_('path', { d: "M4.609 10.609c-1.038 1.041-1.609 2.422-1.609 3.891v0.5h1v-0.5c0-2.481 2.019-4.5 4.5-4.5h0.5v-1h-0.5c-1.469 0-2.85 0.572-3.891 1.609z" }),
_('path', { d: "M20 13h1v1h-1v-1z" })
            );
        }
        function Bomb({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BombSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bomb.SVG = BombSVG;
        return Bomb;
    })();
export const Bone = /*#__PURE__*/ (() => {
    function BoneSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21 15c-1.584 0-1.981-0.397-3.294-1.706l-7-7c-1.447-1.45-1.706-1.788-1.706-2.794 0-1.931-1.569-3.5-3.5-3.5-1.816 0-3.316 1.391-3.484 3.166-1.172 0.409-2.016 1.525-2.016 2.834 0 1.653 1.347 3 3 3 1.584 0 1.981 0.397 3.294 1.706l7 7c1.447 1.45 1.706 1.788 1.706 2.794 0 1.931 1.569 3.5 3.5 3.5 1.816 0 3.316-1.391 3.484-3.166 1.172-0.409 2.016-1.525 2.016-2.834 0-1.653-1.347-3-3-3zM21 19h-2v1h1v0.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-1.916-0.863-2.778-2.294-4.206l-7-7c-0.712-0.712-1.275-1.275-1.972-1.672-0.753-0.431-1.597-0.622-2.734-0.622-0.55 0-1-0.45-1-1s0.45-1 1-1h2v-1h-1v-0.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 1.916 0.863 2.778 2.294 4.206l7 7c0.712 0.713 1.275 1.275 1.972 1.672 0.753 0.428 1.597 0.622 2.734 0.622 0.55 0 1 0.45 1 1s-0.45 1-1 1z" })
        );
    }
    function Bone({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BoneSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bone.SVG = BoneSVG;
    return Bone;
})();
export const BookAudio = /*#__PURE__*/ (() => {
        function BookAudioSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 1c-2.641 0-4.922 1.584-5.937 3.853-1.387-1.044-3.338-1.222-5.234-1.397-1.041-0.094-2.119-0.194-3.094-0.428-0.297-0.072-0.612-0.003-0.853 0.188-0.241 0.188-0.381 0.478-0.381 0.784v1h-1.5c-0.275 0-0.5 0.225-0.5 0.5v14c0 0.247 0.181 0.456 0.425 0.494 0.753 0.112 1.669 0.191 2.634 0.272 2.931 0.244 6.941 0.581 6.941 2.234 0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5 0-1.653 4.009-1.991 6.941-2.234 0.969-0.081 1.881-0.156 2.634-0.272 0.244-0.038 0.425-0.247 0.425-0.494v-12c0-3.584-2.916-6.5-6.5-6.5zM17.5 2c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM13 12.188c1.169 1.122 2.756 1.812 4.5 1.812 0.884 0 1.731-0.178 2.5-0.5v2.684c-0.759 0.128-1.553 0.203-2.328 0.272-1.338 0.122-2.603 0.237-3.731 0.622-0.341 0.116-0.656 0.253-0.941 0.409v-5.3zM4 5.209c0.719 0.109 1.441 0.175 2.147 0.237 1.834 0.169 3.569 0.325 4.453 1.209v0c0.166 0.166 0.3 0.356 0.409 0.569-0.003 0.091-0.006 0.181-0.006 0.275v9.987c-0.288-0.156-0.6-0.294-0.941-0.409-1.128-0.384-2.391-0.5-3.731-0.622-0.775-0.072-1.569-0.144-2.328-0.272v-10.975zM23 19.062c-0.634 0.078-1.372 0.141-2.144 0.206-1.675 0.141-3.572 0.3-5.044 0.694-0.844 0.225-1.475 0.509-1.931 0.863-0.431 0.331-0.703 0.725-0.819 1.175h-2.122c-0.113-0.45-0.387-0.844-0.819-1.175-0.456-0.353-1.091-0.634-1.931-0.863-1.472-0.397-3.372-0.553-5.044-0.694-0.772-0.066-1.509-0.125-2.144-0.206v-13.062h1v11c0 0.462 0.316 0.863 0.766 0.972 1.119 0.269 2.269 0.375 3.381 0.475 2.653 0.241 4.313 0.466 4.931 1.941 0.156 0.372 0.519 0.612 0.922 0.612s0.766-0.241 0.922-0.612c0.622-1.475 2.278-1.697 4.931-1.941 1.113-0.1 2.262-0.206 3.381-0.475 0.45-0.109 0.766-0.509 0.766-0.972v-4.812c0.381-0.366 0.716-0.778 1-1.225v8.1z" }),
_('path', { d: "M15.506 10.609c0.334 0.256 0.803 0.397 1.303 0.397 0.125 0 0.253-0.009 0.381-0.028 1.047-0.147 1.812-0.837 1.809-1.606v0-3.138c0.531 0.475 1.231 0.766 2 0.766v-1c-1.103 0-2-0.897-2-2h-1v4.131c-0.353-0.125-0.762-0.162-1.191-0.103-1.109 0.156-1.903 0.922-1.803 1.747 0.041 0.325 0.213 0.616 0.5 0.834zM16.947 9.016c0.087-0.012 0.172-0.019 0.253-0.019 0.319 0 0.553 0.091 0.681 0.188 0.072 0.053 0.109 0.109 0.116 0.166v0c0.025 0.197-0.341 0.55-0.947 0.634-0.366 0.050-0.731-0.016-0.934-0.172-0.050-0.038-0.109-0.097-0.116-0.166-0.025-0.191 0.341-0.544 0.947-0.631z" })
            );
        }
        function BookAudio({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BookAudioSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BookAudio.SVG = BookAudioSVG;
        return BookAudio;
    })();
export const BookBookmarked = /*#__PURE__*/ (() => {
        function BookBookmarkedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.288 10.041l-1.056-0.316c-0.078-0.2-0.138-0.413-0.172-0.616-0.159-0.916 0-1.984 0.494-2.637l0.984-0.628c0.331-0.209 0.506-0.594 0.453-0.981s-0.328-0.709-0.703-0.822l-10-3c-0.278-0.084-0.578-0.041-0.825 0.116l-11 7c-0.081 0.053-0.153 0.113-0.216 0.184-1.012 1.141-1.447 2.931-1.162 4.794 0.097 0.625 0.425 2.137 1.403 2.722 0.072 0.041 0.147 0.075 0.225 0.1l2.288 0.687v3.856c0 0.203 0.122 0.384 0.309 0.462s0.403 0.034 0.544-0.109l1.509-1.509 1.691 3.378c0.087 0.172 0.263 0.275 0.447 0.275 0.038 0 0.078-0.003 0.116-0.012 0.225-0.053 0.384-0.256 0.384-0.488v-4.353l2.712 0.813c0.094 0.028 0.191 0.041 0.288 0.041 0.187 0 0.375-0.053 0.537-0.156l11-7c0.331-0.209 0.506-0.594 0.453-0.981-0.053-0.384-0.328-0.706-0.703-0.819zM12.684 16.378c-0.334-0.237-0.541-0.787-0.625-1.272 0 0 0 0 0-0.003l9.031-5.747c0.103 0.531 0.284 0.984 0.531 1.331l-8.937 5.691zM2.028 11.487c0.053-0.497 0.181-0.947 0.378-1.322l8.853 2.656c-0.003 0.009-0.006 0.022-0.012 0.031-0.138 0.409-0.219 0.866-0.241 1.325l-8.978-2.691zM21.003 8.228l-8.978 5.716c0.037-0.347 0.122-0.684 0.247-0.981 0.094-0.025 0.181-0.066 0.266-0.119l8.566-5.45c-0.056 0.269-0.091 0.553-0.1 0.834zM13.15 3.091l7.469 2.241-8.769 5.578-7.469-2.241 8.769-5.578zM2.534 14.156c0 0 0 0 0 0s0 0 0 0zM2.487 14.103c-0.15-0.2-0.387-0.772-0.462-1.572l1.975 0.594v1.434l-1.512-0.456zM6.947 18.275c-0.072-0.144-0.209-0.244-0.366-0.269-0.159-0.025-0.319 0.025-0.434 0.141l-1.147 1.147v-5.872l3 0.9v6.059l-1.053-2.106zM9 16.056v-1.434l2.066 0.619c0.003 0.012 0.003 0.025 0.006 0.037 0.116 0.672 0.363 1.222 0.697 1.606l-2.769-0.828z" }),
_('path', { d: "M13.872 8.278c0.091 0 0.181-0.025 0.263-0.075l3.175-1.953c0.169-0.103 0.259-0.297 0.234-0.491s-0.162-0.356-0.353-0.416l-3.672-1.1c-0.144-0.044-0.297-0.019-0.422 0.063l-2.925 1.953c-0.159 0.106-0.244 0.294-0.219 0.484s0.159 0.347 0.341 0.406l3.425 1.103c0.050 0.016 0.103 0.025 0.153 0.025zM13.459 5.269l2.378 0.712-2.028 1.247-2.216-0.712 1.866-1.247z" })
            );
        }
        function BookBookmarked({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BookBookmarkedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BookBookmarked.SVG = BookBookmarkedSVG;
        return BookBookmarked;
    })();
export const BookBookmarked2 = /*#__PURE__*/ (() => {
        function BookBookmarked2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 0h-12c-0.553 0-1 0.447-1 1v18c0 0.553 0.447 1 1 1h1v3.5c0 0.172 0.091 0.334 0.237 0.425s0.331 0.1 0.488 0.022l1.775-0.888 1.775 0.888c0.072 0.034 0.147 0.053 0.225 0.053 0.091 0 0.181-0.025 0.262-0.075 0.147-0.091 0.237-0.253 0.237-0.425v-3.5h6c1.653 0 3-1.347 3-3v-14c0-1.653-1.347-3-3-3zM6 2h9v16h-9v-16zM10 22.691l-1.275-0.638c-0.141-0.072-0.306-0.072-0.447 0l-1.278 0.638v-2.691h3v2.691zM18 17c0 0.55-0.45 1-1 1h-1v-16h1c0.55 0 1 0.45 1 1v14z" }),
_('path', { d: "M13.5 4h-6c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h6c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5zM13 7h-5v-2h5v2z" })
            );
        }
        function BookBookmarked2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BookBookmarked2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BookBookmarked2.SVG = BookBookmarked2SVG;
        return BookBookmarked2;
    })();
export const Book = /*#__PURE__*/ (() => {
    function BookSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.5 4h-1.5v-1c0-0.306-0.141-0.597-0.381-0.784-0.241-0.191-0.556-0.259-0.853-0.188-0.975 0.234-2.053 0.334-3.094 0.428-1.338 0.122-2.603 0.237-3.728 0.622-0.794 0.272-1.437 0.653-1.944 1.153-0.503-0.5-1.147-0.881-1.944-1.153-1.125-0.384-2.391-0.5-3.728-0.622-1.041-0.094-2.119-0.194-3.094-0.428-0.297-0.072-0.612-0.003-0.853 0.188-0.241 0.188-0.381 0.478-0.381 0.784v1h-1.5c-0.275 0-0.5 0.225-0.5 0.5v14c0 0.247 0.181 0.456 0.425 0.494 0.753 0.113 1.669 0.191 2.634 0.272 2.931 0.244 6.941 0.581 6.941 2.234 0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5 0-1.653 4.009-1.991 6.941-2.234 0.969-0.081 1.881-0.156 2.634-0.272 0.244-0.038 0.425-0.247 0.425-0.494v-14c0-0.275-0.225-0.5-0.5-0.5zM17.853 4.447c0.706-0.066 1.428-0.131 2.147-0.237v10.975c-0.759 0.128-1.553 0.203-2.328 0.272-1.338 0.122-2.603 0.237-3.728 0.622-0.341 0.116-0.656 0.253-0.944 0.413v-10.272c0.675-1.322 2.306-1.537 4.853-1.772zM4 4.209c0.719 0.109 1.441 0.175 2.147 0.237 2.55 0.231 4.178 0.447 4.853 1.772v10.269c-0.288-0.159-0.6-0.294-0.944-0.413-1.125-0.384-2.391-0.5-3.728-0.622-0.775-0.072-1.569-0.144-2.328-0.272v-10.972zM23 18.063c-0.634 0.078-1.372 0.141-2.144 0.206-1.675 0.141-3.572 0.3-5.044 0.694-0.844 0.225-1.475 0.509-1.931 0.862-0.431 0.331-0.703 0.725-0.819 1.175h-2.122c-0.113-0.45-0.387-0.844-0.819-1.175-0.456-0.353-1.091-0.634-1.931-0.862-1.472-0.397-3.372-0.553-5.044-0.694-0.772-0.066-1.509-0.125-2.144-0.206v-13.062h1v11c0 0.462 0.316 0.863 0.766 0.972 1.119 0.269 2.269 0.375 3.381 0.475 2.653 0.241 4.309 0.466 4.931 1.941 0.156 0.372 0.519 0.612 0.922 0.612s0.766-0.241 0.922-0.612c0.622-1.475 2.278-1.697 4.931-1.941 1.113-0.1 2.262-0.206 3.381-0.475 0.45-0.109 0.766-0.509 0.766-0.972v-11h1v13.062z" })
        );
    }
    function Book({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BookSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Book.SVG = BookSVG;
    return Book;
})();
export const Book2 = /*#__PURE__*/ (() => {
    function Book2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.288 12.044l-1.059-0.319c-0.078-0.197-0.134-0.413-0.172-0.612-0.159-0.916 0-1.987 0.497-2.641l0.981-0.625c0.331-0.209 0.506-0.594 0.453-0.981s-0.328-0.709-0.703-0.822l-10-3c-0.278-0.084-0.578-0.041-0.825 0.116l-11 7c-0.078 0.050-0.147 0.109-0.209 0.178v0c-0.003 0.003-0.003 0.003-0.006 0.006s-0.003 0.006-0.006 0.006c-1.006 1.141-1.437 2.928-1.153 4.784 0.097 0.625 0.425 2.138 1.403 2.722 0.072 0.041 0.147 0.075 0.225 0.1l10 3c0.094 0.028 0.191 0.041 0.288 0.041 0.188 0 0.375-0.053 0.537-0.156l11-7c0.331-0.209 0.506-0.594 0.453-0.981-0.053-0.384-0.328-0.703-0.703-0.816zM21.075 11.281c0.1 0.566 0.288 1.044 0.547 1.413l-8.934 5.688c-0.334-0.237-0.541-0.788-0.625-1.269-0.125-0.712-0.056-1.519 0.216-2.147 0.091-0.025 0.181-0.066 0.262-0.119l8.566-5.45c-0.128 0.603-0.141 1.269-0.031 1.884zM13.15 5.091l7.469 2.241-8.769 5.578-7.469-2.241 8.769-5.578zM2.487 16.103c-0.159-0.213-0.419-0.85-0.475-1.737-0.053-0.844 0.087-1.612 0.394-2.197l8.853 2.656c-0.003 0.012-0.009 0.022-0.012 0.034-0.25 0.738-0.312 1.622-0.172 2.425 0.119 0.672 0.363 1.222 0.697 1.606l-9.284-2.787z" })
        );
    }
    function Book2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Book2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Book2.SVG = Book2SVG;
    return Book2;
})();
export const Book3 = /*#__PURE__*/ (() => {
        function Book3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.288 12.041l-1.056-0.316c-0.078-0.2-0.138-0.412-0.172-0.616-0.159-0.916 0-1.984 0.494-2.637l0.984-0.628c0.331-0.209 0.506-0.594 0.453-0.981s-0.328-0.709-0.703-0.822l-10-3c-0.278-0.084-0.578-0.041-0.825 0.116l-11 7c-0.081 0.053-0.153 0.116-0.216 0.184-1.012 1.141-1.447 2.931-1.162 4.794 0.097 0.625 0.425 2.138 1.403 2.722 0.072 0.041 0.147 0.075 0.225 0.1l10 3c0.094 0.028 0.191 0.041 0.288 0.041 0.188 0 0.375-0.053 0.537-0.156l11-7c0.331-0.209 0.506-0.594 0.453-0.981s-0.328-0.706-0.703-0.819zM21.075 11.281c0.1 0.566 0.288 1.047 0.547 1.413l-8.934 5.688c-0.334-0.237-0.541-0.788-0.625-1.272-0.125-0.712-0.056-1.516 0.213-2.147 0.094-0.025 0.181-0.066 0.266-0.119l8.566-5.45c-0.128 0.609-0.141 1.272-0.031 1.887zM13.15 5.091l7.469 2.241-8.769 5.578-7.469-2.241 8.769-5.578zM2.487 16.103c-0.159-0.213-0.419-0.85-0.475-1.737-0.053-0.844 0.087-1.612 0.394-2.2l8.853 2.656c-0.003 0.009-0.006 0.022-0.012 0.031-0.25 0.738-0.312 1.622-0.172 2.425 0.116 0.672 0.363 1.222 0.697 1.606l-9.284-2.781z" }),
_('path', { d: "M13.872 10.278c0.091 0 0.181-0.025 0.263-0.075l3.175-1.953c0.169-0.103 0.259-0.297 0.234-0.491s-0.162-0.356-0.353-0.416l-3.672-1.1c-0.144-0.044-0.297-0.019-0.422 0.063l-2.925 1.953c-0.159 0.106-0.244 0.294-0.219 0.484s0.159 0.347 0.341 0.406l3.425 1.103c0.050 0.016 0.103 0.025 0.153 0.025zM13.459 7.269l2.378 0.713-2.028 1.247-2.216-0.713 1.866-1.247z" })
            );
        }
        function Book3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Book3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Book3.SVG = Book3SVG;
        return Book3;
    })();
export const BookmarkMinus = /*#__PURE__*/ (() => {
        function BookmarkMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 6.5c0-3.584-2.916-6.5-6.5-6.5-1.841 0-3.503 0.769-4.684 2h-6.816c-1.103 0-2 0.897-2 2v19c0 0.403 0.244 0.769 0.619 0.925s0.803 0.069 1.091-0.216l6.291-6.294 6.294 6.294c0.191 0.191 0.447 0.294 0.706 0.294 0.128 0 0.259-0.025 0.381-0.075 0.375-0.156 0.619-0.519 0.619-0.925v-10.503c2.347-0.981 4-3.3 4-6zM17 20.584l-5.294-5.291c-0.391-0.391-1.025-0.391-1.416 0l-5.291 5.291v-16.584h5.5c-0.322 0.769-0.5 1.616-0.5 2.5 0 3.584 2.916 6.5 6.5 6.5 0.169 0 0.334-0.006 0.5-0.019v7.603zM16.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M14 6h5v1h-5v-1z" })
            );
        }
        function BookmarkMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BookmarkMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BookmarkMinus.SVG = BookmarkMinusSVG;
        return BookmarkMinus;
    })();
export const BookmarkMove = /*#__PURE__*/ (() => {
        function BookmarkMoveSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 6.5c0-3.584-2.916-6.5-6.5-6.5-1.841 0-3.503 0.769-4.688 2h-6.813c-1.103 0-2 0.897-2 2v19c0 0.403 0.244 0.769 0.619 0.925s0.803 0.069 1.091-0.216l6.291-6.294 6.294 6.294c0.191 0.191 0.447 0.294 0.706 0.294 0.128 0 0.259-0.025 0.381-0.075 0.375-0.156 0.619-0.519 0.619-0.925v-10.503c2.347-0.981 4-3.3 4-6zM17 20.584l-5.294-5.291c-0.391-0.391-1.025-0.391-1.416 0l-5.291 5.291v-16.584h5.5c-0.322 0.769-0.5 1.616-0.5 2.5 0 3.584 2.916 6.5 6.5 6.5 0.169 0 0.334-0.006 0.5-0.019v7.603zM16.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M20.853 6.147l-1.353-1.353-0.706 0.706 0.5 0.5h-5.588l0.5-0.5-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706-0.5-0.5h5.584l-0.5 0.5 0.706 0.706 1.353-1.353c0.2-0.194 0.2-0.513 0.003-0.706z" })
            );
        }
        function BookmarkMove({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BookmarkMoveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BookmarkMove.SVG = BookmarkMoveSVG;
        return BookmarkMove;
    })();
export const BookmarkPlus = /*#__PURE__*/ (() => {
        function BookmarkPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 6.5c0-3.584-2.916-6.5-6.5-6.5-1.841 0-3.503 0.769-4.684 2h-6.816c-1.103 0-2 0.897-2 2v19c0 0.403 0.244 0.769 0.619 0.925s0.803 0.069 1.091-0.216l6.291-6.294 6.294 6.294c0.191 0.191 0.447 0.294 0.706 0.294 0.128 0 0.259-0.025 0.381-0.075 0.375-0.156 0.619-0.519 0.619-0.925v-10.503c2.347-0.981 4-3.3 4-6zM17 20.584l-5.294-5.291c-0.391-0.391-1.025-0.391-1.416 0l-5.291 5.291v-16.584h5.5c-0.322 0.769-0.5 1.616-0.5 2.5 0 3.584 2.916 6.5 6.5 6.5 0.169 0 0.334-0.006 0.5-0.019v7.603zM16.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17 4h-1v2h-2v1h2v2h1v-2h2v-1h-2z" })
            );
        }
        function BookmarkPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BookmarkPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BookmarkPlus.SVG = BookmarkPlusSVG;
        return BookmarkPlus;
    })();
export const Bookmark = /*#__PURE__*/ (() => {
    function BookmarkSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18 1h-12c-1.103 0-2 0.897-2 2v19c0 0.403 0.244 0.769 0.619 0.925s0.803 0.069 1.091-0.216l6.291-6.294 6.294 6.294c0.191 0.191 0.447 0.294 0.706 0.294 0.128 0 0.259-0.025 0.381-0.075 0.375-0.156 0.619-0.519 0.619-0.925v-19.003c0-1.103-0.897-2-2-2zM18 19.584l-5.294-5.291c-0.194-0.194-0.45-0.294-0.706-0.294s-0.513 0.097-0.706 0.294l-5.294 5.291v-16.584h12v16.584z" })
        );
    }
    function Bookmark({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BookmarkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bookmark.SVG = BookmarkSVG;
    return Bookmark;
})();
export const Books = /*#__PURE__*/ (() => {
        function BooksSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.5 18h-2.856l1.256-0.628c0.987-0.494 1.387-1.697 0.894-2.681l-5.797-11.587c-0.237-0.478-0.65-0.834-1.156-1.003s-1.050-0.131-1.525 0.109l-2.212 1.106c-0.987 0.494-1.388 1.697-0.894 2.681v0.003h-4.209v-3c0-0.553-0.447-1-1-1h-4c-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1h-1.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h23c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5zM18.791 16.691l-4.016-8.034 2.212-1.106 4.016 8.034-2.213 1.106zM15.209 3.997l1.328 2.659-2.213 1.106-1.328-2.659 2.212-1.106zM17.003 17.584c0.075 0.153 0.169 0.291 0.278 0.416h-5.281c0.553 0 1-0.447 1-1v-7.419l4.003 8.003zM5 16h-2v-1h2v1zM5 14h-2v-8h2v8zM11 8v8h-4v-8h4zM5 4v1h-2v-1h2zM23 21h-22v-2h22v2z" }),
_('path', { d: "M8 9h2v1h-2v-1z" })
            );
        }
        function Books({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BooksSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Books.SVG = BooksSVG;
        return Books;
    })();
export const BorderColor = /*#__PURE__*/ (() => {
        function BorderColorSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4.5 17c0.031 0 0.066-0.003 0.097-0.009l2.5-0.5c0.097-0.019 0.184-0.066 0.256-0.138l10.084-10.084c0.363-0.363 0.563-0.844 0.563-1.353s-0.2-0.991-0.563-1.353c-0.747-0.747-1.959-0.747-2.706 0l-10.084 10.084c-0.069 0.069-0.119 0.159-0.138 0.256l-0.5 2.5c-0.031 0.162 0.019 0.334 0.138 0.453 0.094 0.091 0.222 0.144 0.353 0.144zM16.731 4.269c0.172 0.172 0.269 0.403 0.269 0.647s-0.097 0.472-0.269 0.647l-0.231 0.231-1.294-1.294 0.231-0.231c0.356-0.356 0.938-0.356 1.294 0zM5.459 14.247l9.041-9.041 1.294 1.294-9.041 9.041-1.616 0.322 0.322-1.616z" }),
_('path', { d: "M2 19h20v2h-20v-2z" })
            );
        }
        function BorderColor({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BorderColorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BorderColor.SVG = BorderColorSVG;
        return BorderColor;
    })();
export const Bottle = /*#__PURE__*/ (() => {
    function BottleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18 11v-3.031c0-0.594-0.263-1.156-0.719-1.538l-2.641-2.2c-0.181-0.15-0.406-0.231-0.641-0.231v-1h0.5c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.828-0.672-1.5-1.5-1.5h-3c-0.828 0-1.5 0.672-1.5 1.5v1c0 0.275 0.225 0.5 0.5 0.5h0.5v1c-0.234 0-0.459 0.081-0.641 0.231l-2.641 2.2c-0.456 0.381-0.719 0.941-0.719 1.538v3.031c0 0.597 0.263 1.134 0.678 1.5-0.416 0.366-0.678 0.903-0.678 1.5s0.262 1.134 0.678 1.5c-0.416 0.366-0.678 0.903-0.678 1.5s0.262 1.134 0.678 1.5c-0.416 0.366-0.678 0.903-0.678 1.5v2c0 1.103 0.897 2 2 2h8c1.103 0 2-0.897 2-2v-2c0-0.597-0.263-1.134-0.678-1.5 0.416-0.366 0.678-0.903 0.678-1.5s-0.263-1.134-0.678-1.5c0.416-0.366 0.678-0.903 0.678-1.5s-0.263-1.134-0.678-1.5c0.416-0.366 0.678-0.903 0.678-1.5zM16 12h-8v-2h8v2zM16 15h-8v-1c0 0 0 0 0.003 0v-1h8v2zM16 18h-8v-1c0 0 0 0 0.003 0v-1h8v2zM10 1.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v0.5h-4v-0.5zM11 3h2v1h-2v-1zM10.362 6h3.275l2.362 1.969v1.031h-8v-1.031l2.363-1.969zM16 22h-8l-0.003-2c0 0 0 0 0.003 0v-1h8v3z" })
        );
    }
    function Bottle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BottleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bottle.SVG = BottleSVG;
    return Bottle;
})();
export const Bottle2 = /*#__PURE__*/ (() => {
    function Bottle2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17.428 8.5c-0.4-1.025-0.978-1.481-1.4-1.816-0.319-0.25-0.509-0.4-0.672-0.791-0.234-0.563-0.356-1.537-0.356-2.894v-1h1v-2h-8v2h1v1c0 1.356-0.122 2.331-0.356 2.897-0.162 0.387-0.353 0.541-0.672 0.791-0.422 0.334-1 0.791-1.4 1.816-0.391 1-0.572 2.431-0.572 4.5v9c0 1.103 0.897 2 2 2h8c1.103 0 2-0.897 2-2v-9.003c0-2.069-0.181-3.5-0.572-4.5zM16 19h-8v-6h8v6zM8.434 9.225c0.2-0.519 0.428-0.697 0.775-0.969 0.406-0.322 0.916-0.722 1.278-1.587 0.35-0.834 0.513-2 0.513-3.669v-1h2v1c0 1.669 0.162 2.834 0.513 3.669 0.363 0.866 0.869 1.266 1.278 1.587 0.344 0.272 0.572 0.453 0.775 0.969 0.231 0.594 0.372 1.525 0.419 2.775h-7.966c0.047-1.25 0.184-2.181 0.416-2.775zM8 22.003c0 0 0-0.003 0 0v-2.003h8v2l-8 0.003z" })
        );
    }
    function Bottle2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bottle2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bottle2.SVG = Bottle2SVG;
    return Bottle2;
})();
export const BowTie = /*#__PURE__*/ (() => {
        function BowTieSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.169 11.722l2-0.997-0.447-0.894-2 0.997c-0.444 0.222-0.722 0.672-0.722 1.172s0.278 0.95 0.725 1.172l2 0.997 0.447-0.894-2-0.997c-0.106-0.053-0.172-0.159-0.172-0.278s0.066-0.225 0.169-0.278z" }),
_('path', { d: "M6.275 10.828l-2-0.997-0.447 0.894 2 0.997c0.106 0.053 0.172 0.159 0.172 0.278s-0.066 0.225-0.169 0.278l-2 0.997 0.447 0.894 2-1c0.444-0.219 0.722-0.669 0.722-1.169s-0.278-0.95-0.725-1.172z" }),
_('path', { d: "M23.431 8.222c-0.7-1.934-1.85-2.222-2.472-2.222-1.203 0-2.528 0.731-4.062 1.575-0.8 0.441-1.625 0.894-2.456 1.256-0.675-0.522-1.522-0.831-2.441-0.831s-1.766 0.309-2.441 0.831c-0.834-0.363-1.656-0.816-2.456-1.256-1.534-0.844-2.859-1.575-4.062-1.575-0.622 0-1.769 0.288-2.472 2.222-0.366 1.012-0.569 2.356-0.569 3.778s0.203 2.766 0.569 3.778c0.703 1.934 1.85 2.222 2.472 2.222 1.203 0 2.528-0.731 4.062-1.575 0.8-0.441 1.625-0.894 2.456-1.256 0.675 0.522 1.522 0.831 2.441 0.831s1.766-0.309 2.441-0.831c0.834 0.363 1.656 0.816 2.456 1.256 1.534 0.844 2.859 1.575 4.062 1.575 0.622 0 1.769-0.288 2.472-2.222 0.366-1.013 0.569-2.356 0.569-3.778s-0.203-2.766-0.569-3.778zM6.138 14.672c-1.184 0.653-2.409 1.328-3.097 1.328-0.081 0-0.344-0.228-0.591-0.903-0.284-0.791-0.45-1.919-0.45-3.097s0.166-2.306 0.45-3.097c0.244-0.675 0.509-0.903 0.591-0.903 0.687 0 1.912 0.675 3.097 1.328 0.672 0.372 1.406 0.775 2.172 1.134-0.197 0.475-0.309 0.994-0.309 1.541 0 0.544 0.109 1.066 0.309 1.541-0.766 0.353-1.5 0.759-2.172 1.128zM12 14c-1.103 0-2-0.897-2-2s0.897-2 2-2c1.103 0 2 0.897 2 2s-0.897 2-2 2zM21.55 15.097c-0.244 0.675-0.509 0.903-0.591 0.903-0.687 0-1.913-0.675-3.097-1.328-0.672-0.372-1.406-0.775-2.172-1.134 0.197-0.475 0.309-0.994 0.309-1.541 0-0.544-0.109-1.066-0.309-1.541 0.762-0.359 1.497-0.762 2.172-1.134 1.184-0.653 2.409-1.328 3.097-1.328 0.081 0 0.344 0.228 0.591 0.903 0.288 0.788 0.45 1.919 0.45 3.097 0 1.184-0.166 2.313-0.45 3.103z" })
            );
        }
        function BowTie({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BowTieSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BowTie.SVG = BowTieSVG;
        return BowTie;
    })();
export const BowlerHat = /*#__PURE__*/ (() => {
        function BowlerHatSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.884 14.109c-0.391-0.919-1.538-1.034-1.913-1.072-0.606-0.059-1.3-0.041-1.972-0.019v-1.019c0-2.166-0.181-4.378-1.491-5.906-0.637-0.744-1.484-1.272-2.587-1.612-1.044-0.325-2.325-0.481-3.922-0.481s-2.878 0.156-3.922 0.481c-1.103 0.341-1.95 0.869-2.587 1.612-1.309 1.528-1.491 3.741-1.491 5.906v1.022c-0.675-0.022-1.369-0.041-1.972 0.019-0.375 0.038-1.519 0.15-1.912 1.072-0.478 1.119 0.641 2.216 1.062 2.628 1.234 1.209 3.162 2.112 5.734 2.681 1.938 0.425 3.9 0.578 5.088 0.578s3.15-0.153 5.088-0.581c2.572-0.569 4.5-1.472 5.734-2.681 0.422-0.413 1.541-1.509 1.062-2.628zM7.009 7.397c0.816-0.953 2.403-1.397 4.991-1.397s4.175 0.444 4.991 1.397c0.716 0.834 1.009 2.169 1.009 4.603v2.25c-3.984 0.994-8.016 0.994-12 0v-2.25c0-2.434 0.294-3.769 1.009-4.603zM2.303 15.022c0.066-0.006 0.138-0.009 0.219-0.012 0.438-0.019 0.953-0.003 1.453 0.012 0.009 0 0.019 0 0.025 0v1.291c-0.544-0.288-1.028-0.619-1.422-1.003-0.112-0.109-0.203-0.203-0.275-0.288zM12 18c-1.172 0-3.716-0.191-6-0.888v-1.834c1.997 0.478 4.009 0.722 6 0.722s4.003-0.241 6-0.722v1.834c-2.284 0.697-4.828 0.888-6 0.888zM21.422 15.309c-0.394 0.384-0.878 0.716-1.422 1.003v-1.291c0.009 0 0.019 0 0.025 0 0.5-0.016 1.016-0.031 1.453-0.012 0.081 0.003 0.153 0.009 0.219 0.012-0.072 0.084-0.162 0.178-0.275 0.288z" }),
_('path', { d: "M15.475 8.7c0.131 0.153 0.312 0.513 0.425 1.344 0.091 0.681 0.103 1.444 0.103 1.956h1c0-1.425-0.087-3.159-0.769-3.953-0.606-0.703-1.991-1.047-4.234-1.047v1c2.666 0 3.334 0.534 3.475 0.7z" })
            );
        }
        function BowlerHat({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BowlerHatSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BowlerHat.SVG = BowlerHatSVG;
        return BowlerHat;
    })();
export const BowlingBall = /*#__PURE__*/ (() => {
        function BowlingBallSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M11.5 9c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5zM11.5 11c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M14.5 12c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM14.5 14c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M9 14c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM9 17c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M12 3v1c4.413 0 8 3.588 8 8h1c0-2.403-0.938-4.666-2.637-6.363-1.697-1.7-3.959-2.637-6.363-2.637z" })
            );
        }
        function BowlingBall({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BowlingBallSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BowlingBall.SVG = BowlingBallSVG;
        return BowlingBall;
    })();
export const BoxCheck = /*#__PURE__*/ (() => {
        function BoxCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 12.813v-6.2c0-0.753-0.416-1.434-1.087-1.781l-9-4.613c-0.572-0.291-1.253-0.291-1.825 0l-9 4.613c-0.669 0.344-1.087 1.028-1.087 1.781v8.778c0 0.753 0.416 1.434 1.087 1.781l9 4.613c0.284 0.147 0.597 0.219 0.909 0.219s0.628-0.072 0.912-0.219l0.491-0.253c1.191 1.503 3.034 2.469 5.097 2.469 3.584 0 6.5-2.916 6.5-6.5 0.003-1.841-0.766-3.503-1.997-4.687zM11 10l-3.353-1.719 7.806-4 3.353 1.719-7.806 4zM12 11.738l8-4.1v3.863c-0.769-0.322-1.616-0.5-2.5-0.5-2.313 0-4.347 1.216-5.5 3.041v-2.303zM11 2l3.356 1.719-7.806 4-3.356-1.719 7.806-4zM2 7.638l8 4.1v7.756l-8-4.103v-7.753zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16.5 18.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4z" })
            );
        }
        function BoxCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BoxCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BoxCheck.SVG = BoxCheckSVG;
        return BoxCheck;
    })();
export const BoxCheck2 = /*#__PURE__*/ (() => {
        function BoxCheck2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8.728 12.209l-5-2.562c-0.156-0.078-0.341-0.072-0.487 0.019-0.15 0.091-0.241 0.253-0.241 0.428v4.381c0 0.188 0.106 0.359 0.272 0.444l5 2.562c0.072 0.038 0.15 0.056 0.228 0.056 0.091 0 0.181-0.025 0.259-0.072 0.15-0.091 0.241-0.253 0.241-0.428v-4.384c0-0.188-0.106-0.359-0.272-0.444zM8 16.216l-4-2.050v-3.256l4 2.050v3.256z" }),
_('path', { d: "M22 12.813v-6.2c0-0.753-0.416-1.434-1.087-1.781l-9-4.613c-0.572-0.291-1.253-0.291-1.825 0l-9 4.613c-0.669 0.344-1.087 1.028-1.087 1.781v8.778c0 0.753 0.416 1.434 1.087 1.781l9 4.613c0.284 0.147 0.597 0.219 0.909 0.219s0.628-0.072 0.912-0.219l0.494-0.253c1.191 1.503 3.034 2.469 5.097 2.469 3.584 0 6.5-2.916 6.5-6.5 0-1.841-0.769-3.503-2-4.687zM11 10l-2.806-1.437 7.806-4 2.806 1.437-7.806 4zM12 11.738l8-4.1v3.863c-0.769-0.322-1.616-0.5-2.5-0.5-2.313 0-4.347 1.216-5.5 3.041v-2.303zM11 2l2.809 1.441-7.806 4-2.809-1.441 7.806-4zM2 7.638l8 4.1v7.756l-8-4.103v-7.753zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16.5 18.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4z" })
            );
        }
        function BoxCheck2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BoxCheck2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BoxCheck2.SVG = BoxCheck2SVG;
        return BoxCheck2;
    })();
export const BoxCross = /*#__PURE__*/ (() => {
        function BoxCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 12.813v-6.2c0-0.753-0.416-1.434-1.087-1.781l-9-4.613c-0.572-0.291-1.253-0.291-1.825 0l-9 4.613c-0.669 0.344-1.087 1.028-1.087 1.781v8.778c0 0.753 0.416 1.434 1.087 1.781l9 4.613c0.284 0.147 0.597 0.219 0.909 0.219s0.628-0.072 0.912-0.219l0.491-0.253c1.191 1.503 3.034 2.469 5.097 2.469 3.584 0 6.5-2.916 6.5-6.5 0.003-1.841-0.766-3.503-1.997-4.687zM11 10l-3.353-1.719 7.806-4 3.353 1.719-7.806 4zM12 11.738l8-4.1v3.863c-0.769-0.322-1.616-0.5-2.5-0.5-2.313 0-4.347 1.216-5.5 3.041v-2.303zM11 2l3.356 1.719-7.806 4-3.356-1.719 7.806-4zM2 7.638l8 4.1v7.756l-8-4.103v-7.753zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 14.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function BoxCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BoxCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BoxCross.SVG = BoxCrossSVG;
        return BoxCross;
    })();
export const BoxCross2 = /*#__PURE__*/ (() => {
        function BoxCross2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8.728 12.209l-5-2.562c-0.156-0.078-0.341-0.072-0.487 0.019-0.15 0.091-0.241 0.253-0.241 0.428v4.381c0 0.188 0.106 0.359 0.272 0.444l5 2.562c0.072 0.038 0.15 0.056 0.228 0.056 0.091 0 0.181-0.025 0.259-0.072 0.15-0.091 0.241-0.253 0.241-0.428v-4.384c0-0.188-0.106-0.359-0.272-0.444zM8 16.216l-4-2.050v-3.256l4 2.050v3.256z" }),
_('path', { d: "M22 12.813v-6.2c0-0.753-0.416-1.434-1.087-1.781l-9-4.613c-0.572-0.291-1.253-0.291-1.825 0l-9 4.613c-0.669 0.344-1.087 1.028-1.087 1.781v8.778c0 0.753 0.416 1.434 1.087 1.781l9 4.613c0.284 0.147 0.597 0.219 0.909 0.219s0.628-0.072 0.912-0.219l0.491-0.253c1.191 1.503 3.034 2.469 5.097 2.469 3.584 0 6.5-2.916 6.5-6.5 0.003-1.841-0.766-3.503-1.997-4.687zM11 10l-2.806-1.437 7.806-4 2.806 1.437-7.806 4zM12 11.738l8-4.1v3.863c-0.769-0.322-1.616-0.5-2.5-0.5-2.313 0-4.347 1.216-5.5 3.041v-2.303zM11 2l2.809 1.441-7.806 4-2.809-1.441 7.806-4zM2 7.638l8 4.1v7.756l-8-4.103v-7.753zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 14.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function BoxCross2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BoxCross2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BoxCross2.SVG = BoxCross2SVG;
        return BoxCross2;
    })();
export const Box = /*#__PURE__*/ (() => {
        function BoxSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.559 5.75v0l-3.669-4.563c-0.094-0.119-0.237-0.188-0.391-0.188h-13c-0.15 0-0.294 0.069-0.391 0.188l-3.669 4.563c-0.275 0.344-0.441 0.778-0.441 1.25v3.5c0 0.275 0.225 0.5 0.5 0.5h1.5v10c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-10h1.5c0.275 0 0.5-0.225 0.5-0.5v-3.5c0-0.472-0.166-0.909-0.441-1.25zM5.741 2h12.522l2.412 3h-17.35l2.416-3zM19 21h-14v-10h14v10zM3 10v-3h18v3h-18z" }),
_('path', { d: "M9.5 15h5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5zM9.5 13h5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-5c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5z" })
            );
        }
        function Box({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BoxSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Box.SVG = BoxSVG;
        return Box;
    })();
export const Box2 = /*#__PURE__*/ (() => {
    function Box2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.912 5.831c0 0 0 0 0 0l-9-4.613c-0.572-0.291-1.253-0.291-1.825 0l-9 4.613c-0.669 0.344-1.087 1.028-1.087 1.781v8.778c0 0.753 0.416 1.434 1.087 1.781l9 4.613c0.284 0.147 0.597 0.219 0.909 0.219s0.628-0.072 0.912-0.219l9-4.613c0.669-0.344 1.087-1.028 1.087-1.781v-8.778c0.003-0.753-0.413-1.434-1.084-1.781zM12 11l-3.353-1.719 7.806-4 3.353 1.719-7.806 4zM12 3l3.356 1.719-7.806 4-3.356-1.719 7.806-4zM3 8.637l8 4.1v7.756l-8-4.103v-7.753zM13 20.491v-7.753l8-4.1v7.756l-8 4.097z" })
        );
    }
    function Box2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Box2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Box2.SVG = Box2SVG;
    return Box2;
})();
export const Box3 = /*#__PURE__*/ (() => {
        function Box3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.912 5.831c0 0 0 0 0 0l-9-4.613c-0.572-0.291-1.253-0.291-1.825 0l-9 4.613c-0.669 0.344-1.087 1.028-1.087 1.781v8.778c0 0.753 0.416 1.434 1.087 1.781l9 4.613c0.284 0.147 0.597 0.219 0.909 0.219s0.628-0.072 0.912-0.219l9-4.613c0.669-0.344 1.087-1.028 1.087-1.781v-8.778c0.003-0.753-0.413-1.434-1.084-1.781zM12 11l-2.806-1.437 7.806-4 2.806 1.437-7.806 4zM12 3l2.809 1.441-7.806 4-2.809-1.441 7.806-4zM3 8.637l8 4.1v7.756l-8-4.103v-7.753zM13 20.491v-7.753l8-4.1v7.756l-8 4.097z" }),
_('path', { d: "M19.759 10.662c-0.15-0.091-0.334-0.097-0.487-0.019l-5 2.562c-0.166 0.084-0.272 0.256-0.272 0.444v4.381c0 0.175 0.091 0.334 0.241 0.428 0.081 0.050 0.169 0.072 0.259 0.072 0.078 0 0.156-0.019 0.228-0.056l5-2.562c0.166-0.084 0.272-0.256 0.272-0.444v-4.378c0-0.175-0.091-0.334-0.241-0.428zM19 15.166l-4 2.050v-3.256l4-2.050v3.256z" }),
_('path', { d: "M9.728 13.209l-5-2.562c-0.156-0.078-0.341-0.072-0.487 0.019-0.15 0.091-0.241 0.253-0.241 0.428v4.381c0 0.188 0.106 0.359 0.272 0.444l5 2.562c0.072 0.038 0.15 0.056 0.228 0.056 0.091 0 0.181-0.025 0.259-0.072 0.15-0.091 0.241-0.253 0.241-0.428v-4.384c0-0.188-0.106-0.359-0.272-0.444zM9 17.216l-4-2.050v-3.256l4 2.050v3.256z" })
            );
        }
        function Box3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Box3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Box3.SVG = Box3SVG;
        return Box3;
    })();
export const Bra = /*#__PURE__*/ (() => {
    function BraSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.587 9.184c-1.3-2.872-0.197-5.163 1.225-6.294l0.391-0.312-0.622-0.781-0.391 0.312c-1.628 1.297-2.925 3.837-1.716 7.006-0.987 0.284-2.694 0.797-4.234 1.728-0.944 0.572-1.691 1.228-2.225 1.95-0.5 0.678-0.819 1.416-0.947 2.203-0.044 0-0.091 0-0.134 0-0.131-0.787-0.447-1.525-0.947-2.203-0.534-0.722-1.281-1.378-2.225-1.95-1.537-0.934-3.247-1.444-4.234-1.728 1.209-3.169-0.087-5.709-1.716-7.006l-0.391-0.312-0.622 0.781 0.391 0.312c1.419 1.131 2.522 3.419 1.225 6.294-0.147 0.103-0.266 0.247-0.341 0.422-0.903 2.109-1.237 3.959-0.994 5.494 0.231 1.462 0.975 2.594 2.15 3.269 0.722 0.416 1.584 0.628 2.491 0.628 0.5 0 1.016-0.066 1.525-0.197 0.713-0.184 1.381-0.484 1.981-0.884 0.116 0.222 0.269 0.419 0.453 0.581-0.325 0.856-0.678 2.306-0.678 3.5h1c0-1.022 0.3-2.284 0.575-3.047 0.138 0.031 0.281 0.047 0.425 0.047 0.247 0 0.481-0.044 0.7-0.125 0.188 0.491 0.3 1.384 0.3 2.125h1c0-0.025 0-0.581-0.081-1.225-0.081-0.638-0.209-1.131-0.387-1.488 0.097-0.112 0.178-0.237 0.247-0.372 0.6 0.397 1.269 0.7 1.981 0.884 0.509 0.131 1.025 0.197 1.525 0.197 0.906 0 1.769-0.213 2.491-0.628 1.175-0.675 1.919-1.806 2.15-3.269 0.244-1.538-0.091-3.384-0.994-5.494-0.081-0.172-0.2-0.316-0.347-0.419zM7.741 16.866c-0.928 0.241-1.847 0.156-2.516-0.228-0.641-0.369-1.034-0.991-1.172-1.847-0.15-0.956 0.031-2.178 0.531-3.569 2.4 0.753 5.156 1.994 5.4 4.275-0.581 0.659-1.366 1.141-2.244 1.369zM12 18c-0.456 0-0.841-0.306-0.963-0.725 0.059-0.056 0.119-0.112 0.175-0.169 0.438-0.15 1.163-0.147 1.581 0.016v-0.003c0.053 0.053 0.109 0.106 0.162 0.156-0.116 0.419-0.5 0.725-0.956 0.725zM19.947 14.787c-0.134 0.859-0.531 1.481-1.172 1.847-0.672 0.384-1.587 0.469-2.516 0.228-0.878-0.228-1.666-0.709-2.244-1.369 0.244-2.281 3-3.522 5.4-4.275 0.5 1.391 0.684 2.613 0.531 3.569z" })
        );
    }
    function Bra({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BraSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bra.SVG = BraSVG;
    return Bra;
})();
export const Branches = /*#__PURE__*/ (() => {
    function BranchesSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 10c-0.738 0-1.384 0.403-1.731 1h-9.841c0.103-0.366 0.172-0.753 0.244-1.153 0.134-0.753 0.272-1.531 0.653-2.050 0.253-0.341 0.75-0.797 2.175-0.797h2.769c0.347 0.597 0.994 1 1.731 1 1.103 0 2-0.897 2-2s-0.897-2-2-2c-0.738 0-1.384 0.403-1.731 1h-2.769c-1.725 0-3 0.541-3.788 1.609-0.659 0.897-0.847 1.953-1.012 2.887-0.094 0.534-0.184 1.041-0.341 1.322-0.063 0.116-0.1 0.178-0.363 0.178h-4.266c-0.347-0.597-0.994-1-1.731-1-1.103 0-2 0.897-2 2s0.897 2 2 2c0.738 0 1.384-0.403 1.731-1h0.269c0.263 0 0.3 0.063 0.363 0.178 0.156 0.281 0.244 0.788 0.341 1.322 0.166 0.934 0.353 1.991 1.013 2.888 0.75 1.019 1.947 1.559 3.553 1.606 0.347 0.6 0.994 1.003 1.734 1.003 1.103 0 2-0.897 2-2s-0.897-2-2-2c-0.738 0-1.381 0.4-1.728 0.997-1.25-0.047-1.709-0.469-1.947-0.791-0.381-0.519-0.519-1.297-0.653-2.050-0.072-0.4-0.141-0.788-0.244-1.153h6.569c0.263 0 0.3 0.063 0.363 0.178 0.156 0.281 0.244 0.788 0.341 1.322 0.166 0.934 0.353 1.991 1.013 2.888 0.75 1.019 1.947 1.559 3.553 1.606 0.347 0.6 0.994 1.003 1.734 1.003 1.103 0 2-0.897 2-2s-0.897-2-2-2c-0.738 0-1.381 0.4-1.728 0.997-1.25-0.047-1.709-0.469-1.947-0.791-0.381-0.519-0.519-1.297-0.653-2.050-0.072-0.4-0.141-0.787-0.244-1.153h4.841c0.347 0.597 0.994 1 1.731 1 1.103 0 2-0.897 2-2-0.003-1.1-0.9-1.997-2.003-1.997zM18 5c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM2 13c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1c0 0.55-0.45 1-1 1zM11 17c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM20 17c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM22 13c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1c0 0.55-0.45 1-1 1z" })
        );
    }
    function Branches({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BranchesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Branches.SVG = BranchesSVG;
    return Branches;
})();
export const Branches2 = /*#__PURE__*/ (() => {
    function Branches2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 16.172v-3.172c0-1.103-0.897-2-2-2h-7v-3.172c1.162-0.413 2-1.525 2-2.828 0-1.653-1.347-3-3-3s-3 1.347-3 3c0 1.303 0.837 2.416 2 2.828v3.172h-7c-1.103 0-2 0.897-2 2v3.172c-1.163 0.413-2 1.525-2 2.828 0 1.653 1.347 3 3 3s3-1.347 3-3c0-1.303-0.837-2.416-2-2.828v-3.172h7v3.172c-1.162 0.413-2 1.525-2 2.828 0 1.653 1.347 3 3 3s3-1.347 3-3c0-1.303-0.837-2.416-2-2.828v-3.172h7v3.172c-1.163 0.413-2 1.525-2 2.828 0 1.653 1.347 3 3 3s3-1.347 3-3c0-1.303-0.837-2.416-2-2.828zM10 5c0-1.103 0.897-2 2-2s2 0.897 2 2-0.897 2-2 2c-1.103 0-2-0.897-2-2zM5 19c0 1.103-0.897 2-2 2s-2-0.897-2-2 0.897-2 2-2 2 0.897 2 2zM14 19c0 1.103-0.897 2-2 2s-2-0.897-2-2 0.897-2 2-2c1.103 0 2 0.897 2 2zM21 21c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2z" })
        );
    }
    function Branches2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Branches2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Branches2.SVG = Branches2SVG;
    return Branches2;
})();
export const Bricks = /*#__PURE__*/ (() => {
    function BricksSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 4h-4v-2h4v2zM10 4v-2h7v2h-7zM14 5v4h-8v-4h8zM10 14v-4h7v4h-7zM5 9h-3v-4h3v4zM9 10v4h-7v-4h7zM5 15v4h-3v-4h3zM6 15h8v4h-8v-4zM17 20v2h-7v-2h7zM15 19v-4h7v4h-7zM18 14v-4h4v4h-4zM15 9v-4h7v4h-7zM9 2v2h-7v-2h7zM2 20h7v2h-7v-2zM22 22h-4v-2h4.003l-0.003 2c0.003 0 0 0 0 0z" })
        );
    }
    function Bricks({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BricksSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bricks.SVG = BricksSVG;
    return Bricks;
})();
export const BriefcaseMoney = /*#__PURE__*/ (() => {
        function BriefcaseMoneySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 5h-5v-1.5c0-0.316-0.147-0.612-0.4-0.8-1.503-1.128-3.050-1.7-4.6-1.7s-3.097 0.572-4.6 1.7c-0.253 0.188-0.4 0.484-0.4 0.8v1.5h-5c-1.103 0-2 0.897-2 2v12c0 1.103 0.897 2 2 2h10.812c1.184 1.231 2.847 2 4.688 2 3.584 0 6.5-2.916 6.5-6.5v-9.5c0-1.103-0.897-2-2-2zM9 4.016c2.037-1.362 3.963-1.362 6 0v0.984h-6v-0.984zM22 7v4.812c-1.169-1.122-2.756-1.812-4.5-1.812-3.416 0-6.225 2.65-6.481 6h-3.019v-1c0-0.553-0.447-1-1-1h-2c-0.553 0-1 0.447-1 1v1h-2v-9h20zM5 16h2v1h-2v-1zM2 17h2v0.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-0.5h3.019c0.053 0.703 0.219 1.375 0.481 2h-9.5v-2zM17.5 22c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18 12h-1v2h-0.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h2c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-3.5v1h2v2h1v-2h0.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-2c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3.5v-1h-2v-2z" })
            );
        }
        function BriefcaseMoney({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BriefcaseMoneySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BriefcaseMoney.SVG = BriefcaseMoneySVG;
        return BriefcaseMoney;
    })();
export const BriefcaseQuestion = /*#__PURE__*/ (() => {
        function BriefcaseQuestionSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 5h-5v-1.5c0-0.316-0.147-0.612-0.4-0.8-1.503-1.128-3.050-1.7-4.6-1.7s-3.097 0.572-4.6 1.7c-0.253 0.188-0.4 0.484-0.4 0.8v1.5h-5c-1.103 0-2 0.897-2 2v12c0 1.103 0.897 2 2 2h10.812c1.184 1.231 2.847 2 4.688 2 3.584 0 6.5-2.916 6.5-6.5v-9.5c0-1.103-0.897-2-2-2zM9 4.016c2.037-1.362 3.963-1.362 6 0v0.984h-6v-0.984zM22 7v4.812c-1.169-1.122-2.756-1.812-4.5-1.812-3.416 0-6.225 2.65-6.481 6h-3.019v-1c0-0.553-0.447-1-1-1h-2c-0.553 0-1 0.447-1 1v1h-2v-9h20zM5 16h2v1h-2v-1zM2 17h2v0.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-0.5h3.019c0.053 0.703 0.219 1.375 0.481 2h-9.5v-2zM17.5 22c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17 20h1v1h-1v-1z" }),
_('path', { d: "M17.503 13.006c-0.65 0-1.256 0.216-1.706 0.606-0.363 0.316-0.797 0.9-0.797 1.887v0.5h1v-0.5c0-1.103 0.809-1.494 1.503-1.494 0.4 0 0.788 0.125 1.062 0.344 0.288 0.228 0.434 0.531 0.434 0.903 0 0.713-0.434 1.084-0.941 1.519-0.497 0.422-1.059 0.903-1.059 1.728v0.5h1v-0.5c0-0.347 0.256-0.584 0.709-0.972 0.575-0.491 1.291-1.103 1.291-2.278 0-1.459-1.287-2.244-2.497-2.244z" })
            );
        }
        function BriefcaseQuestion({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BriefcaseQuestionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BriefcaseQuestion.SVG = BriefcaseQuestionSVG;
        return BriefcaseQuestion;
    })();
export const Briefcase = /*#__PURE__*/ (() => {
    function BriefcaseSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 6h-5v-1.5c0-0.316-0.147-0.612-0.4-0.8-1.503-1.128-3.050-1.7-4.6-1.7s-3.097 0.572-4.6 1.7c-0.253 0.188-0.4 0.484-0.4 0.8v1.5h-5c-1.103 0-2 0.897-2 2v12c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-12c0-1.103-0.897-2-2-2zM9 5.016c2.037-1.362 3.963-1.362 6 0v0.984h-6v-0.984zM22 8v9h-2v-1c0-0.553-0.447-1-1-1h-2c-0.553 0-1 0.447-1 1v1h-8v-1c0-0.553-0.447-1-1-1h-2c-0.553 0-1 0.447-1 1v1h-2v-9h20zM17 17h2v1h-2v-1zM5 17h2v1h-2v-1zM22 20h-20v-2h2v0.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-0.5h8v0.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-0.5h2v2c0.003 0 0 0 0 0z" })
        );
    }
    function Briefcase({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BriefcaseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Briefcase.SVG = BriefcaseSVG;
    return Briefcase;
})();
export const BrightnessAuto = /*#__PURE__*/ (() => {
        function BrightnessAutoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.656 6.344c-1.512-1.512-3.519-2.344-5.656-2.344s-4.147 0.831-5.656 2.344c-1.512 1.512-2.344 3.519-2.344 5.656s0.831 4.147 2.344 5.656c1.512 1.512 3.519 2.344 5.656 2.344s4.147-0.831 5.656-2.344c1.512-1.512 2.344-3.519 2.344-5.656s-0.831-4.147-2.344-5.656zM12 18c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z" }),
_('path', { d: "M0 11h3v2h-3v-2z" }),
_('path', { d: "M21 11h3v2h-3v-2z" }),
_('path', { d: "M18.042 4.544l2.499-2.499 1.414 1.414-2.499 2.499-1.414-1.414z" }),
_('path', { d: "M2.042 3.456l1.414-1.414 2.499 2.499-1.414 1.414-2.499-2.499z" }),
_('path', { d: "M2.042 20.543l2.499-2.499 1.414 1.414-2.499 2.499-1.414-1.414z" }),
_('path', { d: "M18.042 19.456l1.414-1.414 2.499 2.499-1.414 1.414-2.499-2.499z" }),
_('path', { d: "M11 21h2v3h-2v-3z" }),
_('path', { d: "M11 0h2v3h-2v-3z" }),
_('path', { d: "M12 8c-0.203 0-0.384 0.122-0.462 0.306l-2.694 6.462 0.922 0.384 0.897-2.153h2.666l0.897 2.153 0.922-0.384-2.694-6.462c-0.069-0.184-0.25-0.306-0.453-0.306zM11.084 12l0.916-2.2 0.916 2.2h-1.831z" })
            );
        }
        function BrightnessAuto({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BrightnessAutoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BrightnessAuto.SVG = BrightnessAutoSVG;
        return BrightnessAuto;
    })();
export const BrightnessAuto2 = /*#__PURE__*/ (() => {
        function BrightnessAuto2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 11h3v2h-3v-2z" }),
_('path', { d: "M18.042 4.544l2.499-2.499 1.414 1.414-2.499 2.499-1.414-1.414z" }),
_('path', { d: "M2.042 3.456l1.414-1.414 2.499 2.499-1.414 1.414-2.499-2.499z" }),
_('path', { d: "M2.042 20.543l2.499-2.499 1.414 1.414-2.499 2.499-1.414-1.414z" }),
_('path', { d: "M11 0h2v3h-2v-3z" }),
_('path', { d: "M17.5 14c-0.216 0-0.406 0.138-0.475 0.341l-2.159 6.475 0.95 0.316 0.709-2.131h1.947l0.709 2.131 0.95-0.316-2.159-6.475c-0.066-0.203-0.256-0.341-0.472-0.341zM16.859 18l0.641-1.919 0.641 1.919h-1.281z" }),
_('path', { d: "M19.984 11.494c-0.125-2.006-0.991-3.869-2.447-5.266-1.497-1.437-3.462-2.228-5.538-2.228-2.137 0-4.147 0.831-5.656 2.344-1.512 1.512-2.344 3.519-2.344 5.656 0 2.075 0.791 4.041 2.228 5.538 1.397 1.456 3.263 2.319 5.266 2.444 0.978 2.359 3.3 4.019 6.006 4.019 3.584 0 6.5-2.916 6.5-6.5 0-2.706-1.659-5.028-4.016-6.006zM6 12c0-3.309 2.691-6 6-6 2.975 0 5.45 2.15 5.919 5.013-0.138-0.009-0.278-0.012-0.419-0.012-3.584 0-6.5 2.916-6.5 6.5 0 0.141 0.006 0.281 0.012 0.419-2.862-0.469-5.013-2.944-5.013-5.919zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" })
            );
        }
        function BrightnessAuto2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BrightnessAuto2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BrightnessAuto2.SVG = BrightnessAuto2SVG;
        return BrightnessAuto2;
    })();
export const BrightnessContrast = /*#__PURE__*/ (() => {
        function BrightnessContrastSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.656 6.344c-1.512-1.512-3.519-2.344-5.656-2.344s-4.147 0.831-5.656 2.344-2.344 3.519-2.344 5.656c0 2.138 0.831 4.147 2.344 5.656 1.512 1.512 3.519 2.344 5.656 2.344s4.147-0.831 5.656-2.344c1.512-1.512 2.344-3.519 2.344-5.656s-0.831-4.147-2.344-5.656zM12 18c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z" }),
_('path', { d: "M15.716 8.653c-0.822-0.912-1.944-1.491-3.159-1.622-0.141-0.016-0.281 0.031-0.387 0.125s-0.166 0.231-0.166 0.372v8.944c0 0.144 0.059 0.278 0.166 0.372 0.091 0.081 0.213 0.128 0.334 0.128 0.019 0 0.038 0 0.056-0.003 2.534-0.281 4.444-2.419 4.444-4.969-0.003-1.238-0.459-2.428-1.287-3.347zM13 15.875v-7.75c1.744 0.444 3 2.022 3 3.875 0 1.85-1.256 3.428-3 3.875z" }),
_('path', { d: "M0 11h3v2h-3v-2z" }),
_('path', { d: "M21 11h3v2h-3v-2z" }),
_('path', { d: "M18.042 4.543l2.499-2.499 1.414 1.414-2.499 2.499-1.414-1.414z" }),
_('path', { d: "M2.042 3.456l1.414-1.414 2.499 2.499-1.414 1.414-2.499-2.499z" }),
_('path', { d: "M2.042 20.544l2.499-2.499 1.414 1.414-2.499 2.499-1.414-1.414z" }),
_('path', { d: "M18.042 19.456l1.414-1.414 2.499 2.499-1.414 1.414-2.499-2.499z" }),
_('path', { d: "M11 21h2v3h-2v-3z" }),
_('path', { d: "M11 0h2v3h-2v-3z" })
            );
        }
        function BrightnessContrast({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BrightnessContrastSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BrightnessContrast.SVG = BrightnessContrastSVG;
        return BrightnessContrast;
    })();
export const Brightness = /*#__PURE__*/ (() => {
        function BrightnessSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 7c-2.756 0-5 2.244-5 5s2.244 5 5 5c2.756 0 5-2.244 5-5s-2.244-5-5-5zM12 16c-2.206 0-4-1.794-4-4s1.794-4 4-4c2.206 0 4 1.794 4 4s-1.794 4-4 4z" }),
_('path', { d: "M17.656 6.344c-1.512-1.512-3.519-2.344-5.656-2.344s-4.147 0.831-5.656 2.344-2.344 3.519-2.344 5.656c0 2.138 0.831 4.147 2.344 5.656 1.512 1.512 3.519 2.344 5.656 2.344s4.147-0.831 5.656-2.344c1.512-1.512 2.344-3.519 2.344-5.656s-0.831-4.147-2.344-5.656zM12 18c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z" }),
_('path', { d: "M0 11h3v2h-3v-2z" }),
_('path', { d: "M21 11h3v2h-3v-2z" }),
_('path', { d: "M18.042 4.543l2.499-2.499 1.414 1.414-2.499 2.499-1.414-1.414z" }),
_('path', { d: "M2.042 3.456l1.414-1.414 2.499 2.499-1.414 1.414-2.499-2.499z" }),
_('path', { d: "M2.042 20.544l2.499-2.499 1.414 1.414-2.499 2.499-1.414-1.414z" }),
_('path', { d: "M18.042 19.456l1.414-1.414 2.499 2.499-1.414 1.414-2.499-2.499z" }),
_('path', { d: "M11 21h2v3h-2v-3z" }),
_('path', { d: "M11 0h2v3h-2v-3z" })
            );
        }
        function Brightness({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BrightnessSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Brightness.SVG = BrightnessSVG;
        return Brightness;
    })();
export const BringForward = /*#__PURE__*/ (() => {
        function BringForwardSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 8h-9c-1.103 0-2 0.897-2 2v4c0 1.103 0.897 2 2 2h9c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM22 14h-9v-4h9v4c0 0 0 0 0 0z" }),
_('path', { d: "M23.5 18h-12c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h12c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5zM23 23h-11v-4h11v4z" }),
_('path', { d: "M23.5 0h-12c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h12c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5zM23 5h-11v-4h11v4z" }),
_('path', { d: "M3.294 10.294l-3.25 3.25 1.416 1.416 1.541-1.544v10.584h2v-10.584l1.544 1.544 1.416-1.416-3.25-3.25c-0.394-0.391-1.025-0.391-1.416 0z" })
            );
        }
        function BringForward({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BringForwardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BringForward.SVG = BringForwardSVG;
        return BringForward;
    })();
export const Brush = /*#__PURE__*/ (() => {
    function BrushSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.706 1.294c-0.344-0.344-0.881-0.391-1.278-0.113-0.028 0.019-2.913 2.028-5.881 4.131-6.069 4.297-6.566 4.794-6.753 4.981-1.113 1.113-2.112 3.559-2.222 3.834-0.081 0.206-0.094 0.425-0.038 0.631l-1.247 1.247c-2.15 0.109-3.087 1.897-3.919 3.478-0.594 1.128-1.153 2.191-2.053 2.553-0.225 0.087-0.353 0.322-0.306 0.556s0.25 0.406 0.491 0.406c2.531 0 4.641-0.384 6.1-1.116 1.491-0.747 2.316-1.841 2.394-3.172l1.247-1.247c0.084 0.022 0.172 0.034 0.259 0.034 0.125 0 0.25-0.022 0.372-0.072 0.275-0.109 2.722-1.109 3.834-2.222 0.188-0.188 0.684-0.684 4.984-6.753 2.103-2.969 4.109-5.853 4.131-5.881 0.275-0.397 0.228-0.938-0.116-1.278zM7.5 16.209l0.647-0.647 1.294 1.294-0.65 0.644c-0.25-0.575-0.716-1.041-1.291-1.291zM6.15 20.991c-1.028 0.513-2.438 0.837-4.131 0.959 0.484-0.578 0.862-1.297 1.231-2 0.8-1.519 1.553-2.95 3.25-2.95 0.828 0 1.5 0.672 1.5 1.5 0 1.041-0.622 1.878-1.85 2.491zM13.294 13.794c-0.537 0.537-1.747 1.15-2.566 1.522l-1.041-1.044c0.369-0.819 0.981-2.025 1.522-2.566 0.472-0.472 4.072-3.056 7.713-5.625-2.572 3.641-5.159 7.241-5.628 7.713z" })
        );
    }
    function Brush({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BrushSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Brush.SVG = BrushSVG;
    return Brush;
})();
export const Brush2 = /*#__PURE__*/ (() => {
        function Brush2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.916 10.225c-0.569-0.859-1.956-1.116-2.784-1.191l0.853-3.412c0.047-0.191-0.019-0.391-0.172-0.513s-0.363-0.144-0.537-0.056l-2.953 1.478 0.578-1.884c0.041-0.128 0.025-0.269-0.041-0.387-0.975-1.769-2.712-3.191-5.166-4.219-0.222-0.094-0.478-0.016-0.609 0.184-0.019 0.025-1.616 2.412-3.347 4.303-0.328-0.078-0.687 0.009-0.944 0.266l-2.5 2.5c-0.231 0.231-0.334 0.563-0.278 0.888l0.897 4.909-5.684 4.744c-0.003 0.003-0.009 0.006-0.012 0.012-0.772 0.669-1.216 1.634-1.216 2.653 0 0.931 0.363 1.809 1.022 2.472 0.003 0.003 0.003 0.003 0.006 0.006 0.663 0.659 1.541 1.022 2.472 1.022 1.019 0 1.984-0.444 2.653-1.216 0.003-0.003 0.006-0.009 0.012-0.012l4.747-5.684 4.909 0.897c0.322 0.059 0.653-0.044 0.888-0.278l2.5-2.5c0.262-0.262 0.35-0.637 0.256-0.972 1.884-1.806 4.272-3.294 4.3-3.309 0.116-0.072 0.197-0.188 0.225-0.319s0-0.269-0.075-0.381zM10.697 15.016c-0.353-0.066-0.716 0.066-0.947 0.344l-5.116 6.125c-0.288 0.328-0.7 0.516-1.134 0.516-0.4 0-0.775-0.156-1.062-0.438-0.281-0.284-0.438-0.663-0.438-1.062 0-0.434 0.188-0.847 0.519-1.134l6.125-5.116c0.275-0.231 0.406-0.594 0.344-0.947l-0.806-4.416 6.938 6.938-4.422-0.809zM16.147 15.441l-7.587-7.587 0.941-0.941 7.584 7.587-0.938 0.941zM18.853 13.437l-8.309-8.309c1.375-1.516 2.628-3.272 3.138-4.003 1.959 0.884 3.369 2.041 4.2 3.438l-0.859 2.794c-0.059 0.191 0.003 0.4 0.156 0.528s0.369 0.156 0.547 0.066l3.028-1.512-0.738 2.947c-0.037 0.15-0.003 0.306 0.091 0.428s0.241 0.194 0.394 0.194c0.525 0 1.556 0.116 2.175 0.441-0.831 0.544-2.431 1.669-3.822 2.991z" }),
_('path', { d: "M4 20.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Brush2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Brush2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Brush2.SVG = Brush2SVG;
        return Brush2;
    })();
export const BubbleCheck = /*#__PURE__*/ (() => {
        function BubbleCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v19c0 0.387 0.225 0.741 0.575 0.906 0.134 0.063 0.281 0.094 0.425 0.094 0.228 0 0.456-0.078 0.641-0.231l5.722-4.769h3.656c-0.012 0.166-0.019 0.331-0.019 0.5 0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5v-15.5c0-1.103-0.897-2-2-2zM7 15c-0.234 0-0.459 0.081-0.641 0.231l-4.359 3.634v-16.866h20v10.812c-1.169-1.122-2.756-1.812-4.5-1.812-2.7 0-5.019 1.653-6 4h-4.5zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M5 5h14v1h-14v-1z" }),
_('path', { d: "M5 8h14v1h-14v-1z" }),
_('path', { d: "M5 11h7v1h-7v-1z" }),
_('path', { d: "M16.5 18.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4z" })
            );
        }
        function BubbleCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleCheck.SVG = BubbleCheckSVG;
        return BubbleCheck;
    })();
export const BubbleCross = /*#__PURE__*/ (() => {
        function BubbleCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v19c0 0.387 0.225 0.741 0.575 0.906 0.134 0.063 0.281 0.094 0.425 0.094 0.228 0 0.456-0.078 0.641-0.231l5.722-4.769h3.656c-0.012 0.166-0.019 0.331-0.019 0.5 0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5v-15.5c0-1.103-0.897-2-2-2zM7 15c-0.234 0-0.459 0.081-0.641 0.231l-4.359 3.634v-16.866h20v10.812c-1.169-1.122-2.756-1.812-4.5-1.812-2.7 0-5.019 1.653-6 4h-4.5zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M5 5h14v1h-14v-1z" }),
_('path', { d: "M5 8h14v1h-14v-1z" }),
_('path', { d: "M5 11h7v1h-7v-1z" }),
_('path', { d: "M19.5 14.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function BubbleCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleCross.SVG = BubbleCrossSVG;
        return BubbleCross;
    })();
export const BubbleDots = /*#__PURE__*/ (() => {
        function BubbleDotsSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.153-1.537-4.994-2.384-8.006-2.384s-5.853 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.713 1.125-0.559 1.962-1.122 2.412-1.447 0.734 0.106 1.484 0.159 2.238 0.159 3.012 0 5.853-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.641-1.081 0.966-2.234 0.966-3.428s-0.325-2.347-0.966-3.428zM19.344 14.991c-1.816 1.297-4.247 2.009-6.844 2.009-0.787 0-1.572-0.066-2.328-0.2-0.288-0.050-0.578 0.025-0.806 0.209-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.328-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.413-0.809-1.666-1.212-2.584-2.791-2.584-4.437 0-1.672 0.944-3.266 2.656-4.491 1.816-1.297 4.247-2.009 6.844-2.009s5.028 0.713 6.844 2.009c1.713 1.225 2.656 2.819 2.656 4.491s-0.944 3.266-2.656 4.491z" }),
_('path', { d: "M12.5 9c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5zM12.5 11c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M8.5 9c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM8.5 11c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M16.5 9c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM16.5 11c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" })
            );
        }
        function BubbleDots({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleDotsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleDots.SVG = BubbleDotsSVG;
        return BubbleDots;
    })();
export const BubbleEmoji = /*#__PURE__*/ (() => {
        function BubbleEmojiSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.153-1.537-4.994-2.384-8.006-2.384s-5.853 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.713 1.125-0.559 1.962-1.122 2.412-1.447 0.734 0.106 1.484 0.159 2.238 0.159 3.012 0 5.853-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.641-1.081 0.966-2.234 0.966-3.428s-0.325-2.347-0.966-3.428zM19.344 14.991c-1.816 1.297-4.247 2.009-6.844 2.009-0.787 0-1.572-0.066-2.328-0.2-0.288-0.050-0.578 0.025-0.806 0.209-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.328-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.413-0.809-1.666-1.212-2.584-2.791-2.584-4.437 0-1.672 0.944-3.266 2.656-4.491 1.816-1.297 4.247-2.009 6.844-2.009s5.028 0.713 6.844 2.009c1.713 1.225 2.656 2.819 2.656 4.491s-0.944 3.266-2.656 4.491z" }),
_('path', { d: "M12.5 6c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5c2.481 0 4.5-2.019 4.5-4.5s-2.019-4.5-4.5-4.5zM12.5 14c-1.931 0-3.5-1.569-3.5-3.5s1.569-3.5 3.5-3.5 3.5 1.569 3.5 3.5-1.569 3.5-3.5 3.5z" }),
_('path', { d: "M11 8h1v1h-1v-1z" }),
_('path', { d: "M13 8h1v1h-1v-1z" }),
_('path', { d: "M14.5 10h-4c-0.275 0-0.5 0.225-0.5 0.5 0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5c0-0.275-0.225-0.5-0.5-0.5zM12.5 12c-0.653 0-1.209-0.419-1.416-1h2.828c-0.203 0.581-0.759 1-1.413 1z" })
            );
        }
        function BubbleEmoji({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleEmojiSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleEmoji.SVG = BubbleEmojiSVG;
        return BubbleEmoji;
    })();
export const BubbleExclamation = /*#__PURE__*/ (() => {
        function BubbleExclamationSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.153-1.537-4.994-2.384-8.006-2.384s-5.853 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.713 1.125-0.559 1.962-1.122 2.412-1.447 0.734 0.106 1.484 0.159 2.238 0.159 3.012 0 5.853-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.641-1.081 0.966-2.234 0.966-3.428s-0.325-2.347-0.966-3.428zM19.344 14.991c-1.816 1.297-4.247 2.009-6.844 2.009-0.787 0-1.572-0.066-2.328-0.2-0.288-0.050-0.578 0.025-0.806 0.209-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.328-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.413-0.809-1.666-1.212-2.584-2.791-2.584-4.437 0-1.672 0.944-3.266 2.656-4.491 1.816-1.297 4.247-2.009 6.844-2.009s5.028 0.713 6.844 2.009c1.713 1.225 2.656 2.819 2.656 4.491s-0.944 3.266-2.656 4.491z" }),
_('path', { d: "M12 7h1v5h-1v-5z" }),
_('path', { d: "M12 13h1v1h-1v-1z" })
            );
        }
        function BubbleExclamation({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleExclamationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleExclamation.SVG = BubbleExclamationSVG;
        return BubbleExclamation;
    })();
export const BubbleFriendPlus = /*#__PURE__*/ (() => {
        function BubbleFriendPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.15-1.537-4.994-2.384-8.006-2.384s-5.856 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.709 1.125-0.559 1.966-1.122 2.412-1.447 0.738 0.106 1.488 0.159 2.234 0.159 3.012 0 5.856-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.644-1.084 0.969-2.238 0.969-3.431s-0.325-2.347-0.966-3.428zM19.344 14.988c-1.816 1.297-4.247 2.013-6.844 2.013-0.781 0-1.566-0.066-2.331-0.197-0.284-0.050-0.578 0.028-0.803 0.213-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.325-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.409-0.809-1.669-1.219-2.588-2.797-2.588-4.444 0-1.672 0.944-3.266 2.656-4.488 1.816-1.297 4.247-2.013 6.844-2.013s5.028 0.716 6.844 2.013c1.713 1.225 2.656 2.819 2.656 4.488s-0.944 3.266-2.656 4.488z" }),
_('path', { d: "M13.256 11.653c0.466-0.594 0.744-1.341 0.744-2.153 0-1.931-1.569-3.5-3.5-3.5s-3.5 1.569-3.5 3.5c0 0.813 0.278 1.559 0.744 2.153-0.637 0.363-1.184 0.878-1.653 1.563-0.081 0.116-0.106 0.259-0.075 0.397s0.122 0.253 0.244 0.322c1.287 0.716 2.675 1.062 4.244 1.062s2.953-0.347 4.244-1.062c0.122-0.069 0.213-0.184 0.244-0.322s0.006-0.281-0.075-0.397c-0.475-0.684-1.019-1.2-1.659-1.563zM10.5 7c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5-2.5-1.122-2.5-2.5 1.122-2.5 2.5-2.5zM10.5 14c-1.181 0-2.247-0.222-3.234-0.672 0.366-0.419 0.781-0.731 1.25-0.947 0.566 0.391 1.25 0.619 1.984 0.619 0.738 0 1.422-0.228 1.984-0.619 0.469 0.216 0.881 0.528 1.25 0.947-0.987 0.45-2.053 0.672-3.234 0.672z" }),
_('path', { d: "M18 8h-1v2h-2v1h2v2h1v-2h2v-1h-2z" })
            );
        }
        function BubbleFriendPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleFriendPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleFriendPlus.SVG = BubbleFriendPlusSVG;
        return BubbleFriendPlus;
    })();
export const BubbleFriend = /*#__PURE__*/ (() => {
        function BubbleFriendSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.15-1.537-4.994-2.384-8.006-2.384s-5.856 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.709 1.125-0.559 1.966-1.122 2.412-1.447 0.738 0.106 1.488 0.159 2.234 0.159 3.012 0 5.856-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.644-1.084 0.969-2.238 0.969-3.431s-0.325-2.347-0.966-3.428zM19.344 14.988c-1.816 1.297-4.247 2.013-6.844 2.013-0.781 0-1.566-0.066-2.331-0.197-0.284-0.050-0.578 0.028-0.803 0.213-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.325-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.409-0.809-1.669-1.219-2.588-2.797-2.588-4.444 0-1.672 0.944-3.266 2.656-4.488 1.816-1.297 4.247-2.013 6.844-2.013s5.028 0.716 6.844 2.013c1.713 1.225 2.656 2.819 2.656 4.488s-0.944 3.266-2.656 4.488z" }),
_('path', { d: "M15.256 11.653c0.466-0.594 0.744-1.341 0.744-2.153 0-1.931-1.569-3.5-3.5-3.5s-3.5 1.569-3.5 3.5c0 0.813 0.278 1.559 0.744 2.153-0.637 0.363-1.184 0.878-1.653 1.563-0.081 0.116-0.106 0.259-0.075 0.397s0.122 0.253 0.244 0.322c1.287 0.716 2.675 1.062 4.244 1.062s2.953-0.347 4.244-1.062c0.122-0.069 0.213-0.184 0.244-0.322s0.006-0.281-0.075-0.397c-0.475-0.684-1.019-1.2-1.659-1.563zM12.5 7c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5-2.5-1.122-2.5-2.5 1.122-2.5 2.5-2.5zM12.5 14c-1.181 0-2.247-0.222-3.234-0.672 0.366-0.419 0.781-0.731 1.25-0.947 0.566 0.391 1.25 0.619 1.984 0.619 0.738 0 1.422-0.228 1.984-0.619 0.469 0.216 0.881 0.528 1.25 0.947-0.987 0.45-2.053 0.672-3.234 0.672z" })
            );
        }
        function BubbleFriend({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleFriendSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleFriend.SVG = BubbleFriendSVG;
        return BubbleFriend;
    })();
export const BubbleHeart = /*#__PURE__*/ (() => {
        function BubbleHeartSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.153-1.537-4.994-2.384-8.006-2.384s-5.853 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.713 1.125-0.559 1.962-1.122 2.412-1.447 0.734 0.106 1.484 0.159 2.238 0.159 3.012 0 5.853-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.641-1.081 0.966-2.234 0.966-3.428s-0.325-2.347-0.966-3.428zM19.344 14.991c-1.816 1.297-4.247 2.009-6.844 2.009-0.787 0-1.572-0.066-2.328-0.2-0.288-0.050-0.578 0.025-0.806 0.209-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.328-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.413-0.809-1.666-1.212-2.584-2.791-2.584-4.437 0-1.672 0.944-3.266 2.656-4.491 1.816-1.297 4.247-2.009 6.844-2.009s5.028 0.713 6.844 2.009c1.713 1.225 2.656 2.819 2.656 4.491s-0.944 3.266-2.656 4.491z" }),
_('path', { d: "M14.5 7c-0.816 0-1.544 0.394-2 1.003-0.456-0.606-1.184-1.003-2-1.003-1.378 0-2.5 1.122-2.5 2.5 0 1.181 0.725 2.459 2.159 3.803 1.025 0.959 2.034 1.594 2.078 1.622 0.081 0.050 0.172 0.075 0.266 0.075s0.184-0.025 0.266-0.075c0.044-0.028 1.053-0.663 2.078-1.622 1.431-1.344 2.159-2.622 2.159-3.803-0.006-1.378-1.128-2.5-2.506-2.5zM12.5 13.903c-1.178-0.8-3.5-2.722-3.5-4.403 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5v0.5h1v-0.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 1.681-2.322 3.603-3.5 4.403z" })
            );
        }
        function BubbleHeart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleHeartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleHeart.SVG = BubbleHeartSVG;
        return BubbleHeart;
    })();
export const BubbleMad = /*#__PURE__*/ (() => {
        function BubbleMadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.15-1.537-4.994-2.384-8.006-2.384s-5.856 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.709 1.125-0.559 1.966-1.122 2.412-1.447 0.738 0.106 1.488 0.159 2.234 0.159 3.012 0 5.856-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.644-1.084 0.969-2.238 0.969-3.431s-0.325-2.347-0.966-3.428zM19.344 14.988c-1.816 1.297-4.247 2.013-6.844 2.013-0.781 0-1.566-0.066-2.331-0.197-0.284-0.050-0.578 0.028-0.803 0.213-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.325-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.409-0.809-1.669-1.219-2.588-2.797-2.588-4.444 0-1.672 0.944-3.266 2.656-4.488 1.816-1.297 4.247-2.013 6.844-2.013s5.028 0.716 6.844 2.013c1.713 1.225 2.656 2.819 2.656 4.488s-0.944 3.266-2.656 4.488z" }),
_('path', { d: "M12.5 6c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5c2.481 0 4.5-2.019 4.5-4.5s-2.019-4.5-4.5-4.5zM12.5 14c-1.931 0-3.5-1.569-3.5-3.5s1.569-3.5 3.5-3.5 3.5 1.569 3.5 3.5-1.569 3.5-3.5 3.5z" }),
_('path', { d: "M9.793 9.501l0.707-0.707 1.708 1.708-0.707 0.707-1.708-1.708z" }),
_('path', { d: "M12.793 10.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M11 12h3v1h-3v-1z" })
            );
        }
        function BubbleMad({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleMadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleMad.SVG = BubbleMadSVG;
        return BubbleMad;
    })();
export const BubbleMusic = /*#__PURE__*/ (() => {
        function BubbleMusicSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.15-1.537-4.994-2.384-8.006-2.384s-5.856 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.709 1.125-0.559 1.966-1.122 2.412-1.447 0.738 0.106 1.488 0.159 2.234 0.159 3.012 0 5.856-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.644-1.084 0.969-2.238 0.969-3.431s-0.325-2.347-0.966-3.428zM19.344 14.988c-1.816 1.297-4.247 2.013-6.844 2.013-0.781 0-1.566-0.066-2.331-0.197-0.284-0.050-0.578 0.028-0.803 0.213-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.325-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.409-0.809-1.669-1.219-2.588-2.797-2.588-4.444 0-1.672 0.944-3.266 2.656-4.488 1.816-1.297 4.247-2.013 6.844-2.013s5.028 0.716 6.844 2.013c1.713 1.225 2.656 2.819 2.656 4.488s-0.944 3.266-2.656 4.488z" }),
_('path', { d: "M14 7h-1v4.131c-0.35-0.125-0.762-0.162-1.191-0.103-1.109 0.156-1.903 0.922-1.803 1.741 0.041 0.325 0.213 0.616 0.5 0.834 0.334 0.256 0.803 0.397 1.303 0.397 0.125 0 0.253-0.009 0.378-0.025 1.053-0.147 1.819-0.844 1.809-1.616v-3.125c0.531 0.475 1.231 0.766 2 0.766v-1c-1.1 0-1.997-0.897-1.997-2zM12.050 12.981c-0.366 0.050-0.731-0.016-0.934-0.172-0.047-0.037-0.106-0.094-0.116-0.162-0.025-0.194 0.341-0.547 0.947-0.631 0.081-0.012 0.166-0.016 0.244-0.016 0.278 0 0.534 0.066 0.691 0.188 0.069 0.053 0.109 0.109 0.116 0.166v0c0.025 0.194-0.341 0.544-0.947 0.628z" })
            );
        }
        function BubbleMusic({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleMusicSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleMusic.SVG = BubbleMusicSVG;
        return BubbleMusic;
    })();
export const BubbleMusic2 = /*#__PURE__*/ (() => {
        function BubbleMusic2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.15-1.537-4.994-2.384-8.006-2.384s-5.856 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.709 1.125-0.559 1.966-1.122 2.412-1.447 0.738 0.106 1.488 0.159 2.234 0.159 3.012 0 5.856-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.644-1.084 0.969-2.238 0.969-3.431s-0.325-2.347-0.966-3.428zM19.344 14.988c-1.816 1.297-4.247 2.013-6.844 2.013-0.781 0-1.566-0.066-2.331-0.197-0.284-0.050-0.578 0.028-0.803 0.213-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.325-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.409-0.809-1.669-1.219-2.588-2.797-2.588-4.444 0-1.672 0.944-3.266 2.656-4.488 1.816-1.297 4.247-2.013 6.844-2.013s5.028 0.716 6.844 2.013c1.713 1.225 2.656 2.819 2.656 4.488s-0.944 3.266-2.656 4.488z" }),
_('path', { d: "M16 8.5c0-0.228-0.156-0.428-0.378-0.484l-4-1c-0.15-0.038-0.306-0.003-0.428 0.091s-0.194 0.241-0.194 0.394v2.544c-0.216-0.056-0.447-0.066-0.678-0.019-0.8 0.162-1.378 0.919-1.313 1.719 0.031 0.4 0.222 0.747 0.531 0.978 0.237 0.178 0.531 0.272 0.837 0.272 0.1 0 0.203-0.009 0.303-0.031 0.769-0.156 1.328-0.856 1.319-1.616v-3.206l3 0.75v2.153c-0.216-0.056-0.447-0.066-0.678-0.019-0.8 0.162-1.378 0.919-1.313 1.719 0.031 0.4 0.222 0.747 0.531 0.978 0.237 0.178 0.531 0.272 0.837 0.272 0.1 0 0.203-0.009 0.303-0.031 0.769-0.156 1.331-0.856 1.319-1.619v-3.844zM10.481 11.984c-0.131 0.028-0.253 0.006-0.341-0.063-0.078-0.059-0.125-0.15-0.134-0.259-0.022-0.288 0.219-0.597 0.519-0.656 0.038-0.006 0.072-0.012 0.106-0.012 0.091 0 0.172 0.025 0.234 0.072 0.078 0.059 0.125 0.15 0.134 0.259 0 0.009 0 0.022 0 0.031v0.012c-0.003 0.278-0.234 0.559-0.519 0.616zM14.481 12.984c-0.131 0.028-0.253 0.006-0.341-0.063-0.078-0.059-0.125-0.15-0.134-0.259-0.022-0.288 0.219-0.597 0.519-0.656 0.037-0.006 0.072-0.012 0.106-0.012 0.091 0 0.172 0.025 0.234 0.072 0.078 0.059 0.125 0.15 0.134 0.259 0 0.009 0 0.022 0 0.031v0.012c-0.003 0.278-0.234 0.559-0.519 0.616z" })
            );
        }
        function BubbleMusic2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleMusic2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleMusic2.SVG = BubbleMusic2SVG;
        return BubbleMusic2;
    })();
export const BubblePaperclip = /*#__PURE__*/ (() => {
        function BubblePaperclipSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.15-1.537-4.994-2.384-8.006-2.384s-5.856 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.709 1.125-0.559 1.966-1.122 2.412-1.447 0.738 0.106 1.488 0.159 2.234 0.159 3.012 0 5.856-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.644-1.084 0.969-2.238 0.969-3.431s-0.325-2.347-0.966-3.428zM19.344 14.988c-1.816 1.297-4.247 2.013-6.844 2.013-0.781 0-1.566-0.066-2.331-0.197-0.284-0.050-0.578 0.028-0.803 0.213-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.325-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.409-0.809-1.669-1.219-2.588-2.797-2.588-4.444 0-1.672 0.944-3.266 2.656-4.488 1.816-1.297 4.247-2.013 6.844-2.013s5.028 0.716 6.844 2.013c1.713 1.225 2.656 2.819 2.656 4.488s-0.944 3.266-2.656 4.488z" }),
_('path', { d: "M16.5 7h-7c-1.931 0-3.5 1.569-3.5 3.5s1.569 3.5 3.5 3.5h5.5v-1h-5.5c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5h7c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5h-6c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3.5v-1h-3.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h6c1.378 0 2.5-1.122 2.5-2.5s-1.122-2.5-2.5-2.5z" })
            );
        }
        function BubblePaperclip({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubblePaperclipSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubblePaperclip.SVG = BubblePaperclipSVG;
        return BubblePaperclip;
    })();
export const BubblePicture = /*#__PURE__*/ (() => {
        function BubblePictureSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.15-1.537-4.994-2.384-8.006-2.384s-5.856 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.709 1.125-0.559 1.966-1.122 2.412-1.447 0.738 0.106 1.488 0.159 2.234 0.159 3.012 0 5.856-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.644-1.084 0.969-2.238 0.969-3.431s-0.325-2.347-0.966-3.428zM19.344 14.988c-1.816 1.297-4.247 2.013-6.844 2.013-0.781 0-1.566-0.066-2.331-0.197-0.284-0.050-0.578 0.028-0.803 0.213-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.325-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.409-0.809-1.669-1.219-2.588-2.797-2.588-4.444 0-1.672 0.944-3.266 2.656-4.488 1.816-1.297 4.247-2.013 6.844-2.013s5.028 0.716 6.844 2.013c1.713 1.225 2.656 2.819 2.656 4.488s-0.944 3.266-2.656 4.488z" }),
_('path', { d: "M17.5 6h-10c-0.275 0-0.5 0.225-0.5 0.5v8c0 0.275 0.225 0.5 0.5 0.5h10c0.275 0 0.5-0.225 0.5-0.5v-8c0-0.275-0.225-0.5-0.5-0.5zM8 7h9v4.169l-0.584-0.584c-0.781-0.778-2.050-0.778-2.828 0l-3.416 3.416h-2.172v-7zM11.584 14l2.709-2.709c0.387-0.387 1.025-0.387 1.416 0l1.291 1.291v1.419h-5.416z" }),
_('path', { d: "M10.5 11c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM10.5 9c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" })
            );
        }
        function BubblePicture({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubblePictureSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubblePicture.SVG = BubblePictureSVG;
        return BubblePicture;
    })();
export const BubblePokerFace = /*#__PURE__*/ (() => {
        function BubblePokerFaceSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.15-1.537-4.994-2.384-8.006-2.384s-5.856 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.709 1.125-0.559 1.966-1.122 2.412-1.447 0.738 0.106 1.488 0.159 2.234 0.159 3.012 0 5.856-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.644-1.084 0.969-2.238 0.969-3.431s-0.325-2.347-0.966-3.428zM19.344 14.988c-1.816 1.297-4.247 2.013-6.844 2.013-0.781 0-1.566-0.066-2.331-0.197-0.284-0.050-0.578 0.028-0.803 0.213-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.325-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.409-0.809-1.669-1.219-2.588-2.797-2.588-4.444 0-1.672 0.944-3.266 2.656-4.488 1.816-1.297 4.247-2.013 6.844-2.013s5.028 0.716 6.844 2.013c1.713 1.225 2.656 2.819 2.656 4.488s-0.944 3.266-2.656 4.488z" }),
_('path', { d: "M12.5 6c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5c2.481 0 4.5-2.019 4.5-4.5s-2.019-4.5-4.5-4.5zM12.5 14c-1.931 0-3.5-1.569-3.5-3.5s1.569-3.5 3.5-3.5 3.5 1.569 3.5 3.5-1.569 3.5-3.5 3.5z" }),
_('path', { d: "M11 8h1v1h-1v-1z" }),
_('path', { d: "M13 8h1v1h-1v-1z" }),
_('path', { d: "M10 10h5v1h-5v-1z" })
            );
        }
        function BubblePokerFace({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubblePokerFaceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubblePokerFace.SVG = BubblePokerFaceSVG;
        return BubblePokerFace;
    })();
export const BubbleQuestion = /*#__PURE__*/ (() => {
        function BubbleQuestionSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.15-1.537-4.994-2.384-8.006-2.384s-5.856 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.709 1.125-0.559 1.966-1.122 2.412-1.447 0.738 0.106 1.488 0.159 2.234 0.159 3.012 0 5.856-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.644-1.084 0.969-2.238 0.969-3.431s-0.325-2.347-0.966-3.428zM19.344 14.988c-1.816 1.297-4.247 2.013-6.844 2.013-0.781 0-1.566-0.066-2.331-0.197-0.284-0.050-0.578 0.028-0.803 0.213-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.325-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.409-0.809-1.669-1.219-2.588-2.797-2.588-4.444 0-1.672 0.944-3.266 2.656-4.488 1.816-1.297 4.247-2.013 6.844-2.013s5.028 0.716 6.844 2.013c1.713 1.225 2.656 2.819 2.656 4.488s-0.944 3.266-2.656 4.488z" }),
_('path', { d: "M12 13h1v1h-1v-1z" }),
_('path', { d: "M12.503 6.003c-1.206 0-2.503 0.781-2.503 2.497v0.5h1v-0.5c0-1.103 0.809-1.497 1.503-1.497 0.4 0 0.788 0.125 1.062 0.344 0.288 0.228 0.434 0.531 0.434 0.903 0 0.713-0.434 1.084-0.941 1.519-0.497 0.425-1.059 0.906-1.059 1.731v0.5h1v-0.5c0-0.347 0.256-0.584 0.709-0.972 0.575-0.491 1.291-1.103 1.291-2.278 0-1.459-1.287-2.247-2.497-2.247z" })
            );
        }
        function BubbleQuestion({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleQuestionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleQuestion.SVG = BubbleQuestionSVG;
        return BubbleQuestion;
    })();
export const BubbleQuote = /*#__PURE__*/ (() => {
        function BubbleQuoteSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.15-1.537-4.994-2.384-8.006-2.384s-5.856 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.709 1.125-0.559 1.966-1.122 2.412-1.447 0.738 0.106 1.488 0.159 2.234 0.159 3.012 0 5.856-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.644-1.084 0.969-2.238 0.969-3.431s-0.325-2.347-0.966-3.428zM19.344 14.988c-1.816 1.297-4.247 2.013-6.844 2.013-0.781 0-1.566-0.066-2.331-0.197-0.284-0.050-0.578 0.028-0.803 0.213-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.325-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.409-0.809-1.669-1.219-2.588-2.797-2.588-4.444 0-1.672 0.944-3.266 2.656-4.488 1.816-1.297 4.247-2.013 6.844-2.013s5.028 0.716 6.844 2.013c1.713 1.225 2.656 2.819 2.656 4.488s-0.944 3.266-2.656 4.488z" }),
_('path', { d: "M11.5 9h-2.384c0.091-0.191 0.237-0.369 0.428-0.525 0.384-0.306 0.9-0.475 1.456-0.475v-1c-0.781 0-1.519 0.247-2.081 0.697-0.594 0.475-0.919 1.116-0.919 1.803v3c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5zM11 12h-2v-2h2v2z" }),
_('path', { d: "M16.5 9h-2.384c0.091-0.191 0.237-0.369 0.428-0.525 0.384-0.306 0.9-0.475 1.456-0.475v-1c-0.781 0-1.519 0.247-2.081 0.697-0.594 0.475-0.919 1.116-0.919 1.803v3c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5zM16 12h-2v-2h2v2z" })
            );
        }
        function BubbleQuote({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleQuoteSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleQuote.SVG = BubbleQuoteSVG;
        return BubbleQuote;
    })();
export const BubbleSad = /*#__PURE__*/ (() => {
        function BubbleSadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.153-1.537-4.994-2.384-8.006-2.384s-5.853 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.713 1.125-0.559 1.962-1.122 2.412-1.447 0.734 0.106 1.484 0.159 2.238 0.159 3.012 0 5.853-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.641-1.081 0.966-2.234 0.966-3.428s-0.325-2.347-0.966-3.428zM19.344 14.991c-1.816 1.297-4.247 2.009-6.844 2.009-0.787 0-1.572-0.066-2.328-0.2-0.288-0.050-0.578 0.025-0.806 0.209-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.328-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.413-0.809-1.666-1.212-2.584-2.791-2.584-4.437 0-1.672 0.944-3.266 2.656-4.491 1.816-1.297 4.247-2.009 6.844-2.009s5.028 0.713 6.844 2.009c1.713 1.225 2.656 2.819 2.656 4.491s-0.944 3.266-2.656 4.491z" }),
_('path', { d: "M12.5 6c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5c2.481 0 4.5-2.019 4.5-4.5s-2.019-4.5-4.5-4.5zM12.5 14c-1.931 0-3.5-1.569-3.5-3.5s1.569-3.5 3.5-3.5 3.5 1.569 3.5 3.5-1.569 3.5-3.5 3.5z" }),
_('path', { d: "M11 8h1v1h-1v-1z" }),
_('path', { d: "M13 8h1v1h-1v-1z" }),
_('path', { d: "M14.216 10.541c-0.466-0.35-1.075-0.541-1.716-0.541s-1.25 0.191-1.716 0.541c-0.5 0.375-0.784 0.906-0.784 1.459h1c0-0.541 0.687-1 1.5-1s1.5 0.459 1.5 1h1c0-0.553-0.288-1.087-0.784-1.459z" })
            );
        }
        function BubbleSad({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleSadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleSad.SVG = BubbleSadSVG;
        return BubbleSad;
    })();
export const BubbleShiny = /*#__PURE__*/ (() => {
        function BubbleShinySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.15-1.537-4.994-2.384-8.006-2.384s-5.856 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.709 1.125-0.559 1.966-1.122 2.412-1.447 0.738 0.106 1.488 0.159 2.234 0.159 3.012 0 5.856-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.644-1.084 0.969-2.238 0.969-3.431s-0.325-2.347-0.966-3.428zM19.344 14.988c-1.816 1.297-4.247 2.013-6.844 2.013-0.781 0-1.566-0.066-2.331-0.197-0.284-0.050-0.578 0.028-0.803 0.213-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.325-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.409-0.809-1.669-1.219-2.588-2.797-2.588-4.444 0-1.672 0.944-3.266 2.656-4.488 1.816-1.297 4.247-2.013 6.844-2.013s5.028 0.716 6.844 2.013c1.713 1.225 2.656 2.819 2.656 4.488s-0.944 3.266-2.656 4.488z" }),
_('path', { d: "M18.762 6.825c-1.622-1.159-3.906-1.825-6.262-1.825h-0.5v1h0.5c2.153 0 4.225 0.597 5.681 1.638 0.678 0.488 1.819 1.503 1.819 2.862v0.5h1v-0.5c0-1.806-1.403-3.078-2.238-3.675z" })
            );
        }
        function BubbleShiny({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleShinySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleShiny.SVG = BubbleShinySVG;
        return BubbleShiny;
    })();
export const BubbleShocked = /*#__PURE__*/ (() => {
        function BubbleShockedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.153-1.537-4.994-2.384-8.006-2.384s-5.853 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.713 1.125-0.559 1.962-1.122 2.412-1.447 0.734 0.106 1.484 0.159 2.238 0.159 3.012 0 5.853-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.641-1.081 0.966-2.234 0.966-3.428s-0.325-2.347-0.966-3.428zM19.344 14.991c-1.816 1.297-4.247 2.009-6.844 2.009-0.787 0-1.572-0.066-2.328-0.2-0.288-0.050-0.578 0.025-0.806 0.209-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.328-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.413-0.809-1.666-1.212-2.584-2.791-2.584-4.437 0-1.672 0.944-3.266 2.656-4.491 1.816-1.297 4.247-2.009 6.844-2.009s5.028 0.713 6.844 2.009c1.713 1.225 2.656 2.819 2.656 4.491s-0.944 3.266-2.656 4.491z" }),
_('path', { d: "M12.5 6c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5c2.481 0 4.5-2.019 4.5-4.5s-2.019-4.5-4.5-4.5zM12.5 14c-1.931 0-3.5-1.569-3.5-3.5s1.569-3.5 3.5-3.5 3.5 1.569 3.5 3.5-1.569 3.5-3.5 3.5z" }),
_('path', { d: "M11 8h1v1h-1v-1z" }),
_('path', { d: "M13 8h1v1h-1v-1z" }),
_('path', { d: "M12.5 10c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5zM12.5 12c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" })
            );
        }
        function BubbleShocked({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleShockedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleShocked.SVG = BubbleShockedSVG;
        return BubbleShocked;
    })();
export const BubbleText = /*#__PURE__*/ (() => {
        function BubbleTextSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 1h-20c-1.103 0-2 0.897-2 2v19c0 0.387 0.225 0.741 0.575 0.906 0.134 0.063 0.281 0.094 0.425 0.094 0.228 0 0.456-0.078 0.641-0.231l5.722-4.769h14.637c1.103 0 2-0.897 2-2v-13c0-1.103-0.897-2-2-2zM22 16h-15c-0.234 0-0.459 0.081-0.641 0.231l-4.359 3.634v-16.866h20v13z" }),
_('path', { d: "M5 6h14v1h-14v-1z" }),
_('path', { d: "M5 9h14v1h-14v-1z" }),
_('path', { d: "M5 12h14v1h-14v-1z" })
            );
        }
        function BubbleText({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleTextSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleText.SVG = BubbleTextSVG;
        return BubbleText;
    })();
export const BubbleText2 = /*#__PURE__*/ (() => {
        function BubbleText2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.153-1.537-4.994-2.384-8.006-2.384s-5.853 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.713 1.125-0.559 1.962-1.122 2.412-1.447 0.734 0.106 1.484 0.159 2.238 0.159 3.012 0 5.853-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.641-1.081 0.966-2.234 0.966-3.428s-0.325-2.347-0.966-3.428zM19.344 14.991c-1.816 1.297-4.247 2.009-6.844 2.009-0.787 0-1.572-0.066-2.328-0.2-0.288-0.050-0.578 0.025-0.806 0.209-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.328-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.413-0.809-1.666-1.212-2.584-2.791-2.584-4.437 0-1.672 0.944-3.266 2.656-4.491 1.816-1.297 4.247-2.009 6.844-2.009s5.028 0.713 6.844 2.009c1.713 1.225 2.656 2.819 2.656 4.491s-0.944 3.266-2.656 4.491z" }),
_('path', { d: "M7 7h11v1h-11v-1z" }),
_('path', { d: "M7 9h11v1h-11v-1z" }),
_('path', { d: "M7 11h11v1h-11v-1z" }),
_('path', { d: "M7 13h7v1h-7v-1z" })
            );
        }
        function BubbleText2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleText2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleText2.SVG = BubbleText2SVG;
        return BubbleText2;
    })();
export const BubbleTime = /*#__PURE__*/ (() => {
        function BubbleTimeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v19c0 0.387 0.225 0.741 0.575 0.906 0.134 0.063 0.281 0.094 0.425 0.094 0.228 0 0.456-0.078 0.641-0.231l5.722-4.769h3.656c-0.012 0.166-0.019 0.331-0.019 0.5 0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5v-15.5c0-1.103-0.897-2-2-2zM7 15c-0.234 0-0.459 0.081-0.641 0.231l-4.359 3.634v-16.866h20v10.812c-1.169-1.122-2.756-1.812-4.5-1.812-2.7 0-5.019 1.653-6 4h-4.5zM18 22.978v-1.978h-1v1.978c-2.634-0.237-4.737-2.344-4.978-4.978h1.978v-1h-1.978c0.237-2.634 2.344-4.737 4.978-4.978v1.978h1v-1.978c2.634 0.237 4.737 2.344 4.978 4.978h-1.978v1h1.978c-0.241 2.634-2.344 4.737-4.978 4.978z" }),
_('path', { d: "M5 5h14v1h-14v-1z" }),
_('path', { d: "M5 8h14v1h-14v-1z" }),
_('path', { d: "M5 11h7v1h-7v-1z" }),
_('path', { d: "M17.422 17.716l-1.922-1.922-0.706 0.706 2.353 2.353c0.094 0.094 0.222 0.147 0.353 0.147 0.016 0 0.034 0 0.050-0.003 0.15-0.016 0.284-0.097 0.366-0.219l2.278-3.416-0.831-0.556-1.941 2.909z" })
            );
        }
        function BubbleTime({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleTimeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleTime.SVG = BubbleTimeSVG;
        return BubbleTime;
    })();
export const BubbleVideo = /*#__PURE__*/ (() => {
        function BubbleVideoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.15-1.537-4.994-2.384-8.006-2.384s-5.856 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.709 1.125-0.559 1.966-1.122 2.412-1.447 0.738 0.106 1.488 0.159 2.234 0.159 3.012 0 5.856-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.644-1.084 0.969-2.238 0.969-3.431s-0.325-2.347-0.966-3.428zM19.344 14.988c-1.816 1.297-4.247 2.013-6.844 2.013-0.781 0-1.566-0.066-2.331-0.197-0.284-0.050-0.578 0.028-0.803 0.213-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.325-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.409-0.809-1.669-1.219-2.588-2.797-2.588-4.444 0-1.672 0.944-3.266 2.656-4.488 1.816-1.297 4.247-2.013 6.844-2.013s5.028 0.716 6.844 2.013c1.713 1.225 2.656 2.819 2.656 4.488s-0.944 3.266-2.656 4.488z" }),
_('path', { d: "M17.5 7h-10c-0.275 0-0.5 0.225-0.5 0.5v6c0 0.275 0.225 0.5 0.5 0.5h10c0.275 0 0.5-0.225 0.5-0.5v-6c0-0.275-0.225-0.5-0.5-0.5zM17 9h-1v-1h1v1zM9 11h-1v-1h1v1zM10 8h5v5h-5v-5zM16 10h1v1h-1v-1zM9 8v1h-1v-1h1zM8 12h1v1h-1v-1zM16 13v-1h1v1h-1z" })
            );
        }
        function BubbleVideo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleVideoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleVideo.SVG = BubbleVideoSVG;
        return BubbleVideo;
    })();
export const BubbleWriting = /*#__PURE__*/ (() => {
        function BubbleWritingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.15-1.537-4.994-2.384-8.006-2.384s-5.856 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.709 1.125-0.559 1.966-1.122 2.412-1.447 0.738 0.106 1.488 0.159 2.234 0.159 3.012 0 5.856-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.644-1.084 0.969-2.238 0.969-3.431s-0.325-2.347-0.966-3.428zM19.344 14.988c-1.816 1.297-4.247 2.013-6.844 2.013-0.781 0-1.566-0.066-2.331-0.197-0.284-0.050-0.578 0.028-0.803 0.213-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.325-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.409-0.809-1.669-1.219-2.588-2.797-2.588-4.444 0-1.672 0.944-3.266 2.656-4.488 1.816-1.297 4.247-2.013 6.844-2.013s5.028 0.716 6.844 2.013c1.713 1.225 2.656 2.819 2.656 4.488s-0.944 3.266-2.656 4.488z" }),
_('path', { d: "M14.853 7.147l-2-2c-0.194-0.194-0.513-0.194-0.706 0l-5.5 5.5c-0.069 0.069-0.119 0.159-0.138 0.256l-0.5 2.5c-0.031 0.162 0.019 0.334 0.138 0.453 0.094 0.094 0.222 0.147 0.353 0.147 0.031 0 0.066-0.003 0.097-0.009l2.5-0.5c0.097-0.019 0.184-0.066 0.256-0.138l5.5-5.5c0.197-0.197 0.197-0.516 0-0.709zM8.753 12.541l-1.616 0.322 0.322-1.616 5.041-5.041 1.294 1.294-5.041 5.041z" }),
_('path', { d: "M11 13h7v1h-7v-1z" })
            );
        }
        function BubbleWriting({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleWritingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleWriting.SVG = BubbleWritingSVG;
        return BubbleWriting;
    })();
export const Bubble = /*#__PURE__*/ (() => {
    function BubbleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.034 7.072c-0.6-1.013-1.45-1.919-2.528-2.688-2.153-1.537-4.994-2.384-8.006-2.384s-5.853 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.713 1.125-0.559 1.962-1.122 2.412-1.447 0.734 0.106 1.484 0.159 2.238 0.159 3.012 0 5.853-0.847 8.006-2.384 1.078-0.769 1.928-1.675 2.528-2.688 0.641-1.081 0.966-2.234 0.966-3.428s-0.325-2.347-0.966-3.428zM19.344 14.991c-1.816 1.297-4.247 2.009-6.844 2.009-0.787 0-1.572-0.066-2.328-0.2-0.288-0.050-0.578 0.025-0.806 0.209-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.328-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.413-0.809-1.666-1.212-2.584-2.791-2.584-4.437 0-1.672 0.944-3.266 2.656-4.491 1.816-1.297 4.247-2.009 6.844-2.009s5.028 0.713 6.844 2.009c1.713 1.225 2.656 2.819 2.656 4.491s-0.944 3.266-2.656 4.491z" })
        );
    }
    function Bubble({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubble.SVG = BubbleSVG;
    return Bubble;
})();
export const Bubbles = /*#__PURE__*/ (() => {
        function BubblesSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 1h-20c-1.103 0-2 0.897-2 2v19c0 0.387 0.225 0.741 0.575 0.906 0.134 0.063 0.281 0.094 0.425 0.094 0.228 0 0.456-0.078 0.641-0.231l5.722-4.769h2.637v0.5c0 0.275 0.225 0.5 0.5 0.5h9.794l2.853 2.853c0.097 0.097 0.225 0.147 0.353 0.147 0.066 0 0.128-0.012 0.191-0.038 0.188-0.078 0.309-0.259 0.309-0.462v-18.5c0-1.103-0.897-2-2-2zM10 8.5v7.5h-3c-0.234 0-0.459 0.081-0.641 0.231l-4.359 3.634v-16.866h20v5h-11.5c-0.275 0-0.5 0.225-0.5 0.5zM23 20.294l-2.147-2.147c-0.094-0.094-0.222-0.147-0.353-0.147h-9.5v-9h12v11.294z" }),
_('path', { d: "M13 11h8v1h-8v-1z" }),
_('path', { d: "M13 13h8v1h-8v-1z" }),
_('path', { d: "M13 15h8v1h-8v-1z" })
            );
        }
        function Bubbles({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubblesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bubbles.SVG = BubblesSVG;
        return Bubbles;
    })();
export const Bubbles2 = /*#__PURE__*/ (() => {
    function Bubbles2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.853 14.222c0.762-1.162 1.147-2.416 1.147-3.722 0-1.194-0.325-2.347-0.966-3.428-0.6-1.012-1.45-1.919-2.528-2.688-2.153-1.538-4.994-2.384-8.006-2.384s-5.853 0.847-8.006 2.384c-1.078 0.769-1.928 1.675-2.528 2.688-0.641 1.081-0.966 2.234-0.966 3.428 0 1.178 0.316 2.319 0.941 3.387 0.5 0.856 1.178 1.638 2.025 2.325-0.231 1.491-1.581 2.672-3.516 3.953-0.369 0.244-0.534 0.7-0.406 1.122 0.125 0.422 0.516 0.712 0.956 0.712 2.819 0 5.281-0.931 6.85-1.713 1.125-0.559 1.962-1.122 2.412-1.447 0.481 0.069 0.969 0.116 1.456 0.141 0.156 0.006 0.312 0.012 0.472 0.016 0.181 0.2 0.381 0.394 0.603 0.572 1.128 0.922 2.622 1.431 4.206 1.431 0.441 0 0.878-0.041 1.306-0.119 0.775 0.819 2.122 1.119 3.194 1.119 0.228 0 0.428-0.15 0.488-0.369s-0.034-0.447-0.228-0.559c-0.050-0.031-0.681-0.447-0.788-1.322 1.294-0.95 2.028-2.303 2.028-3.75 0-0.537-0.1-1.062-0.294-1.559 0.050-0.075 0.1-0.147 0.147-0.219zM10.172 16.8c-0.288-0.050-0.578 0.025-0.806 0.209-0.009 0.006-0.947 0.766-2.456 1.509-0.663 0.328-1.503 0.684-2.472 0.966 0.938-1.038 1.559-2.247 1.559-3.738 0-0.319-0.153-0.619-0.413-0.809-1.666-1.212-2.584-2.791-2.584-4.437 0-1.672 0.944-3.266 2.656-4.491 1.816-1.297 4.247-2.009 6.844-2.009s5.028 0.712 6.844 2.009c1.713 1.225 2.656 2.819 2.656 4.491 0 0.741-0.181 1.459-0.541 2.15-0.081-0.075-0.166-0.147-0.253-0.219-1.128-0.922-2.622-1.431-4.206-1.431s-3.078 0.509-4.206 1.431c-1.156 0.947-1.794 2.216-1.794 3.569 0 0.316 0.034 0.625 0.103 0.928-0.316-0.031-0.625-0.075-0.931-0.128zM20.181 19.084c-0.141 0.094-0.225 0.25-0.225 0.416 0 0.544 0.134 0.991 0.319 1.344-0.575-0.15-1.094-0.413-1.366-0.8-0.094-0.134-0.25-0.213-0.409-0.213-0.038 0-0.075 0.003-0.112 0.012-0.45 0.103-0.916 0.156-1.388 0.156-2.756 0-5-1.794-5-4s2.244-4 5-4 5 1.794 5 4c0 1.194-0.663 2.319-1.819 3.084z" })
        );
    }
    function Bubbles2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubbles2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubbles2.SVG = Bubbles2SVG;
    return Bubbles2;
})();
export const Bucket = /*#__PURE__*/ (() => {
        function BucketSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.997 13.062c0.019-0.288-0.087-0.566-0.291-0.769l-4.472-4.475c0.534-0.872 0.963-1.728 1.266-2.544 0.747-2.022 0.653-3.644-0.266-4.572-0.466-0.466-1.038-0.703-1.7-0.703v0c-0.972 0-2.15 0.519-3.6 1.587-0.341 0.253-0.7 0.537-1.078 0.853l-0.15-0.15c-0.203-0.203-0.484-0.309-0.769-0.291-0.288 0.019-0.55 0.159-0.728 0.384l-8.772 11.306c-0.616 0.794-0.544 1.928 0.166 2.641l6.066 6.066c0.387 0.387 0.9 0.584 1.416 0.584 0.431 0 0.863-0.138 1.225-0.419l11.303-8.772c0.228-0.178 0.369-0.441 0.384-0.728zM15.534 1v0c0.397 0 0.713 0.131 0.991 0.409 0.619 0.625 0.634 1.906 0.038 3.519-0.256 0.694-0.612 1.422-1.053 2.163l-3.947-3.941c1.488-1.238 2.922-2.15 3.972-2.15zM8.084 20.981l-6.066-6.066 0.956-1.234 6.341 6.341-1.231 0.959zM10.113 19.406l-6.519-6.519 6.5-8.378 4.275 4.272c-0.353 0.472-0.738 0.941-1.144 1.403-0.216-0.119-0.462-0.188-0.722-0.188-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.828 0 1.5-0.672 1.5-1.5 0-0.197-0.038-0.387-0.109-0.559 0.422-0.475 0.822-0.959 1.191-1.444l3.406 3.412-8.378 6.5zM13 11.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5z" }),
_('path', { d: "M22.822 18.266c-0.384-0.684-0.747-1.331-0.825-1.841-0.038-0.244-0.247-0.425-0.494-0.425s-0.456 0.181-0.494 0.425c-0.078 0.513-0.441 1.156-0.825 1.841-0.559 0.984-1.184 2.1-1.184 3.231 0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5c0-1.131-0.625-2.247-1.178-3.231zM21.5 22.997c-0.828 0-1.5-0.672-1.5-1.5 0-0.869 0.534-1.822 1.050-2.741 0.156-0.281 0.312-0.553 0.45-0.822 0.138 0.269 0.291 0.544 0.45 0.822 0.516 0.919 1.050 1.872 1.050 2.741 0 0.828-0.672 1.5-1.5 1.5z" })
            );
        }
        function Bucket({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BucketSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bucket.SVG = BucketSVG;
        return Bucket;
    })();
export const Bug = /*#__PURE__*/ (() => {
    function BugSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.984 11.378c-0.050-0.197-0.213-0.344-0.416-0.375l-2.572-0.369c-0.019-1.597-0.156-2.466-0.488-3.138-0.219-0.441-0.503-0.756-0.837-1.025l2.984-0.987c0.203-0.069 0.344-0.259 0.344-0.475v-4.009h-1v3.65l-3.406 1.131c-0.184-0.109-0.381-0.225-0.594-0.359v-1.422c0-2.206-1.794-4-4-4s-4 1.794-4 4v1.422c-0.213 0.134-0.409 0.25-0.594 0.359l-3.406-1.128v-3.653h-1v4.012c0 0.216 0.138 0.406 0.344 0.475l2.984 0.991c-0.334 0.266-0.622 0.584-0.837 1.025-0.331 0.672-0.472 1.541-0.487 3.138l-2.572 0.369c-0.2 0.028-0.366 0.175-0.416 0.375l-1.122 4.478 0.969 0.244 1.041-4.159 2.106-0.3c0.037 1.2 0.175 2.316 0.412 3.319 0.091 0.381 0.194 0.747 0.312 1.097l-2.619 3.116c-0.144 0.169-0.156 0.416-0.034 0.6l2.278 3.416 0.831-0.556-2.066-3.103 2.034-2.419c0.169 0.356 0.353 0.691 0.556 1 1.228 1.887 3.056 2.884 5.284 2.884s4.056-0.997 5.287-2.884c0.203-0.309 0.387-0.644 0.556-1l2.034 2.419-2.069 3.103 0.831 0.556 2.278-3.416c0.122-0.184 0.109-0.428-0.034-0.6l-2.619-3.116c0.119-0.35 0.225-0.716 0.312-1.097 0.237-1.003 0.375-2.119 0.413-3.319l2.106 0.3 1.041 4.159 0.969-0.244-1.122-4.484zM15.612 17.025c-0.856 1.309-2.069 1.975-3.612 1.975s-2.756-0.666-3.612-1.975c-0.906-1.394-1.387-3.478-1.387-6.025 0-1.431 0.084-2.213 0.281-2.613 0.138-0.278 0.372-0.434 1.062-0.837 0.331-0.194 0.744-0.438 1.219-0.759 0.275-0.188 0.438-0.497 0.438-0.828v-1.962c0-1.103 0.897-2 2-2s2 0.897 2 2v1.962c0 0.331 0.166 0.641 0.438 0.828 0.475 0.322 0.888 0.566 1.219 0.759 0.687 0.403 0.922 0.556 1.059 0.837 0.197 0.4 0.281 1.181 0.281 2.616 0.003 2.544-0.478 4.628-1.384 6.022z" })
        );
    }
    function Bug({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BugSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bug.SVG = BugSVG;
    return Bug;
})();
export const Bug2 = /*#__PURE__*/ (() => {
    function Bug2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.984 11.378c-0.050-0.197-0.213-0.344-0.416-0.375l-2.572-0.369c-0.019-1.597-0.156-2.466-0.488-3.138-0.219-0.441-0.503-0.756-0.837-1.025l2.984-0.987c0.203-0.069 0.344-0.259 0.344-0.475v-4.009h-1v3.65l-3.406 1.131c-0.184-0.109-0.381-0.225-0.594-0.359v-1.422c0-2.206-1.794-4-4-4s-4 1.794-4 4v1.422c-0.213 0.134-0.409 0.25-0.594 0.359l-3.406-1.128v-3.653h-1v4.012c0 0.216 0.138 0.406 0.344 0.475l2.984 0.991c-0.334 0.266-0.622 0.584-0.837 1.025-0.331 0.672-0.472 1.541-0.487 3.138l-2.572 0.369c-0.2 0.028-0.366 0.175-0.416 0.375l-1.122 4.478 0.969 0.244 1.041-4.159 2.106-0.3c0.037 1.2 0.175 2.316 0.412 3.319 0.091 0.381 0.194 0.747 0.312 1.097l-2.619 3.116c-0.144 0.169-0.156 0.416-0.034 0.6l2.278 3.416 0.831-0.556-2.066-3.103 2.034-2.419c0.169 0.356 0.353 0.691 0.556 1 1.228 1.887 3.056 2.884 5.284 2.884s4.056-0.997 5.287-2.884c0.203-0.309 0.387-0.644 0.556-1l2.034 2.419-2.069 3.103 0.831 0.556 2.278-3.416c0.122-0.184 0.109-0.428-0.034-0.6l-2.619-3.116c0.119-0.35 0.225-0.716 0.312-1.097 0.237-1.003 0.375-2.119 0.413-3.319l2.106 0.3 1.041 4.159 0.969-0.244-1.122-4.484zM12 2c1.103 0 2 0.897 2 2v1.184c-0.647-0.122-1.316-0.184-2-0.184s-1.353 0.063-2 0.184v-1.184c0-1.103 0.897-2 2-2zM7 11c0-1.431 0.084-2.213 0.281-2.613 0.138-0.278 0.372-0.434 1.062-0.837 0.331-0.194 0.744-0.438 1.219-0.759 0.203-0.138 0.347-0.347 0.406-0.578 0.334-0.072 0.678-0.125 1.028-0.162-0.056 4.972-0.875 9.456-2.091 11.644-0.184-0.2-0.359-0.425-0.519-0.669-0.906-1.394-1.388-3.478-1.388-6.025zM9.681 18.35c0.738-1.256 1.222-2.994 1.516-4.366 0.5-2.334 0.775-5.084 0.803-7.988 0 0 0 0 0.003 0 0 0 0.003 0 0.003 0 0.028 2.897 0.303 5.65 0.803 7.984 0.294 1.372 0.778 3.109 1.512 4.366-0.663 0.434-1.441 0.653-2.322 0.653s-1.656-0.219-2.319-0.65zM15.612 17.025c-0.159 0.247-0.334 0.469-0.519 0.669-1.212-2.191-2.034-6.675-2.091-11.644 0.35 0.034 0.694 0.087 1.028 0.162 0.059 0.234 0.203 0.441 0.406 0.578 0.475 0.322 0.888 0.566 1.219 0.759 0.687 0.403 0.922 0.556 1.059 0.837 0.197 0.4 0.281 1.181 0.281 2.616 0.003 2.544-0.478 4.628-1.384 6.022z" })
        );
    }
    function Bug2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bug2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bug2.SVG = Bug2SVG;
    return Bug2;
})();
export const Burger = /*#__PURE__*/ (() => {
        function BurgerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.775 5.119c-0.678-0.706-1.634-1.309-2.838-1.797-2.112-0.853-4.931-1.322-7.938-1.322s-5.825 0.469-7.938 1.322c-1.203 0.488-2.159 1.091-2.838 1.797-0.813 0.844-1.225 1.812-1.225 2.881v1.5c0 0.275 0.225 0.5 0.5 0.5h23c0.275 0 0.5-0.225 0.5-0.5v-1.5c0-1.069-0.413-2.037-1.225-2.881zM2 9v-1c0-0.112 0.009-0.225 0.028-0.331 0.069 0.194 0.253 0.331 0.472 0.331 0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5c-0.094 0-0.181 0.025-0.256 0.069 0.481-0.881 1.597-1.5 2.569-1.894 0.912-0.369 2.016-0.659 3.222-0.863-0.022 0.056-0.034 0.119-0.034 0.184 0 0.275 0.225 0.5 0.5 0.5s0.5-0.225 0.5-0.5c0-0.116-0.041-0.225-0.106-0.309 0.994-0.125 2.044-0.191 3.106-0.191 0.747 0 1.488 0.031 2.206 0.094-0.125 0.091-0.206 0.237-0.206 0.406 0 0.275 0.225 0.5 0.5 0.5s0.5-0.225 0.5-0.5c0-0.131-0.050-0.25-0.131-0.338 1.638 0.188 3.134 0.537 4.319 1.016 1.284 0.519 2.813 1.428 2.813 2.822v1h-20z" }),
_('path', { d: "M16.1 11.2c-0.384 0.509-0.625 0.8-1.1 0.8s-0.716-0.291-1.1-0.8c-0.4-0.534-0.9-1.2-1.9-1.2s-1.5 0.666-1.9 1.2c-0.384 0.509-0.625 0.8-1.1 0.8-0.478 0-0.716-0.291-1.1-0.8-0.4-0.534-0.9-1.2-1.9-1.2s-1.5 0.666-1.9 1.2c-0.384 0.509-0.622 0.8-1.1 0.8s-0.716-0.291-1.1-0.8l-0.3-0.4-0.8 0.6 0.3 0.4c0.4 0.534 0.9 1.2 1.9 1.2s1.5-0.666 1.9-1.2c0.384-0.509 0.622-0.8 1.1-0.8s0.716 0.291 1.1 0.8c0.4 0.534 0.9 1.2 1.9 1.2s1.5-0.666 1.9-1.2c0.384-0.509 0.622-0.8 1.1-0.8s0.716 0.291 1.1 0.8c0.4 0.534 0.9 1.2 1.9 1.2s1.5-0.666 1.9-1.2c0.384-0.509 0.622-0.8 1.1-0.8s0.716 0.291 1.1 0.8c0.4 0.534 0.9 1.2 1.9 1.2s1.5-0.666 1.9-1.2l0.3-0.4-0.8-0.6-0.3 0.4c-0.384 0.509-0.622 0.8-1.1 0.8s-0.716-0.291-1.1-0.8c-0.4-0.534-0.9-1.2-1.9-1.2s-1.5 0.666-1.9 1.2z" }),
_('path', { d: "M1.5 13c-0.722 0-1.078 0.381-1.25 0.703-0.169 0.316-0.25 0.728-0.25 1.297s0.078 0.984 0.25 1.297c0.172 0.319 0.531 0.703 1.25 0.703h-1c-0.275 0-0.5 0.225-0.5 0.5v1.5c0 1.653 1.347 3 3 3h18c1.653 0 3-1.347 3-3v-1.5c0-0.275-0.225-0.5-0.5-0.5h-1c0.722 0 1.078-0.381 1.25-0.703 0.169-0.316 0.25-0.728 0.25-1.297s-0.078-0.984-0.25-1.297c-0.172-0.319-0.531-0.703-1.25-0.703h-21zM22 19c0 0.55-0.45 1-1 1h-18c-0.55 0-1-0.45-1-1v-1h20v1zM22.5 14c0.234 0 0.5 0 0.5 1s-0.266 1-0.5 1h-21c-0.234 0-0.5 0-0.5-1s0.266-1 0.5-1h21z" }),
_('path', { d: "M6 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M9 7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M12 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M15 7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M18 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M21 7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Burger({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BurgerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Burger.SVG = BurgerSVG;
        return Burger;
    })();
export const Bus = /*#__PURE__*/ (() => {
        function BusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.603 6.684c-1.050-1.731-2.331-2.684-3.603-2.684h-17c-1.103 0-2 0.897-2 2v11c0 1.103 0.897 2 2 2h1.5v-0.003c0.456 0.606 1.184 1.003 2 1.003s1.544-0.394 2-1.003v0.003l9-0.003c0.456 0.606 1.184 1.003 2 1.003s1.544-0.394 2-1.003v0.003h0.5c1.653 0 3-1.347 3-3v-5c0-1.244-0.534-2.897-1.397-4.316zM5.5 19c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM18.5 19c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM21 17h-0.050c-0.231-1.141-1.244-2-2.45-2s-2.219 0.859-2.45 2h-8.1c-0.231-1.141-1.244-2-2.45-2s-2.219 0.859-2.45 2h-1.050v-1h1v-2h-1v-8h17c0.422 0 1.172 0.534 1.897 1.722 0.659 1.091 1.103 2.406 1.103 3.278v3h-1v1h1v1c0 0.55-0.45 1-1 1z" }),
_('path', { d: "M21 11c0-0.469-0.222-1.372-0.722-2.337-0.431-0.825-0.894-1.35-1.181-1.563-0.087-0.063-0.191-0.1-0.297-0.1h-15.3c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-0.5zM12 8h3v3h-3v-3zM11 11h-3v-3h3v3zM4 8h3v3h-3v-3zM16 11v-3h2.609c0.181 0.178 0.478 0.544 0.781 1.125 0.444 0.859 0.609 1.606 0.609 1.875h-4z" }),
_('path', { d: "M9 14h6v1h-6v-1z" })
            );
        }
        function Bus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bus.SVG = BusSVG;
        return Bus;
    })();
export const Bus2 = /*#__PURE__*/ (() => {
        function Bus2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.5 5h-2.5v-1.209c0-0.941-0.641-1.744-1.559-1.95-2.469-0.556-4.972-0.841-7.441-0.841h-0.006c-2.466 0-4.969 0.281-7.434 0.837-0.441 0.1-0.837 0.35-1.122 0.703-0.281 0.353-0.438 0.797-0.438 1.25v1.209h-2.5c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5-0.225 0.5-0.5v-3.5h1v12c0 0.738 0.403 1.384 1 1.731v1.769c0 0.828 0.672 1.5 1.5 1.5h1c0.828 0 1.5-0.672 1.5-1.5v-1.5h8v1.5c0 0.828 0.672 1.5 1.5 1.5h1c0.828 0 1.5-0.672 1.5-1.5v-1.769c0.597-0.347 1-0.994 1-1.731v-12h1v3.5c0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5zM5 3.791v0c2.322-0.525 4.659-0.788 6.997-0.788 2.341 0 4.681 0.263 7.003 0.788v14.209h-14v-14.209zM7 21.5c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1.5h2v1.5zM19 21.5c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1.5h2v1.5z" }),
_('path', { d: "M17.591 4.522c-1.859-0.347-3.741-0.522-5.591-0.522s-3.731 0.175-5.591 0.522c-0.237 0.044-0.409 0.25-0.409 0.491v6.488c0 0.275 0.225 0.5 0.5 0.5h11c0.275 0 0.5-0.225 0.5-0.5v-6.487c0-0.241-0.172-0.447-0.409-0.491zM17 11h-2.85l2.044-1.362-0.553-0.831-3.294 2.194h-3.197l2.044-1.362-0.553-0.831-3.294 2.194h-0.347v-5.569c1.669-0.288 3.347-0.431 5-0.431s3.331 0.144 5 0.431v5.569z" }),
_('path', { d: "M16 13c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM16 16c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M8 13c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM8 16c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
            );
        }
        function Bus2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Bus2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bus2.SVG = Bus2SVG;
        return Bus2;
    })();
export const BusinessCard = /*#__PURE__*/ (() => {
        function BusinessCardSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-20c-1.103 0-2 0.897-2 2v12c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-12c0-1.103-0.897-2-2-2zM22 18h-20v-12h20v12c0.003 0 0 0 0 0z" }),
_('path', { d: "M13 8h8v1h-8v-1z" }),
_('path', { d: "M13 10h6v1h-6v-1z" }),
_('path', { d: "M13 12h8v1h-8v-1z" }),
_('path', { d: "M13 14h8v1h-8v-1z" }),
_('path', { d: "M9.322 12.578c-0.147-0.087-0.3-0.162-0.456-0.231 0.691-0.55 1.134-1.397 1.134-2.347 0-1.653-1.347-3-3-3s-3 1.347-3 3c0 0.95 0.444 1.797 1.134 2.347-0.156 0.066-0.309 0.144-0.456 0.231-0.631 0.372-1.156 0.916-1.606 1.666-0.141 0.231-0.069 0.534 0.159 0.681 1.144 0.722 2.378 1.075 3.769 1.075s2.625-0.353 3.769-1.078c0.228-0.147 0.3-0.447 0.159-0.681-0.45-0.747-0.975-1.291-1.606-1.662zM5 10c0-1.103 0.897-2 2-2s2 0.897 2 2-0.897 2-2 2-2-0.897-2-2zM7 15c-1.019 0-1.934-0.219-2.787-0.666 0.691-0.919 1.569-1.334 2.787-1.334s2.097 0.416 2.787 1.334c-0.853 0.447-1.769 0.666-2.787 0.666z" })
            );
        }
        function BusinessCard({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BusinessCardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BusinessCard.SVG = BusinessCardSVG;
        return BusinessCard;
    })();
export const Button = /*#__PURE__*/ (() => {
        function ButtonSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M13.984 10.722c0.297 0.175 0.644 0.278 1.016 0.278 1.103 0 2-0.897 2-2s-0.897-2-2-2-2 0.897-2 2c0 0.372 0.1 0.719 0.278 1.016l-1.278 1.278-1.278-1.278c0.175-0.297 0.278-0.644 0.278-1.016 0-1.103-0.897-2-2-2s-2 0.897-2 2 0.897 2 2 2c0.372 0 0.719-0.1 1.016-0.278l1.278 1.278-1.278 1.278c-0.297-0.175-0.644-0.278-1.016-0.278-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2c0-0.372-0.1-0.719-0.278-1.016l1.278-1.278 1.278 1.278c-0.175 0.297-0.278 0.644-0.278 1.016 0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2c-0.372 0-0.719 0.1-1.016 0.278l-1.278-1.278 1.278-1.278zM14 9c0-0.55 0.45-1 1-1s1 0.45 1 1-0.45 1-1 1c-0.091 0-0.175-0.012-0.259-0.034l0.466-0.466-0.706-0.706-0.466 0.466c-0.022-0.084-0.034-0.169-0.034-0.259zM9 10c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1c0 0.091-0.012 0.175-0.034 0.259l-0.466-0.466-0.706 0.706 0.466 0.466c-0.084 0.022-0.169 0.034-0.259 0.034zM10 15c0 0.55-0.45 1-1 1s-1-0.45-1-1 0.45-1 1-1c0.091 0 0.175 0.012 0.259 0.034l-0.466 0.466 0.706 0.706 0.466-0.466c0.022 0.084 0.034 0.169 0.034 0.259zM15 14c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1c0-0.091 0.012-0.175 0.034-0.259l0.466 0.466 0.706-0.706-0.466-0.466c0.084-0.022 0.169-0.034 0.259-0.034z" })
            );
        }
        function Button({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ButtonSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Button.SVG = ButtonSVG;
        return Button;
    })();
export const Button2 = /*#__PURE__*/ (() => {
        function Button2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M9 7c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM9 10c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M9 13c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM9 16c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M15 13c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM15 16c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M15 7c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM15 10c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
            );
        }
        function Button2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Button2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Button2.SVG = Button2SVG;
        return Button2;
    })();
export const Cabinet = /*#__PURE__*/ (() => {
        function CabinetSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 0h-12c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM18 22h-12v-20h12v20c0 0 0 0 0 0z" }),
_('path', { d: "M16.5 3h-9c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h9c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM8 9h8v5h-8v-5zM8 4h8v4h-8v-4zM16 20h-8v-5h8v5z" }),
_('path', { d: "M11 10h2v1h-2v-1z" }),
_('path', { d: "M11 5h2v1h-2v-1z" }),
_('path', { d: "M11 16h2v1h-2v-1z" })
            );
        }
        function Cabinet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CabinetSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cabinet.SVG = CabinetSVG;
        return Cabinet;
    })();
export const Cable = /*#__PURE__*/ (() => {
    function CableSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17.5 4c-2.481 0-4.5 2.019-4.5 4.5v10.5c0 1.653-1.347 3-3 3-1.437 0-2.644-1.019-2.934-2.372 1.147-0.575 1.934-1.762 1.934-3.128v-6c0-0.275-0.225-0.5-0.5-0.5h-1.5v-8.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5v8.5h-1.5c-0.275 0-0.5 0.225-0.5 0.5v6c0 1.794 1.356 3.275 3.097 3.478 0.453 2.291 2.481 4.022 4.903 4.022 2.756 0 5-2.244 5-5v-10.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5v15.5h2v-15.5c0-2.481-2.019-4.5-4.5-4.5zM5.5 1c0.275 0 0.5 0.225 0.5 0.5v1.5h-1v-1.5c0-0.275 0.225-0.5 0.5-0.5zM5 4h1v6h-1v-6zM4 16.5v-5.5h3v5.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5z" })
        );
    }
    function Cable({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CableSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cable.SVG = CableSVG;
    return Cable;
})();
export const Cactus = /*#__PURE__*/ (() => {
        function CactusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h1v1h-1v-1z" }),
_('path', { d: "M12 8h1v1h-1v-1z" }),
_('path', { d: "M11 12h1v1h-1v-1z" }),
_('path', { d: "M24 12v-1h-1.034c0.022-0.328 0.034-0.663 0.034-1 0-1.303-0.837-2.416-2-2.828v-1.172h-1v1c-0.647 0-1.247 0.206-1.737 0.556l-0.762-0.762-0.706 0.706 0.762 0.762c-0.35 0.491-0.556 1.091-0.556 1.737 0 1.375-0.197 2.947-1 3.641v-9.641c0-0.394-0.056-0.772-0.162-1.131l1.369-1.369-0.706-0.706-1.1 1.1c-0.706-1.137-1.966-1.894-3.4-1.894-1.178 0-2.238 0.513-2.969 1.322l-0.531-0.531-0.706 0.709 0.656 0.656c-0.288 0.553-0.45 1.178-0.45 1.844v4.641c-0.803-0.694-1-2.266-1-3.641 0-1.159-0.663-2.169-1.625-2.666l0.831-0.834-0.706-0.706-1.219 1.219c-0.091-0.009-0.184-0.012-0.281-0.012-0.35 0-0.687 0.059-1 0.172v-1.172h-1v1.766c-0.612 0.55-1 1.347-1 2.234h-1v1h1.034c0.103 1.544 0.453 2.988 1.016 4.244l-1.256 1.256 0.706 0.706 1.028-1.028c0.159 0.272 0.328 0.531 0.509 0.778 0.478 0.653 1.028 1.206 1.641 1.656l-0.884 0.888 0.706 0.706 1.047-1.047c0.009 0.006 0.019 0.009 0.031 0.016 0.75 0.397 1.563 0.65 2.425 0.759v8.063h-2v1h12v-1h-2v-3.063c0.863-0.109 1.675-0.366 2.425-0.759 0.009-0.006 0.019-0.009 0.031-0.016l1.047 1.047 0.706-0.706-0.884-0.884c0.612-0.45 1.162-1.006 1.641-1.656 0.181-0.247 0.35-0.506 0.509-0.778l1.028 1.028 0.706-0.706-1.256-1.256c0.441-0.981 0.747-2.078 0.912-3.244h1.131zM19.35 15.772c-1.072 1.456-2.575 2.228-4.35 2.228-0.553 0-1 0.447-1 1v4h-4v-9c0-0.553-0.447-1-1-1-1.775 0-3.278-0.772-4.35-2.228-1.066-1.447-1.65-3.497-1.65-5.772 0-0.55 0.45-1 1-1s1 0.45 1 1c0 1.659 0.266 3.003 0.784 4 0.325 0.619 0.75 1.106 1.266 1.444 0.563 0.369 1.219 0.556 1.95 0.556 0.553 0 1-0.447 1-1v-6c0-1.103 0.897-2 2-2s2 0.897 2 2v11c0 0.553 0.447 1 1 1 0.731 0 1.388-0.188 1.95-0.556 0.516-0.338 0.941-0.825 1.266-1.444 0.522-0.997 0.784-2.341 0.784-4 0-0.55 0.45-1 1-1s1 0.45 1 1c0 2.275-0.584 4.325-1.65 5.772z" })
            );
        }
        function Cactus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CactusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cactus.SVG = CactusSVG;
        return Cactus;
    })();
export const Cake = /*#__PURE__*/ (() => {
    function CakeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.906 9.472c-0.556-0.459-1.331-0.872-2.306-1.225-1.737-0.628-4.069-1.050-6.603-1.194v-1.053c0-0.213-0.1-0.6-0.781-0.828-0.328-0.109-0.75-0.169-1.194-0.172 0.006 0 0.016 0 0.022 0 0.237 0 0.484-0.034 0.728-0.106 0.131-0.034 0.738-0.216 1.050-0.794 0.153-0.284 0.284-0.762 0.034-1.444v0c-0.403-1.1 0.012-1.831 0.047-1.887 0.109-0.166 0.109-0.372 0.003-0.541s-0.306-0.253-0.5-0.222c-0.034 0.006-0.828 0.131-1.634 0.516-1.159 0.559-1.772 1.384-1.772 2.391 0 0.706 0.281 1.306 0.791 1.688 0.35 0.259 0.775 0.397 1.234 0.4-0.009 0-0.016 0-0.025 0-0.453 0-0.884 0.063-1.219 0.172-0.681 0.228-0.781 0.616-0.781 0.828v1.056c-2.534 0.144-4.863 0.563-6.603 1.194-0.972 0.353-1.75 0.762-2.306 1.225-0.9 0.744-1.091 1.512-1.091 2.025v8c0 0.994 0.681 2.397 3.919 3.428 2.172 0.691 5.044 1.072 8.081 1.072s5.909-0.381 8.081-1.072c3.237-1.031 3.919-2.434 3.919-3.428v-8c0-0.513-0.191-1.281-1.094-2.028zM11 2.913c0-0.931 0.978-1.447 1.725-1.7-0.075 0.469-0.066 1.081 0.194 1.791 0.097 0.262 0.106 0.469 0.028 0.619-0.112 0.213-0.391 0.297-0.419 0.303-0.012 0.003-0.016 0.003-0.028 0.006-0.425 0.125-0.828 0.078-1.113-0.131-0.253-0.191-0.387-0.497-0.387-0.888zM11 6.156c0.156-0.069 0.513-0.156 1-0.156s0.844 0.087 1 0.156v4.688c-0.156 0.069-0.513 0.156-1 0.156s-0.844-0.087-1-0.156v-4.688zM4.078 10.128c1.537-0.556 3.622-0.931 5.922-1.069v1.941c0 0.213 0.1 0.6 0.781 0.828 0.334 0.113 0.766 0.172 1.219 0.172s0.884-0.063 1.219-0.172c0.681-0.228 0.781-0.616 0.781-0.828v-1.941c2.3 0.138 4.384 0.516 5.922 1.069 1.697 0.612 2.078 1.209 2.078 1.372 0 0.234-0.619 0.916-2.525 1.522-1.981 0.631-4.638 0.978-7.475 0.978s-5.494-0.347-7.475-0.978c-1.909-0.606-2.525-1.287-2.525-1.522 0-0.159 0.381-0.756 2.078-1.372zM22 16.019c-0.428 0.044-0.897 0.109-1.309 0.319-0.384 0.197-0.653 0.572-0.912 0.934-0.253 0.353-0.519 0.722-0.816 0.809-0.2 0.059-0.569-0.069-0.925-0.194-0.469-0.166-1-0.353-1.531-0.259-0.481 0.084-0.872 0.409-1.247 0.725-0.312 0.262-0.638 0.531-0.909 0.553-0.228 0.019-0.572-0.181-0.906-0.375-0.428-0.25-0.912-0.531-1.441-0.531s-1.012 0.281-1.437 0.531c-0.331 0.194-0.675 0.394-0.9 0.375-0.269-0.022-0.594-0.291-0.906-0.553-0.378-0.316-0.766-0.641-1.247-0.725-0.531-0.091-1.062 0.097-1.528 0.262-0.356 0.125-0.722 0.256-0.922 0.197-0.297-0.087-0.559-0.453-0.813-0.806-0.262-0.363-0.531-0.738-0.916-0.934-0.419-0.213-0.894-0.272-1.328-0.316v-1.903c0.509 0.281 1.141 0.55 1.919 0.797 2.166 0.694 5.037 1.075 8.075 1.075s5.909-0.381 8.081-1.072c0.778-0.247 1.409-0.516 1.919-0.797v1.887zM19.475 21.022c-1.981 0.631-4.638 0.978-7.475 0.978s-5.494-0.347-7.475-0.978c-1.909-0.606-2.525-1.287-2.525-1.522v-2.463c0.322 0.034 0.638 0.081 0.875 0.2 0.169 0.084 0.366 0.359 0.556 0.628 0.334 0.466 0.716 0.997 1.338 1.181 0.513 0.153 1.034-0.034 1.541-0.213 0.369-0.131 0.753-0.266 1.025-0.219 0.216 0.038 0.5 0.275 0.778 0.506 0.412 0.344 0.881 0.734 1.466 0.781 0.038 0.003 0.075 0.003 0.113 0.003 0.497 0 0.941-0.259 1.375-0.513 0.331-0.194 0.675-0.394 0.934-0.394s0.603 0.2 0.938 0.394c0.466 0.272 0.947 0.553 1.491 0.509 0.588-0.047 1.056-0.438 1.469-0.784 0.278-0.231 0.563-0.469 0.781-0.506 0.275-0.047 0.656 0.087 1.028 0.219 0.506 0.178 1.031 0.363 1.544 0.209 0.625-0.188 1.006-0.716 1.341-1.184 0.191-0.266 0.391-0.541 0.556-0.628 0.231-0.119 0.537-0.169 0.853-0.203v2.475c0 0.234-0.616 0.916-2.525 1.522z" })
        );
    }
    function Cake({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CakeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cake.SVG = CakeSVG;
    return Cake;
})();
export const Calculator = /*#__PURE__*/ (() => {
        function CalculatorSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 13h-7c-1.103 0-2 0.897-2 2v7c0 1.103 0.897 2 2 2h7c1.103 0 2-0.897 2-2v-7c0-1.103-0.897-2-2-2zM9 22h-7v-7h7v7z" }),
_('path', { d: "M9 0h-7c-1.103 0-2 0.897-2 2v7c0 1.103 0.897 2 2 2h7c1.103 0 2-0.897 2-2v-7c0-1.103-0.897-2-2-2zM9 9h-7v-7h7v7z" }),
_('path', { d: "M22 13h-7c-1.103 0-2 0.897-2 2v7c0 1.103 0.897 2 2 2h7c1.103 0 2-0.897 2-2v-7c0-1.103-0.897-2-2-2zM22 22h-7v-7h7v7z" }),
_('path', { d: "M22 0h-7c-1.103 0-2 0.897-2 2v7c0 1.103 0.897 2 2 2h7c1.103 0 2-0.897 2-2v-7c0-1.103-0.897-2-2-2zM22 9h-7v-7h7v7z" }),
_('path', { d: "M5 8h1v-2h2v-1h-2v-2h-1v2h-2v1h2z" }),
_('path', { d: "M16 5h5v1h-5v-1z" }),
_('path', { d: "M16 19h5v1h-5v-1z" }),
_('path', { d: "M16 17h5v1h-5v-1z" }),
_('path', { d: "M3.5 21.206l2-2 2 2 0.706-0.706-2-2 2-2-0.706-0.706-2 2-2-2-0.706 0.706 2 2-2 2z" })
            );
        }
        function Calculator({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CalculatorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Calculator.SVG = CalculatorSVG;
        return Calculator;
    })();
export const Calculator2 = /*#__PURE__*/ (() => {
        function Calculator2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 0h-16c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h16c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM20 22h-16v-20h16v20c0 0 0 0 0 0z" }),
_('path', { d: "M18.5 3h-13c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h13c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5zM18 8h-12v-4h12v4z" }),
_('path', { d: "M8.5 10h-3c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5zM8 12h-2v-1h2v1z" }),
_('path', { d: "M18.5 10h-3c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5zM18 12h-2v-1h2v1z" }),
_('path', { d: "M8.5 14h-3c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5zM8 16h-2v-1h2v1z" }),
_('path', { d: "M13.5 14h-3c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5zM13 16h-2v-1h2v1z" }),
_('path', { d: "M8.5 18h-3c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5zM8 20h-2v-1h2v1z" }),
_('path', { d: "M13.5 18h-3c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5zM13 20h-2v-1h2v1z" }),
_('path', { d: "M18.5 14h-3c-0.275 0-0.5 0.225-0.5 0.5v6c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-6c0-0.275-0.225-0.5-0.5-0.5zM18 20h-2v-5h2v5z" }),
_('path', { d: "M13.5 10h-3c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5zM13 12h-2v-1h2v1z" })
            );
        }
        function Calculator2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Calculator2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Calculator2.SVG = Calculator2SVG;
        return Calculator2;
    })();
export const CalendarCheck = /*#__PURE__*/ (() => {
        function CalendarCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 1h5v2h-5v-2z" }),
_('path', { d: "M9 1h6v2h-6v-2z" }),
_('path', { d: "M19 1h5v2h-5v-2z" }),
_('path', { d: "M6 0h2v7h-2v-7z" }),
_('path', { d: "M16 0h2v7h-2v-7z" }),
_('path', { d: "M9 4h6v2h-6v-2z" }),
_('path', { d: "M11 9h2v1h-2v-1z" }),
_('path', { d: "M14 9h2v1h-2v-1z" }),
_('path', { d: "M17 9h2v1h-2v-1z" }),
_('path', { d: "M8 11h2v1h-2v-1z" }),
_('path', { d: "M11 11h2v1h-2v-1z" }),
_('path', { d: "M5 11h2v1h-2v-1z" }),
_('path', { d: "M8 13h2v1h-2v-1z" }),
_('path', { d: "M5 13h2v1h-2v-1z" }),
_('path', { d: "M8 15h2v1h-2v-1z" }),
_('path', { d: "M5 15h2v1h-2v-1z" }),
_('path', { d: "M8 17h2v1h-2v-1z" }),
_('path', { d: "M8 19h2v1h-2v-1z" }),
_('path', { d: "M22 4h-3v2h3v6.813c-1.169-1.122-2.756-1.812-4.5-1.812-3.584 0-6.5 2.916-6.5 6.5 0 1.744 0.691 3.331 1.812 4.5h-5.813v-4.5c0-0.275-0.225-0.5-0.5-0.5h-4.5v-11h3v-2h-3c-1.103 0-2 0.897-2 2v11c0 3.859 3.141 7 7 7h10.5c3.584 0 6.5-2.916 6.5-6.5v-11.5c0-1.103-0.897-2-2-2zM2.1 18h3.9v3.9c-1.956-0.4-3.5-1.944-3.9-3.9zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16.5 18.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4z" })
            );
        }
        function CalendarCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CalendarCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CalendarCheck.SVG = CalendarCheckSVG;
        return CalendarCheck;
    })();
export const CalendarCross = /*#__PURE__*/ (() => {
        function CalendarCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 1h5v2h-5v-2z" }),
_('path', { d: "M9 1h6v2h-6v-2z" }),
_('path', { d: "M19 1h5v2h-5v-2z" }),
_('path', { d: "M6 0h2v7h-2v-7z" }),
_('path', { d: "M16 0h2v7h-2v-7z" }),
_('path', { d: "M9 4h6v2h-6v-2z" }),
_('path', { d: "M11 9h2v1h-2v-1z" }),
_('path', { d: "M14 9h2v1h-2v-1z" }),
_('path', { d: "M17 9h2v1h-2v-1z" }),
_('path', { d: "M8 11h2v1h-2v-1z" }),
_('path', { d: "M11 11h2v1h-2v-1z" }),
_('path', { d: "M5 11h2v1h-2v-1z" }),
_('path', { d: "M8 13h2v1h-2v-1z" }),
_('path', { d: "M5 13h2v1h-2v-1z" }),
_('path', { d: "M8 15h2v1h-2v-1z" }),
_('path', { d: "M5 15h2v1h-2v-1z" }),
_('path', { d: "M8 17h2v1h-2v-1z" }),
_('path', { d: "M8 19h2v1h-2v-1z" }),
_('path', { d: "M22 4h-3v2h3v6.813c-1.169-1.122-2.756-1.812-4.5-1.812-3.584 0-6.5 2.916-6.5 6.5 0 1.744 0.691 3.331 1.812 4.5h-5.813v-4.5c0-0.275-0.225-0.5-0.5-0.5h-4.5v-11h3v-2h-3c-1.103 0-2 0.897-2 2v11c0 1.869 0.728 3.628 2.050 4.95s3.081 2.050 4.95 2.050h10.5c3.584 0 6.5-2.916 6.5-6.5v-11.5c0-1.103-0.897-2-2-2zM2.1 18h3.9v3.9c-1.956-0.4-3.5-1.944-3.9-3.9zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 14.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function CalendarCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CalendarCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CalendarCross.SVG = CalendarCrossSVG;
        return CalendarCross;
    })();
export const CalendarMinus = /*#__PURE__*/ (() => {
        function CalendarMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 1h5v2h-5v-2z" }),
_('path', { d: "M9 1h6v2h-6v-2z" }),
_('path', { d: "M19 1h5v2h-5v-2z" }),
_('path', { d: "M6 0h2v7h-2v-7z" }),
_('path', { d: "M16 0h2v7h-2v-7z" }),
_('path', { d: "M9 4h6v2h-6v-2z" }),
_('path', { d: "M11 9h2v1h-2v-1z" }),
_('path', { d: "M14 9h2v1h-2v-1z" }),
_('path', { d: "M17 9h2v1h-2v-1z" }),
_('path', { d: "M8 11h2v1h-2v-1z" }),
_('path', { d: "M11 11h2v1h-2v-1z" }),
_('path', { d: "M5 11h2v1h-2v-1z" }),
_('path', { d: "M8 13h2v1h-2v-1z" }),
_('path', { d: "M5 13h2v1h-2v-1z" }),
_('path', { d: "M8 15h2v1h-2v-1z" }),
_('path', { d: "M5 15h2v1h-2v-1z" }),
_('path', { d: "M8 17h2v1h-2v-1z" }),
_('path', { d: "M8 19h2v1h-2v-1z" }),
_('path', { d: "M22 4h-3v2h3v6.813c-1.169-1.122-2.756-1.812-4.5-1.812-3.584 0-6.5 2.916-6.5 6.5 0 1.744 0.691 3.331 1.812 4.5h-5.813v-4.5c0-0.275-0.225-0.5-0.5-0.5h-4.5v-11h3v-2h-3c-1.103 0-2 0.897-2 2v11c0 3.859 3.141 7 7 7h10.5c3.584 0 6.5-2.916 6.5-6.5v-11.5c0-1.103-0.897-2-2-2zM2.1 18h3.9v3.9c-1.956-0.4-3.5-1.944-3.9-3.9zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M15 17h5v1h-5v-1z" })
            );
        }
        function CalendarMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CalendarMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CalendarMinus.SVG = CalendarMinusSVG;
        return CalendarMinus;
    })();
export const CalendarPlus = /*#__PURE__*/ (() => {
        function CalendarPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 1h5v2h-5v-2z" }),
_('path', { d: "M9 1h6v2h-6v-2z" }),
_('path', { d: "M19 1h5v2h-5v-2z" }),
_('path', { d: "M6 0h2v7h-2v-7z" }),
_('path', { d: "M16 0h2v7h-2v-7z" }),
_('path', { d: "M9 4h6v2h-6v-2z" }),
_('path', { d: "M11 9h2v1h-2v-1z" }),
_('path', { d: "M14 9h2v1h-2v-1z" }),
_('path', { d: "M17 9h2v1h-2v-1z" }),
_('path', { d: "M8 11h2v1h-2v-1z" }),
_('path', { d: "M11 11h2v1h-2v-1z" }),
_('path', { d: "M5 11h2v1h-2v-1z" }),
_('path', { d: "M8 13h2v1h-2v-1z" }),
_('path', { d: "M5 13h2v1h-2v-1z" }),
_('path', { d: "M8 15h2v1h-2v-1z" }),
_('path', { d: "M5 15h2v1h-2v-1z" }),
_('path', { d: "M8 17h2v1h-2v-1z" }),
_('path', { d: "M8 19h2v1h-2v-1z" }),
_('path', { d: "M22 4h-3v2h3v6.813c-1.169-1.122-2.756-1.812-4.5-1.812-3.584 0-6.5 2.916-6.5 6.5 0 1.744 0.691 3.331 1.812 4.5h-5.813v-4.5c0-0.275-0.225-0.5-0.5-0.5h-4.5v-11h3v-2h-3c-1.103 0-2 0.897-2 2v11c0 3.859 3.141 7 7 7h10.5c3.584 0 6.5-2.916 6.5-6.5v-11.5c0-1.103-0.897-2-2-2zM2.1 18h3.9v3.9c-1.956-0.4-3.5-1.944-3.9-3.9zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18 15h-1v2h-2v1h2v2h1v-2h2v-1h-2z" })
            );
        }
        function CalendarPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CalendarPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CalendarPlus.SVG = CalendarPlusSVG;
        return CalendarPlus;
    })();
export const CalendarTime = /*#__PURE__*/ (() => {
        function CalendarTimeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 1h5v2h-5v-2z" }),
_('path', { d: "M9 1h6v2h-6v-2z" }),
_('path', { d: "M19 1h5v2h-5v-2z" }),
_('path', { d: "M6 0h2v7h-2v-7z" }),
_('path', { d: "M16 0h2v7h-2v-7z" }),
_('path', { d: "M9 4h6v2h-6v-2z" }),
_('path', { d: "M11 9h2v1h-2v-1z" }),
_('path', { d: "M14 9h2v1h-2v-1z" }),
_('path', { d: "M17 9h2v1h-2v-1z" }),
_('path', { d: "M8 11h2v1h-2v-1z" }),
_('path', { d: "M11 11h2v1h-2v-1z" }),
_('path', { d: "M5 11h2v1h-2v-1z" }),
_('path', { d: "M8 13h2v1h-2v-1z" }),
_('path', { d: "M5 13h2v1h-2v-1z" }),
_('path', { d: "M8 15h2v1h-2v-1z" }),
_('path', { d: "M5 15h2v1h-2v-1z" }),
_('path', { d: "M8 17h2v1h-2v-1z" }),
_('path', { d: "M8 19h2v1h-2v-1z" }),
_('path', { d: "M22 4h-3v2h3v6.813c-1.169-1.122-2.756-1.812-4.5-1.812-3.584 0-6.5 2.916-6.5 6.5 0 1.744 0.691 3.331 1.812 4.5h-5.813v-4.5c0-0.275-0.225-0.5-0.5-0.5h-4.5v-11h3v-2h-3c-1.103 0-2 0.897-2 2v11c0 3.859 3.141 7 7 7h10.5c3.584 0 6.5-2.916 6.5-6.5v-11.5c0-1.103-0.897-2-2-2zM2.1 18h3.9v3.9c-1.956-0.4-3.5-1.944-3.9-3.9zM18 22.978v-1.978h-1v1.978c-2.634-0.237-4.737-2.344-4.978-4.978h1.978v-1h-1.978c0.237-2.634 2.344-4.737 4.978-4.978v1.978h1v-1.978c2.634 0.237 4.737 2.344 4.978 4.978h-1.978v1h1.978c-0.241 2.634-2.344 4.737-4.978 4.978z" }),
_('path', { d: "M17.422 17.716l-1.922-1.922-0.706 0.706 2.353 2.353c0.094 0.094 0.222 0.147 0.353 0.147 0.016 0 0.034 0 0.050-0.003 0.15-0.016 0.284-0.097 0.366-0.219l2.278-3.416-0.831-0.556-1.941 2.909z" })
            );
        }
        function CalendarTime({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CalendarTimeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CalendarTime.SVG = CalendarTimeSVG;
        return CalendarTime;
    })();
export const CalendarUser = /*#__PURE__*/ (() => {
        function CalendarUserSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 1h5v2h-5v-2z" }),
_('path', { d: "M9 1h6v2h-6v-2z" }),
_('path', { d: "M19 1h5v2h-5v-2z" }),
_('path', { d: "M6 0h2v7h-2v-7z" }),
_('path', { d: "M16 0h2v7h-2v-7z" }),
_('path', { d: "M9 4h6v2h-6v-2z" }),
_('path', { d: "M11 9h2v1h-2v-1z" }),
_('path', { d: "M14 9h2v1h-2v-1z" }),
_('path', { d: "M17 9h2v1h-2v-1z" }),
_('path', { d: "M8 11h2v1h-2v-1z" }),
_('path', { d: "M11 11h2v1h-2v-1z" }),
_('path', { d: "M5 11h2v1h-2v-1z" }),
_('path', { d: "M8 13h2v1h-2v-1z" }),
_('path', { d: "M5 13h2v1h-2v-1z" }),
_('path', { d: "M8 15h2v1h-2v-1z" }),
_('path', { d: "M5 15h2v1h-2v-1z" }),
_('path', { d: "M8 17h2v1h-2v-1z" }),
_('path', { d: "M8 19h2v1h-2v-1z" }),
_('path', { d: "M22 4h-3v2h3v6.813c-1.169-1.122-2.756-1.812-4.5-1.812-3.584 0-6.5 2.916-6.5 6.5 0 1.744 0.691 3.331 1.812 4.5h-5.813v-4.5c0-0.275-0.225-0.5-0.5-0.5h-4.5v-11h3v-2h-3c-1.103 0-2 0.897-2 2v11c0 3.859 3.141 7 7 7h10.5c3.584 0 6.5-2.916 6.5-6.5v-11.5c0-1.103-0.897-2-2-2zM2.1 18h3.9v3.9c-1.956-0.4-3.5-1.944-3.9-3.9zM14.125 21.841c0.412-1.066 1.8-1.841 3.375-1.841s2.959 0.772 3.375 1.841c-0.931 0.728-2.103 1.159-3.375 1.159s-2.444-0.434-3.375-1.159zM15 16.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5-2.5-1.122-2.5-2.5zM21.641 21.119c-0.422-0.769-1.184-1.388-2.131-1.753 0.9-0.634 1.491-1.681 1.491-2.866 0-1.931-1.569-3.5-3.5-3.5s-3.5 1.569-3.5 3.5c0 1.181 0.591 2.231 1.491 2.862-0.947 0.366-1.709 0.981-2.131 1.753-0.847-0.969-1.359-2.234-1.359-3.616 0-3.031 2.469-5.5 5.5-5.5s5.5 2.469 5.5 5.5c0 1.384-0.513 2.65-1.359 3.619z" })
            );
        }
        function CalendarUser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CalendarUserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CalendarUser.SVG = CalendarUserSVG;
        return CalendarUser;
    })();
export const Calendar = /*#__PURE__*/ (() => {
        function CalendarSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 1h5v2h-5v-2z" }),
_('path', { d: "M9 1h6v2h-6v-2z" }),
_('path', { d: "M19 1h5v2h-5v-2z" }),
_('path', { d: "M6 0h2v7h-2v-7z" }),
_('path', { d: "M16 0h2v7h-2v-7z" }),
_('path', { d: "M9 4h6v2h-6v-2z" }),
_('path', { d: "M22 4h-3v2h3v16h-20v-16h3v-2h-3c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-16c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M4 9.5v10c0 0.275 0.225 0.5 0.5 0.5h15c0.275 0 0.5-0.225 0.5-0.5v-10c0-0.275-0.225-0.5-0.5-0.5h-15c-0.275 0-0.5 0.225-0.5 0.5zM5 15h4v4h-4v-4zM14 15v4h-4v-4h4zM10 14v-4h4v4h-4zM15 19v-4h4v4h-4zM19 14h-4v-4h4v4zM9 10v4h-4v-4h4z" })
            );
        }
        function Calendar({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CalendarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Calendar.SVG = CalendarSVG;
        return Calendar;
    })();
export const Calendar2 = /*#__PURE__*/ (() => {
        function Calendar2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 1h5v2h-5v-2z" }),
_('path', { d: "M9 1h6v2h-6v-2z" }),
_('path', { d: "M19 1h5v2h-5v-2z" }),
_('path', { d: "M6 0h2v7h-2v-7z" }),
_('path', { d: "M16 0h2v7h-2v-7z" }),
_('path', { d: "M9 4h6v2h-6v-2z" }),
_('path', { d: "M22 4h-3v2h3v16h-20v-16h3v-2h-3c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-16c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M6 18h12v1h-12v-1z" }),
_('path', { d: "M6 20h5v1h-5v-1z" }),
_('path', { d: "M8.109 13.309c-0.987 0.481-2.109 1.022-2.109 2.191 0 0.275 0.225 0.5 0.5 0.5h4.5v-1h-3.772c0.253-0.259 0.709-0.497 1.319-0.791 1.094-0.531 2.453-1.191 2.453-2.709 0-1.641-1.256-2.5-2.5-2.5s-2.5 0.859-2.5 2.5v0.5h1v-0.5c0-1.034 0.753-1.5 1.5-1.5 0.397 0 0.775 0.138 1.044 0.375 0.303 0.269 0.456 0.647 0.456 1.125 0 0.831-0.75 1.256-1.891 1.809z" }),
_('path', { d: "M13 11c0 0.553 0.288 1.088 0.784 1.459 0.019 0.012 0.034 0.025 0.053 0.041-0.019 0.012-0.037 0.025-0.053 0.041-0.5 0.375-0.784 0.906-0.784 1.459s0.288 1.088 0.784 1.459c0.466 0.35 1.075 0.541 1.716 0.541s1.25-0.191 1.716-0.541c0.5-0.375 0.784-0.906 0.784-1.459s-0.288-1.087-0.784-1.459c-0.019-0.012-0.034-0.025-0.053-0.041 0.019-0.012 0.037-0.025 0.053-0.041 0.5-0.375 0.784-0.906 0.784-1.459s-0.288-1.087-0.784-1.459c-0.466-0.35-1.075-0.541-1.716-0.541s-1.25 0.191-1.716 0.541c-0.497 0.372-0.784 0.906-0.784 1.459zM17 14c0 0.541-0.687 1-1.5 1s-1.5-0.459-1.5-1 0.687-1 1.5-1 1.5 0.459 1.5 1zM15.5 10c0.813 0 1.5 0.459 1.5 1s-0.687 1-1.5 1-1.5-0.459-1.5-1 0.687-1 1.5-1z" })
            );
        }
        function Calendar2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Calendar2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Calendar2.SVG = Calendar2SVG;
        return Calendar2;
    })();
export const Calendar3 = /*#__PURE__*/ (() => {
        function Calendar3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 1h5v2h-5v-2z" }),
_('path', { d: "M9 1h6v2h-6v-2z" }),
_('path', { d: "M19 1h5v2h-5v-2z" }),
_('path', { d: "M6 0h2v7h-2v-7z" }),
_('path', { d: "M16 0h2v7h-2v-7z" }),
_('path', { d: "M9 4h6v2h-6v-2z" }),
_('path', { d: "M22 4h-3v2h3v16h-15v-4.5c0-0.275-0.225-0.5-0.5-0.5h-4.5v-11h3v-2h-3c-1.103 0-2 0.897-2 2v11c0 3.859 3.141 7 7 7h15c1.103 0 2-0.897 2-2v-16c0-1.103-0.897-2-2-2zM2.1 18h3.9v3.9c-1.956-0.4-3.5-1.944-3.9-3.9z" }),
_('path', { d: "M8 18h10v1h-10v-1z" }),
_('path', { d: "M8 20h3v1h-3v-1z" }),
_('path', { d: "M8.109 13.309c-0.987 0.481-2.109 1.022-2.109 2.191 0 0.275 0.225 0.5 0.5 0.5h4.5v-1h-3.772c0.253-0.259 0.709-0.497 1.319-0.791 1.094-0.531 2.453-1.191 2.453-2.709 0-1.641-1.256-2.5-2.5-2.5s-2.5 0.859-2.5 2.5v0.5h1v-0.5c0-1.034 0.753-1.5 1.5-1.5 0.397 0 0.775 0.138 1.044 0.375 0.303 0.269 0.456 0.647 0.456 1.125 0 0.831-0.75 1.256-1.891 1.809z" }),
_('path', { d: "M13 11c0 0.553 0.288 1.088 0.784 1.459 0.019 0.012 0.034 0.025 0.053 0.041-0.019 0.012-0.037 0.025-0.053 0.041-0.5 0.375-0.784 0.906-0.784 1.459s0.288 1.088 0.784 1.459c0.466 0.35 1.075 0.541 1.716 0.541s1.25-0.191 1.716-0.541c0.5-0.375 0.784-0.906 0.784-1.459s-0.288-1.087-0.784-1.459c-0.019-0.012-0.034-0.025-0.053-0.041 0.019-0.012 0.037-0.025 0.053-0.041 0.5-0.375 0.784-0.906 0.784-1.459s-0.288-1.087-0.784-1.459c-0.466-0.35-1.075-0.541-1.716-0.541s-1.25 0.191-1.716 0.541c-0.497 0.372-0.784 0.906-0.784 1.459zM17 14c0 0.541-0.687 1-1.5 1s-1.5-0.459-1.5-1 0.687-1 1.5-1 1.5 0.459 1.5 1zM15.5 10c0.813 0 1.5 0.459 1.5 1s-0.687 1-1.5 1-1.5-0.459-1.5-1 0.687-1 1.5-1z" })
            );
        }
        function Calendar3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Calendar3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Calendar3.SVG = Calendar3SVG;
        return Calendar3;
    })();
export const Calendar4 = /*#__PURE__*/ (() => {
        function Calendar4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 1h5v2h-5v-2z" }),
_('path', { d: "M9 1h6v2h-6v-2z" }),
_('path', { d: "M19 1h5v2h-5v-2z" }),
_('path', { d: "M6 0h2v7h-2v-7z" }),
_('path', { d: "M16 0h2v7h-2v-7z" }),
_('path', { d: "M9 4h6v2h-6v-2z" }),
_('path', { d: "M22 4h-3v2h3v16h-15v-4.5c0-0.275-0.225-0.5-0.5-0.5h-4.5v-11h3v-2h-3c-1.103 0-2 0.897-2 2v11c0 3.859 3.141 7 7 7h15c1.103 0 2-0.897 2-2v-16c0-1.103-0.897-2-2-2zM2.1 18h3.9v3.9c-1.956-0.4-3.5-1.944-3.9-3.9z" }),
_('path', { d: "M11 9h2v1h-2v-1z" }),
_('path', { d: "M14 9h2v1h-2v-1z" }),
_('path', { d: "M17 9h2v1h-2v-1z" }),
_('path', { d: "M8 11h2v1h-2v-1z" }),
_('path', { d: "M11 11h2v1h-2v-1z" }),
_('path', { d: "M14 11h2v1h-2v-1z" }),
_('path', { d: "M17 11h2v1h-2v-1z" }),
_('path', { d: "M5 11h2v1h-2v-1z" }),
_('path', { d: "M8 13h2v1h-2v-1z" }),
_('path', { d: "M11 13h2v1h-2v-1z" }),
_('path', { d: "M14 13h2v1h-2v-1z" }),
_('path', { d: "M17 13h2v1h-2v-1z" }),
_('path', { d: "M5 13h2v1h-2v-1z" }),
_('path', { d: "M8 15h2v1h-2v-1z" }),
_('path', { d: "M11 15h2v1h-2v-1z" }),
_('path', { d: "M14 15h2v1h-2v-1z" }),
_('path', { d: "M17 15h2v1h-2v-1z" }),
_('path', { d: "M5 15h2v1h-2v-1z" }),
_('path', { d: "M8 17h2v1h-2v-1z" }),
_('path', { d: "M11 17h2v1h-2v-1z" }),
_('path', { d: "M14 17h2v1h-2v-1z" }),
_('path', { d: "M17 17h2v1h-2v-1z" }),
_('path', { d: "M8 19h2v1h-2v-1z" }),
_('path', { d: "M11 19h2v1h-2v-1z" }),
_('path', { d: "M14 19h2v1h-2v-1z" }),
_('path', { d: "M17 19h2v1h-2v-1z" })
            );
        }
        function Calendar4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Calendar4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Calendar4.SVG = Calendar4SVG;
        return Calendar4;
    })();
export const CameraCross = /*#__PURE__*/ (() => {
        function CameraCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 7c0-2.756-2.244-5-5-5-0.788 0-1.575 0.188-2.272 0.544-0.203 0.103-0.4 0.222-0.588 0.353-0.25-0.409-0.547-0.794-0.897-1.141-1.134-1.131-2.641-1.756-4.244-1.756s-3.109 0.625-4.244 1.756-1.756 2.641-1.756 4.244c0 0.947 0.225 1.887 0.653 2.725 0.334 0.656 0.797 1.253 1.347 1.747v1.012l-5.606-2.403c-0.309-0.131-0.663-0.1-0.944 0.084s-0.45 0.497-0.45 0.834v11c0 0.356 0.191 0.687 0.497 0.866 0.156 0.091 0.328 0.134 0.503 0.134 0.172 0 0.344-0.044 0.497-0.131l5.503-3.147v1.278c0 1.103 0.897 2 2 2h3.816c1.184 1.231 2.847 2 4.684 2 3.584 0 6.5-2.916 6.5-6.5v-7.5c0-0.425-0.131-0.816-0.359-1.141 0.237-0.588 0.359-1.219 0.359-1.859zM19 4c1.653 0 3 1.347 3 3 0 0.344-0.059 0.681-0.172 1h-5.169c0.225-0.634 0.341-1.309 0.341-2 0-0.387-0.038-0.766-0.106-1.137 0.559-0.553 1.306-0.863 2.106-0.863zM2 19.278v-7.763l5 2.144v2.759l-5 2.859zM7.8 8.403c-0.516-0.684-0.8-1.519-0.8-2.403 0-2.206 1.794-4 4-4s4 1.794 4 4c0 0.712-0.184 1.397-0.534 2h-5.466c-0.45 0-0.866 0.15-1.2 0.403zM9 10h13v2.816c-1.169-1.122-2.756-1.816-4.5-1.816-3.584 0-6.5 2.916-6.5 6.5 0 0.884 0.178 1.731 0.5 2.5h-2.5v-10zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 14.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function CameraCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CameraCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CameraCross.SVG = CameraCrossSVG;
        return CameraCross;
    })();
export const CameraFlip = /*#__PURE__*/ (() => {
        function CameraFlipSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 14h-1c0 1.653 1.347 3 3 3v-1c-1.103 0-2-0.897-2-2z" }),
_('path', { d: "M3 9h2v1h-2v-1z" }),
_('path', { d: "M17.5 1c-1.841 0-3.503 0.769-4.688 2h-0.312v-0.003h-3.087c-0.534 0-1.034 0.209-1.413 0.588l-2.416 2.416h-3.584c-1.103 0-2 0.897-2 2v13c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-13.5c0-3.584-2.916-6.5-6.5-6.5zM17.5 2c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM16 14c0 2.206-1.794 4-4 4s-4-1.794-4-4c0-2.031 1.525-3.731 3.513-3.972 0.797 1.881 2.459 3.312 4.484 3.794 0.003 0.059 0.003 0.119 0.003 0.178zM2 21v-13h3.584c0.534 0 1.034-0.209 1.413-0.588l2.416-2.416h2.088c-0.322 0.772-0.5 1.616-0.5 2.503 0 0.194 0.009 0.387 0.025 0.578-2.862 0.469-5.025 2.963-5.025 5.922 0 1.603 0.625 3.109 1.756 4.244s2.641 1.756 4.244 1.756 3.109-0.625 4.244-1.756c1.131-1.134 1.756-2.641 1.756-4.244 0-0.006 0-0.012 0-0.019 1.547-0.119 2.944-0.781 4-1.794v8.813h-20z" }),
_('path', { d: "M15 7.5c0-1.306 1.006-2.381 2.284-2.491l-0.491 0.491 0.706 0.706 1.353-1.353c0.194-0.194 0.194-0.513 0-0.706l-1.353-1.353-0.706 0.706 0.506 0.506c-1.837 0.103-3.3 1.631-3.3 3.494v0.5h1v-0.5z" }),
_('path', { d: "M18.206 9.5l-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706-0.506-0.506c1.837-0.103 3.3-1.631 3.3-3.494v-0.5h-1v0.5c0 1.306-1.006 2.381-2.284 2.491l0.491-0.491z" })
            );
        }
        function CameraFlip({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CameraFlipSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CameraFlip.SVG = CameraFlipSVG;
        return CameraFlip;
    })();
export const CameraPause = /*#__PURE__*/ (() => {
        function CameraPauseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 7c0-2.756-2.244-5-5-5-0.788 0-1.575 0.188-2.272 0.544-0.203 0.103-0.4 0.222-0.588 0.353-0.25-0.409-0.547-0.794-0.897-1.141-1.134-1.131-2.641-1.756-4.244-1.756s-3.109 0.625-4.244 1.756-1.756 2.641-1.756 4.244c0 0.947 0.225 1.887 0.653 2.725 0.334 0.656 0.797 1.253 1.347 1.747v1.012l-5.606-2.403c-0.309-0.131-0.663-0.1-0.944 0.084s-0.45 0.497-0.45 0.834v11c0 0.356 0.191 0.687 0.497 0.866 0.156 0.091 0.328 0.134 0.503 0.134 0.172 0 0.344-0.044 0.497-0.131l5.503-3.147v1.278c0 1.103 0.897 2 2 2h3.816c1.184 1.231 2.847 2 4.684 2 3.584 0 6.5-2.916 6.5-6.5v-7.5c0-0.425-0.131-0.816-0.359-1.141 0.237-0.588 0.359-1.219 0.359-1.859zM19 4c1.653 0 3 1.347 3 3 0 0.344-0.059 0.681-0.172 1h-5.169c0.225-0.634 0.341-1.309 0.341-2 0-0.387-0.038-0.766-0.106-1.137 0.559-0.553 1.306-0.863 2.106-0.863zM2 19.278v-7.763l5 2.144v2.759l-5 2.859zM7.8 8.403c-0.516-0.684-0.8-1.519-0.8-2.403 0-2.206 1.794-4 4-4s4 1.794 4 4c0 0.712-0.184 1.397-0.534 2h-5.466c-0.45 0-0.866 0.15-1.2 0.403zM9 10h13v2.816c-1.169-1.122-2.756-1.816-4.5-1.816-3.584 0-6.5 2.916-6.5 6.5 0 0.884 0.178 1.731 0.5 2.5h-2.5v-10zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16 15h1v5h-1v-5z" }),
_('path', { d: "M18 15h1v5h-1v-5z" })
            );
        }
        function CameraPause({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CameraPauseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CameraPause.SVG = CameraPauseSVG;
        return CameraPause;
    })();
export const CameraPlay = /*#__PURE__*/ (() => {
        function CameraPlaySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 7c0-2.756-2.244-5-5-5-0.788 0-1.575 0.188-2.272 0.544-0.203 0.103-0.4 0.222-0.588 0.353-0.25-0.409-0.547-0.794-0.897-1.141-1.134-1.131-2.641-1.756-4.244-1.756s-3.109 0.625-4.244 1.756-1.756 2.641-1.756 4.244c0 0.947 0.225 1.887 0.653 2.725 0.334 0.656 0.797 1.253 1.347 1.747v1.012l-5.606-2.403c-0.309-0.131-0.663-0.1-0.944 0.084s-0.45 0.497-0.45 0.834v11c0 0.356 0.191 0.687 0.497 0.866 0.156 0.091 0.328 0.134 0.503 0.134 0.172 0 0.344-0.044 0.497-0.131l5.503-3.147v1.278c0 1.103 0.897 2 2 2h3.816c1.184 1.231 2.847 2 4.684 2 3.584 0 6.5-2.916 6.5-6.5v-7.5c0-0.425-0.131-0.816-0.359-1.141 0.237-0.588 0.359-1.219 0.359-1.859zM19 4c1.653 0 3 1.347 3 3 0 0.344-0.059 0.681-0.172 1h-5.169c0.225-0.634 0.341-1.309 0.341-2 0-0.387-0.038-0.766-0.106-1.137 0.559-0.553 1.306-0.863 2.106-0.863zM2 19.278v-7.763l5 2.144v2.759l-5 2.859zM7.8 8.403c-0.516-0.684-0.8-1.519-0.8-2.403 0-2.206 1.794-4 4-4s4 1.794 4 4c0 0.712-0.184 1.397-0.534 2h-5.466c-0.45 0-0.866 0.15-1.2 0.403zM9 10h13v2.816c-1.169-1.122-2.756-1.816-4.5-1.816-3.584 0-6.5 2.916-6.5 6.5 0 0.884 0.178 1.731 0.5 2.5h-2.5v-10zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M20.756 17.072l-5-3c-0.153-0.094-0.347-0.094-0.503-0.006s-0.253 0.256-0.253 0.434v6c0 0.181 0.097 0.347 0.253 0.434 0.075 0.044 0.162 0.066 0.247 0.066 0.091 0 0.178-0.025 0.256-0.072l5-3c0.15-0.091 0.244-0.253 0.244-0.428s-0.091-0.337-0.244-0.428zM16 19.616v-4.231l3.528 2.116-3.528 2.116z" })
            );
        }
        function CameraPlay({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CameraPlaySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CameraPlay.SVG = CameraPlaySVG;
        return CameraPlay;
    })();
export const CameraRecord = /*#__PURE__*/ (() => {
        function CameraRecordSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 7c0-2.756-2.244-5-5-5-0.788 0-1.575 0.188-2.272 0.544-0.203 0.103-0.4 0.222-0.588 0.353-0.25-0.409-0.547-0.794-0.897-1.141-1.134-1.131-2.641-1.756-4.244-1.756s-3.109 0.625-4.244 1.756-1.756 2.641-1.756 4.244c0 0.947 0.225 1.887 0.653 2.725 0.334 0.656 0.797 1.253 1.347 1.747v1.012l-5.606-2.403c-0.309-0.131-0.663-0.1-0.944 0.084s-0.45 0.497-0.45 0.834v11c0 0.356 0.191 0.687 0.497 0.866 0.156 0.091 0.328 0.134 0.503 0.134 0.172 0 0.344-0.044 0.497-0.131l5.503-3.147v1.278c0 1.103 0.897 2 2 2h3.816c1.184 1.231 2.847 2 4.684 2 3.584 0 6.5-2.916 6.5-6.5v-7.5c0-0.425-0.131-0.816-0.359-1.141 0.237-0.588 0.359-1.219 0.359-1.859zM19 4c1.653 0 3 1.347 3 3 0 0.344-0.059 0.681-0.172 1h-5.169c0.225-0.634 0.341-1.309 0.341-2 0-0.387-0.038-0.766-0.106-1.137 0.559-0.553 1.306-0.863 2.106-0.863zM2 19.278v-7.763l5 2.144v2.759l-5 2.859zM7.8 8.403c-0.516-0.684-0.8-1.519-0.8-2.403 0-2.206 1.794-4 4-4s4 1.794 4 4c0 0.712-0.184 1.397-0.534 2h-5.466c-0.45 0-0.866 0.15-1.2 0.403zM9 10h13v2.816c-1.169-1.122-2.756-1.816-4.5-1.816-3.584 0-6.5 2.916-6.5 6.5 0 0.884 0.178 1.731 0.5 2.5h-2.5v-10zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17.5 15c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.122-2.5-2.5-2.5zM17.5 19c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" })
            );
        }
        function CameraRecord({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CameraRecordSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CameraRecord.SVG = CameraRecordSVG;
        return CameraRecord;
    })();
export const CameraStabilization = /*#__PURE__*/ (() => {
        function CameraStabilizationSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 17v-10c0-1.103-0.897-2-2-2h-1.763l-1.788-0.894c-0.138-0.069-0.291-0.106-0.447-0.106h-4.003c-0.156 0-0.309 0.037-0.447 0.106l-1.791 0.894h-1.762c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2zM18 17h-12v-10h2c0.156 0 0.309-0.038 0.447-0.106l1.788-0.894h3.528l1.788 0.894c0.138 0.069 0.291 0.106 0.447 0.106h2v10z" }),
_('path', { d: "M3 18h-1c0 1.653 1.347 3 3 3v-1c-1.103 0-2-0.897-2-2z" }),
_('path', { d: "M1 18h-1c0 2.756 2.244 5 5 5v-1c-2.206 0-4-1.794-4-4z" }),
_('path', { d: "M19 20v1c1.653 0 3-1.347 3-3h-1c0 1.103-0.897 2-2 2z" }),
_('path', { d: "M19 22v1c2.756 0 5-2.244 5-5h-1c0 2.206-1.794 4-4 4z" }),
_('path', { d: "M21 6h1c0-1.653-1.347-3-3-3v1c1.103 0 2 0.897 2 2z" }),
_('path', { d: "M23 6h1c0-2.756-2.244-5-5-5v1c2.206 0 4 1.794 4 4z" }),
_('path', { d: "M3 6c0-1.103 0.897-2 2-2v-1c-1.653 0-3 1.347-3 3h1z" }),
_('path', { d: "M5 2v-1c-2.756 0-5 2.244-5 5h1c0-2.206 1.794-4 4-4z" }),
_('path', { d: "M12 8c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.206 0 4-1.794 4-4s-1.794-4-4-4zM12 15c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" }),
_('path', { d: "M11 12h-1c0 1.103 0.897 2 2 2v-1c-0.55 0-1-0.45-1-1z" })
            );
        }
        function CameraStabilization({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CameraStabilizationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CameraStabilization.SVG = CameraStabilizationSVG;
        return CameraStabilization;
    })();
export const CameraStop = /*#__PURE__*/ (() => {
        function CameraStopSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 7c0-2.756-2.244-5-5-5-0.788 0-1.575 0.188-2.272 0.544-0.203 0.103-0.4 0.222-0.588 0.353-0.25-0.409-0.547-0.794-0.897-1.141-1.134-1.131-2.641-1.756-4.244-1.756s-3.109 0.625-4.244 1.756-1.756 2.641-1.756 4.244c0 0.947 0.225 1.887 0.653 2.725 0.334 0.656 0.797 1.253 1.347 1.747v1.012l-5.606-2.403c-0.309-0.131-0.663-0.1-0.944 0.084s-0.45 0.497-0.45 0.834v11c0 0.356 0.191 0.687 0.497 0.866 0.156 0.091 0.328 0.134 0.503 0.134 0.172 0 0.344-0.044 0.497-0.131l5.503-3.147v1.278c0 1.103 0.897 2 2 2h3.816c1.184 1.231 2.847 2 4.684 2 3.584 0 6.5-2.916 6.5-6.5v-7.5c0-0.425-0.131-0.816-0.359-1.141 0.237-0.588 0.359-1.219 0.359-1.859zM19 4c1.653 0 3 1.347 3 3 0 0.344-0.059 0.681-0.172 1h-5.169c0.225-0.634 0.341-1.309 0.341-2 0-0.387-0.038-0.766-0.106-1.137 0.559-0.553 1.306-0.863 2.106-0.863zM2 19.278v-7.763l5 2.144v2.759l-5 2.859zM7.8 8.403c-0.516-0.684-0.8-1.519-0.8-2.403 0-2.206 1.794-4 4-4s4 1.794 4 4c0 0.712-0.184 1.397-0.534 2h-5.466c-0.45 0-0.866 0.15-1.2 0.403zM9 10h13v2.816c-1.169-1.122-2.756-1.816-4.5-1.816-3.584 0-6.5 2.916-6.5 6.5 0 0.884 0.178 1.731 0.5 2.5h-2.5v-10zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 15h-4c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5h4c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5zM19 19h-3v-3h3v3z" })
            );
        }
        function CameraStop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CameraStopSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CameraStop.SVG = CameraStopSVG;
        return CameraStop;
    })();
export const CameraTime = /*#__PURE__*/ (() => {
        function CameraTimeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 7c0-2.756-2.244-5-5-5-0.788 0-1.575 0.188-2.272 0.544-0.203 0.103-0.4 0.222-0.588 0.353-0.25-0.409-0.55-0.794-0.897-1.141-1.134-1.131-2.641-1.756-4.244-1.756s-3.109 0.625-4.244 1.756-1.756 2.641-1.756 4.244c0 0.947 0.225 1.887 0.653 2.725 0.334 0.656 0.797 1.253 1.347 1.747v1.012l-5.606-2.403c-0.309-0.131-0.663-0.1-0.944 0.084s-0.45 0.497-0.45 0.834v11c0 0.356 0.191 0.687 0.497 0.866 0.156 0.091 0.328 0.134 0.503 0.134 0.172 0 0.344-0.044 0.497-0.131l5.503-3.147v1.278c0 1.103 0.897 2 2 2h3.813c1.184 1.231 2.847 2 4.688 2 3.584 0 6.5-2.916 6.5-6.5v-7.5c0-0.425-0.131-0.816-0.359-1.141 0.237-0.588 0.359-1.219 0.359-1.859zM19 4c1.653 0 3 1.347 3 3 0 0.344-0.059 0.681-0.172 1h-5.169c0.225-0.634 0.341-1.309 0.341-2 0-0.387-0.038-0.766-0.106-1.137 0.559-0.553 1.306-0.863 2.106-0.863zM2 19.278v-7.763l5 2.144v2.759l-5 2.859zM7.797 8.403c-0.513-0.684-0.797-1.519-0.797-2.403 0-2.206 1.794-4 4-4s4 1.794 4 4c0 0.712-0.184 1.397-0.534 2h-5.466c-0.45 0-0.866 0.15-1.203 0.403zM9 10h13v2.812c-1.169-1.122-2.756-1.812-4.5-1.812-3.584 0-6.5 2.916-6.5 6.5 0 0.884 0.178 1.731 0.5 2.5h-2.5v-10zM18 22.978v-1.978h-1v1.978c-2.634-0.237-4.737-2.344-4.978-4.978h1.978v-1h-1.978c0.237-2.634 2.344-4.737 4.978-4.978v1.978h1v-1.978c2.634 0.237 4.737 2.344 4.978 4.978h-1.978v1h1.978c-0.241 2.634-2.344 4.737-4.978 4.978z" }),
_('path', { d: "M17.422 17.716l-1.922-1.922-0.706 0.706 2.353 2.353c0.094 0.094 0.222 0.147 0.353 0.147 0.016 0 0.034 0 0.050-0.003 0.15-0.016 0.284-0.097 0.366-0.219l2.278-3.416-0.831-0.556-1.941 2.909z" })
            );
        }
        function CameraTime({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CameraTimeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CameraTime.SVG = CameraTimeSVG;
        return CameraTime;
    })();
export const CameraTime2 = /*#__PURE__*/ (() => {
        function CameraTime2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 14h-1c0 1.653 1.347 3 3 3v-1c-1.103 0-2-0.897-2-2z" }),
_('path', { d: "M3 9h2v1h-2v-1z" }),
_('path', { d: "M17.5 1c-1.841 0-3.503 0.769-4.688 2h-0.312v-0.003h-3.087c-0.534 0-1.034 0.209-1.413 0.588l-2.416 2.416h-3.584c-1.103 0-2 0.897-2 2v13c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-13.5c0-3.584-2.916-6.5-6.5-6.5zM17 2.022v1.978h1v-1.978c2.634 0.237 4.737 2.344 4.978 4.978h-1.978v1h1.978c-0.237 2.634-2.344 4.737-4.978 4.978v-1.978h-1v1.978c-2.634-0.237-4.737-2.344-4.978-4.978h1.978v-1h-1.978c0.241-2.634 2.344-4.737 4.978-4.978zM16 14c0 2.206-1.794 4-4 4s-4-1.794-4-4c0-2.031 1.525-3.731 3.513-3.972 0.797 1.881 2.459 3.312 4.484 3.794 0.003 0.059 0.003 0.119 0.003 0.178zM2 21v-13h3.584c0.534 0 1.034-0.209 1.413-0.588l2.416-2.416h2.088c-0.322 0.772-0.5 1.616-0.5 2.503 0 0.194 0.009 0.387 0.025 0.578-2.862 0.469-5.025 2.963-5.025 5.922 0 1.603 0.625 3.109 1.756 4.244s2.641 1.756 4.244 1.756 3.109-0.625 4.244-1.756c1.131-1.134 1.756-2.641 1.756-4.244 0-0.006 0-0.012 0-0.019 1.547-0.119 2.944-0.781 4-1.794v8.813h-20z" }),
_('path', { d: "M17.5 9c0.016 0 0.034 0 0.050-0.003 0.15-0.016 0.284-0.097 0.366-0.219l2.278-3.416-0.831-0.556-1.938 2.909-1.925-1.922-0.706 0.706 2.353 2.353c0.094 0.094 0.222 0.147 0.353 0.147z" })
            );
        }
        function CameraTime2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CameraTime2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CameraTime2.SVG = CameraTime2SVG;
        return CameraTime2;
    })();
export const Camera = /*#__PURE__*/ (() => {
    function CameraSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 8c0-2.756-2.244-5-5-5-0.788 0-1.575 0.188-2.272 0.544-0.203 0.103-0.4 0.222-0.588 0.353-0.25-0.409-0.547-0.794-0.897-1.141-1.134-1.131-2.641-1.756-4.244-1.756s-3.109 0.625-4.244 1.756-1.756 2.641-1.756 4.244c0 0.947 0.225 1.887 0.653 2.725 0.334 0.656 0.797 1.253 1.347 1.747v1.013l-5.606-2.403c-0.309-0.131-0.663-0.1-0.944 0.084s-0.45 0.497-0.45 0.834v11c0 0.356 0.191 0.687 0.497 0.866 0.156 0.091 0.328 0.134 0.503 0.134 0.172 0 0.344-0.044 0.497-0.131l5.503-3.147v1.278c0 1.103 0.897 2 2 2h13c1.103 0 2-0.897 2-2v-10c0-0.425-0.131-0.816-0.359-1.141 0.237-0.588 0.359-1.219 0.359-1.859zM22 19h-13v-8h13v8zM19 5c1.653 0 3 1.347 3 3 0 0.344-0.059 0.681-0.172 1h-5.169c0.225-0.634 0.341-1.309 0.341-2 0-0.387-0.038-0.766-0.106-1.137 0.559-0.553 1.306-0.863 2.106-0.863zM11 3c2.206 0 4 1.794 4 4 0 0.712-0.184 1.397-0.534 2h-5.466c-0.45 0-0.866 0.15-1.2 0.403-0.516-0.684-0.8-1.519-0.8-2.403 0-2.206 1.794-4 4-4zM2 20.278v-7.763l5 2.144v2.759l-5 2.859zM9 21.003c0 0 0-0.003 0 0v-1.003h13v1l-13 0.003z" })
        );
    }
    function Camera({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CameraSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Camera.SVG = CameraSVG;
    return Camera;
})();
export const Camera2 = /*#__PURE__*/ (() => {
        function Camera2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.894 6.828l-3.209-1.606-1.556-2.334c-0.372-0.553-0.994-0.888-1.662-0.888h-4.050c-0.534 0-1.038 0.209-1.416 0.584l-2.416 2.416h-3.584c-2.756 0-5 2.244-5 5v9c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-10.381c0-0.762-0.425-1.45-1.106-1.791zM16.466 4l0.666 1h-5.719l1-1h4.053zM2 10c0-1.653 1.347-3 3-3h1.003c-0.003 0.466-0.003 1.119-0.003 2 0 0.241 0.003 0.509 0.003 0.797 0.016 2.253 0.044 5.903-0.753 9.203h-3.25v-9zM10 13.5c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5c0 2.481-2.019 4.5-4.5 4.5s-4.5-2.019-4.5-4.5zM22 19h-4.041c1.825-1.153 3.041-3.188 3.041-5.5 0-3.584-2.916-6.5-6.5-6.5s-6.5 2.916-6.5 6.5c0 2.313 1.216 4.347 3.041 5.5h-4.762c0.769-3.356 0.744-6.963 0.728-9.213-0.003-0.284-0.003-0.553-0.003-0.788 0-0.884 0-1.534 0.003-2h1.994c0.266 0 0.519-0.106 0.706-0.294l0.706-0.706h7.384l0.369 0.556c0.097 0.144 0.228 0.263 0.384 0.341l3.45 1.722v10.381z" }),
_('path', { d: "M12 13.5v-0.5h-1v0.5c0 1.931 1.569 3.5 3.5 3.5h0.5v-1h-0.5c-1.378 0-2.5-1.122-2.5-2.5z" })
            );
        }
        function Camera2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Camera2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Camera2.SVG = Camera2SVG;
        return Camera2;
    })();
export const Camera3 = /*#__PURE__*/ (() => {
        function Camera3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 5h-3.584l-2.416-2.416c-0.378-0.375-0.881-0.584-1.416-0.584h-5.169c-0.534 0-1.038 0.209-1.416 0.584l-2.416 2.416h-3.584c-1.103 0-2 0.897-2 2v13c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-13c0-1.103-0.897-2-2-2zM22 20h-20v-13h3.584c0.534 0 1.038-0.209 1.416-0.584l2.416-2.416h5.172l2.416 2.416c0.378 0.378 0.881 0.584 1.416 0.584h3.581v13z" }),
_('path', { d: "M12 7c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zM12 17c-2.206 0-4-1.794-4-4s1.794-4 4-4c2.206 0 4 1.794 4 4s-1.794 4-4 4z" }),
_('path', { d: "M10 13h-1c0 1.653 1.347 3 3 3v-1c-1.103 0-2-0.897-2-2z" }),
_('path', { d: "M3 8h2v1h-2v-1z" })
            );
        }
        function Camera3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Camera3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Camera3.SVG = Camera3SVG;
        return Camera3;
    })();
export const Candy = /*#__PURE__*/ (() => {
    function CandySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.881 4.531c-0.162-0.309-0.478-0.509-0.825-0.528-1.622-0.094-2.041-0.925-2.572-1.975-0.219-0.438-0.447-0.888-0.778-1.256-0.459-0.513-1.034-0.772-1.706-0.772-0.175 0-0.35 0.047-0.503 0.134-0.106 0.063-1.062 0.644-1.763 1.966-0.406 0.766-0.644 1.628-0.709 2.562-0.034 0.516-0.019 1.053 0.053 1.612-0.097-0.034-0.194-0.066-0.294-0.094-0.694-0.194-1.441-0.234-2.222-0.122-1.534 0.219-3.053 1.013-4.272 2.231s-2.009 2.741-2.231 4.275c-0.112 0.781-0.069 1.528 0.122 2.222 0.025 0.094 0.056 0.188 0.087 0.278-4.328 0.466-6.053 3.294-6.128 3.425-0.178 0.3-0.188 0.672-0.022 0.978 0.162 0.309 0.475 0.509 0.825 0.528 1.622 0.094 2.041 0.925 2.572 1.975 0.219 0.438 0.447 0.888 0.778 1.256 0.459 0.513 1.034 0.772 1.706 0.772 0.175 0 0.35-0.047 0.503-0.134 0.106-0.063 1.062-0.644 1.763-1.966 0.406-0.766 0.644-1.628 0.709-2.562 0.034-0.516 0.019-1.053-0.053-1.613 0.097 0.034 0.194 0.066 0.294 0.094 0.441 0.122 0.9 0.184 1.381 0.184 0.275 0 0.556-0.022 0.841-0.063 1.534-0.219 3.053-1.013 4.272-2.231 1.222-1.222 2.013-2.737 2.231-4.272 0.113-0.781 0.069-1.528-0.122-2.222-0.025-0.094-0.056-0.188-0.087-0.278 4.328-0.469 6.053-3.297 6.128-3.428 0.178-0.3 0.187-0.672 0.022-0.978zM5.791 21.903c-0.109-0.113-0.247-0.35-0.491-0.828-0.294-0.578-0.656-1.3-1.291-1.897-0.328-0.309-0.694-0.556-1.103-0.744 0.050-0.041 0.106-0.081 0.159-0.122 1.025-0.744 2.262-1.172 3.691-1.281 0.716 2.884-0.394 4.341-0.966 4.872zM8.706 15.294c-0.572-0.572-0.809-1.441-0.666-2.444 0.159-1.109 0.75-2.225 1.666-3.141 0.097-0.097 0.194-0.188 0.294-0.275v6.516c-0.513-0.097-0.953-0.319-1.294-0.656zM11.15 15.959c-0.050 0.006-0.1 0.012-0.15 0.019v-7.275c0.594-0.347 1.222-0.575 1.85-0.663 0.050-0.006 0.1-0.012 0.15-0.019v7.275c-0.594 0.347-1.222 0.572-1.85 0.663zM15.959 11.15c-0.159 1.109-0.75 2.225-1.666 3.141-0.097 0.097-0.194 0.188-0.294 0.275v-6.513c0.513 0.094 0.953 0.316 1.294 0.656 0 0 0 0 0 0 0.572 0.572 0.809 1.441 0.666 2.441zM20.934 5.691c-1.025 0.744-2.262 1.172-3.691 1.281-0.716-2.888 0.394-4.344 0.966-4.875 0.109 0.112 0.247 0.35 0.491 0.828 0.291 0.578 0.656 1.3 1.291 1.897 0.328 0.309 0.694 0.556 1.103 0.744-0.050 0.044-0.103 0.084-0.159 0.125z" })
        );
    }
    function Candy({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CandySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Candy.SVG = CandySVG;
    return Candy;
})();
export const CanvasBottom = /*#__PURE__*/ (() => {
        function CanvasBottomSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 4h-14c-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1h14c0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM18 18h-12v-12h12v12z" }),
_('path', { d: "M4 21h1v3h-1v-3z" }),
_('path', { d: "M0 19h3v1h-3v-1z" }),
_('path', { d: "M21 19h3v1h-3v-1z" }),
_('path', { d: "M19 21h1v3h-1v-3z" }),
_('path', { d: "M19 0h1v3h-1v-3z" }),
_('path', { d: "M21 4h3v1h-3v-1z" }),
_('path', { d: "M0 4h3v1h-3v-1z" }),
_('path', { d: "M4 0h1v3h-1v-3z" }),
_('path', { d: "M15 15c0-1.653-1.347-3-3-3s-3 1.347-3 3 1.347 3 3 3 3-1.347 3-3zM12 17c-1.103 0-2-0.897-2-2s0.897-2 2-2c1.103 0 2 0.897 2 2s-0.897 2-2 2z" })
            );
        }
        function CanvasBottom({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CanvasBottomSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CanvasBottom.SVG = CanvasBottomSVG;
        return CanvasBottom;
    })();
export const CanvasCenter = /*#__PURE__*/ (() => {
        function CanvasCenterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 15c1.653 0 3-1.347 3-3s-1.347-3-3-3-3 1.347-3 3 1.347 3 3 3zM12 10c1.103 0 2 0.897 2 2s-0.897 2-2 2c-1.103 0-2-0.897-2-2s0.897-2 2-2z" }),
_('path', { d: "M19 4h-14c-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1h14c0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM18 18h-12v-12h12v12z" }),
_('path', { d: "M4 21h1v3h-1v-3z" }),
_('path', { d: "M0 19h3v1h-3v-1z" }),
_('path', { d: "M21 19h3v1h-3v-1z" }),
_('path', { d: "M19 21h1v3h-1v-3z" }),
_('path', { d: "M19 0h1v3h-1v-3z" }),
_('path', { d: "M21 4h3v1h-3v-1z" }),
_('path', { d: "M0 4h3v1h-3v-1z" }),
_('path', { d: "M4 0h1v3h-1v-3z" })
            );
        }
        function CanvasCenter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CanvasCenterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CanvasCenter.SVG = CanvasCenterSVG;
        return CanvasCenter;
    })();
export const CanvasFit = /*#__PURE__*/ (() => {
        function CanvasFitSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 4h-14c-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1h14c0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM18 18h-12v-12h12v12z" }),
_('path', { d: "M4 21h1v3h-1v-3z" }),
_('path', { d: "M0 19h3v1h-3v-1z" }),
_('path', { d: "M21 19h3v1h-3v-1z" }),
_('path', { d: "M19 21h1v3h-1v-3z" }),
_('path', { d: "M19 0h1v3h-1v-3z" }),
_('path', { d: "M21 4h3v1h-3v-1z" }),
_('path', { d: "M0 4h3v1h-3v-1z" }),
_('path', { d: "M4 0h1v3h-1v-3z" }),
_('path', { d: "M7.5 17h2.5v-1h-1.294l7.294-7.294v1.294h1v-2.5c0-0.275-0.225-0.5-0.5-0.5h-2.5v1h1.294l-7.294 7.294v-1.294h-1v2.5c0 0.275 0.225 0.5 0.5 0.5z" })
            );
        }
        function CanvasFit({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CanvasFitSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CanvasFit.SVG = CanvasFitSVG;
        return CanvasFit;
    })();
export const CanvasLeft = /*#__PURE__*/ (() => {
        function CanvasLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 15c1.653 0 3-1.347 3-3s-1.347-3-3-3-3 1.347-3 3 1.347 3 3 3zM9 10c1.103 0 2 0.897 2 2s-0.897 2-2 2-2-0.897-2-2c0-1.103 0.897-2 2-2z" }),
_('path', { d: "M19 4h-14c-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1h14c0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM18 18h-12v-12h12v12z" }),
_('path', { d: "M4 21h1v3h-1v-3z" }),
_('path', { d: "M0 19h3v1h-3v-1z" }),
_('path', { d: "M21 19h3v1h-3v-1z" }),
_('path', { d: "M19 21h1v3h-1v-3z" }),
_('path', { d: "M19 0h1v3h-1v-3z" }),
_('path', { d: "M21 4h3v1h-3v-1z" }),
_('path', { d: "M0 4h3v1h-3v-1z" }),
_('path', { d: "M4 0h1v3h-1v-3z" })
            );
        }
        function CanvasLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CanvasLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CanvasLeft.SVG = CanvasLeftSVG;
        return CanvasLeft;
    })();
export const CanvasRight = /*#__PURE__*/ (() => {
        function CanvasRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 9c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM15 14c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2c0 1.103-0.897 2-2 2z" }),
_('path', { d: "M19 4h-14c-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1h14c0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM18 12v6h-12v-12h12v6z" }),
_('path', { d: "M4 21h1v3h-1v-3z" }),
_('path', { d: "M0 19h3v1h-3v-1z" }),
_('path', { d: "M21 19h3v1h-3v-1z" }),
_('path', { d: "M19 21h1v3h-1v-3z" }),
_('path', { d: "M19 0h1v3h-1v-3z" }),
_('path', { d: "M21 4h3v1h-3v-1z" }),
_('path', { d: "M0 4h3v1h-3v-1z" }),
_('path', { d: "M4 0h1v3h-1v-3z" })
            );
        }
        function CanvasRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CanvasRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CanvasRight.SVG = CanvasRightSVG;
        return CanvasRight;
    })();
export const CanvasTop = /*#__PURE__*/ (() => {
        function CanvasTopSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 9c0 1.653 1.347 3 3 3s3-1.347 3-3-1.347-3-3-3-3 1.347-3 3zM12 7c1.103 0 2 0.897 2 2s-0.897 2-2 2c-1.103 0-2-0.897-2-2s0.897-2 2-2z" }),
_('path', { d: "M19 4h-14c-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1h14c0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM18 18h-12v-12h12v12z" }),
_('path', { d: "M4 21h1v3h-1v-3z" }),
_('path', { d: "M0 19h3v1h-3v-1z" }),
_('path', { d: "M21 19h3v1h-3v-1z" }),
_('path', { d: "M19 21h1v3h-1v-3z" }),
_('path', { d: "M19 0h1v3h-1v-3z" }),
_('path', { d: "M21 4h3v1h-3v-1z" }),
_('path', { d: "M0 4h3v1h-3v-1z" }),
_('path', { d: "M4 0h1v3h-1v-3z" })
            );
        }
        function CanvasTop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CanvasTopSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CanvasTop.SVG = CanvasTopSVG;
        return CanvasTop;
    })();
export const Canvas = /*#__PURE__*/ (() => {
        function CanvasSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 4h-14c-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1h14c0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1zM18 18h-12v-12h12v12z" }),
_('path', { d: "M4 21h1v3h-1v-3z" }),
_('path', { d: "M0 19h3v1h-3v-1z" }),
_('path', { d: "M21 19h3v1h-3v-1z" }),
_('path', { d: "M19 21h1v3h-1v-3z" }),
_('path', { d: "M19 0h1v3h-1v-3z" }),
_('path', { d: "M21 4h3v1h-3v-1z" }),
_('path', { d: "M0 4h3v1h-3v-1z" }),
_('path', { d: "M4 0h1v3h-1v-3z" })
            );
        }
        function Canvas({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CanvasSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Canvas.SVG = CanvasSVG;
        return Canvas;
    })();
export const Capacitor = /*#__PURE__*/ (() => {
    function CapacitorSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17.006 9.309c0.65-0.981 0.994-2.119 0.994-3.309 0-1.603-0.625-3.109-1.756-4.244-1.134-1.131-2.641-1.756-4.244-1.756s-3.109 0.625-4.244 1.756c-1.131 1.134-1.756 2.641-1.756 4.244 0 1.191 0.344 2.328 0.994 3.309-0.003 0.122-0.009 0.253-0.016 0.387-0.050 1.256-0.113 2.819 0.725 3.916 0.094 0.122 0.206 0.222 0.331 0.3-0.022 0.138-0.034 0.278-0.034 0.419v9.669h1v-9.669c0-0.106 0.012-0.209 0.031-0.309 0.428-0.147 0.747-0.525 1.081-0.922 0.369-0.438 0.928-1.1 1.388-1.1h1c0.459 0 1.019 0.663 1.387 1.1 0.334 0.397 0.653 0.775 1.081 0.922 0.022 0.1 0.031 0.203 0.031 0.309v9.669h1v-9.669c0-0.141-0.012-0.281-0.034-0.419 0.125-0.078 0.237-0.178 0.331-0.3 0.837-1.097 0.775-2.659 0.725-3.916-0.006-0.134-0.012-0.266-0.016-0.387zM15.2 8.4c-0.131 0.172-0.2 0.384-0.2 0.6 0 0.244 0.009 0.503 0.022 0.778 0.019 0.481 0.044 1.059-0.006 1.572-0.591-0.65-1.403-1.35-2.516-1.35h-1c-1.113 0-1.925 0.7-2.516 1.35-0.047-0.513-0.025-1.091-0.006-1.572 0.012-0.275 0.022-0.534 0.022-0.778 0-0.216-0.072-0.428-0.2-0.6-0.525-0.697-0.8-1.525-0.8-2.4 0-2.206 1.794-4 4-4s4 1.794 4 4c0 0.875-0.275 1.703-0.8 2.4z" })
        );
    }
    function Capacitor({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CapacitorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Capacitor.SVG = CapacitorSVG;
    return Capacitor;
})();
export const CarBattery = /*#__PURE__*/ (() => {
        function CarBatterySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 5h-2v-0.5c0-0.828-0.672-1.5-1.5-1.5h-2c-0.828 0-1.5 0.672-1.5 1.5v0.5h-6v-0.5c0-0.828-0.672-1.5-1.5-1.5h-2c-0.828 0-1.5 0.672-1.5 1.5v0.5h-2c-1.103 0-2 0.897-2 2v13c0 0.553 0.447 1 1 1h22c0.553 0 1-0.447 1-1v-13c0-1.103-0.897-2-2-2zM16 4.5c0-0.275 0.225-0.5 0.5-0.5h2c0.275 0 0.5 0.225 0.5 0.5v0.5h-3v-0.5zM5 4.5c0-0.275 0.225-0.5 0.5-0.5h2c0.275 0 0.5 0.225 0.5 0.5v0.5h-3v-0.5zM22 19h-20v-12h20v12z" }),
_('path', { d: "M6 14h1v-2h2v-1h-2v-2h-1v2h-2v1h2z" }),
_('path', { d: "M15 11h5v1h-5v-1z" })
            );
        }
        function CarBattery({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CarBatterySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CarBattery.SVG = CarBatterySVG;
        return CarBattery;
    })();
export const CarCheck = /*#__PURE__*/ (() => {
        function CarCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 13c3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5-6.5 2.916-6.5 6.5 2.916 6.5 6.5 6.5zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5z" }),
_('path', { d: "M16.5 9c0.128 0 0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147z" }),
_('path', { d: "M22.016 16.553c-0.978-0.519-2.212-0.828-3.406-1.125-1.156-0.291-2.356-0.591-3.091-1.041-2.737-1.678-7.331-2.95-10.809-2.131-1.069 0.253-1.913 0.572-2.572 0.978-0.684 0.419-1.184 0.934-1.528 1.572-0.612 1.134-0.609 2.45-0.609 3.978v2.219c0 1.103 0.897 2 2 2h1.766c0.55 0.612 1.347 1 2.234 1s1.684-0.387 2.234-1h6.531c0.55 0.612 1.347 1 2.234 1s1.684-0.387 2.234-1h2.766c1.103 0 2-0.897 2-2v-1.5c0-1.263-0.666-2.253-1.984-2.95zM5.166 14.203c2.866-0.675 6.828 0.422 9.181 1.812-4.113 0.034-8.85-0.128-11.037-1.156 0.416-0.228 1.003-0.456 1.856-0.656zM6 23c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM17 23c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM22 21h-2c0-1.653-1.347-3-3-3s-3 1.347-3 3h-5c0-1.653-1.347-3-3-3s-3 1.347-3 3v0h-1v-2.219c0-1.306-0.003-2.337 0.369-3.028 0.034-0.063 0.072-0.128 0.122-0.197 1.134 0.663 2.991 1.078 5.706 1.291 1.591 0.125 3.353 0.169 5.178 0.169 1.075 0 2.175-0.016 3.269-0.038 0.484 0.141 0.987 0.266 1.481 0.391 2.341 0.588 3.875 1.050 3.875 2.131v1.5z" })
            );
        }
        function CarCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CarCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CarCheck.SVG = CarCheckSVG;
        return CarCheck;
    })();
export const CarCross = /*#__PURE__*/ (() => {
        function CarCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.5 9.206l2-2 2 2 0.706-0.706-2-2 2-2-0.706-0.706-2 2-2-2-0.706 0.706 2 2-2 2z" }),
_('path', { d: "M17.5 13c3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5-6.5 2.916-6.5 6.5 2.916 6.5 6.5 6.5zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5z" }),
_('path', { d: "M22.016 16.553c-0.978-0.519-2.212-0.828-3.406-1.125-1.156-0.291-2.356-0.591-3.091-1.041-2.737-1.678-7.331-2.95-10.809-2.131-1.069 0.253-1.913 0.572-2.572 0.978-0.684 0.419-1.184 0.934-1.528 1.572-0.612 1.134-0.609 2.45-0.609 3.978v2.219c0 1.103 0.897 2 2 2h1.766c0.55 0.612 1.347 1 2.234 1s1.684-0.387 2.234-1h6.531c0.55 0.612 1.347 1 2.234 1s1.684-0.387 2.234-1h2.766c1.103 0 2-0.897 2-2v-1.5c0-1.263-0.666-2.253-1.984-2.95zM5.166 14.203c2.866-0.675 6.828 0.422 9.181 1.812-4.113 0.034-8.85-0.128-11.037-1.156 0.416-0.228 1.003-0.456 1.856-0.656zM6 23c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM17 23c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM22 21h-2c0-1.653-1.347-3-3-3s-3 1.347-3 3h-5c0-1.653-1.347-3-3-3s-3 1.347-3 3v0h-1v-2.219c0-1.306-0.003-2.337 0.369-3.028 0.034-0.063 0.072-0.128 0.122-0.197 1.134 0.663 2.991 1.078 5.706 1.291 1.591 0.125 3.353 0.169 5.178 0.169 1.075 0 2.175-0.016 3.269-0.038 0.484 0.141 0.987 0.266 1.481 0.391 2.341 0.588 3.875 1.050 3.875 2.131v1.5z" })
            );
        }
        function CarCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CarCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CarCross.SVG = CarCrossSVG;
        return CarCross;
    })();
export const CarLock = /*#__PURE__*/ (() => {
        function CarLockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 13c3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5-6.5 2.916-6.5 6.5 2.916 6.5 6.5 6.5zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5z" }),
_('path', { d: "M22.019 16.553c-0.978-0.519-2.212-0.828-3.406-1.125-1.156-0.291-2.356-0.591-3.091-1.041-2.741-1.678-7.334-2.95-10.812-2.131-1.069 0.253-1.913 0.572-2.572 0.978-0.684 0.419-1.184 0.934-1.528 1.572-0.612 1.131-0.609 2.45-0.609 3.975v2.219c0 1.103 0.897 2 2 2h1.766c0.55 0.612 1.347 1 2.234 1s1.684-0.387 2.234-1h6.531c0.55 0.612 1.347 1 2.234 1s1.684-0.387 2.234-1h2.766c1.103 0 2-0.897 2-2v-1.5c0-1.259-0.666-2.25-1.981-2.947zM5.166 14.2c2.869-0.675 6.831 0.422 9.184 1.816-4.113 0.034-8.85-0.128-11.041-1.156 0.416-0.231 1.003-0.456 1.856-0.659zM6 23c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM17 23c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM22 21h-2c0-1.653-1.347-3-3-3s-3 1.347-3 3h-5c0-1.653-1.347-3-3-3s-3 1.347-3 3h-1v-2.219c0-1.306-0.003-2.337 0.369-3.028 0.034-0.063 0.072-0.128 0.119-0.197 1.134 0.663 2.991 1.078 5.706 1.291 1.591 0.125 3.356 0.169 5.181 0.169 1.075 0 2.172-0.016 3.266-0.038 0.484 0.141 0.984 0.266 1.478 0.391 2.341 0.588 3.875 1.050 3.875 2.131v1.5z" }),
_('path', { d: "M14.5 10h6c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-0.5v-0.5c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5v0.5h-0.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5zM16 5.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5v0.5h-3v-0.5zM15 7h5v2h-5v-2z" })
            );
        }
        function CarLock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CarLockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CarLock.SVG = CarLockSVG;
        return CarLock;
    })();
export const CarLock2 = /*#__PURE__*/ (() => {
        function CarLock2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.537 11.591c1.5-1.191 2.463-3.031 2.463-5.091 0-3.584-2.916-6.5-6.5-6.5-3.072 0-5.653 2.141-6.328 5.009-1.228 0.034-2.303 0.147-3.206 0.337-1.678 0.356-2.763 0.969-3.319 1.878-0.422 0.687-0.656 1.441-0.866 2.103-0.1 0.322-0.197 0.625-0.303 0.9l-0.422-0.756c0 0 0-0.003-0.003-0.003-0.156-0.278-0.491-0.472-0.806-0.472h-1.247c-0.55 0-1 0.45-1 1s0.45 1 1 1h1.762l0.119 0.213c-0.009 0.009-0.022 0.019-0.031 0.028-0.619 0.531-1.156 1.053-1.472 2.072-0.272 0.869-0.375 2.041-0.375 4.188v1c0 0.744 0.4 1.481 1 1.928v2.075c0 0.828 0.672 1.5 1.5 1.5h2c0.828 0 1.5-0.672 1.5-1.5v-0.825c1.394 0.184 3.081 0.325 5 0.325s3.606-0.141 5-0.325v0.825c0 0.828 0.672 1.5 1.5 1.5h2c0.828 0 1.5-0.672 1.5-1.5v-2.072c0.6-0.45 1-1.188 1-1.928v-1c0-2.069-0.122-3.331-0.406-4.219-0.253-0.787-0.634-1.281-1.059-1.691zM16.234 16.528c0.222-0.172 0.541-0.391 0.947-0.606 0.775-0.413 2.044-0.9 3.719-0.919 0.038 0.341 0.063 0.744 0.078 1.225-1.131 0.637-2.147 0.766-4.275 0.775l-0.469-0.475zM19.847 12.759c0.391 0.334 0.681 0.588 0.875 1.247-3.572 0.097-5.5 2.066-5.581 2.15-0.050 0.053-0.087 0.116-0.112 0.181-0.813-0.162-1.928-0.334-3.028-0.334s-2.216 0.172-3.028 0.334c-0.022-0.066-0.059-0.128-0.113-0.181-0.081-0.084-2.016-2.059-5.603-2.15 0.15-0.519 0.372-0.781 0.678-1.059 3.022-0.778 6.631-1.091 10.2-0.884 0.984 0.594 2.134 0.938 3.366 0.938 0.769 0 1.509-0.134 2.194-0.381 0.050 0.047 0.103 0.094 0.153 0.141zM3.087 15c1.684 0.016 2.956 0.506 3.731 0.919 0.409 0.219 0.728 0.438 0.947 0.606l-0.472 0.475c-2.128-0.006-3.144-0.138-4.278-0.775 0.012-0.484 0.038-0.888 0.072-1.225zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM5.691 9.928c0.191-0.606 0.369-1.178 0.663-1.659 0.334-0.547 1.737-1.147 4.666-1.253 0.122 1.544 0.784 2.937 1.8 3.991-2.706-0.059-5.394 0.172-7.809 0.663 0.312-0.563 0.506-1.172 0.681-1.741zM6 22.5c0 0.275-0.225 0.5-0.5 0.5h-2c-0.275 0-0.5-0.225-0.5-0.5v-1.625c0.513 0.147 1.547 0.416 3 0.653v0.972zM3.266 18.866h-0.003c-0.109-0.038-0.263-0.247-0.263-0.366v-1c0-0.053 0-0.109 0-0.162 1.212 0.559 2.444 0.663 4.5 0.663 0.131 0 0.259-0.053 0.353-0.147l0.306-0.306c0.469-0.122 2.206-0.547 3.841-0.547 1.638 0 3.372 0.425 3.841 0.547l0.306 0.306c0.094 0.094 0.222 0.147 0.353 0.147 2.056 0 3.288-0.103 4.5-0.663 0 0.053 0 0.106 0 0.162v1c0 0.119-0.153 0.328-0.266 0.366-0.034 0.012-3.484 1.134-8.734 1.134s-8.7-1.122-8.734-1.134zM20.5 23h-2c-0.275 0-0.5-0.225-0.5-0.5v-0.972c1.453-0.237 2.487-0.503 3-0.653v1.625c0 0.275-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M14.5 10h6c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-0.5v-0.5c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5v0.5h-0.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5zM16 5.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5v0.5h-3v-0.5zM15 7h5v2h-5v-2z" })
            );
        }
        function CarLock2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CarLock2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CarLock2.SVG = CarLock2SVG;
        return CarLock2;
    })();
export const CarParking = /*#__PURE__*/ (() => {
        function CarParkingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 13c3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5-6.5 2.916-6.5 6.5 2.916 6.5 6.5 6.5zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5z" }),
_('path', { d: "M22.019 16.553c-0.978-0.519-2.212-0.828-3.406-1.125-1.156-0.291-2.356-0.591-3.091-1.041-2.741-1.678-7.334-2.95-10.812-2.131-1.069 0.253-1.913 0.572-2.572 0.978-0.684 0.419-1.184 0.934-1.528 1.572-0.612 1.131-0.609 2.45-0.609 3.975v2.219c0 1.103 0.897 2 2 2h1.766c0.55 0.612 1.347 1 2.234 1s1.684-0.387 2.234-1h6.531c0.55 0.612 1.347 1 2.234 1s1.684-0.387 2.234-1h2.766c1.103 0 2-0.897 2-2v-1.5c0-1.259-0.666-2.25-1.981-2.947zM5.166 14.2c2.869-0.675 6.831 0.422 9.184 1.816-4.113 0.034-8.85-0.128-11.041-1.156 0.416-0.231 1.003-0.456 1.856-0.659zM6 23c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM17 23c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM22 21h-2c0-1.653-1.347-3-3-3s-3 1.347-3 3h-5c0-1.653-1.347-3-3-3s-3 1.347-3 3h-1v-2.219c0-1.306-0.003-2.337 0.369-3.028 0.034-0.063 0.072-0.128 0.119-0.197 1.134 0.663 2.991 1.078 5.706 1.291 1.591 0.125 3.356 0.169 5.181 0.169 1.075 0 2.172-0.016 3.266-0.038 0.484 0.141 0.984 0.266 1.478 0.391 2.341 0.588 3.875 1.050 3.875 2.131v1.5z" }),
_('path', { d: "M16 7h2c1.103 0 2-0.897 2-2s-0.897-2-2-2h-2.5c-0.275 0-0.5 0.225-0.5 0.5v6.5h1v-3zM16 4h2c0.55 0 1 0.45 1 1s-0.45 1-1 1h-2v-2z" })
            );
        }
        function CarParking({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CarParkingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CarParking.SVG = CarParkingSVG;
        return CarParking;
    })();
export const CarParking2 = /*#__PURE__*/ (() => {
        function CarParking2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.537 11.591c1.5-1.191 2.463-3.031 2.463-5.091 0-3.584-2.916-6.5-6.5-6.5-3.072 0-5.653 2.141-6.328 5.009-1.228 0.034-2.303 0.147-3.206 0.337-1.678 0.356-2.763 0.969-3.319 1.878-0.422 0.687-0.656 1.441-0.866 2.103-0.1 0.322-0.197 0.625-0.303 0.9l-0.422-0.756c0 0 0-0.003-0.003-0.003-0.156-0.278-0.491-0.472-0.806-0.472h-1.247c-0.55 0-1 0.45-1 1s0.45 1 1 1h1.762l0.119 0.213c-0.009 0.009-0.022 0.019-0.031 0.028-0.619 0.531-1.156 1.053-1.472 2.072-0.272 0.869-0.375 2.041-0.375 4.188v1c0 0.744 0.4 1.481 1 1.928v2.075c0 0.828 0.672 1.5 1.5 1.5h2c0.828 0 1.5-0.672 1.5-1.5v-0.825c1.394 0.184 3.081 0.325 5 0.325s3.606-0.141 5-0.325v0.825c0 0.828 0.672 1.5 1.5 1.5h2c0.828 0 1.5-0.672 1.5-1.5v-2.072c0.6-0.45 1-1.188 1-1.928v-1c0-2.069-0.122-3.331-0.406-4.219-0.253-0.787-0.634-1.281-1.059-1.691zM16.234 16.528c0.222-0.172 0.541-0.391 0.947-0.606 0.775-0.413 2.044-0.9 3.719-0.919 0.038 0.341 0.063 0.744 0.078 1.225-1.131 0.637-2.147 0.766-4.275 0.775l-0.469-0.475zM19.847 12.759c0.391 0.334 0.681 0.588 0.875 1.247-3.572 0.097-5.5 2.066-5.581 2.15-0.050 0.053-0.087 0.116-0.112 0.181-0.813-0.162-1.928-0.334-3.028-0.334s-2.216 0.172-3.028 0.334c-0.022-0.066-0.059-0.128-0.113-0.181-0.081-0.084-2.016-2.059-5.603-2.15 0.15-0.519 0.372-0.781 0.678-1.059 3.022-0.778 6.631-1.091 10.2-0.884 0.984 0.594 2.134 0.938 3.366 0.938 0.769 0 1.509-0.134 2.194-0.381 0.050 0.047 0.103 0.094 0.153 0.141zM3.087 15c1.684 0.016 2.956 0.506 3.731 0.919 0.409 0.219 0.728 0.438 0.947 0.606l-0.472 0.475c-2.128-0.006-3.144-0.138-4.278-0.775 0.012-0.484 0.038-0.888 0.072-1.225zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM5.691 9.928c0.191-0.606 0.369-1.178 0.663-1.659 0.334-0.547 1.737-1.147 4.666-1.253 0.122 1.544 0.784 2.937 1.8 3.991-2.706-0.059-5.394 0.172-7.809 0.663 0.312-0.563 0.506-1.172 0.681-1.741zM6 22.5c0 0.275-0.225 0.5-0.5 0.5h-2c-0.275 0-0.5-0.225-0.5-0.5v-1.625c0.513 0.147 1.547 0.416 3 0.653v0.972zM3.266 18.866h-0.003c-0.109-0.038-0.263-0.247-0.263-0.366v-1c0-0.053 0-0.109 0-0.162 1.212 0.559 2.444 0.663 4.5 0.663 0.131 0 0.259-0.053 0.353-0.147l0.306-0.306c0.469-0.122 2.206-0.547 3.841-0.547 1.638 0 3.372 0.425 3.841 0.547l0.306 0.306c0.094 0.094 0.222 0.147 0.353 0.147 2.056 0 3.288-0.103 4.5-0.663 0 0.053 0 0.106 0 0.162v1c0 0.119-0.153 0.328-0.266 0.366-0.034 0.012-3.484 1.134-8.734 1.134s-8.7-1.122-8.734-1.134zM20.5 23h-2c-0.275 0-0.5-0.225-0.5-0.5v-0.972c1.453-0.237 2.487-0.503 3-0.653v1.625c0 0.275-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M16 7h2c1.103 0 2-0.897 2-2s-0.897-2-2-2h-2.5c-0.275 0-0.5 0.225-0.5 0.5v6.5h1v-3zM16 4h2c0.55 0 1 0.45 1 1s-0.45 1-1 1h-2v-2z" })
            );
        }
        function CarParking2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CarParking2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CarParking2.SVG = CarParking2SVG;
        return CarParking2;
    })();
export const CarPlug = /*#__PURE__*/ (() => {
    function CarPlugSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 5v-1h-3v-2h-1v1h-0.5c-1.759 0-3.222 1.306-3.466 3h-0.534c-3.356 0-4.556-1.091-5.719-2.144-1.006-0.912-2.044-1.856-4.281-1.856-1.469 0-2.85 0.572-3.891 1.609-1.038 1.041-1.609 2.422-1.609 3.891v11.5c0 1.103 0.897 2 2 2h1.766c0.55 0.612 1.347 1 2.234 1s1.684-0.387 2.234-1h6.531c0.55 0.612 1.347 1 2.234 1s1.684-0.387 2.234-1h2.766c1.103 0 2-0.897 2-2v-1.5c0-1.259-0.666-2.25-1.984-2.947-0.978-0.519-2.212-0.828-3.406-1.125-1.156-0.291-2.356-0.591-3.091-1.041-2.737-1.678-7.331-2.95-10.809-2.131-1.069 0.253-1.912 0.572-2.572 0.978-0.459 0.281-0.834 0.606-1.137 0.981v-4.716c0-2.481 2.019-4.5 4.5-4.5 1.85 0 2.628 0.703 3.609 1.597 0.6 0.544 1.278 1.159 2.269 1.625 1.113 0.522 2.463 0.778 4.122 0.778h0.534c0.244 1.694 1.703 3 3.466 3h0.5v1h1v-2h3v-1h-3v-3h3zM6 21c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM17 21c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM22 17.5v1.5h-2c0-1.653-1.347-3-3-3s-3 1.347-3 3h-5c0-1.653-1.347-3-3-3s-3 1.347-3 3v0h-1v-2.219c0-1.306-0.003-2.337 0.369-3.028 0.034-0.063 0.072-0.128 0.122-0.197 1.134 0.663 2.991 1.078 5.706 1.291 1.591 0.125 3.353 0.169 5.178 0.169 1.075 0 2.175-0.016 3.269-0.038 0.484 0.141 0.987 0.266 1.481 0.391 2.341 0.584 3.875 1.050 3.875 2.131zM5.166 12.203c2.866-0.675 6.828 0.422 9.181 1.812-4.113 0.034-8.85-0.128-11.037-1.156 0.416-0.228 1.003-0.456 1.856-0.656zM19.5 9c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5h0.5v5h-0.5z" })
        );
    }
    function CarPlug({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CarPlugSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CarPlug.SVG = CarPlugSVG;
    return CarPlug;
})();
export const CarWash = /*#__PURE__*/ (() => {
        function CarWashSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4.5 8c0.813 0 1.5-0.781 1.5-1.706 0-0.678-0.328-1.659-0.616-2.528-0.181-0.541-0.35-1.053-0.387-1.331-0.034-0.25-0.247-0.434-0.497-0.434s-0.462 0.184-0.497 0.434c-0.038 0.278-0.206 0.791-0.387 1.331-0.288 0.869-0.616 1.85-0.616 2.528 0 0.925 0.687 1.706 1.5 1.706zM4.5 4.278c0.237 0.716 0.5 1.544 0.5 2.016 0 0.363-0.244 0.706-0.5 0.706s-0.5-0.344-0.5-0.706c0-0.472 0.263-1.3 0.5-2.016z" }),
_('path', { d: "M9.5 8c0.813 0 1.5-0.781 1.5-1.706 0-0.678-0.328-1.659-0.616-2.528-0.181-0.541-0.35-1.053-0.387-1.331-0.034-0.25-0.247-0.434-0.497-0.434s-0.462 0.184-0.497 0.434c-0.037 0.278-0.206 0.791-0.387 1.331-0.288 0.869-0.616 1.85-0.616 2.528 0 0.925 0.687 1.706 1.5 1.706zM9.5 4.278c0.237 0.716 0.5 1.544 0.5 2.016 0 0.363-0.244 0.706-0.5 0.706s-0.5-0.344-0.5-0.706c0-0.472 0.262-1.3 0.5-2.016z" }),
_('path', { d: "M14.5 8c0.813 0 1.5-0.781 1.5-1.706 0-0.678-0.328-1.659-0.616-2.528-0.181-0.541-0.35-1.053-0.387-1.331-0.034-0.25-0.247-0.434-0.497-0.434s-0.462 0.184-0.497 0.434c-0.037 0.278-0.206 0.791-0.387 1.331-0.288 0.869-0.616 1.85-0.616 2.528 0 0.925 0.687 1.706 1.5 1.706zM14.5 4.278c0.237 0.716 0.5 1.544 0.5 2.016 0 0.363-0.244 0.706-0.5 0.706s-0.5-0.344-0.5-0.706c0-0.472 0.263-1.3 0.5-2.016z" }),
_('path', { d: "M19.5 8c0.813 0 1.5-0.781 1.5-1.706 0-0.678-0.328-1.659-0.616-2.528-0.181-0.541-0.35-1.053-0.387-1.331-0.034-0.25-0.247-0.434-0.497-0.434s-0.462 0.184-0.497 0.434c-0.038 0.278-0.206 0.791-0.387 1.331-0.288 0.869-0.616 1.85-0.616 2.528 0 0.925 0.687 1.706 1.5 1.706zM19.5 4.278c0.237 0.716 0.5 1.544 0.5 2.016 0 0.363-0.244 0.706-0.5 0.706s-0.5-0.344-0.5-0.706c0-0.472 0.262-1.3 0.5-2.016z" }),
_('path', { d: "M22.016 14.553c-0.978-0.519-2.212-0.828-3.406-1.125-1.156-0.291-2.356-0.591-3.091-1.041-2.737-1.678-7.331-2.95-10.809-2.131-1.069 0.253-1.913 0.572-2.572 0.978-0.684 0.419-1.184 0.934-1.528 1.572-0.612 1.134-0.609 2.45-0.609 3.978v2.219c0 1.103 0.897 2 2 2h1.766c0.55 0.612 1.347 1 2.234 1s1.684-0.387 2.234-1h6.531c0.55 0.612 1.347 1 2.234 1s1.684-0.387 2.234-1h2.766c1.103 0 2-0.897 2-2v-1.5c0-1.263-0.666-2.253-1.984-2.95zM5.166 12.203c2.866-0.675 6.828 0.422 9.181 1.812-4.113 0.034-8.85-0.128-11.037-1.156 0.416-0.228 1.003-0.456 1.856-0.656zM6 21c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM17 21c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM22 19h-2c0-1.653-1.347-3-3-3s-3 1.347-3 3h-5c0-1.653-1.347-3-3-3s-3 1.347-3 3v0h-1v-2.219c0-1.306-0.003-2.337 0.369-3.028 0.034-0.063 0.072-0.128 0.122-0.197 1.134 0.663 2.991 1.078 5.706 1.291 1.591 0.125 3.353 0.169 5.178 0.169 1.075 0 2.175-0.016 3.269-0.038 0.484 0.141 0.987 0.266 1.481 0.391 2.341 0.588 3.875 1.050 3.875 2.131v1.5z" })
            );
        }
        function CarWash({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CarWashSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CarWash.SVG = CarWashSVG;
        return CarWash;
    })();
export const Car = /*#__PURE__*/ (() => {
    function CarSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.016 10.553c-0.978-0.519-2.212-0.828-3.406-1.125-1.156-0.291-2.356-0.591-3.091-1.041-2.737-1.678-7.331-2.95-10.809-2.131-1.069 0.253-1.913 0.572-2.572 0.978-0.684 0.419-1.184 0.934-1.528 1.572-0.612 1.134-0.609 2.45-0.609 3.978v2.219c0 1.103 0.897 2 2 2h1.766c0.55 0.612 1.347 1 2.234 1s1.684-0.387 2.234-1h6.531c0.55 0.612 1.347 1 2.234 1s1.684-0.387 2.234-1h2.766c1.103 0 2-0.897 2-2v-1.5c0-1.263-0.666-2.253-1.984-2.95zM5.166 8.203c2.866-0.675 6.828 0.422 9.181 1.812-4.113 0.034-8.85-0.128-11.037-1.156 0.416-0.228 1.003-0.456 1.856-0.656zM6 17c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM17 17c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM22 15h-2c0-1.653-1.347-3-3-3s-3 1.347-3 3h-5c0-1.653-1.347-3-3-3s-3 1.347-3 3v0h-1v-2.219c0-1.306-0.003-2.337 0.369-3.028 0.034-0.063 0.072-0.128 0.122-0.197 1.134 0.663 2.991 1.078 5.706 1.291 1.591 0.125 3.353 0.169 5.178 0.169 1.075 0 2.175-0.016 3.269-0.038 0.484 0.141 0.987 0.266 1.481 0.391 2.341 0.588 3.875 1.050 3.875 2.131v1.5z" })
        );
    }
    function Car({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Car.SVG = CarSVG;
    return Car;
})();
export const Car2 = /*#__PURE__*/ (() => {
    function Car2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23 6h-1.25c-0.322 0-0.653 0.197-0.809 0.475l-0.422 0.756c-0.106-0.275-0.203-0.578-0.303-0.9-0.206-0.663-0.444-1.416-0.862-2.103-0.594-0.975-1.803-1.612-3.691-1.953-1.038-0.188-2.234-0.278-3.663-0.278s-2.628 0.091-3.663 0.278c-1.887 0.341-3.094 0.978-3.691 1.95-0.422 0.687-0.656 1.441-0.866 2.103-0.1 0.322-0.197 0.625-0.303 0.9l-0.422-0.756c0 0 0-0.003-0.003-0.003-0.156-0.278-0.491-0.472-0.806-0.472h-1.247c-0.55 0-1 0.45-1 1s0.45 1 1 1h1.763l0.119 0.213c-0.009 0.009-0.022 0.019-0.031 0.028-0.619 0.531-1.156 1.053-1.472 2.072-0.272 0.869-0.375 2.041-0.375 4.188v1c0 0.744 0.4 1.481 1 1.928v2.075c0 0.828 0.672 1.5 1.5 1.5h2c0.828 0 1.5-0.672 1.5-1.5v-0.825c1.394 0.184 3.081 0.325 5 0.325s3.606-0.141 5-0.325v0.825c0 0.828 0.672 1.5 1.5 1.5h2c0.828 0 1.5-0.672 1.5-1.5v-2.072c0.6-0.45 1-1.188 1-1.928v-1c0-2.069-0.122-3.331-0.406-4.219-0.325-1.019-0.869-1.547-1.441-2.041-0.012-0.009-0.022-0.019-0.034-0.028l0.119-0.213h1.759c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 13c-1.1 0-2.216 0.172-3.028 0.334-0.022-0.066-0.059-0.128-0.113-0.181-0.081-0.084-2.016-2.059-5.603-2.15 0.15-0.519 0.372-0.781 0.678-1.059 4.916-1.263 11.203-1.266 16.122 0 0.284 0.259 0.506 0.525 0.663 1.059-3.572 0.097-5.5 2.066-5.581 2.15-0.050 0.053-0.087 0.116-0.112 0.181-0.809-0.162-1.925-0.334-3.025-0.334zM3.087 12c1.684 0.016 2.956 0.506 3.731 0.919 0.409 0.219 0.728 0.438 0.947 0.606l-0.472 0.475c-2.128-0.006-3.144-0.138-4.278-0.775 0.012-0.484 0.038-0.888 0.072-1.225zM16.234 13.528c0.222-0.172 0.541-0.391 0.947-0.606 0.775-0.413 2.044-0.9 3.719-0.919 0.038 0.341 0.063 0.744 0.078 1.225-1.131 0.638-2.147 0.766-4.275 0.775l-0.469-0.475zM5.691 6.928c0.191-0.606 0.369-1.178 0.663-1.659 0.375-0.612 2.056-1.269 5.647-1.269s5.272 0.656 5.647 1.272c0.294 0.478 0.472 1.050 0.663 1.656 0.178 0.566 0.369 1.178 0.678 1.741-1.563-0.319-3.225-0.525-4.919-0.616l2.125-1.416-0.556-0.831-3.291 2.194c-1.128-0.009-2.262 0.028-3.375 0.119l2.222-1.481-0.556-0.831-3.828 2.556c-0.609 0.087-1.209 0.191-1.797 0.312 0.309-0.569 0.503-1.178 0.678-1.747zM6 19.5c0 0.275-0.225 0.5-0.5 0.5h-2c-0.275 0-0.5-0.225-0.5-0.5v-1.625c0.513 0.147 1.547 0.416 3 0.653v0.972zM3.266 15.866h-0.003c-0.109-0.038-0.263-0.247-0.263-0.366v-1c0-0.053 0-0.109 0-0.162 1.212 0.559 2.444 0.663 4.5 0.663 0.131 0 0.259-0.053 0.353-0.147l0.306-0.306c0.469-0.122 2.206-0.547 3.841-0.547 1.638 0 3.372 0.425 3.841 0.547l0.306 0.306c0.094 0.094 0.222 0.147 0.353 0.147 2.056 0 3.288-0.103 4.5-0.663 0 0.053 0 0.106 0 0.162v1c0 0.119-0.153 0.328-0.266 0.366-0.034 0.012-3.484 1.134-8.734 1.134s-8.7-1.122-8.734-1.134zM20.5 20h-2c-0.275 0-0.5-0.225-0.5-0.5v-0.972c1.453-0.237 2.487-0.503 3-0.653v1.625c0 0.275-0.225 0.5-0.5 0.5z" })
        );
    }
    function Car2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Car2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Car2.SVG = Car2SVG;
    return Car2;
})();
export const Carrot = /*#__PURE__*/ (() => {
    function CarrotSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.975 7.344c-0.181-0.556-0.634-1.144-1.237-1.616-0.397-0.306-0.806-0.528-1.188-0.641 0.112-0.691 0.406-1.428 1.284-2.216 0.159-0.144 0.209-0.369 0.128-0.566s-0.278-0.319-0.491-0.306c-0.875 0.053-1.625 0.219-2.269 0.5 0.066-0.716-0.009-1.434-0.222-2.144-0.063-0.2-0.237-0.341-0.447-0.356-0.206-0.016-0.403 0.1-0.491 0.288-0.4 0.866-0.803 1.378-1.269 1.603-0.363-0.675-1.034-1.275-2.034-1.828-0.156-0.084-0.344-0.084-0.497 0.006-0.15 0.091-0.244 0.253-0.244 0.431 0 1.134-0.119 1.844-0.466 2.531-0.738-0.078-1.484-0.003-2.197 0.228-0.931 0.3-1.759 0.85-2.397 1.591-1.641 1.903-4.022 4.781-6.041 7.697-2.625 3.787-3.9 6.553-3.9 8.453 0 1.653 1.347 3 3 3 1.9 0 4.666-1.275 8.456-3.9 2.916-2.019 5.794-4.4 7.697-6.041 0.741-0.638 1.291-1.469 1.591-2.397 0.3-0.931 0.337-1.925 0.109-2.875-0.031-0.134-0.069-0.269-0.106-0.4 0.647-0.325 1.459-0.387 2.753-0.387 0.159 0 0.309-0.078 0.403-0.206 0.097-0.128 0.122-0.297 0.072-0.45zM17.847 12.544c-1.656 1.431-3.237 2.722-4.716 3.856-0.619-0.141-1.491-0.469-2.275-1.253l-0.356-0.353-0.706 0.706 0.353 0.353c0.659 0.659 1.369 1.053 1.997 1.294-4.172 3.1-7.431 4.853-9.144 4.853-0.55 0-1-0.447-1-1 0-1.278 0.975-3.419 2.763-6.159 0.272 0.619 0.7 1.328 1.384 2.013l0.353 0.353 0.706-0.706-0.353-0.353c-0.834-0.834-1.222-1.719-1.4-2.334 1.225-1.781 2.75-3.778 4.538-5.928 0.372 0.797 1.022 1.841 2.153 2.972l0.353 0.353 0.706-0.706-0.353-0.353c-1.275-1.275-1.869-2.416-2.138-3.125 0.244-0.288 0.491-0.575 0.741-0.866 0.644-0.744 1.559-1.156 2.512-1.156 0.259 0 0.522 0.031 0.781 0.094 2.259 0.541 3.619 1.903 4.162 4.163v0c0.291 1.206-0.116 2.469-1.062 3.284zM20.419 7.437c-0.375-0.903-0.888-1.681-1.531-2.328-0.875-0.875-2-1.506-3.347-1.881 0.263-0.594 0.381-1.181 0.428-1.847 0.559 0.406 0.906 0.825 1.053 1.272 0.078 0.234 0.316 0.375 0.556 0.334 0.716-0.119 1.241-0.531 1.641-1.038 0.003 0.469-0.063 0.938-0.203 1.4-0.063 0.209 0.019 0.434 0.2 0.559 0.181 0.122 0.422 0.113 0.591-0.025 0.387-0.312 0.859-0.541 1.419-0.691-0.537 0.837-0.675 1.625-0.725 2.269-0.009 0.138 0.038 0.275 0.131 0.378s0.228 0.159 0.366 0.159c0.403 0 1.162 0.444 1.644 1.013-0.834 0.028-1.563 0.125-2.222 0.425z" })
        );
    }
    function Carrot({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CarrotSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Carrot.SVG = CarrotSVG;
    return Carrot;
})();
export const CartCheck = /*#__PURE__*/ (() => {
        function CartCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.278 16c0.844 0 1.594-0.528 1.881-1.316l1.347-3.066c1.516-1.194 2.494-3.044 2.494-5.119 0-3.584-2.916-6.5-6.5-6.5s-6.5 2.916-6.5 6.5c0 0.169 0.006 0.334 0.019 0.5h-4.9l-0.947-1.894c-0.341-0.681-1.025-1.106-1.788-1.106h-3.384v2h3.381l4.4 8.803-2.281 2.281c-0.491 0.491-0.634 1.222-0.369 1.863s0.884 1.053 1.578 1.053h15.291v-2h-14.584l2-2h8.862zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM11.175 8c0.678 2.862 3.256 5 6.325 5 0.434 0 0.856-0.044 1.269-0.125l-0.456 1.041c-0.012 0.028-0.022 0.056-0.034 0.084h-8.659l-3-6h4.556z" }),
_('path', { d: "M8 22c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM10 21c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M17 22c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM19 21c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M16.5 9c0.128 0 0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147z" })
            );
        }
        function CartCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CartCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CartCheck.SVG = CartCheckSVG;
        return CartCheck;
    })();
export const CartCheckout = /*#__PURE__*/ (() => {
        function CartCheckoutSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 22c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM10 21c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M17 22c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM19 21c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5s-6.5 2.916-6.5 6.5c0 0.169 0.006 0.334 0.019 0.5h-4.903l-0.947-1.894c-0.341-0.684-1.025-1.106-1.788-1.106h-3.381v2h3.381c0 0 0 0 0 0l4.403 8.803-2.281 2.281c-0.491 0.491-0.637 1.222-0.372 1.863s0.884 1.053 1.578 1.053h15.291v-2h-14.584l2-2h8.862c0.844 0 1.594-0.528 1.881-1.316l0.938-2.134 0.409-0.934c1.516-1.191 2.494-3.041 2.494-5.116zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM18.281 13.997c-0.003 0.003-0.003 0.003 0 0l-8.663 0.003-3-6h4.556c0.678 2.862 3.256 5 6.325 5 0.434 0 0.859-0.044 1.269-0.125l-0.456 1.038c-0.012 0.028-0.022 0.056-0.031 0.084z" }),
_('path', { d: "M17.794 8.5l0.706 0.706 2.353-2.353c0.194-0.194 0.194-0.513 0-0.706l-2.353-2.353-0.706 0.706 1.5 1.5h-5.294v1h5.294l-1.5 1.5z" })
            );
        }
        function CartCheckout({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CartCheckoutSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CartCheckout.SVG = CartCheckoutSVG;
        return CartCheckout;
    })();
export const CartCross = /*#__PURE__*/ (() => {
        function CartCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 22c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM10 21c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M17 22c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM19 21c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5s-6.5 2.916-6.5 6.5c0 0.169 0.006 0.334 0.019 0.5h-4.903l-0.947-1.894c-0.341-0.684-1.025-1.106-1.788-1.106h-3.381v2h3.381c0 0 0 0 0 0l4.403 8.803-2.281 2.281c-0.491 0.491-0.637 1.222-0.372 1.863s0.884 1.053 1.578 1.053h15.291v-2h-14.584l2-2h8.862c0.844 0 1.594-0.528 1.881-1.316l0.938-2.134 0.409-0.934c1.516-1.191 2.494-3.041 2.494-5.116zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM18.281 13.997c-0.003 0.003-0.003 0.003 0 0l-8.663 0.003-3-6h4.556c0.678 2.862 3.256 5 6.325 5 0.434 0 0.859-0.044 1.269-0.125l-0.456 1.038c-0.012 0.028-0.022 0.056-0.031 0.084z" }),
_('path', { d: "M15.5 9.206l2-2 2 2 0.706-0.706-2-2 2-2-0.706-0.706-2 2-2-2-0.706 0.706 2 2-2 2z" })
            );
        }
        function CartCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CartCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CartCross.SVG = CartCrossSVG;
        return CartCross;
    })();
export const CartFull = /*#__PURE__*/ (() => {
        function CartFullSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 20c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM10 19c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M17 20c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM19 19c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M18.278 14c0.844 0 1.594-0.528 1.881-1.316l2.756-6.281c0.134-0.309 0.106-0.666-0.078-0.95s-0.5-0.453-0.837-0.453h-2.294l-3.853-3.853c-0.194-0.194-0.513-0.194-0.706 0l-2.147 2.147-1.147-1.147c-0.194-0.194-0.513-0.194-0.706 0l-2.853 2.853h-2.175l-0.947-1.894c-0.341-0.681-1.025-1.106-1.791-1.106h-3.381v2h3.381c0 0 0 0 0 0l4.403 8.803-2.281 2.281c-0.491 0.491-0.637 1.222-0.372 1.863s0.884 1.053 1.578 1.053h15.291v-2h-14.584l2-2h8.862zM15.5 2.206l2.794 2.794h-5.588l2.794-2.794zM11.5 3.206l0.794 0.794-1 1h-1.584l1.791-1.794zM20.909 6l-2.597 5.913c-0.012 0.028-0.022 0.056-0.031 0.084 0 0.003 0 0.003-0.003 0.003h-8.659l-3-6h14.291z" })
            );
        }
        function CartFull({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CartFullSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CartFull.SVG = CartFullSVG;
        return CartFull;
    })();
export const CartLoad = /*#__PURE__*/ (() => {
        function CartLoadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.278 16c0.844 0 1.594-0.528 1.881-1.316l1.347-3.066c1.516-1.194 2.494-3.044 2.494-5.119 0-3.584-2.916-6.5-6.5-6.5s-6.5 2.916-6.5 6.5c0 0.169 0.006 0.334 0.019 0.5h-4.9l-0.947-1.894c-0.341-0.681-1.025-1.106-1.788-1.106h-3.384v2h3.381l4.4 8.803-2.281 2.281c-0.491 0.491-0.634 1.222-0.369 1.863s0.884 1.053 1.578 1.053h15.291v-2h-14.584l2-2h8.862zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM11.175 8c0.678 2.862 3.256 5 6.325 5 0.434 0 0.856-0.044 1.269-0.125l-0.456 1.041c-0.012 0.028-0.022 0.056-0.034 0.084h-8.659l-3-6h4.556z" }),
_('path', { d: "M8 22c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM10 21c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M17 22c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM19 21c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M17.5 10c0.128 0 0.256-0.050 0.353-0.147l2.353-2.353-0.706-0.706-1.5 1.5v-5.294h-1v5.294l-1.5-1.5-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147z" })
            );
        }
        function CartLoad({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CartLoadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CartLoad.SVG = CartLoadSVG;
        return CartLoad;
    })();
export const CartManage = /*#__PURE__*/ (() => {
        function CartManageSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.278 16c0.844 0 1.594-0.528 1.881-1.316l1.347-3.066c1.516-1.194 2.494-3.044 2.494-5.119 0-3.584-2.916-6.5-6.5-6.5s-6.5 2.916-6.5 6.5c0 0.169 0.006 0.334 0.019 0.5h-4.9l-0.947-1.894c-0.341-0.681-1.025-1.106-1.788-1.106h-3.384v2h3.381l4.4 8.803-2.281 2.281c-0.491 0.491-0.634 1.222-0.369 1.863s0.884 1.053 1.578 1.053h15.291v-2h-14.584l2-2h8.862zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM11.175 8c0.678 2.862 3.256 5 6.325 5 0.434 0 0.856-0.044 1.269-0.125l-0.456 1.041c-0.012 0.028-0.022 0.056-0.034 0.084h-8.659l-3-6h4.556z" }),
_('path', { d: "M8 22c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM10 21c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M17 22c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM19 21c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M19 5.706v3.294h1v-3.294l0.5 0.5 0.706-0.706-1.353-1.353c-0.194-0.194-0.513-0.194-0.706 0l-1.353 1.353 0.706 0.706 0.5-0.5z" }),
_('path', { d: "M15.5 9c0.128 0 0.256-0.050 0.353-0.147l1.353-1.353-0.706-0.706-0.5 0.5v-3.294h-1v3.294l-0.5-0.5-0.706 0.706 1.353 1.353c0.097 0.097 0.225 0.147 0.353 0.147z" })
            );
        }
        function CartManage({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CartManageSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CartManage.SVG = CartManageSVG;
        return CartManage;
    })();
export const CartMinus = /*#__PURE__*/ (() => {
        function CartMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.278 16c0.844 0 1.594-0.528 1.881-1.316l1.347-3.066c1.516-1.194 2.494-3.044 2.494-5.119 0-3.584-2.916-6.5-6.5-6.5s-6.5 2.916-6.5 6.5c0 0.169 0.006 0.334 0.019 0.5h-4.9l-0.947-1.894c-0.341-0.681-1.025-1.106-1.788-1.106h-3.384v2h3.381l4.4 8.803-2.281 2.281c-0.491 0.491-0.634 1.222-0.369 1.863s0.884 1.053 1.578 1.053h15.291v-2h-14.584l2-2h8.862zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM11.175 8c0.678 2.862 3.256 5 6.325 5 0.434 0 0.856-0.044 1.269-0.125l-0.456 1.041c-0.012 0.028-0.022 0.056-0.034 0.084h-8.659l-3-6h4.556z" }),
_('path', { d: "M8 22c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM10 21c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M17 22c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM19 21c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M15 6h5v1h-5v-1z" })
            );
        }
        function CartMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CartMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CartMinus.SVG = CartMinusSVG;
        return CartMinus;
    })();
export const CartPlus = /*#__PURE__*/ (() => {
        function CartPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.278 16c0.844 0 1.594-0.528 1.881-1.316l1.347-3.066c1.516-1.194 2.494-3.044 2.494-5.119 0-3.584-2.916-6.5-6.5-6.5s-6.5 2.916-6.5 6.5c0 0.169 0.006 0.334 0.019 0.5h-4.9l-0.947-1.894c-0.341-0.681-1.025-1.106-1.788-1.106h-3.384v2h3.381l4.4 8.803-2.281 2.281c-0.491 0.491-0.634 1.222-0.369 1.863s0.884 1.053 1.578 1.053h15.291v-2h-14.584l2-2h8.862zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM11.175 8c0.678 2.862 3.256 5 6.325 5 0.434 0 0.856-0.044 1.269-0.125l-0.456 1.041c-0.012 0.028-0.022 0.056-0.034 0.084h-8.659l-3-6h4.556z" }),
_('path', { d: "M8 22c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM10 21c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M17 22c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM19 21c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M17 9h1v-2h2v-1h-2v-2h-1v2h-2v1h2z" })
            );
        }
        function CartPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CartPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CartPlus.SVG = CartPlusSVG;
        return CartPlus;
    })();
export const CartUnload = /*#__PURE__*/ (() => {
        function CartUnloadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.278 16c0.844 0 1.594-0.528 1.881-1.316l1.347-3.066c1.516-1.194 2.494-3.044 2.494-5.119 0-3.584-2.916-6.5-6.5-6.5s-6.5 2.916-6.5 6.5c0 0.169 0.006 0.334 0.019 0.5h-4.9l-0.947-1.894c-0.341-0.681-1.025-1.106-1.788-1.106h-3.384v2h3.381l4.4 8.803-2.281 2.281c-0.491 0.491-0.634 1.222-0.369 1.863s0.884 1.053 1.578 1.053h15.291v-2h-14.584l2-2h8.862zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM11.175 8c0.678 2.862 3.256 5 6.325 5 0.434 0 0.856-0.044 1.269-0.125l-0.456 1.041c-0.012 0.028-0.022 0.056-0.034 0.084h-8.659l-3-6h4.556z" }),
_('path', { d: "M8 22c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM10 21c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M17 22c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM19 21c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M17 4.706v5.294h1v-5.294l1.5 1.5 0.706-0.706-2.353-2.353c-0.194-0.194-0.513-0.194-0.706 0l-2.353 2.353 0.706 0.706 1.5-1.5z" })
            );
        }
        function CartUnload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CartUnloadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CartUnload.SVG = CartUnloadSVG;
        return CartUnload;
    })();
export const Cart = /*#__PURE__*/ (() => {
        function CartSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.278 14c0.844 0 1.594-0.528 1.881-1.316l2.756-6.281c0.134-0.309 0.106-0.666-0.078-0.95s-0.5-0.453-0.837-0.453h-15.884l-0.947-1.894c-0.338-0.681-1.022-1.106-1.788-1.106h-3.381v2h3.381c0 0 0 0 0 0l4.403 8.803-2.281 2.281c-0.491 0.491-0.638 1.222-0.372 1.863s0.884 1.053 1.578 1.053h15.291v-2h-14.584l2-2h8.862zM20.909 6l-2.597 5.913c-0.012 0.028-0.022 0.056-0.031 0.084 0 0.003 0 0.003-0.003 0.003h-8.659l-3-6h14.291z" }),
_('path', { d: "M8 20c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM10 19c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M17 20c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM19 19c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" })
            );
        }
        function Cart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cart.SVG = CartSVG;
        return Cart;
    })();
export const Cassette = /*#__PURE__*/ (() => {
        function CassetteSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 3h-20c-1.103 0-2 0.897-2 2v13c0 1.103 0.897 2 2 2h3.091c0.044 0.125 0.106 0.244 0.181 0.356 0.281 0.403 0.741 0.644 1.234 0.644h10.988c0.491 0 0.953-0.241 1.234-0.644 0.078-0.113 0.138-0.231 0.181-0.356h3.091c1.103 0 2-0.897 2-2v-13c0-1.103-0.897-2-2-2zM17.906 19.784c-0.094 0.138-0.244 0.216-0.413 0.216h-10.987c-0.166 0-0.316-0.078-0.413-0.216-0.094-0.138-0.116-0.303-0.056-0.459l0.75-2c0.072-0.194 0.262-0.325 0.469-0.325h9.487c0.209 0 0.394 0.128 0.469 0.325l0.75 2c0.059 0.156 0.038 0.325-0.056 0.459zM22 18h-3.466l-0.384-1.025c-0.219-0.581-0.784-0.975-1.406-0.975h-9.488c-0.622 0-1.188 0.391-1.406 0.975l-0.384 1.025h-3.466v-13h20v13z" }),
_('path', { d: "M7.5 12c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM7.5 10c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M16.5 12c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM16.5 10c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M7.5 14h9c1.931 0 3.5-1.569 3.5-3.5s-1.569-3.5-3.5-3.5h-9c-1.931 0-3.5 1.569-3.5 3.5s1.569 3.5 3.5 3.5zM19 10.5c0 1.378-1.122 2.5-2.5 2.5h-5.259c0.491-0.734 0.759-1.603 0.759-2.5s-0.269-1.766-0.759-2.5h5.259c1.378 0 2.5 1.122 2.5 2.5zM7.5 8h2.45c0.669 0.656 1.050 1.559 1.050 2.5 0 0.944-0.381 1.844-1.050 2.5h-2.45c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5z" }),
_('path', { d: "M9 18.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M16 18.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Cassette({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CassetteSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cassette.SVG = CassetteSVG;
        return Cassette;
    })();
export const Ccw = /*#__PURE__*/ (() => {
        function CcwSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813s-2.384-1.966-3.813-2.572c-1.481-0.625-3.053-0.944-4.672-0.944-1.956 0-3.9 0.481-5.616 1.394-0.856 0.456-1.659 1.016-2.384 1.666v-3.059h-2v6c0 0.553 0.447 1 1 1h6v-2h-4.141c1.866-1.9 4.437-3 7.141-3 5.513 0 10 4.488 10 10s-4.488 10-10 10c-3.394 0-6.528-1.7-8.384-4.547l-1.675 1.094c2.228 3.416 5.988 5.453 10.059 5.453 1.619 0 3.191-0.319 4.672-0.944 1.428-0.603 2.712-1.469 3.813-2.572s1.966-2.384 2.572-3.813c0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672z" }),
_('path', { d: "M12 20c-4.413 0-8-3.588-8-8h-1c0 2.403 0.938 4.662 2.637 6.363s3.959 2.637 6.363 2.637c2.403 0 4.662-0.938 6.363-2.637s2.637-3.959 2.637-6.363c0-2.403-0.938-4.662-2.637-6.363s-3.959-2.637-6.363-2.637v1c4.413 0 8 3.588 8 8s-3.588 8-8 8z" })
            );
        }
        function Ccw({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CcwSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ccw.SVG = CcwSVG;
        return Ccw;
    })();
export const Ccw2 = /*#__PURE__*/ (() => {
        function Ccw2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 2h-6c-0.553 0-1 0.447-1 1v6h2v-4.141c1.9 1.866 3 4.437 3 7.141 0 5.513-4.488 10-10 10s-10-4.488-10-10c0-3.394 1.7-6.528 4.547-8.384l-1.094-1.675c-3.416 2.228-5.453 5.988-5.453 10.059 0 1.619 0.319 3.191 0.944 4.672 0.603 1.428 1.469 2.712 2.572 3.813s2.384 1.966 3.813 2.572c1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572s1.966-2.384 2.572-3.813c0.625-1.481 0.944-3.053 0.944-4.672 0-1.956-0.481-3.9-1.394-5.616-0.456-0.856-1.016-1.659-1.666-2.384h3.059v-2z" }),
_('path', { d: "M3 12c0 2.403 0.938 4.662 2.637 6.363s3.959 2.637 6.363 2.637c2.403 0 4.662-0.938 6.363-2.637s2.637-3.959 2.637-6.363h-1c0 4.413-3.588 8-8 8s-8-3.588-8-8c0-4.413 3.588-8 8-8v-1c-2.403 0-4.662 0.938-6.363 2.637s-2.637 3.959-2.637 6.363z" }),
_('path', { d: "M8 12c0 2.206 1.794 4 4 4s4-1.794 4-4c0-2.206-1.794-4-4-4s-4 1.794-4 4zM15 12c0 1.653-1.347 3-3 3s-3-1.347-3-3 1.347-3 3-3 3 1.347 3 3z" })
            );
        }
        function Ccw2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Ccw2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ccw2.SVG = Ccw2SVG;
        return Ccw2;
    })();
export const Certificate = /*#__PURE__*/ (() => {
        function CertificateSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 4h5v1h-5v-1z" }),
_('path', { d: "M6 6h12v1h-12v-1z" }),
_('path', { d: "M6 8h11v1h-11v-1z" }),
_('path', { d: "M6 10h12v1h-12v-1z" }),
_('path', { d: "M6 12h4v1h-4v-1z" }),
_('path', { d: "M6 14h2v1h-2v-1z" }),
_('path', { d: "M6 16h3v1h-3v-1z" }),
_('path', { d: "M16.281 16.947c0.447-0.525 0.719-1.203 0.719-1.947 0-1.653-1.347-3-3-3s-3 1.347-3 3c0 0.741 0.272 1.422 0.719 1.947l-2.666 5.331c-0.097 0.194-0.059 0.425 0.094 0.578s0.384 0.191 0.578 0.094l1.553-0.775 0.775 1.553c0.084 0.172 0.259 0.275 0.447 0.275 0.019 0 0.041 0 0.059-0.003 0.209-0.025 0.381-0.178 0.428-0.384l1.012-4.391 1.013 4.388c0.047 0.206 0.219 0.359 0.428 0.384 0.019 0.003 0.041 0.003 0.059 0.003 0.188 0 0.363-0.106 0.447-0.275l0.775-1.553 1.553 0.775c0.194 0.097 0.425 0.059 0.578-0.094s0.191-0.384 0.094-0.578l-2.666-5.328zM14 14c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM12.325 22.034l-0.378-0.756c-0.125-0.247-0.425-0.347-0.672-0.225l-0.659 0.328 1.891-3.781c0.237 0.138 0.497 0.241 0.769 0.309l-0.95 4.125zM16.725 21.053c-0.247-0.125-0.547-0.022-0.672 0.225l-0.378 0.756-0.95-4.122c0.272-0.069 0.531-0.172 0.769-0.309l1.891 3.781-0.659-0.331z" }),
_('path', { d: "M19 0h-14c-1.103 0-2 0.897-2 2v17c0 1.103 0.897 2 2 2h4v-2h-4v-17h14v17c0 0 0 0 0 0v2c1.103 0 2-0.897 2-2v-17c0-1.103-0.897-2-2-2z" })
            );
        }
        function Certificate({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CertificateSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Certificate.SVG = CertificateSVG;
        return Certificate;
    })();
export const Certificate2 = /*#__PURE__*/ (() => {
        function Certificate2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 3h-12v-0.5c0-0.275-0.225-0.5-0.5-0.5h-5c-0.275 0-0.5 0.225-0.5 0.5v0.5h-2c-1.103 0-2 0.897-2 2v15c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-15c0-1.103-0.897-2-2-2zM5 3h4v7.119l-1.616-1.941c-0.094-0.113-0.234-0.181-0.384-0.181s-0.291 0.066-0.384 0.181l-1.616 1.941v-7.119zM22 20h-20v-15h2v6.5c0 0.209 0.131 0.4 0.331 0.469 0.197 0.072 0.419 0.012 0.553-0.15l2.116-2.538 2.116 2.541c0.097 0.116 0.237 0.181 0.384 0.181 0.056 0 0.116-0.009 0.169-0.031 0.197-0.072 0.331-0.259 0.331-0.469v-6.503h12v15z" }),
_('path', { d: "M12 7h8v1h-8v-1z" }),
_('path', { d: "M12 9h4v1h-4v-1z" }),
_('path', { d: "M12 11h5v1h-5v-1z" }),
_('path', { d: "M4 13h16v1h-16v-1z" }),
_('path', { d: "M4 15h14v1h-14v-1z" }),
_('path', { d: "M4 17h15v1h-15v-1z" })
            );
        }
        function Certificate2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Certificate2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Certificate2.SVG = Certificate2SVG;
        return Certificate2;
    })();
export const Chair = /*#__PURE__*/ (() => {
    function ChairSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18.022 12c0.075-1.741 0.334-3.216 0.566-4.544 0.222-1.272 0.412-2.369 0.412-3.456 0-1.222-0.738-2.287-2.078-3.003-1.222-0.653-2.925-0.997-4.922-0.997s-3.7 0.344-4.922 0.997c-1.341 0.716-2.078 1.781-2.078 3.003 0 1.088 0.191 2.184 0.412 3.456 0.231 1.328 0.491 2.803 0.566 4.544-1.094 0.012-1.978 0.903-1.978 2v1.5c0 0.275 0.225 0.5 0.5 0.5h1.488c-0.109 2.597-0.966 7.591-0.975 7.644l1.972 0.341c0.038-0.225 0.9-5.253 1.003-7.981h1.012v7h1v-7.003h4v7h1v-7h1.009c0.106 2.728 0.966 7.756 1.003 7.981l1.972-0.341c-0.009-0.053-0.862-5.047-0.975-7.644h1.491c0.275 0 0.5-0.225 0.5-0.5v-1.5c0-1.094-0.884-1.984-1.978-1.997zM17 4c0 0.912-0.178 1.934-0.384 3.112-0.247 1.413-0.522 2.988-0.597 4.887h-2.009c0.094-4.5 0.797-7.95 1.197-9.563 1.178 0.391 1.794 0.987 1.794 1.563zM14.234 2.191c-0.138 0.55-0.306 1.303-0.478 2.238-0.312 1.719-0.681 4.366-0.747 7.572h-2.022c-0.066-3.206-0.434-5.853-0.747-7.572-0.172-0.934-0.341-1.688-0.478-2.238 0.644-0.119 1.388-0.191 2.238-0.191s1.594 0.072 2.234 0.191zM8.794 2.438c0.397 1.609 1.1 5.053 1.194 9.563h-2.009c-0.075-1.9-0.35-3.475-0.597-4.887-0.206-1.181-0.384-2.2-0.384-3.112 0.003-0.575 0.619-1.172 1.797-1.563zM6 15v-1h12v1h-12z" })
        );
    }
    function Chair({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChairSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Chair.SVG = ChairSVG;
    return Chair;
})();
export const ChargingStation = /*#__PURE__*/ (() => {
        function ChargingStationSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 3h-2v-3h-1v3h-2v-3h-1v3h-2v1h1v0.5c0 0.919 0.3 1.784 0.847 2.441 0.328 0.394 0.722 0.684 1.153 0.863v10.197c0 0.55-0.45 1-1 1s-1-0.45-1-1v-6c0-1.653-1.347-3-3-3v-5c0-1.103-0.897-2-2-2h-9c-1.103 0-2 0.897-2 2v18h-1v2h15v-2h-1v-11c0.55 0 1 0.45 1 1v6c0 1.653 1.347 3 3 3s3-1.347 3-3v-10.197c0.431-0.175 0.825-0.469 1.153-0.863 0.547-0.656 0.847-1.522 0.847-2.441v-0.5h1v-1zM3 22v-18h9v18h-9zM22 4.5c0 1.378-0.897 2.5-2 2.5s-2-1.122-2-2.5v-0.5h4v0.5z" }),
_('path', { d: "M10.944 10.272c-0.084-0.166-0.256-0.272-0.444-0.272h-2.191l1.638-3.275c0.078-0.156 0.069-0.341-0.022-0.488s-0.253-0.237-0.425-0.237h-4c-0.244 0-0.453 0.178-0.494 0.419l-1 6c-0.025 0.144 0.016 0.294 0.112 0.406s0.234 0.178 0.381 0.178h1.391l-0.881 4.403c-0.047 0.231 0.075 0.462 0.291 0.556 0.066 0.028 0.131 0.041 0.2 0.041 0.156 0 0.309-0.075 0.406-0.209l5-7c0.109-0.156 0.125-0.356 0.038-0.522zM6.447 15.312l0.544-2.716c0.028-0.147-0.009-0.3-0.103-0.416s-0.237-0.184-0.387-0.184h-1.409l0.834-5h2.769l-1.638 3.275c-0.078 0.156-0.069 0.341 0.022 0.488s0.253 0.237 0.425 0.237h2.028l-3.084 4.316z" })
            );
        }
        function ChargingStation({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChargingStationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ChargingStation.SVG = ChargingStationSVG;
        return ChargingStation;
    })();
export const ChartCircle = /*#__PURE__*/ (() => {
        function ChartCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M7 10h2v7h-2v-7z" }),
_('path', { d: "M11 12h2v5h-2v-5z" }),
_('path', { d: "M15 7h2v10h-2v-10z" })
            );
        }
        function ChartCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChartCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ChartCircle.SVG = ChartCircleSVG;
        return ChartCircle;
    })();
export const ChartDownward = /*#__PURE__*/ (() => {
        function ChartDownwardSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 11h-2c-0.553 0-1 0.447-1 1v11.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11.5c0-0.553-0.447-1-1-1zM14 23v-10h1v10h-1z" }),
_('path', { d: "M10 15h-2c-0.553 0-1 0.447-1 1v7.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-7.5c0-0.553-0.447-1-1-1zM8 23v-6h1v6h-1z" }),
_('path', { d: "M4 7h-2c-0.553 0-1 0.447-1 1v15.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-15.5c0-0.553-0.447-1-1-1zM2 23v-14h1v14h-1z" }),
_('path', { d: "M22 15h-2c-0.553 0-1 0.447-1 1v7.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-7.5c0-0.553-0.447-1-1-1zM20 23v-6h1v6h-1z" }),
_('path', { d: "M23 9v1.272l-6.222-4.188c-0.122-0.081-0.275-0.106-0.416-0.066l-6.738 1.925-8.172-7.15-0.659 0.753 8.375 7.328c0.128 0.113 0.303 0.15 0.466 0.103l6.775-1.938 5.881 3.959h-1.291v1h2.5c0.275 0 0.5-0.225 0.5-0.5v-2.5h-1z" })
            );
        }
        function ChartDownward({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChartDownwardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ChartDownward.SVG = ChartDownwardSVG;
        return ChartDownward;
    })();
export const ChartSquare = /*#__PURE__*/ (() => {
        function ChartSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M7 10h2v8h-2v-8z" }),
_('path', { d: "M11 12h2v6h-2v-6z" }),
_('path', { d: "M15 7h2v11h-2v-11z" })
            );
        }
        function ChartSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChartSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ChartSquare.SVG = ChartSquareSVG;
        return ChartSquare;
    })();
export const ChartUpward = /*#__PURE__*/ (() => {
        function ChartUpwardSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 15h-2c-0.553 0-1 0.447-1 1v7.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-7.5c0-0.553-0.447-1-1-1zM14 23v-6h1v6h-1z" }),
_('path', { d: "M10 11h-2c-0.553 0-1 0.447-1 1v11.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11.5c0-0.553-0.447-1-1-1zM8 23v-10h1v10h-1z" }),
_('path', { d: "M4 15h-2c-0.553 0-1 0.447-1 1v7.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-7.5c0-0.553-0.447-1-1-1zM2 23v-6h1v6h-1z" }),
_('path', { d: "M22 7h-2c-0.553 0-1 0.447-1 1v15.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-15.5c0-0.553-0.447-1-1-1zM20 23v-14h1v14h-1z" }),
_('path', { d: "M23.5 0h-2.5v1h1.194l-8.803 6.95-6.753-1.928c-0.156-0.044-0.322-0.009-0.45 0.091l-5.391 4.312 0.625 0.781 5.187-4.15 6.753 1.928c0.153 0.044 0.322 0.012 0.447-0.087l9.191-7.259v1.362h1v-2.5c0-0.275-0.225-0.5-0.5-0.5z" })
            );
        }
        function ChartUpward({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChartUpwardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ChartUpward.SVG = ChartUpwardSVG;
        return ChartUpward;
    })();
export const Chart = /*#__PURE__*/ (() => {
        function ChartSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 17c1.103 0 2-0.897 2-2 0-0.366-0.1-0.712-0.272-1.006l2.281-3.994c0.1 0 0.197-0.009 0.294-0.022l1.834 2.294c-0.087 0.225-0.138 0.472-0.138 0.728 0 1.103 0.897 2 2 2s2-0.897 2-2c0-0.487-0.175-0.938-0.469-1.284l2.816-7.747c0.938-0.166 1.653-0.984 1.653-1.969 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 0.487 0.175 0.938 0.469 1.284l-2.8 7.7-1.806-2.256c0.087-0.225 0.138-0.472 0.138-0.728 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 0.366 0.1 0.712 0.272 1.006l-2.281 3.994c-1.1 0.006-1.991 0.9-1.991 2 0 1.103 0.897 2 2 2zM17 14c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM21 1c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM13 7c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM9 14c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M23.706 20.294l-2.25-2.25-1.416 1.416 0.544 0.544h-16.584v-16.587l0.544 0.544 1.416-1.416-2.25-2.25c-0.391-0.391-1.025-0.391-1.416 0l-2.25 2.25 1.416 1.416 0.541-0.544v17.584c0 0.553 0.447 1 1 1h17.584l-0.544 0.544 1.416 1.416 2.25-2.25c0.391-0.394 0.391-1.025 0-1.416z" })
            );
        }
        function Chart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Chart.SVG = ChartSVG;
        return Chart;
    })();
export const CheckCircle = /*#__PURE__*/ (() => {
        function CheckCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M10 14.584l-2.544-2.544-1.416 1.416 3.25 3.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l7.25-7.25-1.416-1.416-6.537 6.544z" })
            );
        }
        function CheckCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CheckCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CheckCircle.SVG = CheckCircleSVG;
        return CheckCircle;
    })();
export const CheckSquare = /*#__PURE__*/ (() => {
        function CheckSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M10 17c0.256 0 0.513-0.097 0.706-0.294l7.25-7.25-1.416-1.416-6.541 6.544-2.544-2.544-1.416 1.416 3.25 3.25c0.197 0.197 0.453 0.294 0.709 0.294z" })
            );
        }
        function CheckSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CheckSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CheckSquare.SVG = CheckSquareSVG;
        return CheckSquare;
    })();
export const Check = /*#__PURE__*/ (() => {
    function CheckSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.544 3.044l-15.544 15.541-5.544-5.541-1.413 1.413 6.25 6.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l16.25-16.25-1.413-1.413z" })
        );
    }
    function Check({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Check.SVG = CheckSVG;
    return Check;
})();
export const CheckboxUnchecked = /*#__PURE__*/ (() => {
        function CheckboxUncheckedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" })
            );
        }
        function CheckboxUnchecked({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CheckboxUncheckedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CheckboxUnchecked.SVG = CheckboxUncheckedSVG;
        return CheckboxUnchecked;
    })();
export const ChecklistTime = /*#__PURE__*/ (() => {
        function ChecklistTimeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 4h15v2h-15v-2z" }),
_('path', { d: "M2.5 4.794l-1-1-0.706 0.706 1.353 1.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l3.353-3.353-0.706-0.706-3 3z" }),
_('path', { d: "M2.5 10.794l-1-1-0.706 0.706 1.353 1.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l3.353-3.353-0.706-0.706-3 3z" }),
_('path', { d: "M2.5 16.794l-1-1-0.706 0.706 1.353 1.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l3.353-3.353-0.706-0.706-3 3z" }),
_('path', { d: "M17.5 9c-1.272 0-2.459 0.366-3.459 1h-6.041v2h4.025c-0.65 1.009-1.025 2.212-1.025 3.5 0 0.169 0.006 0.334 0.019 0.5h-3.019v2h3.5c0.981 2.347 3.3 4 6 4 3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5zM18 20.978v-1.978h-1v1.978c-2.634-0.237-4.737-2.344-4.978-4.978h1.978v-1h-1.978c0.237-2.634 2.344-4.737 4.978-4.978v1.978h1v-1.978c2.634 0.237 4.737 2.344 4.978 4.978h-1.978v1h1.978c-0.241 2.634-2.344 4.737-4.978 4.978z" }),
_('path', { d: "M17.422 15.716l-1.922-1.922-0.706 0.706 2.353 2.353c0.094 0.094 0.222 0.147 0.353 0.147 0.016 0 0.034 0 0.050-0.003 0.15-0.016 0.284-0.097 0.366-0.219l2.278-3.416-0.831-0.556-1.941 2.909z" })
            );
        }
        function ChecklistTime({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChecklistTimeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ChecklistTime.SVG = ChecklistTimeSVG;
        return ChecklistTime;
    })();
export const Checklist = /*#__PURE__*/ (() => {
        function ChecklistSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 3h-1v2h1v17h-14v-17h1v-2h-1c-1.103 0-2 0.897-2 2v17c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-17c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M7.5 5h9c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.828-0.672-1.5-1.5-1.5h-0.559c-0.119-0.494-0.416-0.947-0.859-1.303-0.563-0.45-1.3-0.697-2.081-0.697s-1.519 0.247-2.081 0.697c-0.447 0.356-0.741 0.809-0.859 1.303h-0.559c-0.828 0-1.5 0.672-1.5 1.5v1c0 0.275 0.225 0.5 0.5 0.5zM8 3.5c0-0.275 0.225-0.5 0.5-0.5h1c0.275 0 0.5-0.225 0.5-0.5 0-0.378 0.194-0.744 0.544-1.022 0.384-0.309 0.903-0.478 1.456-0.478s1.072 0.169 1.456 0.478c0.35 0.281 0.544 0.644 0.544 1.022 0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5 0.225 0.5 0.5v0.5h-8v-0.5z" }),
_('path', { d: "M5.794 9.5l0.706-0.706 1 1 3-3 0.706 0.706-3.353 3.353c-0.097 0.097-0.225 0.147-0.353 0.147s-0.256-0.050-0.353-0.147l-1.353-1.353zM10.5 10.794l-3 3-1-1-0.706 0.706 1.353 1.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l3.353-3.353-0.706-0.706zM6.5 16.794l-0.706 0.706 1.353 1.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l3.353-3.353-0.706-0.706-3 3-1-1z" }),
_('path', { d: "M18 10h-6v-1h6v1zM18 13h-6v1h6v-1zM12 18h6v-1h-6v1z" })
            );
        }
        function Checklist({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChecklistSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Checklist.SVG = ChecklistSVG;
        return Checklist;
    })();
export const Checklist2 = /*#__PURE__*/ (() => {
        function Checklist2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 5h15v2h-15v-2z" }),
_('path', { d: "M8 11h15v2h-15v-2z" }),
_('path', { d: "M8 17h15v2h-15v-2z" }),
_('path', { d: "M2.5 5.794l-1-1-0.706 0.706 1.353 1.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l3.353-3.353-0.706-0.706-3 3z" }),
_('path', { d: "M2.5 11.794l-1-1-0.706 0.706 1.353 1.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l3.353-3.353-0.706-0.706-3 3z" }),
_('path', { d: "M2.5 17.794l-1-1-0.706 0.706 1.353 1.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l3.353-3.353-0.706-0.706-3 3z" })
            );
        }
        function Checklist2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Checklist2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Checklist2.SVG = Checklist2SVG;
        return Checklist2;
    })();
export const Cheese = /*#__PURE__*/ (() => {
        function CheeseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.897 11.122c-0.237-2.187-0.953-4.094-2.128-5.659-1.134-1.512-2.656-2.675-4.528-3.45-1.587-0.656-3.378-1.006-5.178-1.006-0.247 0-0.488 0.091-0.672 0.259l-11.063 9.994c-0.216 0.197-0.331 0.472-0.328 0.75v2.491c0 0.275 0.225 0.5 0.5 0.5 0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5c-0.275 0-0.5 0.225-0.5 0.5v3.494c0 0.291 0.125 0.566 0.344 0.756 0.184 0.159 0.416 0.244 0.656 0.244 0.047 0 0.094-0.003 0.141-0.009l21-2.997c0.387-0.056 0.709-0.334 0.819-0.709 0.881-3.022 1.197-5.766 0.938-8.156zM12.441 3.012c3.206 0.1 6.075 1.447 7.728 3.65 0.144 0.191 0.278 0.387 0.403 0.594l-16.256 3.094 8.125-7.338zM13.987 10.547c-0.237 0.837-1.013 1.453-1.925 1.453-0.637 0-1.219-0.306-1.587-0.784l3.513-0.669zM21.213 18.097l-20.212 2.887v-2.034c1.141-0.231 2-1.244 2-2.45s-0.859-2.219-2-2.45v-1.050c0.063 0 0.125-0.006 0.188-0.019l8.231-1.566c0.172 0.319 0.397 0.606 0.675 0.847 0.547 0.475 1.247 0.738 1.972 0.738 1.538 0 2.809-1.162 2.981-2.656l6.391-1.216c0.788 2.416 0.716 5.456-0.225 8.969z" }),
_('path', { d: "M10.5 15c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM10.5 17c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M5 17c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM5 18c0 0 0 0 0 0v0z" }),
_('path', { d: "M18 11c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2c0-1.103-0.897-2-2-2zM18 14c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M15 15c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM15 16v0c0 0 0 0 0 0z" }),
_('path', { d: "M7 14.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Cheese({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CheeseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cheese.SVG = CheeseSVG;
        return Cheese;
    })();
export const Chef = /*#__PURE__*/ (() => {
    function ChefSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19 3c-0.569 0-1.125 0.094-1.653 0.281-0.403-0.791-0.984-1.494-1.691-2.037-1.056-0.816-2.322-1.244-3.656-1.244s-2.6 0.428-3.656 1.244c-0.709 0.544-1.287 1.247-1.691 2.037-0.528-0.188-1.084-0.281-1.653-0.281-2.756 0-5 2.244-5 5s2.244 5 5 5c0.338 0 0.672-0.034 1-0.1v9.1c0 0.409 0.25 0.778 0.628 0.928 1.781 0.712 3.575 1.069 5.372 1.069 1.794 0 3.591-0.356 5.372-1.069 0.378-0.15 0.628-0.519 0.628-0.928v-9.1c0.328 0.066 0.663 0.1 1 0.1 2.756 0 5-2.244 5-5s-2.244-5-5-5zM16 11.466v6.869c-2.659 0.881-5.341 0.881-8 0v-6.869c0-0.081-0.009-0.162-0.028-0.241 1.338 0.516 2.684 0.772 4.028 0.772 1.347 0 2.691-0.256 4.028-0.772-0.019 0.078-0.028 0.159-0.028 0.241zM8 21.306v-1.922c1.331 0.409 2.672 0.616 4 0.616s2.669-0.206 4-0.616v1.922c-2.684 0.934-5.316 0.934-8 0zM17.697 10.703c-0.050-0.025-0.131-0.066-0.181-0.094 0 0 0 0-0.003 0-0.231-0.131-0.444-0.294-0.634-0.484-0.147-0.147-0.369-0.188-0.559-0.103-2.866 1.297-5.772 1.297-8.637 0-0.191-0.084-0.413-0.047-0.559 0.103-0.234 0.234-0.503 0.428-0.803 0.575-0.403 0.194-0.866 0.306-1.319 0.306-1.653 0-3-1.347-3-3s1.347-3 3-3c0.584 0 1.15 0.169 1.638 0.487 0.266 0.175 0.6 0.213 0.9 0.1 0.297-0.112 0.525-0.359 0.612-0.666 0.478-1.728 2.063-2.928 3.85-2.928s3.372 1.2 3.853 2.919c0.084 0.306 0.312 0.553 0.612 0.666s0.631 0.075 0.9-0.1c0.487-0.319 1.053-0.488 1.638-0.488 1.653 0 3 1.347 3 3s-1.347 3-3 3c-0.456 0.003-0.903-0.1-1.306-0.294v0 0z" })
        );
    }
    function Chef({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChefSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Chef.SVG = ChefSVG;
    return Chef;
})();
export const Cherry = /*#__PURE__*/ (() => {
        function CherrySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.756 10.047c-0.378-1.106-0.959-2.128-1.722-3.050 0.678-0.019 1.375-0.138 2.078-0.353 1.628-0.497 3.219-1.488 4.731-2.937 0.172-0.166 0.203-0.431 0.075-0.631-0.131-0.2-0.384-0.281-0.606-0.194-1.241 0.497-2.594-0.366-4.025-1.281-0.953-0.612-1.944-1.244-2.959-1.491-1.231-0.297-2.3 0.009-3.266 0.938-0.016 0.012-0.028 0.028-0.044 0.041-0.369-0.072-0.738-0.109-1.106-0.109 0 0 0 0 0 0-1.303 0-2.516 0.466-3.534 1.353-1.125-0.216-2.269-0.331-3.378-0.331h-5v2h1.45c-0.447 0.769-0.563 1.681-0.334 2.691-0.072 0.063-0.144 0.131-0.216 0.203-0.788 0.803-1.059 1.734-0.806 2.759 0.209 0.847 0.741 1.662 1.253 2.453 0.75 1.15 1.456 2.238 1.059 3.206-0.091 0.222-0.012 0.475 0.188 0.606 0.084 0.056 0.178 0.081 0.275 0.081 0.131 0 0.259-0.050 0.356-0.15 1.206-1.234 2.034-2.538 2.456-3.866 0.369-1.162 0.416-2.319 0.128-3.344-0.366-1.306-1.259-2.288-2.334-2.562-0.494-0.125-0.984-0.1-1.447 0.066-0.116-0.85 0.109-1.569 0.672-2.144h0.3c2.134 0 3.588 2.063 4.266 3.294 0.916 1.666 1.534 3.784 1.694 5.731-2.781 0.275-4.959 2.625-4.959 5.475 0 3.031 2.469 5.5 5.5 5.5 2.191 0 4.088-1.287 4.972-3.147 0.247 0.181 0.509 0.344 0.781 0.481 0.844 0.434 1.794 0.666 2.747 0.666 3.309 0 6-2.691 6-6 0-3.053-2.291-5.578-5.244-5.953zM2.859 7c0.122 0 0.247 0.016 0.372 0.047 0.731 0.188 1.35 0.9 1.622 1.863 0.222 0.788 0.459 2.728-1.403 5.166-0.041-0.188-0.1-0.381-0.178-0.581-0.259-0.659-0.678-1.306-1.088-1.931-1.053-1.619-1.662-2.694-0.716-3.813 0.272 0.612 0.563 1.019 0.578 1.044l0.294 0.406 0.809-0.588-0.294-0.406c-0.003-0.006-0.322-0.447-0.569-1.091 0.188-0.078 0.378-0.116 0.572-0.116zM12.406 13.831c-0.438-0.275-0.919-0.487-1.428-0.631-0.059-0.987-0.225-2.031-0.484-3.063-0.347-1.366-0.856-2.681-1.475-3.806-0.447-0.813-0.947-1.519-1.484-2.112 3.509 0.578 7.581 2.359 9.125 5.934-1.944 0.447-3.541 1.841-4.253 3.678zM15.453 1c0.203 0 0.416 0.028 0.641 0.081 0.856 0.206 1.772 0.794 2.659 1.359 1.053 0.675 2.131 1.362 3.241 1.544-1.991 1.525-4.113 2.228-5.956 1.962-0.828-0.762-1.806-1.437-2.922-2.009-0.003-0.003-0.006-0.003-0.012-0.006-0.019-0.053-0.034-0.106-0.047-0.159-0.131-0.541-0.022-1.072 0.319-1.563 1.072 0.334 2.131 1.019 3.047 1.988l0.728-0.687c-0.753-0.797-1.587-1.422-2.478-1.859-0.169-0.081-0.337-0.156-0.506-0.225 0.406-0.288 0.825-0.425 1.287-0.425zM11.913 1.978c0.138 0 0.278 0.006 0.419 0.019-0.237 0.453-0.35 0.934-0.334 1.422-0.75-0.316-1.534-0.581-2.341-0.794 0.691-0.425 1.453-0.647 2.256-0.647zM9.5 22c-1.931 0-3.5-1.569-3.5-3.5s1.569-3.5 3.5-3.5 3.5 1.569 3.5 3.5-1.569 3.5-3.5 3.5zM18 20c-1.166 0-2.244-0.491-3.003-1.356 0-0.047 0.003-0.097 0.003-0.144 0-1.147-0.353-2.212-0.956-3.097 0.288-1.934 1.966-3.403 3.956-3.403 2.206 0 4 1.794 4 4s-1.794 4-4 4z" }),
_('path', { d: "M9.5 16h-0.5v1h0.5c0.828 0 1.5 0.672 1.5 1.5v0.5h1v-0.5c0-1.378-1.122-2.5-2.5-2.5z" }),
_('path', { d: "M18 13v1c1.103 0 2 0.897 2 2h1c0-1.653-1.347-3-3-3z" })
            );
        }
        function Cherry({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CherrySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cherry.SVG = CherrySVG;
        return Cherry;
    })();
export const ChevronDownCircle = /*#__PURE__*/ (() => {
        function ChevronDownCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M12 13.584l-4.544-4.541-1.416 1.416 5.25 5.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l5.25-5.25-1.416-1.416-4.537 4.541z" })
            );
        }
        function ChevronDownCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChevronDownCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ChevronDownCircle.SVG = ChevronDownCircleSVG;
        return ChevronDownCircle;
    })();
export const ChevronDownSquare = /*#__PURE__*/ (() => {
        function ChevronDownSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20l20-0.003c0 0 0 0 0 0.003v20z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M12 16c0.256 0 0.513-0.097 0.706-0.294l5.25-5.25-1.416-1.416-4.541 4.544-4.544-4.541-1.416 1.416 5.25 5.25c0.197 0.194 0.453 0.291 0.709 0.291z" })
            );
        }
        function ChevronDownSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChevronDownSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ChevronDownSquare.SVG = ChevronDownSquareSVG;
        return ChevronDownSquare;
    })();
export const ChevronDown = /*#__PURE__*/ (() => {
    function ChevronDownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.544 6.044l-9.544 9.541-9.544-9.541-1.416 1.416 10.25 10.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l10.25-10.25-1.409-1.416z" })
        );
    }
    function ChevronDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChevronDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ChevronDown.SVG = ChevronDownSVG;
    return ChevronDown;
})();
export const ChevronLeftCircle = /*#__PURE__*/ (() => {
        function ChevronLeftCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M13.544 6.044l-5.25 5.25c-0.391 0.391-0.391 1.025 0 1.416l5.25 5.25 1.416-1.416-4.544-4.544 4.544-4.544-1.416-1.413z" })
            );
        }
        function ChevronLeftCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChevronLeftCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ChevronLeftCircle.SVG = ChevronLeftCircleSVG;
        return ChevronLeftCircle;
    })();
export const ChevronLeftSquare = /*#__PURE__*/ (() => {
        function ChevronLeftSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M13.544 17.956l1.416-1.416-4.544-4.541 4.544-4.544-1.416-1.416-5.25 5.25c-0.391 0.391-0.391 1.025 0 1.416l5.25 5.25z" })
            );
        }
        function ChevronLeftSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChevronLeftSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ChevronLeftSquare.SVG = ChevronLeftSquareSVG;
        return ChevronLeftSquare;
    })();
export const ChevronLeft = /*#__PURE__*/ (() => {
    function ChevronLeftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17.956 2.456l-1.416-1.416-10.25 10.25c-0.391 0.391-0.391 1.025 0 1.416l10.25 10.25 1.416-1.416-9.541-9.541 9.541-9.544z" })
        );
    }
    function ChevronLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChevronLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ChevronLeft.SVG = ChevronLeftSVG;
    return ChevronLeft;
})();
export const ChevronRightCircle = /*#__PURE__*/ (() => {
        function ChevronRightCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M10.456 6.044l-1.416 1.416 4.544 4.541-4.541 4.544 1.416 1.416 5.25-5.25c0.391-0.391 0.391-1.025 0-1.416l-5.253-5.25z" })
            );
        }
        function ChevronRightCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChevronRightCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ChevronRightCircle.SVG = ChevronRightCircleSVG;
        return ChevronRightCircle;
    })();
export const ChevronRightSquare = /*#__PURE__*/ (() => {
        function ChevronRightSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20l20-0.003c0 0 0 0 0 0.003v20z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M10.456 17.956l5.25-5.25c0.391-0.391 0.391-1.025 0-1.416l-5.25-5.25-1.416 1.416 4.544 4.544-4.541 4.544 1.413 1.413z" })
            );
        }
        function ChevronRightSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChevronRightSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ChevronRightSquare.SVG = ChevronRightSquareSVG;
        return ChevronRightSquare;
    })();
export const ChevronRight = /*#__PURE__*/ (() => {
    function ChevronRightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17.706 11.294l-10.25-10.25-1.416 1.416 9.544 9.541-9.541 9.544 1.416 1.416 10.25-10.25c0.387-0.394 0.387-1.025-0.003-1.416z" })
        );
    }
    function ChevronRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChevronRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ChevronRight.SVG = ChevronRightSVG;
    return ChevronRight;
})();
export const ChevronUpCircle = /*#__PURE__*/ (() => {
        function ChevronUpCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M11.294 8.294l-5.25 5.25 1.416 1.416 4.541-4.544 4.544 4.544 1.416-1.416-5.25-5.25c-0.394-0.391-1.025-0.391-1.416 0z" })
            );
        }
        function ChevronUpCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChevronUpCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ChevronUpCircle.SVG = ChevronUpCircleSVG;
        return ChevronUpCircle;
    })();
export const ChevronUpSquare = /*#__PURE__*/ (() => {
        function ChevronUpSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20l20-0.003c0 0 0 0 0 0.003v20z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M12 10.416l4.544 4.544 1.416-1.416-5.25-5.25c-0.391-0.391-1.025-0.391-1.416 0l-5.25 5.25 1.416 1.416 4.541-4.544z" })
            );
        }
        function ChevronUpSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChevronUpSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ChevronUpSquare.SVG = ChevronUpSquareSVG;
        return ChevronUpSquare;
    })();
export const ChevronUp = /*#__PURE__*/ (() => {
    function ChevronUpSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.706 6.294c-0.391-0.391-1.025-0.391-1.416 0l-10.25 10.25 1.416 1.416 9.544-9.544 9.544 9.544 1.416-1.416-10.253-10.25z" })
        );
    }
    function ChevronUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChevronUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ChevronUp.SVG = ChevronUpSVG;
    return ChevronUp;
})();
export const ChickenLeg = /*#__PURE__*/ (() => {
        function ChickenLegSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 19.5c0-1.378-1.122-2.5-2.5-2.5-0.209 0-0.419 0.025-0.622 0.078-0.637-0.306-2.981-1.5-4.359-3.128 0.15-0.091 0.275-0.219 0.359-0.378 0.162-0.3 0.162-0.659 0-0.956-0.038-0.087-0.338-0.825-0.897-3.741-0.459-2.406-1.281-4.372-2.441-5.847-1.044-1.328-2.337-2.234-3.844-2.697-1.362-0.419-2.844-0.444-4.284-0.075-1.294 0.334-2.453 0.959-3.259 1.769-0.7 0.7-1.244 1.531-1.616 2.469-0.359 0.903-0.537 1.863-0.537 2.85 0.003 2.056 0.797 3.994 2.234 5.459 1.025 1.047 2.347 1.628 4.022 2.369 1.091 0.481 2.328 1.028 3.769 1.822 1.041 0.575 1.897 1.006 2.606 1.006 0.284 0 0.547-0.069 0.791-0.228 0.103-0.069 0.191-0.144 0.266-0.228 1.725 0.997 3.012 2.619 3.434 3.191-0.078 0.247-0.119 0.503-0.119 0.766 0 1.378 1.122 2.5 2.5 2.5 1.222 0 2.244-0.881 2.459-2.041 1.156-0.216 2.037-1.238 2.037-2.459zM10.991 15.241c-1.519-0.837-2.8-1.403-3.928-1.9-1.534-0.678-2.644-1.166-3.4-1.938-2.163-2.203-2.206-5.85-0.094-7.962 0.797-0.8 2.281-1.437 3.878-1.437 0.55 0 1.113 0.075 1.666 0.247 2.478 0.759 4.175 3.184 4.906 7.006 0.159 0.834 0.403 2.041 0.656 2.994-0.694 0.153-1.509 0.456-2.056 1.059-0.469 0.519-0.678 1.175-0.606 1.9l0.003 0.028c0.019 0.181 0.037 0.378 0.050 0.559-0.247-0.116-0.591-0.291-1.075-0.556zM21.956 20.928c-0.031-0.203-0.081-0.403-0.15-0.594l-0.166-0.472-0.944 0.331 0.166 0.472c0.091 0.263 0.138 0.544 0.138 0.834 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.219 0.047-0.431 0.138-0.628 0.072-0.156 0.059-0.341-0.038-0.487-0.072-0.109-1.653-2.45-4.028-3.775 0.012-0.103 0.016-0.188 0.016-0.247 0.012-0.366-0.028-0.791-0.081-1.325l-0.003-0.028c-0.022-0.209 0.041-0.297 0.097-0.359 0.234-0.263 0.794-0.428 1.306-0.503 1.659 2.316 5.069 3.853 5.231 3.922 0.116 0.053 0.247 0.056 0.369 0.016 0.162-0.056 0.328-0.084 0.497-0.084 0.828 0 1.5 0.672 1.5 1.5-0.003 0.669-0.444 1.237-1.047 1.428z" }),
_('path', { d: "M12.138 9.109l0.969-0.247-0.122-0.484c-0.438-1.722-1.263-3.219-2.325-4.212-0.787-0.741-1.941-1.166-3.159-1.166h-0.5v1h0.5c0.969 0 1.869 0.325 2.475 0.894 0.922 0.866 1.647 2.191 2.041 3.728l0.122 0.487z" })
            );
        }
        function ChickenLeg({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChickenLegSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ChickenLeg.SVG = ChickenLegSVG;
        return ChickenLeg;
    })();
export const ChristmasTree = /*#__PURE__*/ (() => {
        function ChristmasTreeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8.2 2.9l1.694 1.269-0.856 2.144c-0.081 0.2-0.022 0.428 0.141 0.566 0.094 0.078 0.209 0.119 0.325 0.119 0.087 0 0.178-0.025 0.256-0.072l2.244-1.347 2.244 1.347c0.184 0.109 0.416 0.091 0.578-0.047s0.222-0.363 0.144-0.563l-0.834-2.15 1.669-1.272c0.172-0.131 0.241-0.353 0.172-0.556-0.069-0.2-0.259-0.338-0.475-0.338h-1.972l-1.103-1.766c-0.094-0.147-0.253-0.234-0.425-0.234s-0.331 0.087-0.425 0.234l-1.103 1.766h-1.972c-0.216 0-0.406 0.138-0.475 0.341-0.069 0.206 0.003 0.431 0.175 0.559zM10.75 3c0.172 0 0.331-0.087 0.425-0.234l0.825-1.322 0.825 1.322c0.091 0.147 0.253 0.234 0.425 0.234h0.769l-0.791 0.603c-0.178 0.134-0.244 0.372-0.162 0.578l0.441 1.141-1.25-0.75c-0.078-0.047-0.169-0.072-0.256-0.072s-0.178 0.025-0.256 0.072l-1.228 0.738 0.45-1.122c0.084-0.209 0.016-0.45-0.166-0.584l-0.8-0.603h0.75z" }),
_('path', { d: "M20.491 21.128c-1.441-0.809-2.631-1.653-3.563-2.512 0.534-0.188 1.069-0.441 1.594-0.762 0.291-0.178 0.472-0.491 0.478-0.834s-0.159-0.663-0.444-0.853c-1.297-0.866-2.291-1.722-2.969-2.562 0.391-0.219 0.775-0.528 1.144-0.925 0.188-0.2 0.284-0.469 0.269-0.741s-0.144-0.528-0.35-0.703c-1.528-1.297-2.828-2.922-3.762-4.703-0.172-0.328-0.513-0.534-0.884-0.534s-0.713 0.206-0.884 0.534c-0.934 1.778-2.234 3.406-3.762 4.703-0.209 0.178-0.334 0.431-0.35 0.703s0.081 0.541 0.269 0.741c0.372 0.397 0.753 0.706 1.144 0.925-0.678 0.837-1.672 1.697-2.969 2.562-0.284 0.191-0.453 0.513-0.444 0.853 0.006 0.341 0.188 0.656 0.478 0.834 0.525 0.319 1.056 0.575 1.591 0.762-0.931 0.859-2.122 1.703-3.562 2.512-0.341 0.191-0.537 0.563-0.506 0.953s0.288 0.725 0.653 0.859c2.694 0.981 5.262 1.059 8.344 1.059 3.078 0 5.647-0.078 8.344-1.059 0.366-0.134 0.622-0.469 0.653-0.859 0.028-0.391-0.169-0.762-0.509-0.953zM12 22c-2.091 0-3.844-0.034-5.531-0.356 1.4-0.966 2.497-1.966 3.322-3.031 0.228-0.294 0.275-0.687 0.119-1.025s-0.481-0.563-0.85-0.584c-0.359-0.022-0.722-0.087-1.088-0.197 1.391-1.103 2.353-2.212 2.925-3.359 0.159-0.322 0.138-0.703-0.063-1.003s-0.544-0.469-0.903-0.441c-0.125 0.009-0.253-0.016-0.378-0.066 0.916-0.897 1.741-1.897 2.447-2.972 0.706 1.072 1.531 2.075 2.447 2.972-0.125 0.050-0.253 0.075-0.378 0.066-0.359-0.025-0.703 0.144-0.903 0.441s-0.225 0.681-0.063 1.003c0.572 1.147 1.534 2.256 2.925 3.359-0.366 0.109-0.728 0.175-1.087 0.197-0.369 0.022-0.697 0.247-0.85 0.584s-0.106 0.731 0.119 1.025c0.825 1.066 1.922 2.066 3.322 3.031-1.688 0.322-3.441 0.356-5.531 0.356z" })
            );
        }
        function ChristmasTree({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChristmasTreeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ChristmasTree.SVG = ChristmasTreeSVG;
        return ChristmasTree;
    })();
export const CigarNo = /*#__PURE__*/ (() => {
        function CigarNoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1.497 16c0.063 0 0.128-0.012 0.187-0.038 0.188-0.078 0.312-0.259 0.312-0.462 0-2.037 1.313-3.453 2.581-4.825 0.931-1.006 1.809-1.956 2.209-3.131 0.456-1.35 0.169-2.763-0.881-4.322l-0.278-0.416-0.831 0.559 0.278 0.416c1.903 2.828 0.519 4.322-1.234 6.216-1.069 1.156-2.253 2.434-2.684 4.147-0.181-0.444-0.209-0.906-0.094-1.403 0.197-0.847 0.791-1.741 1.366-2.606 0.713-1.072 1.447-2.181 1.566-3.356 0.138-1.378-0.588-2.588-2.222-3.691l-0.416-0.281-0.559 0.828 0.416 0.281c2.862 1.934 1.769 3.581 0.384 5.666-0.622 0.938-1.266 1.909-1.506 2.931-0.288 1.231 0.053 2.322 1.044 3.337 0.1 0.097 0.231 0.15 0.363 0.15z" }),
_('path', { d: "M21.559 17.637c-1.234-0.413-2.853-0.638-4.559-0.638h-16c-0.203 0-0.387 0.125-0.466 0.316-0.713 1.781-0.713 3.591 0 5.372 0.078 0.188 0.262 0.312 0.466 0.312h16c1.706 0 3.325-0.225 4.559-0.637 2.019-0.672 2.441-1.656 2.441-2.363s-0.425-1.691-2.441-2.362zM1.347 22c-0.456-1.328-0.456-2.672 0-4h2.653v4h-2.653zM20.553 20.578c-0.987 0.272-2.25 0.422-3.553 0.422h-11v-2h11c1.303 0 2.566 0.15 3.553 0.422 0.756 0.209 1.163 0.434 1.347 0.578-0.184 0.144-0.591 0.369-1.347 0.578z" }),
_('path', { d: "M16.5 14c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zM16.5 13c1.338 0 2.562-0.478 3.519-1.275l-7.744-7.744c-0.797 0.956-1.275 2.181-1.275 3.519 0 3.031 2.469 5.5 5.5 5.5zM16.5 2c-1.338 0-2.562 0.478-3.519 1.275l7.744 7.744c0.797-0.956 1.275-2.181 1.275-3.519 0-3.031-2.469-5.5-5.5-5.5z" })
            );
        }
        function CigarNo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CigarNoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CigarNo.SVG = CigarNoSVG;
        return CigarNo;
    })();
export const CigarWarning = /*#__PURE__*/ (() => {
        function CigarWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1.497 15c0.063 0 0.128-0.012 0.187-0.037 0.188-0.078 0.312-0.259 0.312-0.462 0-2.037 1.313-3.453 2.581-4.825 0.931-1.006 1.809-1.956 2.209-3.131 0.456-1.35 0.169-2.763-0.881-4.322l-0.278-0.416-0.831 0.559 0.278 0.416c1.903 2.828 0.519 4.322-1.234 6.216-1.069 1.156-2.253 2.434-2.684 4.147-0.181-0.444-0.209-0.906-0.094-1.403 0.197-0.847 0.791-1.741 1.366-2.606 0.713-1.072 1.447-2.181 1.566-3.356 0.138-1.378-0.588-2.588-2.222-3.691l-0.416-0.281-0.553 0.828 0.416 0.281c2.862 1.934 1.769 3.581 0.384 5.666-0.622 0.938-1.266 1.909-1.506 2.931-0.288 1.231 0.053 2.322 1.044 3.337 0.094 0.097 0.225 0.15 0.356 0.15z" }),
_('path', { d: "M21.559 16.637c-1.234-0.413-2.853-0.638-4.559-0.638h-16c-0.203 0-0.387 0.125-0.466 0.316-0.713 1.781-0.713 3.591 0 5.372 0.078 0.188 0.262 0.312 0.466 0.312h16c1.706 0 3.325-0.225 4.559-0.638 2.019-0.672 2.441-1.656 2.441-2.362s-0.425-1.691-2.441-2.363zM1.347 21c-0.456-1.328-0.456-2.672 0-4h2.653v4h-2.653zM20.553 19.578c-0.987 0.272-2.25 0.422-3.553 0.422h-11v-2h11c1.303 0 2.566 0.15 3.553 0.422 0.756 0.209 1.163 0.434 1.347 0.578-0.184 0.144-0.591 0.369-1.347 0.578z" }),
_('path', { d: "M15 10h1v1h-1v-1z" }),
_('path', { d: "M15 5h1v4h-1v-4z" }),
_('path', { d: "M11.5 13h8c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672l-4-7.997c-0.25-0.506-0.775-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-4 7.997c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.831 0.672 1.503 1.5 1.503zM11.050 11.281l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219z" })
            );
        }
        function CigarWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CigarWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CigarWarning.SVG = CigarWarningSVG;
        return CigarWarning;
    })();
export const Cigar = /*#__PURE__*/ (() => {
        function CigarSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1.497 15c0.063 0 0.128-0.012 0.187-0.037 0.188-0.078 0.312-0.259 0.312-0.462 0-2.034 1.313-3.453 2.581-4.825 0.931-1.006 1.809-1.956 2.209-3.131 0.456-1.35 0.169-2.763-0.881-4.322l-0.278-0.416-0.831 0.559 0.278 0.416c1.903 2.828 0.519 4.322-1.234 6.216-1.069 1.156-2.253 2.434-2.681 4.147-0.181-0.444-0.209-0.906-0.094-1.403 0.197-0.847 0.791-1.744 1.366-2.606 0.712-1.072 1.447-2.178 1.566-3.356 0.138-1.378-0.588-2.588-2.222-3.691l-0.416-0.281-0.556 0.828 0.416 0.281c2.862 1.934 1.769 3.581 0.384 5.666-0.622 0.938-1.266 1.909-1.506 2.934-0.288 1.231 0.053 2.322 1.044 3.338 0.094 0.094 0.225 0.147 0.356 0.147z" }),
_('path', { d: "M21.559 16.637c-1.234-0.413-2.853-0.638-4.559-0.638h-16c-0.203 0-0.387 0.125-0.466 0.316-0.713 1.781-0.713 3.591 0 5.372 0.078 0.188 0.262 0.312 0.466 0.312h16c1.706 0 3.325-0.225 4.559-0.638 2.019-0.672 2.441-1.656 2.441-2.362s-0.425-1.691-2.441-2.363zM1.347 21c-0.466-1.344-0.466-2.656 0-4h2.653v4h-2.653zM20.556 19.578c-0.987 0.272-2.25 0.422-3.556 0.422h-11v-2h11c1.306 0 2.569 0.15 3.556 0.422 0.756 0.209 1.163 0.434 1.347 0.578-0.184 0.144-0.591 0.369-1.347 0.578z" })
            );
        }
        function Cigar({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CigarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cigar.SVG = CigarSVG;
        return Cigar;
    })();
export const CircleExtract = /*#__PURE__*/ (() => {
        function CircleExtractSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 0h-8v2h5.584l-9.541 9.544 1.416 1.416 9.541-9.544v5.584h2v-8c0-0.553-0.447-1-1-1z" }),
_('path', { d: "M9 23c-4.413 0-8-3.588-8-8s3.588-8 8-8v-1c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363h-1c0 4.413-3.588 8-8 8z" })
            );
        }
        function CircleExtract({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleExtractSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleExtract.SVG = CircleExtractSVG;
        return CircleExtract;
    })();
export const CircleInsert = /*#__PURE__*/ (() => {
        function CircleInsertSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.956 1.456l-1.413-1.413-9.544 9.541v-5.584h-2v8c0 0.553 0.447 1 1 1h8v-2h-5.584l9.541-9.544z" }),
_('path', { d: "M9 23c-4.413 0-8-3.588-8-8s3.588-8 8-8v-1c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363h-1c0 4.413-3.588 8-8 8z" })
            );
        }
        function CircleInsert({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleInsertSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleInsert.SVG = CircleInsertSVG;
        return CircleInsert;
    })();
export const Citrus = /*#__PURE__*/ (() => {
    function CitrusSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.853 18.409l-17.262-17.262c-0.194-0.194-0.513-0.194-0.706 0l-0.603 0.603c-1.147 1.147-2.016 2.525-2.572 4.088-0.531 1.475-0.762 3.053-0.694 4.691 0.069 1.606 0.425 3.175 1.056 4.659 0.653 1.531 1.563 2.888 2.709 4.031 1.144 1.144 2.5 2.056 4.031 2.709 1.484 0.634 3.053 0.987 4.659 1.056 0.188 0.009 0.375 0.012 0.563 0.012 1.434 0 2.822-0.234 4.128-0.703 1.566-0.559 2.941-1.425 4.087-2.572l0.603-0.603c0.197-0.197 0.197-0.516 0-0.709zM7.356 4.325l4.675 4.675h-6.981c0.191-1.728 0.897-3.266 2.056-4.425l0.25-0.25zM13.031 10l0.131 0.131-5.897 5.897c-1.328-1.497-2.141-3.5-2.253-5.572-0.009-0.153-0.012-0.306-0.012-0.456h8.031zM13.869 10.837l0.131 0.131v8.037c-2.131 0.003-4.331-0.762-6.028-2.272l5.897-5.897zM15 11.969l4.672 4.672-0.25 0.25c-1.184 1.181-2.753 1.866-4.422 2.059v-6.981zM6.194 17.806c-4.034-4.034-4.266-10.875-0.5-14.641l0.25-0.25 0.706 0.706-0.25 0.25c-0.859 0.859-1.5 1.897-1.909 3.081-0.384 1.119-0.544 2.316-0.478 3.559 0.134 2.487 1.188 4.887 2.888 6.588 1.7 1.697 4.1 2.75 6.588 2.884 0.184 0.009 0.369 0.016 0.553 0.016 1.047 0 2.056-0.166 3.009-0.491 1.184-0.409 2.222-1.050 3.081-1.909l0.25-0.25 0.709 0.709-0.25 0.25c-3.772 3.762-10.613 3.528-14.647-0.503z" })
        );
    }
    function Citrus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CitrusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Citrus.SVG = CitrusSVG;
    return Citrus;
})();
export const City = /*#__PURE__*/ (() => {
        function CitySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 7h1v2h-1v-2z" }),
_('path', { d: "M17 7h1v2h-1v-2z" }),
_('path', { d: "M19 7h1v2h-1v-2z" }),
_('path', { d: "M15 10h1v2h-1v-2z" }),
_('path', { d: "M17 10h1v2h-1v-2z" }),
_('path', { d: "M19 10h1v2h-1v-2z" }),
_('path', { d: "M15 13h1v2h-1v-2z" }),
_('path', { d: "M17 13h1v2h-1v-2z" }),
_('path', { d: "M19 13h1v2h-1v-2z" }),
_('path', { d: "M15 16h1v2h-1v-2z" }),
_('path', { d: "M17 16h1v2h-1v-2z" }),
_('path', { d: "M19 16h1v2h-1v-2z" }),
_('path', { d: "M23 22v-17c0-0.394-0.231-0.753-0.594-0.912l-9-4c-0.309-0.138-0.669-0.109-0.95 0.075-0.284 0.184-0.456 0.5-0.456 0.837v6.5c0-0.131-0.053-0.259-0.147-0.353l-0.853-0.853v-0.794c0-0.1-0.028-0.194-0.084-0.278l-1.916-2.875v-2.347h-1v2.35l-1.916 2.875c-0.056 0.081-0.084 0.178-0.084 0.278v0.794l-0.853 0.853c-0.094 0.094-0.147 0.222-0.147 0.353v0.794l-0.706 0.703h-0.794c-0.275 0-0.5 0.225-0.5 0.5v0.5h-1c-0.553 0-1 0.447-1 1v11h-1v2h24v-2h-1zM21 5.65v16.35h-7v-19.462l7 3.113zM5.853 8.853c0.094-0.094 0.147-0.222 0.147-0.353v-0.794l0.853-0.853c0.094-0.094 0.147-0.222 0.147-0.353v-0.85l1.5-2.25 1.5 2.25v0.85c0 0.131 0.053 0.259 0.147 0.353l0.853 0.853v0.794c0 0.131 0.053 0.259 0.147 0.353l0.853 0.853v12.294h-2v-11c0-0.553-0.447-1-1-1h-1v-0.5c0-0.275-0.225-0.5-0.5-0.5h-1.794l0.147-0.147zM3 12h5v10h-5v-10z" }),
_('path', { d: "M15 4h1v2h-1v-2z" }),
_('path', { d: "M15 19h1v2h-1v-2z" }),
_('path', { d: "M4 13h1v2h-1v-2z" }),
_('path', { d: "M17 19h1v2h-1v-2z" }),
_('path', { d: "M19 19h1v2h-1v-2z" }),
_('path', { d: "M6 13h1v2h-1v-2z" }),
_('path', { d: "M4 16h1v2h-1v-2z" }),
_('path', { d: "M6 16h1v2h-1v-2z" }),
_('path', { d: "M4 19h1v2h-1v-2z" }),
_('path', { d: "M6 19h1v2h-1v-2z" }),
_('path', { d: "M17 5h1v1h-1v-1z" })
            );
        }
        function City({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CitySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        City.SVG = CitySVG;
        return City;
    })();
export const ClapboardPlay = /*#__PURE__*/ (() => {
        function ClapboardPlaySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.5 8h-12.563l11.688-3.016c0.266-0.069 0.428-0.338 0.359-0.606l-1-4c-0.066-0.269-0.337-0.431-0.606-0.363l-17.528 4.381c-0.391-0.25-0.853-0.397-1.35-0.397-1.378 0-2.5 1.122-2.5 2.5v15.5c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-13.5c0-0.275-0.225-0.5-0.5-0.5v0zM8.5 12c0.316-0.419 0.5-0.938 0.5-1.5s-0.188-1.081-0.5-1.5h3.794l-3 3h-0.794zM13.706 9h3.584l-3 3h-3.584l3-3zM18.706 9h3.584l-3 3h-3.584l3-3zM23 9.706v2.294h-2.294l2.294-2.294zM6.5 8c-0.828 0-1.5-0.672-1.5-1.5 0-0.466-0.128-0.9-0.35-1.272l2.769-0.694 3.888 2.337-4.369 1.128h-0.438zM15.272 5.85l-2.603 0.672-3.875-2.328 2.628-0.656 3.85 2.313zM12.791 3.194l2.628-0.656 3.813 2.291-2.603 0.672-3.837-2.306zM21.894 4.141l-1.303 0.338-3.8-2.284 4.344-1.087 0.759 3.034zM1 6.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 1.378 1.122 2.5 2.5 2.5 0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5h-4c-0.828 0-1.5-0.672-1.5-1.5v-4zM2 22v-9.050c0.162 0.034 0.328 0.050 0.5 0.050h19.5v9h-20z" }),
_('path', { d: "M3 11c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1z" }),
_('path', { d: "M9.237 20.925c0.081 0.050 0.172 0.075 0.262 0.075 0.075 0 0.153-0.019 0.225-0.053l6-3c0.169-0.084 0.275-0.259 0.275-0.447s-0.106-0.363-0.275-0.447l-6-3c-0.156-0.078-0.337-0.069-0.488 0.022-0.147 0.091-0.237 0.253-0.237 0.425v6c0 0.172 0.091 0.334 0.237 0.425zM10 15.309l4.381 2.191-4.381 2.191v-4.381z" })
            );
        }
        function ClapboardPlay({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ClapboardPlaySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ClapboardPlay.SVG = ClapboardPlaySVG;
        return ClapboardPlay;
    })();
export const Clapboard = /*#__PURE__*/ (() => {
        function ClapboardSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.5 8h-12.563l11.688-3.016c0.266-0.069 0.428-0.338 0.359-0.606l-1-4c-0.066-0.269-0.337-0.431-0.606-0.363l-17.528 4.381c-0.391-0.25-0.853-0.397-1.35-0.397-1.378 0-2.5 1.122-2.5 2.5v15.5c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-13.5c0-0.275-0.225-0.5-0.5-0.5zM8.5 12c0.316-0.419 0.5-0.938 0.5-1.5s-0.188-1.081-0.5-1.5h3.794l-3 3h-0.794zM13.706 9h3.584l-3 3h-3.584l3-3zM18.706 9h3.584l-3 3h-3.584l3-3zM23 9.706v2.294h-2.294l2.294-2.294zM6.5 8c-0.828 0-1.5-0.672-1.5-1.5 0-0.466-0.128-0.9-0.35-1.272l2.769-0.694 3.888 2.337-4.369 1.128h-0.438zM15.272 5.85l-2.603 0.672-3.875-2.328 2.628-0.656 3.85 2.313zM12.791 3.194l2.628-0.656 3.813 2.291-2.603 0.672-3.837-2.306zM21.894 4.141l-1.303 0.338-3.8-2.284 4.344-1.087 0.759 3.034zM1 6.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 1.378 1.122 2.5 2.5 2.5 0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5h-4c-0.828 0-1.5-0.672-1.5-1.5v-4zM2 22v-9.050c0.162 0.034 0.328 0.050 0.5 0.050h19.5v9h-20z" }),
_('path', { d: "M3 11c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1z" })
            );
        }
        function Clapboard({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ClapboardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Clapboard.SVG = ClapboardSVG;
        return Clapboard;
    })();
export const Cli = /*#__PURE__*/ (() => {
        function CliSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 2h-20c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-16c0-1.103-0.897-2-2-2zM22 20h-20v-16h20v16c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 5h-17c-0.275 0-0.5 0.225-0.5 0.5v13c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-13c0-0.275-0.225-0.5-0.5-0.5zM20 18h-16v-12h16v12z" }),
_('path', { d: "M6.384 14.341l3.406-2.434c0.131-0.094 0.209-0.247 0.209-0.406s-0.078-0.312-0.209-0.406l-3.406-2.434-0.581 0.813 2.838 2.028-2.838 2.028 0.581 0.813z" }),
_('path', { d: "M11 15h5v1h-5v-1z" })
            );
        }
        function Cli({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CliSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cli.SVG = CliSVG;
        return Cli;
    })();
export const ClipboardChart = /*#__PURE__*/ (() => {
        function ClipboardChartSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 3h-1v2h1v17h-14v-17h1v-2h-1c-1.103 0-2 0.897-2 2v17c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-17c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M7.5 5h9c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.828-0.672-1.5-1.5-1.5h-0.559c-0.119-0.497-0.416-0.947-0.863-1.303-0.559-0.45-1.297-0.697-2.078-0.697s-1.519 0.247-2.081 0.697c-0.447 0.356-0.744 0.809-0.862 1.303h-0.556c-0.828 0-1.5 0.672-1.5 1.5v1c0 0.275 0.225 0.5 0.5 0.5zM8 3.5c0-0.275 0.225-0.5 0.5-0.5h1c0.275 0 0.5-0.225 0.5-0.5 0-0.378 0.194-0.744 0.544-1.025 0.384-0.306 0.903-0.475 1.456-0.475s1.072 0.169 1.456 0.475c0.35 0.281 0.544 0.644 0.544 1.025 0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5 0.225 0.5 0.5v0.5h-8v-0.5z" }),
_('path', { d: "M7.5 18c0.828 0 1.5-0.672 1.5-1.5 0-0.306-0.094-0.594-0.253-0.831l1.303-1.737c0.141 0.044 0.294 0.069 0.45 0.069 0.231 0 0.45-0.053 0.647-0.147l1 1c-0.094 0.197-0.147 0.416-0.147 0.647 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.403-0.159-0.772-0.422-1.041l1.734-3.472c0.059 0.006 0.122 0.012 0.184 0.012 0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5c0 0.403 0.159 0.772 0.422 1.041l-1.734 3.472c-0.059-0.006-0.122-0.012-0.184-0.012-0.231 0-0.45 0.053-0.647 0.147l-1-1c0.094-0.197 0.147-0.416 0.147-0.647 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.306 0.094 0.594 0.253 0.831l-1.303 1.737c-0.141-0.044-0.294-0.069-0.45-0.069-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5zM16.5 9c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM13.5 15c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM10.5 12c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM7.5 16c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" })
            );
        }
        function ClipboardChart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ClipboardChartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ClipboardChart.SVG = ClipboardChartSVG;
        return ClipboardChart;
    })();
export const ClipboardCheck = /*#__PURE__*/ (() => {
        function ClipboardCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 3h-1v2h1v17h-14v-17h1v-2h-1c-1.103 0-2 0.897-2 2v17c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-17c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M7.5 5h9c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.828-0.672-1.5-1.5-1.5h-0.559c-0.119-0.494-0.416-0.947-0.859-1.303-0.563-0.45-1.3-0.697-2.081-0.697s-1.519 0.247-2.081 0.697c-0.447 0.356-0.741 0.809-0.859 1.303h-0.559c-0.828 0-1.5 0.672-1.5 1.5v1c0 0.275 0.225 0.5 0.5 0.5zM8 3.5c0-0.275 0.225-0.5 0.5-0.5h1c0.275 0 0.5-0.225 0.5-0.5 0-0.378 0.194-0.744 0.544-1.022 0.384-0.309 0.903-0.478 1.456-0.478s1.072 0.169 1.456 0.478c0.35 0.281 0.544 0.644 0.544 1.022 0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5 0.225 0.5 0.5v0.5h-8v-0.5z" }),
_('path', { d: "M9.997 18c0 0 0 0 0 0 0.266 0 0.519-0.106 0.706-0.294l7.253-7.25-1.413-1.416-6.547 6.544-2.541-2.544-1.416 1.413 3.247 3.25c0.191 0.191 0.444 0.297 0.709 0.297z" })
            );
        }
        function ClipboardCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ClipboardCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ClipboardCheck.SVG = ClipboardCheckSVG;
        return ClipboardCheck;
    })();
export const ClipboardDown = /*#__PURE__*/ (() => {
        function ClipboardDownSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 3h-1v2h1v17h-14v-17h1v-2h-1c-1.103 0-2 0.897-2 2v17c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-17c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M11 8v7.584l-2.544-2.544-1.416 1.416 4.25 4.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l4.25-4.25-1.416-1.416-2.538 2.544v-7.584h-2z" }),
_('path', { d: "M7.5 5h9c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.828-0.672-1.5-1.5-1.5h-0.559c-0.119-0.494-0.416-0.947-0.859-1.303-0.563-0.45-1.3-0.697-2.081-0.697s-1.519 0.247-2.081 0.697c-0.447 0.356-0.741 0.809-0.859 1.303h-0.559c-0.828 0-1.5 0.672-1.5 1.5v1c0 0.275 0.225 0.5 0.5 0.5zM8 3.5c0-0.275 0.225-0.5 0.5-0.5h1c0.275 0 0.5-0.225 0.5-0.5 0-0.378 0.194-0.744 0.544-1.022 0.384-0.309 0.903-0.478 1.456-0.478s1.072 0.169 1.456 0.478c0.35 0.281 0.544 0.644 0.544 1.022 0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5 0.225 0.5 0.5v0.5h-8v-0.5z" })
            );
        }
        function ClipboardDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ClipboardDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ClipboardDown.SVG = ClipboardDownSVG;
        return ClipboardDown;
    })();
export const ClipboardEmpty = /*#__PURE__*/ (() => {
        function ClipboardEmptySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 3h-1v2h1v17h-14v-17h1v-2h-1c-1.103 0-2 0.897-2 2v17c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-17c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M7.5 5h9c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.828-0.672-1.5-1.5-1.5h-0.559c-0.119-0.494-0.416-0.947-0.859-1.303-0.563-0.45-1.3-0.697-2.081-0.697s-1.519 0.247-2.081 0.697c-0.447 0.356-0.741 0.809-0.859 1.303h-0.559c-0.828 0-1.5 0.672-1.5 1.5v1c0 0.275 0.225 0.5 0.5 0.5zM8 3.5c0-0.275 0.225-0.5 0.5-0.5h1c0.275 0 0.5-0.225 0.5-0.5 0-0.378 0.194-0.744 0.544-1.022 0.384-0.309 0.903-0.478 1.456-0.478s1.072 0.169 1.456 0.478c0.35 0.281 0.544 0.644 0.544 1.022 0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5 0.225 0.5 0.5v0.5h-8v-0.5z" })
            );
        }
        function ClipboardEmpty({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ClipboardEmptySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ClipboardEmpty.SVG = ClipboardEmptySVG;
        return ClipboardEmpty;
    })();
export const ClipboardLeft = /*#__PURE__*/ (() => {
        function ClipboardLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 12h-6.584l2.544-2.544-1.416-1.416-4.25 4.25c-0.391 0.391-0.391 1.025 0 1.416l4.25 4.25 1.416-1.416-2.544-2.541h6.584v-2z" }),
_('path', { d: "M19 3h-1v2h1v17h-14v-17h1v-2h-1c-1.103 0-2 0.897-2 2v17c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-17c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M7.5 5h9c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.828-0.672-1.5-1.5-1.5h-0.559c-0.119-0.494-0.416-0.947-0.859-1.303-0.563-0.45-1.3-0.697-2.081-0.697s-1.519 0.247-2.081 0.697c-0.447 0.356-0.741 0.809-0.859 1.303h-0.559c-0.828 0-1.5 0.672-1.5 1.5v1c0 0.275 0.225 0.5 0.5 0.5zM8 3.5c0-0.275 0.225-0.5 0.5-0.5h1c0.275 0 0.5-0.225 0.5-0.5 0-0.378 0.194-0.744 0.544-1.022 0.384-0.309 0.903-0.478 1.456-0.478s1.072 0.169 1.456 0.478c0.35 0.281 0.544 0.644 0.544 1.022 0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5 0.225 0.5 0.5v0.5h-8v-0.5z" })
            );
        }
        function ClipboardLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ClipboardLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ClipboardLeft.SVG = ClipboardLeftSVG;
        return ClipboardLeft;
    })();
export const ClipboardList = /*#__PURE__*/ (() => {
        function ClipboardListSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 3h-1v2h1v17h-14v-17h1v-2h-1c-1.103 0-2 0.897-2 2v17c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-17c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M7.5 5h9c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.828-0.672-1.5-1.5-1.5h-0.559c-0.119-0.494-0.416-0.947-0.859-1.303-0.563-0.45-1.3-0.697-2.081-0.697s-1.519 0.247-2.081 0.697c-0.447 0.356-0.741 0.809-0.859 1.303h-0.559c-0.828 0-1.5 0.672-1.5 1.5v1c0 0.275 0.225 0.5 0.5 0.5zM8 3.5c0-0.275 0.225-0.5 0.5-0.5h1c0.275 0 0.5-0.225 0.5-0.5 0-0.378 0.194-0.744 0.544-1.022 0.384-0.309 0.903-0.478 1.456-0.478s1.072 0.169 1.456 0.478c0.35 0.281 0.544 0.644 0.544 1.022 0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5 0.225 0.5 0.5v0.5h-8v-0.5z" }),
_('path', { d: "M10 9h8v1h-8v-1zM10 13h8v1h-8v-1zM10 17h8v1h-8v-1z" }),
_('path', { d: "M7.5 11c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM7.5 9c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM7.5 12c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM7.5 14c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5zM7.5 16c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM7.5 18c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" })
            );
        }
        function ClipboardList({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ClipboardListSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ClipboardList.SVG = ClipboardListSVG;
        return ClipboardList;
    })();
export const ClipboardPencil = /*#__PURE__*/ (() => {
        function ClipboardPencilSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 3h-1v2h1v17h-14v-17h1v-2h-1c-1.103 0-2 0.897-2 2v17c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-17c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M7.5 5h9c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.828-0.672-1.5-1.5-1.5h-0.559c-0.119-0.494-0.416-0.947-0.859-1.303-0.563-0.45-1.3-0.697-2.081-0.697s-1.519 0.247-2.081 0.697c-0.447 0.356-0.741 0.809-0.859 1.303h-0.559c-0.828 0-1.5 0.672-1.5 1.5v1c0 0.275 0.225 0.5 0.5 0.5zM8 3.5c0-0.275 0.225-0.5 0.5-0.5h1c0.275 0 0.5-0.225 0.5-0.5 0-0.378 0.194-0.744 0.544-1.022 0.384-0.309 0.903-0.478 1.456-0.478s1.072 0.169 1.456 0.478c0.35 0.281 0.544 0.644 0.544 1.022 0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5 0.225 0.5 0.5v0.5h-8v-0.5z" }),
_('path', { d: "M13.731 8.562l-6.084 6.084c-0.069 0.069-0.119 0.159-0.138 0.256l-0.5 2.5c-0.031 0.162 0.019 0.334 0.138 0.453 0.094 0.094 0.222 0.147 0.353 0.147 0.031 0 0.066-0.003 0.097-0.009l2.5-0.5c0.097-0.019 0.184-0.066 0.256-0.138l6.084-6.087c0.363-0.363 0.563-0.844 0.563-1.353s-0.2-0.991-0.563-1.353c-0.747-0.747-1.959-0.747-2.706 0zM9.753 16.541l-1.616 0.322 0.322-1.616 5.041-5.041 1.294 1.294-5.041 5.041zM15.731 10.563l-0.231 0.231-1.294-1.294 0.231-0.231c0.356-0.356 0.938-0.356 1.294 0 0.172 0.172 0.269 0.403 0.269 0.647s-0.097 0.472-0.269 0.647z" })
            );
        }
        function ClipboardPencil({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ClipboardPencilSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ClipboardPencil.SVG = ClipboardPencilSVG;
        return ClipboardPencil;
    })();
export const ClipboardText = /*#__PURE__*/ (() => {
        function ClipboardTextSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 3h-1v2h1v17h-14v-17h1v-2h-1c-1.103 0-2 0.897-2 2v17c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-17c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M7.5 5h9c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.828-0.672-1.5-1.5-1.5h-0.559c-0.119-0.494-0.416-0.947-0.859-1.303-0.563-0.45-1.3-0.697-2.081-0.697s-1.519 0.247-2.081 0.697c-0.447 0.356-0.741 0.809-0.859 1.303h-0.559c-0.828 0-1.5 0.672-1.5 1.5v1c0 0.275 0.225 0.5 0.5 0.5zM8 3.5c0-0.275 0.225-0.5 0.5-0.5h1c0.275 0 0.5-0.225 0.5-0.5 0-0.378 0.194-0.744 0.544-1.022 0.384-0.309 0.903-0.478 1.456-0.478s1.072 0.169 1.456 0.478c0.35 0.281 0.544 0.644 0.544 1.022 0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5 0.225 0.5 0.5v0.5h-8v-0.5z" }),
_('path', { d: "M17 8h-10v-1h10v1zM13 10h-6v1h6v-1zM17 12h-10v1h10v-1zM15 14h-8v1h8v-1zM17 16h-10v1h10v-1zM16 18h-9v1h9v-1z" })
            );
        }
        function ClipboardText({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ClipboardTextSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ClipboardText.SVG = ClipboardTextSVG;
        return ClipboardText;
    })();
export const ClipboardUser = /*#__PURE__*/ (() => {
        function ClipboardUserSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 3h-1v2h1v17h-14v-17h1v-2h-1c-1.103 0-2 0.897-2 2v17c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-17c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M7.5 5h9c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.828-0.672-1.5-1.5-1.5h-0.559c-0.119-0.494-0.416-0.947-0.859-1.303-0.563-0.45-1.3-0.697-2.081-0.697s-1.519 0.247-2.081 0.697c-0.447 0.356-0.741 0.809-0.859 1.303h-0.559c-0.828 0-1.5 0.672-1.5 1.5v1c0 0.275 0.225 0.5 0.5 0.5zM8 3.5c0-0.275 0.225-0.5 0.5-0.5h1c0.275 0 0.5-0.225 0.5-0.5 0-0.378 0.194-0.744 0.544-1.022 0.384-0.309 0.903-0.478 1.456-0.478s1.072 0.169 1.456 0.478c0.35 0.281 0.544 0.644 0.544 1.022 0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5 0.225 0.5 0.5v0.5h-8v-0.5z" }),
_('path', { d: "M8.072 16.244c-0.141 0.231-0.069 0.534 0.159 0.681 1.144 0.722 2.378 1.075 3.769 1.075s2.625-0.353 3.769-1.078c0.228-0.147 0.3-0.447 0.159-0.681-0.45-0.75-0.975-1.294-1.606-1.666-0.147-0.087-0.3-0.162-0.456-0.231 0.691-0.55 1.134-1.397 1.134-2.347 0-1.653-1.347-3-3-3s-3 1.347-3 3c0 0.95 0.444 1.797 1.134 2.347-0.156 0.066-0.309 0.144-0.456 0.231-0.631 0.375-1.156 0.919-1.606 1.669zM10 12c0-1.103 0.897-2 2-2s2 0.897 2 2c0 1.103-0.897 2-2 2s-2-0.897-2-2zM14.787 16.334c-0.853 0.447-1.769 0.666-2.787 0.666s-1.934-0.219-2.787-0.666c0.691-0.919 1.569-1.334 2.787-1.334s2.097 0.416 2.787 1.334z" })
            );
        }
        function ClipboardUser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ClipboardUserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ClipboardUser.SVG = ClipboardUserSVG;
        return ClipboardUser;
    })();
export const ClipboardWarning = /*#__PURE__*/ (() => {
        function ClipboardWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 3h-1v2h1v17h-14v-17h1v-2h-1c-1.103 0-2 0.897-2 2v17c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-17c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M7.5 5h9c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.828-0.672-1.5-1.5-1.5h-0.559c-0.119-0.494-0.416-0.947-0.859-1.303-0.563-0.45-1.3-0.697-2.081-0.697s-1.519 0.247-2.081 0.697c-0.447 0.356-0.741 0.809-0.859 1.303h-0.559c-0.828 0-1.5 0.672-1.5 1.5v1c0 0.275 0.225 0.5 0.5 0.5zM8 3.5c0-0.275 0.225-0.5 0.5-0.5h1c0.275 0 0.5-0.225 0.5-0.5 0-0.378 0.194-0.744 0.544-1.022 0.384-0.309 0.903-0.478 1.456-0.478s1.072 0.169 1.456 0.478c0.35 0.281 0.544 0.644 0.544 1.022 0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5 0.225 0.5 0.5v0.5h-8v-0.5z" }),
_('path', { d: "M10.997 9h2v6h-2v-6z" }),
_('path', { d: "M12 18c0.55 0 1-0.45 1-1s-0.45-1-1-1c-0.55 0-1 0.45-1 1s0.45 1 1 1z" })
            );
        }
        function ClipboardWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ClipboardWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ClipboardWarning.SVG = ClipboardWarningSVG;
        return ClipboardWarning;
    })();
export const Clock = /*#__PURE__*/ (() => {
        function ClockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M16.5 7.794l-4.241 4.241c-0.081-0.022-0.169-0.034-0.259-0.034-0.147 0-0.288 0.031-0.413 0.091l-3.203-2.288-0.581 0.813 3.203 2.288c-0.003 0.031-0.003 0.063-0.003 0.097 0 0.55 0.45 1 1 1s1-0.45 1-1c0-0.091-0.012-0.175-0.034-0.259l4.238-4.241-0.706-0.706z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" })
            );
        }
        function Clock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ClockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Clock.SVG = ClockSVG;
        return Clock;
    })();
export const CloudBackup = /*#__PURE__*/ (() => {
        function CloudBackupSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.928 12.066c0.047-0.353 0.072-0.709 0.072-1.066 0-2.403-0.938-4.666-2.634-6.366-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h6.025c1.156 1.803 3.178 3 5.475 3 3.584 0 6.5-2.916 6.5-6.5 0-0.744-0.125-1.459-0.356-2.125 0.131-0.425 0.228-0.866 0.284-1.309zM6 17c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.797 0 6.897 3.038 6.997 6.813-1.169-1.122-2.753-1.812-4.497-1.812-3.584 0-6.5 2.916-6.5 6.5 0 0.516 0.059 1.019 0.175 1.5h-5.175zM17.5 21c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M20.147 13.147l-1.353 1.353 0.706 0.706 0.5-0.5v0.794c0 1.378-1.122 2.5-2.5 2.5s-2.5-1.122-2.5-2.5 1.122-2.5 2.5-2.5h0.5v-1h-0.5c-1.931 0-3.5 1.569-3.5 3.5s1.569 3.5 3.5 3.5 3.5-1.569 3.5-3.5v-0.794l0.5 0.5 0.706-0.706-1.353-1.353c-0.194-0.197-0.513-0.197-0.706 0z" })
            );
        }
        function CloudBackup({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudBackupSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudBackup.SVG = CloudBackupSVG;
        return CloudBackup;
    })();
export const CloudBolt = /*#__PURE__*/ (() => {
        function CloudBoltSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.366 2.634c-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244 2.641 1.756 4.244 1.756h1v-2h-1c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.859 0 7 3.141 7 7 0 3.309-2.691 6-6 6v2c2.137 0 4.147-0.831 5.656-2.344 1.512-1.512 2.344-3.519 2.344-5.656 0-2.403-0.938-4.666-2.634-6.366z" }),
_('path', { d: "M14.5 16h-2.191l1.638-3.275c0.078-0.156 0.069-0.338-0.022-0.487-0.091-0.147-0.253-0.237-0.425-0.237h-4c-0.244 0-0.453 0.178-0.494 0.419l-1 6c-0.025 0.144 0.016 0.294 0.113 0.406s0.234 0.178 0.381 0.178h1.391l-0.881 4.403c-0.047 0.231 0.075 0.462 0.291 0.556 0.066 0.028 0.131 0.041 0.2 0.041 0.156 0 0.309-0.075 0.406-0.209l5-7c0.109-0.153 0.122-0.353 0.038-0.519s-0.256-0.275-0.444-0.275zM10.447 21.312l0.544-2.716c0.028-0.147-0.009-0.3-0.103-0.416s-0.237-0.184-0.387-0.184h-1.409l0.834-5h2.769l-1.638 3.275c-0.078 0.156-0.069 0.337 0.022 0.488 0.091 0.147 0.253 0.237 0.425 0.237h2.028l-3.084 4.316z" })
            );
        }
        function CloudBolt({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudBoltSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudBolt.SVG = CloudBoltSVG;
        return CloudBolt;
    })();
export const CloudCheck = /*#__PURE__*/ (() => {
        function CloudCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.928 12.066c0.047-0.353 0.072-0.709 0.072-1.066 0-2.403-0.938-4.666-2.634-6.366-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h6.025c1.156 1.803 3.178 3 5.475 3 3.584 0 6.5-2.916 6.5-6.5 0-0.744-0.125-1.459-0.356-2.125 0.131-0.425 0.228-0.866 0.284-1.309zM6 17c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.797 0 6.897 3.038 6.997 6.813-1.169-1.122-2.753-1.812-4.497-1.812-3.584 0-6.5 2.916-6.5 6.5 0 0.516 0.059 1.019 0.175 1.5h-5.175zM17.5 21c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16.5 16.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4z" })
            );
        }
        function CloudCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudCheck.SVG = CloudCheckSVG;
        return CloudCheck;
    })();
export const CloudConnected = /*#__PURE__*/ (() => {
    function CloudConnectedSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 20.5c0-0.275-0.225-0.5-0.5-0.5h-1.5v-3h3c2.137 0 4.147-0.831 5.656-2.344 1.512-1.512 2.344-3.519 2.344-5.656 0-2.403-0.938-4.666-2.634-6.366-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h5v3h-1.5c-0.275 0-0.5 0.225-0.5 0.5v0.5h-9v2h9v0.5c0 0.275 0.225 0.5 0.5 0.5h5c0.275 0 0.5-0.225 0.5-0.5v-0.5h9v-2h-9v-0.5zM2 11c0-2.206 1.794-4 4-4 1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.859 0 7 3.141 7 7 0 3.309-2.691 6-6 6h-10c-2.206 0-4-1.794-4-4zM14 23h-4v-2h4v2z" })
        );
    }
    function CloudConnected({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CloudConnectedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CloudConnected.SVG = CloudConnectedSVG;
    return CloudConnected;
})();
export const CloudCross = /*#__PURE__*/ (() => {
        function CloudCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.928 12.066c0.047-0.353 0.072-0.709 0.072-1.066 0-2.403-0.938-4.666-2.634-6.366-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h6.025c1.156 1.803 3.178 3 5.475 3 3.584 0 6.5-2.916 6.5-6.5 0-0.744-0.125-1.459-0.356-2.125 0.131-0.425 0.228-0.866 0.284-1.309zM6 17c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.797 0 6.897 3.038 6.997 6.813-1.169-1.122-2.753-1.812-4.497-1.812-3.584 0-6.5 2.916-6.5 6.5 0 0.516 0.059 1.019 0.175 1.5h-5.175zM17.5 21c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 12.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function CloudCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudCross.SVG = CloudCrossSVG;
        return CloudCross;
    })();
export const CloudDatabase = /*#__PURE__*/ (() => {
        function CloudDatabaseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.928 12.066c0.047-0.353 0.072-0.709 0.072-1.066 0-2.403-0.938-4.666-2.634-6.366-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h6.025c1.156 1.803 3.178 3 5.475 3 3.584 0 6.5-2.916 6.5-6.5 0-0.744-0.125-1.459-0.356-2.125 0.131-0.425 0.228-0.866 0.284-1.309zM6 17c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.797 0 6.897 3.038 6.997 6.813-1.169-1.122-2.753-1.812-4.497-1.812-3.584 0-6.5 2.916-6.5 6.5 0 0.516 0.059 1.019 0.175 1.5h-5.175zM17.5 21c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17.5 12c-1.741 0-3.5 0.462-3.5 1.5v4c0 1.038 1.759 1.5 3.5 1.5s3.5-0.462 3.5-1.5v-4c0-1.038-1.759-1.5-3.5-1.5zM17.5 13c1.381 0 2.219 0.316 2.453 0.5-0.234 0.184-1.072 0.5-2.453 0.5s-2.219-0.316-2.453-0.5c0.234-0.184 1.072-0.5 2.453-0.5zM20 15.459c-0.147 0.175-1.003 0.541-2.5 0.541s-2.353-0.369-2.5-0.541v-0.856c0.666 0.272 1.584 0.4 2.5 0.4s1.834-0.128 2.5-0.4v0.856zM17.5 18c-1.494 0-2.353-0.369-2.5-0.541v-0.856c0.666 0.272 1.584 0.4 2.5 0.4s1.834-0.128 2.5-0.4v0.856c-0.147 0.172-1.006 0.541-2.5 0.541z" })
            );
        }
        function CloudDatabase({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudDatabaseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudDatabase.SVG = CloudDatabaseSVG;
        return CloudDatabase;
    })();
export const CloudDownload = /*#__PURE__*/ (() => {
        function CloudDownloadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 17.294v-5.294h-1v5.294l-1.5-1.5-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l2.353-2.353-0.706-0.706-1.5 1.5z" }),
_('path', { d: "M23.928 12.066c0.047-0.353 0.072-0.709 0.072-1.066 0-2.403-0.938-4.666-2.634-6.366-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h6.025c1.156 1.803 3.178 3 5.475 3 3.584 0 6.5-2.916 6.5-6.5 0-0.744-0.125-1.459-0.356-2.125 0.131-0.425 0.228-0.866 0.284-1.309zM6 17c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.797 0 6.897 3.038 6.997 6.813-1.169-1.122-2.753-1.812-4.497-1.812-3.584 0-6.5 2.916-6.5 6.5 0 0.516 0.059 1.019 0.175 1.5h-5.175zM17.5 21c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" })
            );
        }
        function CloudDownload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudDownloadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudDownload.SVG = CloudDownloadSVG;
        return CloudDownload;
    })();
export const CloudFog = /*#__PURE__*/ (() => {
    function CloudFogSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 15c-2.253 0-3.625 0.306-4.834 0.578-1.009 0.225-1.884 0.422-3.166 0.422-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.859 0 7 3.141 7 7 0 0.738-0.112 1.478-0.337 2.206l1.913 0.588c0.281-0.919 0.425-1.859 0.425-2.794 0-2.403-0.938-4.666-2.634-6.366s-3.963-2.634-6.366-2.634c-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244v6.5c0 1.456 0.669 2.844 1.884 3.912 1.15 1.009 2.65 1.587 4.116 1.587 1.447 0 2.441-0.222 3.494-0.459 1.188-0.266 2.419-0.541 4.506-0.541 1.966 0 3.488 0.253 4.959 0.497 1.494 0.247 3.037 0.503 5.041 0.503v-1c-1.919 0-3.356-0.237-4.878-0.491-1.512-0.25-3.075-0.509-5.122-0.509-2.2 0-3.541 0.3-4.725 0.566-0.997 0.222-1.938 0.434-3.275 0.434-2.359 0-5-1.925-5-4.5v-0.047c0.25 0.341 0.547 0.663 0.884 0.959 1.15 1.009 2.65 1.587 4.116 1.587 1.447 0 2.441-0.222 3.494-0.459 1.188-0.266 2.419-0.541 4.506-0.541 1.966 0 3.488 0.253 4.959 0.497 1.494 0.247 3.038 0.503 5.041 0.503v-1c-1.919 0-3.356-0.237-4.878-0.491-1.512-0.25-3.075-0.509-5.122-0.509-2.2 0-3.541 0.3-4.725 0.566-0.997 0.222-1.938 0.434-3.275 0.434-2.359 0-5-1.925-5-4.5v-0.178c0.219 0.328 0.472 0.638 0.756 0.922 1.134 1.131 2.641 1.756 4.244 1.756 1.503 0 2.572-0.241 3.603-0.472 1.162-0.259 2.363-0.528 4.397-0.528 1.925 0 3.359 0.237 4.878 0.491 1.512 0.25 3.078 0.509 5.122 0.509v-2c-1.878 0-3.297-0.234-4.794-0.484-1.531-0.253-3.116-0.516-5.206-0.516z" })
        );
    }
    function CloudFog({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CloudFogSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CloudFog.SVG = CloudFogSVG;
    return CloudFog;
})();
export const CloudLock = /*#__PURE__*/ (() => {
        function CloudLockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.928 12.066c0.047-0.353 0.072-0.709 0.072-1.066 0-2.403-0.938-4.666-2.634-6.366-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h6.025c1.156 1.803 3.178 3 5.475 3 3.584 0 6.5-2.916 6.5-6.5 0-0.744-0.125-1.459-0.356-2.125 0.131-0.425 0.228-0.866 0.284-1.309zM6 17c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.797 0 6.897 3.038 6.997 6.813-1.169-1.122-2.753-1.812-4.497-1.812-3.584 0-6.5 2.916-6.5 6.5 0 0.516 0.059 1.019 0.175 1.5h-5.175zM17.5 21c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M20.5 15h-0.5v-0.5c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5v0.5h-0.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h6c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5zM16 14.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5v0.5h-3v-0.5zM20 18h-5v-2h5v2z" })
            );
        }
        function CloudLock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudLockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudLock.SVG = CloudLockSVG;
        return CloudLock;
    })();
export const CloudMessage = /*#__PURE__*/ (() => {
        function CloudMessageSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.991 10.397c0 0 0 0 0 0 0-0.003 0-0.006-0.003-0.009 0 0 0 0 0-0.003s0-0.003 0-0.006c0 0 0 0 0 0 0-0.003 0-0.003-0.003-0.006 0 0 0-0.003 0-0.003 0-0.003 0-0.003 0-0.006 0 0 0-0.003 0-0.003s0-0.003 0-0.003c0 0 0-0.003 0-0.003 0-0.003 0-0.003-0.003-0.006 0 0 0-0.003 0-0.003s0-0.003 0-0.003c0 0 0-0.003 0-0.003 0-0.003 0-0.003-0.003-0.006 0 0 0 0 0-0.003s0-0.003-0.003-0.006c0 0 0 0 0-0.003s-0.003-0.003-0.003-0.006c0 0 0 0 0 0-0.038-0.091-0.1-0.172-0.184-0.228 0 0 0 0 0 0-0.003-0.003-0.009-0.006-0.012-0.009 0 0 0 0 0 0-0.003 0-0.003-0.003-0.006-0.003 0 0 0 0 0 0-0.003 0-0.003-0.003-0.006-0.003 0 0 0 0-0.003 0 0 0 0 0-0.003 0-0.003-0.003-0.009-0.006-0.012-0.006 0 0 0 0 0 0-0.1-0.053-0.209-0.069-0.316-0.053 0 0 0 0 0 0-0.003 0-0.006 0-0.006 0s0 0 0 0c-0.003 0-0.003 0-0.006 0 0 0 0 0-0.003 0s-0.006 0-0.006 0c0 0 0 0 0 0-0.003 0-0.003 0-0.006 0 0 0 0 0-0.003 0s-0.006 0-0.006 0.003c0 0 0 0-0.003 0s-0.003 0-0.006 0.003c0 0 0 0 0 0-0.003 0-0.006 0-0.006 0.003 0 0 0 0 0 0-0.006 0-0.009 0.003-0.016 0.006 0 0 0 0 0 0-0.050 0.016-0.1 0.044-0.144 0.075l-11.009 7.997c-0.156 0.116-0.234 0.309-0.197 0.5s0.181 0.344 0.369 0.391l3.709 0.928 0.928 3.709c0.050 0.197 0.216 0.347 0.416 0.375 0.022 0.003 0.047 0.006 0.069 0.006 0.178 0 0.344-0.094 0.434-0.253l1.788-3.131 3.603 1.347c0.153 0.056 0.325 0.037 0.459-0.056s0.216-0.247 0.216-0.412v-10.991c0-0.037-0.003-0.075-0.009-0.113zM7.659 18.275l7.275-5.291-4.628 5.95-2.647-0.659zM11.684 22.172l-0.641-2.556 4.525-5.819-2.519 5.981-1.366 2.394zM14.163 19.716l2.838-6.741v7.803l-2.838-1.062z" }),
_('path', { d: "M21.366 2.634c-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244c0 1.394 0.488 2.75 1.372 3.822 0.872 1.056 2.091 1.788 3.428 2.059l0.397-1.959c-1.853-0.378-3.197-2.025-3.197-3.922 0-2.206 1.794-4 4-4 1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.859 0 7 3.141 7 7 0 1.669-0.703 3.275-1.928 4.406l1.356 1.469c0.803-0.741 1.434-1.622 1.878-2.616 0.459-1.028 0.694-2.125 0.694-3.262 0-2.4-0.938-4.662-2.634-6.363z" })
            );
        }
        function CloudMessage({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudMessageSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudMessage.SVG = CloudMessageSVG;
        return CloudMessage;
    })();
export const CloudMusic = /*#__PURE__*/ (() => {
        function CloudMusicSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.928 12.066c0.047-0.353 0.072-0.709 0.072-1.066 0-2.403-0.938-4.666-2.634-6.366-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h6.025c1.156 1.803 3.178 3 5.475 3 3.584 0 6.5-2.916 6.5-6.5 0-0.744-0.125-1.459-0.356-2.125 0.131-0.425 0.228-0.866 0.284-1.309zM6 17c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.797 0 6.897 3.038 6.997 6.813-1.169-1.122-2.753-1.812-4.497-1.812-3.584 0-6.5 2.916-6.5 6.5 0 0.516 0.059 1.019 0.175 1.5h-5.175zM17.5 21c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19 12h-1v4.131c-0.353-0.125-0.762-0.162-1.191-0.103-1.109 0.156-1.903 0.922-1.803 1.747 0.041 0.328 0.213 0.616 0.5 0.837 0.334 0.256 0.803 0.397 1.303 0.397 0.125 0 0.253-0.009 0.381-0.028 1.047-0.147 1.812-0.837 1.809-1.606v0-3.141c0.531 0.475 1.231 0.766 2 0.766v-1c-1.103 0-2-0.897-2-2zM17.050 17.991c-0.366 0.050-0.731-0.016-0.934-0.172-0.050-0.038-0.109-0.097-0.116-0.166-0.025-0.197 0.341-0.55 0.947-0.634 0.087-0.012 0.172-0.019 0.253-0.019 0.319 0 0.553 0.091 0.681 0.188 0.072 0.053 0.109 0.109 0.116 0.166v0c0.025 0.197-0.341 0.55-0.947 0.637z" })
            );
        }
        function CloudMusic({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudMusicSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudMusic.SVG = CloudMusicSVG;
        return CloudMusic;
    })();
export const CloudMusic2 = /*#__PURE__*/ (() => {
        function CloudMusic2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.928 12.066c0.047-0.353 0.072-0.709 0.072-1.066 0-2.403-0.938-4.666-2.634-6.366-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h6.025c1.156 1.803 3.178 3 5.475 3 3.584 0 6.5-2.916 6.5-6.5 0-0.744-0.125-1.459-0.356-2.125 0.131-0.425 0.228-0.866 0.284-1.309zM6 17c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.797 0 6.897 3.038 6.997 6.813-1.169-1.122-2.753-1.812-4.497-1.812-3.584 0-6.5 2.916-6.5 6.5 0 0.516 0.059 1.019 0.175 1.5h-5.175zM17.5 21c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M21 13.5c0-0.228-0.156-0.428-0.378-0.484l-4-1c-0.15-0.037-0.306-0.003-0.428 0.091s-0.194 0.241-0.194 0.394v2.544c-0.216-0.056-0.447-0.066-0.678-0.019-0.8 0.162-1.378 0.919-1.313 1.719 0.031 0.4 0.222 0.747 0.531 0.978 0.237 0.178 0.531 0.272 0.837 0.272 0.1 0 0.203-0.009 0.303-0.031 0.769-0.156 1.331-0.856 1.319-1.619v-3.203l3 0.75v2.153c-0.216-0.056-0.447-0.066-0.678-0.019-0.8 0.162-1.378 0.919-1.313 1.719 0.031 0.4 0.222 0.747 0.531 0.978 0.237 0.178 0.531 0.272 0.837 0.272 0.1 0 0.203-0.009 0.303-0.031 0.769-0.156 1.331-0.856 1.319-1.619v-3.844zM15.481 16.984c-0.131 0.028-0.253 0.006-0.341-0.063-0.078-0.059-0.125-0.15-0.134-0.259-0.022-0.288 0.219-0.597 0.519-0.656 0.038-0.006 0.072-0.012 0.106-0.012 0.091 0 0.172 0.025 0.234 0.072 0.078 0.059 0.125 0.15 0.134 0.259 0 0.009 0 0.022 0 0.031v0.012c-0.003 0.278-0.234 0.559-0.519 0.616zM19.481 17.984c-0.131 0.028-0.253 0.006-0.341-0.063-0.078-0.059-0.125-0.15-0.134-0.259-0.022-0.288 0.219-0.597 0.519-0.656 0.037-0.006 0.072-0.012 0.106-0.012 0.091 0 0.172 0.025 0.234 0.072 0.078 0.059 0.125 0.15 0.134 0.259 0 0.009 0 0.022 0 0.031v0.012c-0.003 0.278-0.234 0.559-0.519 0.616z" })
            );
        }
        function CloudMusic2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudMusic2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudMusic2.SVG = CloudMusic2SVG;
        return CloudMusic2;
    })();
export const CloudRain = /*#__PURE__*/ (() => {
        function CloudRainSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 9c0-2.403-0.938-4.666-2.634-6.366-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h10c2.137 0 4.147-0.831 5.656-2.344 1.512-1.509 2.344-3.519 2.344-5.656zM16 15h-10c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.859 0 7 3.141 7 7 0 3.309-2.691 6-6 6z" }),
_('path', { d: "M3 18h1v3h-1v-3z" }),
_('path', { d: "M5 21h1v3h-1v-3z" }),
_('path', { d: "M7 18h1v3h-1v-3z" }),
_('path', { d: "M9 21h1v3h-1v-3z" }),
_('path', { d: "M11 18h1v3h-1v-3z" }),
_('path', { d: "M13 21h1v3h-1v-3z" }),
_('path', { d: "M15 18h1v3h-1v-3z" }),
_('path', { d: "M17 21h1v3h-1v-3z" }),
_('path', { d: "M19 18h1v3h-1v-3z" }),
_('path', { d: "M21 21h1v3h-1v-3z" })
            );
        }
        function CloudRain({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudRainSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudRain.SVG = CloudRainSVG;
        return CloudRain;
    })();
export const CloudRain2 = /*#__PURE__*/ (() => {
        function CloudRain2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5.997 18.434c-0.034-0.247-0.244-0.434-0.497-0.434s-0.462 0.184-0.497 0.434c-0.037 0.278-0.206 0.791-0.387 1.331-0.288 0.869-0.616 1.85-0.616 2.528 0 0.925 0.687 1.706 1.5 1.706s1.5-0.781 1.5-1.706c0-0.678-0.328-1.659-0.616-2.528-0.181-0.541-0.353-1.053-0.387-1.331zM5.5 23c-0.256 0-0.5-0.344-0.5-0.706 0-0.472 0.263-1.3 0.5-2.016 0.237 0.716 0.5 1.544 0.5 2.016 0 0.363-0.244 0.706-0.5 0.706z" }),
_('path', { d: "M21.366 2.634c-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h10c2.137 0 4.147-0.831 5.656-2.344 1.512-1.512 2.344-3.519 2.344-5.656 0-2.403-0.938-4.666-2.634-6.366zM16 15h-10c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.859 0 7 3.141 7 7 0 3.309-2.691 6-6 6z" }),
_('path', { d: "M9.997 18.434c-0.034-0.247-0.244-0.434-0.497-0.434s-0.462 0.184-0.497 0.434c-0.037 0.278-0.206 0.791-0.387 1.331-0.288 0.869-0.616 1.85-0.616 2.528 0 0.925 0.687 1.706 1.5 1.706s1.5-0.781 1.5-1.706c0-0.678-0.328-1.659-0.616-2.528-0.181-0.541-0.353-1.053-0.387-1.331zM9.5 23c-0.256 0-0.5-0.344-0.5-0.706 0-0.472 0.262-1.3 0.5-2.016 0.237 0.716 0.5 1.544 0.5 2.016 0 0.363-0.244 0.706-0.5 0.706z" }),
_('path', { d: "M13.997 18.434c-0.034-0.247-0.244-0.434-0.497-0.434s-0.462 0.184-0.497 0.434c-0.037 0.278-0.206 0.791-0.387 1.331-0.288 0.869-0.616 1.85-0.616 2.528 0 0.925 0.687 1.706 1.5 1.706s1.5-0.781 1.5-1.706c0-0.678-0.328-1.659-0.616-2.528-0.181-0.541-0.353-1.053-0.387-1.331zM13.5 23c-0.256 0-0.5-0.344-0.5-0.706 0-0.472 0.262-1.3 0.5-2.016 0.237 0.716 0.5 1.544 0.5 2.016 0 0.363-0.244 0.706-0.5 0.706z" }),
_('path', { d: "M17.997 18.434c-0.034-0.247-0.244-0.434-0.497-0.434s-0.462 0.184-0.497 0.434c-0.038 0.278-0.206 0.791-0.387 1.331-0.288 0.869-0.616 1.85-0.616 2.528 0 0.925 0.687 1.706 1.5 1.706s1.5-0.781 1.5-1.706c0-0.678-0.328-1.659-0.616-2.528-0.181-0.541-0.353-1.053-0.387-1.331zM17.5 23c-0.256 0-0.5-0.344-0.5-0.706 0-0.472 0.262-1.3 0.5-2.016 0.237 0.716 0.5 1.544 0.5 2.016 0 0.363-0.244 0.706-0.5 0.706z" })
            );
        }
        function CloudRain2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudRain2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudRain2.SVG = CloudRain2SVG;
        return CloudRain2;
    })();
export const CloudRain3 = /*#__PURE__*/ (() => {
        function CloudRain3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.366 2.634c-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h10c2.137 0 4.147-0.831 5.656-2.344 1.512-1.512 2.344-3.519 2.344-5.656 0-2.403-0.938-4.666-2.634-6.366zM16 15h-10c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.859 0 7 3.141 7 7 0 3.309-2.691 6-6 6z" }),
_('path', { d: "M0.8 22.6l3.6-4.8 0.8 0.6-3.6 4.8-0.8-0.6z" }),
_('path', { d: "M4.8 22.6l3.6-4.8 0.8 0.6-3.6 4.8-0.8-0.6z" }),
_('path', { d: "M8.8 22.6l3.6-4.8 0.8 0.6-3.6 4.8-0.8-0.6z" }),
_('path', { d: "M12.8 22.6l3.6-4.8 0.8 0.6-3.6 4.8-0.8-0.6z" }),
_('path', { d: "M16.8 22.6l3.6-4.8 0.8 0.6-3.6 4.8-0.8-0.6z" })
            );
        }
        function CloudRain3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudRain3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudRain3.SVG = CloudRain3SVG;
        return CloudRain3;
    })();
export const CloudSettings = /*#__PURE__*/ (() => {
        function CloudSettingsSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 13c0-2.206 1.794-4 4-4 1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.859 0 7 3.141 7 7h2c0-2.403-0.938-4.666-2.634-6.366s-3.963-2.634-6.366-2.634c-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h6v-2h-6c-2.206 0-4-1.794-4-4z" }),
_('path', { d: "M18.5 15c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM18.5 17c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M23.816 14.994c0.034-0.128 0.016-0.266-0.050-0.378l-1-1.731c-0.138-0.237-0.444-0.322-0.681-0.184l-1.591 0.919c-0.078-0.053-0.156-0.103-0.241-0.153s-0.166-0.094-0.25-0.131v-1.837c0-0.275-0.225-0.5-0.5-0.5h-2c-0.275 0-0.5 0.225-0.5 0.5v1.837c-0.081 0.041-0.166 0.084-0.25 0.131-0.081 0.047-0.162 0.1-0.241 0.153l-1.591-0.912c-0.237-0.138-0.544-0.056-0.681 0.184l-1 1.731c-0.066 0.116-0.084 0.25-0.050 0.378s0.119 0.237 0.234 0.303l1.591 0.919c-0.006 0.091-0.009 0.184-0.009 0.281 0 0.094 0.003 0.188 0.009 0.281l-1.591 0.919c-0.116 0.066-0.2 0.175-0.234 0.303s-0.016 0.266 0.050 0.378l1 1.731c0.138 0.237 0.444 0.322 0.681 0.184l1.591-0.919c0.078 0.053 0.156 0.103 0.241 0.153s0.166 0.094 0.25 0.131v1.837c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-1.837c0.081-0.041 0.166-0.084 0.25-0.131 0.081-0.047 0.162-0.1 0.241-0.153l1.591 0.912c0.237 0.138 0.544 0.056 0.681-0.184l1-1.731c0.066-0.116 0.084-0.25 0.050-0.378s-0.119-0.237-0.234-0.303l-1.591-0.919c0.006-0.091 0.009-0.184 0.009-0.281 0-0.094-0.003-0.188-0.009-0.281l1.591-0.919c0.116-0.066 0.2-0.175 0.234-0.303zM21.2 15.516c-0.184 0.106-0.281 0.319-0.241 0.528 0.028 0.141 0.041 0.294 0.041 0.453 0 0.162-0.012 0.312-0.041 0.45-0.041 0.209 0.056 0.422 0.241 0.528l1.447 0.834-0.5 0.866-1.45-0.831c-0.184-0.106-0.416-0.084-0.575 0.056-0.113 0.097-0.237 0.188-0.372 0.266-0.144 0.081-0.278 0.144-0.412 0.191-0.203 0.069-0.338 0.259-0.338 0.472v1.672h-1v-1.672c0-0.213-0.134-0.403-0.338-0.472-0.134-0.047-0.272-0.109-0.412-0.191-0.134-0.078-0.259-0.166-0.372-0.266-0.162-0.138-0.394-0.159-0.575-0.056l-1.447 0.834-0.5-0.866 1.447-0.834c0.184-0.106 0.281-0.319 0.241-0.528-0.028-0.141-0.041-0.294-0.041-0.453 0-0.162 0.012-0.312 0.041-0.45 0.041-0.209-0.056-0.422-0.241-0.528l-1.45-0.831 0.5-0.866 1.45 0.831c0.184 0.106 0.416 0.084 0.575-0.056 0.113-0.097 0.237-0.188 0.372-0.266 0.144-0.081 0.278-0.144 0.412-0.191 0.203-0.069 0.338-0.259 0.338-0.472v-1.672h1v1.672c0 0.213 0.134 0.403 0.338 0.472 0.134 0.047 0.272 0.109 0.412 0.191 0.134 0.078 0.259 0.166 0.372 0.266 0.162 0.138 0.394 0.159 0.575 0.056l1.447-0.834 0.5 0.866-1.444 0.831z" })
            );
        }
        function CloudSettings({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudSettingsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudSettings.SVG = CloudSettingsSVG;
        return CloudSettings;
    })();
export const CloudSnow = /*#__PURE__*/ (() => {
        function CloudSnowSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3 19c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1z" }),
_('path', { d: "M9 19c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1z" }),
_('path', { d: "M15 19c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1z" }),
_('path', { d: "M21 19c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1z" }),
_('path', { d: "M6 22c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1z" }),
_('path', { d: "M12 22c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1z" }),
_('path', { d: "M18 22c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1z" }),
_('path', { d: "M24 9c0-2.403-0.938-4.666-2.634-6.366-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h10c2.137 0 4.147-0.831 5.656-2.344 1.512-1.509 2.344-3.519 2.344-5.656zM16 15h-10c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.859 0 7 3.141 7 7 0 3.309-2.691 6-6 6z" })
            );
        }
        function CloudSnow({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudSnowSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudSnow.SVG = CloudSnowSVG;
        return CloudSnow;
    })();
export const CloudSnow2 = /*#__PURE__*/ (() => {
        function CloudSnow2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7.744 19.072l-1.744 1.044v-2.116h-1v2.116l-1.744-1.044-0.513 0.856 1.784 1.072-1.784 1.072 0.513 0.856 1.744-1.044v2.116h1v-2.116l1.744 1.044 0.513-0.856-1.784-1.072 1.784-1.072z" }),
_('path', { d: "M14.744 19.072l-1.744 1.044v-2.116h-1v2.116l-1.744-1.044-0.513 0.856 1.784 1.072-1.784 1.072 0.513 0.856 1.744-1.044v2.116h1v-2.116l1.744 1.044 0.513-0.856-1.784-1.072 1.784-1.072z" }),
_('path', { d: "M21.744 19.072l-1.744 1.044v-2.116h-1v2.116l-1.744-1.044-0.513 0.856 1.784 1.072-1.784 1.072 0.513 0.856 1.744-1.044v2.116h1v-2.116l1.744 1.044 0.513-0.856-1.784-1.072 1.784-1.072z" }),
_('path', { d: "M24 9c0-2.403-0.938-4.666-2.634-6.366-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h10c2.137 0 4.147-0.831 5.656-2.344 1.512-1.509 2.344-3.519 2.344-5.656zM16 15h-10c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.859 0 7 3.141 7 7 0 3.309-2.691 6-6 6z" })
            );
        }
        function CloudSnow2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudSnow2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudSnow2.SVG = CloudSnow2SVG;
        return CloudSnow2;
    })();
export const CloudSun = /*#__PURE__*/ (() => {
        function CloudSunSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.366 9.634c-1.653-1.653-3.834-2.584-6.166-2.634-1.062-1.844-3.038-3.003-5.2-3.003-3.309 0-6 2.691-6 6 0 0.769 0.144 1.512 0.419 2.209-0.997 0.272-1.913 0.797-2.663 1.547-1.131 1.137-1.756 2.644-1.756 4.247s0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h10c2.137 0 4.147-0.831 5.656-2.344 1.512-1.512 2.344-3.519 2.344-5.656 0-2.403-0.938-4.666-2.634-6.366zM10 6c1.119 0 2.159 0.466 2.9 1.244-1.106 0.262-2.156 0.738-3.1 1.409-1.25 0.884-2.238 2.053-2.897 3.416-0.116-0.019-0.234-0.031-0.353-0.044-0.363-0.612-0.55-1.303-0.55-2.025 0-2.206 1.794-4 4-4zM16 22h-10c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.859 0 7 3.141 7 7 0 3.309-2.691 6-6 6z" }),
_('path', { d: "M0 9h3v2h-3v-2z" }),
_('path', { d: "M9 0h2v3h-2v-3z" }),
_('path', { d: "M14.042 4.544l2.499-2.499 1.414 1.414-2.499 2.499-1.414-1.414z" }),
_('path', { d: "M2.042 3.456l1.414-1.414 2.499 2.499-1.414 1.414-2.499-2.499z" })
            );
        }
        function CloudSun({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudSunSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudSun.SVG = CloudSunSVG;
        return CloudSun;
    })();
export const CloudSync = /*#__PURE__*/ (() => {
        function CloudSyncSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.928 12.066c0.047-0.353 0.072-0.709 0.072-1.066 0-2.403-0.938-4.666-2.634-6.366-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h6.025c1.156 1.803 3.178 3 5.475 3 3.584 0 6.5-2.916 6.5-6.5 0-0.744-0.125-1.459-0.356-2.125 0.131-0.425 0.228-0.866 0.284-1.309zM6 17c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.797 0 6.897 3.038 6.997 6.813-1.169-1.122-2.753-1.812-4.497-1.812-3.584 0-6.5 2.916-6.5 6.5 0 0.516 0.059 1.019 0.175 1.5h-5.175zM17.5 21c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16.794 13.5l0.706 0.706 1.353-1.353c0.194-0.194 0.194-0.513 0-0.706l-1.353-1.353-0.706 0.706 0.506 0.506c-1.838 0.103-3.3 1.631-3.3 3.494v0.5h1v-0.5c0-1.306 1.006-2.381 2.284-2.491l-0.491 0.491z" }),
_('path', { d: "M20 15.5c0 1.306-1.006 2.381-2.284 2.491l0.491-0.491-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706-0.506-0.506c1.837-0.103 3.3-1.631 3.3-3.494v-0.5h-1v0.5z" })
            );
        }
        function CloudSync({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudSyncSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudSync.SVG = CloudSyncSVG;
        return CloudSync;
    })();
export const CloudTime = /*#__PURE__*/ (() => {
        function CloudTimeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.859 12.5v0c0.094-0.484 0.141-0.991 0.141-1.5 0-2.403-0.938-4.666-2.634-6.366s-3.963-2.634-6.366-2.634c-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h6.025c1.156 1.803 3.178 3 5.475 3 3.584 0 6.5-2.916 6.5-6.5 0-0.744-0.125-1.459-0.356-2.125 0.087-0.284 0.159-0.578 0.216-0.875zM6 17c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.797 0 6.897 3.038 6.997 6.813-1.169-1.122-2.753-1.812-4.497-1.812-3.584 0-6.5 2.916-6.5 6.5 0 0.516 0.059 1.019 0.175 1.5h-5.175zM18 20.978v-1.978h-1v1.978c-2.634-0.237-4.737-2.344-4.978-4.978h1.978v-1h-1.978c0.237-2.634 2.344-4.737 4.978-4.978v1.978h1v-1.978c2.634 0.237 4.737 2.344 4.978 4.978h-1.978v1h1.978c-0.241 2.634-2.344 4.737-4.978 4.978z" }),
_('path', { d: "M17.422 15.716l-1.922-1.922-0.706 0.706 2.353 2.353c0.094 0.094 0.222 0.147 0.353 0.147 0.016 0 0.034 0 0.050-0.003 0.15-0.016 0.284-0.097 0.366-0.219l2.278-3.416-0.831-0.556-1.941 2.909z" })
            );
        }
        function CloudTime({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudTimeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudTime.SVG = CloudTimeSVG;
        return CloudTime;
    })();
export const CloudUpload = /*#__PURE__*/ (() => {
        function CloudUploadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 13.706v5.294h1v-5.294l1.5 1.5 0.706-0.706-2.353-2.353c-0.097-0.097-0.225-0.147-0.353-0.147s-0.256 0.050-0.353 0.147l-2.353 2.353 0.706 0.706 1.5-1.5z" }),
_('path', { d: "M23.928 12.066c0.047-0.353 0.072-0.709 0.072-1.066 0-2.403-0.938-4.666-2.634-6.366-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h6.025c1.156 1.803 3.178 3 5.475 3 3.584 0 6.5-2.916 6.5-6.5 0-0.744-0.125-1.459-0.356-2.125 0.131-0.425 0.228-0.866 0.284-1.309zM6 17c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.797 0 6.897 3.038 6.997 6.813-1.169-1.122-2.753-1.812-4.497-1.812-3.584 0-6.5 2.916-6.5 6.5 0 0.516 0.059 1.019 0.175 1.5h-5.175zM17.5 21c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" })
            );
        }
        function CloudUpload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudUploadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudUpload.SVG = CloudUploadSVG;
        return CloudUpload;
    })();
export const CloudWarning = /*#__PURE__*/ (() => {
        function CloudWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 19h1v1h-1v-1z" }),
_('path', { d: "M17 14h1v4h-1v-4z" }),
_('path', { d: "M21.384 16.916c1.666-1.516 2.616-3.656 2.616-5.916 0-2.403-0.938-4.666-2.634-6.366s-3.963-2.634-6.366-2.634c-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756-1.131 1.134-1.756 2.641-1.756 4.244s0.625 3.109 1.756 4.244c1.134 1.131 2.641 1.756 4.244 1.756h6.575l-0.413 0.828c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h8c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672l-1.459-2.913zM6 17c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.859 0 7 3.141 7 7 0 1.503-0.559 2.934-1.556 4.031l-1.6-3.2c-0.25-0.506-0.778-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-2.587 5.172h-7.575zM21.5 21h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5z" })
            );
        }
        function CloudWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudWarning.SVG = CloudWarningSVG;
        return CloudWarning;
    })();
export const CloudWind = /*#__PURE__*/ (() => {
        function CloudWindSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 16.5c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5c0 1.931 1.569 3.5 3.5 3.5 2.034 0 3.153-1.075 3.734-1.978 0.616-0.956 0.756-1.909 0.762-1.95l-0.991-0.141c0 0.006-0.122 0.787-0.612 1.55-0.65 1.006-1.622 1.519-2.894 1.519-1.378 0-2.5-1.122-2.5-2.5 0-0.828 0.672-1.5 1.5-1.5 0.175 0 0.344 0.031 0.5 0.084-0.581 0.206-1 0.762-1 1.416zM16.5 17c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5c0.275 0 0.497 0.222 0.5 0.494 0 0.003 0 0.003 0 0.006 0 0.275-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M22.188 20.109c-0.025 0.019-2.406 1.891-5.187 1.891-3.466 0-5.109-2.119-6.697-4.169-1.462-1.884-2.975-3.831-5.803-3.831-2.481 0-4.5 2.019-4.5 4.5v0.5h0.034c0.244 1.694 1.703 3 3.466 3 1.931 0 3.5-1.569 3.5-3.5 0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.653-0.419-1.209-1-1.416 0.156-0.056 0.325-0.084 0.5-0.084 0.828 0 1.5 0.672 1.5 1.5 0 1.378-1.122 2.5-2.5 2.5s-2.5-1.122-2.5-2.5c0-1.931 1.569-3.5 3.5-3.5 2.341 0 3.578 1.597 5.013 3.447 1.656 2.134 3.531 4.553 7.488 4.553 3.141 0 5.703-2.025 5.813-2.109l0.391-0.312-0.625-0.781-0.391 0.312zM3.5 19c-0.275 0-0.5-0.225-0.5-0.5 0-0.003 0-0.003 0-0.006 0.003-0.272 0.225-0.494 0.5-0.494s0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M21.366 3.634c-1.7-1.697-3.963-2.634-6.366-2.634-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244c0 0.406 0.041 0.809 0.119 1.2l1.959-0.4c-0.053-0.259-0.081-0.528-0.081-0.8 0-2.206 1.794-4 4-4 1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.316-1.531-2.187-1.997 1.209-2.247 3.584-3.703 6.181-3.703 3.859 0 7 3.141 7 7v0.5c0 0.778-0.097 1.531-0.288 2.241l1.931 0.519c0.237-0.878 0.356-1.806 0.356-2.759v-0.5c0-2.403-0.938-4.666-2.634-6.366z" })
            );
        }
        function CloudWind({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudWindSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudWind.SVG = CloudWindSVG;
        return CloudWind;
    })();
export const Cloud = /*#__PURE__*/ (() => {
    function CloudSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.363 5.637c-1.697-1.7-3.959-2.637-6.363-2.637-1.875 0-3.675 0.572-5.2 1.653-1.25 0.884-2.238 2.053-2.897 3.416-0.297-0.044-0.597-0.069-0.903-0.069-3.309 0-6 2.691-6 6s2.691 6 6 6h10c2.137 0 4.147-0.831 5.656-2.344 1.512-1.512 2.344-3.519 2.344-5.656 0-2.403-0.938-4.666-2.637-6.363zM16 18h-10c-2.206 0-4-1.794-4-4s1.794-4 4-4c1.35 0 2.597 0.672 3.341 1.8l1.669-1.1c-0.563-0.853-1.319-1.531-2.187-1.997 1.206-2.247 3.581-3.703 6.178-3.703 3.859 0 7 3.141 7 7 0 3.309-2.691 6-6 6z" })
        );
    }
    function Cloud({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CloudSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cloud.SVG = CloudSVG;
    return Cloud;
})();
export const Clubs = /*#__PURE__*/ (() => {
    function ClubsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.544 17.478c0.938-0.922 1.456-2.156 1.456-3.478 0-1.169-0.256-2.231-0.762-3.153-0.466-0.847-1.144-1.566-1.966-2.078-0.425-0.266-0.884-0.475-1.366-0.625 0.063-0.375 0.094-0.759 0.094-1.144 0-1.869-0.728-3.628-2.050-4.95s-3.081-2.050-4.95-2.050c-1.869 0-3.628 0.728-4.95 2.050s-2.050 3.081-2.050 4.95c0 0.387 0.031 0.769 0.094 1.147-0.478 0.15-0.934 0.359-1.356 0.622-0.822 0.513-1.5 1.231-1.966 2.078-0.506 0.922-0.762 1.984-0.762 3.153 0 1.322 0.516 2.556 1.456 3.478 1.028 1.009 2.472 1.55 4.062 1.522 0.531-0.009 1.441-0.15 2.306-0.403-0.466 2.112-1.866 3.403-3.825 3.403h-0.009v2h14v-2c-1.959 0-3.359-1.291-3.825-3.403 0.862 0.253 1.775 0.394 2.306 0.403 1.591 0.031 3.034-0.513 4.062-1.522zM14.694 16.241c-0.291-0.272-0.716-0.347-1.081-0.188s-0.603 0.519-0.603 0.919c0 2.031 0.559 3.769 1.616 5.031h-5.241c1.056-1.263 1.616-3 1.616-5.031 0-0.4-0.237-0.759-0.603-0.919s-0.791-0.084-1.081 0.188c-0.066 0.059-0.409 0.263-1.181 0.478-0.591 0.166-1.238 0.275-1.644 0.281-1.050 0.019-1.981-0.319-2.625-0.95-0.553-0.541-0.856-1.269-0.856-2.050 0-1.559 0.634-2.816 1.788-3.534 1.128-0.703 2.609-0.791 3.775-0.222l0.878-1.797c-0.728-0.356-1.541-0.55-2.372-0.575-0.050-0.284-0.075-0.578-0.075-0.872 0-2.756 2.244-5 5-5s5 2.244 5 5c0 0.294-0.025 0.584-0.075 0.872-0.828 0.025-1.638 0.219-2.362 0.575l0.878 1.797c1.166-0.569 2.647-0.481 3.775 0.222 1.153 0.719 1.788 1.975 1.788 3.534 0 0.781-0.303 1.509-0.856 2.050-0.644 0.631-1.575 0.969-2.625 0.95-0.406-0.006-1.050-0.119-1.644-0.281-0.778-0.216-1.122-0.419-1.188-0.478z" })
        );
    }
    function Clubs({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ClubsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Clubs.SVG = ClubsSVG;
    return Clubs;
})();
export const Clubs2 = /*#__PURE__*/ (() => {
        function Clubs2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.544 17.478c0.938-0.922 1.456-2.156 1.456-3.478 0-1.169-0.256-2.231-0.762-3.153-0.466-0.847-1.144-1.566-1.966-2.078-0.425-0.266-0.884-0.475-1.366-0.625 0.063-0.375 0.094-0.759 0.094-1.144 0-1.869-0.728-3.628-2.050-4.95s-3.081-2.050-4.95-2.050c-1.869 0-3.628 0.728-4.95 2.050s-2.050 3.081-2.050 4.95c0 0.387 0.031 0.769 0.094 1.147-0.478 0.15-0.934 0.359-1.356 0.622-0.822 0.513-1.5 1.231-1.966 2.078-0.506 0.922-0.762 1.984-0.762 3.153 0 1.322 0.516 2.556 1.456 3.478 1.028 1.009 2.472 1.55 4.062 1.522 0.531-0.009 1.441-0.15 2.306-0.403-0.466 2.112-1.866 3.403-3.825 3.403h-0.009v2h14v-2c-1.959 0-3.359-1.291-3.825-3.403 0.862 0.253 1.775 0.394 2.306 0.403 1.591 0.031 3.034-0.513 4.062-1.522zM14.694 16.241c-0.291-0.272-0.716-0.347-1.081-0.188s-0.603 0.519-0.603 0.919c0 2.031 0.559 3.769 1.616 5.031h-5.241c1.056-1.263 1.616-3 1.616-5.031 0-0.4-0.237-0.759-0.603-0.919s-0.791-0.084-1.081 0.188c-0.066 0.059-0.409 0.263-1.181 0.478-0.591 0.166-1.238 0.275-1.644 0.281-1.050 0.019-1.981-0.319-2.625-0.95-0.553-0.541-0.856-1.269-0.856-2.050 0-1.559 0.634-2.816 1.788-3.534 1.128-0.703 2.609-0.791 3.775-0.222l0.878-1.797c-0.728-0.356-1.541-0.55-2.372-0.575-0.050-0.284-0.075-0.578-0.075-0.872 0-2.756 2.244-5 5-5s5 2.244 5 5c0 0.294-0.025 0.584-0.075 0.872-0.828 0.025-1.638 0.219-2.362 0.575l0.878 1.797c1.166-0.569 2.647-0.481 3.775 0.222 1.153 0.719 1.788 1.975 1.788 3.534 0 0.781-0.303 1.509-0.856 2.050-0.644 0.631-1.575 0.969-2.625 0.95-0.406-0.006-1.050-0.119-1.644-0.281-0.778-0.216-1.122-0.419-1.188-0.478z" }),
_('path', { d: "M16 7c0-2.206-1.794-4-4-4v1c1.653 0 3 1.347 3 3h1z" })
            );
        }
        function Clubs2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Clubs2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Clubs2.SVG = Clubs2SVG;
        return Clubs2;
    })();
export const CodeCircle = /*#__PURE__*/ (() => {
        function CodeCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M8.5 9.794l-2.353 2.353c-0.194 0.194-0.194 0.513 0 0.706l2.353 2.353 0.706-0.706-2-2 2-2-0.706-0.706z" }),
_('path', { d: "M14.794 10.5l2 2-2 2 0.706 0.706 2.353-2.353c0.194-0.194 0.194-0.513 0-0.706l-2.353-2.353-0.706 0.706z" }),
_('path', { d: "M9.842 15.764l3.394-7.919 0.919 0.394-3.394 7.919-0.919-0.394z" })
            );
        }
        function CodeCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CodeCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CodeCircle.SVG = CodeCircleSVG;
        return CodeCircle;
    })();
export const CodeSquare = /*#__PURE__*/ (() => {
        function CodeSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M8.5 15.206l0.706-0.706-2-2 2-2-0.706-0.706-2.353 2.353c-0.194 0.194-0.194 0.513 0 0.706l2.353 2.353z" }),
_('path', { d: "M15.5 15.206l2.353-2.353c0.194-0.194 0.194-0.513 0-0.706l-2.353-2.353-0.706 0.706 2 2-2 2 0.706 0.706z" }),
_('path', { d: "M9.842 15.764l3.394-7.919 0.919 0.394-3.394 7.919-0.919-0.394z" })
            );
        }
        function CodeSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CodeSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CodeSquare.SVG = CodeSquareSVG;
        return CodeSquare;
    })();
export const Code = /*#__PURE__*/ (() => {
        function CodeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.706 12.294l-4.25-4.25-1.416 1.416 3.544 3.541-3.541 3.544 1.416 1.416 4.25-4.25c0.387-0.394 0.387-1.025-0.003-1.416z" }),
_('path', { d: "M4.544 8.044l-4.25 4.25c-0.391 0.391-0.391 1.025 0 1.416l4.25 4.25 1.416-1.416-3.544-3.544 3.544-3.544-1.416-1.413z" }),
_('path', { d: "M7.81 20.66l6.499-18.001 1.881 0.679-6.499 18.001-1.881-0.679z" })
            );
        }
        function Code({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CodeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Code.SVG = CodeSVG;
        return Code;
    })();
export const CoffeeBean = /*#__PURE__*/ (() => {
    function CoffeeBeanSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18.906 3.672c-1.581-2.403-3.969-3.672-6.906-3.672s-5.325 1.269-6.906 3.672c-1.369 2.081-2.094 4.962-2.094 8.328s0.725 6.247 2.094 8.328c1.581 2.403 3.969 3.672 6.906 3.672s5.325-1.269 6.906-3.672c1.369-2.081 2.094-4.962 2.094-8.328s-0.725-6.247-2.094-8.328zM6.766 19.228c-1.156-1.753-1.766-4.253-1.766-7.228s0.609-5.475 1.766-7.228c0.987-1.503 2.344-2.4 4.041-2.678-1.209 1.553-1.803 3.219-1.806 5.047-0.003 2.112 0.772 4.197 1.522 6.213 1.1 2.953 2.144 5.759 0.925 8.628-2-0.141-3.572-1.066-4.681-2.753zM11.116 3.387c-0.438 2.609 0.506 5.141 1.425 7.609 1.222 3.278 2.384 6.409 0.344 9.616 0.438-2.609-0.506-5.141-1.425-7.609-1.219-3.278-2.384-6.409-0.344-9.616zM17.234 19.228c-0.987 1.503-2.344 2.4-4.041 2.678 1.209-1.553 1.803-3.219 1.806-5.047 0.003-2.112-0.772-4.197-1.522-6.213-1.1-2.953-2.144-5.759-0.925-8.628 2 0.141 3.575 1.066 4.684 2.753 1.153 1.753 1.763 4.253 1.763 7.228s-0.609 5.475-1.766 7.228z" })
        );
    }
    function CoffeeBean({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CoffeeBeanSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CoffeeBean.SVG = CoffeeBeanSVG;
    return CoffeeBean;
})();
export const CoffeeMaker = /*#__PURE__*/ (() => {
    function CoffeeMakerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.853 4.147l-1-1c-0.094-0.094-0.222-0.147-0.353-0.147h-2.85l-2.875-1.916c-0.081-0.056-0.178-0.084-0.278-0.084h-0.5v-1h-2v1h-0.5c-0.1 0-0.194 0.028-0.278 0.084l-2.875 1.916h-0.844c-0.053 0-0.106 0.009-0.159 0.025l-3 1c-0.166 0.056-0.288 0.191-0.328 0.359s0.009 0.347 0.134 0.469l4 4c0.016 0.016 0.031 0.028 0.047 0.041l0.837 3.35c0.112 0.444 0.513 0.756 0.969 0.756v1h-1c-0.503 0-0.931 0.375-0.994 0.875l-1 8c-0.034 0.284 0.053 0.572 0.244 0.784s0.462 0.337 0.75 0.337h10c0.288 0 0.559-0.122 0.75-0.337s0.278-0.5 0.244-0.784l-1-8c-0.063-0.5-0.488-0.875-0.994-0.875h-1v-1c0.459 0 0.859-0.312 0.969-0.756l2-8c0.019-0.081 0.031-0.162 0.031-0.244h1.294l0.666 0.666-0.869 4.334h-1.091v1h1.5c0.237 0 0.444-0.169 0.491-0.403l1-5c0.031-0.162-0.019-0.331-0.138-0.45zM10.65 2h2.697l1.5 1h-5.697l1.5-1zM4.425 4.719l1.591-0.531c0.003 0.019 0.006 0.037 0.012 0.056l0.694 2.775-2.297-2.3zM15.869 22h-7.737l0.75-6h6.234l0.753 6zM14 14h-4v-1h4v1zM14.219 11h-4.437l-1.5-6h7.437l-1.5 6z" })
        );
    }
    function CoffeeMaker({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CoffeeMakerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CoffeeMaker.SVG = CoffeeMakerSVG;
    return CoffeeMaker;
})();
export const CoffeePot = /*#__PURE__*/ (() => {
        function CoffeePotSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.956 11.297l-4-9c-0.081-0.181-0.259-0.297-0.456-0.297h-3c-0.053 0-0.106 0.009-0.159 0.025l-2.897 0.966-8.887-0.987c-0.194-0.022-0.381 0.072-0.481 0.237s-0.097 0.375 0.012 0.537l1.838 2.759-0.869 1.741c-0.078 0.156-0.069 0.341 0.022 0.487s0.25 0.237 0.422 0.237c-0.072 0.044-0.147 0.084-0.216 0.125-0.934 0.537-2.213 1.272-3.297 2.484-1.319 1.475-1.987 3.288-1.987 5.388 0 1.625 0.528 2.969 1.569 4 2.009 1.988 5.225 2.003 5.438 2h4.994c0.003 0 0.009 0 0.016 0 0.322 0 3.45-0.050 5.422-2 1.034-1.031 1.563-2.375 1.563-4 0-2.1-0.669-3.912-1.984-5.391-1.084-1.216-2.362-1.95-3.297-2.484-0.069-0.041-0.144-0.081-0.216-0.125 0.172 0 0.331-0.091 0.422-0.237s0.1-0.331 0.022-0.488l-0.138-0.275h0.691c0.1 0 0.194-0.028 0.278-0.084l2.553-1.703 3.734 6.534c0.087 0.156 0.253 0.253 0.434 0.253h2c0.169 0 0.328-0.084 0.419-0.228 0.094-0.141 0.106-0.319 0.037-0.475zM6.309 7l0.5-1h5.381l0.5 1h-6.381zM5.512 3.116l7.222 0.803-0.544 1.081h-5.422l-1.256-1.884zM12.012 20v0c-0.003 0-0.006 0-0.012 0h-5c-0.003 0-0.006 0-0.009 0-0.025 0-2.591-0.012-4.016-1.422-0.656-0.65-0.975-1.494-0.975-2.578 0-0.659 0.081-1.247 0.228-1.775 2.353-0.731 4.638 0.462 7.041 1.719 1.394 0.728 2.834 1.481 4.303 1.837 0.594 0.144 1.166 0.216 1.719 0.216 0.438 0 0.863-0.044 1.281-0.134-0.144 0.259-0.322 0.494-0.537 0.709-1.425 1.416-3.966 1.428-4.022 1.428zM17 16c0 0.253-0.016 0.491-0.053 0.716-2.416 0.85-4.753-0.372-7.216-1.659-1.394-0.728-2.834-1.481-4.303-1.837-0.972-0.237-1.881-0.278-2.753-0.128 0.881-1.666 2.444-2.566 3.603-3.231 0.384-0.219 0.712-0.409 0.978-0.606 0.184-0.138 0.744-0.553 0.744-1.253h3c0 0.7 0.559 1.116 0.744 1.253 0.262 0.194 0.594 0.384 0.978 0.606 1.703 0.978 4.278 2.459 4.278 6.141zM21.791 11l-3.856-6.747c-0.069-0.122-0.184-0.206-0.319-0.237s-0.278-0.006-0.394 0.072l-2.875 1.916h-1.041l-0.25-0.5 0.797-1.591 2.728-0.912h2.594l3.556 8h-0.941z" }),
_('path', { d: "M11.834 11.65l0.428 0.259c1.734 1.050 2.737 2.056 2.737 4.094h1c0-1.212-0.309-2.213-0.944-3.056-0.625-0.831-1.503-1.422-2.278-1.891l-0.428-0.259-0.516 0.853z" })
            );
        }
        function CoffeePot({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CoffeePotSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CoffeePot.SVG = CoffeePotSVG;
        return CoffeePot;
    })();
export const ColorSampler = /*#__PURE__*/ (() => {
        function ColorSamplerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 5c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM15 8c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M23.9 12.2l-3.237-4.316-0.597-2.025c-0.016-0.053-0.038-0.1-0.066-0.141v-1.719c0-1.103-0.897-2-2-2h-16c-1.103 0-2 0.897-2 2v6c0 1.103 0.897 2 2 2h0.359l1.659 5.641c0.066 0.219 0.262 0.359 0.478 0.359 0.047 0 0.094-0.006 0.141-0.022l2.944-0.866 3.516 4.688c0.097 0.131 0.247 0.2 0.4 0.2 0.103 0 0.209-0.031 0.3-0.1l12-9c0.225-0.166 0.269-0.478 0.103-0.7zM2 4c0 0 0 0 0 0h16v6h-16v-6zM3.403 12h14.597c1.103 0 2-0.897 2-2v-0.828l0.878 2.988-16.041 4.719-1.434-4.878zM11.6 20.8l-2.991-3.987 13.031-3.834c0.128-0.038 0.234-0.125 0.297-0.241s0.078-0.253 0.041-0.381l-0.509-1.728 1.331 1.772-11.2 8.4z" })
            );
        }
        function ColorSampler({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ColorSamplerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ColorSampler.SVG = ColorSamplerSVG;
        return ColorSampler;
    })();
export const Combine = /*#__PURE__*/ (() => {
    function CombineSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21 8h-5v-5c0-1.103-0.897-2-2-2h-11c-1.103 0-2 0.897-2 2v11c0 1.103 0.897 2 2 2h5v5c0 1.103 0.897 2 2 2h11c1.103 0 2-0.897 2-2v-11c0-1.103-0.897-2-2-2zM21 21h-11v-6c0-0.553-0.447-1-1-1h-6v-11h11v6c0 0.553 0.447 1 1 1h6v11z" })
        );
    }
    function Combine({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CombineSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Combine.SVG = CombineSVG;
    return Combine;
})();
export const CommunicationCross = /*#__PURE__*/ (() => {
        function CommunicationCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 17c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM4 21c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M20 1c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM20 5c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M20 10v-1c-2.756 0-5-2.244-5-5h-1c0 3.309 2.691 6 6 6z" }),
_('path', { d: "M14.712 10.003c-1.725-1.522-2.712-3.7-2.712-6.003h-1c0 2.278 0.856 4.444 2.378 6.097-1.694 0.297-3.166 1.25-4.137 2.588-0.672-0.481-1.4-0.866-2.178-1.147-0.978-0.356-2.009-0.537-3.063-0.537v1c1.694 0 3.353 0.544 4.716 1.538-0.325 0.631-0.55 1.322-0.65 2.050-1.097-1.009-2.544-1.587-4.062-1.587v1c1.587 0 3.078 0.756 4.022 2.028 0.266 3.337 3.069 5.972 6.475 5.972 3.584 0 6.5-2.916 6.5-6.5 0-3.513-2.8-6.384-6.288-6.497zM14.5 22c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16.5 13.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function CommunicationCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CommunicationCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CommunicationCross.SVG = CommunicationCrossSVG;
        return CommunicationCross;
    })();
export const Communication = /*#__PURE__*/ (() => {
        function CommunicationSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 17c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM4 21c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M4 14v1c2.756 0 5 2.244 5 5h1c0-3.309-2.691-6-6-6z" }),
_('path', { d: "M4 11v1c4.413 0 8 3.588 8 8h1c0-2.403-0.938-4.666-2.637-6.363-1.697-1.7-3.959-2.637-6.363-2.637z" }),
_('path', { d: "M20 1c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM20 5c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M15 4h-1c0 3.309 2.691 6 6 6v-1c-2.756 0-5-2.244-5-5z" }),
_('path', { d: "M12 4h-1c0 2.403 0.938 4.666 2.637 6.363 1.697 1.7 3.959 2.637 6.363 2.637v-1c-4.413 0-8-3.588-8-8z" })
            );
        }
        function Communication({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CommunicationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Communication.SVG = CommunicationSVG;
        return Communication;
    })();
export const Compass = /*#__PURE__*/ (() => {
    function CompassSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.169 20.853l-3.409-7.853h2.241v-1h-2.675l-1.863-4.291c0.338-0.484 0.537-1.075 0.537-1.709 0-1.303-0.837-2.416-2-2.828v-3.172h-2v3.172c-1.163 0.412-2 1.525-2 2.828 0 0.634 0.197 1.225 0.537 1.709l-1.863 4.291h-2.675v1h2.241l-3.406 7.853 1.169 0.506v2.641h1v-3.119l3.416-7.881h5.159l3.422 7.881v3.119h1v-2.641l1.169-0.506zM12 4c1.103 0 2 0.897 2 2s-0.897 2-2 2c-1.103 0-2-0.897-2-2s0.897-2 2-2zM9.853 12l1.35-3.106c0.253 0.069 0.522 0.106 0.797 0.106s0.544-0.038 0.797-0.106l1.35 3.106h-4.294z" })
        );
    }
    function Compass({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CompassSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Compass.SVG = CompassSVG;
    return Compass;
})();
export const Compass2 = /*#__PURE__*/ (() => {
        function Compass2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M16.275 7.053l-6 3c-0.097 0.047-0.175 0.128-0.225 0.225l-3 6c-0.097 0.194-0.059 0.425 0.094 0.578 0.097 0.097 0.225 0.147 0.353 0.147 0.075 0 0.153-0.019 0.225-0.053l6-3c0.097-0.047 0.175-0.128 0.225-0.225l3-6c0.097-0.194 0.059-0.425-0.094-0.578s-0.384-0.191-0.578-0.094zM10.638 11.344l2.019 2.019-4.038 2.019 2.019-4.038zM13.362 12.656l-2.019-2.019 4.038-2.019-2.019 4.038z" })
            );
        }
        function Compass2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Compass2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Compass2.SVG = Compass2SVG;
        return Compass2;
    })();
export const Compass3 = /*#__PURE__*/ (() => {
        function Compass3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M17.853 6.147c-0.162-0.162-0.419-0.194-0.616-0.072l-13 8c-0.191 0.119-0.281 0.347-0.219 0.563 0.059 0.216 0.256 0.363 0.481 0.363h4.5v4.5c0 0.225 0.15 0.419 0.363 0.481 0.044 0.012 0.091 0.019 0.138 0.019 0.172 0 0.334-0.087 0.425-0.237l8-13c0.122-0.197 0.094-0.453-0.072-0.616zM10 17.734v-3.234c0-0.275-0.225-0.5-0.5-0.5h-3.234l9.706-5.975-5.972 9.709z" }),
_('path', { d: "M12 20v1c2.403 0 4.666-0.938 6.363-2.637 1.7-1.697 2.637-3.959 2.637-6.363h-1c0 4.413-3.588 8-8 8z" }),
_('path', { d: "M12 4v-1c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363h1c0-4.413 3.588-8 8-8z" })
            );
        }
        function Compass3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Compass3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Compass3.SVG = Compass3SVG;
        return Compass3;
    })();
export const Concave = /*#__PURE__*/ (() => {
        function ConcaveSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 12c0-3.288 0.344-6.394 0.966-8.744 0.091-0.338-0.003-0.694-0.244-0.947s-0.594-0.359-0.934-0.288c-2.944 0.631-6.775 0.978-10.788 0.978s-7.844-0.347-10.791-0.978c-0.341-0.072-0.694 0.037-0.934 0.288-0.237 0.253-0.331 0.609-0.241 0.947 0.622 2.35 0.966 5.456 0.966 8.744s-0.344 6.394-0.966 8.744c-0.091 0.337 0.003 0.694 0.244 0.947 0.191 0.2 0.453 0.309 0.725 0.309 0.069 0 0.141-0.006 0.209-0.022 2.944-0.631 6.775-0.978 10.788-0.978s7.844 0.347 10.791 0.978c0.341 0.072 0.694-0.038 0.934-0.288 0.241-0.253 0.331-0.609 0.244-0.947-0.625-2.35-0.969-5.456-0.969-8.744zM21.684 19.731c-2.819-0.475-6.191-0.731-9.684-0.731s-6.866 0.256-9.684 0.731c0.444-2.253 0.684-4.938 0.684-7.731s-0.241-5.478-0.684-7.731c2.819 0.475 6.191 0.731 9.684 0.731s6.866-0.256 9.684-0.731c-0.444 2.253-0.684 4.938-0.684 7.731s0.241 5.478 0.684 7.731z" }),
_('path', { d: "M20.231 5.694c-0.109-0.109-0.263-0.162-0.416-0.144-2.406 0.294-5.109 0.45-7.816 0.45s-5.409-0.156-7.816-0.453c-0.153-0.019-0.306 0.034-0.416 0.144s-0.159 0.266-0.141 0.419c0.247 1.853 0.372 3.837 0.372 5.891s-0.125 4.034-0.372 5.891c-0.022 0.153 0.031 0.306 0.141 0.419 0.109 0.109 0.262 0.162 0.416 0.144 2.406-0.297 5.109-0.453 7.816-0.453s5.409 0.156 7.816 0.453c0.022 0.003 0.041 0.003 0.063 0.003 0.131 0 0.259-0.053 0.356-0.147 0.109-0.109 0.159-0.266 0.141-0.419-0.25-1.853-0.375-3.837-0.375-5.891s0.125-4.038 0.372-5.891c0.019-0.153-0.031-0.306-0.141-0.416zM19.3 17.384c-2.281-0.253-4.791-0.384-7.3-0.384s-5.019 0.131-7.3 0.384c0.2-1.713 0.3-3.519 0.3-5.384s-0.1-3.675-0.3-5.384c2.281 0.253 4.791 0.384 7.3 0.384s5.019-0.131 7.3-0.384c-0.2 1.713-0.3 3.519-0.3 5.384s0.1 3.675 0.3 5.384z" })
            );
        }
        function Concave({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ConcaveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Concave.SVG = ConcaveSVG;
        return Concave;
    })();
export const Confused = /*#__PURE__*/ (() => {
        function ConfusedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M8.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM8.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M15.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM15.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M17.047 13.291c-0.753 1.647-1.478 2.553-2.15 2.691-0.697 0.141-1.466-0.559-2.281-1.303-0.963-0.878-2.053-1.875-3.369-1.644-1.122 0.197-2.134 1.225-3.188 3.234l-0.231 0.444 0.884 0.466 0.231-0.444c0.875-1.666 1.706-2.578 2.475-2.712 0.828-0.147 1.65 0.603 2.519 1.397 0.963 0.878 1.959 1.788 3.156 1.544 1.031-0.209 1.941-1.244 2.859-3.253l0.209-0.453-0.909-0.416-0.206 0.45z" })
            );
        }
        function Confused({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ConfusedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Confused.SVG = ConfusedSVG;
        return Confused;
    })();
export const ConnectionWarning = /*#__PURE__*/ (() => {
        function ConnectionWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 12h-4v-1h4.5c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672l-4-7.997c-0.25-0.506-0.775-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-1.584 3.172h-2.575v-2c0-1.103-0.897-2-2-2h-9c-1.103 0-2 0.897-2 2v5c0 1.103 0.897 2 2 2h1.319l-0.306 1.834c-0.047 0.291 0.034 0.588 0.222 0.809s0.469 0.353 0.762 0.353h5c0.294 0 0.572-0.128 0.762-0.353s0.272-0.522 0.222-0.809l-0.306-1.834h1.325c1.103 0 2-0.897 2-2v-2h2.075l-1.913 3.828c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h2.5v1h-4.003c-1.103 0-2 0.897-2 2v5c0 1.103 0.897 2 2 2h1.319l-0.306 1.834c-0.047 0.291 0.034 0.588 0.222 0.809 0.191 0.225 0.469 0.353 0.762 0.353h5c0.294 0 0.572-0.128 0.762-0.353s0.272-0.522 0.222-0.809l-0.306-1.834h1.325c1.103 0 2-0.897 2-2v-5c0-1.103-0.897-2-2-2zM7.988 11h-2.972l0.334-2h2.306l0.331 2zM11 7h-9v-5h9v5c0 0 0 0 0 0zM14 9.5c0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5h-8c-0.275 0-0.5-0.225-0.5-0.5zM18.987 23h-2.972l0.334-2h2.306l0.331 2zM22 19h-9v-5h9v5c0 0 0 0 0 0z" }),
_('path', { d: "M18 8h1v1h-1v-1z" }),
_('path', { d: "M18 3h1v4h-1v-4z" })
            );
        }
        function ConnectionWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ConnectionWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ConnectionWarning.SVG = ConnectionWarningSVG;
        return ConnectionWarning;
    })();
export const Connection = /*#__PURE__*/ (() => {
    function ConnectionSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 12h-4v-7.5c0-0.275-0.225-0.5-0.5-0.5h-4.5v-2c0-1.103-0.897-2-2-2h-9c-1.103 0-2 0.897-2 2v5c0 1.103 0.897 2 2 2h1.319l-0.306 1.834c-0.047 0.291 0.034 0.588 0.222 0.809s0.469 0.353 0.762 0.353h5c0.294 0 0.572-0.128 0.762-0.353s0.272-0.522 0.222-0.809l-0.306-1.834h1.325c1.103 0 2-0.897 2-2v-2h4v7h-4c-1.103 0-2 0.897-2 2v5c0 1.103 0.897 2 2 2h1.319l-0.306 1.834c-0.047 0.291 0.034 0.588 0.222 0.809 0.191 0.225 0.469 0.353 0.762 0.353h5c0.294 0 0.572-0.128 0.762-0.353s0.272-0.522 0.222-0.809l-0.306-1.834h1.325c1.103 0 2-0.897 2-2v-5c0-1.103-0.897-2-2-2zM7.988 11h-2.972l0.334-2h2.306l0.331 2zM11 7h-9v-5h9v5c0 0 0 0 0 0zM18.987 23h-2.972l0.334-2h2.306l0.331 2zM22 19h-9v-5h9v5c0 0 0 0 0 0z" })
        );
    }
    function Connection({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ConnectionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Connection.SVG = ConnectionSVG;
    return Connection;
})();
export const ConstructionCone = /*#__PURE__*/ (() => {
    function ConstructionConeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.5 21h-1.597l-5-18.759c0-0.006-0.003-0.012-0.003-0.016-0.35-1.309-1.544-2.225-2.9-2.225s-2.55 0.916-2.9 2.225c0 0.006-0.003 0.012-0.003 0.016l-5 18.759h-1.597c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h19c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5zM14.634 9h-5.269l0.534-2h4.203l0.531 2zM14.9 10l1.066 4h-7.931l1.066-4h5.8zM16.234 15l0.534 2h-9.531l0.534-2h8.463zM11.037 2.728c0.119-0.428 0.513-0.728 0.963-0.728s0.844 0.3 0.963 0.728c0 0.003 0.003 0.006 0.003 0.012l0.869 3.259h-3.669l0.869-3.259c0-0.003 0-0.006 0.003-0.012zM6.969 18h10.062l0.8 3h-11.663l0.8-3zM21.5 23h-19c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h19c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5z" })
        );
    }
    function ConstructionCone({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ConstructionConeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ConstructionCone.SVG = ConstructionConeSVG;
    return ConstructionCone;
})();
export const Construction = /*#__PURE__*/ (() => {
    function ConstructionSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 5h-1.269c0.172-0.294 0.269-0.638 0.269-1 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 0.363 0.097 0.706 0.269 1h-10.537c0.172-0.294 0.269-0.638 0.269-1 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 0.363 0.097 0.706 0.269 1h-1.269c-1.103 0-2 0.897-2 2v7c0 1.103 0.897 2 2 2h1.834l-0.769 5h-1.066v1h4v-1h-0.912l0.306-2h13.206l0.306 2h-0.906v1h4v-1h-1.066l-0.769-5h1.834c1.103 0 2-0.897 2-2v-7c0-1.103-0.897-2-2-2zM22 8.584l-5.416 5.416h-3.169l7-7h1.584v1.584zM6.416 14l7-7h4.172l-7 7h-4.172zM18 4c0-0.55 0.45-1 1-1s1 0.45 1 1-0.45 1-1 1-1-0.45-1-1zM4 4c0-0.55 0.45-1 1-1s1 0.45 1 1-0.45 1-1 1-1-0.45-1-1zM4.584 7l-2.584 2.584v-2.584h2.584zM2 12.416l5.416-5.416h3.172l-7 7h-1.587v-1.584zM18.45 18h-12.9l0.306-2h12.284l0.309 2zM22 14h-2.584l2.587-2.587-0.003 2.587c0 0 0 0 0 0z" })
        );
    }
    function Construction({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ConstructionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Construction.SVG = ConstructionSVG;
    return Construction;
})();
export const Contacts = /*#__PURE__*/ (() => {
        function ContactsSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 0h-13c-1.103 0-2 0.897-2 2v1h-1v1h1v3h-1v1h1v3h-1v1h1v3h-1v1h1v3h-1v1h1v2c0 1.103 0.897 2 2 2h13c2.206 0 4-1.794 4-4v-16c0-2.206-1.794-4-4-4zM20 20c0 1.103-0.897 2-2 2h-13v-2h1v-1h-1v-3h1v-1h-1v-3h1v-1h-1v-3h1v-1h-1v-3h1v-1h-1v-1h13c1.103 0 2 0.897 2 2v16z" }),
_('path', { d: "M14.456 13.4c0.931-0.628 1.544-1.694 1.544-2.9 0-1.931-1.569-3.5-3.5-3.5s-3.5 1.569-3.5 3.5c0 1.206 0.612 2.269 1.541 2.9-0.85 0.338-1.725 0.909-2.434 1.788-0.094 0.116-0.128 0.266-0.1 0.409s0.119 0.269 0.25 0.341c1.294 0.716 2.681 1.062 4.241 1.062 1.566 0 2.953-0.347 4.244-1.062 0.128-0.072 0.219-0.197 0.247-0.341s-0.009-0.294-0.1-0.409c-0.709-0.878-1.584-1.45-2.431-1.788zM10 10.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5c0 1.347-1.069 2.447-2.403 2.497-0.034 0-0.066 0-0.1 0-0.031 0-0.063 0-0.097 0-1.331-0.050-2.4-1.15-2.4-2.497zM12.497 16c-1.178 0-2.203-0.209-3.184-0.65 0.994-0.95 2.222-1.325 3.084-1.35 0.034 0 0.069 0 0.103 0s0.066 0 0.1 0c0.862 0.028 2.091 0.4 3.081 1.35-0.975 0.438-2.022 0.65-3.184 0.65z" })
            );
        }
        function Contacts({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ContactsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Contacts.SVG = ContactsSVG;
        return Contacts;
    })();
export const Contrast = /*#__PURE__*/ (() => {
        function ContrastSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.656 6.344c-1.512-1.512-3.519-2.344-5.656-2.344s-4.147 0.831-5.656 2.344-2.344 3.519-2.344 5.656c0 2.138 0.831 4.147 2.344 5.656 1.512 1.512 3.519 2.344 5.656 2.344s4.147-0.831 5.656-2.344c1.512-1.512 2.344-3.519 2.344-5.656s-0.831-4.147-2.344-5.656zM12 18c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z" }),
_('path', { d: "M15.716 8.653c-0.822-0.912-1.944-1.491-3.159-1.622-0.141-0.016-0.281 0.031-0.387 0.125s-0.166 0.231-0.166 0.372v8.944c0 0.144 0.059 0.278 0.166 0.372 0.091 0.081 0.213 0.128 0.334 0.128 0.019 0 0.038 0 0.056-0.003 2.534-0.281 4.444-2.419 4.444-4.969-0.003-1.238-0.459-2.428-1.287-3.347zM13 15.875v-7.75c1.744 0.444 3 2.022 3 3.875 0 1.85-1.256 3.428-3 3.875z" })
            );
        }
        function Contrast({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ContrastSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Contrast.SVG = ContrastSVG;
        return Contrast;
    })();
export const Convex = /*#__PURE__*/ (() => {
        function ConvexSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.709 4.137c-0.106-0.269-0.322-0.481-0.594-0.578-2.784-1.006-6.375-1.559-10.116-1.559s-7.331 0.553-10.119 1.559c-0.272 0.097-0.487 0.309-0.594 0.578-0.828 2.138-1.287 4.931-1.287 7.863s0.459 5.725 1.291 7.863c0.106 0.269 0.322 0.481 0.594 0.578 2.784 1.006 6.375 1.559 10.116 1.559s7.331-0.553 10.119-1.559c0.272-0.097 0.488-0.309 0.594-0.578 0.828-2.137 1.287-4.931 1.287-7.863s-0.459-5.725-1.291-7.863zM21.003 18.709c-2.509 0.834-5.684 1.291-9.003 1.291s-6.494-0.456-9.003-1.291c-0.644-1.856-0.997-4.216-0.997-6.709s0.353-4.853 0.997-6.709c2.509-0.834 5.684-1.291 9.003-1.291s6.494 0.456 9.003 1.291c0.644 1.856 0.997 4.216 0.997 6.709s-0.353 4.853-0.997 6.709z" }),
_('path', { d: "M19.947 6.012c-2.291-0.653-5.112-1.013-7.947-1.013s-5.656 0.359-7.947 1.013c-0.166 0.047-0.297 0.178-0.344 0.344-0.466 1.634-0.709 3.584-0.709 5.644s0.244 4.009 0.709 5.644c0.047 0.166 0.178 0.297 0.344 0.344 2.291 0.653 5.112 1.013 7.947 1.013s5.656-0.359 7.947-1.013c0.166-0.047 0.297-0.178 0.344-0.344 0.466-1.634 0.709-3.584 0.709-5.644s-0.244-4.009-0.709-5.644c-0.047-0.169-0.178-0.297-0.344-0.344zM19.403 17.103c-2.153 0.578-4.769 0.897-7.403 0.897s-5.25-0.319-7.403-0.897c-0.391-1.491-0.597-3.25-0.597-5.103s0.206-3.612 0.597-5.103c2.153-0.578 4.769-0.897 7.403-0.897s5.25 0.319 7.403 0.897c0.391 1.491 0.597 3.25 0.597 5.103s-0.206 3.612-0.597 5.103z" })
            );
        }
        function Convex({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ConvexSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Convex.SVG = ConvexSVG;
        return Convex;
    })();
export const Conveyor = /*#__PURE__*/ (() => {
        function ConveyorSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 6.706v3.294h1v-3.294l0.5 0.5 0.706-0.706-1.353-1.353c-0.194-0.194-0.513-0.194-0.706 0l-1.353 1.353 0.706 0.706 0.5-0.5z" }),
_('path', { d: "M10 6.706v3.294h1v-3.294l0.5 0.5 0.706-0.706-1.353-1.353c-0.194-0.194-0.513-0.194-0.706 0l-1.353 1.353 0.706 0.706 0.5-0.5z" }),
_('path', { d: "M4 11h9v1h-9v-1z" }),
_('path', { d: "M20 16h-19.5c-0.275 0-0.5 0.225-0.5 0.5v7c0 0.275 0.225 0.5 0.5 0.5h19.5c2.206 0 4-1.794 4-4s-1.794-4-4-4zM20 22h-19v-4h19c1.103 0 2 0.897 2 2s-0.897 2-2 2z" }),
_('path', { d: "M19 19c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM19 20c0 0 0 0 0 0v0z" }),
_('path', { d: "M15 19c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM15 20c0 0 0 0 0 0v0z" }),
_('path', { d: "M11 19c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM11 20c0 0 0 0 0 0v0z" }),
_('path', { d: "M7 19c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM7 20c0 0 0 0 0 0v0z" }),
_('path', { d: "M3 19c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM3 20c0 0 0 0 0 0v0z" }),
_('path', { d: "M21.794 9.5l0.706 0.706 1.353-1.353c0.194-0.194 0.194-0.513 0-0.706l-1.353-1.353-0.706 0.706 0.5 0.5h-4.294v1h4.294l-0.5 0.5z" }),
_('path', { d: "M0.5 4h0.5v9c0 1.103 0.897 2 2 2h11c1.103 0 2-0.897 2-2v-9h0.5c0.275 0 0.5-0.225 0.5-0.5v-1.5c0-1.103-0.897-2-2-2h-13c-1.103 0-2 0.897-2 2v1.5c0 0.275 0.225 0.5 0.5 0.5zM14 13h-11v-9h11v9zM2 2h13v1h-13v-1z" })
            );
        }
        function Conveyor({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ConveyorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Conveyor.SVG = ConveyorSVG;
        return Conveyor;
    })();
export const Cool = /*#__PURE__*/ (() => {
        function CoolSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM3.141 8.956c0.128-0.6 0.634-0.956 1.359-0.956h15c0.725 0 1.231 0.356 1.359 0.956 0.106 0.5-0.066 1.091-0.481 1.669-0.528 0.731-1.422 1.391-2.581 1.903-2.444 1.087-3.075 0.112-3.803-1.013-0.459-0.709-0.981-1.516-1.994-1.516s-1.534 0.806-1.994 1.516c-0.728 1.125-1.359 2.1-3.803 1.013-1.159-0.516-2.050-1.175-2.581-1.903-0.416-0.578-0.588-1.169-0.481-1.669zM12 2c3.841 0 7.181 2.175 8.856 5.356-0.378-0.228-0.841-0.356-1.356-0.356h-15c-0.516 0-0.978 0.128-1.356 0.356 1.675-3.181 5.016-5.356 8.856-5.356zM12 22c-5.512 0-10-4.488-10-10 0-0.697 0.072-1.375 0.206-2.031 0.109 0.416 0.312 0.837 0.606 1.241 0.631 0.872 1.662 1.644 2.984 2.231 1.406 0.625 2.525 0.722 3.416 0.297 0.787-0.375 1.238-1.069 1.634-1.681 0.438-0.675 0.706-1.059 1.153-1.059s0.716 0.381 1.153 1.059c0.397 0.612 0.847 1.306 1.634 1.681 0.363 0.172 0.762 0.259 1.203 0.259 0.644 0 1.378-0.184 2.212-0.556 1.319-0.588 2.353-1.359 2.984-2.231 0.291-0.403 0.497-0.822 0.606-1.241 0.134 0.656 0.206 1.334 0.206 2.031 0 5.512-4.488 10-10 10z" }),
_('path', { d: "M12 19v1c1.522 0 3.009-0.453 4.297-1.309 1.231-0.819 2.225-1.959 2.875-3.303l-0.9-0.438c-1.191 2.463-3.653 4.050-6.272 4.050z" })
            );
        }
        function Cool({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CoolSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cool.SVG = CoolSVG;
        return Cool;
    })();
export const Coolant = /*#__PURE__*/ (() => {
        function CoolantSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1.141 11.594c0.656-1.628 1.503-3.213 2.325-4.741 1.178-2.2 2.294-4.281 2.547-5.997 0.072-0.494 0.491-0.856 0.987-0.856 0 0 0 0 0 0 0.497 0 0.916 0.363 0.991 0.853 0.253 1.716 1.366 3.794 2.547 5.994 0.822 1.531 1.669 3.116 2.325 4.744 0.766 1.909 1.137 3.584 1.137 5.122 0 4.016-3.141 7.284-7 7.284s-7-3.269-7-7.284c0-1.538 0.372-3.213 1.141-5.119zM7 21.997c2.756 0 5-2.372 5-5.284 0-2.897-1.641-5.959-3.228-8.919-0.647-1.203-1.272-2.375-1.772-3.506-0.5 1.131-1.128 2.303-1.775 3.509-1.584 2.959-3.225 6.019-3.225 8.916 0 2.913 2.244 5.284 5 5.284z" }),
_('path', { d: "M7 21c-2.206 0-4-1.922-4-4.284v-0.716h1v0.716c0 1.812 1.347 3.284 3 3.284v1z" }),
_('path', { d: "M17.134 6h-2.428l-1.206 1.206-0.706-0.706 1-1-1-1 0.706-0.706 1.206 1.206h2.428l-1.212-2.103-1.65-0.441 0.259-0.966 1.366 0.366 0.366-1.366 0.966 0.259-0.441 1.647 1.212 2.103 1.212-2.103-0.441-1.647 0.966-0.259 0.366 1.366 1.366-0.366 0.259 0.966-1.65 0.441-1.212 2.103h2.428l1.206-1.206 0.706 0.706-1 1 1 1-0.706 0.706-1.206-1.206h-2.428l1.212 2.103 1.65 0.441-0.259 0.966-1.366-0.366-0.366 1.366-0.966-0.259 0.441-1.647-1.212-2.103-1.212 2.103 0.441 1.647-0.966 0.259-0.366-1.366-1.366 0.366-0.259-0.966 1.65-0.441z" })
            );
        }
        function Coolant({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CoolantSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Coolant.SVG = CoolantSVG;
        return Coolant;
    })();
export const Cosine = /*#__PURE__*/ (() => {
    function CosineSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.853 13.147l-1.353-1.353-0.706 0.706 0.5 0.5h-5.328c0.428-1.287 0.875-2.55 1.388-3.491 0.825-1.509 1.444-1.509 1.647-1.509v-2c-0.75 0-1.444 0.269-2.063 0.8-0.484 0.416-0.922 0.987-1.341 1.753-0.681 1.25-1.219 2.866-1.737 4.447h-6.722c-0.519-1.581-1.056-3.197-1.737-4.447-0.416-0.766-0.856-1.338-1.341-1.753-0.619-0.531-1.313-0.8-2.063-0.8v-3.294l0.5 0.5 0.709-0.706-1.353-1.353c-0.194-0.194-0.513-0.194-0.706 0l-1.353 1.353 0.706 0.706 0.5-0.5v20.294h1v-9h3.363c0.519 1.581 1.056 3.197 1.737 4.447 0.416 0.766 0.856 1.338 1.341 1.753 0.619 0.531 1.313 0.8 2.063 0.8s1.444-0.269 2.063-0.8c0.484-0.416 0.922-0.987 1.341-1.753 0.681-1.25 1.219-2.866 1.737-4.447h5.653l-0.5 0.5 0.706 0.706 1.353-1.353c0.194-0.194 0.194-0.513-0.003-0.706zM3 8c0.203 0 0.822 0 1.647 1.509 0.513 0.941 0.959 2.203 1.388 3.491h-3.034v-5zM13.147 17.491c-0.825 1.509-1.444 1.509-1.647 1.509s-0.822 0-1.647-1.509c-0.513-0.941-0.959-2.203-1.388-3.491h6.066c-0.425 1.287-0.872 2.55-1.384 3.491z" })
        );
    }
    function Cosine({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CosineSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cosine.SVG = CosineSVG;
    return Cosine;
})();
export const Couch = /*#__PURE__*/ (() => {
        function CouchSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.806 10.128c-0.5-0.497-1.122-0.837-1.806-1.006v-1.122c0-1.869-0.728-3.628-2.050-4.95s-3.081-2.050-4.95-2.050h-4c-1.869 0-3.628 0.728-4.95 2.050s-2.050 3.081-2.050 4.95v1.119c-0.684 0.169-1.303 0.513-1.806 1.009-0.769 0.762-1.194 1.825-1.194 2.997 0 0.869 0.275 1.747 0.769 2.466 0.344 0.5 0.766 0.881 1.231 1.122v4.287c0 1.103 0.897 2 2 2h3c0.553 0 1-0.447 1-1h8c0 0.553 0.447 1 1 1h3c1.103 0 2-0.897 2-2v-4.287c0.466-0.241 0.888-0.622 1.231-1.122 0.497-0.719 0.769-1.597 0.769-2.466 0-1.172-0.425-2.234-1.194-2.997zM6 21h-2v-5h1v-1h-1.916c-0.5-0.116-1.084-0.972-1.084-1.875 0-0.641 0.209-1.188 0.6-1.575 0.359-0.356 0.853-0.55 1.397-0.55 0.009 0 0.016 0 0.025 0 1.091 0.012 1.978 0.925 1.978 2.037v7.962zM16 18h-8v-2.5c0-0.828 0.672-1.5 1.5-1.5h5c0.828 0 1.5 0.672 1.5 1.5v2.5zM8 20v-1h8v1h-8zM17.147 10.209c-0.741 0.762-1.147 1.766-1.147 2.828v0.462c-0.419-0.316-0.938-0.5-1.5-0.5h-5c-0.563 0-1.081 0.188-1.5 0.5v-0.462c0-1.062-0.406-2.066-1.147-2.828-0.519-0.531-1.156-0.903-1.853-1.084v-1.125c0-2.756 2.244-5 5-5h4c2.756 0 5 2.244 5 5v1.128c-0.697 0.178-1.334 0.55-1.853 1.081zM20.916 15h-1.916v1h1v5h-2v-7.962c0-1.113 0.888-2.025 1.978-2.037 0.009 0 0.016 0 0.025 0 0.544 0 1.038 0.194 1.397 0.55 0.391 0.387 0.6 0.934 0.6 1.575 0 0.903-0.584 1.759-1.084 1.875z" }),
_('path', { d: "M12 5c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 6c0 0 0 0 0 0v0z" }),
_('path', { d: "M9 7c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM9 8c0 0 0 0 0 0v0z" }),
_('path', { d: "M15 7c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM15 8c0 0 0 0 0 0v0z" }),
_('path', { d: "M12 9c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 10c0 0 0 0 0 0v0z" })
            );
        }
        function Couch({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CouchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Couch.SVG = CouchSVG;
        return Couch;
    })();
export const CpuX64 = /*#__PURE__*/ (() => {
        function CpuX64SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 8v-1h-3v-1c0-1.653-1.347-3-3-3h-1v-3h-1v3h-2v-3h-1v3h-2v-3h-1v3h-2v-3h-1v3h-1c-1.653 0-3 1.347-3 3v1h-3v1h3v2h-3v1h3v2h-3v1h3v2h-3v1h3v1c0 1.653 1.347 3 3 3h1v3h1v-3h2v3h1v-3h2v3h1v-3h2v3h1v-3h1c1.653 0 3-1.347 3-3v-1h3v-1h-3v-2h3v-1h-3v-2h3v-1h-3v-2h3zM19 18c0 0.55-0.45 1-1 1h-12c-0.55 0-1-0.45-1-1v-12c0-0.55 0.45-1 1-1h12c0.55 0 1 0.45 1 1v12z" }),
_('path', { d: "M16 6c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM16 9c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M8.5 13.794l-1 1-1-1-0.706 0.706 1 1-1 1 0.706 0.706 1-1 1 1 0.706-0.706-1-1 1-1z" }),
_('path', { d: "M16 16h-0.806l0.938-2.816-0.95-0.316-1.159 3.475c-0.050 0.153-0.025 0.319 0.069 0.45s0.244 0.206 0.406 0.206h1.5v1h1v-3h-1v1z" }),
_('path', { d: "M10.847 14.059c-0.547 0.656-0.847 1.522-0.847 2.441 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5c-0.034 0-0.069 0-0.1 0.003 0.366-0.609 0.947-1.003 1.6-1.003v-1c-0.819 0-1.584 0.375-2.153 1.059zM11.5 16c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" })
            );
        }
        function CpuX64({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CpuX64SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CpuX64.SVG = CpuX64SVG;
        return CpuX64;
    })();
export const CpuX86 = /*#__PURE__*/ (() => {
        function CpuX86SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 8v-1h-3v-1c0-1.653-1.347-3-3-3h-1v-3h-1v3h-2v-3h-1v3h-2v-3h-1v3h-2v-3h-1v3h-1c-1.653 0-3 1.347-3 3v1h-3v1h3v2h-3v1h3v2h-3v1h3v2h-3v1h3v1c0 1.653 1.347 3 3 3h1v3h1v-3h2v3h1v-3h2v3h1v-3h2v3h1v-3h1c1.653 0 3-1.347 3-3v-1h3v-1h-3v-2h3v-1h-3v-2h3v-1h-3v-2h3zM19 18c0 0.55-0.45 1-1 1h-12c-0.55 0-1-0.45-1-1v-12c0-0.55 0.45-1 1-1h12c0.55 0 1 0.45 1 1v12z" }),
_('path', { d: "M16 6c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM16 9c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M8.5 13.794l-1 1-1-1-0.706 0.706 1 1-1 1 0.706 0.706 1-1 1 1 0.706-0.706-1-1 1-1z" }),
_('path', { d: "M14.847 14.059c-0.547 0.656-0.847 1.522-0.847 2.441 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5c-0.034 0-0.069 0-0.1 0.003 0.366-0.609 0.947-1.003 1.6-1.003v-1c-0.819 0-1.584 0.375-2.153 1.059zM15.5 16c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M11.5 13c-0.828 0-1.5 0.672-1.5 1.5 0 0.384 0.144 0.734 0.384 1-0.237 0.266-0.384 0.616-0.384 1 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.384-0.144-0.734-0.384-1 0.237-0.266 0.384-0.616 0.384-1 0-0.828-0.672-1.5-1.5-1.5zM11.5 14c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM11.5 17c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" })
            );
        }
        function CpuX86({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CpuX86SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CpuX86.SVG = CpuX86SVG;
        return CpuX86;
    })();
export const Cpu = /*#__PURE__*/ (() => {
        function CpuSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 8v-1h-3v-1c0-1.653-1.347-3-3-3h-1v-3h-1v3h-2v-3h-1v3h-2v-3h-1v3h-2v-3h-1v3h-1c-1.653 0-3 1.347-3 3v1h-3v1h3v2h-3v1h3v2h-3v1h3v2h-3v1h3v1c0 1.653 1.347 3 3 3h1v3h1v-3h2v3h1v-3h2v3h1v-3h2v3h1v-3h1c1.653 0 3-1.347 3-3v-1h3v-1h-3v-2h3v-1h-3v-2h3v-1h-3v-2h3zM19 18c0 0.55-0.45 1-1 1h-12c-0.55 0-1-0.45-1-1v-12c0-0.55 0.45-1 1-1h12c0.55 0 1 0.45 1 1v12z" }),
_('path', { d: "M16 6c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM16 9c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
            );
        }
        function Cpu({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CpuSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cpu.SVG = CpuSVG;
        return Cpu;
    })();
export const CropRotate = /*#__PURE__*/ (() => {
        function CropRotateSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 10c0-1.103-0.897-2-2-2h-4v-3h-1v3h-4v2h4v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v4h2v-4h3v-1h-3v-4zM10 14v-4h4v4h-4z" }),
_('path', { d: "M22 0v3.059c-0.725-0.647-1.525-1.209-2.384-1.666-1.716-0.912-3.659-1.394-5.616-1.394h-3v2h3c2.703 0 5.275 1.1 7.141 3h-4.141v2h6c0.553 0 1-0.447 1-1v-6h-2z" }),
_('path', { d: "M2.859 19h4.141v-2h-6c-0.553 0-1 0.447-1 1v6h2v-3.059c0.725 0.647 1.525 1.209 2.384 1.666 1.719 0.912 3.659 1.394 5.616 1.394h3v-2h-3c-2.703 0-5.275-1.1-7.141-3z" })
            );
        }
        function CropRotate({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CropRotateSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CropRotate.SVG = CropRotateSVG;
        return CropRotate;
    })();
export const Crop = /*#__PURE__*/ (() => {
        function CropSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 6h-16v2h16v16h2v-16c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M6 0h1v5h-1v-5z" }),
_('path', { d: "M7 9h-1v8.5c0 0.275 0.225 0.5 0.5 0.5h8.5v-1h-8v-8z" }),
_('path', { d: "M19 17h5v1h-5v-1z" })
            );
        }
        function Crop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CropSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Crop.SVG = CropSVG;
        return Crop;
    })();
export const Crop2 = /*#__PURE__*/ (() => {
        function Crop2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.5 5h-18c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5h13.5v13.5c0 0.275 0.225 0.5 0.5 0.5h4c0.275 0 0.5-0.225 0.5-0.5v-18c0-0.275-0.225-0.5-0.5-0.5zM18 23h-3v-1h2v-1h-2v-1h1v-1h-1v-1h1v-1h-1v-1h2v-1h-2v-1h1v-1h-1v-1h1v-1h-1v-1h2v-1h-2v-2h-1v2h-1v-1h-1v1h-1v-1h-1v1h-1v-2h-1v2h-1v-1h-1v1h-1v-1h-1v1h-1v-2h-1v2h-1v-3h17v17z" }),
_('path', { d: "M5 0h2v4h-2v-4z" }),
_('path', { d: "M7 11h-2v6c0 1.103 0.897 2 2 2h6v-2h-6v-6z" }),
_('path', { d: "M20 17h4v2h-4v-2z" })
            );
        }
        function Crop2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Crop2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Crop2.SVG = Crop2SVG;
        return Crop2;
    })();
export const CrossCircle = /*#__PURE__*/ (() => {
        function CrossCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M15.537 7.050l-3.537 3.534-3.537-3.534-1.413 1.413 3.534 3.537-3.534 3.537 1.413 1.413 3.537-3.534 3.537 3.534 1.413-1.413-3.534-3.537 3.534-3.537z" })
            );
        }
        function CrossCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CrossCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CrossCircle.SVG = CrossCircleSVG;
        return CrossCircle;
    })();
export const CrossCircle2 = /*#__PURE__*/ (() => {
        function CrossCircle2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M14.538 8.050l-2.538 2.534-2.538-2.534-1.413 1.413 2.534 2.538-2.534 2.538 1.413 1.413 2.538-2.534 2.538 2.534 1.413-1.413-2.534-2.538 2.534-2.538z" })
            );
        }
        function CrossCircle2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CrossCircle2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CrossCircle2.SVG = CrossCircle2SVG;
        return CrossCircle2;
    })();
export const CrossSquare = /*#__PURE__*/ (() => {
        function CrossSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M8.456 16.956l3.544-3.541 3.537 3.534 1.413-1.413-3.534-3.537 3.541-3.544-1.413-1.413-3.544 3.541-3.537-3.534-1.413 1.413 3.534 3.537-3.541 3.544z" })
            );
        }
        function CrossSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CrossSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CrossSquare.SVG = CrossSquareSVG;
        return CrossSquare;
    })();
export const CrossSquare2 = /*#__PURE__*/ (() => {
        function CrossSquare2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M9.462 15.95l2.538-2.534 2.538 2.534 1.413-1.413-2.534-2.538 2.534-2.538-1.413-1.413-2.538 2.534-2.538-2.534-1.413 1.413 2.534 2.538-2.534 2.538z" })
            );
        }
        function CrossSquare2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CrossSquare2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CrossSquare2.SVG = CrossSquare2SVG;
        return CrossSquare2;
    })();
export const Cross = /*#__PURE__*/ (() => {
    function CrossSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.956 4.456l-1.413-1.413-7.544 7.541-7.544-7.541-1.413 1.413 7.541 7.544-7.541 7.544 1.413 1.413 7.544-7.541 7.544 7.541 1.413-1.413-7.541-7.544z" })
        );
    }
    function Cross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cross.SVG = CrossSVG;
    return Cross;
})();
export const Crown = /*#__PURE__*/ (() => {
        function CrownSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.306 0.094 0.594 0.253 0.831-0.119 0.109-0.234 0.219-0.35 0.328-1.597 1.497-2.706 2.538-4.512 3.175-1.075-1.563-2.122-3.672-3.122-6.288 0.447-0.369 0.731-0.925 0.731-1.547 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 0.622 0.284 1.178 0.731 1.544-1 2.616-2.047 4.725-3.122 6.288-1.806-0.638-2.916-1.678-4.512-3.175-0.116-0.106-0.231-0.216-0.35-0.328 0.159-0.234 0.253-0.522 0.253-0.828 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.653 0.419 1.209 1.003 1.416-0.012 0.144 0.006 0.294 0.063 0.438 1.062 2.813 1.734 5.859 1.941 8.647h-1.006v2h1.072c-0.003 0.366-0.019 0.725-0.041 1.075-0.6 0.197-1.031 0.762-1.031 1.425 0 0.828 0.672 1.5 1.5 1.5h17c0.828 0 1.5-0.672 1.5-1.5 0-0.663-0.431-1.228-1.028-1.425-0.022-0.35-0.038-0.709-0.041-1.075h1.069v-2h-1.006c0.206-2.787 0.878-5.834 1.941-8.647 0.053-0.144 0.072-0.294 0.063-0.438 0.584-0.206 1.003-0.762 1.003-1.416zM12 2c0.55 0 1 0.45 1 1s-0.45 1-1 1c-0.55 0-1-0.45-1-1s0.45-1 1-1zM1.5 6c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM20.5 22h-17c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h17c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5zM18.963 20h-13.925c0.019-0.328 0.028-0.659 0.031-1h13.859c0.006 0.341 0.016 0.672 0.034 1zM5.009 17c-0.131-1.891-0.459-3.888-0.969-5.862 1.034 0.781 2.169 1.406 3.697 1.825 0.394 0.109 0.816-0.034 1.062-0.359 1.128-1.488 2.184-3.413 3.203-5.847 1.019 2.434 2.075 4.359 3.203 5.847 0.247 0.325 0.666 0.469 1.062 0.359 1.528-0.419 2.662-1.044 3.697-1.825-0.509 1.972-0.841 3.972-0.969 5.862h-13.988zM22.5 7c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M11 15.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M14 15.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M17 15.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M8 15.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M12 12c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 13c0 0 0 0 0 0v0z" })
            );
        }
        function Crown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CrownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Crown.SVG = CrownSVG;
        return Crown;
    })();
export const CrystalBall = /*#__PURE__*/ (() => {
        function CrystalBallSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21 21.269v-0.269c0-0.941-0.434-1.781-1.116-2.331 0.766-0.791 1.419-1.694 1.916-2.669 0.797-1.559 1.2-3.241 1.2-5 0-1.484-0.291-2.925-0.866-4.281-0.553-1.309-1.347-2.487-2.356-3.497s-2.187-1.803-3.497-2.356c-1.356-0.575-2.797-0.866-4.281-0.866s-2.925 0.291-4.281 0.866c-1.309 0.553-2.487 1.347-3.497 2.356s-1.803 2.187-2.356 3.497c-0.575 1.356-0.866 2.797-0.866 4.281 0 1.759 0.403 3.441 1.2 4.997 0.5 0.978 1.15 1.881 1.916 2.669-0.681 0.553-1.116 1.394-1.116 2.334v0.269c-0.597 0.347-1 0.994-1 1.731v0.5c0 0.275 0.225 0.5 0.5 0.5h19c0.275 0 0.5-0.225 0.5-0.5v-0.5c0-0.738-0.403-1.384-1-1.731zM6 20h12c0.55 0 1 0.45 1 1h-14c0-0.55 0.45-1 1-1zM12 2c4.962 0 9 4.038 9 9 0 2.747-1.216 5.281-3.344 7h-5.656c-3.859 0-7-3.141-7-7h-1c0 2.138 0.831 4.147 2.344 5.656 0.534 0.534 1.131 0.984 1.775 1.344h-1.775c-2.128-1.719-3.344-4.253-3.344-7 0-4.962 4.038-9 9-9zM3 23c0-0.55 0.45-1 1-1h16c0.55 0 1 0.45 1 1h-18z" }),
_('path', { d: "M19 11h1c0-4.413-3.588-8-8-8v1c3.859 0 7 3.141 7 7z" })
            );
        }
        function CrystalBall({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CrystalBallSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CrystalBall.SVG = CrystalBallSVG;
        return CrystalBall;
    })();
export const Cube3D = /*#__PURE__*/ (() => {
        function Cube3DSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 6.5c0-1.306 1.006-2.381 2.284-2.491l-0.491 0.491 0.706 0.706 1.353-1.353c0.194-0.194 0.194-0.513 0-0.706l-1.353-1.353-0.706 0.706 0.506 0.506c-1.837 0.103-3.3 1.631-3.3 3.494v0.5h1v-0.5z" }),
_('path', { d: "M18.206 8.5l-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706-0.506-0.506c1.837-0.103 3.3-1.631 3.3-3.494v-0.5h-1v0.5c0 1.306-1.006 2.381-2.284 2.491l0.491-0.491z" }),
_('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5-2.063 0-3.906 0.966-5.097 2.472l-0.491-0.253c-0.572-0.291-1.253-0.291-1.825 0l-9 4.612c-0.669 0.344-1.087 1.028-1.087 1.781v8.778c0 0.753 0.416 1.434 1.087 1.781l9 4.612c0.284 0.147 0.597 0.219 0.909 0.219s0.628-0.072 0.912-0.219l9-4.613c0.669-0.344 1.087-1.028 1.087-1.781v-6.203c1.234-1.184 2.003-2.847 2.003-4.688zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM11 4l0.416 0.213c-0.269 0.713-0.416 1.484-0.416 2.287 0 1.769 0.709 3.375 1.859 4.547l-1.859 0.953-7.806-4 7.806-4zM2 9.637l8 4.1v7.756l-8-4.103v-7.753zM12 21.491v-7.753l2.688-1.378c0.853 0.409 1.806 0.641 2.813 0.641 0.884 0 1.731-0.178 2.5-0.5v4.891l-8 4.1z" })
            );
        }
        function Cube3D({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Cube3DSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cube3D.SVG = Cube3DSVG;
        return Cube3D;
    })();
export const CubeBottom = /*#__PURE__*/ (() => {
        function CubeBottomSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.912 5.828l-9-4.612c-0.572-0.291-1.253-0.291-1.825 0l-9 4.612c-0.669 0.344-1.087 1.028-1.087 1.781v8.778c0 0.753 0.416 1.434 1.087 1.781l9 4.612c0.284 0.147 0.597 0.219 0.909 0.219s0.628-0.072 0.912-0.219l9-4.612c0.669-0.344 1.087-1.028 1.087-1.781v-8.778c0.003-0.753-0.413-1.434-1.084-1.781zM21 15.363l-8-4.1v-7.753l8 4.1v7.753zM11 3.509v7.756l-8 4.097v-7.756l8-4.097zM12 21l-7.806-4 7.806-4 7.806 4-7.806 4z" }),
_('path', { d: "M16.747 16.556l-4.519-2.316c-0.144-0.072-0.312-0.072-0.456 0l-4.519 2.316c-0.166 0.084-0.272 0.256-0.272 0.444s0.106 0.359 0.272 0.444l4.519 2.316c0.072 0.037 0.15 0.056 0.228 0.056s0.156-0.019 0.228-0.056l4.519-2.316c0.166-0.084 0.272-0.256 0.272-0.444s-0.106-0.359-0.272-0.444zM12 18.753l-3.422-1.753 3.422-1.753 3.422 1.753-3.422 1.753z" })
            );
        }
        function CubeBottom({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CubeBottomSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CubeBottom.SVG = CubeBottomSVG;
        return CubeBottom;
    })();
export const CubeFront = /*#__PURE__*/ (() => {
        function CubeFrontSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.912 5.831c0 0 0 0 0 0l-9-4.613c-0.572-0.291-1.253-0.291-1.825 0l-9 4.613c-0.669 0.344-1.087 1.028-1.087 1.781v8.778c0 0.753 0.416 1.434 1.087 1.781l9 4.613c0.284 0.147 0.597 0.219 0.909 0.219s0.628-0.072 0.912-0.219l9-4.613c0.669-0.344 1.087-1.028 1.087-1.781v-8.778c0.003-0.753-0.413-1.434-1.084-1.781zM12 3l7.806 4-7.806 4-7.806-4 7.806-4zM3 8.637l8 4.1v7.756l-8-4.103v-7.753zM13 20.491v-7.753l8-4.1v7.756l-8 4.097z" }),
_('path', { d: "M9.728 13.209l-5-2.562c-0.156-0.078-0.341-0.072-0.487 0.019-0.15 0.091-0.241 0.253-0.241 0.428v4.381c0 0.188 0.106 0.359 0.272 0.444l5 2.562c0.072 0.038 0.15 0.056 0.228 0.056 0.091 0 0.181-0.025 0.259-0.072 0.15-0.091 0.241-0.253 0.241-0.428v-4.384c0-0.188-0.106-0.359-0.272-0.444zM9 17.216l-4-2.050v-3.256l4 2.050v3.256z" })
            );
        }
        function CubeFront({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CubeFrontSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CubeFront.SVG = CubeFrontSVG;
        return CubeFront;
    })();
export const CubeSide = /*#__PURE__*/ (() => {
        function CubeSideSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.912 5.831c0 0 0 0 0 0l-9-4.613c-0.572-0.291-1.253-0.291-1.825 0l-9 4.613c-0.669 0.344-1.087 1.028-1.087 1.781v8.778c0 0.753 0.416 1.434 1.087 1.781l9 4.613c0.284 0.147 0.597 0.219 0.909 0.219s0.628-0.072 0.912-0.219l9-4.613c0.669-0.344 1.087-1.028 1.087-1.781v-8.778c0.003-0.753-0.413-1.434-1.084-1.781zM12 3l7.806 4-7.806 4-7.806-4 7.806-4zM3 8.637l8 4.1v7.756l-8-4.103v-7.753zM13 20.491v-7.753l8-4.1v7.756l-8 4.097z" }),
_('path', { d: "M19.759 10.662c-0.15-0.091-0.334-0.097-0.487-0.019l-5 2.562c-0.166 0.084-0.272 0.256-0.272 0.444v4.381c0 0.175 0.091 0.334 0.241 0.428 0.081 0.050 0.169 0.072 0.259 0.072 0.078 0 0.156-0.019 0.228-0.056l5-2.562c0.166-0.084 0.272-0.256 0.272-0.444v-4.378c0-0.175-0.091-0.338-0.241-0.428zM19 15.166l-4 2.050v-3.256l4-2.050v3.256z" })
            );
        }
        function CubeSide({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CubeSideSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CubeSide.SVG = CubeSideSVG;
        return CubeSide;
    })();
export const CubeTop = /*#__PURE__*/ (() => {
        function CubeTopSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.912 5.831c0 0 0 0 0 0l-9-4.613c-0.572-0.291-1.253-0.291-1.825 0l-9 4.613c-0.669 0.344-1.087 1.028-1.087 1.781v8.778c0 0.753 0.416 1.434 1.087 1.781l9 4.613c0.284 0.147 0.597 0.219 0.909 0.219s0.628-0.072 0.912-0.219l9-4.613c0.669-0.344 1.087-1.028 1.087-1.781v-8.778c0.003-0.753-0.413-1.434-1.084-1.781zM12 3l7.806 4-7.806 4-7.806-4 7.806-4zM3 8.637l8 4.1v7.756l-8-4.103v-7.753zM13 20.491v-7.753l8-4.1v7.756l-8 4.097z" }),
_('path', { d: "M7.253 7.444l4.519 2.316c0.072 0.038 0.15 0.056 0.228 0.056s0.156-0.019 0.228-0.056l4.519-2.316c0.166-0.084 0.272-0.256 0.272-0.444s-0.106-0.359-0.272-0.444l-4.519-2.316c-0.144-0.072-0.312-0.072-0.456 0l-4.519 2.316c-0.166 0.084-0.272 0.256-0.272 0.444s0.106 0.359 0.272 0.444zM12 5.247l3.422 1.753-3.422 1.753-3.422-1.753 3.422-1.753z" })
            );
        }
        function CubeTop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CubeTopSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CubeTop.SVG = CubeTopSVG;
        return CubeTop;
    })();
export const Cube = /*#__PURE__*/ (() => {
    function CubeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.912 5.831l-9-4.613c-0.572-0.294-1.253-0.294-1.825 0l-9 4.613c-0.672 0.344-1.087 1.025-1.087 1.781v8.778c0 0.753 0.416 1.437 1.087 1.781l9 4.613c0.284 0.147 0.6 0.219 0.912 0.219s0.628-0.072 0.912-0.219l9-4.613c0.672-0.344 1.087-1.025 1.087-1.781v-8.778c0-0.756-0.416-1.437-1.087-1.781zM12 3l7.806 4-7.806 4-7.806-4 7.806-4zM3 8.637l8 4.1v7.753l-8-4.103v-7.75zM13 20.487v-7.75l8-4.1v7.753l-8 4.097z" })
        );
    }
    function Cube({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CubeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cube.SVG = CubeSVG;
    return Cube;
})();
export const Cutter = /*#__PURE__*/ (() => {
    function CutterSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.544 8.044l-2.55 2.55c-0.266 0.266-0.619 0.413-0.994 0.413s-0.728-0.147-0.994-0.413l-2.6-2.597c-0.266-0.266-0.412-0.619-0.412-0.994s0.147-0.728 0.412-0.994l2.55-2.55-1.416-1.416-2.547 2.55c-0.644 0.644-0.997 1.5-0.997 2.409 0 0.656 0.184 1.281 0.528 1.822l-11.394 12.334c-0.15 0.162-0.175 0.403-0.063 0.594 0.091 0.153 0.256 0.244 0.431 0.244 0.041 0 0.081-0.006 0.122-0.016l12-3c0.222-0.056 0.378-0.256 0.378-0.484v-4.791l1.647-1.647c0.638 0.609 1.469 0.944 2.353 0.944 0.909 0 1.766-0.353 2.409-0.997l2.55-2.55-1.416-1.413zM13.147 13.147c-0.094 0.094-0.147 0.222-0.147 0.353v4.609l-9.997 2.5 10.172-11.019 1.766 1.766-1.794 1.791z" })
        );
    }
    function Cutter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CutterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cutter.SVG = CutterSVG;
    return Cutter;
})();
export const CwBolt = /*#__PURE__*/ (() => {
        function CwBoltSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 0v3.056c-0.725-0.647-1.525-1.209-2.381-1.662-1.719-0.912-3.663-1.394-5.619-1.394-1.619 0-3.191 0.319-4.672 0.944-1.428 0.603-2.712 1.469-3.813 2.572s-1.966 2.384-2.572 3.813c-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813s2.384 1.966 3.813 2.572c1.481 0.625 3.053 0.944 4.672 0.944v-2c-5.512 0-10-4.488-10-10s4.488-10 10-10c2.703 0 5.275 1.1 7.141 3h-4.141v2h6c0.553 0 1-0.447 1-1v-6h-2z" }),
_('path', { d: "M3 12c0 2.403 0.938 4.662 2.637 6.363s3.959 2.637 6.363 2.637v-1c-4.413 0-8-3.588-8-8s3.588-8 8-8v-1c-2.403 0-4.662 0.938-6.363 2.637s-2.637 3.959-2.637 6.363z" }),
_('path', { d: "M21.5 15h-2.191l1.638-3.275c0.078-0.156 0.069-0.341-0.022-0.488s-0.253-0.237-0.425-0.237h-4c-0.244 0-0.453 0.178-0.494 0.419l-1 6c-0.025 0.144 0.016 0.294 0.112 0.406s0.234 0.178 0.381 0.178h1.391l-0.881 4.403c-0.047 0.231 0.075 0.462 0.291 0.556 0.066 0.028 0.131 0.041 0.2 0.041 0.156 0 0.309-0.075 0.406-0.209l5-7c0.109-0.153 0.122-0.353 0.038-0.519s-0.256-0.275-0.444-0.275zM17.447 20.313l0.544-2.716c0.028-0.147-0.009-0.3-0.103-0.416s-0.237-0.184-0.387-0.184h-1.409l0.834-5h2.769l-1.638 3.275c-0.078 0.156-0.069 0.338 0.022 0.487 0.091 0.147 0.253 0.237 0.425 0.237h2.028l-3.084 4.316z" })
            );
        }
        function CwBolt({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CwBoltSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CwBolt.SVG = CwBoltSVG;
        return CwBolt;
    })();
export const Cw = /*#__PURE__*/ (() => {
        function CwSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.384 17.453c-1.856 2.847-4.991 4.547-8.384 4.547-5.512 0-10-4.488-10-10s4.488-10 10-10c2.703 0 5.275 1.1 7.141 3h-4.141v2h6c0.553 0 1-0.447 1-1v-6h-2v3.059c-0.725-0.647-1.525-1.209-2.384-1.666-1.716-0.912-3.659-1.394-5.616-1.394-1.619 0-3.191 0.319-4.672 0.944-1.428 0.603-2.712 1.469-3.813 2.572s-1.966 2.384-2.572 3.813c-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813s2.384 1.966 3.813 2.572c1.481 0.625 3.053 0.944 4.672 0.944 4.072 0 7.831-2.037 10.059-5.453l-1.675-1.094z" }),
_('path', { d: "M12 4v-1c-2.403 0-4.662 0.938-6.363 2.637s-2.637 3.959-2.637 6.363c0 2.403 0.938 4.662 2.637 6.363s3.959 2.637 6.363 2.637c2.403 0 4.662-0.938 6.363-2.637s2.637-3.959 2.637-6.363h-1c0 4.413-3.588 8-8 8s-8-3.588-8-8c0-4.413 3.588-8 8-8z" })
            );
        }
        function Cw({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CwSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cw.SVG = CwSVG;
        return Cw;
    })();
export const Cw2 = /*#__PURE__*/ (() => {
        function Cw2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 2h6c0.553 0 1 0.447 1 1v6h-2v-4.141c-1.9 1.866-3 4.437-3 7.141 0 5.513 4.488 10 10 10s10-4.488 10-10c0-3.394-1.7-6.528-4.547-8.384l1.094-1.675c3.416 2.228 5.453 5.988 5.453 10.059 0 1.619-0.319 3.191-0.944 4.672-0.603 1.428-1.469 2.712-2.572 3.813s-2.384 1.966-3.813 2.572c-1.481 0.625-3.053 0.944-4.672 0.944s-3.191-0.319-4.672-0.944c-1.428-0.603-2.712-1.469-3.813-2.572s-1.966-2.384-2.572-3.813c-0.625-1.481-0.944-3.053-0.944-4.672 0-1.956 0.481-3.9 1.394-5.616 0.456-0.856 1.016-1.659 1.666-2.384h-3.059v-2z" }),
_('path', { d: "M21 12c0 2.403-0.938 4.662-2.637 6.363s-3.959 2.637-6.363 2.637c-2.403 0-4.662-0.938-6.363-2.637s-2.637-3.959-2.637-6.363h1c0 4.413 3.588 8 8 8s8-3.588 8-8c0-4.413-3.588-8-8-8v-1c2.403 0 4.662 0.938 6.363 2.637s2.637 3.959 2.637 6.363z" }),
_('path', { d: "M16 12c0 2.206-1.794 4-4 4s-4-1.794-4-4c0-2.206 1.794-4 4-4s4 1.794 4 4zM9 12c0 1.653 1.347 3 3 3s3-1.347 3-3-1.347-3-3-3-3 1.347-3 3z" })
            );
        }
        function Cw2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Cw2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cw2.SVG = Cw2SVG;
        return Cw2;
    })();
export const DatabaseBackup = /*#__PURE__*/ (() => {
        function DatabaseBackupSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5-0.822 0-1.609 0.153-2.334 0.434-0.353-0.066-0.725-0.125-1.113-0.175-1.269-0.172-2.631-0.259-4.053-0.259-2.491 0-4.847 0.272-6.631 0.769-0.925 0.256-1.669 0.569-2.209 0.922-0.959 0.628-1.159 1.331-1.159 1.809v17c0 0.478 0.2 1.181 1.159 1.809 0.541 0.353 1.284 0.666 2.209 0.922 1.784 0.497 4.141 0.769 6.631 0.769s4.847-0.272 6.631-0.769c0.928-0.256 1.672-0.569 2.209-0.922 0.956-0.628 1.159-1.331 1.159-1.809v-8c2.347-0.981 4-3.3 4-6zM4.347 2.581c1.559-0.375 3.566-0.581 5.653-0.581 0.919 0 1.834 0.041 2.703 0.119-0.728 0.797-1.263 1.775-1.522 2.859-0.391 0.016-0.784 0.022-1.181 0.022-2.088 0-4.094-0.206-5.653-0.581-1.413-0.341-2.053-0.716-2.278-0.919 0.225-0.203 0.866-0.578 2.278-0.919zM2 13.706c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 2.234 0 4.391-0.228 6.075-0.641 0.772-0.188 1.413-0.406 1.925-0.65v2.856c-0.347 0.225-0.906 0.478-1.772 0.719-1.656 0.462-3.869 0.716-6.228 0.716s-4.572-0.253-6.228-0.712c-0.866-0.241-1.425-0.494-1.772-0.719v-2.862zM15.834 13.388c-1.606 0.397-3.678 0.612-5.834 0.612-2.359 0-4.572-0.253-6.228-0.712-0.866-0.241-1.425-0.494-1.772-0.719v-2.859c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 0.925 0 1.834-0.037 2.706-0.113 1.113 1.216 2.678 2.006 4.428 2.103-0.353 0.134-0.784 0.269-1.3 0.394zM10 10c-2.359 0-4.572-0.253-6.228-0.713-0.866-0.241-1.425-0.494-1.772-0.719v-2.809c0.397 0.175 0.856 0.331 1.369 0.475 1.784 0.494 4.141 0.766 6.631 0.766 0.341 0 0.681-0.006 1.019-0.016 0.081 1.078 0.425 2.084 0.969 2.953-0.65 0.041-1.316 0.063-1.987 0.063zM15.653 21.419c-1.559 0.375-3.569 0.581-5.653 0.581s-4.094-0.206-5.653-0.581c-1.603-0.384-2.213-0.819-2.347-0.991v-2.722c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75s4.756-0.266 6.497-0.75c0.581-0.162 1.084-0.344 1.503-0.544v2.722c-0.134 0.172-0.744 0.606-2.347 0.991zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M20.853 4.147c-0.194-0.194-0.513-0.194-0.706 0l-1.353 1.353 0.706 0.706 0.5-0.5v0.794c0 1.378-1.122 2.5-2.5 2.5s-2.5-1.122-2.5-2.5 1.122-2.5 2.5-2.5h0.5v-1h-0.5c-1.931 0-3.5 1.569-3.5 3.5s1.569 3.5 3.5 3.5 3.5-1.569 3.5-3.5v-0.794l0.5 0.5 0.706-0.706-1.353-1.353z" })
            );
        }
        function DatabaseBackup({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseBackupSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseBackup.SVG = DatabaseBackupSVG;
        return DatabaseBackup;
    })();
export const DatabaseCheck = /*#__PURE__*/ (() => {
        function DatabaseCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5-0.822 0-1.609 0.153-2.334 0.434-0.353-0.066-0.725-0.125-1.113-0.175-1.269-0.172-2.631-0.259-4.053-0.259-2.491 0-4.847 0.272-6.631 0.769-0.925 0.256-1.669 0.569-2.209 0.922-0.959 0.628-1.159 1.331-1.159 1.809v17c0 0.478 0.2 1.181 1.159 1.809 0.541 0.353 1.284 0.666 2.209 0.922 1.784 0.497 4.141 0.769 6.631 0.769s4.847-0.272 6.631-0.769c0.928-0.256 1.672-0.569 2.209-0.922 0.956-0.628 1.159-1.331 1.159-1.809v-8c2.347-0.981 4-3.3 4-6zM4.347 2.581c1.559-0.375 3.566-0.581 5.653-0.581 0.919 0 1.834 0.041 2.703 0.119-0.728 0.797-1.263 1.775-1.522 2.859-0.391 0.016-0.784 0.022-1.181 0.022-2.088 0-4.094-0.206-5.653-0.581-1.413-0.341-2.053-0.716-2.278-0.919 0.225-0.203 0.866-0.578 2.278-0.919zM2 13.706c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 2.234 0 4.391-0.228 6.075-0.641 0.772-0.188 1.413-0.406 1.925-0.65v2.856c-0.347 0.225-0.906 0.478-1.772 0.719-1.656 0.462-3.869 0.716-6.228 0.716s-4.572-0.253-6.228-0.712c-0.866-0.241-1.425-0.494-1.772-0.719v-2.862zM15.834 13.388c-1.606 0.397-3.678 0.612-5.834 0.612-2.359 0-4.572-0.253-6.228-0.712-0.866-0.241-1.425-0.494-1.772-0.719v-2.859c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 0.925 0 1.834-0.037 2.706-0.113 1.113 1.216 2.678 2.006 4.428 2.103-0.353 0.134-0.784 0.269-1.3 0.394zM10 10c-2.359 0-4.572-0.253-6.228-0.713-0.866-0.241-1.425-0.494-1.772-0.719v-2.809c0.397 0.175 0.856 0.331 1.369 0.475 1.784 0.494 4.141 0.766 6.631 0.766 0.341 0 0.681-0.006 1.019-0.016 0.081 1.078 0.425 2.084 0.969 2.953-0.65 0.041-1.316 0.063-1.987 0.063zM15.653 21.419c-1.559 0.375-3.569 0.581-5.653 0.581s-4.094-0.206-5.653-0.581c-1.603-0.384-2.213-0.819-2.347-0.991v-2.722c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75s4.756-0.266 6.497-0.75c0.581-0.162 1.084-0.344 1.503-0.544v2.722c-0.134 0.172-0.744 0.606-2.347 0.991zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16.5 7.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4z" })
            );
        }
        function DatabaseCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseCheck.SVG = DatabaseCheckSVG;
        return DatabaseCheck;
    })();
export const DatabaseDownload = /*#__PURE__*/ (() => {
        function DatabaseDownloadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5-0.822 0-1.609 0.153-2.334 0.434-0.353-0.066-0.725-0.125-1.113-0.175-1.269-0.172-2.631-0.259-4.053-0.259-2.491 0-4.847 0.272-6.631 0.769-0.925 0.256-1.669 0.569-2.209 0.922-0.959 0.628-1.159 1.331-1.159 1.809v17c0 0.478 0.2 1.181 1.159 1.809 0.541 0.353 1.284 0.666 2.209 0.922 1.784 0.497 4.141 0.769 6.631 0.769s4.847-0.272 6.631-0.769c0.928-0.256 1.672-0.569 2.209-0.922 0.956-0.628 1.159-1.331 1.159-1.809v-8c2.347-0.981 4-3.3 4-6zM4.347 2.581c1.559-0.375 3.566-0.581 5.653-0.581 0.919 0 1.834 0.041 2.703 0.119-0.728 0.797-1.263 1.775-1.522 2.859-0.391 0.016-0.784 0.022-1.181 0.022-2.088 0-4.094-0.206-5.653-0.581-1.413-0.341-2.053-0.716-2.278-0.919 0.225-0.203 0.866-0.578 2.278-0.919zM2 13.706c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 2.234 0 4.391-0.228 6.075-0.641 0.772-0.188 1.413-0.406 1.925-0.65v2.856c-0.347 0.225-0.906 0.478-1.772 0.719-1.656 0.462-3.869 0.716-6.228 0.716s-4.572-0.253-6.228-0.712c-0.866-0.241-1.425-0.494-1.772-0.719v-2.862zM15.834 13.388c-1.606 0.397-3.678 0.612-5.834 0.612-2.359 0-4.572-0.253-6.228-0.712-0.866-0.241-1.425-0.494-1.772-0.719v-2.859c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 0.925 0 1.834-0.037 2.706-0.113 1.113 1.216 2.678 2.006 4.428 2.103-0.353 0.134-0.784 0.269-1.3 0.394zM10 10c-2.359 0-4.572-0.253-6.228-0.713-0.866-0.241-1.425-0.494-1.772-0.719v-2.809c0.397 0.175 0.856 0.331 1.369 0.475 1.784 0.494 4.141 0.766 6.631 0.766 0.341 0 0.681-0.006 1.019-0.016 0.081 1.078 0.425 2.084 0.969 2.953-0.65 0.041-1.316 0.063-1.987 0.063zM15.653 21.419c-1.559 0.375-3.569 0.581-5.653 0.581s-4.094-0.206-5.653-0.581c-1.603-0.384-2.213-0.819-2.347-0.991v-2.722c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75s4.756-0.266 6.497-0.75c0.581-0.162 1.084-0.344 1.503-0.544v2.722c-0.134 0.172-0.744 0.606-2.347 0.991zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18 8.294v-5.294h-1v5.294l-1.5-1.5-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l2.353-2.353-0.706-0.706-1.5 1.5z" })
            );
        }
        function DatabaseDownload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseDownloadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseDownload.SVG = DatabaseDownloadSVG;
        return DatabaseDownload;
    })();
export const DatabaseLock = /*#__PURE__*/ (() => {
        function DatabaseLockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5-0.822 0-1.609 0.153-2.334 0.434-0.353-0.066-0.725-0.125-1.113-0.175-1.269-0.172-2.631-0.259-4.053-0.259-2.491 0-4.847 0.272-6.631 0.769-0.925 0.256-1.669 0.569-2.209 0.922-0.959 0.628-1.159 1.331-1.159 1.809v17c0 0.478 0.2 1.181 1.159 1.809 0.541 0.353 1.284 0.666 2.209 0.922 1.784 0.497 4.141 0.769 6.631 0.769s4.847-0.272 6.631-0.769c0.928-0.256 1.672-0.569 2.209-0.922 0.956-0.628 1.159-1.331 1.159-1.809v-8c2.347-0.981 4-3.3 4-6zM4.347 2.581c1.559-0.375 3.566-0.581 5.653-0.581 0.919 0 1.834 0.041 2.703 0.119-0.728 0.797-1.263 1.775-1.522 2.859-0.391 0.016-0.784 0.022-1.181 0.022-2.088 0-4.094-0.206-5.653-0.581-1.413-0.341-2.053-0.716-2.278-0.919 0.225-0.203 0.866-0.578 2.278-0.919zM2 13.706c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 2.234 0 4.391-0.228 6.075-0.641 0.772-0.188 1.413-0.406 1.925-0.65v2.856c-0.347 0.225-0.906 0.478-1.772 0.719-1.656 0.462-3.869 0.716-6.228 0.716s-4.572-0.253-6.228-0.712c-0.866-0.241-1.425-0.494-1.772-0.719v-2.862zM15.834 13.388c-1.606 0.397-3.678 0.612-5.834 0.612-2.359 0-4.572-0.253-6.228-0.712-0.866-0.241-1.425-0.494-1.772-0.719v-2.859c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 0.925 0 1.834-0.037 2.706-0.113 1.113 1.216 2.678 2.006 4.428 2.103-0.353 0.134-0.784 0.269-1.3 0.394zM10 10c-2.359 0-4.572-0.253-6.228-0.713-0.866-0.241-1.425-0.494-1.772-0.719v-2.809c0.397 0.175 0.856 0.331 1.369 0.475 1.784 0.494 4.141 0.766 6.631 0.766 0.341 0 0.681-0.006 1.019-0.016 0.081 1.078 0.425 2.084 0.969 2.953-0.65 0.041-1.316 0.063-1.987 0.063zM15.653 21.419c-1.559 0.375-3.569 0.581-5.653 0.581s-4.094-0.206-5.653-0.581c-1.603-0.384-2.213-0.819-2.347-0.991v-2.722c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75s4.756-0.266 6.497-0.75c0.581-0.162 1.084-0.344 1.503-0.544v2.722c-0.134 0.172-0.744 0.606-2.347 0.991zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M20.5 6h-0.5v-0.5c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5v0.5h-0.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h6c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5zM16 5.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5v0.5h-3v-0.5zM20 9h-5v-2h5v2z" })
            );
        }
        function DatabaseLock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseLockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseLock.SVG = DatabaseLockSVG;
        return DatabaseLock;
    })();
export const DatabaseMinus = /*#__PURE__*/ (() => {
        function DatabaseMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5-0.822 0-1.609 0.153-2.334 0.434-0.353-0.066-0.725-0.125-1.113-0.175-1.269-0.172-2.631-0.259-4.053-0.259-2.491 0-4.847 0.272-6.631 0.769-0.925 0.256-1.669 0.569-2.209 0.922-0.959 0.628-1.159 1.331-1.159 1.809v17c0 0.478 0.2 1.181 1.159 1.809 0.541 0.353 1.284 0.666 2.209 0.922 1.784 0.497 4.141 0.769 6.631 0.769s4.847-0.272 6.631-0.769c0.928-0.256 1.672-0.569 2.209-0.922 0.956-0.628 1.159-1.331 1.159-1.809v-8c2.347-0.981 4-3.3 4-6zM4.347 2.581c1.559-0.375 3.566-0.581 5.653-0.581 0.919 0 1.834 0.041 2.703 0.119-0.728 0.797-1.263 1.775-1.522 2.859-0.391 0.016-0.784 0.022-1.181 0.022-2.088 0-4.094-0.206-5.653-0.581-1.413-0.341-2.053-0.716-2.278-0.919 0.225-0.203 0.866-0.578 2.278-0.919zM2 13.706c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 2.234 0 4.391-0.228 6.075-0.641 0.772-0.188 1.413-0.406 1.925-0.65v2.856c-0.347 0.225-0.906 0.478-1.772 0.719-1.656 0.462-3.869 0.716-6.228 0.716s-4.572-0.253-6.228-0.712c-0.866-0.241-1.425-0.494-1.772-0.719v-2.862zM15.834 13.388c-1.606 0.397-3.678 0.612-5.834 0.612-2.359 0-4.572-0.253-6.228-0.712-0.866-0.241-1.425-0.494-1.772-0.719v-2.859c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 0.925 0 1.834-0.037 2.706-0.113 1.113 1.216 2.678 2.006 4.428 2.103-0.353 0.134-0.784 0.269-1.3 0.394zM10 10c-2.359 0-4.572-0.253-6.228-0.713-0.866-0.241-1.425-0.494-1.772-0.719v-2.809c0.397 0.175 0.856 0.331 1.369 0.475 1.784 0.494 4.141 0.766 6.631 0.766 0.341 0 0.681-0.006 1.019-0.016 0.081 1.078 0.425 2.084 0.969 2.953-0.65 0.041-1.316 0.063-1.987 0.063zM15.653 21.419c-1.559 0.375-3.569 0.581-5.653 0.581s-4.094-0.206-5.653-0.581c-1.603-0.384-2.213-0.819-2.347-0.991v-2.722c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75s4.756-0.266 6.497-0.75c0.581-0.162 1.084-0.344 1.503-0.544v2.722c-0.134 0.172-0.744 0.606-2.347 0.991zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M15 6h5v1h-5v-1z" })
            );
        }
        function DatabaseMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseMinus.SVG = DatabaseMinusSVG;
        return DatabaseMinus;
    })();
export const DatabasePlus = /*#__PURE__*/ (() => {
        function DatabasePlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5-0.822 0-1.609 0.153-2.334 0.434-0.353-0.066-0.725-0.125-1.113-0.175-1.269-0.172-2.631-0.259-4.053-0.259-2.491 0-4.847 0.272-6.631 0.769-0.925 0.256-1.669 0.569-2.209 0.922-0.959 0.628-1.159 1.331-1.159 1.809v17c0 0.478 0.2 1.181 1.159 1.809 0.541 0.353 1.284 0.666 2.209 0.922 1.784 0.497 4.141 0.769 6.631 0.769s4.847-0.272 6.631-0.769c0.928-0.256 1.672-0.569 2.209-0.922 0.956-0.628 1.159-1.331 1.159-1.809v-8c2.347-0.981 4-3.3 4-6zM4.347 2.581c1.559-0.375 3.566-0.581 5.653-0.581 0.919 0 1.834 0.041 2.703 0.119-0.728 0.797-1.263 1.775-1.522 2.859-0.391 0.016-0.784 0.022-1.181 0.022-2.088 0-4.094-0.206-5.653-0.581-1.413-0.341-2.053-0.716-2.278-0.919 0.225-0.203 0.866-0.578 2.278-0.919zM2 13.706c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 2.234 0 4.391-0.228 6.075-0.641 0.772-0.188 1.413-0.406 1.925-0.65v2.856c-0.347 0.225-0.906 0.478-1.772 0.719-1.656 0.462-3.869 0.716-6.228 0.716s-4.572-0.253-6.228-0.712c-0.866-0.241-1.425-0.494-1.772-0.719v-2.862zM15.834 13.388c-1.606 0.397-3.678 0.612-5.834 0.612-2.359 0-4.572-0.253-6.228-0.712-0.866-0.241-1.425-0.494-1.772-0.719v-2.859c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 0.925 0 1.834-0.037 2.706-0.113 1.113 1.216 2.678 2.006 4.428 2.103-0.353 0.134-0.784 0.269-1.3 0.394zM10 10c-2.359 0-4.572-0.253-6.228-0.713-0.866-0.241-1.425-0.494-1.772-0.719v-2.809c0.397 0.175 0.856 0.331 1.369 0.475 1.784 0.494 4.141 0.766 6.631 0.766 0.341 0 0.681-0.006 1.019-0.016 0.081 1.078 0.425 2.084 0.969 2.953-0.65 0.041-1.316 0.063-1.987 0.063zM15.653 21.419c-1.559 0.375-3.569 0.581-5.653 0.581s-4.094-0.206-5.653-0.581c-1.603-0.384-2.213-0.819-2.347-0.991v-2.722c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75s4.756-0.266 6.497-0.75c0.581-0.162 1.084-0.344 1.503-0.544v2.722c-0.134 0.172-0.744 0.606-2.347 0.991zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18 4h-1v2h-2v1h2v2h1v-2h2v-1h-2z" })
            );
        }
        function DatabasePlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabasePlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabasePlus.SVG = DatabasePlusSVG;
        return DatabasePlus;
    })();
export const DatabaseSync = /*#__PURE__*/ (() => {
        function DatabaseSyncSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5-0.822 0-1.609 0.153-2.334 0.434-0.353-0.066-0.725-0.125-1.113-0.175-1.269-0.172-2.631-0.259-4.053-0.259-2.491 0-4.847 0.272-6.631 0.769-0.925 0.256-1.669 0.569-2.209 0.922-0.959 0.628-1.159 1.331-1.159 1.809v17c0 0.478 0.2 1.181 1.159 1.809 0.541 0.353 1.284 0.666 2.209 0.922 1.784 0.497 4.141 0.769 6.631 0.769s4.847-0.272 6.631-0.769c0.928-0.256 1.672-0.569 2.209-0.922 0.956-0.628 1.159-1.331 1.159-1.809v-8c2.347-0.981 4-3.3 4-6zM4.347 2.581c1.559-0.375 3.566-0.581 5.653-0.581 0.919 0 1.834 0.041 2.703 0.119-0.728 0.797-1.263 1.775-1.522 2.859-0.391 0.016-0.784 0.022-1.181 0.022-2.088 0-4.094-0.206-5.653-0.581-1.413-0.341-2.053-0.716-2.278-0.919 0.225-0.203 0.866-0.578 2.278-0.919zM2 13.706c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 2.234 0 4.391-0.228 6.075-0.641 0.772-0.188 1.413-0.406 1.925-0.65v2.856c-0.347 0.225-0.906 0.478-1.772 0.719-1.656 0.462-3.869 0.716-6.228 0.716s-4.572-0.253-6.228-0.712c-0.866-0.241-1.425-0.494-1.772-0.719v-2.862zM15.834 13.388c-1.606 0.397-3.678 0.612-5.834 0.612-2.359 0-4.572-0.253-6.228-0.712-0.866-0.241-1.425-0.494-1.772-0.719v-2.859c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 0.925 0 1.834-0.037 2.706-0.113 1.113 1.216 2.678 2.006 4.428 2.103-0.353 0.134-0.784 0.269-1.3 0.394zM10 10c-2.359 0-4.572-0.253-6.228-0.713-0.866-0.241-1.425-0.494-1.772-0.719v-2.809c0.397 0.175 0.856 0.331 1.369 0.475 1.784 0.494 4.141 0.766 6.631 0.766 0.341 0 0.681-0.006 1.019-0.016 0.081 1.078 0.425 2.084 0.969 2.953-0.65 0.041-1.316 0.063-1.987 0.063zM15.653 21.419c-1.559 0.375-3.569 0.581-5.653 0.581s-4.094-0.206-5.653-0.581c-1.603-0.384-2.213-0.819-2.347-0.991v-2.722c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75s4.756-0.266 6.497-0.75c0.581-0.162 1.084-0.344 1.503-0.544v2.722c-0.134 0.172-0.744 0.606-2.347 0.991zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16.794 4.5l0.706 0.706 1.353-1.353c0.194-0.194 0.194-0.513 0-0.706l-1.353-1.353-0.706 0.706 0.506 0.506c-1.838 0.103-3.3 1.631-3.3 3.494v0.5h1v-0.5c0-1.306 1.006-2.381 2.284-2.491l-0.491 0.491z" }),
_('path', { d: "M20 6.5c0 1.306-1.006 2.381-2.284 2.491l0.491-0.491-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706-0.506-0.506c1.837-0.103 3.3-1.631 3.3-3.494v-0.5h-1v0.5z" })
            );
        }
        function DatabaseSync({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseSyncSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseSync.SVG = DatabaseSyncSVG;
        return DatabaseSync;
    })();
export const DatabaseTime = /*#__PURE__*/ (() => {
        function DatabaseTimeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5-0.825 0-1.612 0.153-2.337 0.434-0.306-0.056-0.628-0.109-0.975-0.156-1.3-0.184-2.706-0.278-4.188-0.278-2.494 0-4.847 0.272-6.631 0.769-0.925 0.256-1.669 0.569-2.209 0.922-0.959 0.628-1.159 1.331-1.159 1.809v17c0 0.478 0.2 1.181 1.159 1.809 0.541 0.353 1.284 0.666 2.209 0.922 1.784 0.497 4.141 0.769 6.631 0.769s4.847-0.272 6.631-0.769c0.928-0.256 1.672-0.569 2.209-0.922 0.956-0.628 1.159-1.331 1.159-1.809v-8c2.347-0.981 4-3.3 4-6zM4.347 2.581c1.559-0.375 3.566-0.581 5.653-0.581 0.922 0 1.837 0.041 2.703 0.119-0.728 0.797-1.263 1.778-1.522 2.859-0.359 0.012-0.747 0.019-1.178 0.019-2.088 0-4.094-0.206-5.653-0.581-1.413-0.341-2.053-0.716-2.278-0.919 0.222-0.2 0.862-0.575 2.275-0.916zM2 13.706c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 2.234 0 4.391-0.228 6.075-0.641 0.772-0.188 1.413-0.406 1.925-0.65v2.856c-0.347 0.225-0.906 0.478-1.772 0.719-1.656 0.462-3.869 0.716-6.228 0.716s-4.572-0.253-6.228-0.712c-0.866-0.241-1.425-0.494-1.772-0.719v-2.862zM17.138 12.991c-0.353 0.138-0.784 0.272-1.3 0.4-1.606 0.394-3.681 0.609-5.838 0.609-2.359 0-4.572-0.253-6.228-0.713-0.866-0.241-1.425-0.494-1.772-0.719v-2.859c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 0.928 0 1.838-0.037 2.706-0.112 1.113 1.209 2.681 2.003 4.431 2.1zM10 10c-2.359 0-4.572-0.253-6.228-0.713-0.866-0.241-1.425-0.494-1.772-0.719v-2.809c0.397 0.175 0.853 0.331 1.369 0.475 1.784 0.494 4.137 0.766 6.631 0.766 0.366 0 0.7-0.003 1.019-0.012 0.081 1.078 0.425 2.084 0.969 2.953-0.647 0.038-1.313 0.059-1.987 0.059zM15.653 21.419c-1.559 0.375-3.569 0.581-5.653 0.581s-4.094-0.206-5.653-0.581c-1.603-0.384-2.213-0.819-2.347-0.991v-2.722c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75s4.756-0.266 6.497-0.75c0.581-0.162 1.084-0.344 1.503-0.544v2.722c-0.134 0.172-0.744 0.606-2.347 0.991zM18 11.978v-1.978h-1v1.978c-2.634-0.237-4.737-2.344-4.978-4.978h1.978v-1h-1.978c0.237-2.634 2.344-4.737 4.978-4.978v1.978h1v-1.978c2.634 0.237 4.737 2.344 4.978 4.978h-1.978v1h1.978c-0.241 2.634-2.344 4.737-4.978 4.978z" }),
_('path', { d: "M17.422 6.716l-1.922-1.922-0.706 0.706 2.353 2.353c0.094 0.094 0.222 0.147 0.353 0.147 0.016 0 0.034 0 0.050-0.003 0.15-0.016 0.284-0.097 0.366-0.219l2.278-3.416-0.831-0.556-1.941 2.909z" })
            );
        }
        function DatabaseTime({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseTimeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseTime.SVG = DatabaseTimeSVG;
        return DatabaseTime;
    })();
export const DatabaseUpload = /*#__PURE__*/ (() => {
        function DatabaseUploadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5-0.822 0-1.609 0.153-2.334 0.434-0.353-0.066-0.725-0.125-1.113-0.175-1.269-0.172-2.631-0.259-4.053-0.259-2.491 0-4.847 0.272-6.631 0.769-0.925 0.256-1.669 0.569-2.209 0.922-0.959 0.628-1.159 1.331-1.159 1.809v17c0 0.478 0.2 1.181 1.159 1.809 0.541 0.353 1.284 0.666 2.209 0.922 1.784 0.497 4.141 0.769 6.631 0.769s4.847-0.272 6.631-0.769c0.928-0.256 1.672-0.569 2.209-0.922 0.956-0.628 1.159-1.331 1.159-1.809v-8c2.347-0.981 4-3.3 4-6zM4.347 2.581c1.559-0.375 3.566-0.581 5.653-0.581 0.919 0 1.834 0.041 2.703 0.119-0.728 0.797-1.263 1.775-1.522 2.859-0.391 0.016-0.784 0.022-1.181 0.022-2.088 0-4.094-0.206-5.653-0.581-1.413-0.341-2.053-0.716-2.278-0.919 0.225-0.203 0.866-0.578 2.278-0.919zM2 13.706c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 2.234 0 4.391-0.228 6.075-0.641 0.772-0.188 1.413-0.406 1.925-0.65v2.856c-0.347 0.225-0.906 0.478-1.772 0.719-1.656 0.462-3.869 0.716-6.228 0.716s-4.572-0.253-6.228-0.712c-0.866-0.241-1.425-0.494-1.772-0.719v-2.862zM15.834 13.388c-1.606 0.397-3.678 0.612-5.834 0.612-2.359 0-4.572-0.253-6.228-0.712-0.866-0.241-1.425-0.494-1.772-0.719v-2.859c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75 0.925 0 1.834-0.037 2.706-0.113 1.113 1.216 2.678 2.006 4.428 2.103-0.353 0.134-0.784 0.269-1.3 0.394zM10 10c-2.359 0-4.572-0.253-6.228-0.713-0.866-0.241-1.425-0.494-1.772-0.719v-2.809c0.397 0.175 0.856 0.331 1.369 0.475 1.784 0.494 4.141 0.766 6.631 0.766 0.341 0 0.681-0.006 1.019-0.016 0.081 1.078 0.425 2.084 0.969 2.953-0.65 0.041-1.316 0.063-1.987 0.063zM15.653 21.419c-1.559 0.375-3.569 0.581-5.653 0.581s-4.094-0.206-5.653-0.581c-1.603-0.384-2.213-0.819-2.347-0.991v-2.722c0.419 0.2 0.922 0.381 1.503 0.544 1.744 0.484 4.050 0.75 6.497 0.75s4.756-0.266 6.497-0.75c0.581-0.162 1.084-0.344 1.503-0.544v2.722c-0.134 0.172-0.744 0.606-2.347 0.991zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17.147 3.147l-2.353 2.353 0.706 0.706 1.5-1.5v5.294h1v-5.294l1.5 1.5 0.706-0.706-2.353-2.353c-0.194-0.197-0.513-0.197-0.706 0z" })
            );
        }
        function DatabaseUpload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseUploadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseUpload.SVG = DatabaseUploadSVG;
        return DatabaseUpload;
    })();
export const Database = /*#__PURE__*/ (() => {
    function DatabaseSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.841 1.691c-0.541-0.353-1.284-0.666-2.209-0.922-1.784-0.497-4.141-0.769-6.631-0.769s-4.847 0.272-6.631 0.769c-0.925 0.256-1.669 0.569-2.209 0.922-0.959 0.628-1.159 1.331-1.159 1.809v17c0 0.478 0.2 1.181 1.159 1.809 0.541 0.353 1.284 0.666 2.209 0.922 1.784 0.497 4.141 0.769 6.631 0.769s4.847-0.272 6.631-0.769c0.928-0.256 1.669-0.569 2.209-0.922 0.956-0.628 1.159-1.331 1.159-1.809v-17c0-0.478-0.2-1.181-1.159-1.809zM20 12.566c-0.347 0.225-0.906 0.478-1.769 0.719-1.659 0.462-3.872 0.716-6.231 0.716s-4.572-0.253-6.231-0.712c-0.866-0.241-1.425-0.494-1.769-0.719v-2.859c0.419 0.2 0.919 0.381 1.503 0.544 1.741 0.484 4.050 0.75 6.497 0.75s4.756-0.266 6.497-0.75c0.581-0.162 1.084-0.344 1.503-0.544v2.856zM20 8.566c-0.347 0.225-0.906 0.478-1.769 0.719-1.659 0.462-3.872 0.716-6.231 0.716s-4.572-0.253-6.231-0.713c-0.866-0.241-1.425-0.494-1.769-0.719v-2.809c0.397 0.175 0.856 0.331 1.369 0.475 1.784 0.494 4.141 0.766 6.631 0.766s4.847-0.272 6.631-0.769c0.513-0.144 0.972-0.303 1.369-0.475v2.809zM4 13.706c0.419 0.2 0.919 0.381 1.503 0.544 1.741 0.484 4.050 0.75 6.497 0.75s4.756-0.266 6.497-0.75c0.581-0.162 1.084-0.344 1.503-0.544v2.859c-0.347 0.225-0.906 0.478-1.769 0.719-1.659 0.462-3.872 0.716-6.231 0.716s-4.572-0.253-6.231-0.712c-0.866-0.241-1.425-0.494-1.769-0.719v-2.862zM6.347 2.581c1.559-0.375 3.566-0.581 5.653-0.581s4.094 0.206 5.653 0.581c1.413 0.341 2.053 0.716 2.278 0.919-0.225 0.203-0.866 0.578-2.278 0.919-1.559 0.375-3.566 0.581-5.653 0.581s-4.094-0.206-5.653-0.581c-1.413-0.341-2.053-0.716-2.278-0.919 0.225-0.203 0.866-0.578 2.278-0.919zM17.653 21.419c-1.559 0.375-3.566 0.581-5.653 0.581s-4.094-0.206-5.653-0.581c-1.603-0.384-2.213-0.819-2.347-0.991v-2.722c0.419 0.2 0.919 0.381 1.503 0.544 1.741 0.484 4.050 0.75 6.497 0.75s4.756-0.266 6.497-0.75c0.581-0.162 1.084-0.344 1.503-0.544v2.722c-0.134 0.172-0.744 0.606-2.347 0.991z" })
        );
    }
    function Database({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DatabaseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Database.SVG = DatabaseSVG;
    return Database;
})();
export const Dead = /*#__PURE__*/ (() => {
        function DeadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M6.5 11.206l1.5-1.5 1.5 1.5 0.706-0.706-1.5-1.5 1.5-1.5-0.706-0.706-1.5 1.5-1.5-1.5-0.706 0.706 1.5 1.5-1.5 1.5z" }),
_('path', { d: "M17.5 6.794l-1.5 1.5-1.5-1.5-0.706 0.706 1.5 1.5-1.5 1.5 0.706 0.706 1.5-1.5 1.5 1.5 0.706-0.706-1.5-1.5 1.5-1.5z" }),
_('path', { d: "M6 15h6v1.5c0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5v-1.5h1v-1h-12v1zM16 16.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-1.5h3v1.5z" })
            );
        }
        function Dead({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DeadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Dead.SVG = DeadSVG;
        return Dead;
    })();
export const DebitCard = /*#__PURE__*/ (() => {
        function DebitCardSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21 4h-18c-1.653 0-3 1.347-3 3v10c0 1.653 1.347 3 3 3h18c1.653 0 3-1.347 3-3v-10c0-1.653-1.347-3-3-3zM3 6h18c0.55 0 1 0.45 1 1h-20c0-0.55 0.45-1 1-1zM22 8v2h-20v-2h20zM21 18h-18c-0.55 0-1-0.45-1-1v-6h20v6c0 0.55-0.45 1-1 1z" }),
_('path', { d: "M8.5 13h-4c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h4c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5zM8 16h-3v-2h3v2z" }),
_('path', { d: "M15 16h2v1h-2v-1z" }),
_('path', { d: "M18 16h2v1h-2v-1z" })
            );
        }
        function DebitCard({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DebitCardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DebitCard.SVG = DebitCardSVG;
        return DebitCard;
    })();
export const Delete = /*#__PURE__*/ (() => {
        function DeleteSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-13.616c-0.513 0-1 0.194-1.372 0.544l-6.381 6c-0.4 0.375-0.631 0.906-0.631 1.456s0.231 1.081 0.631 1.456l6.378 5.997c0.372 0.35 0.859 0.544 1.372 0.544h13.619c1.103 0 2-0.897 2-2v-11.997c0-1.103-0.897-2-2-2zM22 18h-13.616c0 0 0 0 0 0l-6.381-6 6.381-6c0 0 0 0 0 0h13.616v12z" }),
_('path', { d: "M11.5 16.206l3.5-3.5 3.5 3.5 0.706-0.706-3.5-3.5 3.5-3.5-0.706-0.706-3.5 3.5-3.5-3.5-0.706 0.706 3.5 3.5-3.5 3.5z" })
            );
        }
        function Delete({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DeleteSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Delete.SVG = DeleteSVG;
        return Delete;
    })();
export const Depressed = /*#__PURE__*/ (() => {
        function DepressedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 7c1.103 0 2-0.897 2-2s-0.897-2-2-2-2 0.897-2 2 0.897 2 2 2zM15 4c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M13.653 11.531c0.144 0.231 0.378 0.394 0.644 0.45 0.269 0.056 0.547 0 0.772-0.156 0.103-0.072 2.547-1.775 4.062-4.6l-1.762-0.947c-0.778 1.453-1.875 2.575-2.619 3.237l-1.903-3.047c-0.175-0.278-0.475-0.456-0.806-0.469-0.328-0.012-0.644 0.134-0.844 0.4-1.122 1.494-2.616 4.275-3.166 6.344-0.075 0.275-0.025 0.572 0.131 0.809s0.409 0.397 0.694 0.438c0.694 0.1 1.469 0.109 2.222 0.116 1.003 0.012 2.328 0.028 2.919 0.347v6.547h2v-7c0-0.228-0.078-0.447-0.219-0.625-0.981-1.222-2.859-1.247-4.675-1.269-0.256-0.003-0.506-0.006-0.75-0.012 0.422-1.088 1.028-2.272 1.619-3.25l1.681 2.688z" }),
_('path', { d: "M12.5 15h-5.578c0.122-1.437 0.131-2.647 0.097-3.581-0.087-2.347-0.497-4.291-1.103-5.197l-0.278-0.416-0.831 0.556 0.278 0.416c0.372 0.559 0.841 2.119 0.934 4.678 0.069 1.916-0.047 5.019-1.003 8.925l-0.119 0.484 0.972 0.237 0.119-0.484c0.416-1.694 0.678-3.244 0.834-4.619h5.178v5h1v-5.5c0-0.275-0.225-0.5-0.5-0.5z" })
            );
        }
        function Depressed({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DepressedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Depressed.SVG = DepressedSVG;
        return Depressed;
    })();
export const Diamond = /*#__PURE__*/ (() => {
        function DiamondSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.769 8.359l-5-6c-0.191-0.228-0.472-0.359-0.769-0.359h-12c-0.297 0-0.578 0.131-0.769 0.359l-5 6c-0.322 0.384-0.306 0.947 0.031 1.316l11 12c0.191 0.206 0.456 0.325 0.738 0.325s0.547-0.119 0.738-0.325l11-12c0.338-0.369 0.35-0.931 0.031-1.316zM12 19.519l-9.672-10.55 4.141-4.969h11.063l4.141 4.969-9.672 10.55z" }),
_('path', { d: "M16.5 5h-9c-0.147 0-0.284 0.063-0.378 0.175l-3 3.5c-0.162 0.191-0.159 0.469 0.006 0.656l7.5 8.5c0.094 0.106 0.231 0.169 0.375 0.169s0.281-0.063 0.375-0.169l7.5-8.5c0.166-0.188 0.166-0.466 0.006-0.656l-3-3.5c-0.1-0.113-0.237-0.175-0.384-0.175zM12 16.744l-6.837-7.75 2.569-2.994h8.541l2.569 2.994-6.841 7.75z" })
            );
        }
        function Diamond({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DiamondSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Diamond.SVG = DiamondSVG;
        return Diamond;
    })();
export const Diamond2 = /*#__PURE__*/ (() => {
    function Diamond2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.769 8.359l-5-6c-0.191-0.228-0.472-0.359-0.769-0.359h-12c-0.297 0-0.578 0.131-0.769 0.359l-5 6c-0.322 0.384-0.306 0.947 0.031 1.316l11 12c0.191 0.206 0.456 0.325 0.738 0.325s0.547-0.119 0.738-0.325l11-12c0.338-0.369 0.35-0.931 0.031-1.316zM20.866 8h-4.069l-2.181-4h2.916l3.334 4zM7.15 9l3.1 8.609-7.894-8.609h4.794zM8.212 9h7.578l-3.787 10.519-0.003 0.003-0.003-0.003-3.784-10.519zM8.344 8l2.181-4h2.953l2.178 4h-7.313zM16.85 9h4.791l-7.887 8.609 3.097-8.609zM6.469 4h2.916l-2.181 4h-4.069l3.334-4z" })
        );
    }
    function Diamond2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Diamond2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Diamond2.SVG = Diamond2SVG;
    return Diamond2;
})();
export const Diamonds = /*#__PURE__*/ (() => {
    function DiamondsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19.844 11.463l-7-11c-0.184-0.288-0.503-0.462-0.844-0.462s-0.659 0.175-0.844 0.462l-7 11c-0.209 0.328-0.209 0.747 0 1.075l7 11c0.184 0.288 0.503 0.462 0.844 0.462s0.659-0.175 0.844-0.462l7-11c0.209-0.328 0.209-0.747 0-1.075zM12 21.138l-5.816-9.138 5.816-9.138 5.816 9.138-5.816 9.138z" })
        );
    }
    function Diamonds({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DiamondsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Diamonds.SVG = DiamondsSVG;
    return Diamonds;
})();
export const Diamonds2 = /*#__PURE__*/ (() => {
        function Diamonds2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.844 11.463l-7-11c-0.184-0.288-0.503-0.462-0.844-0.462s-0.659 0.175-0.844 0.462l-7 11c-0.209 0.328-0.209 0.747 0 1.075l7 11c0.184 0.288 0.503 0.462 0.844 0.462s0.659-0.175 0.844-0.462l7-11c0.209-0.328 0.209-0.747 0-1.075zM12 21.138l-5.816-9.138 5.816-9.138 5.816 9.138-5.816 9.138z" }),
_('path', { d: "M11.863 6.375l0.844-0.537 3.643 5.723-0.844 0.537-3.643-5.723z" })
            );
        }
        function Diamonds2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Diamonds2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Diamonds2.SVG = Diamonds2SVG;
        return Diamonds2;
    })();
export const Dice = /*#__PURE__*/ (() => {
        function DiceSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21 1h-18c-1.103 0-2 0.897-2 2v18c0 1.103 0.897 2 2 2h18c1.103 0 2-0.897 2-2v-18c0-1.103-0.897-2-2-2zM21 21h-18v-18h18v18c0 0 0 0 0 0z" }),
_('path', { d: "M7 5c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM7 8c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M12 10c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12 13c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M7 15c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM7 18c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M17 5c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM17 8c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M17 15c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM17 18c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
            );
        }
        function Dice({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DiceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Dice.SVG = DiceSVG;
        return Dice;
    })();
export const DirectionLtr = /*#__PURE__*/ (() => {
        function DirectionLtrSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 2v-1h-8c-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244 2.641 1.756 4.244 1.756h1v9h-2v1h9v-1h-2v-20h2zM16 11c-2.206 0-4-1.794-4-4s1.794-4 4-4h1v8h-1zM21 22h-2v-20h2v20z" }),
_('path', { d: "M5.456 7.044l-1.416 1.416 2.544 2.544h-6.584v2h6.584l-2.544 2.544 1.416 1.416 4.25-4.25c0.391-0.391 0.391-1.025 0-1.416l-4.25-4.253z" })
            );
        }
        function DirectionLtr({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DirectionLtrSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DirectionLtr.SVG = DirectionLtrSVG;
        return DirectionLtr;
    })();
export const DirectionRtl = /*#__PURE__*/ (() => {
        function DirectionRtlSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 2h2v-1h-8c-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244 2.641 1.756 4.244 1.756h1v9h-2v1h9v-1h-2v-20zM6 11c-2.206 0-4-1.794-4-4s1.794-4 4-4h1v8h-1zM9 2h2v20h-2v-20z" }),
_('path', { d: "M24 11h-6.584l2.544-2.544-1.416-1.416-4.25 4.25c-0.391 0.391-0.391 1.025 0 1.416l4.25 4.25 1.416-1.416-2.544-2.541h6.584v-2z" })
            );
        }
        function DirectionRtl({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DirectionRtlSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DirectionRtl.SVG = DirectionRtlSVG;
        return DirectionRtl;
    })();
export const DiscAudio = /*#__PURE__*/ (() => {
        function DiscAudioSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.088 0.181c-0.687-0.122-1.388-0.181-2.088-0.181-1.619 0-3.191 0.319-4.672 0.944-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672 0-0.7-0.059-1.4-0.181-2.088-0.066-0.369-0.147-0.734-0.247-1.097 0.275-0.719 0.428-1.5 0.428-2.319 0-3.581-2.916-6.497-6.5-6.497-0.816 0-1.597 0.15-2.319 0.428-0.359-0.1-0.728-0.181-1.094-0.247zM23 6.5c0 3.031-2.469 5.5-5.5 5.5s-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5zM8 12c0-1.925 1.347-3.547 3.194-3.919 0.081 0.331 0.191 0.65 0.322 0.959-1.425 0.231-2.516 1.472-2.516 2.963 0 1.653 1.347 3 3 3 1.491 0 2.728-1.091 2.962-2.516 0.309 0.131 0.628 0.241 0.959 0.322-0.375 1.847-1.991 3.191-3.922 3.191-2.206 0-4-1.794-4-4zM12.012 11c0 0 0.003 0 0.003 0 0.003 0 0.006 0 0.009 0 0 0 0.003 0 0.003 0 0.003 0 0.006 0 0.009 0 0 0 0 0 0 0 0.522 0.019 0.941 0.441 0.959 0.959 0 0 0 0 0 0 0 0.003 0 0.006 0 0.009 0 0 0 0.003 0 0.003 0 0.003 0 0.006 0 0.009 0 0 0 0.003 0 0.003 0 0.003 0 0.009 0 0.012 0 0.55-0.45 1-1 1s-1-0.45-1-1c0-0.55 0.45-1 1-1 0.006 0.003 0.012 0.003 0.016 0.003zM2 12c0-5.512 4.488-10 10-10 0.263 0 0.525 0.009 0.784 0.031-1.106 1.166-1.784 2.741-1.784 4.469 0 0.2 0.009 0.4 0.028 0.594-1.047 0.206-2.003 0.744-2.728 1.544-0.837 0.922-1.3 2.116-1.3 3.363 0 1.172 0.406 2.253 1.084 3.106l-3.594 3.491c-1.55-1.759-2.491-4.072-2.491-6.597zM5.191 19.316l3.594-3.491c0.409 0.344 0.875 0.625 1.378 0.825l-1.366 4.822c-1.356-0.459-2.581-1.2-3.606-2.156zM12 22c-0.772 0-1.522-0.087-2.244-0.253l1.369-4.825c0.284 0.050 0.578 0.078 0.875 0.078 1.256 0 2.456-0.469 3.381-1.316 0.791-0.725 1.319-1.672 1.525-2.712 0.197 0.019 0.394 0.028 0.594 0.028 1.731 0 3.303-0.678 4.469-1.784 0.019 0.259 0.031 0.522 0.031 0.784 0 5.513-4.488 10-10 10z" }),
_('path', { d: "M14.538 8.722c0.237 0.178 0.531 0.272 0.837 0.272 0.1 0 0.203-0.009 0.303-0.031 0.769-0.156 1.331-0.856 1.319-1.619v-3.203l3 0.75v2.153c-0.216-0.056-0.447-0.066-0.678-0.019-0.8 0.162-1.378 0.919-1.313 1.719 0.031 0.4 0.222 0.747 0.531 0.978 0.237 0.178 0.531 0.272 0.837 0.272 0.1 0 0.203-0.009 0.303-0.031 0.769-0.156 1.331-0.856 1.319-1.619v-3.844c0-0.228-0.156-0.428-0.378-0.484l-4-1c-0.15-0.038-0.306-0.003-0.428 0.091s-0.194 0.241-0.194 0.394v2.544c-0.216-0.056-0.447-0.066-0.678-0.019-0.8 0.162-1.378 0.919-1.313 1.719 0.034 0.397 0.222 0.747 0.531 0.978zM19.481 8.984c-0.131 0.028-0.253 0.006-0.341-0.063-0.078-0.059-0.125-0.15-0.134-0.259-0.022-0.288 0.219-0.597 0.519-0.656 0.037-0.006 0.072-0.012 0.106-0.012 0.091 0 0.172 0.025 0.234 0.072 0.078 0.059 0.125 0.15 0.134 0.259 0 0.009 0 0.022 0 0.031v0.012c-0.003 0.278-0.234 0.559-0.519 0.616zM15.522 7.006c0.037-0.006 0.072-0.012 0.106-0.012 0.091 0 0.172 0.025 0.234 0.072 0.078 0.059 0.125 0.15 0.134 0.259 0 0.009 0 0.022 0 0.031v0.012c-0.003 0.275-0.234 0.556-0.519 0.612-0.131 0.028-0.253 0.006-0.341-0.063-0.078-0.059-0.125-0.15-0.134-0.259-0.022-0.284 0.219-0.594 0.519-0.653z" })
            );
        }
        function DiscAudio({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DiscAudioSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DiscAudio.SVG = DiscAudioSVG;
        return DiscAudio;
    })();
export const DiscBrake = /*#__PURE__*/ (() => {
        function DiscBrakeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 7c-2.756 0-5 2.244-5 5s2.244 5 5 5 5-2.244 5-5c0-2.756-2.244-5-5-5zM12 16c-2.206 0-4-1.794-4-4s1.794-4 4-4c2.206 0 4 1.794 4 4s-1.794 4-4 4z" }),
_('path', { d: "M5 11c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1c0-0.55-0.45-1-1-1zM5 12c0 0 0 0 0 0v0z" }),
_('path', { d: "M7 8c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM7 7v0c0 0 0 0 0 0z" }),
_('path', { d: "M12 6c0.55 0 1-0.45 1-1s-0.45-1-1-1c-0.55 0-1 0.45-1 1s0.45 1 1 1zM12 5v0c0 0 0 0 0 0z" }),
_('path', { d: "M7 16c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM7 17c0 0 0 0 0 0v0z" }),
_('path', { d: "M12 18c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 19c0 0 0 0 0 0v0z" }),
_('path', { d: "M12 10c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12 13c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M18.547 1.941c-0.275-0.178-0.622-0.213-0.925-0.087-0.203 0.084-0.372 0.231-0.481 0.416-1.578-0.831-3.328-1.269-5.141-1.269-1.484 0-2.925 0.291-4.281 0.866-1.309 0.553-2.487 1.347-3.497 2.356s-1.803 2.187-2.356 3.497c-0.575 1.356-0.866 2.797-0.866 4.281s0.291 2.925 0.866 4.281c0.553 1.309 1.347 2.487 2.356 3.497s2.187 1.803 3.497 2.356c1.356 0.575 2.797 0.866 4.281 0.866 1.812 0 3.563-0.438 5.138-1.272 0.109 0.184 0.278 0.334 0.481 0.416 0.122 0.050 0.25 0.075 0.381 0.075 0.191 0 0.381-0.056 0.547-0.162 3.416-2.225 5.453-5.984 5.453-10.056s-2.037-7.831-5.453-10.059zM3 12c0-4.962 4.038-9 9-9 1.669 0 3.272 0.45 4.681 1.309-0.262 1.494-0.453 2.994-0.563 4.478-0.019 0.266 0.069 0.528 0.244 0.731 0.087 0.1 0.191 0.181 0.309 0.237 1.156 0.588 1.328 1.656 1.328 2.241 0 0.588-0.172 1.656-1.334 2.244-0.359 0.181-0.575 0.563-0.547 0.966 0.109 1.484 0.297 2.988 0.563 4.478-1.406 0.859-3.012 1.309-4.681 1.309-4.962 0.006-9-4.031-9-8.994zM18.669 19.453c-0.225-1.259-0.397-2.525-0.506-3.781 0.544-0.384 0.978-0.875 1.294-1.459 0.356-0.659 0.544-1.425 0.544-2.212s-0.188-1.553-0.544-2.212c-0.316-0.588-0.75-1.075-1.294-1.459 0.112-1.256 0.281-2.522 0.506-3.781 2.109 1.884 3.331 4.575 3.331 7.453s-1.222 5.569-3.331 7.453z" })
            );
        }
        function DiscBrake({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DiscBrakeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DiscBrake.SVG = DiscBrakeSVG;
        return DiscBrake;
    })();
export const DiscPlay = /*#__PURE__*/ (() => {
        function DiscPlaySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.822 9.916c-0.066-0.372-0.147-0.741-0.247-1.1 0.275-0.719 0.425-1.5 0.425-2.316 0-3.584-2.916-6.5-6.5-6.5-0.816 0-1.597 0.15-2.316 0.425-0.359-0.1-0.728-0.181-1.097-0.247v0c-0.681-0.119-1.381-0.178-2.088-0.178-1.619 0-3.191 0.319-4.672 0.944-1.428 0.603-2.712 1.469-3.813 2.572s-1.966 2.384-2.572 3.813c-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813s2.384 1.966 3.813 2.572c1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572s1.966-2.384 2.572-3.813c0.625-1.481 0.944-3.053 0.944-4.672 0-0.706-0.059-1.406-0.178-2.084v0zM23 6.5c0 3.031-2.469 5.5-5.5 5.5s-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5zM8 12c0-1.925 1.347-3.547 3.194-3.922 0.081 0.331 0.191 0.65 0.322 0.959-1.425 0.231-2.516 1.472-2.516 2.962 0 1.653 1.347 3 3 3 1.491 0 2.728-1.091 2.962-2.516 0.309 0.131 0.628 0.241 0.959 0.322-0.375 1.85-1.991 3.194-3.922 3.194-2.206 0-4-1.794-4-4zM13 12c0 0.55-0.45 1-1 1s-1-0.45-1-1c0-0.55 0.45-1 1-1s1 0.45 1 1zM2 12c0-5.512 4.488-10 10-10 0.263 0 0.525 0.009 0.784 0.031-1.106 1.166-1.784 2.741-1.784 4.469 0 0.2 0.009 0.397 0.028 0.594-1.047 0.206-2 0.744-2.728 1.544-0.837 0.922-1.3 2.116-1.3 3.363 0 1.172 0.406 2.253 1.084 3.106l-3.594 3.491c-1.55-1.759-2.491-4.072-2.491-6.597zM5.191 19.316l3.594-3.491c0.409 0.344 0.875 0.625 1.378 0.825l-1.366 4.822c-1.356-0.459-2.581-1.2-3.606-2.156zM12 22c-0.772 0-1.522-0.087-2.244-0.253l1.369-4.825c0.284 0.050 0.578 0.078 0.875 0.078 1.256 0 2.456-0.466 3.381-1.316 0.791-0.725 1.319-1.672 1.525-2.712 0.197 0.019 0.394 0.028 0.594 0.028 1.731 0 3.303-0.678 4.469-1.784 0.019 0.259 0.031 0.522 0.031 0.784 0 5.513-4.488 10-10 10z" }),
_('path', { d: "M15.253 9.934c0.075 0.044 0.162 0.066 0.247 0.066 0.091 0 0.178-0.025 0.256-0.072l5-3c0.15-0.091 0.244-0.253 0.244-0.428s-0.091-0.337-0.244-0.428l-5-3c-0.153-0.094-0.347-0.094-0.503-0.006s-0.253 0.256-0.253 0.434v6c0 0.181 0.097 0.347 0.253 0.434zM16 4.384l3.528 2.116-3.528 2.116v-4.231z" })
            );
        }
        function DiscPlay({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DiscPlaySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DiscPlay.SVG = DiscPlaySVG;
        return DiscPlay;
    })();
export const Disc = /*#__PURE__*/ (() => {
        function DiscSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM18.809 4.684l-3.591 3.491c-0.409-0.344-0.875-0.625-1.378-0.825l1.366-4.825c1.353 0.462 2.578 1.203 3.603 2.159zM8 12c0-2.206 1.794-4 4-4s4 1.794 4 4c0 2.206-1.794 4-4 4s-4-1.794-4-4zM2 12c0-5.512 4.488-10 10-10 0.772 0 1.522 0.087 2.244 0.253l-1.369 4.825c-0.284-0.050-0.578-0.078-0.875-0.078-2.756 0-5 2.244-5 5 0 1.172 0.406 2.253 1.084 3.106l-3.594 3.491c-1.55-1.759-2.491-4.072-2.491-6.597zM5.191 19.316l3.594-3.491c0.409 0.344 0.875 0.625 1.378 0.825l-1.366 4.825c-1.356-0.462-2.581-1.203-3.606-2.159zM12 22c-0.772 0-1.522-0.087-2.244-0.253l1.369-4.825c0.284 0.050 0.578 0.078 0.875 0.078 2.756 0 5-2.244 5-5 0-1.172-0.406-2.253-1.084-3.106l3.594-3.491c1.55 1.759 2.491 4.072 2.491 6.597 0 5.512-4.488 10-10 10z" }),
_('path', { d: "M15 12c0-1.653-1.347-3-3-3s-3 1.347-3 3 1.347 3 3 3 3-1.347 3-3zM11 12c0-0.55 0.45-1 1-1s1 0.45 1 1c0 0.55-0.45 1-1 1s-1-0.45-1-1z" })
            );
        }
        function Disc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DiscSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Disc.SVG = DiscSVG;
        return Disc;
    })();
export const Disposal = /*#__PURE__*/ (() => {
        function DisposalSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 5c1.103 0 2-0.897 2-2s-0.897-2-2-2-2 0.897-2 2 0.897 2 2 2zM7 2c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M21.019 11.803l-1.837 9.197h-3.363l-1.841-9.197-1.962 0.394 2 10c0.094 0.469 0.503 0.803 0.981 0.803h5c0.478 0 0.888-0.338 0.981-0.803l2-10-1.959-0.394z" }),
_('path', { d: "M16 14.5c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5zM18 14.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5z" }),
_('path', { d: "M17 11.5v0.5h1v-0.5c0-0.247-0.016-0.897-0.162-1.572-0.197-0.9-0.556-1.522-1.066-1.85l-0.422-0.272-0.541 0.841 0.422 0.272c0.531 0.344 0.769 1.544 0.769 2.581z" }),
_('path', { d: "M9.987 9.922c0.156 0.094 0.334 0.141 0.513 0.141 0.181 0 0.366-0.050 0.525-0.15l3.75-2.313-1.050-1.703-3.206 1.978c-0.628-0.441-1.75-1.309-2.747-2.513 0 0 0 0 0 0s0 0 0 0v0c-0.087-0.106-0.197-0.194-0.322-0.256-0.338-0.169-0.744-0.134-1.047 0.094l-3.341 2.5c-0.122 0.091-0.222 0.209-0.291 0.347l-1.909 3.75 1.781 0.906 1.803-3.544 1.556-1.162v3.919l-0.947 5.672-3.1 4.056 1.587 1.216 3.25-4.25c0.1-0.131 0.166-0.281 0.191-0.444l0.556-3.322 1.413 2.356-0.941 5.637 1.972 0.328 1-6c0.041-0.234-0.006-0.475-0.128-0.678l-2.856-4.766v-3.281c1.069 0.928 1.934 1.45 1.988 1.481z" })
            );
        }
        function Disposal({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DisposalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Disposal.SVG = DisposalSVG;
        return Disposal;
    })();
export const DivingMask = /*#__PURE__*/ (() => {
        function DivingMaskSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8.097 13.2l1.5-2c0.131-0.175 0.306-0.2 0.4-0.2s0.272 0.025 0.4 0.2l1.5 2c0.375 0.5 0.975 0.8 1.6 0.8h2.984c0.681 0 1.347-0.234 1.878-0.659s0.903-1.025 1.053-1.688c0 0 0 0 0 0 0.237-1.059 0.531-2.778 0.581-4.95 0.019-0.819-0.475-1.581-1.234-1.894-2.897-1.2-5.847-1.809-8.759-1.809s-5.862 0.609-8.766 1.809c-0.756 0.312-1.253 1.075-1.234 1.894 0.053 2.172 0.347 3.891 0.584 4.95 0.147 0.663 0.522 1.263 1.053 1.688s1.197 0.659 1.878 0.659h2.984c0.622 0 1.222-0.3 1.597-0.8zM2.534 11.219c-0.216-0.972-0.487-2.55-0.534-4.563 5.309-2.194 10.691-2.194 16 0-0.050 2.009-0.319 3.591-0.534 4.563-0.103 0.459-0.506 0.781-0.978 0.781h-2.984l-1.5-2c-0.478-0.634-1.206-1-2-1s-1.525 0.366-2 1l-1.503 2h-2.984c-0.475 0-0.878-0.322-0.981-0.781z" }),
_('path', { d: "M10.5 18c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM10.5 20c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M23.5 0h-2c-0.275 0-0.5 0.225-0.5 0.5v15c0 1.378-1.122 2.5-2.5 2.5h-3.756c-0.619-1.747-2.288-3-4.244-3-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5c1.956 0 3.625-1.253 4.244-3h3.756c3.031 0 5.5-2.469 5.5-5.5v-15c0-0.275-0.225-0.5-0.5-0.5zM10.5 22c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5zM23 15.5c0 2.481-2.019 4.5-4.5 4.5h-3.528c0.019-0.166 0.028-0.331 0.028-0.5s-0.009-0.334-0.028-0.5h3.528c1.931 0 3.5-1.569 3.5-3.5v-14.5h1v14.5z" }),
_('path', { d: "M2.793 8.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M3.792 10.5l3.708-3.708 0.707 0.707-3.708 3.708-0.707-0.707z" })
            );
        }
        function DivingMask({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DivingMaskSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DivingMask.SVG = DivingMaskSVG;
        return DivingMask;
    })();
export const DivingWarning = /*#__PURE__*/ (() => {
        function DivingWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 14c1.103 0 2-0.897 2-2s-0.897-2-2-2-2 0.897-2 2c0 1.103 0.897 2 2 2zM18 11c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1c0-0.55 0.45-1 1-1z" }),
_('path', { d: "M21.775 21.553c-0.481 0.241-0.894 0.447-1.775 0.447s-1.297-0.206-1.775-0.447c-0.519-0.259-1.106-0.553-2.225-0.553s-1.706 0.294-2.225 0.553c-0.481 0.241-0.894 0.447-1.775 0.447s-1.297-0.206-1.775-0.447c-0.519-0.259-1.106-0.553-2.225-0.553s-1.706 0.294-2.225 0.553c-0.481 0.241-0.894 0.447-1.775 0.447s-1.297-0.206-1.775-0.447c-0.519-0.259-1.106-0.553-2.225-0.553v1c0.881 0 1.297 0.206 1.775 0.447 0.519 0.259 1.106 0.553 2.225 0.553s1.706-0.294 2.225-0.553c0.481-0.241 0.894-0.447 1.775-0.447s1.297 0.206 1.775 0.447c0.519 0.259 1.106 0.553 2.225 0.553s1.706-0.294 2.225-0.553c0.481-0.241 0.894-0.447 1.775-0.447s1.297 0.206 1.775 0.447c0.519 0.259 1.106 0.553 2.225 0.553s1.706-0.294 2.225-0.553c0.481-0.241 0.894-0.447 1.775-0.447v-1c-1.119 0-1.706 0.294-2.225 0.553z" }),
_('path', { d: "M6.4 6.8l3.944 2.956 3.766 3.766 1.928 6.75 1.922-0.55-2-7c-0.047-0.162-0.134-0.312-0.253-0.431l-3.869-3.866-1.894-4.263-0.981-3.553-1.928 0.531 1 3.625c0.012 0.047 0.031 0.094 0.050 0.141l0.438 0.987-0.725-0.544-1.891-4.025-1.812 0.85 2 4.25c0.072 0.15 0.175 0.278 0.306 0.375z" }),
_('path', { d: "M5 17h1v1h-1v-1z" }),
_('path', { d: "M5 12h1v4h-1v-4z" }),
_('path', { d: "M1.5 20h8c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672l-4-7.997c-0.25-0.506-0.778-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-4 8c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5zM1.050 18.281l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219z" })
            );
        }
        function DivingWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DivingWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DivingWarning.SVG = DivingWarningSVG;
        return DivingWarning;
    })();
export const Diving = /*#__PURE__*/ (() => {
        function DivingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 14c1.103 0 2-0.897 2-2s-0.897-2-2-2-2 0.897-2 2c0 1.103 0.897 2 2 2zM18 11c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1c0-0.55 0.45-1 1-1z" }),
_('path', { d: "M21.775 21.553c-0.481 0.241-0.894 0.447-1.775 0.447s-1.297-0.206-1.775-0.447c-0.519-0.259-1.106-0.553-2.225-0.553s-1.706 0.294-2.225 0.553c-0.481 0.241-0.894 0.447-1.775 0.447s-1.297-0.206-1.775-0.447c-0.519-0.259-1.106-0.553-2.225-0.553s-1.706 0.294-2.225 0.553c-0.481 0.241-0.894 0.447-1.775 0.447s-1.297-0.206-1.775-0.447c-0.519-0.259-1.106-0.553-2.225-0.553v1c0.881 0 1.297 0.206 1.775 0.447 0.519 0.259 1.106 0.553 2.225 0.553s1.706-0.294 2.225-0.553c0.481-0.241 0.894-0.447 1.775-0.447s1.297 0.206 1.775 0.447c0.519 0.259 1.106 0.553 2.225 0.553s1.706-0.294 2.225-0.553c0.481-0.241 0.894-0.447 1.775-0.447s1.297 0.206 1.775 0.447c0.519 0.259 1.106 0.553 2.225 0.553s1.706-0.294 2.225-0.553c0.481-0.241 0.894-0.447 1.775-0.447v-1c-1.119 0-1.706 0.294-2.225 0.553z" }),
_('path', { d: "M6.4 6.8l3.944 2.956 3.766 3.766 1.928 6.75 1.922-0.55-2-7c-0.047-0.162-0.134-0.312-0.253-0.431l-3.869-3.866-1.894-4.263-0.981-3.553-1.928 0.531 1 3.625c0.012 0.047 0.031 0.094 0.050 0.141l0.438 0.987-0.725-0.544-1.891-4.025-1.812 0.85 2 4.25c0.072 0.15 0.175 0.278 0.306 0.375z" })
            );
        }
        function Diving({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DivingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Diving.SVG = DivingSVG;
        return Diving;
    })();
export const DnaCode = /*#__PURE__*/ (() => {
        function DnaCodeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.338 22.062c0.963-0.822 2.284-1.647 3.684-2.519 1.612-1.003 3.278-2.044 4.575-3.197 1.616-1.441 2.403-2.862 2.403-4.347 0-2.575-2.372-4.522-4.691-6.081l-1.116 1.659c0.7 0.472 1.441 1.003 2.078 1.575l-8.003 1.778c0.828-1.697 3.428-3.319 5.769-4.775 1.466-0.912 2.847-1.775 3.925-2.694 0.875-0.75 2.037-1.922 2.037-3.462h-2c0 0 0 0 0 0.003l-8.525 2.050c-0.813-0.672-1.475-1.409-1.475-2.053h-2c0 2.172 2.309 3.831 4.675 5.344l1.075-1.688c-0.341-0.219-0.784-0.5-1.244-0.822l6.941-1.672c-0.206 0.244-0.469 0.503-0.787 0.775-0.963 0.822-2.284 1.647-3.684 2.519-1.612 1.003-3.278 2.044-4.575 3.197-1.613 1.441-2.4 2.862-2.4 4.347 0 2.575 2.372 4.522 4.691 6.081l1.116-1.659c-0.663-0.447-1.362-0.947-1.978-1.484l7.838-1.741c-0.891 1.653-3.422 3.228-5.703 4.65-1.466 0.912-2.847 1.775-3.925 2.694-0.875 0.747-2.037 1.919-2.037 3.459h2c0 0 0-0.003 0-0.003v0.003l8.688-1.919c0.734 0.634 1.313 1.319 1.313 1.919h2c0-2.172-2.309-3.831-4.675-5.344l-1.075 1.688c0.381 0.244 0.891 0.569 1.413 0.941l-7.125 1.575c0.203-0.253 0.472-0.516 0.8-0.797zM12.981 14.103c-0.588-0.666-0.978-1.372-0.981-2.091l9.1-2.022c0.544 0.644 0.9 1.322 0.9 2.009 0 0.034 0 0.066-0.003 0.1l-9.016 2.003z" }),
_('path', { d: "M2.691 9.038c-0.188-0.078-0.403-0.034-0.544 0.109l-1.353 1.353 0.706 0.706 0.5-0.5v3.294h1v-4.5c0-0.203-0.122-0.384-0.309-0.462z" }),
_('path', { d: "M2.5 2c-0.312 0-0.781 0-1.113 0.456-0.272 0.375-0.387 0.987-0.387 2.044s0.116 1.669 0.387 2.044c0.331 0.456 0.8 0.456 1.113 0.456s0.781 0 1.113-0.456c0.272-0.375 0.387-0.987 0.387-2.044s-0.116-1.669-0.387-2.044c-0.331-0.456-0.8-0.456-1.113-0.456zM2.803 5.956c-0.022 0.031-0.053 0.044-0.303 0.044s-0.278-0.012-0.303-0.044c-0.059-0.081-0.197-0.387-0.197-1.456s0.138-1.375 0.197-1.456c0.022-0.031 0.053-0.044 0.303-0.044s0.278 0.012 0.303 0.044c0.059 0.081 0.197 0.387 0.197 1.456s-0.138 1.375-0.197 1.456z" }),
_('path', { d: "M7 14v-4.5c0-0.203-0.122-0.384-0.309-0.462s-0.403-0.034-0.544 0.109l-1.353 1.353 0.706 0.706 0.5-0.5v3.294h1z" }),
_('path', { d: "M2.691 16.038c-0.188-0.078-0.403-0.034-0.544 0.109l-1.353 1.353 0.706 0.706 0.5-0.5v3.294h1v-4.5c0-0.203-0.122-0.384-0.309-0.462z" }),
_('path', { d: "M6.5 2c-0.312 0-0.781 0-1.113 0.456-0.272 0.375-0.387 0.987-0.387 2.044s0.116 1.669 0.387 2.044c0.331 0.456 0.8 0.456 1.113 0.456s0.781 0 1.113-0.456c0.272-0.375 0.387-0.987 0.387-2.044s-0.116-1.669-0.387-2.044c-0.331-0.456-0.8-0.456-1.113-0.456zM6.803 5.956c-0.022 0.031-0.053 0.044-0.303 0.044s-0.278-0.012-0.303-0.044c-0.059-0.081-0.197-0.387-0.197-1.456s0.138-1.375 0.197-1.456c0.022-0.031 0.053-0.044 0.303-0.044s0.278 0.012 0.303 0.044c0.059 0.081 0.197 0.387 0.197 1.456s-0.138 1.375-0.197 1.456z" }),
_('path', { d: "M6.5 16c-0.312 0-0.781 0-1.113 0.456-0.272 0.375-0.387 0.987-0.387 2.044s0.116 1.669 0.387 2.044c0.331 0.456 0.8 0.456 1.113 0.456s0.781 0 1.113-0.456c0.272-0.375 0.387-0.987 0.387-2.044s-0.116-1.669-0.387-2.044c-0.331-0.456-0.8-0.456-1.113-0.456zM6.803 19.956c-0.022 0.031-0.053 0.044-0.303 0.044s-0.278-0.012-0.303-0.044c-0.059-0.081-0.197-0.387-0.197-1.456s0.138-1.375 0.197-1.456c0.022-0.031 0.053-0.044 0.303-0.044s0.278 0.012 0.303 0.044c0.059 0.081 0.197 0.387 0.197 1.456s-0.138 1.375-0.197 1.456z" })
            );
        }
        function DnaCode({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DnaCodeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DnaCode.SVG = DnaCodeSVG;
        return DnaCode;
    })();
export const Dna = /*#__PURE__*/ (() => {
    function DnaSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.337 22.062c0.963-0.822 2.284-1.647 3.684-2.519 1.612-1.003 3.278-2.044 4.575-3.197 1.616-1.441 2.403-2.862 2.403-4.347 0-2.578-2.372-4.522-4.691-6.081l-1.116 1.659c0.7 0.472 1.441 1.003 2.078 1.572l-8.003 1.778c0.828-1.697 3.428-3.319 5.769-4.775 1.466-0.912 2.847-1.775 3.925-2.694 0.875-0.747 2.037-1.919 2.037-3.459h-2c0 0 0 0 0 0.003l-8.525 2.050c-0.813-0.672-1.475-1.409-1.475-2.053h-2c0 2.172 2.309 3.831 4.675 5.344l1.078-1.684c-0.341-0.219-0.784-0.5-1.244-0.822l6.941-1.672c-0.206 0.244-0.466 0.503-0.784 0.775-0.963 0.822-2.284 1.647-3.684 2.519-1.613 1.003-3.278 2.044-4.575 3.197-1.619 1.437-2.406 2.859-2.406 4.344 0 2.578 2.372 4.522 4.691 6.081l1.116-1.659c-0.663-0.447-1.362-0.947-1.978-1.484l7.837-1.741c-0.891 1.653-3.419 3.228-5.703 4.65-1.466 0.912-2.847 1.775-3.925 2.694-0.875 0.747-2.037 1.919-2.037 3.459h2c0 0 0-0.003 0-0.003v0.003l8.688-1.919c0.738 0.634 1.313 1.319 1.313 1.919h2c0-2.172-2.309-3.831-4.675-5.344l-1.078 1.688c0.381 0.244 0.891 0.569 1.413 0.941l-7.125 1.572c0.206-0.25 0.475-0.513 0.803-0.794zM7.981 14.103c-0.584-0.666-0.975-1.372-0.981-2.091l9.1-2.022c0.544 0.644 0.9 1.322 0.9 2.009 0 0.034 0 0.066-0.003 0.1l-9.016 2.003z" })
        );
    }
    function Dna({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DnaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Dna.SVG = DnaSVG;
    return Dna;
})();
export const Donut = /*#__PURE__*/ (() => {
        function DonutSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1 8.384c0.625-1.075 1.509-2.031 2.634-2.85 2.247-1.634 5.219-2.534 8.366-2.534s6.119 0.9 8.366 2.534c1.125 0.816 2.009 1.775 2.634 2.85 0.663 1.141 1 2.356 1 3.616s-0.337 2.475-1 3.616c-0.625 1.075-1.509 2.031-2.634 2.85-2.247 1.634-5.219 2.534-8.366 2.534s-6.119-0.9-8.366-2.534c-1.122-0.816-2.009-1.775-2.634-2.85-0.663-1.141-1-2.356-1-3.616s0.338-2.475 1-3.616zM19.191 7.153c-1.909-1.387-4.462-2.153-7.191-2.153s-5.281 0.766-7.191 2.153c-1.812 1.316-2.809 3.037-2.809 4.847 0 0.259 0.022 0.516 0.063 0.772 0.056 0.006 0.112 0.009 0.172 0.012 0.522 0.041 1.059 0.084 1.512 0.344 0.472 0.272 0.791 0.725 1.1 1.166 0.275 0.394 0.534 0.762 0.828 0.881 0.316 0.128 0.775 0.034 1.256-0.066 0.509-0.103 1.038-0.213 1.544-0.094 0.519 0.122 0.947 0.453 1.366 0.775 0.384 0.297 0.75 0.578 1.075 0.603 0.331 0.025 0.734-0.206 1.159-0.447 0.456-0.259 0.925-0.525 1.45-0.572 0.522-0.047 1.028 0.134 1.519 0.309 0.462 0.166 0.903 0.322 1.228 0.237 0.312-0.078 0.622-0.412 0.947-0.769 0.363-0.391 0.734-0.797 1.234-1.003 0.484-0.2 1.022-0.172 1.544-0.147 0.494 0.025 0.956 0.047 1.253-0.128 0.25-0.144 0.444-0.494 0.641-0.878 0.069-0.328 0.103-0.663 0.103-1 0.006-1.806-0.991-3.528-2.803-4.844zM4.809 16.847c1.909 1.388 4.463 2.153 7.191 2.153s5.281-0.766 7.191-2.153c0.766-0.556 1.388-1.188 1.847-1.866-0.363 0.053-0.738 0.037-1.084 0.019-0.431-0.022-0.837-0.041-1.116 0.075-0.294 0.122-0.578 0.431-0.881 0.756-0.413 0.447-0.841 0.909-1.441 1.059-0.619 0.153-1.25-0.069-1.806-0.266-0.409-0.144-0.794-0.281-1.097-0.256-0.309 0.028-0.666 0.231-1.047 0.447-0.481 0.272-1.019 0.578-1.606 0.578-0.038 0-0.078 0-0.119-0.003-0.628-0.044-1.131-0.434-1.616-0.809-0.347-0.269-0.675-0.522-0.981-0.594-0.294-0.069-0.694 0.012-1.116 0.1-0.578 0.119-1.234 0.253-1.831 0.016-0.572-0.228-0.928-0.741-1.278-1.237-0.256-0.366-0.497-0.713-0.778-0.872-0.219-0.128-0.55-0.169-0.909-0.2 0.441 1.137 1.281 2.184 2.478 3.053z" }),
_('path', { d: "M18.219 8.872c-1.534-1.188-3.803-1.872-6.219-1.872v-1c2.634 0 5.125 0.759 6.831 2.078l0.397 0.306-0.612 0.791-0.397-0.303z" }),
_('path', { d: "M14.672 10.481c0.516 0.222 0.834 0.478 1.031 0.725 0.566-0.281 1.050-0.634 1.428-1.044l0.341-0.366 0.734 0.678-0.341 0.366c-0.647 0.7-1.512 1.247-2.572 1.625-0.963 0.344-2.063 0.528-3.181 0.537-0.025 0-0.050 0-0.072 0-2.416 0-4.619-0.803-5.903-2.156l-0.344-0.363 0.725-0.687 0.344 0.363c0.387 0.406 0.875 0.756 1.444 1.038 0.197-0.244 0.516-0.497 1.022-0.713 0.722-0.312 1.672-0.484 2.672-0.484s1.95 0.172 2.672 0.481zM12.106 12c0.916-0.006 1.791-0.141 2.575-0.387-0.459-0.306-1.4-0.612-2.681-0.612-1.269 0-2.203 0.3-2.666 0.603 0.841 0.266 1.784 0.403 2.772 0.397z" })
            );
        }
        function Donut({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DonutSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Donut.SVG = DonutSVG;
        return Donut;
    })();
export const Dork = /*#__PURE__*/ (() => {
        function DorkSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 2c4.094 0 7.619 2.472 9.166 6h-2.2c-0.244-1.694-1.703-3-3.466-3s-3.222 1.306-3.466 3h-0.072c-0.244-1.694-1.703-3-3.466-3s-3.222 1.306-3.466 3h-2.197c1.547-3.528 5.072-6 9.166-6zM15.5 6c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5-2.5-1.122-2.5-2.5 1.122-2.5 2.5-2.5zM8.5 6c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5-2.5-1.122-2.5-2.5 1.122-2.5 2.5-2.5zM12 22c-5.512 0-10-4.488-10-10 0-1.044 0.162-2.053 0.459-3h2.575c0.244 1.694 1.703 3 3.466 3s3.222-1.306 3.466-3h0.072c0.244 1.694 1.703 3 3.466 3s3.222-1.306 3.466-3h2.575c0.3 0.947 0.459 1.956 0.459 3-0.003 5.513-4.491 10-10.003 10z" }),
_('path', { d: "M8.5 10c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM8.5 8c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M15.5 10c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM15.5 8c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M12 14c-1.762 0-3.559 0.325-5.659 1.025l-0.475 0.159 0.316 0.95 0.475-0.159c0.819-0.272 1.594-0.487 2.341-0.647v1.172c0 0.275 0.225 0.5 0.5 0.5h1.5v0.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-2.172c0.75 0.159 1.522 0.375 2.341 0.647l0.475 0.159 0.316-0.95-0.475-0.159c-2.094-0.7-3.891-1.025-5.653-1.025zM10 15.15c0.337-0.050 0.669-0.084 1-0.109v0.959h-1v-0.85zM14 17h-2v-2c0.663 0 1.325 0.050 2 0.147v1.853z" })
            );
        }
        function Dork({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DorkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Dork.SVG = DorkSVG;
        return Dork;
    })();
export const DownloadCircle = /*#__PURE__*/ (() => {
        function DownloadCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M8 17h8v1h-8v-1z" }),
_('path', { d: "M16.956 12.456l-1.416-1.416-2.541 2.544v-7.584h-2v7.584l-2.544-2.544-1.416 1.416 4.25 4.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l4.253-4.25z" })
            );
        }
        function DownloadCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DownloadCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DownloadCircle.SVG = DownloadCircleSVG;
        return DownloadCircle;
    })();
export const DownloadSquare = /*#__PURE__*/ (() => {
        function DownloadSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20l20-0.003c0 0 0 0 0 0.003v20z" }),
_('path', { d: "M8 17h8v1h-8v-1z" }),
_('path', { d: "M12 17c0.256 0 0.513-0.097 0.706-0.294l4.25-4.25-1.416-1.416-2.541 2.544v-7.584h-2v7.584l-2.544-2.544-1.416 1.416 4.25 4.25c0.197 0.197 0.453 0.294 0.709 0.294z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" })
            );
        }
        function DownloadSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DownloadSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DownloadSquare.SVG = DownloadSquareSVG;
        return DownloadSquare;
    })();
export const Download = /*#__PURE__*/ (() => {
        function DownloadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 18v4h-20v-4h-2v4c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-4h-2z" }),
_('path', { d: "M12 18c0.256 0 0.513-0.097 0.706-0.294l5.25-5.25-1.416-1.416-3.541 3.544v-14.584h-2v14.584l-3.544-3.541-1.416 1.416 5.25 5.25c0.197 0.194 0.453 0.291 0.709 0.291z" })
            );
        }
        function Download({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DownloadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Download.SVG = DownloadSVG;
        return Download;
    })();
export const DrawerDownload = /*#__PURE__*/ (() => {
        function DrawerDownloadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.753 14.037v0l-4.816-8.778c-0.087-0.159-0.256-0.259-0.438-0.259h-3.5v1h3.203l3.841 7c-0.016 0-0.028 0-0.044 0h-6.5c-0.275 0-0.5 0.225-0.5 0.5v0.5c0 1.653-1.347 3-3 3s-3-1.347-3-3v-0.5c0-0.275-0.225-0.5-0.5-0.5h-6.5c-0.016 0-0.028 0-0.044 0l3.841-7h3.203v-1h-3.5c-0.181 0-0.35 0.1-0.438 0.259l-4.816 8.778c-0.156 0.288-0.247 0.616-0.247 0.963v6c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-6c0-0.347-0.091-0.675-0.247-0.963zM22 21h-20v-6h6.125c0.444 1.722 2.013 3 3.875 3 1.859 0 3.428-1.278 3.875-3h6.125v6z" }),
_('path', { d: "M8.456 7.044l-1.416 1.416 4.25 4.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l4.25-4.25-1.416-1.416-2.538 2.541v-8.584h-2v8.584l-2.544-2.541z" })
            );
        }
        function DrawerDownload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DrawerDownloadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DrawerDownload.SVG = DrawerDownloadSVG;
        return DrawerDownload;
    })();
export const DrawerFull = /*#__PURE__*/ (() => {
        function DrawerFullSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.753 12.038v0l-4.816-8.778c-0.087-0.159-0.256-0.259-0.438-0.259h-13c-0.181 0-0.35 0.1-0.438 0.259l-4.816 8.778c-0.156 0.288-0.247 0.616-0.247 0.963v6c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-6c0-0.347-0.091-0.675-0.247-0.963zM22 19h-20v-6h6.125c0.444 1.722 2.013 3 3.875 3 1.859 0 3.428-1.278 3.875-3h6.125v6zM15.5 11c-0.275 0-0.5 0.225-0.5 0.5v0.5c0 1.653-1.347 3-3 3s-3-1.347-3-3v-0.5c0-0.275-0.225-0.5-0.5-0.5h-6.5c-0.016 0-0.028 0-0.044 0l3.841-7h12.409l3.841 7c-0.016 0-0.028 0-0.044 0h-6.503z" }),
_('path', { d: "M4 9h16v1h-16v-1z" }),
_('path', { d: "M5 7h14v1h-14v-1z" }),
_('path', { d: "M6 5h12v1h-12v-1z" })
            );
        }
        function DrawerFull({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DrawerFullSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DrawerFull.SVG = DrawerFullSVG;
        return DrawerFull;
    })();
export const DrawerFull2 = /*#__PURE__*/ (() => {
        function DrawerFull2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.753 12.038v0l-4.816-8.778c-0.087-0.159-0.256-0.259-0.438-0.259h-13c-0.181 0-0.35 0.1-0.438 0.259l-4.816 8.778c-0.156 0.288-0.247 0.616-0.247 0.963v6c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-6c0-0.347-0.091-0.675-0.247-0.963zM22 19h-20v-6h20v6zM2 11c-0.016 0-0.028 0-0.044 0l3.841-7h12.409l3.841 7c-0.016 0-0.028 0-0.044 0h-20.003z" }),
_('path', { d: "M4 9h16v1h-16v-1z" }),
_('path', { d: "M5 7h14v1h-14v-1z" }),
_('path', { d: "M6 5h12v1h-12v-1z" }),
_('path', { d: "M9 16.5c0-0.275 0.225-0.5 0.5-0.5h5c0.275 0 0.5 0.225 0.5 0.5v0.5h1v-0.5c0-0.828-0.672-1.5-1.5-1.5h-5c-0.828 0-1.5 0.672-1.5 1.5v0.5h1v-0.5z" })
            );
        }
        function DrawerFull2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DrawerFull2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DrawerFull2.SVG = DrawerFull2SVG;
        return DrawerFull2;
    })();
export const DrawerPaper = /*#__PURE__*/ (() => {
        function DrawerPaperSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.753 13.038v0l-4.753-8.666v-1.872c0-0.275-0.225-0.5-0.5-0.5h-13c-0.275 0-0.5 0.225-0.5 0.5v1.872l-4.753 8.666c-0.156 0.288-0.247 0.616-0.247 0.963v6c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-6c0-0.347-0.091-0.675-0.247-0.963zM18 3v7h-12v-7h12zM22 20h-20v-6h6.125c0.444 1.722 2.013 3 3.875 3 1.859 0 3.428-1.278 3.875-3h6.125v6zM15.5 12c-0.275 0-0.5 0.225-0.5 0.5v0.5c0 1.653-1.347 3-3 3s-3-1.347-3-3v-0.5c0-0.275-0.225-0.5-0.5-0.5h-6.5c-0.016 0-0.028 0-0.044 0l3.044-5.55v3.55h-1v1h16v-1h-1v-3.55l3.044 5.55c-0.016 0-0.028 0-0.044 0h-6.5z" }),
_('path', { d: "M7 4h5v1h-5v-1z" }),
_('path', { d: "M7 6h10v1h-10v-1z" }),
_('path', { d: "M7 8h9v1h-9v-1z" })
            );
        }
        function DrawerPaper({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DrawerPaperSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DrawerPaper.SVG = DrawerPaperSVG;
        return DrawerPaper;
    })();
export const DrawerPaper2 = /*#__PURE__*/ (() => {
        function DrawerPaper2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 4h5v1h-5v-1z" }),
_('path', { d: "M7 6h10v1h-10v-1z" }),
_('path', { d: "M7 8h9v1h-9v-1z" }),
_('path', { d: "M23.753 13.038v0l-4.753-8.666v-1.872c0-0.275-0.225-0.5-0.5-0.5h-13c-0.275 0-0.5 0.225-0.5 0.5v1.872l-4.753 8.666c-0.156 0.288-0.247 0.616-0.247 0.963v6c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-6c0-0.347-0.091-0.675-0.247-0.963zM18 3v7h-12v-7h12zM22 20h-20v-6h20v6zM2 12c-0.016 0-0.028 0-0.044 0l3.044-5.55v3.55h-1v1h16v-1h-1v-3.55l3.044 5.55c-0.016 0-0.028 0-0.044 0h-20z" }),
_('path', { d: "M9 17.5c0-0.275 0.225-0.5 0.5-0.5h5c0.275 0 0.5 0.225 0.5 0.5v0.5h1v-0.5c0-0.828-0.672-1.5-1.5-1.5h-5c-0.828 0-1.5 0.672-1.5 1.5v0.5h1v-0.5z" })
            );
        }
        function DrawerPaper2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DrawerPaper2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DrawerPaper2.SVG = DrawerPaper2SVG;
        return DrawerPaper2;
    })();
export const DrawerSync = /*#__PURE__*/ (() => {
        function DrawerSyncSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.753 15.038l-1.991-3.631c1.372-1.194 2.238-2.95 2.238-4.906 0-3.584-2.916-6.5-6.5-6.5-3.416 0-6.225 2.65-6.481 6h-5.519c-0.181 0-0.35 0.1-0.438 0.259l-4.816 8.778c-0.156 0.288-0.247 0.616-0.247 0.963v6c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-6c0-0.347-0.091-0.675-0.247-0.963v0zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM22 22h-20v-6h6.125c0.444 1.722 2.013 3 3.875 3 1.859 0 3.428-1.278 3.875-3h6.125v6zM15.5 14c-0.275 0-0.5 0.225-0.5 0.5v0.5c0 1.653-1.347 3-3 3s-3-1.347-3-3v-0.5c0-0.275-0.225-0.5-0.5-0.5h-6.5c-0.016 0-0.028 0-0.044 0l3.841-7h5.222c0.256 3.35 3.066 6 6.481 6 1.266 0 2.45-0.366 3.45-0.994l1.094 1.994c-0.016 0-0.028 0-0.044 0h-6.5z" }),
_('path', { d: "M4 12h9v1h-9v-1z" }),
_('path', { d: "M5 10h6v1h-6v-1z" }),
_('path', { d: "M6 8h4v1h-4v-1z" }),
_('path', { d: "M15 6.5c0-1.306 1.006-2.381 2.284-2.491l-0.491 0.491 0.706 0.706 1.353-1.353c0.194-0.194 0.194-0.513 0-0.706l-1.353-1.353-0.706 0.706 0.506 0.506c-1.837 0.103-3.3 1.631-3.3 3.494v0.5h1v-0.5z" }),
_('path', { d: "M18.206 8.5l-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706-0.506-0.506c1.837-0.103 3.3-1.631 3.3-3.494v-0.5h-1v0.5c0 1.306-1.006 2.381-2.284 2.491l0.491-0.491z" })
            );
        }
        function DrawerSync({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DrawerSyncSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DrawerSync.SVG = DrawerSyncSVG;
        return DrawerSync;
    })();
export const DrawerUpload = /*#__PURE__*/ (() => {
        function DrawerUploadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.753 14.037v0l-5.056-9.216-0.878 0.481 4.225 7.697c-0.016 0-0.028 0-0.044 0h-6.5c-0.275 0-0.5 0.225-0.5 0.5v0.5c0 1.653-1.347 3-3 3s-3-1.347-3-3v-0.5c0-0.275-0.225-0.5-0.5-0.5h-6.5c-0.016 0-0.028 0-0.044 0l4.222-7.697-0.878-0.481-5.053 9.216c-0.156 0.288-0.247 0.616-0.247 0.963v6c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-6c0-0.347-0.091-0.675-0.247-0.963zM22 21h-20v-6h6.125c0.444 1.722 2.013 3 3.875 3 1.859 0 3.428-1.278 3.875-3h6.125v6z" }),
_('path', { d: "M11 4.416v8.584h2v-8.584l2.544 2.544 1.416-1.416-4.25-4.25c-0.391-0.391-1.025-0.391-1.416 0l-4.25 4.25 1.416 1.416 2.541-2.544z" })
            );
        }
        function DrawerUpload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DrawerUploadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DrawerUpload.SVG = DrawerUploadSVG;
        return DrawerUpload;
    })();
export const DrawerWarning = /*#__PURE__*/ (() => {
        function DrawerWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.753 15.038l-2.216-4.038h0.963c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672l-4-7.997c-0.25-0.506-0.775-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-2.584 5.172h-9.075c-0.181 0-0.35 0.1-0.438 0.259l-4.816 8.778c-0.156 0.288-0.247 0.616-0.247 0.963v6c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-6c0-0.347-0.091-0.675-0.247-0.963v0zM18.053 1.275c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006zM22 22h-20v-6h6.125c0.444 1.722 2.013 3 3.875 3 1.859 0 3.428-1.278 3.875-3h6.125v6zM15.5 14c-0.275 0-0.5 0.225-0.5 0.5v0.5c0 1.653-1.347 3-3 3s-3-1.347-3-3v-0.5c0-0.275-0.225-0.5-0.5-0.5h-6.5c-0.016 0-0.028 0-0.044 0l3.841-7h8.278l-0.912 1.828c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h5.897l1.647 3c-0.016 0-0.028 0-0.044 0h-6.503z" }),
_('path', { d: "M4 12h16v1h-16v-1z" }),
_('path', { d: "M5 10h7v1h-7v-1z" }),
_('path', { d: "M6 8h6v1h-6v-1z" }),
_('path', { d: "M18 8h1v1h-1v-1z" }),
_('path', { d: "M18 3h1v4h-1v-4z" })
            );
        }
        function DrawerWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DrawerWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DrawerWarning.SVG = DrawerWarningSVG;
        return DrawerWarning;
    })();
export const Drawer = /*#__PURE__*/ (() => {
    function DrawerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.753 12.041v0l-4.816-8.781c-0.087-0.159-0.256-0.259-0.438-0.259h-13c-0.181 0-0.35 0.1-0.438 0.259l-4.816 8.781c-0.156 0.284-0.247 0.612-0.247 0.959v6c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-6c0-0.347-0.091-0.675-0.247-0.959zM22 19h-20v-6h6.125c0.444 1.722 2.013 3 3.875 3 1.859 0 3.428-1.278 3.875-3h6.125v6zM15.5 11c-0.275 0-0.5 0.225-0.5 0.5v0.5c0 1.653-1.347 3-3 3s-3-1.347-3-3v-0.5c0-0.275-0.225-0.5-0.5-0.5h-6.5c-0.016 0-0.028 0-0.044 0l3.841-7h12.409l3.841 7c-0.016 0-0.028 0-0.044 0h-6.503z" })
        );
    }
    function Drawer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DrawerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Drawer.SVG = DrawerSVG;
    return Drawer;
})();
export const Dreaming = /*#__PURE__*/ (() => {
        function DreamingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M11 8.5c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5 1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5zM9 8c0 0 0 0 0 0v0zM7 8.5c0-0.828 0.672-1.5 1.5-1.5 0.094 0 0.188 0.009 0.275 0.025-0.444 0.103-0.775 0.5-0.775 0.975 0 0.55 0.45 1 1 1 0.475 0 0.872-0.331 0.975-0.775 0.016 0.091 0.025 0.181 0.025 0.275 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5z" }),
_('path', { d: "M15.5 6c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.122-2.5-2.5-2.5zM16 8c0 0 0 0 0 0v0zM15.5 10c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.094 0 0.188 0.009 0.275 0.025-0.444 0.103-0.775 0.5-0.775 0.975 0 0.55 0.45 1 1 1 0.475 0 0.872-0.331 0.975-0.775 0.016 0.091 0.025 0.181 0.025 0.275 0 0.828-0.672 1.5-1.5 1.5z" }),
_('path', { d: "M16.341 14.025c-3.897 1.3-4.788 1.3-8.684 0l-0.475-0.159-0.316 0.95 0.475 0.159c2.047 0.681 3.353 1.025 4.659 1.025s2.613-0.341 4.659-1.025l0.475-0.159-0.316-0.95-0.478 0.159z" })
            );
        }
        function Dreaming({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DreamingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Dreaming.SVG = DreamingSVG;
        return Dreaming;
    })();
export const Dresser = /*#__PURE__*/ (() => {
        function DresserSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 4h-24v2h1v14h2v-1h18v1h2v-14h1v-2zM21 17h-18v-11h18v11z" }),
_('path', { d: "M4.5 16h8c0.275 0 0.5-0.225 0.5-0.5v-8c0-0.275-0.225-0.5-0.5-0.5h-8c-0.275 0-0.5 0.225-0.5 0.5v8c0 0.275 0.225 0.5 0.5 0.5zM5 15v-3h7v3h-7zM12 8v3h-7v-3h7z" }),
_('path', { d: "M14.5 16h5c0.275 0 0.5-0.225 0.5-0.5v-8c0-0.275-0.225-0.5-0.5-0.5h-5c-0.275 0-0.5 0.225-0.5 0.5v8c0 0.275 0.225 0.5 0.5 0.5zM15 8h4v7h-4v-7z" }),
_('path', { d: "M9 9.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M17 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M9 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Dresser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DresserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Dresser.SVG = DresserSVG;
        return Dresser;
    })();
export const Dresser2 = /*#__PURE__*/ (() => {
        function Dresser2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-20c-1.103 0-2 0.897-2 2v14h2v-1h20v1h2v-14c0-1.103-0.897-2-2-2zM2 17v-11h20v11h-20z" }),
_('path', { d: "M20.5 7h-17c-0.275 0-0.5 0.225-0.5 0.5v8c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-8c0-0.275-0.225-0.5-0.5-0.5zM20 8v3h-16v-3h16zM4 15v-3h16v3h-16z" }),
_('path', { d: "M7 9h2v1h-2v-1z" }),
_('path', { d: "M7 13h2v1h-2v-1z" }),
_('path', { d: "M15 9h2v1h-2v-1z" }),
_('path', { d: "M15 13h2v1h-2v-1z" })
            );
        }
        function Dresser2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Dresser2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Dresser2.SVG = Dresser2SVG;
        return Dresser2;
    })();
export const Drop = /*#__PURE__*/ (() => {
        function DropSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.141 11.594c0.656-1.628 1.503-3.213 2.325-4.741 1.178-2.2 2.294-4.281 2.547-5.997 0.072-0.494 0.491-0.856 0.987-0.856 0 0 0 0 0 0 0.497 0 0.916 0.363 0.991 0.853 0.253 1.716 1.366 3.794 2.547 5.994 0.822 1.531 1.669 3.116 2.325 4.744 0.766 1.909 1.137 3.584 1.137 5.122 0 4.016-3.141 7.284-7 7.284s-7-3.269-7-7.284c0-1.538 0.372-3.213 1.141-5.119zM12 21.997c2.756 0 5-2.372 5-5.284 0-2.897-1.641-5.959-3.228-8.919-0.647-1.203-1.272-2.375-1.772-3.506-0.5 1.131-1.128 2.303-1.775 3.509-1.584 2.959-3.225 6.019-3.225 8.916 0 2.913 2.244 5.284 5 5.284z" }),
_('path', { d: "M12 21c-2.206 0-4-1.922-4-4.284v-0.716h1v0.716c0 1.812 1.347 3.284 3 3.284v1z" })
            );
        }
        function Drop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DropSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Drop.SVG = DropSVG;
        return Drop;
    })();
export const Dropdown = /*#__PURE__*/ (() => {
        function DropdownSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v21.5c0 0.275 0.225 0.5 0.5 0.5h18c0.275 0 0.5-0.225 0.5-0.5v-14.5h3c1.103 0 2-0.897 2-2v-5c0-1.103-0.897-2-2-2zM2 2h12v5h-12v-5zM18 23h-17v-14h17v14zM22 7h-7v-5h7v5c0.003 0 0 0 0 0z" }),
_('path', { d: "M18.5 4.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l2.353-2.353-0.706-0.706-2 2z" }),
_('path', { d: "M3 11h9v1h-9v-1z" }),
_('path', { d: "M13 11h3v1h-3v-1z" }),
_('path', { d: "M3 14h9v1h-9v-1z" }),
_('path', { d: "M13 14h3v1h-3v-1z" }),
_('path', { d: "M3 17h9v1h-9v-1z" }),
_('path', { d: "M13 17h3v1h-3v-1z" }),
_('path', { d: "M3 20h9v1h-9v-1z" }),
_('path', { d: "M13 20h3v1h-3v-1z" }),
_('path', { d: "M4 4h8v1h-8v-1z" })
            );
        }
        function Dropdown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DropdownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Dropdown.SVG = DropdownSVG;
        return Dropdown;
    })();
export const DropletCross = /*#__PURE__*/ (() => {
        function DropletCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.141 11.594c0.656-1.628 1.503-3.213 2.325-4.741 1.178-2.2 2.294-4.281 2.547-5.997 0.072-0.494 0.491-0.856 0.987-0.856s0.916 0.363 0.991 0.853c0.141 0.953 0.556 2.016 0.997 2.972 1.169-1.128 2.763-1.825 4.512-1.825 3.584 0 6.5 2.916 6.5 6.5 0 3.466-2.725 6.306-6.147 6.491 0.097 0.594 0.147 1.172 0.147 1.722 0 4.016-3.141 7.284-7 7.284s-7-3.269-7-7.284c0-1.538 0.372-3.213 1.141-5.119zM21 8.5c0-3.031-2.469-5.5-5.5-5.5s-5.5 2.469-5.5 5.5 2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5zM9 21.997c2.756 0 5-2.372 5-5.284 0-0.612-0.075-1.25-0.225-1.944-2.75-0.759-4.775-3.281-4.775-6.269 0-1.019 0.234-1.981 0.653-2.838v0c-0.219-0.438-0.444-0.897-0.653-1.372-0.5 1.131-1.128 2.303-1.772 3.509-1.587 2.956-3.228 6.016-3.228 8.913 0 2.913 2.244 5.284 5 5.284z" }),
_('path', { d: "M9 21c-2.206 0-4-1.922-4-4.284v-0.716h1v0.716c0 1.812 1.347 3.284 3 3.284v1z" }),
_('path', { d: "M13.5 11.206l-0.706-0.706 2-2-2-2 0.706-0.706 2 2 2-2 0.706 0.706-2 2 2 2-0.706 0.706-2-2z" })
            );
        }
        function DropletCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DropletCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DropletCross.SVG = DropletCrossSVG;
        return DropletCross;
    })();
export const DropletMinus = /*#__PURE__*/ (() => {
        function DropletMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.141 11.594c0.656-1.628 1.503-3.213 2.325-4.741 1.178-2.2 2.294-4.281 2.547-5.997 0.072-0.494 0.491-0.856 0.987-0.856s0.916 0.363 0.991 0.853c0.141 0.953 0.556 2.016 0.997 2.972 1.169-1.128 2.763-1.825 4.512-1.825 3.584 0 6.5 2.916 6.5 6.5 0 3.466-2.725 6.306-6.147 6.491 0.097 0.594 0.147 1.172 0.147 1.722 0 4.016-3.141 7.284-7 7.284s-7-3.269-7-7.284c0-1.538 0.372-3.213 1.141-5.119zM21 8.5c0-3.031-2.469-5.5-5.5-5.5s-5.5 2.469-5.5 5.5 2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5zM9 21.997c2.756 0 5-2.372 5-5.284 0-0.612-0.075-1.25-0.225-1.944-2.75-0.759-4.775-3.281-4.775-6.269 0-1.019 0.234-1.981 0.653-2.838v0c-0.219-0.438-0.444-0.897-0.653-1.372-0.5 1.131-1.128 2.303-1.772 3.509-1.587 2.956-3.228 6.016-3.228 8.913 0 2.913 2.244 5.284 5 5.284z" }),
_('path', { d: "M9 21c-2.206 0-4-1.922-4-4.284v-0.716h1v0.716c0 1.812 1.347 3.284 3 3.284v1z" }),
_('path', { d: "M18 8h-5v1h5v-1z" })
            );
        }
        function DropletMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DropletMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DropletMinus.SVG = DropletMinusSVG;
        return DropletMinus;
    })();
export const DropletPlus = /*#__PURE__*/ (() => {
        function DropletPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.141 11.594c0.656-1.628 1.503-3.213 2.325-4.741 1.178-2.2 2.294-4.281 2.547-5.997 0.072-0.494 0.491-0.856 0.987-0.856s0.916 0.363 0.991 0.853c0.141 0.953 0.556 2.016 0.997 2.972 1.169-1.128 2.763-1.825 4.512-1.825 3.584 0 6.5 2.916 6.5 6.5 0 3.466-2.725 6.306-6.147 6.491 0.097 0.594 0.147 1.172 0.147 1.722 0 4.016-3.141 7.284-7 7.284s-7-3.269-7-7.284c0-1.538 0.372-3.213 1.141-5.119zM21 8.5c0-3.031-2.469-5.5-5.5-5.5s-5.5 2.469-5.5 5.5 2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5zM9 21.997c2.756 0 5-2.372 5-5.284 0-0.612-0.075-1.25-0.225-1.944-2.75-0.759-4.775-3.281-4.775-6.269 0-1.019 0.234-1.981 0.653-2.838v0c-0.219-0.438-0.444-0.897-0.653-1.372-0.5 1.131-1.128 2.303-1.772 3.509-1.587 2.956-3.228 6.016-3.228 8.913 0 2.913 2.244 5.284 5 5.284z" }),
_('path', { d: "M9 21c-2.206 0-4-1.922-4-4.284v-0.716h1v0.716c0 1.812 1.347 3.284 3 3.284v1z" }),
_('path', { d: "M15 11v-2h-2v-1h2v-2h1v2h2v1h-2v2z" })
            );
        }
        function DropletPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DropletPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DropletPlus.SVG = DropletPlusSVG;
        return DropletPlus;
    })();
export const Droplets = /*#__PURE__*/ (() => {
        function DropletsSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 21c-2.206 0-4-1.922-4-4.284v-0.716h1v0.716c0 1.812 1.347 3.284 3 3.284v1z" }),
_('path', { d: "M19.434 8.156c-0.897-1.722-1.744-3.35-1.941-4.728-0.034-0.244-0.244-0.428-0.494-0.428 0 0 0 0 0 0-0.25 0-0.459 0.184-0.494 0.428-0.197 1.375-1.044 3.003-1.941 4.725-0.222 0.428-0.45 0.863-0.672 1.303-0.438-0.884-0.903-1.753-1.359-2.606-1.178-2.2-2.294-4.281-2.547-5.997-0.072-0.491-0.491-0.853-0.987-0.853 0 0 0 0 0 0-0.497 0-0.916 0.363-0.991 0.853-0.253 1.716-1.366 3.794-2.547 5.994-0.822 1.531-1.669 3.116-2.325 4.744-0.766 1.909-1.137 3.584-1.137 5.122 0 4.016 3.141 7.284 7 7.284 2.512 0 4.722-1.388 5.956-3.462 0.638 0.306 1.331 0.466 2.044 0.466 2.756 0 5-2.403 5-5.356 0-2.553-1.362-5.175-2.566-7.488zM9 21.997c-2.756 0-5-2.372-5-5.284 0-2.897 1.641-5.959 3.228-8.919 0.647-1.203 1.272-2.375 1.772-3.506 0.5 1.131 1.128 2.303 1.775 3.509 1.584 2.959 3.225 6.019 3.225 8.916 0 2.913-2.244 5.284-5 5.284zM17 20c-0.553 0-1.094-0.122-1.591-0.359 0.381-0.897 0.591-1.887 0.591-2.928 0-1.538-0.372-3.213-1.141-5.119-0.131-0.328-0.272-0.653-0.419-0.978 0.322-0.675 0.672-1.344 1.013-2 0.584-1.125 1.15-2.212 1.547-3.247 0.397 1.034 0.963 2.125 1.547 3.25 1.206 2.319 2.453 4.716 2.453 7.025 0 2.403-1.794 4.356-4 4.356z" })
            );
        }
        function Droplets({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DropletsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Droplets.SVG = DropletsSVG;
        return Droplets;
    })();
export const Dumbbell = /*#__PURE__*/ (() => {
    function DumbbellSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.5 10h-1.5c0-1.313-0.847-2.431-2.022-2.838-0.166-1.219-1.212-2.163-2.478-2.163-1.378 0-2.5 1.122-2.5 2.5v2.5h-6v-2.5c0-1.378-1.122-2.5-2.5-2.5-1.266 0-2.313 0.944-2.478 2.163-1.175 0.406-2.022 1.525-2.022 2.838h-1.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h1.5c0 1.313 0.847 2.431 2.022 2.838 0.166 1.219 1.212 2.163 2.478 2.163 1.378 0 2.5-1.122 2.5-2.5v-2.5h6v2.5c0 1.378 1.122 2.5 2.5 2.5 1.266 0 2.313-0.944 2.478-2.163 1.175-0.406 2.022-1.525 2.022-2.838h1.5c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5zM1 13v-2h1v2h-1zM4 14v-4c0-0.55 0.45-1 1-1v6c-0.55 0-1-0.45-1-1zM7 16.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5v-9c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v9zM9 13v-2h6v2h-6zM18 16.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5v-9c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v9zM20 14c0 0.55-0.45 1-1 1v-6c0.55 0 1 0.45 1 1v4zM23 13h-1v-2h1v2z" })
        );
    }
    function Dumbbell({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DumbbellSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Dumbbell.SVG = DumbbellSVG;
    return Dumbbell;
})();
export const Earphones = /*#__PURE__*/ (() => {
        function EarphonesSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 0c-0.8 0-2.844 0.225-4.572 2.313-0.75 0.906-1.338 2.050-1.741 3.394-0.456 1.512-0.687 3.291-0.687 5.294v3.5c0 0.275 0.225 0.5 0.5 0.5h0.5v9h1v-9h0.5c0.275 0 0.5-0.225 0.5-0.5v-1c0-3.431 0.456-5.25 0.837-6.172 0.509-1.231 1.041-1.328 1.191-1.328 0.278 0 0.472 0.263 0.472 0.5 0 0.828 0.672 1.5 1.5 1.5h1.5c0.275 0 0.5-0.225 0.5-0.5v-7c0-0.275-0.225-0.5-0.5-0.5h-1.5zM20 7c-0.275 0-0.5-0.225-0.5-0.5 0-0.378-0.15-0.756-0.416-1.038-0.281-0.297-0.656-0.462-1.056-0.462-0.488 0-1.413 0.253-2.116 1.944-0.606 1.462-0.912 3.669-0.912 6.556v0.5h-1v-3c0-3.528 0.759-6.312 2.197-8.047 1.459-1.763 3.147-1.953 3.803-1.953v6z" }),
_('path', { d: "M8.572 8.313c-1.728-2.088-3.772-2.313-4.572-2.313h-1.5c-0.275 0-0.5 0.225-0.5 0.5v7c0 0.275 0.225 0.5 0.5 0.5h1.5c0.828 0 1.5-0.672 1.5-1.5 0-0.237 0.194-0.5 0.472-0.5 0.15 0 0.681 0.097 1.191 1.328 0.381 0.922 0.837 2.741 0.837 6.172v1c0 0.275 0.225 0.5 0.5 0.5h0.5v3h1v-3h0.5c0.275 0 0.5-0.225 0.5-0.5v-3.5c0-2.003-0.231-3.781-0.684-5.291-0.406-1.347-0.994-2.487-1.744-3.397zM10 20h-1v-0.5c0-2.888-0.306-5.094-0.912-6.556-0.7-1.691-1.625-1.944-2.116-1.944-0.4 0-0.775 0.162-1.056 0.462-0.266 0.281-0.416 0.659-0.416 1.038 0 0.275-0.225 0.5-0.5 0.5v-6c0.656 0 2.344 0.191 3.803 1.953 1.437 1.734 2.197 4.519 2.197 8.047v3z" })
            );
        }
        function Earphones({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EarphonesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Earphones.SVG = EarphonesSVG;
        return Earphones;
    })();
export const EarthLock = /*#__PURE__*/ (() => {
        function EarthLockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813s-2.384-1.966-3.813-2.572c-1.481-0.625-3.053-0.944-4.672-0.944-0.706 0-1.406 0.059-2.088 0.178-0.369 0.066-0.738 0.147-1.097 0.247-0.719-0.275-1.5-0.425-2.316-0.425-3.584 0-6.5 2.916-6.5 6.5 0 0.816 0.15 1.597 0.425 2.316-0.097 0.359-0.181 0.728-0.247 1.1-0.119 0.678-0.178 1.378-0.178 2.084 0 1.619 0.319 3.191 0.944 4.672 0.603 1.428 1.469 2.712 2.572 3.813s2.384 1.966 3.813 2.572c1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572s1.966-2.384 2.572-3.813c0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM20.572 6.866c-0.125 0.063-0.253 0.141-0.378 0.237l-0.066 0.050-0.047 0.069c-0.469 0.694-1.203 0.906-1.691 0.756-0.262-0.081-0.397-0.241-0.397-0.478 0-0.675-0.359-1.2-0.647-1.622-0.25-0.369-0.4-0.603-0.35-0.775 0.044-0.15 0.266-0.459 1.216-0.922 0.941 0.744 1.741 1.653 2.359 2.684zM6.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM12.506 15.237c-0.347-0.312-0.825-0.594-1.291-0.866-0.334-0.194-0.647-0.378-0.888-0.559-0.269-0.203-0.319-0.306-0.325-0.325 0-0.184 0.034-0.394 0.066-0.616 0.047-0.309 0.1-0.647 0.078-0.994 0.453-0.309 0.866-0.672 1.228-1.081 0.291-0.156 0.537-0.394 0.778-0.625 0.216-0.206 0.438-0.419 0.616-0.484 0.059-0.022 0.159-0.056 0.378 0.162 0.831 0.831 1.509 1.050 2.006 1.212 0.459 0.15 0.669 0.219 0.903 0.666 0.391 0.741 0.981 1.028 1.413 1.238 0.472 0.228 0.531 0.288 0.531 0.531 0 0.159 0.006 0.331 0.009 0.509 0.019 0.637 0.044 1.603-0.244 1.9-0.041 0.044-0.109 0.091-0.266 0.091-0.997 0-1.397 0.888-1.662 1.475-0.075 0.169-0.2 0.441-0.281 0.528-0.653-0.091-1.453 0.656-2.694 1.869-0.275 0.269-0.638 0.625-0.925 0.875 0.031-0.331 0.106-0.828 0.269-1.534 0.219-0.959 0.531-1.994 0.756-2.516 0.147-0.341 0.188-0.872-0.456-1.456zM2.862 16.059c0.597 0.103 1.031-0.334 1.353-0.656 0.106-0.106 0.328-0.328 0.419-0.35 0.044 0.019 0.359 0.188 0.903 1.625 0.319 0.844 0.334 1.713 0.35 2.716 0.003 0.169 0.006 0.341 0.009 0.522-1.306-1.009-2.356-2.334-3.034-3.856zM6.922 20.613c-0.025-0.428-0.031-0.837-0.041-1.237-0.019-1.053-0.034-2.044-0.416-3.053-0.556-1.469-1.028-2.119-1.631-2.25-0.584-0.125-1.016 0.309-1.331 0.625-0.128 0.128-0.391 0.391-0.475 0.375-0.034-0.006-0.334-0.103-0.872-1.306-0.103-0.575-0.156-1.162-0.156-1.766 0-0.262 0.009-0.525 0.031-0.784 1.166 1.106 2.741 1.784 4.469 1.784 0.931 0 1.816-0.197 2.619-0.55-0.012 0.091-0.025 0.181-0.041 0.275-0.037 0.253-0.078 0.516-0.078 0.775 0 0.741 0.831 1.225 1.709 1.741 0.419 0.247 0.853 0.5 1.122 0.744 0.075 0.069 0.247 0.234 0.209 0.319-0.262 0.609-0.612 1.775-0.847 2.838-0.128 0.575-0.213 1.088-0.253 1.484-0.056 0.584-0.012 0.931 0.144 1.159 0.056 0.081 0.131 0.147 0.216 0.194-1.587-0.112-3.078-0.597-4.378-1.366zM12 22h-0.147c0.394-0.141 0.875-0.6 1.706-1.413 0.4-0.391 0.813-0.794 1.178-1.106 0.459-0.391 0.653-0.469 0.706-0.481 0.216 0.031 0.591 0.009 0.909-0.394 0.162-0.203 0.275-0.453 0.394-0.719 0.281-0.625 0.45-0.884 0.753-0.884 0.391 0 0.731-0.138 0.981-0.394 0.584-0.6 0.553-1.675 0.528-2.625-0.006-0.172-0.009-0.334-0.009-0.481 0-0.903-0.634-1.209-1.097-1.431-0.372-0.181-0.725-0.35-0.963-0.8-0.425-0.809-0.963-0.984-1.481-1.153-0.444-0.144-0.947-0.309-1.609-0.969-0.459-0.459-0.9-0.516-1.234-0.45 0.247-0.687 0.381-1.425 0.381-2.197 0-1.731-0.678-3.303-1.784-4.469 0.259-0.019 0.522-0.031 0.784-0.031 1.947 0 3.769 0.559 5.306 1.528-0.738 0.419-1.128 0.828-1.263 1.294-0.184 0.634 0.172 1.156 0.484 1.616 0.244 0.356 0.475 0.694 0.475 1.059 0 0.675 0.422 1.225 1.103 1.434 0.184 0.056 0.387 0.087 0.606 0.087 0.719 0 1.559-0.334 2.153-1.169 0.066-0.047 0.125-0.081 0.181-0.106 0.609 1.294 0.953 2.734 0.953 4.256 0.003 5.509-4.484 9.997-9.997 9.997z" }),
_('path', { d: "M3.5 10h6c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-0.5v-0.5c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5v0.5h-0.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5zM5 5.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5v0.5h-3v-0.5zM4 7h5v2h-5v-2z" })
            );
        }
        function EarthLock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EarthLockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EarthLock.SVG = EarthLockSVG;
        return EarthLock;
    })();
export const Earth = /*#__PURE__*/ (() => {
    function EarthSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM20.578 6.863c-0.128 0.063-0.256 0.144-0.381 0.241l-0.066 0.050-0.047 0.069c-0.469 0.694-1.203 0.906-1.691 0.756-0.262-0.081-0.397-0.241-0.397-0.478 0-0.675-0.359-1.2-0.647-1.625-0.25-0.369-0.4-0.603-0.35-0.775 0.044-0.15 0.269-0.459 1.222-0.925 0.938 0.747 1.737 1.659 2.356 2.688zM12 2c0.203 0 0.403 0.006 0.6 0.019-0.1 0.066-0.219 0.119-0.353 0.181-0.391 0.178-0.928 0.425-1.209 1.113l-0.009 0.019-0.006 0.019c-0.644 2.037-1.506 2.838-2.078 3.366-0.409 0.378-0.762 0.706-0.769 1.25-0.006 0.472 0.247 0.972 0.931 1.844 0.547 0.697 1.072 1.050 1.606 1.087 0.675 0.044 1.15-0.419 1.534-0.791 0.194-0.188 0.394-0.384 0.544-0.434 0.041-0.012 0.131-0.044 0.359 0.181 0.831 0.831 1.509 1.050 2.006 1.212 0.459 0.15 0.669 0.219 0.903 0.666 0.391 0.741 0.981 1.028 1.413 1.237 0.472 0.228 0.531 0.288 0.531 0.531 0 0.159 0.006 0.331 0.009 0.509 0.019 0.638 0.044 1.603-0.244 1.9-0.041 0.044-0.109 0.091-0.266 0.091-0.997 0-1.397 0.888-1.662 1.475-0.075 0.169-0.2 0.441-0.281 0.528-0.653-0.091-1.453 0.656-2.694 1.869-0.275 0.269-0.638 0.625-0.925 0.875 0.031-0.331 0.106-0.828 0.269-1.534 0.219-0.959 0.531-1.994 0.756-2.516 0.147-0.341 0.188-0.872-0.456-1.456-0.347-0.312-0.825-0.594-1.291-0.866-0.334-0.194-0.647-0.378-0.888-0.559-0.269-0.203-0.319-0.306-0.325-0.325 0-0.184 0.034-0.394 0.066-0.616 0.128-0.834 0.319-2.097-1.366-2.834-0.175-0.078-0.359-0.15-0.534-0.219-1.409-0.556-2.862-1.131-3.122-5 1.794-1.744 4.247-2.822 6.95-2.822zM2.862 16.059c0.597 0.103 1.031-0.334 1.353-0.656 0.106-0.106 0.328-0.328 0.419-0.35 0.044 0.019 0.359 0.188 0.903 1.625 0.319 0.844 0.334 1.713 0.35 2.716 0.003 0.169 0.006 0.341 0.009 0.522-1.306-1.009-2.356-2.334-3.034-3.856zM6.922 20.613c-0.025-0.428-0.031-0.837-0.041-1.237-0.019-1.053-0.034-2.044-0.416-3.053-0.556-1.469-1.028-2.119-1.631-2.25-0.584-0.125-1.016 0.309-1.331 0.625-0.128 0.128-0.391 0.391-0.475 0.375-0.034-0.006-0.334-0.103-0.872-1.306-0.103-0.575-0.156-1.162-0.156-1.766 0-2.328 0.8-4.475 2.141-6.175 0.181 1.344 0.541 2.381 1.084 3.147 0.753 1.062 1.722 1.444 2.575 1.781 0.175 0.069 0.341 0.134 0.503 0.206 0.981 0.428 0.906 0.931 0.778 1.766-0.037 0.253-0.078 0.516-0.078 0.775 0 0.741 0.831 1.225 1.709 1.741 0.419 0.247 0.853 0.5 1.122 0.744 0.231 0.209 0.219 0.297 0.209 0.319-0.262 0.609-0.612 1.775-0.847 2.838-0.128 0.575-0.213 1.087-0.253 1.484-0.056 0.584-0.012 0.931 0.144 1.159 0.056 0.081 0.131 0.147 0.216 0.194-1.591-0.113-3.081-0.597-4.381-1.366zM12 22c-0.050 0-0.097 0-0.147 0 0.394-0.141 0.875-0.6 1.706-1.413 0.4-0.391 0.813-0.794 1.178-1.106 0.459-0.391 0.653-0.469 0.706-0.481 0.216 0.031 0.591 0.009 0.909-0.394 0.162-0.203 0.275-0.453 0.394-0.719 0.281-0.625 0.45-0.884 0.753-0.884 0.391 0 0.731-0.138 0.981-0.394 0.584-0.6 0.553-1.675 0.528-2.625-0.006-0.172-0.009-0.334-0.009-0.481 0-0.903-0.634-1.209-1.097-1.431-0.372-0.181-0.725-0.35-0.963-0.8-0.425-0.809-0.963-0.984-1.481-1.153-0.444-0.144-0.947-0.309-1.609-0.969-0.441-0.441-0.906-0.584-1.384-0.422-0.366 0.122-0.647 0.397-0.922 0.666-0.278 0.269-0.537 0.525-0.769 0.509-0.131-0.009-0.419-0.112-0.888-0.706-0.478-0.609-0.722-1.016-0.719-1.209 0.003-0.112 0.172-0.275 0.45-0.531 0.606-0.563 1.622-1.503 2.347-3.775 0.125-0.294 0.328-0.397 0.694-0.566 0.375-0.172 0.844-0.387 1.113-0.95 1.278 0.231 2.472 0.703 3.531 1.369-0.741 0.422-1.131 0.831-1.266 1.297-0.184 0.634 0.172 1.156 0.484 1.616 0.244 0.356 0.475 0.694 0.475 1.059 0 0.675 0.422 1.225 1.103 1.434 0.184 0.056 0.391 0.087 0.606 0.087 0.719 0 1.559-0.334 2.156-1.166 0.066-0.047 0.128-0.081 0.184-0.109 0.612 1.284 0.953 2.725 0.953 4.247 0 5.513-4.488 10-10 10z" })
        );
    }
    function Earth({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EarthSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Earth.SVG = EarthSVG;
    return Earth;
})();
export const EasterEgg = /*#__PURE__*/ (() => {
        function EasterEggSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.75 5.172c-0.797-1.519-1.725-2.731-2.756-3.603-1.234-1.041-2.575-1.569-3.994-1.569s-2.759 0.528-3.994 1.569c-1.034 0.872-1.962 2.084-2.756 3.603-1.388 2.647-2.25 6.028-2.25 8.828 0 2.712 0.844 5.203 2.372 7.009 0.8 0.944 1.762 1.681 2.859 2.191 1.147 0.531 2.412 0.8 3.769 0.8s2.622-0.269 3.769-0.8c1.097-0.509 2.059-1.247 2.859-2.191 1.528-1.806 2.372-4.297 2.372-7.009 0-2.8-0.862-6.181-2.25-8.828zM17.659 18.95l-0.806-0.806c-0.194-0.194-0.513-0.194-0.706 0l-1.647 1.65-1.647-1.647c-0.194-0.194-0.513-0.194-0.706 0l-1.647 1.647-1.647-1.647c-0.194-0.194-0.513-0.194-0.706 0l-1.387 1.387c-0.531-0.663-0.956-1.444-1.253-2.319l0.641 0.641c0.194 0.194 0.513 0.194 0.706 0l1.647-1.647 1.647 1.647c0.194 0.194 0.513 0.194 0.706 0l1.647-1.647 1.647 1.647c0.194 0.194 0.513 0.194 0.706 0l1.647-1.647 1.647 1.647c0.022 0.022 0.047 0.044 0.072 0.059-0.162 0.366-0.35 0.713-0.559 1.034zM17.409 6.991c0.197 0.438 0.378 0.891 0.541 1.35l-0.45 0.453-1.647-1.647c-0.194-0.194-0.513-0.194-0.706 0l-1.647 1.647-1.647-1.647c-0.194-0.194-0.513-0.194-0.706 0l-1.647 1.647-1.647-1.647c-0.194-0.194-0.513-0.194-0.706 0l-1.044 1.041c0.384-1.059 0.863-2.072 1.419-2.959l1.625 1.625c0.194 0.194 0.513 0.194 0.706 0l1.647-1.647 1.647 1.647c0.194 0.194 0.513 0.194 0.706 0l1.647-1.647 1.647 1.647c0.075 0.075 0.166 0.122 0.262 0.138zM18.875 12.172c0.025 0.191 0.047 0.381 0.063 0.569-0.084 0.156-0.25 0.259-0.438 0.259-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5c0.15 0 0.284 0.066 0.375 0.172zM18.5 16.794l-1.647-1.647c-0.194-0.194-0.513-0.194-0.706 0l-1.647 1.647-1.647-1.647c-0.194-0.194-0.513-0.194-0.706 0l-1.647 1.647-1.647-1.647c-0.194-0.194-0.513-0.194-0.706 0l-1.647 1.647-1.413-1.413c-0.056-0.444-0.087-0.903-0.087-1.378 0-0.363 0.016-0.738 0.050-1.122 0.169 0.644 0.753 1.119 1.45 1.119 0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5c-0.572 0-1.069 0.322-1.322 0.791 0.091-0.591 0.213-1.194 0.366-1.794 0.113-0.009 0.222-0.059 0.309-0.144l1.647-1.647 1.647 1.647c0.194 0.194 0.513 0.194 0.706 0l1.647-1.647 1.647 1.647c0.194 0.194 0.513 0.194 0.706 0l1.647-1.647 1.647 1.647c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l0.441-0.441c0.153 0.531 0.284 1.069 0.391 1.6-0.059-0.006-0.122-0.012-0.184-0.012-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.175 0 0.344-0.031 0.5-0.084 0 0.028 0 0.056 0 0.084 0 0.934-0.113 1.812-0.328 2.619l-0.172 0.175zM6 12.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5zM12 2c1.344 0 2.562 0.784 3.597 2.009-0.156-0.031-0.328 0.016-0.45 0.138l-1.647 1.647-1.647-1.647c-0.194-0.194-0.513-0.194-0.706 0l-1.647 1.647-1.4-1.4c1.091-1.444 2.422-2.394 3.9-2.394zM12 22c-1.803 0-3.369-0.631-4.559-1.734l1.059-1.059 1.647 1.647c0.194 0.194 0.513 0.194 0.706 0l1.647-1.647 1.647 1.647c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l1.647-1.647 0.553 0.553c-1.238 1.416-2.988 2.241-5.053 2.241z" }),
_('path', { d: "M10.5 11c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5c0-0.828-0.672-1.5-1.5-1.5zM10.5 13c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M14.5 11c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5c0-0.828-0.672-1.5-1.5-1.5zM14.5 13c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" })
            );
        }
        function EasterEgg({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EasterEggSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EasterEgg.SVG = EasterEggSVG;
        return EasterEgg;
    })();
export const Edit = /*#__PURE__*/ (() => {
    function EditSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.672 1.328c-0.856-0.856-1.994-1.331-3.206-1.331s-2.35 0.472-3.206 1.328l-1.675 1.675h-14.084c-0.275 0-0.5 0.225-0.5 0.5v20c0 0.275 0.225 0.5 0.5 0.5h20c0.275 0 0.5-0.225 0.5-0.5v-14.084l1.672-1.672c1.769-1.772 1.769-4.647 0-6.416zM7.875 12.581l3.544 3.544-4.962 1.419 1.419-4.962zM12.147 15.441l-3.588-3.588 8.294-8.294 3.584 3.584-8.291 8.297zM20 23h-19v-19h12.584l-7.291 7.294c-0.119 0.119-0.206 0.269-0.253 0.431l-2 7c-0.1 0.35-0.003 0.725 0.253 0.981 0.191 0.191 0.447 0.294 0.706 0.294 0.091 0 0.184-0.012 0.275-0.038l7-2c0.162-0.047 0.312-0.134 0.431-0.253l7.294-7.294v12.584zM21.259 6.328l-0.112 0.113-3.588-3.588 0.112-0.112c0.478-0.478 1.116-0.744 1.794-0.744s1.313 0.263 1.794 0.744c0.987 0.991 0.987 2.597 0 3.588z" })
        );
    }
    function Edit({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EditSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Edit.SVG = EditSVG;
    return Edit;
})();
export const Edit2 = /*#__PURE__*/ (() => {
    function Edit2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.706 4.294l-4-4c-0.391-0.391-1.025-0.391-1.416 0l-2.706 2.706h-15.084c-0.275 0-0.5 0.225-0.5 0.5v20c0 0.275 0.225 0.5 0.5 0.5h20c0.275 0 0.5-0.225 0.5-0.5v-15.084l2.706-2.706c0.391-0.394 0.391-1.025 0-1.416zM20 23h-19v-19h13.584l-8.791 8.794c-0.122 0.122-0.213 0.275-0.256 0.444l-1.5 5.5c-0.094 0.347 0.003 0.716 0.256 0.969 0.191 0.191 0.447 0.294 0.706 0.294 0.087 0 0.175-0.012 0.263-0.034l5.5-1.5c0.169-0.047 0.322-0.134 0.444-0.256l8.794-8.794v13.584zM9.981 16.606l-3.556 0.969 0.969-3.556 11.606-11.603 2.584 2.584-11.603 11.606z" })
        );
    }
    function Edit2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Edit2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Edit2.SVG = Edit2SVG;
    return Edit2;
})();
export const Edit3 = /*#__PURE__*/ (() => {
    function Edit3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.853 0.478c-0.181-0.297-0.506-0.478-0.853-0.478-2.106 0-4.359 0.481-6.516 1.394-1.041 0.441-2.059 0.981-3.028 1.606h-12.956c-0.275 0-0.5 0.225-0.5 0.5v20c0 0.275 0.225 0.5 0.5 0.5h20c0.275 0 0.5-0.225 0.5-0.5v-16.994c0.95-1.456 1.909-3.134 2.891-5.050 0.159-0.309 0.144-0.681-0.038-0.978zM20 23h-19v-19h11.041c-0.588 0.453-1.15 0.938-1.681 1.45-1.953 1.881-3.491 4.1-4.569 6.594-1.188 2.744-1.791 5.756-1.791 8.956h2c0-2.169 0.294-4.097 0.775-5.797 0.772-1.234 1.528-1.225 2.991-1.206 1.5 0.022 3.556 0.047 5.981-1.625 1.409-0.975 2.819-2.434 4.253-4.409v15.038zM19.572 5.037c-1.009 0.128-3.7 0.687-6.403 3.087l-0.375 0.331 0.666 0.747 0.375-0.331c1.6-1.422 3.194-2.128 4.25-2.469 0.259-0.084 0.503-0.15 0.719-0.203-1.437 2.084-2.828 3.581-4.194 4.525-1.9 1.313-3.381 1.291-4.816 1.272-0.628-0.009-1.231-0.016-1.828 0.087 1.1-2.25 2.503-3.959 3.784-5.194 2.709-2.613 6.172-4.328 9.531-4.775-0.578 1.066-1.15 2.037-1.709 2.922z" })
        );
    }
    function Edit3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Edit3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Edit3.SVG = Edit3SVG;
    return Edit3;
})();
export const EggBroken = /*#__PURE__*/ (() => {
    function EggBrokenSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18.75 5.172c-0.797-1.519-1.725-2.731-2.756-3.603-1.234-1.041-2.575-1.569-3.994-1.569s-2.759 0.528-3.994 1.569c-1.034 0.872-1.962 2.084-2.756 3.603-1.388 2.647-2.25 6.028-2.25 8.828 0 2.712 0.844 5.203 2.372 7.009 0.8 0.944 1.762 1.681 2.859 2.191 1.147 0.531 2.412 0.8 3.769 0.8s2.622-0.269 3.769-0.8c1.097-0.509 2.059-1.247 2.859-2.191 1.528-1.806 2.372-4.297 2.372-7.009 0-2.8-0.862-6.181-2.25-8.828zM12 22c-4.122 0-7-3.291-7-8 0-4.831 2.941-12 7-12 1.431 0 2.722 0.891 3.794 2.253l-3.522 1.803c-0.144 0.072-0.241 0.209-0.266 0.369s0.028 0.319 0.141 0.431l1.8 1.8-0.862 3.444-3.222 0.922c-0.159 0.047-0.284 0.166-0.338 0.322l-0.5 1.5 0.95 0.316 0.416-1.25 1.722-0.491 0.897 4.675 0.981-0.188-0.912-4.766 0.559-0.159c0.172-0.050 0.303-0.188 0.347-0.359l1-4c0.044-0.172-0.006-0.35-0.131-0.475l-1.516-1.516 3.041-1.556c1.628 2.522 2.622 6.119 2.622 8.925 0 4.709-2.878 8-7 8z" })
        );
    }
    function EggBroken({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EggBrokenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    EggBroken.SVG = EggBrokenSVG;
    return EggBroken;
})();
export const Egg = /*#__PURE__*/ (() => {
        function EggSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.75 5.172c-0.797-1.519-1.725-2.731-2.756-3.603-1.234-1.041-2.575-1.569-3.994-1.569s-2.759 0.528-3.994 1.569c-1.034 0.872-1.962 2.084-2.756 3.603-1.388 2.647-2.25 6.028-2.25 8.828 0 2.712 0.844 5.203 2.372 7.009 0.8 0.944 1.762 1.681 2.859 2.191 1.147 0.531 2.412 0.8 3.769 0.8 1.353 0 2.622-0.269 3.769-0.8 1.097-0.509 2.059-1.247 2.859-2.191 1.528-1.806 2.372-4.297 2.372-7.009 0-2.8-0.862-6.181-2.25-8.828zM12 22c-4.122 0-7-3.291-7-8 0-4.831 2.941-12 7-12s7 7.169 7 12c0 4.709-2.878 8-7 8z" }),
_('path', { d: "M16.094 6.566c-0.3-0.572-0.794-1.403-1.441-2.122-0.862-0.959-1.756-1.444-2.653-1.444v1c1.503 0 2.834 2.319 3.206 3.028 1.091 2.075 1.794 4.812 1.794 6.972h1c0-2.306-0.75-5.225-1.906-7.434z" })
            );
        }
        function Egg({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EggSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Egg.SVG = EggSVG;
        return Egg;
    })();
export const EjectCircle = /*#__PURE__*/ (() => {
        function EjectCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M8.5 14h7c0.178 0 0.344-0.097 0.434-0.25s0.087-0.347-0.003-0.5l-3.5-6c-0.091-0.153-0.253-0.247-0.431-0.247s-0.344 0.094-0.431 0.247l-3.5 6c-0.091 0.153-0.091 0.347-0.003 0.5 0.091 0.153 0.256 0.25 0.434 0.25zM12 8.494l2.628 4.506h-5.256l2.628-4.506z" }),
_('path', { d: "M8 15h8v1h-8v-1z" })
            );
        }
        function EjectCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EjectCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EjectCircle.SVG = EjectCircleSVG;
        return EjectCircle;
    })();
export const EjectSquare = /*#__PURE__*/ (() => {
        function EjectSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M8.5 14h7c0.178 0 0.344-0.097 0.434-0.25s0.087-0.347-0.003-0.5l-3.5-6c-0.091-0.153-0.253-0.247-0.431-0.247s-0.344 0.094-0.431 0.247l-3.5 6c-0.091 0.153-0.091 0.347-0.003 0.5 0.091 0.153 0.256 0.25 0.434 0.25zM12 8.494l2.628 4.506h-5.256l2.628-4.506z" }),
_('path', { d: "M8 15h8v1h-8v-1z" })
            );
        }
        function EjectSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EjectSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EjectSquare.SVG = EjectSquareSVG;
        return EjectSquare;
    })();
export const Eject = /*#__PURE__*/ (() => {
        function EjectSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3 18h18c0.359 0 0.694-0.194 0.869-0.506 0.178-0.312 0.172-0.697-0.012-1.006l-9-15c-0.178-0.303-0.506-0.487-0.856-0.487s-0.678 0.184-0.856 0.484l-9 15c-0.184 0.309-0.191 0.694-0.012 1.006 0.175 0.316 0.509 0.509 0.869 0.509zM12 3.944l7.234 12.056h-14.469l7.234-12.056z" }),
_('path', { d: "M2 20h20v2h-20v-2z" })
            );
        }
        function Eject({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EjectSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Eject.SVG = EjectSVG;
        return Eject;
    })();
export const Ellipsis = /*#__PURE__*/ (() => {
        function EllipsisSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 9c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM12 13c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M4 9c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM4 13c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1c0 0.55-0.45 1-1 1z" }),
_('path', { d: "M20 9c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM20 13c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1c0 0.55-0.45 1-1 1z" })
            );
        }
        function Ellipsis({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EllipsisSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ellipsis.SVG = EllipsisSVG;
        return Ellipsis;
    })();
export const Emerald = /*#__PURE__*/ (() => {
        function EmeraldSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.706 4.294l-4-4c-0.188-0.188-0.441-0.294-0.706-0.294h-8c-0.266 0-0.519 0.106-0.706 0.294l-4 4c-0.188 0.188-0.294 0.441-0.294 0.706v14c0 0.266 0.106 0.519 0.294 0.706l4 4c0.188 0.188 0.441 0.294 0.706 0.294h8c0.266 0 0.519-0.106 0.706-0.294l4-4c0.188-0.188 0.294-0.441 0.294-0.706v-14c0-0.266-0.106-0.519-0.294-0.706zM17 17.169v-10.338l2-0.856v12.056l-2-0.862zM18.628 5.044l-2.013 0.863-1.522-1.522 0.862-2.016 2.672 2.675zM9.831 20h4.341l0.856 2h-6.056l0.859-2zM14.294 19h-4.587l-1.706-1.706v-10.587l1.706-1.706h4.584l1.706 1.706v10.584l-1.703 1.709zM14.169 4h-4.338l-0.856-2h6.056l-0.862 2zM8.044 2.372l0.863 2.016-1.522 1.519-2.016-0.863 2.675-2.672zM7 6.831v10.341l-2 0.856v-12.056l2 0.859zM5.372 18.956l2.016-0.862 1.522 1.522-0.863 2.016-2.675-2.675zM15.956 21.628l-0.862-2.013 1.522-1.522 2.016 0.862-2.675 2.672z" }),
_('path', { d: "M13.853 6.147c-0.094-0.094-0.222-0.147-0.353-0.147h-1.5v1h1.294l0.706 0.706v2.294h1v-2.5c0-0.131-0.053-0.259-0.147-0.353l-1-1z" })
            );
        }
        function Emerald({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EmeraldSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Emerald.SVG = EmeraldSVG;
        return Emerald;
    })();
export const Engine = /*#__PURE__*/ (() => {
    function EngineSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21 8h-0.5c-0.275 0-0.5 0.225-0.5 0.5v2.5h-1v-2c0-1.103-0.897-2-2-2h-2.584l-1.416-1.416c-0.378-0.378-0.881-0.588-1.413-0.588h-0.588v-0.997h3v-1h-8v1h3v0.997h-0.584c-0.534 0-1.034 0.209-1.413 0.588l-1.416 1.416h-1.587c-1.103 0-2 0.897-2 2v2h-1v-3h-1v8h1v-3h1v3c0 1.103 0.897 2 2 2h2.584l2.416 2.416c0.378 0.378 0.881 0.588 1.413 0.588h6.588c1.103 0 2-0.897 2-2v-2h1v2.497c0 0.275 0.225 0.5 0.5 0.5h0.5c1.653 0 3-1.347 3-3v-6c0-1.653-1.347-3-3-3zM22 17c0 0.55-0.45 1-1 1v-2.5c0-0.275-0.225-0.5-0.5-0.5h-0.5v0.003h-2c-0.553 0-1 0.447-1 1v3h-6.588l-2.416-2.416c-0.378-0.378-0.881-0.588-1.413-0.588h-2.584v-7h1.587c0.534 0 1.034-0.209 1.413-0.588l1.416-1.416h3.172l1.416 1.416c0.378 0.378 0.881 0.588 1.413 0.588h2.584v3c0 0.553 0.447 1 1 1h2.5c0.275 0 0.5-0.225 0.5-0.5v-2.5c0.55 0 1 0.45 1 1v6z" })
        );
    }
    function Engine({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EngineSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Engine.SVG = EngineSVG;
    return Engine;
})();
export const Enter = /*#__PURE__*/ (() => {
        function EnterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.447 0.106c-0.144-0.072-0.297-0.106-0.453-0.106h-12.494c-0.275 0-0.5 0.225-0.5 0.5v3.5h1v-3h10.334l-6.934 5.2c-0.253 0.188-0.4 0.484-0.4 0.8v10h-3v-3h-1v3.5c0 0.275 0.225 0.5 0.5 0.5h3.5v5c0 0.378 0.213 0.725 0.553 0.894 0.141 0.072 0.294 0.106 0.447 0.106 0.213 0 0.425-0.069 0.6-0.2l8-6c0.253-0.188 0.4-0.484 0.4-0.8v-16c0-0.378-0.213-0.725-0.553-0.894zM21 16.5l-6 4.5v-13.5l6-4.5v13.5z" }),
_('path', { d: "M10.706 8.294l-4.25-4.25-1.416 1.416 2.544 2.544h-6.584v2h6.584l-2.544 2.544 1.416 1.416 4.25-4.25c0.391-0.397 0.391-1.028 0-1.419z" })
            );
        }
        function Enter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EnterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Enter.SVG = EnterSVG;
        return Enter;
    })();
export const Enter2 = /*#__PURE__*/ (() => {
    function Enter2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 3v9h-18.584l5.544-5.544-1.416-1.416-7.25 7.25c-0.391 0.391-0.391 1.025 0 1.416l7.25 7.25 1.416-1.416-5.544-5.541h18.584c1.103 0 2-0.897 2-2v-9h-2z" })
        );
    }
    function Enter2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Enter2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Enter2.SVG = Enter2SVG;
    return Enter2;
})();
export const EnvelopeCheck = /*#__PURE__*/ (() => {
        function EnvelopeCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 7.5c0-3.584-2.916-6.5-6.5-6.5-3.416 0-6.225 2.65-6.481 6h-9.019c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h18c1.103 0 2-0.897 2-2v-6.813c1.231-1.184 2-2.847 2-4.688zM17.5 2c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM13.231 12.397l-2.228 1.616c0 0-0.003 0-0.003 0l-6.919-5.013h7.091c0.322 1.341 1.053 2.522 2.059 3.397zM6.831 13.462l-4.831 4.831v-8.334l4.831 3.503zM7.65 14.056l2.175 1.578c0.35 0.253 0.762 0.381 1.172 0.381 0.413 0 0.822-0.128 1.175-0.381l2.175-1.578 4.947 4.944h-16.587l4.944-4.944zM15.337 13.631c0.678 0.241 1.406 0.369 2.163 0.369 0.884 0 1.731-0.178 2.5-0.5v4.794l-4.662-4.662z" }),
_('path', { d: "M16.5 10c0.128 0 0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147z" })
            );
        }
        function EnvelopeCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EnvelopeCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EnvelopeCheck.SVG = EnvelopeCheckSVG;
        return EnvelopeCheck;
    })();
export const EnvelopeCross = /*#__PURE__*/ (() => {
        function EnvelopeCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 7.5c0-3.584-2.916-6.5-6.5-6.5-3.416 0-6.225 2.65-6.481 6h-9.019c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h18c1.103 0 2-0.897 2-2v-6.813c1.231-1.184 2-2.847 2-4.688zM17.5 2c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM13.231 12.397l-2.228 1.616c0 0-0.003 0-0.003 0l-6.919-5.013h7.091c0.322 1.341 1.053 2.522 2.059 3.397zM6.831 13.462l-4.831 4.831v-8.334l4.831 3.503zM7.65 14.056l2.175 1.578c0.35 0.253 0.762 0.381 1.172 0.381 0.413 0 0.822-0.128 1.175-0.381l2.175-1.578 4.947 4.944h-16.587l4.944-4.944zM15.337 13.631c0.678 0.241 1.406 0.369 2.163 0.369 0.884 0 1.731-0.178 2.5-0.5v4.794l-4.662-4.662z" }),
_('path', { d: "M15.5 10.206l2-2 2 2 0.706-0.706-2-2 2-2-0.706-0.706-2 2-2-2-0.706 0.706 2 2-2 2z" })
            );
        }
        function EnvelopeCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EnvelopeCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EnvelopeCross.SVG = EnvelopeCrossSVG;
        return EnvelopeCross;
    })();
export const EnvelopeOpen = /*#__PURE__*/ (() => {
    function EnvelopeOpenSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.175 7.891l-9-6.525c-0.703-0.509-1.647-0.509-2.347 0l-9 6.525c-0.519 0.375-0.825 0.981-0.825 1.619v10.491c0 1.103 0.897 2 2 2h18c1.103 0 2-0.897 2-2v-10.491c-0.003-0.638-0.312-1.244-0.828-1.619zM3 19.294v-9.109l5.694 3.416-5.694 5.694zM10.706 13h2.584l7 7h-16.584l7-7zM15.306 13.6l5.694-3.416v9.109l-5.694-5.694zM12 2.984l8.628 6.256-6.050 3.631-0.725-0.725c-0.094-0.094-0.222-0.147-0.353-0.147h-3c-0.131 0-0.259 0.053-0.353 0.147l-0.725 0.725-6.050-3.631 8.628-6.256z" })
        );
    }
    function EnvelopeOpen({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EnvelopeOpenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    EnvelopeOpen.SVG = EnvelopeOpenSVG;
    return EnvelopeOpen;
})();
export const EnvelopeOpen2 = /*#__PURE__*/ (() => {
        function EnvelopeOpen2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.175 8.891l-1.175-0.853v-6.537c0-0.275-0.225-0.5-0.5-0.5h-17c-0.275 0-0.5 0.225-0.5 0.5v6.537l-1.172 0.85c-0.519 0.375-0.828 0.981-0.828 1.619v10.494c0 1.103 0.897 2 2 2h18c1.103 0 2-0.897 2-2v-10.491c0-0.641-0.309-1.247-0.825-1.619zM13.853 13.147c-0.094-0.094-0.222-0.147-0.353-0.147h-3c-0.131 0-0.259 0.053-0.353 0.147l-0.725 0.725-5.422-3.256v-8.616h16v8.616l-5.422 3.256-0.725-0.725zM8.694 14.6l-5.694 5.694v-9.113l5.694 3.419zM10.706 14h2.584l7 7h-16.584l7-7zM15.306 14.6l5.694-3.419v9.109l-5.694-5.691z" }),
_('path', { d: "M6 4h12v1h-12v-1z" }),
_('path', { d: "M6 6h10v1h-10v-1z" }),
_('path', { d: "M6 8h11v1h-11v-1z" }),
_('path', { d: "M6 10h12v1h-12v-1z" })
            );
        }
        function EnvelopeOpen2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EnvelopeOpen2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EnvelopeOpen2.SVG = EnvelopeOpen2SVG;
        return EnvelopeOpen2;
    })();
export const EnvelopePlus = /*#__PURE__*/ (() => {
        function EnvelopePlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 7.5c0-3.584-2.916-6.5-6.5-6.5-3.416 0-6.225 2.65-6.481 6h-9.019c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h18c1.103 0 2-0.897 2-2v-6.813c1.231-1.184 2-2.847 2-4.688zM17.5 2c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM13.231 12.397l-2.228 1.616c0 0-0.003 0-0.003 0l-6.919-5.013h7.091c0.322 1.341 1.053 2.522 2.059 3.397zM6.831 13.462l-4.831 4.831v-8.334l4.831 3.503zM7.65 14.056l2.175 1.578c0.35 0.253 0.762 0.381 1.172 0.381 0.413 0 0.822-0.128 1.175-0.381l2.175-1.578 4.947 4.944h-16.587l4.944-4.944zM15.337 13.631c0.678 0.241 1.406 0.369 2.163 0.369 0.884 0 1.731-0.178 2.5-0.5v4.794l-4.662-4.662z" }),
_('path', { d: "M17 10h1v-2h2v-1h-2v-2h-1v2h-2v1h2z" })
            );
        }
        function EnvelopePlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EnvelopePlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EnvelopePlus.SVG = EnvelopePlusSVG;
        return EnvelopePlus;
    })();
export const EnvelopeWarning = /*#__PURE__*/ (() => {
        function EnvelopeWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 10h1v1h-1v-1z" }),
_('path', { d: "M18 5h1v4h-1v-4z" }),
_('path', { d: "M23.841 10.828l-4-7.997c-0.25-0.506-0.775-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-1.584 3.172h-13.575c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h18c1.103 0 2-0.897 2-2v-5h0.5c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672zM6.831 12.462l-4.831 4.831v-8.334l4.831 3.503zM7.65 13.056l2.175 1.578c0.35 0.253 0.762 0.381 1.172 0.381 0.413 0 0.822-0.128 1.175-0.381l2.175-1.578 4.947 4.944h-16.587l4.944-4.944zM13.159 10.828c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.022 0 0.044 0 0.066l-2 1.45c0 0-0.003 0-0.003 0l-6.916-5.016h10.491l-1.413 2.828zM20 17.294l-4.294-4.294h4.294v4.294zM22.5 12h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5z" })
            );
        }
        function EnvelopeWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EnvelopeWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EnvelopeWarning.SVG = EnvelopeWarningSVG;
        return EnvelopeWarning;
    })();
export const Envelope = /*#__PURE__*/ (() => {
    function EnvelopeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21 5h-18c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h18c1.103 0 2-0.897 2-2v-10c0-1.103-0.897-2-2-2zM12 12.016l-6.916-5.016h13.834l-6.919 5.016zM7.831 11.463l-4.831 4.831v-8.334l4.831 3.503zM8.65 12.056l2.175 1.578c0.35 0.253 0.762 0.381 1.175 0.381s0.822-0.128 1.175-0.381l2.175-1.578 4.944 4.944h-16.587l4.944-4.944zM16.169 11.463l4.831-3.503v8.334l-4.831-4.831z" })
        );
    }
    function Envelope({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EnvelopeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Envelope.SVG = EnvelopeSVG;
    return Envelope;
})();
export const Equalizer = /*#__PURE__*/ (() => {
        function EqualizerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 9c-1.103 0-2 0.897-2 2h-16v2h16c0 1.103 0.897 2 2 2s2-0.897 2-2h4v-2h-4c0-1.103-0.897-2-2-2zM19 13c0 0.55-0.45 1-1 1s-1-0.45-1-1v-2c0-0.55 0.45-1 1-1s1 0.45 1 1v2z" }),
_('path', { d: "M8 3c0-1.103-0.897-2-2-2s-2 0.897-2 2h-4v2h4c0 1.103 0.897 2 2 2s2-0.897 2-2h16v-2h-16zM7 5c0 0.55-0.45 1-1 1s-1-0.45-1-1v-2c0-0.55 0.45-1 1-1s1 0.45 1 1v2z" }),
_('path', { d: "M9 17c-1.103 0-2 0.897-2 2h-7v2h7c0 1.103 0.897 2 2 2s2-0.897 2-2h13v-2h-13c0-1.103-0.897-2-2-2zM10 21c0 0.55-0.45 1-1 1s-1-0.45-1-1v-2c0-0.55 0.45-1 1-1s1 0.45 1 1v2z" })
            );
        }
        function Equalizer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EqualizerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Equalizer.SVG = EqualizerSVG;
        return Equalizer;
    })();
export const Equalizer2 = /*#__PURE__*/ (() => {
        function Equalizer2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 16v-16h-2v16c-1.103 0-2 0.897-2 2s0.897 2 2 2v4h2v-4c1.103 0 2-0.897 2-2s-0.897-2-2-2zM13 19h-2c-0.55 0-1-0.45-1-1s0.45-1 1-1h2c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M5 10v-10h-2v10c-1.103 0-2 0.897-2 2s0.897 2 2 2v10h2v-10c1.103 0 2-0.897 2-2s-0.897-2-2-2zM5 13h-2c-0.55 0-1-0.45-1-1s0.45-1 1-1h2c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M21 4v-4h-2v4c-1.103 0-2 0.897-2 2s0.897 2 2 2v16h2v-16c1.103 0 2-0.897 2-2s-0.897-2-2-2zM21 7h-2c-0.55 0-1-0.45-1-1s0.45-1 1-1h2c0.55 0 1 0.45 1 1s-0.45 1-1 1z" })
            );
        }
        function Equalizer2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Equalizer2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Equalizer2.SVG = Equalizer2SVG;
        return Equalizer2;
    })();
export const EqualsCircle = /*#__PURE__*/ (() => {
        function EqualsCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M8 9h8v2h-8v-2z" }),
_('path', { d: "M8 13h8v2h-8v-2z" })
            );
        }
        function EqualsCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EqualsCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EqualsCircle.SVG = EqualsCircleSVG;
        return EqualsCircle;
    })();
export const EqualsSquare = /*#__PURE__*/ (() => {
        function EqualsSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M8 9h8v2h-8v-2z" }),
_('path', { d: "M8 13h8v2h-8v-2z" })
            );
        }
        function EqualsSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EqualsSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EqualsSquare.SVG = EqualsSquareSVG;
        return EqualsSquare;
    })();
export const Eraser = /*#__PURE__*/ (() => {
        function EraserSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.409 8.006l-6.4-6.413c-0.378-0.378-0.881-0.588-1.416-0.588v0c-0.534 0-1.038 0.209-1.416 0.584l-9.584 9.588c-0.378 0.378-0.584 0.881-0.584 1.416s0.209 1.038 0.584 1.413l3.987 3.994h-5.581v1h11.894c0.266 0 0.522-0.106 0.709-0.297l7.812-7.878c0.772-0.778 0.772-2.044-0.006-2.819zM14.478 17h-4.069l-4.4-4.406 5.441-5.441 6.422 6.422-3.394 3.425zM18.575 12.869l-6.422-6.422 3.438-3.438 6.403 6.409-3.419 3.45z" }),
_('path', { d: "M0 20h8v1h-8v-1z" }),
_('path', { d: "M2 22h8v1h-8v-1z" })
            );
        }
        function Eraser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EraserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Eraser.SVG = EraserSVG;
        return Eraser;
    })();
export const EscalatorDown = /*#__PURE__*/ (() => {
        function EscalatorDownSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.997 17.484c-0.009-2.472-2.044-4.484-4.537-4.484h-2.547l-1.916-1.916v-5.084c0-0.553-0.447-1-1-1s-1 0.447-1 1v3.081l-4.5-4.5c-0.378-0.378-0.881-0.588-1.413-0.588h-2.547c-2.494 0.003-4.528 2.016-4.537 4.488-0.003 1.206 0.462 2.337 1.313 3.194 0.85 0.853 1.981 1.322 3.188 1.322h2.584l8.412 8.416c0.378 0.378 0.878 0.588 1.413 0.588h2.587c1.203 0 2.337-0.469 3.188-1.322 0.85-0.856 1.316-1.987 1.313-3.194zM21.266 19.266c-0.472 0.475-1.1 0.734-1.769 0.734h-2.587l-8.412-8.416c-0.378-0.378-0.881-0.588-1.413-0.588h-2.584c-0.669 0-1.297-0.262-1.769-0.734-0.475-0.475-0.734-1.106-0.731-1.775 0.003-1.372 1.144-2.491 2.538-2.491h2.547l8.416 8.416c0.378 0.378 0.881 0.588 1.413 0.588h2.547c1.394 0 2.534 1.119 2.538 2.491 0.003 0.669-0.256 1.3-0.731 1.775z" }),
_('path', { d: "M15.997 3c0-1.103-0.897-2-2-2s-2 0.897-2 2 0.897 2 2 2 2-0.897 2-2zM13.997 4c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M9.997 21.294l-6.5-6.5-0.706 0.706 6.5 6.5h-2.294v1h3.5c0.275 0 0.5-0.225 0.5-0.5v-3.5h-1v2.294z" })
            );
        }
        function EscalatorDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EscalatorDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EscalatorDown.SVG = EscalatorDownSVG;
        return EscalatorDown;
    })();
export const EscalatorUp = /*#__PURE__*/ (() => {
        function EscalatorUpSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.997 8.481c-0.009-2.472-2.044-4.484-4.537-4.484h-2.547c-0.534 0-1.034 0.209-1.413 0.588l-4.5 4.5v-3.084c0-0.553-0.447-1-1-1s-1 0.447-1 1v5.084l-1.916 1.916h-2.547c-2.494 0-4.528 2.013-4.537 4.484-0.003 1.206 0.462 2.337 1.313 3.194 0.85 0.853 1.984 1.322 3.188 1.322h2.587c0.534 0 1.034-0.209 1.413-0.588l8.412-8.416h2.584c1.203 0 2.337-0.469 3.188-1.322 0.85-0.856 1.316-1.988 1.313-3.194zM21.266 10.263c-0.472 0.475-1.1 0.734-1.769 0.734h-2.584c-0.534 0-1.034 0.209-1.413 0.588l-8.412 8.416h-2.588c-0.669 0-1.297-0.263-1.769-0.734-0.472-0.475-0.731-1.103-0.731-1.775 0.003-1.372 1.144-2.491 2.538-2.491h2.547c0.534 0 1.034-0.209 1.413-0.588l8.416-8.416h2.547c1.394 0 2.534 1.119 2.538 2.491 0.003 0.669-0.256 1.3-0.731 1.775z" }),
_('path', { d: "M20.5 15h-3.5v1h2.294l-6.5 6.5 0.706 0.706 6.5-6.5v2.294h1v-3.5c0-0.275-0.225-0.5-0.5-0.5z" }),
_('path', { d: "M12 3c0-1.103-0.897-2-2-2s-2 0.897-2 2 0.897 2 2 2 2-0.897 2-2zM10 4c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
            );
        }
        function EscalatorUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EscalatorUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EscalatorUp.SVG = EscalatorUpSVG;
        return EscalatorUp;
    })();
export const Evil = /*#__PURE__*/ (() => {
        function EvilSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.266-0.631-0.584-1.234-0.95-1.803 1.15-1.741 0.903-4.922 0.894-5.066-0.019-0.216-0.172-0.394-0.378-0.444-0.209-0.050-0.428 0.038-0.541 0.219-0.012 0.019-1.013 1.584-2.591 2.388-0.859-0.687-1.803-1.247-2.819-1.678-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.016 0.431-1.959 0.991-2.816 1.678-1.572-0.806-2.578-2.369-2.591-2.388-0.116-0.181-0.334-0.269-0.541-0.219-0.209 0.050-0.363 0.231-0.378 0.444-0.012 0.144-0.259 3.328 0.894 5.066-0.366 0.572-0.684 1.172-0.95 1.803-0.628 1.481-0.947 3.053-0.947 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM22.016 1.909c-0.041 0.888-0.181 1.95-0.547 2.716-0.303-0.387-0.631-0.759-0.981-1.109-0.066-0.066-0.131-0.131-0.197-0.194 0.703-0.419 1.287-0.947 1.725-1.413zM1.984 1.909c0.438 0.466 1.022 0.994 1.728 1.413-0.066 0.063-0.131 0.128-0.197 0.194-0.353 0.35-0.681 0.722-0.984 1.109-0.366-0.769-0.506-1.828-0.547-2.716zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M7.381 7.503c-0.237 0.266-0.381 0.616-0.381 0.997 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.181-0.031-0.356-0.091-0.516 0.194 0.009 0.394 0.016 0.591 0.016h0.5v-1h-0.5c-1.437 0-2.816-0.325-3.784-0.894l-0.431-0.253-0.506 0.863 0.431 0.253c0.356 0.209 0.747 0.387 1.172 0.534zM8.5 9c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M17.247 6.106c-0.969 0.569-2.347 0.894-3.784 0.894h-0.5v1h0.5c0.213 0 0.422-0.006 0.631-0.019-0.059 0.162-0.094 0.337-0.094 0.519 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.387-0.147-0.741-0.387-1.006 0.413-0.147 0.794-0.322 1.141-0.525l0.431-0.253-0.506-0.863-0.431 0.253zM15.5 9c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M17.341 13.025c-3.894 1.3-6.791 1.3-10.684 0l-0.475-0.159-0.316 0.95 0.475 0.159c2.1 0.7 3.897 1.025 5.659 1.025s3.559-0.325 5.659-1.025l0.475-0.159-0.316-0.95-0.478 0.159z" })
            );
        }
        function Evil({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EvilSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Evil.SVG = EvilSVG;
        return Evil;
    })();
export const Exclamation = /*#__PURE__*/ (() => {
        function ExclamationSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 2h2v16h-2v-16z" }),
_('path', { d: "M11 20h2v2h-2v-2z" })
            );
        }
        function Exclamation({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ExclamationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Exclamation.SVG = ExclamationSVG;
        return Exclamation;
    })();
export const Exclude = /*#__PURE__*/ (() => {
    function ExcludeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21 7h-4v-4c0-1.103-0.897-2-2-2h-12c-1.103 0-2 0.897-2 2v12c0 1.103 0.897 2 2 2h4v4c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2v-12c0-1.103-0.897-2-2-2zM3 15v-12h12v5h-6.5c-0.275 0-0.5 0.225-0.5 0.5v6.5h-5zM15 9v6h-6v-6h6zM21 21h-12v-5h6.5c0.275 0 0.5-0.225 0.5-0.5v-6.5h5v12z" })
        );
    }
    function Exclude({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ExcludeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Exclude.SVG = ExcludeSVG;
    return Exclude;
})();
export const Exit = /*#__PURE__*/ (() => {
        function ExitSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1.553 0.106c0.144-0.072 0.297-0.106 0.453-0.106h12.494c0.275 0 0.5 0.225 0.5 0.5v4.5h-1v-4h-10.334l6.934 5.2c0.253 0.188 0.4 0.484 0.4 0.8v10h3v-4h1v4.5c0 0.275-0.225 0.5-0.5 0.5h-3.5v5c0 0.378-0.213 0.725-0.553 0.894-0.141 0.072-0.294 0.106-0.447 0.106-0.213 0-0.425-0.069-0.6-0.2l-8-6c-0.253-0.188-0.4-0.484-0.4-0.8v-16c0-0.378 0.213-0.725 0.553-0.894zM3 16.5l6 4.5v-13.5l-6-4.5v13.5z" }),
_('path', { d: "M13 10v-2h6.584l-2.544-2.544 1.416-1.416 4.25 4.25c0.391 0.391 0.391 1.025 0 1.416l-4.25 4.25-1.416-1.416 2.544-2.541h-6.584z" })
            );
        }
        function Exit({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ExitSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Exit.SVG = ExitSVG;
        return Exit;
    })();
export const ExpandHorizontal = /*#__PURE__*/ (() => {
        function ExpandHorizontalSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.706 11.294l-6.25-6.25-1.416 1.416 5.544 5.541-5.541 5.544 1.416 1.416 6.25-6.25c0.387-0.394 0.387-1.025-0.003-1.416z" }),
_('path', { d: "M6.544 5.044l-6.25 6.25c-0.391 0.391-0.391 1.025 0 1.416l6.25 6.25 1.416-1.416-5.544-5.544 5.544-5.544-1.416-1.413z" })
            );
        }
        function ExpandHorizontal({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ExpandHorizontalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ExpandHorizontal.SVG = ExpandHorizontalSVG;
        return ExpandHorizontal;
    })();
export const ExpandSquare = /*#__PURE__*/ (() => {
        function ExpandSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M9.5 13.794l-4.5 4.5v-1.294h-1v2.5c0 0.275 0.225 0.5 0.5 0.5h2.5v-1h-1.294l4.5-4.5-0.706-0.706z" }),
_('path', { d: "M19.5 4h-2.5v1h1.294l-4.5 4.5 0.706 0.706 4.5-4.5v1.294h1v-2.5c0-0.275-0.225-0.5-0.5-0.5z" }),
_('path', { d: "M19 18.294l-4.5-4.5-0.706 0.706 4.5 4.5h-1.294v1h2.5c0.275 0 0.5-0.225 0.5-0.5v-2.5h-1v1.294z" }),
_('path', { d: "M7 5v-1h-2.5c-0.275 0-0.5 0.225-0.5 0.5v2.5h1v-1.294l4.5 4.5 0.706-0.706-4.5-4.5h1.294z" })
            );
        }
        function ExpandSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ExpandSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ExpandSquare.SVG = ExpandSquareSVG;
        return ExpandSquare;
    })();
export const ExpandSquare2 = /*#__PURE__*/ (() => {
        function ExpandSquare2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M19.5 4h-2.5v1h1.294l-13.294 13.294v-1.294h-1v2.5c0 0.275 0.225 0.5 0.5 0.5h2.5v-1h-1.294l13.294-13.294v1.294h1v-2.5c0-0.275-0.225-0.5-0.5-0.5z" })
            );
        }
        function ExpandSquare2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ExpandSquare2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ExpandSquare2.SVG = ExpandSquare2SVG;
        return ExpandSquare2;
    })();
export const ExpandVertical = /*#__PURE__*/ (() => {
        function ExpandVerticalSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 2.416l5.544 5.544 1.416-1.416-6.25-6.25c-0.391-0.391-1.025-0.391-1.416 0l-6.25 6.25 1.416 1.416 5.541-5.544z" }),
_('path', { d: "M12 21.584l-5.544-5.541-1.416 1.416 6.25 6.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l6.25-6.25-1.416-1.416-5.538 5.541z" })
            );
        }
        function ExpandVertical({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ExpandVerticalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ExpandVertical.SVG = ExpandVerticalSVG;
        return ExpandVertical;
    })();
export const Expand = /*#__PURE__*/ (() => {
        function ExpandSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 2v-2h-6c-0.553 0-1 0.447-1 1v6h2v-3.584l5.544 5.544 1.416-1.416-5.544-5.544h3.584z" }),
_('path', { d: "M7.544 15.044l-5.544 5.541v-3.584h-2v6c0 0.553 0.447 1 1 1h6v-2h-3.584l5.544-5.544-1.416-1.413z" }),
_('path', { d: "M22 20.584l-5.544-5.541-1.416 1.416 5.544 5.541h-3.584v2h6c0.553 0 1-0.447 1-1v-6h-2v3.584z" }),
_('path', { d: "M23 0h-6v2h3.584l-5.541 5.544 1.416 1.416 5.541-5.544v3.584h2v-6c0-0.553-0.447-1-1-1z" })
            );
        }
        function Expand({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ExpandSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Expand.SVG = ExpandSVG;
        return Expand;
    })();
export const Expand2 = /*#__PURE__*/ (() => {
        function Expand2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8.544 14.044l-6.544 6.541v-3.584h-2v6c0 0.553 0.447 1 1 1h6v-2h-3.584l6.544-6.544-1.416-1.413z" }),
_('path', { d: "M23 0h-6v2h3.584l-6.541 6.544 1.416 1.416 6.541-6.544v3.584h2v-6c0-0.553-0.447-1-1-1z" })
            );
        }
        function Expand2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Expand2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Expand2.SVG = Expand2SVG;
        return Expand2;
    })();
export const Explosion = /*#__PURE__*/ (() => {
        function ExplosionSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.584 19h-0.775l-0.863-1.725c-0.084-0.169-0.259-0.275-0.447-0.275s-0.363 0.106-0.447 0.275l-0.862 1.725h-2.191v-0.191l1.725-0.862c0.097-0.047 0.175-0.128 0.225-0.225l1-2c0.078-0.156 0.069-0.338-0.022-0.488-0.091-0.147-0.253-0.237-0.425-0.237h-2.191l0.638-1.275c0.097-0.194 0.056-0.428-0.097-0.581l-1.853-1.812-0.328-0.931c-1.662 0.588-3.031 1.769-3.859 3.328-0.831 1.566-1.034 3.375-0.575 5.088 0.484 1.806 1.644 3.316 3.263 4.25 1.078 0.622 2.278 0.941 3.491 0.941 0.606 0 1.219-0.081 1.822-0.241 2.228-0.597 4.019-2.253 4.791-4.428l-1.884-0.669c-0.041 0.113-0.087 0.225-0.134 0.334zM8.294 21.831c-2.663 0.712-5.409-0.875-6.125-3.537-0.622-2.309 0.513-4.734 2.613-5.775l1.109 1.084-0.837 1.675c-0.078 0.156-0.069 0.337 0.022 0.487 0.091 0.147 0.253 0.237 0.425 0.237h2.191l-0.563 1.128-1.85 0.925c-0.169 0.084-0.275 0.259-0.275 0.447v1c0 0.275 0.225 0.5 0.5 0.5h3c0.191 0 0.363-0.106 0.447-0.275l0.553-1.106 0.553 1.106c0.084 0.169 0.259 0.275 0.447 0.275h0.503c-0.669 0.881-1.616 1.534-2.712 1.828z" }),
_('path', { d: "M7.84 10.754l4.406-9.915 0.914 0.406-4.406 9.915-0.914-0.406z" }),
_('path', { d: "M9.794 13.499l9.707-9.707 0.707 0.707-9.707 9.707-0.707-0.707z" }),
_('path', { d: "M11.952 16.052l10.995-1.1 0.1 0.995-10.995 1.1-0.1-0.995z" }),
_('path', { d: "M4.005 1.072l0.99-0.141 1 7-0.99 0.141-1-7z" }),
_('path', { d: "M15.5 5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM15.5 3c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M14.929 19.996l0.141-0.99 7 1-0.141 0.99-7-1z" }),
_('path', { d: "M22 4c1.103 0 2-0.897 2-2s-0.897-2-2-2-2 0.897-2 2 0.897 2 2 2zM22 1c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M22.5 8c-0.828 0-1.5 0.672-1.5 1.5 0 0.091 0.009 0.181 0.025 0.269l-6.206 3.544 0.497 0.869 6.206-3.547c0.262 0.228 0.606 0.366 0.978 0.366 0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5zM22.5 10c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M8 4.978c0.541 0 0.978-0.438 0.978-0.978s-0.438-0.978-0.978-0.978-0.978 0.438-0.978 0.978 0.438 0.978 0.978 0.978zM8 3.978c0.012 0 0.022 0.009 0.022 0.022s-0.009 0.022-0.022 0.022-0.022-0.009-0.022-0.022 0.009-0.022 0.022-0.022z" }),
_('path', { d: "M24 18c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" }),
_('path', { d: "M22 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M19 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M13 7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M10 0.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Explosion({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ExplosionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Explosion.SVG = ExplosionSVG;
        return Explosion;
    })();
export const Exposure = /*#__PURE__*/ (() => {
        function ExposureSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM19.294 4l-15.294 15.294v-15.294h15.294zM4.706 20l15.294-15.294v15.294h-15.294z" }),
_('path', { d: "M16 13h-1v2h-2v1h2v2h1v-2h2v-1h-2z" }),
_('path', { d: "M6 8h5v1h-5v-1z" })
            );
        }
        function Exposure({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ExposureSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Exposure.SVG = ExposureSVG;
        return Exposure;
    })();
export const External = /*#__PURE__*/ (() => {
        function ExternalSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 0h-8v2h5.584l-12.541 12.544 1.416 1.416 12.541-12.544v5.584h2v-8c0-0.553-0.447-1-1-1z" }),
_('path', { d: "M17 23h-16v-16h8v-1h-8.5c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-8.5h-1v8z" })
            );
        }
        function External({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ExternalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        External.SVG = ExternalSVG;
        return External;
    })();
export const External2 = /*#__PURE__*/ (() => {
        function External2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 5h-6v2h3.584l-5.541 5.544 1.416 1.416 5.541-5.544v3.584h2v-6c0-0.553-0.447-1-1-1z" }),
_('path', { d: "M22 0h-15c-1.103 0-2 0.897-2 2v3h-4.5c-0.275 0-0.5 0.225-0.5 0.5v18c0 0.275 0.225 0.5 0.5 0.5h18c0.275 0 0.5-0.225 0.5-0.5v-4.5h3c1.103 0 2-0.897 2-2v-15c0-1.103-0.897-2-2-2zM18 23h-17v-17h4v11c0 1.103 0.897 2 2 2h11v4zM22 17h-15v-15h15v15c0.003 0 0 0 0 0z" })
            );
        }
        function External2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( External2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        External2.SVG = External2SVG;
        return External2;
    })();
export const Extinguisher = /*#__PURE__*/ (() => {
    function ExtinguisherSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.975 5.341c-0.012-0.038-0.331-0.963-1.084-1.953-1.009-1.331-2.331-2.156-3.816-2.381l-0.038-0.006h2.962c0.55 0 1 0.45 1 1h1c0-1.103-0.897-2-2-2h-5c-0.741 0-1.388 0.403-1.734 1.003-2.175 0.059-4.169 0.969-5.634 2.569-1.634 1.784-2.538 4.344-2.625 7.428h-0.506c-0.256 0-0.469 0.191-0.497 0.444l-1 9c-0.016 0.141 0.028 0.281 0.125 0.387 0.094 0.106 0.231 0.166 0.372 0.166h4c0.144 0 0.278-0.059 0.372-0.166s0.141-0.247 0.125-0.387l-1-9c-0.028-0.253-0.241-0.444-0.497-0.444h-0.494c0.178-5.928 3.528-8.738 6.994-8.981 0.003 0.466 0.169 0.894 0.441 1.234-1.994 0.663-3.441 2.562-3.441 4.791v13.956c0 1.103 0.897 2 2 2h6c1.103 0 2-0.897 2-2v-14c0-1.338-0.522-2.597-1.472-3.541-0.563-0.559-1.234-0.972-1.969-1.209 0.272-0.341 0.438-0.772 0.438-1.241 1.2 0.2 2.234 0.859 3.075 1.959 0.663 0.863 0.95 1.688 0.95 1.694l0.159 0.475 0.947-0.322-0.153-0.475zM5.941 20h-2.881l0.888-8h1.106l0.888 8zM14 1c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM17 9v11h-6v-11h6zM11 22v-1h6v1h-6zM17 8h-6c0.022-1.653 1.356-2.994 2.988-3 0.003 0 0.006 0 0.009 0 0.8 0 1.55 0.309 2.119 0.875 0.572 0.566 0.884 1.322 0.884 2.125z" })
        );
    }
    function Extinguisher({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ExtinguisherSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Extinguisher.SVG = ExtinguisherSVG;
    return Extinguisher;
})();
export const ExtractDown = /*#__PURE__*/ (() => {
        function ExtractDownSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.5 1h-17c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h6.5v-1h-6v-10h16v10h-6v1h6.5c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5z" }),
_('path', { d: "M13 19.584v-12.584h-2v12.584l-2.544-2.544-1.416 1.416 4.25 4.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l4.25-4.25-1.416-1.416-2.538 2.544z" })
            );
        }
        function ExtractDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ExtractDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ExtractDown.SVG = ExtractDownSVG;
        return ExtractDown;
    })();
export const ExtractLeft = /*#__PURE__*/ (() => {
        function ExtractLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.5 3h-11c-0.275 0-0.5 0.225-0.5 0.5v6.5h1v-6h10v16h-10v-6h-1v6.5c0 0.275 0.225 0.5 0.5 0.5h11c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5z" }),
_('path', { d: "M17 13v-2h-12.584l2.544-2.544-1.416-1.416-4.25 4.25c-0.391 0.391-0.391 1.025 0 1.416l4.25 4.25 1.416-1.416-2.544-2.541h12.584z" })
            );
        }
        function ExtractLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ExtractLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ExtractLeft.SVG = ExtractLeftSVG;
        return ExtractLeft;
    })();
export const ExtractRight = /*#__PURE__*/ (() => {
        function ExtractRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 20h-10v-16h10v6h1v-6.5c0-0.275-0.225-0.5-0.5-0.5h-11c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h11c0.275 0 0.5-0.225 0.5-0.5v-6.5h-1v6z" }),
_('path', { d: "M22.706 11.294l-4.25-4.25-1.416 1.416 2.544 2.544h-12.584v2h12.584l-2.544 2.544 1.416 1.416 4.25-4.25c0.391-0.397 0.391-1.028 0-1.419z" })
            );
        }
        function ExtractRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ExtractRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ExtractRight.SVG = ExtractRightSVG;
        return ExtractRight;
    })();
export const ExtractUp = /*#__PURE__*/ (() => {
        function ExtractUpSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.5 11h-6.5v1h6v10h-16v-10h6v-1h-6.5c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5z" }),
_('path', { d: "M11 4.416v12.584h2v-12.584l2.544 2.544 1.416-1.416-4.25-4.25c-0.391-0.391-1.025-0.391-1.416 0l-4.25 4.25 1.416 1.416 2.541-2.544z" })
            );
        }
        function ExtractUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ExtractUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ExtractUp.SVG = ExtractUpSVG;
        return ExtractUp;
    })();
export const EyeCross = /*#__PURE__*/ (() => {
        function EyeCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0.262 13.325c1.816-1.981 3.669-3.516 5.503-4.559 1.731-0.987 3.497-1.563 5.25-1.722 0.234-3.372 3.053-6.044 6.484-6.044 3.584 0 6.5 2.916 6.5 6.5 0 1.678-0.641 3.213-1.688 4.366 0.475 0.453 0.953 0.944 1.425 1.459 0.35 0.381 0.35 0.969 0 1.353-1.9 2.072-3.837 3.653-5.759 4.703-1.972 1.072-3.984 1.619-5.978 1.619s-4.006-0.547-5.978-1.622c-1.922-1.047-3.859-2.631-5.759-4.703-0.35-0.381-0.35-0.969 0-1.35zM8 13c0 2.206 1.794 4 4 4 1.931 0 3.547-1.344 3.919-3.194-2.316-0.581-4.144-2.409-4.725-4.725-1.85 0.372-3.194 1.988-3.194 3.919zM17.5 2c-3.031 0-5.5 2.469-5.5 5.5s2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5-2.469-5.5-5.5-5.5zM12 19c3.15 0 6.384-1.681 9.625-5-0.294-0.303-0.591-0.591-0.884-0.866-0.953 0.55-2.063 0.866-3.241 0.866-0.2 0-0.4-0.009-0.594-0.028-0.206 1.038-0.734 1.987-1.525 2.712-0.925 0.847-2.125 1.316-3.381 1.316-2.756 0-5-2.244-5-5 0-1.166 0.403-2.284 1.141-3.178-1.906 0.806-3.834 2.203-5.763 4.178 3.237 3.319 6.472 5 9.622 5z" }),
_('path', { d: "M19.5 10.206l-2-2-2 2-0.706-0.706 2-2-2-2 0.706-0.706 2 2 2-2 0.706 0.706-2 2 2 2z" })
            );
        }
        function EyeCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EyeCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EyeCross.SVG = EyeCrossSVG;
        return EyeCross;
    })();
export const EyeDroplet = /*#__PURE__*/ (() => {
        function EyeDropletSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0.262 13.325c1.816-1.981 3.669-3.516 5.503-4.559 1.731-0.987 3.497-1.563 5.25-1.722 0.234-3.372 3.053-6.044 6.484-6.044 3.584 0 6.5 2.916 6.5 6.5 0 1.678-0.641 3.213-1.688 4.366 0.475 0.453 0.953 0.944 1.425 1.459 0.35 0.381 0.35 0.969 0 1.353-1.9 2.072-3.837 3.653-5.759 4.703-1.972 1.072-3.984 1.619-5.978 1.619s-4.006-0.547-5.978-1.622c-1.922-1.047-3.859-2.631-5.759-4.703-0.35-0.381-0.35-0.969 0-1.35zM8 13c0 2.206 1.794 4 4 4 1.931 0 3.547-1.344 3.919-3.194-2.316-0.581-4.144-2.409-4.725-4.725-1.85 0.372-3.194 1.988-3.194 3.919zM17.5 2c-3.031 0-5.5 2.469-5.5 5.5s2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5-2.469-5.5-5.5-5.5zM12 19c3.15 0 6.384-1.681 9.625-5-0.294-0.303-0.591-0.591-0.884-0.866-0.953 0.55-2.063 0.866-3.241 0.866-0.2 0-0.4-0.009-0.594-0.028-0.206 1.038-0.734 1.987-1.525 2.712-0.925 0.847-2.125 1.316-3.381 1.316-2.756 0-5-2.244-5-5 0-1.166 0.403-2.284 1.141-3.178-1.906 0.806-3.834 2.203-5.763 4.178 3.237 3.319 6.472 5 9.622 5z" }),
_('path', { d: "M17.5 12c-1.378 0-2.5-1.25-2.5-2.784 0-1.259 0.619-2.522 1.166-3.634 0.387-0.791 0.756-1.541 0.837-2.147 0.034-0.247 0.247-0.431 0.497-0.434 0 0 0 0 0 0 0.25 0 0.462 0.184 0.497 0.434 0.081 0.606 0.45 1.353 0.837 2.144 0.547 1.113 1.166 2.375 1.166 3.634 0 1.538-1.122 2.787-2.5 2.787zM17.934 6.022c-0.153-0.309-0.303-0.616-0.434-0.912-0.134 0.297-0.284 0.603-0.438 0.912-0.522 1.066-1.062 2.166-1.062 3.194 0 0.984 0.672 1.784 1.5 1.784s1.5-0.8 1.5-1.784c0-1.028-0.541-2.131-1.066-3.194z" })
            );
        }
        function EyeDroplet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EyeDropletSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EyeDroplet.SVG = EyeDropletSVG;
        return EyeDroplet;
    })();
export const EyeMinus = /*#__PURE__*/ (() => {
        function EyeMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0.262 13.325c1.816-1.981 3.669-3.516 5.503-4.559 1.731-0.987 3.497-1.563 5.25-1.722 0.234-3.372 3.053-6.044 6.484-6.044 3.584 0 6.5 2.916 6.5 6.5 0 1.678-0.641 3.213-1.688 4.366 0.475 0.453 0.953 0.944 1.425 1.459 0.35 0.381 0.35 0.969 0 1.353-1.9 2.072-3.837 3.653-5.759 4.703-1.972 1.072-3.984 1.619-5.978 1.619s-4.006-0.547-5.978-1.622c-1.922-1.047-3.859-2.631-5.759-4.703-0.35-0.381-0.35-0.969 0-1.35zM8 13c0 2.206 1.794 4 4 4 1.931 0 3.547-1.344 3.919-3.194-2.316-0.581-4.144-2.409-4.725-4.725-1.85 0.372-3.194 1.988-3.194 3.919zM17.5 2c-3.031 0-5.5 2.469-5.5 5.5s2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5-2.469-5.5-5.5-5.5zM12 19c3.15 0 6.384-1.681 9.625-5-0.294-0.303-0.591-0.591-0.884-0.866-0.953 0.55-2.063 0.866-3.241 0.866-0.2 0-0.4-0.009-0.594-0.028-0.206 1.038-0.734 1.987-1.525 2.712-0.925 0.847-2.125 1.316-3.381 1.316-2.756 0-5-2.244-5-5 0-1.166 0.403-2.284 1.141-3.178-1.906 0.806-3.834 2.203-5.763 4.178 3.237 3.319 6.472 5 9.622 5z" }),
_('path', { d: "M20 7h-5v1h5v-1z" })
            );
        }
        function EyeMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EyeMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EyeMinus.SVG = EyeMinusSVG;
        return EyeMinus;
    })();
export const EyePlus = /*#__PURE__*/ (() => {
        function EyePlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0.262 13.325c1.816-1.981 3.669-3.516 5.503-4.559 1.731-0.987 3.497-1.563 5.25-1.722 0.234-3.372 3.053-6.044 6.484-6.044 3.584 0 6.5 2.916 6.5 6.5 0 1.678-0.641 3.213-1.688 4.366 0.475 0.453 0.953 0.944 1.425 1.459 0.35 0.381 0.35 0.969 0 1.353-1.9 2.072-3.837 3.653-5.759 4.703-1.972 1.072-3.984 1.619-5.978 1.619s-4.006-0.547-5.978-1.622c-1.922-1.047-3.859-2.631-5.759-4.703-0.35-0.381-0.35-0.969 0-1.35zM8 13c0 2.206 1.794 4 4 4 1.931 0 3.547-1.344 3.919-3.194-2.316-0.581-4.144-2.409-4.725-4.725-1.85 0.372-3.194 1.988-3.194 3.919zM17.5 2c-3.031 0-5.5 2.469-5.5 5.5s2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5-2.469-5.5-5.5-5.5zM12 19c3.15 0 6.384-1.681 9.625-5-0.294-0.303-0.591-0.591-0.884-0.866-0.953 0.55-2.063 0.866-3.241 0.866-0.2 0-0.4-0.009-0.594-0.028-0.206 1.038-0.734 1.987-1.525 2.712-0.925 0.847-2.125 1.316-3.381 1.316-2.756 0-5-2.244-5-5 0-1.166 0.403-2.284 1.141-3.178-1.906 0.806-3.834 2.203-5.763 4.178 3.237 3.319 6.472 5 9.622 5z" }),
_('path', { d: "M18 10h-1v-2h-2v-1h2v-2h1v2h2v1h-2z" })
            );
        }
        function EyePlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EyePlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EyePlus.SVG = EyePlusSVG;
        return EyePlus;
    })();
export const Eye = /*#__PURE__*/ (() => {
    function EyeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.737 11.325c-1.9-2.072-3.837-3.653-5.759-4.703-1.972-1.075-3.984-1.622-5.978-1.622s-4.006 0.547-5.978 1.622c-1.922 1.047-3.859 2.631-5.759 4.703-0.35 0.381-0.35 0.969 0 1.35 1.9 2.072 3.837 3.653 5.759 4.703 1.972 1.075 3.984 1.622 5.978 1.622s4.006-0.547 5.978-1.622c1.922-1.047 3.859-2.631 5.759-4.703 0.35-0.381 0.35-0.969 0-1.35zM16 11c0 2.206-1.794 4-4 4s-4-1.794-4-4c0-2.206 1.794-4 4-4v0c2.206 0 4 1.794 4 4zM12 17c-3.15 0-6.384-1.681-9.625-5 1.928-1.978 3.856-3.372 5.766-4.178-0.712 0.866-1.141 1.972-1.141 3.178 0 2.756 2.244 5 5 5s5-2.244 5-5c0-1.206-0.428-2.313-1.144-3.178 1.909 0.806 3.837 2.2 5.769 4.178-3.241 3.319-6.475 5-9.625 5z" })
        );
    }
    function Eye({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EyeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Eye.SVG = EyeSVG;
    return Eye;
})();
export const Eye2 = /*#__PURE__*/ (() => {
        function Eye2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.737 11.325c-1.9-2.072-3.837-3.653-5.759-4.703-1.972-1.075-3.984-1.622-5.978-1.622s-4.006 0.547-5.978 1.622c-1.922 1.047-3.859 2.631-5.759 4.703-0.35 0.381-0.35 0.969 0 1.35 1.9 2.072 3.837 3.653 5.759 4.703 1.972 1.075 3.984 1.622 5.978 1.622s4.006-0.547 5.978-1.622c1.922-1.047 3.859-2.631 5.759-4.703 0.35-0.381 0.35-0.969 0-1.35zM16 11c0 2.206-1.794 4-4 4s-4-1.794-4-4c0-2.206 1.794-4 4-4v0c2.206 0 4 1.794 4 4zM12 17c-3.15 0-6.384-1.681-9.625-5 1.928-1.978 3.856-3.372 5.766-4.178-0.712 0.866-1.141 1.972-1.141 3.178 0 2.756 2.244 5 5 5s5-2.244 5-5c0-1.206-0.428-2.313-1.144-3.178 1.909 0.806 3.837 2.2 5.769 4.178-3.241 3.319-6.475 5-9.625 5z" }),
_('path', { d: "M10 11c0 1.103 0.897 2 2 2s2-0.897 2-2c0-1.103-0.897-2-2-2s-2 0.897-2 2zM13 11c0 0.55-0.45 1-1 1s-1-0.45-1-1 0.45-1 1-1c0.55 0 1 0.45 1 1z" })
            );
        }
        function Eye2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Eye2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Eye2.SVG = Eye2SVG;
        return Eye2;
    })();
export const Eyedropper = /*#__PURE__*/ (() => {
    function EyedropperSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.109 0.891c-0.791-0.791-1.85-1.056-2.984-0.747-0.825 0.225-1.697 0.769-2.456 1.528-0.697 0.697-1.137 1.388-1.603 2.116-0.5 0.784-1.059 1.656-2.084 2.781l-1.278-1.278c-0.391-0.391-1.025-0.391-1.416 0l-2 2c-0.194 0.194-0.194 0.513 0 0.706l2 2-9.141 9.15c-0.059 0.059-0.103 0.131-0.125 0.209-0.006 0.025-0.731 2.419-1.903 3.822-0.166 0.2-0.153 0.491 0.031 0.675 0.097 0.097 0.225 0.147 0.353 0.147 0.112 0 0.228-0.038 0.322-0.116 1.4-1.172 3.8-1.897 3.822-1.903 0.078-0.025 0.153-0.066 0.209-0.125l9.144-9.15 2 2c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l2-2c0.391-0.391 0.391-1.025 0-1.416l-1.278-1.278c1.125-1.025 1.997-1.581 2.781-2.084 0.731-0.466 1.419-0.906 2.116-1.603 0.759-0.759 1.3-1.631 1.528-2.456 0.312-1.128 0.047-2.187-0.744-2.978zM4.234 21.059c-0.322 0.103-1.209 0.403-2.169 0.875 0.472-0.959 0.772-1.847 0.875-2.169l9.059-9.059 1.294 1.294-9.059 9.059zM11.059 8.353l0.941-0.941 4.584 4.587-0.941 0.941-4.584-4.587zM21.925 3.344c-0.134 0.488-0.503 1.059-1.012 1.569-0.544 0.544-1.088 0.891-1.778 1.331-0.831 0.531-1.834 1.172-3.122 2.353l-0.616-0.616c1.181-1.284 1.822-2.291 2.353-3.122 0.441-0.691 0.788-1.234 1.331-1.778 0.175-0.175 1.722-1.669 2.609-0.781 0.194 0.194 0.391 0.481 0.234 1.044z" })
        );
    }
    function Eyedropper({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EyedropperSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Eyedropper.SVG = EyedropperSVG;
    return Eyedropper;
})();
export const FaceDetection = /*#__PURE__*/ (() => {
        function FaceDetectionSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 14c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zM12 4c2.206 0 4 1.794 4 4s-1.794 4-4 4c-2.206 0-4-1.794-4-4s1.794-4 4-4z" }),
_('path', { d: "M12 15c-3.806 0-6.328 0.675-7.709 2.069-1.291 1.3-1.291 2.884-1.291 3.931v0.5c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-0.5c0-1.047 0-2.631-1.291-3.931-1.381-1.394-3.903-2.069-7.709-2.069zM5 21c0-0.888 0-1.809 0.709-2.522 0.422-0.425 1.072-0.762 1.938-1.006 1.106-0.312 2.572-0.472 4.353-0.472s3.247 0.159 4.353 0.472c0.866 0.244 1.516 0.581 1.938 1.006 0.709 0.712 0.709 1.634 0.709 2.522h-14z" }),
_('path', { d: "M20 13h-2v1h2.5c0.275 0 0.5-0.225 0.5-0.5v-2.5h-1v2z" }),
_('path', { d: "M20.5 2h-2.5v1h2v2h1v-2.5c0-0.275-0.225-0.5-0.5-0.5z" }),
_('path', { d: "M3.5 14h2.5v-1h-2v-2h-1v2.5c0 0.275 0.225 0.5 0.5 0.5z" }),
_('path', { d: "M4 3h2v-1h-2.5c-0.275 0-0.5 0.225-0.5 0.5v2.5h1v-2z" })
            );
        }
        function FaceDetection({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FaceDetectionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FaceDetection.SVG = FaceDetectionSVG;
        return FaceDetection;
    })();
export const Factory = /*#__PURE__*/ (() => {
        function FactorySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.456 12.109c-0.334-0.172-0.734-0.144-1.038 0.075l-5.419 3.872v-3.056c0-0.375-0.209-0.719-0.544-0.891s-0.734-0.144-1.038 0.075l-0.875 0.625-0.544-6.356c-0.022-0.259-0.237-0.456-0.497-0.456h-2.284l-0.219-2.544c-0.022-0.259-0.237-0.456-0.497-0.456h-2.284l-0.219-2.544c-0.025-0.253-0.241-0.453-0.5-0.453h-5c-0.259 0-0.475 0.2-0.497 0.456l-1.425 16.628-0.106 0.066c-0.294 0.184-0.472 0.506-0.472 0.85v5c0 0.553 0.447 1 1 1h22c0.553 0 1-0.447 1-1v-10c0-0.375-0.209-0.719-0.544-0.891zM13.041 7l0.556 6.487-1.638 1.172-0.656-7.659h1.737zM10.041 4l0.972 11.334-1.012 0.722v-3.056c0-0.363-0.197-0.697-0.516-0.875-0.156-0.084-0.325-0.128-0.497-0.125l-0.684-8h1.737zM2.959 1h4.081l0.981 11.431-6.384 3.991 1.322-15.422zM22 22h-20v-3.447l6-3.75v3.197c0 0.375 0.209 0.719 0.544 0.891s0.734 0.144 1.038-0.075l5.419-3.872v3.056c0 0.375 0.209 0.719 0.544 0.891s0.734 0.144 1.038-0.075l5.419-3.872v7.056z" }),
_('path', { d: "M18 7c0.237 0 0.472-0.028 0.697-0.081 0.55 0.659 1.378 1.081 2.303 1.081 1.653 0 3-1.347 3-3 0-0.716-0.256-1.409-0.725-1.953-0.347-0.403-0.791-0.703-1.284-0.878 0.003-0.056 0.006-0.112 0.006-0.169 0-1.103-0.897-2-2-2-0.744 0-1.394 0.406-1.737 1.012-0.087-0.006-0.175-0.012-0.262-0.012-1.653 0-3 1.347-3 3s1.35 3 3.003 3zM18 2v1h1v-1c0-0.55 0.45-1 1-1s1 0.45 1 1c0 0.122-0.022 0.241-0.063 0.353-0.15 0.387-0.525 0.647-0.938 0.647v1c0.672 0 1.294-0.344 1.662-0.891 0.794 0.275 1.338 1.022 1.338 1.891 0 1.103-0.897 2-2 2s-2-0.897-2-2h-1c0 0.347 0.059 0.681 0.169 0.994-0.056 0.003-0.113 0.006-0.169 0.006-1.103 0-2-0.897-2-2s0.897-2 2-2z" }),
_('path', { d: "M12.5 3c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5zM12.5 1c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" })
            );
        }
        function Factory({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FactorySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Factory.SVG = FactorySVG;
        return Factory;
    })();
export const Fan = /*#__PURE__*/ (() => {
    function FanSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19.5 0c-1.353 0-2.403 0.547-3.125 1.622-0.572 0.853-0.875 1.922-1.194 3.053-0.281 0.994-0.572 2.022-1.056 2.741-0.244 0.359-0.519 0.622-0.841 0.797-0.403-0.138-0.834-0.209-1.281-0.209-2.059 0-3.762 1.566-3.978 3.569-1.741 0.234-3.606 1.059-5.075 2.256-1.903 1.547-2.95 3.562-2.95 5.672 0 2.481 2.019 4.5 4.5 4.5 1.353 0 2.403-0.547 3.125-1.622 0.572-0.853 0.875-1.922 1.194-3.053 0.281-0.994 0.572-2.022 1.056-2.741 0.244-0.359 0.519-0.622 0.841-0.797 0.403 0.138 0.834 0.209 1.281 0.209 2.059 0 3.762-1.566 3.978-3.569 1.741-0.234 3.606-1.059 5.075-2.256 1.903-1.547 2.95-3.563 2.95-5.672 0-2.481-2.019-4.5-4.5-4.5zM8.222 15.466c-0.666 0.984-1.003 2.172-1.325 3.316-0.659 2.334-1.038 3.219-2.397 3.219-1.378 0-2.5-1.122-2.5-2.5 0-1.919 1.203-3.303 2.213-4.125 1.178-0.963 2.722-1.644 4.1-1.825 0.162 0.384 0.384 0.741 0.653 1.053-0.275 0.247-0.522 0.534-0.744 0.862zM12 15c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3zM19.788 8.625c-1.178 0.963-2.722 1.644-4.1 1.825-0.162-0.384-0.384-0.741-0.653-1.053 0.272-0.247 0.522-0.534 0.741-0.863 0.666-0.984 1.003-2.172 1.325-3.316 0.663-2.337 1.041-3.219 2.4-3.219 1.378 0 2.5 1.122 2.5 2.5 0 1.919-1.203 3.303-2.212 4.125z" })
        );
    }
    function Fan({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FanSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Fan.SVG = FanSVG;
    return Fan;
})();
export const Fan2 = /*#__PURE__*/ (() => {
        function Fan2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 16c2.059 0 3.762-1.566 3.978-3.569 1.741-0.234 3.606-1.059 5.075-2.256 1.9-1.55 2.947-3.566 2.947-5.675 0-2.481-2.019-4.5-4.5-4.5-1.353 0-2.403 0.547-3.125 1.622-0.572 0.853-0.875 1.922-1.194 3.053-0.281 0.994-0.572 2.022-1.056 2.741-0.244 0.359-0.519 0.622-0.841 0.797-0.403-0.138-0.834-0.209-1.281-0.209-2.059 0-3.762 1.566-3.978 3.569-1.741 0.234-3.606 1.059-5.075 2.256-1.903 1.547-2.95 3.563-2.95 5.672 0 2.481 2.019 4.5 4.5 4.5 1.353 0 2.403-0.547 3.125-1.622 0.572-0.853 0.875-1.922 1.194-3.053 0.281-0.994 0.572-2.022 1.056-2.741 0.244-0.359 0.519-0.622 0.841-0.797 0.406 0.138 0.837 0.213 1.284 0.213zM15.778 8.534c0.666-0.984 1.003-2.172 1.325-3.316 0.659-2.337 1.038-3.219 2.397-3.219 1.378 0 2.5 1.122 2.5 2.5 0 1.919-1.203 3.303-2.212 4.125-1.178 0.963-2.722 1.644-4.1 1.825-0.162-0.384-0.384-0.741-0.653-1.053 0.275-0.247 0.522-0.534 0.744-0.863zM12 9c1.653 0 3 1.347 3 3s-1.347 3-3 3-3-1.347-3-3 1.347-3 3-3zM8.222 15.466c-0.666 0.984-1.003 2.172-1.325 3.316-0.659 2.334-1.038 3.219-2.397 3.219-1.378 0-2.5-1.122-2.5-2.5 0-1.919 1.203-3.303 2.213-4.125 1.178-0.963 2.722-1.644 4.1-1.825 0.162 0.384 0.384 0.741 0.653 1.053-0.275 0.247-0.522 0.534-0.744 0.862z" }),
_('path', { d: "M12 3v-1c-2.672 0-5.181 1.041-7.072 2.928-1.887 1.891-2.928 4.4-2.928 7.072h1c0-4.962 4.038-9 9-9z" }),
_('path', { d: "M12 21v1c2.672 0 5.181-1.041 7.072-2.928s2.928-4.4 2.928-7.072h-1c0 4.962-4.038 9-9 9z" }),
_('path', { d: "M5.803 2.909c1.647-1.141 3.938-1.909 5.697-1.909h0.5v-1h-0.5c-1.947 0-4.466 0.841-6.266 2.091l-0.412 0.284 0.569 0.822 0.412-0.288z" }),
_('path', { d: "M18.197 21.091c-1.647 1.141-3.938 1.909-5.697 1.909h-0.5v1h0.5c1.947 0 4.466-0.841 6.266-2.091l0.409-0.284-0.569-0.822-0.409 0.288z" })
            );
        }
        function Fan2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Fan2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Fan2.SVG = Fan2SVG;
        return Fan2;
    })();
export const Fan3 = /*#__PURE__*/ (() => {
    function Fan3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.378 16.375c-0.853-0.572-1.922-0.875-3.053-1.194-0.994-0.281-2.022-0.572-2.741-1.056-0.359-0.244-0.622-0.519-0.797-0.841 0.094-0.272 0.156-0.556 0.188-0.85 1.741-0.234 3.606-1.059 5.075-2.256 1.903-1.553 2.95-3.569 2.95-5.678 0-2.481-2.019-4.5-4.5-4.5-1.353 0-2.403 0.547-3.125 1.622-0.572 0.853-0.875 1.922-1.194 3.053-0.281 0.994-0.572 2.022-1.056 2.741-0.244 0.359-0.519 0.622-0.841 0.797-0.272-0.094-0.556-0.156-0.85-0.188-0.234-1.741-1.059-3.606-2.256-5.075-1.553-1.903-3.569-2.95-5.678-2.95-2.481 0-4.5 2.019-4.5 4.5 0 1.353 0.547 2.403 1.622 3.125 0.853 0.572 1.922 0.875 3.053 1.194 0.994 0.281 2.022 0.572 2.741 1.056 0.359 0.244 0.622 0.519 0.797 0.841-0.094 0.272-0.156 0.556-0.188 0.85-1.741 0.234-3.606 1.059-5.075 2.256-1.903 1.553-2.95 3.569-2.95 5.678 0 2.481 2.019 4.5 4.5 4.5 1.353 0 2.403-0.547 3.125-1.622 0.572-0.853 0.875-1.922 1.194-3.053 0.281-0.994 0.572-2.022 1.056-2.741 0.244-0.359 0.519-0.622 0.841-0.797 0.272 0.094 0.556 0.156 0.85 0.188 0.234 1.741 1.059 3.606 2.256 5.075 1.553 1.903 3.569 2.95 5.678 2.95 2.481 0 4.5-2.019 4.5-4.5 0-1.353-0.547-2.403-1.622-3.125zM12 15c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3zM15.778 8.534c0.666-0.984 1.003-2.172 1.325-3.316 0.659-2.337 1.038-3.219 2.397-3.219 1.378 0 2.5 1.122 2.5 2.5 0 1.919-1.203 3.303-2.212 4.125-1.178 0.963-2.722 1.644-4.1 1.825-0.162-0.384-0.384-0.741-0.653-1.053 0.275-0.247 0.522-0.534 0.744-0.863zM5.219 6.897c-2.337-0.659-3.219-1.038-3.219-2.397 0-1.378 1.122-2.5 2.5-2.5 1.919 0 3.303 1.203 4.125 2.213 0.963 1.178 1.644 2.722 1.825 4.1-0.384 0.162-0.741 0.384-1.053 0.653-0.247-0.272-0.534-0.522-0.863-0.741-0.984-0.669-2.169-1.003-3.316-1.328zM8.222 15.466c-0.666 0.984-1.003 2.172-1.325 3.316-0.659 2.334-1.038 3.219-2.397 3.219-1.378 0-2.5-1.122-2.5-2.5 0-1.919 1.203-3.303 2.213-4.125 1.178-0.963 2.722-1.644 4.1-1.825 0.162 0.384 0.384 0.741 0.653 1.053-0.275 0.247-0.522 0.534-0.744 0.862zM19.5 22c-1.919 0-3.303-1.203-4.125-2.212-0.963-1.178-1.644-2.722-1.825-4.1 0.384-0.162 0.741-0.384 1.053-0.653 0.247 0.272 0.534 0.522 0.862 0.741 0.984 0.666 2.172 1.003 3.316 1.325 2.334 0.659 3.219 1.038 3.219 2.397 0 1.381-1.122 2.503-2.5 2.503z" })
        );
    }
    function Fan3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Fan3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Fan3.SVG = Fan3SVG;
    return Fan3;
})();
export const Faucet = /*#__PURE__*/ (() => {
    function FaucetSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23 20.084v-3.084c0-3.859-3.141-7-7-7h-1v-1.5c0-0.275-0.225-0.5-0.5-0.5h-1.5v-1.5c0-0.275-0.225-0.5-0.5-0.5h-0.5v-0.331c0.169-0.122 0.325-0.275 0.459-0.453 0.050-0.069 0.1-0.141 0.144-0.216h3.897c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-3.897c-0.044-0.075-0.094-0.147-0.144-0.216-0.375-0.5-0.906-0.784-1.459-0.784s-1.088 0.288-1.459 0.784c-0.050 0.069-0.1 0.141-0.144 0.216h-3.897c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h3.897c0.044 0.075 0.094 0.147 0.144 0.216 0.134 0.181 0.291 0.331 0.459 0.453v0.331h-0.5c-0.275 0-0.5 0.225-0.5 0.5v1.5h-1.5c-0.275 0-0.5 0.225-0.5 0.5v1.5h-6.5c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h6.5c0.938 1.247 2.422 2 4 2 0.894 0 1.772-0.237 2.534-0.691 0.569-0.334 1.069-0.784 1.466-1.309h1c0.55 0 1 0.45 1 1v3.084c-0.581 0.206-1 0.762-1 1.416 0 0.828 0.672 1.5 1.5 1.5h5c0.828 0 1.5-0.672 1.5-1.5 0-0.653-0.419-1.209-1-1.416zM16.5 3c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-3.541c0.025-0.162 0.041-0.331 0.041-0.5s-0.012-0.338-0.041-0.5h3.541zM5.5 4c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3.541c-0.025 0.162-0.041 0.331-0.041 0.5s0.012 0.337 0.041 0.5h-3.541zM11 2c0.541 0 1 0.687 1 1.5s-0.459 1.5-1 1.5-1-0.687-1-1.5 0.459-1.5 1-1.5zM16 14h-1.534c-0.356 0-0.687 0.191-0.866 0.5-0.537 0.925-1.534 1.5-2.6 1.5-1.069 0-2.066-0.575-2.6-1.5-0.178-0.309-0.509-0.5-0.866-0.5h-6.534v-2h7c0.553 0 1-0.447 1-1v-2h0.5c0.275 0 0.5-0.225 0.5-0.5v-1.5h2v1.5c0 0.275 0.225 0.5 0.5 0.5h0.5v2c0 0.553 0.447 1 1 1h2c2.756 0 5 2.244 5 5v3h-2v-3c0-1.653-1.347-3-3-3zM22.5 22h-5c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5z" })
        );
    }
    function Faucet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FaucetSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Faucet.SVG = FaucetSVG;
    return Faucet;
})();
export const Female = /*#__PURE__*/ (() => {
        function FemaleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16.95 11.95c1.322-1.322 2.050-3.081 2.050-4.95s-0.728-3.628-2.050-4.95c-1.322-1.322-3.081-2.050-4.95-2.050s-3.628 0.728-4.95 2.050c-1.322 1.322-2.050 3.081-2.050 4.95s0.728 3.628 2.050 4.95c1.084 1.084 2.459 1.769 3.95 1.978v5.072h-3v2h3v3h2v-3h3v-2h-3v-5.072c1.491-0.209 2.866-0.894 3.95-1.978zM7 7c0-2.756 2.244-5 5-5s5 2.244 5 5-2.244 5-5 5c-2.756 0-5-2.244-5-5z" }),
_('path', { d: "M16 7c0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4c2.206 0 4-1.794 4-4zM9 7c0-1.653 1.347-3 3-3s3 1.347 3 3-1.347 3-3 3-3-1.347-3-3z" })
            );
        }
        function Female({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FemaleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Female.SVG = FemaleSVG;
        return Female;
    })();
export const Fence = /*#__PURE__*/ (() => {
        function FenceSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 16c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM18 17c0 0 0 0 0 0v0z" }),
_('path', { d: "M6 16c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM6 17c0 0 0 0 0 0v0z" }),
_('path', { d: "M23.5 11c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5h-1.5v-0.584c0-0.534-0.209-1.038-0.584-1.416l-2.709-2.706c-0.188-0.188-0.441-0.294-0.706-0.294s-0.519 0.106-0.706 0.294l-2.709 2.706c-0.378 0.378-0.584 0.881-0.584 1.416v0.584h-4v-0.584c0-0.534-0.209-1.038-0.584-1.416l-2.709-2.706c-0.391-0.391-1.025-0.391-1.416 0l-2.706 2.706c-0.375 0.378-0.584 0.881-0.584 1.416v0.584h-1.5c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h1.5v3h-1.5c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h1.5v2c0 1.103 0.897 2 2 2h4c1.103 0 2-0.897 2-2v-2h4v2c0 1.103 0.897 2 2 2h4c1.103 0 2-0.897 2-2v-2h1.5c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5h-1.5v-3h1.5zM1 10v-4h1v4h-1zM1 19v-4h1v4h-1zM14 6v4h-4v-4h4zM14 11v3h-4v-3h4zM8 22h-4c0 0 0 0 0 0v-17.584l2-2 2 2v17.584zM10 19v-4h4v4h-4zM23 6v4h-1v-4h1zM20 22h-4c0 0 0 0 0 0v-17.584l2-2 2 2v17.584zM23 15v4h-1v-4h1z" }),
_('path', { d: "M17 8c0 0.55 0.45 1 1 1s1-0.45 1-1-0.45-1-1-1-1 0.45-1 1zM18 8c0 0 0 0 0 0v0z" }),
_('path', { d: "M5 8c0 0.55 0.45 1 1 1s1-0.45 1-1-0.45-1-1-1-1 0.45-1 1zM6 8c0 0 0 0 0 0v0z" })
            );
        }
        function Fence({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FenceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Fence.SVG = FenceSVG;
        return Fence;
    })();
export const Fencing = /*#__PURE__*/ (() => {
    function FencingSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3.584 17.584c0.378-0.378 0.881-0.584 1.416-0.584s1.038 0.209 1.416 0.584c0.781 0.781 0.781 2.050 0 2.828l-2.831-2.828zM7.828 21.828c1.441-1.441 1.55-3.712 0.331-5.281l3.841-3.841 3.841 3.841c-0.547 0.7-0.841 1.553-0.841 2.453 0 1.069 0.416 2.072 1.172 2.828v0l0.353 0.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l1.769-1.769 3.544 3.544 1.416-1.416-3.544-3.541 1.769-1.769c0.194-0.194 0.194-0.513 0-0.706l-0.353-0.353c-0.759-0.756-1.763-1.172-2.831-1.172-0.9 0-1.753 0.294-2.453 0.841l-3.841-3.841 10.034-10.034c0.081 0.022 0.169 0.034 0.259 0.034 0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1c0 0.091 0.012 0.175 0.034 0.259l-10.034 10.034-10.034-10.034c0.022-0.081 0.034-0.169 0.034-0.259 0-0.55-0.45-1-1-1s-1 0.45-1 1 0.45 1 1 1c0.091 0 0.175-0.012 0.259-0.034l10.034 10.034-3.841 3.841c-0.7-0.547-1.553-0.841-2.453-0.841-1.069 0-2.072 0.416-2.828 1.172v0l-0.353 0.353c-0.194 0.194-0.194 0.513 0 0.706l1.769 1.769-3.544 3.544 1.416 1.416 3.541-3.544 1.769 1.769c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l0.353-0.356zM1 1v0c0 0 0 0 0 0zM17.584 20.416c-0.375-0.378-0.584-0.881-0.584-1.416s0.209-1.038 0.584-1.416c0.378-0.378 0.881-0.584 1.416-0.584s1.038 0.209 1.416 0.584l-2.831 2.831z" })
        );
    }
    function Fencing({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FencingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Fencing.SVG = FencingSVG;
    return Fencing;
})();
export const FileChartBars = /*#__PURE__*/ (() => {
        function FileChartBarsSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 0h-9c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-15c0-3.859-3.141-7-7-7zM18.9 6h-3.9v-3.9c1.956 0.4 3.5 1.944 3.9 3.9zM19 22h-14v-20h9v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v15c0.003 0 0 0 0 0z" }),
_('path', { d: "M8 14h2v5h-2v-5z" }),
_('path', { d: "M11 15h2v4h-2v-4z" }),
_('path', { d: "M14 11h2v8h-2v-8z" })
            );
        }
        function FileChartBars({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileChartBarsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileChartBars.SVG = FileChartBarsSVG;
        return FileChartBars;
    })();
export const FileChart = /*#__PURE__*/ (() => {
        function FileChartSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 0h-9c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-15c0-3.859-3.141-7-7-7zM18.9 6h-3.9v-3.9c1.956 0.4 3.5 1.944 3.9 3.9zM19 22h-14v-20h9v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v15c0.003 0 0 0 0 0z" }),
_('path', { d: "M15.5 15h-3.5v-3.5c0-0.275-0.225-0.5-0.5-0.5-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5c2.481 0 4.5-2.019 4.5-4.5 0-0.275-0.225-0.5-0.5-0.5zM11.5 19c-1.931 0-3.5-1.569-3.5-3.5 0-1.759 1.306-3.222 3-3.466v3.466c0 0.275 0.225 0.5 0.5 0.5h3.466c-0.244 1.694-1.706 3-3.466 3z" }),
_('path', { d: "M13.5 10c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5 0-1.931-1.569-3.5-3.5-3.5zM14 13v-1.95c0.978 0.2 1.75 0.972 1.95 1.95h-1.95z" })
            );
        }
        function FileChart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileChartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileChart.SVG = FileChartSVG;
        return FileChart;
    })();
export const FileCheck = /*#__PURE__*/ (() => {
        function FileCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 0h-9c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-15c0-3.859-3.141-7-7-7zM18.9 6h-3.9v-3.9c1.956 0.4 3.5 1.944 3.9 3.9zM19 22h-14v-20h9v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v15c0.003 0 0 0 0 0z" }),
_('path', { d: "M10.497 16.794l-1.997-2-0.706 0.706 2.35 2.353c0.094 0.094 0.222 0.147 0.353 0.147 0 0 0 0 0 0 0.131 0 0.259-0.053 0.353-0.147l5.356-5.353-0.706-0.709-5.003 5.003z" })
            );
        }
        function FileCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileCheck.SVG = FileCheckSVG;
        return FileCheck;
    })();
export const FileCode = /*#__PURE__*/ (() => {
        function FileCodeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 0h-9c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-15c0-3.859-3.141-7-7-7zM18.9 6h-3.9v-3.9c1.956 0.4 3.5 1.944 3.9 3.9zM19 22h-14v-20h9v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v15c0.003 0 0 0 0 0z" }),
_('path', { d: "M8.5 13.794l-2.353 2.353c-0.194 0.194-0.194 0.513 0 0.706l2.353 2.353 0.706-0.706-2-2 2-2-0.706-0.706z" }),
_('path', { d: "M15.5 13.794l-0.706 0.706 2 2-2 2 0.706 0.706 2.353-2.353c0.194-0.194 0.194-0.513 0-0.706l-2.353-2.353z" }),
_('path', { d: "M9.842 19.764l3.394-7.919 0.919 0.394-3.394 7.919-0.919-0.394z" })
            );
        }
        function FileCode({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileCodeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileCode.SVG = FileCodeSVG;
        return FileCode;
    })();
export const FileCompressed = /*#__PURE__*/ (() => {
    function FileCompressedSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 0h-9c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-15c0-3.859-3.141-7-7-7zM18.9 6h-3.9v-3.9c1.956 0.4 3.5 1.944 3.9 3.9zM10 15.5v1.5h-1v-1.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5zM19 22h-14v-20h3v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1.084c-0.581 0.206-1 0.762-1 1.416v2c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.653-0.419-1.209-1-1.416v-0.084h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h4v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v15c0.003 0 0 0 0 0z" })
        );
    }
    function FileCompressed({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FileCompressedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FileCompressed.SVG = FileCompressedSVG;
    return FileCompressed;
})();
export const FileEmpty = /*#__PURE__*/ (() => {
    function FileEmptySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 0h-9c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-15c0-3.859-3.141-7-7-7zM18.9 6h-3.9v-3.9c1.956 0.4 3.5 1.944 3.9 3.9zM19 22h-14v-20h9v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v15c0.003 0 0 0 0 0z" })
        );
    }
    function FileEmpty({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FileEmptySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FileEmpty.SVG = FileEmptySVG;
    return FileEmpty;
})();
export const FileLock = /*#__PURE__*/ (() => {
        function FileLockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.5 13h-0.5v-1c0-1.653-1.347-3-3-3s-3 1.347-3 3v1h-0.5c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5h7c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5zM10 12c0-1.103 0.897-2 2-2s2 0.897 2 2v1h-4v-1zM15 17h-6v-3h6v3z" }),
_('path', { d: "M14 0h-9c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-15c0-3.859-3.141-7-7-7zM18.9 6h-3.9v-3.9c1.956 0.4 3.5 1.944 3.9 3.9zM19 22h-14v-20h9v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v15c0.003 0 0 0 0 0z" })
            );
        }
        function FileLock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileLockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileLock.SVG = FileLockSVG;
        return FileLock;
    })();
export const FileMagnifier = /*#__PURE__*/ (() => {
        function FileMagnifierSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 0h-9c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-15c0-3.859-3.141-7-7-7zM18.9 6h-3.9v-3.9c1.956 0.4 3.5 1.944 3.9 3.9zM19 22h-14v-20h9v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v15c0.003 0 0 0 0 0z" }),
_('path', { d: "M14 13c0-1.653-1.347-3-3-3s-3 1.347-3 3 1.347 3 3 3c0.647 0 1.247-0.206 1.737-0.556l2.763 2.763 0.706-0.706-2.763-2.763c0.35-0.491 0.556-1.091 0.556-1.737zM9 13c0-1.103 0.897-2 2-2s2 0.897 2 2c0 1.103-0.897 2-2 2s-2-0.897-2-2z" })
            );
        }
        function FileMagnifier({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileMagnifierSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileMagnifier.SVG = FileMagnifierSVG;
        return FileMagnifier;
    })();
export const FileMusic = /*#__PURE__*/ (() => {
        function FileMusicSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 9h-1v6.241c-0.116-0.056-0.237-0.103-0.369-0.138-0.559-0.159-1.206-0.131-1.816 0.075-0.762 0.259-1.362 0.756-1.644 1.366-0.2 0.428-0.222 0.888-0.063 1.291 0.2 0.509 0.65 0.888 1.266 1.059 0.241 0.069 0.497 0.103 0.762 0.103 0.347 0 0.706-0.059 1.053-0.178 0.759-0.256 1.359-0.753 1.644-1.362 0.122-0.259 0.175-0.528 0.169-0.791v-5.022c0.734 0.831 1.806 1.356 3 1.356v-1c-1.656 0-3.003-1.347-3.003-3zM10.866 17.875c-0.869 0.297-1.662 0.025-1.828-0.403-0.059-0.153-0.047-0.322 0.037-0.506 0.166-0.356 0.563-0.672 1.059-0.841v0c0.869-0.297 1.662-0.025 1.828 0.403 0.019 0.050 0.031 0.1 0.034 0.156v0.044h0.003c0 0.097-0.025 0.203-0.075 0.309-0.166 0.356-0.563 0.669-1.059 0.837z" }),
_('path', { d: "M14 0h-9c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-15c0-3.859-3.141-7-7-7zM18.9 6h-3.9v-3.9c1.956 0.4 3.5 1.944 3.9 3.9zM19 22h-14v-20h9v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v15c0.003 0 0 0 0 0z" })
            );
        }
        function FileMusic({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileMusicSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileMusic.SVG = FileMusicSVG;
        return FileMusic;
    })();
export const FilePencil = /*#__PURE__*/ (() => {
        function FilePencilSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 0h-9c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-15c0-3.859-3.141-7-7-7zM18.9 6h-3.9v-3.9c1.956 0.4 3.5 1.944 3.9 3.9zM19 22h-14v-20h9v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v15c0.003 0 0 0 0 0z" }),
_('path', { d: "M14.731 9.563l-7.084 7.084c-0.069 0.069-0.119 0.159-0.138 0.256l-0.5 2.5c-0.031 0.162 0.019 0.334 0.138 0.453 0.094 0.094 0.222 0.147 0.353 0.147 0.031 0 0.066-0.003 0.097-0.009l2.5-0.5c0.097-0.019 0.184-0.066 0.256-0.138l7.084-7.087c0.363-0.363 0.563-0.844 0.563-1.353s-0.2-0.991-0.563-1.353c-0.747-0.747-1.959-0.747-2.706 0zM9.753 18.541l-1.616 0.322 0.322-1.616 6.041-6.041 1.294 1.294-6.041 6.041zM16.731 11.562l-0.231 0.231-1.294-1.294 0.231-0.231c0.356-0.356 0.938-0.356 1.294 0 0.172 0.172 0.269 0.403 0.269 0.647s-0.097 0.472-0.269 0.647z" })
            );
        }
        function FilePencil({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilePencilSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilePencil.SVG = FilePencilSVG;
        return FilePencil;
    })();
export const FilePicture = /*#__PURE__*/ (() => {
        function FilePictureSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 7c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM9 10c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M14 0h-9c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-15c0-3.859-3.141-7-7-7zM18.9 6h-3.9v-3.9c1.956 0.4 3.5 1.944 3.9 3.9zM5 18.584l4.294-4.294c0.387-0.387 1.025-0.387 1.416 0l0.916 0.916 0.706-0.706-0.916-0.916c-0.781-0.778-2.050-0.778-2.828 0l-3.588 3.588v-15.172h9v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v6.169l-0.584-0.584c-0.781-0.778-2.050-0.778-2.828 0l-9.416 9.416h-1.172v-3.416zM19 22h-11.416l8.709-8.709c0.387-0.387 1.025-0.387 1.416 0l1.291 1.291v7.419c0.003 0 0 0 0 0z" })
            );
        }
        function FilePicture({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilePictureSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilePicture.SVG = FilePictureSVG;
        return FilePicture;
    })();
export const FilePlus = /*#__PURE__*/ (() => {
        function FilePlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 11h-1v3h-3v1h3v3h1v-3h3v-1h-3z" }),
_('path', { d: "M14 0h-9c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-15c0-3.859-3.141-7-7-7zM18.9 6h-3.9v-3.9c1.956 0.4 3.5 1.944 3.9 3.9zM19 22h-14v-20h9v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v15c0.003 0 0 0 0 0z" })
            );
        }
        function FilePlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilePlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilePlus.SVG = FilePlusSVG;
        return FilePlus;
    })();
export const FilePreview = /*#__PURE__*/ (() => {
        function FilePreviewSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 0h-9c-1.103 0-2 0.897-2 2v8h2v-8h9v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v15h-14v-3h-2v3c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-15c0-3.859-3.141-7-7-7zM16 6v-3.9c1.956 0.4 3.5 1.944 3.9 3.9h-3.9z" }),
_('path', { d: "M15.841 14.869c0.103-0.094 0.159-0.228 0.159-0.369s-0.059-0.272-0.159-0.369c-2.253-2.078-4.556-3.131-6.841-3.131s-4.587 1.053-6.841 3.131c-0.103 0.094-0.159 0.228-0.159 0.369s0.059 0.272 0.159 0.369c2.253 2.078 4.556 3.131 6.841 3.131s4.587-1.053 6.841-3.131zM9 12c1.103 0 2 0.897 2 2s-0.897 2-2 2-2-0.897-2-2 0.897-2 2-2zM6.394 12.516c-0.25 0.438-0.394 0.944-0.394 1.484 0 1.653 1.347 3 3 3s3-1.347 3-3c0-0.541-0.144-1.047-0.394-1.484 1.044 0.413 2.091 1.075 3.144 1.984-3.866 3.337-7.634 3.337-11.5 0 1.053-0.909 2.1-1.572 3.144-1.984z" })
            );
        }
        function FilePreview({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilePreviewSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilePreview.SVG = FilePreviewSVG;
        return FilePreview;
    })();
export const FileSpreadsheet = /*#__PURE__*/ (() => {
        function FileSpreadsheetSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 0h-9c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-15c0-3.859-3.141-7-7-7zM18.9 6h-3.9v-3.9c1.956 0.4 3.5 1.944 3.9 3.9zM19 22h-14v-20h9v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v15c0.003 0 0 0 0 0z" }),
_('path', { d: "M16.5 12h-9c-0.275 0-0.5 0.225-0.5 0.5v7c0 0.275 0.225 0.5 0.5 0.5h9c0.275 0 0.5-0.225 0.5-0.5v-7c0-0.275-0.225-0.5-0.5-0.5zM16 16h-2v-2h2v2zM11 16v-2h2v2h-2zM13 17v2h-2v-2h2zM10 14v2h-2v-2h2zM8 17h2v2h-2v-2zM14 19v-2h2v2h-2z" })
            );
        }
        function FileSpreadsheet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileSpreadsheetSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileSpreadsheet.SVG = FileSpreadsheetSVG;
        return FileSpreadsheet;
    })();
export const FileText = /*#__PURE__*/ (() => {
        function FileTextSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 0h-9c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-15c0-3.859-3.141-7-7-7zM18.9 6h-3.9v-3.9c1.956 0.4 3.5 1.944 3.9 3.9zM19 22h-14v-20h9v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v15c0.003 0 0 0 0 0z" }),
_('path', { d: "M7 4h4v1h-4v-1z" }),
_('path', { d: "M7 7h5v1h-5v-1z" }),
_('path', { d: "M7 11h10v1h-10v-1z" }),
_('path', { d: "M7 13h9v1h-9v-1z" }),
_('path', { d: "M7 9h10v1h-10v-1z" }),
_('path', { d: "M7 15h10v1h-10v-1z" }),
_('path', { d: "M7 17h8v1h-8v-1z" }),
_('path', { d: "M7 19h10v1h-10v-1z" })
            );
        }
        function FileText({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileTextSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileText.SVG = FileTextSVG;
        return FileText;
    })();
export const FileUser = /*#__PURE__*/ (() => {
        function FileUserSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 5h-4v-1h4v1zM10 7h-5v1h5v-1zM11 11h-6v1h6v-1zM10 13h-5v1h5v-1zM14 9h-9v1h9v-1zM5 16h4.016v-1h-4.016v1zM5 18h4v-1h-4v1zM5 20h4v-1h-4v1z" }),
_('path', { d: "M19 11.5v-4.5c0-3.859-3.141-7-7-7h-9c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h13.5c3.584 0 6.5-2.916 6.5-6.5 0-2.7-1.653-5.019-4-6zM16.9 6h-3.9v-3.9c1.956 0.4 3.5 1.944 3.9 3.9zM3 2h9v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v4.019c-0.166-0.012-0.331-0.019-0.5-0.019-3.584 0-6.5 2.916-6.5 6.5 0 1.744 0.691 3.331 1.816 4.5h-8.816v-20zM13.125 21.841c0.413-1.066 1.8-1.841 3.375-1.841s2.959 0.772 3.375 1.841c-0.931 0.728-2.103 1.159-3.375 1.159s-2.444-0.434-3.375-1.159zM14 16.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5-2.5-1.122-2.5-2.5zM20.641 21.119c-0.422-0.769-1.184-1.388-2.131-1.753 0.9-0.634 1.491-1.681 1.491-2.866 0-1.931-1.569-3.5-3.5-3.5s-3.5 1.569-3.5 3.5c0 1.181 0.591 2.231 1.491 2.862-0.947 0.366-1.709 0.981-2.131 1.753-0.847-0.969-1.359-2.234-1.359-3.616 0-3.031 2.469-5.5 5.5-5.5s5.5 2.469 5.5 5.5c0 1.384-0.513 2.65-1.359 3.619z" })
            );
        }
        function FileUser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileUserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileUser.SVG = FileUserSVG;
        return FileUser;
    })();
export const FileVideo = /*#__PURE__*/ (() => {
    function FileVideoSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 0h-9c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-15c0-3.859-3.141-7-7-7zM18.9 6h-3.9v-3.9c1.956 0.4 3.5 1.944 3.9 3.9zM14 2v4.5c0 0.275 0.225 0.5 0.5 0.5h4.5v2h-14v-7h9zM17 11v-1h1v1h-1zM9 17v-5h6v5h-6zM16 11h-1v-1h1v1zM14 11h-1v-1h1v1zM12 11h-1v-1h1v1zM10 11h-1v-1h1v1zM8 11h-1v-1h1v1zM6 11h-1v-1h1v1zM8 12v5h-3v-5h3zM6 18h1v1h-1v-1zM8 18h1v1h-1v-1zM10 18h1v1h-1v-1zM12 18h1v1h-1v-1zM14 18h1v1h-1v-1zM16 18h1v1h-1v-1zM18 18h1v1h-1v-1zM16 17v-5h3v5h-3zM19 11v0zM19 22h-14v-2h14.003l-0.003 2c0.003 0 0 0 0 0z" })
        );
    }
    function FileVideo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FileVideoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FileVideo.SVG = FileVideoSVG;
    return FileVideo;
})();
export const FilesCompare = /*#__PURE__*/ (() => {
        function FilesCompareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21 11.813v-6.813c0-2.756-2.244-5-5-5h-7c-1.103 0-2 0.897-2 2v2h-4c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h10c0.825 0 1.534-0.5 1.841-1.216 0.531 0.141 1.087 0.216 1.659 0.216 3.584 0 6.5-2.916 6.5-6.5 0-1.841-0.769-3.503-2-4.688zM19 5h-3v-3c1.653 0 3 1.347 3 3zM9 2h6v3.5c0 0.275 0.225 0.5 0.5 0.5h3.5v4.5c-0.769-0.322-1.616-0.5-2.5-0.5-0.516 0-1.019 0.059-1.5 0.175v-1.175c0-2.756-2.244-5-5-5h-1v-2zM10 6c1.653 0 3 1.347 3 3h-3v-3zM13 22h-10v-16h6v3.5c0 0.275 0.225 0.5 0.5 0.5h3.5v1.025c-1.803 1.156-3 3.178-3 5.475s1.197 4.319 3 5.475v0.025zM16.5 22c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17.5 12.794l-0.706 0.706 0.5 0.5h-3.294v1h3.294l-0.5 0.5 0.706 0.706 1.353-1.353c0.194-0.194 0.194-0.513 0-0.706l-1.353-1.353z" }),
_('path', { d: "M16.206 17.5l-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706-0.5-0.5h3.294v-1h-3.294l0.5-0.5z" })
            );
        }
        function FilesCompare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilesCompareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilesCompare.SVG = FilesCompareSVG;
        return FilesCompare;
    })();
export const Files = /*#__PURE__*/ (() => {
    function FilesSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17 0h-7c-1.103 0-2 0.897-2 2v2h-4c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-2h4c1.103 0 2-0.897 2-2v-13c0-2.756-2.244-5-5-5zM20 5h-3v-3c1.653 0 3 1.347 3 3zM11 6c1.653 0 3 1.347 3 3h-3v-3zM14 22h-10v-16h6v3.5c0 0.275 0.225 0.5 0.5 0.5h3.5v12c0 0 0 0 0 0zM16 18v-9c0-2.756-2.244-5-5-5h-1v-2h6v3.5c0 0.275 0.225 0.5 0.5 0.5h3.5v12h-4z" })
        );
    }
    function Files({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FilesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Files.SVG = FilesSVG;
    return Files;
})();
export const Files2 = /*#__PURE__*/ (() => {
    function Files2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17 0h-7c-1.103 0-2 0.897-2 2h-1c-1.103 0-2 0.897-2 2h-1c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-1h1c1.103 0 2-0.897 2-2v-11c0-2.756-2.244-5-5-5zM20 5h-3v-3c1.653 0 3 1.347 3 3zM15 22c0 0.55-0.45 1-1 1h-10c-0.55 0-1-0.45-1-1v-16c0-0.55 0.45-1 1-1h1v14c0 1.103 0.897 2 2 2h8v1zM18 19c0 0.55-0.45 1-1 1h-10c-0.55 0-1-0.45-1-1v-15c0-0.55 0.45-1 1-1h1v13c0 1.103 0.897 2 2 2h8v1zM20 16h-10v-14h6v3.5c0 0.275 0.225 0.5 0.5 0.5h3.5v10c0.003 0 0 0 0 0z" })
        );
    }
    function Files2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Files2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Files2.SVG = Files2SVG;
    return Files2;
})();
export const FilmPlay = /*#__PURE__*/ (() => {
        function FilmPlaySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.5 4h-23c-0.275 0-0.5 0.225-0.5 0.5v15c0 0.275 0.225 0.5 0.5 0.5h23c0.275 0 0.5-0.225 0.5-0.5v-15c0-0.275-0.225-0.5-0.5-0.5zM4 5v2h-2v-2h2zM2 14h2v2h-2v-2zM2 13v-2h2v2h-2zM2 10v-2h2v2h-2zM2 19v-2h2v2h-2zM18 18h-12v-12h12v12zM22 16h-2v-2h2v2zM22 13h-2v-2h2v2zM22 10h-2v-2h2v2zM20 19v-2h2v2h-2zM22 7h-2v-2h2v2z" }),
_('path', { d: "M9.25 15.934c0.078 0.044 0.162 0.066 0.25 0.066s0.175-0.022 0.253-0.069l6-3.5c0.153-0.091 0.247-0.253 0.247-0.431s-0.094-0.344-0.247-0.431l-6-3.5c-0.153-0.091-0.347-0.091-0.5-0.003-0.156 0.091-0.25 0.253-0.25 0.434v7c-0.003 0.178 0.094 0.344 0.247 0.434zM10 9.372l4.506 2.628-4.506 2.628v-5.256z" })
            );
        }
        function FilmPlay({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilmPlaySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilmPlay.SVG = FilmPlaySVG;
        return FilmPlay;
    })();
export const FilmPlay2 = /*#__PURE__*/ (() => {
        function FilmPlay2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.5 3h-23c-0.275 0-0.5 0.225-0.5 0.5v15c0 0.275 0.225 0.5 0.5 0.5h12.312c1.184 1.231 2.847 2 4.688 2 3.584 0 6.5-2.916 6.5-6.5v-11c0-0.275-0.225-0.5-0.5-0.5zM4 4v2h-2v-2h2zM2 13h2v2h-2v-2zM2 12v-2h2v2h-2zM2 9v-2h2v2h-2zM2 18v-2h2v2h-2zM22 9h-1.041c-0.303-0.191-0.625-0.359-0.959-0.5v-1.5h2v2zM6 5h12v3.019c-0.166-0.012-0.331-0.019-0.5-0.019-3.584 0-6.5 2.916-6.5 6.5 0 0.884 0.178 1.731 0.5 2.5h-5.5v-12zM17.5 20c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5zM22 6h-2v-2h2v2z" }),
_('path', { d: "M20.756 14.072l-5-3c-0.153-0.094-0.347-0.094-0.503-0.006s-0.253 0.256-0.253 0.434v6c0 0.181 0.097 0.347 0.253 0.434 0.075 0.044 0.162 0.066 0.247 0.066 0.091 0 0.178-0.025 0.256-0.072l5-3c0.15-0.091 0.244-0.253 0.244-0.428s-0.091-0.337-0.244-0.428zM16 16.616v-4.231l3.528 2.116-3.528 2.116z" })
            );
        }
        function FilmPlay2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilmPlay2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilmPlay2.SVG = FilmPlay2SVG;
        return FilmPlay2;
    })();
export const Film = /*#__PURE__*/ (() => {
    function FilmSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.5 4h-23c-0.275 0-0.5 0.225-0.5 0.5v15c0 0.275 0.225 0.5 0.5 0.5h23c0.275 0 0.5-0.225 0.5-0.5v-15c0-0.275-0.225-0.5-0.5-0.5zM4 5v2h-2v-2h2zM2 14h2v2h-2v-2zM2 13v-2h2v2h-2zM2 10v-2h2v2h-2zM2 19v-2h2v2h-2zM18 18h-12v-12h12v12zM22 16h-2v-2h2v2zM22 13h-2v-2h2v2zM22 10h-2v-2h2v2zM20 19v-2h2v2h-2zM22 7h-2v-2h2v2z" })
        );
    }
    function Film({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FilmSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Film.SVG = FilmSVG;
    return Film;
})();
export const FindReplace = /*#__PURE__*/ (() => {
        function FindReplaceSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.803 2.197c-1.416-1.416-3.3-2.197-5.303-2.197s-3.888 0.781-5.303 2.197c-1.416 1.416-2.197 3.3-2.197 5.303 0 1.666 0.541 3.25 1.538 4.55l-1.122 1.122c-0.897-0.35-1.959-0.166-2.681 0.556l-6.006 6.003c-0.972 0.975-0.972 2.562 0.003 3.537 0.488 0.484 1.128 0.728 1.769 0.728s1.281-0.244 1.766-0.731l6.003-6.003c0.719-0.722 0.906-1.781 0.556-2.675l1.125-1.125c1.3 0.997 2.884 1.537 4.55 1.537 2.003 0 3.888-0.781 5.303-2.197s2.197-3.3 2.197-5.303-0.781-3.888-2.197-5.303zM8.853 15.853l-6 6c-0.194 0.194-0.513 0.194-0.706 0s-0.194-0.513 0-0.706l6-6c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.194 0.194 0.194 0.509 0 0.706zM16.5 13c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M15.794 5.5l0.706 0.706 1.353-1.353c0.194-0.194 0.194-0.513 0-0.706l-1.353-1.353-0.706 0.706 0.506 0.506c-1.837 0.103-3.3 1.631-3.3 3.494v0.5h1v-0.5c0-1.306 1.006-2.381 2.284-2.491l-0.491 0.491z" }),
_('path', { d: "M19 7.5c0 1.306-1.006 2.381-2.284 2.491l0.491-0.491-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706-0.506-0.506c1.837-0.103 3.3-1.631 3.3-3.494v-0.5h-1v0.5z" })
            );
        }
        function FindReplace({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FindReplaceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FindReplace.SVG = FindReplaceSVG;
        return FindReplace;
    })();
export const Fingerprint = /*#__PURE__*/ (() => {
        function FingerprintSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21 11.5c0-0.2-0.009-0.397-0.028-0.594-0.144-2.884-0.862-5.372-2.1-7.238-1.591-2.4-3.969-3.669-6.872-3.669s-5.281 1.269-6.872 3.669c-1.394 2.1-2.128 4.978-2.128 8.331 0 2.772 0.178 5.925 1.503 8.269 0.684 1.209 1.638 2.137 2.834 2.753 1.272 0.656 2.797 0.975 4.662 0.975s3.391-0.319 4.662-0.975c1.197-0.619 2.15-1.544 2.834-2.753 1.325-2.344 1.503-5.497 1.503-8.269 0-0.169-0.003-0.334-0.006-0.5h0.006zM6.794 4.775c1.222-1.841 2.972-2.775 5.206-2.775 1.384 0 2.584 0.359 3.584 1.069-0.359-0.044-0.722-0.069-1.084-0.069-1.563 0-3.806 0.288-5.616 1.666-1.913 1.453-2.884 3.753-2.884 6.834 0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5v-0.5h-1v0.5c0 1.931-1.569 3.5-3.5 3.5s-3.5-1.569-3.5-3.5c0-6.525 4.7-7.5 7.5-7.5 0.831 0 1.662 0.141 2.447 0.409 0.087 0.119 0.175 0.237 0.259 0.366 0.237 0.356 0.45 0.741 0.641 1.156-0.978-0.591-2.125-0.931-3.347-0.931-3.584 0-6.5 2.916-6.5 6.5 0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 3.031-2.469 5.5-5.5 5.5-2.975 0-5.406-2.375-5.497-5.331 0.044-2.813 0.663-5.191 1.791-6.894zM17.753 19.287c-1.047 1.85-2.875 2.712-5.753 2.712s-4.709-0.862-5.753-2.712c-0.041-0.072-0.078-0.144-0.116-0.216 1.184 0.606 2.503 0.928 3.869 0.928v-1c-1.619 0-3.169-0.516-4.453-1.462-0.206-0.75-0.338-1.556-0.419-2.381 1.172 1.716 3.141 2.844 5.372 2.844 3.584 0 6.5-2.916 6.5-6.5 0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-3.031 2.469-5.5 5.5-5.5 1.566 0 2.981 0.656 3.984 1.713 0.341 1.272 0.516 2.716 0.516 4.287 0 2.512-0.147 5.344-1.247 7.287z" }),
_('path', { d: "M10 11.5v0.5h1v-0.5c0-1.931 1.569-3.5 3.5-3.5h0.5v-1h-0.5c-2.481 0-4.5 2.019-4.5 4.5z" }),
_('path', { d: "M16 7v1c0.472 0 0.956 0.387 1.331 1.062 0.431 0.778 0.669 1.822 0.669 2.937 0 3.853-2.191 8-7 8v1c2.503 0 4.597-1 6.053-2.891 0.637-0.828 1.131-1.8 1.469-2.884 0.319-1.031 0.478-2.112 0.478-3.222 0-2.806-1.319-5.003-3-5.003z" })
            );
        }
        function Fingerprint({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FingerprintSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Fingerprint.SVG = FingerprintSVG;
        return Fingerprint;
    })();
export const FireForbidden = /*#__PURE__*/ (() => {
        function FireForbiddenSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.947 16.038c-0.506-3.284-3.041-4.894-3.147-4.962-0.153-0.097-0.347-0.1-0.506-0.012s-0.256 0.256-0.256 0.438c0 1.581-0.559 2.403-1.1 3.194-0.547 0.8-1.109 1.628-0.881 3.028 0 0.006 0.003 0.012 0.003 0.019 0.15 0.738 0.591 1.369 1.244 1.781 0.497 0.316 1.081 0.478 1.684 0.478 0.175 0 0.35-0.012 0.525-0.041 0.003 0 0.006 0 0.009 0 0.784-0.138 1.456-0.556 1.897-1.188 0.494-0.706 0.678-1.65 0.531-2.728-0.003-0.003-0.003-0.006-0.003-0.006zM9.353 18.972c-1.097 0.169-2.112-0.453-2.316-1.422-0.159-1 0.209-1.541 0.722-2.294 0.459-0.675 1.012-1.484 1.203-2.772 0.7 0.656 1.713 1.887 1.994 3.7 0.25 1.803-0.666 2.622-1.603 2.787z" }),
_('path', { d: "M23 7.5c0-3.584-2.916-6.5-6.5-6.5-2.362 0-4.437 1.269-5.575 3.159-1.572-1.447-3.428-2.825-5.409-4.016-0.347-0.209-0.784-0.188-1.109 0.053s-0.475 0.653-0.375 1.047c0.903 3.612-0.159 5.862-1.281 8.244-0.544 1.153-1.103 2.344-1.437 3.687-0.381 1.547-0.403 3.091-0.063 4.716 0.003 0.012 0.006 0.025 0.009 0.037 0.516 2.075 1.809 3.822 3.641 4.922 1.259 0.756 2.672 1.147 4.106 1.147 0.65 0 1.303-0.078 1.95-0.241 1.047-0.259 2-0.716 2.834-1.353 0.797-0.609 1.466-1.366 1.991-2.253 1.019-1.725 1.416-3.844 1.119-5.963-0.009-0.066-0.019-0.131-0.028-0.197 3.409-0.191 6.128-3.031 6.128-6.491zM10.472 21.816c-1.556 0.387-3.169 0.147-4.541-0.678-1.369-0.822-2.337-2.128-2.728-3.675-0.612-2.95 0.3-4.884 1.353-7.125 0.594-1.263 1.209-2.566 1.55-4.103 0.231-1.041 0.309-2.094 0.234-3.178 1.397 0.972 2.688 2.025 3.797 3.109-0.091 0.431-0.138 0.875-0.138 1.331 0 2.994 2.034 5.522 4.794 6.272 0.050 0.228 0.091 0.459 0.122 0.691 0.491 3.5-1.378 6.594-4.444 7.356zM16.5 13c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18.5 4.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function FireForbidden({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FireForbiddenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FireForbidden.SVG = FireForbiddenSVG;
        return FireForbidden;
    })();
export const FireHazard = /*#__PURE__*/ (() => {
        function FireHazardSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.787 21.103l-10-19.997c-0.337-0.681-1.025-1.106-1.788-1.106-0.766 0-1.45 0.425-1.788 1.106l-10 19.997c-0.138 0.275-0.213 0.584-0.213 0.897 0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2 0-0.312-0.075-0.622-0.213-0.897zM2 22l10-20c0 0 0 0 0 0l10 20h-20zM22 22c0 0 0 0 0 0s0.003 0 0 0c0.003 0 0 0 0 0z" }),
_('path', { d: "M12 19c1.103 0 2-0.897 2-2 0-1.688-1.1-2.806-1.147-2.853-0.153-0.153-0.384-0.191-0.578-0.094-0.094 0.047-2.275 1.159-2.275 2.947 0 1.103 0.897 2 2 2zM12.384 15.147c0.25 0.353 0.616 1.013 0.616 1.853 0 0.55-0.45 1-1 1s-1-0.45-1-1c0-0.788 0.819-1.488 1.384-1.853z" }),
_('path', { d: "M11.103 9.063c-0.156 0.087-0.256 0.256-0.256 0.438 0 2.231-0.8 3.381-1.572 4.494-0.778 1.119-1.512 2.178-1.203 4.031 0 0.006 0.003 0.012 0.003 0.019 0.2 0.963 0.787 1.791 1.656 2.331 0.663 0.412 1.441 0.625 2.25 0.625 0.234 0 0.469-0.019 0.703-0.053 0.003 0 0.006 0 0.009 0 1.044-0.178 1.941-0.728 2.528-1.55 0.666-0.934 0.912-2.184 0.709-3.622 0-0.003 0-0.006 0-0.009-0.366-2.316-1.516-4.009-2.416-5.022-0.975-1.097-1.869-1.647-1.906-1.669-0.156-0.097-0.35-0.1-0.506-0.012zM14.941 15.916c0.366 2.613-1.006 3.8-2.412 4.044-1.647 0.25-3.169-0.675-3.472-2.106-0.237-1.447 0.328-2.259 1.041-3.288 0.675-0.972 1.494-2.15 1.703-4.1 0.984 0.834 2.7 2.65 3.141 5.45z" })
            );
        }
        function FireHazard({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FireHazardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FireHazard.SVG = FireHazardSVG;
        return FireHazard;
    })();
export const FirePrice = /*#__PURE__*/ (() => {
        function FirePriceSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.947 16.038c-0.506-3.284-3.041-4.894-3.147-4.962-0.153-0.097-0.347-0.1-0.506-0.012s-0.256 0.256-0.256 0.438c0 1.581-0.559 2.403-1.1 3.194-0.547 0.8-1.109 1.628-0.881 3.028 0 0.006 0.003 0.012 0.003 0.019 0.15 0.738 0.591 1.369 1.244 1.781 0.497 0.316 1.081 0.478 1.684 0.478 0.175 0 0.35-0.012 0.525-0.041 0.003 0 0.006 0 0.009 0 0.784-0.138 1.456-0.556 1.897-1.188 0.494-0.706 0.678-1.65 0.531-2.728-0.003-0.003-0.003-0.006-0.003-0.006zM9.353 18.972c-1.097 0.169-2.112-0.453-2.316-1.422-0.159-1 0.209-1.541 0.722-2.294 0.459-0.675 1.012-1.484 1.203-2.772 0.7 0.656 1.713 1.887 1.994 3.7 0.25 1.803-0.666 2.622-1.603 2.787z" }),
_('path', { d: "M23 7.5c0-3.584-2.916-6.5-6.5-6.5-2.362 0-4.437 1.269-5.575 3.159-1.572-1.447-3.428-2.825-5.409-4.016-0.347-0.209-0.784-0.188-1.109 0.053s-0.475 0.653-0.375 1.047c0.903 3.612-0.159 5.862-1.281 8.244-0.544 1.153-1.103 2.344-1.437 3.687-0.381 1.547-0.403 3.091-0.063 4.716 0.003 0.012 0.006 0.025 0.009 0.037 0.516 2.075 1.809 3.822 3.641 4.922 1.259 0.756 2.672 1.147 4.106 1.147 0.65 0 1.303-0.078 1.95-0.241 1.047-0.259 2-0.716 2.834-1.353 0.797-0.609 1.466-1.366 1.991-2.253 1.019-1.725 1.416-3.844 1.119-5.963-0.009-0.066-0.019-0.131-0.028-0.197 3.409-0.191 6.128-3.031 6.128-6.491zM10.472 21.816c-1.556 0.387-3.169 0.147-4.541-0.678-1.369-0.822-2.337-2.128-2.728-3.675-0.612-2.95 0.3-4.884 1.353-7.125 0.594-1.263 1.209-2.566 1.55-4.103 0.231-1.041 0.309-2.094 0.234-3.178 1.397 0.972 2.688 2.025 3.797 3.109-0.091 0.431-0.138 0.875-0.138 1.331 0 2.994 2.034 5.522 4.794 6.272 0.050 0.228 0.091 0.459 0.122 0.691 0.491 3.5-1.378 6.594-4.444 7.356zM16.5 13c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17 3h-1v2h-0.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h2c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-3.5v1h2v2h1v-2h0.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-2c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3.5v-1h-2v-2z" })
            );
        }
        function FirePrice({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FirePriceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FirePrice.SVG = FirePriceSVG;
        return FirePrice;
    })();
export const FireWarning = /*#__PURE__*/ (() => {
        function FireWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9.8 11.075c-0.153-0.097-0.347-0.1-0.506-0.012s-0.256 0.256-0.256 0.438c0 1.581-0.559 2.403-1.1 3.194-0.547 0.8-1.109 1.628-0.881 3.028 0 0.006 0.003 0.012 0.003 0.019 0.15 0.738 0.591 1.369 1.244 1.781 0.497 0.316 1.081 0.478 1.684 0.478 0.175 0 0.35-0.012 0.525-0.041 0.003 0 0.006 0 0.009 0 0.784-0.138 1.456-0.556 1.897-1.188 0.494-0.706 0.678-1.65 0.531-2.728 0-0.003 0-0.006 0-0.009-0.509-3.281-3.044-4.891-3.15-4.959zM10.353 18.972c-1.097 0.169-2.112-0.453-2.316-1.422-0.159-1 0.209-1.541 0.722-2.294 0.459-0.675 1.012-1.484 1.203-2.772 0.7 0.656 1.713 1.887 1.994 3.7 0.247 1.803-0.666 2.622-1.603 2.787z" }),
_('path', { d: "M16 8h1v1h-1v-1z" }),
_('path', { d: "M16 3h1v4h-1v-4z" }),
_('path', { d: "M21.841 8.828l-4-7.997c-0.25-0.506-0.775-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-2.178 4.356c-2.231-2.287-4.709-3.987-6.466-5.041-0.347-0.209-0.784-0.188-1.109 0.053s-0.472 0.653-0.375 1.047c0.903 3.612-0.159 5.862-1.281 8.244-0.544 1.153-1.103 2.344-1.437 3.687-0.381 1.547-0.403 3.091-0.063 4.716 0.003 0.012 0.006 0.025 0.009 0.037 0.516 2.075 1.809 3.822 3.641 4.922 1.259 0.756 2.672 1.147 4.106 1.147 0.65 0 1.303-0.078 1.95-0.241 1.047-0.259 2-0.716 2.834-1.353 0.797-0.609 1.466-1.366 1.991-2.253 1.019-1.725 1.416-3.844 1.119-5.966-0.153-1.059-0.453-2.125-0.9-3.184h3.5c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672zM15.916 14.463c0.491 3.497-1.378 6.588-4.444 7.353-1.556 0.387-3.169 0.147-4.541-0.678-1.369-0.822-2.337-2.128-2.728-3.675-0.612-2.95 0.3-4.884 1.353-7.125 0.594-1.263 1.209-2.566 1.55-4.103 0.231-1.041 0.309-2.094 0.234-3.181 1.488 1.031 3.175 2.384 4.688 4.031l-0.869 1.737c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h2.297c0.581 1.163 0.959 2.328 1.119 3.469zM20.5 10h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5z" })
            );
        }
        function FireWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FireWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FireWarning.SVG = FireWarningSVG;
        return FireWarning;
    })();
export const Fire = /*#__PURE__*/ (() => {
        function FireSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.897 14.184c-0.394-2.787-1.803-5.556-4.194-8.225-2.397-2.678-5.231-4.641-7.188-5.816-0.347-0.209-0.784-0.188-1.109 0.053s-0.472 0.653-0.375 1.047c0.903 3.612-0.159 5.862-1.281 8.244-0.544 1.153-1.103 2.344-1.437 3.687-0.381 1.547-0.403 3.091-0.063 4.716 0.003 0.012 0.006 0.025 0.009 0.037 0.516 2.075 1.809 3.822 3.641 4.922 1.259 0.756 2.672 1.147 4.106 1.147 0.65 0 1.303-0.078 1.95-0.241 1.047-0.259 2-0.716 2.834-1.353 0.797-0.609 1.466-1.366 1.991-2.253 1.016-1.728 1.413-3.844 1.116-5.966zM13.472 21.816c-1.556 0.387-3.169 0.147-4.541-0.678-1.369-0.822-2.337-2.128-2.728-3.675-0.612-2.95 0.3-4.884 1.353-7.125 0.594-1.263 1.209-2.566 1.55-4.103 0.231-1.041 0.309-2.094 0.234-3.178 3.216 2.231 7.853 6.278 8.575 11.406 0.491 3.497-1.378 6.591-4.444 7.353z" }),
_('path', { d: "M14.947 16.034c-0.509-3.281-3.041-4.891-3.147-4.959-0.153-0.097-0.347-0.1-0.506-0.012s-0.256 0.256-0.256 0.438c0 1.581-0.559 2.4-1.1 3.194-0.547 0.8-1.109 1.628-0.881 3.028 0 0.006 0.003 0.012 0.003 0.019 0.15 0.738 0.594 1.372 1.247 1.784 0.497 0.312 1.078 0.478 1.678 0.478 0.175 0 0.353-0.012 0.531-0.041 0.003 0 0.003 0 0.006 0 0.784-0.134 1.459-0.556 1.9-1.184 0.497-0.706 0.678-1.65 0.531-2.728-0.003-0.009-0.006-0.012-0.006-0.016zM12.353 18.972c-1.097 0.172-2.109-0.45-2.316-1.422-0.159-1 0.209-1.541 0.722-2.291 0.459-0.675 1.012-1.481 1.203-2.772 0.153 0.144 0.325 0.316 0.497 0.516 0.813 0.938 1.316 2.009 1.497 3.181 0.25 1.803-0.663 2.622-1.603 2.787z" })
            );
        }
        function Fire({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FireSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Fire.SVG = FireSVG;
        return Fire;
    })();
export const Fireworks = /*#__PURE__*/ (() => {
        function FireworksSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.706 0.294c-0.228-0.228-0.553-0.331-0.872-0.278l-10.219 1.7c-0.716 0.119-1.297 0.622-1.519 1.313s-0.041 1.437 0.472 1.953l0.519 0.519-7.794 7.794c-0.391 0.391-0.391 1.025 0 1.416l2.141 2.141c-1.106 1.022-2.194 1.381-3.087 1.012-0.819-0.341-1.347-1.269-1.347-2.366 0-1.113 0.681-2.013 1.403-2.959 0.784-1.034 1.597-2.103 1.597-3.537h-1c0 1.097-0.678 1.988-1.394 2.931-0.791 1.041-1.606 2.116-1.606 3.566 0 1.503 0.772 2.794 1.966 3.288 0.344 0.144 0.712 0.216 1.097 0.216 0.322 0 0.653-0.050 0.987-0.153 0.703-0.216 1.406-0.647 2.094-1.291l2.153 2.153c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l7.791-7.794 0.519 0.519c0.369 0.369 0.856 0.566 1.359 0.566 0.197 0 0.397-0.031 0.591-0.094 0.691-0.222 1.194-0.803 1.313-1.519l1.703-10.222c0.056-0.319-0.050-0.644-0.278-0.872zM15 8.416v4.172l-2 2v-7.172l0.5-0.5 1.5 1.5zM9 11.416v5.172l-2.584-2.588 2.584-2.584zM10 17.584v-7.169l2-2v7.172l-2 1.997zM16 11.584v-2.172l1.084 1.084-1.084 1.087zM19.725 11.725l0.706-0.706c0 0 0 0 0 0l-0.706 0.706zM20.334 10.919l-7.253-7.253 8.703-1.45-1.45 8.703z" }),
_('path', { d: "M8.793 22.5l8.706-8.706 0.707 0.707-8.706 8.706-0.707-0.707z" }),
_('path', { d: "M4.793 7.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M3.829 5.724l1.448-2.896 0.894 0.447-1.448 2.896-0.894-0.447z" }),
_('path', { d: "M0.829 3.276l0.894-0.447 1.448 2.896-0.894 0.447-1.448-2.896z" }),
_('path', { d: "M0.793 7.501l0.707-0.707 1.708 1.708-0.707 0.707-1.708-1.708z" }),
_('path', { d: "M3 2h1v1h-1v-1z" })
            );
        }
        function Fireworks({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FireworksSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Fireworks.SVG = FireworksSVG;
        return Fireworks;
    })();
export const FirstAidKit = /*#__PURE__*/ (() => {
        function FirstAidKitSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 6h-5v-2c0-1.103-0.897-2-2-2h-6c-1.103 0-2 0.897-2 2v2h-5c-1.103 0-2 0.897-2 2v12c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-12c0-1.103-0.897-2-2-2zM9 4h6v2h-6v-2zM22 8v1h-20v-1h20zM22 20h-20v-10h20v10c0.003 0 0 0 0 0z" }),
_('path', { d: "M13 12h-2v2h-2v2h2v2h2v-2h2v-2h-2z" })
            );
        }
        function FirstAidKit({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FirstAidKitSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FirstAidKit.SVG = FirstAidKitSVG;
        return FirstAidKit;
    })();
export const FirstAid = /*#__PURE__*/ (() => {
        function FirstAidSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M11 17h2v-4h4v-2h-4v-4h-2v4h-4v2h4z" })
            );
        }
        function FirstAid({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FirstAidSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FirstAid.SVG = FirstAidSVG;
        return FirstAid;
    })();
export const FirstCircle = /*#__PURE__*/ (() => {
        function FirstCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M16.744 9.063c-0.159-0.087-0.353-0.084-0.506 0.012l-3.237 2.022v-1.597c0-0.181-0.1-0.35-0.256-0.438-0.159-0.087-0.353-0.084-0.506 0.012l-4 2.5c-0.147 0.091-0.234 0.253-0.234 0.425s0.087 0.331 0.234 0.425l4 2.5c0.081 0.050 0.172 0.075 0.266 0.075 0.084 0 0.166-0.022 0.244-0.063 0.159-0.087 0.256-0.256 0.256-0.438v-1.597l3.234 2.022c0.081 0.050 0.172 0.075 0.266 0.075 0.084 0 0.166-0.022 0.244-0.063 0.159-0.087 0.256-0.256 0.256-0.438v-5c-0.003-0.181-0.103-0.35-0.259-0.438zM12 13.597l-2.556-1.597 2.556-1.597v3.194zM16 13.597l-2.556-1.597 2.556-1.597v3.194z" }),
_('path', { d: "M7 9h1v6h-1v-6z" })
            );
        }
        function FirstCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FirstCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FirstCircle.SVG = FirstCircleSVG;
        return FirstCircle;
    })();
export const FirstCircle2 = /*#__PURE__*/ (() => {
        function FirstCircle2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M8.234 12.425l4 2.5c0.081 0.050 0.172 0.075 0.266 0.075 0.084 0 0.166-0.022 0.244-0.063 0.159-0.087 0.256-0.256 0.256-0.438v-1.597l3.234 2.022c0.081 0.050 0.172 0.075 0.266 0.075 0.084 0 0.166-0.022 0.244-0.063 0.159-0.087 0.256-0.256 0.256-0.438v-5c0-0.181-0.1-0.35-0.256-0.438-0.159-0.087-0.353-0.084-0.506 0.012l-3.237 2.022v-1.597c0-0.181-0.1-0.35-0.256-0.438-0.159-0.087-0.353-0.084-0.506 0.012l-4 2.5c-0.147 0.091-0.234 0.253-0.234 0.425s0.084 0.331 0.231 0.425zM16 10.403v3.197l-2.556-1.6 2.556-1.597zM12 10.403v3.197l-2.556-1.6 2.556-1.597z" }),
_('path', { d: "M7 9h1v6h-1v-6z" })
            );
        }
        function FirstCircle2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FirstCircle2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FirstCircle2.SVG = FirstCircle2SVG;
        return FirstCircle2;
    })();
export const First = /*#__PURE__*/ (() => {
    function FirstSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.463 4.113c-0.331-0.172-0.731-0.147-1.034 0.069l-9.428 6.597v-5.778c0-0.372-0.206-0.716-0.537-0.888s-0.731-0.147-1.034 0.069l-9.428 6.597v-6.778h-2v16h2v-6.778l9.425 6.6c0.172 0.119 0.372 0.181 0.575 0.181 0.159 0 0.316-0.038 0.462-0.112 0.331-0.172 0.537-0.516 0.537-0.888v-5.781l9.425 6.6c0.172 0.119 0.372 0.181 0.575 0.181 0.159 0 0.316-0.038 0.462-0.113 0.331-0.172 0.537-0.516 0.537-0.888v-14.003c0-0.372-0.206-0.716-0.537-0.888zM11 17.078l-7.256-5.078 7.256-5.078v10.156zM22 17.078l-7.256-5.078 7.256-5.078v10.156z" })
        );
    }
    function First({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FirstSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    First.SVG = FirstSVG;
    return First;
})();
export const FishBowl = /*#__PURE__*/ (() => {
        function FishBowlSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.538 11.187c-1.128-0.403-2.897-0.344-5.041 2.059-0.719-0.769-2.322-2.247-3.997-2.247-0.175 0-0.338 0.091-0.428 0.241s-0.097 0.334-0.019 0.487c0.453 0.881 0.941 2.009 0.944 2.278v1.494c0 0.275 0.225 0.5 0.5 0.5 1.453 0 2.441-0.697 2.966-1.209 1.387 1.709 2.697 2.209 3.756 2.209 0.394 0 0.756-0.069 1.072-0.172 0.706-0.228 1.394-0.7 1.941-1.328 0.369-0.425 0.766-1.038 0.766-1.484 0-0.366-0.259-0.938-0.656-1.462-0.344-0.453-0.938-1.059-1.803-1.366zM6 14.962v-0.969c0-0.009 0-0.019 0-0.028-0.009-0.222-0.091-0.619-0.544-1.628-0.025-0.056-0.050-0.109-0.075-0.162 1.041 0.391 2.003 1.338 2.456 1.831-0.312 0.325-0.925 0.819-1.838 0.956zM12.819 15.928c-1.203 0.303-2.469-0.353-3.678-1.894 1.419-1.634 2.791-2.303 3.978-1.931s1.844 1.619 1.881 1.909c-0.056 0.291-0.872 1.584-2.181 1.916z" }),
_('path', { d: "M14 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M18.5 11c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5c0-0.828-0.672-1.5-1.5-1.5zM18.5 13c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M22.95 5.381c-0.675-1.563-1.634-2.944-2.85-4.103-0.188-0.178-0.434-0.275-0.691-0.275h-14.819c-0.256 0-0.503 0.1-0.691 0.275-1.219 1.159-2.178 2.541-2.85 4.103-0.697 1.612-1.050 3.334-1.050 5.119 0 1.681 0.316 3.312 0.938 4.85 0.603 1.488 1.462 2.825 2.562 3.972 1.1 1.15 2.384 2.056 3.816 2.688 1.484 0.656 3.063 0.991 4.688 0.991s3.203-0.331 4.688-0.991c1.431-0.631 2.712-1.538 3.816-2.688 1.097-1.147 1.959-2.484 2.562-3.972 0.622-1.538 0.937-3.169 0.937-4.85-0.006-1.784-0.359-3.506-1.056-5.119zM5.003 3h13.997c1.266 1.303 2.172 2.931 2.637 4.7-1.266 0.306-2.597 0.341-3.638 0.244-0.028-1.078-0.916-1.944-2-1.944-0.8 0-1.491 0.472-1.812 1.153-0.684-0.197-1.372-0.416-2.044-0.631-2.806-0.891-5.694-1.806-8.712-1.437 0.438-0.756 0.963-1.456 1.572-2.084zM17 8c0 0.55-0.45 1-1 1s-1-0.45-1-1 0.45-1 1-1 1 0.45 1 1zM12 21c-5.512 0-10-4.709-10-10.5 0-1.503 0.309-2.972 0.888-4.316 3.028-0.588 5.916 0.328 8.956 1.294 0.706 0.225 1.434 0.456 2.163 0.666 0.072 1.038 0.941 1.859 1.994 1.859 0.769 0 1.437-0.434 1.772-1.072 0.387 0.041 0.816 0.063 1.269 0.063 0.881 0 1.859-0.087 2.806-0.312 0.1 0.597 0.153 1.209 0.153 1.822 0 5.787-4.488 10.497-10 10.497z" })
            );
        }
        function FishBowl({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FishBowlSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FishBowl.SVG = FishBowlSVG;
        return FishBowl;
    })();
export const Fish = /*#__PURE__*/ (() => {
        function FishSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 10c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM18 11c0 0 0 0 0 0v0z" }),
_('path', { d: "M23.819 10.281c-0.122-0.175-3.075-4.294-7.819-4.294-0.081 0-0.159 0-0.237 0.003-0.553-0.775-1.713-1.991-2.763-1.991-0.050 0-0.103 0.009-0.15 0.022-1.413 0.447-3.438 2.525-4.741 4.166-0.094 0.116-0.128 0.269-0.097 0.413 0.031 0.147 0.125 0.269 0.256 0.341 0.631 0.334 0.722 0.547 0.734 0.594-0.322 0.241-0.619 0.416-0.872 0.462h-0.162c-0.541-0.231-1.184-0.759-1.859-1.319-1.45-1.191-3.253-2.678-5.609-2.678-0.188 0-0.359 0.106-0.444 0.272s-0.072 0.369 0.037 0.519c0.006 0.009 0.75 1.044 1.481 2.228 1.322 2.134 1.425 2.822 1.425 2.981s-0.103 0.847-1.422 2.978c-0.734 1.181-1.478 2.219-1.484 2.231-0.109 0.153-0.125 0.353-0.038 0.519s0.256 0.272 0.444 0.272c2.356 0 4.159-1.488 5.609-2.681 0.678-0.559 1.322-1.088 1.859-1.319h0.031c0.866 0 1.759 0.544 2.794 1.172 0.041 0.025 0.081 0.050 0.119 0.072-0.472 0.325-0.991 0.584-1.575 0.781-0.162 0.053-0.284 0.188-0.325 0.353s0.006 0.341 0.122 0.466c0.959 1.013 1.975 1.691 3.194 2.128 0.056 0.019 0.112 0.028 0.169 0.028 0.075 0 0.15-0.016 0.216-0.050 1.059-0.509 1.781-1.191 2.153-2.025 0.359 0.059 0.734 0.091 1.131 0.091 2.391 0 4.45-1.466 5.466-2.337 1.169-1.006 2.534-2.609 2.534-3.822 0.003-0.206-0.059-0.406-0.178-0.575zM9.25 8.372c1.416-1.697 2.925-3.034 3.819-3.366 0.244 0.034 0.603 0.241 0.978 0.569 0.188 0.162 0.375 0.353 0.547 0.547-2.103 0.409-3.559 1.678-4.672 2.647-0.047 0.041-0.094 0.081-0.138 0.122-0.125-0.181-0.303-0.353-0.534-0.519zM5.472 14.547c-1.144 0.944-2.416 1.991-3.938 2.337 0.259-0.384 0.575-0.866 0.891-1.375 1.575-2.544 1.575-3.269 1.575-3.509s0-0.966-1.575-3.509c-0.316-0.509-0.631-0.991-0.891-1.375 1.522 0.344 2.794 1.394 3.938 2.337 0.544 0.45 1.044 0.859 1.528 1.163v2.772c-0.484 0.3-0.981 0.709-1.528 1.159zM12.472 17.956c-0.759-0.297-1.431-0.713-2.069-1.275 0.525-0.241 1.003-0.531 1.447-0.884 0.619 0.347 1.284 0.669 2.022 0.894-0.272 0.497-0.734 0.912-1.4 1.266zM21.5 11.741c-0.372 0.503-0.881 1.034-1.434 1.5-1.344 1.128-2.825 1.775-4.066 1.775-1.616 0-2.913-0.787-4.169-1.55-0.897-0.547-1.819-1.106-2.831-1.344v-0.294c0.797-0.297 1.503-0.912 2.238-1.55 1.231-1.072 2.625-2.287 4.762-2.287 1.525 0 3.019 0.566 4.437 1.681 0.681 0.534 1.184 1.078 1.472 1.419-0.075 0.153-0.203 0.372-0.409 0.65z" })
            );
        }
        function Fish({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FishSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Fish.SVG = FishSVG;
        return Fish;
    })();
export const Flag = /*#__PURE__*/ (() => {
    function FlagSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.5 4h-14.5v-0.269c0.597-0.347 1-0.994 1-1.731 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 0.738 0.403 1.384 1 1.731v20.269h2v-11h14.5c0.275 0 0.5-0.225 0.5-0.5v-8c0-0.275-0.225-0.5-0.5-0.5zM5 1c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM20 12h-14v-7h14v7z" })
        );
    }
    function Flag({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FlagSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Flag.SVG = FlagSVG;
    return Flag;
})();
export const Flag2 = /*#__PURE__*/ (() => {
    function Flag2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20 7.478c-0.009-0.216-0.156-0.4-0.363-0.459l-9.637-2.753v-0.534c0.597-0.347 1-0.994 1-1.731 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 0.738 0.403 1.384 1 1.731v16.303c-2.075 0.15-4 0.778-4 1.962 0 1.375 2.591 2 5 2s5-0.625 5-2c0-1.184-1.925-1.812-4-1.962v-8.381l9.678-3.687c0.2-0.075 0.331-0.272 0.322-0.488zM9 1c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM12.025 21.413c0.806 0.269 0.975 0.544 0.975 0.588s-0.169 0.319-0.975 0.588c-0.8 0.266-1.875 0.413-3.025 0.413s-2.225-0.147-3.025-0.413c-0.806-0.269-0.975-0.544-0.975-0.588s0.169-0.319 0.975-0.588c0.563-0.188 1.259-0.316 2.025-0.375v0.963h2v-0.963c0.762 0.059 1.463 0.188 2.025 0.375zM10 10.584v-5.278l7.919 2.262-7.919 3.016z" })
        );
    }
    function Flag2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Flag2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Flag2.SVG = Flag2SVG;
    return Flag2;
})();
export const Flag3 = /*#__PURE__*/ (() => {
    function Flag3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.991 3.406c-0.116-0.606-0.769-1.116-2.003-1.556-0.928-0.331-2.169-0.606-3.403-0.756-1.038-0.125-1.978-0.156-2.719-0.087-0.991 0.094-1.575 0.363-1.788 0.828-0.069 0.153-0.097 0.309-0.078 0.469v2.3c-0.525 0.178-1.25 0.322-2.153 0.363-1.691 0.078-3.438-0.213-4.847-0.797v-0.441c0.597-0.347 1-0.994 1-1.731 0-1.103-0.897-2-2-2s-2 0.9-2 2.003c0 0.738 0.403 1.384 1 1.731v20.269h2v-11.753c1.391 0.509 2.934 0.738 4.344 0.738 1.425 0 2.709-0.234 3.547-0.647 0.619-0.303 0.987-0.694 1.097-1.162 0.009-0.037 0.012-0.075 0.012-0.113v-2.044c1.069-0.097 2.666 0.037 4.156 0.363 0.847 0.184 1.572 0.412 2.097 0.656 0.584 0.275 0.744 0.491 0.753 0.553 0.044 0.237 0.253 0.406 0.491 0.406 0.016 0 0.031 0 0.047-0.003 0.256-0.025 0.453-0.241 0.453-0.497v-6.997c0.003-0.031 0-0.063-0.006-0.094zM4 1c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM12.45 11.441c-1.516 0.744-4.881 0.797-7.45-0.269v-5.925c1.472 0.541 3.213 0.8 4.894 0.722 0.881-0.041 1.694-0.175 2.35-0.387 0.284-0.094 0.537-0.2 0.753-0.319v5.728c-0.056 0.144-0.256 0.309-0.547 0.45zM21 9.3c-0.1-0.056-0.206-0.109-0.322-0.166-0.591-0.278-1.391-0.528-2.309-0.728-1.559-0.341-3.197-0.481-4.369-0.387v-4.144c-0.003-0.347-0.156-0.778-0.663-1.244 0 0-0.003 0-0.003-0.003-0.228-0.206-0.303-0.334-0.328-0.391 0.131-0.1 0.644-0.288 1.906-0.266 1.097 0.019 2.438 0.2 3.591 0.481 0.759 0.184 1.403 0.406 1.859 0.637 0.441 0.222 0.597 0.4 0.634 0.475v5.734z" })
        );
    }
    function Flag3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Flag3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Flag3.SVG = Flag3SVG;
    return Flag3;
})();
export const FlashlightBright = /*#__PURE__*/ (() => {
        function FlashlightBrightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.412 3.594c-0.781-0.781-2.050-0.781-2.831 0l-2.291 2.294c-0.106 0.106-0.184 0.234-0.234 0.375l-1.825 5.172-6.612 6.125c-0.009 0.009-0.019 0.019-0.028 0.025-0.781 0.781-0.781 2.050 0 2.831l0.612 0.612c-0.684 0.138-1.203 0.747-1.203 1.472 0 0.828 0.672 1.5 1.5 1.5 0.725 0 1.334-0.519 1.472-1.206l0.612 0.612c0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584c0.009-0.009 0.019-0.019 0.025-0.028l6.125-6.612 5.172-1.825c0.141-0.050 0.269-0.131 0.375-0.237l2.294-2.294c0.778-0.778 0.778-2.047 0-2.828l-5.994-5.988zM1.5 23c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5zM4.997 21.994l-2.991-2.994 1.188-1.1 2.903 2.903-1.1 1.191zM11.669 14.962c-0.153 0.053-0.291 0.144-0.4 0.263l-4.488 4.844-2.85-2.85 4.844-4.488c0.119-0.109 0.209-0.247 0.263-0.4l1.831-5.194 0.281-0.281 5.994 5.994-0.284 0.284-5.191 1.828zM17.85 12.144l-5.994-5.994 1.141-1.144 5.994 5.994-1.141 1.144z" }),
_('path', { d: "M9.793 13.5l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M18.792 4.501l3.708-3.708 0.707 0.707-3.708 3.708-0.707-0.707z" }),
_('path', { d: "M16.828 3.725l1.448-2.896 0.894 0.447-1.448 2.896-0.894-0.447z" }),
_('path', { d: "M19.828 6.277l2.896-1.448 0.447 0.894-2.896 1.448-0.447-0.894z" })
            );
        }
        function FlashlightBright({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FlashlightBrightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FlashlightBright.SVG = FlashlightBrightSVG;
        return FlashlightBright;
    })();
export const Flashlight = /*#__PURE__*/ (() => {
        function FlashlightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.406 7.584c0 0 0 0 0 0l-5.991-5.991c-0.378-0.378-0.881-0.584-1.416-0.584s-1.038 0.209-1.416 0.584l-2.294 2.294c-0.106 0.106-0.188 0.234-0.237 0.375l-1.825 5.172-6.612 6.125c-0.009 0.009-0.019 0.019-0.028 0.025-0.378 0.378-0.584 0.881-0.584 1.416s0.209 1.038 0.584 1.416l0.616 0.616c-0.684 0.134-1.203 0.741-1.203 1.469 0 0.828 0.672 1.5 1.5 1.5 0.728 0 1.334-0.519 1.472-1.209l0.616 0.616c0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584c0.009-0.009 0.019-0.019 0.025-0.028l6.125-6.612 5.172-1.825c0.141-0.050 0.269-0.131 0.375-0.237l2.294-2.294c0.778-0.775 0.778-2.044-0.003-2.825zM3.5 21c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5zM7 19.991l-2.991-2.991 1.188-1.1 2.903 2.903-1.1 1.188zM13.669 12.963c-0.153 0.053-0.291 0.144-0.4 0.263l-4.488 4.844-2.85-2.85 4.844-4.488c0.119-0.109 0.209-0.247 0.263-0.4l1.831-5.191 0.284-0.284 5.991 5.991-0.284 0.284-5.191 1.831zM19.85 10.144l-5.994-5.994 1.144-1.141 5.991 5.991-1.141 1.144z" }),
_('path', { d: "M11.793 11.5l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" })
            );
        }
        function Flashlight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FlashlightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Flashlight.SVG = FlashlightSVG;
        return Flashlight;
    })();
export const FlaskWarning = /*#__PURE__*/ (() => {
        function FlaskWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 14h1v1h-1v-1z" }),
_('path', { d: "M17 9h1v4h-1v-4z" }),
_('path', { d: "M22.841 14.828l-4-7.997c-0.25-0.506-0.778-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-1.756 3.516-0.325-0.513c-0.050-0.078-0.075-0.169-0.075-0.262v-7.569h0.997v-2h-8v2h1v7.566c0 0.094-0.025 0.188-0.075 0.266l-6.531 10.331c-0.487 0.772-0.519 1.747-0.078 2.544s1.278 1.294 2.191 1.294h14.991c0.909 0 1.75-0.497 2.191-1.294s0.413-1.772-0.075-2.544l-2-3.162h2.888c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672zM18.934 21.741c-0.044 0.078-0.172 0.259-0.438 0.259h-14.991c-0.266 0-0.394-0.181-0.438-0.259s-0.128-0.284 0.016-0.509l2.475-3.916c1.906-0.825 3.759 0.125 5.716 1.128 1.072 0.55 2.178 1.119 3.316 1.387 0.462 0.109 0.909 0.166 1.341 0.166 0.681 0 1.328-0.138 1.95-0.416l1.041 1.647c0.141 0.228 0.056 0.434 0.012 0.513zM17.337 18.728c-1.869 0.747-3.691-0.188-5.609-1.172-1.072-0.55-2.178-1.119-3.316-1.388-0.722-0.172-1.406-0.209-2.056-0.112l3.259-5.153c0.253-0.4 0.384-0.859 0.384-1.334v-7.569h2.003v7.566c0 0.475 0.134 0.938 0.387 1.334l0.969 1.531-1.197 2.397c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h2.747l1.087 1.728zM21.5 16h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5z" })
            );
        }
        function FlaskWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FlaskWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FlaskWarning.SVG = FlaskWarningSVG;
        return FlaskWarning;
    })();
export const Flask = /*#__PURE__*/ (() => {
        function FlaskSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.609 20.163l-6.531-10.334c-0.050-0.078-0.075-0.169-0.075-0.262v-7.566h0.997v-2h-8v2h1v7.566c0 0.094-0.025 0.188-0.075 0.266l-6.531 10.331c-0.487 0.772-0.519 1.747-0.078 2.544s1.278 1.294 2.191 1.294h14.991c0.909 0 1.75-0.497 2.191-1.294s0.409-1.772-0.078-2.544zM10.616 10.9c0.253-0.4 0.384-0.859 0.384-1.334v-7.566h2.003v7.566c0 0.475 0.134 0.938 0.387 1.334l4.947 7.828c-1.869 0.747-3.691-0.188-5.609-1.172-1.072-0.55-2.178-1.119-3.316-1.388-0.722-0.172-1.406-0.209-2.056-0.112l3.259-5.156zM19.934 21.741c-0.044 0.078-0.172 0.259-0.438 0.259h-14.991c-0.266 0-0.394-0.181-0.438-0.259s-0.128-0.284 0.016-0.509l2.475-3.916c1.906-0.825 3.759 0.125 5.716 1.128 1.072 0.55 2.178 1.119 3.316 1.387 0.462 0.109 0.909 0.166 1.341 0.166 0.681 0 1.328-0.138 1.95-0.416l1.041 1.647c0.141 0.228 0.056 0.434 0.012 0.513z" }),
_('path', { d: "M12.624 13.345l0.845-0.534 2.432 3.846-0.845 0.534-2.432-3.846z" })
            );
        }
        function Flask({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FlaskSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Flask.SVG = FlaskSVG;
        return Flask;
    })();
export const FlipHorizontal = /*#__PURE__*/ (() => {
        function FlipHorizontalSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.231 2.028c-0.45-0.106-0.916 0.113-1.125 0.525l-9 18c-0.156 0.309-0.138 0.678 0.044 0.972 0.181 0.297 0.503 0.475 0.85 0.475h9c0.553 0 1-0.447 1-1v-18c0-0.462-0.319-0.866-0.769-0.972zM9 20h-6.381l6.381-12.762v12.762z" }),
_('path', { d: "M23.944 21.266l-10-19c-0.106-0.203-0.341-0.306-0.563-0.253-0.225 0.056-0.381 0.256-0.381 0.487v19c0 0.275 0.225 0.5 0.5 0.5h10c0.175 0 0.338-0.091 0.428-0.241s0.097-0.337 0.016-0.494zM14 21v-16.475l8.672 16.475h-8.672z" })
            );
        }
        function FlipHorizontal({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FlipHorizontalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FlipHorizontal.SVG = FlipHorizontalSVG;
        return FlipHorizontal;
    })();
export const FlipHorizontal2 = /*#__PURE__*/ (() => {
        function FlipHorizontal2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9.6 11.2l-8-6c-0.303-0.228-0.709-0.263-1.047-0.094-0.341 0.169-0.553 0.516-0.553 0.894v12c0 0.378 0.213 0.725 0.553 0.894 0.141 0.072 0.294 0.106 0.447 0.106 0.213 0 0.425-0.069 0.6-0.2l8-6c0.253-0.188 0.4-0.484 0.4-0.8s-0.147-0.612-0.4-0.8zM2 16v-8l5.334 4-5.334 4z" }),
_('path', { d: "M23.716 5.050c-0.175-0.084-0.381-0.059-0.531 0.063l-8 6.5c-0.116 0.094-0.184 0.237-0.184 0.387s0.069 0.294 0.184 0.387l8 6.5c0.091 0.075 0.203 0.112 0.316 0.112 0.072 0 0.147-0.016 0.216-0.050 0.175-0.084 0.284-0.259 0.284-0.45v-13c0-0.194-0.112-0.369-0.284-0.45zM23 17.45l-6.706-5.45 6.706-5.45v10.9z" }),
_('path', { d: "M12 20h1v3h-1v-3z" }),
_('path', { d: "M12 15h1v3h-1v-3z" }),
_('path', { d: "M12 10h1v3h-1v-3z" }),
_('path', { d: "M14.794 5.5l1.353 1.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l1.353-1.353-0.706-0.706-0.503 0.503c-0.106-2.388-2.084-4.297-4.497-4.297-2.481 0-4.5 2.019-4.5 4.5v0.5h1v-0.5c0-1.931 1.569-3.5 3.5-3.5 1.859 0 3.381 1.456 3.494 3.288l-0.494-0.494-0.706 0.706z" }),
_('path', { d: "M12 5h1v3h-1v-3z" })
            );
        }
        function FlipHorizontal2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FlipHorizontal2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FlipHorizontal2.SVG = FlipHorizontal2SVG;
        return FlipHorizontal2;
    })();
export const FlipVertical = /*#__PURE__*/ (() => {
        function FlipVerticalSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3 11h18c0.462 0 0.866-0.319 0.972-0.769s-0.112-0.916-0.525-1.125l-18-9c-0.309-0.156-0.678-0.138-0.972 0.044-0.297 0.181-0.475 0.503-0.475 0.85v9c0 0.553 0.447 1 1 1zM4 2.619l12.762 6.381h-12.762v-6.381z" }),
_('path', { d: "M21.5 13h-19c-0.275 0-0.5 0.225-0.5 0.5v10c0 0.175 0.091 0.337 0.241 0.428 0.078 0.047 0.169 0.072 0.259 0.072 0.081 0 0.159-0.019 0.234-0.056l19-10c0.203-0.106 0.306-0.341 0.253-0.563-0.056-0.225-0.256-0.381-0.487-0.381zM3 22.672v-8.672h16.475l-16.475 8.672z" })
            );
        }
        function FlipVertical({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FlipVerticalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FlipVertical.SVG = FlipVerticalSVG;
        return FlipVertical;
    })();
export const FlipVertical2 = /*#__PURE__*/ (() => {
        function FlipVertical2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.2 9.6c0.188 0.253 0.484 0.4 0.8 0.4s0.612-0.147 0.8-0.4l6-8c0.228-0.303 0.262-0.709 0.094-1.047-0.169-0.341-0.516-0.553-0.894-0.553h-12c-0.378 0-0.725 0.213-0.894 0.553-0.169 0.337-0.134 0.744 0.094 1.047l6 8zM16 2l-4 5.334-4-5.334h8z" }),
_('path', { d: "M12.387 15.184c-0.094-0.116-0.237-0.184-0.387-0.184s-0.294 0.069-0.387 0.184l-6.5 8c-0.122 0.15-0.147 0.356-0.063 0.531s0.259 0.284 0.45 0.284h13c0.194 0 0.369-0.112 0.45-0.284 0.084-0.175 0.059-0.381-0.063-0.531l-6.5-8zM6.55 23l5.45-6.706 5.45 6.706h-10.9z" }),
_('path', { d: "M1 12h3v1h-3v-1z" }),
_('path', { d: "M6 12h3v1h-3v-1z" }),
_('path', { d: "M11 12h3v1h-3v-1z" }),
_('path', { d: "M23 12.5c0-2.481-2.019-4.5-4.5-4.5h-0.5v1h0.5c1.931 0 3.5 1.569 3.5 3.5 0 1.859-1.456 3.384-3.288 3.494l0.494-0.494-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706-0.503-0.503c2.388-0.106 4.297-2.084 4.297-4.497z" }),
_('path', { d: "M16 12h3v1h-3v-1z" })
            );
        }
        function FlipVertical2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FlipVertical2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FlipVertical2.SVG = FlipVertical2SVG;
        return FlipVertical2;
    })();
export const FloorLamp = /*#__PURE__*/ (() => {
    function FloorLampSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18.969 8.756l-2-8c-0.109-0.444-0.509-0.756-0.969-0.756h-8c-0.459 0-0.859 0.312-0.969 0.756l-2 8c-0.075 0.3-0.006 0.616 0.181 0.859 0.191 0.244 0.481 0.384 0.787 0.384h5v10.5c0 1.541-1.531 2.5-4 2.5v1h10v-1c-2.469 0-4-0.959-4-2.5v-10.5h2v5.084c-0.581 0.206-1 0.762-1 1.416v2c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.653-0.419-1.209-1-1.416v-5.084h2c0.309 0 0.6-0.141 0.788-0.384 0.191-0.244 0.256-0.559 0.181-0.859zM13.281 23h-2.562c0.828-0.619 1.281-1.503 1.281-2.5 0 0.997 0.456 1.881 1.281 2.5zM16 18h-1v-1.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v1.5zM7.281 8l1.5-6h6.438l1.5 6h-9.438z" })
        );
    }
    function FloorLamp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FloorLampSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FloorLamp.SVG = FloorLampSVG;
    return FloorLamp;
})();
export const FloppyDisk = /*#__PURE__*/ (() => {
        function FloppyDiskSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21 1h-18c-1.103 0-2 0.897-2 2v15.584c0 0.534 0.209 1.034 0.588 1.413l2.416 2.416c0.378 0.378 0.881 0.588 1.413 0.588h15.584c1.103 0 2-0.897 2-2v-18c0-1.103-0.897-2-2-2zM6 2h12v8c0 0.55-0.45 1-1 1h-10c-0.55 0-1-0.45-1-1v-8zM17 22h-9v-6h9v6zM21 21h-3v-5.5c0-0.275-0.225-0.5-0.5-0.5h-10c-0.275 0-0.5 0.225-0.5 0.5v5.5h-1.584l-2.416-2.416v-15.584h2v7c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-7h2v18z" }),
_('path', { d: "M9.5 21h2c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-2c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5zM10 18h1v2h-1v-2z" })
            );
        }
        function FloppyDisk({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FloppyDiskSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FloppyDisk.SVG = FloppyDiskSVG;
        return FloppyDisk;
    })();
export const Flower = /*#__PURE__*/ (() => {
    function FlowerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24.006 12c0-1.784-1.175-3.3-2.791-3.813 0.294-0.562 0.45-1.194 0.45-1.847 0-1.069-0.416-2.072-1.172-2.828s-1.759-1.172-2.828-1.172c-0.653 0-1.281 0.156-1.847 0.45-0.513-1.616-2.028-2.791-3.813-2.791-1.788-0.003-3.303 1.172-3.819 2.791-1.506-0.781-3.412-0.541-4.675 0.722s-1.503 3.169-0.722 4.675c-1.616 0.513-2.791 2.028-2.791 3.813s1.175 3.3 2.794 3.816c-0.781 1.506-0.541 3.412 0.722 4.675s3.166 1.503 4.675 0.722c0.513 1.619 2.028 2.794 3.816 2.794 1.784 0 3.3-1.175 3.813-2.791 0.563 0.294 1.194 0.45 1.847 0.45 1.069 0 2.072-0.416 2.828-1.172s1.172-1.759 1.172-2.828c0-0.653-0.156-1.281-0.45-1.847 1.616-0.519 2.791-2.034 2.791-3.819zM15.834 5.247c0.019-0.012 0.041-0.028 0.056-0.038 0.097-0.066 0.231-0.156 0.356-0.281 0.781-0.781 2.050-0.781 2.828 0 0.781 0.781 0.781 2.050 0 2.828-0.125 0.125-0.209 0.25-0.278 0.353-0.012 0.019-0.031 0.044-0.044 0.063-0.197 0.162-0.316 0.391-0.35 0.634l-2.931 1.216c-0.356-0.622-0.872-1.141-1.494-1.494l1.216-2.928c0.247-0.034 0.475-0.156 0.641-0.353zM12 14c-1.103 0-2-0.897-2-2s0.897-2 2-2c1.103 0 2 0.897 2 2s-0.897 2-2 2zM9.95 4.45c0.022-0.116 0.053-0.275 0.053-0.453 0-1.103 0.897-2 2-2s2 0.897 2 2c0 0.178 0.031 0.334 0.053 0.45 0.003 0.022 0.009 0.050 0.012 0.072-0.022 0.253 0.053 0.5 0.2 0.697l-1.216 2.928c-0.337-0.094-0.691-0.141-1.056-0.141s-0.719 0.050-1.056 0.141l-1.209-2.925c0.15-0.197 0.228-0.444 0.206-0.7 0.003-0.022 0.009-0.047 0.012-0.069zM4.928 4.925c0.781-0.781 2.050-0.781 2.828 0 0.125 0.125 0.25 0.209 0.353 0.278 0.019 0.012 0.044 0.031 0.063 0.044 0.162 0.194 0.391 0.316 0.631 0.35l1.216 2.928c-0.622 0.356-1.141 0.872-1.494 1.494l-2.925-1.212c-0.031-0.244-0.153-0.475-0.35-0.637-0.012-0.019-0.028-0.038-0.037-0.056-0.066-0.097-0.156-0.231-0.281-0.356-0.781-0.781-0.781-2.050-0.003-2.831zM2 12c0-1.103 0.897-2 2-2 0.178 0 0.334-0.031 0.45-0.053 0.022-0.003 0.050-0.009 0.072-0.012 0.253 0.022 0.503-0.053 0.697-0.203l2.925 1.212c-0.094 0.337-0.141 0.691-0.141 1.056s0.050 0.719 0.141 1.056l-2.925 1.212c-0.194-0.15-0.441-0.225-0.697-0.203-0.022-0.003-0.047-0.009-0.069-0.012-0.116-0.022-0.275-0.053-0.453-0.053-1.103 0-2-0.897-2-2zM8.172 18.753c-0.019 0.012-0.038 0.028-0.056 0.037-0.097 0.066-0.231 0.156-0.356 0.281-0.781 0.781-2.050 0.781-2.828 0-0.781-0.781-0.781-2.050 0-2.828 0.125-0.125 0.209-0.25 0.278-0.353 0.012-0.019 0.031-0.044 0.044-0.063 0.197-0.162 0.316-0.394 0.35-0.638l2.925-1.212c0.356 0.622 0.872 1.141 1.494 1.494l-1.216 2.928c-0.244 0.038-0.472 0.159-0.634 0.353zM14.056 19.55c-0.022 0.116-0.053 0.275-0.053 0.453 0 1.103-0.897 2-2 2s-2-0.897-2-2c0-0.178-0.031-0.334-0.053-0.45-0.003-0.022-0.009-0.050-0.012-0.072 0.022-0.256-0.053-0.506-0.206-0.7l1.212-2.925c0.338 0.094 0.691 0.141 1.056 0.141s0.719-0.050 1.056-0.141l1.216 2.928c-0.147 0.194-0.225 0.441-0.203 0.694-0.003 0.025-0.009 0.050-0.012 0.072zM19.078 19.075c-0.781 0.781-2.050 0.781-2.828 0-0.125-0.125-0.25-0.209-0.353-0.278-0.019-0.012-0.044-0.031-0.063-0.044-0.166-0.197-0.394-0.319-0.638-0.35l-1.216-2.928c0.622-0.356 1.141-0.872 1.494-1.494l2.931 1.216c0.034 0.244 0.153 0.472 0.35 0.634 0.012 0.019 0.028 0.041 0.038 0.056 0.066 0.097 0.156 0.231 0.281 0.356 0.781 0.781 0.781 2.050 0.003 2.831zM20.006 14c-0.178 0-0.334 0.031-0.45 0.053-0.022 0.003-0.050 0.009-0.072 0.012-0.256-0.022-0.503 0.053-0.7 0.203l-2.928-1.216c0.094-0.338 0.141-0.691 0.141-1.056s-0.050-0.719-0.141-1.056l2.928-1.216c0.194 0.15 0.444 0.228 0.697 0.203 0.022 0.003 0.047 0.009 0.069 0.012 0.116 0.022 0.275 0.053 0.453 0.053 1.103 0 2 0.897 2 2 0.003 1.109-0.894 2.006-1.997 2.006z" })
        );
    }
    function Flower({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FlowerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Flower.SVG = FlowerSVG;
    return Flower;
})();
export const Flower2 = /*#__PURE__*/ (() => {
        function Flower2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 12c0-1.653-1.347-3-3-3s-3 1.347-3 3 1.347 3 3 3 3-1.347 3-3zM10 12c0-1.103 0.897-2 2-2s2 0.897 2 2c0 1.103-0.897 2-2 2s-2-0.897-2-2z" }),
_('path', { d: "M24 12c0-1.741-1.119-3.228-2.675-3.775 0.047-0.072 0.094-0.147 0.138-0.222 0.35-0.603 0.537-1.297 0.537-2.003 0-2.206-1.794-4-4-4-0.706 0-1.4 0.188-2.006 0.537-0.075 0.044-0.15 0.091-0.222 0.138-0.544-1.556-2.031-2.675-3.772-2.675s-3.228 1.119-3.775 2.675c-0.072-0.047-0.147-0.094-0.222-0.138-0.603-0.35-1.297-0.537-2.003-0.537-2.206 0-4 1.794-4 4 0 0.706 0.188 1.4 0.537 2.006 0.044 0.075 0.091 0.15 0.138 0.222-1.556 0.544-2.675 2.031-2.675 3.772s1.119 3.228 2.675 3.775c-0.047 0.072-0.094 0.147-0.138 0.222-0.35 0.603-0.537 1.297-0.537 2.003 0 2.206 1.794 4 4 4 0.706 0 1.4-0.188 2.006-0.537 0.075-0.044 0.15-0.091 0.222-0.138 0.547 1.556 2.031 2.675 3.775 2.675 1.741 0 3.228-1.119 3.775-2.675 0.072 0.047 0.147 0.094 0.222 0.138 0.6 0.35 1.294 0.537 2 0.537 2.206 0 4-1.794 4-4 0-0.706-0.188-1.397-0.541-2.006-0.044-0.075-0.091-0.147-0.138-0.219 1.559-0.547 2.678-2.034 2.678-3.775zM18 3c1.653 0 3 1.347 3 3 0 0.747-0.284 1.462-0.772 2.006-0.075-0.003-0.15-0.006-0.228-0.006-0.519 0-1.022 0.097-1.5 0.291l-2.334 0.944c-0.091-0.138-0.191-0.272-0.294-0.4l2.337-2.337-0.709-0.703-2.337 2.337c-0.128-0.106-0.263-0.203-0.4-0.294l0.944-2.334c0.194-0.478 0.291-0.984 0.291-1.5 0-0.075-0.003-0.153-0.006-0.228 0.547-0.491 1.263-0.775 2.009-0.775zM8 12c0-2.206 1.794-4 4-4s4 1.794 4 4c0 2.206-1.794 4-4 4s-4-1.794-4-4zM12 2c1.103 0 2 0.897 2 2 0 0.259-0.050 0.513-0.147 0.75l-0.944 2.334c-0.294-0.053-0.6-0.084-0.909-0.084s-0.616 0.028-0.909 0.084l-0.944-2.334c-0.097-0.237-0.147-0.491-0.147-0.75 0-1.103 0.897-2 2-2zM3 6c0-1.653 1.347-3 3-3 0.747 0 1.462 0.284 2.006 0.772-0.003 0.075-0.006 0.15-0.006 0.228 0 0.519 0.097 1.022 0.291 1.5l0.944 2.334c-0.138 0.091-0.272 0.191-0.4 0.294l-2.334-2.334-0.706 0.706 2.337 2.337c-0.106 0.128-0.203 0.263-0.294 0.4l-2.337-0.947c-0.478-0.194-0.984-0.291-1.5-0.291-0.075 0-0.153 0.003-0.228 0.006-0.488-0.544-0.772-1.259-0.772-2.006zM2 12c0-1.103 0.897-2 2-2 0.259 0 0.513 0.050 0.75 0.147l2.334 0.944c-0.053 0.294-0.084 0.6-0.084 0.909s0.028 0.616 0.084 0.909l-2.334 0.944c-0.237 0.097-0.491 0.147-0.75 0.147-1.103 0-2-0.897-2-2zM6 21c-1.653 0-3-1.347-3-3 0-0.747 0.284-1.462 0.772-2.006 0.075 0.003 0.15 0.006 0.228 0.006 0.519 0 1.022-0.097 1.5-0.291l2.334-0.944c0.091 0.138 0.191 0.272 0.294 0.4l-2.334 2.334 0.706 0.706 2.337-2.337c0.128 0.106 0.263 0.203 0.4 0.294l-0.947 2.337c-0.194 0.478-0.291 0.984-0.291 1.5 0 0.075 0.003 0.153 0.006 0.228-0.544 0.487-1.259 0.772-2.006 0.772zM12 22c-1.103 0-2-0.897-2-2 0-0.259 0.050-0.513 0.147-0.75l0.944-2.334c0.294 0.053 0.6 0.084 0.909 0.084s0.616-0.028 0.909-0.084l0.944 2.334c0.097 0.237 0.147 0.491 0.147 0.75 0 1.103-0.897 2-2 2zM21 18c0 1.653-1.347 3-3 3-0.747 0-1.462-0.284-2.006-0.772 0.003-0.075 0.006-0.15 0.006-0.228 0-0.519-0.097-1.022-0.291-1.5l-0.944-2.334c0.138-0.091 0.272-0.191 0.4-0.294l2.337 2.337 0.706-0.706-2.337-2.337c0.106-0.128 0.203-0.263 0.294-0.4l2.334 0.944c0.478 0.194 0.984 0.291 1.5 0.291 0.075 0 0.153-0.003 0.228-0.006 0.487 0.544 0.772 1.259 0.772 2.006zM20 14c-0.259 0-0.513-0.050-0.75-0.147l-2.334-0.944c0.053-0.294 0.084-0.6 0.084-0.909s-0.028-0.616-0.084-0.909l2.334-0.944c0.237-0.097 0.491-0.147 0.75-0.147 1.103 0 2 0.897 2 2s-0.897 2-2 2z" })
            );
        }
        function Flower2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Flower2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Flower2.SVG = Flower2SVG;
        return Flower2;
    })();
export const Flower3 = /*#__PURE__*/ (() => {
    function Flower3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 12c0-1.784-1.175-3.3-2.791-3.813 0.794-1.519 0.531-3.416-0.722-4.672-0.756-0.756-1.763-1.172-2.831-1.172-0.653 0-1.281 0.156-1.844 0.447-0.513-1.634-2.037-2.791-3.813-2.791-1.784 0-3.3 1.175-3.813 2.791-1.519-0.794-3.416-0.531-4.672 0.722-1.263 1.263-1.503 3.162-0.722 4.672-1.638 0.516-2.794 2.041-2.794 3.816 0 1.784 1.175 3.3 2.791 3.813-0.794 1.519-0.531 3.416 0.722 4.672 0.756 0.756 1.759 1.172 2.828 1.172 0.653 0 1.281-0.156 1.844-0.447 0.516 1.634 2.041 2.791 3.816 2.791 1.784 0 3.3-1.175 3.813-2.794 0.578 0.3 1.209 0.45 1.841 0.45 1.028 0 2.053-0.397 2.831-1.175 0.756-0.756 1.172-1.759 1.172-2.828 0-0.653-0.156-1.281-0.447-1.844 1.634-0.509 2.791-2.034 2.791-3.809zM19.778 4.222c1.019 1.019 1.163 2.603 0.378 3.781-0.053-0.003-0.103-0.003-0.156-0.003-1.547 0-3.219 0.462-4.981 1.378-0.462-0.534-1.066-0.944-1.75-1.172 0.431-1.322 1.137-2.859 2.266-3.984 0.569-0.566 1.322-0.878 2.122-0.878s1.556 0.312 2.122 0.878zM10 12c0-1.103 0.897-2 2-2s2 0.897 2 2c0 1.103-0.897 2-2 2s-2-0.897-2-2zM12 1c1.444 0 2.666 1.019 2.941 2.406-0.037 0.034-0.075 0.072-0.112 0.109-1.094 1.094-1.947 2.603-2.547 4.497-0.094-0.006-0.188-0.009-0.281-0.009-0.641 0-1.247 0.153-1.784 0.422-0.628-1.244-1.216-2.831-1.216-4.425 0-1.653 1.347-3 3-3zM4.222 4.222c1.019-1.019 2.603-1.162 3.781-0.378-0.003 0.053-0.003 0.103-0.003 0.156 0 1.544 0.462 3.219 1.378 4.981-0.534 0.462-0.944 1.066-1.172 1.75-1.322-0.431-2.859-1.137-3.984-2.266-1.169-1.172-1.169-3.075 0-4.244zM1 12c0-1.444 1.019-2.666 2.406-2.941 0.034 0.037 0.072 0.075 0.109 0.112 1.094 1.094 2.603 1.947 4.497 2.547-0.006 0.094-0.009 0.188-0.009 0.281 0 0.641 0.153 1.247 0.422 1.784-1.244 0.628-2.831 1.216-4.425 1.216-1.653 0-3-1.347-3-3zM4.222 19.778c-1.019-1.019-1.162-2.603-0.378-3.781 0.053 0.003 0.103 0.003 0.156 0.003 1.544 0 3.219-0.462 4.981-1.378 0.462 0.534 1.066 0.944 1.75 1.172-0.431 1.322-1.137 2.859-2.266 3.984-0.569 0.566-1.322 0.878-2.122 0.878-0.803 0-1.556-0.312-2.122-0.878zM12 23c-1.444 0-2.666-1.019-2.941-2.406 0.037-0.034 0.075-0.072 0.112-0.109 1.094-1.094 1.947-2.603 2.547-4.494 0.094 0.006 0.188 0.009 0.281 0.009 0.641 0 1.247-0.153 1.784-0.422 0.628 1.241 1.216 2.828 1.216 4.422 0 1.653-1.347 3-3 3zM19.778 19.778c-1.019 1.019-2.603 1.163-3.781 0.378 0.003-0.053 0.003-0.103 0.003-0.156 0-1.547-0.462-3.219-1.378-4.981 0.534-0.462 0.944-1.066 1.172-1.75 1.322 0.431 2.859 1.137 3.984 2.266 0.566 0.569 0.878 1.322 0.878 2.122s-0.312 1.556-0.878 2.122zM20.594 14.941c-0.034-0.037-0.072-0.075-0.109-0.112-1.094-1.094-2.603-1.947-4.494-2.547 0.006-0.094 0.009-0.188 0.009-0.281 0-0.641-0.153-1.247-0.422-1.784 1.241-0.628 2.828-1.216 4.422-1.216 1.653 0 3 1.347 3 3 0 1.444-1.019 2.666-2.406 2.941z" })
        );
    }
    function Flower3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Flower3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Flower3.SVG = Flower3SVG;
    return Flower3;
})();
export const FlyingSaucer = /*#__PURE__*/ (() => {
        function FlyingSaucerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.5 16c1.931 0 3.5-1.569 3.5-3.5s-1.569-3.5-3.5-3.5h-1.572c-0.213-1.491-0.897-2.866-1.981-3.95-1.319-1.322-3.078-2.050-4.947-2.050s-3.628 0.728-4.95 2.050c-1.084 1.084-1.769 2.459-1.981 3.95h-1.569c-1.931 0-3.5 1.569-3.5 3.5s1.569 3.5 3.5 3.5h1.672l-1.441 2.019c-0.075-0.012-0.153-0.019-0.231-0.019-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5c0-0.384-0.147-0.734-0.384-1.003l1.784-2.497h11.2l1.784 2.497c-0.237 0.266-0.384 0.616-0.384 1.003 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5c-0.078 0-0.156 0.006-0.231 0.019l-1.441-2.019h1.672zM3.5 20c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5zM21 19.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5zM12 4c2.969 0 5.441 2.166 5.916 5h-0.984c-0.466-2.297-2.5-4.031-4.931-4.031v1c1.878 0 3.462 1.291 3.906 3.031h-9.822c0.475-2.834 2.947-5 5.916-5zM2 12.5c0-0.828 0.672-1.5 1.5-1.5h17c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5h-17c-0.828 0-1.5-0.672-1.5-1.5z" }),
_('path', { d: "M5 12.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M20 12.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M15 12.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M10 12.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function FlyingSaucer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FlyingSaucerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FlyingSaucer.SVG = FlyingSaucerSVG;
        return FlyingSaucer;
    })();
export const FlyingSaucer2 = /*#__PURE__*/ (() => {
        function FlyingSaucer2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.769 6.828c-0.144-0.041-0.288-0.078-0.434-0.116-0.344-0.675-0.813-1.294-1.397-1.831-1.319-1.212-3.072-1.881-4.938-1.881-2.784 0-5.194 1.516-6.322 3.709-0.15 0.038-0.297 0.078-0.441 0.119-3.378 0.944-5.238 2.603-5.238 4.672 0 0.912 0.384 1.837 1.106 2.678 0.644 0.747 1.538 1.419 2.656 1.997 0.459 0.237 0.944 0.453 1.45 0.647l-1.991 3.178h-1.222v1h4v-1h-1.597l1.778-2.847c1.781 0.553 3.775 0.847 5.819 0.847s4.041-0.294 5.819-0.847l1.778 2.847h-1.597v1h4v-1h-1.222l-1.987-3.181c0.506-0.194 0.991-0.409 1.45-0.647 1.119-0.578 2.013-1.25 2.656-1.997 0.725-0.841 1.106-1.766 1.106-2.678-0.003-2.066-1.863-3.725-5.234-4.669zM12 4c3.263 0 5.922 2.397 5.997 5.372-0.294 0.478-1.856 2.628-5.997 2.628-1.909 0-3.563-0.472-4.778-1.366-0.716-0.525-1.091-1.056-1.222-1.266 0.078-2.972 2.741-5.369 6-5.369zM19.319 14.397c-1.969 1.019-4.638 1.603-7.319 1.603s-5.35-0.584-7.319-1.603c-1.653-0.856-2.681-1.966-2.681-2.897 0-0.941 1.116-1.856 3.022-2.516-0.016 0.169-0.022 0.341-0.022 0.516 0 0.078 0.019 0.153 0.053 0.225 0.019 0.034 0.441 0.866 1.522 1.675 0.972 0.731 2.703 1.6 5.425 1.6s4.453-0.869 5.425-1.6c1.081-0.813 1.506-1.641 1.522-1.675 0.034-0.069 0.053-0.147 0.053-0.225 0-0.172-0.006-0.344-0.022-0.516 1.906 0.656 3.022 1.575 3.022 2.516 0 0.931-1.028 2.041-2.681 2.897z" }),
_('path', { d: "M15.959 9.003l0.987-0.156c-0.15-0.95-0.625-1.812-1.369-2.497-0.947-0.872-2.219-1.35-3.581-1.35v1c1.109 0 2.141 0.387 2.903 1.087 0.578 0.528 0.944 1.194 1.059 1.916z" })
            );
        }
        function FlyingSaucer2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FlyingSaucer2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FlyingSaucer2.SVG = FlyingSaucer2SVG;
        return FlyingSaucer2;
    })();
export const FocalPoint = /*#__PURE__*/ (() => {
        function FocalPointSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 2v6h2v-6h6v-2h-6c-1.103 0-2 0.897-2 2z" }),
_('path', { d: "M22 0h-6v2h6v6h2v-6c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M22 22h-6v2h6c1.103 0 2-0.897 2-2v-6h-2v6z" }),
_('path', { d: "M2 16h-2v6c0 1.103 0.897 2 2 2h6v-2h-6v-6z" }),
_('path', { d: "M13.5 10h-3c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5zM13 13h-2v-2h2v2z" })
            );
        }
        function FocalPoint({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FocalPointSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FocalPoint.SVG = FocalPointSVG;
        return FocalPoint;
    })();
export const Fold = /*#__PURE__*/ (() => {
        function FoldSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-4v-3c0-0.356-0.191-0.687-0.497-0.866-0.309-0.178-0.687-0.181-0.997-0.003l-7 4c-0.312 0.178-0.503 0.509-0.503 0.869v18c0 0.356 0.191 0.687 0.497 0.866 0.156 0.091 0.328 0.134 0.503 0.134h12c1.103 0 2-0.897 2-2v-16c-0.003-1.103-0.9-2-2.003-2zM11 5.581l5-2.856v15.697l-5 2.856v-15.697zM22 22h-8.234l3.731-2.131c0.312-0.178 0.503-0.509 0.503-0.869v-13h4v16z" }),
_('path', { d: "M6 4h2v1h-2v-1z" }),
_('path', { d: "M3 4h2v1h-2v-1z" }),
_('path', { d: "M0 6h1c0-0.55 0.45-1 1-1v-1c-1.103 0-2 0.897-2 2z" }),
_('path', { d: "M1 22h-1c0 1.103 0.897 2 2 2v-1c-0.55 0-1-0.45-1-1z" }),
_('path', { d: "M6 23h2v1h-2v-1z" }),
_('path', { d: "M3 23h2v1h-2v-1z" }),
_('path', { d: "M0 19h1v2h-1v-2z" }),
_('path', { d: "M0 16h1v2h-1v-2z" }),
_('path', { d: "M0 13h1v2h-1v-2z" }),
_('path', { d: "M0 10h1v2h-1v-2z" }),
_('path', { d: "M0 7h1v2h-1v-2z" }),
_('path', { d: "M6.5 12.206l1.353-1.353c0.194-0.194 0.194-0.513 0-0.706l-1.353-1.353-0.706 0.706 0.506 0.506c-1.838 0.103-3.3 1.631-3.3 3.494v0.5h1v-0.5c0-1.306 1.006-2.381 2.284-2.491l-0.491 0.491 0.706 0.706z" })
            );
        }
        function Fold({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FoldSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Fold.SVG = FoldSVG;
        return Fold;
    })();
export const FolderCamera = /*#__PURE__*/ (() => {
        function FolderCameraSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.444-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0.003 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.444 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M16.5 11h-0.794l-0.853-0.853c-0.094-0.094-0.222-0.147-0.353-0.147h-4c-0.131 0-0.259 0.053-0.353 0.147l-0.853 0.853h-0.794c-0.828 0-1.5 0.672-1.5 1.5v4c0 0.828 0.672 1.5 1.5 1.5h8c0.828 0 1.5-0.672 1.5-1.5v-4c0-0.828-0.672-1.5-1.5-1.5zM17 16.5c0 0.275-0.225 0.5-0.5 0.5h-8c-0.275 0-0.5-0.225-0.5-0.5v-4c0-0.275 0.225-0.5 0.5-0.5h1c0.131 0 0.259-0.053 0.353-0.147l0.853-0.853h3.584l0.853 0.853c0.094 0.094 0.222 0.147 0.353 0.147h1c0.275 0 0.5 0.225 0.5 0.5v4z" }),
_('path', { d: "M15 14.5c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5 1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5zM12.5 16c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5z" })
            );
        }
        function FolderCamera({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderCameraSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderCamera.SVG = FolderCameraSVG;
        return FolderCamera;
    })();
export const FolderCode = /*#__PURE__*/ (() => {
        function FolderCodeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.444-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0.003 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.444 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M8.5 11.794l-2.353 2.353c-0.194 0.194-0.194 0.513 0 0.706l2.353 2.353 0.706-0.706-2-2 2-2-0.706-0.706z" }),
_('path', { d: "M15.5 11.794l-0.706 0.706 2 2-2 2 0.706 0.706 2.353-2.353c0.194-0.194 0.194-0.513 0-0.706l-2.353-2.353z" }),
_('path', { d: "M9.842 17.764l3.394-7.919 0.919 0.394-3.394 7.919-0.919-0.394z" })
            );
        }
        function FolderCode({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderCodeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderCode.SVG = FolderCodeSVG;
        return FolderCode;
    })();
export const FolderDownload = /*#__PURE__*/ (() => {
        function FolderDownloadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.444-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0.003 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.444 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M13 16.294v-5.294h-1v5.294l-1.5-1.5-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l2.353-2.353-0.706-0.706-1.5 1.5z" })
            );
        }
        function FolderDownload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderDownloadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderDownload.SVG = FolderDownloadSVG;
        return FolderDownload;
    })();
export const FolderFilm = /*#__PURE__*/ (() => {
        function FolderFilmSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.444-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0.003 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.444 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M17.5 11h-11c-0.275 0-0.5 0.225-0.5 0.5v6c0 0.275 0.225 0.5 0.5 0.5h11c0.275 0 0.5-0.225 0.5-0.5v-6c0-0.275-0.225-0.5-0.5-0.5zM17 13h-1v-1h1v1zM8 15h-1v-1h1v1zM9 12h6v5h-6v-5zM16 14h1v1h-1v-1zM8 12v1h-1v-1h1zM7 16h1v1h-1v-1zM16 17v-1h1v1h-1z" })
            );
        }
        function FolderFilm({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderFilmSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderFilm.SVG = FolderFilmSVG;
        return FolderFilm;
    })();
export const FolderHeart = /*#__PURE__*/ (() => {
        function FolderHeartSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.444-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0.003 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.444 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M14.5 10c-0.816 0-1.544 0.394-2 1.003-0.456-0.606-1.184-1.003-2-1.003-1.378 0-2.5 1.122-2.5 2.5 0 1.181 0.725 2.459 2.159 3.803 1.025 0.959 2.034 1.594 2.078 1.622 0.081 0.050 0.172 0.075 0.266 0.075s0.184-0.025 0.266-0.075c0.044-0.028 1.053-0.663 2.078-1.622 1.431-1.344 2.159-2.622 2.159-3.803-0.006-1.378-1.128-2.5-2.506-2.5zM12.5 16.903c-1.178-0.8-3.5-2.722-3.5-4.403 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5v0.5h1v-0.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 1.681-2.322 3.603-3.5 4.403z" })
            );
        }
        function FolderHeart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderHeartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderHeart.SVG = FolderHeartSVG;
        return FolderHeart;
    })();
export const FolderHistory = /*#__PURE__*/ (() => {
        function FolderHistorySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.444-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0.003 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.444 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M10 14v1h2c0.156 0 0.306-0.075 0.4-0.2l1.8-2.4-0.8-0.6-1.65 2.2h-1.75z" }),
_('path', { d: "M12 9c-2.756 0-5 2.244-5 5s2.244 5 5 5h0.5c0.203 0 0.384-0.122 0.462-0.309s0.034-0.403-0.109-0.544l-1.353-1.353-0.706 0.706 0.422 0.422c-1.831-0.366-3.216-1.984-3.216-3.922 0-2.206 1.794-4 4-4s4 1.794 4 4v1h1v-1c0-2.756-2.244-5-5-5z" })
            );
        }
        function FolderHistory({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderHistorySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderHistory.SVG = FolderHistorySVG;
        return FolderHistory;
    })();
export const FolderHome = /*#__PURE__*/ (() => {
        function FolderHomeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.444-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0.003 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.444 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M12.853 9.147c-0.194-0.194-0.513-0.194-0.706 0l-4 4c-0.094 0.094-0.147 0.222-0.147 0.353v5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-2.5h1v2.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.131-0.053-0.259-0.147-0.353l-4-4zM16 18h-2v-2.5c0-0.275-0.225-0.5-0.5-0.5h-2c-0.275 0-0.5 0.225-0.5 0.5v2.5h-2v-4.294l3.5-3.5 3.5 3.5v4.294z" })
            );
        }
        function FolderHome({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderHomeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderHome.SVG = FolderHomeSVG;
        return FolderHome;
    })();
export const FolderLock = /*#__PURE__*/ (() => {
        function FolderLockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.444-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0.003 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.444 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M15.5 14h-0.5v-1c0-1.653-1.347-3-3-3s-3 1.347-3 3v1h-0.5c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5h7c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5zM10 13c0-1.103 0.897-2 2-2s2 0.897 2 2v1h-4v-1zM15 18h-6v-3h6v3z" })
            );
        }
        function FolderLock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderLockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderLock.SVG = FolderLockSVG;
        return FolderLock;
    })();
export const FolderMinus = /*#__PURE__*/ (() => {
        function FolderMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.444-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0.003 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.444 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M9 14h7v1h-7v-1z" })
            );
        }
        function FolderMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderMinus.SVG = FolderMinusSVG;
        return FolderMinus;
    })();
export const FolderMusic = /*#__PURE__*/ (() => {
        function FolderMusicSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 10h-1v5.131c-0.353-0.125-0.762-0.166-1.191-0.103-1.109 0.156-1.903 0.922-1.803 1.747 0.041 0.328 0.213 0.616 0.5 0.837 0.334 0.256 0.803 0.397 1.303 0.397 0.125 0 0.253-0.009 0.381-0.028 1.047-0.147 1.812-0.837 1.809-1.606h0.003v-4.141c0.531 0.475 1.231 0.766 2 0.766v-1c-1.106 0-2.003-0.897-2.003-2zM11.050 16.991c-0.366 0.050-0.731-0.016-0.934-0.172-0.050-0.038-0.109-0.097-0.116-0.166-0.025-0.197 0.341-0.55 0.947-0.634 0.087-0.012 0.172-0.019 0.253-0.019 0.319 0 0.553 0.091 0.681 0.188 0.072 0.053 0.109 0.109 0.116 0.166v0c0.025 0.197-0.341 0.55-0.947 0.638z" }),
_('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.441-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.441 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" })
            );
        }
        function FolderMusic({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderMusicSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderMusic.SVG = FolderMusicSVG;
        return FolderMusic;
    })();
export const FolderMusic2 = /*#__PURE__*/ (() => {
        function FolderMusic2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.441-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.441 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M15.597 11.009l-5-1c-0.147-0.028-0.3 0.009-0.416 0.103s-0.184 0.237-0.184 0.387v3.544c-0.216-0.056-0.447-0.066-0.678-0.019-0.8 0.162-1.378 0.919-1.313 1.719 0.031 0.4 0.222 0.747 0.531 0.978 0.237 0.178 0.531 0.272 0.837 0.272 0.1 0 0.203-0.009 0.303-0.031 0.759-0.156 1.316-0.841 1.319-1.594v0-4.259l4 0.8v3.134c-0.216-0.056-0.447-0.066-0.678-0.019-0.8 0.162-1.378 0.919-1.313 1.719 0.031 0.4 0.222 0.747 0.531 0.978 0.237 0.178 0.531 0.272 0.837 0.272 0.1 0 0.203-0.009 0.303-0.031 0.759-0.156 1.316-0.841 1.319-1.594v0-4.869c0.003-0.237-0.166-0.444-0.4-0.491zM9.481 15.984c-0.131 0.028-0.253 0.006-0.341-0.063-0.078-0.059-0.125-0.15-0.134-0.259-0.022-0.288 0.219-0.597 0.519-0.656 0.038-0.006 0.072-0.012 0.106-0.012 0.091 0 0.172 0.025 0.234 0.072 0.078 0.059 0.125 0.15 0.134 0.259 0.022 0.291-0.219 0.6-0.519 0.659zM14.481 16.984c-0.131 0.028-0.253 0.006-0.341-0.063-0.078-0.059-0.125-0.15-0.134-0.259-0.022-0.288 0.219-0.597 0.519-0.656 0.037-0.006 0.072-0.012 0.106-0.012 0.091 0 0.172 0.025 0.234 0.072 0.078 0.059 0.125 0.15 0.134 0.259 0.022 0.291-0.219 0.6-0.519 0.659z" })
            );
        }
        function FolderMusic2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderMusic2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderMusic2.SVG = FolderMusic2SVG;
        return FolderMusic2;
    })();
export const FolderPicture = /*#__PURE__*/ (() => {
        function FolderPictureSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.444-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0.003 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.444 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M17.5 9h-11c-0.275 0-0.5 0.225-0.5 0.5v9c0 0.275 0.225 0.5 0.5 0.5h11c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.225-0.5-0.5-0.5zM7 10h10v5.169l-0.584-0.584c-0.781-0.778-2.050-0.778-2.828 0l-3.416 3.416h-3.172v-8zM11.584 18l2.709-2.709c0.387-0.387 1.025-0.387 1.416 0l1.291 1.291v1.419h-5.416z" }),
_('path', { d: "M11 12.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5zM9 12.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5z" })
            );
        }
        function FolderPicture({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderPictureSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderPicture.SVG = FolderPictureSVG;
        return FolderPicture;
    })();
export const FolderPlus = /*#__PURE__*/ (() => {
        function FolderPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.444-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0.003 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.444 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M13 11h-1v3h-3v1h3v3h1v-3h3v-1h-3z" })
            );
        }
        function FolderPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderPlus.SVG = FolderPlusSVG;
        return FolderPlus;
    })();
export const FolderSearch = /*#__PURE__*/ (() => {
        function FolderSearchSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.444-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0.003 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.444 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M14 13c0-1.653-1.347-3-3-3s-3 1.347-3 3 1.347 3 3 3c0.647 0 1.247-0.206 1.737-0.556l2.763 2.763 0.706-0.706-2.763-2.763c0.35-0.491 0.556-1.091 0.556-1.737zM9 13c0-1.103 0.897-2 2-2s2 0.897 2 2c0 1.103-0.897 2-2 2s-2-0.897-2-2z" })
            );
        }
        function FolderSearch({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderSearchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderSearch.SVG = FolderSearchSVG;
        return FolderSearch;
    })();
export const FolderShare = /*#__PURE__*/ (() => {
        function FolderShareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.441-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.441 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M14 14c0-1.103-0.897-2-2-2s-2 0.897-2 2 0.897 2 2 2c1.103 0 2-0.897 2-2zM11 14c0-0.55 0.45-1 1-1s1 0.45 1 1-0.45 1-1 1c-0.55 0-1-0.45-1-1z" }),
_('path', { d: "M12 10c-1.053 0-2.050 0.356-2.8 1-0.634 0.544-1.038 1.244-1.159 2h-3.041v1h3.5c0.275 0 0.5-0.225 0.5-0.5 0-1.378 1.347-2.5 3-2.5v-1z" }),
_('path', { d: "M15 14.5c0 1.378-1.347 2.5-3 2.5v1c1.053 0 2.050-0.356 2.8-1 0.634-0.544 1.038-1.244 1.159-2h3.041v-1h-3.5c-0.275 0-0.5 0.225-0.5 0.5z" })
            );
        }
        function FolderShare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderShareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderShare.SVG = FolderShareSVG;
        return FolderShare;
    })();
export const FolderStar = /*#__PURE__*/ (() => {
        function FolderStarSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.444-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0.003 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.444 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M16.5 12h-2.663l-0.875-2.184c-0.075-0.191-0.259-0.316-0.466-0.316s-0.387 0.125-0.466 0.316l-0.875 2.184h-2.656c-0.219 0-0.412 0.141-0.478 0.35s0.012 0.434 0.191 0.559l2.203 1.541-0.894 2.903c-0.066 0.209 0.016 0.438 0.197 0.559s0.422 0.116 0.594-0.022l2.187-1.75 2.187 1.75c0.091 0.072 0.2 0.109 0.312 0.109 0.097 0 0.197-0.028 0.281-0.087 0.181-0.122 0.263-0.35 0.197-0.559l-0.894-2.903 2.203-1.541c0.178-0.125 0.256-0.353 0.191-0.559-0.066-0.209-0.259-0.35-0.478-0.35zM13.713 13.841c-0.178 0.125-0.256 0.35-0.191 0.556l0.522 1.697-1.231-0.984c-0.091-0.072-0.203-0.109-0.312-0.109s-0.222 0.037-0.312 0.109l-1.231 0.984 0.522-1.697c0.063-0.206-0.012-0.431-0.191-0.556l-1.2-0.841h1.413c0.203 0 0.387-0.125 0.466-0.316l0.534-1.341 0.534 1.341c0.075 0.191 0.259 0.316 0.466 0.316h1.413l-1.2 0.841z" })
            );
        }
        function FolderStar({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderStarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderStar.SVG = FolderStarSVG;
        return FolderStar;
    })();
export const FolderUpload = /*#__PURE__*/ (() => {
        function FolderUploadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.441-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.441 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M12.147 11.147l-2.353 2.353 0.706 0.706 1.5-1.5v5.294h1v-5.294l1.5 1.5 0.706-0.706-2.353-2.353c-0.194-0.197-0.513-0.197-0.706 0z" })
            );
        }
        function FolderUpload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderUploadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderUpload.SVG = FolderUploadSVG;
        return FolderUpload;
    })();
export const FolderUser = /*#__PURE__*/ (() => {
        function FolderUserSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.441-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.441 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M14.322 15.578c-0.147-0.087-0.3-0.162-0.456-0.231 0.691-0.55 1.134-1.397 1.134-2.347 0-1.653-1.347-3-3-3s-3 1.347-3 3c0 0.95 0.444 1.797 1.134 2.347-0.156 0.066-0.309 0.144-0.456 0.231-0.631 0.372-1.156 0.916-1.606 1.666-0.141 0.231-0.069 0.534 0.159 0.681 1.144 0.722 2.378 1.075 3.769 1.075s2.625-0.353 3.769-1.078c0.228-0.147 0.3-0.447 0.159-0.681-0.45-0.747-0.975-1.291-1.606-1.662zM10 13c0-1.103 0.897-2 2-2s2 0.897 2 2c0 1.103-0.897 2-2 2s-2-0.897-2-2zM12 18c-1.019 0-1.934-0.219-2.787-0.666 0.691-0.919 1.569-1.334 2.787-1.334s2.097 0.416 2.787 1.334c-0.853 0.447-1.769 0.666-2.787 0.666z" })
            );
        }
        function FolderUser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderUserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderUser.SVG = FolderUserSVG;
        return FolderUser;
    })();
export const FolderVideo = /*#__PURE__*/ (() => {
        function FolderVideoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.444-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0.003 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.444 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" }),
_('path', { d: "M17.5 11h-7c-0.275 0-0.5 0.225-0.5 0.5v1.191l-3.275-1.638c-0.156-0.078-0.341-0.069-0.488 0.022s-0.237 0.253-0.237 0.425v5c0 0.172 0.091 0.334 0.237 0.425 0.081 0.050 0.172 0.075 0.262 0.075 0.075 0 0.153-0.019 0.225-0.053l3.275-1.638v1.191c0 0.275 0.225 0.5 0.5 0.5h7c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5zM7 15.691v-3.381l3 1.5v0.381l-3 1.5zM17 16h-6v-4h6v4z" })
            );
        }
        function FolderVideo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderVideoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderVideo.SVG = FolderVideoSVG;
        return FolderVideo;
    })();
export const FolderZip = /*#__PURE__*/ (() => {
    function FolderZipSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.444-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h5v1h-1v1h1v1h-1v1h1v1h-1v1h1v1.084c-0.581 0.206-1 0.762-1 1.416v2c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.653-0.419-1.209-1-1.416v-0.084h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h9c1.103 0 2 0.897 2 2v10c0.003 0 0 0 0 0zM10 16.5v1.5h-1v-1.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.444 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" })
        );
    }
    function FolderZip({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderZipSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderZip.SVG = FolderZipSVG;
    return FolderZip;
})();
export const Folder = /*#__PURE__*/ (() => {
    function FolderSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 4h-9.294l-1.706-1.706c-0.188-0.188-0.441-0.294-0.706-0.294h-8.294c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 20h-20v-10c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10c0 0 0 0 0 0zM20 6h-16c-1.194 0-2.266 0.525-3 1.356v-3.356c0-0.55 0.45-1 1-1h8.294l1.706 1.706c0.188 0.188 0.441 0.294 0.706 0.294h9.294c0.55 0 1 0.45 1 1v1.356c-0.734-0.831-1.806-1.356-3-1.356z" })
        );
    }
    function Folder({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Folder.SVG = FolderSVG;
    return Folder;
})();
export const Football = /*#__PURE__*/ (() => {
        function FootballSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.913 4.369c-0.119-0.975-0.425-2.3-1.203-3.078s-2.103-1.084-3.078-1.203c-1.313-0.159-2.841-0.1-4.416 0.175-2.216 0.387-6.45 1.553-9.925 5.028s-4.641 7.709-5.028 9.925c-0.275 1.578-0.338 3.103-0.175 4.416 0.119 0.975 0.425 2.3 1.203 3.078s2.103 1.084 3.078 1.203c0.478 0.059 0.984 0.087 1.512 0.087 0.919 0 1.903-0.087 2.903-0.262 2.216-0.387 6.447-1.553 9.922-5.028 3.478-3.475 4.644-7.709 5.031-9.925 0.275-1.575 0.334-3.103 0.175-4.416zM18.122 1.997c1.684 0 2.813 0.347 3.175 0.706v0c0.475 0.475 0.925 2.284 0.591 4.944-0.766-1.078-1.616-2.084-2.531-3.003-0.919-0.919-1.922-1.766-3.003-2.531 0.641-0.078 1.231-0.116 1.769-0.116zM5.878 22.003c-1.684 0-2.813-0.347-3.175-0.706-0.475-0.475-0.922-2.284-0.591-4.944 0.766 1.078 1.616 2.084 2.531 3.003 0.919 0.919 1.922 1.766 3.003 2.531-0.641 0.078-1.231 0.116-1.769 0.116zM17.294 17.294c-2.784 2.784-6.138 3.903-8.222 4.35-2.709-1.753-4.962-4.006-6.716-6.716 0.447-2.084 1.566-5.438 4.35-8.222s6.138-3.903 8.222-4.35c2.709 1.753 4.962 4.006 6.716 6.716-0.447 2.084-1.566 5.438-4.35 8.222z" }),
_('path', { d: "M16.5 6.794l-1.5 1.5-1.5-1.5-0.706 0.706 1.5 1.5-1.294 1.294-1.5-1.5-0.706 0.706 1.5 1.5-1.294 1.294-1.5-1.5-0.706 0.706 1.5 1.5-1.294 1.294-1.5-1.5-0.706 0.706 1.5 1.5-1.5 1.5 0.706 0.706 1.5-1.5 1.5 1.5 0.706-0.706-1.5-1.5 1.294-1.294 1.5 1.5 0.706-0.706-1.5-1.5 1.294-1.294 1.5 1.5 0.706-0.706-1.5-1.5 1.294-1.294 1.5 1.5 0.706-0.706-1.5-1.5 1.5-1.5z" })
            );
        }
        function Football({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FootballSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Football.SVG = FootballSVG;
        return Football;
    })();
export const Footprint = /*#__PURE__*/ (() => {
        function FootprintSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.994 18.206c-0.050-0.941-0.409-2.306-1.856-3.484-1.263-1.025-1.681-2.394-2.163-3.978l-0.012-0.038c-0.178-0.588-0.725-2.378-1.834-3.909-0.6-0.828-1.287-1.481-2.047-1.947-0.928-0.566-1.962-0.853-3.078-0.853-1.962 0-3.975 0.822-5.663 2.316-1.166 1.031-2.341 2.569-2.341 3.687 0 0.631 0 1.809 1.122 2.716 1.087 0.878 2.956 1.284 5.878 1.284 2.166 0 2.484 1.287 2.897 3.753 0.197 1.181 0.403 2.4 1 3.391 0.747 1.231 1.959 1.856 3.609 1.856v0c0.197 0 1.953-0.038 3.206-1.294 0.672-0.672 1.362-1.944 1.281-3.5zM21.3 20.294c-0.672 0.672-1.75 0.706-1.8 0.706-1.853-0.003-2.194-0.984-2.628-3.578-0.203-1.219-0.416-2.481-1.053-3.509-0.787-1.269-2.069-1.913-3.816-1.913-2.959 0-4.147-0.459-4.625-0.844-0.356-0.288-0.378-0.591-0.378-1.141 0.041-0.269 0.597-1.287 1.759-2.284 0.753-0.647 2.309-1.731 4.244-1.731 2.275 0 3.975 1.781 5.047 5.291l0.012 0.038c0.506 1.659 1.081 3.537 2.816 4.947 0.703 0.572 1.081 1.256 1.122 2.034 0.041 0.841-0.334 1.619-0.7 1.984z" }),
_('path', { d: "M4.975 6.712c-0.091-0.634-0.419-1.263-0.922-1.766s-1.131-0.831-1.766-0.922c-0.687-0.097-1.306 0.087-1.741 0.522s-0.619 1.053-0.522 1.741c0.091 0.634 0.419 1.263 0.922 1.766s1.131 0.831 1.766 0.922c0.122 0.019 0.241 0.025 0.356 0.025 0.544 0 1.028-0.188 1.387-0.547 0.431-0.434 0.616-1.053 0.519-1.741zM3.747 7.747v0c-0.206 0.206-0.525 0.291-0.894 0.237-0.422-0.059-0.85-0.288-1.2-0.638s-0.578-0.778-0.637-1.2c-0.053-0.369 0.031-0.687 0.237-0.894 0.166-0.166 0.406-0.253 0.684-0.253 0.069 0 0.138 0.006 0.209 0.016 0.422 0.059 0.85 0.288 1.2 0.637s0.578 0.778 0.637 1.2c0.053 0.369-0.031 0.687-0.237 0.894z" }),
_('path', { d: "M4.547 5.453c0.291 0.291 0.653 0.478 1.025 0.531 0.069 0.009 0.141 0.016 0.209 0.016 0.337 0 0.65-0.122 0.875-0.347v0c0.253-0.253 0.375-0.612 0.341-1 0.106 0.037 0.216 0.066 0.325 0.081 0.069 0.009 0.141 0.016 0.209 0.016 0.338 0 0.65-0.122 0.875-0.347v0c0.162-0.162 0.272-0.372 0.319-0.606 0.247 0.131 0.513 0.203 0.772 0.203 0.203 0 0.406-0.044 0.588-0.134v0c0.303-0.153 0.519-0.416 0.616-0.747 0.006 0.006 0.012 0.012 0.019 0.019v0c0.294 0.275 0.669 0.428 1.038 0.428 0.028 0 0.059 0 0.087-0.003 0.347-0.022 0.659-0.181 0.872-0.447 0.466-0.572 0.359-1.463-0.244-2.028-0.319-0.297-0.728-0.453-1.128-0.425-0.344 0.022-0.656 0.181-0.869 0.447-0.109 0.134-0.188 0.284-0.234 0.447-0.503-0.519-1.25-0.706-1.825-0.419-0.309 0.156-0.531 0.428-0.622 0.769-0.006 0.022-0.012 0.044-0.016 0.069-0.191-0.106-0.394-0.178-0.6-0.206-0.419-0.059-0.813 0.063-1.084 0.331-0.253 0.253-0.375 0.612-0.341 1-0.106-0.038-0.216-0.066-0.325-0.081-0.419-0.059-0.813 0.063-1.084 0.331-0.269 0.269-0.391 0.666-0.331 1.081 0.056 0.369 0.244 0.731 0.534 1.022zM11.25 1.737c0.041-0.050 0.094-0.075 0.166-0.078 0.006 0 0.016 0 0.022 0 0.116 0 0.247 0.059 0.353 0.159 0.231 0.219 0.266 0.528 0.153 0.669-0.041 0.050-0.094 0.075-0.166 0.078-0.122 0.009-0.263-0.050-0.375-0.156v0c-0.234-0.222-0.269-0.528-0.153-0.672zM8.763 2.163c0.022-0.084 0.069-0.116 0.103-0.131 0.041-0.019 0.087-0.031 0.141-0.031 0.194 0 0.456 0.134 0.622 0.381 0.106 0.156 0.147 0.328 0.113 0.459-0.022 0.084-0.069 0.116-0.103 0.131-0.188 0.094-0.553-0.034-0.762-0.35-0.106-0.159-0.147-0.331-0.113-0.459zM6.803 2.803c0.034-0.034 0.094-0.053 0.169-0.053 0.144 0 0.344 0.072 0.525 0.253 0.272 0.272 0.3 0.594 0.2 0.694s-0.422 0.072-0.694-0.2c-0.272-0.272-0.3-0.594-0.2-0.694zM5.053 4.053c0.034-0.034 0.094-0.053 0.169-0.053 0.144 0 0.344 0.072 0.525 0.253 0.272 0.272 0.3 0.594 0.2 0.694s-0.422 0.072-0.694-0.2c-0.272-0.272-0.3-0.594-0.2-0.694z" })
            );
        }
        function Footprint({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FootprintSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Footprint.SVG = FootprintSVG;
        return Footprint;
    })();
export const ForkKnife = /*#__PURE__*/ (() => {
    function ForkKnifeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17.194 14.691c-1.234-0.931-2.494-1.884-3.722-2.903 0.406-0.472 0.819-0.928 1.241-1.372l1.434 1.434c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l5-5c2.463-2.463 2.819-4.841 1.003-6.703-0.094-0.097-0.222-0.15-0.356-0.15-0.134-0.003-0.262 0.053-0.356 0.147l-8.381 8.388c-0.622 0.622-1.272 1.228-1.944 1.825-0.306-0.281-0.609-0.569-0.909-0.863 0.053-0.172 0.091-0.372 0.094-0.603 0.009-1.050-0.712-2.309-2.147-3.744 0 0 0 0 0 0v0l-4.356-4.353-0.706 0.706 4.353 4.353c0.219 0.219 0.219 0.575 0 0.794-0.106 0.106-0.247 0.166-0.397 0.166s-0.291-0.059-0.397-0.166l-4.853-4.853-0.706 0.706 4.853 4.853c0.106 0.106 0.166 0.247 0.166 0.397s-0.059 0.291-0.166 0.397c-0.219 0.219-0.575 0.219-0.794 0v0l-4.353-4.353-0.706 0.706 4.353 4.353c0 0 0 0 0 0 1.425 1.425 2.678 2.147 3.725 2.147 0.006 0 0.012 0 0.022 0 0.228-0.003 0.428-0.038 0.603-0.094 0.259 0.262 0.509 0.528 0.759 0.797-1.069 0.897-2.163 1.772-3.241 2.634-2.287 1.831-4.447 3.556-6.281 5.394-0.972 0.972-0.972 2.556 0 3.537 0.487 0.488 1.125 0.728 1.766 0.728s1.281-0.244 1.769-0.731c1.847-1.847 3.506-4.078 5.262-6.441 0.787-1.056 1.584-2.128 2.406-3.172 0.963 1.172 1.866 2.366 2.753 3.541 1.644 2.175 3.194 4.228 5.041 6.075 0.487 0.488 1.128 0.731 1.769 0.731s1.281-0.244 1.769-0.731c0.975-0.975 0.975-2.559 0-3.534-1.847-1.85-3.9-3.4-6.075-5.044zM22.472 1.234c1.006 1.372 0.563 3.022-1.325 4.909l-4.647 4.65-1.794-1.794 7.766-7.766zM8.881 10.003c-0.387 0.003-1.006-0.166-1.916-0.866 0.141-0.072 0.272-0.166 0.387-0.284 0.291-0.291 0.441-0.666 0.456-1.044 0.381-0.016 0.756-0.166 1.044-0.456 0.116-0.116 0.213-0.247 0.284-0.387 0.7 0.909 0.869 1.528 0.866 1.916-0.003 0.425-0.222 0.634-0.325 0.734-0.012 0.012-0.022 0.022-0.031 0.031s-0.019 0.019-0.031 0.031c-0.1 0.103-0.309 0.319-0.734 0.325zM2.856 21.85c-0.197 0.197-0.516 0.197-0.706 0.003-0.197-0.197-0.197-0.516-0.003-0.709 1.406-1.406 3.038-2.769 4.781-4.175-1.353 1.803-2.672 3.481-4.072 4.881zM21.853 21.853c-0.194 0.194-0.513 0.194-0.706 0-1.403-1.403-2.653-2.969-3.919-4.625 1.656 1.266 3.222 2.516 4.625 3.919 0.197 0.194 0.197 0.513 0 0.706z" })
        );
    }
    function ForkKnife({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ForkKnifeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ForkKnife.SVG = ForkKnifeSVG;
    return ForkKnife;
})();
export const ForkKnife2 = /*#__PURE__*/ (() => {
        function ForkKnife2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.756 0.072c-0.15-0.091-0.341-0.094-0.494-0.009-1.534 0.831-2.416 1.8-2.862 3.138-0.4 1.203-0.4 2.569-0.4 4.3v4c0 0.275 0.225 0.5 0.5 0.5h0.5c0 2.637-0.572 4.175-1.128 5.666-0.447 1.206-0.872 2.344-0.872 3.834 0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5v-21c0-0.175-0.094-0.341-0.244-0.428zM15 7.5c0-2.947 0-4.703 2-6.106v9.606h-2v-3.5zM16 21.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5c0-1.128 0.331-2.016 0.747-3.138 0.081-0.222 0.166-0.45 0.253-0.687v3.825z" }),
_('path', { d: "M10 6.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5v-6.5h-1v6.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5v-5.5h-1v5.5c0 1.147 0.231 2.034 0.687 2.631 0.094 0.125 0.2 0.234 0.312 0.334v0.534c0 2.75-0.312 5.044-0.584 7.069-0.225 1.638-0.416 3.053-0.416 4.431s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5c0-1.378-0.191-2.794-0.416-4.431-0.272-2.025-0.584-4.319-0.584-7.069v-0.534c0.113-0.097 0.216-0.209 0.312-0.334 0.456-0.597 0.687-1.484 0.687-2.631v-5.5h-1v5.5zM7.5 8c0.384 0 0.734-0.144 1-0.384 0.266 0.237 0.616 0.384 1 0.384 0.106 0 0.206-0.009 0.306-0.031-0.231 0.684-0.669 1.031-1.306 1.031s-1.075-0.347-1.306-1.031c0.1 0.022 0.2 0.031 0.306 0.031zM8.5 22c-0.275 0-0.5-0.225-0.5-0.5 0-1.241 0.184-2.597 0.397-4.163 0.034-0.253 0.069-0.509 0.103-0.772 0.034 0.262 0.069 0.519 0.103 0.772 0.213 1.569 0.397 2.922 0.397 4.163 0 0.275-0.225 0.5-0.5 0.5z" })
            );
        }
        function ForkKnife2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ForkKnife2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ForkKnife2.SVG = ForkKnife2SVG;
        return ForkKnife2;
    })();
export const ForkSpoon = /*#__PURE__*/ (() => {
        function ForkSpoonSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.269 19.731c-1.841-1.841-4.084-3.584-6.459-5.428-1.053-0.819-2.122-1.647-3.159-2.494 0.278-0.303 0.563-0.606 0.856-0.903 0.175 0.056 0.375 0.091 0.603 0.094 0.006 0 0.012 0 0.022 0 1.047 0 2.3-0.722 3.725-2.147l4.35-4.353-0.706-0.706-4.353 4.353c-0.219 0.219-0.575 0.219-0.794 0s-0.219-0.572 0-0.791l4.853-4.856-0.706-0.706-4.853 4.853c-0.106 0.106-0.247 0.166-0.397 0.166s-0.291-0.059-0.397-0.166c-0.219-0.219-0.219-0.575 0-0.794l4.353-4.353-0.706-0.706-4.353 4.353c-1.434 1.434-2.156 2.694-2.147 3.744 0.003 0.228 0.038 0.428 0.091 0.6-0.341 0.334-0.687 0.663-1.041 0.981-0.563-0.488-1.109-0.981-1.631-1.481 0.628-0.981 0.75-2.088 0.347-3.247-0.319-0.922-0.959-1.869-1.906-2.816-1.319-1.319-2.891-2.278-4.422-2.7-1.563-0.434-2.9-0.237-3.672 0.534-0.775 0.775-0.972 2.112-0.541 3.678 0.422 1.531 1.381 3.1 2.7 4.422 0.944 0.944 1.891 1.584 2.816 1.906 0.447 0.156 0.888 0.231 1.316 0.231 0.681 0 1.334-0.197 1.938-0.581 0.462 0.484 0.922 0.987 1.372 1.506-1.178 0.969-2.381 1.878-3.559 2.769-2.175 1.641-4.228 3.194-6.075 5.037-0.972 0.972-0.972 2.556 0 3.537 0.487 0.487 1.125 0.731 1.766 0.731s1.278-0.244 1.769-0.728l0.003-0.003c1.841-1.844 3.391-3.894 5.031-6.066 0.853-1.128 1.719-2.275 2.641-3.403 0.806 0.997 1.6 2.016 2.378 3.022 1.841 2.369 3.578 4.609 5.416 6.45l0.003 0.003c0.487 0.484 1.128 0.728 1.766 0.728 0.641 0 1.281-0.244 1.769-0.731 0.969-0.981 0.969-2.566-0.003-3.541zM14.862 6.966c0.072 0.141 0.166 0.272 0.284 0.387 0.281 0.281 0.65 0.444 1.044 0.456 0.016 0.378 0.166 0.753 0.456 1.044 0.116 0.116 0.247 0.213 0.387 0.284-0.9 0.691-1.516 0.866-1.903 0.866-0.003 0-0.009 0-0.012 0-0.425-0.003-0.634-0.219-0.734-0.325-0.012-0.012-0.022-0.022-0.031-0.031s-0.019-0.019-0.031-0.031c-0.103-0.1-0.322-0.309-0.325-0.734-0.003-0.387 0.169-1.006 0.866-1.916zM6.069 9.822c-0.778-0.269-1.597-0.831-2.434-1.669-1.2-1.2-2.069-2.613-2.444-3.981-0.328-1.191-0.222-2.2 0.281-2.703 0.309-0.309 0.813-0.469 1.428-0.469 0.384 0 0.816 0.063 1.275 0.188 1.366 0.378 2.781 1.247 3.981 2.444 0.837 0.837 1.397 1.656 1.669 2.434 0.391 1.125 0.144 2.109-0.75 3.003-0.625 0.625-1.287 0.931-2.013 0.931-0.319 0-0.65-0.059-0.994-0.178zM2.853 21.853c-0.197 0.194-0.516 0.194-0.706 0.003-0.197-0.197-0.197-0.516-0.003-0.709 1.403-1.403 2.966-2.65 4.622-3.916-1.263 1.656-2.513 3.219-3.912 4.622zM21.853 21.853c-0.194 0.194-0.513 0.194-0.709 0-1.403-1.403-2.775-3.091-4.191-4.9 1.809 1.419 3.497 2.791 4.9 4.194 0.197 0.194 0.194 0.513 0 0.706z" }),
_('path', { d: "M3.872 5.281l-0.269-0.422-0.844 0.537 0.269 0.422c0.366 0.575 0.806 1.125 1.312 1.628 0.959 0.959 1.978 1.553 2.659 1.553v-1c-0.288 0-1.081-0.391-1.95-1.259-0.456-0.453-0.85-0.944-1.178-1.459z" })
            );
        }
        function ForkSpoon({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ForkSpoonSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ForkSpoon.SVG = ForkSpoonSVG;
        return ForkSpoon;
    })();
export const ForkSpoon2 = /*#__PURE__*/ (() => {
        function ForkSpoon2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 10v-0.353c0.372-0.188 0.709-0.45 0.997-0.778 0.656-0.75 1.003-1.775 1.003-2.969 0-1.188-0.356-2.631-0.931-3.766-0.7-1.375-1.612-2.134-2.569-2.134s-1.869 0.759-2.569 2.134c-0.575 1.134-0.931 2.578-0.931 3.766 0 1.191 0.347 2.219 1.003 2.969 0.288 0.328 0.625 0.591 0.997 0.778v0.353c0 2.75-0.312 5.044-0.584 7.069-0.225 1.638-0.416 3.053-0.416 4.431s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5c0-1.378-0.191-2.794-0.416-4.431-0.272-2.025-0.584-4.319-0.584-7.069zM13 5.9c0-1.041 0.316-2.309 0.825-3.312 0.503-0.994 1.131-1.587 1.675-1.587s1.172 0.594 1.675 1.587c0.509 1.003 0.825 2.272 0.825 3.312 0 1.825-1.028 3.1-2.5 3.1s-2.5-1.275-2.5-3.1zM15.5 22c-0.275 0-0.5-0.225-0.5-0.5 0-1.241 0.184-2.597 0.397-4.163 0.034-0.253 0.069-0.509 0.103-0.772 0.034 0.262 0.069 0.519 0.103 0.772 0.213 1.569 0.397 2.922 0.397 4.163 0 0.275-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M9 6.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5v-6.5h-1v6.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5v-5.5h-1v5.5c0 1.147 0.231 2.034 0.687 2.631 0.094 0.125 0.2 0.234 0.312 0.334v0.534c0 2.75-0.312 5.044-0.584 7.069-0.225 1.638-0.416 3.053-0.416 4.431s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5c0-1.378-0.191-2.794-0.416-4.431-0.272-2.025-0.584-4.319-0.584-7.069v-0.534c0.113-0.097 0.216-0.209 0.312-0.334 0.456-0.597 0.687-1.484 0.687-2.631v-5.5h-1v5.5zM6.5 8c0.384 0 0.734-0.144 1-0.384 0.266 0.237 0.616 0.384 1 0.384 0.106 0 0.206-0.009 0.306-0.031-0.231 0.684-0.669 1.031-1.306 1.031s-1.075-0.347-1.306-1.031c0.1 0.022 0.2 0.031 0.306 0.031zM7.5 22c-0.275 0-0.5-0.225-0.5-0.5 0-1.241 0.184-2.597 0.397-4.163 0.034-0.253 0.069-0.509 0.103-0.772 0.034 0.262 0.069 0.519 0.103 0.772 0.213 1.569 0.397 2.922 0.397 4.163 0 0.275-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M16 8v-1h-0.5c-0.366 0-0.5-0.659-0.5-1.1 0-0.112 0.006-0.231 0.019-0.353l0.047-0.497-0.997-0.091-0.047 0.497c-0.016 0.153-0.022 0.303-0.022 0.447 0 0.491 0.1 0.956 0.278 1.306 0.263 0.509 0.697 0.791 1.222 0.791h0.5z" })
            );
        }
        function ForkSpoon2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ForkSpoon2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ForkSpoon2.SVG = ForkSpoon2SVG;
        return ForkSpoon2;
    })();
export const Fork = /*#__PURE__*/ (() => {
    function ForkSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.269 19.731c-1.847-1.847-3.9-3.397-6.075-5.041-2.112-1.597-4.297-3.247-6.284-5.2 0.053-0.172 0.091-0.372 0.094-0.603 0.009-1.050-0.713-2.309-2.147-3.744 0 0 0 0 0 0v0l-4.356-4.35-0.706 0.706 4.353 4.353c0.219 0.219 0.219 0.575 0 0.794-0.106 0.106-0.247 0.166-0.397 0.166s-0.291-0.059-0.397-0.166l-4.853-4.853-0.706 0.706 4.853 4.853c0.106 0.106 0.166 0.247 0.166 0.397s-0.059 0.291-0.166 0.397c-0.219 0.219-0.575 0.219-0.794 0v0l-4.353-4.353-0.706 0.706 4.353 4.353c0 0 0 0 0 0 1.425 1.425 2.678 2.147 3.725 2.147 0.006 0 0.012 0 0.022 0 0.228-0.003 0.428-0.038 0.603-0.094 1.953 1.987 3.603 4.172 5.2 6.284 1.644 2.175 3.194 4.228 5.041 6.075 0.481 0.491 1.122 0.734 1.763 0.734s1.281-0.244 1.769-0.731c0.975-0.975 0.975-2.562 0-3.537zM8.881 10.003c-0.387 0.003-1.006-0.166-1.916-0.866 0.141-0.072 0.272-0.166 0.387-0.284 0.291-0.291 0.441-0.666 0.456-1.044 0.381-0.016 0.756-0.166 1.044-0.456 0.116-0.116 0.213-0.247 0.284-0.387 0.7 0.909 0.869 1.528 0.866 1.916-0.003 0.425-0.222 0.634-0.325 0.734-0.012 0.012-0.022 0.022-0.031 0.031s-0.019 0.019-0.031 0.031c-0.1 0.103-0.309 0.319-0.734 0.325zM21.853 21.853c-0.194 0.194-0.513 0.194-0.706 0-1.403-1.403-2.653-2.969-3.919-4.625 1.656 1.266 3.222 2.516 4.625 3.919 0.197 0.194 0.197 0.513 0 0.706z" })
        );
    }
    function Fork({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ForkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Fork.SVG = ForkSVG;
    return Fork;
})();
export const FormatClear = /*#__PURE__*/ (() => {
        function FormatClearSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1 19h14v1h-14v-1z" }),
_('path', { d: "M7.038 16.728l1.925 0.544 4.044-14.272h5.994v-2h-14v2h5.928z" }),
_('path', { d: "M23.206 16.5l-0.706-0.706-3 3-3-3-0.706 0.706 3 3-3 3 0.706 0.706 3-3 3 3 0.706-0.706-3-3z" })
            );
        }
        function FormatClear({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FormatClearSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FormatClear.SVG = FormatClearSVG;
        return FormatClear;
    })();
export const FormatShapes = /*#__PURE__*/ (() => {
        function FormatShapesSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.5 4c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v0.5h-16v-0.5c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h0.5v16h-0.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-0.5h16v0.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-0.5v-16h0.5zM21 1h2v2h-2v-2zM1 1h2v2h-2v-2zM3 23h-2v-2h2v2zM23 23h-2v-2h2v2zM21 20h-0.5c-0.275 0-0.5 0.225-0.5 0.5v0.5h-16v-0.5c0-0.275-0.225-0.5-0.5-0.5h-0.5v-16h0.5c0.275 0 0.5-0.225 0.5-0.5v-0.5h16v0.5c0 0.275 0.225 0.5 0.5 0.5h0.5v16z" }),
_('path', { d: "M12 5c-0.4 0-0.762 0.237-0.919 0.606l-5.25 12.25 1.838 0.788 1.563-3.644h5.538l1.563 3.644 1.837-0.788-5.25-12.25c-0.156-0.369-0.519-0.606-0.919-0.606zM10.087 13l1.913-4.463 1.913 4.463h-3.825z" })
            );
        }
        function FormatShapes({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FormatShapesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FormatShapes.SVG = FormatShapesSVG;
        return FormatShapes;
    })();
export const Forward10S = /*#__PURE__*/ (() => {
        function Forward10SSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.384 17.453c-1.856 2.847-4.991 4.547-8.384 4.547-5.512 0-10-4.488-10-10s4.488-10 10-10c2.703 0 5.275 1.1 7.141 3h-4.141v2h6c0.553 0 1-0.447 1-1v-6h-2v3.059c-0.725-0.647-1.525-1.209-2.384-1.666-1.716-0.912-3.659-1.394-5.616-1.394-1.619 0-3.191 0.319-4.672 0.944-1.428 0.603-2.712 1.469-3.813 2.572s-1.966 2.384-2.572 3.813c-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813s2.384 1.966 3.813 2.572c1.481 0.625 3.053 0.944 4.672 0.944 4.072 0 7.831-2.037 10.059-5.453l-1.675-1.094z" }),
_('path', { d: "M3 12c0 2.403 0.938 4.662 2.637 6.363s3.959 2.637 6.363 2.637c2.403 0 4.662-0.938 6.363-2.637s2.637-3.959 2.637-6.363h-1c0 4.413-3.588 8-8 8s-8-3.588-8-8c0-4.413 3.588-8 8-8v-1c-2.403 0-4.662 0.938-6.363 2.637s-2.637 3.959-2.637 6.363z" }),
_('path', { d: "M11 12.5c0 0.9 0.237 1.75 0.669 2.4 0.475 0.709 1.125 1.1 1.831 1.1s1.356-0.391 1.831-1.1c0.431-0.647 0.669-1.5 0.669-2.4s-0.237-1.75-0.669-2.4c-0.475-0.709-1.125-1.1-1.831-1.1s-1.356 0.391-1.831 1.1c-0.431 0.65-0.669 1.5-0.669 2.4zM13.5 10c0.813 0 1.5 1.144 1.5 2.5s-0.687 2.5-1.5 2.5-1.5-1.144-1.5-2.5 0.687-2.5 1.5-2.5z" }),
_('path', { d: "M10 16v-6.5c0-0.203-0.122-0.384-0.309-0.462s-0.403-0.034-0.544 0.109l-1.353 1.353 0.706 0.706 0.5-0.5v5.294h1z" })
            );
        }
        function Forward10S({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Forward10SSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Forward10S.SVG = Forward10SSVG;
        return Forward10S;
    })();
export const Forward5S = /*#__PURE__*/ (() => {
        function Forward5SSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.384 17.453c-1.856 2.847-4.991 4.547-8.384 4.547-5.512 0-10-4.488-10-10s4.488-10 10-10c2.703 0 5.275 1.1 7.141 3h-4.141v2h6c0.553 0 1-0.447 1-1v-6h-2v3.059c-0.725-0.647-1.525-1.209-2.384-1.666-1.716-0.912-3.659-1.394-5.616-1.394-1.619 0-3.191 0.319-4.672 0.944-1.428 0.603-2.712 1.469-3.813 2.572s-1.966 2.384-2.572 3.813c-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813s2.384 1.966 3.813 2.572c1.481 0.625 3.053 0.944 4.672 0.944 4.072 0 7.831-2.037 10.059-5.453l-1.675-1.094z" }),
_('path', { d: "M3 12c0 2.403 0.938 4.662 2.637 6.363s3.959 2.637 6.363 2.637c2.403 0 4.662-0.938 6.363-2.637s2.637-3.959 2.637-6.363h-1c0 4.413-3.588 8-8 8s-8-3.588-8-8c0-4.413 3.588-8 8-8v-1c-2.403 0-4.662 0.938-6.363 2.637s-2.637 3.959-2.637 6.363z" }),
_('path', { d: "M13 10v-1h-3c-0.244 0-0.453 0.178-0.494 0.419l-0.5 3c-0.025 0.144 0.016 0.294 0.113 0.406s0.234 0.178 0.381 0.178h0.269c0.178 0 0.344-0.097 0.434-0.25 0.266-0.462 0.762-0.75 1.297-0.75 0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5c-0.531 0-1.028-0.288-1.3-0.75l-0.25-0.431-0.866 0.503 0.25 0.431c0.447 0.769 1.278 1.25 2.163 1.25 1.378 0 2.5-1.122 2.5-2.5s-1.122-2.5-2.5-2.5c-0.469 0-0.919 0.131-1.303 0.369l0.228-1.369h2.578z" })
            );
        }
        function Forward5S({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Forward5SSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Forward5S.SVG = Forward5SSVG;
        return Forward5S;
    })();
export const ForwardCircle = /*#__PURE__*/ (() => {
        function ForwardCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M16.766 11.575l-4-2.5c-0.153-0.097-0.347-0.1-0.506-0.012s-0.256 0.256-0.256 0.438v1.597l-3.234-2.022c-0.153-0.097-0.347-0.1-0.506-0.012s-0.256 0.256-0.256 0.438v5c0 0.181 0.1 0.35 0.256 0.438 0.075 0.041 0.159 0.063 0.244 0.063 0.091 0 0.184-0.025 0.266-0.075l3.228-2.022v1.597c0 0.181 0.1 0.35 0.256 0.438 0.075 0.041 0.159 0.063 0.244 0.063 0.091 0 0.184-0.025 0.266-0.075l4-2.5c0.147-0.091 0.234-0.253 0.234-0.425s-0.087-0.331-0.234-0.425zM9 13.597v-3.194l2.556 1.597-2.556 1.597zM13 13.597v-3.194l2.556 1.597-2.556 1.597z" })
            );
        }
        function ForwardCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ForwardCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ForwardCircle.SVG = ForwardCircleSVG;
        return ForwardCircle;
    })();
export const ForwardSquare = /*#__PURE__*/ (() => {
        function ForwardSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M8.256 14.937c0.075 0.041 0.159 0.063 0.244 0.063 0.091 0 0.184-0.025 0.266-0.075l3.234-2.022v1.597c0 0.181 0.1 0.35 0.256 0.438 0.075 0.041 0.159 0.063 0.244 0.063 0.091 0 0.184-0.025 0.266-0.075l4-2.5c0.147-0.091 0.234-0.253 0.234-0.425s-0.087-0.331-0.234-0.425l-4-2.5c-0.153-0.097-0.347-0.1-0.506-0.012s-0.256 0.256-0.256 0.438v1.597l-3.234-2.022c-0.153-0.097-0.347-0.1-0.506-0.012s-0.256 0.256-0.256 0.438v5c-0.006 0.181 0.094 0.35 0.25 0.438zM13 10.403l2.556 1.597-2.556 1.597v-3.194zM9 10.403l2.556 1.597-2.556 1.597v-3.194z" })
            );
        }
        function ForwardSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ForwardSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ForwardSquare.SVG = ForwardSquareSVG;
        return ForwardSquare;
    })();
export const Forward = /*#__PURE__*/ (() => {
    function ForwardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.575 11.181l-10-7c-0.306-0.213-0.703-0.241-1.034-0.069s-0.537 0.516-0.537 0.888v5.778l-9.428-6.597c-0.306-0.213-0.703-0.241-1.034-0.069-0.334 0.172-0.541 0.516-0.541 0.888v14c0 0.372 0.206 0.716 0.537 0.888 0.144 0.075 0.303 0.113 0.462 0.113 0.203 0 0.403-0.059 0.575-0.181l9.425-6.597v5.778c0 0.372 0.206 0.716 0.537 0.888 0.147 0.075 0.303 0.113 0.462 0.113 0.203 0 0.403-0.059 0.575-0.181l10-7c0.269-0.188 0.425-0.494 0.425-0.819s-0.159-0.631-0.425-0.819zM3 17.078v-10.156l7.256 5.078-7.256 5.078zM14 17.078v-10.156l7.256 5.078-7.256 5.078z" })
        );
    }
    function Forward({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ForwardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Forward.SVG = ForwardSVG;
    return Forward;
})();
export const FreeTransform = /*#__PURE__*/ (() => {
        function FreeTransformSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.5 10h-3c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5zM13 13h-2v-2h2v2z" }),
_('path', { d: "M23.5 4c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v0.5h-6v-0.5c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v0.5h-6v-0.5c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h0.5v6h-0.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h0.5v6h-0.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-0.5h6v0.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-0.5h6v0.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-0.5v-6h0.5c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-0.5v-6h0.5zM21 1h2v2h-2v-2zM11 1h2v2h-2v-2zM1 1h2v2h-2v-2zM1 11h2v2h-2v-2zM3 23h-2v-2h2v2zM13 23h-2v-2h2v2zM23 23h-2v-2h2v2zM23 13h-2v-2h2v2zM21 10h-0.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h0.5v6h-0.5c-0.275 0-0.5 0.225-0.5 0.5v0.5h-6v-0.5c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v0.5h-6v-0.5c0-0.275-0.225-0.5-0.5-0.5h-0.5v-6h0.5c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-0.5v-6h0.5c0.275 0 0.5-0.225 0.5-0.5v-0.5h6v0.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-0.5h6v0.5c0 0.275 0.225 0.5 0.5 0.5h0.5v6z" })
            );
        }
        function FreeTransform({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FreeTransformSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FreeTransform.SVG = FreeTransformSVG;
        return FreeTransform;
    })();
export const FriedEgg = /*#__PURE__*/ (() => {
        function FriedEggSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.916 8.35c-0.647-1.469-1.556-2.797-2.706-3.95-1.041-1.044-2.262-1.909-3.531-2.503-1.253-0.588-2.522-0.897-3.669-0.897-1.609 0-3.012 0.503-4.291 1.537-1.047 0.847-1.803 1.884-2.475 2.8-0.347 0.475-0.675 0.925-0.972 1.237-0.419 0.441-1.134 0.759-1.894 1.094-0.75 0.331-1.528 0.678-2.156 1.206-0.809 0.681-1.222 1.556-1.222 2.6 0 1.541 0.637 2.869 1.897 3.953 1.013 0.872 2.287 1.478 3.412 2.013 0.816 0.387 1.587 0.756 2.072 1.134 0.356 0.281 0.734 0.6 1.131 0.938 0.891 0.756 1.9 1.612 2.972 2.275 1.316 0.816 2.519 1.212 3.678 1.212 0.603 0 1.547-0.059 2.606-0.344 1.091-0.294 2.069-0.759 2.906-1.384 1.022-0.762 1.822-1.75 2.378-2.937 0.625-1.338 0.944-2.937 0.944-4.756 0.003-1.831-0.363-3.591-1.081-5.228zM15.162 21c-1.803 0-3.691-1.6-5.359-3.012-0.412-0.35-0.803-0.681-1.188-0.984-0.659-0.522-1.531-0.934-2.453-1.372-1.059-0.503-2.156-1.025-2.966-1.722-0.819-0.706-1.203-1.481-1.203-2.438 0-0.909 0.669-1.3 2.191-1.975 0.903-0.4 1.841-0.816 2.534-1.547 0.384-0.406 0.75-0.906 1.137-1.434 1.212-1.647 2.578-3.516 5.153-3.516 1.834 0 4.050 1.078 5.784 2.816 2.069 2.069 3.206 4.828 3.206 7.762 0 6.888-5.231 7.422-6.837 7.422z" }),
_('path', { d: "M14 7c-2.756 0-5 2.244-5 5s2.244 5 5 5c2.756 0 5-2.244 5-5s-2.244-5-5-5zM14 16c-2.206 0-4-1.794-4-4s1.794-4 4-4c2.206 0 4 1.794 4 4s-1.794 4-4 4z" }),
_('path', { d: "M14 9v1c1.103 0 2 0.897 2 2h1c0-1.653-1.347-3-3-3z" })
            );
        }
        function FriedEgg({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FriedEggSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FriedEgg.SVG = FriedEggSVG;
        return FriedEgg;
    })();
export const Fries = /*#__PURE__*/ (() => {
    function FriesSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.475 7.119c-0.203-0.109-0.428-0.144-0.644-0.106l1.159-5.409c0.047-0.222-0.063-0.45-0.266-0.553l-2-1c-0.138-0.069-0.3-0.072-0.441-0.003s-0.241 0.197-0.272 0.347l-0.012 0.059c-0.025-0.253-0.237-0.453-0.5-0.453h-2c-0.275 0-0.5 0.225-0.5 0.5v0.191l-1.275-0.637c-0.134-0.066-0.291-0.072-0.428-0.009s-0.237 0.181-0.278 0.325l-1.019 3.731v-1.6c0-0.275-0.225-0.5-0.5-0.5h-1.5v-1.5c0-0.275-0.225-0.5-0.5-0.5h-2c-0.275 0-0.5 0.225-0.5 0.5v1.938l-0.016-0.059c-0.037-0.147-0.138-0.269-0.275-0.334-0.138-0.063-0.297-0.059-0.431 0.006l-2 1c-0.213 0.106-0.322 0.35-0.259 0.578l1.109 4.069c-0.141-0.131-0.281-0.269-0.422-0.409-0.312-0.312-0.794-0.384-1.181-0.172-0.387 0.209-0.594 0.65-0.503 1.081l3 14.5c0.081 0.394 0.391 0.7 0.784 0.778 1.725 0.344 3.459 0.516 5.197 0.516s3.472-0.172 5.197-0.516c0.394-0.078 0.703-0.384 0.784-0.778l3-14.5c0.084-0.428-0.122-0.866-0.509-1.078zM18.856 1.237l1.075 0.537-1.322 6.175c-0.203 0.184-0.406 0.359-0.606 0.528v-3.175l0.853-4.066zM17 1v8.238c-0.334 0.231-0.669 0.441-1 0.628v-8.359c0-0.003 0-0.009 0-0.012v-0.494h1zM15 10.356c-0.591 0.25-1.181 0.428-1.766 0.534l1.766-5.947v5.412zM13.822 1.219l1.078 0.541-2.741 9.237c-0.053 0-0.106 0.003-0.159 0.003-0.275 0-0.553-0.016-0.831-0.050l2.653-9.731zM11 3v4.766l-0.816 2.994c-0.063-0.016-0.122-0.031-0.184-0.050v-7.709h1zM8 1h1v9.356c-0.006-0.003-0.016-0.006-0.022-0.009l-0.978-3.909v-5.438zM5.091 3.762l1.075-0.537 1.631 6.522c-0.438-0.256-0.878-0.553-1.319-0.891l-1.387-5.094zM7.844 21.641l-0.466-2.253c1.541 0.406 3.087 0.612 4.622 0.612s3.084-0.206 4.622-0.612l-0.466 2.253c-2.759 0.475-5.553 0.475-8.313 0zM16.85 18.288c-3.222 0.944-6.478 0.944-9.7 0l-1.575-7.609c0.659 0.481 1.319 0.888 1.978 1.216 1.469 0.734 2.962 1.106 4.447 1.106s2.981-0.372 4.447-1.106c0.659-0.328 1.319-0.734 1.978-1.216l-1.575 7.609z" })
        );
    }
    function Fries({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FriesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Fries.SVG = FriesSVG;
    return Fries;
})();
export const FullScreenEnter = /*#__PURE__*/ (() => {
        function FullScreenEnterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 2h-20c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-16c0-1.103-0.897-2-2-2zM22 20h-20v-16h20v16c0.003 0 0 0 0 0z" }),
_('path', { d: "M8.5 12.794l-3.5 3.5v-1.294h-1v2.5c0 0.275 0.225 0.5 0.5 0.5h2.5v-1h-1.294l3.5-3.5-0.706-0.706z" }),
_('path', { d: "M19.5 6h-2.5v1h1.294l-3.5 3.5 0.706 0.706 3.5-3.5v1.294h1v-2.5c0-0.275-0.225-0.5-0.5-0.5z" })
            );
        }
        function FullScreenEnter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FullScreenEnterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FullScreenEnter.SVG = FullScreenEnterSVG;
        return FullScreenEnter;
    })();
export const FullScreenEnter2 = /*#__PURE__*/ (() => {
        function FullScreenEnter2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 4h4v-2h-4c-1.103 0-2 0.897-2 2v4h2v-4z" }),
_('path', { d: "M22 2h-4v2h4v4h2v-4c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M22 20h-4v2h4c1.103 0 2-0.897 2-2v-4h-2v4z" }),
_('path', { d: "M2 16h-2v4c0 1.103 0.897 2 2 2h4v-2h-4v-4z" }),
_('path', { d: "M3 5.5v13c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-13c0-0.275-0.225-0.5-0.5-0.5h-17c-0.275 0-0.5 0.225-0.5 0.5zM4 6h16v12h-16v-12z" })
            );
        }
        function FullScreenEnter2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FullScreenEnter2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FullScreenEnter2.SVG = FullScreenEnter2SVG;
        return FullScreenEnter2;
    })();
export const FullScreenExit = /*#__PURE__*/ (() => {
        function FullScreenExitSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 2h-20c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-16c0-1.103-0.897-2-2-2zM22 20h-20v-16h20v16c0.003 0 0 0 0 0z" }),
_('path', { d: "M19.5 5.794l-3.5 3.5v-1.294h-1v2.5c0 0.275 0.225 0.5 0.5 0.5h2.5v-1h-1.294l3.5-3.5-0.706-0.706z" }),
_('path', { d: "M8.5 13h-2.5v1h1.294l-3.5 3.5 0.706 0.706 3.5-3.5v1.294h1v-2.5c0-0.275-0.225-0.5-0.5-0.5z" })
            );
        }
        function FullScreenExit({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FullScreenExitSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FullScreenExit.SVG = FullScreenExitSVG;
        return FullScreenExit;
    })();
export const FullScreenExit2 = /*#__PURE__*/ (() => {
        function FullScreenExit2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 6v-4h-2v4h-4v2h4c1.103 0 2-0.897 2-2z" }),
_('path', { d: "M20 6v-4h-2v4c0 1.103 0.897 2 2 2h4v-2h-4z" }),
_('path', { d: "M18 18v4h2v-4h4v-2h-4c-1.103 0-2 0.897-2 2z" }),
_('path', { d: "M4 16h-4v2h4v4h2v-4c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M18 8.5c0-0.275-0.225-0.5-0.5-0.5h-11c-0.275 0-0.5 0.225-0.5 0.5v7c0 0.275 0.225 0.5 0.5 0.5h11c0.275 0 0.5-0.225 0.5-0.5v-7zM17 15h-10v-6h10v6z" })
            );
        }
        function FullScreenExit2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FullScreenExit2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FullScreenExit2.SVG = FullScreenExit2SVG;
        return FullScreenExit2;
    })();
export const Funnel = /*#__PURE__*/ (() => {
    function FunnelSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.987 2.841c-0.044-0.275-0.2-0.519-0.431-0.672-1.072-0.716-2.512-1.269-4.284-1.644-1.603-0.344-3.425-0.525-5.272-0.525s-3.669 0.181-5.272 0.522c-1.769 0.378-3.213 0.931-4.281 1.647-0.231 0.153-0.387 0.397-0.431 0.672s0.028 0.556 0.197 0.775l6.787 8.728v11.156c0 0.194 0.109 0.369 0.284 0.45 0.069 0.034 0.144 0.050 0.216 0.050 0.113 0 0.222-0.037 0.312-0.109l5-4c0.119-0.094 0.188-0.237 0.188-0.391v-7.156l6.791-8.728c0.169-0.222 0.241-0.503 0.197-0.775zM12 2c2.656 0 5.153 0.4 6.947 1.084-3.8 1.225-10.094 1.225-13.894 0 1.794-0.681 4.291-1.084 6.947-1.084zM13.209 11.388c-0.138 0.175-0.209 0.391-0.209 0.612v8.059l-2 1.6v-9.659c0-0.222-0.075-0.438-0.209-0.612l-5.616-7.222c0.616 0.175 1.291 0.328 2.025 0.453 1.469 0.25 3.128 0.381 4.803 0.381s3.334-0.131 4.803-0.381c0.734-0.125 1.409-0.275 2.025-0.453l-5.622 7.222z" })
        );
    }
    function Funnel({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FunnelSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Funnel.SVG = FunnelSVG;
    return Funnel;
})();
export const Gallon = /*#__PURE__*/ (() => {
        function GallonSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.416 5l-0.853-0.853 1.125-1.128c0.391-0.391 0.391-1.025 0-1.416l-1.294-1.291c-0.391-0.391-1.025-0.391-1.416 0l-1.128 1.128-0.85-0.856c-0.378-0.375-0.881-0.584-1.416-0.584h-7.169c-0.534 0-1.038 0.209-1.416 0.584l-4.416 4.416c-0.375 0.378-0.584 0.881-0.584 1.416v15.584c0 1.103 0.897 2 2 2h16c1.103 0 2-0.897 2-2v-15.584c0-0.534-0.209-1.038-0.584-1.416zM19.688 1.019l1.294 1.294-1.128 1.128-1.294-1.294 1.128-1.128zM20 22h-16v-15.584l4.416-4.416h7.172l4.413 4.416v15.584c0 0 0 0 0 0z" }),
_('path', { d: "M9.5 7h5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5zM9.5 5h5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-5c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5z" }),
_('path', { d: "M18.194 9.363l-0.831-0.556-2.131 3.194h-6.462l-2.128-3.194-0.831 0.556 2.191 3.288v3.697l-2.194 3.291 0.831 0.556 2.131-3.194h6.466l2.128 3.194 0.831-0.556-2.194-3.288v-3.7l2.194-3.288zM15 16h-6v-3h6v3z" })
            );
        }
        function Gallon({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GallonSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Gallon.SVG = GallonSVG;
        return Gallon;
    })();
export const Game = /*#__PURE__*/ (() => {
        function GameSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.6 17.2l-6.934-5.2 6.934-5.2c0.213-0.159 0.353-0.397 0.391-0.659s-0.031-0.528-0.191-0.741c-1.003-1.338-2.319-2.444-3.803-3.2-1.556-0.797-3.237-1.2-4.997-1.2-1.484 0-2.925 0.291-4.281 0.866-1.309 0.553-2.487 1.347-3.497 2.356s-1.803 2.187-2.356 3.497c-0.575 1.356-0.866 2.797-0.866 4.281s0.291 2.925 0.866 4.281c0.553 1.309 1.347 2.487 2.356 3.497s2.187 1.803 3.497 2.356c1.356 0.575 2.797 0.866 4.281 0.866 1.759 0 3.441-0.403 4.997-1.2 1.484-0.759 2.797-1.866 3.803-3.2 0.159-0.213 0.228-0.478 0.191-0.741s-0.178-0.5-0.391-0.659zM12 21c-4.962 0-9-4.038-9-9s4.038-9 9-9c2.519 0 4.859 1.022 6.556 2.834l-7.156 5.366c-0.253 0.188-0.4 0.484-0.4 0.8s0.147 0.612 0.4 0.8l7.156 5.366c-1.697 1.812-4.038 2.834-6.556 2.834z" }),
_('path', { d: "M13 6.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5c0.828 0 1.5-0.672 1.5-1.5zM11 6.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5z" })
            );
        }
        function Game({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GameSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Game.SVG = GameSVG;
        return Game;
    })();
export const Gamepad = /*#__PURE__*/ (() => {
        function GamepadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.5 9h-1.5v-1.5c0-0.275-0.225-0.5-0.5-0.5h-2c-0.275 0-0.5 0.225-0.5 0.5v1.5h-1.5c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h1.5v1.5c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-1.5h1.5c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5zM10 11h-1.5c-0.275 0-0.5 0.225-0.5 0.5v1.5h-1v-1.5c0-0.275-0.225-0.5-0.5-0.5h-1.5v-1h1.5c0.275 0 0.5-0.225 0.5-0.5v-1.5h1v1.5c0 0.275 0.225 0.5 0.5 0.5h1.5v1z" }),
_('path', { d: "M15.5 7c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM15.5 9c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M18.5 10c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5c0-0.828-0.672-1.5-1.5-1.5zM18.5 12c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M22.603 6.972c-0.55-1.25-1.281-2.219-2.169-2.881-0.966-0.725-2.122-1.091-3.434-1.091-0.806 0-1.391 0.222-1.953 0.438-0.691 0.263-1.472 0.563-3.047 0.563s-2.356-0.297-3.047-0.563c-0.566-0.216-1.15-0.438-1.953-0.438-1.313 0-2.469 0.366-3.434 1.091-0.888 0.663-1.616 1.634-2.169 2.881-0.941 2.131-1.397 5.084-1.397 9.031 0 1.081 0.328 2.169 0.922 3.059 0.612 0.916 1.459 1.563 2.391 1.819 0.825 0.225 1.675 0.138 2.456-0.256 0.8-0.403 1.503-1.113 2.094-2.106 0.006-0.009 0.012-0.019 0.016-0.031 0.719-1.322 1.181-1.488 4.122-1.488s3.403 0.166 4.122 1.481c0.006 0.009 0.012 0.019 0.016 0.031 0.591 0.994 1.294 1.703 2.094 2.106 0.5 0.253 1.025 0.381 1.556 0.381 0.3 0 0.6-0.041 0.897-0.122 0.928-0.256 1.778-0.9 2.391-1.819 0.594-0.891 0.922-1.975 0.922-3.059 0.003-3.944-0.453-6.897-1.394-9.028zM20.159 18.95c-1.066 0.294-1.891-0.772-2.291-1.444-0.628-1.141-1.309-1.778-2.278-2.128-0.872-0.319-1.934-0.378-3.591-0.378s-2.719 0.059-3.591 0.378c-0.966 0.35-1.65 0.987-2.278 2.128-0.4 0.672-1.225 1.737-2.291 1.444-1.016-0.278-1.841-1.6-1.841-2.947 0-3.609 0.413-6.375 1.228-8.222 0.834-1.897 2.034-2.781 3.772-2.781 0.438 0 0.756 0.122 1.241 0.306 0.766 0.294 1.816 0.694 3.759 0.694s2.991-0.4 3.759-0.694c0.484-0.184 0.803-0.306 1.241-0.306 1.737 0 2.937 0.884 3.772 2.778 0.816 1.847 1.228 4.613 1.228 8.225 0 1.347-0.825 2.669-1.841 2.947z" })
            );
        }
        function Gamepad({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GamepadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Gamepad.SVG = GamepadSVG;
        return Gamepad;
    })();
export const GasMask = /*#__PURE__*/ (() => {
    function GasMaskSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21 4h-1.050c-0.431-0.725-0.984-1.372-1.656-1.928-1.616-1.334-3.85-2.072-6.294-2.072s-4.678 0.738-6.294 2.072c-0.672 0.556-1.225 1.2-1.656 1.928h-1.050c-1.103 0-2 0.897-2 2v3c0 1.103 0.897 2 2 2h0.416c0.209 0.8 0.494 1.616 0.847 2.416 0.803 1.812 1.916 3.425 3.147 4.569 0.347 0.803 0.9 1.497 1.591 2.016v0.294l-0.853 0.853c-0.094 0.094-0.147 0.222-0.147 0.353v2c0 0.275 0.225 0.5 0.5 0.5h7c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.131-0.053-0.259-0.147-0.353l-0.853-0.853v-0.294c0.691-0.519 1.244-1.212 1.591-2.016 1.234-1.144 2.344-2.753 3.147-4.569 0.353-0.8 0.637-1.612 0.847-2.416h0.416c1.103 0 2-0.897 2-2v-3c0-1.103-0.897-2-2-2zM9 16c0-0.647 0.206-1.247 0.556-1.737l1.478 1.478c-0.022 0.081-0.034 0.169-0.034 0.259 0 0.275 0.113 0.525 0.294 0.706l-0.541 2.022c-1.034-0.475-1.753-1.519-1.753-2.728zM12.706 15.294c-0.181-0.181-0.431-0.294-0.706-0.294-0.091 0-0.175 0.012-0.259 0.034l-1.478-1.478c0.491-0.35 1.091-0.556 1.737-0.556 1.209 0 2.253 0.719 2.728 1.753l-2.022 0.541zM3 10c-0.55 0-1-0.45-1-1v-3c0-0.55 0.45-1 1-1h0.556c-0.369 0.922-0.556 1.928-0.556 3 0 0.634 0.066 1.306 0.194 2h-0.194zM11 2.050v4.053c-0.191-1.191-1.231-2.106-2.484-2.106-0.7 0-1.341 0.309-1.809 0.869-0.456 0.547-0.706 1.306-0.706 2.134 0 0.987 0.128 1.672 0.406 2.147 0.331 0.566 0.869 0.853 1.603 0.853 0.681 0 1.447-0.416 2.053-1.109 0.506-0.581 0.837-1.278 0.934-1.962v4.172c-1.828 0.372-3.297 1.747-3.806 3.519-1.306-1.984-2.191-4.528-2.191-6.619 0-3.747 2.875-5.622 6-5.95zM10.031 6.5c0 1.206-1.184 2.5-2.019 2.5-0.428 0-1.013 0-1.013-2 0-1.159 0.638-2 1.516-2 0.834 0 1.516 0.672 1.516 1.5zM14.147 20.853l0.853 0.853v1.294h-6v-1.294l0.853-0.853c0.075-0.075 0.122-0.172 0.141-0.275 0.616 0.269 1.294 0.422 2.006 0.422s1.391-0.15 2.006-0.422c0.016 0.103 0.066 0.2 0.141 0.275zM12 19c-0.094 0-0.191-0.003-0.281-0.012l0.541-2.022c0.344-0.094 0.616-0.363 0.706-0.706l2.022-0.541c0.009 0.094 0.012 0.188 0.012 0.281 0 1.653-1.347 3-3 3zM16.806 14.619c-0.509-1.775-1.978-3.147-3.806-3.519v-4.172c0.1 0.684 0.428 1.381 0.934 1.962 0.606 0.694 1.375 1.109 2.053 1.109 0.734 0 1.275-0.288 1.603-0.853 0.278-0.475 0.406-1.159 0.406-2.147 0-0.828-0.25-1.587-0.706-2.131-0.466-0.559-1.109-0.869-1.809-0.869-1.253 0-2.294 0.912-2.484 2.106v-4.056c3.128 0.328 6.003 2.203 6.003 5.95 0 2.091-0.884 4.634-2.194 6.619zM13.969 6.5c0-0.828 0.681-1.5 1.516-1.5 0.878 0 1.516 0.841 1.516 2 0 2-0.584 2-1.013 2-0.834 0-2.019-1.294-2.019-2.5zM22 9c0 0.55-0.45 1-1 1h-0.194c0.128-0.694 0.194-1.366 0.194-2 0-1.072-0.188-2.078-0.556-3h0.556c0.55 0 1 0.45 1 1v3z" })
        );
    }
    function GasMask({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GasMaskSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    GasMask.SVG = GasMaskSVG;
    return GasMask;
})();
export const GasStation = /*#__PURE__*/ (() => {
        function GasStationSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 2v-2c-0.934 0-1.709 0.159-2.372 0.488-0.691 0.341-1.244 0.872-1.653 1.575-0.675 1.169-0.978 2.847-0.978 5.438v10.5c0 0.55-0.45 1-1 1s-1-0.45-1-1v-6c0-1.653-1.347-3-3-3v-5c0-1.103-0.897-2-2-2h-8.997c-1.103 0-2 0.897-2 2v18h-1v2h15v-2h-1v-11c0.55 0 1 0.45 1 1v6c0 1.653 1.347 3 3 3s3-1.347 3-3v-9.172c1.163-0.413 2-1.525 2-2.828 0-1.088-0.578-2.056-1.466-2.581 0.053-0.128 0.113-0.247 0.175-0.356 0.303-0.525 0.813-1.062 2.291-1.062zM3 22v-18h9v18h-9zM22 6c0 0.738-0.403 1.384-1 1.731v-0.231c0-1.275 0.075-2.287 0.237-3.075 0.469 0.369 0.762 0.941 0.762 1.575z" }),
_('path', { d: "M10.5 6h-6c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h6c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5zM10 11h-5v-4h5v4z" })
            );
        }
        function GasStation({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GasStationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        GasStation.SVG = GasStationSVG;
        return GasStation;
    })();
export const Gear = /*#__PURE__*/ (() => {
        function GearSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.034 8.137c-1.031-0.275-2.109-0.134-3.034 0.4s-1.587 1.397-1.863 2.428c-0.275 1.031-0.134 2.109 0.4 3.034s1.397 1.587 2.428 1.863c0.344 0.094 0.694 0.138 1.041 0.138 0.694 0 1.378-0.181 1.994-0.537 1.909-1.103 2.566-3.553 1.466-5.466-0.534-0.922-1.397-1.584-2.431-1.859zM13.5 14.597c-0.694 0.4-1.503 0.506-2.275 0.3-0.775-0.206-1.422-0.703-1.822-1.397s-0.506-1.503-0.3-2.275c0.206-0.775 0.703-1.422 1.397-1.822 0.462-0.266 0.975-0.403 1.494-0.403 0.259 0 0.522 0.034 0.781 0.103 0.775 0.206 1.422 0.703 1.822 1.397 0.828 1.431 0.334 3.272-1.097 4.097z" }),
_('path', { d: "M12.519 10.069c-0.516-0.138-1.056-0.069-1.519 0.2-0.462 0.266-0.794 0.697-0.931 1.216-0.138 0.516-0.069 1.056 0.2 1.519s0.697 0.794 1.216 0.931c0.172 0.047 0.347 0.069 0.522 0.069 0.347 0 0.687-0.091 0.997-0.269 0.462-0.266 0.794-0.697 0.931-1.216s0.069-1.056-0.2-1.519-0.7-0.794-1.216-0.931zM12.966 12.259c-0.069 0.259-0.234 0.475-0.466 0.606-0.231 0.134-0.5 0.169-0.759 0.1s-0.475-0.234-0.606-0.466-0.169-0.5-0.1-0.759 0.234-0.475 0.466-0.606c0.153-0.087 0.325-0.134 0.497-0.134 0.087 0 0.175 0.012 0.259 0.034 0.259 0.069 0.475 0.234 0.606 0.466s0.172 0.5 0.103 0.759z" }),
_('path', { d: "M22.159 14.403l-2.238-1.294c0.103-0.738 0.103-1.488 0.003-2.222l2.238-1.291c0.462-0.269 0.794-0.7 0.931-1.216s0.066-1.056-0.2-1.519l-1-1.731c-0.55-0.956-1.778-1.284-2.731-0.731l-2.238 1.291c-0.584-0.456-1.234-0.828-1.925-1.109v-2.584c-0.003-1.103-0.9-1.997-2-1.997h-2.003c-0.531 0-1.031 0.206-1.409 0.584-0.381 0.378-0.588 0.881-0.588 1.416v2.584c-0.344 0.141-0.678 0.303-1 0.488-0.322 0.188-0.631 0.394-0.922 0.619l-2.238-1.294c-0.462-0.269-1.003-0.341-1.519-0.2-0.516 0.138-0.947 0.469-1.212 0.931l-0.997 1.731c-0.556 0.953-0.228 2.178 0.728 2.734l2.241 1.294c-0.103 0.738-0.103 1.488-0.003 2.222l-2.238 1.294c-0.462 0.269-0.794 0.7-0.931 1.216s-0.066 1.056 0.2 1.519l1 1.731c0.55 0.956 1.778 1.284 2.731 0.731l2.241-1.294c0.584 0.456 1.234 0.828 1.922 1.109l-0.003 2.591c0.003 1.103 0.897 1.997 1.997 1.997h2.006c0.531 0 1.031-0.206 1.409-0.584s0.588-0.881 0.588-1.416l0.003-2.587c0.344-0.141 0.678-0.303 0.997-0.484 0.325-0.188 0.634-0.397 0.925-0.622l2.234 1.291c0.462 0.269 1.003 0.341 1.519 0.2 0.516-0.138 0.947-0.469 1.212-0.931l0.997-1.731c0.556-0.956 0.228-2.181-0.728-2.734zM11 22v0c0 0 0 0 0 0s0 0 0 0zM20.159 17.866l-2.844-1.647c-0.384-0.222-0.866-0.166-1.188 0.141-0.334 0.316-0.713 0.597-1.125 0.837-0.4 0.231-0.831 0.419-1.284 0.553-0.422 0.128-0.709 0.516-0.712 0.956l-0.006 3.294h-2l0.003-3.294c0-0.444-0.291-0.831-0.712-0.959-0.897-0.269-1.731-0.75-2.412-1.391-0.322-0.303-0.803-0.359-1.188-0.138l-2.85 1.647-1-1.731 2.85-1.647c0.384-0.222 0.575-0.669 0.472-1.1-0.219-0.903-0.216-1.866 0.003-2.778 0.103-0.431-0.087-0.878-0.472-1.1l-2.853-1.65 1-1.728 2.85 1.647c0.384 0.222 0.866 0.166 1.188-0.141 0.334-0.316 0.712-0.597 1.122-0.834 0.403-0.234 0.837-0.422 1.287-0.556 0.422-0.128 0.713-0.516 0.713-0.956v-3.291h2v3.291c0 0.441 0.291 0.831 0.712 0.959 0.897 0.269 1.731 0.75 2.412 1.391 0.322 0.303 0.803 0.359 1.184 0.138l2.85-1.644 1 1.731-2.85 1.644c-0.384 0.222-0.575 0.669-0.472 1.1 0.219 0.903 0.216 1.866-0.003 2.778-0.103 0.431 0.087 0.878 0.472 1.1l2.853 1.65-1 1.728z" })
            );
        }
        function Gear({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GearSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Gear.SVG = GearSVG;
        return Gear;
    })();
export const Gear2 = /*#__PURE__*/ (() => {
        function Gear2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 8c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.206 0 4-1.794 4-4s-1.794-4-4-4zM12 15c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" }),
_('path', { d: "M12 10c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12 13c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M22.003 9h-1.516c-0.369-1.041-0.925-2.009-1.647-2.85l0.759-1.313c0.266-0.462 0.337-1.003 0.2-1.519s-0.469-0.947-0.931-1.216l-1.731-1c-0.956-0.55-2.181-0.222-2.731 0.731l-0.759 1.312c-0.544-0.097-1.094-0.147-1.647-0.147s-1.103 0.050-1.644 0.15l-0.759-1.312c-0.55-0.956-1.778-1.284-2.731-0.731l-1.731 1c-0.462 0.266-0.794 0.7-0.931 1.216s-0.069 1.056 0.2 1.519l0.759 1.313c-0.719 0.841-1.278 1.809-1.647 2.85h-1.519c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h1.516c0.369 1.041 0.925 2.009 1.647 2.85l-0.759 1.313c-0.266 0.462-0.338 1.003-0.2 1.519s0.469 0.947 0.931 1.216l1.731 1c0.316 0.181 0.656 0.269 0.997 0.269 0.691 0 1.366-0.359 1.734-1l0.759-1.313c0.541 0.1 1.091 0.15 1.644 0.15s1.103-0.050 1.644-0.15l0.759 1.313c0.369 0.641 1.044 1 1.734 1 0.338 0 0.681-0.087 0.997-0.269l1.731-1c0.462-0.266 0.794-0.697 0.931-1.216 0.138-0.516 0.069-1.056-0.2-1.519l-0.759-1.313c0.719-0.841 1.278-1.809 1.647-2.85h1.516c1.103 0 2-0.897 2-2v-2c0.006-1.106-0.891-2.003-1.994-2.003zM22.003 13h-2.256c-0.456 0-0.856 0.309-0.969 0.75-0.316 1.228-0.966 2.35-1.875 3.244-0.325 0.319-0.394 0.819-0.166 1.212l1.128 1.953-1.731 1-1.128-1.953c-0.228-0.394-0.694-0.584-1.134-0.462-0.606 0.169-1.237 0.253-1.875 0.253s-1.269-0.084-1.875-0.253c-0.441-0.122-0.906 0.069-1.134 0.462l-1.128 1.953-1.731-1 1.128-1.953c0.228-0.394 0.159-0.894-0.166-1.212-0.909-0.894-1.559-2.016-1.875-3.244-0.113-0.441-0.513-0.75-0.969-0.75h-2.256v-2h2.256c0.456 0 0.856-0.309 0.969-0.75 0.316-1.228 0.966-2.35 1.875-3.244 0.325-0.319 0.394-0.819 0.166-1.212l-1.128-1.953 1.731-1 1.128 1.953c0.228 0.394 0.694 0.584 1.134 0.462 0.606-0.169 1.238-0.253 1.875-0.253s1.269 0.084 1.875 0.253c0.441 0.122 0.906-0.069 1.134-0.462l1.128-1.953 1.731 1-1.128 1.953c-0.228 0.394-0.159 0.894 0.166 1.212 0.909 0.894 1.559 2.016 1.875 3.244 0.112 0.441 0.513 0.75 0.969 0.75h2.256v2z" })
            );
        }
        function Gear2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Gear2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Gear2.SVG = Gear2SVG;
        return Gear2;
    })();
export const Gear3 = /*#__PURE__*/ (() => {
        function Gear3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 8c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.206 0 4-1.794 4-4s-1.794-4-4-4zM12 15c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" }),
_('path', { d: "M12 10c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12 13c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M22 9h-1.512c-0.106-0.3-0.228-0.594-0.366-0.881l1.069-1.069c0.378-0.378 0.584-0.881 0.584-1.416s-0.209-1.038-0.584-1.416l-1.419-1.419c-0.775-0.775-2.037-0.778-2.819-0.009l-1.091 1.078c-0.281-0.134-0.572-0.253-0.863-0.356v-1.512c0-1.103-0.897-2-2-2h-2c-1.103 0-2 0.897-2 2v1.512c-0.3 0.106-0.594 0.228-0.881 0.366l-1.069-1.069c-0.378-0.378-0.881-0.584-1.416-0.584 0 0 0 0 0 0-0.534 0-1.038 0.209-1.416 0.584l-1.416 1.416c-0.378 0.378-0.584 0.881-0.584 1.416s0.209 1.038 0.584 1.416l1.069 1.069c-0.138 0.288-0.259 0.581-0.366 0.881h-1.506c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2h1.512c0.106 0.3 0.228 0.594 0.366 0.881l-1.069 1.069c-0.378 0.378-0.584 0.881-0.584 1.416s0.209 1.038 0.584 1.416l1.416 1.416c0.781 0.781 2.050 0.781 2.828 0l1.069-1.069c0.288 0.138 0.581 0.259 0.881 0.366v1.5c0 1.103 0.897 2 2 2h2c1.103 0 2-0.897 2-2v-1.512c0.3-0.106 0.594-0.228 0.881-0.366l1.069 1.069c0.378 0.378 0.881 0.584 1.416 0.584s1.038-0.209 1.416-0.584l1.419-1.419c0.775-0.775 0.778-2.041 0.009-2.819l-1.078-1.091c0.134-0.281 0.253-0.572 0.356-0.863h1.509c1.103 0 2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM22 13h-2.253c-0.456 0-0.856 0.309-0.969 0.75-0.156 0.612-0.413 1.231-0.741 1.791-0.228 0.391-0.166 0.884 0.153 1.206l1.591 1.613-1.419 1.419-1.594-1.594c-0.322-0.322-0.822-0.387-1.216-0.153-0.563 0.334-1.172 0.584-1.806 0.747-0.441 0.113-0.75 0.513-0.75 0.969v2.253h-2v-2.253c0-0.456-0.309-0.856-0.75-0.969-0.634-0.162-1.241-0.416-1.806-0.747-0.159-0.094-0.334-0.141-0.509-0.141-0.259 0-0.516 0.1-0.706 0.294l-1.594 1.594-1.416-1.416 1.594-1.594c0.322-0.322 0.387-0.822 0.153-1.216-0.334-0.563-0.584-1.172-0.747-1.806-0.113-0.441-0.513-0.75-0.969-0.75l-2.247 0.003v-2h2.253c0.456 0 0.856-0.309 0.969-0.75 0.162-0.634 0.416-1.241 0.747-1.806 0.231-0.394 0.169-0.894-0.153-1.216l-1.594-1.594 1.416-1.416 1.594 1.594c0.322 0.322 0.822 0.387 1.216 0.153 0.563-0.334 1.172-0.584 1.806-0.747 0.441-0.112 0.75-0.513 0.75-0.969v-2.25h2v2.253c0 0.456 0.309 0.856 0.75 0.969 0.612 0.156 1.231 0.412 1.791 0.741 0.391 0.228 0.884 0.166 1.206-0.153l1.613-1.591 1.419 1.419-1.594 1.594c-0.322 0.322-0.387 0.822-0.153 1.216 0.334 0.563 0.584 1.172 0.747 1.806 0.113 0.441 0.513 0.75 0.969 0.75h2.253v1.997z" })
            );
        }
        function Gear3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Gear3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Gear3.SVG = Gear3SVG;
        return Gear3;
    })();
export const Geek = /*#__PURE__*/ (() => {
        function GeekSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 2c4.094 0 7.619 2.472 9.166 6h-2.166v-0.5c0-0.828-0.672-1.5-1.5-1.5h-3c-0.828 0-1.5 0.672-1.5 1.5v0.6c-0.288-0.066-0.638-0.1-1-0.1s-0.712 0.034-1 0.1v-0.6c0-0.828-0.672-1.5-1.5-1.5h-3c-0.828 0-1.5 0.672-1.5 1.5v0.5h-2.166c1.547-3.528 5.072-6 9.166-6zM14 7.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v3c0 0.275-0.225 0.5-0.5 0.5h-3c-0.275 0-0.5-0.225-0.5-0.5v-3zM10 10.5c0 0.275-0.225 0.5-0.5 0.5h-3c-0.275 0-0.5-0.225-0.5-0.5v-3c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v3zM12 22c-5.512 0-10-4.488-10-10 0-1.044 0.162-2.053 0.459-3h2.541v1.5c0 0.828 0.672 1.5 1.5 1.5h3c0.828 0 1.5-0.672 1.5-1.5v-1.356c0.144-0.059 0.484-0.144 1-0.144s0.856 0.081 1 0.144v1.356c0 0.828 0.672 1.5 1.5 1.5h3c0.828 0 1.5-0.672 1.5-1.5v-1.5h2.541c0.3 0.947 0.459 1.956 0.459 3 0 5.513-4.488 10-10 10z" }),
_('path', { d: "M8 8c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM8 9c0 0 0 0 0 0v0z" }),
_('path', { d: "M16 10c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM16 9v0c0 0 0 0 0 0z" }),
_('path', { d: "M17.341 15.025c-3.894 1.3-6.791 1.3-10.684 0l-0.475-0.159-0.316 0.95 0.475 0.159c2.1 0.7 3.897 1.025 5.659 1.025s3.559-0.325 5.659-1.025l0.475-0.159-0.316-0.95-0.478 0.159z" })
            );
        }
        function Geek({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GeekSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Geek.SVG = GeekSVG;
        return Geek;
    })();
export const Gender = /*#__PURE__*/ (() => {
        function GenderSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 0h-5v2h2.584l-3.112 3.112c-0.978-0.7-2.178-1.113-3.472-1.113-3.309 0-6 2.691-6 6 0 2.969 2.166 5.437 5 5.916v3.084h-3v2h3v3h2v-3h3v-2h-3v-3.084c2.834-0.478 5-2.947 5-5.916 0-1.294-0.413-2.494-1.113-3.475l3.112-3.112v2.588h2v-5c0-0.553-0.447-1-1-1zM10 14c-2.206 0-4-1.794-4-4s1.794-4 4-4c2.206 0 4 1.794 4 4s-1.794 4-4 4z" }),
_('path', { d: "M10 7c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM10 12c-1.103 0-2-0.897-2-2s0.897-2 2-2c1.103 0 2 0.897 2 2s-0.897 2-2 2z" })
            );
        }
        function Gender({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GenderSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Gender.SVG = GenderSVG;
        return Gender;
    })();
export const Gender2 = /*#__PURE__*/ (() => {
    function Gender2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21 0h-5v2h2.584l-3.112 3.112c-0.978-0.7-2.178-1.113-3.472-1.113-0.687 0-1.359 0.116-2 0.341-0.641-0.228-1.313-0.341-2-0.341-3.309 0-6 2.691-6 6 0 2.969 2.166 5.437 5 5.916v3.084h-3v2h3v3h2v-3h3v-2h-3v-3.084c0.341-0.056 0.675-0.144 1-0.259 0.641 0.228 1.313 0.341 2 0.341 3.309 0 6-2.691 6-6 0-1.294-0.412-2.494-1.113-3.475l3.113-3.112v2.591h2v-5c0-0.553-0.447-1-1-1zM10 13.466c-1.241-0.716-2-2.019-2-3.466 0-1.444 0.759-2.75 2-3.466 1.241 0.716 2 2.019 2 3.466 0 1.444-0.759 2.75-2 3.466zM4 10c0-2.206 1.794-4 4-4 0.297 0 0.591 0.031 0.875 0.097-0.431 0.347-0.806 0.762-1.103 1.234-0.506 0.797-0.772 1.719-0.772 2.669s0.266 1.872 0.772 2.669c0.3 0.472 0.672 0.888 1.103 1.234-0.284 0.063-0.578 0.097-0.875 0.097-2.206 0-4-1.794-4-4zM12 14c-0.297 0-0.591-0.031-0.875-0.097 0.431-0.347 0.806-0.762 1.103-1.234 0.506-0.797 0.772-1.722 0.772-2.669s-0.266-1.872-0.772-2.669c-0.3-0.472-0.672-0.888-1.103-1.234 0.284-0.063 0.578-0.097 0.875-0.097 2.206 0 4 1.794 4 4s-1.794 4-4 4z" })
        );
    }
    function Gender2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Gender2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Gender2.SVG = Gender2SVG;
    return Gender2;
})();
export const GesturePinch = /*#__PURE__*/ (() => {
        function GesturePinchSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.5 10c-0.087 0-0.172 0.003-0.256 0.009-0.55-0.619-1.353-1.009-2.244-1.009-0.237 0-0.469 0.028-0.697 0.081-0.55-0.659-1.378-1.081-2.303-1.081v-2c0-1.653-1.347-3-3-3s-3 1.347-3 3v7.15l-1.128-0.738c-0.406-0.266-0.881-0.409-1.372-0.409-1.378 0-2.5 1.119-2.5 2.497 0 0.541 0.172 1.059 0.497 1.497 0 0.003 0.003 0.003 0.003 0.006l4.525 6.034c0.922 1.228 2.394 1.962 3.934 1.962h4.887c1.85 0 3.525-1.019 4.372-2.656v-0.003c1.166-2.262 1.781-4.803 1.781-7.341v-0.5c0-1.931-1.569-3.5-3.5-3.5zM22 14c0 2.222-0.537 4.444-1.556 6.425-0.503 0.972-1.497 1.575-2.597 1.575h-4.887c-0.916 0-1.788-0.434-2.334-1.162l-4.522-6.031c-0.047-0.063-0.103-0.169-0.103-0.306 0-0.275 0.225-0.497 0.5-0.497 0.1 0 0.194 0.028 0.275 0.081l2.678 1.753c0.306 0.2 0.7 0.219 1.022 0.044s0.525-0.513 0.525-0.881v-9c0-0.55 0.45-1 1-1s1 0.45 1 1v7h1v-2c0-0.175 0.047-0.347 0.134-0.5s0.216-0.278 0.366-0.366 0.322-0.134 0.5-0.134c0.55 0 1 0.45 1 1v2h1v-1c0-0.175 0.047-0.347 0.134-0.5s0.213-0.278 0.366-0.366c0.15-0.087 0.322-0.134 0.5-0.134 0.55 0 1 0.45 1 1v2h1v-1.916c0.159-0.056 0.328-0.084 0.5-0.084 0.828 0 1.5 0.672 1.5 1.5v0.5z" }),
_('path', { d: "M9.206 1.5l-0.706-0.706-2.5 2.5v-1.294h-1v2.5c0 0.275 0.225 0.5 0.5 0.5h2.5v-1h-1.294l2.5-2.5z" }),
_('path', { d: "M4.5 5h-2.5v1h1.294l-2.5 2.5 0.706 0.706 2.5-2.5v1.294h1v-2.5c0-0.275-0.225-0.5-0.5-0.5z" })
            );
        }
        function GesturePinch({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GesturePinchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        GesturePinch.SVG = GesturePinchSVG;
        return GesturePinch;
    })();
export const GestureZoom = /*#__PURE__*/ (() => {
        function GestureZoomSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.5 10c-0.087 0-0.172 0.003-0.256 0.009-0.55-0.619-1.353-1.009-2.244-1.009-0.237 0-0.469 0.028-0.697 0.081-0.55-0.659-1.378-1.081-2.303-1.081v-2c0-1.653-1.347-3-3-3s-3 1.347-3 3v7.15l-1.128-0.738c-0.406-0.266-0.881-0.409-1.372-0.409-1.378 0-2.5 1.119-2.5 2.497 0 0.541 0.172 1.059 0.497 1.497 0 0.003 0.003 0.003 0.003 0.006l4.525 6.034c0.922 1.228 2.394 1.962 3.934 1.962h4.887c1.85 0 3.525-1.019 4.372-2.656v-0.003c1.166-2.262 1.781-4.803 1.781-7.341v-0.5c0-1.931-1.569-3.5-3.5-3.5zM22 14c0 2.222-0.537 4.444-1.556 6.425-0.503 0.972-1.497 1.575-2.597 1.575h-4.887c-0.916 0-1.788-0.434-2.334-1.162l-4.522-6.031c-0.047-0.063-0.103-0.169-0.103-0.306 0-0.275 0.225-0.497 0.5-0.497 0.1 0 0.194 0.028 0.275 0.081l2.678 1.753c0.306 0.2 0.7 0.219 1.022 0.044s0.525-0.513 0.525-0.881v-9c0-0.55 0.45-1 1-1s1 0.45 1 1v7h1v-2c0-0.175 0.047-0.347 0.134-0.5s0.216-0.278 0.366-0.366 0.322-0.134 0.5-0.134c0.55 0 1 0.45 1 1v2h1v-1c0-0.175 0.047-0.347 0.134-0.5s0.213-0.278 0.366-0.366c0.15-0.087 0.322-0.134 0.5-0.134 0.55 0 1 0.45 1 1v2h1v-1.916c0.159-0.056 0.328-0.084 0.5-0.084 0.828 0 1.5 0.672 1.5 1.5v0.5z" }),
_('path', { d: "M8.5 1h-2.5v1h1.294l-5.294 5.294v-1.294h-1v2.5c0 0.275 0.225 0.5 0.5 0.5h2.5v-1h-1.294l5.294-5.294v1.294h1v-2.5c0-0.275-0.225-0.5-0.5-0.5z" })
            );
        }
        function GestureZoom({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GestureZoomSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        GestureZoom.SVG = GestureZoomSVG;
        return GestureZoom;
    })();
export const GhostDead = /*#__PURE__*/ (() => {
        function GhostDeadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.5 11.206l0.706-0.706-1.5-1.5 1.5-1.5-0.706-0.706-1.5 1.5-1.5-1.5-0.706 0.706 1.5 1.5-1.5 1.5 0.706 0.706 1.5-1.5z" }),
_('path', { d: "M16.5 6.794l-1.5 1.5-1.5-1.5-0.706 0.706 1.5 1.5-1.5 1.5 0.706 0.706 1.5-1.5 1.5 1.5 0.706-0.706-1.5-1.5 1.5-1.5z" }),
_('path', { d: "M8 14h2v1.5c0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5v-1.5h1v-1h-8v1zM14 15.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-1.5h3v1.5z" }),
_('path', { d: "M23.969 13.756c-0.016-0.066-0.175-0.672-0.559-1.287-0.594-0.947-1.45-1.469-2.409-1.469-0.55 0-1-0.45-1-1v-1c0-2.134-0.831-4.141-2.337-5.653-1.506-1.509-3.513-2.344-5.65-2.347h-0.028c-2.134 0.003-4.141 0.837-5.647 2.347-1.506 1.512-2.337 3.519-2.337 5.653v1c0 0.55-0.45 1-1 1-0.963 0-1.819 0.522-2.409 1.469-0.387 0.619-0.544 1.222-0.559 1.287-0.078 0.306-0.003 0.631 0.197 0.875 0.272 0.331 0.528 0.641 0.778 0.938 1.956 2.347 2.941 3.525 2.997 6.45 0.009 0.544 0.456 0.981 1 0.981 1.328 0 2.034-0.806 2.503-1.341 0.431-0.5 0.606-0.659 0.994-0.659s0.563 0.159 0.997 0.659c0.469 0.534 1.175 1.341 2.503 1.341s2.034-0.806 2.503-1.341c0.434-0.5 0.609-0.659 0.997-0.659s0.563 0.159 0.997 0.659c0.469 0.534 1.175 1.341 2.503 1.341 0.544 0 0.991-0.438 1-0.981 0.056-2.925 1.041-4.103 2.997-6.45 0.247-0.297 0.503-0.606 0.778-0.938 0.2-0.241 0.272-0.566 0.194-0.875zM2.541 14.291c-0.131-0.156-0.266-0.319-0.403-0.481 0.166-0.363 0.456-0.809 0.862-0.809 0.769 0 1.469-0.291 2-0.766v5.441c-0.6-1.156-1.444-2.169-2.459-3.384zM15.5 19c-1.328 0-2.034 0.806-2.503 1.341-0.434 0.5-0.609 0.659-0.997 0.659s-0.563-0.159-0.997-0.659c-0.469-0.534-1.175-1.341-2.503-1.341s-2.034 0.806-2.5 1.338v-10.287c0-0.016 0-0.034 0-0.050v-1c0-3.303 2.688-5.994 5.988-6h0.022c3.303 0.006 5.991 2.697 5.991 6v11.337c-0.469-0.534-1.175-1.338-2.5-1.338zM21.462 14.291c-1.016 1.219-1.859 2.231-2.463 3.387v-5.444c0.531 0.475 1.231 0.766 2 0.766 0.406 0 0.697 0.447 0.862 0.806-0.138 0.166-0.269 0.325-0.4 0.484z" })
            );
        }
        function GhostDead({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GhostDeadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        GhostDead.SVG = GhostDeadSVG;
        return GhostDead;
    })();
export const GhostNeutral = /*#__PURE__*/ (() => {
        function GhostNeutralSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9.5 10c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM9.5 8c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M14.5 7c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM14.5 9c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M8 12h8v1h-8v-1z" }),
_('path', { d: "M23.969 13.756c-0.016-0.066-0.175-0.672-0.559-1.287-0.594-0.947-1.45-1.469-2.409-1.469-0.55 0-1-0.45-1-1v-1c0-2.134-0.831-4.141-2.337-5.653-1.506-1.509-3.513-2.344-5.65-2.347h-0.028c-2.134 0.003-4.141 0.837-5.647 2.347-1.506 1.512-2.337 3.519-2.337 5.653v1c0 0.55-0.45 1-1 1-0.963 0-1.819 0.522-2.409 1.469-0.387 0.619-0.544 1.222-0.559 1.287-0.078 0.306-0.003 0.631 0.197 0.875 0.272 0.331 0.528 0.641 0.778 0.938 1.956 2.347 2.941 3.525 2.997 6.45 0.009 0.544 0.456 0.981 1 0.981 1.328 0 2.034-0.806 2.503-1.341 0.431-0.5 0.606-0.659 0.994-0.659s0.563 0.159 0.997 0.659c0.469 0.534 1.175 1.341 2.503 1.341s2.034-0.806 2.503-1.341c0.434-0.5 0.609-0.659 0.997-0.659s0.563 0.159 0.997 0.659c0.469 0.534 1.175 1.341 2.503 1.341 0.544 0 0.991-0.438 1-0.981 0.056-2.925 1.041-4.103 2.997-6.45 0.247-0.297 0.503-0.606 0.778-0.938 0.2-0.241 0.272-0.566 0.194-0.875zM2.541 14.291c-0.131-0.156-0.266-0.319-0.403-0.481 0.166-0.363 0.456-0.809 0.862-0.809 0.769 0 1.469-0.291 2-0.766v5.441c-0.6-1.156-1.444-2.169-2.459-3.384zM15.5 19c-1.328 0-2.034 0.806-2.503 1.341-0.434 0.5-0.609 0.659-0.997 0.659s-0.563-0.159-0.997-0.659c-0.469-0.534-1.175-1.341-2.503-1.341s-2.034 0.806-2.5 1.338v-10.287c0-0.016 0-0.034 0-0.050v-1c0-3.303 2.688-5.994 5.988-6h0.022c3.303 0.006 5.991 2.697 5.991 6v11.337c-0.469-0.534-1.175-1.338-2.5-1.338zM21.462 14.291c-1.016 1.219-1.859 2.231-2.463 3.387v-5.444c0.531 0.475 1.231 0.766 2 0.766 0.406 0 0.697 0.447 0.862 0.806-0.138 0.166-0.269 0.325-0.4 0.484z" })
            );
        }
        function GhostNeutral({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GhostNeutralSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        GhostNeutral.SVG = GhostNeutralSVG;
        return GhostNeutral;
    })();
export const Ghost = /*#__PURE__*/ (() => {
        function GhostSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.903 11.572c-0.166-0.35-0.519-0.572-0.903-0.572h-2c-0.55 0-1-0.45-1-1v-1c0-2.134-0.831-4.141-2.337-5.653-1.506-1.509-3.513-2.344-5.65-2.347h-0.028c-2.134 0.003-4.141 0.837-5.647 2.347-1.506 1.512-2.337 3.519-2.337 5.653v1c0 0.55-0.45 1-1 1h-2c-0.387 0-0.738 0.222-0.903 0.572s-0.116 0.762 0.131 1.062c2.475 3.022 3.709 6.091 3.772 9.384 0.009 0.544 0.456 0.981 1 0.981 1.328 0 2.034-0.806 2.503-1.341 0.434-0.5 0.609-0.659 0.997-0.659s0.563 0.159 0.997 0.659c0.469 0.534 1.175 1.341 2.503 1.341s2.034-0.806 2.503-1.341c0.434-0.5 0.609-0.659 0.997-0.659s0.563 0.159 0.997 0.659c0.469 0.534 1.175 1.341 2.503 1.341 0.544 0 0.991-0.438 1-0.981 0.063-3.294 1.297-6.366 3.775-9.384 0.244-0.3 0.294-0.713 0.128-1.062zM2.997 13h0.003c0.769 0 1.469-0.291 2-0.766v4.578c-0.056-0.147-0.113-0.291-0.172-0.438-0.466-1.137-1.081-2.266-1.831-3.375zM15.5 19c-1.328 0-2.034 0.806-2.503 1.341-0.434 0.5-0.609 0.659-0.997 0.659s-0.563-0.159-0.997-0.659c-0.469-0.534-1.175-1.341-2.503-1.341s-2.034 0.806-2.5 1.338v-10.287c0-0.016 0-0.034 0-0.050v-1c0-3.303 2.688-5.994 5.988-6h0.022c3.303 0.006 5.991 2.697 5.991 6v11.337c-0.469-0.534-1.175-1.338-2.5-1.338zM19.172 16.378c-0.059 0.147-0.116 0.291-0.172 0.438v-4.581c0.531 0.475 1.231 0.766 2 0.766h0.003c-0.75 1.109-1.366 2.238-1.831 3.378z" }),
_('path', { d: "M12 12c-0.553 0-1.087 0.288-1.459 0.784-0.35 0.466-0.541 1.075-0.541 1.716s0.191 1.25 0.541 1.716c0.375 0.5 0.906 0.784 1.459 0.784s1.087-0.288 1.459-0.784c0.35-0.466 0.541-1.075 0.541-1.716s-0.191-1.25-0.541-1.716c-0.372-0.497-0.906-0.784-1.459-0.784zM12 16c-0.541 0-1-0.687-1-1.5s0.459-1.5 1-1.5 1 0.687 1 1.5-0.456 1.5-1 1.5z" }),
_('path', { d: "M11 8.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5zM9.5 9c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M14.5 7c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM14.5 9c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" })
            );
        }
        function Ghost({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GhostSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ghost.SVG = GhostSVG;
        return Ghost;
    })();
export const Gift = /*#__PURE__*/ (() => {
    function GiftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21 6h-4.075c0.097-0.053 0.194-0.109 0.284-0.169 1.062-0.672 1.694-1.625 1.778-2.691 0.056-0.722-0.144-1.441-0.569-2.022-0.428-0.591-1.044-0.978-1.728-1.087-0.991-0.156-2.009 0.284-2.872 1.247-0.75 0.834-1.381 2.044-1.884 3.6-0.544-1.266-1.206-2.238-1.972-2.906-0.903-0.788-1.934-1.109-2.906-0.912-1.291 0.266-2.169 1.394-2.044 2.628 0.094 0.919 0.728 1.741 1.784 2.316h-3.797c-1.103 0-2 0.897-2 2v3.5c0 0.275 0.225 0.5 0.5 0.5h1.5v10c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-10.003h1.5c0.275 0 0.5-0.225 0.5-0.5v-3.5c0-1.103-0.897-2-2-2zM14 22h-4v-15h4v15zM14.566 1.944c0.559-0.622 1.15-0.944 1.728-0.944 0.081 0 0.162 0.006 0.241 0.019 0.881 0.141 1.538 1.056 1.459 2.047-0.106 1.344-1.578 2.778-5.347 2.925 0.494-1.803 1.153-3.194 1.919-4.047zM6.006 3.584c-0.072-0.722 0.466-1.388 1.25-1.55 0.119-0.025 0.237-0.037 0.363-0.037 0.556 0 1.144 0.25 1.688 0.722 0.775 0.675 1.459 1.797 1.994 3.266-3.725-0.131-5.187-1.35-5.294-2.4zM3 8h6v3h-6v-3zM5 12h4v10h-4v-10zM19 22h-4v-10h4v10zM15 11v-3h6v3h-6z" })
        );
    }
    function Gift({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GiftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Gift.SVG = GiftSVG;
    return Gift;
})();
export const GlassBroken = /*#__PURE__*/ (() => {
    function GlassBrokenSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.966 13.053c1.022-0.591 1.803-1.437 2.322-2.516 0.703-1.459 0.891-3.338 0.525-5.288-0.341-1.809-1.109-3.537-2.172-4.875-0.188-0.237-0.475-0.375-0.781-0.375h-7.722c-0.306 0-0.594 0.141-0.784 0.378-1.059 1.334-1.831 3.066-2.169 4.875-0.366 1.95-0.178 3.828 0.528 5.287 0.522 1.078 1.303 1.925 2.325 2.516 0.844 0.487 1.838 0.787 2.966 0.897v6.547c0 0.6-0.494 1.212-1.35 1.681-0.969 0.528-2.266 0.819-3.653 0.819v1h12v-1c-1.388 0-2.684-0.291-3.65-0.819-0.859-0.469-1.35-1.081-1.35-1.681v-6.547c1.128-0.109 2.122-0.409 2.966-0.9zM7.512 9.669c-1.109-2.297-0.319-5.591 1.128-7.669h5.653l-2.147 2.147c-0.112 0.112-0.166 0.275-0.141 0.434s0.125 0.294 0.269 0.366l1.641 0.822-0.291 1.163-3.759 1.253 0.316 0.95 3.156-1.053-0.447 1.784 0.969 0.244 1.122-4.484c0.056-0.228-0.053-0.462-0.263-0.569l-1.375-0.694 2.156-2.153c1.356 2.084 2.063 5.238 0.991 7.459-0.747 1.547-2.259 2.331-4.491 2.331s-3.741-0.784-4.488-2.331zM13.763 23h-3.525c1.094-0.631 1.763-1.512 1.763-2.5 0 0.987 0.669 1.869 1.762 2.5z" })
        );
    }
    function GlassBroken({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GlassBrokenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    GlassBroken.SVG = GlassBrokenSVG;
    return GlassBroken;
})();
export const GlassCocktail = /*#__PURE__*/ (() => {
    function GlassCocktailSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2.066 0.644c0.147-0.387 0.519-0.644 0.934-0.644h18c0.416 0 0.788 0.256 0.934 0.644s0.041 0.828-0.272 1.103l-8.663 7.703v11.050c0 0.6 0.494 1.212 1.35 1.681 0.966 0.528 2.262 0.819 3.65 0.819v1h-12v-1c1.387 0 2.684-0.291 3.65-0.819 0.859-0.469 1.35-1.081 1.35-1.681v-11.050l-8.666-7.703c-0.309-0.275-0.416-0.716-0.269-1.103zM12.191 3.522c1.15 0.378 2.247 0.738 4.225 0.216l3.078-2.737h-14.991l2.631 2.337c2.431-0.678 3.762-0.241 5.056 0.184zM8.044 4.147l3.956 3.516 3.009-2.675c-0.15 0.009-0.294 0.016-0.434 0.016-1.081 0-1.897-0.269-2.697-0.531-1.072-0.353-2.097-0.691-3.834-0.325zM10.238 23h3.525c-1.094-0.631-1.763-1.512-1.763-2.5 0 0.987-0.669 1.869-1.762 2.5z" })
        );
    }
    function GlassCocktail({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GlassCocktailSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    GlassCocktail.SVG = GlassCocktailSVG;
    return GlassCocktail;
})();
export const Glass = /*#__PURE__*/ (() => {
    function GlassSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.966 13.053c1.022-0.591 1.803-1.437 2.322-2.516 0.703-1.459 0.891-3.338 0.525-5.288-0.341-1.809-1.109-3.537-2.172-4.875-0.188-0.237-0.475-0.375-0.781-0.375h-7.722c-0.306 0-0.594 0.141-0.784 0.378-1.059 1.334-1.831 3.066-2.169 4.875-0.366 1.95-0.178 3.828 0.528 5.287 0.522 1.078 1.303 1.925 2.325 2.516 0.844 0.487 1.838 0.787 2.966 0.897v6.547c0 0.6-0.494 1.212-1.35 1.681-0.969 0.528-2.266 0.819-3.653 0.819v1h12v-1c-1.388 0-2.684-0.291-3.65-0.819-0.859-0.469-1.35-1.081-1.35-1.681v-6.547c1.128-0.109 2.122-0.409 2.966-0.9zM8.641 2h6.719c0.656 0.944 1.178 2.141 1.45 3.378-1.791 1.163-3.087 0.472-4.572-0.319-1.359-0.725-2.869-1.528-4.753-0.725 0.284-0.856 0.687-1.659 1.156-2.334zM7.512 9.669c-0.569-1.175-0.638-2.609-0.378-4.009 1.819-1.216 3.128-0.519 4.631 0.281 0.959 0.509 1.991 1.059 3.175 1.059 0.631 0 1.306-0.156 2.034-0.556 0.106 1.141-0.025 2.269-0.488 3.225-0.744 1.547-2.256 2.331-4.488 2.331s-3.741-0.784-4.488-2.331zM13.763 23h-3.525c1.094-0.631 1.763-1.512 1.763-2.5 0 0.987 0.669 1.869 1.762 2.5z" })
        );
    }
    function Glass({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GlassSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Glass.SVG = GlassSVG;
    return Glass;
})();
export const Glass2 = /*#__PURE__*/ (() => {
        function Glass2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 17.5c0-0.934 0.334-2.044 0.725-3.328 0.934-3.084 2.209-7.306 0.228-13.478-0.134-0.413-0.519-0.694-0.953-0.694h-8c-0.434 0-0.819 0.281-0.953 0.694-1.984 6.172-0.706 10.394 0.228 13.478 0.391 1.284 0.725 2.394 0.725 3.328 0 3.138-0.863 4.984-0.897 5.056-0.156 0.309-0.141 0.675 0.041 0.972s0.506 0.475 0.856 0.475h8c0.347 0 0.675-0.178 0.856-0.475s0.197-0.663 0.041-0.972c-0.034-0.072-0.897-1.919-0.897-5.056zM15.259 2c0.213 0.744 0.375 1.456 0.491 2.134-0.35-0.091-0.691-0.138-1.022-0.144-0.35-0.591-0.994-0.991-1.728-0.991-1.103 0-2 0.897-2 2 0 0.162 0.019 0.319 0.056 0.469-0.872 0.491-1.737 0.769-3.006 0.297 0.087-1.153 0.303-2.403 0.694-3.766h6.516zM14 5c0 0.55-0.45 1-1 1s-1-0.45-1-1 0.45-1 1-1 1 0.45 1 1zM9.416 22c0.166-0.591 0.337-1.356 0.45-2.278 0.659 0.181 1.387 0.278 2.134 0.278s1.475-0.097 2.134-0.278c0.112 0.922 0.284 1.688 0.45 2.278h-5.169zM14.809 13.594c-0.434 1.437-0.809 2.678-0.809 3.906 0 0.422 0.012 0.825 0.037 1.209-0.612 0.191-1.313 0.291-2.037 0.291s-1.425-0.103-2.037-0.291c0.025-0.381 0.037-0.784 0.037-1.209 0-1.228-0.375-2.469-0.809-3.906-0.569-1.881-1.225-4.050-1.188-6.791 0.45 0.138 0.881 0.206 1.3 0.206 0.084 0 0.169-0.003 0.253-0.009 0.772-0.053 1.416-0.337 1.972-0.65 0.366 0.4 0.891 0.65 1.472 0.65 1.1 0 1.994-0.894 2-1.991 0.288 0.031 0.588 0.103 0.903 0.219 0.378 3.503-0.419 6.138-1.094 8.366z" }),
_('path', { d: "M10.5 8c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM10.5 10c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M13 12c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1z" })
            );
        }
        function Glass2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Glass2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Glass2.SVG = Glass2SVG;
        return Glass2;
    })();
export const Glasses = /*#__PURE__*/ (() => {
        function GlassesSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 7c-2.116 0-3.928 1.322-4.659 3.181-0.544-0.697-1.391-1.147-2.341-1.147s-1.8 0.45-2.341 1.147c-0.731-1.859-2.544-3.181-4.659-3.181-2.756 0-5 2.244-5 5s2.244 5 5 5 5-2.244 5-5h0.034c0-1.084 0.881-1.966 1.966-1.966s1.966 0.881 1.966 1.966h0.034c0 2.756 2.244 5 5 5s5-2.244 5-5c0-2.756-2.244-5-5-5zM5 15c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3zM19 15c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" }),
_('path', { d: "M18.291 12.706c-0.391-0.387-0.387-1.022 0.003-1.416l-0.709-0.706c-0.778 0.784-0.778 2.053 0.003 2.828 0.391 0.387 0.903 0.581 1.416 0.581s1.025-0.194 1.413-0.584l-0.706-0.706c-0.394 0.391-1.028 0.391-1.419 0.003z" }),
_('path', { d: "M4.291 12.706c-0.387-0.387-0.387-1.025 0-1.416l-0.709-0.706c-0.778 0.781-0.778 2.050 0.003 2.828 0.391 0.387 0.903 0.581 1.416 0.581s1.025-0.194 1.413-0.584l-0.706-0.706c-0.391 0.391-1.025 0.391-1.416 0.003z" })
            );
        }
        function Glasses({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GlassesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Glasses.SVG = GlassesSVG;
        return Glasses;
    })();
export const Glasses2 = /*#__PURE__*/ (() => {
    function Glasses2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.828 10c-0.413-1.163-1.525-2-2.828-2s-2.416 0.837-2.828 2h-8.672c-0.275 0-0.5 0.225-0.5 0.5v0.453c0 2.763 2.222 5.041 4.984 5.047 2.766 0.006 5.016-2.238 5.016-5 0-1.103 0.897-2 2-2s2 0.897 2 2c0 2.763 2.25 5.006 5.016 5 2.763-0.006 4.984-2.284 4.984-5.047v-0.453c0-0.275-0.225-0.5-0.5-0.5h-8.672zM5 14c-1.653 0-3-1.347-3-3h6c0 1.653-1.347 3-3 3zM19 14c-1.653 0-3-1.347-3-3h6c0 1.653-1.347 3-3 3z" })
        );
    }
    function Glasses2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Glasses2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Glasses2.SVG = Glasses2SVG;
    return Glasses2;
})();
export const Golf = /*#__PURE__*/ (() => {
        function GolfSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.375 15.097c-0.784-0.338-1.894-0.6-3.297-0.778-2.484-0.319-5.359-0.319-7.078-0.319-1.062 0-2.066 0.063-3 0.184v-6.556l7.691-3.166c0.184-0.075 0.306-0.253 0.309-0.45s-0.109-0.381-0.288-0.466l-7.5-3.5c-0.066-0.031-0.138-0.047-0.213-0.047h-1.5c-0.275 0-0.5 0.225-0.5 0.5v14.063c-0.825 0.213-1.572 0.481-2.225 0.809-1.791 0.897-2.775 2.184-2.775 3.628s0.984 2.731 2.775 3.628c1.791 0.897 4.287 1.372 7.225 1.372 2.791 0 4.791-0.347 6.119-1.059 1.25-0.669 1.881-1.659 1.881-2.941 0-0.55 0.519-0.741 1.622-1.016 0.525-0.131 1.069-0.269 1.506-0.522 0.578-0.337 0.872-0.828 0.872-1.462 0-0.8-0.547-1.441-1.625-1.903zM14.256 3.972l-6.256 2.575v-5.494l6.256 2.919zM20.378 18.016c-0.525 0.131-1.069 0.269-1.506 0.522-0.578 0.338-0.872 0.828-0.872 1.463 0 0.897-0.444 1.572-1.353 2.059-1.163 0.625-3.063 0.941-5.647 0.941-2.781 0-5.125-0.438-6.775-1.266-1.434-0.719-2.225-1.691-2.225-2.734s0.791-2.016 2.225-2.734c0.525-0.263 1.119-0.487 1.775-0.669v1.462c-0.622 0.075-1.197 0.219-1.672 0.422-1.156 0.494-1.328 1.163-1.328 1.519s0.172 1.025 1.328 1.519c0.722 0.309 1.672 0.481 2.672 0.481s1.95-0.172 2.672-0.481c1.156-0.494 1.328-1.166 1.328-1.519s-0.172-1.025-1.328-1.519c-0.475-0.203-1.050-0.347-1.672-0.422v-1.866c0.925-0.128 1.931-0.191 3-0.191 1.694 0 4.531 0 6.953 0.309 2.572 0.325 4.047 0.941 4.047 1.688 0 0.55-0.519 0.741-1.622 1.016zM8 18.066c1.259 0.175 2 0.65 2 0.934 0 0.353-1.137 1-3 1s-3-0.647-3-1c0-0.284 0.741-0.759 2-0.934v0.934h2v-0.934z" }),
_('path', { d: "M14.5 17c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM14.5 19c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" })
            );
        }
        function Golf({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GolfSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Golf.SVG = GolfSVG;
        return Golf;
    })();
export const Gown = /*#__PURE__*/ (() => {
    function GownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18.994 20.881c-0.003-0.034-0.009-0.069-0.019-0.103-0.022-0.097-0.056-0.188-0.103-0.269-2.869-5.281-1.856-6.966-0.881-8.597 0.494-0.825 1.056-1.762 0.997-3.025-0.056-1.219-0.691-2.569-1.988-4.234v-3.653h-1v3.075l-0.166 0.394c-1.116 2.287-2.091 3.191-3.834 3.522-1.744-0.331-2.719-1.234-3.834-3.522l-0.166-0.394v-3.075h-1v3.634c-1.306 1.672-1.944 3.031-2 4.253-0.059 1.263 0.503 2.2 0.997 3.025 0.978 1.631 1.991 3.319-0.888 8.613-0.169 0.309-0.162 0.684 0.019 0.987 0.141 0.237 0.372 0.403 0.634 0.462 2.069 0.681 4.166 1.025 6.241 1.025h0.003c2.097 0 4.219-0.353 6.306-1.050 0.016-0.006 0.031-0.009 0.047-0.016 0.425-0.162 0.687-0.6 0.634-1.053zM7.431 20.384c1.1-2.25 1.613-4.137 1.559-5.744-0.056-1.719-0.734-2.85-1.278-3.759-0.475-0.794-0.744-1.275-0.716-1.903 0.031-0.659 0.403-1.491 1.137-2.522 0.347 0.525 0.7 0.944 1.084 1.287 0.728 0.653 1.584 1.050 2.697 1.247 0.028 0.006 0.059 0.006 0.087 0.006s0.059-0.003 0.087-0.006c1.113-0.197 1.969-0.594 2.697-1.247 0.381-0.341 0.731-0.756 1.075-1.278 0.728 1.028 1.1 1.856 1.131 2.512 0.028 0.628-0.237 1.109-0.716 1.903-0.544 0.909-1.225 2.041-1.278 3.759-0.053 1.606 0.459 3.494 1.563 5.747-3.038 0.809-6.097 0.809-9.131-0.003z" })
        );
    }
    function Gown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Gown.SVG = GownSVG;
    return Gown;
})();
export const Gradient = /*#__PURE__*/ (() => {
        function GradientSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M8 5h1v1h-1v-1z" }),
_('path', { d: "M8 9h1v1h-1v-1z" }),
_('path', { d: "M8 13h1v1h-1v-1z" }),
_('path', { d: "M8 17h1v1h-1v-1z" }),
_('path', { d: "M9 6h1v1h-1v-1z" }),
_('path', { d: "M9 8h1v1h-1v-1z" }),
_('path', { d: "M9 10h1v1h-1v-1z" }),
_('path', { d: "M9 12h1v1h-1v-1z" }),
_('path', { d: "M9 14h1v1h-1v-1z" }),
_('path', { d: "M9 16h1v1h-1v-1z" }),
_('path', { d: "M9 18h1v1h-1v-1z" }),
_('path', { d: "M10 5h1v1h-1v-1z" }),
_('path', { d: "M10 7h1v1h-1v-1z" }),
_('path', { d: "M10 9h1v1h-1v-1z" }),
_('path', { d: "M10 11h1v1h-1v-1z" }),
_('path', { d: "M10 13h1v1h-1v-1z" }),
_('path', { d: "M10 15h1v1h-1v-1z" }),
_('path', { d: "M10 17h1v1h-1v-1z" }),
_('path', { d: "M11 6h1v1h-1v-1z" }),
_('path', { d: "M11 10h1v1h-1v-1z" }),
_('path', { d: "M11 14h1v1h-1v-1z" }),
_('path', { d: "M11 18h1v1h-1v-1z" }),
_('path', { d: "M13 8h1v1h-1v-1z" }),
_('path', { d: "M13 12h1v1h-1v-1z" }),
_('path', { d: "M13 16h1v1h-1v-1z" }),
_('path', { d: "M16 6h1v1h-1v-1z" }),
_('path', { d: "M16 10h1v1h-1v-1z" }),
_('path', { d: "M16 14h1v1h-1v-1z" }),
_('path', { d: "M16 18h1v1h-1v-1z" }),
_('path', { d: "M9 4h1v1h-1v-1z" }),
_('path', { d: "M10 3h1v1h-1v-1z" }),
_('path', { d: "M11 4h1v1h-1v-1z" }),
_('path', { d: "M8 19v-1h-1v1h-1v-1h1v-1h1v-1h1v-1h-1v-1h-1v1h-1v-1h1v-1h1v-1h1v-1h-1v-1h-1v1h-1v-1h1v-1h1v-1h1v-1h-1v-1h-1v1h-1v-1h1v-1h1v-1h1v-1h-5.5c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h4.5v-1h1v-1h-1zM6 4v1h-1v-1h1zM4 7h1v1h1v1h-1v-1h-1v-1zM4 11h1v1h1v1h-1v-1h-1v-1zM5 20h-1v-1h1v1zM5 17v-1h-1v-1h1v1h1v1h-1z" }),
_('path', { d: "M9 20h1v1h-1v-1z" }),
_('path', { d: "M10 19h1v1h-1v-1z" }),
_('path', { d: "M11 20h1v1h-1v-1z" }),
_('path', { d: "M13 20h1v1h-1v-1z" }),
_('path', { d: "M13 4h1v1h-1v-1z" })
            );
        }
        function Gradient({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GradientSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Gradient.SVG = GradientSVG;
        return Gradient;
    })();
export const Graduation = /*#__PURE__*/ (() => {
    function GraduationSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23 15.084v-4.984l0.413-0.188c0.356-0.162 0.588-0.519 0.588-0.909s-0.228-0.747-0.588-0.909l-11-5c-0.263-0.119-0.566-0.119-0.828 0l-11 5c-0.356 0.159-0.584 0.516-0.584 0.906s0.228 0.747 0.588 0.909l3.412 1.553v5.538c0 0.709 0.344 2.050 2.656 3.041 1.444 0.619 3.341 0.959 5.344 0.959s3.9-0.341 5.344-0.959c2.313-0.991 2.656-2.331 2.656-3.041v-5.538l2-0.909v4.531c-0.581 0.206-1 0.762-1 1.416v2c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.653-0.419-1.209-1-1.416zM18 17c0 0.281-0.453 0.778-1.444 1.203-1.184 0.506-2.844 0.797-4.556 0.797s-3.372-0.291-4.556-0.797c-0.991-0.425-1.444-0.922-1.444-1.203v-4.628l5.587 2.541c0.131 0.059 0.272 0.091 0.413 0.091s0.281-0.031 0.413-0.091l5.587-2.541v4.628zM12 12.9l-8.584-3.9 8.584-3.9 8.584 3.9-8.584 3.9zM23 18h-1v-1.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v1.5z" })
        );
    }
    function Graduation({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GraduationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Graduation.SVG = GraduationSVG;
    return Graduation;
})();
export const Grape = /*#__PURE__*/ (() => {
    function GrapeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.612 18.472c0.247-0.434 0.387-0.938 0.387-1.472 0-1.059-0.553-1.994-1.387-2.528 0.247-0.434 0.387-0.938 0.387-1.472 0-1.059-0.553-1.994-1.387-2.528 0.247-0.434 0.387-0.938 0.387-1.472 0-1.234-0.75-2.297-1.819-2.756 1.116-0.494 2.363-1.287 3.666-2.538 0.172-0.166 0.203-0.431 0.075-0.631-0.131-0.2-0.384-0.281-0.606-0.194-1.241 0.497-2.594-0.366-4.025-1.281-0.956-0.612-1.944-1.244-2.962-1.491-1.231-0.297-2.3 0.009-3.269 0.938-0.016 0.012-0.028 0.028-0.044 0.041-0.366-0.072-0.731-0.109-1.097-0.109h-0.006c-1.172 0-2.269 0.378-3.219 1.097-0.2-0.181-0.416-0.356-0.65-0.522-1.481-1.044-3.456-1.553-6.044-1.553h-1v2h1c0.009 0 0.019 0 0.028 0-0.769 1.069-1.15 2.784-0.991 4.263 0.106 0.978 0.438 1.822 0.959 2.453-0.034 0.65 0.066 1.297 0.297 1.906 0.359 0.941 1.025 1.734 1.925 2.303 0.425 0.269 0.666 0.622 0.734 1.078 0.213 1.416-1.263 3.494-1.847 4.172l-0.325 0.378 0.756 0.653 0.328-0.378c0.097-0.112 2.403-2.813 2.078-4.972-0.113-0.753-0.513-1.35-1.191-1.778-1.069-0.672-1.569-1.609-1.716-2.516 0.553 0.291 1.206 0.438 1.944 0.438 1.184 0 2.2-0.591 2.712-1.581 0.431-0.834 0.406-1.772-0.072-2.45-0.306-0.434-1.066-1.128-2.738-0.903-1.147 0.156-2.106 1-2.581 2.216-0.159-0.397-0.234-0.797-0.272-1.128-0.197-1.831 0.566-3.681 1.369-4.094 3.569 0.325 4.544 1.941 5.656 3.781 0.484 0.8 1.006 1.662 1.769 2.397-1.072 0.459-1.825 1.525-1.825 2.763 0 1.059 0.553 1.994 1.387 2.528-0.247 0.434-0.387 0.938-0.387 1.472 0 1.059 0.553 1.994 1.387 2.528-0.247 0.434-0.387 0.938-0.387 1.472 0 1.653 1.347 3 3 3 0.534 0 1.038-0.141 1.472-0.387 0.534 0.834 1.469 1.387 2.528 1.387 0.534 0 1.038-0.141 1.472-0.387 0.534 0.834 1.469 1.387 2.528 1.387 1.653 0 3-1.347 3-3 0-1.059-0.553-1.994-1.388-2.528zM2.075 8.181c0.253-1.166 1.016-1.997 1.944-2.125 0.85-0.116 1.484 0.059 1.788 0.487 0.262 0.372 0.262 0.912 0.003 1.413-0.341 0.653-1.022 1.044-1.828 1.044-0.881 0-1.503-0.262-1.944-0.644 0.012-0.059 0.025-0.119 0.037-0.175zM16 15c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM14 12c0-0.55 0.45-1 1-1s1 0.45 1 1c0 0.55-0.45 1-1 1s-1-0.45-1-1zM20 18c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM19 14c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM18 10c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM14 9c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM12 11c0 0.55-0.45 1-1 1s-1-0.45-1-1 0.45-1 1-1 1 0.45 1 1zM12 14c0.55 0 1 0.45 1 1s-0.45 1-1 1c-0.55 0-1-0.45-1-1s0.45-1 1-1zM15.091 1.081c0.856 0.206 1.772 0.794 2.659 1.359 1.056 0.675 2.134 1.362 3.247 1.544-1.922 1.488-3.603 1.925-4.775 2-0.55-0.603-1.344-0.984-2.222-0.984-0.338 0-0.659 0.056-0.963 0.159-0.55-0.412-0.912-0.947-1.013-1.512-0.087-0.494 0.031-0.981 0.344-1.434 1.072 0.334 2.131 1.019 3.047 1.984l0.725-0.687c-0.753-0.797-1.584-1.419-2.475-1.856-0.169-0.084-0.341-0.159-0.509-0.225 0.597-0.419 1.209-0.525 1.934-0.347zM8.397 2.803c0.753-0.541 1.609-0.825 2.519-0.825h0.006c0.138 0 0.275 0.006 0.416 0.019-0.297 0.572-0.4 1.194-0.294 1.819 0.119 0.687 0.497 1.334 1.062 1.859-0.372 0.306-0.672 0.697-0.862 1.147-0.584-0.547-1.006-1.25-1.472-2.019-0.394-0.644-0.816-1.344-1.375-2zM13 20c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM17 21c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM21 22c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
        );
    }
    function Grape({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GrapeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Grape.SVG = GrapeSVG;
    return Grape;
})();
export const Grenade = /*#__PURE__*/ (() => {
    function GrenadeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19.95 13.559c-0.169-2.125-0.878-4.178-2.106-6.1-0.184-0.288-0.5-0.462-0.844-0.462h-0.047c-0.987-1.603-0.966-2.941-0.953-3.753 0-0.087 0.003-0.172 0.003-0.247h1v-1.997c0-0.553-0.447-1-1-1h-4.003c-0.266 0-0.519 0.106-0.706 0.294l-1.784 1.784c-0.681-1.237-2-2.078-3.509-2.078-2.206 0-4 1.794-4 4s1.794 4 4 4c0.225 0 0.444-0.019 0.659-0.053-0.131 0.228-0.256 0.469-0.369 0.716-0.409 0.894-0.709 1.916-0.916 3.125-0.375 2.209-0.375 4.641-0.375 7.212h1c0-4.947 0-9.622 2.784-12.128v0c0.75-0.728 1.216-1.747 1.216-2.869h2.013c0.019 0.744-0.022 1.666-0.941 3h-0.072c-0.341 0-0.659 0.175-0.844 0.462-1.231 1.922-1.941 3.975-2.106 6.1-0.134 1.697 0.075 3.438 0.622 5.169 0.925 2.928 2.494 4.831 2.562 4.909 0.191 0.228 0.472 0.359 0.769 0.359h4c0.297 0 0.578-0.131 0.769-0.359 0.066-0.078 1.638-1.981 2.562-4.909 0.541-1.737 0.75-3.478 0.616-5.175zM8.063 6.178c-0.016 0.016-0.031 0.028-0.047 0.044-0.534 0.484-1.241 0.778-2.016 0.778-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3c0 0.856-0.363 1.631-0.938 2.178zM16.675 20h-0.675v-2h1.462c-0.006 0.022-0.012 0.041-0.019 0.063-0.225 0.719-0.494 1.372-0.769 1.938zM16.441 9c0.381 0.656 0.694 1.322 0.938 2h-1.375v-2h0.438zM15 11h-2v-2h2v2zM13 14v-2h2v2h-2zM15 15v2h-2v-2h2zM12 9v2h-1.375c0.241-0.678 0.553-1.344 0.938-2h0.438zM12 12v2h-1.981c0.034-0.675 0.134-1.344 0.3-2h1.681zM12 15v2h-1.722c-0.147-0.675-0.234-1.341-0.263-2h1.984zM10.578 18.128c-0.012-0.044-0.028-0.084-0.041-0.128h1.462v2h-0.678c-0.262-0.547-0.525-1.175-0.744-1.872zM13 18h2v2h-2v-2zM16 17v-2h1.984c-0.028 0.659-0.116 1.325-0.263 2h-1.722zM16 14v-2h1.678c0.166 0.656 0.266 1.325 0.3 2h-1.978zM13.006 3.803c-0.003-0.106-0.006-0.209-0.006-0.303 0-0.275-0.225-0.5-0.5-0.5h-1.084l1-1h2.584v1c0 0.072 0 0.147-0.003 0.231-0.012 0.781-0.031 2.147 0.806 3.769h-3.553c0.809-1.416 0.778-2.469 0.756-3.197zM15.503 22h-3.006c-0.166-0.231-0.394-0.569-0.644-1h4.291c-0.25 0.428-0.478 0.769-0.641 1z" })
        );
    }
    function Grenade({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GrenadeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Grenade.SVG = GrenadeSVG;
    return Grenade;
})();
export const GridCross = /*#__PURE__*/ (() => {
        function GridCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h15.5c3.584 0 6.5-2.916 6.5-6.5v-15.5c0-1.103-0.897-2-2-2zM12.813 22h-3.813v-6h2.175c-0.116 0.481-0.175 0.984-0.175 1.5 0 1.744 0.691 3.331 1.812 4.5zM11.5 15h-2.5v-6h6v2.5c-1.578 0.659-2.841 1.922-3.5 3.5zM8 15h-6v-6h6v6zM9 8v-6h6v6h-6zM16 9h6v3.813c-1.169-1.122-2.756-1.812-4.5-1.812-0.516 0-1.019 0.059-1.5 0.175v-2.175zM22 8h-6v-6h6v6zM8 2v6h-6v-6h6zM2 16h6v6h-6v-6zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 14.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function GridCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GridCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        GridCross.SVG = GridCrossSVG;
        return GridCross;
    })();
export const Grid = /*#__PURE__*/ (() => {
    function GridSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 8h-6v-6h6v6zM9 15v-6h6v6h-6zM15 16v6h-6v-6h6zM8 15h-6v-6h6v6zM9 8v-6h6v6h-6zM16 9h6v6h-6v-6zM8 2v6h-6v-6h6zM2 16h6v6h-6v-6zM22 22h-6v-6h6v6c0 0 0 0 0 0z" })
        );
    }
    function Grid({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GridSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Grid.SVG = GridSVG;
    return Grid;
})();
export const GrinBraces = /*#__PURE__*/ (() => {
        function GrinBracesSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M8.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM8.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M15.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM15.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M4 12.5c0 1.897 0.856 3.8 2.353 5.228 1.534 1.466 3.541 2.272 5.647 2.272s4.113-0.806 5.647-2.272c1.497-1.428 2.353-3.331 2.353-5.228 0-0.275-0.225-0.5-0.5-0.5h-15c-0.275 0-0.5 0.225-0.5 0.5zM8 16h1v2.325c-0.722-0.337-1.384-0.787-1.95-1.325h0.95v-1zM10 18.706v-2.706h1v1h2v-1h1v2.706c-0.641 0.191-1.313 0.294-2 0.294s-1.359-0.103-2-0.294zM11 14v1h-1v-2h4v2h-1v-1h-2zM16.95 17c-0.566 0.537-1.228 0.987-1.95 1.325v-2.325h1v1h0.95zM18.419 15h-0.419v-1h-2v1h-1v-2h3.978c-0.066 0.697-0.259 1.372-0.559 2zM9 13v2h-1v-1h-2v1h-0.419c-0.3-0.628-0.494-1.303-0.559-2h3.978z" })
            );
        }
        function GrinBraces({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GrinBracesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        GrinBraces.SVG = GrinBracesSVG;
        return GrinBraces;
    })();
export const GrinEvil = /*#__PURE__*/ (() => {
        function GrinEvilSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M4 12.5c0 1.897 0.856 3.8 2.353 5.228 1.534 1.466 3.541 2.272 5.647 2.272s4.113-0.806 5.647-2.272c1.497-1.428 2.353-3.331 2.353-5.228 0-0.275-0.225-0.5-0.5-0.5h-15c-0.275 0-0.5 0.225-0.5 0.5zM10 18.706v-5.706h4v5.706c-0.641 0.191-1.313 0.294-2 0.294s-1.359-0.103-2-0.294zM15 18.325v-5.325h3.978c-0.209 2.281-1.812 4.316-3.978 5.325zM9 13v5.325c-2.166-1.009-3.769-3.044-3.978-5.325h3.978z" }),
_('path', { d: "M7.381 7.503c-0.237 0.266-0.381 0.616-0.381 0.997 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.181-0.031-0.356-0.091-0.516 0.194 0.009 0.394 0.016 0.591 0.016h0.5v-1h-0.5c-1.437 0-2.816-0.325-3.784-0.894l-0.431-0.253-0.506 0.863 0.431 0.253c0.356 0.209 0.747 0.387 1.172 0.534zM8.5 9c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M14.094 7.981c-0.059 0.162-0.094 0.337-0.094 0.519 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.387-0.147-0.741-0.387-1.006 0.413-0.147 0.794-0.322 1.141-0.525l0.431-0.253-0.506-0.862-0.431 0.253c-0.969 0.569-2.347 0.894-3.784 0.894h-0.5v1h0.5c0.213 0 0.422-0.006 0.631-0.019zM15.5 9c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" })
            );
        }
        function GrinEvil({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GrinEvilSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        GrinEvil.SVG = GrinEvilSVG;
        return GrinEvil;
    })();
export const GrinHappy = /*#__PURE__*/ (() => {
        function GrinHappySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M4 12.5c0 1.897 0.856 3.8 2.353 5.228 1.534 1.466 3.541 2.272 5.647 2.272s4.113-0.806 5.647-2.272c1.497-1.428 2.353-3.331 2.353-5.228 0-0.275-0.225-0.5-0.5-0.5h-15c-0.275 0-0.5 0.225-0.5 0.5zM10 18.706v-5.706h4v5.706c-0.641 0.191-1.313 0.294-2 0.294s-1.359-0.103-2-0.294zM15 18.325v-5.325h3.978c-0.209 2.281-1.812 4.316-3.978 5.325zM9 13v5.325c-2.166-1.009-3.769-3.044-3.978-5.325h3.978z" }),
_('path', { d: "M8.5 7.206l2 2 0.706-0.706-2.353-2.353c-0.194-0.194-0.513-0.194-0.706 0l-2.353 2.353 0.706 0.706 2-2z" }),
_('path', { d: "M15.5 7.206l2 2 0.706-0.706-2.353-2.353c-0.194-0.194-0.513-0.194-0.706 0l-2.353 2.353 0.706 0.706 2-2z" })
            );
        }
        function GrinHappy({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GrinHappySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        GrinHappy.SVG = GrinHappySVG;
        return GrinHappy;
    })();
export const Grin = /*#__PURE__*/ (() => {
        function GrinSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M8.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM8.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M15.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM15.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M4 12.5c0 1.897 0.856 3.8 2.353 5.228 1.534 1.466 3.541 2.272 5.647 2.272s4.113-0.806 5.647-2.272c1.497-1.428 2.353-3.331 2.353-5.228 0-0.275-0.225-0.5-0.5-0.5h-15c-0.275 0-0.5 0.225-0.5 0.5zM10 18.706v-5.706h4v5.706c-0.641 0.191-1.313 0.294-2 0.294s-1.359-0.103-2-0.294zM15 18.325v-5.325h3.978c-0.209 2.281-1.812 4.316-3.978 5.325zM9 13v5.325c-2.166-1.009-3.769-3.044-3.978-5.325h3.978z" })
            );
        }
        function Grin({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GrinSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Grin.SVG = GrinSVG;
        return Grin;
    })();
export const GroupCircle = /*#__PURE__*/ (() => {
    function GroupCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.928 20.244c-0.45-0.75-0.975-1.294-1.606-1.666-0.147-0.087-0.3-0.162-0.456-0.231 0.691-0.55 1.134-1.397 1.134-2.347 0-1.378-0.931-2.541-2.2-2.891-0.303-1.406-0.944-2.734-1.866-3.847-0.9-1.088-2.050-1.95-3.334-2.513-0.372-0.5-0.794-0.888-1.278-1.172-0.147-0.087-0.3-0.162-0.456-0.231 0.691-0.55 1.134-1.397 1.134-2.347 0-1.653-1.347-3-3-3s-3 1.347-3 3c0 0.95 0.444 1.797 1.134 2.347-0.156 0.066-0.309 0.144-0.456 0.231-0.481 0.284-0.903 0.669-1.278 1.172-1.287 0.563-2.434 1.428-3.334 2.513-0.922 1.113-1.566 2.441-1.866 3.847-1.269 0.35-2.2 1.512-2.2 2.891 0 0.95 0.444 1.797 1.134 2.347-0.156 0.066-0.309 0.144-0.456 0.231-0.631 0.372-1.156 0.916-1.606 1.666-0.141 0.231-0.069 0.534 0.159 0.681 1.144 0.722 2.378 1.075 3.769 1.075 0.709 0 1.378-0.091 2.016-0.278 1.65 1.469 3.772 2.278 5.984 2.278s4.334-0.809 5.984-2.278c0.638 0.188 1.306 0.278 2.016 0.278 1.391 0 2.625-0.353 3.769-1.078 0.228-0.144 0.3-0.447 0.159-0.678zM22 16c0 1.103-0.897 2-2 2s-2-0.897-2-2 0.897-2 2-2 2 0.897 2 2zM10 3c0-1.103 0.897-2 2-2s2 0.897 2 2-0.897 2-2 2c-1.103 0-2-0.897-2-2zM12 6c1.219 0 2.097 0.416 2.787 1.334-0.853 0.447-1.769 0.666-2.787 0.666s-1.934-0.219-2.787-0.666c0.691-0.919 1.569-1.334 2.787-1.334zM2 16c0-1.103 0.897-2 2-2s2 0.897 2 2-0.897 2-2 2-2-0.897-2-2zM1.212 20.334c0.691-0.919 1.569-1.334 2.787-1.334s2.097 0.416 2.787 1.334c-0.853 0.447-1.769 0.666-2.787 0.666s-1.934-0.219-2.787-0.666zM7.953 20.712c0.069-0.147 0.066-0.322-0.025-0.469-0.45-0.75-0.975-1.294-1.606-1.666-0.147-0.087-0.3-0.162-0.456-0.231 0.691-0.55 1.134-1.397 1.134-2.347 0-1.222-0.731-2.272-1.781-2.741 0.547-2.125 2.106-3.919 4.153-4.75 0.819 0.328 1.688 0.491 2.628 0.491s1.809-0.162 2.628-0.491c2.047 0.831 3.606 2.625 4.153 4.75-1.050 0.469-1.781 1.522-1.781 2.741 0 0.95 0.444 1.797 1.134 2.347-0.156 0.066-0.309 0.144-0.456 0.231-0.631 0.372-1.156 0.916-1.606 1.666-0.087 0.147-0.094 0.325-0.025 0.469-1.178 0.834-2.587 1.287-4.047 1.287s-2.869-0.453-4.047-1.287zM20 21c-1.019 0-1.934-0.219-2.787-0.666 0.691-0.919 1.569-1.334 2.787-1.334s2.097 0.416 2.787 1.334c-0.853 0.447-1.769 0.666-2.787 0.666z" })
        );
    }
    function GroupCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GroupCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    GroupCircle.SVG = GroupCircleSVG;
    return GroupCircle;
})();
export const GroupEdit = /*#__PURE__*/ (() => {
        function GroupEditSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.709 18.478c0.422-0.425 1.072-0.762 1.938-1.006 1.106-0.312 2.572-0.472 4.353-0.472v-2c-1.822 0-3.353 0.156-4.6 0.469-0.788-0.312-1.756-0.469-2.9-0.469-1.241 0-2.284 0.184-3.097 0.553-0.738 0.331-1.309 0.822-1.703 1.456-0.7 1.128-0.7 2.494-0.7 3.491 0 0.134 0.053 0.262 0.15 0.356 0.094 0.094 0.219 0.144 0.35 0.144 0.003 0 0.006 0 0.006 0l3.494-0.053c0 0.019 0 0.034 0 0.053v0.5c0 0.275 0.225 0.5 0.5 0.5h7.5v-1h-6c0-0.888 0-1.809 0.709-2.522zM1.003 19.994c0.016-0.816 0.094-1.725 0.547-2.456 0.641-1.034 1.934-1.538 3.95-1.538 0.434 0 0.837 0.025 1.209 0.072-0.563 0.278-1.034 0.609-1.419 0.994-0.906 0.912-1.175 1.969-1.256 2.878l-3.031 0.050z" }),
_('path', { d: "M5.5 14c1.338 0 2.591-0.6 3.434-1.591 1.069 0.987 2.5 1.591 4.066 1.591 3.309 0 6-2.691 6-6s-2.691-6-6-6c-2.412 0-4.5 1.434-5.45 3.494-0.628-0.322-1.331-0.494-2.050-0.494-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5zM13 4c2.206 0 4 1.794 4 4s-1.794 4-4 4c-2.206 0-4-1.794-4-4s1.794-4 4-4zM5.5 6c0.603 0 1.188 0.153 1.706 0.444-0.134 0.497-0.206 1.019-0.206 1.556 0 1.378 0.466 2.65 1.25 3.663-0.653 0.831-1.666 1.338-2.75 1.338-1.931 0-3.5-1.569-3.5-3.5s1.569-3.5 3.5-3.5z" }),
_('path', { d: "M23.438 11.562c-0.747-0.747-1.959-0.747-2.706 0l-7.084 7.084c-0.069 0.069-0.119 0.159-0.138 0.256l-0.5 2.5c-0.031 0.162 0.019 0.334 0.138 0.453 0.094 0.094 0.222 0.147 0.353 0.147 0.031 0 0.066-0.003 0.097-0.009l2.5-0.5c0.097-0.019 0.184-0.066 0.256-0.138l7.084-7.087c0.747-0.747 0.747-1.959 0-2.706zM15.753 20.541l-1.616 0.322 0.322-1.616 6.041-6.041 1.294 1.294-6.041 6.041zM22.731 13.563l-0.231 0.231-1.294-1.294 0.231-0.231c0.356-0.356 0.938-0.356 1.294 0 0.172 0.172 0.269 0.403 0.269 0.647s-0.097 0.472-0.269 0.647z" })
            );
        }
        function GroupEdit({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GroupEditSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        GroupEdit.SVG = GroupEditSVG;
        return GroupEdit;
    })();
export const GroupMinus = /*#__PURE__*/ (() => {
        function GroupMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.175 10.034c0.537-0.916 0.825-1.959 0.825-3.034 0-3.309-2.691-6-6-6-2.412 0-4.5 1.434-5.45 3.494-0.628-0.322-1.331-0.494-2.050-0.494-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5c1.338 0 2.591-0.6 3.434-1.591 0.853 0.787 1.938 1.331 3.138 1.519-0.231 0.347-0.428 0.719-0.588 1.109-1.172 0.063-2.2 0.206-3.087 0.428-0.787-0.312-1.756-0.469-2.897-0.469-1.241 0-2.284 0.184-3.097 0.553-0.738 0.334-1.309 0.825-1.703 1.459-0.7 1.128-0.7 2.494-0.7 3.491 0 0.134 0.053 0.262 0.15 0.356 0.094 0.094 0.219 0.144 0.35 0.144 0.003 0 0.006 0 0.006 0l3.494-0.053c0 0.019 0 0.034 0 0.053v0.5c0 0.275 0.225 0.5 0.5 0.5h8.313c1.184 1.231 2.847 2 4.688 2 3.584 0 6.5-2.916 6.5-6.5 0-3.356-2.556-6.125-5.825-6.466zM5.5 12c-1.931 0-3.5-1.569-3.5-3.5s1.569-3.5 3.5-3.5c0.603 0 1.188 0.153 1.706 0.444-0.134 0.497-0.206 1.019-0.206 1.556 0 1.378 0.466 2.65 1.25 3.663-0.653 0.831-1.666 1.338-2.75 1.338zM9 7c0-2.206 1.794-4 4-4s4 1.794 4 4c0 0.925-0.319 1.816-0.9 2.528 0 0 0 0.003-0.003 0.003-0.003 0.003-0.006 0.009-0.012 0.012 0 0.003-0.003 0.003-0.003 0.006-0.003 0.003-0.006 0.009-0.012 0.012 0 0-0.003 0.003-0.003 0.003-0.019 0.022-0.037 0.044-0.056 0.066v0c-0.747 0.856-1.812 1.35-2.95 1.366-0.003 0-0.003 0-0.006 0-0.009 0-0.016 0-0.025 0-0.003 0-0.003 0-0.006 0-0.009 0-0.016 0-0.025 0-2.203 0.003-3.997-1.791-3.997-3.997zM1.003 18.994c0.016-0.816 0.094-1.725 0.547-2.456 0.641-1.034 1.934-1.538 3.95-1.538 0.434 0 0.837 0.025 1.206 0.072-0.672 0.331-1.212 0.738-1.631 1.228-0.734 0.856-0.969 1.816-1.041 2.647l-3.031 0.047zM6 20c0-0.837 0-1.706 0.594-2.397 0.712-0.831 2.197-1.344 4.419-1.525-0.009 0.141-0.012 0.281-0.012 0.425 0 1.287 0.375 2.491 1.025 3.5h-6.025zM17.5 22c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M15 16h5v1h-5v-1z" })
            );
        }
        function GroupMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GroupMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        GroupMinus.SVG = GroupMinusSVG;
        return GroupMinus;
    })();
export const GroupPlus = /*#__PURE__*/ (() => {
        function GroupPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.175 10.034c0.537-0.916 0.825-1.959 0.825-3.034 0-3.309-2.691-6-6-6-2.412 0-4.5 1.434-5.45 3.494-0.628-0.322-1.331-0.494-2.050-0.494-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5c1.338 0 2.591-0.6 3.434-1.591 0.853 0.787 1.938 1.331 3.138 1.519-0.231 0.347-0.428 0.719-0.588 1.109-1.172 0.063-2.2 0.206-3.087 0.428-0.787-0.312-1.756-0.469-2.897-0.469-1.241 0-2.284 0.184-3.097 0.553-0.738 0.334-1.309 0.825-1.703 1.459-0.7 1.128-0.7 2.494-0.7 3.491 0 0.134 0.053 0.262 0.15 0.356 0.094 0.094 0.219 0.144 0.35 0.144 0.003 0 0.006 0 0.006 0l3.494-0.053c0 0.019 0 0.034 0 0.053v0.5c0 0.275 0.225 0.5 0.5 0.5h8.313c1.184 1.231 2.847 2 4.688 2 3.584 0 6.5-2.916 6.5-6.5 0-3.356-2.556-6.125-5.825-6.466zM5.5 12c-1.931 0-3.5-1.569-3.5-3.5s1.569-3.5 3.5-3.5c0.603 0 1.188 0.153 1.706 0.444-0.134 0.497-0.206 1.019-0.206 1.556 0 1.378 0.466 2.65 1.25 3.663-0.653 0.831-1.666 1.338-2.75 1.338zM9 7c0-2.206 1.794-4 4-4s4 1.794 4 4c0 0.925-0.319 1.816-0.9 2.528 0 0 0 0.003-0.003 0.003-0.003 0.003-0.006 0.009-0.012 0.012 0 0.003-0.003 0.003-0.003 0.006-0.003 0.003-0.006 0.009-0.012 0.012 0 0-0.003 0.003-0.003 0.003-0.019 0.022-0.037 0.044-0.056 0.066v0c-0.747 0.856-1.812 1.35-2.95 1.366-0.003 0-0.003 0-0.006 0-0.009 0-0.016 0-0.025 0-0.003 0-0.003 0-0.006 0-0.009 0-0.016 0-0.025 0-2.203 0.003-3.997-1.791-3.997-3.997zM1.003 18.994c0.016-0.816 0.094-1.725 0.547-2.456 0.641-1.034 1.934-1.538 3.95-1.538 0.434 0 0.837 0.025 1.206 0.072-0.672 0.331-1.212 0.738-1.631 1.228-0.734 0.856-0.969 1.816-1.041 2.647l-3.031 0.047zM6 20c0-0.837 0-1.706 0.594-2.397 0.712-0.831 2.197-1.344 4.419-1.525-0.009 0.141-0.012 0.281-0.012 0.425 0 1.287 0.375 2.491 1.025 3.5h-6.025zM17.5 22c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18 14h-1v2h-2v1h2v2h1v-2h2v-1h-2z" })
            );
        }
        function GroupPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GroupPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        GroupPlus.SVG = GroupPlusSVG;
        return GroupPlus;
    })();
export const Group = /*#__PURE__*/ (() => {
        function GroupSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.709 17.069c-1.381-1.394-3.903-2.069-7.709-2.069-1.822 0-3.353 0.156-4.6 0.469-0.788-0.312-1.756-0.469-2.9-0.469-1.241 0-2.284 0.184-3.097 0.553-0.738 0.331-1.309 0.822-1.703 1.456-0.7 1.128-0.7 2.494-0.7 3.491 0 0.134 0.053 0.263 0.15 0.356 0.094 0.094 0.219 0.144 0.35 0.144 0.003 0 0.006 0 0.006 0l3.494-0.053c0 0.019 0 0.034 0 0.053v0.5c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-0.5c0-1.047 0-2.631-1.291-3.931zM2.003 19.994c0.016-0.816 0.094-1.725 0.547-2.456 0.641-1.034 1.934-1.538 3.95-1.538 0.434 0 0.837 0.025 1.209 0.072-0.563 0.278-1.034 0.609-1.419 0.994-0.906 0.912-1.175 1.969-1.256 2.878l-3.031 0.050zM7 21c0-0.888 0-1.809 0.709-2.522 0.422-0.425 1.072-0.762 1.938-1.006 1.106-0.312 2.572-0.472 4.353-0.472s3.247 0.159 4.353 0.472c0.866 0.244 1.516 0.581 1.938 1.006 0.709 0.712 0.709 1.634 0.709 2.522h-14z" }),
_('path', { d: "M6.5 14c1.338 0 2.591-0.6 3.434-1.591 1.069 0.987 2.5 1.591 4.066 1.591 3.309 0 6-2.691 6-6s-2.691-6-6-6c-2.412 0-4.5 1.434-5.45 3.494-0.628-0.322-1.331-0.494-2.050-0.494-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5zM14 4c2.206 0 4 1.794 4 4s-1.794 4-4 4c-2.206 0-4-1.794-4-4s1.794-4 4-4zM6.5 6c0.603 0 1.188 0.153 1.706 0.444-0.134 0.497-0.206 1.019-0.206 1.556 0 1.378 0.466 2.65 1.25 3.663-0.653 0.831-1.666 1.338-2.75 1.338-1.931 0-3.5-1.569-3.5-3.5s1.569-3.5 3.5-3.5z" })
            );
        }
        function Group({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GroupSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Group.SVG = GroupSVG;
        return Group;
    })();
export const Group2 = /*#__PURE__*/ (() => {
        function Group2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 14h-3c-1.103 0-2 0.897-2 2v3c0 1.103 0.897 2 2 2h3c1.103 0 2-0.897 2-2v-3c0-1.103-0.897-2-2-2zM19 19h-3v-3h3v3c0 0 0 0 0 0z" }),
_('path', { d: "M7.5 16h-4c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5h4c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5zM7 20h-3v-3h3v3z" }),
_('path', { d: "M16.5 8h4c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5h-4c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5zM17 4h3v3h-3v-3z" }),
_('path', { d: "M8 3h-3c-1.103 0-2 0.897-2 2v3c0 1.103 0.897 2 2 2h3c1.103 0 2-0.897 2-2v-3c0-1.103-0.897-2-2-2zM8 8h-3c0 0 0 0 0 0v-3h3v3z" }),
_('path', { d: "M19 11h-2c-2.206 0-4-1.794-4-4v-2c0-2.756-2.244-5-5-5h-3c-2.756 0-5 2.244-5 5v3c0 2.756 2.244 5 5 5h2c2.206 0 4 1.794 4 4v2c0 2.756 2.244 5 5 5h3c2.756 0 5-2.244 5-5v-3c0-2.756-2.244-5-5-5zM23 19c0 2.206-1.794 4-4 4h-3c-2.206 0-4-1.794-4-4v-2c0-2.756-2.244-5-5-5h-2c-2.206 0-4-1.794-4-4v-3c0-2.206 1.794-4 4-4h3c2.206 0 4 1.794 4 4v2c0 2.756 2.244 5 5 5h2c2.206 0 4 1.794 4 4v3z" })
            );
        }
        function Group2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Group2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Group2.SVG = Group2SVG;
        return Group2;
    })();
export const Group3 = /*#__PURE__*/ (() => {
        function Group3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 15h-3c-1.103 0-2 0.897-2 2v3c0 1.103 0.897 2 2 2h3c1.103 0 2-0.897 2-2v-3c0-1.103-0.897-2-2-2zM20 20h-3v-3h3v3c0 0 0 0 0 0z" }),
_('path', { d: "M8.5 15h-4c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5h4c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5zM8 19h-3v-3h3v3z" }),
_('path', { d: "M19.5 4h-4c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5h4c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5zM19 8h-3v-3h3v3z" }),
_('path', { d: "M4 9h3c1.103 0 2-0.897 2-2v-3c0-1.103-0.897-2-2-2h-3c-1.103 0-2 0.897-2 2v3c0 1.103 0.897 2 2 2zM4 4h3v3h-3c0 0 0 0 0 0v-3z" }),
_('path', { d: "M19 0h-3c-2.756 0-5 2.244-5 5v2c0 2.206-1.794 4-4 4h-2c-2.756 0-5 2.244-5 5v3c0 2.756 2.244 5 5 5h3c2.756 0 5-2.244 5-5v-2c0-2.206 1.794-4 4-4h2c2.756 0 5-2.244 5-5v-3c0-2.756-2.244-5-5-5zM23 8c0 2.206-1.794 4-4 4h-2c-2.756 0-5 2.244-5 5v2c0 2.206-1.794 4-4 4h-3c-2.206 0-4-1.794-4-4v-3c0-2.206 1.794-4 4-4h2c2.756 0 5-2.244 5-5v-2c0-2.206 1.794-4 4-4h3c2.206 0 4 1.794 4 4v3z" })
            );
        }
        function Group3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Group3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Group3.SVG = Group3SVG;
        return Group3;
    })();
export const GuitarElectric = /*#__PURE__*/ (() => {
        function GuitarElectricSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.793 15.501l0.707-0.707 1.708 1.708-0.707 0.707-1.708-1.708z" }),
_('path', { d: "M23.853 0.147c-0.153-0.153-0.384-0.191-0.578-0.094l-4 2c-0.169 0.084-0.275 0.259-0.275 0.447v1.084l-6.416 6.416h-1.084c-0.072 0-0.141 0.016-0.206 0.044l-11 5c-0.188 0.084-0.303 0.275-0.294 0.481s0.147 0.384 0.341 0.447l5.763 1.922 1.922 5.763c0.066 0.194 0.244 0.331 0.447 0.341 0.009 0 0.019 0 0.025 0 0.194 0 0.375-0.112 0.456-0.294l5-11c0.028-0.066 0.044-0.134 0.044-0.206v-1.084l6.419-6.413h1.084c0.191 0 0.363-0.106 0.447-0.275l2-4c0.097-0.194 0.059-0.425-0.094-0.578zM13 12.391l-4.428 9.744-1.597-4.791c-0.050-0.15-0.166-0.266-0.316-0.316l-4.794-1.6 9.744-4.428h1.391v1.391zM21.191 4h-1.191v-1.191l2.381-1.191-1.191 2.381z" }),
_('path', { d: "M8.793 13.501l0.707-0.707 1.708 1.708-0.707 0.707-1.708-1.708z" })
            );
        }
        function GuitarElectric({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GuitarElectricSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        GuitarElectric.SVG = GuitarElectricSVG;
        return GuitarElectric;
    })();
export const GuitarPick = /*#__PURE__*/ (() => {
        function GuitarPickSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.487 4.7c-0.391-0.981-0.997-1.831-1.8-2.516-1.697-1.45-4.281-2.184-7.688-2.184s-5.991 0.734-7.688 2.184c-0.803 0.687-1.409 1.534-1.8 2.519-0.353 0.888-0.531 1.897-0.531 2.994 0 1.641 0.391 3.484 1.166 5.481 0.656 1.694 1.581 3.472 2.675 5.147 0.994 1.519 2.106 2.906 3.131 3.912 1.216 1.188 2.209 1.766 3.044 1.766s1.828-0.578 3.044-1.766c1.025-1.003 2.138-2.394 3.131-3.912 1.097-1.672 2.022-3.453 2.675-5.147 0.772-1.997 1.166-3.844 1.166-5.481 0.003-1.1-0.175-2.106-0.525-2.997zM16.7 16.922c-0.916 1.437-1.944 2.759-2.897 3.722-1.038 1.050-1.644 1.331-1.803 1.353-0.159-0.022-0.766-0.303-1.803-1.353-0.953-0.966-1.981-2.287-2.897-3.722-2.225-3.494-3.431-6.994-3.309-9.6 0.078-1.634 0.653-2.853 1.756-3.728 1.331-1.056 3.438-1.594 6.253-1.594s4.919 0.534 6.253 1.594c1.103 0.875 1.678 2.094 1.756 3.728 0.122 2.606-1.084 6.106-3.309 9.6z" }),
_('path', { d: "M17.272 4.122c-1.156-0.734-2.981-1.122-5.272-1.122s-4.116 0.387-5.272 1.122c-0.875 0.556-1.406 1.328-1.625 2.362-0.225 1.059-0.119 2.431 0.3 3.969 0.412 1.503 1.125 3.166 2.062 4.809 0.825 1.447 1.816 2.856 2.784 3.972 0.647 0.741 1.137 1.184 1.437 1.425 0.091 0.075 0.203 0.109 0.312 0.109 0.112 0 0.222-0.038 0.312-0.109 0.3-0.241 0.791-0.681 1.437-1.425 0.969-1.113 1.959-2.522 2.784-3.972 0.938-1.644 1.65-3.306 2.063-4.809 0.422-1.537 0.525-2.913 0.303-3.969-0.219-1.034-0.753-1.806-1.628-2.362zM17.634 10.188c-0.391 1.422-1.069 3.003-1.966 4.578-0.794 1.391-1.744 2.744-2.669 3.809-0.406 0.466-0.741 0.8-0.997 1.031-0.256-0.234-0.591-0.569-0.997-1.031-0.928-1.066-1.875-2.419-2.669-3.809-0.897-1.572-1.578-3.156-1.966-4.578-0.378-1.384-0.478-2.594-0.288-3.497 0.166-0.778 0.531-1.309 1.184-1.725 0.991-0.631 2.631-0.966 4.731-0.966s3.741 0.334 4.737 0.966c0.653 0.416 1.019 0.947 1.184 1.725 0.191 0.903 0.091 2.112-0.288 3.497z" })
            );
        }
        function GuitarPick({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GuitarPickSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        GuitarPick.SVG = GuitarPickSVG;
        return GuitarPick;
    })();
export const Guitar = /*#__PURE__*/ (() => {
        function GuitarSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.853 2.147l-2-2c-0.116-0.116-0.278-0.166-0.438-0.141-0.159 0.028-0.297 0.128-0.366 0.275-0.619 1.281-1.522 2.184-2.763 2.766-0.147 0.069-0.253 0.206-0.281 0.366s0.025 0.325 0.138 0.441l0.294 0.294-5.753 5.756c-0.809-0.653-1.522-0.941-2.197-0.9-1.025 0.063-1.656 0.866-2.216 1.575-0.363 0.459-0.703 0.894-1.069 1.028-0.141 0.053-0.384 0.125-0.663 0.209-1.872 0.559-5.759 1.725-6.441 4.422-0.194 0.766-0.106 1.587 0.256 2.447 0.381 0.9 1.084 1.869 2.088 2.872 0 0 0 0 0 0 1.003 1.003 1.969 1.706 2.872 2.088 0.563 0.237 1.106 0.356 1.631 0.356 0.278 0 0.55-0.034 0.813-0.1 2.7-0.681 3.866-4.569 4.425-6.438 0.084-0.281 0.156-0.522 0.209-0.666 0.134-0.366 0.569-0.706 1.028-1.069 0.709-0.559 1.512-1.191 1.575-2.216 0.041-0.675-0.247-1.388-0.9-2.197l5.756-5.756 0.294 0.294c0.094 0.094 0.222 0.147 0.353 0.147 0.028 0 0.056-0.003 0.087-0.006 0.159-0.028 0.297-0.131 0.366-0.281 0.581-1.238 1.484-2.144 2.766-2.763 0.147-0.072 0.247-0.206 0.275-0.366s-0.025-0.325-0.141-0.438zM13.997 13.453c-0.034 0.578-0.6 1.022-1.197 1.491-0.55 0.431-1.116 0.878-1.347 1.509-0.063 0.172-0.138 0.416-0.228 0.725-0.263 0.875-0.659 2.197-1.284 3.384-0.709 1.347-1.525 2.144-2.422 2.369-1.209 0.306-2.678-0.397-4.366-2.081v0c-1.688-1.688-2.388-3.156-2.081-4.366 0.228-0.9 1.025-1.713 2.369-2.422 1.184-0.625 2.509-1.022 3.384-1.284 0.309-0.094 0.553-0.166 0.722-0.228 0.628-0.231 1.075-0.8 1.509-1.347 0.472-0.597 0.916-1.162 1.491-1.197 0.553-0.034 1.284 0.397 2.175 1.278 0.881 0.884 1.309 1.616 1.275 2.169zM20.375 4.669l-1.044-1.044c0.941-0.563 1.709-1.331 2.291-2.297l1.053 1.053c-0.966 0.578-1.737 1.347-2.3 2.288z" }),
_('path', { d: "M7.5 14c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.122-2.5-2.5-2.5zM7.5 18c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" })
            );
        }
        function Guitar({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GuitarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Guitar.SVG = GuitarSVG;
        return Guitar;
    })();
export const Gun = /*#__PURE__*/ (() => {
        function GunSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 4v1h-21c-0.553 0-1 0.447-1 1v2c0 0.397 0.234 0.756 0.6 0.916 0.775 0.341 1.247 0.691 1.359 1.019 0.175 0.506-0.356 1.488-0.919 2.525-0.909 1.678-2.041 3.766-2.041 6.541 0 0.553 0.447 1 1 1h6.012c0.525 0 1.022-0.203 1.397-0.569s0.591-0.859 0.603-1.384c0.028-1.172 0.106-2.184 0.244-3.047h0.222c1.325 0 2.375 0 3.162-0.356 0.928-0.419 1.359-1.259 1.359-2.644v-1h8c1.103 0 2-0.897 2-2v-5h-1zM7.012 18c0 0 0 0 0 0h-4.95c0.225-1.8 1.022-3.269 1.734-4.587 0.372-0.687 0.725-1.338 0.944-1.959 0.056-0.156 0.1-0.306 0.138-0.453h3.687c-0.141 0.206-0.275 0.431-0.394 0.669-0.725 1.434-1.094 3.444-1.159 6.331zM13 12c0 1.916-0.788 2-3.522 2h-0.025c0.138-0.556 0.306-1.031 0.506-1.428 0.056-0.109 0.112-0.213 0.175-0.312 0.050 0.059 0.103 0.119 0.159 0.175 0.319 0.309 0.738 0.513 1.15 0.563l0.497 0.056 0.116-0.994-0.497-0.056c-0.303-0.034-0.609-0.262-0.741-0.513 0.444-0.334 0.994-0.491 1.681-0.491h0.5v1zM22 9h-9.5c-0.997 0-1.875 0.234-2.609 0.7-0.144 0.091-0.281 0.191-0.416 0.3h-4.488c-0.012-0.25-0.059-0.488-0.138-0.716-0.263-0.766-0.856-1.381-1.85-1.913v-0.372h19v2z" }),
_('path', { d: "M6 12.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M5 16.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Gun({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GunSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Gun.SVG = GunSVG;
        return Gun;
    })();
export const Hairdryer = /*#__PURE__*/ (() => {
        function HairdryerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.5 1.831c-2.128-0.55-7.606-1.831-12.5-1.831-1.594 0-3.094 0.619-4.225 1.741s-1.763 2.616-1.775 4.209c0 0.016 0 0.034 0 0.050v0c0 3.262 0.781 7.072 1.247 9.050 0.641 2.719 1.416 5.134 1.847 5.737 0.462 0.647 1.803 0.953 2.559 1.078 0.459 0.075 0.916 0.119 1.347 0.131v0.003c0 0.55-0.45 1-1 1h-6v1h6c1.103 0 2-0.897 2-2v-0.038c0.316-0.034 0.603-0.091 0.847-0.169 1.003-0.322 1.153-0.95 1.153-1.297 0-1.069-0.122-1.328-0.569-1.722-0.141-0.125-0.303-0.266-0.525-0.572-0.306-0.425-0.637-1.231-0.8-2.206h1.394c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5h-1.247c0.128-0.409 0.316-0.816 0.588-1.184 4.131-0.509 8.141-1.941 9.891-2.625 0.769-0.3 1.269-1.031 1.269-1.863v-3.559c0-0.909-0.616-1.706-1.5-1.934zM9 14v1h-0.994c0-0.047-0.003-0.094-0.003-0.141-0.003-0.266 0.006-0.556 0.044-0.859h0.953zM7.381 12.469c-0.262 0.722-0.391 1.531-0.378 2.403 0.019 1.469 0.456 3.044 1.091 3.922 0.288 0.4 0.522 0.603 0.678 0.738 0.138 0.119 0.15 0.138 0.166 0.184 0.056 0.156 0.063 0.522 0.063 0.784 0 0.162-0.25 0.278-0.456 0.344-0.616 0.197-1.662 0.213-2.728 0.037-1.116-0.184-1.788-0.503-1.906-0.672-0.253-0.356-0.966-2.316-1.688-5.388-0.284-1.212-0.691-3.125-0.956-5.159 0.15 0.191 0.309 0.372 0.484 0.547 1.153 1.156 2.681 1.794 4.309 1.794 0.009 0 0.019 0 0.028 0 0.503-0.003 1.012-0.025 1.522-0.063-0.087 0.166-0.162 0.344-0.228 0.528zM6.075 10c-1.097 0.006-2.131-0.422-2.909-1.203-0.759-0.762-1.175-1.769-1.166-2.831 0.019-2.187 1.812-3.966 4-3.966 4.666 0 9.947 1.234 12 1.766v3.559c-1.587 0.622-7.141 2.653-11.925 2.675z" }),
_('path', { d: "M6 3c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM6 8c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2z" }),
_('path', { d: "M24 3v1h-3v-1h3zM21 6h3v-1h-3v1zM21 8h3v-1h-3v1z" }),
_('path', { d: "M5 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M6 18.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Hairdryer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HairdryerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Hairdryer.SVG = HairdryerSVG;
        return Hairdryer;
    })();
export const Halloween = /*#__PURE__*/ (() => {
        function HalloweenSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.244 7.113c-0.578-0.947-1.263-1.697-2.031-2.228-0.85-0.588-1.762-0.884-2.712-0.884-0.744 0-1.466 0.184-2.153 0.544-0.794-1.737-1.972-2.853-2.844-3.491-0.994-0.731-1.809-1.016-1.841-1.025-0.181-0.063-0.381-0.016-0.516 0.119l-1 1c-0.097 0.097-0.15 0.231-0.147 0.369s0.066 0.269 0.169 0.359c0.253 0.228 0.947 1.003 0.787 1.569-0.113 0.4-0.669 0.738-1.584 0.966-0.603-0.272-1.228-0.406-1.872-0.406-0.95 0-1.863 0.297-2.709 0.884-0.772 0.534-1.453 1.284-2.031 2.228-1.134 1.853-1.759 4.3-1.759 6.884s0.625 5.031 1.756 6.884c0.578 0.947 1.263 1.697 2.031 2.228 0.847 0.588 1.759 0.884 2.709 0.884 0.756 0 1.491-0.188 2.184-0.563 1.059 0.372 2.172 0.563 3.316 0.563 1.141 0 2.256-0.188 3.316-0.563 0.697 0.372 1.428 0.563 2.184 0.563 0.95 0 1.863-0.297 2.709-0.884 0.772-0.534 1.453-1.284 2.031-2.228 1.137-1.853 1.762-4.3 1.762-6.884s-0.625-5.031-1.756-6.888zM10.616 1.091c0.291 0.134 0.778 0.384 1.325 0.791 0.866 0.641 1.569 1.422 2.103 2.328-0.669-0.138-1.35-0.209-2.047-0.209-0.416 0-0.825 0.025-1.231 0.075 0.066-0.116 0.116-0.241 0.153-0.369 0.244-0.881-0.312-1.725-0.719-2.2l0.416-0.416zM17.5 22c-0.334 0-0.669-0.069-0.997-0.209 0.456-0.263 0.891-0.566 1.297-0.909l0.381-0.322-0.644-0.766-0.381 0.325c-1.428 1.203-3.241 1.872-5.109 1.881 0 0 0 0 0 0-0.016 0-0.028 0-0.044 0s-0.028 0-0.044 0c0 0 0 0 0 0-1.869-0.009-3.684-0.678-5.112-1.881l-0.381-0.322-0.644 0.766 0.381 0.322c0.406 0.344 0.841 0.647 1.297 0.909-0.328 0.138-0.659 0.209-0.997 0.209-2.441 0-4.5-3.663-4.5-8s2.059-8 4.5-8c0.334 0 0.669 0.069 0.997 0.209-0.456 0.262-0.891 0.566-1.297 0.909l-0.381 0.322 0.644 0.766 0.381-0.322c1.431-1.203 3.244-1.872 5.112-1.881 0 0 0 0 0 0 0.016 0 0.028 0 0.044 0s0.028 0 0.044 0c0 0 0 0 0 0 1.869 0.009 3.684 0.678 5.112 1.881l0.381 0.322 0.644-0.766-0.381-0.322c-0.406-0.344-0.841-0.647-1.297-0.909 0.328-0.138 0.659-0.209 0.997-0.209 2.441 0 4.5 3.663 4.5 8-0.003 4.334-2.063 7.997-4.503 7.997z" }),
_('path', { d: "M9.941 12.734c0.087-0.162 0.078-0.359-0.025-0.513l-2-3c-0.094-0.141-0.25-0.222-0.416-0.222s-0.322 0.084-0.416 0.222l-2 3c-0.103 0.153-0.112 0.35-0.025 0.513s0.256 0.266 0.441 0.266h4c0.184 0 0.353-0.1 0.441-0.266zM6.434 12l1.066-1.6 1.066 1.6h-2.131z" }),
_('path', { d: "M16.909 9.222c-0.094-0.141-0.25-0.222-0.416-0.222s-0.322 0.084-0.416 0.222l-2 3c-0.103 0.153-0.112 0.35-0.025 0.513s0.256 0.266 0.441 0.266h4c0.184 0 0.353-0.1 0.441-0.266s0.078-0.359-0.025-0.513l-2-3zM15.428 12l1.066-1.6 1.066 1.6h-2.131z" }),
_('path', { d: "M17.5 15h-2c-0.131 0-0.259 0.053-0.353 0.147l-0.653 0.647-0.641-0.647c-0.094-0.094-0.222-0.147-0.353-0.147h-3c-0.131 0-0.259 0.053-0.353 0.147l-0.647 0.647-0.647-0.647c-0.094-0.094-0.222-0.147-0.353-0.147h-2c-0.275 0-0.5 0.225-0.5 0.5 0 0.056 0.009 0.109 0.025 0.156 0.053 1.172 0.691 2.259 1.806 3.075 1.119 0.819 2.6 1.269 4.169 1.269s3.050-0.45 4.169-1.269c1.116-0.816 1.753-1.903 1.806-3.075 0.016-0.050 0.025-0.103 0.025-0.156 0-0.275-0.225-0.5-0.5-0.5zM15.578 17.925c-0.95 0.694-2.219 1.075-3.578 1.075s-2.628-0.381-3.578-1.075c-0.734-0.537-1.2-1.206-1.35-1.925h1.219l0.853 0.853c0.194 0.194 0.513 0.194 0.706 0l0.853-0.853h2.584l0.847 0.853c0.094 0.094 0.222 0.147 0.353 0.147v0c0.131 0 0.259-0.053 0.353-0.147l0.859-0.853h1.222c-0.144 0.719-0.609 1.387-1.344 1.925z" })
            );
        }
        function Halloween({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HalloweenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Halloween.SVG = HalloweenSVG;
        return Halloween;
    })();
export const HammerWrench = /*#__PURE__*/ (() => {
    function HammerWrenchSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.331 17.975l-6.575-6.075 1.116-1.028c0.363 0.084 0.741 0.128 1.125 0.128 2.756 0 5-2.244 5-5 0-0.491-0.072-0.981-0.216-1.45-0.050-0.169-0.188-0.297-0.356-0.341-0.172-0.044-0.35 0.006-0.475 0.131l-1.656 1.659h-2.294v-2.294l1.659-1.659c0.125-0.125 0.175-0.303 0.131-0.475s-0.172-0.306-0.341-0.356c-0.469-0.144-0.959-0.216-1.45-0.216-2.756 0-5 2.244-5 5 0 0.334 0.031 0.659 0.094 0.975l-1.444 1.134-0.641-0.594c-0.006-0.006-0.012-0.009-0.016-0.016-0.369-0.325-0.828-0.491-1.284-0.5l-1.353-1.353c-0.225-0.225-0.353-0.55-0.353-0.897s0.128-0.672 0.353-0.897c0.831-0.834 2.131-0.853 2.144-0.853 0.222 0 0.416-0.144 0.478-0.356 0.063-0.209-0.019-0.438-0.2-0.559-0.066-0.044-1.647-1.084-3.278-1.084-1.991 0-3.009 0.803-3.353 1.147l-2 2c-0.094 0.094-0.147 0.222-0.147 0.353 0 0.259-0.087 0.878-0.353 1.147-0.284 0.284-0.941 0.353-1.147 0.353-0.131 0-0.259 0.053-0.353 0.147l-1 1c-0.194 0.194-0.194 0.513 0 0.706l3 3c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l1-1c0.094-0.094 0.147-0.222 0.147-0.353 0-0.766 0.209-1.275 0.594-1.434 0.319-0.131 0.753-0.012 1.053 0.288l1.356 1.356c0.009 0.459 0.172 0.916 0.494 1.284 0.006 0.006 0.012 0.012 0.019 0.022l0.184 0.2-7.859 6.175c-0.697 0.531-1 1.441-0.753 2.262 0.45 1.506 1.437 2.578 2.941 3.188 0 0 0.003 0 0.003 0 0.266 0.106 0.544 0.156 0.819 0.156 0.553 0 1.1-0.209 1.516-0.603l7.381-6.8 6.228 6.738c0.387 0.434 0.931 0.669 1.488 0.669 0.222 0 0.444-0.037 0.659-0.112 0 0 0.003 0 0.003 0 0.669-0.237 1.244-0.591 1.706-1.053 0.466-0.462 0.819-1.038 1.053-1.706 0.272-0.766 0.053-1.609-0.553-2.153zM19 2c0.094 0 0.188 0.003 0.284 0.009l-1.137 1.137c-0.094 0.094-0.147 0.222-0.147 0.353v3c0 0.275 0.225 0.5 0.5 0.5h3c0.131 0 0.259-0.053 0.353-0.147l1.137-1.137c0.006 0.094 0.009 0.188 0.009 0.284 0 2.206-1.794 4-4 4s-4-1.794-4-4 1.794-4 4-4zM14.913 8.875c0.284 0.403 0.628 0.762 1.019 1.069l-0.647 0.597-1.144-1.056 0.772-0.609zM5.209 7.141c-0.431 0.178-1.144 0.694-1.206 2.147l-0.503 0.506-2.294-2.294 0.509-0.509c0.381-0.031 1.15-0.15 1.638-0.638s0.606-1.256 0.637-1.638l1.863-1.863c0.2-0.2 0.984-0.853 2.647-0.853 0.513 0 1.034 0.134 1.481 0.303-0.447 0.169-0.925 0.431-1.338 0.844-0.406 0.409-0.644 0.994-0.644 1.603s0.234 1.194 0.647 1.603l0.956 0.956c-0.122 0.078-0.241 0.172-0.347 0.278l-0.672 0.672c-0.106 0.106-0.197 0.222-0.275 0.344l-0.956-0.956c-0.588-0.591-1.45-0.794-2.144-0.506zM4 20.931c-0.006 0.006-0.009 0.009-0.016 0.016-0.053 0.050-0.141 0.069-0.209 0.041-0.934-0.378-1.497-0.984-1.772-1.906-0.009-0.031 0.012-0.072 0.050-0.1 0.006-0.003 0.009-0.009 0.016-0.012l7.994-6.281 1.328 1.437-7.391 6.806zM20.469 21c-0.003 0-0.003-0.003 0 0-0.006-0.006-0.012-0.012-0.016-0.019l-10.453-11.306c0 0 0-0.003 0-0.003l0.672-0.672 11.309 10.45c0.006 0.003 0.009 0.009 0.016 0.012 0 0 0.003 0.003 0.003 0.003-0.272 0.772-0.759 1.259-1.531 1.534z" })
        );
    }
    function HammerWrench({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HammerWrenchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    HammerWrench.SVG = HammerWrenchSVG;
    return HammerWrench;
})();
export const Hammer = /*#__PURE__*/ (() => {
    function HammerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.331 17.975l-11.319-10.459c-0.006-0.006-0.012-0.009-0.016-0.016-0.369-0.325-0.828-0.491-1.284-0.5l-1.353-1.353c-0.225-0.225-0.353-0.55-0.353-0.897s0.128-0.672 0.353-0.897c0.828-0.834 2.128-0.853 2.141-0.853 0.222 0 0.416-0.144 0.478-0.356 0.063-0.209-0.019-0.438-0.2-0.559-0.066-0.044-1.647-1.084-3.278-1.084-1.991 0-3.009 0.803-3.353 1.147l-2 2c-0.094 0.094-0.147 0.222-0.147 0.353 0 0.259-0.087 0.878-0.353 1.147-0.284 0.284-0.941 0.353-1.147 0.353-0.131 0-0.259 0.053-0.353 0.147l-1 1c-0.194 0.194-0.194 0.513 0 0.706l3 3c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l1-1c0.094-0.094 0.147-0.222 0.147-0.353 0-0.766 0.209-1.275 0.594-1.434 0.319-0.131 0.753-0.012 1.053 0.288l1.356 1.356c0.009 0.459 0.172 0.916 0.494 1.284 0.006 0.006 0.012 0.012 0.019 0.022l10.463 11.319c0.387 0.434 0.931 0.669 1.488 0.669 0.222 0 0.444-0.038 0.659-0.113 0 0 0.003 0 0.003 0 0.669-0.237 1.244-0.591 1.706-1.053 0.466-0.462 0.819-1.038 1.053-1.706 0.269-0.769 0.050-1.613-0.556-2.156zM5.209 7.141c-0.431 0.178-1.144 0.694-1.206 2.147l-0.503 0.506-2.294-2.294 0.509-0.509c0.381-0.031 1.15-0.15 1.638-0.638s0.606-1.256 0.637-1.638l1.863-1.863c0.2-0.2 0.984-0.853 2.647-0.853 0.513 0 1.034 0.134 1.481 0.303-0.447 0.169-0.925 0.431-1.338 0.844-0.406 0.409-0.644 0.994-0.644 1.603s0.234 1.194 0.647 1.603l0.956 0.956c-0.122 0.078-0.241 0.172-0.347 0.278l-0.672 0.672c-0.106 0.106-0.197 0.222-0.275 0.344l-0.956-0.956c-0.588-0.591-1.45-0.794-2.144-0.506zM20.469 21c-0.003 0-0.003-0.003 0 0-0.006-0.006-0.012-0.012-0.016-0.019l-10.453-11.306c0 0 0-0.003 0-0.003l0.672-0.672 11.309 10.45c0.006 0.003 0.009 0.009 0.016 0.012 0 0 0.003 0.003 0.003 0.003-0.272 0.772-0.759 1.259-1.531 1.534z" })
        );
    }
    function Hammer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HammerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Hammer.SVG = HammerSVG;
    return Hammer;
})();
export const Hammer2 = /*#__PURE__*/ (() => {
        function Hammer2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.559 12.147l0.294-0.294c0.194-0.194 0.194-0.513 0-0.706l-1.294-1.294 1.294-1.294 0.294 0.294c0.094 0.094 0.222 0.147 0.353 0.147 2.472 0 2.5-1.437 2.5-1.5 0-0.131-0.053-0.259-0.147-0.353l-7-7c-0.094-0.094-0.222-0.147-0.353-0.147-0.063 0-1.5 0.028-1.5 2.5 0 0.131 0.053 0.259 0.147 0.353l0.294 0.294-5.294 5.294-0.294-0.294c-0.094-0.094-0.222-0.147-0.353-0.147-2.472 0-2.5 1.437-2.5 1.5 0 0.131 0.053 0.259 0.147 0.353l7 7c0.094 0.094 0.222 0.147 0.353 0.147 0.063 0 1.5-0.028 1.5-2.5 0-0.131-0.053-0.259-0.147-0.353l-0.294-0.294 1.294-1.294 1.294 1.294c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l0.294-0.294 10.397 10.397 1.416-1.416-10.4-10.394zM9.372 1.081l6.547 6.547c-0.144 0.159-0.497 0.341-1.216 0.369l-5.7-5.7c0.028-0.719 0.209-1.072 0.369-1.216zM7.628 15.919l-6.547-6.547c0.144-0.159 0.497-0.341 1.216-0.369l5.7 5.7c-0.028 0.719-0.209 1.072-0.369 1.216zM4.559 9.853l5.294-5.294 2.584 2.584-5.291 5.297-2.587-2.588zM10.559 11.853l1.294-1.294 0.941 0.941-1.294 1.294-0.941-0.941z" }),
_('path', { d: "M11 20h-7c-1.103 0-2 0.897-2 2h-1v2h13v-2h-1c0-1.103-0.897-2-2-2zM4 21h7c0.55 0 1 0.45 1 1h-9c0-0.55 0.45-1 1-1z" })
            );
        }
        function Hammer2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Hammer2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Hammer2.SVG = Hammer2SVG;
        return Hammer2;
    })();
export const HandGrip = /*#__PURE__*/ (() => {
    function HandGripSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17.5 6c-0.087 0-0.172 0.003-0.256 0.009-0.55-0.619-1.353-1.009-2.244-1.009-0.237 0-0.469 0.028-0.697 0.081-0.55-0.659-1.378-1.081-2.303-1.081s-1.753 0.422-2.303 1.081c-0.225-0.053-0.459-0.081-0.697-0.081-1.653 0-3 1.347-3 3v2c-1.653 0-3 1.347-3 3 0 0.656 0.206 1.281 0.597 1.8l2.428 3.237c0.922 1.228 2.394 1.962 3.934 1.962h4.887c1.85 0 3.525-1.019 4.372-2.656 0 0 0-0.003 0-0.003 1.166-2.262 1.781-4.803 1.781-7.341v-0.5c0-1.931-1.569-3.5-3.5-3.5zM14.444 7.169c0.166-0.109 0.359-0.169 0.556-0.169 0.55 0 1 0.45 1 1v2h1v-1.913c0.159-0.056 0.328-0.087 0.5-0.087 0.828 0 1.5 0.672 1.5 1.5v0.5c0 2.222-0.537 4.444-1.556 6.425-0.506 0.972-1.5 1.575-2.597 1.575h-4.887c-0.916 0-1.788-0.434-2.334-1.163l-2.428-3.237c-0.128-0.172-0.197-0.381-0.197-0.6 0-0.55 0.45-1 1-1h1c0.553 0 1-0.447 1-1v-3c0-0.55 0.45-1 1-1 0.2 0 0.391 0.059 0.559 0.169 0.125 0.084 0.231 0.197 0.309 0.331 0.087 0.153 0.134 0.325 0.134 0.5v1h1v-2c0-0.55 0.45-1 1-1s1 0.45 1 1v2h1v-1c0-0.175 0.047-0.35 0.134-0.5 0.072-0.134 0.178-0.247 0.306-0.331z" })
        );
    }
    function HandGrip({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HandGripSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    HandGrip.SVG = HandGripSVG;
    return HandGrip;
})();
export const HandSoap = /*#__PURE__*/ (() => {
        function HandSoapSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.141 9.891l-0.25 0.969 0.484 0.125c1.216 0.316 2.419 1.953 2.628 3.578l0.063 0.497 0.991-0.128-0.063-0.497c-0.119-0.928-0.525-1.922-1.113-2.731-0.638-0.878-1.441-1.478-2.259-1.688l-0.481-0.125z" }),
_('path', { d: "M20 3v-2.5c0-0.275-0.225-0.5-0.5-0.5h-12.5v2h3v3c-1.103 0-2 0.897-2 2v0.422c-2.447 1.556-4 4.631-4 8.022 0 1.85 0.456 3.628 1.322 5.144s2.072 2.666 3.494 3.319c0.131 0.059 0.275 0.091 0.419 0.091h5.534c0.144 0 0.288-0.031 0.419-0.094 1.419-0.656 2.625-1.803 3.491-3.319s1.322-3.294 1.322-5.144c0-3.391-1.553-6.466-4-8.022v-0.419c0-1.103-0.897-2-2-2v-3h5v1h1zM14.538 22h-5.072c-2.081-1.072-3.466-3.675-3.466-6.556 0-0.097 0-0.191 0.003-0.284 1.816-0.528 3.756 0.363 5.797 1.3 1.669 0.766 3.375 1.547 5.072 1.547 0.256 0 0.513-0.019 0.766-0.056-0.537 1.809-1.65 3.303-3.1 4.050zM14.541 8.887c2.1 1.088 3.459 3.663 3.459 6.556 0 0.487-0.041 0.969-0.116 1.434-1.772 0.456-3.672-0.416-5.666-1.328-2.013-0.922-4.078-1.872-6.119-1.447 0.347-2.328 1.591-4.3 3.359-5.216 0.331-0.172 0.541-0.513 0.541-0.888v-1h4v1c0 0.375 0.209 0.716 0.541 0.888zM13 5h-2v-3h2v3z" })
            );
        }
        function HandSoap({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HandSoapSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HandSoap.SVG = HandSoapSVG;
        return HandSoap;
    })();
export const HandTruck = /*#__PURE__*/ (() => {
        function HandTruckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.647 15.931l-0.725-1.866-8.066 3.138c-0.513-0.525-1.172-0.909-1.906-1.091l-6.019-15.475c-0.113-0.284-0.347-0.503-0.641-0.594s-0.609-0.041-0.862 0.134l-3.25 2.25 1.137 1.644 2.209-1.528 5.3 13.631c-1.631 0.503-2.825 2.028-2.825 3.825 0 2.206 1.794 4 4 4s4-1.794 4-4c0-0.359-0.047-0.709-0.138-1.041l7.784-3.028zM11 23c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" }),
_('path', { d: "M11 18c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2zM11 21c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M13.034 15.681c0.047 0.125 0.144 0.222 0.266 0.275 0.066 0.028 0.131 0.044 0.2 0.044 0.063 0 0.122-0.012 0.181-0.034l8-3.113c0.125-0.047 0.222-0.144 0.275-0.266s0.056-0.259 0.009-0.381l-3.050-7.838c-0.1-0.256-0.391-0.384-0.647-0.284l-4.566 1.775-1.781-4.584c-0.1-0.256-0.391-0.384-0.647-0.284l-2.969 1.153c-0.125 0.047-0.222 0.144-0.278 0.266-0.053 0.122-0.056 0.259-0.009 0.381l5.016 12.891zM18.166 5.197l2.688 6.906-4.1 1.594-2.684-6.906 4.097-1.594zM11.172 2.103l4.65 11.956-2.037 0.791-4.65-11.956 2.037-0.791z" })
            );
        }
        function HandTruck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HandTruckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HandTruck.SVG = HandTruckSVG;
        return HandTruck;
    })();
export const Handwriting = /*#__PURE__*/ (() => {
        function HandwritingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.353 10.353l7.084-7.084c0.747-0.747 0.747-1.959 0-2.706s-1.959-0.747-2.706 0l-7.084 7.084c-0.069 0.069-0.119 0.159-0.138 0.256l-0.5 2.5c-0.031 0.162 0.019 0.334 0.138 0.453 0.094 0.094 0.222 0.147 0.353 0.147 0.031 0 0.066-0.003 0.097-0.009l2.5-0.5c0.097-0.022 0.188-0.072 0.256-0.141zM9.731 1.269c0.356 0.356 0.356 0.938 0 1.294l-0.231 0.231-1.294-1.294 0.231-0.231c0.356-0.356 0.938-0.356 1.294 0zM1.137 9.863l0.322-1.616 6.041-6.041 1.294 1.294-6.041 6.041-1.616 0.322z" }),
_('path', { d: "M22.447 19.153c-2.031 2.456-3.922 3.391-5.059 2.5-1.125-0.881-1.619-3.294-1.263-6.144 0.056-0.45 0.131-0.903 0.225-1.359 2.609-0.144 4.6-0.147 4.647-0.147v-2c-0.178 0-1.847 0.003-4.113 0.112 0.806-2.544 2.147-5.128 3.916-7.519 0.262-0.353 0.262-0.834 0.003-1.188s-0.719-0.497-1.134-0.353c-4.978 1.731-8.206 5.775-10.897 9.881-1.609 0.288-3.081 0.659-4.178 1.147l0.813 1.828c0.528-0.234 1.162-0.441 1.869-0.619-0.072 0.119-0.147 0.234-0.219 0.35-1.656 2.653-3.219 5.159-4.975 6.738l1.338 1.488c1.966-1.766 3.6-4.387 5.334-7.166 0.4-0.637 0.806-1.291 1.222-1.941 1.4-0.216 2.897-0.369 4.319-0.478-0.059 0.328-0.106 0.653-0.147 0.975-0.219 1.741-0.162 3.375 0.159 4.728 0.341 1.437 0.984 2.556 1.856 3.241 0.644 0.503 1.4 0.759 2.209 0.759 0.491 0 1.003-0.094 1.522-0.284 1.328-0.487 2.706-1.591 4.1-3.275l-1.547-1.275zM11.453 12.547c1.609-2.287 3.441-4.444 5.697-5.984-1.047 1.863-1.853 3.781-2.388 5.678-1.066 0.075-2.191 0.175-3.309 0.306z" })
            );
        }
        function Handwriting({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HandwritingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Handwriting.SVG = HandwritingSVG;
        return Handwriting;
    })();
export const Hanger = /*#__PURE__*/ (() => {
    function HangerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.378 16.759c-0.406-0.641-0.981-1.15-1.666-1.475-0.441-0.209-0.909-0.425-1.366-0.634-1.397-0.641-2.841-1.306-3.903-2.009-0.944-0.628-1.444-1.194-1.444-1.641 0-0.553-0.447-1-1-1h-1v-1.172c1.162-0.413 2-1.525 2-2.828 0-1.653-1.347-3-3-3s-3 1.347-3 3h1c0-1.103 0.897-2 2-2s2 0.897 2 2-0.897 2-2 2c-0.266 0-0.519 0.106-0.706 0.294s-0.294 0.441-0.294 0.706v1h-1c-0.553 0-1 0.447-1 1 0 0.447-0.5 1.013-1.447 1.641-1.062 0.703-2.506 1.366-3.903 2.009-0.453 0.209-0.922 0.425-1.362 0.634-0.684 0.325-1.263 0.834-1.666 1.475-0.406 0.641-0.622 1.378-0.622 2.137v2.103h2v-1h20v1h2v-2.103c0-0.759-0.216-1.497-0.622-2.137zM13 11c0 0.791 0.337 1.481 0.9 2.106-0.925-0.106-1.597-0.106-1.9-0.106s-0.975 0-1.903 0.109c0.563-0.625 0.9-1.319 0.9-2.109h2.003zM2 19v-0.103c0-0.766 0.45-1.475 1.147-1.806 0.428-0.203 0.872-0.406 1.338-0.622 1.431-0.656 2.881-1.325 4.050-2.081 1.734-0.387 3.022-0.387 3.466-0.387s1.731 0 3.462 0.387c1.169 0.756 2.622 1.425 4.053 2.081 0.469 0.216 0.909 0.419 1.341 0.622 0.694 0.331 1.144 1.038 1.144 1.806v0.103h-20z" })
        );
    }
    function Hanger({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HangerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Hanger.SVG = HangerSVG;
    return Hanger;
})();
export const Hanger2 = /*#__PURE__*/ (() => {
    function Hanger2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.378 13.759c-0.406-0.641-0.981-1.15-1.666-1.475-0.444-0.213-0.916-0.428-1.369-0.637-1.397-0.641-2.841-1.303-3.9-2.006-0.944-0.628-1.444-1.194-1.444-1.641 0-0.553-0.447-1-1-1h-0.997l-0.003-1v-0.172c1.163-0.412 2-1.525 2-2.828 0-1.653-1.347-3-3-3s-3 1.347-3 3h1c0-1.103 0.897-2 2-2s2 0.897 2 2-0.897 2-2 2c-0.266 0-0.519 0.106-0.709 0.294-0.188 0.188-0.294 0.444-0.291 0.709l0.003 0.997h-1.003c-0.553 0-1 0.447-1 1 0 0.447-0.5 1.013-1.447 1.641-1.059 0.703-2.503 1.366-3.9 2.006-0.456 0.209-0.925 0.425-1.369 0.638-0.684 0.325-1.263 0.834-1.666 1.475s-0.619 1.378-0.619 2.138v2.103h2v-1h4v5c0 1.103 0.897 2 2 2h8c1.103 0 2-0.897 2-2v-5h4v1h2v-2.103c0-0.759-0.216-1.497-0.622-2.138zM13 8c0 0.791 0.337 1.481 0.9 2.106-0.925-0.106-1.594-0.106-1.897-0.106s-0.975 0-1.903 0.109c0.563-0.625 0.9-1.319 0.9-2.109h2zM16 22h-8v-6h8v6c0 0 0 0 0 0zM18 16c0-1.103-0.897-2-2-2h-8c-1.103 0-2 0.897-2 2h-4v-0.103c0-0.766 0.45-1.475 1.147-1.806 0.431-0.206 0.875-0.409 1.344-0.625 1.428-0.656 2.878-1.322 4.047-2.078 1.731-0.387 3.019-0.387 3.466-0.387 0.444 0 1.731 0 3.456 0.384 1.169 0.756 2.619 1.425 4.050 2.081 0.469 0.216 0.912 0.419 1.347 0.625 0.694 0.331 1.144 1.038 1.144 1.806v0.103h-4z" })
        );
    }
    function Hanger2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Hanger2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Hanger2.SVG = Hanger2SVG;
    return Hanger2;
})();
export const Happy = /*#__PURE__*/ (() => {
        function HappySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M8.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM8.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M15.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM15.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M4 12.5c0 1.897 0.856 3.803 2.353 5.228 1.534 1.466 3.541 2.272 5.647 2.272s4.113-0.806 5.65-2.272c1.494-1.425 2.35-3.331 2.35-5.228 0-0.275-0.225-0.5-0.5-0.5h-15c-0.275 0-0.5 0.225-0.5 0.5zM18.978 13c-0.297 3.25-3.431 6-6.978 6s-6.681-2.75-6.978-6h13.956z" })
            );
        }
        function Happy({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HappySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Happy.SVG = HappySVG;
        return Happy;
    })();
export const HardDiskWarning = /*#__PURE__*/ (() => {
        function HardDiskWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 17c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM5 20c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M16 20h-6v1h6.5c0.275 0 0.5-0.225 0.5-0.5v-1.5h-1v1z" }),
_('path', { d: "M9.5 8c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM9.5 10c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M18 8h1v1h-1v-1z" }),
_('path', { d: "M18 3h1v4h-1v-4z" }),
_('path', { d: "M23.841 8.828l-4-7.997c-0.25-0.506-0.775-0.831-1.341-0.831h-16.5c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h16c1.103 0 2-0.897 2-2v-11h2.5c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672zM18 22h-16v-20h14.575l-1.828 3.659c-1.219-1.659-3.153-2.659-5.247-2.659-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5c0.584 0 1.156-0.075 1.706-0.225l2.644 1.859c0.166 0.119 0.347 0.209 0.531 0.269 0.206 0.066 0.412 0.097 0.619 0.097 0.844 0 1.628-0.537 1.903-1.381 0.166-0.509 0.122-1.050-0.119-1.525-0.244-0.475-0.656-0.828-1.163-0.994l-1.175-0.381c0.666-0.784 1.144-1.719 1.378-2.719h2.175v11zM14.5 11h0.294c-0.253 0.891-0.734 1.716-1.391 2.378l-4.091-1.328c-0.466-0.15-0.981 0.066-1.203 0.503s-0.084 0.981 0.319 1.266l1.641 1.153c-0.188 0.019-0.375 0.028-0.566 0.028-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5c1.95 0 3.738 1.025 4.728 2.691l-1.069 2.137c-0.103 0.206-0.159 0.438-0.159 0.672-0.003 0.828 0.669 1.5 1.497 1.5zM9.003 13.003c0-0.003 0-0.003 0 0l6.309 2.047c0.253 0.081 0.459 0.259 0.581 0.497s0.144 0.509 0.059 0.762c-0.172 0.525-0.738 0.813-1.263 0.641-0.091-0.028-0.175-0.072-0.263-0.131l-5.425-3.816zM22.5 10h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5z" })
            );
        }
        function HardDiskWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HardDiskWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HardDiskWarning.SVG = HardDiskWarningSVG;
        return HardDiskWarning;
    })();
export const HardDisk = /*#__PURE__*/ (() => {
        function HardDiskSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 0h-16c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h16c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM20 22h-16v-20h16v20c0 0 0 0 0 0z" }),
_('path', { d: "M7 17c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM7 20c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M18 20h-6v1h6.5c0.275 0 0.5-0.225 0.5-0.5v-1.5h-1v1z" }),
_('path', { d: "M11.5 11c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5zM11.5 9c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M17.619 14.097l-1.172-0.381c0.994-1.169 1.553-2.666 1.553-4.216 0-3.584-2.916-6.5-6.5-6.5s-6.5 2.916-6.5 6.5 2.916 6.5 6.5 6.5c0.578 0 1.15-0.075 1.703-0.225l2.647 1.859c0.162 0.113 0.341 0.203 0.531 0.266 0.206 0.066 0.413 0.1 0.619 0.1 0.844 0 1.628-0.537 1.903-1.381 0.166-0.509 0.122-1.050-0.119-1.525-0.244-0.478-0.656-0.831-1.166-0.997zM11.5 15c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5c0 1.453-0.581 2.85-1.6 3.878l-4.166-1.353h-0.016c-0.441-0.1-0.909 0.116-1.116 0.528-0.219 0.441-0.081 0.984 0.319 1.266l1.638 1.153c-0.181 0.019-0.372 0.028-0.559 0.028zM17.95 16.309c-0.172 0.525-0.738 0.813-1.259 0.641-0.087-0.028-0.169-0.069-0.244-0.116l-5.447-3.834 0.075 0.025 6.234 2.025c0.253 0.081 0.459 0.259 0.581 0.497s0.144 0.509 0.059 0.762z" })
            );
        }
        function HardDisk({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HardDiskSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HardDisk.SVG = HardDiskSVG;
        return HardDisk;
    })();
export const HeadBubble = /*#__PURE__*/ (() => {
        function HeadBubbleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.5 0h-16c-0.341-0.003-0.687 0.009-1.047 0.034-1.191 0.081-2.247 0.353-3.134 0.809-0.934 0.478-1.684 1.156-2.234 2.016-0.806 1.259-1.166 2.887-1.069 4.841 0.094 1.913 0.628 4.156 1.584 6.669 0.581 1.525 0.566 3.272-0.047 5.197-0.488 1.528-1.194 2.628-1.322 2.794-0.247 0.297-0.303 0.709-0.141 1.059 0.166 0.353 0.519 0.581 0.909 0.581h12c0.453 0 0.853-0.306 0.969-0.747s-0.081-0.903-0.478-1.125c-0.031-0.016-2.575-1.481-3.3-4.203 1.012 0.178 1.812-0.012 2.341-0.231 2.019-0.834 3.247-3.247 3.441-6.694h2.028v2.5c0 0.203 0.122 0.384 0.309 0.462 0.063 0.025 0.128 0.037 0.191 0.037 0.131 0 0.259-0.050 0.353-0.147l2.853-2.853h1.794c0.275 0 0.5-0.225 0.5-0.5v-10c0-0.275-0.225-0.5-0.5-0.5zM0.234 22.356c0.003-0.003 0.003-0.003 0.006-0.006-0.003 0.003-0.003 0.003-0.006 0.006zM13.306 14.106c-0.384 0.884-0.916 1.484-1.537 1.741-0.513 0.213-1.106 0.2-1.769-0.038-0.8-0.288-1.647-0.875-2.522-1.753l-1.416 1.413c0.691 0.694 1.347 1.209 1.959 1.591 0.138 1.791 0.906 3.491 2.238 4.953 0.356 0.391 0.709 0.719 1.031 0.987h-9.094c0.363-0.609 0.853-1.575 1.228-2.725 0.775-2.372 0.791-4.659 0.044-6.616-0.881-2.316-1.372-4.353-1.456-6.053-0.075-1.531 0.178-2.763 0.756-3.666 0.728-1.141 2.016-1.781 3.822-1.906 2.316-0.159 4.1 0.328 5.303 1.45 1.397 1.303 2.103 3.503 2.103 6.537 0.003 1.628-0.237 3.041-0.691 4.084zM23 10h-1.5c-0.131 0-0.259 0.053-0.353 0.147l-2.147 2.147v-1.794c0-0.275-0.225-0.5-0.5-0.5h-2.5c-0.003-3.603-0.925-6.288-2.741-7.981-0.425-0.397-0.897-0.738-1.416-1.019h11.156v9z" }),
_('path', { d: "M16 3h6v1h-6v-1z" }),
_('path', { d: "M17 5h5v1h-5v-1z" }),
_('path', { d: "M17 7h5v1h-5v-1z" })
            );
        }
        function HeadBubble({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HeadBubbleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HeadBubble.SVG = HeadBubbleSVG;
        return HeadBubble;
    })();
export const HeadHearing = /*#__PURE__*/ (() => {
        function HeadHearingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.356 8.025l-0.416-0.281-0.559 0.828 0.416 0.281c1.378 0.934 2.203 2.484 2.203 4.147 0 1.65-0.813 3.191-2.175 4.125l-0.413 0.284 0.566 0.825 0.413-0.284c1.634-1.122 2.609-2.972 2.609-4.95 0-1.997-0.987-3.856-2.644-4.975z" }),
_('path', { d: "M1.675 10.512l-0.416-0.278-0.556 0.831 0.416 0.278c0.553 0.369 0.881 0.991 0.881 1.656 0 0.659-0.325 1.275-0.869 1.65l-0.413 0.281 0.566 0.825 0.413-0.281c0.816-0.559 1.303-1.484 1.303-2.475 0-1-0.494-1.931-1.325-2.487z" }),
_('path', { d: "M20.491 22.128c-0.031-0.016-2.575-1.481-3.3-4.203 1.012 0.178 1.812-0.012 2.341-0.231 2.203-0.909 3.469-3.706 3.469-7.675 0-3.612-0.922-6.303-2.741-8-1.625-1.516-3.916-2.184-6.806-1.984-1.191 0.081-2.247 0.353-3.134 0.809-0.931 0.478-1.684 1.156-2.234 2.016-0.806 1.259-1.166 2.888-1.069 4.841 0.094 1.912 0.628 4.156 1.584 6.669 0.581 1.525 0.566 3.272-0.047 5.197-0.488 1.528-1.194 2.628-1.319 2.794-0.247 0.297-0.303 0.709-0.141 1.059 0.162 0.353 0.519 0.581 0.909 0.581h12c0.453 0 0.853-0.306 0.969-0.747 0.109-0.441-0.084-0.903-0.481-1.125zM7.234 22.356c0.003-0.003 0.003-0.003 0.006-0.006-0.003 0.003-0.003 0.003-0.006 0.006zM9.012 7.603c-0.075-1.531 0.178-2.763 0.756-3.666 0.728-1.141 2.016-1.781 3.822-1.906 2.316-0.159 4.1 0.328 5.303 1.45 1.397 1.303 2.103 3.503 2.103 6.537 0 1.628-0.241 3.044-0.694 4.084-0.384 0.884-0.916 1.484-1.538 1.741-0.513 0.213-1.106 0.2-1.769-0.037-0.8-0.288-1.647-0.875-2.522-1.753l-1.413 1.416c0.691 0.694 1.347 1.209 1.959 1.591 0.138 1.791 0.906 3.491 2.238 4.953 0.356 0.391 0.709 0.719 1.031 0.987h-9.094c0.363-0.609 0.853-1.575 1.228-2.725 0.775-2.372 0.791-4.659 0.044-6.616-0.881-2.319-1.372-4.356-1.456-6.056z" })
            );
        }
        function HeadHearing({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HeadHearingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HeadHearing.SVG = HeadHearingSVG;
        return HeadHearing;
    })();
export const HeadMoney = /*#__PURE__*/ (() => {
        function HeadMoneySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.491 22.128c-0.031-0.016-2.575-1.481-3.3-4.203 1.013 0.178 1.812-0.009 2.344-0.231 2.203-0.909 3.469-3.706 3.469-7.675 0-3.612-0.922-6.303-2.741-8-1.628-1.519-3.919-2.184-6.809-1.984-1.194 0.081-2.247 0.353-3.134 0.809-0.931 0.478-1.684 1.156-2.234 2.016-0.806 1.259-1.166 2.888-1.069 4.841 0.094 1.912 0.628 4.156 1.584 6.669 0.581 1.525 0.566 3.272-0.047 5.197-0.488 1.528-1.194 2.628-1.319 2.794-0.247 0.297-0.303 0.709-0.141 1.059 0.162 0.356 0.519 0.581 0.909 0.581h12c0.453 0 0.853-0.306 0.969-0.747 0.109-0.441-0.084-0.903-0.481-1.125zM4.234 22.356c0.003-0.003 0.003-0.003 0.006-0.006-0.003 0-0.003 0.003-0.006 0.006zM6.012 7.603c-0.075-1.531 0.178-2.763 0.756-3.666 0.728-1.141 2.016-1.781 3.822-1.906 2.316-0.159 4.103 0.328 5.306 1.45 1.397 1.303 2.103 3.503 2.103 6.537 0 1.631-0.241 3.044-0.694 4.084-0.384 0.884-0.916 1.484-1.534 1.741-0.513 0.213-1.106 0.2-1.769-0.037-0.8-0.288-1.647-0.875-2.522-1.753l-1.419 1.416c0.691 0.694 1.347 1.209 1.959 1.591 0.138 1.791 0.906 3.491 2.238 4.956 0.356 0.391 0.709 0.719 1.031 0.987h-9.094c0.363-0.609 0.853-1.575 1.228-2.725 0.775-2.372 0.791-4.659 0.044-6.619-0.884-2.319-1.372-4.356-1.456-6.056z" }),
_('path', { d: "M11 12h1v-2h0.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-2c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3.5v-1h-2v-2h-1v2h-0.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h2c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-3.5v1h2v2z" })
            );
        }
        function HeadMoney({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HeadMoneySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HeadMoney.SVG = HeadMoneySVG;
        return HeadMoney;
    })();
export const HeadProcessing = /*#__PURE__*/ (() => {
        function HeadProcessingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 7.5c0-1.306 1.006-2.381 2.284-2.491l-0.491 0.491 0.706 0.706 1.353-1.353c0.194-0.194 0.194-0.513 0-0.706l-1.353-1.353-0.706 0.706 0.506 0.506c-1.837 0.103-3.3 1.631-3.3 3.494v0.5h1v-0.5z" }),
_('path', { d: "M12.206 9.5l-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706-0.506-0.506c1.837-0.103 3.3-1.631 3.3-3.494v-0.5h-1v0.5c0 1.306-1.006 2.381-2.284 2.491l0.491-0.491z" }),
_('path', { d: "M17.491 22.128c-0.031-0.016-2.575-1.481-3.3-4.203 1.013 0.178 1.812-0.012 2.341-0.231 2.203-0.909 3.469-3.706 3.469-7.675 0-3.612-0.922-6.303-2.741-8-1.625-1.516-3.916-2.184-6.806-1.984-1.191 0.081-2.247 0.353-3.134 0.809-0.931 0.478-1.684 1.156-2.234 2.016-0.806 1.259-1.166 2.888-1.069 4.841 0.094 1.912 0.628 4.156 1.584 6.669 0.581 1.525 0.566 3.272-0.047 5.197-0.488 1.528-1.194 2.628-1.319 2.794-0.247 0.297-0.303 0.709-0.141 1.059 0.162 0.353 0.519 0.581 0.909 0.581h12c0.453 0 0.853-0.306 0.969-0.747 0.109-0.441-0.084-0.903-0.481-1.125zM4.234 22.356c0.003-0.003 0.003-0.003 0.006-0.006-0.003 0.003-0.003 0.003-0.006 0.006zM6.012 7.603c-0.075-1.531 0.178-2.763 0.756-3.666 0.728-1.141 2.016-1.781 3.822-1.906 2.316-0.159 4.1 0.328 5.303 1.45 1.397 1.303 2.103 3.503 2.103 6.537 0 1.628-0.241 3.044-0.694 4.084-0.384 0.884-0.916 1.484-1.538 1.741-0.513 0.213-1.106 0.2-1.769-0.037-0.8-0.288-1.647-0.875-2.522-1.753l-1.413 1.416c0.691 0.694 1.347 1.209 1.959 1.591 0.138 1.791 0.906 3.491 2.238 4.953 0.356 0.391 0.709 0.719 1.031 0.987h-9.094c0.363-0.609 0.853-1.575 1.228-2.725 0.775-2.372 0.791-4.659 0.044-6.616-0.881-2.319-1.372-4.356-1.456-6.056z" })
            );
        }
        function HeadProcessing({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HeadProcessingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HeadProcessing.SVG = HeadProcessingSVG;
        return HeadProcessing;
    })();
export const HeadQuestion = /*#__PURE__*/ (() => {
        function HeadQuestionSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.491 22.128c-0.031-0.016-2.575-1.481-3.3-4.203 1.013 0.178 1.812-0.009 2.344-0.231 2.203-0.909 3.469-3.706 3.469-7.675 0-3.612-0.922-6.303-2.741-8-1.628-1.519-3.919-2.184-6.809-1.984-1.194 0.081-2.247 0.353-3.134 0.809-0.931 0.478-1.684 1.156-2.234 2.016-0.806 1.259-1.166 2.888-1.069 4.841 0.094 1.912 0.628 4.156 1.584 6.669 0.581 1.525 0.566 3.272-0.047 5.197-0.488 1.528-1.194 2.628-1.319 2.794-0.247 0.297-0.303 0.709-0.141 1.059 0.162 0.356 0.519 0.581 0.909 0.581h12c0.453 0 0.853-0.306 0.969-0.747 0.109-0.441-0.084-0.903-0.481-1.125zM4.234 22.356c0.003-0.003 0.003-0.003 0.006-0.006-0.003 0-0.003 0.003-0.006 0.006zM6.012 7.603c-0.075-1.531 0.178-2.763 0.756-3.666 0.728-1.141 2.016-1.781 3.822-1.906 2.316-0.159 4.103 0.328 5.306 1.45 1.397 1.303 2.103 3.503 2.103 6.537 0 1.631-0.241 3.044-0.694 4.084-0.384 0.884-0.916 1.484-1.534 1.741-0.513 0.213-1.106 0.2-1.769-0.037-0.8-0.288-1.647-0.875-2.522-1.753l-1.419 1.416c0.691 0.694 1.347 1.209 1.959 1.591 0.138 1.791 0.906 3.491 2.238 4.956 0.356 0.391 0.709 0.719 1.031 0.987h-9.094c0.363-0.609 0.853-1.575 1.228-2.725 0.775-2.372 0.791-4.659 0.044-6.619-0.884-2.319-1.372-4.356-1.456-6.056z" }),
_('path', { d: "M11 11h1v1h-1v-1z" }),
_('path', { d: "M10 6.5c0-1.103 0.809-1.497 1.503-1.497 0.4 0 0.787 0.125 1.062 0.344 0.288 0.228 0.434 0.531 0.434 0.903 0 0.712-0.434 1.084-0.941 1.519-0.497 0.425-1.059 0.906-1.059 1.731v0.5h1v-0.5c0-0.347 0.256-0.584 0.709-0.972 0.575-0.491 1.291-1.103 1.291-2.278 0-1.459-1.287-2.247-2.497-2.247-1.206 0-2.503 0.781-2.503 2.497v0.5h1v-0.5z" })
            );
        }
        function HeadQuestion({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HeadQuestionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HeadQuestion.SVG = HeadQuestionSVG;
        return HeadQuestion;
    })();
export const HeadSpeech = /*#__PURE__*/ (() => {
        function HeadSpeechSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21 13c0-1.653-1.347-3-3-3v1c1.103 0 2 0.897 2 2s-0.897 2-2 2v1c1.653 0 3-1.347 3-3z" }),
_('path', { d: "M18 7v1c2.756 0 5 2.244 5 5s-2.244 5-5 5v1c3.309 0 6-2.691 6-6s-2.691-6-6-6z" }),
_('path', { d: "M12.531 17.694c2.203-0.909 3.469-3.706 3.469-7.675 0-3.612-0.922-6.303-2.741-8-1.625-1.516-3.916-2.184-6.806-1.984-1.191 0.081-2.247 0.353-3.134 0.809-0.934 0.478-1.684 1.156-2.234 2.016-0.806 1.259-1.166 2.888-1.069 4.841 0.094 1.912 0.628 4.156 1.584 6.669 0.581 1.525 0.566 3.272-0.047 5.197-0.488 1.528-1.194 2.628-1.322 2.794-0.247 0.297-0.303 0.709-0.141 1.059 0.166 0.353 0.519 0.581 0.909 0.581h12c0.453 0 0.853-0.306 0.969-0.747s-0.081-0.903-0.478-1.125c-0.031-0.016-2.575-1.481-3.3-4.203 1.012 0.178 1.812-0.012 2.341-0.231zM0.234 22.356c0.003-0.003 0.003-0.003 0.006-0.006-0.003 0.003-0.003 0.003-0.006 0.006zM10.259 22.013c0.356 0.391 0.709 0.719 1.031 0.987h-9.094c0.363-0.609 0.853-1.575 1.228-2.725 0.775-2.372 0.791-4.659 0.044-6.616-0.881-2.316-1.372-4.353-1.456-6.053-0.075-1.531 0.178-2.763 0.756-3.666 0.728-1.141 2.016-1.781 3.822-1.906 2.316-0.159 4.1 0.328 5.303 1.45 1.397 1.303 2.103 3.503 2.103 6.537 0 1.628-0.241 3.044-0.694 4.084-0.384 0.884-0.916 1.484-1.537 1.741-0.513 0.213-1.106 0.2-1.769-0.037-0.8-0.288-1.647-0.875-2.522-1.753l-1.413 1.413c0.691 0.694 1.347 1.209 1.959 1.591 0.141 1.788 0.906 3.491 2.238 4.953z" })
            );
        }
        function HeadSpeech({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HeadSpeechSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HeadSpeech.SVG = HeadSpeechSVG;
        return HeadSpeech;
    })();
export const Head = /*#__PURE__*/ (() => {
    function HeadSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17.491 22.128c-0.031-0.016-2.575-1.481-3.3-4.203 1.013 0.178 1.812-0.012 2.341-0.231 2.203-0.909 3.469-3.706 3.469-7.675 0-3.612-0.922-6.303-2.741-8-1.625-1.516-3.916-2.184-6.806-1.984-1.191 0.081-2.247 0.353-3.134 0.809-0.931 0.478-1.684 1.156-2.234 2.016-0.806 1.259-1.166 2.888-1.069 4.841 0.094 1.912 0.628 4.156 1.584 6.669 0.581 1.525 0.566 3.272-0.047 5.197-0.488 1.528-1.194 2.628-1.319 2.794-0.247 0.297-0.303 0.709-0.141 1.059 0.162 0.353 0.519 0.581 0.909 0.581h12c0.453 0 0.853-0.306 0.969-0.747 0.109-0.441-0.084-0.903-0.481-1.125zM4.234 22.356c0.003-0.003 0.003-0.003 0.006-0.006-0.003 0.003-0.003 0.003-0.006 0.006zM6.012 7.603c-0.075-1.531 0.178-2.763 0.756-3.666 0.728-1.141 2.016-1.781 3.822-1.906 2.316-0.159 4.1 0.328 5.303 1.45 1.397 1.303 2.103 3.503 2.103 6.537 0 1.628-0.241 3.044-0.694 4.084-0.384 0.884-0.916 1.484-1.538 1.741-0.513 0.213-1.106 0.2-1.769-0.037-0.8-0.288-1.647-0.875-2.522-1.753l-1.413 1.416c0.691 0.694 1.347 1.209 1.959 1.591 0.138 1.791 0.906 3.491 2.238 4.953 0.356 0.391 0.709 0.719 1.031 0.987h-9.094c0.363-0.609 0.853-1.575 1.228-2.725 0.775-2.372 0.791-4.659 0.044-6.616-0.881-2.319-1.372-4.356-1.456-6.056z" })
        );
    }
    function Head({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HeadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Head.SVG = HeadSVG;
    return Head;
})();
export const HeadphonesCross = /*#__PURE__*/ (() => {
        function HeadphonesCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 12.503v-0.319c1.231-1.184 2-2.847 2-4.684 0-3.584-2.916-6.5-6.5-6.5-1.85 0-3.522 0.778-4.706 2.022-0.15-0.009-0.3-0.012-0.453-0.016v0c-0.022 0-0.041 0-0.063 0-0.016 0-0.028 0-0.044 0-0.078 0-0.156-0.003-0.237-0.003-1.341 0-2.616 0.172-3.794 0.513-1.203 0.347-2.272 0.862-3.175 1.525-0.953 0.703-1.7 1.556-2.212 2.541-0.541 1.031-0.816 2.181-0.816 3.419v1.503c-0.462 0.269-0.853 0.644-1.166 1.122-0.553 0.844-0.834 1.981-0.834 3.375s0.281 2.531 0.834 3.375c0.697 1.062 1.791 1.625 3.166 1.625h0.087c0.206 0.581 0.762 1 1.413 1 0.828 0 1.5-0.672 1.5-1.5v-9c0-0.828-0.672-1.5-1.5-1.5-0.653 0-1.206 0.419-1.413 1h-0.087v-1c0-3.969 3.687-5.841 7.497-5.991-0.319 0.769-0.497 1.609-0.497 2.491 0 3.416 2.65 6.225 6 6.481v7.519c0 0.828 0.672 1.5 1.5 1.5 0.653 0 1.206-0.419 1.413-1h0.087c1.375 0 2.469-0.563 3.166-1.625 0.553-0.844 0.834-1.981 0.834-3.375 0-1.231-0.219-2.266-0.653-3.072-0.334-0.619-0.791-1.097-1.347-1.425zM2 17c0-3 1.506-3 2-3v6c-0.494 0-2 0-2-3zM5 12.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v9c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5v-9zM12 7.5c0-3.031 2.469-5.5 5.5-5.5s5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5zM18.5 22c-0.275 0-0.5-0.225-0.5-0.5v-7.519c0.341-0.025 0.675-0.078 1-0.156v7.675c0 0.275-0.225 0.5-0.5 0.5zM20 20v-6c0.166 0 0.319 0.012 0.459 0.041 0.025 0.003 0.050 0.009 0.072 0.016 0.006 0 0.012 0.003 0.022 0.003 0.959 0.234 1.447 1.222 1.447 2.941 0 3-1.506 3-2 3z" }),
_('path', { d: "M19.5 10.206l0.706-0.706-2-2 2-2-0.706-0.706-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2z" })
            );
        }
        function HeadphonesCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HeadphonesCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HeadphonesCross.SVG = HeadphonesCrossSVG;
        return HeadphonesCross;
    })();
export const HeadphonesWarning = /*#__PURE__*/ (() => {
        function HeadphonesWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 12.503v-0.503h0.5c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672l-4-7.997c-0.25-0.506-0.775-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-0.912 1.825c-1.297-0.434-2.722-0.653-4.247-0.653-1.341 0-2.616 0.172-3.794 0.513-1.203 0.347-2.272 0.863-3.175 1.525-0.953 0.703-1.7 1.556-2.212 2.541-0.544 1.034-0.819 2.184-0.819 3.422v1.503c-0.462 0.269-0.853 0.644-1.166 1.122-0.553 0.844-0.834 1.981-0.834 3.375s0.281 2.531 0.834 3.375c0.697 1.062 1.791 1.625 3.166 1.625h0.087c0.206 0.581 0.762 1 1.413 1 0.828 0 1.5-0.672 1.5-1.5v-9c0-0.828-0.672-1.5-1.5-1.5-0.653 0-1.206 0.419-1.413 1h-0.087v-1c0-4.144 4.019-6 8-6 1.2 0 2.322 0.156 3.341 0.462l-2.181 4.362c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h2.588c-0.056 0.156-0.087 0.325-0.087 0.5v9c0 0.828 0.672 1.5 1.5 1.5 0.653 0 1.206-0.419 1.413-1h0.087c1.375 0 2.469-0.563 3.166-1.625 0.553-0.841 0.834-1.978 0.834-3.372s-0.281-2.531-0.834-3.375c-0.312-0.478-0.703-0.853-1.166-1.122zM2 17c0-3 1.506-3 2-3v6c-0.494 0-2 0-2-3zM5 12.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v9c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5v-9zM14 10.5c0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5h-8c-0.275 0-0.5-0.225-0.5-0.5zM19 21.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5v-9c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v9zM20 20v-6c0.494 0 2 0 2 3s-1.506 3-2 3z" }),
_('path', { d: "M18 9h1v1h-1v-1z" }),
_('path', { d: "M18 4h1v4h-1v-4z" })
            );
        }
        function HeadphonesWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HeadphonesWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HeadphonesWarning.SVG = HeadphonesWarningSVG;
        return HeadphonesWarning;
    })();
export const Headphones = /*#__PURE__*/ (() => {
    function HeadphonesSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.166 12.625c-0.312-0.475-0.703-0.853-1.166-1.122v-1.503c0-1.238-0.275-2.388-0.819-3.422-0.516-0.981-1.259-1.838-2.212-2.541-0.903-0.666-1.972-1.178-3.175-1.525-1.178-0.341-2.453-0.513-3.794-0.513s-2.616 0.172-3.794 0.513c-1.203 0.347-2.272 0.863-3.175 1.525-0.953 0.703-1.7 1.556-2.212 2.541-0.544 1.034-0.819 2.184-0.819 3.422v1.503c-0.462 0.269-0.853 0.644-1.166 1.122-0.553 0.844-0.834 1.981-0.834 3.375s0.281 2.531 0.834 3.375c0.697 1.062 1.791 1.625 3.166 1.625h0.084c0.206 0.581 0.762 1 1.416 1 0.828 0 1.5-0.672 1.5-1.5v-9c0-0.828-0.672-1.5-1.5-1.5-0.653 0-1.209 0.419-1.416 1h-0.084v-1c0-4.144 4.019-6 8-6s8 1.856 8 6v1h-0.084c-0.206-0.581-0.762-1-1.416-1-0.828 0-1.5 0.672-1.5 1.5v9c0 0.828 0.672 1.5 1.5 1.5 0.653 0 1.209-0.419 1.416-1h0.084c1.375 0 2.469-0.563 3.166-1.625 0.553-0.844 0.834-1.981 0.834-3.375s-0.281-2.531-0.834-3.375zM2 16c0-3 1.506-3 2-3v6c-0.494 0-2 0-2-3zM5 11.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v9c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5v-9zM19 20.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5v-9c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v9zM20 19v-6c0.494 0 2 0 2 3s-1.506 3-2 3z" })
        );
    }
    function Headphones({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HeadphonesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Headphones.SVG = HeadphonesSVG;
    return Headphones;
})();
export const Headset = /*#__PURE__*/ (() => {
    function HeadsetSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.166 10.625c-0.312-0.475-0.703-0.85-1.166-1.122v-1.503c0-1.237-0.275-2.388-0.819-3.422-0.516-0.984-1.259-1.837-2.212-2.541-0.903-0.666-1.972-1.178-3.175-1.525-1.178-0.341-2.453-0.513-3.794-0.513s-2.616 0.172-3.794 0.513c-1.203 0.347-2.272 0.859-3.175 1.525-0.953 0.703-1.7 1.556-2.212 2.541-0.544 1.034-0.819 2.184-0.819 3.422v1.503c-0.462 0.269-0.853 0.644-1.166 1.122-0.553 0.844-0.834 1.981-0.834 3.375s0.281 2.531 0.834 3.375c0.697 1.062 1.791 1.625 3.166 1.625h0.087c0.206 0.581 0.762 1 1.413 1 0.828 0 1.5-0.672 1.5-1.5v-9c0-0.828-0.672-1.5-1.5-1.5-0.653 0-1.206 0.419-1.413 1h-0.087v-1c0-4.144 4.019-6 8-6s8 1.856 8 6v1h-0.087c-0.206-0.581-0.762-1-1.413-1-0.828 0-1.5 0.672-1.5 1.5v9c0 0.828 0.672 1.5 1.5 1.5 0.653 0 1.206-0.419 1.413-1h0.087v0.5c0 1.125-0.553 1.784-1.794 2.144-1.147 0.331-2.728 0.353-4.291 0.356-0.206-0.581-0.762-1-1.413-1-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.653 0 1.206-0.419 1.413-1 1.634 0 3.294-0.025 4.569-0.394 1.669-0.484 2.516-1.528 2.516-3.106v-0.609c0.909-0.213 1.647-0.725 2.166-1.512 0.553-0.847 0.834-1.984 0.834-3.378s-0.281-2.531-0.834-3.375zM2 14c0-3 1.506-3 2-3v6c-0.494 0-2 0-2-3zM5 9.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v9c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5v-9zM12.5 23c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5zM19 18.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5v-9c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v9zM20 17v-6c0.494 0 2 0 2 3s-1.506 3-2 3z" })
        );
    }
    function Headset({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HeadsetSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Headset.SVG = HeadsetSVG;
    return Headset;
})();
export const HeartPlus = /*#__PURE__*/ (() => {
        function HeartPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.447 11.041c-0.050 0.166-0.106 0.328-0.166 0.491 0.459 0.891 0.719 1.9 0.719 2.969 0 3.584-2.916 6.5-6.5 6.5-0.603 0-1.191-0.084-1.744-0.237-1.812 1.344-3.228 2.091-3.291 2.125v0c-0.144 0.075-0.303 0.116-0.462 0.116s-0.319-0.038-0.462-0.116c-0.116-0.063-2.9-1.531-5.712-4.125-1.669-1.538-3.006-3.156-3.969-4.806-1.234-2.112-1.859-4.284-1.859-6.456 0-3.584 2.916-6.5 6.5-6.5 1.694 0 3.319 0.65 4.575 1.834 0.353 0.334 0.663 0.697 0.925 1.081 0.262-0.384 0.572-0.747 0.925-1.081 1.256-1.184 2.881-1.834 4.575-1.834 3.584 0 6.5 2.916 6.5 6.5 0 1.181-0.184 2.372-0.553 3.541zM17.5 9c-3.031 0-5.5 2.469-5.5 5.5s2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5-2.469-5.5-5.5-5.5zM7.144 17.259c1.975 1.825 3.975 3.078 4.856 3.594 0.384-0.225 0.984-0.591 1.7-1.081-1.634-1.184-2.7-3.106-2.7-5.272 0-3.584 2.916-6.5 6.5-6.5 1.631 0 3.122 0.603 4.266 1.6 0.156-0.7 0.234-1.403 0.234-2.1 0-2.481-2.019-4.5-4.5-4.5-1.181 0-2.319 0.459-3.203 1.291-0.825 0.775-1.297 1.763-1.297 2.709h-2c0-0.947-0.472-1.934-1.297-2.709-0.884-0.831-2.022-1.291-3.203-1.291-2.481 0-4.5 2.019-4.5 4.5 0 4.137 2.797 7.591 5.144 9.759z" }),
_('path', { d: "M18 17h-1v-2h-2v-1h2v-2h1v2h2v1h-2z" })
            );
        }
        function HeartPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HeartPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HeartPlus.SVG = HeartPlusSVG;
        return HeartPlus;
    })();
export const HeartPulse = /*#__PURE__*/ (() => {
        function HeartPulseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16.053 18.275l-1.397 2.794-2.672-10.688c-0.056-0.222-0.256-0.378-0.484-0.378s-0.428 0.156-0.484 0.378l-1.906 7.622h-7.109v1h7.5c0.228 0 0.428-0.156 0.484-0.378l1.516-6.063 2.516 10.059c0.050 0.203 0.222 0.353 0.431 0.375 0.019 0.003 0.037 0.003 0.056 0.003 0.188 0 0.363-0.106 0.447-0.275l1.859-3.725h5.191v-1h-5.5c-0.191 0-0.363 0.106-0.447 0.275z" }),
_('path', { d: "M4.050 13.697c-1.359-2.047-2.050-4.131-2.050-6.197 0-2.481 2.019-4.5 4.5-4.5 1.181 0 2.319 0.459 3.203 1.291 0.825 0.775 1.297 1.762 1.297 2.709h2c0-0.947 0.472-1.934 1.297-2.709 0.884-0.831 2.022-1.291 3.203-1.291 2.481 0 4.5 2.019 4.5 4.5 0 2.066-0.691 4.15-2.050 6.197l1.666 1.106c1.581-2.378 2.384-4.834 2.384-7.303 0-3.584-2.916-6.5-6.5-6.5-1.694 0-3.319 0.65-4.575 1.834-0.353 0.334-0.663 0.697-0.925 1.081-0.263-0.384-0.572-0.747-0.925-1.081-1.256-1.184-2.881-1.834-4.575-1.834-3.584 0-6.5 2.916-6.5 6.5 0 2.469 0.803 4.925 2.384 7.303l1.666-1.106z" })
            );
        }
        function HeartPulse({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HeartPulseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HeartPulse.SVG = HeartPulseSVG;
        return HeartPulse;
    })();
export const HeartShiny = /*#__PURE__*/ (() => {
        function HeartShinySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 0c-2.313 0-4.347 1.216-5.5 3.041-1.153-1.825-3.188-3.041-5.5-3.041-3.584 0-6.5 2.916-6.5 6.5 0 1.928 0.644 3.756 1.966 5.581 1.119 1.547 2.584 2.913 4.003 4.234 2.588 2.412 5.031 4.694 5.031 7.681h2c0-2.991 2.444-5.269 5.031-7.681 1.419-1.322 2.884-2.688 4.003-4.234 1.322-1.825 1.966-3.653 1.966-5.581 0-3.584-2.916-6.5-6.5-6.5zM16.669 14.856c-1.772 1.653-3.584 3.344-4.669 5.347-1.084-2.003-2.894-3.694-4.669-5.347-2.741-2.559-5.331-4.972-5.331-8.356 0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5v0.5h2v-0.5c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5c0 3.384-2.591 5.797-5.331 8.356z" }),
_('path', { d: "M17.5 3h-0.5v1h0.5c1.378 0 2.5 1.122 2.5 2.5v0.5h1v-0.5c0-1.931-1.569-3.5-3.5-3.5z" })
            );
        }
        function HeartShiny({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HeartShinySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HeartShiny.SVG = HeartShinySVG;
        return HeartShiny;
    })();
export const HeartTime = /*#__PURE__*/ (() => {
        function HeartTimeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.681 10.194c0.213-0.894 0.319-1.797 0.319-2.694 0-3.584-2.916-6.5-6.5-6.5-1.694 0-3.319 0.65-4.575 1.834-0.353 0.334-0.663 0.697-0.925 1.081-0.262-0.384-0.572-0.747-0.925-1.081-1.256-1.184-2.881-1.834-4.575-1.834-3.584 0-6.5 2.916-6.5 6.5 0 2.172 0.625 4.344 1.856 6.456 0.963 1.65 2.297 3.269 3.969 4.806 2.816 2.594 5.597 4.062 5.712 4.125 0.147 0.075 0.303 0.116 0.462 0.116s0.316-0.038 0.462-0.112v0c0.059-0.031 1.463-0.762 3.294-2.125 0.556 0.156 1.141 0.237 1.744 0.237 3.584 0 6.5-2.916 6.5-6.5 0-1.069-0.259-2.075-0.716-2.966 0.159-0.453 0.294-0.903 0.397-1.344zM7.144 17.259c-2.347-2.169-5.144-5.622-5.144-9.759 0-2.481 2.019-4.5 4.5-4.5 1.181 0 2.319 0.459 3.203 1.291 0.825 0.775 1.297 1.762 1.297 2.709h2c0-0.947 0.472-1.934 1.297-2.709 0.884-0.831 2.022-1.291 3.203-1.291 2.481 0 4.5 2.019 4.5 4.5 0 0.697-0.078 1.4-0.234 2.1-1.144-0.997-2.634-1.6-4.266-1.6-3.584 0-6.5 2.916-6.5 6.5 0 2.166 1.066 4.091 2.7 5.272-0.716 0.491-1.316 0.856-1.7 1.081-0.881-0.516-2.881-1.769-4.856-3.594zM18 19.978v-1.978h-1v1.978c-2.634-0.237-4.737-2.344-4.978-4.978h1.978v-1h-1.978c0.237-2.634 2.344-4.737 4.978-4.978v1.978h1v-1.978c2.634 0.237 4.737 2.344 4.978 4.978h-1.978v1h1.978c-0.241 2.634-2.344 4.737-4.978 4.978z" }),
_('path', { d: "M17.422 14.716l-1.922-1.922-0.706 0.706 2.353 2.353c0.094 0.094 0.222 0.147 0.353 0.147 0.016 0 0.034 0 0.050-0.003 0.15-0.016 0.284-0.097 0.366-0.219l2.278-3.416-0.831-0.556-1.941 2.909z" })
            );
        }
        function HeartTime({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HeartTimeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HeartTime.SVG = HeartTimeSVG;
        return HeartTime;
    })();
export const Heart = /*#__PURE__*/ (() => {
    function HeartSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17.5 0c-2.313 0-4.347 1.216-5.5 3.041-1.153-1.825-3.188-3.041-5.5-3.041-3.584 0-6.5 2.916-6.5 6.5 0 1.928 0.644 3.756 1.966 5.581 1.119 1.547 2.584 2.913 4.003 4.234 2.588 2.412 5.031 4.694 5.031 7.681h2c0-2.991 2.444-5.269 5.031-7.681 1.419-1.322 2.884-2.688 4.003-4.234 1.322-1.825 1.966-3.653 1.966-5.581 0-3.584-2.916-6.5-6.5-6.5zM16.669 14.856c-1.772 1.653-3.584 3.344-4.669 5.347-1.084-2.003-2.894-3.694-4.669-5.347-2.741-2.559-5.331-4.972-5.331-8.356 0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5v0.5h2v-0.5c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5c0 3.384-2.591 5.797-5.331 8.356z" })
        );
    }
    function Heart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HeartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Heart.SVG = HeartSVG;
    return Heart;
})();
export const Heart2 = /*#__PURE__*/ (() => {
    function Heart2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17.5 1c-1.694 0-3.319 0.65-4.575 1.834-0.353 0.334-0.663 0.697-0.925 1.081-0.263-0.384-0.572-0.747-0.925-1.081-1.256-1.184-2.881-1.834-4.575-1.834-3.584 0-6.5 2.916-6.5 6.5 0 2.172 0.625 4.344 1.856 6.456 0.963 1.65 2.297 3.269 3.969 4.806 2.816 2.594 5.597 4.062 5.712 4.125 0.144 0.075 0.306 0.116 0.466 0.116s0.319-0.038 0.466-0.116c0.116-0.063 2.9-1.531 5.712-4.125 1.669-1.538 3.006-3.156 3.969-4.806 1.225-2.112 1.85-4.284 1.85-6.456 0-3.584-2.916-6.5-6.5-6.5zM16.856 17.259c-1.975 1.825-3.975 3.078-4.856 3.594-2.028-1.188-10-6.3-10-13.353 0-2.481 2.019-4.5 4.5-4.5 1.181 0 2.319 0.459 3.203 1.291 0.825 0.775 1.297 1.762 1.297 2.709h2c0-0.947 0.472-1.934 1.297-2.709 0.884-0.831 2.022-1.291 3.203-1.291 2.481 0 4.5 2.019 4.5 4.5 0 4.137-2.797 7.591-5.144 9.759z" })
        );
    }
    function Heart2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Heart2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Heart2.SVG = Heart2SVG;
    return Heart2;
})();
export const Heart3 = /*#__PURE__*/ (() => {
        function Heart3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 1c-1.694 0-3.319 0.65-4.575 1.834-0.353 0.334-0.663 0.697-0.925 1.081-0.263-0.384-0.572-0.747-0.925-1.081-1.256-1.184-2.881-1.834-4.575-1.834-3.584 0-6.5 2.916-6.5 6.5 0 2.172 0.625 4.344 1.856 6.456 0.963 1.65 2.297 3.269 3.969 4.806 2.816 2.594 5.597 4.062 5.712 4.125 0.144 0.075 0.306 0.116 0.466 0.116s0.319-0.038 0.466-0.116c0.116-0.063 2.9-1.531 5.712-4.125 1.669-1.538 3.006-3.156 3.969-4.806 1.225-2.112 1.85-4.284 1.85-6.456 0-3.584-2.916-6.5-6.5-6.5zM16.856 17.259c-1.975 1.825-3.975 3.078-4.856 3.594-2.028-1.188-10-6.3-10-13.353 0-2.481 2.019-4.5 4.5-4.5 1.181 0 2.319 0.459 3.203 1.291 0.825 0.775 1.297 1.762 1.297 2.709h2c0-0.947 0.472-1.934 1.297-2.709 0.884-0.831 2.022-1.291 3.203-1.291 2.481 0 4.5 2.019 4.5 4.5 0 4.137-2.797 7.591-5.144 9.759z" }),
_('path', { d: "M17.5 4h-0.5v1h0.5c1.378 0 2.5 1.122 2.5 2.5v0.5h1v-0.5c0-1.931-1.569-3.5-3.5-3.5z" })
            );
        }
        function Heart3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Heart3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Heart3.SVG = Heart3SVG;
        return Heart3;
    })();
export const Height = /*#__PURE__*/ (() => {
        function HeightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12.478 7.072c-0.506-0.369-1.113-0.644-1.812-0.822 0.813-0.641 1.334-1.634 1.334-2.747 0-1.934-1.569-3.503-3.5-3.503s-3.5 1.569-3.5 3.5c0 1.113 0.522 2.106 1.334 2.747-0.7 0.178-1.303 0.453-1.812 0.822-0.981 0.716-1.522 1.756-1.522 2.931v4c0 1.303 0.837 2.416 2 2.828v5.172c0 1.103 0.897 2 2 2h3c1.103 0 2-0.897 2-2v-5.172c1.166-0.413 2-1.525 2-2.828v-4c0-1.175-0.541-2.216-1.522-2.928zM6 3.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5-2.5-1.122-2.5-2.5zM12 14c0 0.55-0.45 1-1 1v-4h-1v11h-1v-7h-1v7h-1v-11h-1v4c-0.55 0-1-0.45-1-1v-4c0-0.534 0.234-0.975 0.7-1.313 0.431-0.312 1.266-0.687 2.8-0.687s2.369 0.375 2.8 0.687c0.466 0.337 0.7 0.781 0.7 1.313v4z" }),
_('path', { d: "M21 1h-2.5c0.128 0 0.256 0.050 0.353 0.147l1.353 1.353-0.706 0.706-0.5-0.5v18.584l0.5-0.5 0.706 0.706-1.353 1.353c-0.097 0.097-0.225 0.147-0.353 0.147s-0.256-0.050-0.353-0.147l-1.353-1.35 0.706-0.706 0.5 0.5v-18.588l-0.5 0.5-0.706-0.706 1.353-1.353c0.097-0.097 0.225-0.147 0.353-0.147h-2.5v-1h5v1zM16 24h5v-1h-5v1z" })
            );
        }
        function Height({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HeightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Height.SVG = HeightSVG;
        return Height;
    })();
export const Helicopter = /*#__PURE__*/ (() => {
    function HelicopterSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.453 3.981c-3.15-0.7-5.603-1.013-7.953-1.013s-4.803 0.312-7.953 1.013l-0.488 0.109 0.216 0.975 0.488-0.109c2.756-0.612 5.013-0.941 7.234-0.984v3.028h-0.775c-1.403 0-2.637 0.628-3.419 1.734-1.281-0.247-4.091-0.713-7.072-0.734-0.347-0.597-0.994-1-1.731-1-1.103 0-2 0.897-2 2s0.897 2 2 2c0.738 0 1.384-0.403 1.731-1 2.531 0.022 4.978 0.391 6.316 0.628-0.131 0.894 0.006 1.834 0.422 2.706 0.453 0.95 1.194 1.863 2.141 2.647 0.188 0.156 0.381 0.303 0.581 0.444l-1.984 3.575h-3.206v1h13c1.103 0 2-0.897 2-2h-1c0 0.55-0.45 1-1 1h-1.206l-1.156-2.066c0.684-0.103 1.325-0.331 1.906-0.681 1.025-0.612 1.772-1.516 2.163-2.619 0.363-1.025 0.397-2.144 0.094-3.237-0.337-1.222-1.087-2.322-2.112-3.097-1.131-0.853-2.572-1.306-4.166-1.306h-0.522v-3.025c2.222 0.044 4.478 0.372 7.234 0.984l0.487 0.109 0.216-0.975-0.484-0.106zM2 10c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM12.35 20l1.691-3.041c0.553 0.309 1.131 0.556 1.713 0.731 0.6 0.181 1.191 0.284 1.769 0.306l1.125 2.006h-6.297zM19.516 15.537c-1.1 0.659-2.337 0.491-3.181 0.237-1.709-0.516-3.378-1.872-4.059-3.3-0.397-0.831-0.363-1.756 0.091-2.478 0.381-0.603 0.987-0.953 1.716-0.994 0.081 0.491 0.216 0.984 0.406 1.462 0.322 0.816 0.803 1.594 1.391 2.244 1.153 1.281 2.675 2.063 4.347 2.247-0.2 0.225-0.438 0.419-0.709 0.581zM20.869 11.934c0.2 0.725 0.169 1.437-0.063 2.063-3.075-0.097-5.247-2.481-5.712-4.997h1.425c2.609 0 3.959 1.516 4.35 2.934z" })
        );
    }
    function Helicopter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HelicopterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Helicopter.SVG = HelicopterSVG;
    return Helicopter;
})();
export const Helipad = /*#__PURE__*/ (() => {
        function HelipadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M14 11h-4v-4h-2v10h2v-4h4v4h2v-10h-2z" })
            );
        }
        function Helipad({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HelipadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Helipad.SVG = HelipadSVG;
        return Helipad;
    })();
export const Helipad2 = /*#__PURE__*/ (() => {
        function Helipad2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M10 13h4v4h2v-10h-2v4h-4v-4h-2v10h2z" })
            );
        }
        function Helipad2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Helipad2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Helipad2.SVG = Helipad2SVG;
        return Helipad2;
    })();
export const Helm = /*#__PURE__*/ (() => {
        function HelmSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 8c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.206 0 4-1.794 4-4s-1.794-4-4-4zM12 14c-1.103 0-2-0.897-2-2s0.897-2 2-2c1.103 0 2 0.897 2 2s-0.897 2-2 2z" }),
_('path', { d: "M24 13v-2h-3.053c-0.188-1.697-0.847-3.288-1.912-4.619l2.159-2.159-1.416-1.416-2.159 2.163c-1.331-1.069-2.922-1.728-4.619-1.912v-3.056h-2v3.053c-1.697 0.188-3.288 0.847-4.619 1.912l-2.159-2.159-1.416 1.416 2.159 2.159c-1.069 1.331-1.728 2.922-1.912 4.619h-3.053v2h3.053c0.188 1.697 0.847 3.288 1.912 4.619l-2.159 2.159 1.416 1.416 2.159-2.159c1.331 1.069 2.922 1.728 4.619 1.913v3.053h2v-3.053c1.697-0.188 3.288-0.847 4.619-1.913l2.159 2.159 1.416-1.416-2.163-2.159c1.069-1.331 1.728-2.922 1.912-4.619h3.056zM19.938 11h-2.022c-0.153-0.909-0.513-1.753-1.028-2.475l1.428-1.428c0.863 1.106 1.441 2.444 1.622 3.903zM12 17c-2.756 0-5-2.244-5-5s2.244-5 5-5c2.756 0 5 2.244 5 5s-2.244 5-5 5zM16.903 5.681l-1.428 1.428c-0.722-0.516-1.566-0.875-2.475-1.028v-2.019c1.459 0.181 2.797 0.759 3.903 1.619zM11 4.062v2.022c-0.909 0.153-1.753 0.513-2.475 1.028l-1.428-1.428c1.106-0.862 2.444-1.441 3.903-1.622zM5.681 7.097l1.428 1.428c-0.516 0.722-0.875 1.566-1.028 2.475h-2.019c0.181-1.459 0.759-2.797 1.619-3.903zM4.062 13h2.022c0.153 0.909 0.513 1.753 1.028 2.475l-1.428 1.428c-0.862-1.106-1.441-2.444-1.622-3.903zM7.097 18.319l1.428-1.428c0.722 0.516 1.566 0.875 2.475 1.028v2.019c-1.459-0.181-2.797-0.759-3.903-1.619zM13 19.938v-2.022c0.909-0.153 1.753-0.513 2.475-1.028l1.428 1.428c-1.106 0.863-2.444 1.441-3.903 1.622zM18.319 16.903l-1.428-1.428c0.516-0.722 0.875-1.566 1.028-2.475h2.019c-0.181 1.459-0.759 2.797-1.619 3.903z" })
            );
        }
        function Helm({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HelmSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Helm.SVG = HelmSVG;
        return Helm;
    })();
export const HighHeels = /*#__PURE__*/ (() => {
    function HighHeelsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.581 7.728c-0.622-1.459-1.816-2.506-2.866-3.431l-0.056-0.050c-0.416-0.366-1.047-0.325-1.413 0.091l-0.659 0.75c-0.725 0.825-2.466 3.547-3.534 5.688-1.594 3.184-3.547 4.281-4.403 4.225-0.297-0.019-0.397-0.162-0.447-0.294l-0.234-0.947c-0.131-0.537-0.675-0.862-1.212-0.731-2.619 0.647-4.156 1.328-5.141 2.278-1.031 0.994-1.334 2.172-1.6 3.497-0.059 0.294 0.019 0.597 0.206 0.831 0.194 0.231 0.478 0.366 0.778 0.366h11.628c0.5 0 0.981-0.188 1.35-0.525 0 0 0.003-0.003 0.003-0.003 1.347-1.25 2.372-3.159 3.194-4.697 0.15-0.278 0.319-0.597 0.484-0.891 0.012 0.087 0.025 0.178 0.041 0.278 0.122 0.909 0.219 2.172 0.297 3.862v1.975h2.003c0-1.925 0.234-5.394 0.869-6.503 0.638-1.119 0.997-2.144 1.1-3.141 0.097-0.919-0.034-1.8-0.387-2.628zM18.003 11.384c-0.188 0.159-0.372 0.375-0.575 0.675-0.312 0.459-0.638 1.066-1.016 1.772-0.75 1.403-1.684 3.147-2.787 4.169h-10.362c0.422-1.331 1.316-2.122 4.978-3.028 0.003 0.016 0.009 0.028 0.012 0.044 0.203 0.584 0.687 0.941 1.334 0.984 0.044 0.003 0.087 0.003 0.131 0.003 0.75 0 1.638-0.403 2.519-1.147 1.016-0.859 1.953-2.112 2.712-3.631 1.087-2.175 2.781-4.778 3.394-5.472l0.166 0.147c1.872 1.65 3.447 3.119 1.809 6.272-0.022-0.059-0.047-0.119-0.069-0.172-0.231-0.531-0.578-0.85-1.028-0.953-0.244-0.056-0.722-0.084-1.219 0.337z" })
        );
    }
    function HighHeels({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HighHeelsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    HighHeels.SVG = HighHeelsSVG;
    return HighHeels;
})();
export const Highlight = /*#__PURE__*/ (() => {
    function HighlightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.544 10.044l-6.55 6.55c-0.266 0.266-0.619 0.413-0.994 0.413s-0.728-0.147-0.994-0.413l-4.6-4.597c-0.547-0.547-0.547-1.441 0-1.988l6.55-6.55-1.416-1.416-6.547 6.55c-1.137 1.137-1.3 2.884-0.491 4.197l-7.356 7.356c-0.094 0.094-0.147 0.222-0.147 0.353v1c0 0.275 0.225 0.5 0.5 0.5h9c0.131 0 0.259-0.053 0.353-0.147l3.356-3.356c0.531 0.331 1.147 0.506 1.791 0.506 0.909 0 1.766-0.353 2.409-0.997l6.55-6.55-1.416-1.413zM9.294 21h-8.294v-0.294l7.144-7.144 4.294 4.294-3.144 3.144z" })
        );
    }
    function Highlight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HighlightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Highlight.SVG = HighlightSVG;
    return Highlight;
})();
export const Hiking = /*#__PURE__*/ (() => {
        function HikingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 6c1.103 0 2-0.897 2-2s-0.897-2-2-2c-1.103 0-2 0.897-2 2s0.897 2 2 2zM13 3c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M18.447 9.106v0l-6-3c-0.219-0.109-0.469-0.134-0.703-0.072-0.969-0.966-2.172-1.281-3.409-0.884-0.809 0.259-1.6 0.822-2.219 1.584-0.606 0.744-0.997 1.609-1.103 2.437-0.15 1.178 0.281 2.156 1.219 2.75 1.141 0.725 2.116 1.088 2.913 1.088 0.047 0 0.091-0.003 0.134-0.003l-4.4 7.75 1.741 0.987 4.388-7.731c1.025 0.191 2.384 1.241 2.913 2.069l-1.869 5.603 1.897 0.631 2-6c0.075-0.225 0.069-0.472-0.022-0.691-0.309-0.766-1.019-1.609-1.944-2.319-0.419-0.322-1.156-0.816-2.003-1.103 0-0.003 0.003-0.006 0.003-0.009l0.744-3.716 4.828 2.416c0.134 0.069 0.288 0.106 0.447 0.106v11h1v-12c0-0.391-0.225-0.728-0.553-0.894zM8.641 6.103c0.244-0.078 0.487-0.119 0.722-0.119 0.572 0 1.113 0.228 1.597 0.681-0.116 0.603-0.409 2.134-0.653 3.331-1.216-0.034-2.225-0.4-2.997-1.084-0.456-0.406-0.703-0.816-0.8-1 0.5-0.837 1.294-1.544 2.131-1.809zM6.769 11.078c-0.756-0.481-0.831-1.231-0.762-1.778 0.012-0.087 0.028-0.178 0.047-0.269 0.147 0.188 0.328 0.387 0.547 0.588 0.644 0.584 1.763 1.275 3.5 1.369-0.034 0.159-0.063 0.294-0.087 0.397-0.066 0.272-0.213 0.459-0.441 0.55-0.266 0.109-1.072 0.244-2.803-0.856z" })
            );
        }
        function Hiking({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HikingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Hiking.SVG = HikingSVG;
        return Hiking;
    })();
export const History = /*#__PURE__*/ (() => {
        function HistorySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 13c0-0.091-0.012-0.175-0.034-0.259l4.241-4.241-0.706-0.706-4.241 4.241c-0.081-0.022-0.169-0.034-0.259-0.034-0.147 0-0.288 0.031-0.413 0.091l-3.203-2.287-0.581 0.813 3.203 2.288c-0.003 0.031-0.003 0.063-0.003 0.097 0 0.55 0.45 1 1 1 0.547 0 0.997-0.45 0.997-1z" }),
_('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813s-2.384-1.966-3.813-2.572c-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572s-1.966 2.384-2.572 3.813c-0.625 1.481-0.944 3.053-0.944 4.672 0 1.956 0.481 3.9 1.394 5.616 0.456 0.856 1.016 1.659 1.666 2.384h-3.059v2h6c0.553 0 1-0.447 1-1v-6h-2v4.141c-1.9-1.866-3-4.437-3-7.141 0-5.513 4.488-10 10-10s10 4.488 10 10h2c0-1.619-0.319-3.191-0.944-4.672z" }),
_('path', { d: "M12 3c-2.403 0-4.662 0.938-6.363 2.637s-2.637 3.959-2.637 6.363h1c0-4.413 3.588-8 8-8s8 3.588 8 8c0 4.413-3.588 8-8 8v1c2.403 0 4.662-0.938 6.363-2.637s2.637-3.959 2.637-6.363c0-2.403-0.938-4.662-2.637-6.363s-3.959-2.637-6.363-2.637z" })
            );
        }
        function History({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HistorySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        History.SVG = HistorySVG;
        return History;
    })();
export const Hockey = /*#__PURE__*/ (() => {
        function HockeySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.306 0.047c-0.416-0.131-0.869 0.019-1.119 0.372-0.012 0.019-1.313 1.831-3.044 3.822-2.238 2.569-4.153 4.244-5.538 4.841-3.906 1.688-9.031 0.478-10.716 0.081-0.494-0.116-0.694-0.162-0.891-0.162-0.631 0-1.194 0.338-1.544 0.922-0.306 0.513-0.456 1.191-0.456 2.078 0 0.987 0.334 1.819 0.991 2.469 1.416 1.403 3.991 1.541 5.844 1.541 0.244 0 0.475-0.003 0.691-0.003 0.172-0.003 0.334-0.003 0.475-0.003 0.981 0 2.737-0.119 4.444-0.387 0.906-0.141 1.697-0.309 2.347-0.497 0.841-0.241 1.444-0.519 1.841-0.844 0.237-0.194 0.872-0.709 4.144-5.322 1.584-2.231 3.038-4.372 3.053-4.391 0.112-0.166 0.172-0.363 0.172-0.563v-3c0-0.434-0.281-0.819-0.694-0.953zM19.144 7.8c-2.887 4.072-3.619 4.8-3.775 4.925-0.103 0.084-0.744 0.522-3.231 0.912-1.6 0.25-3.231 0.363-4.134 0.363-0.153 0-0.319 0.003-0.497 0.003-1.431 0.016-4.097 0.044-5.106-0.956-0.275-0.269-0.4-0.6-0.4-1.047 0-0.509 0.069-0.809 0.128-0.959 0.091 0.022 0.2 0.047 0.3 0.069 0.975 0.231 2.794 0.659 4.953 0.803 2.709 0.181 5.069-0.153 7.016-0.994 1.681-0.725 3.784-2.531 6.253-5.363 0.116-0.134 0.231-0.266 0.341-0.397-0.522 0.756-1.175 1.688-1.847 2.641z" }),
_('path', { d: "M7.672 18.481c-0.722-0.309-1.672-0.481-2.672-0.481s-1.95 0.172-2.672 0.481c-1.156 0.494-1.328 1.163-1.328 1.519v2c0 0.356 0.172 1.025 1.328 1.519 0.722 0.309 1.672 0.481 2.672 0.481s1.95-0.172 2.672-0.481c1.156-0.494 1.328-1.166 1.328-1.519v-2c0-0.356-0.172-1.025-1.328-1.519zM5 23c-1.863 0-3-0.647-3-1v-0.637c0.1 0.053 0.209 0.106 0.328 0.159 0.722 0.306 1.672 0.478 2.672 0.478s1.95-0.172 2.672-0.481c0.119-0.050 0.228-0.103 0.328-0.159v0.641c0 0.353-1.137 1-3 1zM5 21c-1.863 0-3-0.647-3-1s1.137-1 3-1 3 0.647 3 1-1.137 1-3 1z" })
            );
        }
        function Hockey({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HockeySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Hockey.SVG = HockeySVG;
        return Hockey;
    })();
export const HomeLock = /*#__PURE__*/ (() => {
        function HomeLockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.972 13.556l-4.972-5.163v-5.894c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v1.737l-1.556-1.619c-0.381-0.397-0.894-0.612-1.441-0.612 0 0 0 0 0 0-0.55 0-1.059 0.219-1.441 0.612l-10.531 10.938 1.441 1.387 2.528-2.628v7.684c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2v-7.684l2.528 2.628 1.444-1.388zM16 3h2v4.353l-2-2.078v-2.275zM18 20h-12v-9.759l6-6.234 6 6.231v9.762z" }),
_('path', { d: "M9 12v1h-0.5c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5h7c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5h-0.5v-1c0-1.653-1.347-3-3-3s-3 1.347-3 3zM15 17h-6v-3h6v3zM14 12v1h-4v-1c0-1.103 0.897-2 2-2s2 0.897 2 2z" })
            );
        }
        function HomeLock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HomeLockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HomeLock.SVG = HomeLockSVG;
        return HomeLock;
    })();
export const HomeSleep = /*#__PURE__*/ (() => {
        function HomeSleepSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 4.5c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v1.737l-1.556-1.619c-0.381-0.397-0.894-0.612-1.441-0.612 0 0 0 0 0 0-0.55 0-1.059 0.219-1.441 0.612l-10.531 10.938 1.441 1.388 2.528-2.628v7.684c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2v-7.684l2.528 2.628 1.441-1.388-4.969-5.163v-5.894zM16 5h2v4.353l-2-2.078v-2.275zM18 22h-12v-9.759l6-6.234 6 6.231v9.762z" }),
_('path', { d: "M23.853 0.853c0.144-0.144 0.184-0.359 0.109-0.544-0.078-0.187-0.259-0.309-0.462-0.309h-3.5v1h2.294l-2.147 2.147c-0.144 0.144-0.184 0.359-0.109 0.544 0.078 0.188 0.259 0.309 0.462 0.309h3.5v-1h-2.294l2.147-2.147z" }),
_('path', { d: "M9 14h4.294l-4.147 4.147c-0.144 0.144-0.184 0.359-0.109 0.544s0.259 0.309 0.462 0.309h5.5v-1h-4.294l4.147-4.147c0.144-0.144 0.184-0.359 0.109-0.544s-0.259-0.309-0.462-0.309h-5.5v1z" }),
_('path', { d: "M1.038 6.691c0.078 0.188 0.259 0.309 0.462 0.309h4.5v-1h-3.294l3.147-3.147c0.144-0.144 0.184-0.359 0.109-0.544-0.078-0.188-0.259-0.309-0.462-0.309h-4.5v1h3.294l-3.147 3.147c-0.144 0.144-0.188 0.356-0.109 0.544z" })
            );
        }
        function HomeSleep({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HomeSleepSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HomeSleep.SVG = HomeSleepSVG;
        return HomeSleep;
    })();
export const HomeSmart = /*#__PURE__*/ (() => {
        function HomeSmartSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.972 13.556l-4.972-5.163v-5.894c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v1.737l-1.556-1.619c-0.381-0.397-0.894-0.612-1.441-0.612 0 0 0 0 0 0-0.55 0-1.059 0.219-1.441 0.612l-10.531 10.938 1.441 1.387 2.528-2.628v7.684c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2v-7.684l2.528 2.628 1.444-1.388zM16 3h2v4.353l-2-2.078v-2.275zM18 20h-12v-9.759l6-6.234 6 6.231v9.762z" }),
_('path', { d: "M14.122 15.878l0.353 0.353-0.706 0.706-0.353-0.353c-0.378-0.375-0.881-0.584-1.416-0.584s-1.038 0.209-1.413 0.584l-0.356 0.353-0.706-0.706 0.353-0.353c0.569-0.566 1.322-0.878 2.122-0.878s1.553 0.312 2.122 0.878zM12 13c-1.334 0-2.591 0.519-3.534 1.466l-0.353 0.353 0.706 0.706 0.353-0.353c0.756-0.756 1.759-1.172 2.828-1.172s2.072 0.416 2.828 1.172l0.353 0.353 0.706-0.706-0.353-0.353c-0.944-0.947-2.2-1.466-3.534-1.466zM7.050 13.050l-0.353 0.353 0.706 0.706 0.353-0.353c1.134-1.131 2.641-1.756 4.244-1.756s3.109 0.625 4.244 1.756l0.353 0.353 0.706-0.706-0.353-0.353c-1.322-1.322-3.081-2.050-4.95-2.050s-3.628 0.728-4.95 2.050z" })
            );
        }
        function HomeSmart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HomeSmartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HomeSmart.SVG = HomeSmartSVG;
        return HomeSmart;
    })();
export const HomeUser = /*#__PURE__*/ (() => {
        function HomeUserSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.972 13.556l-4.972-5.163v-5.894c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v1.737l-1.556-1.619c-0.381-0.397-0.894-0.612-1.441-0.612 0 0 0 0 0 0-0.55 0-1.059 0.219-1.441 0.612l-10.531 10.938 1.441 1.387 2.528-2.628v7.684c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2v-7.684l2.528 2.628 1.444-1.388zM16 3h2v4.353l-2-2.078v-2.275zM18 20h-12v-9.759l6-6.234 6 6.231v9.762z" }),
_('path', { d: "M9 12c0 0.95 0.444 1.797 1.134 2.347-0.156 0.066-0.309 0.144-0.456 0.231-0.631 0.372-1.156 0.916-1.606 1.666-0.141 0.231-0.069 0.534 0.159 0.681 1.144 0.722 2.378 1.075 3.769 1.075s2.625-0.353 3.769-1.078c0.228-0.147 0.3-0.447 0.159-0.681-0.45-0.75-0.975-1.294-1.606-1.666-0.147-0.087-0.3-0.162-0.456-0.231 0.691-0.55 1.134-1.397 1.134-2.347 0-1.653-1.347-3-3-3s-3 1.35-3 3.003zM14.787 16.334c-0.853 0.447-1.769 0.666-2.787 0.666s-1.934-0.219-2.787-0.666c0.691-0.919 1.569-1.334 2.787-1.334s2.097 0.416 2.787 1.334zM14 12c0 1.103-0.897 2-2 2s-2-0.897-2-2c0-1.103 0.897-2 2-2s2 0.897 2 2z" })
            );
        }
        function HomeUser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HomeUserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HomeUser.SVG = HomeUserSVG;
        return HomeUser;
    })();
export const Home = /*#__PURE__*/ (() => {
    function HomeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.972 13.556l-10.528-10.938c-0.375-0.391-0.9-0.612-1.441-0.612s-1.066 0.222-1.441 0.612l-10.534 10.938 1.441 1.388 2.528-2.628v7.684c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2v-7.684l2.528 2.628 1.447-1.388zM18 20h-12v-9.762l6-6.234 6 6.234v9.762z" })
        );
    }
    function Home({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HomeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Home.SVG = HomeSVG;
    return Home;
})();
export const Home2 = /*#__PURE__*/ (() => {
    function Home2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.972 13.556l-10.528-10.938c-0.381-0.397-0.894-0.612-1.441-0.612 0 0 0 0 0 0-0.55 0-1.059 0.219-1.441 0.612l-10.531 10.938 1.441 1.388 2.528-2.628v7.684c0 1.103 0.897 2 2 2h3.5c0.275 0 0.5-0.225 0.5-0.5v-6.5h4v6.5c0 0.275 0.225 0.5 0.5 0.5h3.5c1.103 0 2-0.897 2-2v-7.684l2.528 2.628 1.444-1.388zM18 20h-3v-5.5c0-0.275-0.225-0.5-0.5-0.5h-5c-0.275 0-0.5 0.225-0.5 0.5v5.5h-3v-9.759l6-6.234 6 6.231v9.762z" })
        );
    }
    function Home2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Home2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Home2.SVG = Home2SVG;
    return Home2;
})();
export const Home3 = /*#__PURE__*/ (() => {
    function Home3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.972 13.556l-4.972-5.163v-5.894c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v1.737l-1.556-1.619c-0.381-0.397-0.894-0.612-1.441-0.612 0 0 0 0 0 0-0.55 0-1.059 0.219-1.441 0.612l-10.531 10.938 1.441 1.387 2.528-2.628v7.684c0 1.103 0.897 2 2 2h3.5c0.275 0 0.5-0.225 0.5-0.5v-6.5h4v6.5c0 0.275 0.225 0.5 0.5 0.5h3.5c1.103 0 2-0.897 2-2v-7.684l2.528 2.628 1.444-1.388zM16 3h2v4.353l-2-2.078v-2.275zM18 20h-3v-5.5c0-0.275-0.225-0.5-0.5-0.5h-5c-0.275 0-0.5 0.225-0.5 0.5v5.5h-3v-9.759l6-6.234 6 6.231v9.762z" })
        );
    }
    function Home3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Home3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Home3.SVG = Home3SVG;
    return Home3;
})();
export const Home4 = /*#__PURE__*/ (() => {
    function Home4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.972 13.556l-4.972-5.163v-5.894c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v1.737l-1.559-1.619c-0.375-0.391-0.9-0.612-1.441-0.612s-1.066 0.222-1.441 0.612l-10.531 10.938 1.441 1.387 2.528-2.628v7.684c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2v-7.684l2.528 2.628 1.447-1.388zM16 3h2v4.353l-2-2.078v-2.275zM18 20h-12v-9.762l6-6.234 6 6.234v9.762z" })
        );
    }
    function Home4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Home4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Home4.SVG = Home4SVG;
    return Home4;
})();
export const Hoodie = /*#__PURE__*/ (() => {
    function HoodieSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.994 23c0-0.159 0-0.341 0.003-0.544 0.006-1.106 0.016-2.778-0.109-4.434-0.159-2.109-0.494-3.588-1.022-4.519-0.681-1.2-1.703-2.103-3.028-2.684-0.369-0.162-0.762-0.3-1.181-0.413 0.834-0.894 1.347-2.094 1.347-3.409 0-1.475-0.369-3.075-0.984-4.284-0.406-0.797-0.919-1.431-1.522-1.887-0.731-0.547-1.569-0.825-2.497-0.825s-1.766 0.278-2.494 0.828c-0.603 0.456-1.116 1.091-1.522 1.887-0.616 1.209-0.984 2.809-0.984 4.284 0 1.316 0.509 2.516 1.344 3.409-0.419 0.113-0.813 0.253-1.184 0.416-1.328 0.581-2.347 1.484-3.028 2.684-0.528 0.931-0.863 2.406-1.022 4.519-0.125 1.653-0.116 3.328-0.109 4.434 0 0.203 0.003 0.384 0.003 0.544v0.5c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-0.5h-0.009zM9.766 3.625c0.831-1.625 1.887-1.625 2.234-1.625s1.403 0 2.234 1.625c0.566 1.106 0.766 2.469 0.766 3.375 0 1.638-1.319 2.975-2.953 3-0.016 0-0.034 0-0.050 0-0.012 0-0.028 0-0.041 0-1.634-0.025-2.956-1.359-2.956-3 0-0.906 0.2-2.269 0.766-3.375zM16 23v-6h-1v6h-6v-6h-1v6h-3c0-0.162 0-0.347-0.003-0.556-0.009-1.903-0.034-6.356 0.872-7.95 0.759-1.334 2.094-2.112 4.131-2.384v2.891h1v-2.981c0.3-0.016 0.609-0.022 0.934-0.019 0.022 0 0.044 0 0.066 0s0.047 0 0.069 0c0.322-0.003 0.634 0.006 0.931 0.022v2.978h1v-2.888c2.034 0.272 3.366 1.050 4.125 2.384 0.906 1.594 0.881 6.050 0.872 7.95 0 0.206-0.003 0.394-0.003 0.556h-2.994z" })
        );
    }
    function Hoodie({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HoodieSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Hoodie.SVG = HoodieSVG;
    return Hoodie;
})();
export const Hook = /*#__PURE__*/ (() => {
    function HookSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19 6c0-0.738-0.403-1.384-1-1.731v-4.269h-2v4.269c-0.597 0.347-1 0.994-1 1.731s0.403 1.384 1 1.731v9.769c0 2.481-2.019 4.5-4.5 4.5s-4.5-2.019-4.5-4.5v-1.547l1.456 1.903 1.587-1.216-3.25-4.25c-0.259-0.341-0.709-0.478-1.116-0.341s-0.678 0.519-0.678 0.947v4.5c0 3.584 2.916 6.5 6.5 6.5 3.309 0 6.047-2.484 6.45-5.684 0.034-0.1 0.050-0.206 0.050-0.316v-10.266c0.597-0.347 1-0.994 1-1.731zM17 7c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
        );
    }
    function Hook({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HookSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Hook.SVG = HookSVG;
    return Hook;
})();
export const Horns = /*#__PURE__*/ (() => {
    function HornsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19 4c-1.653 0-3 1.347-3 3v1c-0.237 0-0.469 0.028-0.697 0.081-0.55-0.659-1.378-1.081-2.303-1.081v-2c0-1.653-1.347-3-3-3s-3 1.347-3 3v7.15l-1.128-0.738c-0.406-0.266-0.881-0.409-1.372-0.409-1.378 0-2.5 1.119-2.5 2.497 0 0.541 0.172 1.059 0.497 1.497 0 0.003 0.003 0.003 0.003 0.006l4.525 6.034c0.922 1.228 2.394 1.962 3.934 1.962h4.887c1.85 0 3.525-1.019 4.372-2.656 0 0 0-0.003 0-0.003 1.166-2.262 1.781-4.803 1.781-7.341v-6c0-1.653-1.347-3-3-3zM16.494 10.131c0.309 0.178 0.506 0.513 0.506 0.869v2h1v-6c0-0.55 0.45-1 1-1s1 0.45 1 1v6c0 2.222-0.537 4.444-1.556 6.425-0.503 0.972-1.497 1.575-2.597 1.575h-4.887c-0.916 0-1.788-0.434-2.334-1.163l-4.522-6.031c-0.047-0.063-0.103-0.169-0.103-0.306 0-0.275 0.225-0.497 0.5-0.497 0.1 0 0.194 0.028 0.275 0.081l2.678 1.753c0.306 0.2 0.7 0.219 1.022 0.044s0.525-0.513 0.525-0.881v-9c0-0.55 0.45-1 1-1s1 0.45 1 1v7h1v-2c0-0.175 0.047-0.35 0.134-0.5 0.075-0.131 0.181-0.247 0.309-0.331 0.166-0.109 0.359-0.169 0.559-0.169 0.55 0 1 0.45 1 1v2h1v-1c0-0.334 0.166-0.644 0.444-0.831 0.166-0.109 0.359-0.169 0.556-0.169 0.172 0 0.344 0.047 0.491 0.131z" })
        );
    }
    function Horns({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HornsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Horns.SVG = HornsSVG;
    return Horns;
})();
export const HotDog = /*#__PURE__*/ (() => {
        function HotDogSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.419 8.003l0.247-0.247c0.859-0.856 1.334-1.997 1.334-3.209 0-1.216-0.472-2.356-1.331-3.216-0.856-0.859-1.997-1.331-3.213-1.331s-2.353 0.472-3.213 1.331l-0.25 0.25-0.225-0.225c-1.803-1.803-4.737-1.803-6.541 0l-7.875 7.875c-1.803 1.803-1.803 4.737 0 6.541l0.225 0.225-0.25 0.25c-1.769 1.769-1.769 4.65 0 6.425 0.859 0.859 2 1.331 3.213 1.331s2.353-0.472 3.213-1.331l0.25-0.25 0.228 0.228c0.903 0.903 2.088 1.353 3.272 1.353s2.369-0.45 3.272-1.353l7.875-7.875c1.803-1.803 1.803-4.737 0-6.541l-0.231-0.231zM2.769 14.356c-1.025-1.025-1.025-2.691 0-3.713l7.875-7.875c1.025-1.025 2.691-1.025 3.713 0l0.225 0.225-11.587 11.588-0.225-0.225zM2.747 21.253c-0.991-0.994-0.991-2.606 0-3.597l14.913-14.913c0.481-0.481 1.119-0.744 1.797-0.744s1.316 0.266 1.797 0.747c0.481 0.481 0.747 1.122 0.744 1.8 0 0.678-0.266 1.316-0.747 1.794l-14.909 14.913c-0.991 0.991-2.606 0.991-3.594 0zM21.231 13.356l-7.875 7.875c-0.497 0.497-1.156 0.769-1.856 0.769s-1.359-0.272-1.856-0.769l-0.228-0.228 11.588-11.587 0.228 0.228c0.497 0.497 0.769 1.156 0.769 1.856 0 0.703-0.272 1.359-0.769 1.856z" }),
_('path', { d: "M19.178 5.178c-0.581 0.581-1.050 0.647-1.644 0.728-0.653 0.091-1.397 0.194-2.216 1.012s-0.922 1.559-1.012 2.216c-0.081 0.594-0.147 1.062-0.728 1.644s-1.050 0.647-1.647 0.728c-0.656 0.091-1.397 0.191-2.216 1.009s-0.922 1.559-1.012 2.216c-0.081 0.594-0.147 1.062-0.728 1.644s-1.050 0.647-1.644 0.728c-0.653 0.091-1.397 0.194-2.216 1.013l-0.353 0.353 0.706 0.706 0.353-0.353c0.581-0.581 1.050-0.647 1.644-0.728 0.653-0.091 1.397-0.194 2.216-1.012s0.922-1.559 1.013-2.216c0.081-0.594 0.147-1.062 0.728-1.644s1.050-0.647 1.647-0.728c0.656-0.091 1.397-0.191 2.216-1.009s0.922-1.559 1.013-2.216c0.081-0.594 0.147-1.062 0.728-1.644s1.050-0.647 1.644-0.728c0.653-0.091 1.397-0.194 2.216-1.012l0.353-0.353-0.706-0.706-0.353 0.353z" })
            );
        }
        function HotDog({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HotDogSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        HotDog.SVG = HotDogSVG;
        return HotDog;
    })();
export const Hotspot = /*#__PURE__*/ (() => {
        function HotspotSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8.344 8.553l-0.791-0.612-0.306 0.397c-1.666 2.156-1.669 5.169 0 7.328l0.306 0.397 0.791-0.612-0.306-0.397c-1.387-1.797-1.387-4.309 0-6.106l0.306-0.394z" }),
_('path', { d: "M5.9 6.825l0.325-0.381-0.762-0.647-0.325 0.381c-1.378 1.619-2.138 3.687-2.138 5.822s0.759 4.203 2.137 5.822l0.325 0.381 0.762-0.647-0.325-0.381c-2.55-2.997-2.55-7.35 0-10.35z" }),
_('path', { d: "M3.759 4.716l0.331-0.375-0.75-0.663-0.331 0.375c-4.013 4.531-4.013 11.366 0 15.894l0.331 0.375 0.75-0.663-0.331-0.375c-3.678-4.153-3.678-10.416 0-14.569z" }),
_('path', { d: "M12 9c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM12 13c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M16.753 8.337l-0.306-0.397-0.791 0.612 0.306 0.397c1.388 1.797 1.391 4.306 0 6.106l-0.306 0.397 0.791 0.612 0.306-0.397c1.669-2.163 1.666-5.175 0-7.331z" }),
_('path', { d: "M18.862 6.175l-0.325-0.381-0.762 0.647 0.325 0.381c2.55 3 2.547 7.356-0.003 10.353l-0.325 0.381 0.762 0.647 0.325-0.381c1.378-1.619 2.137-3.687 2.137-5.822 0.003-2.134-0.756-4.203-2.134-5.825z" }),
_('path', { d: "M20.991 4.053l-0.331-0.375-0.75 0.663 0.331 0.375c3.678 4.153 3.678 10.416 0 14.569l-0.331 0.375 0.75 0.663 0.331-0.375c4.012-4.531 4.012-11.363 0-15.894z" })
            );
        }
        function Hotspot({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HotspotSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Hotspot.SVG = HotspotSVG;
        return Hotspot;
    })();
export const Hotspot2 = /*#__PURE__*/ (() => {
        function Hotspot2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8.344 11.553l-0.791-0.612-0.306 0.397c-1.666 2.156-1.669 5.169 0 7.328l0.306 0.397 0.791-0.612-0.306-0.397c-1.387-1.797-1.387-4.309 0-6.106l0.306-0.394z" }),
_('path', { d: "M5.9 9.825l0.325-0.381-0.762-0.647-0.325 0.381c-1.378 1.619-2.138 3.687-2.138 5.822s0.759 4.203 2.137 5.822l0.325 0.381 0.762-0.647-0.325-0.381c-2.55-2.997-2.55-7.35 0-10.35z" }),
_('path', { d: "M3.759 7.716l0.331-0.375-0.75-0.663-0.331 0.375c-4.013 4.531-4.013 11.366 0 15.894l0.331 0.375 0.75-0.663-0.331-0.375c-3.678-4.153-3.678-10.416 0-14.569z" }),
_('path', { d: "M9 1.706v6.294h1v-6.294l1.5 1.5 0.706-0.706-2.353-2.353c-0.194-0.194-0.513-0.194-0.706 0l-2.353 2.353 0.706 0.706 1.5-1.5z" }),
_('path', { d: "M11.794 5.5l2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l2.353-2.353-0.706-0.706-1.5 1.5v-6.294h-1v6.294l-1.5-1.5-0.706 0.706z" }),
_('path', { d: "M12 12c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM12 16c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M16.753 11.337l-0.306-0.397-0.791 0.612 0.306 0.397c1.388 1.797 1.391 4.306 0 6.106l-0.306 0.397 0.791 0.612 0.306-0.397c1.669-2.163 1.666-5.175 0-7.331z" }),
_('path', { d: "M18.862 9.175l-0.325-0.381-0.762 0.647 0.325 0.381c2.55 3 2.547 7.356-0.003 10.353l-0.325 0.381 0.762 0.647 0.325-0.381c1.378-1.619 2.137-3.687 2.137-5.822 0.003-2.134-0.756-4.203-2.134-5.825z" }),
_('path', { d: "M20.991 7.053l-0.331-0.375-0.75 0.663 0.331 0.375c3.678 4.153 3.678 10.416 0 14.569l-0.331 0.375 0.75 0.663 0.331-0.375c4.012-4.531 4.012-11.363 0-15.894z" })
            );
        }
        function Hotspot2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Hotspot2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Hotspot2.SVG = Hotspot2SVG;
        return Hotspot2;
    })();
export const Hourglass = /*#__PURE__*/ (() => {
        function HourglassSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.959 7.969c0.669-1.256 1.009-2.644 1.041-4.238 0.597-0.344 1-0.991 1-1.731h1v-2h-18v2h1c0 0.741 0.403 1.387 1.003 1.734 0.031 1.591 0.372 2.981 1.041 4.237 0.597 1.122 1.347 1.934 1.953 2.584 0.541 0.581 1.006 1.084 1.006 1.447s-0.466 0.862-1.006 1.447c-0.603 0.653-1.356 1.463-1.953 2.584-0.669 1.256-1.009 2.644-1.041 4.237-0.6 0.341-1.003 0.987-1.003 1.728h-1v2h18v-2h-1c0-0.741-0.403-1.387-1.003-1.734-0.031-1.591-0.372-2.981-1.041-4.238-0.597-1.122-1.347-1.934-1.953-2.584-0.537-0.581-1.003-1.084-1.003-1.444s0.466-0.862 1.006-1.447c0.603-0.65 1.356-1.463 1.953-2.584zM19 2c0 0.55-0.45 1-1 1h-12c-0.55 0-1-0.45-1-1h14zM8.231 16.297c1.334-0.691 2.653-0.041 4.050 0.65 0.75 0.369 1.525 0.753 2.328 0.938 0.331 0.075 0.65 0.116 0.963 0.116 0.35 0 0.691-0.050 1.019-0.147 0.216 0.609 0.363 1.313 0.403 2.147h-9.981c0.084-1.669 0.584-2.809 1.209-3.716l0.009 0.012zM5 22c0-0.55 0.45-1 1-1h12c0.55 0 1 0.45 1 1h-14zM14.538 14.806c0.566 0.609 1.166 1.259 1.634 2.122-1.131 0.272-2.262-0.288-3.453-0.875-0.75-0.369-1.525-0.753-2.328-0.938-0.387-0.087-0.759-0.125-1.116-0.112 0.063-0.066 0.122-0.134 0.184-0.2 0.791-0.853 1.537-1.659 1.537-2.806 0-1.144-0.747-1.95-1.538-2.806-1.087-1.175-2.313-2.497-2.45-5.194h9.975c-0.134 2.697-1.359 4.022-2.45 5.194-0.787 0.859-1.534 1.666-1.534 2.809s0.747 1.95 1.538 2.806z" }),
_('path', { d: "M15.847 5.178l-0.953-0.306-0.153 0.475c-0.337 1.053-0.984 1.75-1.669 2.487-0.344 0.372-0.734 0.791-1.078 1.275l-0.291 0.406 0.813 0.581 0.291-0.406c0.309-0.431 0.659-0.809 0.997-1.175 0.728-0.788 1.481-1.6 1.887-2.862l0.156-0.475z" })
            );
        }
        function Hourglass({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HourglassSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Hourglass.SVG = HourglassSVG;
        return Hourglass;
    })();
export const Hydrant = /*#__PURE__*/ (() => {
        function HydrantSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 13c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 14v0c0 0 0 0 0 0z" }),
_('path', { d: "M20.853 13.147l-1-1c-0.094-0.094-0.222-0.147-0.353-0.147h-0.5v-0.5c0-0.275-0.225-0.5-0.5-0.5h-1.5v-3h0.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-0.5c0-2.756-2.244-5-5-5s-5 2.244-5 5h-0.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h0.5v3h-1.5c-0.275 0-0.5 0.225-0.5 0.5v0.5h-0.5c-0.131 0-0.259 0.053-0.353 0.147l-1 1c-0.094 0.094-0.147 0.222-0.147 0.353v1c0 0.131 0.053 0.259 0.147 0.353l1 1c0.094 0.094 0.222 0.147 0.353 0.147h0.5v0.5c0 0.275 0.225 0.5 0.5 0.5h1.5v5h-1v2h12v-2h-1v-5h1.5c0.275 0 0.5-0.225 0.5-0.5v-0.5h0.5c0.131 0 0.259-0.053 0.353-0.147l1-1c0.094-0.094 0.147-0.222 0.147-0.353v-1c0-0.131-0.053-0.259-0.147-0.353zM4.706 15l-0.706-0.706v-0.584l0.706-0.706h0.294v2h-0.294zM12 2c1.653 0 3 1.347 3 3h-6c0-1.653 1.347-3 3-3zM6 6.5c0-0.275 0.225-0.5 0.5-0.5h11c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-11c-0.275 0-0.5-0.225-0.5-0.5zM15 8v3.356c-0.734-0.831-1.806-1.356-3-1.356s-2.266 0.525-3 1.356v-3.356h6zM15 14c0 1.653-1.347 3-3 3s-3-1.347-3-3 1.347-3 3-3 3 1.347 3 3zM6 16v-4h1v4h-1zM9 22v-5.356c0.734 0.831 1.806 1.356 3 1.356s2.266-0.525 3-1.356v5.356h-6zM18 16h-1v-4h1v4zM20 14.294l-0.706 0.706h-0.294v-2h0.294l0.706 0.706v0.588z" })
            );
        }
        function Hydrant({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HydrantSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Hydrant.SVG = HydrantSVG;
        return Hydrant;
    })();
export const Ic = /*#__PURE__*/ (() => {
        function IcSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 19c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1z" }),
_('path', { d: "M21 3v-1h-3c0-1.103-0.897-2-2-2h-8c-1.103 0-2 0.897-2 2h-3v1h3v2h-3v1h3v2h-3v1h3v2h-3v1h3v2h-3v1h3v2h-3v1h3v2h-3v1h3v1c0 1.103 0.897 2 2 2h8c1.103 0 2-0.897 2-2v-1h3v-1h-3v-2h3v-1h-3v-2h3v-1h-3v-2h3v-1h-3v-2h3v-1h-3v-2h3v-1h-3v-2h3zM13 2c0 0.55-0.45 1-1 1s-1-0.45-1-1h2zM16 22h-8v-20h2c0 1.103 0.897 2 2 2s2-0.897 2-2h2v20c0 0 0 0 0 0z" })
            );
        }
        function Ic({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( IcSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ic.SVG = IcSVG;
        return Ic;
    })();
export const IceCreamBar = /*#__PURE__*/ (() => {
        function IceCreamBarSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12.003 0v0c-1.606 0-3.113 0.625-4.244 1.756-1.134 1.134-1.759 2.641-1.759 4.244v9c0 1.653 1.347 3 3 3h1v4c0 1.103 0.897 2 2 2s2-0.897 2-2v-4h1c1.653 0 3-1.347 3-3v-8.953c0-3.331-2.691-6.044-5.997-6.047zM13 22c0 0.55-0.45 1-1 1s-1-0.45-1-1v-4h2v4zM16 15c0 0.55-0.45 1-1 1h-6c-0.55 0-1-0.45-1-1v-9c0-1.069 0.416-2.075 1.172-2.828 0.756-0.756 1.759-1.172 2.828-1.172h0.003c2.203 0 3.997 1.816 3.997 4.047v8.953z" }),
_('path', { d: "M12 3v1c1.103 0 2 0.897 2 2v4h1v-4c0-1.653-1.347-3-3-3z" })
            );
        }
        function IceCreamBar({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( IceCreamBarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        IceCreamBar.SVG = IceCreamBarSVG;
        return IceCreamBar;
    })();
export const IceCream = /*#__PURE__*/ (() => {
    function IceCreamSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21 8c0-2.313-1.578-4.263-3.712-4.831-1.013-1.884-3.003-3.169-5.288-3.169-2.231 0-4.253 1.228-5.291 3.169-2.134 0.572-3.709 2.522-3.709 4.831 0 2.459 1.784 4.509 4.125 4.922l3.941 10.431c0.147 0.387 0.522 0.647 0.934 0.647s0.788-0.259 0.934-0.647l3.937-10.431c2.344-0.412 4.128-2.463 4.128-4.922zM14.856 15.438l-4.147 4.147-0.434-1.15 5.431-5.434h0.069l-0.919 2.438zM9.888 17.406l-0.434-1.15 3.253-3.256h1.584l-4.403 4.406zM9.066 15.228l-0.844-2.228h3.069l-2.225 2.228zM12 23l-0.903-2.391 2.9-2.9-1.997 5.291zM16 11h-8c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3h2c0-2.344-1.622-4.319-3.803-4.856 0.734-0.719 1.731-1.144 2.803-1.144 2.206 0 4 1.794 4 4 0 0.269-0.028 0.541-0.081 0.8l1.959 0.397c0.078-0.394 0.119-0.797 0.119-1.2 0-0.081-0.003-0.159-0.006-0.237 0.622 0.553 1.009 1.353 1.009 2.241 0 1.653-1.347 3-3 3z" })
        );
    }
    function IceCream({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( IceCreamSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    IceCream.SVG = IceCreamSVG;
    return IceCream;
})();
export const Import = /*#__PURE__*/ (() => {
        function ImportSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 15v4h-20v-4h-2v4c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-4h-2z" }),
_('path', { d: "M11 15h2v-5h5v-2h-5v-5h-2v5h-5v2h5z" })
            );
        }
        function Import({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ImportSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Import.SVG = ImportSVG;
        return Import;
    })();
export const IndentDecrease = /*#__PURE__*/ (() => {
        function IndentDecreaseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3 2h21v2h-21v-2z" }),
_('path', { d: "M3 21h21v1h-21v-1z" }),
_('path', { d: "M5.956 15.544l-2.541-2.544h5.584v-2h-5.584l2.544-2.544-1.416-1.416-4.25 4.25c-0.391 0.391-0.391 1.025 0 1.416l4.25 4.25 1.413-1.413z" }),
_('path', { d: "M11 9h13v1h-13v-1z" }),
_('path', { d: "M11 12h13v1h-13v-1z" }),
_('path', { d: "M11 15h13v1h-13v-1z" }),
_('path', { d: "M11 18h13v1h-13v-1z" }),
_('path', { d: "M11 6h13v1h-13v-1z" })
            );
        }
        function IndentDecrease({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( IndentDecreaseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        IndentDecrease.SVG = IndentDecreaseSVG;
        return IndentDecrease;
    })();
export const IndentIncrease = /*#__PURE__*/ (() => {
        function IndentIncreaseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3 2h21v2h-21v-2z" }),
_('path', { d: "M3 21h21v1h-21v-1z" }),
_('path', { d: "M3.044 15.544l1.416 1.416 4.25-4.25c0.391-0.391 0.391-1.025 0-1.416l-4.25-4.25-1.416 1.416 2.544 2.544h-5.587v2h5.584l-2.541 2.541z" }),
_('path', { d: "M11 9h13v1h-13v-1z" }),
_('path', { d: "M11 12h13v1h-13v-1z" }),
_('path', { d: "M11 15h13v1h-13v-1z" }),
_('path', { d: "M11 18h13v1h-13v-1z" }),
_('path', { d: "M11 6h13v1h-13v-1z" })
            );
        }
        function IndentIncrease({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( IndentIncreaseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        IndentIncrease.SVG = IndentIncreaseSVG;
        return IndentIncrease;
    })();
export const InfinityCircle = /*#__PURE__*/ (() => {
        function InfinityCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M16.194 9.113c-0.453-0.153-1.191-0.228-2.134 0.275-0.669 0.356-1.359 0.963-2.059 1.8-0.7-0.837-1.391-1.441-2.059-1.8-0.944-0.503-1.681-0.428-2.134-0.275-0.559 0.188-1.031 0.594-1.359 1.175-0.288 0.506-0.447 1.109-0.447 1.703v0.006c0 0.594 0.159 1.197 0.447 1.703 0.331 0.581 0.8 0.987 1.359 1.175 0.453 0.153 1.191 0.228 2.134-0.275 0.669-0.356 1.359-0.963 2.059-1.8 0.7 0.837 1.391 1.441 2.059 1.8 0.55 0.294 1.028 0.391 1.422 0.391 0.284 0 0.522-0.050 0.712-0.112 0.559-0.188 1.031-0.594 1.359-1.175 0.288-0.506 0.447-1.109 0.447-1.703v-0.006c0-0.594-0.159-1.197-0.447-1.703-0.328-0.581-0.8-0.987-1.359-1.178zM8.519 13.994c-0.138 0-0.269-0.022-0.394-0.063-0.731-0.247-1.125-1.178-1.125-1.931v-0.006c0-0.753 0.394-1.688 1.125-1.931 0.125-0.041 0.256-0.063 0.394-0.063 0.8 0 1.806 0.703 2.85 1.997-1.044 1.297-2.050 1.997-2.85 1.997zM17 12c0 0.753-0.394 1.688-1.125 1.931-0.85 0.284-2.022-0.419-3.244-1.934 1.222-1.519 2.394-2.222 3.244-1.934 0.731 0.247 1.125 1.178 1.125 1.931v0.006z" })
            );
        }
        function InfinityCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( InfinityCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        InfinityCircle.SVG = InfinityCircleSVG;
        return InfinityCircle;
    })();
export const InfinitySquare = /*#__PURE__*/ (() => {
        function InfinitySquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M7.806 14.878c0.453 0.153 1.191 0.228 2.134-0.275 0.669-0.356 1.359-0.963 2.059-1.8 0.7 0.837 1.391 1.441 2.059 1.8 0.55 0.294 1.028 0.391 1.422 0.391 0.284 0 0.522-0.050 0.712-0.113 0.559-0.188 1.031-0.594 1.359-1.175 0.288-0.509 0.447-1.113 0.447-1.706v-0.006c0-0.594-0.159-1.197-0.447-1.703-0.331-0.581-0.8-0.987-1.359-1.175-0.453-0.153-1.191-0.228-2.134 0.275-0.669 0.356-1.359 0.963-2.059 1.8-0.7-0.837-1.391-1.441-2.059-1.8-0.944-0.503-1.681-0.428-2.134-0.275-0.559 0.188-1.031 0.594-1.359 1.175-0.288 0.506-0.447 1.109-0.447 1.703v0.006c0 0.594 0.159 1.197 0.447 1.703 0.328 0.581 0.8 0.987 1.359 1.175zM15.875 10.062c0.731 0.247 1.125 1.178 1.125 1.931v0.006c0 0.753-0.394 1.688-1.125 1.931-0.85 0.284-2.022-0.416-3.244-1.934 1.222-1.516 2.394-2.219 3.244-1.934zM7 11.994c0-0.753 0.394-1.688 1.125-1.931 0.125-0.041 0.256-0.063 0.394-0.063 0.8 0 1.806 0.7 2.85 1.997-1.044 1.294-2.050 1.997-2.85 1.997-0.138 0-0.269-0.022-0.394-0.063-0.731-0.247-1.125-1.178-1.125-1.931v-0.006z" })
            );
        }
        function InfinitySquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( InfinitySquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        InfinitySquare.SVG = InfinitySquareSVG;
        return InfinitySquare;
    })();
export const InfoCircle = /*#__PURE__*/ (() => {
        function InfoCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M13 11c0-0.553-0.447-1-1-1h-2v2h1v3h-1v2h4v-2h-1v-4z" }),
_('path', { d: "M11 7h2v2h-2v-2z" })
            );
        }
        function InfoCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( InfoCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        InfoCircle.SVG = InfoCircleSVG;
        return InfoCircle;
    })();
export const InfoOctagon = /*#__PURE__*/ (() => {
        function InfoOctagonSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.706 6.738l-6.444-6.444c-0.188-0.188-0.441-0.294-0.706-0.294h-9.113c-0.266 0-0.519 0.106-0.706 0.294l-6.444 6.444c-0.188 0.188-0.294 0.441-0.294 0.706v9.112c0 0.266 0.106 0.519 0.294 0.706l6.444 6.444c0.188 0.188 0.441 0.294 0.706 0.294h9.113c0.266 0 0.519-0.106 0.706-0.294l6.444-6.444c0.188-0.188 0.294-0.441 0.294-0.706v-9.112c0-0.266-0.106-0.519-0.294-0.706zM22 16.141l-5.859 5.859h-8.281l-5.859-5.859v-8.281l5.859-5.859h8.284l5.856 5.859v8.281z" }),
_('path', { d: "M15.522 3h-7.044c-0.131 0-0.259 0.053-0.353 0.147l-4.978 4.978c-0.094 0.094-0.147 0.222-0.147 0.353v7.044c0 0.131 0.053 0.259 0.147 0.353l4.978 4.978c0.094 0.094 0.222 0.147 0.353 0.147h7.044c0.131 0 0.259-0.053 0.353-0.147l4.978-4.978c0.094-0.094 0.147-0.222 0.147-0.353v-7.044c0-0.131-0.053-0.259-0.147-0.353l-4.978-4.978c-0.094-0.094-0.222-0.147-0.353-0.147zM20 15.316l-4.684 4.684h-6.631l-4.684-4.684v-6.631l4.684-4.684h6.628l4.688 4.684v6.631z" }),
_('path', { d: "M13 11c0-0.553-0.447-1-1-1h-2v2h1v3h-1v2h4v-2h-1v-4z" }),
_('path', { d: "M11 7h2v2h-2v-2z" })
            );
        }
        function InfoOctagon({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( InfoOctagonSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        InfoOctagon.SVG = InfoOctagonSVG;
        return InfoOctagon;
    })();
export const InfoSquare = /*#__PURE__*/ (() => {
        function InfoSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M14 15h-1v-4c0-0.553-0.447-1-1-1h-2v2h1v3h-1v2h4v-2z" }),
_('path', { d: "M11 7h2v2h-2v-2z" })
            );
        }
        function InfoSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( InfoSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        InfoSquare.SVG = InfoSquareSVG;
        return InfoSquare;
    })();
export const Inhaler = /*#__PURE__*/ (() => {
        function InhalerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.384 7.578l-0.45-0.188 1.031-2.712c0.091-0.241-0.012-0.509-0.244-0.625l-4-2c-0.125-0.063-0.272-0.069-0.403-0.019s-0.234 0.153-0.288 0.284l-1.166 2.962-0.484-0.2c-0.256-0.106-0.547-0.103-0.8 0.012s-0.447 0.331-0.534 0.594l-2.769 8.313h-3.278c-1.103 0-2 0.897-2 2v4c0 1.103 0.897 2 2 2h7.797c0.841 0 1.597-0.531 1.881-1.322l4.263-11.838c0.181-0.503-0.063-1.059-0.556-1.263zM18.766 3.191l3.106 1.553-0.859 2.259-3.219-1.341 0.972-2.472zM16.797 20h-7.797v-4h3.278c0.863 0 1.625-0.55 1.897-1.369 0 0 0 0 0 0l2.431-7.297 4.128 1.719-3.938 10.947z" }),
_('path', { d: "M5 18h1v1h-1v-1zM5 17h1v-1h-1v1zM3 20h1v-1h-1v1zM3 18h1v-1h-1v1zM5 21h1v-1h-1v1zM3 16h1v-1h-1v1zM3 22h1v-1h-1v1zM1 20h1v-1h-1v1zM1 18h1v-1h-1v1zM1 16h1v-1h-1v1zM1 22h1v-1h-1v1z" })
            );
        }
        function Inhaler({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( InhalerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Inhaler.SVG = InhalerSVG;
        return Inhaler;
    })();
export const InsertDown = /*#__PURE__*/ (() => {
        function InsertDownSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.5 10h-6.5v1h6v10h-16v-10h6v-1h-6.5c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5z" }),
_('path', { d: "M8.456 13.044l-1.416 1.416 4.25 4.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l4.25-4.25-1.416-1.416-2.538 2.541v-13.584h-2v13.584l-2.544-2.541z" })
            );
        }
        function InsertDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( InsertDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        InsertDown.SVG = InsertDownSVG;
        return InsertDown;
    })();
export const InsertLeft = /*#__PURE__*/ (() => {
        function InsertLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 20h-10v-16h10v6h1v-6.5c0-0.275-0.225-0.5-0.5-0.5h-11c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h11c0.275 0 0.5-0.225 0.5-0.5v-6.5h-1v6z" }),
_('path', { d: "M8.416 11l2.544-2.544-1.416-1.416-4.25 4.25c-0.391 0.391-0.391 1.025 0 1.416l4.25 4.25 1.416-1.416-2.544-2.541h13.584v-2h-13.584z" })
            );
        }
        function InsertLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( InsertLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        InsertLeft.SVG = InsertLeftSVG;
        return InsertLeft;
    })();
export const InsertRight = /*#__PURE__*/ (() => {
        function InsertRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.5 3h-11c-0.275 0-0.5 0.225-0.5 0.5v6.5h1v-6h10v16h-10v-6h-1v6.5c0 0.275 0.225 0.5 0.5 0.5h11c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5z" }),
_('path', { d: "M13.044 15.544l1.416 1.416 4.25-4.25c0.391-0.391 0.391-1.025 0-1.416l-4.25-4.25-1.416 1.416 2.544 2.544h-13.587v2h13.584l-2.541 2.541z" })
            );
        }
        function InsertRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( InsertRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        InsertRight.SVG = InsertRightSVG;
        return InsertRight;
    })();
export const InsertUp = /*#__PURE__*/ (() => {
        function InsertUpSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.5 2h-17c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h6.5v-1h-6v-10h16v10h-6v1h6.5c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5z" }),
_('path', { d: "M15.544 10.956l1.416-1.416-4.25-4.25c-0.391-0.391-1.025-0.391-1.416 0l-4.25 4.25 1.416 1.416 2.544-2.544v13.587h2v-13.584l2.541 2.541z" })
            );
        }
        function InsertUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( InsertUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        InsertUp.SVG = InsertUpSVG;
        return InsertUp;
    })();
export const Insomnia = /*#__PURE__*/ (() => {
        function InsomniaSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M11 8.5c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5 1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5zM7 8.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5z" }),
_('path', { d: "M15.5 6c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.122-2.5-2.5-2.5zM15.5 10c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" }),
_('path', { d: "M9 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M16 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M8 15h8v1h-8v-1z" })
            );
        }
        function Insomnia({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( InsomniaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Insomnia.SVG = InsomniaSVG;
        return Insomnia;
    })();
export const Install = /*#__PURE__*/ (() => {
        function InstallSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 17v-2c0-0.475-0.166-0.909-0.444-1.253v0l-3.666-4.559c-0.094-0.119-0.237-0.188-0.391-0.188h-1.5v1h1.259l2.412 3h-17.347l2.412-3h1.263v-1h-1.5c-0.15 0-0.294 0.069-0.391 0.188l-3.669 4.559c-0.275 0.344-0.441 0.778-0.441 1.253v2c0 0.597 0.263 1.134 0.678 1.5-0.416 0.366-0.678 0.903-0.678 1.5v2c0 1.103 0.897 2 2 2h18c1.103 0 2-0.897 2-2v-2c0-0.597-0.262-1.134-0.678-1.5 0.416-0.366 0.678-0.903 0.678-1.5zM21 22h-18v-2c0 0 0 0 0 0v-1h18v3zM3 18v-3h18v3h-18z" }),
_('path', { d: "M17 16h3v1h-3v-1z" }),
_('path', { d: "M15 16h1v1h-1v-1z" }),
_('path', { d: "M17 20h3v1h-3v-1z" }),
_('path', { d: "M15 20h1v1h-1v-1z" }),
_('path', { d: "M12 12c0.256 0 0.513-0.097 0.706-0.294l4.25-4.25-1.416-1.416-2.541 2.544v-8.584h-2v8.584l-2.544-2.544-1.416 1.416 4.25 4.25c0.197 0.197 0.453 0.294 0.709 0.294z" })
            );
        }
        function Install({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( InstallSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Install.SVG = InstallSVG;
        return Install;
    })();
export const Intersect = /*#__PURE__*/ (() => {
    function IntersectSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.5 7h-5.5v-5.5c0-0.275-0.225-0.5-0.5-0.5h-15c-0.275 0-0.5 0.225-0.5 0.5v15c0 0.275 0.225 0.5 0.5 0.5h5.5v5.5c0 0.275 0.225 0.5 0.5 0.5h15c0.275 0 0.5-0.225 0.5-0.5v-15c0-0.275-0.225-0.5-0.5-0.5zM2 16v-14h14v5h-7c-1.103 0-2 0.897-2 2v7h-5zM15 15c0 0 0 0 0 0h-6v-6h6v6zM22 22h-14v-5h7c1.103 0 2-0.897 2-2v-7h5v14z" })
        );
    }
    function Intersect({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( IntersectSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Intersect.SVG = IntersectSVG;
    return Intersect;
})();
export const IronHigh = /*#__PURE__*/ (() => {
        function IronHighSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 13c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM12 13c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1zM15 13c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1z" }),
_('path', { d: "M23.934 12.641l-2.572-6.678c0-0.003-0.003-0.006-0.003-0.012-0.35-0.875-0.947-1.616-1.725-2.144-0.784-0.528-1.694-0.806-2.634-0.806h-9v2h9c1.106 0 2.088 0.663 2.497 1.688l0.506 1.313h-6.003c-2.672 0-5.069 0.506-7.125 1.506-1.666 0.809-3.106 1.938-4.284 3.353-2.003 2.412-2.547 4.825-2.569 4.928-0.066 0.297 0.009 0.603 0.197 0.841 0.194 0.234 0.478 0.372 0.781 0.372 0 1.103 0.897 2 2 2h13c1.103 0 2-0.897 2-2h1c0.303 0 0.591-0.138 0.781-0.375l4-5c0.222-0.278 0.281-0.653 0.153-0.984zM16 20h-13c-0.55 0-1-0.45-1-1h15c0 0.55-0.45 1-1 1zM18.519 17h-16.125c0.331-0.791 0.894-1.866 1.791-2.928 2.284-2.703 5.584-4.072 9.816-4.072h6.772l1.087 2.825-3.341 4.175z" })
            );
        }
        function IronHigh({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( IronHighSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        IronHigh.SVG = IronHighSVG;
        return IronHigh;
    })();
export const IronLow = /*#__PURE__*/ (() => {
        function IronLowSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 13c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1z" }),
_('path', { d: "M23.934 12.641l-2.572-6.678c0-0.003-0.003-0.006-0.003-0.012-0.35-0.875-0.947-1.616-1.725-2.144-0.784-0.528-1.694-0.806-2.634-0.806h-9v2h9c1.106 0 2.088 0.663 2.497 1.688l0.506 1.313h-6.003c-2.672 0-5.069 0.506-7.125 1.506-1.666 0.809-3.106 1.938-4.284 3.353-2.003 2.412-2.547 4.825-2.569 4.928-0.066 0.297 0.009 0.603 0.197 0.841 0.194 0.234 0.478 0.372 0.781 0.372 0 1.103 0.897 2 2 2h13c1.103 0 2-0.897 2-2h1c0.303 0 0.591-0.138 0.781-0.375l4-5c0.222-0.278 0.281-0.653 0.153-0.984zM16 20h-13c-0.55 0-1-0.45-1-1h15c0 0.55-0.45 1-1 1zM18.519 17h-16.125c0.331-0.791 0.894-1.866 1.791-2.928 2.284-2.703 5.584-4.072 9.816-4.072h6.772l1.087 2.825-3.341 4.175z" })
            );
        }
        function IronLow({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( IronLowSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        IronLow.SVG = IronLowSVG;
        return IronLow;
    })();
export const IronMedium = /*#__PURE__*/ (() => {
        function IronMediumSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 13c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM14 13c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1z" }),
_('path', { d: "M23.934 12.641l-2.572-6.678c0-0.003-0.003-0.006-0.003-0.012-0.35-0.875-0.947-1.616-1.725-2.144-0.784-0.528-1.694-0.806-2.634-0.806h-9v2h9c1.106 0 2.088 0.663 2.497 1.688l0.506 1.313h-6.003c-2.672 0-5.069 0.506-7.125 1.506-1.666 0.809-3.106 1.938-4.284 3.353-2.003 2.412-2.547 4.825-2.569 4.928-0.066 0.297 0.009 0.603 0.197 0.841 0.194 0.234 0.478 0.372 0.781 0.372 0 1.103 0.897 2 2 2h13c1.103 0 2-0.897 2-2h1c0.303 0 0.591-0.138 0.781-0.375l4-5c0.222-0.278 0.281-0.653 0.153-0.984zM16 20h-13c-0.55 0-1-0.45-1-1h15c0 0.55-0.45 1-1 1zM18.519 17h-16.125c0.331-0.791 0.894-1.866 1.791-2.928 2.284-2.703 5.584-4.072 9.816-4.072h6.772l1.087 2.825-3.341 4.175z" })
            );
        }
        function IronMedium({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( IronMediumSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        IronMedium.SVG = IronMediumSVG;
        return IronMedium;
    })();
export const IronNo = /*#__PURE__*/ (() => {
        function IronNoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.841 12.8l0.941-1.175c0.222-0.278 0.281-0.653 0.153-0.984l-2.572-6.678c0-0.003-0.003-0.006-0.003-0.012-0.35-0.875-0.947-1.616-1.725-2.144-0.784-0.528-1.694-0.806-2.634-0.806h-9v2h9c1.106 0 2.088 0.663 2.497 1.688l0.506 1.313h-6.003c-2.672 0-5.069 0.506-7.125 1.506-1.666 0.809-3.106 1.938-4.284 3.353-2.003 2.412-2.547 4.825-2.569 4.928-0.066 0.297 0.009 0.603 0.197 0.841 0.194 0.234 0.478 0.372 0.781 0.372 0 1.103 0.897 2 2 2h8.5c0.981 2.347 3.3 4 6 4 3.584 0 6.5-2.916 6.5-6.5 0-1.375-0.428-2.65-1.159-3.7zM4.184 12.072c2.284-2.703 5.584-4.072 9.816-4.072h6.772l1.087 2.825-0.412 0.516c-1.094-0.841-2.463-1.341-3.947-1.341-3.069 0-5.647 2.137-6.325 5h-8.781c0.331-0.788 0.894-1.866 1.791-2.928zM3 18c-0.55 0-1-0.45-1-1h9.019c0.025 0.341 0.078 0.675 0.156 1h-8.175zM17.5 22c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 13.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function IronNo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( IronNoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        IronNo.SVG = IronNoSVG;
        return IronNo;
    })();
export const IronSteamNo = /*#__PURE__*/ (() => {
        function IronSteamNoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.841 11.8l0.941-1.175c0.222-0.278 0.281-0.653 0.153-0.984l-2.572-6.678c0-0.003-0.003-0.006-0.003-0.012-0.35-0.875-0.947-1.616-1.725-2.144-0.784-0.528-1.694-0.806-2.634-0.806h-9v2h9c1.106 0 2.088 0.663 2.497 1.688l0.506 1.312h-6.003c-2.672 0-5.069 0.506-7.125 1.506-1.666 0.809-3.106 1.938-4.284 3.353-2.003 2.412-2.547 4.825-2.569 4.928-0.066 0.297 0.009 0.603 0.197 0.841 0.194 0.234 0.478 0.372 0.781 0.372 0 1.103 0.897 2 2 2h8.5c0.141 0.334 0.306 0.656 0.5 0.959v5.041h1v-3.816c1.169 1.122 2.756 1.816 4.5 1.816 3.584 0 6.5-2.916 6.5-6.5 0-1.375-0.428-2.65-1.159-3.7zM4.184 11.072c2.284-2.703 5.584-4.072 9.816-4.072h6.772l1.087 2.825-0.412 0.516c-1.094-0.841-2.463-1.341-3.947-1.341-3.069 0-5.647 2.137-6.325 5h-8.781c0.331-0.787 0.894-1.866 1.791-2.928zM3 17c-0.55 0-1-0.45-1-1h9.019c0.025 0.341 0.078 0.675 0.156 1h-8.175zM17.5 21c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 12.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" }),
_('path', { d: "M6 19h1v5h-1v-5z" }),
_('path', { d: "M9 19h1v5h-1v-5z" }),
_('path', { d: "M1.868 22.816l1.316-3.949 0.949 0.316-1.316 3.949-0.949-0.316z" })
            );
        }
        function IronSteamNo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( IronSteamNoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        IronSteamNo.SVG = IronSteamNoSVG;
        return IronSteamNo;
    })();
export const IronSteam = /*#__PURE__*/ (() => {
        function IronSteamSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 19h1v5h-1v-5z" }),
_('path', { d: "M9 19h1v5h-1v-5z" }),
_('path', { d: "M12 19h1v5h-1v-5z" }),
_('path', { d: "M1.868 22.816l1.316-3.949 0.949 0.316-1.316 3.949-0.949-0.316z" }),
_('path', { d: "M14.867 19.184l0.949-0.316 1.316 3.949-0.949 0.316-1.316-3.949z" }),
_('path', { d: "M23.937 9.65l-1.5-4c-0.003-0.006-0.006-0.012-0.009-0.022v0l-1.072-2.678c-0.35-0.875-0.947-1.616-1.725-2.144-0.781-0.528-1.691-0.806-2.631-0.806h-9v2h9c1.109 0 2.091 0.666 2.5 1.694l0.522 1.306h-6.022c-2.672 0-5.069 0.506-7.125 1.506-1.666 0.809-3.106 1.938-4.284 3.353-2.003 2.412-2.547 4.825-2.569 4.928-0.066 0.297 0.009 0.603 0.197 0.841 0.194 0.234 0.478 0.372 0.781 0.372 0 1.103 0.897 2 2 2h13c1.103 0 2-0.897 2-2h1c0.303 0 0.591-0.138 0.781-0.375l4-5c0.219-0.275 0.278-0.647 0.156-0.975zM16 17h-13c-0.55 0-1-0.45-1-1h15c0 0.55-0.45 1-1 1zM18.519 14h-16.125c0.331-0.791 0.894-1.866 1.791-2.928 2.284-2.703 5.584-4.072 9.816-4.072h6.806l1.056 2.819-3.344 4.181z" })
            );
        }
        function IronSteam({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( IronSteamSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        IronSteam.SVG = IronSteamSVG;
        return IronSteam;
    })();
export const Iron = /*#__PURE__*/ (() => {
    function IronSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.934 12.641l-2.572-6.678c0-0.003-0.003-0.006-0.003-0.012-0.35-0.875-0.947-1.616-1.725-2.144-0.784-0.528-1.694-0.806-2.634-0.806h-9v2h9c1.106 0 2.088 0.663 2.497 1.688l0.506 1.313h-6.003c-2.672 0-5.069 0.506-7.125 1.506-1.666 0.809-3.106 1.938-4.284 3.353-2.003 2.412-2.547 4.825-2.569 4.928-0.066 0.297 0.009 0.603 0.197 0.841 0.194 0.234 0.478 0.372 0.781 0.372 0 1.103 0.897 2 2 2h13c1.103 0 2-0.897 2-2h1c0.303 0 0.591-0.138 0.781-0.375l4-5c0.222-0.278 0.281-0.653 0.153-0.984zM16 20h-13c-0.55 0-1-0.45-1-1h15c0 0.55-0.45 1-1 1zM18.519 17h-16.125c0.331-0.791 0.894-1.866 1.791-2.928 2.284-2.703 5.584-4.072 9.816-4.072h6.772l1.087 2.825-3.341 4.175z" })
        );
    }
    function Iron({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( IronSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Iron.SVG = IronSVG;
    return Iron;
})();
export const Italic = /*#__PURE__*/ (() => {
    function ItalicSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20 3v-1h-6v1h1.606l-9.472 18h-2.134v1h6v-1h-1.606l9.472-18z" })
        );
    }
    function Italic({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ItalicSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Italic.SVG = ItalicSVG;
    return Italic;
})();
export const JetEngine = /*#__PURE__*/ (() => {
        function JetEngineSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM16.744 18.438c-0.716 0.531-1.525 0.944-2.397 1.212 0.312-0.597 0.456-1.256 0.419-1.944-0.063-1.091-0.581-2.172-1.425-3.022 0.109-0.053 0.213-0.116 0.316-0.181 1.172 0.156 2.194 0.747 2.756 1.603 0.453 0.691 0.566 1.494 0.331 2.331zM10.65 17.872c-0.372 0.741-1.012 1.241-1.856 1.456-0.828-0.363-1.584-0.862-2.238-1.472 0.669-0.028 1.313-0.234 1.887-0.609 0.916-0.6 1.591-1.591 1.903-2.744 0.1 0.066 0.206 0.128 0.316 0.181 0.45 1.094 0.45 2.272-0.012 3.188zM7.256 5.562c0.716-0.531 1.525-0.944 2.397-1.212-0.312 0.597-0.456 1.256-0.419 1.944 0.063 1.091 0.581 2.172 1.425 3.022-0.109 0.053-0.213 0.116-0.316 0.181-1.172-0.156-2.194-0.747-2.756-1.603-0.453-0.691-0.566-1.494-0.331-2.331zM9.006 12.184c-0.719 0.938-1.744 1.525-2.766 1.584-0.828 0.047-1.581-0.256-2.191-0.881-0.031-0.291-0.050-0.588-0.050-0.888 0-0.616 0.069-1.216 0.203-1.791 0.359 0.569 0.863 1.025 1.475 1.334 0.6 0.303 1.284 0.453 1.991 0.453 0.441 0 0.894-0.059 1.338-0.178-0.003 0.059-0.006 0.119-0.006 0.181s0.003 0.122 0.006 0.184zM6.078 14.772c0.072 0 0.147-0.003 0.219-0.006 1.091-0.063 2.172-0.581 3.022-1.425 0.053 0.109 0.116 0.213 0.181 0.316-0.156 1.172-0.747 2.194-1.603 2.756-0.691 0.453-1.497 0.569-2.331 0.334-0.531-0.716-0.944-1.525-1.212-2.397 0.531 0.278 1.116 0.422 1.725 0.422zM10 12c0-1.103 0.897-2 2-2s2 0.897 2 2c0 1.103-0.897 2-2 2s-2-0.897-2-2zM13.35 6.128c0.372-0.741 1.012-1.241 1.856-1.456 0.828 0.363 1.584 0.862 2.238 1.472-0.669 0.028-1.313 0.234-1.887 0.609-0.916 0.6-1.591 1.591-1.903 2.744-0.1-0.066-0.206-0.128-0.316-0.181-0.45-1.094-0.45-2.272 0.012-3.188zM14.994 11.816c0.719-0.938 1.744-1.525 2.766-1.584 0.828-0.047 1.581 0.256 2.191 0.881 0.031 0.291 0.050 0.588 0.050 0.888 0 0.616-0.069 1.216-0.203 1.791-0.359-0.569-0.862-1.025-1.475-1.334-0.978-0.491-2.172-0.584-3.328-0.275 0.003-0.059 0.006-0.119 0.006-0.181s-0.003-0.122-0.006-0.184zM17.703 9.234c-1.091 0.063-2.172 0.581-3.022 1.425-0.053-0.109-0.116-0.213-0.181-0.316 0.156-1.172 0.747-2.194 1.603-2.756 0.691-0.453 1.497-0.569 2.331-0.334 0.531 0.716 0.944 1.525 1.212 2.397-0.594-0.309-1.256-0.456-1.944-0.416zM13.791 4.203c-0.569 0.359-1.025 0.862-1.334 1.475-0.491 0.978-0.584 2.172-0.275 3.328-0.059-0.003-0.119-0.006-0.181-0.006s-0.122 0.003-0.184 0.006c-0.938-0.719-1.525-1.744-1.584-2.766-0.047-0.828 0.256-1.581 0.881-2.191 0.291-0.031 0.588-0.050 0.888-0.050 0.616 0 1.216 0.069 1.791 0.203zM6.144 6.556c0.028 0.669 0.234 1.313 0.609 1.887 0.6 0.916 1.591 1.591 2.744 1.903-0.066 0.1-0.128 0.206-0.181 0.316-1.094 0.45-2.272 0.45-3.187-0.012-0.741-0.372-1.241-1.012-1.456-1.856 0.363-0.828 0.862-1.584 1.472-2.238zM10.209 19.797c0.569-0.359 1.025-0.863 1.334-1.475 0.491-0.978 0.584-2.172 0.275-3.328 0.059 0.003 0.119 0.006 0.181 0.006s0.122-0.003 0.184-0.006c0.938 0.719 1.525 1.744 1.584 2.766 0.047 0.828-0.256 1.581-0.881 2.191-0.291 0.031-0.588 0.050-0.888 0.050-0.616 0-1.216-0.069-1.791-0.203zM17.856 17.444c-0.028-0.669-0.234-1.313-0.609-1.887-0.6-0.916-1.591-1.591-2.744-1.903 0.066-0.1 0.128-0.206 0.181-0.316 1.094-0.45 2.272-0.45 3.188 0.012 0.741 0.372 1.241 1.012 1.456 1.856-0.363 0.828-0.862 1.584-1.472 2.238z" })
            );
        }
        function JetEngine({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( JetEngineSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        JetEngine.SVG = JetEngineSVG;
        return JetEngine;
    })();
export const Jumping = /*#__PURE__*/ (() => {
        function JumpingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 2c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM15 5c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M11.291 13.197c0.634-1.744 1.891-3.978 3.416-5.487 0.316-0.312 0.387-0.8 0.175-1.191s-0.659-0.594-1.094-0.497l-4.5 1c-0.213 0.047-0.406 0.162-0.547 0.331l-2.75 3.25 1.528 1.291 2.531-2.994 1.375-0.306c-1.188 1.772-2.050 3.731-2.391 5.169-0.066 0.275-0.012 0.563 0.147 0.794s0.406 0.387 0.687 0.428c1.344 0.191 2.928 0.497 3.884 1.191l-2.613 4.572 1.737 0.994 3-5.25c0.203-0.356 0.169-0.8-0.087-1.122-1.031-1.266-2.759-1.841-4.5-2.172z" })
            );
        }
        function Jumping({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( JumpingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Jumping.SVG = JumpingSVG;
        return Jumping;
    })();
export const KeyHole = /*#__PURE__*/ (() => {
    function KeyHoleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.172 13.241c1.131-0.575 2.084-1.45 2.759-2.525 0.694-1.106 1.062-2.388 1.069-3.7 0.003-1.866-0.722-3.625-2.044-4.953-1.322-1.325-3.078-2.059-4.944-2.063h-0.028c-1.866 0.003-3.619 0.738-4.944 2.066-1.322 1.328-2.050 3.087-2.044 4.953 0.003 1.313 0.372 2.591 1.069 3.7 0.675 1.075 1.631 1.95 2.759 2.525 0.147 0.075 0.209 0.247 0.15 0.403l-2.841 7.484c-0.247 0.65-0.159 1.381 0.237 1.956 0.397 0.572 1.047 0.916 1.744 0.916h7.759c0.697 0 1.347-0.341 1.744-0.916s0.484-1.303 0.237-1.956l-2.841-7.484c-0.053-0.159 0.012-0.331 0.156-0.406zM13.15 14.353l2.841 7.484c0.006 0.016 0.022 0.059-0.012 0.109s-0.081 0.050-0.097 0.050h-7.759c-0.016 0-0.063 0-0.097-0.050s-0.019-0.094-0.012-0.109l2.841-7.484c0.422-1.113-0.056-2.356-1.113-2.894-1.681-0.856-2.731-2.559-2.734-4.447-0.003-1.331 0.516-2.588 1.463-3.537 0.938-0.947 2.191-1.472 3.519-1.475h0.022c1.331 0.003 2.584 0.528 3.528 1.478s1.466 2.206 1.462 3.537c-0.006 1.887-1.053 3.591-2.734 4.447-1.056 0.534-1.537 1.778-1.116 2.891z" })
        );
    }
    function KeyHole({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( KeyHoleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    KeyHole.SVG = KeyHoleSVG;
    return KeyHole;
})();
export const Key = /*#__PURE__*/ (() => {
        function KeySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.5 0h-3.5c-0.266 0-0.519 0.106-0.706 0.294l-10.069 10.066c-0.709-0.237-1.456-0.359-2.225-0.359-1.869 0-3.628 0.728-4.95 2.050s-2.050 3.081-2.050 4.95 0.728 3.628 2.050 4.95c1.322 1.322 3.081 2.050 4.95 2.050s3.628-0.728 4.95-2.050c1.322-1.322 2.050-3.081 2.050-4.95 0-0.687-0.1-1.362-0.291-2.003l3.144-3.144c0.094-0.094 0.147-0.222 0.147-0.353v-1.5h1.5c0.275 0 0.5-0.225 0.5-0.5v-1.5h0.5c0.275 0 0.5-0.225 0.5-0.5v-0.5h1.5c0.275 0 0.5-0.225 0.5-0.5v-1.5h1.5c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5zM7 22c-2.756 0-5-2.244-5-5s2.244-5 5-5 5 2.244 5 5-2.244 5-5 5zM23 4h-1.5c-0.275 0-0.5 0.225-0.5 0.5v1.5h-1.5c-0.275 0-0.5 0.225-0.5 0.5v0.5h-0.5c-0.275 0-0.5 0.225-0.5 0.5v1.5h-1.5c-0.275 0-0.5 0.225-0.5 0.5v1.794l-2.684 2.684c-0.166-0.347-0.363-0.681-0.588-1l2.478-2.478-0.706-0.706-2.406 2.406c-0.047-0.050-0.094-0.1-0.144-0.15-0.269-0.269-0.553-0.513-0.856-0.731l9.322-9.319h2.584v2z" }),
_('path', { d: "M3.503 15.503c-0.472 0.472-0.619 1.188-0.413 2.013 0.184 0.734 0.634 1.488 1.272 2.125 0.634 0.634 1.391 1.088 2.125 1.272 0.244 0.063 0.478 0.091 0.7 0.091 0.528 0 0.981-0.172 1.313-0.503 0.919-0.919 0.544-2.737-0.856-4.137-1.406-1.403-3.222-1.778-4.141-0.859zM7.791 19.791c-0.213 0.213-0.6 0.266-1.062 0.15-0.553-0.138-1.159-0.506-1.659-1.006-0.503-0.503-0.869-1.106-1.006-1.659-0.116-0.462-0.063-0.85 0.15-1.062 0.138-0.138 0.353-0.209 0.616-0.209 0.575 0 1.381 0.341 2.106 1.066 1.053 1.053 1.297 2.281 0.856 2.722z" })
            );
        }
        function Key({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( KeySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Key.SVG = KeySVG;
        return Key;
    })();
export const Key2 = /*#__PURE__*/ (() => {
    function Key2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 11h-16.078c-0.147-0.906-0.488-1.747-1-2.428-0.75-1-1.812-1.572-2.922-1.572s-2.172 0.572-2.922 1.572c-0.694 0.928-1.078 2.144-1.078 3.428s0.384 2.5 1.078 3.428c0.75 1 1.812 1.572 2.922 1.572s2.172-0.572 2.922-1.572c0.513-0.681 0.853-1.522 1-2.428h7.078v2.5c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-0.5h1v1.5c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-3.5h2v-2zM4 15c-1.084 0-2-1.375-2-3s0.916-3 2-3 2 1.375 2 3-0.916 3-2 3zM21 16h-1v-1.5c0-0.275-0.225-0.5-0.5-0.5h-2c-0.275 0-0.5 0.225-0.5 0.5v0.5h-1v-2h5v3z" })
        );
    }
    function Key2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Key2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Key2.SVG = Key2SVG;
    return Key2;
})();
export const KeyboardHide = /*#__PURE__*/ (() => {
        function KeyboardHideSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v9c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-9c0-1.103-0.897-2-2-2zM22 11h-20v-9h20v9c0.003 0 0 0 0 0z" }),
_('path', { d: "M3 9h2v1h-2v-1zM6 10h6v-1h-6v1zM13 10h1v-1h-1v1zM15 10h1v-1h-1v1zM6 7h-3v1h3v-1zM5 5h-2v1h2v-1zM4 3h-1v1h1v-1zM6 3h-1v1h1v-1zM8 3h-1v1h1v-1zM10 3h-1v1h1v-1zM12 3h-1v1h1v-1zM14 3h-1v1h1v-1zM15 4h1v-1h-1v1zM6 6h1v-1h-1v1zM8 6h1v-1h-1v1zM10 6h1v-1h-1v1zM13 5h-1v1h1v-1zM14 6h2v-1h-2v1zM13 8h3v-1h-3v1zM11 8h1v-1h-1v1zM9 8h1v-1h-1v1zM7 8h1v-1h-1v1zM20 10h1v-1h-1v1zM20 8h1v-1h-1v1zM20 6h1v-1h-1v1zM20 4h1v-1h-1v1zM18 10h1v-1h-1v1zM18 8h1v-1h-1v1zM18 6h1v-1h-1v1zM18 4h1v-1h-1v1z" }),
_('path', { d: "M13 20.584v-5.584h-2v5.584l-1.544-1.544-1.416 1.416 3.25 3.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l3.25-3.25-1.416-1.416-1.537 1.544z" })
            );
        }
        function KeyboardHide({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( KeyboardHideSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        KeyboardHide.SVG = KeyboardHideSVG;
        return KeyboardHide;
    })();
export const KeyboardKeyDown = /*#__PURE__*/ (() => {
        function KeyboardKeyDownSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.5 0h-15c-2.481 0-4.5 2.019-4.5 4.5v15c0 2.481 2.019 4.5 4.5 4.5h15c2.481 0 4.5-2.019 4.5-4.5v-15c0-2.481-2.019-4.5-4.5-4.5zM19.5 1c0.784 0 1.509 0.259 2.094 0.697l-1.578 1.578c-0.297-0.175-0.644-0.275-1.016-0.275h-14c-0.372 0-0.719 0.1-1.016 0.278l-1.578-1.581c0.584-0.438 1.309-0.697 2.094-0.697h15zM19.003 19c0 0-0.003 0 0 0h-14.003v-14h14l0.003 14zM1 4.5c0-0.784 0.259-1.509 0.697-2.094l1.578 1.578c-0.175 0.297-0.275 0.644-0.275 1.016v14c0 0.372 0.1 0.719 0.278 1.016l-1.581 1.578c-0.438-0.584-0.697-1.309-0.697-2.094v-15zM4.5 23c-0.784 0-1.509-0.259-2.094-0.697l1.578-1.578c0.297 0.175 0.644 0.278 1.016 0.278h14c0.372 0 0.719-0.1 1.016-0.278l1.578 1.578c-0.584 0.438-1.309 0.697-2.094 0.697h-15zM23 19.5c0 0.784-0.259 1.509-0.697 2.094l-1.578-1.578c0.175-0.297 0.278-0.644 0.278-1.016v-14c0-0.372-0.1-0.719-0.278-1.016l1.578-1.578c0.438 0.584 0.697 1.309 0.697 2.094v15z" }),
_('path', { d: "M13 14.584v-8.584h-2v8.584l-2.544-2.544-1.416 1.416 4.25 4.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l4.25-4.25-1.416-1.416-2.538 2.544z" })
            );
        }
        function KeyboardKeyDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( KeyboardKeyDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        KeyboardKeyDown.SVG = KeyboardKeyDownSVG;
        return KeyboardKeyDown;
    })();
export const KeyboardKeyUp = /*#__PURE__*/ (() => {
        function KeyboardKeyUpSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.5 0h-15c-2.481 0-4.5 2.019-4.5 4.5v15c0 2.481 2.019 4.5 4.5 4.5h15c2.481 0 4.5-2.019 4.5-4.5v-15c0-2.481-2.019-4.5-4.5-4.5zM19.5 1c0.784 0 1.509 0.259 2.094 0.697l-1.578 1.578c-0.297-0.175-0.644-0.275-1.016-0.275h-14c-0.372 0-0.719 0.1-1.016 0.278l-1.578-1.581c0.584-0.438 1.309-0.697 2.094-0.697h15zM19.003 19c0 0-0.003 0 0 0h-14.003v-14h14l0.003 14zM1 4.5c0-0.784 0.259-1.509 0.697-2.094l1.578 1.578c-0.175 0.297-0.275 0.644-0.275 1.016v14c0 0.372 0.1 0.719 0.278 1.016l-1.581 1.578c-0.438-0.584-0.697-1.309-0.697-2.094v-15zM4.5 23c-0.784 0-1.509-0.259-2.094-0.697l1.578-1.578c0.297 0.175 0.644 0.278 1.016 0.278h14c0.372 0 0.719-0.1 1.016-0.278l1.578 1.578c-0.584 0.438-1.309 0.697-2.094 0.697h-15zM23 19.5c0 0.784-0.259 1.509-0.697 2.094l-1.578-1.578c0.175-0.297 0.278-0.644 0.278-1.016v-14c0-0.372-0.1-0.719-0.278-1.016l1.578-1.578c0.438 0.584 0.697 1.309 0.697 2.094v15z" }),
_('path', { d: "M11.294 6.294l-4.25 4.25 1.416 1.416 2.544-2.544v8.584h2v-8.584l2.544 2.544 1.416-1.416-4.25-4.25c-0.397-0.391-1.028-0.391-1.419 0z" })
            );
        }
        function KeyboardKeyUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( KeyboardKeyUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        KeyboardKeyUp.SVG = KeyboardKeyUpSVG;
        return KeyboardKeyUp;
    })();
export const KeyboardKey = /*#__PURE__*/ (() => {
        function KeyboardKeySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.5 0h-15c-2.481 0-4.5 2.019-4.5 4.5v15c0 2.481 2.019 4.5 4.5 4.5h15c2.481 0 4.5-2.019 4.5-4.5v-15c0-2.481-2.019-4.5-4.5-4.5zM19.5 1c0.784 0 1.509 0.259 2.094 0.697l-1.578 1.578c-0.297-0.175-0.644-0.275-1.016-0.275h-14c-0.372 0-0.719 0.1-1.016 0.278l-1.578-1.581c0.584-0.438 1.309-0.697 2.094-0.697h15zM19.003 19c0 0-0.003 0 0 0h-14.003v-14h14l0.003 14zM1 4.5c0-0.784 0.259-1.509 0.697-2.094l1.578 1.578c-0.175 0.297-0.275 0.644-0.275 1.016v14c0 0.372 0.1 0.719 0.278 1.016l-1.581 1.578c-0.438-0.584-0.697-1.309-0.697-2.094v-15zM4.5 23c-0.784 0-1.509-0.259-2.094-0.697l1.578-1.578c0.297 0.175 0.644 0.278 1.016 0.278h14c0.372 0 0.719-0.1 1.016-0.278l1.578 1.578c-0.584 0.438-1.309 0.697-2.094 0.697h-15zM23 19.5c0 0.784-0.259 1.509-0.697 2.094l-1.578-1.578c0.175-0.297 0.278-0.644 0.278-1.016v-14c0-0.372-0.1-0.719-0.278-1.016l1.578-1.578c0.438 0.584 0.697 1.309 0.697 2.094v15z" }),
_('path', { d: "M12 6c-0.331 0-0.625 0.159-0.806 0.409l-2.394 3.191 0.8 0.6 1.4-1.866v9.666h2v-11c0-0.553-0.447-1-1-1z" })
            );
        }
        function KeyboardKey({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( KeyboardKeySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        KeyboardKey.SVG = KeyboardKeySVG;
        return KeyboardKey;
    })();
export const KeyboardKey2 = /*#__PURE__*/ (() => {
        function KeyboardKey2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.5 0h-15c-2.481 0-4.5 2.019-4.5 4.5v15c0 2.481 2.019 4.5 4.5 4.5h15c2.481 0 4.5-2.019 4.5-4.5v-15c0-2.481-2.019-4.5-4.5-4.5zM19.5 1c0.784 0 1.509 0.259 2.094 0.697l-1.578 1.578c-0.297-0.175-0.644-0.275-1.016-0.275h-14c-0.372 0-0.719 0.1-1.016 0.278l-1.578-1.581c0.584-0.438 1.309-0.697 2.094-0.697h15zM19.003 19c0 0-0.003 0 0 0h-14.003v-14h14l0.003 14zM1 4.5c0-0.784 0.259-1.509 0.697-2.094l1.578 1.578c-0.175 0.297-0.275 0.644-0.275 1.016v14c0 0.372 0.1 0.719 0.278 1.016l-1.581 1.578c-0.438-0.584-0.697-1.309-0.697-2.094v-15zM4.5 23c-0.784 0-1.509-0.259-2.094-0.697l1.578-1.578c0.297 0.175 0.644 0.278 1.016 0.278h14c0.372 0 0.719-0.1 1.016-0.278l1.578 1.578c-0.584 0.438-1.309 0.697-2.094 0.697h-15zM23 19.5c0 0.784-0.259 1.509-0.697 2.094l-1.578-1.578c0.175-0.297 0.278-0.644 0.278-1.016v-14c0-0.372-0.1-0.719-0.278-1.016l1.578-1.578c0.438 0.584 0.697 1.309 0.697 2.094v15z" }),
_('path', { d: "M12 6c-0.413 0-0.784 0.253-0.931 0.641l-4.25 11 1.866 0.722 1.297-3.363h4.038l1.297 3.359 1.866-0.722-4.25-11c-0.147-0.384-0.519-0.638-0.931-0.638zM10.753 13l1.247-3.225 1.247 3.225h-2.494z" })
            );
        }
        function KeyboardKey2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( KeyboardKey2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        KeyboardKey2.SVG = KeyboardKey2SVG;
        return KeyboardKey2;
    })();
export const KeyboardShow = /*#__PURE__*/ (() => {
        function KeyboardShowSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 11h-20c-1.103 0-2 0.897-2 2v9c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-9c0-1.103-0.897-2-2-2zM22 22h-20v-9h20v9c0.003 0 0 0 0 0z" }),
_('path', { d: "M3 20h2v1h-2v-1zM6 21h6v-1h-6v1zM13 21h1v-1h-1v1zM15 21h1v-1h-1v1zM6 18h-3v1h3v-1zM5 16h-2v1h2v-1zM4 14h-1v1h1v-1zM6 14h-1v1h1v-1zM8 14h-1v1h1v-1zM10 14h-1v1h1v-1zM12 14h-1v1h1v-1zM14 14h-1v1h1v-1zM15 15h1v-1h-1v1zM6 17h1v-1h-1v1zM8 17h1v-1h-1v1zM10 17h1v-1h-1v1zM13 16h-1v1h1v-1zM14 17h2v-1h-2v1zM13 19h3v-1h-3v1zM11 19h1v-1h-1v1zM9 19h1v-1h-1v1zM7 19h1v-1h-1v1zM20 21h1v-1h-1v1zM20 19h1v-1h-1v1zM20 17h1v-1h-1v1zM20 15h1v-1h-1v1zM18 21h1v-1h-1v1zM18 19h1v-1h-1v1zM18 17h1v-1h-1v1zM18 15h1v-1h-1v1z" }),
_('path', { d: "M11 3.416v5.584h2v-5.584l1.544 1.544 1.416-1.416-3.25-3.25c-0.391-0.391-1.025-0.391-1.416 0l-3.25 3.25 1.416 1.416 1.541-1.544z" })
            );
        }
        function KeyboardShow({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( KeyboardShowSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        KeyboardShow.SVG = KeyboardShowSVG;
        return KeyboardShow;
    })();
export const KeyboardWireless = /*#__PURE__*/ (() => {
        function KeyboardWirelessSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 11h-20c-1.103 0-2 0.897-2 2v9c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-9c0-1.103-0.897-2-2-2zM22 22h-20v-9h20v9c0.003 0 0 0 0 0z" }),
_('path', { d: "M3 20h2v1h-2v-1zM6 21h6v-1h-6v1zM13 21h1v-1h-1v1zM15 21h1v-1h-1v1zM6 18h-3v1h3v-1zM5 16h-2v1h2v-1zM4 14h-1v1h1v-1zM6 14h-1v1h1v-1zM8 14h-1v1h1v-1zM10 14h-1v1h1v-1zM12 14h-1v1h1v-1zM14 14h-1v1h1v-1zM15 15h1v-1h-1v1zM6 17h1v-1h-1v1zM8 17h1v-1h-1v1zM10 17h1v-1h-1v1zM13 16h-1v1h1v-1zM14 17h2v-1h-2v1zM13 19h3v-1h-3v1zM11 19h1v-1h-1v1zM9 19h1v-1h-1v1zM7 19h1v-1h-1v1zM20 21h1v-1h-1v1zM20 19h1v-1h-1v1zM20 17h1v-1h-1v1zM20 15h1v-1h-1v1zM18 21h1v-1h-1v1zM18 19h1v-1h-1v1zM18 17h1v-1h-1v1zM18 15h1v-1h-1v1z" }),
_('path', { d: "M9.172 7.172l-0.353 0.353 0.706 0.706 0.353-0.353c1.169-1.169 3.072-1.169 4.244 0l0.353 0.353 0.706-0.706-0.353-0.353c-1.559-1.559-4.097-1.559-5.656 0zM16.597 6.109l0.706-0.706-0.353-0.353c-1.322-1.322-3.081-2.050-4.95-2.050s-3.628 0.728-4.95 2.050l-0.353 0.353 0.706 0.706 0.353-0.353c2.337-2.337 6.147-2.337 8.487 0l0.353 0.353zM5.634 3.634c3.509-3.509 9.219-3.509 12.728 0l0.353 0.353 0.706-0.706-0.353-0.353c-1.887-1.887-4.4-2.928-7.069-2.928s-5.184 1.041-7.072 2.928l-0.353 0.353 0.706 0.706 0.353-0.353z" })
            );
        }
        function KeyboardWireless({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( KeyboardWirelessSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        KeyboardWireless.SVG = KeyboardWirelessSVG;
        return KeyboardWireless;
    })();
export const Keyboard = /*#__PURE__*/ (() => {
        function KeyboardSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 10h-10v-6c0-1.103 0.897-2 2-2s2 0.897 2 2c0 1.653 1.347 3 3 3s3-1.347 3-3v-3h-1v3c0 1.103-0.897 2-2 2s-2-0.897-2-2c0-1.653-1.347-3-3-3s-3 1.347-3 3v6h-9c-1.103 0-2 0.897-2 2v9c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-9c0-1.103-0.897-2-2-2zM22 21h-20v-9h20v9c0.003 0 0 0 0 0z" }),
_('path', { d: "M3 19h2v1h-2v-1zM6 20h6v-1h-6v1zM13 20h1v-1h-1v1zM15 20h1v-1h-1v1zM6 17h-3v1h3v-1zM5 15h-2v1h2v-1zM4 13h-1v1h1v-1zM6 13h-1v1h1v-1zM8 13h-1v1h1v-1zM10 13h-1v1h1v-1zM12 13h-1v1h1v-1zM14 13h-1v1h1v-1zM15 14h1v-1h-1v1zM6 16h1v-1h-1v1zM8 16h1v-1h-1v1zM10 16h1v-1h-1v1zM13 15h-1v1h1v-1zM14 16h2v-1h-2v1zM13 18h3v-1h-3v1zM11 18h1v-1h-1v1zM9 18h1v-1h-1v1zM7 18h1v-1h-1v1zM20 20h1v-1h-1v1zM20 18h1v-1h-1v1zM20 16h1v-1h-1v1zM20 14h1v-1h-1v1zM18 20h1v-1h-1v1zM18 18h1v-1h-1v1zM18 16h1v-1h-1v1zM18 14h1v-1h-1v1z" })
            );
        }
        function Keyboard({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( KeyboardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Keyboard.SVG = KeyboardSVG;
        return Keyboard;
    })();
export const KitchenScale = /*#__PURE__*/ (() => {
        function KitchenScaleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.022 10.8l-0.978 4.794c-0.028 0.128-0.044 0.259-0.044 0.406 0 1.103 0.897 2 2 2s2-0.897 2-2c0-0.125-0.012-0.259-0.041-0.397-0.003-0.009-0.003-0.019-0.006-0.028l-0.972-4.772c0 0 0 0 0 0-0.094-0.462-0.506-0.8-0.978-0.8-0.472-0.003-0.884 0.334-0.981 0.797zM12.978 15.8c0 0.006 0.003 0.009 0.003 0.016 0.012 0.066 0.019 0.128 0.019 0.184 0 0.55-0.45 1-1 1s-1-0.45-1-1c0-0.072 0.006-0.134 0.019-0.191 0-0.003 0-0.006 0.003-0.009l0.981-4.794 0.975 4.794z" }),
_('path', { d: "M21.5 0h-19c-0.275 0-0.5 0.225-0.5 0.5v0.5c0 1.163 0.381 2.247 1.1 3.131 0.619 0.762 1.494 1.384 2.531 1.797 0.119 0.047 0.244 0.072 0.372 0.072h5.019v1.072c-1.491 0.213-2.866 0.897-3.95 1.981-1.322 1.322-2.050 3.081-2.050 4.95s0.728 3.628 2.050 4.95c0.006 0.006 0.009 0.009 0.016 0.016-2.059 1.319-2.966 3.553-3.012 3.669-0.122 0.309-0.084 0.656 0.103 0.931s0.497 0.438 0.828 0.438h14c0.331 0 0.641-0.162 0.828-0.438s0.225-0.622 0.103-0.931c-0.047-0.116-0.947-2.334-2.991-3.653 0.009-0.009 0.019-0.019 0.028-0.028 1.322-1.322 2.050-3.081 2.050-4.95s-0.728-3.628-2.050-4.95c-1.084-1.084-2.459-1.769-3.95-1.981v-1.075h4.975c0.128 0 0.253-0.025 0.372-0.072 1.038-0.416 1.909-1.038 2.531-1.797 0.719-0.884 1.1-1.969 1.1-3.131v-0.5c-0.003-0.275-0.228-0.5-0.503-0.5zM17.259 22h-10.522c0.003-0.003 0.006-0.009 0.009-0.012 0.631-0.834 1.353-1.409 2.15-1.716 0.956 0.475 2.019 0.728 3.119 0.728 1.094 0 2.15-0.25 3.1-0.722 0.95 0.372 1.659 1.078 2.144 1.722zM17.019 14c0 2.756-2.244 5-5 5s-5-2.244-5-5c0-2.756 2.244-5 5-5s5 2.244 5 5zM17.8 4h-11.6c-0.891-0.394-2.2-1.266-2.2-3h16c0 1.734-1.309 2.606-2.2 3z" })
            );
        }
        function KitchenScale({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( KitchenScaleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        KitchenScale.SVG = KitchenScaleSVG;
        return KitchenScale;
    })();
export const Knife = /*#__PURE__*/ (() => {
    function KnifeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.269 19.731c-1.844-1.841-3.769-3.334-5.809-4.916-2.050-1.591-4.169-3.234-6.209-5.275l-9.397-9.394c-0.094-0.094-0.222-0.15-0.356-0.147-0.134 0-0.262 0.056-0.356 0.15-1.812 1.863-1.456 4.241 1.003 6.703l6 6c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l1.434-1.434c1.809 1.897 3.25 3.912 4.644 5.866 1.516 2.122 2.944 4.125 4.8 5.981 0.472 0.472 1.1 0.731 1.769 0.731s1.297-0.259 1.769-0.731c0.978-0.972 0.978-2.559 0.003-3.534zM8.5 11.794l-5.647-5.647c-1.887-1.887-2.331-3.537-1.325-4.912l8.766 8.766-1.794 1.794zM21.853 21.853c-0.194 0.194-0.513 0.194-0.706 0-1.4-1.4-2.569-2.928-3.738-4.544 1.556 1.219 3.041 2.434 4.444 3.837 0.197 0.194 0.197 0.513 0 0.706z" })
        );
    }
    function Knife({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( KnifeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Knife.SVG = KnifeSVG;
    return Knife;
})();
export const Label = /*#__PURE__*/ (() => {
        function LabelSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.366 10.541l-6.381-5.997c-0.372-0.35-0.856-0.544-1.369-0.544h-13.616c-1.103 0-2 0.897-2 2v12c0 1.103 0.897 2 2 2h13.619c0.513 0 1-0.194 1.372-0.544l6.381-6c0.403-0.378 0.631-0.909 0.631-1.459-0.003-0.55-0.234-1.081-0.638-1.456zM15.619 18c0 0 0 0 0 0h-13.619v-12h13.616c0 0 0 0 0 0l6.381 6c0 0 0 0 0 0l-6.378 6z" }),
_('path', { d: "M19.841 11.634l-4.788-4.5c-0.094-0.087-0.216-0.134-0.344-0.134h-11.209c-0.275 0-0.5 0.225-0.5 0.5v9c0 0.275 0.225 0.5 0.5 0.5h11.209c0.128 0 0.25-0.050 0.344-0.134l4.788-4.5c0.1-0.094 0.156-0.225 0.156-0.366 0-0.138-0.056-0.269-0.156-0.366zM14.513 16h-10.512v-8h10.512l4.256 4-4.256 4z" })
            );
        }
        function Label({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LabelSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Label.SVG = LabelSVG;
        return Label;
    })();
export const LampBright = /*#__PURE__*/ (() => {
        function LampBrightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16.95 2.081c-1.322-1.338-3.072-2.075-4.928-2.081-0.006 0-0.012 0-0.019 0-1.866 0-3.619 0.725-4.944 2.044-1.328 1.325-2.059 3.084-2.059 4.956 0 3.116 1.084 4.484 1.959 5.584 0.603 0.762 1.041 1.313 1.041 2.416v3c0 1.103 0.897 2 2 2h4c1.103 0 2-0.897 2-2v-3c0-1.1 0.438-1.653 1.041-2.412 0.859-1.081 1.931-2.425 1.959-5.459 0.009-0.956-0.172-1.891-0.537-2.772-0.356-0.853-0.862-1.619-1.512-2.275zM17 7.109c-0.022 2.344-0.753 3.263-1.525 4.231 0 0 0 0 0 0-0.691 0.872-1.475 1.859-1.475 3.656v3h-4v-3c0-1.797-0.784-2.787-1.475-3.659-0.784-0.984-1.525-1.919-1.525-4.338 0-1.338 0.522-2.594 1.472-3.537 0.944-0.944 2.197-1.463 3.528-1.463 0.006 0 0.009 0 0.016 0 1.319 0.003 2.566 0.531 3.509 1.488 0.966 0.975 1.488 2.259 1.475 3.622z" }),
_('path', { d: "M9 21h6v1h-6v-1z" }),
_('path', { d: "M11 23h2v1h-2v-1z" }),
_('path', { d: "M21 7h3v1h-3v-1z" }),
_('path', { d: "M19.828 2.277l2.896-1.448 0.447 0.894-2.896 1.448-0.447-0.894z" }),
_('path', { d: "M19.828 12.724l0.447-0.894 2.896 1.448-0.447 0.894-2.896-1.448z" }),
_('path', { d: "M0 7h3v1h-3v-1z" }),
_('path', { d: "M0.828 1.723l0.447-0.894 2.896 1.448-0.447 0.894-2.896-1.448z" }),
_('path', { d: "M0.828 13.277l2.896-1.448 0.447 0.894-2.896 1.448-0.447-0.894z" })
            );
        }
        function LampBright({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LampBrightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LampBright.SVG = LampBrightSVG;
        return LampBright;
    })();
export const LampCheck = /*#__PURE__*/ (() => {
        function LampCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 21h6v1h-6v-1z" }),
_('path', { d: "M8 23h2v1h-2v-1z" }),
_('path', { d: "M15.694 5.003c-0.416-1.362-1.25-2.588-2.366-3.481-1.241-0.991-2.731-1.519-4.306-1.522-0.006 0-0.012 0-0.019 0-1.866 0-3.619 0.725-4.944 2.044-1.328 1.325-2.059 3.084-2.059 4.956 0 3.116 1.084 4.484 1.959 5.584 0.603 0.762 1.041 1.313 1.041 2.416v3c0 1.103 0.897 2 2 2h4c1.103 0 2-0.897 2-2v-0.5c0.769 0.322 1.616 0.5 2.5 0.5 3.584 0 6.5-2.916 6.5-6.5 0-3.519-2.813-6.394-6.306-6.497zM11 18h-4v-3c0-1.797-0.784-2.787-1.475-3.659-0.784-0.987-1.525-1.922-1.525-4.341 0-1.338 0.522-2.594 1.472-3.537 0.944-0.944 2.197-1.462 3.528-1.462 0.006 0 0.009 0 0.016 0 2.078 0.006 3.922 1.322 4.656 3.262-2.697 0.791-4.672 3.288-4.672 6.237 0 1.841 0.769 3.503 2 4.688v1.812zM15.5 17c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M14.5 12.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4z" })
            );
        }
        function LampCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LampCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LampCheck.SVG = LampCheckSVG;
        return LampCheck;
    })();
export const LampGear = /*#__PURE__*/ (() => {
        function LampGearSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 18h-4v-3c0-1.797-0.784-2.787-1.475-3.659-0.784-0.987-1.525-1.922-1.525-4.341 0-1.338 0.522-2.594 1.472-3.537 0.944-0.944 2.197-1.462 3.528-1.462 0.006 0 0.009 0 0.016 0 2.412 0.006 4.478 1.763 4.906 4.175l1.969-0.35c-0.284-1.6-1.122-3.066-2.359-4.134-1.259-1.084-2.862-1.688-4.509-1.691-1.872-0.006-3.634 0.722-4.962 2.044-1.328 1.325-2.059 3.084-2.059 4.956 0 3.116 1.084 4.484 1.959 5.584 0.603 0.762 1.041 1.313 1.041 2.416v3c0 1.103 0.897 2 2 2h4c1.103 0 2-0.897 2-2v-1h-2v1z" }),
_('path', { d: "M6 21h6v1h-6v-1z" }),
_('path', { d: "M8 23h2v1h-2v-1z" }),
_('path', { d: "M16.5 11c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5c0-0.828-0.672-1.5-1.5-1.5zM16.5 13c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M21.581 13.694l-1.591-0.919c0.006-0.091 0.009-0.184 0.009-0.281 0-0.094-0.003-0.188-0.009-0.281l1.591-0.919c0.116-0.066 0.2-0.175 0.234-0.303s0.016-0.266-0.050-0.378l-1-1.731c-0.138-0.237-0.444-0.322-0.681-0.184l-1.591 0.919c-0.078-0.053-0.156-0.103-0.241-0.153s-0.166-0.094-0.25-0.131v-1.838c0-0.275-0.225-0.5-0.5-0.5h-2c-0.275 0-0.5 0.225-0.5 0.5v1.837c-0.081 0.041-0.166 0.084-0.25 0.131-0.081 0.047-0.162 0.1-0.241 0.153l-1.591-0.912c-0.237-0.138-0.544-0.056-0.681 0.184l-1 1.731c-0.066 0.116-0.084 0.25-0.050 0.378s0.119 0.237 0.234 0.303l1.591 0.919c-0.006 0.091-0.009 0.184-0.009 0.281 0 0.094 0.003 0.188 0.009 0.281l-1.591 0.919c-0.116 0.066-0.2 0.175-0.234 0.303s-0.016 0.266 0.050 0.378l1 1.731c0.138 0.237 0.444 0.322 0.681 0.184l1.591-0.919c0.078 0.053 0.156 0.103 0.241 0.153s0.166 0.094 0.25 0.131v1.837c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-1.837c0.081-0.041 0.166-0.084 0.25-0.131 0.081-0.047 0.162-0.1 0.241-0.153l1.591 0.912c0.237 0.138 0.544 0.056 0.681-0.184l1-1.731c0.066-0.116 0.084-0.25 0.050-0.378-0.034-0.125-0.119-0.234-0.234-0.303zM20.147 15.178l-1.45-0.831c-0.184-0.106-0.416-0.084-0.575 0.056-0.113 0.097-0.237 0.188-0.372 0.266-0.144 0.081-0.278 0.144-0.413 0.191-0.203 0.069-0.337 0.259-0.337 0.472v1.672h-1v-1.672c0-0.213-0.134-0.403-0.337-0.472-0.134-0.047-0.272-0.109-0.413-0.191-0.134-0.078-0.259-0.166-0.372-0.266-0.162-0.138-0.394-0.159-0.575-0.056l-1.447 0.834-0.5-0.866 1.447-0.834c0.184-0.106 0.281-0.319 0.241-0.528-0.028-0.141-0.041-0.294-0.041-0.453 0-0.162 0.012-0.312 0.041-0.45 0.041-0.209-0.056-0.422-0.241-0.528l-1.45-0.834 0.5-0.866 1.45 0.831c0.184 0.106 0.416 0.084 0.575-0.056 0.112-0.097 0.237-0.188 0.372-0.266 0.144-0.081 0.278-0.144 0.413-0.191 0.2-0.069 0.337-0.259 0.337-0.472v-1.672h1v1.672c0 0.213 0.134 0.403 0.337 0.472 0.134 0.047 0.272 0.109 0.413 0.191 0.134 0.078 0.259 0.166 0.372 0.266 0.162 0.138 0.394 0.162 0.575 0.056l1.447-0.834 0.5 0.866-1.447 0.834c-0.184 0.106-0.281 0.319-0.241 0.528 0.028 0.141 0.041 0.294 0.041 0.453 0 0.162-0.012 0.312-0.041 0.45-0.041 0.209 0.056 0.422 0.241 0.528l1.447 0.834-0.497 0.866z" })
            );
        }
        function LampGear({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LampGearSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LampGear.SVG = LampGearSVG;
        return LampGear;
    })();
export const LampMinus = /*#__PURE__*/ (() => {
        function LampMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 21h6v1h-6v-1z" }),
_('path', { d: "M8 23h2v1h-2v-1z" }),
_('path', { d: "M15.694 5.003c-0.416-1.362-1.25-2.588-2.366-3.481-1.241-0.991-2.731-1.519-4.306-1.522-0.006 0-0.012 0-0.019 0-1.866 0-3.619 0.725-4.944 2.044-1.328 1.325-2.059 3.084-2.059 4.956 0 3.116 1.084 4.484 1.959 5.584 0.603 0.762 1.041 1.313 1.041 2.416v3c0 1.103 0.897 2 2 2h4c1.103 0 2-0.897 2-2v-0.5c0.769 0.322 1.616 0.5 2.5 0.5 3.584 0 6.5-2.916 6.5-6.5 0-3.519-2.813-6.394-6.306-6.497zM11 18h-4v-3c0-1.797-0.784-2.787-1.475-3.659-0.784-0.987-1.525-1.922-1.525-4.341 0-1.338 0.522-2.594 1.472-3.537 0.944-0.944 2.197-1.462 3.528-1.462 0.006 0 0.009 0 0.016 0 2.078 0.006 3.922 1.322 4.656 3.262-2.697 0.791-4.672 3.288-4.672 6.237 0 1.841 0.769 3.503 2 4.688v1.812zM15.5 17c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M13 11h5v1h-5v-1z" })
            );
        }
        function LampMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LampMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LampMinus.SVG = LampMinusSVG;
        return LampMinus;
    })();
export const LampPlus = /*#__PURE__*/ (() => {
        function LampPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 21h6v1h-6v-1z" }),
_('path', { d: "M8 23h2v1h-2v-1z" }),
_('path', { d: "M15.694 5.003c-0.416-1.362-1.25-2.588-2.366-3.481-1.241-0.991-2.731-1.519-4.306-1.522-0.006 0-0.012 0-0.019 0-1.866 0-3.619 0.725-4.944 2.044-1.328 1.325-2.059 3.084-2.059 4.956 0 3.116 1.084 4.484 1.959 5.584 0.603 0.762 1.041 1.313 1.041 2.416v3c0 1.103 0.897 2 2 2h4c1.103 0 2-0.897 2-2v-0.5c0.769 0.322 1.616 0.5 2.5 0.5 3.584 0 6.5-2.916 6.5-6.5 0-3.519-2.813-6.394-6.306-6.497zM11 18h-4v-3c0-1.797-0.784-2.787-1.475-3.659-0.784-0.987-1.525-1.922-1.525-4.341 0-1.338 0.522-2.594 1.472-3.537 0.944-0.944 2.197-1.462 3.528-1.462 0.006 0 0.009 0 0.016 0 2.078 0.006 3.922 1.322 4.656 3.262-2.697 0.791-4.672 3.288-4.672 6.237 0 1.841 0.769 3.503 2 4.688v1.812zM15.5 17c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16 9h-1v2h-2v1h2v2h1v-2h2v-1h-2z" })
            );
        }
        function LampPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LampPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LampPlus.SVG = LampPlusSVG;
        return LampPlus;
    })();
export const LampTime = /*#__PURE__*/ (() => {
        function LampTimeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 21h6v1h-6v-1z" }),
_('path', { d: "M8 23h2v1h-2v-1z" }),
_('path', { d: "M15.694 5.003c-0.416-1.359-1.25-2.588-2.366-3.478-1.241-0.994-2.731-1.519-4.306-1.525-0.006 0-0.012 0-0.019 0-1.866 0-3.619 0.725-4.944 2.044-1.328 1.325-2.059 3.084-2.059 4.956 0 1.375 0.213 2.531 0.65 3.534 0.387 0.888 0.878 1.503 1.309 2.047l0.012 0.016c0.597 0.759 1.028 1.309 1.028 2.403v3c0 1.103 0.897 2 2 2h4c1.103 0 2-0.897 2-2v-0.5c0.769 0.322 1.616 0.5 2.5 0.5 3.584 0 6.5-2.916 6.5-6.5 0-3.519-2.813-6.394-6.306-6.497zM11 18h-4v-3c0-1.788-0.775-2.769-1.456-3.637l-0.012-0.019c0 0-0.003-0.003-0.003-0.003-0.787-0.987-1.528-1.919-1.528-4.341 0-1.338 0.522-2.594 1.472-3.537 0.95-0.947 2.206-1.466 3.544-1.463 2.078 0.006 3.919 1.322 4.653 3.263-2.694 0.791-4.669 3.288-4.669 6.237 0 1.841 0.769 3.503 2 4.688v1.812zM16 16.978v-1.978h-1v1.978c-2.634-0.237-4.737-2.344-4.978-4.978h1.978v-1h-1.978c0.237-2.634 2.344-4.737 4.978-4.978v1.978h1v-1.978c2.634 0.237 4.737 2.344 4.978 4.978h-1.978v1h1.978c-0.241 2.634-2.344 4.737-4.978 4.978z" }),
_('path', { d: "M15.422 11.716l1.938-2.909 0.831 0.556-2.278 3.416c-0.084 0.125-0.219 0.206-0.366 0.219-0.016 0.003-0.034 0.003-0.050 0.003-0.131 0-0.259-0.053-0.353-0.147l-2.353-2.353 0.709-0.706 1.922 1.922z" })
            );
        }
        function LampTime({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LampTimeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LampTime.SVG = LampTimeSVG;
        return LampTime;
    })();
export const Lamp = /*#__PURE__*/ (() => {
        function LampSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.462 4.356c-0.353-0.853-0.862-1.619-1.512-2.275-1.322-1.338-3.072-2.075-4.928-2.081-0.006 0-0.012 0-0.019 0-1.866 0-3.619 0.725-4.944 2.044-1.328 1.325-2.059 3.084-2.059 4.956 0 3.116 1.084 4.484 1.959 5.584 0.603 0.762 1.041 1.313 1.041 2.416v3c0 1.103 0.897 2 2 2h4c1.103 0 2-0.897 2-2v-3c0-1.1 0.438-1.653 1.041-2.412 0.859-1.081 1.931-2.425 1.959-5.459 0.009-0.956-0.172-1.891-0.537-2.772zM17 7.109c-0.022 2.344-0.753 3.263-1.525 4.231 0 0 0 0 0 0-0.691 0.872-1.475 1.859-1.475 3.656v3h-4v-3c0-1.797-0.784-2.787-1.475-3.659-0.784-0.984-1.525-1.919-1.525-4.338 0-1.338 0.522-2.594 1.472-3.537 0.944-0.944 2.197-1.463 3.528-1.463 0.006 0 0.009 0 0.016 0 1.319 0.003 2.566 0.531 3.509 1.488 0.966 0.975 1.488 2.259 1.475 3.622z" }),
_('path', { d: "M9 21h6v1h-6v-1z" }),
_('path', { d: "M11 23h2v1h-2v-1z" })
            );
        }
        function Lamp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LampSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Lamp.SVG = LampSVG;
        return Lamp;
    })();
export const LaptopCode = /*#__PURE__*/ (() => {
        function LaptopCodeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2.5 17h19c0.275 0 0.5-0.225 0.5-0.5v-10.5c0-1.103-0.897-2-2-2h-16c-1.103 0-2 0.897-2 2v10.5c0 0.275 0.225 0.5 0.5 0.5zM4 6h16v10h-16v-10z" }),
_('path', { d: "M0 18h24v2h-24v-2z" }),
_('path', { d: "M8.5 8.794l-2.353 2.353c-0.194 0.194-0.194 0.513 0 0.706l2.353 2.353 0.706-0.706-2-2 2-2-0.706-0.706z" }),
_('path', { d: "M15.5 8.794l-0.706 0.706 2 2-2 2 0.706 0.706 2.353-2.353c0.194-0.194 0.194-0.513 0-0.706l-2.353-2.353z" }),
_('path', { d: "M9.842 14.764l3.394-7.919 0.919 0.394-3.394 7.919-0.919-0.394z" })
            );
        }
        function LaptopCode({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LaptopCodeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LaptopCode.SVG = LaptopCodeSVG;
        return LaptopCode;
    })();
export const LaptopCross = /*#__PURE__*/ (() => {
        function LaptopCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2.5 19h19c0.275 0 0.5-0.225 0.5-0.5v-5.313c1.231-1.184 2-2.847 2-4.688 0-3.584-2.916-6.5-6.5-6.5-2.7 0-5.019 1.653-6 4h-7.5c-1.103 0-2 0.897-2 2v10.5c0 0.275 0.225 0.5 0.5 0.5zM17.5 3c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM4 8h7.019c-0.012 0.166-0.019 0.331-0.019 0.5 0 3.584 2.916 6.5 6.5 6.5 0.884 0 1.731-0.178 2.5-0.5v3.5h-16v-10z" }),
_('path', { d: "M0 20h24v2h-24v-2z" }),
_('path', { d: "M15.5 11.206l2-2 2 2 0.706-0.706-2-2 2-2-0.706-0.706-2 2-2-2-0.706 0.706 2 2-2 2z" })
            );
        }
        function LaptopCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LaptopCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LaptopCross.SVG = LaptopCrossSVG;
        return LaptopCross;
    })();
export const LaptopEducation = /*#__PURE__*/ (() => {
        function LaptopEducationSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2.5 17h19c0.275 0 0.5-0.225 0.5-0.5v-10.5c0-1.103-0.897-2-2-2h-16c-1.103 0-2 0.897-2 2v10.5c0 0.275 0.225 0.5 0.5 0.5zM4 6h16v10h-16v-10z" }),
_('path', { d: "M0 18h24v2h-24v-2z" }),
_('path', { d: "M17.672 9.031l-5.5-2c-0.109-0.041-0.231-0.041-0.341 0l-5.5 2c-0.197 0.072-0.328 0.259-0.328 0.469s0.131 0.397 0.328 0.469l1.672 0.606v2.425c0 0.356 0.172 1.025 1.328 1.519 0.719 0.309 1.669 0.481 2.669 0.481s1.95-0.172 2.672-0.481c1.156-0.494 1.328-1.166 1.328-1.519v-2.422l1-0.363v4.784h1v-5.5c0-0.209-0.131-0.397-0.328-0.469zM15 13c0 0.353-1.137 1-3 1s-3-0.647-3-1v-2.059l2.828 1.028c0.056 0.019 0.112 0.031 0.172 0.031s0.116-0.009 0.172-0.031l2.828-1.028v2.059zM12 10.969l-4.038-1.469 4.038-1.469 4.038 1.469-4.038 1.469z" })
            );
        }
        function LaptopEducation({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LaptopEducationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LaptopEducation.SVG = LaptopEducationSVG;
        return LaptopEducation;
    })();
export const LaptopPhoneSync = /*#__PURE__*/ (() => {
        function LaptopPhoneSyncSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 20h-16v2h16v-2z" }),
_('path', { d: "M0.5 11h6c0.275 0 0.5 0.225 0.5 0.5v10c0 0.275-0.225 0.5-0.5 0.5h-6c-0.275 0-0.5-0.225-0.5-0.5v-10c0-0.275 0.225-0.5 0.5-0.5zM1 21h5v-9h-5v9z" }),
_('path', { d: "M4 19h-1v1h1v-1z" }),
_('path', { d: "M20 14.5c-0.769 0.322-1.616 0.5-2.5 0.5-3.584 0-6.5-2.916-6.5-6.5 0-0.169 0.006-0.334 0.019-0.5h-7.019v2h-2v-2c0-1.103 0.897-2 2-2h7.5c0.981-2.347 3.3-4 6-4 3.584 0 6.5 2.916 6.5 6.5 0 1.841-0.769 3.503-2 4.687v5.313c0 0.275-0.225 0.5-0.5 0.5h-13.5v-1h12v-3.5zM23 8.5c0-3.031-2.469-5.5-5.5-5.5s-5.5 2.469-5.5 5.5 2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5z" }),
_('path', { d: "M15 8.5c0-1.306 1.006-2.381 2.284-2.491l-0.491 0.491 0.706 0.706 1.353-1.353c0.194-0.194 0.194-0.513 0-0.706l-1.353-1.353-0.706 0.706 0.506 0.506c-1.838 0.103-3.3 1.631-3.3 3.494v0.5h1v-0.5z" }),
_('path', { d: "M18.206 10.5l-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706-0.506-0.506c1.838-0.103 3.3-1.631 3.3-3.494v-0.5h-1v0.5c0 1.306-1.006 2.381-2.284 2.491l0.491-0.491z" })
            );
        }
        function LaptopPhoneSync({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LaptopPhoneSyncSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LaptopPhoneSync.SVG = LaptopPhoneSyncSVG;
        return LaptopPhoneSync;
    })();
export const LaptopPhone = /*#__PURE__*/ (() => {
        function LaptopPhoneSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 6h-16v2h-2v-2c0-1.103 0.897-2 2-2h16c1.103 0 2 0.897 2 2v10.5c0 0.275-0.225 0.5-0.5 0.5h-13.5v-1h12v-10z" }),
_('path', { d: "M24 18h-16v2h16v-2z" }),
_('path', { d: "M0.5 9h6c0.275 0 0.5 0.225 0.5 0.5v10c0 0.275-0.225 0.5-0.5 0.5h-6c-0.275 0-0.5-0.225-0.5-0.5v-10c0-0.275 0.225-0.5 0.5-0.5zM1 19h5v-9h-5v9z" }),
_('path', { d: "M4 17h-1v1h1v-1z" })
            );
        }
        function LaptopPhone({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LaptopPhoneSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LaptopPhone.SVG = LaptopPhoneSVG;
        return LaptopPhone;
    })();
export const LaptopPlay = /*#__PURE__*/ (() => {
        function LaptopPlaySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2.5 17h19c0.275 0 0.5-0.225 0.5-0.5v-10.5c0-1.103-0.897-2-2-2h-16c-1.103 0-2 0.897-2 2v10.5c0 0.275 0.225 0.5 0.5 0.5zM4 6h16v10h-16v-10z" }),
_('path', { d: "M0 18h24v2h-24v-2z" }),
_('path', { d: "M14.766 10.575l-4-2.5c-0.153-0.097-0.347-0.1-0.506-0.012s-0.256 0.256-0.256 0.438v5c0 0.181 0.1 0.35 0.256 0.438 0.075 0.041 0.159 0.063 0.244 0.063 0.091 0 0.184-0.025 0.266-0.075l4-2.5c0.147-0.091 0.234-0.253 0.234-0.425s-0.091-0.331-0.237-0.425zM11 12.597v-3.194l2.556 1.597-2.556 1.597z" })
            );
        }
        function LaptopPlay({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LaptopPlaySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LaptopPlay.SVG = LaptopPlaySVG;
        return LaptopPlay;
    })();
export const LaptopShare = /*#__PURE__*/ (() => {
        function LaptopShareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2.5 21h19c0.275 0 0.5-0.225 0.5-0.5v-10.5c0-1.103-0.897-2-2-2h-7v2h7v10h-16v-10h4v-2h-4c-1.103 0-2 0.897-2 2v10.5c0 0.275 0.225 0.5 0.5 0.5z" }),
_('path', { d: "M0 22h24v2h-24v-2z" }),
_('path', { d: "M11 7c0-1.653 1.347-3 3-3h4.294l-1.5 1.5 0.706 0.706 2.353-2.353c0.194-0.194 0.194-0.513 0-0.706l-2.353-2.353-0.706 0.706 1.5 1.5h-4.294c-2.206 0-4 1.794-4 4v7h1v-7z" })
            );
        }
        function LaptopShare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LaptopShareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LaptopShare.SVG = LaptopShareSVG;
        return LaptopShare;
    })();
export const LaptopUser = /*#__PURE__*/ (() => {
        function LaptopUserSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2.5 17h19c0.275 0 0.5-0.225 0.5-0.5v-10.5c0-1.103-0.897-2-2-2h-16c-1.103 0-2 0.897-2 2v10.5c0 0.275 0.225 0.5 0.5 0.5zM10 11c0-1.103 0.897-2 2-2s2 0.897 2 2c0 1.103-0.897 2-2 2s-2-0.897-2-2zM15 16h-6v-0.359c0.722-1.134 1.653-1.641 3-1.641s2.278 0.506 3 1.641v0.359zM4 6h16v10h-4v-0.5c0-0.091-0.025-0.181-0.072-0.256-0.45-0.75-0.975-1.294-1.606-1.666-0.147-0.087-0.3-0.162-0.456-0.231 0.691-0.55 1.134-1.397 1.134-2.347 0-1.653-1.347-3-3-3s-3 1.347-3 3c0 0.95 0.444 1.797 1.134 2.347-0.156 0.066-0.309 0.144-0.456 0.231-0.631 0.372-1.156 0.916-1.606 1.666-0.047 0.078-0.072 0.166-0.072 0.256v0.5h-4v-10z" }),
_('path', { d: "M0 18h24v2h-24v-2z" })
            );
        }
        function LaptopUser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LaptopUserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LaptopUser.SVG = LaptopUserSVG;
        return LaptopUser;
    })();
export const LaptopWarning = /*#__PURE__*/ (() => {
        function LaptopWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2.5 19h19c0.275 0 0.5-0.225 0.5-0.5v-5.5h0.5c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672l-4-7.997c-0.25-0.506-0.775-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-1.584 3.172h-11.575c-1.103 0-2 0.897-2 2v10.5c0 0.275 0.225 0.5 0.5 0.5zM18.053 3.275c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006zM4 8h10.575l-1.413 2.828c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h5.5v5h-16.003v-10z" }),
_('path', { d: "M0 20h24v2h-24v-2z" }),
_('path', { d: "M18 10h1v1h-1v-1z" }),
_('path', { d: "M18 5h1v4h-1v-4z" })
            );
        }
        function LaptopWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LaptopWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LaptopWarning.SVG = LaptopWarningSVG;
        return LaptopWarning;
    })();
export const Laptop = /*#__PURE__*/ (() => {
        function LaptopSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2.5 17h19c0.275 0 0.5-0.225 0.5-0.5v-10.5c0-1.103-0.897-2-2-2h-16c-1.103 0-2 0.897-2 2v10.5c0 0.275 0.225 0.5 0.5 0.5zM4 6h16v10h-16v-10z" }),
_('path', { d: "M0 18h24v2h-24v-2z" })
            );
        }
        function Laptop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LaptopSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Laptop.SVG = LaptopSVG;
        return Laptop;
    })();
export const LastCircle = /*#__PURE__*/ (() => {
        function LastCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M16 9h1v6h-1v-6z" }),
_('path', { d: "M15.766 11.575l-4-2.5c-0.153-0.097-0.347-0.1-0.506-0.012s-0.256 0.256-0.256 0.438v1.597l-3.234-2.022c-0.153-0.097-0.347-0.1-0.506-0.012s-0.256 0.256-0.256 0.438v5c0 0.181 0.1 0.35 0.256 0.438 0.075 0.041 0.159 0.063 0.244 0.063 0.091 0 0.184-0.025 0.266-0.075l3.228-2.022v1.597c0 0.181 0.1 0.35 0.256 0.438 0.075 0.041 0.159 0.063 0.244 0.063 0.091 0 0.184-0.025 0.266-0.075l4-2.5c0.147-0.091 0.234-0.253 0.234-0.425s-0.087-0.331-0.234-0.425zM8 13.597v-3.194l2.556 1.597-2.556 1.597zM12 13.597v-3.194l2.556 1.597-2.556 1.597z" })
            );
        }
        function LastCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LastCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LastCircle.SVG = LastCircleSVG;
        return LastCircle;
    })();
export const LastSquare = /*#__PURE__*/ (() => {
        function LastSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M7.256 14.937c0.075 0.041 0.159 0.063 0.244 0.063 0.091 0 0.184-0.025 0.266-0.075l3.234-2.022v1.597c0 0.181 0.1 0.35 0.256 0.438 0.075 0.041 0.159 0.063 0.244 0.063 0.091 0 0.184-0.025 0.266-0.075l4-2.5c0.147-0.091 0.234-0.253 0.234-0.425s-0.087-0.331-0.234-0.425l-4-2.5c-0.153-0.097-0.347-0.1-0.506-0.012s-0.256 0.256-0.256 0.438v1.597l-3.234-2.022c-0.153-0.097-0.347-0.1-0.506-0.012s-0.256 0.256-0.256 0.438v5c-0.006 0.181 0.094 0.35 0.25 0.438zM12 10.403l2.556 1.597-2.556 1.597v-3.194zM8 10.403l2.556 1.597-2.556 1.597v-3.194z" }),
_('path', { d: "M16 9h1v6h-1v-6z" })
            );
        }
        function LastSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LastSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LastSquare.SVG = LastSquareSVG;
        return LastSquare;
    })();
export const Last = /*#__PURE__*/ (() => {
    function LastSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 4v6.778l-9.425-6.597c-0.306-0.213-0.703-0.241-1.034-0.069s-0.541 0.516-0.541 0.888v5.778l-9.425-6.597c-0.306-0.213-0.703-0.241-1.034-0.069-0.334 0.172-0.541 0.516-0.541 0.888v14c0 0.372 0.206 0.716 0.537 0.888 0.144 0.075 0.303 0.112 0.462 0.112 0.203 0 0.403-0.059 0.575-0.181l9.425-6.597v5.778c0 0.372 0.206 0.716 0.537 0.888 0.144 0.075 0.303 0.112 0.462 0.112 0.203 0 0.403-0.059 0.575-0.181l9.425-6.597v6.778h2v-16h-2zM2 17.078v-10.156l7.256 5.078-7.256 5.078zM13 17.078v-10.156l7.256 5.078-7.256 5.078z" })
        );
    }
    function Last({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LastSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Last.SVG = LastSVG;
    return Last;
})();
export const LaundryTime = /*#__PURE__*/ (() => {
        function LaundryTimeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 14h-1c0 2.206 1.794 4 4 4v-1c-1.653 0-3-1.347-3-3z" }),
_('path', { d: "M16 3h1v1h-1v-1z" }),
_('path', { d: "M3 3h2v1h-2v-1z" }),
_('path', { d: "M6 3h1v1h-1v-1z" }),
_('path', { d: "M8 3h1v1h-1v-1z" }),
_('path', { d: "M20 11.5v-9.5c0-1.103-0.897-2-2-2h-16c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h15.5c3.584 0 6.5-2.916 6.5-6.5 0-2.7-1.653-5.019-4-6zM18 2v3.997c-2.219-0.637-5.056-0.997-8-0.997s-5.781 0.359-8 0.997v-3.997h16zM2 7.041c2.163-0.666 5.019-1.041 8-1.041s5.838 0.375 8 1.041v3.978c-0.166-0.012-0.331-0.019-0.5-0.019-0.384 0-0.762 0.034-1.128 0.097-0.522-1.147-1.341-2.125-2.381-2.85-1.175-0.816-2.556-1.247-3.991-1.247-3.859 0-7 3.141-7 7s3.141 7 7 7c0.637 0 1.266-0.084 1.869-0.253 0.262 0.456 0.581 0.875 0.944 1.253h-10.812v-14.959zM11 17.5c0 0.469 0.050 0.928 0.144 1.369-0.372 0.087-0.756 0.131-1.144 0.131-2.756 0-5-2.244-5-5s2.244-5 5-5c1.916 0 3.622 1.066 4.466 2.753-2.059 1.091-3.466 3.256-3.466 5.747zM18 22.978v-1.978h-1v1.978c-2.634-0.237-4.737-2.344-4.978-4.978h1.978v-1h-1.978c0.237-2.634 2.344-4.737 4.978-4.978v1.978h1v-1.978c2.634 0.237 4.737 2.344 4.978 4.978h-1.978v1h1.978c-0.241 2.634-2.344 4.737-4.978 4.978z" }),
_('path', { d: "M17.422 17.716l-1.922-1.922-0.706 0.706 2.353 2.353c0.094 0.094 0.222 0.147 0.353 0.147 0.016 0 0.034 0 0.050-0.003 0.15-0.016 0.284-0.097 0.366-0.219l2.278-3.416-0.831-0.556-1.941 2.909z" })
            );
        }
        function LaundryTime({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LaundryTimeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LaundryTime.SVG = LaundryTimeSVG;
        return LaundryTime;
    })();
export const LayersCross = /*#__PURE__*/ (() => {
        function LayersCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 13.5c0-0.197-0.119-0.378-0.3-0.459l-1.781-0.781c1.278-1.188 2.078-2.881 2.078-4.759 0-3.584-2.916-6.5-6.5-6.5-1.931 0-3.672 0.847-4.863 2.191l-0.225-0.103c-0.263-0.119-0.566-0.119-0.828 0l-11 5c-0.353 0.166-0.581 0.522-0.581 0.912s0.228 0.747 0.588 0.909l3.363 1.528-3.65 1.603c-0.181 0.081-0.3 0.263-0.3 0.459s0.119 0.378 0.3 0.459l3.513 1.541-3.513 1.541c-0.181 0.081-0.3 0.262-0.3 0.459s0.119 0.378 0.3 0.459l11.5 5.050c0.063 0.028 0.131 0.041 0.2 0.041s0.138-0.016 0.2-0.041l11.5-5.050c0.181-0.081 0.3-0.259 0.3-0.459 0-0.197-0.119-0.378-0.3-0.459l-3.513-1.541 3.513-1.541c0.181-0.081 0.3-0.263 0.3-0.459zM17.5 2c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM11.35 5.394c-0.228 0.659-0.35 1.369-0.35 2.106 0 1.931 0.847 3.669 2.191 4.863l-1.191 0.537-8.584-3.9 7.934-3.606zM22.256 17.5l-10.256 4.503-10.256-4.503 3.312-1.453 6.744 2.962c0.063 0.028 0.131 0.041 0.2 0.041s0.138-0.016 0.2-0.041l6.744-2.962 3.312 1.453zM12 18.003l-10.256-4.503 3.428-1.506 6.416 2.916c0.131 0.059 0.272 0.091 0.413 0.091s0.281-0.031 0.413-0.091l2.862-1.303c0.697 0.256 1.444 0.394 2.225 0.394 1.297 0 2.509-0.381 3.525-1.041l1.231 0.541-10.256 4.503z" }),
_('path', { d: "M15.5 10.206l2-2 2 2 0.706-0.706-2-2 2-2-0.706-0.706-2 2-2-2-0.706 0.706 2 2-2 2z" })
            );
        }
        function LayersCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LayersCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LayersCross.SVG = LayersCrossSVG;
        return LayersCross;
    })();
export const Layers = /*#__PURE__*/ (() => {
    function LayersSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 12.5c0-0.197-0.119-0.378-0.3-0.459l-3.65-1.603 3.363-1.528c0.356-0.162 0.588-0.519 0.588-0.909s-0.228-0.747-0.588-0.909l-11-5c-0.263-0.119-0.566-0.119-0.828 0l-11 5c-0.356 0.162-0.584 0.519-0.584 0.909s0.228 0.747 0.588 0.909l3.363 1.528-3.65 1.603c-0.181 0.081-0.3 0.263-0.3 0.459s0.119 0.378 0.3 0.459l3.513 1.541-3.513 1.541c-0.181 0.081-0.3 0.262-0.3 0.459s0.119 0.378 0.3 0.459l11.5 5.050c0.063 0.028 0.131 0.041 0.2 0.041s0.138-0.016 0.2-0.041l11.5-5.050c0.181-0.081 0.3-0.259 0.3-0.459 0-0.197-0.119-0.378-0.3-0.459l-3.513-1.541 3.513-1.541c0.181-0.081 0.3-0.263 0.3-0.459zM12 4.1l8.584 3.9-8.584 3.9-8.584-3.9 8.584-3.9zM22.256 16.5l-10.256 4.503-10.256-4.503 3.312-1.453 6.744 2.962c0.063 0.028 0.131 0.041 0.2 0.041s0.138-0.016 0.2-0.041l6.744-2.962 3.312 1.453zM12 17.003l-10.256-4.503 3.428-1.506 6.416 2.916c0.131 0.059 0.272 0.091 0.413 0.091s0.281-0.031 0.413-0.091l6.416-2.916 3.428 1.506-10.256 4.503z" })
        );
    }
    function Layers({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LayersSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Layers.SVG = LayersSVG;
    return Layers;
})();
export const LeafCheck = /*#__PURE__*/ (() => {
        function LeafCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.728 10.116c1.275-2.131 2.737-4.494 4.922-6.356 0.266-0.225 0.394-0.575 0.337-0.919s-0.284-0.634-0.606-0.769c-2.319-0.953-5.616-1.294-8.816-0.912-3.606 0.431-6.603 1.703-8.434 3.588-1.638 1.684-3.15 4.669-1.169 9.369-0.097 0.459-0.356 1.459-0.925 2.434-0.944 1.625-2.303 2.45-4.038 2.45v2c2.487 0 4.494-1.212 5.8-3.503 0.381-0.669 0.647-1.334 0.828-1.897 0.472 0.441 1.075 0.791 1.794 1.034 1.047 0.356 1.975 0.366 2.078 0.366 0.175 0 0.347-0.006 0.519-0.019 0.247 3.359 3.059 6.019 6.481 6.019 3.584 0 6.5-2.916 6.5-6.5 0-3.166-2.272-5.809-5.272-6.384zM16.625 9.734c-0.069 0.116-0.141 0.237-0.213 0.356-2.559 0.434-4.616 2.369-5.225 4.866-0.219 0.028-0.447 0.044-0.681 0.044-0.059 0-2.534-0.050-3.019-1.7 0.769-1.681 1.878-2.947 2.763-3.772 1.384-1.294 2.978-2.222 4.369-2.544l0.487-0.113-0.225-0.975-0.487 0.112c-1.556 0.359-3.316 1.375-4.828 2.784-0.944 0.881-2.128 2.231-2.959 4.028-1.012-2.738-0.691-4.984 0.966-6.684 1.512-1.556 4.084-2.619 7.238-2.997 2.175-0.259 4.444-0.144 6.278 0.294-1.825 1.9-3.1 4.031-4.25 5.953-0.075 0.122-0.144 0.234-0.213 0.347zM17.5 22c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16.5 17.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4z" })
            );
        }
        function LeafCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LeafCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LeafCheck.SVG = LeafCheckSVG;
        return LeafCheck;
    })();
export const LeafCross = /*#__PURE__*/ (() => {
        function LeafCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.728 10.116c1.275-2.131 2.737-4.494 4.922-6.356 0.266-0.225 0.394-0.575 0.337-0.919s-0.284-0.634-0.606-0.769c-2.319-0.953-5.616-1.294-8.816-0.912-3.606 0.431-6.603 1.703-8.434 3.588-1.638 1.684-3.15 4.669-1.169 9.369-0.097 0.459-0.356 1.459-0.925 2.434-0.944 1.625-2.303 2.45-4.038 2.45v2c2.487 0 4.494-1.212 5.8-3.503 0.381-0.669 0.647-1.334 0.828-1.897 0.472 0.441 1.075 0.791 1.794 1.034 1.047 0.356 1.975 0.366 2.078 0.366 0.175 0 0.347-0.006 0.519-0.019 0.247 3.359 3.059 6.019 6.481 6.019 3.584 0 6.5-2.916 6.5-6.5 0-3.166-2.272-5.809-5.272-6.384zM16.625 9.734c-0.069 0.116-0.141 0.237-0.213 0.356-2.559 0.434-4.616 2.369-5.225 4.866-0.219 0.028-0.447 0.044-0.681 0.044-0.059 0-2.534-0.050-3.019-1.7 0.769-1.681 1.878-2.947 2.763-3.772 1.384-1.294 2.978-2.222 4.369-2.544l0.487-0.113-0.225-0.975-0.487 0.112c-1.556 0.359-3.316 1.375-4.828 2.784-0.944 0.881-2.128 2.231-2.959 4.028-1.012-2.738-0.691-4.984 0.966-6.684 1.512-1.556 4.084-2.619 7.238-2.997 2.175-0.259 4.444-0.144 6.278 0.294-1.825 1.9-3.1 4.031-4.25 5.953-0.075 0.122-0.144 0.234-0.213 0.347zM17.5 22c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 13.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function LeafCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LeafCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LeafCross.SVG = LeafCrossSVG;
        return LeafCross;
    })();
export const LeafPlus = /*#__PURE__*/ (() => {
        function LeafPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.728 10.116c1.275-2.131 2.737-4.494 4.922-6.356 0.266-0.225 0.394-0.575 0.337-0.919s-0.284-0.634-0.606-0.769c-2.319-0.953-5.616-1.294-8.816-0.912-3.606 0.431-6.603 1.703-8.434 3.588-1.638 1.684-3.15 4.669-1.169 9.369-0.097 0.459-0.356 1.459-0.925 2.434-0.944 1.625-2.303 2.45-4.038 2.45v2c2.487 0 4.494-1.212 5.8-3.503 0.381-0.669 0.647-1.334 0.828-1.897 0.472 0.441 1.075 0.791 1.794 1.034 1.047 0.356 1.975 0.366 2.078 0.366 0.175 0 0.347-0.006 0.519-0.019 0.247 3.359 3.059 6.019 6.481 6.019 3.584 0 6.5-2.916 6.5-6.5 0-3.166-2.272-5.809-5.272-6.384zM16.625 9.734c-0.069 0.116-0.141 0.237-0.213 0.356-2.559 0.434-4.616 2.369-5.225 4.866-0.219 0.028-0.447 0.044-0.681 0.044-0.059 0-2.534-0.050-3.019-1.7 0.769-1.681 1.878-2.947 2.763-3.772 1.384-1.294 2.978-2.222 4.369-2.544l0.487-0.113-0.225-0.975-0.487 0.112c-1.556 0.359-3.316 1.375-4.828 2.784-0.944 0.881-2.128 2.231-2.959 4.028-1.012-2.738-0.691-4.984 0.966-6.684 1.512-1.556 4.084-2.619 7.238-2.997 2.175-0.259 4.444-0.144 6.278 0.294-1.825 1.9-3.1 4.031-4.25 5.953-0.075 0.122-0.144 0.234-0.213 0.347zM17.5 22c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18 14h-1v2h-2v1h2v2h1v-2h2v-1h-2z" })
            );
        }
        function LeafPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LeafPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LeafPlus.SVG = LeafPlusSVG;
        return LeafPlus;
    })();
export const Leaf = /*#__PURE__*/ (() => {
    function LeafSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.988 3.844c-0.056-0.344-0.284-0.634-0.606-0.769-2.319-0.956-5.616-1.297-8.816-0.916-3.606 0.431-6.603 1.703-8.434 3.588-1.638 1.684-3.15 4.669-1.169 9.369-0.097 0.459-0.356 1.459-0.925 2.434-0.944 1.625-2.303 2.45-4.038 2.45v2c2.487 0 4.494-1.212 5.8-3.503 0.381-0.669 0.647-1.334 0.828-1.897 0.472 0.441 1.075 0.791 1.794 1.034 1.047 0.356 1.975 0.366 2.078 0.366 1.881 0 3.478-0.687 4.887-2.097 1.194-1.197 2.147-2.794 3.159-4.481 1.319-2.206 2.816-4.706 5.103-6.659 0.266-0.228 0.394-0.575 0.337-0.919zM16.831 10.394c-2.144 3.581-3.494 5.606-6.331 5.606-0.025 0-2.528-0.047-3.019-1.7 0.769-1.681 1.878-2.947 2.763-3.772 1.384-1.294 2.978-2.222 4.369-2.544l0.487-0.113-0.225-0.975-0.488 0.112c-1.556 0.359-3.316 1.375-4.828 2.784-0.944 0.881-2.128 2.231-2.959 4.028-1.012-2.738-0.691-4.984 0.966-6.684 1.512-1.556 4.084-2.619 7.238-2.997 2.175-0.259 4.444-0.144 6.278 0.294-1.825 1.903-3.103 4.038-4.25 5.959z" })
        );
    }
    function Leaf({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LeafSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Leaf.SVG = LeafSVG;
    return Leaf;
})();
export const LeapBackward = /*#__PURE__*/ (() => {
        function LeapBackwardSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 4v3.059c0.725-0.647 1.525-1.209 2.384-1.666 1.716-0.912 3.659-1.394 5.616-1.394 4.072 0 7.831 2.037 10.059 5.453l-1.675 1.094c-1.856-2.847-4.991-4.547-8.384-4.547-2.703 0-5.275 1.1-7.141 3h4.141v2h-6c-0.553 0-1-0.447-1-1v-6h2z" }),
_('path', { d: "M12 7c2.403 0 4.662 0.938 6.363 2.637s2.637 3.959 2.637 6.363h-1c0-4.413-3.588-8-8-8v-1z" }),
_('path', { d: "M12 12c2.206 0 4 1.794 4 4s-1.794 4-4 4c-2.206 0-4-1.794-4-4s1.794-4 4-4zM12 19c1.653 0 3-1.347 3-3s-1.347-3-3-3-3 1.347-3 3 1.347 3 3 3z" })
            );
        }
        function LeapBackward({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LeapBackwardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LeapBackward.SVG = LeapBackwardSVG;
        return LeapBackward;
    })();
export const LeapForward = /*#__PURE__*/ (() => {
        function LeapForwardSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 4v3.059c-0.725-0.647-1.525-1.209-2.384-1.666-1.716-0.912-3.659-1.394-5.616-1.394-4.072 0-7.831 2.037-10.059 5.453l1.675 1.094c1.856-2.847 4.991-4.547 8.384-4.547 2.703 0 5.275 1.1 7.141 3h-4.141v2h6c0.553 0 1-0.447 1-1v-6h-2z" }),
_('path', { d: "M12 7c-2.403 0-4.662 0.938-6.363 2.637s-2.637 3.959-2.637 6.363h1c0-4.413 3.588-8 8-8v-1z" }),
_('path', { d: "M12 12c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.206 0 4-1.794 4-4s-1.794-4-4-4zM12 19c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" })
            );
        }
        function LeapForward({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LeapForwardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LeapForward.SVG = LeapForwardSVG;
        return LeapForward;
    })();
export const LedBright = /*#__PURE__*/ (() => {
        function LedBrightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 10v-5c0-2.756-2.244-5-5-5s-5 2.244-5 5v5c0 0.55-0.45 1-1 1v2h4v11h1v-11h2v10h1v-10h4v-2c-0.55 0-1-0.45-1-1zM14 11v-3h-1v3h-2v-3h-1v3h-1.172c0.113-0.312 0.172-0.65 0.172-1v-5c0-1.653 1.347-3 3-3s3 1.347 3 3v5c0 0.35 0.059 0.687 0.172 1h-1.172z" }),
_('path', { d: "M1.828 1.723l0.447-0.894 2.896 1.448-0.447 0.894-2.896-1.448z" }),
_('path', { d: "M18.828 2.277l2.896-1.448 0.447 0.894-2.896 1.448-0.447-0.894z" }),
_('path', { d: "M0.828 13.277l2.896-1.448 0.447 0.894-2.896 1.448-0.447-0.894z" }),
_('path', { d: "M19.828 12.724l0.447-0.894 2.896 1.448-0.447 0.894-2.896-1.448z" }),
_('path', { d: "M0 7h4v1h-4v-1z" }),
_('path', { d: "M20 7h4v1h-4v-1z" })
            );
        }
        function LedBright({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LedBrightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LedBright.SVG = LedBrightSVG;
        return LedBright;
    })();
export const Led = /*#__PURE__*/ (() => {
    function LedSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18 11c-0.55 0-1-0.45-1-1v-5c0-2.756-2.244-5-5-5s-5 2.244-5 5v5c0 0.55-0.45 1-1 1v2h4v11h1v-11h2v10h1v-10h4v-2zM13 8v3h-2v-3h-1v3h-1.172c0.112-0.312 0.172-0.65 0.172-1v-5c0-1.653 1.347-3 3-3s3 1.347 3 3v5c0 0.35 0.059 0.687 0.172 1h-1.172v-3h-1z" })
        );
    }
    function Led({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Led.SVG = LedSVG;
    return Led;
})();
export const Library = /*#__PURE__*/ (() => {
        function LibrarySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.772 5l-8.266-4.863c-0.312-0.184-0.7-0.184-1.012 0l-8.266 4.863h-3.228v2h3.5c0.178 0 0.353-0.047 0.506-0.138l7.994-4.703 7.994 4.703c0.153 0.091 0.328 0.138 0.506 0.138h3.5v-2h-3.228z" }),
_('path', { d: "M0 8h24v1h-24v-1z" }),
_('path', { d: "M1 19v1h4v-1h-1v-8h1v-1h-4v1h1v8z" }),
_('path', { d: "M7 19v1h4v-1h-1v-8h1v-1h-4v1h1v8z" }),
_('path', { d: "M13 19v1h4v-1h-1v-8h1v-1h-4v1h1v8z" }),
_('path', { d: "M19 19v1h4v-1h-1v-8h1v-1h-4v1h1v8z" }),
_('path', { d: "M0 21h24v1h-24v-1z" }),
_('path', { d: "M0 23h24v1h-24v-1z" })
            );
        }
        function Library({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LibrarySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Library.SVG = LibrarySVG;
        return Library;
    })();
export const Lifebuoy = /*#__PURE__*/ (() => {
    function LifebuoySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 12c0-1.619-0.319-3.191-0.944-4.672-0.55-1.303-1.322-2.484-2.287-3.519 0.216 0.122 0.466 0.191 0.731 0.191 0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5c0 0.266 0.069 0.516 0.191 0.731-1.034-0.969-2.216-1.737-3.519-2.287-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.303 0.55-2.484 1.322-3.519 2.287 0.122-0.216 0.191-0.466 0.191-0.731 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5c0.266 0 0.516-0.069 0.731-0.191-0.969 1.034-1.737 2.216-2.287 3.519-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.55 1.303 1.322 2.484 2.287 3.519-0.216-0.122-0.466-0.191-0.731-0.191-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5c0-0.266-0.069-0.516-0.191-0.731 1.034 0.966 2.216 1.737 3.519 2.287 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.303-0.55 2.484-1.322 3.519-2.287-0.122 0.216-0.191 0.466-0.191 0.731 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5c-0.266 0-0.516 0.069-0.731 0.191 0.966-1.034 1.737-2.216 2.287-3.519 0.625-1.481 0.944-3.053 0.944-4.672zM21.5 2c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM20.034 6.053l-3.225 2.366c-0.347-0.466-0.762-0.881-1.228-1.228l2.366-3.225c0.794 0.591 1.497 1.294 2.088 2.088zM12 16c-2.206 0-4-1.794-4-4s1.794-4 4-4c2.206 0 4 1.794 4 4s-1.794 4-4 4zM12 2c1.869 0 3.616 0.516 5.116 1.409l-2.384 3.247c-0.819-0.419-1.747-0.656-2.731-0.656s-1.912 0.237-2.731 0.659l-2.384-3.247c1.5-0.897 3.247-1.413 5.116-1.413zM6.053 3.966l2.366 3.225c-0.466 0.347-0.881 0.762-1.228 1.228l-3.225-2.366c0.591-0.794 1.294-1.497 2.088-2.088zM2.5 3c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5zM3.409 6.884l3.247 2.384c-0.419 0.819-0.656 1.747-0.656 2.731s0.237 1.912 0.659 2.731l-3.247 2.384c-0.897-1.5-1.413-3.247-1.413-5.116s0.516-3.616 1.409-5.116zM2.5 22c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5zM3.966 17.947l3.225-2.366c0.347 0.466 0.762 0.881 1.228 1.228l-2.366 3.225c-0.794-0.591-1.497-1.294-2.088-2.088zM12 22c-1.869 0-3.616-0.516-5.116-1.409l2.384-3.247c0.819 0.422 1.747 0.659 2.731 0.659s1.912-0.237 2.731-0.659l2.384 3.247c-1.5 0.894-3.247 1.409-5.116 1.409zM17.947 20.034l-2.366-3.225c0.466-0.347 0.881-0.762 1.228-1.228l3.225 2.366c-0.591 0.794-1.294 1.497-2.088 2.088zM21.5 21c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM20.591 17.116l-3.247-2.384c0.422-0.819 0.659-1.747 0.659-2.731s-0.237-1.912-0.659-2.731l3.247-2.384c0.894 1.5 1.409 3.247 1.409 5.116s-0.516 3.616-1.409 5.116z" })
        );
    }
    function Lifebuoy({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LifebuoySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lifebuoy.SVG = LifebuoySVG;
    return Lifebuoy;
})();
export const Ligature = /*#__PURE__*/ (() => {
    function LigatureSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17 21v-8.5c0-0.275-0.225-0.5-0.5-0.5h-7.5v-5c0-1.653 1.347-3 3-3s3 1.347 3 3v1h2v-1c0-2.756-2.244-5-5-5s-5 2.244-5 5v5h-2v1h2v8h-2v1h6v-1h-2v-8h6v8h-2v1h6v-1h-2z" })
        );
    }
    function Ligature({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LigatureSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Ligature.SVG = LigatureSVG;
    return Ligature;
})();
export const Lighter = /*#__PURE__*/ (() => {
        function LighterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 10v-1.5c0-0.275-0.225-0.5-0.5-0.5h-3.5v-0.5c0-0.275-0.225-0.5-0.5-0.5h-4c-0.275 0-0.5 0.225-0.5 0.5v2.5c-0.272 0-0.516 0.109-0.697 0.284l-6.134-6.138c-0.094-0.094-0.222-0.147-0.353-0.147s-0.259 0.053-0.353 0.147l-2.872 2.872c-0.003 0.003-0.003 0.003-0.006 0.006-0.378 0.381-0.581 0.881-0.581 1.413s0.209 1.034 0.588 1.409l4.559 4.563c0.391 0.391 0.903 0.584 1.416 0.584 0.509 0 1.019-0.194 1.409-0.578l2.028-2.028v9.612c0 1.103 0.897 2 2 2h7c1.103 0 2-0.897 2-2v-11c-0.003-0.553-0.45-1-1.003-1zM19 9v1h-3v-1h3zM19 12v8h-7v-8h7zM12 8h3v2h-3v-2zM6.563 12.997l-4.559-4.563c0 0 0 0 0.003-0.003l2.516-2.516 4.563 4.563-2.522 2.519zM12 22v-1h7v1h-7z" }),
_('path', { d: "M13.5 5c0.419 0 0.8-0.162 1.075-0.456 0.278-0.3 0.425-0.713 0.425-1.191 0-0.809-0.872-2.697-1.047-3.066-0.084-0.175-0.259-0.288-0.453-0.288s-0.369 0.112-0.453 0.288c-0.175 0.369-1.047 2.256-1.047 3.066 0 0.478 0.147 0.891 0.425 1.191 0.275 0.294 0.656 0.456 1.075 0.456zM13.5 1.747c0.269 0.663 0.5 1.328 0.5 1.606 0 0.413-0.181 0.647-0.5 0.647s-0.5-0.234-0.5-0.647c0-0.278 0.231-0.944 0.5-1.606z" })
            );
        }
        function Lighter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LighterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Lighter.SVG = LighterSVG;
        return Lighter;
    })();
export const Lighthouse = /*#__PURE__*/ (() => {
        function LighthouseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16.069 8h0.431c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-1.5v-1c0-1.653-1.347-3-3-3s-3 1.347-3 3v1h-1.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h0.431l-2.753 14h-2.178v2h18v-2h-2.178l-2.753-14zM11 3c0-0.55 0.45-1 1-1s1 0.45 1 1v1h-2v-1zM8 5h8v2h-8v-2zM9.969 8h4.062l2.753 14h-1.784v-3h-2v3h-5.784l2.753-14z" }),
_('path', { d: "M16.828 2.277l2.896-1.448 0.447 0.894-2.896 1.448-0.447-0.894z" }),
_('path', { d: "M18 4h4v1h-4v-1z" }),
_('path', { d: "M17.828 6.724l0.447-0.894 2.896 1.448-0.447 0.894-2.896-1.448z" }),
_('path', { d: "M3.828 1.723l0.447-0.894 2.896 1.448-0.447 0.894-2.896-1.448z" }),
_('path', { d: "M2 4h4v1h-4v-1z" }),
_('path', { d: "M2.828 7.277l2.896-1.448 0.447 0.894-2.896 1.448-0.447-0.894z" })
            );
        }
        function Lighthouse({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LighthouseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Lighthouse.SVG = LighthouseSVG;
        return Lighthouse;
    })();
export const LineSpacing = /*#__PURE__*/ (() => {
        function LineSpacingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 2h14v2h-14v-2z" }),
_('path', { d: "M10 21h14v1h-14v-1z" }),
_('path', { d: "M6.544 6.956l1.416-1.416-3.25-3.25c-0.391-0.391-1.025-0.391-1.416 0l-3.25 3.25 1.416 1.416 1.541-1.541v13.172l-1.544-1.544-1.413 1.413 3.25 3.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l3.25-3.25-1.416-1.416-1.541 1.544v-13.169l1.544 1.541z" }),
_('path', { d: "M10 9h14v1h-14v-1z" }),
_('path', { d: "M10 12h14v1h-14v-1z" }),
_('path', { d: "M10 15h14v1h-14v-1z" }),
_('path', { d: "M10 18h14v1h-14v-1z" }),
_('path', { d: "M10 6h14v1h-14v-1z" })
            );
        }
        function LineSpacing({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LineSpacingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LineSpacing.SVG = LineSpacingSVG;
        return LineSpacing;
    })();
export const LinkCross = /*#__PURE__*/ (() => {
        function LinkCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.366 10.056l0.097-0.097c2.047-2.047 2.047-5.375 0-7.422s-5.375-2.047-7.422 0l-3.503 3.503c-2.047 2.047-2.047 5.375 0 7.422 0.281 0.281 0.597 0.531 0.934 0.744l1.059-1.697c-0.209-0.131-0.403-0.284-0.578-0.459-1.266-1.266-1.266-3.328 0-4.594l3.503-3.503c1.266-1.266 3.328-1.266 4.594 0s1.266 3.328 0 4.594l-1.894 1.891c-0.453 0.175-0.884 0.403-1.281 0.669-0.213-0.966-0.7-1.856-1.413-2.569-0.281-0.281-0.597-0.531-0.934-0.744l-1.059 1.697c0.209 0.131 0.403 0.284 0.578 0.459 0.581 0.581 0.916 1.347 0.95 2.163h-0.003c0.019 0.441-0.050 0.869-0.206 1.278-0.097 0.175-0.184 0.359-0.266 0.544-0.134 0.219-0.294 0.422-0.478 0.606v0l-3.5 3.509c-1.266 1.266-3.328 1.266-4.594 0s-1.266-3.328 0-4.594l2.006-1.997-1.413-1.416-2.006 2c-2.047 2.047-2.047 5.375 0 7.422 1.022 1.022 2.366 1.534 3.712 1.534 1.344 0 2.688-0.513 3.713-1.534l2.097-2.097c0.422 3.172 3.15 5.631 6.441 5.631 3.584 0 6.5-2.916 6.5-6.5 0-3.291-2.459-6.019-5.634-6.444zM17.5 22c-3.031 0-5.5-2.469-5.5-5.5 0-0.025 0-0.053 0-0.078l0.006-0.006-0.006-0.006c0.050-2.991 2.497-5.409 5.5-5.409 3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 13.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function LinkCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LinkCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LinkCross.SVG = LinkCrossSVG;
        return LinkCross;
    })();
export const Link = /*#__PURE__*/ (() => {
        function LinkSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 15.25c0 0.866-0.337 1.681-0.95 2.297l-1.503 1.503c-1.266 1.266-3.328 1.266-4.594 0s-1.266-3.328 0-4.594l1.503-1.503c0.612-0.612 1.428-0.95 2.297-0.95h0.247v-2h-0.247c-1.403 0-2.719 0.547-3.712 1.537l-1.503 1.503c-2.047 2.047-2.047 5.375 0 7.422 1.022 1.022 2.366 1.534 3.712 1.534 1.344 0 2.688-0.513 3.712-1.534l1.503-1.503c0.987-0.994 1.534-2.313 1.534-3.712v-0.25h-2v0.25z" }),
_('path', { d: "M20.463 3.537c-2.047-2.047-5.375-2.047-7.422 0l-1.503 1.503c-0.991 0.991-1.537 2.309-1.537 3.709v0.25h2v-0.25c0-0.866 0.337-1.681 0.95-2.297l1.503-1.503c1.266-1.266 3.328-1.266 4.594 0s1.266 3.328 0 4.594l-1.503 1.503c-0.612 0.612-1.428 0.95-2.297 0.95h-0.247v2h0.247c1.403 0 2.719-0.547 3.713-1.537l1.503-1.503c2.047-2.044 2.047-5.372 0-7.419z" }),
_('path', { d: "M8.042 14.543l6.501-6.501 1.414 1.414-6.501 6.501-1.414-1.414z" })
            );
        }
        function Link({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LinkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Link.SVG = LinkSVG;
        return Link;
    })();
export const Link2 = /*#__PURE__*/ (() => {
        function Link2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.531 8.794l-1.062 1.697c0.209 0.131 0.403 0.284 0.578 0.459 1.266 1.266 1.266 3.328 0 4.594l-3.503 3.506c-0.634 0.634-1.466 0.95-2.297 0.95s-1.662-0.316-2.297-0.95c-1.266-1.266-1.266-3.328 0-4.594l2.006-1.997-1.413-1.416-2.006 2c-2.047 2.047-2.047 5.375 0 7.422 1.022 1.022 2.366 1.534 3.713 1.534 1.344 0 2.688-0.513 3.712-1.534l3.503-3.503c2.047-2.047 2.047-5.375 0-7.422-0.284-0.288-0.6-0.534-0.934-0.747z" }),
_('path', { d: "M20.463 3.537c-2.047-2.047-5.375-2.047-7.422 0l-3.503 3.503c-2.047 2.047-2.047 5.375 0 7.422 0.281 0.281 0.597 0.531 0.934 0.744l1.059-1.697c-0.209-0.131-0.403-0.284-0.578-0.459-1.266-1.266-1.266-3.328 0-4.594l3.503-3.503c1.266-1.266 3.328-1.266 4.594 0s1.266 3.328 0 4.594l-2.006 1.997 1.413 1.416 2.006-2c2.047-2.047 2.047-5.375 0-7.422z" })
            );
        }
        function Link2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Link2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Link2.SVG = Link2SVG;
        return Link2;
    })();
export const Lips = /*#__PURE__*/ (() => {
    function LipsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.975 10.775c-0.103-0.453-0.509-0.775-0.975-0.775-1.231 0-2.516-0.981-3.759-1.931-1.331-1.016-2.709-2.069-4.241-2.069-1.188 0-1.881 0.422-2.384 0.731-0.325 0.2-0.453 0.269-0.616 0.269s-0.291-0.069-0.616-0.269c-0.503-0.309-1.197-0.731-2.384-0.731-1.531 0-2.909 1.053-4.241 2.069-1.244 0.95-2.528 1.931-3.759 1.931-0.466 0-0.869 0.322-0.975 0.775-0.103 0.453 0.119 0.919 0.537 1.125 0.775 0.378 1.253 1.019 1.856 1.831 0.709 0.953 1.512 2.031 2.981 2.878 1.628 0.934 3.787 1.391 6.6 1.391s4.972-0.456 6.6-1.391c1.469-0.844 2.272-1.925 2.981-2.878 0.603-0.813 1.081-1.453 1.856-1.831 0.419-0.203 0.641-0.672 0.537-1.125zM5.972 9.659c1.116-0.853 2.172-1.659 3.028-1.659 0.625 0 0.941 0.194 1.344 0.438 0.409 0.25 0.919 0.563 1.656 0.563s1.247-0.312 1.656-0.563c0.4-0.244 0.716-0.438 1.344-0.438 0.856 0 1.909 0.806 3.028 1.659 0.675 0.516 1.394 1.062 2.159 1.5-5.444 1.113-10.931 1.113-16.375 0 0.769-0.438 1.484-0.984 2.159-1.5zM19.975 12.537c-1.266 1.703-2.575 3.462-7.975 3.462s-6.709-1.759-7.975-3.462c-0.091-0.125-0.184-0.247-0.278-0.372 2.75 0.553 5.516 0.834 8.253 0.834s5.503-0.281 8.256-0.834c-0.094 0.122-0.188 0.247-0.281 0.372z" })
        );
    }
    function Lips({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LipsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lips.SVG = LipsSVG;
    return Lips;
})();
export const Lipstick = /*#__PURE__*/ (() => {
    function LipstickSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 13v-3.5c0-0.275-0.225-0.5-0.5-0.5h-0.5v-5c0-0.469-0.225-0.919-0.6-1.2l-3.6-2.7c-0.2-0.15-0.478-0.128-0.653 0.047-1.147 1.147-1.147 2.806-1.147 3.353v5.5h-0.5c-0.275 0-0.5 0.225-0.5 0.5v3.5c-0.553 0-1 0.447-1 1v9c0 0.553 0.447 1 1 1h8c0.553 0 1-0.447 1-1v-9c0-0.553-0.447-1-1-1zM10 3.5c0-0.391 0-1.478 0.578-2.316l3.222 2.416c0.125 0.094 0.2 0.244 0.2 0.4v5h-4v-5.5zM9 10h6v3h-6v-3zM15 22h-6v-7h6v7z" })
        );
    }
    function Lipstick({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LipstickSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lipstick.SVG = LipstickSVG;
    return Lipstick;
})();
export const ListHeart = /*#__PURE__*/ (() => {
        function ListHeartSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.5 13c-0.816 0-1.544 0.394-2 1-0.456-0.606-1.184-1-2-1-1.378 0-2.5 1.122-2.5 2.5 0 1.181 0.725 2.459 2.159 3.803 1.025 0.959 2.034 1.594 2.078 1.622 0.081 0.050 0.172 0.075 0.266 0.075s0.184-0.025 0.266-0.075c0.044-0.028 1.053-0.663 2.078-1.622 1.431-1.344 2.159-2.622 2.159-3.803-0.006-1.378-1.128-2.5-2.506-2.5zM17.5 19.903c-1.178-0.8-3.5-2.722-3.5-4.403 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5v0.5h1v-0.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 1.681-2.322 3.603-3.5 4.403z" }),
_('path', { d: "M3 4c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM3 5c0 0 0 0 0 0v0z" }),
_('path', { d: "M3 9c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM3 10c0 0 0 0 0 0v0z" }),
_('path', { d: "M3 14c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM3 15c0 0 0 0 0 0v0z" }),
_('path', { d: "M6 4h16v2h-16v-2z" }),
_('path', { d: "M6 9h16v2h-16v-2z" }),
_('path', { d: "M6 14h5v2h-5v-2z" })
            );
        }
        function ListHeart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ListHeartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ListHeart.SVG = ListHeartSVG;
        return ListHeart;
    })();
export const LockCheck = /*#__PURE__*/ (() => {
        function LockCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 11v-2c0-1.603 0.625-3.109 1.756-4.244s2.641-1.756 4.244-1.756c0.256 0 0.516 0.016 0.769 0.050 1.184-1.263 2.869-2.050 4.731-2.050 3.584 0 6.5 2.916 6.5 6.5 0 2.7-1.653 5.019-4 6v7.5c0 1.103-0.897 2-2 2h-12c-1.103 0-2-0.897-2-2v-8c0-1.103 0.897-2 2-2zM6 9v2h4.025c-0.65-1.009-1.025-2.212-1.025-3.5 0-0.872 0.172-1.706 0.488-2.466-1.966 0.25-3.488 1.934-3.488 3.966zM21 7.5c0-3.031-2.469-5.5-5.5-5.5s-5.5 2.469-5.5 5.5 2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5zM4 21h12v-7.019c-0.166 0.012-0.331 0.019-0.5 0.019-1.272 0-2.459-0.366-3.459-1h-8.041v8z" }),
_('path', { d: "M13 16c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM13 17c0 0 0 0 0 0v0z" }),
_('path', { d: "M10 18c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM10 17v0c0 0 0 0 0 0z" }),
_('path', { d: "M7 18c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM7 17v0c0 0 0 0 0 0z" }),
_('path', { d: "M18.5 4.794l-4 4-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706z" })
            );
        }
        function LockCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LockCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LockCheck.SVG = LockCheckSVG;
        return LockCheck;
    })();
export const LockCross = /*#__PURE__*/ (() => {
        function LockCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 11v-2c0-1.603 0.625-3.109 1.756-4.244s2.641-1.756 4.244-1.756c0.256 0 0.516 0.016 0.769 0.050 1.184-1.263 2.869-2.050 4.731-2.050 3.584 0 6.5 2.916 6.5 6.5 0 2.7-1.653 5.019-4 6v7.5c0 1.103-0.897 2-2 2h-12c-1.103 0-2-0.897-2-2v-8c0-1.103 0.897-2 2-2zM6 9v2h4.025c-0.65-1.009-1.025-2.212-1.025-3.5 0-0.872 0.172-1.706 0.488-2.466-1.966 0.25-3.488 1.934-3.488 3.966zM21 7.5c0-3.031-2.469-5.5-5.5-5.5s-5.5 2.469-5.5 5.5 2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5zM4 21h12v-7.019c-0.166 0.012-0.331 0.019-0.5 0.019-1.272 0-2.459-0.366-3.459-1h-8.041v8z" }),
_('path', { d: "M13 16c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM13 17c0 0 0 0 0 0v0z" }),
_('path', { d: "M10 18c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM10 17v0c0 0 0 0 0 0z" }),
_('path', { d: "M7 18c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM7 17v0c0 0 0 0 0 0z" }),
_('path', { d: "M13.5 10.206l-0.706-0.706 2-2-2-2 0.706-0.706 2 2 2-2 0.706 0.706-2 2 2 2-0.706 0.706-2-2z" })
            );
        }
        function LockCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LockCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LockCross.SVG = LockCrossSVG;
        return LockCross;
    })();
export const LockWarning = /*#__PURE__*/ (() => {
        function LockWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 16c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1z" }),
_('path', { d: "M10 16c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1z" }),
_('path', { d: "M13 16c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1z" }),
_('path', { d: "M21.841 9.828l-4-7.997c-0.25-0.506-0.775-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-1.291 2.584c-1.075-0.906-2.444-1.413-3.869-1.413-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244v2c-1.103 0-2 0.897-2 2v8c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2v-8c0-0.366-0.097-0.706-0.269-1h2.769c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672zM6 9c0-2.206 1.794-4 4-4 1.116 0 2.178 0.466 2.934 1.281l-1.775 3.547c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.175 0.031 0.344 0.087 0.5h-5.088v-2zM16 21h-12v-8h12v8c0.003 0 0 0 0 0zM20.5 11h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M16 9h1v1h-1v-1z" }),
_('path', { d: "M16 4h1v4h-1v-4z" })
            );
        }
        function LockWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LockWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LockWarning.SVG = LockWarningSVG;
        return LockWarning;
    })();
export const LockWireless = /*#__PURE__*/ (() => {
        function LockWirelessSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 11h-8v-3c0-1.653 1.347-3 3-3s3 1.347 3 3v1h2v-1c0-2.756-2.244-5-5-5s-5 2.244-5 5v3c-1.103 0-2 0.897-2 2v6c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-6c0-1.103-0.897-2-2-2zM8 19h-2v-3c0-0.55 0.45-1 1-1s1 0.45 1 1v3zM12 19h-3v-3c0-1.103-0.897-2-2-2s-2 0.897-2 2v3h-3v-6h10v6c0.003 0 0 0 0 0z" }),
_('path', { d: "M16.828 7.172l-0.353-0.353-0.706 0.706 0.353 0.353c1.169 1.169 1.169 3.072 0 4.244l-0.353 0.353 0.706 0.706 0.353-0.353c1.559-1.559 1.559-4.097 0-5.656z" }),
_('path', { d: "M18.95 5.050l-0.353-0.353-0.706 0.706 0.353 0.353c2.337 2.337 2.337 6.147 0 8.487l-0.353 0.353 0.706 0.706 0.353-0.353c1.322-1.322 2.050-3.081 2.050-4.95 0-1.872-0.728-3.628-2.050-4.95z" }),
_('path', { d: "M21.072 2.928l-0.353-0.353-0.706 0.706 0.353 0.353c3.509 3.509 3.509 9.219 0 12.728l-0.353 0.353 0.706 0.706 0.353-0.353c1.887-1.887 2.928-4.4 2.928-7.069s-1.041-5.184-2.928-7.072z" })
            );
        }
        function LockWireless({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LockWirelessSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LockWireless.SVG = LockWirelessSVG;
        return LockWireless;
    })();
export const Lock = /*#__PURE__*/ (() => {
        function LockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 10v-2c0-1.603-0.625-3.109-1.756-4.244s-2.641-1.756-4.244-1.756-3.109 0.625-4.244 1.756-1.756 2.641-1.756 4.244v2c-1.103 0-2 0.897-2 2v8c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2v-8c0-1.103-0.897-2-2-2zM8 8c0-2.206 1.794-4 4-4s4 1.794 4 4v2h-8v-2zM18 20h-12v-8h12v8c0.003 0 0 0 0 0z" }),
_('path', { d: "M9 15c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM9 16c0 0 0 0 0 0v0z" }),
_('path', { d: "M12 15c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 16c0 0 0 0 0 0v0z" }),
_('path', { d: "M15 15c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM15 16c0 0 0 0 0 0v0z" })
            );
        }
        function Lock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Lock.SVG = LockSVG;
        return Lock;
    })();
export const Lock2 = /*#__PURE__*/ (() => {
        function Lock2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 10v-2c0-3.309-2.691-6-6-6s-6 2.691-6 6v2c-1.103 0-2 0.897-2 2v8c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2v-8c0-1.103-0.897-2-2-2zM8 8c0-2.206 1.794-4 4-4s4 1.794 4 4v2h-8v-2zM18 20h-12v-8h12v8c0.003 0 0 0 0 0z" }),
_('path', { d: "M12 13c-1.103 0-2 0.897-2 2v3.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-3.5c0-1.103-0.897-2-2-2zM13 18h-2v-3c0-0.55 0.45-1 1-1s1 0.45 1 1v3z" })
            );
        }
        function Lock2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Lock2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Lock2.SVG = Lock2SVG;
        return Lock2;
    })();
export const Lollipop = /*#__PURE__*/ (() => {
    function LollipopSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19 7c0-1.869-0.728-3.628-2.050-4.95s-3.081-2.050-4.95-2.050c-1.869 0-3.628 0.728-4.95 2.050s-2.050 3.081-2.050 4.95 0.728 3.628 2.050 4.95c1.084 1.084 2.459 1.769 3.95 1.981v10.069h2v-10.072c1.491-0.213 2.866-0.897 3.95-1.981 1.322-1.319 2.050-3.078 2.050-4.947zM12 12c-1.931 0-3.5-1.569-3.5-3.5 0-1.916 1.547-3.478 3.456-3.5 0.016 0 0.028 0.003 0.044 0.003 1.378 0 2.497 1.122 2.497 2.497 0 1.103-0.897 1.997-1.997 1.997-0.012 0-0.025 0-0.041 0-0.528-0.012-0.987-0.3-1.244-0.725 0.228 0.141 0.497 0.225 0.784 0.225 0.828 0 1.5-0.672 1.5-1.5 0-0.403-0.159-0.784-0.447-1.069-0.284-0.281-0.659-0.434-1.056-0.431-1.103 0-1.997 0.897-1.997 2 0 1.378 1.122 2.5 2.5 2.5 0.016 0 0.034 0 0.050-0.003 1.631-0.028 2.947-1.362 2.947-2.997 0-1.912-1.544-3.472-3.447-3.497-0.016-0.003-0.034-0.003-0.050-0.003-2.481 0-4.5 2.019-4.5 4.5 0 0.284 0.025 0.559 0.078 0.831-0.369-0.694-0.578-1.488-0.578-2.328 0-2.756 2.244-5 5-5s5 2.244 5 5-2.244 5-5 5zM11.5 7.497c0-0.275 0.225-0.497 0.5-0.497 0.003 0 0.006 0 0.009 0 0.128 0 0.25 0.050 0.341 0.141 0.097 0.097 0.15 0.222 0.15 0.359 0 0.275-0.225 0.5-0.5 0.5s-0.497-0.222-0.5-0.503z" })
        );
    }
    function Lollipop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LollipopSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lollipop.SVG = LollipopSVG;
    return Lollipop;
})();
export const Loudspeaker = /*#__PURE__*/ (() => {
        function LoudspeakerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 0h-14c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM19 22h-14v-20h14v20c0 0 0 0 0 0z" }),
_('path', { d: "M12 9c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zM12 19c-2.206 0-4-1.794-4-4s1.794-4 4-4c2.206 0 4 1.794 4 4s-1.794 4-4 4z" }),
_('path', { d: "M12 13c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12 16c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M10.5 8h3c1.378 0 2.5-1.122 2.5-2.5s-1.122-2.5-2.5-2.5h-3c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5zM10.5 4h3c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5h-3c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5z" })
            );
        }
        function Loudspeaker({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LoudspeakerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Loudspeaker.SVG = LoudspeakerSVG;
        return Loudspeaker;
    })();
export const LoupMinus = /*#__PURE__*/ (() => {
        function LoupMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944v0c0 0 0 0 0 0v0c-1.619 0-3.191 0.319-4.669 0.944-1.428 0.606-2.712 1.469-3.813 2.572-1.103 1.103-1.969 2.384-2.572 3.813-0.628 1.481-0.947 3.053-0.947 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944h10c1.103 0 2-0.897 2-2v-10c0-1.619-0.319-3.191-0.944-4.672zM22 22h-10c-5.512 0-10-4.488-10-10 0-2.669 1.041-5.178 2.931-7.069s4.4-2.931 7.069-2.931c5.513 0 10 4.488 10 10v10z" }),
_('path', { d: "M12 4c-2.137 0-4.147 0.831-5.656 2.344s-2.344 3.519-2.344 5.656 0.831 4.147 2.344 5.656 3.519 2.344 5.656 2.344 4.147-0.831 5.656-2.344 2.344-3.519 2.344-5.656-0.831-4.147-2.344-5.656-3.519-2.344-5.656-2.344zM12 19c-3.859 0-7-3.141-7-7s3.141-7 7-7c3.859 0 7 3.141 7 7s-3.141 7-7 7z" }),
_('path', { d: "M8 11h8v2h-8v-2z" })
            );
        }
        function LoupMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LoupMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LoupMinus.SVG = LoupMinusSVG;
        return LoupMinus;
    })();
export const LoupPlus = /*#__PURE__*/ (() => {
        function LoupPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944v0c0 0 0 0 0 0v0c-1.619 0-3.191 0.319-4.669 0.944-1.428 0.606-2.712 1.469-3.813 2.572-1.103 1.103-1.969 2.384-2.572 3.813-0.628 1.481-0.947 3.053-0.947 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944h10c1.103 0 2-0.897 2-2v-10c0-1.619-0.319-3.191-0.944-4.672zM22 22h-10c-5.512 0-10-4.488-10-10 0-2.669 1.041-5.178 2.931-7.069s4.4-2.931 7.069-2.931c5.513 0 10 4.488 10 10v10z" }),
_('path', { d: "M12 4c-2.137 0-4.147 0.831-5.656 2.344s-2.344 3.519-2.344 5.656 0.831 4.147 2.344 5.656 3.519 2.344 5.656 2.344 4.147-0.831 5.656-2.344 2.344-3.519 2.344-5.656-0.831-4.147-2.344-5.656-3.519-2.344-5.656-2.344zM12 19c-3.859 0-7-3.141-7-7s3.141-7 7-7c3.859 0 7 3.141 7 7s-3.141 7-7 7z" }),
_('path', { d: "M13 8h-2v3h-3v2h3v3h2v-3h3v-2h-3z" })
            );
        }
        function LoupPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LoupPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LoupPlus.SVG = LoupPlusSVG;
        return LoupPlus;
    })();
export const Loupe = /*#__PURE__*/ (() => {
        function LoupeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944v0c0 0 0 0 0 0v0c-1.619 0-3.191 0.319-4.669 0.944-1.428 0.606-2.712 1.469-3.813 2.572-1.103 1.103-1.969 2.384-2.572 3.813-0.628 1.481-0.947 3.053-0.947 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944h10c1.103 0 2-0.897 2-2v-10c0-1.619-0.319-3.191-0.944-4.672zM22 22h-10c-5.512 0-10-4.488-10-10 0-2.669 1.041-5.178 2.931-7.069s4.4-2.931 7.069-2.931c5.513 0 10 4.488 10 10v10z" }),
_('path', { d: "M12 4c-2.137 0-4.147 0.831-5.656 2.344s-2.344 3.519-2.344 5.656 0.831 4.147 2.344 5.656 3.519 2.344 5.656 2.344 4.147-0.831 5.656-2.344 2.344-3.519 2.344-5.656-0.831-4.147-2.344-5.656-3.519-2.344-5.656-2.344zM12 19c-3.859 0-7-3.141-7-7s3.141-7 7-7c3.859 0 7 3.141 7 7s-3.141 7-7 7z" }),
_('path', { d: "M12 6v1c2.756 0 5 2.244 5 5h1c0-3.309-2.691-6-6-6z" })
            );
        }
        function Loupe({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LoupeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Loupe.SVG = LoupeSVG;
        return Loupe;
    })();
export const LuggageWeight = /*#__PURE__*/ (() => {
        function LuggageWeightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.5 20h-0.5v-13.172c1.163-0.413 2-1.525 2-2.828 0-1.653-1.347-3-3-3s-3 1.347-3 3c0 1.303 0.837 2.416 2 2.828v13.172h-18.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h21c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5zM19 4c0-0.372 0.1-0.719 0.278-1.016l1.222 1.222 0.706-0.706-1.222-1.222c0.297-0.178 0.644-0.278 1.016-0.278 1.103 0 2 0.897 2 2s-0.897 2-2 2-2-0.897-2-2zM22.5 22h-21c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h21c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M4 19h10c1.103 0 2-0.897 2-2v-6c0-1.103-0.897-2-2-2h-2v-1.5c0-0.275-0.225-0.5-0.5-0.5h-5c-0.275 0-0.5 0.225-0.5 0.5v1.5h-2c-1.103 0-2 0.897-2 2v6c0 1.103 0.897 2 2 2zM14 17h-10v-1h10v1c0.003 0 0 0 0 0zM7 8h4v1h-4v-1zM14 11v4h-10v-4h10z" })
            );
        }
        function LuggageWeight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LuggageWeightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        LuggageWeight.SVG = LuggageWeightSVG;
        return LuggageWeight;
    })();
export const Lungs = /*#__PURE__*/ (() => {
    function LungsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.816 10.056c-0.484-1.328-1.094-2.484-1.809-3.434-0.781-1.034-1.666-1.797-2.631-2.266-1.266-0.612-2.197-0.322-2.753 0.025-1.122 0.703-1.828 2.303-2.222 5.031-0.025 0.162-0.047 0.331-0.069 0.503l-0.331-0.331v-7.584h-2v7.584l-0.331 0.331c-0.022-0.172-0.044-0.341-0.069-0.503-0.394-2.728-1.1-4.325-2.222-5.031-0.556-0.35-1.488-0.638-2.753-0.025-0.966 0.466-1.853 1.228-2.631 2.266-0.716 0.95-1.325 2.106-1.809 3.434-0.959 2.628-1.356 5.728-1.116 8.728 0.072 0.9 0.516 1.725 1.25 2.325 0.7 0.575 1.606 0.891 2.553 0.891h1.631c1.45 0 2.816-0.497 3.844-1.397 1.066-0.934 1.653-2.191 1.653-3.541 0-1.744-0.034-3.241-0.106-4.544l1.106-1.106 1.106 1.106c-0.072 1.3-0.106 2.8-0.106 4.544 0 1.35 0.588 2.606 1.653 3.541 1.028 0.9 2.394 1.397 3.844 1.397h1.631c0.947 0 1.853-0.316 2.553-0.891 0.734-0.6 1.178-1.428 1.25-2.325 0.241-3-0.156-6.1-1.116-8.728zM5.503 20h-1.631c-0.953 0-1.747-0.603-1.809-1.375-0.219-2.719 0.138-5.519 1.003-7.884 0.837-2.291 2.056-3.919 3.434-4.584 0.534-0.259 0.741-0.128 0.819-0.081 0.259 0.162 0.903 0.841 1.303 3.622 0.097 0.681 0.175 1.441 0.234 2.303h-1.091l-2.128-3.194-0.831 0.556 1.916 2.872-2.853 0.95 0.316 0.95 2.328-0.775-1.684 3.369 0.894 0.447 2.088-4.175h1.106c0.056 1.175 0.084 2.519 0.084 4.066 0 1.619-1.569 2.934-3.497 2.934zM21.938 18.625c-0.063 0.772-0.856 1.375-1.809 1.375h-1.631c-1.928 0-3.497-1.316-3.497-2.934 0-1.547 0.028-2.891 0.084-4.066h1.106l2.084 4.172 0.894-0.447-1.684-3.369 2.328 0.775 0.316-0.95-2.853-0.95 1.916-2.872-0.831-0.556-2.128 3.197h-1.091c0.059-0.859 0.138-1.622 0.234-2.303 0.4-2.781 1.047-3.459 1.303-3.622 0.041-0.025 0.122-0.075 0.269-0.075 0.128 0 0.303 0.037 0.55 0.156 1.378 0.666 2.597 2.294 3.434 4.584 0.869 2.366 1.225 5.166 1.006 7.884z" })
        );
    }
    function Lungs({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LungsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lungs.SVG = LungsSVG;
    return Lungs;
})();
export const MachineWashCold = /*#__PURE__*/ (() => {
        function MachineWashColdSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.281 3.497l-0.725 2.775c-2.972-0.753-5.784 0.206-8.516 1.184-1.778-0.95-3.516-1.416-5.306-1.422-0.012 0-0.025 0-0.038 0-1.178 0-2.231 0.197-3.2 0.459l-0.781-2.991-1.934 0.5 4.25 16.25c0.116 0.441 0.513 0.747 0.969 0.747h12c0.456 0 0.853-0.306 0.969-0.747l4.25-16.25-1.938-0.506zM10.725 7.922c-2.225 0.772-4.378 1.369-6.606 0.934l-0.366-1.4c1.938-0.522 4.194-0.769 6.972 0.466zM17.228 19h-10.456l-2.375-9.084c0.422 0.059 0.841 0.084 1.256 0.084 2.244 0 4.406-0.775 6.516-1.528 2.766-0.991 5.391-1.928 8.134-1.234l-3.075 11.763z" }),
_('path', { d: "M12 13c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 14c0 0 0 0 0 0v0z" })
            );
        }
        function MachineWashCold({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MachineWashColdSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MachineWashCold.SVG = MachineWashColdSVG;
        return MachineWashCold;
    })();
export const MachineWashHot = /*#__PURE__*/ (() => {
        function MachineWashHotSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.281 3.497l-0.725 2.775c-2.972-0.753-5.784 0.206-8.516 1.184-1.778-0.95-3.516-1.416-5.306-1.422-0.012 0-0.025 0-0.038 0-1.178 0-2.231 0.197-3.2 0.459l-0.781-2.991-1.934 0.5 4.25 16.25c0.116 0.441 0.513 0.747 0.969 0.747h12c0.456 0 0.853-0.306 0.969-0.747l4.25-16.25-1.938-0.506zM10.725 7.922c-2.225 0.772-4.378 1.369-6.606 0.934l-0.366-1.4c1.938-0.522 4.194-0.769 6.972 0.466zM17.228 19h-10.456l-2.375-9.084c0.422 0.059 0.841 0.084 1.256 0.084 2.244 0 4.406-0.775 6.516-1.528 2.766-0.991 5.391-1.928 8.134-1.234l-3.075 11.763z" }),
_('path', { d: "M12 13c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 14c0 0 0 0 0 0v0z" }),
_('path', { d: "M15 13c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM15 14c0 0 0 0 0 0v0z" }),
_('path', { d: "M9 13c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM9 14c0 0 0 0 0 0v0z" })
            );
        }
        function MachineWashHot({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MachineWashHotSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MachineWashHot.SVG = MachineWashHotSVG;
        return MachineWashHot;
    })();
export const MachineWashWarm = /*#__PURE__*/ (() => {
        function MachineWashWarmSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.281 3.497l-0.725 2.775c-2.972-0.753-5.784 0.206-8.516 1.184-1.778-0.95-3.516-1.416-5.306-1.422-0.012 0-0.025 0-0.038 0-1.178 0-2.231 0.197-3.2 0.459l-0.781-2.991-1.934 0.5 4.25 16.25c0.116 0.441 0.513 0.747 0.969 0.747h12c0.456 0 0.853-0.306 0.969-0.747l4.25-16.25-1.938-0.506zM10.725 7.922c-2.225 0.772-4.378 1.369-6.606 0.934l-0.366-1.4c1.938-0.522 4.194-0.769 6.972 0.466zM17.228 19h-10.456l-2.375-9.084c0.422 0.059 0.841 0.084 1.256 0.084 2.244 0 4.406-0.775 6.516-1.528 2.766-0.991 5.391-1.928 8.134-1.234l-3.075 11.763z" }),
_('path', { d: "M10 13c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM10 14c0 0 0 0 0 0v0z" }),
_('path', { d: "M14 13c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM14 14c0 0 0 0 0 0v0z" })
            );
        }
        function MachineWashWarm({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MachineWashWarmSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MachineWashWarm.SVG = MachineWashWarmSVG;
        return MachineWashWarm;
    })();
export const MachineWash = /*#__PURE__*/ (() => {
    function MachineWashSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.281 3.497l-0.725 2.775c-2.972-0.753-5.784 0.206-8.516 1.184-1.778-0.95-3.516-1.416-5.306-1.422-0.012 0-0.025 0-0.038 0-1.178 0-2.231 0.197-3.2 0.459l-0.781-2.991-1.934 0.5 4.25 16.25c0.116 0.441 0.513 0.747 0.969 0.747h12c0.456 0 0.853-0.306 0.969-0.747l4.25-16.25-1.938-0.506zM10.725 7.922c-2.225 0.772-4.378 1.369-6.606 0.934l-0.366-1.4c1.938-0.522 4.194-0.769 6.972 0.466zM17.228 19h-10.456l-2.375-9.084c0.422 0.059 0.841 0.084 1.256 0.084 2.244 0 4.406-0.775 6.516-1.528 2.766-0.991 5.391-1.928 8.134-1.234l-3.075 11.763z" })
        );
    }
    function MachineWash({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MachineWashSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MachineWash.SVG = MachineWashSVG;
    return MachineWash;
})();
export const Mad = /*#__PURE__*/ (() => {
        function MadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M14.953 13.097c-1.003-0.738-1.969-1.097-2.953-1.097s-1.95 0.359-2.953 1.097c-0.931 0.684-1.897 1.7-2.947 3.103l-0.3 0.4 0.8 0.6 0.3-0.4c1.944-2.594 3.566-3.8 5.1-3.8s3.156 1.206 5.1 3.8l0.3 0.4 0.8-0.6-0.3-0.4c-1.053-1.403-2.016-2.419-2.947-3.103z" }),
_('path', { d: "M7.381 7.503c-0.237 0.266-0.381 0.616-0.381 0.997 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.181-0.031-0.356-0.091-0.516 0.194 0.009 0.394 0.016 0.591 0.016h0.5v-1h-0.5c-1.437 0-2.816-0.325-3.784-0.894l-0.431-0.253-0.506 0.863 0.431 0.253c0.356 0.209 0.747 0.387 1.172 0.534zM8.5 9c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M14.094 7.981c-0.059 0.162-0.094 0.337-0.094 0.519 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.387-0.147-0.741-0.387-1.006 0.413-0.147 0.794-0.322 1.141-0.525l0.431-0.253-0.506-0.862-0.431 0.253c-0.969 0.569-2.347 0.894-3.784 0.894h-0.5v1h0.5c0.213 0 0.422-0.006 0.631-0.019zM15.5 9c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" })
            );
        }
        function Mad({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Mad.SVG = MadSVG;
        return Mad;
    })();
export const MagicWand = /*#__PURE__*/ (() => {
        function MagicWandSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.997 21.459c-0.012-0.147-0.087-0.281-0.209-0.366-2.337-1.666-4.316-3.644-5.881-5.878-0.084-0.122-0.219-0.197-0.366-0.213-0.147-0.012-0.294 0.041-0.397 0.144l-0.294 0.294-10.394-10.397-1.416 1.416 10.397 10.397-0.294 0.294c-0.103 0.103-0.156 0.25-0.144 0.397s0.091 0.281 0.213 0.366c2.238 1.566 4.216 3.544 5.878 5.881 0.084 0.119 0.219 0.197 0.366 0.209 0.012 0 0.028 0.003 0.041 0.003 0.131 0 0.259-0.053 0.353-0.147l2-2c0.106-0.109 0.159-0.253 0.147-0.4zM21.559 22.734c-1.491-2-3.209-3.734-5.122-5.172l1.125-1.125c1.437 1.913 3.172 3.631 5.172 5.122l-1.175 1.175z" }),
_('path', { d: "M0.792 1.5l0.707-0.707 3.708 3.708-0.707 0.707-3.708-3.708z" }),
_('path', { d: "M6 0h1v4h-1v-4z" }),
_('path', { d: "M0 6h4v1h-4v-1z" }),
_('path', { d: "M0.792 11.5l3.708-3.708 0.707 0.707-3.708 3.708-0.707-0.707z" }),
_('path', { d: "M7.792 4.5l3.708-3.708 0.707 0.707-3.708 3.708-0.707-0.707z" }),
_('path', { d: "M6 10h1v3h-1v-3z" }),
_('path', { d: "M10 6h3v1h-3v-1z" })
            );
        }
        function MagicWand({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagicWandSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagicWand.SVG = MagicWandSVG;
        return MagicWand;
    })();
export const MagnetAngle = /*#__PURE__*/ (() => {
        function MagnetAngleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.397 16.056l1.797-2.694-0.831-0.556-4.278 6.416c-0.103 0.153-0.112 0.35-0.025 0.513s0.256 0.266 0.441 0.266h6.5v-1h-2.028c-0.128-1.147-0.691-2.2-1.575-2.944zM16.837 16.897c0.612 0.55 1.009 1.294 1.128 2.103h-2.531l1.403-2.103z" }),
_('path', { d: "M23.897 11.444c0.191-0.384 0.116-0.847-0.188-1.153l-3-3c-0.228-0.228-0.547-0.331-0.866-0.281-0.316 0.050-0.591 0.25-0.734 0.537-0.612 1.209-1.184 2.269-1.75 3.237 0 0-0.084 0.147-0.128 0.219-3.459 0.144-6.231 3.003-6.231 6.497 0 0.125 0.003 0.247 0.009 0.369-1.375 0.363-2.822-0.025-3.841-1.044-1.559-1.559-1.559-4.097 0-5.656 0.003-0.003 0.009-0.009 0.012-0.012 2.063-2.131 4.922-4.066 9.269-6.266 0.288-0.144 0.484-0.419 0.537-0.734 0.050-0.316-0.053-0.638-0.281-0.866l-3-3c-0.303-0.303-0.766-0.378-1.15-0.188-1.706 0.847-3.363 1.831-4.919 2.928-1.631 1.147-3.209 2.453-4.694 3.884-0.003 0.003-0.009 0.009-0.012 0.012-0.953 0.953-1.694 2.066-2.197 3.306-0.488 1.2-0.734 2.469-0.734 3.766s0.247 2.566 0.731 3.762c0.503 1.241 1.244 2.353 2.197 3.306 1.478 1.478 3.344 2.444 5.4 2.791 0.559 0.094 1.125 0.141 1.684 0.141 1.434 0 2.85-0.309 4.166-0.916 0.975 0.581 2.109 0.916 3.322 0.916 3.584 0 6.5-2.916 6.5-6.5 0-1.447-0.475-2.787-1.281-3.869 0.416-0.712 0.809-1.447 1.178-2.187zM20.259 9.675l1.519 1.519c-0.175 0.334-0.353 0.666-0.537 0.994-0.559-0.397-1.188-0.706-1.859-0.909 0.291-0.509 0.581-1.041 0.878-1.603zM12.806 2.222l1.519 1.519c-0.891 0.472-1.719 0.934-2.487 1.391l-1.497-1.497c0.8-0.503 1.622-0.975 2.466-1.413zM4.344 19.656c-1.512-1.509-2.344-3.519-2.344-5.656 0-2.134 0.831-4.141 2.337-5.65 1.638-1.578 3.341-2.956 5.144-4.162l1.478 1.478c-2.156 1.35-3.834 2.675-5.209 4.097-2.334 2.341-2.331 6.144 0.006 8.481 0.809 0.809 1.825 1.369 2.941 1.616 0.906 0.2 1.841 0.191 2.734-0.031 0.25 0.653 0.603 1.253 1.038 1.784-2.825 0.912-5.988 0.178-8.125-1.956zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" })
            );
        }
        function MagnetAngle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnetAngleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagnetAngle.SVG = MagnetAngleSVG;
        return MagnetAngle;
    })();
export const MagnetCross = /*#__PURE__*/ (() => {
        function MagnetCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.5 14.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" }),
_('path', { d: "M23.897 11.444c0.191-0.384 0.116-0.847-0.188-1.153l-3-3c-0.228-0.228-0.547-0.331-0.866-0.281-0.316 0.050-0.591 0.25-0.734 0.537-0.612 1.209-1.184 2.269-1.75 3.237 0 0-0.084 0.147-0.128 0.219-3.459 0.144-6.231 3.003-6.231 6.497 0 0.125 0.003 0.247 0.009 0.369-1.375 0.363-2.822-0.025-3.841-1.044-1.559-1.559-1.559-4.097 0-5.656 0.003-0.003 0.009-0.009 0.012-0.012 2.063-2.131 4.922-4.066 9.269-6.266 0.288-0.144 0.484-0.419 0.537-0.734 0.050-0.316-0.053-0.638-0.281-0.866l-3-3c-0.303-0.303-0.766-0.378-1.15-0.188-1.706 0.847-3.363 1.831-4.919 2.928-1.631 1.147-3.209 2.453-4.694 3.884-0.003 0.003-0.009 0.009-0.012 0.012-0.953 0.953-1.694 2.066-2.197 3.306-0.488 1.2-0.734 2.469-0.734 3.766s0.247 2.566 0.731 3.762c0.503 1.241 1.244 2.353 2.197 3.306 1.478 1.478 3.344 2.444 5.4 2.791 0.559 0.094 1.125 0.141 1.684 0.141 1.434 0 2.85-0.309 4.166-0.916 0.975 0.581 2.109 0.916 3.322 0.916 3.584 0 6.5-2.916 6.5-6.5 0-1.447-0.475-2.787-1.281-3.869 0.416-0.712 0.809-1.447 1.178-2.187zM20.259 9.675l1.519 1.519c-0.175 0.334-0.353 0.666-0.537 0.994-0.559-0.397-1.188-0.706-1.859-0.909 0.291-0.509 0.581-1.041 0.878-1.603zM12.806 2.222l1.519 1.519c-0.891 0.472-1.719 0.934-2.487 1.391l-1.497-1.497c0.8-0.503 1.622-0.975 2.466-1.413zM4.344 19.656c-1.512-1.509-2.344-3.519-2.344-5.656 0-2.134 0.831-4.141 2.337-5.65 1.638-1.578 3.341-2.956 5.144-4.162l1.478 1.478c-2.156 1.35-3.834 2.675-5.209 4.097-2.334 2.341-2.331 6.144 0.006 8.481 0.809 0.809 1.825 1.369 2.941 1.616 0.906 0.2 1.841 0.191 2.734-0.031 0.25 0.653 0.603 1.253 1.038 1.784-2.825 0.912-5.988 0.178-8.125-1.956zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" })
            );
        }
        function MagnetCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnetCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagnetCross.SVG = MagnetCrossSVG;
        return MagnetCross;
    })();
export const MagnetGrid = /*#__PURE__*/ (() => {
        function MagnetGridSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.897 11.444c0.191-0.384 0.116-0.847-0.188-1.153l-3-3c-0.228-0.228-0.547-0.331-0.866-0.281-0.316 0.050-0.591 0.25-0.734 0.537-0.612 1.209-1.184 2.269-1.75 3.237 0 0-0.084 0.147-0.128 0.219-3.459 0.144-6.231 3.003-6.231 6.497 0 0.125 0.003 0.247 0.009 0.369-1.375 0.363-2.822-0.025-3.841-1.044-1.559-1.559-1.559-4.097 0-5.656 0.003-0.003 0.009-0.009 0.012-0.012 2.063-2.131 4.922-4.066 9.269-6.266 0.288-0.144 0.484-0.419 0.537-0.734 0.050-0.316-0.053-0.638-0.281-0.866l-3-3c-0.303-0.303-0.766-0.378-1.15-0.188-1.706 0.847-3.363 1.831-4.919 2.928-1.631 1.147-3.209 2.453-4.694 3.884-0.003 0.003-0.009 0.009-0.012 0.012-0.953 0.953-1.694 2.066-2.197 3.306-0.488 1.2-0.734 2.469-0.734 3.766s0.247 2.566 0.731 3.762c0.503 1.241 1.244 2.353 2.197 3.306 1.478 1.478 3.344 2.444 5.4 2.791 0.559 0.094 1.125 0.141 1.684 0.141 1.434 0 2.85-0.309 4.166-0.916 0.975 0.581 2.109 0.916 3.322 0.916 3.584 0 6.5-2.916 6.5-6.5 0-1.447-0.475-2.787-1.281-3.869 0.416-0.712 0.809-1.447 1.178-2.187zM20.259 9.675l1.519 1.519c-0.175 0.334-0.353 0.666-0.537 0.994-0.559-0.397-1.188-0.706-1.859-0.909 0.291-0.509 0.581-1.041 0.878-1.603zM12.806 2.222l1.519 1.519c-0.891 0.472-1.719 0.934-2.487 1.391l-1.497-1.497c0.8-0.503 1.622-0.975 2.466-1.413zM4.344 19.656c-1.512-1.509-2.344-3.519-2.344-5.656 0-2.134 0.831-4.141 2.337-5.65 1.638-1.578 3.341-2.956 5.144-4.162l1.478 1.478c-2.156 1.35-3.834 2.675-5.209 4.097-2.334 2.341-2.331 6.144 0.006 8.481 0.809 0.809 1.825 1.369 2.941 1.616 0.906 0.2 1.841 0.191 2.734-0.031 0.25 0.653 0.603 1.253 1.038 1.784-2.825 0.912-5.988 0.178-8.125-1.956zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M21 14.5c0-0.275-0.225-0.5-0.5-0.5h-2.5v-1h-1v1h-2.5c-0.275 0-0.5 0.225-0.5 0.5v2.5h-1v1h1v2.5c0 0.275 0.225 0.5 0.5 0.5h2.5v1h1v-1h2.5c0.275 0 0.5-0.225 0.5-0.5v-2.5h1v-1h-1v-2.5zM20 15v2h-2v-2h2zM15 15h2v2h-2v-2zM15 20v-2h2v2h-2zM20 20h-2v-2h2v2z" })
            );
        }
        function MagnetGrid({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnetGridSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagnetGrid.SVG = MagnetGridSVG;
        return MagnetGrid;
    })();
export const MagnetPoint = /*#__PURE__*/ (() => {
        function MagnetPointSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.897 11.444c0.191-0.384 0.116-0.847-0.188-1.153l-3-3c-0.228-0.228-0.547-0.331-0.866-0.281-0.316 0.050-0.591 0.25-0.734 0.537-0.612 1.209-1.184 2.269-1.75 3.237 0 0-0.084 0.147-0.128 0.219-3.459 0.144-6.231 3.003-6.231 6.497 0 0.125 0.003 0.247 0.009 0.369-1.375 0.363-2.822-0.025-3.841-1.044-1.559-1.559-1.559-4.097 0-5.656 0.003-0.003 0.009-0.009 0.012-0.012 2.063-2.131 4.922-4.066 9.269-6.266 0.288-0.144 0.484-0.419 0.537-0.734 0.050-0.316-0.053-0.638-0.281-0.866l-3-3c-0.303-0.303-0.766-0.378-1.15-0.188-1.706 0.847-3.363 1.831-4.919 2.928-1.631 1.147-3.209 2.453-4.694 3.884-0.003 0.003-0.009 0.009-0.012 0.012-0.953 0.953-1.694 2.066-2.197 3.306-0.488 1.2-0.734 2.469-0.734 3.766s0.247 2.566 0.731 3.762c0.503 1.241 1.244 2.353 2.197 3.306 1.478 1.478 3.344 2.444 5.4 2.791 0.559 0.094 1.125 0.141 1.684 0.141 1.434 0 2.85-0.309 4.166-0.916 0.975 0.581 2.109 0.916 3.322 0.916 3.584 0 6.5-2.916 6.5-6.5 0-1.447-0.475-2.787-1.281-3.869 0.416-0.712 0.809-1.447 1.178-2.187zM20.259 9.675l1.519 1.519c-0.175 0.334-0.353 0.666-0.537 0.994-0.559-0.397-1.188-0.706-1.859-0.909 0.291-0.509 0.581-1.041 0.878-1.603zM12.806 2.222l1.519 1.519c-0.891 0.472-1.719 0.934-2.487 1.391l-1.497-1.497c0.8-0.503 1.622-0.975 2.466-1.413zM4.344 19.656c-1.512-1.509-2.344-3.519-2.344-5.656 0-2.134 0.831-4.141 2.337-5.65 1.638-1.578 3.341-2.956 5.144-4.162l1.478 1.478c-2.156 1.35-3.834 2.675-5.209 4.097-2.334 2.341-2.331 6.144 0.006 8.481 0.809 0.809 1.825 1.369 2.941 1.616 0.906 0.2 1.841 0.191 2.734-0.031 0.25 0.653 0.603 1.253 1.038 1.784-2.825 0.912-5.988 0.178-8.125-1.956zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18 16.084v-3.084h-1v3.084c-0.425 0.15-0.762 0.487-0.916 0.916h-3.084v1h3.084c0.15 0.425 0.488 0.762 0.916 0.916v3.084h1v-3.084c0.425-0.15 0.762-0.487 0.916-0.916h3.084v-1h-3.084c-0.153-0.425-0.491-0.762-0.916-0.916zM17.5 18c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" })
            );
        }
        function MagnetPoint({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnetPointSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagnetPoint.SVG = MagnetPointSVG;
        return MagnetPoint;
    })();
export const MagnetScale = /*#__PURE__*/ (() => {
        function MagnetScaleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.519 14h-6c-0.275 0-0.5 0.225-0.5 0.5v6c0 0.275 0.225 0.5 0.5 0.5h6c0.275 0 0.5-0.225 0.5-0.5v-6c0-0.275-0.225-0.5-0.5-0.5zM15.019 15h5v2h-2.5c-0.275 0-0.5 0.225-0.5 0.5v2.5h-2v-5zM20.019 20h-2v-2h2v2z" }),
_('path', { d: "M23.897 11.444c0.191-0.384 0.116-0.847-0.188-1.153l-3-3c-0.228-0.228-0.547-0.331-0.866-0.281-0.316 0.050-0.591 0.25-0.734 0.537-0.612 1.209-1.184 2.269-1.75 3.237 0 0-0.084 0.147-0.128 0.219-3.459 0.144-6.231 3.003-6.231 6.497 0 0.125 0.003 0.247 0.009 0.369-1.375 0.363-2.822-0.025-3.841-1.044-1.559-1.559-1.559-4.097 0-5.656 0.003-0.003 0.009-0.009 0.012-0.012 2.063-2.131 4.922-4.066 9.269-6.266 0.288-0.144 0.484-0.419 0.537-0.734 0.050-0.316-0.053-0.638-0.281-0.866l-3-3c-0.303-0.303-0.766-0.378-1.15-0.188-1.706 0.847-3.363 1.831-4.919 2.928-1.631 1.147-3.209 2.453-4.694 3.884-0.003 0.003-0.009 0.009-0.012 0.012-0.953 0.953-1.694 2.066-2.197 3.306-0.488 1.2-0.734 2.469-0.734 3.766s0.247 2.566 0.731 3.762c0.503 1.241 1.244 2.353 2.197 3.306 1.478 1.478 3.344 2.444 5.4 2.791 0.559 0.094 1.125 0.141 1.684 0.141 1.434 0 2.85-0.309 4.166-0.916 0.975 0.581 2.109 0.916 3.322 0.916 3.584 0 6.5-2.916 6.5-6.5 0-1.447-0.475-2.787-1.281-3.869 0.416-0.712 0.809-1.447 1.178-2.187zM20.259 9.675l1.519 1.519c-0.175 0.334-0.353 0.666-0.537 0.994-0.559-0.397-1.188-0.706-1.859-0.909 0.291-0.509 0.581-1.041 0.878-1.603zM12.806 2.222l1.519 1.519c-0.891 0.472-1.719 0.934-2.487 1.391l-1.497-1.497c0.8-0.503 1.622-0.975 2.466-1.413zM4.344 19.656c-1.512-1.509-2.344-3.519-2.344-5.656 0-2.134 0.831-4.141 2.337-5.65 1.638-1.578 3.341-2.956 5.144-4.162l1.478 1.478c-2.156 1.35-3.834 2.675-5.209 4.097-2.334 2.341-2.331 6.144 0.006 8.481 0.809 0.809 1.825 1.369 2.941 1.616 0.906 0.2 1.841 0.191 2.734-0.031 0.25 0.653 0.603 1.253 1.038 1.784-2.825 0.912-5.988 0.178-8.125-1.956zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" })
            );
        }
        function MagnetScale({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnetScaleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagnetScale.SVG = MagnetScaleSVG;
        return MagnetScale;
    })();
export const Magnet = /*#__PURE__*/ (() => {
    function MagnetSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.706 10.294l-3-3c-0.228-0.228-0.547-0.331-0.866-0.281-0.316 0.050-0.591 0.25-0.734 0.534-2.203 4.353-4.137 7.212-6.266 9.269-0.003 0.003-0.009 0.009-0.012 0.012-0.756 0.756-1.759 1.172-2.828 1.172s-2.072-0.416-2.828-1.172c-0.756-0.756-1.172-1.759-1.172-2.828s0.416-2.072 1.172-2.828c0.003-0.003 0.009-0.009 0.012-0.012 2.056-2.131 4.912-4.062 9.269-6.266 0.288-0.144 0.484-0.419 0.534-0.734s-0.053-0.638-0.281-0.866l-3-3c-0.303-0.303-0.766-0.378-1.153-0.188-1.703 0.844-3.356 1.828-4.916 2.925-1.631 1.147-3.209 2.453-4.694 3.884-0.003 0.003-0.009 0.009-0.012 0.012-1.891 1.891-2.931 4.4-2.931 7.072s1.041 5.181 2.928 7.072c1.891 1.887 4.4 2.928 7.072 2.928s5.181-1.041 7.072-2.928c0.003-0.003 0.009-0.009 0.012-0.012 1.431-1.484 2.738-3.066 3.884-4.694 1.097-1.559 2.081-3.213 2.928-4.919 0.191-0.387 0.113-0.85-0.191-1.153zM12.806 2.222l1.519 1.519c-0.891 0.472-1.719 0.934-2.487 1.391l-1.5-1.5c0.803-0.5 1.625-0.972 2.469-1.409zM15.65 19.662c-1.509 1.506-3.516 2.337-5.65 2.337-2.137 0-4.147-0.831-5.656-2.344-3.116-3.116-3.119-8.187-0.006-11.306 1.638-1.578 3.341-2.956 5.144-4.162l1.478 1.478c-2.159 1.353-3.837 2.678-5.209 4.097-1.128 1.131-1.75 2.637-1.75 4.238 0 1.603 0.625 3.109 1.756 4.244 1.134 1.131 2.641 1.756 4.244 1.756 1.6 0 3.103-0.622 4.238-1.75 1.419-1.372 2.747-3.050 4.097-5.209l1.478 1.478c-1.206 1.803-2.584 3.506-4.163 5.144zM20.369 13.659l-1.497-1.497c0.456-0.769 0.919-1.597 1.391-2.487l1.519 1.519c-0.441 0.844-0.912 1.666-1.413 2.466z" })
        );
    }
    function Magnet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MagnetSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Magnet.SVG = MagnetSVG;
    return Magnet;
})();
export const MagnifierBug = /*#__PURE__*/ (() => {
        function MagnifierBugSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.803 2.197c-1.416-1.416-3.3-2.197-5.303-2.197s-3.888 0.781-5.303 2.197c-1.416 1.416-2.197 3.3-2.197 5.303 0 1.666 0.541 3.25 1.538 4.55l-1.122 1.122c-0.897-0.35-1.959-0.166-2.681 0.556l-6.006 6.003c-0.972 0.975-0.972 2.562 0.003 3.537 0.488 0.484 1.128 0.728 1.769 0.728s1.281-0.244 1.766-0.731c0 0 0 0 0 0l6.003-6.003c0.719-0.722 0.906-1.781 0.556-2.675l1.125-1.125c1.3 0.997 2.884 1.537 4.55 1.537 2.003 0 3.888-0.781 5.303-2.197s2.197-3.3 2.197-5.303-0.781-3.888-2.197-5.303zM8.853 15.853l-6 6c-0.194 0.194-0.513 0.194-0.706 0s-0.194-0.513 0-0.706l6-6c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.194 0.194 0.194 0.509 0 0.706zM16.5 13c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.853 7.147c-0.094-0.094-0.222-0.147-0.353-0.147h-0.531c-0.034-0.241-0.097-0.428-0.181-0.584l0.938-0.469c0.169-0.084 0.275-0.259 0.275-0.447v-1.5h-1v1.191l-0.978 0.487c-0.006-0.006-0.016-0.012-0.022-0.016v-0.162c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5v0.162c-0.006 0.006-0.016 0.012-0.022 0.016l-0.978-0.487v-1.191h-1v1.5c0 0.191 0.106 0.363 0.275 0.447l0.938 0.469c-0.084 0.156-0.147 0.344-0.181 0.584h-0.531c-0.131 0-0.259 0.053-0.353 0.147l-1.353 1.353 0.706 0.706 1.206-1.206h0.319c0.056 0.566 0.209 1.1 0.444 1.559l-0.575 2.306 0.969 0.244 0.391-1.559c0.372 0.294 0.797 0.45 1.247 0.45s0.875-0.156 1.247-0.453l0.391 1.559 0.969-0.244-0.575-2.303c0.237-0.459 0.387-0.994 0.444-1.559h0.319l1.206 1.206 0.706-0.706-1.353-1.353zM16.5 10c-0.363 0-0.697-0.225-0.959-0.597l0.009-0.031-0.037-0.009c-0.312-0.462-0.513-1.131-0.513-1.863 0-0.344 0.025-0.509 0.109-0.634l0.016 0.006 0.034-0.072c0.063-0.066 0.147-0.128 0.262-0.209 0.119-0.084 0.253-0.181 0.406-0.312 0.109-0.094 0.172-0.231 0.172-0.378v-0.4c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v0.4c0 0.144 0.063 0.281 0.172 0.378 0.15 0.131 0.284 0.228 0.406 0.312 0.112 0.081 0.2 0.141 0.262 0.209l0.034 0.072 0.016-0.006c0.084 0.125 0.109 0.294 0.109 0.634 0 0.731-0.2 1.4-0.513 1.863l-0.038 0.009 0.009 0.031c-0.263 0.372-0.597 0.597-0.959 0.597z" })
            );
        }
        function MagnifierBug({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnifierBugSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagnifierBug.SVG = MagnifierBugSVG;
        return MagnifierBug;
    })();
export const MagnifierCheck = /*#__PURE__*/ (() => {
        function MagnifierCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.803 2.197c-1.416-1.416-3.3-2.197-5.303-2.197s-3.888 0.781-5.303 2.197c-1.416 1.416-2.197 3.3-2.197 5.303 0 1.666 0.541 3.25 1.538 4.55l-1.122 1.122c-0.897-0.35-1.959-0.166-2.681 0.556l-6.006 6.003c-0.972 0.975-0.972 2.562 0.003 3.537 0.488 0.484 1.128 0.728 1.769 0.728s1.281-0.244 1.766-0.731c0 0 0 0 0 0l6.003-6.003c0.719-0.722 0.906-1.781 0.556-2.675l1.125-1.125c1.3 0.997 2.884 1.537 4.55 1.537 2.003 0 3.888-0.781 5.303-2.197s2.197-3.3 2.197-5.303-0.781-3.888-2.197-5.303zM8.853 15.853l-6 6c-0.194 0.194-0.513 0.194-0.706 0s-0.194-0.513 0-0.706l6-6c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.194 0.194 0.194 0.509 0 0.706zM16.5 13c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M15.5 8.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4z" })
            );
        }
        function MagnifierCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnifierCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagnifierCheck.SVG = MagnifierCheckSVG;
        return MagnifierCheck;
    })();
export const MagnifierDollar = /*#__PURE__*/ (() => {
        function MagnifierDollarSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.803 2.197c-1.416-1.416-3.3-2.197-5.303-2.197s-3.888 0.781-5.303 2.197c-1.416 1.416-2.197 3.3-2.197 5.303 0 1.666 0.541 3.25 1.538 4.55l-1.122 1.122c-0.897-0.35-1.959-0.166-2.681 0.556l-6.006 6.003c-0.972 0.975-0.972 2.562 0.003 3.537 0.488 0.484 1.128 0.728 1.769 0.728s1.281-0.244 1.766-0.731l6.003-6.003c0.719-0.722 0.906-1.781 0.556-2.675l1.125-1.125c1.3 0.997 2.884 1.537 4.55 1.537 2.003 0 3.888-0.781 5.303-2.197s2.197-3.3 2.197-5.303-0.781-3.888-2.197-5.303zM8.853 15.853l-6 6c-0.194 0.194-0.513 0.194-0.706 0s-0.194-0.513 0-0.706l6-6c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.194 0.194 0.194 0.509 0 0.706zM16.5 13c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17 3h-1v2h-0.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h2c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-3.5v1h2v2h1v-2h0.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-2c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3.5v-1h-2v-2z" })
            );
        }
        function MagnifierDollar({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnifierDollarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagnifierDollar.SVG = MagnifierDollarSVG;
        return MagnifierDollar;
    })();
export const MagnifierEuro = /*#__PURE__*/ (() => {
        function MagnifierEuroSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.803 2.197c-1.416-1.416-3.3-2.197-5.303-2.197s-3.888 0.781-5.303 2.197c-1.416 1.416-2.197 3.3-2.197 5.303 0 1.666 0.541 3.25 1.538 4.55l-1.122 1.122c-0.897-0.35-1.959-0.166-2.681 0.556l-6.006 6.003c-0.972 0.975-0.972 2.562 0.003 3.537 0.488 0.484 1.128 0.728 1.769 0.728s1.281-0.244 1.766-0.731l6.003-6.003c0.719-0.722 0.906-1.781 0.556-2.675l1.125-1.125c1.3 0.997 2.884 1.537 4.55 1.537 2.003 0 3.888-0.781 5.303-2.197s2.197-3.3 2.197-5.303-0.781-3.888-2.197-5.303zM8.853 15.853l-6 6c-0.194 0.194-0.513 0.194-0.706 0s-0.194-0.513 0-0.706l6-6c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.194 0.194 0.194 0.509 0 0.706zM16.5 13c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17.5 5c1.081 0 1.544 0.713 1.572 0.756l0.25 0.428 0.862-0.506-0.253-0.431c-0.031-0.050-0.75-1.247-2.431-1.247-1.512 0-2.688 0.775-3.209 2h-1.291v1h1.028c-0.019 0.162-0.028 0.328-0.028 0.5s0.009 0.337 0.028 0.5h-1.028v1h1.291c0.519 1.225 1.697 2 3.209 2 1.684 0 2.403-1.197 2.431-1.247l0.253-0.431-0.862-0.506-0.253 0.431c-0.003 0.006-0.469 0.753-1.569 0.753-0.928 0-1.656-0.369-2.081-1h2.581v-1h-2.962c-0.025-0.159-0.038-0.325-0.038-0.5s0.012-0.341 0.038-0.5h2.962v-1h-2.581c0.425-0.631 1.153-1 2.081-1z" })
            );
        }
        function MagnifierEuro({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnifierEuroSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagnifierEuro.SVG = MagnifierEuroSVG;
        return MagnifierEuro;
    })();
export const MagnifierMarquee = /*#__PURE__*/ (() => {
        function MagnifierMarqueeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 7.5c0-2.003-0.781-3.888-2.197-5.303s-3.3-2.197-5.303-2.197-3.888 0.781-5.303 2.197c-0.253 0.253-0.488 0.522-0.7 0.803h-2.497v1h1.863c-0.563 1.066-0.863 2.259-0.863 3.5 0 1.666 0.541 3.25 1.537 4.55l-1.122 1.122c-0.897-0.35-1.959-0.166-2.681 0.556l-2.734 2.731v-2.459h-1v3.459l-2.272 2.272c-0.972 0.975-0.972 2.562 0.003 3.537 0.487 0.484 1.128 0.728 1.769 0.728s1.281-0.244 1.766-0.731l2.266-2.266h3.469v-1h-2.466l2.734-2.734c0.719-0.722 0.906-1.781 0.556-2.675l1.125-1.125c1.3 0.994 2.884 1.534 4.55 1.534 1.241 0 2.434-0.3 3.5-0.862v1.863h1v-2.497c0.281-0.213 0.55-0.444 0.803-0.7 1.416-1.416 2.197-3.3 2.197-5.303zM8.853 15.853l-6 6c-0.194 0.194-0.513 0.194-0.706 0s-0.194-0.513 0-0.706l6-6c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.194 0.194 0.194 0.509 0 0.706zM11 7.5c0-3.031 2.469-5.5 5.5-5.5s5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5z" }),
_('path', { d: "M4 4h2v-1h-2.5c-0.275 0-0.5 0.225-0.5 0.5v3.5h1v-3z" }),
_('path', { d: "M3 9h1v3h-1v-3z" }),
_('path', { d: "M20 20h-3v1h3.5c0.275 0 0.5-0.225 0.5-0.5v-2.5h-1v2z" }),
_('path', { d: "M12 20h3v1h-3v-1z" }),
_('path', { d: "M21 7h-1v0.5c0 1.931-1.569 3.5-3.5 3.5h-0.5v1h0.5c2.481 0 4.5-2.019 4.5-4.5v-0.5z" })
            );
        }
        function MagnifierMarquee({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnifierMarqueeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagnifierMarquee.SVG = MagnifierMarqueeSVG;
        return MagnifierMarquee;
    })();
export const MagnifierMove = /*#__PURE__*/ (() => {
        function MagnifierMoveSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.803 2.197c-1.416-1.416-3.3-2.197-5.303-2.197s-3.888 0.781-5.303 2.197c-1.416 1.416-2.197 3.3-2.197 5.303 0 1.666 0.541 3.25 1.538 4.55l-1.122 1.122c-0.897-0.35-1.959-0.166-2.681 0.556l-6.006 6.003c-0.972 0.975-0.972 2.562 0.003 3.537 0.488 0.484 1.128 0.728 1.769 0.728s1.281-0.244 1.766-0.731l6.003-6.003c0.719-0.722 0.906-1.781 0.556-2.675l1.125-1.125c1.3 0.997 2.884 1.537 4.55 1.537 2.003 0 3.888-0.781 5.303-2.197s2.197-3.3 2.197-5.303-0.781-3.888-2.197-5.303zM8.853 15.853l-6 6c-0.194 0.194-0.513 0.194-0.706 0s-0.194-0.513 0-0.706l6-6c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.194 0.194 0.194 0.509 0 0.706zM16.5 13c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M20.853 7.147l-1.353-1.353-0.706 0.706 0.5 0.5h-2.294v-2.294l0.5 0.5 0.706-0.706-1.353-1.353c-0.194-0.194-0.513-0.194-0.706 0l-1.353 1.353 0.706 0.706 0.5-0.5v2.294h-2.294l0.5-0.5-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706-0.5-0.5h2.294v2.294l-0.5-0.5-0.706 0.706 1.353 1.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l1.353-1.353-0.706-0.706-0.5 0.5v-2.294h2.294l-0.5 0.5 0.706 0.706 1.353-1.353c0.197-0.194 0.197-0.513 0-0.706z" })
            );
        }
        function MagnifierMove({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnifierMoveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagnifierMove.SVG = MagnifierMoveSVG;
        return MagnifierMove;
    })();
export const MagnifierNext = /*#__PURE__*/ (() => {
        function MagnifierNextSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.803 2.197c-1.416-1.416-3.3-2.197-5.303-2.197s-3.888 0.781-5.303 2.197c-1.416 1.416-2.197 3.3-2.197 5.303 0 1.666 0.541 3.25 1.538 4.55l-1.122 1.122c-0.897-0.35-1.959-0.166-2.681 0.556l-6.006 6.003c-0.972 0.975-0.972 2.562 0.003 3.537 0.488 0.484 1.128 0.728 1.769 0.728s1.281-0.244 1.766-0.731c0 0 0 0 0 0l6.003-6.003c0.719-0.722 0.906-1.781 0.556-2.675l1.125-1.125c1.3 0.997 2.884 1.537 4.55 1.537 2.003 0 3.888-0.781 5.303-2.197s2.197-3.3 2.197-5.303-0.781-3.888-2.197-5.303zM8.853 15.853l-6 6c-0.194 0.194-0.513 0.194-0.706 0s-0.194-0.513 0-0.706l6-6c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.194 0.194 0.194 0.509 0 0.706zM16.5 13c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17.5 4.794l-0.706 0.706 1.5 1.5h-5.294v1h5.294l-1.5 1.5 0.706 0.706 2.353-2.353c0.194-0.194 0.194-0.513 0-0.706l-2.353-2.353z" })
            );
        }
        function MagnifierNext({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnifierNextSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagnifierNext.SVG = MagnifierNextSVG;
        return MagnifierNext;
    })();
export const MagnifierPound = /*#__PURE__*/ (() => {
        function MagnifierPoundSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.803 2.197c-1.416-1.416-3.3-2.197-5.303-2.197s-3.888 0.781-5.303 2.197c-1.416 1.416-2.197 3.3-2.197 5.303 0 1.666 0.541 3.25 1.538 4.55l-1.125 1.125c-0.897-0.35-1.959-0.166-2.681 0.556l-6.003 6c-0.972 0.975-0.972 2.562 0.003 3.537 0.488 0.484 1.128 0.728 1.769 0.728s1.281-0.244 1.766-0.731l6.003-6.003c0.719-0.722 0.906-1.781 0.556-2.675l1.125-1.125c1.3 0.997 2.884 1.537 4.55 1.537 2.003 0 3.888-0.781 5.303-2.197s2.197-3.3 2.197-5.303-0.781-3.888-2.197-5.303zM8.853 15.853l-6 6c-0.194 0.194-0.513 0.194-0.706 0s-0.194-0.513 0-0.706l6-6c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.194 0.194 0.194 0.509 0 0.706zM16.5 13c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M15.497 5.356c-0.247 0.494-0.35 1.062-0.406 1.644h-1.091v1h1.025c-0.091 1.544-0.253 2-1.025 2v1h5v-1h-3.328c0.019-0.037 0.034-0.075 0.050-0.113 0.222-0.537 0.266-1.194 0.303-1.887h1.975v-1h-1.9c0.134-1.259 0.487-2 1.9-2h1v-1h-1c-1.212 0-2.053 0.456-2.503 1.356z" })
            );
        }
        function MagnifierPound({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnifierPoundSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagnifierPound.SVG = MagnifierPoundSVG;
        return MagnifierPound;
    })();
export const MagnifierPrev = /*#__PURE__*/ (() => {
        function MagnifierPrevSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.803 2.197c-1.416-1.416-3.3-2.197-5.303-2.197s-3.888 0.781-5.303 2.197c-1.416 1.416-2.197 3.3-2.197 5.303 0 1.666 0.541 3.25 1.538 4.55l-1.122 1.122c-0.897-0.35-1.959-0.166-2.681 0.556l-6.006 6.003c-0.972 0.975-0.972 2.562 0.003 3.537 0.488 0.484 1.128 0.728 1.769 0.728s1.281-0.244 1.766-0.731c0 0 0 0 0 0l6.003-6.003c0.719-0.722 0.906-1.781 0.556-2.675l1.125-1.125c1.3 0.997 2.884 1.537 4.55 1.537 2.003 0 3.888-0.781 5.303-2.197s2.197-3.3 2.197-5.303-0.781-3.888-2.197-5.303zM8.853 15.853l-6 6c-0.194 0.194-0.513 0.194-0.706 0s-0.194-0.513 0-0.706l6-6c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.194 0.194 0.194 0.509 0 0.706zM16.5 13c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16.206 5.5l-0.706-0.706-2.353 2.353c-0.194 0.194-0.194 0.513 0 0.706l2.353 2.353 0.706-0.706-1.5-1.5h5.294v-1h-5.294l1.5-1.5z" })
            );
        }
        function MagnifierPrev({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnifierPrevSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagnifierPrev.SVG = MagnifierPrevSVG;
        return MagnifierPrev;
    })();
export const MagnifierQuestion = /*#__PURE__*/ (() => {
        function MagnifierQuestionSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.803 2.197c-1.416-1.416-3.3-2.197-5.303-2.197s-3.888 0.781-5.303 2.197c-1.416 1.416-2.197 3.3-2.197 5.303 0 1.666 0.541 3.25 1.538 4.55l-1.122 1.122c-0.897-0.35-1.959-0.166-2.681 0.556l-6.006 6.003c-0.972 0.975-0.972 2.562 0.003 3.537 0.488 0.484 1.128 0.728 1.769 0.728s1.281-0.244 1.766-0.731l6.003-6.003c0.719-0.722 0.906-1.781 0.556-2.675l1.125-1.125c1.3 0.997 2.884 1.537 4.55 1.537 2.003 0 3.888-0.781 5.303-2.197s2.197-3.3 2.197-5.303-0.781-3.888-2.197-5.303zM8.853 15.853l-6 6c-0.194 0.194-0.513 0.194-0.706 0s-0.194-0.513 0-0.706l6-6c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.194 0.194 0.194 0.509 0 0.706zM16.5 13c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16 11h1v1h-1v-1z" }),
_('path', { d: "M16.503 4.003c-1.206 0-2.503 0.781-2.503 2.497v0.5h1v-0.5c0-1.103 0.809-1.497 1.503-1.497 0.4 0 0.788 0.125 1.062 0.344 0.288 0.228 0.434 0.531 0.434 0.903 0 0.713-0.434 1.084-0.941 1.519-0.497 0.425-1.059 0.906-1.059 1.731v0.5h1v-0.5c0-0.347 0.256-0.584 0.709-0.972 0.575-0.491 1.291-1.103 1.291-2.278 0-1.459-1.287-2.247-2.497-2.247z" })
            );
        }
        function MagnifierQuestion({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnifierQuestionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagnifierQuestion.SVG = MagnifierQuestionSVG;
        return MagnifierQuestion;
    })();
export const MagnifierRuble = /*#__PURE__*/ (() => {
        function MagnifierRubleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.803 2.197c-1.416-1.416-3.3-2.197-5.303-2.197s-3.888 0.781-5.303 2.197c-1.416 1.416-2.197 3.3-2.197 5.303 0 1.666 0.541 3.25 1.538 4.55l-1.125 1.125c-0.897-0.35-1.959-0.166-2.681 0.556l-6.003 6c-0.972 0.975-0.972 2.562 0.003 3.537 0.488 0.484 1.128 0.728 1.769 0.728s1.281-0.244 1.766-0.731l6.003-6.003c0.719-0.722 0.906-1.781 0.556-2.675l1.125-1.125c1.3 0.997 2.884 1.537 4.55 1.537 2.003 0 3.888-0.781 5.303-2.197s2.197-3.3 2.197-5.303-0.781-3.888-2.197-5.303zM8.853 15.853l-6 6c-0.194 0.194-0.513 0.194-0.706 0s-0.194-0.513 0-0.706l6-6c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.194 0.194 0.194 0.509 0 0.706zM16.5 13c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17 4h-1.5c-0.275 0-0.5 0.225-0.5 0.5v2.5h-1v1h1v1h-1v1h1v1h1v-1h2v-1h-2v-1h1c1.103 0 2-0.897 2-2s-0.897-2-2-2zM17 7h-1v-2h1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" })
            );
        }
        function MagnifierRuble({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnifierRubleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagnifierRuble.SVG = MagnifierRubleSVG;
        return MagnifierRuble;
    })();
export const MagnifierUser = /*#__PURE__*/ (() => {
    function MagnifierUserSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.803 2.197c-1.416-1.416-3.3-2.197-5.303-2.197s-3.888 0.781-5.303 2.197c-1.416 1.416-2.197 3.3-2.197 5.303 0 1.666 0.541 3.25 1.538 4.55l-1.125 1.125c-0.897-0.35-1.956-0.166-2.681 0.559l-6 6c-0.472 0.469-0.731 1.097-0.731 1.766s0.259 1.297 0.731 1.769c0.487 0.488 1.128 0.731 1.769 0.731s1.281-0.244 1.769-0.731l6-6c0.472-0.472 0.731-1.1 0.731-1.769 0-0.319-0.059-0.625-0.172-0.912l1.122-1.122c1.3 0.994 2.884 1.534 4.55 1.534 2.003 0 3.888-0.781 5.303-2.197s2.197-3.3 2.197-5.303-0.781-3.888-2.197-5.303zM8.853 15.853l-6 6c-0.194 0.194-0.513 0.194-0.706 0-0.128-0.128-0.147-0.275-0.147-0.353s0.019-0.225 0.147-0.353l6-6c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.128 0.128 0.147 0.275 0.147 0.353s-0.019 0.225-0.147 0.353zM13.125 11.841c0.153-0.394 0.441-0.756 0.847-1.062 0.669-0.503 1.569-0.778 2.528-0.778s1.859 0.275 2.528 0.778c0.406 0.303 0.694 0.669 0.847 1.062-0.931 0.725-2.103 1.159-3.375 1.159s-2.441-0.434-3.375-1.159zM14 6.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5-2.5-1.122-2.5-2.5zM20.641 11.116c-0.231-0.422-0.572-0.809-1.013-1.137-0.334-0.25-0.712-0.456-1.119-0.616 0.9-0.634 1.491-1.681 1.491-2.866 0-1.931-1.569-3.5-3.5-3.5s-3.5 1.569-3.5 3.5c0 1.184 0.591 2.231 1.491 2.866-0.406 0.156-0.784 0.363-1.119 0.616-0.438 0.328-0.778 0.716-1.012 1.137-0.847-0.969-1.359-2.234-1.359-3.616 0-3.031 2.469-5.5 5.5-5.5s5.5 2.469 5.5 5.5c0 1.384-0.513 2.65-1.359 3.616z" })
        );
    }
    function MagnifierUser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MagnifierUserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MagnifierUser.SVG = MagnifierUserSVG;
    return MagnifierUser;
})();
export const MagnifierYen = /*#__PURE__*/ (() => {
        function MagnifierYenSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.803 2.197c-1.416-1.416-3.3-2.197-5.303-2.197s-3.888 0.781-5.303 2.197c-1.416 1.416-2.197 3.3-2.197 5.303 0 1.666 0.541 3.25 1.538 4.55l-1.125 1.125c-0.897-0.35-1.959-0.166-2.681 0.556l-6.003 6c-0.972 0.975-0.972 2.562 0.003 3.537 0.488 0.484 1.128 0.728 1.769 0.728s1.281-0.244 1.766-0.731l6.003-6.003c0.719-0.722 0.906-1.781 0.556-2.675l1.125-1.125c1.3 0.997 2.884 1.537 4.55 1.537 2.003 0 3.888-0.781 5.303-2.197s2.197-3.3 2.197-5.303-0.781-3.888-2.197-5.303zM8.853 15.853l-6 6c-0.194 0.194-0.513 0.194-0.706 0s-0.194-0.513 0-0.706l6-6c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.194 0.194 0.194 0.509 0 0.706zM16.5 13c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.206 4.5l-0.706-0.706-2 2-2-2-0.706 0.706 2.206 2.206v0.294h-2v1h2v1h-2v1h2v1h1v-1h2v-1h-2v-1h2v-1h-2v-0.294z" })
            );
        }
        function MagnifierYen({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnifierYenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MagnifierYen.SVG = MagnifierYenSVG;
        return MagnifierYen;
    })();
export const MailboxEmpty = /*#__PURE__*/ (() => {
        function MailboxEmptySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.5 3h-15.584c-0.206-0.581-0.762-1-1.416-1-0.828 0-1.5 0.672-1.5 1.5v14c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-0.5h6v4.5c0 0.275 0.225 0.5 0.5 0.5h5c0.275 0 0.5-0.225 0.5-0.5v-4.5h7c1.103 0 2-0.897 2-2v-6.5c0-3.031-2.469-5.5-5.5-5.5zM2 17h-1v-13.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v13.5zM13 21h-2v-4h2v4zM22 15h-19v-10h15.5c1.931 0 3.5 1.569 3.5 3.5v6.5z" }),
_('path', { d: "M19.5 9h-9.5v-0.5c0-0.275-0.225-0.5-0.5-0.5h-4c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5h4c0.275 0 0.5-0.225 0.5-0.5v-0.5h6v1.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5zM9 12h-3v-3h3v3zM19 13h-2v-1.5c0-0.275-0.225-0.5-0.5-0.5h-6.5v-1h9v3z" })
            );
        }
        function MailboxEmpty({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MailboxEmptySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MailboxEmpty.SVG = MailboxEmptySVG;
        return MailboxEmpty;
    })();
export const MailboxFull = /*#__PURE__*/ (() => {
    function MailboxFullSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18.5 5h-9.5v-1h1.5c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-4c-0.275 0-0.5 0.225-0.5 0.5v4.5h-3.084c-0.206-0.581-0.762-1-1.416-1-0.828 0-1.5 0.672-1.5 1.5v14c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-0.5h6v4.5c0 0.275 0.225 0.5 0.5 0.5h5c0.275 0 0.5-0.225 0.5-0.5v-4.5h7c1.103 0 2-0.897 2-2v-6.5c0-3.031-2.469-5.5-5.5-5.5zM2 19h-1v-13.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v13.5zM9 11v3h-3v-3h3zM10 1v2h-1.5c-0.275 0-0.5 0.225-0.5 0.5v6.5h-1v-9h3zM13 23h-2v-4h2v4zM22 17h-19v-10h3v3h-0.5c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5h4c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5h-0.5v-3h9.5c1.931 0 3.5 1.569 3.5 3.5v6.5z" })
        );
    }
    function MailboxFull({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MailboxFullSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MailboxFull.SVG = MailboxFullSVG;
    return MailboxFull;
})();
export const Male = /*#__PURE__*/ (() => {
        function MaleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 11c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zM9 18c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" }),
_('path', { d: "M21 2h-6v2h3.584l-5.391 5.394c-1.206-0.903-2.663-1.394-4.194-1.394-1.869 0-3.628 0.728-4.95 2.050s-2.050 3.081-2.050 4.95c0 1.869 0.728 3.628 2.050 4.95s3.081 2.050 4.95 2.050 3.628-0.728 4.95-2.050c1.322-1.322 2.050-3.081 2.050-4.95 0-1.531-0.491-2.988-1.394-4.194l5.394-5.391v3.584h2v-6c0-0.553-0.447-1-1-1zM9 20c-2.756 0-5-2.244-5-5s2.244-5 5-5 5 2.244 5 5-2.244 5-5 5z" })
            );
        }
        function Male({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MaleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Male.SVG = MaleSVG;
        return Male;
    })();
export const MapMarkerCheck = /*#__PURE__*/ (() => {
        function MapMarkerCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 8c0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4 4-1.794 4-4zM9 11c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" }),
_('path', { d: "M16.575 11l0.053-0.209c0.247-1.006 0.375-1.944 0.375-2.791 0-2.137-0.831-4.147-2.344-5.656-1.512-1.512-3.522-2.344-5.659-2.344s-4.147 0.831-5.656 2.344c-1.512 1.512-2.344 3.519-2.344 5.656 0 2.669 1.222 6.119 3.638 10.253 1.763 3.022 3.5 5.266 3.575 5.359 0.191 0.244 0.481 0.387 0.791 0.387s0.6-0.144 0.791-0.387c0.025-0.031 0.625-0.803 1.475-2.047l0.078-0.116c1.184 1.55 3.053 2.55 5.153 2.55 3.584 0 6.5-2.916 6.5-6.5 0-3.559-2.875-6.459-6.425-6.5zM9 21.312c-1.788-2.509-6-8.891-6-13.313 0-3.309 2.691-6 6-6s6 2.691 6 6c0 0.684-0.106 1.462-0.316 2.309l-0.044 0.175-0.091 0.316c-0.022 0.078-0.047 0.159-0.069 0.241l-0.094 0.312c-2.55 0.878-4.388 3.303-4.388 6.147 0 0.669 0.103 1.316 0.291 1.925l-0.206 0.309c-0.066 0.1-0.131 0.194-0.194 0.291l-0.178 0.266-0.1 0.147c-0.225 0.328-0.431 0.622-0.612 0.875zM16.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M15.5 18.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4z" })
            );
        }
        function MapMarkerCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MapMarkerCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MapMarkerCheck.SVG = MapMarkerCheckSVG;
        return MapMarkerCheck;
    })();
export const MapMarkerCross = /*#__PURE__*/ (() => {
        function MapMarkerCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 8c0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4 4-1.794 4-4zM9 11c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" }),
_('path', { d: "M16.575 11l0.053-0.209c0.247-1.006 0.375-1.944 0.375-2.791 0-2.137-0.831-4.147-2.344-5.656-1.512-1.512-3.522-2.344-5.659-2.344s-4.147 0.831-5.656 2.344c-1.512 1.512-2.344 3.519-2.344 5.656 0 2.669 1.222 6.119 3.638 10.253 1.763 3.022 3.5 5.266 3.575 5.359 0.191 0.244 0.481 0.387 0.791 0.387s0.6-0.144 0.791-0.387c0.025-0.031 0.625-0.803 1.475-2.047l0.078-0.116c1.184 1.55 3.053 2.55 5.153 2.55 3.584 0 6.5-2.916 6.5-6.5 0-3.559-2.875-6.459-6.425-6.5zM9 21.312c-1.788-2.509-6-8.891-6-13.313 0-3.309 2.691-6 6-6s6 2.691 6 6c0 0.684-0.106 1.462-0.316 2.309l-0.044 0.175-0.091 0.316c-0.022 0.078-0.047 0.159-0.069 0.241l-0.094 0.312c-2.55 0.878-4.388 3.303-4.388 6.147 0 0.669 0.103 1.316 0.291 1.925l-0.206 0.309c-0.066 0.1-0.131 0.194-0.194 0.291l-0.178 0.266-0.1 0.147c-0.225 0.328-0.431 0.622-0.612 0.875zM16.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18.5 14.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function MapMarkerCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MapMarkerCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MapMarkerCross.SVG = MapMarkerCrossSVG;
        return MapMarkerCross;
    })();
export const MapMarkerDown = /*#__PURE__*/ (() => {
        function MapMarkerDownSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 8c0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4 4-1.794 4-4zM9 11c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" }),
_('path', { d: "M16.575 11l0.053-0.209c0.247-1.006 0.375-1.944 0.375-2.791 0-2.137-0.831-4.147-2.344-5.656-1.512-1.512-3.522-2.344-5.659-2.344s-4.147 0.831-5.656 2.344c-1.512 1.512-2.344 3.519-2.344 5.656 0 2.669 1.222 6.119 3.638 10.253 1.763 3.022 3.5 5.266 3.575 5.359 0.191 0.244 0.481 0.387 0.791 0.387s0.6-0.144 0.791-0.387c0.025-0.031 0.625-0.803 1.475-2.047l0.078-0.116c1.184 1.55 3.053 2.55 5.153 2.55 3.584 0 6.5-2.916 6.5-6.5 0-3.559-2.875-6.459-6.425-6.5zM9 21.312c-1.788-2.509-6-8.891-6-13.313 0-3.309 2.691-6 6-6s6 2.691 6 6c0 0.684-0.106 1.462-0.316 2.309l-0.044 0.175-0.091 0.316c-0.022 0.078-0.047 0.159-0.069 0.241l-0.094 0.312c-2.55 0.878-4.388 3.303-4.388 6.147 0 0.669 0.103 1.316 0.291 1.925l-0.206 0.309c-0.066 0.1-0.131 0.194-0.194 0.291l-0.178 0.266-0.1 0.147c-0.225 0.328-0.431 0.622-0.612 0.875zM16.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17 19.294v-5.294h-1v5.294l-1.5-1.5-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l2.353-2.353-0.706-0.706-1.5 1.5z" })
            );
        }
        function MapMarkerDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MapMarkerDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MapMarkerDown.SVG = MapMarkerDownSVG;
        return MapMarkerDown;
    })();
export const MapMarkerEdit = /*#__PURE__*/ (() => {
        function MapMarkerEditSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.656 2.344c-1.509-1.512-3.519-2.344-5.656-2.344s-4.147 0.831-5.656 2.344c-1.512 1.509-2.344 3.519-2.344 5.656 0 2.669 1.222 6.119 3.638 10.253 1.763 3.022 3.5 5.266 3.575 5.359 0.191 0.244 0.481 0.387 0.791 0.387s0.6-0.144 0.791-0.387c0.072-0.094 1.812-2.337 3.575-5.359 2.409-4.134 3.631-7.584 3.631-10.253 0-2.138-0.831-4.147-2.344-5.656zM8 21.312c-1.791-2.512-6-8.891-6-13.313 0-3.309 2.691-6 6-6s6 2.691 6 6c0 4.422-4.209 10.8-6 13.313z" }),
_('path', { d: "M8 4c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zM8 11c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" }),
_('path', { d: "M23.438 13.563c-0.747-0.747-1.959-0.747-2.706 0l-7.084 7.084c-0.069 0.069-0.119 0.159-0.138 0.256l-0.5 2.5c-0.031 0.162 0.019 0.334 0.138 0.453 0.094 0.094 0.222 0.147 0.353 0.147 0.031 0 0.066-0.003 0.097-0.009l2.5-0.5c0.097-0.019 0.184-0.066 0.256-0.138l7.084-7.087c0.747-0.747 0.747-1.959 0-2.706zM15.753 22.541l-1.616 0.322 0.322-1.616 6.041-6.041 1.294 1.294-6.041 6.041zM22.731 15.563l-0.231 0.231-1.294-1.294 0.231-0.231c0.172-0.172 0.403-0.269 0.647-0.269s0.472 0.097 0.647 0.269c0.172 0.172 0.269 0.403 0.269 0.647s-0.097 0.472-0.269 0.647z" })
            );
        }
        function MapMarkerEdit({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MapMarkerEditSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MapMarkerEdit.SVG = MapMarkerEditSVG;
        return MapMarkerEdit;
    })();
export const MapMarkerMinus = /*#__PURE__*/ (() => {
        function MapMarkerMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 8c0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4 4-1.794 4-4zM9 11c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" }),
_('path', { d: "M16.575 11l0.053-0.209c0.247-1 0.372-1.941 0.372-2.791 0-2.137-0.831-4.147-2.344-5.656-1.509-1.512-3.519-2.344-5.656-2.344s-4.147 0.831-5.656 2.344c-1.512 1.512-2.344 3.519-2.344 5.656 0 2.669 1.222 6.119 3.638 10.253 1.763 3.022 3.5 5.266 3.575 5.359 0.191 0.244 0.481 0.387 0.791 0.387 0 0 0 0 0 0 0.309 0 0.6-0.144 0.791-0.387 0.025-0.031 0.622-0.803 1.472-2.044l0.081-0.116c1.184 1.547 3.053 2.547 5.153 2.547 3.584 0 6.5-2.916 6.5-6.5 0-3.559-2.875-6.459-6.425-6.5zM9 21.312c-1.791-2.512-6-8.891-6-13.313 0-3.309 2.691-6 6-6s6 2.691 6 6c0 0.687-0.106 1.466-0.316 2.309l-0.003 0.016h-0.003l-0.131 0.481c-0.019 0.066-0.041 0.141-0.066 0.231l-0.097 0.316c-2.55 0.881-4.384 3.303-4.384 6.147 0 0.672 0.103 1.319 0.291 1.928l-0.206 0.303c-0.044 0.066-0.091 0.134-0.134 0.2l-0.234 0.353-0.106 0.153c-0.222 0.328-0.428 0.622-0.609 0.875zM16.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M14 17h5v1h-5v-1z" })
            );
        }
        function MapMarkerMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MapMarkerMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MapMarkerMinus.SVG = MapMarkerMinusSVG;
        return MapMarkerMinus;
    })();
export const MapMarkerPlus = /*#__PURE__*/ (() => {
        function MapMarkerPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 8c0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4 4-1.794 4-4zM9 11c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" }),
_('path', { d: "M16.575 11l0.053-0.209c0.247-1 0.372-1.941 0.372-2.791 0-2.137-0.831-4.147-2.344-5.656-1.509-1.512-3.519-2.344-5.656-2.344s-4.147 0.831-5.656 2.344c-1.512 1.512-2.344 3.519-2.344 5.656 0 2.669 1.222 6.119 3.638 10.253 1.763 3.022 3.5 5.266 3.575 5.359 0.191 0.244 0.481 0.387 0.791 0.387 0 0 0 0 0 0 0.309 0 0.6-0.144 0.791-0.387 0.025-0.031 0.622-0.803 1.472-2.044l0.081-0.116c1.184 1.547 3.053 2.547 5.153 2.547 3.584 0 6.5-2.916 6.5-6.5 0-3.559-2.875-6.459-6.425-6.5zM9 21.312c-1.791-2.512-6-8.891-6-13.313 0-3.309 2.691-6 6-6s6 2.691 6 6c0 0.687-0.106 1.466-0.316 2.309l-0.003 0.016h-0.003l-0.131 0.481c-0.019 0.066-0.041 0.141-0.066 0.231l-0.097 0.316c-2.55 0.881-4.384 3.303-4.384 6.147 0 0.672 0.103 1.319 0.291 1.928l-0.206 0.303c-0.044 0.066-0.091 0.134-0.134 0.2l-0.234 0.353-0.106 0.153c-0.222 0.328-0.428 0.622-0.609 0.875zM16.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17 15h-1v2h-2v1h2v2.013h1v-2.013h2v-1h-2z" })
            );
        }
        function MapMarkerPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MapMarkerPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MapMarkerPlus.SVG = MapMarkerPlusSVG;
        return MapMarkerPlus;
    })();
export const MapMarkerUser = /*#__PURE__*/ (() => {
        function MapMarkerUserSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 8c0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4 4-1.794 4-4zM6 8c0-1.653 1.347-3 3-3s3 1.347 3 3-1.347 3-3 3-3-1.347-3-3z" }),
_('path', { d: "M16.572 11c0.284-1.091 0.428-2.097 0.428-3 0-2.137-0.831-4.147-2.344-5.656-1.509-1.512-3.519-2.344-5.656-2.344s-4.147 0.831-5.656 2.344c-1.512 1.512-2.344 3.519-2.344 5.656 0 2.669 1.222 6.119 3.638 10.253 1.763 3.022 3.5 5.266 3.575 5.359 0.191 0.244 0.481 0.387 0.791 0.387s0.6-0.144 0.791-0.387c0.031-0.038 0.666-0.856 1.553-2.163 1.184 1.55 3.053 2.55 5.153 2.55 3.584 0 6.5-2.916 6.5-6.5 0-3.559-2.878-6.459-6.428-6.5zM3 8c0-3.309 2.691-6 6-6s6 2.691 6 6c0 0.956-0.206 2.084-0.612 3.353-2.55 0.878-4.387 3.303-4.387 6.147 0 0.669 0.1 1.313 0.291 1.919-0.487 0.747-0.931 1.391-1.291 1.894-1.791-2.513-6-8.891-6-13.313zM13.125 21.841c0.413-1.066 1.8-1.841 3.375-1.841s2.959 0.772 3.375 1.841c-0.931 0.728-2.103 1.159-3.375 1.159s-2.444-0.434-3.375-1.159zM14 16.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5-2.5-1.122-2.5-2.5zM20.641 21.119c-0.422-0.769-1.184-1.388-2.131-1.753 0.9-0.634 1.491-1.681 1.491-2.866 0-1.931-1.569-3.5-3.5-3.5s-3.5 1.569-3.5 3.5c0 1.181 0.591 2.231 1.491 2.862-0.947 0.366-1.709 0.981-2.131 1.753-0.847-0.969-1.359-2.234-1.359-3.616 0-3.031 2.469-5.5 5.5-5.5s5.5 2.469 5.5 5.5c0 1.384-0.513 2.65-1.359 3.619z" })
            );
        }
        function MapMarkerUser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MapMarkerUserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MapMarkerUser.SVG = MapMarkerUserSVG;
        return MapMarkerUser;
    })();
export const MapMarker = /*#__PURE__*/ (() => {
        function MapMarkerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.656 2.344c-1.509-1.512-3.519-2.344-5.656-2.344s-4.147 0.831-5.656 2.344c-1.512 1.512-2.344 3.519-2.344 5.656 0 2.669 1.222 6.119 3.638 10.253 1.762 3.022 3.5 5.266 3.575 5.359 0.191 0.244 0.481 0.387 0.791 0.387s0.6-0.144 0.791-0.387c0.072-0.094 1.812-2.337 3.575-5.359 2.409-4.134 3.631-7.584 3.631-10.253 0-2.138-0.831-4.147-2.344-5.656zM12 21.312c-1.791-2.512-6-8.891-6-13.313 0-3.309 2.691-6 6-6s6 2.691 6 6c0 4.422-4.209 10.8-6 13.313z" }),
_('path', { d: "M12 4c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.206 0 4-1.794 4-4s-1.794-4-4-4zM12 11c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" })
            );
        }
        function MapMarker({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MapMarkerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MapMarker.SVG = MapMarkerSVG;
        return MapMarker;
    })();
export const Map = /*#__PURE__*/ (() => {
        function MapSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 4.294l-2.294-2.294h2.294v2.294zM22 9.294l-8 8-9.294-9.294 6-6h7.584l3.709 3.706v3.588zM2 18.706l3.294 3.294h-3.294v-3.294zM11.294 22h-4.587l-4.706-4.706v-4.587l2 2 0.706-0.706-2.706-2.706v-9.294h7.294l-5.647 5.647c-0.194 0.194-0.194 0.513 0 0.706l10 10c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l7.647-7.647v4.584l-5.353 5.356c-0.194 0.194-0.194 0.513 0 0.706l0.647 0.647h-4.587l-2.706-2.706-0.706 0.706 2 2zM22 22h-3.294l-1-1 4.294-4.294v5.294c0.003 0 0 0 0 0z" }),
_('path', { d: "M5.292 15.999l0.707-0.707 2.707 2.707-0.707 0.707-2.707-2.707z" }),
_('path', { d: "M13.5 5c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.122-2.5-2.5-2.5zM13.5 9c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" }),
_('path', { d: "M13.5 3c-2.481 0-4.5 2.019-4.5 4.5 0 1.563 0.706 3.284 2.103 5.116 1.019 1.338 2.025 2.225 2.069 2.259 0.094 0.081 0.213 0.125 0.328 0.125s0.234-0.041 0.328-0.125c0.044-0.038 1.050-0.925 2.069-2.259 1.397-1.831 2.103-3.553 2.103-5.116 0-2.481-2.019-4.5-4.5-4.5zM13.5 13.816c-0.928-0.906-3.5-3.65-3.5-6.316 0-1.931 1.569-3.5 3.5-3.5s3.5 1.569 3.5 3.5c0 2.659-2.572 5.409-3.5 6.316z" })
            );
        }
        function Map({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MapSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Map.SVG = MapSVG;
        return Map;
    })();
export const Map2 = /*#__PURE__*/ (() => {
    function Map2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.559 2.172c-0.275-0.187-0.625-0.225-0.931-0.1l-7.116 2.847-6.619-2.838c-0.244-0.103-0.519-0.109-0.766-0.009l-7.5 3c-0.378 0.15-0.628 0.519-0.628 0.928v15c0 0.331 0.166 0.641 0.441 0.828 0.169 0.113 0.363 0.172 0.559 0.172 0.125 0 0.25-0.025 0.372-0.072l7.116-2.847 6.619 2.838c0.244 0.103 0.519 0.109 0.766 0.009l7.5-3c0.378-0.15 0.628-0.519 0.628-0.928v-15c0-0.331-0.166-0.641-0.441-0.828zM9 4.303l6 2.572v12.825l-6-2.575v-12.822zM2 6.678l6-2.4v12.847l-6 2.397v-12.844zM22 17.322l-6 2.4v-12.844l6-2.4v12.844z" })
        );
    }
    function Map2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Map2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Map2.SVG = Map2SVG;
    return Map2;
})();
export const MatchFire = /*#__PURE__*/ (() => {
        function MatchFireSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 20c-0.837 0-1.494 0.269-2.128 0.525-0.597 0.244-1.162 0.475-1.872 0.475h-11v2h11c0.706 0 1.272 0.231 1.872 0.475 0.634 0.259 1.294 0.525 2.128 0.525 1.103 0 2-0.897 2-2s-0.897-2-2-2zM15 23c-0.641 0-1.181-0.219-1.753-0.453-0.631-0.256-1.344-0.547-2.247-0.547 0.903 0 1.619-0.291 2.247-0.547 0.572-0.234 1.113-0.453 1.753-0.453 0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M18.981 7.356c-0.528-1.234-1.263-2.481-2.181-3.706-1.553-2.069-3.094-3.366-3.159-3.419-0.316-0.262-0.756-0.306-1.119-0.109-0.359 0.197-0.566 0.591-0.516 0.997 0.278 2.322-0.656 3.588-1.741 5.056-1.075 1.456-2.297 3.106-2.266 5.831 0 1.6 0.625 3.106 1.756 4.238 1.134 1.131 2.641 1.756 4.244 1.756s3.109-0.625 4.244-1.756c1.131-1.134 1.756-2.641 1.756-4.244 0-1.506-0.344-3.069-1.019-4.644zM14 16c-2.206 0-4-1.794-4-4 0-0.003 0-0.009 0-0.012-0.025-2.056 0.856-3.247 1.875-4.625 0.825-1.116 1.725-2.334 2.053-4.047 0.406 0.447 0.853 0.975 1.3 1.572 1.266 1.694 2.772 4.303 2.772 7.113 0 2.206-1.794 4-4 4z" }),
_('path', { d: "M14.334 9.028c-0.206 0.072-0.344 0.275-0.331 0.494 0.047 1.012-0.294 1.238-0.809 1.575-0.447 0.294-1.003 0.659-1.162 1.556 0 0 0 0 0 0-0.094 0.525 0.025 1.056 0.331 1.494s0.766 0.731 1.291 0.822c0.116 0.022 0.234 0.031 0.347 0.031 0.953 0 1.797-0.684 1.969-1.653 0.378-2.156-1.006-4.066-1.066-4.147-0.131-0.175-0.363-0.244-0.569-0.172zM14.981 13.175c-0.097 0.544-0.616 0.906-1.159 0.809-0.262-0.047-0.491-0.194-0.644-0.412s-0.213-0.484-0.166-0.747c0.084-0.472 0.341-0.638 0.725-0.894 0.322-0.213 0.712-0.469 0.972-0.95 0.237 0.612 0.416 1.394 0.272 2.194z" })
            );
        }
        function MatchFire({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MatchFireSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MatchFire.SVG = MatchFireSVG;
        return MatchFire;
    })();
export const MedalEmpty = /*#__PURE__*/ (() => {
    function MedalEmptySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19.5 6.788l-0.625-0.625 0.231-0.859c0.244-0.916-0.303-1.859-1.216-2.103l-0.853-0.228-0.231-0.859c-0.247-0.916-1.194-1.459-2.106-1.216l-0.853 0.228-0.628-0.628c-0.672-0.669-1.762-0.666-2.431 0l-0.625 0.625-0.859-0.231c-0.916-0.244-1.859 0.303-2.103 1.216l-0.228 0.853-0.859 0.231c-0.916 0.247-1.459 1.194-1.216 2.106l0.228 0.853-0.628 0.631c-0.669 0.672-0.666 1.763 0 2.431l0.625 0.625-0.231 0.859c-0.244 0.916 0.303 1.859 1.216 2.106l1.891 0.506v9.691c0 0.403 0.244 0.769 0.619 0.925s0.803 0.069 1.091-0.216l2.294-2.294 2.294 2.294c0.191 0.191 0.447 0.294 0.706 0.294 0.128 0 0.259-0.025 0.381-0.075 0.375-0.156 0.619-0.519 0.619-0.925v-9.691l1.887-0.506c0.916-0.247 1.459-1.194 1.216-2.106l-0.228-0.853 0.628-0.628c0.666-0.672 0.666-1.763-0.003-2.431zM12 11c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3zM12.706 19.294c-0.391-0.391-1.025-0.391-1.416 0l-1.291 1.291v-8.003c0.612 0.269 1.291 0.419 2 0.419s1.388-0.15 2-0.419v8.003l-1.294-1.291zM18.794 8.512l-0.831 0.831c-0.125 0.125-0.175 0.309-0.128 0.484l0.303 1.131c0.103 0.381-0.128 0.778-0.509 0.881l-1.628 0.438v-1.278c0.628-0.834 1-1.875 1-2.997 0-2.756-2.244-5-5-5s-5 2.244-5 5c0 1.122 0.372 2.163 1 2.997v1.275l-1.631-0.438c-0.381-0.103-0.609-0.5-0.509-0.881l0.303-1.134c0.047-0.172-0.003-0.356-0.128-0.484l-0.828-0.828c-0.281-0.281-0.278-0.738 0-1.019l0.831-0.831c0.125-0.125 0.175-0.309 0.128-0.484l-0.303-1.131c-0.103-0.381 0.128-0.778 0.509-0.881l1.134-0.303c0.172-0.047 0.306-0.181 0.353-0.353l0.303-1.131c0.103-0.381 0.5-0.609 0.881-0.509l1.134 0.303c0.172 0.047 0.356-0.003 0.484-0.128l0.828-0.828c0.281-0.281 0.738-0.278 1.019 0l0.834 0.825c0.125 0.125 0.309 0.175 0.484 0.128l1.131-0.303c0.381-0.103 0.778 0.128 0.881 0.509l0.303 1.134c0.047 0.172 0.181 0.306 0.353 0.353l1.131 0.303c0.381 0.103 0.609 0.5 0.509 0.881l-0.303 1.134c-0.047 0.172 0.003 0.356 0.128 0.484l0.828 0.828c0.281 0.284 0.281 0.741 0.003 1.022z" })
        );
    }
    function MedalEmpty({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MedalEmptySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MedalEmpty.SVG = MedalEmptySVG;
    return MedalEmpty;
})();
export const MedalFirst = /*#__PURE__*/ (() => {
        function MedalFirstSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.153 11.212c0.006-0.172-0.012-0.347-0.059-0.516l-0.228-0.853 0.628-0.628c0.669-0.672 0.666-1.762 0-2.431l-0.625-0.625 0.228-0.856c0.241-0.916-0.303-1.859-1.216-2.103l-0.85-0.228-0.228-0.856c-0.247-0.916-1.191-1.463-2.106-1.216l-0.853 0.231-0.628-0.631c-0.672-0.669-1.763-0.666-2.431 0l-0.625 0.625-0.856-0.228c-0.916-0.241-1.859 0.303-2.103 1.216l-0.231 0.853-0.856 0.228c-0.444 0.119-0.813 0.403-1.044 0.8s-0.291 0.862-0.172 1.303l0.228 0.853-0.628 0.631c-0.669 0.672-0.666 1.763 0 2.431l0.625 0.625-0.228 0.856c-0.241 0.916 0.303 1.859 1.216 2.103l1.887 0.506v9.697c0 0.403 0.244 0.769 0.619 0.925 0.125 0.050 0.253 0.075 0.381 0.075 0.259 0 0.516-0.103 0.706-0.294l2.475-2.475c1.181 1.675 3.125 2.769 5.322 2.769 3.584 0 6.5-2.916 6.5-6.5 0-3.012-2.059-5.553-4.847-6.288zM4.372 11.831c-0.381-0.103-0.609-0.5-0.509-0.881l0.303-1.134c0.047-0.172-0.003-0.356-0.128-0.481l-0.828-0.828c-0.281-0.281-0.278-0.738 0-1.019l0.831-0.831c0.125-0.125 0.175-0.309 0.128-0.484l-0.303-1.131c-0.050-0.184-0.025-0.378 0.072-0.544s0.253-0.288 0.438-0.334l1.134-0.303c0.172-0.047 0.306-0.181 0.353-0.353l0.303-1.131c0.103-0.381 0.5-0.609 0.881-0.509l1.134 0.303c0.172 0.047 0.356-0.003 0.481-0.128l0.828-0.828c0.278-0.281 0.738-0.278 1.019 0l0.831 0.831c0.125 0.125 0.309 0.175 0.484 0.128l1.131-0.303c0.381-0.103 0.778 0.125 0.881 0.509l0.303 1.134c0.047 0.172 0.181 0.306 0.353 0.353l1.131 0.303c0.381 0.103 0.609 0.5 0.509 0.881l-0.303 1.134c-0.047 0.172 0.003 0.356 0.128 0.481l0.828 0.828c0.281 0.281 0.278 0.738 0 1.019l-0.831 0.831c-0.125 0.125-0.175 0.309-0.128 0.484l0.303 1.134c0.006 0.025 0.012 0.047 0.016 0.072-0.213-0.022-0.428-0.031-0.647-0.031-0.516 0-1.019 0.059-1.5 0.175v-0.178c0.628-0.834 1-1.875 1-2.997 0-2.756-2.244-5-5-5s-5 2.244-5 5c0 1.122 0.372 2.163 1 2.997v1.272l-1.628-0.441zM7 8c0-1.653 1.347-3 3-3s3 1.347 3 3-1.347 3-3 3-3-1.347-3-3zM8 20.584v-8.003c0.612 0.269 1.291 0.419 2 0.419 0.303 0 0.603-0.028 0.891-0.078-1.169 1.175-1.891 2.794-1.891 4.578 0 0.634 0.091 1.247 0.259 1.825l-1.259 1.259zM15.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16 14.5c0-0.203-0.122-0.384-0.309-0.462s-0.403-0.034-0.544 0.109l-1.353 1.353 0.706 0.706 0.5-0.5v4.294h-1v1h3v-1h-1v-5.5z" })
            );
        }
        function MedalFirst({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MedalFirstSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MedalFirst.SVG = MedalFirstSVG;
        return MedalFirst;
    })();
export const MedalSecond = /*#__PURE__*/ (() => {
        function MedalSecondSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.153 11.212c0.006-0.172-0.012-0.347-0.059-0.516l-0.228-0.853 0.628-0.628c0.669-0.672 0.666-1.762 0-2.431l-0.625-0.625 0.228-0.856c0.241-0.916-0.303-1.859-1.216-2.103l-0.85-0.228-0.228-0.856c-0.247-0.916-1.191-1.463-2.106-1.216l-0.853 0.231-0.628-0.631c-0.672-0.669-1.763-0.666-2.431 0l-0.625 0.625-0.856-0.228c-0.916-0.241-1.859 0.303-2.103 1.216l-0.231 0.853-0.856 0.228c-0.444 0.119-0.813 0.403-1.044 0.8s-0.291 0.862-0.172 1.303l0.228 0.853-0.628 0.631c-0.669 0.672-0.666 1.763 0 2.431l0.625 0.625-0.228 0.856c-0.241 0.916 0.303 1.859 1.216 2.103l1.887 0.506v9.697c0 0.403 0.244 0.769 0.619 0.925 0.125 0.050 0.253 0.075 0.381 0.075 0.259 0 0.516-0.103 0.706-0.294l2.475-2.475c1.181 1.675 3.125 2.769 5.322 2.769 3.584 0 6.5-2.916 6.5-6.5 0-3.012-2.059-5.553-4.847-6.288zM4.372 11.831c-0.381-0.103-0.609-0.5-0.509-0.881l0.303-1.134c0.047-0.172-0.003-0.356-0.128-0.481l-0.828-0.828c-0.281-0.281-0.278-0.738 0-1.019l0.831-0.831c0.125-0.125 0.175-0.309 0.128-0.484l-0.303-1.131c-0.050-0.184-0.025-0.378 0.072-0.544s0.253-0.288 0.438-0.334l1.134-0.303c0.172-0.047 0.306-0.181 0.353-0.353l0.303-1.131c0.103-0.381 0.5-0.609 0.881-0.509l1.134 0.303c0.172 0.047 0.356-0.003 0.481-0.128l0.828-0.828c0.278-0.281 0.738-0.278 1.019 0l0.831 0.831c0.125 0.125 0.309 0.175 0.484 0.128l1.131-0.303c0.381-0.103 0.778 0.125 0.881 0.509l0.303 1.134c0.047 0.172 0.181 0.306 0.353 0.353l1.131 0.303c0.381 0.103 0.609 0.5 0.509 0.881l-0.303 1.134c-0.047 0.172 0.003 0.356 0.128 0.481l0.828 0.828c0.281 0.281 0.278 0.738 0 1.019l-0.831 0.831c-0.125 0.125-0.175 0.309-0.128 0.484l0.303 1.134c0.006 0.025 0.012 0.047 0.016 0.072-0.213-0.022-0.428-0.031-0.647-0.031-0.516 0-1.019 0.059-1.5 0.175v-0.178c0.628-0.834 1-1.875 1-2.997 0-2.756-2.244-5-5-5s-5 2.244-5 5c0 1.122 0.372 2.163 1 2.997v1.272l-1.628-0.441zM7 8c0-1.653 1.347-3 3-3s3 1.347 3 3-1.347 3-3 3-3-1.347-3-3zM8 20.584v-8.003c0.612 0.269 1.291 0.419 2 0.419 0.303 0 0.603-0.028 0.891-0.078-1.169 1.175-1.891 2.794-1.891 4.578 0 0.634 0.091 1.247 0.259 1.825l-1.259 1.259zM15.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M15.547 19.209c1.094-0.531 2.453-1.191 2.453-2.709 0-1.641-1.256-2.5-2.5-2.5s-2.5 0.859-2.5 2.5v0.5h1v-0.5c0-1.034 0.753-1.5 1.5-1.5 0.397 0 0.775 0.138 1.044 0.375 0.303 0.269 0.456 0.647 0.456 1.125 0 0.831-0.75 1.256-1.891 1.809-0.987 0.481-2.109 1.022-2.109 2.191 0 0.275 0.225 0.5 0.5 0.5h4.5v-1h-3.772c0.256-0.259 0.712-0.497 1.319-0.791z" })
            );
        }
        function MedalSecond({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MedalSecondSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MedalSecond.SVG = MedalSecondSVG;
        return MedalSecond;
    })();
export const MedalThird = /*#__PURE__*/ (() => {
        function MedalThirdSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.153 11.212c0.006-0.172-0.012-0.347-0.059-0.516l-0.228-0.853 0.628-0.628c0.669-0.672 0.666-1.762 0-2.431l-0.625-0.625 0.228-0.856c0.241-0.916-0.303-1.859-1.216-2.103l-0.85-0.228-0.228-0.856c-0.247-0.916-1.191-1.463-2.106-1.216l-0.853 0.231-0.628-0.631c-0.672-0.669-1.763-0.666-2.431 0l-0.625 0.625-0.856-0.228c-0.916-0.241-1.859 0.303-2.103 1.216l-0.231 0.853-0.856 0.228c-0.444 0.119-0.813 0.403-1.044 0.8s-0.291 0.862-0.172 1.303l0.228 0.853-0.628 0.631c-0.669 0.672-0.666 1.763 0 2.431l0.625 0.625-0.228 0.856c-0.241 0.916 0.303 1.859 1.216 2.103l1.887 0.506v9.697c0 0.403 0.244 0.769 0.619 0.925 0.125 0.050 0.253 0.075 0.381 0.075 0.259 0 0.516-0.103 0.706-0.294l2.475-2.475c1.181 1.675 3.125 2.769 5.322 2.769 3.584 0 6.5-2.916 6.5-6.5 0-3.012-2.059-5.553-4.847-6.288zM4.372 11.831c-0.381-0.103-0.609-0.5-0.509-0.881l0.303-1.134c0.047-0.172-0.003-0.356-0.128-0.481l-0.828-0.828c-0.281-0.281-0.278-0.738 0-1.019l0.831-0.831c0.125-0.125 0.175-0.309 0.128-0.484l-0.303-1.131c-0.050-0.184-0.025-0.378 0.072-0.544s0.253-0.288 0.438-0.334l1.134-0.303c0.172-0.047 0.306-0.181 0.353-0.353l0.303-1.131c0.103-0.381 0.5-0.609 0.881-0.509l1.134 0.303c0.172 0.047 0.356-0.003 0.481-0.128l0.828-0.828c0.278-0.281 0.738-0.278 1.019 0l0.831 0.831c0.125 0.125 0.309 0.175 0.484 0.128l1.131-0.303c0.381-0.103 0.778 0.125 0.881 0.509l0.303 1.134c0.047 0.172 0.181 0.306 0.353 0.353l1.131 0.303c0.381 0.103 0.609 0.5 0.509 0.881l-0.303 1.134c-0.047 0.172 0.003 0.356 0.128 0.481l0.828 0.828c0.281 0.281 0.278 0.738 0 1.019l-0.831 0.831c-0.125 0.125-0.175 0.309-0.128 0.484l0.303 1.134c0.006 0.025 0.012 0.047 0.016 0.072-0.213-0.022-0.428-0.031-0.647-0.031-0.516 0-1.019 0.059-1.5 0.175v-0.178c0.628-0.834 1-1.875 1-2.997 0-2.756-2.244-5-5-5s-5 2.244-5 5c0 1.122 0.372 2.163 1 2.997v1.272l-1.628-0.441zM7 8c0-1.653 1.347-3 3-3s3 1.347 3 3-1.347 3-3 3-3-1.347-3-3zM8 20.584v-8.003c0.612 0.269 1.291 0.419 2 0.419 0.303 0 0.603-0.028 0.891-0.078-1.169 1.175-1.891 2.794-1.891 4.578 0 0.634 0.091 1.247 0.259 1.825l-1.259 1.259zM15.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16.381 16.159l1.019-1.359c0.113-0.15 0.131-0.353 0.047-0.525-0.084-0.169-0.259-0.275-0.447-0.275h-3v1h2l-0.9 1.2c-0.112 0.15-0.131 0.353-0.047 0.525 0.084 0.169 0.259 0.275 0.447 0.275 0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5c-0.531 0-1.028-0.288-1.3-0.75l-0.25-0.431-0.866 0.503 0.25 0.431c0.447 0.769 1.278 1.25 2.163 1.25 1.378 0 2.5-1.122 2.5-2.5 0.003-1.072-0.672-1.987-1.616-2.344z" })
            );
        }
        function MedalThird({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MedalThirdSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MedalThird.SVG = MedalThirdSVG;
        return MedalThird;
    })();
export const Megaphone = /*#__PURE__*/ (() => {
        function MegaphoneSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.438 10.725l-10.163-10.163c-0.747-0.75-1.966-0.75-2.712 0v0c-0.534 0.534-0.687 1.313-0.456 1.984l-8.7 15.469c-0.066-0.009-0.131-0.016-0.197-0.016 0 0-0.003 0-0.003 0-0.322 0-0.625 0.128-0.853 0.356-0.228 0.231-0.353 0.534-0.353 0.859 0 0.322 0.128 0.625 0.356 0.85l3.578 3.578c0.228 0.228 0.534 0.356 0.856 0.356 0 0 0.003 0 0.003 0 0.322 0 0.625-0.128 0.85-0.356 0.231-0.231 0.356-0.534 0.356-0.859 0-0.066-0.006-0.128-0.016-0.191l2.497-1.403 1.084 1.084c0.478 0.478 1.113 0.725 1.756 0.725 0.428 0 0.859-0.109 1.25-0.337l3.719-2.169c0.369-0.213 0.619-0.578 0.691-0.997s-0.047-0.844-0.325-1.169l-1.006-1.172 5.8-3.263c0.203 0.069 0.416 0.106 0.628 0.106 0.491 0 0.981-0.188 1.356-0.563 0.753-0.747 0.753-1.966 0.003-2.712zM9.647 12.191l3.881-5.95 6.284 6.284-15.094 8.484-1.728-1.728 8.484-15.091 1.328 1.328-3.994 6.128 0.837 0.544zM4.934 22.941c-0.050 0.053-0.112 0.059-0.144 0.059v0c-0.031 0-0.094-0.009-0.15-0.063l-3.581-3.581c-0.053-0.050-0.059-0.112-0.059-0.144s0.009-0.097 0.063-0.15c0 0 0 0 0.003-0.003 0.050-0.053 0.112-0.059 0.144-0.059v0c0.031 0 0.094 0.009 0.15 0.063l3.581 3.581c0.053 0.050 0.059 0.112 0.059 0.144s-0.009 0.094-0.066 0.153zM15.897 18.978c0.112 0.131 0.109 0.275 0.097 0.35s-0.056 0.213-0.206 0.3l-3.719 2.169c-0.581 0.337-1.319 0.244-1.794-0.231l-0.884-0.884 5.375-3.022 1.131 1.319zM22.731 12.731c-0.172 0.172-0.403 0.269-0.65 0.269s-0.475-0.097-0.65-0.269l-10.163-10.163c-0.359-0.359-0.359-0.941 0-1.3s0.941-0.359 1.3 0l10.163 10.162c0.172 0.172 0.269 0.403 0.269 0.65s-0.097 0.475-0.269 0.65z" }),
_('path', { d: "M18.792 4.501l3.708-3.708 0.707 0.707-3.708 3.708-0.707-0.707z" }),
_('path', { d: "M16.829 2.723l1.353-2.706 0.894 0.447-1.353 2.706-0.894-0.447z" }),
_('path', { d: "M20.829 6.276l2.706-1.353 0.447 0.894-2.706 1.353-0.447-0.894z" })
            );
        }
        function Megaphone({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MegaphoneSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Megaphone.SVG = MegaphoneSVG;
        return Megaphone;
    })();
export const Megaphone2 = /*#__PURE__*/ (() => {
        function Megaphone2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M23.5 8h-1.5v-5c0-0.425-0.269-0.803-0.669-0.944s-0.847-0.012-1.113 0.319c-0.406 0.506-1.931 1.684-4.053 2.712-1.706 0.825-4.297 1.8-7.163 1.903v-0.491c0-0.275-0.225-0.5-0.5-0.5h-5.003c-0.275 0-0.5 0.225-0.5 0.5v0.5h-1c-1.103 0-2 0.897-2 2v3c0 1.103 0.897 2 2 2h1v0.5c0 0.275 0.225 0.5 0.5 0.5h0.513c0.109 2.519 0.966 5.966 1.003 6.122 0.016 0.066 0.044 0.125 0.084 0.178 0.109 0.144 0.441 0.584 2.447 0.684 0.194 0.009 0.406 0.016 0.628 0.016 0.744 0 1.591-0.063 2.122-0.237 0.581-0.194 0.703-0.522 0.703-0.759 0-0.109-0.034-0.213-0.1-0.3-0.028-0.038-2.516-3.378-2.859-5.7h0.459c0.275 0 0.5-0.225 0.5-0.5v-0.491c2.866 0.103 5.456 1.078 7.162 1.903 2.125 1.028 3.65 2.203 4.053 2.712 0.194 0.244 0.484 0.375 0.781 0.375 0.109 0 0.222-0.019 0.331-0.056 0.4-0.141 0.669-0.519 0.669-0.944v-5.003h1.5c0.275 0 0.5-0.225 0.5-0.5v-4c0.003-0.275-0.222-0.5-0.497-0.5zM2 12v-3h1v3h-1zM4 7h4v7h-4v-7zM9.788 20.866c-0.359 0.078-0.987 0.147-1.809 0.131-1.066-0.019-1.791-0.166-2.031-0.281-0.169-0.709-0.834-3.6-0.934-5.716h2.019c0.262 2.109 2.025 4.819 2.756 5.866zM9 12.009v-3.016c3.241-0.103 6.138-1.188 8.034-2.103 0.334-0.162 0.656-0.328 0.966-0.494v8.212c-0.309-0.166-0.631-0.331-0.966-0.494-1.897-0.919-4.794-2.003-8.034-2.106zM20 15.837c-0.303-0.213-0.637-0.434-1-0.653v-9.369c0.363-0.222 0.697-0.441 1-0.653v10.675zM23 12h-1v-3h1v3z" })
            );
        }
        function Megaphone2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Megaphone2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Megaphone2.SVG = Megaphone2SVG;
        return Megaphone2;
    })();
export const MenuCircle = /*#__PURE__*/ (() => {
        function MenuCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M7 8h10v2h-10v-2z" }),
_('path', { d: "M7 11h10v2h-10v-2z" }),
_('path', { d: "M7 14h10v2h-10v-2z" })
            );
        }
        function MenuCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MenuCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MenuCircle.SVG = MenuCircleSVG;
        return MenuCircle;
    })();
export const MenuSquare = /*#__PURE__*/ (() => {
        function MenuSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M7 8h10v2h-10v-2z" }),
_('path', { d: "M7 11h10v2h-10v-2z" }),
_('path', { d: "M7 14h10v2h-10v-2z" })
            );
        }
        function MenuSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MenuSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MenuSquare.SVG = MenuSquareSVG;
        return MenuSquare;
    })();
export const Menu = /*#__PURE__*/ (() => {
        function MenuSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 5h20v2h-20v-2z" }),
_('path', { d: "M2 11h20v2h-20v-2z" }),
_('path', { d: "M2 17h20v2h-20v-2z" })
            );
        }
        function Menu({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MenuSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Menu.SVG = MenuSVG;
        return Menu;
    })();
export const Menu2 = /*#__PURE__*/ (() => {
        function Menu2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 9c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM12 13c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M12 17c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM12 21c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M12 7c1.653 0 3-1.347 3-3s-1.347-3-3-3-3 1.347-3 3 1.347 3 3 3zM12 3c0.55 0 1 0.45 1 1s-0.45 1-1 1c-0.55 0-1-0.45-1-1s0.45-1 1-1z" })
            );
        }
        function Menu2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Menu2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Menu2.SVG = Menu2SVG;
        return Menu2;
    })();
export const Merge = /*#__PURE__*/ (() => {
        function MergeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 13.584v-10.169l3.544 3.544 1.416-1.416-5.25-5.25c-0.391-0.391-1.025-0.391-1.416 0l-5.25 5.25 1.416 1.416 3.541-3.544v10.584c0 0.266 0.106 0.519 0.294 0.706l9.25 9.25 1.416-1.416-8.959-8.956z" }),
_('path', { d: "M2.043 22.542l7.5-7.5 1.414 1.414-7.5 7.5-1.414-1.414z" })
            );
        }
        function Merge({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MergeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Merge.SVG = MergeSVG;
        return Merge;
    })();
export const Metronome = /*#__PURE__*/ (() => {
    function MetronomeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.206 4.5l2-2-0.706-0.706-2 2-0.647-0.647c-0.106-0.106-0.253-0.159-0.403-0.144s-0.284 0.097-0.366 0.219l-2 3c-0.131 0.197-0.106 0.462 0.063 0.631l0.147 0.147-2.131 2.131-1.747-6.638c-0.231-0.881-1.028-1.494-1.934-1.494h-3.959c-0.906 0-1.703 0.612-1.931 1.494l-4.475 16.997c-0.159 0.603-0.034 1.231 0.347 1.728s0.963 0.781 1.591 0.781h0.947v1h2v-1h7v1h2v-1h0.956c0.622 0 1.2-0.284 1.581-0.778s0.509-1.125 0.353-1.731l-2.434-9.241 2.544-2.544 0.147 0.147c0.097 0.097 0.225 0.147 0.353 0.147 0.097 0 0.194-0.028 0.278-0.084l3-2c0.125-0.084 0.206-0.219 0.219-0.366 0.016-0.15-0.038-0.297-0.144-0.403l-0.647-0.647zM7.522 3h3.959l2.044 7.766-3.525 3.528v-9.294h-1v2h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h-4.634l3.156-12zM3.050 20l1.053-4h10.8l1.053 4h-12.906zM14.637 15h-3.931l3.113-3.113 0.819 3.113zM18.563 6.856l-0.419-0.419 1.434-2.15 1.137 1.137-2.153 1.431z" })
        );
    }
    function Metronome({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MetronomeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Metronome.SVG = MetronomeSVG;
    return Metronome;
})();
export const MicCross = /*#__PURE__*/ (() => {
        function MicCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3 11v-1h2v1c0 2.756 2.244 5 5 5 1.756 0 3.369-0.922 4.269-2.394-0.319-0.116-0.625-0.256-0.916-0.419-0.731 1.119-1.984 1.812-3.353 1.812-2.206 0-4-1.794-4-4v-6c0-2.206 1.794-4 4-4 1.066 0 2.066 0.416 2.809 1.153 1.050-0.728 2.322-1.153 3.691-1.153 3.584 0 6.5 2.916 6.5 6.5s-2.916 6.5-6.5 6.5c-0.059 0-0.116 0-0.172-0.003-1.013 2.134-3.025 3.597-5.328 3.931v1.572c0 0.6 0.494 1.212 1.35 1.681 0.966 0.528 2.262 0.819 3.65 0.819v1h-12v-1c1.387 0 2.684-0.291 3.65-0.819 0.859-0.469 1.35-1.081 1.35-1.681v-1.572c-3.387-0.488-6-3.406-6-6.928zM8 5v6c0 1.103 0.897 2 2 2 0.744 0 1.416-0.409 1.763-1.053-1.094-1.166-1.763-2.728-1.763-4.447 0-1.494 0.506-2.872 1.356-3.969-0.366-0.341-0.847-0.531-1.356-0.531-1.103 0-2 0.897-2 2zM22 7.5c0-3.031-2.469-5.5-5.5-5.5s-5.5 2.469-5.5 5.5 2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5zM8.238 22h3.525c-1.094-0.631-1.762-1.512-1.762-2.5 0 0.987-0.669 1.869-1.763 2.5z" }),
_('path', { d: "M14.5 4.794l2 2 2-2 0.706 0.706-2 2 2 2-0.706 0.706-2-2-2 2-0.706-0.706 2-2-2-2z" })
            );
        }
        function MicCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MicCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MicCross.SVG = MicCrossSVG;
        return MicCross;
    })();
export const MicCross2 = /*#__PURE__*/ (() => {
        function MicCross2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.194 11.584c2.225-0.878 3.806-3.050 3.806-5.584 0-3.309-2.691-6-6-6-3.178 0-5.787 2.484-5.988 5.613l-9.522 11.028c-0.331 0.384-0.506 0.875-0.487 1.381s0.228 0.981 0.584 1.341l0.672 0.672-2.469 2.466 0.709 0.706 2.469-2.466 0.666 0.666c0.387 0.391 0.9 0.588 1.416 0.588 0.466 0 0.931-0.159 1.306-0.484l3.694-3.191c0.406 3.2 3.144 5.681 6.45 5.681 3.584 0 6.5-2.916 6.5-6.5 0-2.625-1.563-4.891-3.806-5.916zM15.375 2.984c0.041 0.009 0.081 0.016 0.125 0.016 0.263 0 0.478-0.203 0.5-0.462 0.378-0.219 0.797-0.378 1.244-0.466-0.144 0.087-0.241 0.247-0.241 0.428 0 0.275 0.225 0.5 0.5 0.5s0.5-0.225 0.5-0.5c0-0.231-0.156-0.425-0.369-0.484 0.122-0.012 0.247-0.016 0.369-0.016 0.394 0 0.772 0.056 1.131 0.162-0.081 0.087-0.131 0.206-0.131 0.337 0 0.275 0.225 0.5 0.5 0.5 0.262 0 0.481-0.203 0.5-0.462 0.606 0.353 1.113 0.859 1.466 1.466-0.259 0.019-0.462 0.234-0.462 0.5 0 0.275 0.225 0.5 0.5 0.5 0.131 0 0.247-0.050 0.338-0.131 0.106 0.359 0.162 0.738 0.162 1.131 0 0.125-0.006 0.247-0.016 0.369-0.056-0.213-0.253-0.369-0.484-0.369-0.275 0-0.5 0.225-0.5 0.5s0.225 0.5 0.5 0.5c0.181 0 0.341-0.097 0.428-0.241-0.084 0.444-0.244 0.862-0.466 1.244-0.259 0.019-0.462 0.234-0.462 0.5 0 0.044 0.006 0.084 0.016 0.125-0.734 0.841-1.812 1.375-3.016 1.375-1.031 0-1.972-0.391-2.681-1.034 0.056 0.022 0.116 0.034 0.181 0.034 0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5-0.5 0.225-0.5 0.5c0 0.063 0.012 0.125 0.034 0.181-0.65-0.716-1.041-1.656-1.041-2.688 0-1.203 0.534-2.281 1.375-3.016zM15.331 11.372c-0.531 0.188-1.031 0.447-1.491 0.759l-2.581-2.581 1.162-1.347c0.544 1.381 1.587 2.509 2.909 3.169zM11.337 15.431l-3.328 2.872-2.313-2.316 4.906-5.681 2.453 2.453c-0.775 0.728-1.372 1.644-1.719 2.672zM6.050 19.997l-2.047-2.047 1.038-1.2 2.209 2.209-1.2 1.038zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 14.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" }),
_('path', { d: "M15.5 4c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM15.5 6c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM17.5 4c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM17.5 6c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM19.5 4c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM19.5 6c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM17.5 8c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM19.5 8c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" })
            );
        }
        function MicCross2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MicCross2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MicCross2.SVG = MicCross2SVG;
        return MicCross2;
    })();
export const MicSettings = /*#__PURE__*/ (() => {
        function MicSettingsSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 11c0 2.756-2.244 5-5 5s-5-2.244-5-5v-1h-2v1c0 3.522 2.613 6.441 6 6.928v1.572c0 0.6-0.494 1.212-1.35 1.681-0.966 0.528-2.262 0.819-3.65 0.819v1h12v-1c-1.388 0-2.684-0.291-3.65-0.819-0.859-0.469-1.35-1.081-1.35-1.681v-1.572c3.387-0.488 6-3.406 6-6.928v-1h-2v1zM12.762 22h-3.525c1.094-0.631 1.762-1.512 1.762-2.5 0 0.987 0.669 1.869 1.763 2.5z" }),
_('path', { d: "M11 15c2.206 0 4-1.794 4-4v-1h-2v1c0 1.103-0.897 2-2 2s-2-0.897-2-2v-6c0-1.103 0.897-2 2-2s2 0.897 2 2h2c0-2.206-1.794-4-4-4s-4 1.794-4 4v6c0 2.206 1.794 4 4 4z" }),
_('path', { d: "M11 7.5c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5c-0.828 0-1.5 0.672-1.5 1.5zM13 7.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5z" }),
_('path', { d: "M16.5 6c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM16.5 8c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M20.5 6c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM20.5 8c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" })
            );
        }
        function MicSettings({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MicSettingsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MicSettings.SVG = MicSettingsSVG;
        return MicSettings;
    })();
export const MicTwoWay = /*#__PURE__*/ (() => {
        function MicTwoWaySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3 11v-1h2v1c0 2.756 2.244 5 5 5 1.756 0 3.366-0.922 4.269-2.394-0.319-0.116-0.622-0.256-0.916-0.419-0.728 1.119-1.981 1.812-3.353 1.812-2.206 0-4-1.794-4-4v-6c0-2.206 1.794-4 4-4 1.066 0 2.066 0.416 2.809 1.15 1.050-0.725 2.322-1.15 3.691-1.15 3.584 0 6.5 2.916 6.5 6.5s-2.916 6.5-6.5 6.5c-0.059 0-0.116 0-0.172-0.003-1.016 2.134-3.028 3.6-5.328 3.931v1.572c0 0.6 0.494 1.212 1.35 1.681 0.966 0.528 2.262 0.819 3.65 0.819v1h-12v-1c1.387 0 2.684-0.291 3.65-0.819 0.859-0.469 1.35-1.081 1.35-1.681v-1.572c-3.387-0.488-6-3.406-6-6.928zM8 5v6c0 1.103 0.897 2 2 2 0.744 0 1.419-0.406 1.763-1.053-1.091-1.162-1.763-2.728-1.763-4.447 0-1.494 0.506-2.872 1.356-3.972-0.366-0.338-0.847-0.528-1.356-0.528-1.103 0-2 0.897-2 2zM22 7.5c0-3.031-2.469-5.5-5.5-5.5s-5.5 2.469-5.5 5.5 2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5zM8.238 22h3.525c-1.094-0.631-1.762-1.512-1.762-2.5 0 0.987-0.669 1.869-1.763 2.5z" }),
_('path', { d: "M16.794 6.5l0.706 0.706 1.353-1.353c0.194-0.194 0.194-0.513 0-0.706l-1.353-1.353-0.706 0.706 0.5 0.5h-3.294v1h3.294l-0.5 0.5z" }),
_('path', { d: "M16.206 8.5l-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706-0.5-0.5h3.294v-1h-3.294l0.5-0.5z" })
            );
        }
        function MicTwoWay({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MicTwoWaySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MicTwoWay.SVG = MicTwoWaySVG;
        return MicTwoWay;
    })();
export const MicWarning = /*#__PURE__*/ (() => {
        function MicWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 11v-1h2v1c0 2.756 2.244 5 5 5 2.016 0 3.803-1.2 4.584-3h-1.119c-0.712 1.234-2.041 2-3.462 2-2.206 0-4-1.794-4-4v-6c0-2.206 1.794-4 4-4s4 1.794 4 4v0.147l1.159-2.316c0.247-0.506 0.772-0.831 1.338-0.831s1.091 0.325 1.341 0.828l4 7.997c0.103 0.206 0.159 0.438 0.159 0.672 0 0.828-0.672 1.5-1.5 1.5h-3.791c-0.784 2.634-3.031 4.544-5.709 4.928v1.575c0 0.6 0.494 1.212 1.35 1.681 0.966 0.528 2.262 0.819 3.65 0.819v1h-12v-1c1.387 0 2.684-0.291 3.65-0.819 0.859-0.469 1.35-1.081 1.35-1.681v-1.572c-3.387-0.488-6-3.406-6-6.928zM13 5c0-1.103-0.897-2-2-2s-2 0.897-2 2v6c0 1.103 0.897 2 2 2 0.506 0 0.991-0.194 1.356-0.531-0.222-0.263-0.356-0.6-0.356-0.969 0-0.234 0.056-0.466 0.159-0.672l0.841-1.681v-4.147zM22 11.5c0-0.078-0.019-0.153-0.050-0.219l-4.003-8.006c-0.081-0.166-0.256-0.275-0.447-0.275s-0.363 0.109-0.447 0.278l-4.003 8.003c-0.034 0.066-0.050 0.141-0.050 0.219 0 0.275 0.225 0.5 0.5 0.5h8c0.275 0 0.5-0.225 0.5-0.5zM9.237 22h3.525c-1.094-0.631-1.763-1.512-1.763-2.5 0 0.987-0.669 1.869-1.762 2.5z" }),
_('path', { d: "M18 10h-1v1h1v-1z" }),
_('path', { d: "M18 5h-1v4h1v-4z" })
            );
        }
        function MicWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MicWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MicWarning.SVG = MicWarningSVG;
        return MicWarning;
    })();
export const MicWarning2 = /*#__PURE__*/ (() => {
        function MicWarning2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6c0-3.309-2.691-6-6-6-3.178 0-5.787 2.484-5.988 5.613l-9.522 11.028c-0.331 0.384-0.506 0.875-0.487 1.381s0.228 0.981 0.584 1.341l0.672 0.672-2.469 2.466 0.709 0.706 2.469-2.466 0.666 0.666c0.387 0.391 0.9 0.588 1.416 0.588 0.466 0 0.931-0.159 1.306-0.484l11.028-9.522c3.131-0.2 5.616-2.809 5.616-5.988zM15.375 2.984c0.041 0.009 0.081 0.016 0.125 0.016 0.263 0 0.478-0.203 0.5-0.462 0.378-0.219 0.797-0.378 1.244-0.466-0.144 0.087-0.241 0.247-0.241 0.428 0 0.275 0.225 0.5 0.5 0.5s0.5-0.225 0.5-0.5c0-0.231-0.156-0.425-0.369-0.484 0.122-0.012 0.247-0.016 0.369-0.016 0.394 0 0.772 0.056 1.131 0.162-0.081 0.087-0.131 0.206-0.131 0.337 0 0.275 0.225 0.5 0.5 0.5 0.262 0 0.481-0.203 0.5-0.462 0.606 0.353 1.113 0.859 1.466 1.466-0.259 0.019-0.462 0.234-0.462 0.5 0 0.275 0.225 0.5 0.5 0.5 0.131 0 0.247-0.050 0.338-0.131 0.106 0.359 0.162 0.738 0.162 1.131 0 0.125-0.006 0.247-0.016 0.369-0.056-0.213-0.253-0.369-0.484-0.369-0.275 0-0.5 0.225-0.5 0.5s0.225 0.5 0.5 0.5c0.181 0 0.341-0.097 0.428-0.241-0.084 0.444-0.244 0.862-0.466 1.244-0.259 0.019-0.462 0.234-0.462 0.5 0 0.044 0.006 0.084 0.016 0.125-0.734 0.841-1.812 1.375-3.016 1.375-1.031 0-1.972-0.391-2.681-1.034 0.056 0.022 0.116 0.034 0.181 0.034 0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5-0.5 0.225-0.5 0.5c0 0.063 0.012 0.125 0.034 0.181-0.65-0.716-1.041-1.656-1.041-2.688 0-1.203 0.534-2.281 1.375-3.016zM15.797 11.581l-1.347 1.162-3.194-3.194 1.162-1.347c0.609 1.541 1.837 2.769 3.378 3.378zM13.691 13.4l-5.681 4.906-2.316-2.316 4.906-5.681 3.091 3.091zM6.050 19.997l-2.047-2.047 1.038-1.2 2.209 2.209-1.2 1.038c0 0 0 0 0 0z" }),
_('path', { d: "M18 21h1v1h-1v-1z" }),
_('path', { d: "M18 16h1v4h-1v-4z" }),
_('path', { d: "M19.841 13.831c-0.25-0.506-0.778-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-4 7.997c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h8c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672l-4-7.994zM22.5 23h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M15 4.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5zM15.5 7c0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5-0.5 0.225-0.5 0.5 0.225 0.5 0.5 0.5zM17.5 5c0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5-0.5 0.225-0.5 0.5 0.225 0.5 0.5 0.5zM17.5 7c0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5-0.5 0.225-0.5 0.5 0.225 0.5 0.5 0.5zM19.5 5c0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5-0.5 0.225-0.5 0.5 0.225 0.5 0.5 0.5zM19.5 7c0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5-0.5 0.225-0.5 0.5 0.225 0.5 0.5 0.5zM17.5 9c0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5-0.5 0.225-0.5 0.5 0.225 0.5 0.5 0.5zM19.5 9c0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5-0.5 0.225-0.5 0.5 0.225 0.5 0.5 0.5z" })
            );
        }
        function MicWarning2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MicWarning2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MicWarning2.SVG = MicWarning2SVG;
        return MicWarning2;
    })();
export const Mic = /*#__PURE__*/ (() => {
        function MicSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 11v-1h-2v1c0 2.756-2.244 5-5 5s-5-2.244-5-5v-1h-2v1c0 3.522 2.613 6.441 6 6.928v1.572c0 0.6-0.494 1.212-1.35 1.681-0.966 0.528-2.262 0.819-3.65 0.819v1h12v-1c-1.387 0-2.684-0.291-3.65-0.819-0.859-0.469-1.35-1.081-1.35-1.681v-1.572c3.387-0.488 6-3.406 6-6.928zM13.763 22h-3.525c1.094-0.631 1.763-1.512 1.763-2.5 0 0.987 0.669 1.869 1.762 2.5z" }),
_('path', { d: "M12 15c2.206 0 4-1.794 4-4v-6c0-2.206-1.794-4-4-4s-4 1.794-4 4v6c0 2.206 1.794 4 4 4zM10 5c0-1.103 0.897-2 2-2s2 0.897 2 2v6c0 1.103-0.897 2-2 2s-2-0.897-2-2v-6z" })
            );
        }
        function Mic({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MicSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Mic.SVG = MicSVG;
        return Mic;
    })();
export const Mic2 = /*#__PURE__*/ (() => {
        function Mic2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6c0-3.309-2.691-6-6-6-3.178 0-5.787 2.484-5.988 5.613l-9.522 11.028c-0.331 0.384-0.506 0.875-0.487 1.381s0.228 0.981 0.584 1.341l0.672 0.672-2.469 2.466 0.709 0.706 2.469-2.466 0.666 0.666c0.387 0.391 0.9 0.588 1.416 0.588 0.466 0 0.931-0.159 1.306-0.484l11.028-9.522c3.131-0.2 5.616-2.809 5.616-5.988zM15.797 11.581l-1.347 1.162-3.194-3.194 1.162-1.347c0.609 1.541 1.837 2.769 3.378 3.378zM13.691 13.4l-5.681 4.906-2.316-2.316 4.906-5.681 3.091 3.091zM6.050 19.997l-2.047-2.047 1.038-1.2 2.209 2.209-1.2 1.038c0 0 0 0 0 0zM21.984 6.369c-0.056-0.213-0.253-0.369-0.484-0.369-0.275 0-0.5 0.225-0.5 0.5s0.225 0.5 0.5 0.5c0.181 0 0.341-0.097 0.428-0.241-0.084 0.444-0.244 0.862-0.466 1.244-0.259 0.019-0.462 0.234-0.462 0.5 0 0.044 0.006 0.084 0.016 0.125-0.734 0.841-1.812 1.375-3.016 1.375-1.031 0-1.972-0.391-2.681-1.034 0.056 0.022 0.116 0.034 0.181 0.034 0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5-0.5 0.225-0.5 0.5c0 0.063 0.012 0.125 0.034 0.181-0.644-0.713-1.034-1.653-1.034-2.684 0-1.203 0.534-2.281 1.375-3.016 0.041 0.009 0.081 0.016 0.125 0.016 0.263 0 0.478-0.203 0.5-0.462 0.378-0.219 0.797-0.378 1.244-0.466-0.144 0.087-0.241 0.247-0.241 0.428 0 0.275 0.225 0.5 0.5 0.5s0.5-0.225 0.5-0.5c0-0.231-0.156-0.425-0.369-0.484 0.122-0.012 0.247-0.016 0.369-0.016 0.394 0 0.772 0.056 1.131 0.162-0.081 0.087-0.131 0.206-0.131 0.338 0 0.275 0.225 0.5 0.5 0.5 0.262 0 0.481-0.203 0.5-0.462 0.606 0.353 1.113 0.859 1.466 1.466-0.259 0.019-0.462 0.234-0.462 0.5 0 0.275 0.225 0.5 0.5 0.5 0.131 0 0.247-0.050 0.338-0.131 0.106 0.359 0.162 0.738 0.162 1.131-0.006 0.122-0.012 0.244-0.022 0.366z" }),
_('path', { d: "M16 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M16 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M18 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M18 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M20 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M20 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M18 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M20 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Mic2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Mic2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Mic2.SVG = Mic2SVG;
        return Mic2;
    })();
export const Microscope = /*#__PURE__*/ (() => {
        function MicroscopeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2.747 10.825c-0.078 0.206-0.147 0.416-0.213 0.628-1.5 0.731-2.534 2.272-2.534 4.047 0 2.019 1.338 3.731 3.169 4.3 0.031 0.066 0.066 0.134 0.1 0.2h-1.269c-1.103 0-2 0.897-2 2v1.5c0 0.275 0.225 0.5 0.5 0.5h23c0.275 0 0.5-0.225 0.5-0.5v-1.5c0-1.103-0.897-2-2-2h-11.319c-0.775-0.516-1.416-1.197-1.878-2h12.697c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5h-12.528c-0.078-0.691-0.312-1.338-0.666-1.897 0.819-2.456 3.103-4.103 5.694-4.103v1c0 1.103 0.897 2 2 2v1.5c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-1.5c1.103 0 2-0.897 2-2v-7c0-1.103-0.897-2-2-2v-0.5c0-0.275-0.225-0.5-0.5-0.5h-2c-0.275 0-0.5 0.225-0.5 0.5v0.5c-1.103 0-2 0.897-2 2-2.591 0-5.056 0.813-7.131 2.347-0.997 0.738-1.872 1.625-2.6 2.631-0.638 0.878-1.147 1.834-1.522 2.847zM21 17h-12.256c0.113-0.319 0.191-0.653 0.228-1h12.028v1zM18 13h-1v-1h1v1zM19 10h-3v-5h3v5c0 0 0 0 0 0zM19 3v1h-3v-1h3zM14 5v2c-1.719 0-3.353 0.537-4.734 1.55-1.091 0.803-1.947 1.847-2.512 3.056-0.575-0.334-1.228-0.544-1.928-0.594 1.572-3.634 5.147-6.012 9.175-6.012zM1 15.5c0-1.931 1.569-3.5 3.5-3.5s3.5 1.569 3.5 3.5-1.569 3.5-3.5 3.5-3.5-1.569-3.5-3.5zM2 23v-1h2.997c0.366 0 0.703-0.2 0.878-0.525s0.159-0.716-0.041-1.022c-0.122-0.188-0.237-0.375-0.35-0.563 0.609-0.138 1.175-0.397 1.662-0.756 0.672 1.113 1.6 2.044 2.725 2.722 0.156 0.094 0.334 0.144 0.516 0.144h11.613v1h-20z" }),
_('path', { d: "M6 15.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5zM4 15.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5z" })
            );
        }
        function Microscope({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MicroscopeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Microscope.SVG = MicroscopeSVG;
        return Microscope;
    })();
export const MicrosdPlus = /*#__PURE__*/ (() => {
        function MicrosdPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 4h1v3h-1v-3z" }),
_('path', { d: "M10 3h1v4h-1v-4z" }),
_('path', { d: "M12 4h1v3h-1v-3z" }),
_('path', { d: "M14 3h1v4h-1v-4z" }),
_('path', { d: "M16 4h1v3h-1v-3z" }),
_('path', { d: "M19.997 12.022v-10.022c0-1.103-0.897-2-2-2h-10.997c-1.103 0-2 0.897-2 2v4.587l-2.416 2.416c-0.378 0.378-0.588 0.881-0.588 1.413v1.584c0 0.266 0.106 0.519 0.294 0.706s0.441 0.294 0.706 0.294h1.003v0.584l-1.709 1.706c-0.188 0.188-0.294 0.441-0.294 0.706v6c0 1.103 0.897 2 2 2h12.503c3.584 0 6.5-2.916 6.5-6.5 0-2.294-1.2-4.319-3.003-5.475zM3.997 16.416l1.709-1.706c0.188-0.188 0.294-0.441 0.294-0.706v-2c0-0.266-0.106-0.519-0.294-0.706s-0.441-0.294-0.706-0.294h-1.003v-0.584l2.416-2.416c0.372-0.372 0.588-0.891 0.588-1.416v-4.587h10.997v9.175c-0.481-0.112-0.981-0.175-1.497-0.175-3.584 0-6.5 2.916-6.5 6.5 0 1.744 0.691 3.331 1.812 4.5h-7.816v-5.584zM16.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17 15h-1v2h-2v1h2v2h1v-2h2v-1h-2z" })
            );
        }
        function MicrosdPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MicrosdPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MicrosdPlus.SVG = MicrosdPlusSVG;
        return MicrosdPlus;
    })();
export const Microsd = /*#__PURE__*/ (() => {
        function MicrosdSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.997 0h-10.997c-1.103 0-2 0.897-2 2v4.587l-2.416 2.416c-0.378 0.378-0.588 0.881-0.588 1.413v1.584c0 0.266 0.106 0.519 0.294 0.706s0.441 0.294 0.706 0.294h1.003v0.584l-1.709 1.706c-0.188 0.188-0.294 0.441-0.294 0.706v6c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-19.997c0-1.103-0.897-2-2-2zM18.997 22h-14v-5.584l1.709-1.706c0.188-0.188 0.294-0.441 0.294-0.706v-2c0-0.266-0.106-0.519-0.294-0.706s-0.441-0.294-0.706-0.294h-1.003v-0.584l2.416-2.416c0.372-0.372 0.588-0.891 0.588-1.416v-4.587h10.997v20z" }),
_('path', { d: "M9 4h1v3h-1v-3z" }),
_('path', { d: "M11 3h1v4h-1v-4z" }),
_('path', { d: "M13 4h1v3h-1v-3z" }),
_('path', { d: "M15 3h1v4h-1v-4z" }),
_('path', { d: "M17 4h1v3h-1v-3z" })
            );
        }
        function Microsd({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MicrosdSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Microsd.SVG = MicrosdSVG;
        return Microsd;
    })();
export const Microwave = /*#__PURE__*/ (() => {
        function MicrowaveSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 3h-20c-1.103 0-2 0.897-2 2v13c0 1.103 0.897 2 2 2h1v0.5c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-0.5h12v0.5c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-0.5h1c1.103 0 2-0.897 2-2v-13c0-1.103-0.897-2-2-2zM22 18h-20v-13h20v13z" }),
_('path', { d: "M3.5 17h13c0.275 0 0.5-0.225 0.5-0.5v-10c0-0.275-0.225-0.5-0.5-0.5h-13c-0.275 0-0.5 0.225-0.5 0.5v10c0 0.275 0.225 0.5 0.5 0.5zM4 7h12v9h-12v-9z" }),
_('path', { d: "M13.234 12.566c-0.406 0.231-0.756 0.434-1.497 0.434s-1.091-0.2-1.497-0.434c-0.462-0.266-0.987-0.566-1.994-0.566s-1.531 0.3-1.994 0.566l-0.434 0.25 0.497 0.869 0.434-0.25c0.406-0.234 0.756-0.434 1.497-0.434s1.091 0.2 1.497 0.434c0.462 0.266 0.987 0.566 1.994 0.566s1.531-0.3 1.994-0.566l0.434-0.25-0.497-0.869-0.434 0.25z" }),
_('path', { d: "M13.234 9.566c-0.406 0.234-0.756 0.434-1.497 0.434s-1.091-0.2-1.497-0.434c-0.462-0.266-0.987-0.566-1.994-0.566s-1.531 0.3-1.994 0.566l-0.434 0.25 0.497 0.869 0.434-0.25c0.406-0.234 0.756-0.434 1.497-0.434s1.091 0.2 1.497 0.434c0.462 0.266 0.987 0.566 1.994 0.566s1.531-0.3 1.994-0.566l0.434-0.25-0.497-0.869-0.434 0.25z" }),
_('path', { d: "M19.5 10c0.828 0 1.5-0.672 1.5-1.5 0-0.653-0.419-1.209-1-1.416v-1.084h-1v1.084c-0.581 0.206-1 0.762-1 1.416 0 0.828 0.672 1.5 1.5 1.5zM19.5 8c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M18 13h3v1h-3v-1z" }),
_('path', { d: "M18 15h3v1h-3v-1z" })
            );
        }
        function Microwave({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MicrowaveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Microwave.SVG = MicrowaveSVG;
        return Microwave;
    })();
export const MilkBottle = /*#__PURE__*/ (() => {
    function MilkBottleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17.497 7.984c-0.331-1.131-0.797-1.734-1.209-2.266-0.469-0.603-0.912-1.175-1.212-2.834 0.544-0.225 0.925-0.762 0.925-1.384 0-0.828-0.672-1.5-1.5-1.5h-5c-0.828 0-1.5 0.672-1.5 1.5 0 0.622 0.381 1.159 0.925 1.384-0.303 1.659-0.747 2.231-1.212 2.834-0.413 0.531-0.878 1.131-1.209 2.266-0.344 1.169-0.503 2.763-0.503 5.016v9c0 1.103 0.897 2 2 2h8c1.103 0 2-0.897 2-2v-9c0-2.253-0.159-3.847-0.503-5.016zM16 13v6h-8v-6c0-0.772 0.019-1.431 0.056-2h7.891c0.034 0.569 0.053 1.228 0.053 2zM8.144 10c0.222-1.859 0.675-2.444 1.15-3.053 0.591-0.762 1.256-1.622 1.641-3.947h2.131c0.384 2.325 1.050 3.184 1.641 3.947 0.472 0.609 0.925 1.194 1.15 3.053h-7.713zM9.5 1h5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-5c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5zM8 22v-2h8v2h-8z" })
        );
    }
    function MilkBottle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MilkBottleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MilkBottle.SVG = MilkBottleSVG;
    return MilkBottle;
})();
export const MinusCircle = /*#__PURE__*/ (() => {
        function MinusCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M8 11h8v2h-8v-2z" })
            );
        }
        function MinusCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MinusCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MinusCircle.SVG = MinusCircleSVG;
        return MinusCircle;
    })();
export const MinusSquare = /*#__PURE__*/ (() => {
        function MinusSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M8 11h8v2h-8v-2z" })
            );
        }
        function MinusSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MinusSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MinusSquare.SVG = MinusSquareSVG;
        return MinusSquare;
    })();
export const Minus = /*#__PURE__*/ (() => {
    function MinusSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2 11h20v2h-20v-2z" })
        );
    }
    function Minus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Minus.SVG = MinusSVG;
    return Minus;
})();
export const Mirror = /*#__PURE__*/ (() => {
        function MirrorSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 14c1.638 0 3.166-0.753 4.303-2.116 1.094-1.313 1.697-3.047 1.697-4.884s-0.603-3.569-1.697-4.884c-1.137-1.362-2.666-2.116-4.303-2.116s-3.166 0.753-4.303 2.116c-1.094 1.313-1.697 3.047-1.697 4.884s0.603 3.569 1.697 4.884c1.137 1.362 2.666 2.116 4.303 2.116zM12 2c2.206 0 4 2.244 4 5s-1.794 5-4 5c-2.206 0-4-2.244-4-5s1.794-5 4-5z" }),
_('path', { d: "M11.793 8.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M9.792 7.5l3.708-3.708 0.707 0.707-3.708 3.708-0.707-0.707z" }),
_('path', { d: "M13 20.5v-4.569c1.769-0.247 3.403-1.144 4.678-2.591 1.497-1.697 2.322-3.947 2.322-6.341h-1c0 4.413-3.141 8-7 8s-7-3.588-7-8h-1c0 2.394 0.825 4.644 2.322 6.341 1.275 1.447 2.909 2.344 4.678 2.591v4.569c0 0.6-0.494 1.212-1.35 1.681-0.966 0.528-2.262 0.819-3.65 0.819v1h12v-1c-1.388 0-2.684-0.291-3.65-0.819-0.856-0.469-1.35-1.081-1.35-1.681zM10.238 23c1.094-0.631 1.762-1.512 1.762-2.5 0 0.987 0.669 1.869 1.763 2.5h-3.525z" })
            );
        }
        function Mirror({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MirrorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Mirror.SVG = MirrorSVG;
        return Mirror;
    })();
export const MissedIncoming = /*#__PURE__*/ (() => {
        function MissedIncomingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.913 16.984c-0.659-1.097-1.603-2.047-2.803-2.825-2.153-1.394-5.028-2.163-8.1-2.163h-0.006c-3.072 0-5.95 0.769-8.106 2.159-1.203 0.778-2.147 1.728-2.809 2.825-0.719 1.203-1.088 2.556-1.088 4.022 0 0.003 0 0.003 0 0.006l0.006 0.991c0.003 1.103 0.884 2 1.972 2l5.053-0.003c0.522 0 1.013-0.206 1.381-0.578 0.378-0.381 0.584-0.888 0.581-1.428v-0.703c0-0.331-0.081-0.663-0.237-0.956 0 0-0.003-0.003-0.003-0.003-0.097-0.181-0.309-0.816-0.006-1.325 0.384-0.644 1.538-1 3.241-1h0.006c1.709 0 2.862 0.356 3.247 1 0.303 0.509 0.091 1.147-0.006 1.328-0.003 0.006-0.006 0.012-0.009 0.019-0.153 0.3-0.231 0.619-0.231 0.941v0.706c0 1.103 0.884 2.003 1.972 2.003l5.053-0.003c1.088 0 1.972-0.897 1.972-2l0.009-0.997c0-1.462-0.366-2.816-1.087-4.016zM6.997 21.997l-4.991 0.003c0 0 0-0.003 0-0.003 0-0.003 0-0.003 0-0.006l-0.006-0.991c0 0 0 0 0 0h4.866c0.041 0.1 0.084 0.191 0.125 0.269 0.003 0.006 0.003 0.012 0.003 0.019v0.709zM12 16h-0.009c-2.506 0-4.175 0.663-4.959 1.975-0.406 0.681-0.484 1.406-0.419 2.025h-4.531c0.344-2.084 1.722-3.397 2.903-4.163 1.809-1.169 4.369-1.841 7.019-1.841h0.003c2.65 0 5.206 0.672 7.016 1.841 1.181 0.762 2.556 2.078 2.897 4.163h-4.538c0.069-0.622-0.009-1.344-0.416-2.025-0.784-1.309-2.453-1.975-4.966-1.975zM21.997 21.994c0 0 0 0.003 0 0.003l-4.997 0.003c0 0 0-0.003 0-0.003v-0.706c0-0.003 0.003-0.012 0.009-0.028 0.041-0.078 0.081-0.166 0.122-0.263h4.869l-0.003 0.991v0.003z" }),
_('path', { d: "M5 3.416l6.294 6.294c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l7.25-7.25-1.416-1.416-6.541 6.541-5.584-5.584h3.584v-2h-6c-0.553 0-1 0.447-1 1v6h2v-3.584z" })
            );
        }
        function MissedIncoming({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MissedIncomingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MissedIncoming.SVG = MissedIncomingSVG;
        return MissedIncoming;
    })();
export const MissedIncoming2 = /*#__PURE__*/ (() => {
    function MissedIncoming2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.544 7.044l-9.544 9.541-9.584-9.584h4.584v-2h-7c-0.553 0-1 0.447-1 1v7h2v-4.584l10.294 10.294c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l10.25-10.25-1.413-1.416z" })
        );
    }
    function MissedIncoming2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MissedIncoming2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MissedIncoming2.SVG = MissedIncoming2SVG;
    return MissedIncoming2;
})();
export const MissedOutgoing = /*#__PURE__*/ (() => {
        function MissedOutgoingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1.087 16.984c0.659-1.097 1.603-2.047 2.803-2.825 2.153-1.394 5.028-2.163 8.1-2.163h0.006c3.072 0 5.95 0.769 8.106 2.159 1.203 0.778 2.147 1.728 2.809 2.825 0.719 1.203 1.087 2.556 1.087 4.022 0 0.003 0 0.003 0 0.006l-0.006 0.991c-0.003 1.103-0.884 2-1.972 2l-5.053-0.003c-0.522 0-1.013-0.206-1.381-0.578-0.378-0.381-0.584-0.888-0.581-1.428v-0.703c0-0.331 0.081-0.663 0.237-0.956 0 0 0.003-0.003 0.003-0.003 0.097-0.181 0.309-0.816 0.006-1.325-0.384-0.644-1.538-1-3.241-1h-0.006c-1.709 0-2.862 0.356-3.247 1-0.303 0.509-0.091 1.147 0.006 1.328 0.003 0.006 0.006 0.012 0.009 0.019 0.153 0.3 0.231 0.619 0.231 0.941v0.706c0 1.103-0.884 2.003-1.972 2.003l-5.053-0.003c-1.087 0-1.972-0.897-1.972-2l-0.009-0.997c0-1.462 0.366-2.816 1.088-4.016zM17.003 21.997l4.991 0.003c0 0 0-0.003 0-0.003 0-0.003 0-0.003 0-0.006l0.006-0.991c0 0 0 0 0 0h-4.866c-0.041 0.1-0.084 0.191-0.125 0.269-0.003 0.006-0.003 0.012-0.003 0.019v0.709zM12 16h0.009c2.506 0 4.175 0.663 4.959 1.975 0.406 0.681 0.484 1.406 0.419 2.025h4.531c-0.344-2.084-1.722-3.397-2.903-4.163-1.809-1.169-4.369-1.841-7.019-1.841h-0.003c-2.65 0-5.206 0.672-7.016 1.841-1.181 0.762-2.556 2.078-2.897 4.163h4.537c-0.069-0.622 0.009-1.344 0.416-2.025 0.784-1.309 2.453-1.975 4.966-1.975zM2.003 21.994c0 0 0 0.003 0 0.003l4.997 0.003c0 0 0-0.003 0-0.003v-0.706c0-0.003-0.003-0.012-0.009-0.028-0.041-0.078-0.081-0.166-0.122-0.263h-4.869l0.003 0.991v0.003z" }),
_('path', { d: "M19 3.416l-6.294 6.294c-0.194 0.194-0.45 0.294-0.706 0.294s-0.513-0.097-0.706-0.294l-7.25-7.25 1.416-1.416 6.541 6.541 5.584-5.584h-3.584v-2h6c0.553 0 1 0.447 1 1v6h-2v-3.584z" })
            );
        }
        function MissedOutgoing({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MissedOutgoingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MissedOutgoing.SVG = MissedOutgoingSVG;
        return MissedOutgoing;
    })();
export const MissedOutgoing2 = /*#__PURE__*/ (() => {
    function MissedOutgoing2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23 5h-7v2h4.584l-9.584 9.584-9.544-9.541-1.413 1.413 10.25 10.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l10.294-10.291v4.584h2v-7c0-0.553-0.447-1-1-1z" })
        );
    }
    function MissedOutgoing2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MissedOutgoing2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MissedOutgoing2.SVG = MissedOutgoing2SVG;
    return MissedOutgoing2;
})();
export const Mixer = /*#__PURE__*/ (() => {
        function MixerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 9c1.103 0 2-0.897 2-2v-2c0-2.756-2.244-5-5-5h-12c-1.869 0-3.628 0.728-4.95 2.050s-2.050 3.081-2.050 4.95c0 1.103 0.897 2 2 2h2v9c0 1.103-0.897 2-2 2s-2 0.897-2 2v1.5c0 0.275 0.225 0.5 0.5 0.5h23c0.275 0 0.5-0.225 0.5-0.5v-1.5c0-1.103-0.897-2-2-2h-6c-2.756 0-5-2.244-5-5v-6h7v1.038c-0.881 0.131-1.625 0.622-2.166 1.437-0.537 0.803-0.834 1.878-0.834 3.025s0.297 2.222 0.834 3.028c0.644 0.963 1.566 1.472 2.666 1.472s2.025-0.509 2.666-1.472c0.537-0.806 0.834-1.881 0.834-3.028s-0.297-2.222-0.834-3.028c-0.544-0.813-1.284-1.303-2.166-1.437v-1.034h3zM16 14.5c0-0.938 0.244-1.838 0.666-2.472 0.35-0.525 0.797-0.853 1.334-0.972v6.891c-1.369-0.319-2-1.934-2-3.447zM21 14.5c0 0.938-0.244 1.837-0.666 2.472-0.35 0.525-0.797 0.853-1.334 0.972v-6.888c1.369 0.316 2 1.931 2 3.444zM7 2h12c1.653 0 3 1.347 3 3v2h-20c0-2.756 2.244-5 5-5zM22 22v1h-20v-1h20zM11.050 19.95c0.016 0.016 0.034 0.034 0.050 0.050h-5.637c0.341-0.588 0.537-1.272 0.537-2v-9h3v6c0 1.869 0.728 3.628 2.050 4.95z" }),
_('path', { d: "M8 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Mixer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MixerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Mixer.SVG = MixerSVG;
        return Mixer;
    })();
export const MoneyPouchEuro = /*#__PURE__*/ (() => {
        function MoneyPouchEuroSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9.291 15h-1.291v1h1.028c-0.019 0.162-0.028 0.328-0.028 0.5s0.009 0.337 0.028 0.5h-1.028v1h1.291c0.519 1.225 1.697 2 3.209 2 1.684 0 2.403-1.197 2.431-1.247l0.253-0.431-0.862-0.506-0.253 0.431c-0.003 0.006-0.469 0.753-1.569 0.753-0.928 0-1.656-0.369-2.081-1h2.581v-1h-2.962c-0.025-0.159-0.038-0.325-0.038-0.5s0.012-0.341 0.038-0.5h2.962v-1h-2.581c0.425-0.631 1.153-1 2.081-1 1.081 0 1.544 0.712 1.572 0.756l0.25 0.428 0.862-0.506-0.253-0.431c-0.031-0.050-0.75-1.247-2.431-1.247-1.512 0-2.688 0.775-3.209 2z" }),
_('path', { d: "M20.834 5.128c-0.963-0.869-2.091-1.253-3.263-1.106-1.166 0.147-2.209 0.791-2.925 1.512-0.159-0.188-0.363-0.338-0.594-0.428 0.103-0.397 0.353-0.869 0.722-1.362 0.438-0.584 0.888-0.997 0.891-1 0.228-0.203 0.347-0.503 0.328-0.806-0.019-0.306-0.178-0.584-0.428-0.756-1.141-0.791-2.013-1.15-2.831-1.166-0.831-0.016-1.425 0.341-1.903 0.628-0.641 0.384-1.197 0.716-2.609 0.387-0.434-0.1-0.884 0.097-1.1 0.487-0.219 0.391-0.15 0.878 0.166 1.194 0.597 0.6 1.403 1.647 1.641 2.406-0.544 0.219-0.928 0.756-0.928 1.381 0 0.563 0.312 1.053 0.772 1.309-0.572 1.141-1.503 2.341-2.406 3.506-1.656 2.141-3.366 4.35-3.366 6.684 0 0.916 0.216 1.766 0.637 2.531 0.412 0.747 1.016 1.394 1.794 1.922 1.491 1.012 3.591 1.547 6.069 1.547s4.578-0.534 6.069-1.547c0.775-0.528 1.378-1.172 1.794-1.922 0.422-0.766 0.638-1.616 0.638-2.531 0-2.334-1.709-4.544-3.366-6.681-0.903-1.169-1.834-2.369-2.406-3.506 0.328-0.184 0.581-0.484 0.7-0.847 1.528-0.091 2.547 0.481 3.119 1.744l0.206 0.456 0.912-0.412-0.206-0.456c-0.472-1.050-1.209-1.756-2.191-2.1-0.344-0.122-0.712-0.197-1.109-0.225 0.547-0.462 1.269-0.853 2.041-0.95 0.888-0.112 1.719 0.175 2.469 0.853l0.372 0.334 0.672-0.741-0.378-0.341zM13.5 7h-4c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h4c0.275 0 0.5 0.225 0.5 0.5 0 0 0 0 0 0s0 0 0 0c0 0.275-0.225 0.5-0.5 0.5zM11.862 2.356c0.391-0.234 0.591-0.347 0.837-0.344 0.194 0.003 0.434 0.075 0.725 0.209-0.572 0.7-1.222 1.703-1.388 2.778h-1.084c-0.1-0.584-0.375-1.228-0.816-1.919 0.756-0.144 1.287-0.462 1.725-0.725zM18 18c0 2.469-2.491 4-6.5 4s-6.5-1.531-6.5-4c0-1.65 1.497-3.584 2.947-5.456 1.137-1.469 2.309-2.984 2.931-4.544h1.244c0.622 1.559 1.797 3.075 2.931 4.544 1.45 1.872 2.947 3.806 2.947 5.456z" })
            );
        }
        function MoneyPouchEuro({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MoneyPouchEuroSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MoneyPouchEuro.SVG = MoneyPouchEuroSVG;
        return MoneyPouchEuro;
    })();
export const MoneyPouchPound = /*#__PURE__*/ (() => {
        function MoneyPouchPoundSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.497 14.356c-0.247 0.494-0.35 1.062-0.406 1.644h-1.091v1h1.025c-0.091 1.544-0.253 2-1.025 2v1h5v-1h-3.328c0.019-0.037 0.034-0.075 0.050-0.112 0.222-0.537 0.266-1.194 0.303-1.887h1.975v-1h-1.9c0.134-1.259 0.488-2 1.9-2h1v-1h-1c-1.212 0-2.053 0.456-2.503 1.356z" }),
_('path', { d: "M20.834 5.128c-0.963-0.869-2.091-1.253-3.263-1.106-1.166 0.147-2.209 0.791-2.925 1.512-0.159-0.188-0.363-0.338-0.594-0.428 0.103-0.397 0.353-0.869 0.722-1.362 0.438-0.584 0.888-0.997 0.891-1 0.228-0.203 0.347-0.503 0.328-0.806-0.019-0.306-0.178-0.584-0.428-0.756-1.141-0.791-2.013-1.15-2.831-1.166-0.831-0.016-1.425 0.341-1.903 0.628-0.641 0.384-1.197 0.716-2.609 0.387-0.434-0.1-0.884 0.097-1.1 0.487-0.219 0.391-0.15 0.878 0.166 1.194 0.597 0.6 1.403 1.647 1.641 2.406-0.544 0.219-0.928 0.756-0.928 1.381 0 0.563 0.312 1.053 0.772 1.309-0.572 1.141-1.503 2.341-2.406 3.506-1.656 2.141-3.366 4.35-3.366 6.684 0 0.916 0.216 1.766 0.637 2.531 0.412 0.747 1.016 1.394 1.794 1.922 1.491 1.012 3.591 1.547 6.069 1.547s4.578-0.534 6.069-1.547c0.775-0.528 1.378-1.172 1.794-1.922 0.422-0.766 0.638-1.616 0.638-2.531 0-2.334-1.709-4.544-3.366-6.681-0.903-1.169-1.834-2.369-2.406-3.506 0.328-0.184 0.581-0.484 0.7-0.847 1.528-0.091 2.547 0.481 3.119 1.744l0.206 0.456 0.912-0.412-0.206-0.456c-0.472-1.050-1.209-1.756-2.191-2.1-0.344-0.122-0.712-0.197-1.109-0.225 0.547-0.462 1.269-0.853 2.041-0.95 0.888-0.112 1.719 0.175 2.469 0.853l0.372 0.334 0.672-0.741-0.378-0.341zM13.5 7h-4c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h4c0.275 0 0.5 0.225 0.5 0.5 0 0 0 0 0 0s0 0 0 0c0 0.275-0.225 0.5-0.5 0.5zM11.862 2.356c0.391-0.234 0.591-0.347 0.837-0.344 0.194 0.003 0.434 0.075 0.725 0.209-0.572 0.7-1.222 1.703-1.388 2.778h-1.084c-0.1-0.584-0.375-1.228-0.816-1.919 0.756-0.144 1.287-0.462 1.725-0.725zM18 18c0 2.469-2.491 4-6.5 4s-6.5-1.531-6.5-4c0-1.65 1.497-3.584 2.947-5.456 1.137-1.469 2.309-2.984 2.931-4.544h1.244c0.622 1.559 1.797 3.075 2.931 4.544 1.45 1.872 2.947 3.806 2.947 5.456z" })
            );
        }
        function MoneyPouchPound({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MoneyPouchPoundSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MoneyPouchPound.SVG = MoneyPouchPoundSVG;
        return MoneyPouchPound;
    })();
export const MoneyPouchRuble = /*#__PURE__*/ (() => {
        function MoneyPouchRubleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 13h-1.5c-0.275 0-0.5 0.225-0.5 0.5v2.5h-1v1h1v1h-1v1h1v1h1v-1h2v-1h-2v-1h1c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12 16h-1v-2h1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M20.834 5.128c-0.963-0.869-2.091-1.253-3.263-1.106-1.166 0.147-2.209 0.791-2.925 1.512-0.159-0.188-0.363-0.338-0.594-0.428 0.103-0.397 0.353-0.869 0.722-1.362 0.438-0.584 0.888-0.997 0.891-1 0.228-0.203 0.347-0.503 0.328-0.806-0.019-0.306-0.178-0.584-0.428-0.756-1.141-0.791-2.013-1.15-2.831-1.166-0.831-0.016-1.425 0.341-1.903 0.628-0.641 0.384-1.197 0.716-2.609 0.387-0.434-0.1-0.884 0.097-1.1 0.487-0.219 0.391-0.15 0.878 0.166 1.194 0.597 0.6 1.403 1.647 1.641 2.406-0.544 0.219-0.928 0.756-0.928 1.381 0 0.563 0.312 1.053 0.772 1.309-0.572 1.141-1.503 2.341-2.406 3.506-1.656 2.141-3.366 4.35-3.366 6.684 0 0.916 0.216 1.766 0.637 2.531 0.412 0.747 1.016 1.394 1.794 1.922 1.491 1.012 3.591 1.547 6.069 1.547s4.578-0.534 6.069-1.547c0.775-0.528 1.378-1.172 1.794-1.922 0.422-0.766 0.638-1.616 0.638-2.531 0-2.334-1.709-4.544-3.366-6.681-0.903-1.169-1.834-2.369-2.406-3.506 0.328-0.184 0.581-0.484 0.7-0.847 1.528-0.091 2.547 0.481 3.119 1.744l0.206 0.456 0.912-0.412-0.206-0.456c-0.472-1.050-1.209-1.756-2.191-2.1-0.344-0.122-0.712-0.197-1.109-0.225 0.547-0.462 1.269-0.853 2.041-0.95 0.888-0.112 1.719 0.175 2.469 0.853l0.372 0.334 0.672-0.741-0.378-0.341zM13.5 7h-4c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h4c0.275 0 0.5 0.225 0.5 0.5 0 0 0 0 0 0s0 0 0 0c0 0.275-0.225 0.5-0.5 0.5zM11.862 2.356c0.391-0.234 0.591-0.347 0.837-0.344 0.194 0.003 0.434 0.075 0.725 0.209-0.572 0.7-1.222 1.703-1.388 2.778h-1.084c-0.1-0.584-0.375-1.228-0.816-1.919 0.756-0.144 1.287-0.462 1.725-0.725zM18 18c0 2.469-2.491 4-6.5 4s-6.5-1.531-6.5-4c0-1.65 1.497-3.584 2.947-5.456 1.137-1.469 2.309-2.984 2.931-4.544h1.244c0.622 1.559 1.797 3.075 2.931 4.544 1.45 1.872 2.947 3.806 2.947 5.456z" })
            );
        }
        function MoneyPouchRuble({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MoneyPouchRubleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MoneyPouchRuble.SVG = MoneyPouchRubleSVG;
        return MoneyPouchRuble;
    })();
export const MoneyPouchYen = /*#__PURE__*/ (() => {
        function MoneyPouchYenSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.206 13.5l-0.706-0.706-2 2-2-2-0.706 0.706 2.206 2.206v0.294h-2v1h2v1h-2v1h2v1h1v-1h2v-1h-2v-1h2v-1h-2v-0.294z" }),
_('path', { d: "M20.834 5.128c-0.963-0.869-2.091-1.253-3.263-1.106-1.166 0.147-2.209 0.791-2.925 1.512-0.159-0.188-0.363-0.338-0.594-0.428 0.103-0.397 0.353-0.869 0.722-1.362 0.438-0.584 0.888-0.997 0.891-1 0.228-0.203 0.347-0.503 0.328-0.806-0.019-0.306-0.178-0.584-0.428-0.756-1.141-0.791-2.013-1.15-2.831-1.166-0.831-0.016-1.425 0.341-1.903 0.628-0.641 0.384-1.197 0.716-2.609 0.387-0.434-0.1-0.884 0.097-1.1 0.487-0.219 0.391-0.15 0.878 0.166 1.194 0.597 0.6 1.403 1.647 1.641 2.406-0.544 0.219-0.928 0.756-0.928 1.381 0 0.563 0.312 1.053 0.772 1.309-0.572 1.141-1.503 2.341-2.406 3.506-1.656 2.141-3.366 4.35-3.366 6.684 0 0.916 0.216 1.766 0.637 2.531 0.412 0.747 1.016 1.394 1.794 1.922 1.491 1.012 3.591 1.547 6.069 1.547s4.578-0.534 6.069-1.547c0.775-0.528 1.378-1.172 1.794-1.922 0.422-0.766 0.638-1.616 0.638-2.531 0-2.334-1.709-4.544-3.366-6.681-0.903-1.169-1.834-2.369-2.406-3.506 0.328-0.184 0.581-0.484 0.7-0.847 1.528-0.091 2.547 0.481 3.119 1.744l0.206 0.456 0.912-0.412-0.206-0.456c-0.472-1.050-1.209-1.756-2.191-2.1-0.344-0.122-0.712-0.197-1.109-0.225 0.547-0.462 1.269-0.853 2.041-0.95 0.888-0.112 1.719 0.175 2.469 0.853l0.372 0.334 0.672-0.741-0.378-0.341zM13.5 7h-4c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h4c0.275 0 0.5 0.225 0.5 0.5 0 0 0 0 0 0s0 0 0 0c0 0.275-0.225 0.5-0.5 0.5zM11.862 2.356c0.391-0.234 0.591-0.347 0.837-0.344 0.194 0.003 0.434 0.075 0.725 0.209-0.572 0.7-1.222 1.703-1.388 2.778h-1.084c-0.1-0.584-0.375-1.228-0.816-1.919 0.756-0.144 1.287-0.462 1.725-0.725zM18 18c0 2.469-2.491 4-6.5 4s-6.5-1.531-6.5-4c0-1.65 1.497-3.584 2.947-5.456 1.137-1.469 2.309-2.984 2.931-4.544h1.244c0.622 1.559 1.797 3.075 2.931 4.544 1.45 1.872 2.947 3.806 2.947 5.456z" })
            );
        }
        function MoneyPouchYen({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MoneyPouchYenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MoneyPouchYen.SVG = MoneyPouchYenSVG;
        return MoneyPouchYen;
    })();
export const MoneyPouch = /*#__PURE__*/ (() => {
        function MoneyPouchSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 12h-1v2h-0.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h2c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-3.5v1h2v2h1v-2h0.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-2c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3.5v-1h-2v-2z" }),
_('path', { d: "M20.834 5.128c-0.963-0.869-2.091-1.253-3.263-1.106-1.166 0.147-2.209 0.791-2.925 1.512-0.159-0.188-0.363-0.338-0.594-0.428 0.103-0.397 0.353-0.869 0.722-1.362 0.438-0.584 0.888-0.997 0.891-1 0.228-0.203 0.347-0.503 0.328-0.806-0.019-0.306-0.178-0.584-0.428-0.756-1.141-0.791-2.013-1.15-2.831-1.166-0.831-0.016-1.425 0.341-1.903 0.628-0.641 0.384-1.197 0.716-2.609 0.387-0.434-0.1-0.884 0.097-1.1 0.487-0.219 0.391-0.15 0.878 0.166 1.194 0.597 0.6 1.403 1.647 1.641 2.406-0.544 0.219-0.928 0.756-0.928 1.381 0 0.563 0.312 1.053 0.772 1.309-0.572 1.141-1.503 2.341-2.406 3.506-1.656 2.141-3.366 4.35-3.366 6.684 0 0.916 0.216 1.766 0.637 2.531 0.412 0.747 1.016 1.394 1.794 1.922 1.491 1.012 3.591 1.547 6.069 1.547s4.578-0.534 6.069-1.547c0.775-0.528 1.378-1.172 1.794-1.922 0.422-0.766 0.638-1.616 0.638-2.531 0-2.334-1.709-4.544-3.366-6.681-0.903-1.169-1.834-2.369-2.406-3.506 0.328-0.184 0.581-0.484 0.7-0.847 1.528-0.091 2.547 0.481 3.119 1.744l0.206 0.456 0.912-0.412-0.206-0.456c-0.472-1.050-1.209-1.756-2.191-2.1-0.344-0.122-0.712-0.197-1.109-0.225 0.547-0.462 1.269-0.853 2.041-0.95 0.888-0.112 1.719 0.175 2.469 0.853l0.372 0.334 0.672-0.741-0.378-0.341zM13.5 7h-4c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h4c0.275 0 0.5 0.225 0.5 0.5 0 0 0 0 0 0s0 0 0 0c0 0.275-0.225 0.5-0.5 0.5zM11.862 2.356c0.391-0.234 0.591-0.347 0.837-0.344 0.194 0.003 0.434 0.075 0.725 0.209-0.572 0.7-1.222 1.703-1.388 2.778h-1.084c-0.1-0.584-0.375-1.228-0.816-1.919 0.756-0.144 1.287-0.462 1.725-0.725zM18 18c0 2.469-2.491 4-6.5 4s-6.5-1.531-6.5-4c0-1.65 1.497-3.584 2.947-5.456 1.137-1.469 2.309-2.984 2.931-4.544h1.244c0.622 1.559 1.797 3.075 2.931 4.544 1.45 1.872 2.947 3.806 2.947 5.456z" })
            );
        }
        function MoneyPouch({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MoneyPouchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MoneyPouch.SVG = MoneyPouchSVG;
        return MoneyPouch;
    })();
export const MonitorPlay = /*#__PURE__*/ (() => {
        function MonitorPlaySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 1h-20c-1.103 0-2 0.897-2 2v13c0 1.103 0.897 2 2 2h5.781l-0.759 3.803c-0.059 0.294 0.019 0.597 0.206 0.831s0.472 0.366 0.772 0.366h8c0.3 0 0.584-0.134 0.772-0.366s0.266-0.537 0.206-0.831l-0.759-3.803h5.781c1.103 0 2-0.897 2-2v-13c0-1.103-0.897-2-2-2zM22 3v1h-20v-1h20zM2 14v-9h20v9h-20zM2 15h16v1h-16v-1zM14.981 22h-5.963l0.8-4h4.359l0.803 4zM22 16h-2v-1h2.003l-0.003 1c0.003 0 0 0 0 0z" }),
_('path', { d: "M15.725 9.053l-6-3c-0.156-0.078-0.337-0.069-0.488 0.022-0.147 0.091-0.237 0.253-0.237 0.425v6c0 0.172 0.091 0.334 0.237 0.425 0.081 0.050 0.172 0.075 0.262 0.075 0.075 0 0.153-0.019 0.225-0.053l6-3c0.169-0.084 0.275-0.259 0.275-0.447s-0.106-0.363-0.275-0.447zM10 11.691v-4.381l4.381 2.191-4.381 2.191z" })
            );
        }
        function MonitorPlay({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MonitorPlaySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MonitorPlay.SVG = MonitorPlaySVG;
        return MonitorPlay;
    })();
export const MonitorShare = /*#__PURE__*/ (() => {
        function MonitorShareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 1h-20c-1.103 0-2 0.897-2 2v13c0 1.103 0.897 2 2 2h5.781l-0.759 3.803c-0.059 0.294 0.019 0.597 0.206 0.831s0.472 0.366 0.772 0.366h8c0.3 0 0.584-0.134 0.772-0.366s0.266-0.537 0.206-0.831l-0.759-3.803h5.781c1.103 0 2-0.897 2-2v-13c0-1.103-0.897-2-2-2zM22 3l0.003 11h-20.003v-11h20zM2 15h16v1h-16v-1zM14.981 22h-5.963l0.8-4h4.359l0.803 4zM22 16h-2v-1h2.003l-0.003 1c0.003 0 0 0 0 0z" }),
_('path', { d: "M9.5 10c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5c0-0.063-0.003-0.125-0.012-0.184l3.472-1.734c0.269 0.259 0.638 0.422 1.041 0.422 0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5c-0.403 0-0.772 0.159-1.041 0.422l-3.472-1.734c0.006-0.059 0.012-0.122 0.012-0.184 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5c0.403 0 0.772-0.159 1.041-0.422l3.472 1.734c-0.006 0.059-0.012 0.122-0.012 0.184s0.003 0.125 0.012 0.184l-3.472 1.734c-0.269-0.262-0.637-0.422-1.041-0.422zM9.5 12c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5zM15.5 8c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM9.5 6c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" })
            );
        }
        function MonitorShare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MonitorShareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MonitorShare.SVG = MonitorShareSVG;
        return MonitorShare;
    })();
export const Monitor = /*#__PURE__*/ (() => {
    function MonitorSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 1h-20c-1.103 0-2 0.897-2 2v13c0 1.103 0.897 2 2 2h5.781l-0.759 3.803c-0.059 0.294 0.019 0.597 0.206 0.831s0.472 0.366 0.772 0.366h8c0.3 0 0.584-0.134 0.772-0.366s0.266-0.537 0.206-0.831l-0.759-3.803h5.781c1.103 0 2-0.897 2-2v-13c0-1.103-0.897-2-2-2zM22 3v1h-20v-1h20zM2 14v-9h20v9h-20zM2 15h16v1h-16v-1zM14.981 22h-5.963l0.8-4h4.359l0.803 4zM22 16h-2v-1h2v1c0 0 0 0 0 0z" })
        );
    }
    function Monitor({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MonitorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Monitor.SVG = MonitorSVG;
    return Monitor;
})();
export const Moon = /*#__PURE__*/ (() => {
    function MoonSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.187 17.719c0.316-0.65 0.584-1.35 0.794-2.084 0.059-0.209-0.022-0.434-0.206-0.553s-0.422-0.109-0.591 0.028c-3.203 2.594-9.444 2.813-13.275-1.019-3.828-3.831-3.609-10.072-1.019-13.275 0.138-0.169 0.15-0.409 0.028-0.591-0.119-0.181-0.344-0.266-0.553-0.206-0.734 0.209-1.434 0.478-2.084 0.794-0.791 0.387-1.522 0.853-2.181 1.391-0.884 0.725-1.644 1.584-2.253 2.559-1.225 1.953-1.847 4.303-1.847 6.987 0 6.753 5.497 12.25 12.25 12.25 2.684 0 5.034-0.622 6.987-1.847 0.972-0.609 1.834-1.369 2.559-2.253 0.537-0.659 1.003-1.388 1.391-2.181zM12.25 22c-5.653 0-10.25-4.597-10.25-10.25 0-4.069 1.634-7.169 4.634-8.866-0.478 1.359-0.697 2.887-0.619 4.456 0.147 2.897 1.278 5.544 3.188 7.456s4.556 3.044 7.456 3.188c0.209 0.009 0.419 0.016 0.625 0.016 1.347 0 2.65-0.219 3.831-0.634-1.697 3-4.797 4.634-8.866 4.634z" })
        );
    }
    function Moon({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MoonSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Moon.SVG = MoonSVG;
    return Moon;
})();
export const MouseCheck = /*#__PURE__*/ (() => {
        function MouseCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 8v-2c0-1.103-0.897-2-2-2s-2 0.897-2 2v2c0 1.103 0.897 2 2 2s2-0.897 2-2zM8 8v-2c0-0.55 0.45-1 1-1s1 0.45 1 1v2c0 0.55-0.45 1-1 1s-1-0.45-1-1z" }),
_('path', { d: "M16 10.019v-3.519c0-3.031-2.469-5.5-5.5-5.5h-2.984c-1.466 0-2.847 0.572-3.884 1.606-1.038 1.038-1.612 2.416-1.616 3.881l-0.016 6.513c0 1.866 0.728 3.622 2.047 4.944s3.072 2.050 4.941 2.056c0.341 0 0.672-0.025 0.994-0.072 1.147 1.844 3.194 3.072 5.519 3.072 3.584 0 6.5-2.916 6.5-6.5 0-3.416-2.65-6.225-6-6.481zM8.991 18c-2.75-0.006-4.991-2.247-4.991-4.997l0.016-6.509c0.006-1.925 1.575-3.494 3.5-3.494h2.984c1.931 0 3.5 1.569 3.5 3.5v3.675c-2.862 0.678-5 3.256-5 6.325 0 0.516 0.059 1.016 0.175 1.497-0.063 0.003-0.125 0.003-0.184 0.003zM15.5 22c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M14.5 17.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4z" })
            );
        }
        function MouseCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MouseCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MouseCheck.SVG = MouseCheckSVG;
        return MouseCheck;
    })();
export const MouseClickBoth = /*#__PURE__*/ (() => {
        function MouseClickBothSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 4h-1v-4h1v4zM20 7v1h4v-1h-4zM21.5 1.794l-2.706 2.706 0.706 0.706 2.706-2.706-0.706-0.706z" }),
_('path', { d: "M8 4h-1v-4h1v4zM0 8h4v-1h-4v1zM2.5 1.794l-0.706 0.706 2.706 2.706 0.706-0.706-2.706-2.706z" }),
_('path', { d: "M13.5 5h-2.984c-1.466 0-2.847 0.572-3.884 1.606-1.038 1.038-1.613 2.416-1.616 3.881l-0.016 6.509v0.003c0 1.866 0.728 3.622 2.047 4.944s3.072 2.050 4.941 2.056c0.003 0 0.009 0 0.012 0 1.847 0 3.591-0.728 4.916-2.050 0.65-0.65 1.163-1.406 1.522-2.25 0.372-0.875 0.563-1.8 0.563-2.75v-6.45c0-3.031-2.469-5.5-5.5-5.5zM17 16.95c0 1.347-0.531 2.619-1.497 3.584-0.947 0.944-2.191 1.466-3.503 1.466-0.003 0-0.006 0-0.009 0-2.75-0.006-4.991-2.247-4.991-5l0.016-6.506c0.006-1.925 1.575-3.494 3.5-3.494h2.984c1.931 0 3.5 1.569 3.5 3.5v6.45z" }),
_('path', { d: "M12 8c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2s2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM13 12c0 0.55-0.45 1-1 1s-1-0.45-1-1v-2c0-0.55 0.45-1 1-1s1 0.45 1 1v2z" })
            );
        }
        function MouseClickBoth({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MouseClickBothSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MouseClickBoth.SVG = MouseClickBothSVG;
        return MouseClickBoth;
    })();
export const MouseClickLeft = /*#__PURE__*/ (() => {
        function MouseClickLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 4h-1v-4h1v4zM0 8h4v-1h-4v1zM2.5 1.794l-0.706 0.706 2.706 2.706 0.706-0.706-2.706-2.706z" }),
_('path', { d: "M13.5 5h-2.984c-1.466 0-2.847 0.572-3.884 1.606-1.038 1.038-1.613 2.416-1.616 3.881l-0.016 6.509v0.003c0 1.866 0.728 3.622 2.047 4.944s3.072 2.050 4.941 2.056c0.003 0 0.009 0 0.012 0 1.847 0 3.591-0.728 4.916-2.050 0.65-0.65 1.163-1.406 1.522-2.25 0.372-0.875 0.563-1.8 0.563-2.75v-6.45c0-3.031-2.469-5.5-5.5-5.5zM17 16.95c0 1.347-0.531 2.619-1.497 3.584-0.947 0.944-2.191 1.466-3.503 1.466-0.003 0-0.006 0-0.009 0-2.75-0.006-4.991-2.247-4.991-5l0.016-6.506c0.006-1.925 1.575-3.494 3.5-3.494h2.984c1.931 0 3.5 1.569 3.5 3.5v6.45z" }),
_('path', { d: "M12 8c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2s2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM13 12c0 0.55-0.45 1-1 1s-1-0.45-1-1v-2c0-0.55 0.45-1 1-1s1 0.45 1 1v2z" })
            );
        }
        function MouseClickLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MouseClickLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MouseClickLeft.SVG = MouseClickLeftSVG;
        return MouseClickLeft;
    })();
export const MouseClickRight = /*#__PURE__*/ (() => {
        function MouseClickRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 0h1v4h-1v-4z" }),
_('path', { d: "M20 7h4v1h-4v-1z" }),
_('path', { d: "M18.792 4.501l2.707-2.707 0.707 0.707-2.707 2.707-0.707-0.707z" }),
_('path', { d: "M13.5 5h-2.984c-1.466 0-2.847 0.572-3.884 1.606-1.038 1.038-1.613 2.416-1.616 3.881l-0.016 6.509v0.003c0 1.866 0.728 3.622 2.047 4.944s3.072 2.050 4.941 2.056h0.012c1.847 0 3.591-0.728 4.916-2.050 0.65-0.65 1.163-1.406 1.522-2.25 0.372-0.875 0.563-1.8 0.563-2.75v-6.45c0-3.031-2.469-5.5-5.5-5.5zM17 16.95c0 1.347-0.531 2.619-1.497 3.584-0.947 0.944-2.191 1.466-3.503 1.466h-0.009c-2.75-0.006-4.991-2.247-4.991-5l0.016-6.506c0.006-1.925 1.575-3.494 3.5-3.494h2.984c1.931 0 3.5 1.569 3.5 3.5v6.45z" }),
_('path', { d: "M12 8c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2s2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM13 12c0 0.55-0.45 1-1 1s-1-0.45-1-1v-2c0-0.55 0.45-1 1-1s1 0.45 1 1v2z" })
            );
        }
        function MouseClickRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MouseClickRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MouseClickRight.SVG = MouseClickRightSVG;
        return MouseClickRight;
    })();
export const MouseCross = /*#__PURE__*/ (() => {
        function MouseCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 8v-2c0-1.103-0.897-2-2-2s-2 0.897-2 2v2c0 1.103 0.897 2 2 2s2-0.897 2-2zM8 8v-2c0-0.55 0.45-1 1-1s1 0.45 1 1v2c0 0.55-0.45 1-1 1s-1-0.45-1-1z" }),
_('path', { d: "M16 10.019v-3.519c0-3.031-2.469-5.5-5.5-5.5h-2.984c-1.466 0-2.847 0.572-3.884 1.606-1.038 1.038-1.612 2.416-1.616 3.881l-0.016 6.513c0 1.866 0.728 3.622 2.047 4.944s3.072 2.050 4.941 2.056c0.341 0 0.672-0.025 0.994-0.072 1.147 1.844 3.194 3.072 5.519 3.072 3.584 0 6.5-2.916 6.5-6.5 0-3.416-2.65-6.225-6-6.481zM8.991 18c-2.75-0.006-4.991-2.247-4.991-4.997l0.016-6.509c0.006-1.925 1.575-3.494 3.5-3.494h2.984c1.931 0 3.5 1.569 3.5 3.5v3.675c-2.862 0.678-5 3.256-5 6.325 0 0.516 0.059 1.016 0.175 1.497-0.063 0.003-0.125 0.003-0.184 0.003zM15.5 22c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17.5 13.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function MouseCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MouseCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MouseCross.SVG = MouseCrossSVG;
        return MouseCross;
    })();
export const MouseNetwork = /*#__PURE__*/ (() => {
        function MouseNetworkSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 8v-2c0-1.103-0.897-2-2-2s-2 0.897-2 2v2c0 1.103 0.897 2 2 2s2-0.897 2-2zM8 8v-2c0-0.55 0.45-1 1-1s1 0.45 1 1v2c0 0.55-0.45 1-1 1s-1-0.45-1-1z" }),
_('path', { d: "M16 10.019v-3.519c0-3.031-2.469-5.5-5.5-5.5h-2.984c-1.466 0-2.847 0.572-3.884 1.606-1.038 1.038-1.612 2.416-1.616 3.881l-0.016 6.513c0 1.866 0.728 3.622 2.047 4.944s3.072 2.050 4.941 2.056h0.012c0.328 0 0.659-0.025 0.981-0.069 1.147 1.841 3.194 3.069 5.519 3.069 3.584 0 6.5-2.916 6.5-6.5 0-3.416-2.65-6.225-6-6.481zM10.022 17h1.987c0.028 0.694 0.113 1.369 0.25 2h-1.656c-0.312-0.609-0.516-1.284-0.581-2zM15 11.125v1.875h-1.403c0.072-0.181 0.147-0.353 0.228-0.519 0.341-0.678 0.75-1.147 1.175-1.356zM15 14v2h-1.991c0.031-0.703 0.122-1.378 0.275-2h1.716zM16 14h1.716c0.15 0.622 0.244 1.297 0.275 2h-1.991v-2zM16 13v-1.875c0.425 0.209 0.834 0.678 1.175 1.356 0.081 0.166 0.159 0.338 0.228 0.519h-1.403zM12.931 12.034c-0.15 0.3-0.284 0.622-0.397 0.966h-1.272c0.534-0.644 1.209-1.166 1.981-1.516-0.109 0.169-0.216 0.353-0.312 0.55zM10.603 14h1.656c-0.138 0.631-0.222 1.306-0.25 2h-1.987c0.066-0.716 0.269-1.391 0.581-2zM13.009 17h1.991v2h-1.716c-0.15-0.622-0.244-1.297-0.275-2zM15 20v1.875c-0.425-0.209-0.834-0.678-1.175-1.356-0.081-0.166-0.159-0.337-0.228-0.519h1.403zM16 21.875v-1.875h1.403c-0.072 0.181-0.147 0.353-0.228 0.519-0.341 0.678-0.75 1.147-1.175 1.356zM16 19v-2h1.991c-0.031 0.703-0.122 1.378-0.275 2h-1.716zM18.991 17h1.987c-0.066 0.716-0.266 1.391-0.578 2h-1.656c0.134-0.631 0.219-1.306 0.247-2zM18.991 16c-0.028-0.694-0.113-1.369-0.25-2h1.656c0.312 0.609 0.516 1.284 0.578 2h-1.984zM19.741 13h-1.272c-0.116-0.344-0.247-0.666-0.397-0.966-0.097-0.197-0.203-0.378-0.312-0.55 0.769 0.35 1.447 0.872 1.981 1.516zM8.991 18c-2.75-0.006-4.991-2.247-4.991-4.997l0.016-6.509c0.006-1.925 1.575-3.494 3.5-3.494h2.984c1.931 0 3.5 1.569 3.5 3.5v3.675c-2.862 0.678-5 3.256-5 6.325 0 0.516 0.059 1.016 0.175 1.497-0.063 0.003-0.125 0.003-0.184 0.003zM11.259 20h1.272c0.116 0.344 0.247 0.666 0.397 0.966 0.097 0.197 0.203 0.378 0.312 0.55-0.769-0.35-1.447-0.872-1.981-1.516zM17.756 21.516c0.109-0.169 0.213-0.353 0.312-0.55 0.15-0.3 0.284-0.622 0.397-0.966h1.272c-0.531 0.644-1.209 1.166-1.981 1.516z" })
            );
        }
        function MouseNetwork({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MouseNetworkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MouseNetwork.SVG = MouseNetworkSVG;
        return MouseNetwork;
    })();
export const MouseWireless = /*#__PURE__*/ (() => {
        function MouseWirelessSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16.828 11.828l-0.353 0.353-0.706-0.706 0.353-0.353c1.169-1.169 1.169-3.072 0-4.244l-0.353-0.353 0.706-0.706 0.353 0.353c1.559 1.559 1.559 4.097 0 5.656zM18.95 4.050l-0.353-0.353-0.706 0.706 0.353 0.353c2.337 2.337 2.337 6.147 0 8.487l-0.353 0.353 0.706 0.706 0.353-0.353c1.322-1.322 2.050-3.081 2.050-4.95 0-1.872-0.728-3.628-2.050-4.95zM21.072 1.928l-0.353-0.353-0.706 0.706 0.353 0.353c3.509 3.509 3.509 9.219 0 12.728l-0.353 0.353 0.706 0.706 0.353-0.353c1.887-1.887 2.928-4.4 2.928-7.069s-1.041-5.184-2.928-7.072z" }),
_('path', { d: "M8.5 3h-2.984c-1.466 0-2.847 0.572-3.884 1.606-1.038 1.038-1.612 2.416-1.616 3.881l-0.016 6.509v0.003c0 1.866 0.728 3.622 2.047 4.944s3.072 2.050 4.941 2.056c0.003 0 0.009 0 0.012 0 1.847 0 3.591-0.728 4.916-2.050 0.65-0.65 1.163-1.406 1.522-2.25 0.372-0.875 0.563-1.8 0.563-2.75v-6.45c0-3.031-2.469-5.5-5.5-5.5zM12 14.95c0 1.347-0.531 2.619-1.497 3.584-0.947 0.944-2.191 1.466-3.503 1.466-0.003 0-0.006 0-0.009 0-2.753-0.006-4.991-2.247-4.991-5l0.016-6.506c0.006-1.925 1.575-3.494 3.5-3.494h2.984c1.931 0 3.5 1.569 3.5 3.5v6.45z" }),
_('path', { d: "M7 6c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2s2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM8 10c0 0.55-0.45 1-1 1s-1-0.45-1-1v-2c0-0.55 0.45-1 1-1s1 0.45 1 1v2z" })
            );
        }
        function MouseWireless({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MouseWirelessSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MouseWireless.SVG = MouseWirelessSVG;
        return MouseWireless;
    })();
export const Mouse = /*#__PURE__*/ (() => {
        function MouseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.5 5h-0.522c-0.116-1.281-0.669-2.469-1.587-3.391-1.041-1.038-2.422-1.609-3.891-1.609h-2c-1.469 0-2.85 0.572-3.891 1.609-1.038 1.041-1.609 2.422-1.609 3.891v8.5c0 2.756-2.244 5-5 5v1c3.309 0 6-2.691 6-6v-8.5c0-2.481 2.019-4.5 4.5-4.5h2c2.313 0 4.222 1.753 4.472 4h-1.456c-1.466 0-2.847 0.572-3.884 1.606-1.038 1.038-1.612 2.416-1.616 3.881l-0.016 6.509v0.003c0 1.866 0.728 3.622 2.047 4.944s3.072 2.050 4.941 2.056c0.003 0 0.009 0 0.012 0 1.847 0 3.591-0.728 4.916-2.050 0.65-0.65 1.163-1.406 1.522-2.25 0.372-0.875 0.563-1.8 0.563-2.75v-6.45c0-3.031-2.469-5.5-5.5-5.5zM22 16.95c0 1.347-0.531 2.619-1.497 3.584-0.95 0.947-2.197 1.469-3.513 1.466-2.75-0.006-4.991-2.247-4.991-5l0.016-6.506c0.006-1.925 1.575-3.494 3.5-3.494h2.984c1.931 0 3.5 1.569 3.5 3.5v6.45z" }),
_('path', { d: "M17 8c-1.103 0-2 0.897-2 2v2c0 1.103 0.897 2 2 2s2-0.897 2-2v-2c0-1.103-0.897-2-2-2zM18 12c0 0.55-0.45 1-1 1s-1-0.45-1-1v-2c0-0.55 0.45-1 1-1s1 0.45 1 1v2z" })
            );
        }
        function Mouse({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MouseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Mouse.SVG = MouseSVG;
        return Mouse;
    })();
export const MoveBottomDown = /*#__PURE__*/ (() => {
        function MoveBottomDownSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 10h-12v-10h-2v11c0 0.553 0.447 1 1 1h14c0.553 0 1-0.447 1-1v-11h-2v10z" }),
_('path', { d: "M19 13h1v3h-1v-3z" }),
_('path', { d: "M21 11h3v1h-3v-1z" }),
_('path', { d: "M0 11h3v1h-3v-1z" }),
_('path', { d: "M4 13h1v3h-1v-3z" }),
_('path', { d: "M13 20.584v-6.584h-2v6.584l-1.544-1.544-1.416 1.416 3.25 3.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l3.25-3.25-1.416-1.416-1.537 1.544z" })
            );
        }
        function MoveBottomDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MoveBottomDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MoveBottomDown.SVG = MoveBottomDownSVG;
        return MoveBottomDown;
    })();
export const MoveBottomUp = /*#__PURE__*/ (() => {
        function MoveBottomUpSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 10h-12v-10h-2v11c0 0.553 0.447 1 1 1h14c0.553 0 1-0.447 1-1v-11h-2v10z" }),
_('path', { d: "M19 13h1v3h-1v-3z" }),
_('path', { d: "M21 11h3v1h-3v-1z" }),
_('path', { d: "M0 11h3v1h-3v-1z" }),
_('path', { d: "M4 13h1v3h-1v-3z" }),
_('path', { d: "M11.294 14.294l-3.25 3.25 1.416 1.416 1.544-1.544v6.584h2v-6.584l1.544 1.544 1.416-1.416-3.25-3.25c-0.397-0.391-1.028-0.391-1.419 0z" })
            );
        }
        function MoveBottomUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MoveBottomUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MoveBottomUp.SVG = MoveBottomUpSVG;
        return MoveBottomUp;
    })();
export const MoveDown = /*#__PURE__*/ (() => {
        function MoveDownSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 12h-8c-1.103 0-2 0.897-2 2v8c0 1.103 0.897 2 2 2h8c1.103 0 2-0.897 2-2v-8c0-1.103-0.897-2-2-2zM22 22h-8v-8h8v8c0.003 0 0 0 0 0z" }),
_('path', { d: "M6 16.584v-12.584h-2v12.584l-2.544-2.544-1.413 1.416 4.25 4.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l4.25-4.25-1.416-1.416-2.541 2.544z" }),
_('path', { d: "M13.5 10h9c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.225-0.5-0.5-0.5h-9c-0.275 0-0.5 0.225-0.5 0.5v9c0 0.275 0.225 0.5 0.5 0.5zM14 1h8v8h-8v-8z" })
            );
        }
        function MoveDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MoveDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MoveDown.SVG = MoveDownSVG;
        return MoveDown;
    })();
export const MoveLeftLeft = /*#__PURE__*/ (() => {
        function MoveLeftLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6v-2h-11c-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1h11v-2h-10v-12h10z" }),
_('path', { d: "M8 19h3v1h-3v-1z" }),
_('path', { d: "M12 21h1v3h-1v-3z" }),
_('path', { d: "M12 0h1v3h-1v-3z" }),
_('path', { d: "M8 4h3v1h-3v-1z" }),
_('path', { d: "M10 13v-2h-6.584l1.544-1.544-1.416-1.416-3.25 3.25c-0.391 0.391-0.391 1.025 0 1.416l3.25 3.25 1.416-1.416-1.544-1.541h6.584z" })
            );
        }
        function MoveLeftLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MoveLeftLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MoveLeftLeft.SVG = MoveLeftLeftSVG;
        return MoveLeftLeft;
    })();
export const MoveLeftRight = /*#__PURE__*/ (() => {
        function MoveLeftRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6v-2h-11c-0.553 0-1 0.447-1 1v14c0 0.553 0.447 1 1 1h11v-2h-10v-12h10z" }),
_('path', { d: "M8 19h3v1h-3v-1z" }),
_('path', { d: "M12 21h1v3h-1v-3z" }),
_('path', { d: "M12 0h1v3h-1v-3z" }),
_('path', { d: "M8 4h3v1h-3v-1z" }),
_('path', { d: "M9.706 11.294l-3.25-3.25-1.416 1.416 1.544 1.544h-6.584v2h6.584l-1.544 1.544 1.416 1.416 3.25-3.25c0.391-0.397 0.391-1.028 0-1.419z" })
            );
        }
        function MoveLeftRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MoveLeftRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MoveLeftRight.SVG = MoveLeftRightSVG;
        return MoveLeftRight;
    })();
export const MoveRightLeft = /*#__PURE__*/ (() => {
        function MoveRightLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h-11v2h10v12h-10v2h11c0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1z" }),
_('path', { d: "M13 19h3v1h-3v-1z" }),
_('path', { d: "M11 21h1v3h-1v-3z" }),
_('path', { d: "M11 0h1v3h-1v-3z" }),
_('path', { d: "M13 4h3v1h-3v-1z" }),
_('path', { d: "M24 11h-6.584l1.544-1.544-1.416-1.416-3.25 3.25c-0.391 0.391-0.391 1.025 0 1.416l3.25 3.25 1.416-1.416-1.544-1.541h6.584v-2z" })
            );
        }
        function MoveRightLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MoveRightLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MoveRightLeft.SVG = MoveRightLeftSVG;
        return MoveRightLeft;
    })();
export const MoveRightRight = /*#__PURE__*/ (() => {
        function MoveRightRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h-11v2h10v12h-10v2h11c0.553 0 1-0.447 1-1v-14c0-0.553-0.447-1-1-1z" }),
_('path', { d: "M13 19h3v1h-3v-1z" }),
_('path', { d: "M11 21h1v3h-1v-3z" }),
_('path', { d: "M11 0h1v3h-1v-3z" }),
_('path', { d: "M13 4h3v1h-3v-1z" }),
_('path', { d: "M23.706 11.294l-3.25-3.25-1.416 1.416 1.544 1.544h-6.584v2h6.584l-1.544 1.544 1.416 1.416 3.25-3.25c0.391-0.397 0.391-1.028 0-1.419z" })
            );
        }
        function MoveRightRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MoveRightRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MoveRightRight.SVG = MoveRightRightSVG;
        return MoveRightRight;
    })();
export const MoveTopDown = /*#__PURE__*/ (() => {
        function MoveTopDownSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 12h-14c-0.553 0-1 0.447-1 1v11h2v-10h12v10h2v-11c0-0.553-0.447-1-1-1z" }),
_('path', { d: "M19 8h1v3h-1v-3z" }),
_('path', { d: "M21 12h3v1h-3v-1z" }),
_('path', { d: "M0 12h3v1h-3v-1z" }),
_('path', { d: "M4 8h1v3h-1v-3z" }),
_('path', { d: "M12 10c0.256 0 0.513-0.097 0.706-0.294l3.25-3.25-1.416-1.416-1.541 1.544v-6.584h-2v6.584l-1.544-1.544-1.416 1.416 3.25 3.25c0.197 0.197 0.453 0.294 0.709 0.294z" })
            );
        }
        function MoveTopDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MoveTopDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MoveTopDown.SVG = MoveTopDownSVG;
        return MoveTopDown;
    })();
export const MoveTopUp = /*#__PURE__*/ (() => {
        function MoveTopUpSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 12h-14c-0.553 0-1 0.447-1 1v11h2v-10h12v10h2v-11c0-0.553-0.447-1-1-1z" }),
_('path', { d: "M19 8h1v3h-1v-3z" }),
_('path', { d: "M21 12h3v1h-3v-1z" }),
_('path', { d: "M0 12h3v1h-3v-1z" }),
_('path', { d: "M4 8h1v3h-1v-3z" }),
_('path', { d: "M11 3.416v6.584h2v-6.584l1.544 1.544 1.416-1.416-3.25-3.25c-0.391-0.391-1.025-0.391-1.416 0l-3.25 3.25 1.416 1.416 1.541-1.544z" })
            );
        }
        function MoveTopUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MoveTopUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MoveTopUp.SVG = MoveTopUpSVG;
        return MoveTopUp;
    })();
export const MoveUp = /*#__PURE__*/ (() => {
        function MoveUpSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-8c-1.103 0-2 0.897-2 2v8c0 1.103 0.897 2 2 2h8c1.103 0 2-0.897 2-2v-8c0-1.103-0.897-2-2-2zM22 10h-8v-8l8-0.003c0 0 0 0 0 0.003v8z" }),
_('path', { d: "M4.294 4.294l-4.25 4.25 1.416 1.416 2.544-2.544v12.584h2v-12.584l2.544 2.544 1.416-1.416-4.25-4.25c-0.397-0.391-1.028-0.391-1.419 0z" }),
_('path', { d: "M22.5 14h-9c-0.275 0-0.5 0.225-0.5 0.5v9c0 0.275 0.225 0.5 0.5 0.5h9c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.225-0.5-0.5-0.5zM22 23h-8v-8h8v8z" })
            );
        }
        function MoveUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MoveUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MoveUp.SVG = MoveUpSVG;
        return MoveUp;
    })();
export const Move = /*#__PURE__*/ (() => {
    function MoveSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.706 11.294l-3.25-3.25-1.416 1.416 1.544 1.544h-7.584v-7.587l1.544 1.544 1.416-1.416-3.25-3.25c-0.391-0.391-1.025-0.391-1.416 0l-3.25 3.25 1.416 1.416 1.544-1.544v7.584h-7.587l1.544-1.544-1.416-1.416-3.25 3.25c-0.391 0.391-0.391 1.025 0 1.416l3.25 3.25 1.416-1.416-1.544-1.541h7.584v7.584l-1.544-1.544-1.416 1.416 3.25 3.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l3.25-3.25-1.416-1.416-1.538 1.544v-7.584h7.584l-1.544 1.544 1.416 1.416 3.25-3.25c0.391-0.394 0.391-1.025 0-1.416z" })
        );
    }
    function Move({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MoveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Move.SVG = MoveSVG;
    return Move;
})();
export const Mug = /*#__PURE__*/ (() => {
        function MugSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 11h1v5h-1v-5z" }),
_('path', { d: "M21.728 12.513c-0.853-0.975-2-1.512-3.228-1.512-0.519 0-1.025 0.097-1.5 0.281v-1.281c0-1.103-0.897-2-2-2h-9c-1.103 0-2 0.897-2 2v12c0 1.103 0.897 2 2 2h9c1.103 0 2-0.897 2-2v-1.287c0.478 0.188 0.984 0.288 1.5 0.288 1.228 0 2.375-0.537 3.228-1.512 0.819-0.938 1.272-2.175 1.272-3.488s-0.453-2.55-1.272-3.488zM15 22h-9v-12h9v12c0.003 0 0 0 0 0zM18.5 19c-0.547 0-1.069-0.213-1.5-0.603v-4.794c0.431-0.391 0.956-0.603 1.5-0.603 1.378 0 2.5 1.347 2.5 3s-1.122 3-2.5 3z" }),
_('path', { d: "M10.116 4.856l0.356 0.35 0.7-0.716-0.356-0.35c-0.837-0.819-0.819-1.106-0.816-1.134 0.019-0.109 0.387-0.297 0.612-0.406 0.331-0.166 0.709-0.356 0.987-0.656 0.363-0.394 0.481-0.881 0.347-1.45l-0.116-0.488-0.972 0.231 0.116 0.488c0.106 0.45-0.075 0.616-0.809 0.981-0.494 0.247-1.053 0.528-1.15 1.147-0.091 0.553 0.25 1.172 1.1 2.003z" })
            );
        }
        function Mug({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MugSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Mug.SVG = MugSVG;
        return Mug;
    })();
export const MusicNotePlus = /*#__PURE__*/ (() => {
        function MusicNotePlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 0c-3.197 0-5.862 2.319-6.4 5.363-1.159-1.072-2.1-2.484-2.1-4.863v-0.5h-2v16.478c-1.022-0.519-2.281-0.622-3.491-0.278-1.131 0.322-2.109 0.997-2.753 1.903-0.684 0.963-0.916 2.069-0.65 3.116 0.234 0.919 0.837 1.7 1.706 2.2 0.666 0.384 1.45 0.581 2.259 0.581 0.469 0 0.95-0.066 1.422-0.2 1.131-0.322 2.109-0.997 2.753-1.903 0.519-0.731 0.778-1.544 0.756-2.35v-9.541c0.019 0.025 0.041 0.050 0.059 0.075 0.9 1.1 2.075 1.891 3.113 2.588 0.375 0.253 0.731 0.491 1.062 0.734 1.137 0.837 1.644 1.519 1.747 2.347 0.138 1.103-0.466 2.562-1.841 4.456l-0.294 0.403 0.809 0.588 0.294-0.403c1.553-2.141 2.197-3.781 2.025-5.166-0.091-0.725-0.403-1.319-0.816-1.822 0.197-0.375 0.359-0.731 0.484-1.075 0.588 0.175 1.212 0.269 1.856 0.269 3.584 0 6.5-2.916 6.5-6.5s-2.919-6.5-6.503-6.5zM4.944 21.875c-0.769 0.219-1.547 0.15-2.134-0.191-0.278-0.159-0.638-0.459-0.766-0.959-0.259-1.025 0.659-2.219 2.009-2.6 0.297-0.084 0.591-0.125 0.878-0.125 0.459 0 0.894 0.106 1.256 0.316 0.278 0.159 0.637 0.459 0.766 0.959 0.263 1.025-0.659 2.216-2.009 2.6zM14.416 13.059c-0.194-0.162-0.391-0.316-0.588-0.462-0.347-0.256-0.712-0.5-1.097-0.759-1.469-0.987-2.975-1.997-3.731-3.738v-3.725c0.597 0.994 1.391 1.728 2 2.225 0.038 2.544 1.547 4.737 3.709 5.772-0.081 0.219-0.178 0.45-0.294 0.687zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18 4h-1v2h-2v1h2v2h1v-2h2v-1h-2z" })
            );
        }
        function MusicNotePlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MusicNotePlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MusicNotePlus.SVG = MusicNotePlusSVG;
        return MusicNotePlus;
    })();
export const MusicNote = /*#__PURE__*/ (() => {
    function MusicNoteSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19.953 10.378c-0.266-1.609-1.584-2.553-2.981-3.553-1.953-1.394-3.972-2.838-3.972-6.325v-0.5h-2v16.478c-1.022-0.519-2.281-0.622-3.491-0.278-1.131 0.322-2.109 0.997-2.753 1.903-0.684 0.963-0.916 2.069-0.65 3.116 0.234 0.919 0.837 1.7 1.706 2.2 0.666 0.384 1.45 0.581 2.259 0.581 0.469 0 0.95-0.066 1.422-0.2 1.131-0.322 2.109-0.997 2.753-1.903 0.519-0.731 0.778-1.544 0.756-2.35v-15.175c0.888 1.481 2.222 2.438 3.387 3.269 1.278 0.912 2.381 1.703 2.578 2.9 0.188 1.131-0.425 2.659-1.872 4.669l-0.291 0.406 0.813 0.584 0.291-0.406c1.628-2.269 2.278-3.987 2.044-5.416zM8.944 21.875c-0.769 0.219-1.547 0.15-2.134-0.191-0.278-0.159-0.638-0.459-0.766-0.959-0.259-1.025 0.659-2.219 2.009-2.6 0.297-0.084 0.591-0.125 0.878-0.125 0.459 0 0.894 0.106 1.256 0.316 0.278 0.159 0.637 0.459 0.766 0.959 0.263 1.025-0.659 2.216-2.009 2.6z" })
        );
    }
    function MusicNote({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MusicNoteSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MusicNote.SVG = MusicNoteSVG;
    return MusicNote;
})();
export const MusicNote2 = /*#__PURE__*/ (() => {
    function MusicNote2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19.159 13.803c0.909-1.731 1.078-3.097 0.531-4.284-0.516-1.119-1.587-1.884-2.722-2.694-1.95-1.394-3.969-2.838-3.969-6.325v-0.5h-2v16.478c-1.022-0.519-2.281-0.622-3.494-0.278-1.131 0.322-2.109 0.997-2.753 1.903-0.684 0.963-0.916 2.069-0.65 3.116 0.234 0.919 0.837 1.703 1.706 2.2 0.666 0.384 1.45 0.581 2.259 0.581 0.469 0 0.95-0.066 1.422-0.2 1.131-0.322 2.109-0.997 2.753-1.903 0.522-0.734 0.778-1.55 0.756-2.359v-9.531c0.019 0.025 0.041 0.050 0.059 0.075 0.9 1.1 2.075 1.891 3.113 2.587 1.378 0.925 2.569 1.725 2.787 2.956 0.2 1.119-0.397 2.616-1.822 4.581l-0.294 0.406 0.809 0.588 0.294-0.406c1.616-2.225 2.25-3.922 1.997-5.344-0.109-0.638-0.394-1.172-0.784-1.647zM8.944 21.875c-0.769 0.219-1.547 0.15-2.134-0.191-0.278-0.159-0.638-0.459-0.766-0.959-0.259-1.025 0.659-2.219 2.009-2.603 0.297-0.084 0.591-0.125 0.878-0.125 0.459 0 0.894 0.106 1.256 0.316 0.278 0.159 0.637 0.459 0.766 0.959 0.263 1.028-0.659 2.219-2.009 2.603zM13 8.1v-3.731c0.888 1.481 2.225 2.438 3.387 3.269 2.059 1.472 3.466 2.478 2.028 5.422-0.506-0.431-1.087-0.822-1.684-1.222-1.469-0.984-2.975-1.997-3.731-3.738z" })
        );
    }
    function MusicNote2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MusicNote2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MusicNote2.SVG = MusicNote2SVG;
    return MusicNote2;
})();
export const MusicNote3 = /*#__PURE__*/ (() => {
    function MusicNote3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 15.547v-15.047c0-0.159-0.078-0.312-0.206-0.406-0.131-0.094-0.297-0.119-0.45-0.069l-15 5c-0.203 0.069-0.341 0.259-0.341 0.475v11.706c-0.234-0.237-0.506-0.45-0.813-0.625-1.053-0.606-2.394-0.747-3.681-0.381-1.131 0.322-2.109 0.997-2.753 1.903-0.684 0.963-0.916 2.069-0.65 3.116 0.234 0.919 0.837 1.7 1.706 2.2 0.666 0.384 1.45 0.581 2.259 0.581 0.469 0 0.95-0.066 1.422-0.2 1.131-0.322 2.109-0.997 2.753-1.903 0.519-0.731 0.778-1.544 0.756-2.35v-12.631l13.997-4.669v10.959c-0.234-0.237-0.506-0.45-0.813-0.625-1.053-0.606-2.394-0.747-3.681-0.381-1.131 0.322-2.109 0.997-2.753 1.903-0.684 0.963-0.916 2.069-0.65 3.116 0.234 0.919 0.837 1.7 1.706 2.2 0.666 0.384 1.45 0.581 2.259 0.581 0.469 0 0.95-0.066 1.422-0.2 1.131-0.322 2.109-0.997 2.753-1.903 0.519-0.731 0.778-1.544 0.756-2.35zM4.944 21.875c-0.769 0.219-1.547 0.15-2.134-0.191-0.278-0.159-0.638-0.459-0.766-0.959-0.259-1.025 0.659-2.219 2.009-2.6 0.297-0.084 0.591-0.125 0.878-0.125 0.459 0 0.894 0.106 1.256 0.316 0.278 0.159 0.637 0.459 0.766 0.959 0.263 1.025-0.659 2.216-2.009 2.6zM19.944 17.875c-0.769 0.219-1.547 0.15-2.134-0.191-0.278-0.159-0.638-0.459-0.766-0.959-0.259-1.025 0.659-2.219 2.009-2.6 0.297-0.084 0.591-0.125 0.878-0.125 0.459 0 0.894 0.106 1.256 0.316 0.278 0.159 0.637 0.459 0.766 0.959v0c0.263 1.025-0.659 2.216-2.009 2.6z" })
        );
    }
    function MusicNote3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MusicNote3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MusicNote3.SVG = MusicNote3SVG;
    return MusicNote3;
})();
export const MusicNote4 = /*#__PURE__*/ (() => {
    function MusicNote4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 19.547v-14.047c0-0.216-0.138-0.406-0.341-0.475l-15-5c-0.153-0.050-0.322-0.025-0.453 0.069s-0.206 0.244-0.206 0.406v12.706c-0.234-0.237-0.506-0.45-0.813-0.625-1.053-0.606-2.394-0.747-3.681-0.381-1.131 0.322-2.109 0.997-2.753 1.903-0.681 0.963-0.912 2.069-0.647 3.116 0.234 0.919 0.837 1.7 1.706 2.2 0.666 0.384 1.45 0.581 2.259 0.581 0.469 0 0.95-0.066 1.422-0.2 1.131-0.322 2.109-0.997 2.753-1.903 0.519-0.731 0.778-1.544 0.756-2.35v-13.3l14 4.669v10.291c-0.234-0.237-0.506-0.45-0.813-0.625-1.053-0.606-2.394-0.747-3.681-0.381-1.131 0.322-2.109 0.997-2.753 1.903-0.684 0.963-0.916 2.069-0.65 3.116 0.234 0.919 0.837 1.7 1.706 2.2 0.666 0.384 1.45 0.581 2.259 0.581 0.469 0 0.95-0.066 1.422-0.2 1.131-0.322 2.109-0.997 2.753-1.903 0.516-0.731 0.775-1.544 0.753-2.35zM4.944 17.875c-0.769 0.219-1.547 0.15-2.134-0.191-0.278-0.159-0.638-0.459-0.766-0.959-0.259-1.025 0.659-2.219 2.009-2.6 0.297-0.084 0.591-0.125 0.878-0.125 0.459 0 0.894 0.106 1.256 0.316 0.278 0.159 0.637 0.459 0.766 0.959 0.263 1.025-0.659 2.216-2.009 2.6zM19.944 21.875c-0.769 0.219-1.547 0.15-2.134-0.191-0.278-0.159-0.638-0.459-0.766-0.959-0.259-1.025 0.659-2.219 2.009-2.6 0.297-0.084 0.591-0.125 0.878-0.125 0.459 0 0.894 0.106 1.256 0.316 0.278 0.159 0.637 0.459 0.766 0.959v0c0.263 1.025-0.659 2.216-2.009 2.6z" })
        );
    }
    function MusicNote4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MusicNote4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MusicNote4.SVG = MusicNote4SVG;
    return MusicNote4;
})();
export const MusicNote5 = /*#__PURE__*/ (() => {
    function MusicNote5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 15.537v-15.038c0-0.159-0.078-0.312-0.206-0.406-0.131-0.094-0.297-0.119-0.45-0.069l-15 5c-0.203 0.069-0.341 0.259-0.341 0.475v11.706c-0.234-0.237-0.506-0.45-0.813-0.625-1.053-0.606-2.397-0.747-3.681-0.381-1.131 0.322-2.109 0.997-2.753 1.903-0.684 0.963-0.916 2.069-0.65 3.116 0.234 0.919 0.837 1.703 1.706 2.2 0.666 0.384 1.45 0.581 2.259 0.581 0.469 0 0.95-0.066 1.422-0.2 1.131-0.322 2.109-0.997 2.753-1.903 0.522-0.734 0.778-1.55 0.756-2.359v-8.609l14-4.666v6.944c-0.234-0.237-0.506-0.45-0.813-0.625-1.053-0.606-2.397-0.747-3.681-0.381-1.131 0.322-2.109 0.997-2.753 1.903-0.684 0.963-0.916 2.069-0.65 3.116 0.234 0.919 0.837 1.703 1.706 2.2 0.666 0.384 1.45 0.581 2.259 0.581 0.469 0 0.95-0.066 1.422-0.2 1.131-0.322 2.109-0.997 2.753-1.903 0.519-0.731 0.778-1.55 0.753-2.359zM4.944 21.875c-0.769 0.219-1.547 0.15-2.134-0.191-0.278-0.159-0.638-0.459-0.766-0.959-0.259-1.025 0.659-2.219 2.009-2.603 0.297-0.084 0.591-0.125 0.878-0.125 0.459 0 0.894 0.106 1.256 0.316 0.278 0.159 0.637 0.459 0.766 0.959 0.263 1.028-0.659 2.219-2.009 2.603zM19.944 17.875c-0.769 0.219-1.547 0.15-2.134-0.191-0.278-0.159-0.638-0.459-0.766-0.959-0.259-1.025 0.659-2.219 2.009-2.603 0.297-0.084 0.591-0.125 0.878-0.125 0.459 0 0.894 0.106 1.256 0.316 0.278 0.159 0.637 0.459 0.766 0.959v0c0.263 1.028-0.659 2.219-2.009 2.603zM9 8.819v-1.903l14-4.669v1.906l-14 4.666z" })
        );
    }
    function MusicNote5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MusicNote5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MusicNote5.SVG = MusicNote5SVG;
    return MusicNote5;
})();
export const MusicNote6 = /*#__PURE__*/ (() => {
    function MusicNote6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 19.547v-14.047c0-0.216-0.138-0.406-0.341-0.475l-15-5c-0.153-0.050-0.322-0.025-0.453 0.069s-0.206 0.244-0.206 0.406v12.706c-0.234-0.237-0.506-0.45-0.813-0.625-1.053-0.606-2.394-0.747-3.681-0.381-1.131 0.322-2.109 0.997-2.753 1.903-0.681 0.963-0.912 2.069-0.647 3.116 0.234 0.919 0.837 1.7 1.706 2.2 0.666 0.384 1.45 0.581 2.259 0.581 0.469 0 0.95-0.066 1.422-0.2 1.131-0.322 2.109-0.997 2.753-1.903 0.519-0.731 0.778-1.544 0.756-2.35v-9.284l14 4.666v6.278c-0.234-0.237-0.506-0.45-0.813-0.625-1.053-0.606-2.394-0.747-3.681-0.381-1.131 0.322-2.109 0.997-2.753 1.903-0.684 0.963-0.916 2.069-0.65 3.116 0.234 0.919 0.837 1.7 1.706 2.2 0.666 0.384 1.45 0.581 2.259 0.581 0.469 0 0.95-0.066 1.422-0.2 1.131-0.322 2.109-0.997 2.753-1.903 0.516-0.731 0.775-1.544 0.753-2.35zM4.944 17.875c-0.769 0.219-1.547 0.15-2.134-0.191-0.278-0.159-0.638-0.459-0.766-0.959-0.259-1.025 0.659-2.219 2.009-2.6 0.297-0.084 0.591-0.125 0.878-0.125 0.459 0 0.894 0.106 1.256 0.316 0.278 0.159 0.637 0.459 0.766 0.959 0.263 1.025-0.659 2.216-2.009 2.6zM19.944 21.875c-0.769 0.219-1.547 0.15-2.134-0.191-0.278-0.159-0.638-0.459-0.766-0.959-0.259-1.025 0.659-2.219 2.009-2.6 0.297-0.084 0.591-0.125 0.878-0.125 0.459 0 0.894 0.106 1.256 0.316 0.278 0.159 0.637 0.459 0.766 0.959v0c0.263 1.025-0.659 2.216-2.009 2.6zM9 4.153v-1.906l14 4.669v1.903l-14-4.666z" })
        );
    }
    function MusicNote6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MusicNote6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MusicNote6.SVG = MusicNote6SVG;
    return MusicNote6;
})();
export const MustacheGlasses = /*#__PURE__*/ (() => {
        function MustacheGlassesSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 12c2.756 0 5-2.244 5-5h0.034c0-1.084 0.881-1.966 1.966-1.966s1.966 0.881 1.966 1.966h0.034c0 2.756 2.244 5 5 5s5-2.244 5-5-2.244-5-5-5c-2.116 0-3.928 1.322-4.659 3.181-0.544-0.697-1.391-1.147-2.341-1.147s-1.8 0.45-2.341 1.147c-0.731-1.859-2.544-3.181-4.659-3.181-2.756 0-5 2.244-5 5s2.244 5 5 5zM19 4c1.653 0 3 1.347 3 3s-1.347 3-3 3-3-1.347-3-3 1.347-3 3-3zM5 4c1.653 0 3 1.347 3 3s-1.347 3-3 3-3-1.347-3-3 1.347-3 3-3z" }),
_('path', { d: "M9 13c-1.653 0-3 1.347-3 3 0 1.103-0.897 2-2 2s-2-0.897-2-1.997v-0.003h-2c0 1.603 0.625 3.109 1.756 4.244s2.641 1.756 4.244 1.756 3.109-0.625 4.244-1.756 1.756-2.641 1.756-4.244c0-1.653-1.347-3-3-3zM6 20c-0.344 0-0.681-0.044-1-0.125 1.722-0.444 3-2.013 3-3.875 0-0.55 0.45-1 1-1s1 0.45 1 1c0 2.206-1.794 4-4 4z" }),
_('path', { d: "M22 16.003c0 1.103-0.897 1.997-2 1.997s-2-0.897-2-2c0-1.653-1.347-3-3-3s-3 1.347-3 3c0 1.603 0.625 3.109 1.756 4.244 1.134 1.131 2.641 1.756 4.244 1.756s3.109-0.625 4.244-1.756c1.131-1.134 1.756-2.641 1.756-4.244l-2 0.003zM18 20c-2.206 0-4-1.794-4-4 0-0.55 0.45-1 1-1s1 0.45 1 1c0 1.859 1.278 3.428 3 3.875-0.319 0.081-0.656 0.125-1 0.125z" }),
_('path', { d: "M19 8.997c0.513 0 1.025-0.194 1.413-0.584l-0.706-0.706c-0.387 0.387-1.025 0.387-1.416 0-0.188-0.188-0.294-0.438-0.291-0.706 0-0.269 0.103-0.519 0.294-0.709l-0.709-0.706c-0.378 0.378-0.584 0.881-0.584 1.416s0.209 1.038 0.588 1.416c0.387 0.387 0.9 0.581 1.413 0.581z" }),
_('path', { d: "M5 8.997c0.513 0 1.025-0.194 1.413-0.584l-0.706-0.706c-0.387 0.387-1.025 0.387-1.416 0-0.387-0.387-0.387-1.025 0-1.416l-0.709-0.706c-0.778 0.781-0.778 2.050 0.003 2.828 0.391 0.391 0.903 0.584 1.416 0.584z" })
            );
        }
        function MustacheGlasses({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MustacheGlassesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MustacheGlasses.SVG = MustacheGlassesSVG;
        return MustacheGlasses;
    })();
export const MustacheMonocle = /*#__PURE__*/ (() => {
        function MustacheMonocleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 14c-1.653 0-3 1.347-3 3 0 1.103-0.897 2-2 2s-2-0.897-2-1.997v-0.003h-2c0 1.603 0.625 3.109 1.756 4.244s2.641 1.756 4.244 1.756 3.109-0.625 4.244-1.756 1.756-2.641 1.756-4.244c0-1.653-1.347-3-3-3zM6 21c-0.344 0-0.681-0.044-1-0.125 1.722-0.444 3-2.013 3-3.875 0-0.55 0.45-1 1-1s1 0.45 1 1c0 2.206-1.794 4-4 4z" }),
_('path', { d: "M22 17.003c0 1.103-0.897 1.997-2 1.997s-2-0.897-2-2c0-1.653-1.347-3-3-3s-3 1.347-3 3c0 1.603 0.625 3.109 1.756 4.244 1.134 1.131 2.641 1.756 4.244 1.756s3.109-0.625 4.244-1.756c1.131-1.134 1.756-2.641 1.756-4.244l-2 0.003zM18 21c-2.206 0-4-1.794-4-4 0-0.55 0.45-1 1-1s1 0.45 1 1c0 1.859 1.278 3.428 3 3.875-0.319 0.081-0.656 0.125-1 0.125z" }),
_('path', { d: "M16.291 6.706c-0.188-0.188-0.294-0.438-0.291-0.706 0-0.269 0.103-0.519 0.294-0.709l-0.709-0.706c-0.378 0.378-0.584 0.881-0.584 1.416s0.209 1.038 0.588 1.416c0.391 0.387 0.903 0.581 1.416 0.581s1.025-0.194 1.413-0.584l-0.706-0.706c-0.394 0.387-1.028 0.387-1.419 0z" }),
_('path', { d: "M22.5 5c-0.206 0-0.4 0.041-0.578 0.116-0.419-2.337-2.466-4.116-4.922-4.116-2.756 0-5 2.244-5 5s2.244 5 5 5c2.141 0 3.969-1.35 4.681-3.244 0.234 0.153 0.516 0.244 0.819 0.244 0.175 0 0.344-0.031 0.5-0.084v8.084h1v-9.5c0-0.828-0.672-1.5-1.5-1.5zM17 9c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3zM22.5 7c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" })
            );
        }
        function MustacheMonocle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MustacheMonocleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MustacheMonocle.SVG = MustacheMonocleSVG;
        return MustacheMonocle;
    })();
export const Mustache = /*#__PURE__*/ (() => {
        function MustacheSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 8c-1.653 0-3 1.347-3 3 0 1.103-0.897 2-2 2s-2-0.897-2-1.997v-0.003h-2c0 1.603 0.625 3.109 1.756 4.244s2.641 1.756 4.244 1.756 3.109-0.625 4.244-1.756 1.756-2.641 1.756-4.244c0-1.653-1.347-3-3-3zM6 15c-0.344 0-0.681-0.044-1-0.125 1.722-0.444 3-2.013 3-3.875 0-0.55 0.45-1 1-1s1 0.45 1 1c0 2.206-1.794 4-4 4z" }),
_('path', { d: "M22 11v0c0 1.103-0.897 2-2 2s-2-0.897-2-2c0-1.653-1.347-3-3-3s-3 1.347-3 3c0 1.603 0.625 3.109 1.756 4.244 1.134 1.131 2.641 1.756 4.244 1.756s3.109-0.625 4.244-1.756c1.131-1.134 1.756-2.641 1.756-4.244h-2zM18 15c-2.206 0-4-1.794-4-4 0-0.55 0.45-1 1-1s1 0.45 1 1c0 1.859 1.278 3.428 3 3.875-0.319 0.081-0.656 0.125-1 0.125z" })
            );
        }
        function Mustache({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MustacheSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Mustache.SVG = MustacheSVG;
        return Mustache;
    })();
export const Necktie = /*#__PURE__*/ (() => {
    function NecktieSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.962 10.859c-0.725-2.622-1.453-5.206-1.8-6.419 0.019-0.016 0.034-0.034 0.053-0.050 0.259-0.25 0.531-0.575 0.791-0.944 0.372-0.528 0.994-1.55 0.994-2.447v-0.5c0-0.275-0.225-0.5-0.5-0.5h-5c-0.275 0-0.5 0.225-0.5 0.5v0.5c0 0.897 0.622 1.919 0.994 2.45 0.256 0.369 0.531 0.694 0.791 0.944 0.016 0.016 0.034 0.031 0.053 0.050-0.344 1.212-1.075 3.794-1.8 6.419-2.037 7.378-2.037 7.872-2.037 8.137 0 0.459 0.213 0.975 0.666 1.622 0.325 0.459 0.756 0.966 1.25 1.459s1 0.928 1.459 1.25c0.647 0.456 1.163 0.666 1.622 0.666s0.975-0.213 1.622-0.666c0.459-0.325 0.966-0.756 1.459-1.25s0.928-1 1.25-1.459c0.456-0.647 0.666-1.163 0.666-1.622 0.006-0.266 0.006-0.759-2.031-8.141zM13.763 14.056l-2.772-2.772c0.003-0.016 0.009-0.034 0.012-0.050 0.347-1.25 0.691-2.487 0.994-3.562 0.303 1.075 0.647 2.313 0.994 3.562 0.3 1.084 0.556 2.019 0.772 2.822zM13 1c0 0.084-0.091 0.472-0.5 1.106-0.178 0.275-0.353 0.503-0.5 0.669-0.147-0.166-0.322-0.391-0.5-0.669-0.409-0.634-0.5-1.019-0.5-1.106h2zM10.331 20.669c-0.844-0.844-1.244-1.481-1.325-1.7 0.025-0.166 0.113-0.616 0.422-1.834l3.878 3.878c-0.628 0.578-1.103 0.878-1.306 0.966-0.241-0.103-0.862-0.503-1.669-1.309zM14.016 20.306l-4.3-4.297c0.237-0.909 0.553-2.088 0.972-3.616l3.588 3.588c0.55 2.106 0.687 2.775 0.716 2.984-0.069 0.188-0.369 0.678-0.975 1.341z" })
        );
    }
    function Necktie({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( NecktieSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Necktie.SVG = NecktieSVG;
    return Necktie;
})();
export const Network = /*#__PURE__*/ (() => {
    function NetworkSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM22 12c0 0.684-0.069 1.353-0.2 2h-2.903c0.069-0.653 0.103-1.322 0.103-2s-0.034-1.347-0.103-2h2.903c0.131 0.647 0.2 1.316 0.2 2zM14.206 21.753c-0.181 0.041-0.366 0.078-0.553 0.109 0.222-0.531 0.425-1.194 0.6-1.975 0.066-0.284 0.125-0.581 0.181-0.888h2.019c-0.094 0.178-0.188 0.353-0.291 0.525-0.572 0.972-1.237 1.725-1.956 2.228zM7.834 19.525c-0.1-0.169-0.197-0.344-0.291-0.525h2.019c0.056 0.309 0.119 0.606 0.181 0.888 0.178 0.781 0.378 1.441 0.6 1.975-0.188-0.031-0.372-0.066-0.553-0.109-0.716-0.503-1.381-1.256-1.956-2.228zM2.459 15h2.778c0.172 1.056 0.434 2.066 0.778 3h-2.009c-0.675-0.897-1.203-1.906-1.547-3zM2 12c0-0.684 0.069-1.353 0.2-2h2.903c-0.069 0.653-0.103 1.322-0.103 2s0.034 1.347 0.103 2h-2.903c-0.131-0.647-0.2-1.316-0.2-2zM9.794 2.247c0.181-0.041 0.366-0.078 0.553-0.109-0.222 0.531-0.425 1.194-0.6 1.975-0.066 0.284-0.125 0.581-0.181 0.888h-2.019c0.094-0.178 0.188-0.353 0.291-0.525 0.572-0.972 1.238-1.725 1.956-2.228zM16.166 4.475c0.1 0.169 0.197 0.344 0.291 0.525h-2.019c-0.056-0.309-0.119-0.606-0.181-0.888-0.178-0.781-0.378-1.441-0.6-1.975 0.188 0.031 0.372 0.066 0.553 0.109 0.716 0.503 1.381 1.256 1.956 2.228zM18 12c0 0.678-0.038 1.347-0.109 2h-2.931c0.028-0.653 0.041-1.322 0.041-2s-0.012-1.347-0.041-2h2.931c0.072 0.653 0.109 1.322 0.109 2zM12.484 21.987c-0.159 0.006-0.322 0.012-0.484 0.012s-0.325-0.003-0.484-0.012c-0.237-0.413-0.525-1.128-0.797-2.322-0.050-0.216-0.094-0.438-0.141-0.669h2.841c-0.044 0.228-0.091 0.453-0.141 0.669-0.269 1.194-0.556 1.909-0.794 2.322zM10.409 18c-0.141-0.925-0.247-1.934-0.316-3h3.813c-0.069 1.066-0.175 2.075-0.316 3h-3.181zM10.041 14c-0.028-0.653-0.041-1.322-0.041-2s0.016-1.347 0.041-2h3.916c0.028 0.653 0.041 1.322 0.041 2s-0.016 1.347-0.041 2h-3.916zM6 12c0-0.678 0.038-1.347 0.109-2h2.931c-0.028 0.653-0.041 1.322-0.041 2s0.012 1.347 0.041 2h-2.931c-0.072-0.653-0.109-1.322-0.109-2zM11.516 2.013c0.159-0.006 0.322-0.012 0.484-0.012s0.325 0.003 0.484 0.012c0.237 0.413 0.525 1.128 0.797 2.322 0.050 0.216 0.094 0.438 0.141 0.669h-2.841c0.044-0.228 0.091-0.453 0.141-0.669 0.269-1.194 0.556-1.909 0.794-2.322zM13.591 6c0.141 0.925 0.247 1.934 0.316 3h-3.813c0.069-1.066 0.175-2.075 0.316-3h3.181zM14.906 9c-0.066-1.059-0.169-2.069-0.306-3h2.313c0.372 0.922 0.653 1.931 0.837 3h-2.844zM9.4 6c-0.134 0.931-0.237 1.941-0.306 3h-2.844c0.184-1.069 0.466-2.078 0.837-3h2.313zM5.238 9h-2.778c0.344-1.094 0.872-2.103 1.544-3h2.009c-0.344 0.934-0.603 1.944-0.775 3zM6.25 15h2.844c0.066 1.059 0.169 2.069 0.306 3h-2.313c-0.372-0.922-0.653-1.931-0.837-3zM14.6 18c0.134-0.931 0.237-1.941 0.306-3h2.844c-0.184 1.069-0.466 2.078-0.837 3h-2.313zM18.762 15h2.778c-0.344 1.094-0.872 2.103-1.544 3h-2.009c0.344-0.934 0.603-1.944 0.775-3zM18.762 9c-0.172-1.056-0.434-2.066-0.778-3h2.009c0.675 0.897 1.2 1.906 1.544 3h-2.775zM19.134 5h-1.566c-0.166-0.359-0.347-0.703-0.541-1.031-0.2-0.341-0.413-0.656-0.634-0.95 1.022 0.503 1.95 1.175 2.741 1.981zM7.609 3.019c-0.222 0.294-0.434 0.609-0.634 0.95-0.194 0.328-0.375 0.672-0.541 1.031h-1.566c0.787-0.806 1.716-1.478 2.741-1.981zM4.866 19h1.566c0.166 0.359 0.347 0.703 0.541 1.031 0.2 0.341 0.413 0.656 0.634 0.95-1.022-0.503-1.95-1.175-2.741-1.981zM16.391 20.981c0.222-0.294 0.434-0.609 0.634-0.95 0.194-0.328 0.375-0.672 0.541-1.031h1.566c-0.788 0.806-1.716 1.478-2.741 1.981z" })
        );
    }
    function Network({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( NetworkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Network.SVG = NetworkSVG;
    return Network;
})();
export const Network2 = /*#__PURE__*/ (() => {
    function Network2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23 13v-2h-10v-3h1.5c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5h-5c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h1.5v3h-10v2h4v3h-1.5c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h5c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5h-1.5v-3h10v3h-1.5c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h5c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5h-1.5v-3h4zM10 3h4v4h-4v-4zM8 21h-4v-4h4v4zM20 21h-4v-4h4v4z" })
        );
    }
    function Network2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Network2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Network2.SVG = Network2SVG;
    return Network2;
})();
export const Neutral = /*#__PURE__*/ (() => {
        function NeutralSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M10 7.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5zM8 7.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5z" }),
_('path', { d: "M15.5 6c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM15.5 8c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M8 15h8v1h-8v-1z" })
            );
        }
        function Neutral({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( NeutralSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Neutral.SVG = NeutralSVG;
        return Neutral;
    })();
export const News = /*#__PURE__*/ (() => {
        function NewsSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.5 7h-3.5v-2c0-1.103-0.897-2-2-2h-14c-1.103 0-2 0.897-2 2v13c0 1.653 1.347 3 3 3h16c0.794 0 1.541-0.306 2.106-0.866 0.575-0.569 0.894-1.325 0.894-2.134v-10.5c0-0.275-0.225-0.5-0.5-0.5zM4 19c-0.55 0-1-0.45-1-1v-13h14v12.969c0 0.359 0.063 0.706 0.181 1.031h-13.181zM21 18c0 0.269-0.106 0.522-0.297 0.712s-0.447 0.291-0.716 0.288c-0.544-0.006-0.987-0.469-0.987-1.031v-9.969h2v10z" }),
_('path', { d: "M15.5 6h-11c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5h11c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5zM15 10h-10v-3h10v3z" }),
_('path', { d: "M4 12h11v1h-11v-1z" }),
_('path', { d: "M4 14h9v1h-9v-1z" }),
_('path', { d: "M4 16h11v1h-11v-1z" })
            );
        }
        function News({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( NewsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        News.SVG = NewsSVG;
        return News;
    })();
export const Newsletter = /*#__PURE__*/ (() => {
        function NewsletterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 0h-14c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM19 22h-14v-20h14v20c0 0 0 0 0 0z" }),
_('path', { d: "M7 4h4v1h-4v-1z" }),
_('path', { d: "M7 6h4v1h-4v-1z" }),
_('path', { d: "M7 12h10v1h-10v-1z" }),
_('path', { d: "M7 14h9v1h-9v-1z" }),
_('path', { d: "M7 8h4v1h-4v-1z" }),
_('path', { d: "M7 16h10v1h-10v-1z" }),
_('path', { d: "M7 18h10v1h-10v-1z" }),
_('path', { d: "M16.5 4h-4c-0.275 0-0.5 0.225-0.5 0.5v6c0 0.275 0.225 0.5 0.5 0.5h4c0.275 0 0.5-0.225 0.5-0.5v-6c0-0.275-0.225-0.5-0.5-0.5zM16 10h-3v-5h3v5z" }),
_('path', { d: "M7 10h4v1h-4v-1z" })
            );
        }
        function Newsletter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( NewsletterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Newsletter.SVG = NewsletterSVG;
        return Newsletter;
    })();
export const Newsletters = /*#__PURE__*/ (() => {
        function NewslettersSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 4h3v1h-3v-1z" }),
_('path', { d: "M6 6h3v1h-3v-1z" }),
_('path', { d: "M6 12h8v1h-8v-1z" }),
_('path', { d: "M6 14h7v1h-7v-1z" }),
_('path', { d: "M6 8h3v1h-3v-1z" }),
_('path', { d: "M13.5 4h-3c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5zM13 8h-2v-3h2v3z" }),
_('path', { d: "M6 10h8v1h-8v-1z" }),
_('path', { d: "M20 5c0-1.103-0.897-2-2-2v-1c0-1.103-0.897-2-2-2h-12c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h1c0 1.103 0.897 2 2 2 0 1.103 0.897 2 2 2h11c1.103 0 2-0.897 2-2v-15c0-1.103-0.897-2-2-2zM4 18v-16h12l0.003 16c0 0 0 0-0.003 0h-12zM6 20h10c1.103 0 2-0.897 2-2v-14c0.55 0 1 0.45 1 1v15c0 0.55-0.45 1-1 1h-11c-0.55 0-1-0.45-1-1zM21 22c0 0.55-0.45 1-1 1h-11c-0.55 0-1-0.45-1-1h10c1.103 0 2-0.897 2-2v-14c0.55 0 1 0.45 1 1v15z" })
            );
        }
        function Newsletters({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( NewslettersSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Newsletters.SVG = NewslettersSVG;
        return Newsletters;
    })();
export const NextCircle = /*#__PURE__*/ (() => {
        function NextCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M14.753 11.569l-6-3.5c-0.153-0.091-0.347-0.091-0.5-0.003-0.156 0.091-0.25 0.253-0.25 0.434v7c0 0.178 0.097 0.344 0.25 0.434 0.078 0.044 0.162 0.066 0.25 0.066s0.175-0.022 0.253-0.069l6-3.5c0.153-0.091 0.247-0.253 0.247-0.431s-0.097-0.344-0.25-0.431zM9 14.628v-5.256l4.506 2.628-4.506 2.628z" }),
_('path', { d: "M15 8h1v8h-1v-8z" })
            );
        }
        function NextCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( NextCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        NextCircle.SVG = NextCircleSVG;
        return NextCircle;
    })();
export const NextFrameCircle = /*#__PURE__*/ (() => {
        function NextFrameCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M16.753 11.569l-6-3.5c-0.153-0.091-0.347-0.091-0.5-0.003-0.156 0.091-0.25 0.253-0.25 0.434v7c0 0.178 0.097 0.344 0.25 0.434 0.078 0.044 0.162 0.066 0.25 0.066s0.175-0.022 0.253-0.069l6-3.5c0.153-0.091 0.247-0.253 0.247-0.431s-0.097-0.344-0.25-0.431zM11 14.628v-5.256l4.506 2.628-4.506 2.628z" }),
_('path', { d: "M8 8h1v8h-1v-8z" })
            );
        }
        function NextFrameCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( NextFrameCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        NextFrameCircle.SVG = NextFrameCircleSVG;
        return NextFrameCircle;
    })();
export const NextFrameSquare = /*#__PURE__*/ (() => {
        function NextFrameSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M10.25 15.934c0.078 0.044 0.162 0.066 0.25 0.066s0.175-0.022 0.253-0.069l6-3.5c0.153-0.091 0.247-0.253 0.247-0.431s-0.094-0.344-0.247-0.431l-6-3.5c-0.153-0.091-0.347-0.091-0.5-0.003-0.156 0.091-0.25 0.253-0.25 0.434v7c-0.003 0.178 0.094 0.344 0.247 0.434zM11 9.372l4.506 2.628-4.506 2.628v-5.256z" }),
_('path', { d: "M8 8h1v8h-1v-8z" })
            );
        }
        function NextFrameSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( NextFrameSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        NextFrameSquare.SVG = NextFrameSquareSVG;
        return NextFrameSquare;
    })();
export const NextFrame = /*#__PURE__*/ (() => {
        function NextFrameSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.516 11.144l-15-9c-0.309-0.184-0.694-0.191-1.006-0.012-0.316 0.175-0.509 0.509-0.509 0.869v18c0 0.359 0.194 0.694 0.506 0.869 0.153 0.087 0.322 0.131 0.494 0.131 0.178 0 0.356-0.047 0.516-0.144l15-9c0.3-0.181 0.484-0.506 0.484-0.856s-0.184-0.678-0.484-0.856zM8 19.234v-14.469l12.056 7.234-12.056 7.234z" }),
_('path', { d: "M2 2h2v20h-2v-20z" })
            );
        }
        function NextFrame({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( NextFrameSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        NextFrame.SVG = NextFrameSVG;
        return NextFrame;
    })();
export const NextSquare = /*#__PURE__*/ (() => {
        function NextSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M8.25 15.934c0.078 0.044 0.162 0.066 0.25 0.066s0.175-0.022 0.253-0.069l6-3.5c0.153-0.091 0.247-0.253 0.247-0.431s-0.094-0.344-0.247-0.431l-6-3.5c-0.153-0.091-0.347-0.091-0.5-0.003-0.156 0.091-0.25 0.253-0.25 0.434v7c-0.003 0.178 0.094 0.344 0.247 0.434zM9 9.372l4.506 2.628-4.506 2.628v-5.256z" }),
_('path', { d: "M15 8h1v8h-1v-8z" })
            );
        }
        function NextSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( NextSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        NextSquare.SVG = NextSquareSVG;
        return NextSquare;
    })();
export const Next = /*#__PURE__*/ (() => {
    function NextSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19 2v8.834l-14.484-8.691c-0.309-0.184-0.694-0.191-1.006-0.012-0.316 0.175-0.509 0.509-0.509 0.869v18c0 0.359 0.194 0.694 0.506 0.869 0.153 0.087 0.322 0.131 0.494 0.131 0.178 0 0.356-0.047 0.516-0.144l14.484-8.691v8.834h2v-20h-2zM5 19.234v-14.469l12.056 7.234-12.056 7.234z" })
        );
    }
    function Next({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( NextSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Next.SVG = NextSVG;
    return Next;
})();
export const Ninja = /*#__PURE__*/ (() => {
        function NinjaSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 2c2.678 0 5.112 1.059 6.909 2.778-1.987 0.794-4.394 1.222-6.909 1.222s-4.922-0.428-6.909-1.222c1.797-1.719 4.231-2.778 6.909-2.778zM4.356 5.556c2.178 0.934 4.853 1.444 7.644 1.444s5.466-0.509 7.644-1.444c1.344 1.594 2.2 3.609 2.337 5.819-1.003 1.469-1.922 2.272-2.881 2.525-0.912 0.241-1.863 0.006-3.066-0.288-1.137-0.278-2.425-0.597-4.034-0.597s-2.897 0.316-4.034 0.597c-1.203 0.294-2.153 0.528-3.066 0.288-0.959-0.253-1.878-1.056-2.881-2.525 0.138-2.209 0.994-4.225 2.337-5.819zM12 22c-5.15 0-9.403-3.912-9.944-8.925 0.847 0.984 1.675 1.55 2.587 1.791 0.356 0.094 0.709 0.134 1.062 0.134 0.797 0 1.603-0.197 2.497-0.416 1.081-0.266 2.309-0.566 3.797-0.566s2.712 0.3 3.797 0.566c1.287 0.316 2.4 0.588 3.559 0.284 0.912-0.241 1.741-0.809 2.587-1.791-0.541 5.009-4.794 8.922-9.944 8.922z" }),
_('path', { d: "M7.381 9.503c-0.237 0.266-0.381 0.616-0.381 0.997 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.181-0.031-0.356-0.091-0.516 0.194 0.009 0.394 0.016 0.591 0.016h0.5v-1h-0.5c-1.437 0-2.816-0.325-3.784-0.894l-0.431-0.253-0.506 0.863 0.431 0.253c0.356 0.209 0.747 0.387 1.172 0.534zM8.5 11c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M14.094 9.981c-0.059 0.162-0.094 0.337-0.094 0.519 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.387-0.147-0.741-0.387-1.006 0.413-0.147 0.794-0.322 1.141-0.525l0.431-0.253-0.506-0.863-0.431 0.253c-0.969 0.569-2.347 0.894-3.784 0.894h-0.5v1h0.5c0.213 0 0.422-0.006 0.631-0.019zM15.5 11c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" })
            );
        }
        function Ninja({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( NinjaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ninja.SVG = NinjaSVG;
        return Ninja;
    })();
export const NoEntry = /*#__PURE__*/ (() => {
        function NoEntrySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M6 11h12v2h-12v-2z" })
            );
        }
        function NoEntry({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( NoEntrySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        NoEntry.SVG = NoEntrySVG;
        return NoEntry;
    })();
export const No = /*#__PURE__*/ (() => {
        function NoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0.944 7.328c0.603-1.428 1.469-2.712 2.572-3.813 1.103-1.103 2.384-1.966 3.813-2.572 1.481-0.625 3.053-0.944 4.672-0.944s3.191 0.319 4.672 0.944c1.428 0.603 2.712 1.469 3.813 2.572 1.103 1.103 1.966 2.384 2.572 3.813 0.625 1.481 0.944 3.053 0.944 4.672s-0.319 3.191-0.944 4.672c-0.603 1.428-1.469 2.712-2.572 3.813-1.103 1.103-2.384 1.966-3.813 2.572-1.481 0.625-3.053 0.944-4.672 0.944s-3.191-0.319-4.672-0.944c-1.428-0.603-2.712-1.469-3.813-2.572-1.103-1.103-1.966-2.384-2.572-3.813-0.625-1.481-0.944-3.053-0.944-4.672s0.319-3.191 0.944-4.672zM12 22c5.513 0 10-4.488 10-10s-4.488-10-10-10c-5.512 0-10 4.488-10 10s4.488 10 10 10z" }),
_('path', { d: "M12 3c2.403 0 4.666 0.938 6.363 2.637s2.637 3.959 2.637 6.363-0.938 4.666-2.637 6.363c-1.697 1.7-3.959 2.637-6.363 2.637s-4.666-0.938-6.363-2.637c-1.7-1.697-2.637-3.959-2.637-6.363s0.938-4.666 2.637-6.363c1.697-1.7 3.959-2.637 6.363-2.637zM12 4c-1.847 0-3.547 0.628-4.903 1.684l11.219 11.219c1.056-1.356 1.684-3.056 1.684-4.903 0-4.413-3.588-8-8-8zM12 20c1.847 0 3.547-0.628 4.903-1.684l-11.219-11.219c-1.056 1.356-1.684 3.056-1.684 4.903 0 4.413 3.588 8 8 8z" })
            );
        }
        function No({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( NoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        No.SVG = NoSVG;
        return No;
    })();
export const Notebook = /*#__PURE__*/ (() => {
        function NotebookSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 7h7v1h-7v-1z" }),
_('path', { d: "M6 9h10v1h-10v-1z" }),
_('path', { d: "M6 11h8v1h-8v-1z" }),
_('path', { d: "M24 8.916c0-0.509-0.2-0.991-0.563-1.353-0.747-0.747-1.959-0.747-2.706 0l-0.731 0.731v-5.294c0-1.103-0.897-2-2-2h-2v-1h-1v1h-2v-1h-1v1h-2v-1h-1v1h-2v-1h-1v1h-2c-1.103 0-2 0.897-2 2v19c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-8.294l3.438-3.438c0.363-0.363 0.563-0.844 0.563-1.353zM15.753 16.541l-1.616 0.322 0.322-1.616 6.041-6.041 1.294 1.294-6.041 6.041zM4 22v-19h2v2h1v-2h2v2h1v-2h2v2h1v-2h2v2h1v-2h2v7.294l-4.353 4.353c-0.069 0.069-0.119 0.159-0.138 0.256l-0.5 2.5c-0.031 0.162 0.019 0.334 0.138 0.453 0.094 0.094 0.222 0.147 0.353 0.147 0.031 0 0.066-0.003 0.097-0.009l2.5-0.5c0.097-0.019 0.184-0.066 0.256-0.138l1.647-1.647v6.291h-14zM22.731 9.563l-0.231 0.231-1.294-1.294 0.231-0.231c0.356-0.356 0.938-0.356 1.294 0 0.172 0.172 0.269 0.403 0.269 0.647s-0.097 0.472-0.269 0.647z" }),
_('path', { d: "M6 13h6v1h-6v-1z" }),
_('path', { d: "M6 16h5v1h-5v-1z" }),
_('path', { d: "M6 18h6v1h-6v-1z" })
            );
        }
        function Notebook({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( NotebookSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Notebook.SVG = NotebookSVG;
        return Notebook;
    })();
export const Nuclear = /*#__PURE__*/ (() => {
        function NuclearSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 10c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12 13c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M8.634 8.169c0.131 0.231 0.35 0.397 0.606 0.466 0.084 0.022 0.172 0.034 0.259 0.034 0.175 0 0.347-0.047 0.5-0.134 0.603-0.35 1.297-0.534 2-0.534s1.394 0.184 2 0.534c0.231 0.134 0.503 0.169 0.759 0.1s0.475-0.237 0.606-0.466l3-5.197c0.275-0.478 0.113-1.091-0.366-1.366-1.816-1.050-3.891-1.606-6-1.606s-4.184 0.556-6 1.606c-0.478 0.275-0.641 0.888-0.366 1.366l3 5.197zM12 2c1.422 0 2.825 0.303 4.109 0.881l-2.016 3.494c-0.666-0.247-1.375-0.375-2.094-0.375-0.716 0-1.425 0.128-2.094 0.375l-2.016-3.494c1.284-0.578 2.688-0.881 4.109-0.881z" }),
_('path', { d: "M10 15.466c-0.606-0.35-1.113-0.856-1.463-1.466-0.353-0.609-0.537-1.3-0.537-2 0-0.266-0.106-0.519-0.294-0.706s-0.441-0.294-0.706-0.294h-6c0 0 0 0 0 0-0.553 0-1 0.447-1 1-0.003 2.1 0.553 4.175 1.609 6 1.053 1.825 2.572 3.347 4.394 4.394 0.156 0.091 0.328 0.134 0.497 0.134 0.347 0 0.681-0.178 0.866-0.5l3-5.197c0.131-0.231 0.169-0.503 0.1-0.759s-0.237-0.475-0.466-0.606zM6.159 20.119c-1.144-0.825-2.109-1.887-2.819-3.119s-1.15-2.597-1.291-4h4.034c0.119 0.7 0.363 1.378 0.722 2s0.825 1.172 1.372 1.625l-2.019 3.494z" }),
_('path', { d: "M23 11h-6c-0.266 0-0.519 0.106-0.706 0.294s-0.294 0.444-0.294 0.706c0 0.7-0.184 1.391-0.537 2s-0.856 1.116-1.462 1.466c-0.231 0.131-0.397 0.35-0.466 0.606s-0.034 0.528 0.1 0.759l3 5.197c0.184 0.322 0.522 0.5 0.866 0.5 0.169 0 0.341-0.044 0.497-0.134 1.819-1.047 3.338-2.569 4.394-4.394 1.053-1.825 1.609-3.9 1.609-6 0-0.553-0.447-1-1-1zM20.659 17c-0.709 1.231-1.675 2.294-2.819 3.119l-2.016-3.494c0.547-0.453 1.013-1.003 1.372-1.625s0.603-1.3 0.722-2h4.034c-0.144 1.403-0.581 2.769-1.294 4z" })
            );
        }
        function Nuclear({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( NuclearSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Nuclear.SVG = NuclearSVG;
        return Nuclear;
    })();
export const ObelusCircle = /*#__PURE__*/ (() => {
        function ObelusCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M8 11h8v2h-8v-2z" }),
_('path', { d: "M12 14c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1z" }),
_('path', { d: "M12 10c0.55 0 1-0.45 1-1s-0.45-1-1-1c-0.55 0-1 0.45-1 1s0.45 1 1 1z" })
            );
        }
        function ObelusCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ObelusCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ObelusCircle.SVG = ObelusCircleSVG;
        return ObelusCircle;
    })();
export const ObelusSquare = /*#__PURE__*/ (() => {
        function ObelusSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M8 11h8v2h-8v-2z" }),
_('path', { d: "M12 10c0.55 0 1-0.45 1-1s-0.45-1-1-1c-0.55 0-1 0.45-1 1s0.45 1 1 1zM12 9v0c0 0 0 0 0 0z" }),
_('path', { d: "M12 14c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 15c0 0 0 0 0 0v0z" })
            );
        }
        function ObelusSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ObelusSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ObelusSquare.SVG = ObelusSquareSVG;
        return ObelusSquare;
    })();
export const Obelus = /*#__PURE__*/ (() => {
        function ObelusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 11h20v2h-20v-2z" }),
_('path', { d: "M12 9c1.653 0 3-1.347 3-3s-1.347-3-3-3-3 1.347-3 3 1.347 3 3 3zM12 5c0.55 0 1 0.45 1 1s-0.45 1-1 1c-0.55 0-1-0.45-1-1s0.45-1 1-1z" }),
_('path', { d: "M12 15c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM12 19c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" })
            );
        }
        function Obelus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ObelusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Obelus.SVG = ObelusSVG;
        return Obelus;
    })();
export const Office = /*#__PURE__*/ (() => {
        function OfficeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 22v-18h1v-1h-1v-2h1v-1h-16v1h1v2h-1v1h1v18h-2v2h18v-2h-2zM7 2h10v1h-10v-1zM7 4h10v18h-2v-3.5c0-0.275-0.225-0.5-0.5-0.5h-5c-0.275 0-0.5 0.225-0.5 0.5v3.5h-2v-18zM14 22h-4v-3h4v3z" }),
_('path', { d: "M8 5h2v2h-2v-2z" }),
_('path', { d: "M11 5h2v2h-2v-2z" }),
_('path', { d: "M14 5h2v2h-2v-2z" }),
_('path', { d: "M8 8h2v2h-2v-2z" }),
_('path', { d: "M11 8h2v2h-2v-2z" }),
_('path', { d: "M14 8h2v2h-2v-2z" }),
_('path', { d: "M8 11h2v2h-2v-2z" }),
_('path', { d: "M11 11h2v2h-2v-2z" }),
_('path', { d: "M14 11h2v2h-2v-2z" }),
_('path', { d: "M8 14h2v2h-2v-2z" }),
_('path', { d: "M11 14h2v2h-2v-2z" }),
_('path', { d: "M14 14h2v2h-2v-2z" })
            );
        }
        function Office({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( OfficeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Office.SVG = OfficeSVG;
        return Office;
    })();
export const OilPressure = /*#__PURE__*/ (() => {
        function OilPressureSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 8c-0.075 0-0.147 0.009-0.219 0.025l-8.238 1.831-0.375-0.747c-0.341-0.684-1.025-1.106-1.788-1.106h-2.381v-1h1v-1h-3v1h1v1h-3c-0.253 0-0.487 0.094-0.663 0.253l-3.678-1.231c-0.153-0.050-0.319-0.025-0.45 0.069s-0.206 0.244-0.206 0.406v3c0 0.216 0.138 0.406 0.341 0.475l3.659 1.219v2.569c0 0.306 0.072 0.616 0.213 0.894l0.619 1.238c0.341 0.681 1.025 1.106 1.788 1.106h6c0.487 0 0.959-0.178 1.328-0.503 0 0 0.003-0.003 0.003-0.003l8.428-7.494h1.619v-2h-2zM1 10.141v-1.947l3 1v1.947l-3-1zM12.622 15.997c-0.003 0.003-0.003 0.003-0.003 0.003h-6c0 0 0 0 0 0l-0.619-1.237v-4.763h5.381c0 0 0 0 0 0l0.725 1.447c0.206 0.409 0.663 0.628 1.113 0.528l5.238-1.162-5.834 5.184z" }),
_('path', { d: "M22.997 13.431c-0.034-0.247-0.247-0.431-0.497-0.431s-0.462 0.184-0.497 0.431c-0.037 0.263-0.213 0.619-0.397 0.997-0.284 0.581-0.609 1.241-0.609 1.928 0 0.906 0.672 1.644 1.5 1.644s1.5-0.738 1.5-1.644c0-0.687-0.322-1.347-0.609-1.928-0.181-0.378-0.356-0.731-0.391-0.997zM22.5 17c-0.272 0-0.5-0.294-0.5-0.644 0-0.45 0.253-0.972 0.5-1.475 0.247 0.503 0.5 1.022 0.5 1.475 0 0.35-0.228 0.644-0.5 0.644z" })
            );
        }
        function OilPressure({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( OilPressureSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        OilPressure.SVG = OilPressureSVG;
        return OilPressure;
    })();
export const OilPrice = /*#__PURE__*/ (() => {
        function OilPriceSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 16.716v-0.716h-1v0.716c0 2.362 1.794 4.284 4 4.284v-1c-1.653 0-3-1.472-3-3.284z" }),
_('path', { d: "M22 8.5c0-3.584-2.916-6.5-6.5-6.5-1.75 0-3.344 0.697-4.512 1.825-0.441-0.956-0.856-2.022-0.997-2.972-0.075-0.491-0.494-0.853-0.991-0.853 0 0 0 0 0 0-0.497 0-0.916 0.363-0.991 0.853-0.253 1.719-1.369 3.797-2.547 5.997-0.819 1.531-1.669 3.113-2.325 4.741-0.766 1.909-1.137 3.584-1.137 5.122 0 4.019 3.141 7.287 7 7.287s7-3.269 7-7.287c0-0.55-0.050-1.128-0.147-1.722 3.422-0.184 6.147-3.025 6.147-6.491zM9 22c-2.756 0-5-2.372-5-5.288 0-2.897 1.641-5.956 3.225-8.916 0.647-1.206 1.272-2.375 1.772-3.509 0.209 0.475 0.434 0.938 0.653 1.372v0c-0.416 0.859-0.65 1.822-0.65 2.841 0 2.988 2.025 5.509 4.775 6.269 0.153 0.694 0.225 1.331 0.225 1.944 0 2.916-2.244 5.288-5 5.288zM15.5 14c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16 4h-1v2h-0.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h2c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-3.5v1h2v2h1v-2h0.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-2c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3.5v-1h-2v-2z" })
            );
        }
        function OilPrice({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( OilPriceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        OilPrice.SVG = OilPriceSVG;
        return OilPrice;
    })();
export const Ol = /*#__PURE__*/ (() => {
        function OlSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 4h17v2h-17v-2z" }),
_('path', { d: "M6 11h17v2h-17v-2z" }),
_('path', { d: "M6 18h17v2h-17v-2z" }),
_('path', { d: "M2 3.706v3.294h1v-4.5c0-0.203-0.122-0.384-0.309-0.462s-0.403-0.034-0.544 0.109l-1.353 1.353 0.706 0.706 0.5-0.5z" }),
_('path', { d: "M4 10.5c0-0.45-0.172-0.85-0.481-1.125-0.272-0.241-0.634-0.375-1.019-0.375s-0.747 0.134-1.019 0.378c-0.309 0.275-0.481 0.675-0.481 1.125v0.5h1v-0.5c0-0.478 0.416-0.5 0.5-0.5 0.138 0 0.266 0.044 0.356 0.125 0.097 0.084 0.144 0.213 0.144 0.378 0 0.612-0.341 0.9-0.897 1.319-0.491 0.363-1.103 0.819-1.103 1.675 0 0.275 0.225 0.5 0.5 0.5h2.5v-1h-1.766c0.116-0.116 0.272-0.234 0.466-0.381 0.55-0.413 1.3-0.975 1.3-2.119z" }),
_('path', { d: "M2.95 18.069l0.95-1.269c0.112-0.15 0.131-0.353 0.047-0.525-0.084-0.169-0.259-0.275-0.447-0.275h-2.5v1h1.5l-0.9 1.2c-0.113 0.15-0.131 0.353-0.047 0.525 0.084 0.169 0.259 0.275 0.447 0.275h0.5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-1.5v1h1.5c0.828 0 1.5-0.672 1.5-1.5 0-0.672-0.444-1.241-1.050-1.431z" })
            );
        }
        function Ol({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( OlSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ol.SVG = OlSVG;
        return Ol;
    })();
export const Omega = /*#__PURE__*/ (() => {
    function OmegaSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16.809 20c2.019-3.394 3.087-6.509 3.178-9.281 0.047-1.444-0.175-2.772-0.663-3.95-0.456-1.106-1.134-2.056-2.013-2.825-1.431-1.253-3.319-1.944-5.313-1.944s-3.881 0.691-5.313 1.944c-0.878 0.769-1.556 1.719-2.013 2.825-0.488 1.178-0.709 2.506-0.663 3.95 0.091 2.769 1.159 5.884 3.178 9.281h-5.191v2h7c0.369 0 0.706-0.203 0.881-0.528s0.156-0.719-0.047-1.025c-2.444-3.687-3.731-6.981-3.822-9.794-0.072-2.2 0.616-4 1.994-5.206 2.203-1.928 5.791-1.928 7.994 0 1.375 1.203 2.066 3.003 1.994 5.206-0.094 2.812-1.378 6.106-3.822 9.794-0.203 0.306-0.222 0.7-0.047 1.025s0.506 0.528 0.875 0.528h7v-2h-5.191z" })
        );
    }
    function Omega({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( OmegaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Omega.SVG = OmegaSVG;
    return Omega;
})();
export const Pacifier = /*#__PURE__*/ (() => {
        function PacifierSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6c0 1.097 0.294 2.125 0.809 3.009-0.409 0.038-0.794 0.2-1.106 0.466l-3.881-3.881c-0.781-0.781-2.050-0.781-2.831 0l-1.209 1.209c-0.094 0.094-0.147 0.222-0.147 0.353s0.053 0.259 0.147 0.353l3.65 3.647-0.859 0.859c-0.344 0.344-0.55 0.8-0.581 1.284-0.097 1.512-0.972 2.7-1.991 2.7-1.078 0-2.091 0.422-2.847 1.191-0.759 0.769-1.169 1.788-1.153 2.866 0.016 1.044 0.431 2.028 1.175 2.769 0.744 0.744 1.725 1.159 2.769 1.175 0.019 0 0.037 0 0.056 0 1.059 0 2.053-0.406 2.806-1.153 0.769-0.756 1.191-1.769 1.191-2.847 0-1.019 1.188-1.894 2.703-1.991 0.484-0.031 0.941-0.237 1.284-0.581l0.859-0.859 3.647 3.647c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l1.206-1.206c0.378-0.378 0.584-0.881 0.584-1.416s-0.209-1.038-0.584-1.416l-3.878-3.881c0.275-0.322 0.428-0.709 0.466-1.106 0.884 0.513 1.913 0.809 3.009 0.809zM18 1c2.756 0 5 2.244 5 5s-2.244 5-5 5-5-2.244-5-5 2.244-5 5-5zM10.572 16.013c-2.606 0.169-4.572 1.884-4.572 3.987 0 0.541-0.213 1.044-0.597 1.425-0.384 0.378-0.894 0.581-1.434 0.575-1.072-0.016-1.956-0.9-1.972-1.972-0.006-0.541 0.197-1.050 0.575-1.434 0.384-0.381 0.888-0.594 1.428-0.594 2.103 0 3.819-1.966 3.987-4.572l0.859-0.859 2.587 2.584-0.863 0.859zM16.141 18.45l-10.591-10.587 0.856-0.856 10.584 10.587-0.85 0.856zM12.416 10.188c0.169-0.122 0.372-0.188 0.584-0.188 0.266 0 0.519 0.103 0.706 0.294 0.35 0.35 0.387 0.9 0.106 1.291l-1.397-1.397z" }),
_('path', { d: "M18 10c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zM18 3c1.653 0 3 1.347 3 3s-1.347 3-3 3-3-1.347-3-3 1.347-3 3-3z" })
            );
        }
        function Pacifier({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PacifierSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pacifier.SVG = PacifierSVG;
        return Pacifier;
    })();
export const PageBreak = /*#__PURE__*/ (() => {
        function PageBreakSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 10h12c1.103 0 2-0.897 2-2v-8h-2v8h-12v-8h-2v8c0 1.103 0.897 2 2 2z" }),
_('path', { d: "M18 15h-12c-1.103 0-2 0.897-2 2v7h2v-7h12v7h2v-7c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M0 12h1v1h-1v-1zM4 12h-2v1h2v-1zM5 13h2v-1h-2v1zM10 13v-1h-2v1h2zM13 13v-1h-2v1h2zM16 13v-1h-2v1h2zM17 13h2v-1h-2v1zM20 13h2v-1h-2v1zM23 12v1h1v-1h-1z" })
            );
        }
        function PageBreak({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PageBreakSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PageBreak.SVG = PageBreakSVG;
        return PageBreak;
    })();
export const PaintRoller = /*#__PURE__*/ (() => {
        function PaintRollerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21 3h-1v-1c0-1.103-0.897-2-2-2h-13c-1.103 0-2 0.897-2 2v3c0 1.103 0.897 2 2 2h13c1.103 0 2-0.897 2-2v-1h1c0.55 0 1 0.45 1 1v3c0 0.55-0.45 1-1 1h-8c-1.103 0-2 0.897-2 2v0.050c-1.141 0.231-2 1.244-2 2.45v8c0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5v-8c0-1.206-0.859-2.219-2-2.45v-0.050c0-0.55 0.45-1 1-1h8c1.103 0 2-0.897 2-2v-3c0-1.103-0.897-2-2-2zM4 5v-3c0-0.55 0.45-1 1-1h13c0.55 0 1 0.45 1 1v1c0 0.55-0.45 1-1 1-0.444 0-0.656-0.247-1.025-0.722-0.419-0.541-0.991-1.278-2.225-1.278-1.041 0-1.541 0.644-1.944 1.163-0.416 0.534-0.681 0.837-1.306 0.837-0.837 0-1.409-0.281-1.962-0.55-0.663-0.325-1.347-0.659-2.231-0.284-0.566 0.237-0.919 0.513-1.116 0.859-0.191 0.334-0.191 0.669-0.191 0.938v0.037c0 0.55-0.45 1-1 1s-1-0.45-1-1zM7 5v-0.041c0-0.216 0.003-0.344 0.059-0.444 0.078-0.141 0.3-0.288 0.634-0.431 0.447-0.187 0.772-0.050 1.403 0.263 0.594 0.291 1.331 0.653 2.403 0.653 1.147 0 1.672-0.678 2.097-1.225 0.397-0.509 0.628-0.775 1.153-0.775 0.744 0 1.050 0.394 1.434 0.891 0.384 0.494 0.863 1.109 1.816 1.109h-11zM12 21.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5v-8c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v8z" }),
_('path', { d: "M4.997 9.431c-0.034-0.247-0.247-0.431-0.497-0.431s-0.462 0.184-0.497 0.431c-0.038 0.263-0.209 0.619-0.397 0.997-0.284 0.581-0.609 1.241-0.609 1.928 0 0.906 0.672 1.644 1.5 1.644s1.5-0.738 1.5-1.644c0-0.687-0.322-1.347-0.609-1.928-0.181-0.378-0.356-0.731-0.391-0.997zM4.5 13c-0.272 0-0.5-0.294-0.5-0.644 0-0.45 0.253-0.972 0.5-1.475 0.247 0.503 0.5 1.022 0.5 1.475 0 0.35-0.228 0.644-0.5 0.644z" })
            );
        }
        function PaintRoller({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PaintRollerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PaintRoller.SVG = PaintRollerSVG;
        return PaintRoller;
    })();
export const Palette = /*#__PURE__*/ (() => {
        function PaletteSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.4 11.019c-0.809-0.578-1.806-0.934-2.684-1.25-0.478-0.172-0.931-0.334-1.275-0.503-0.306-0.15-0.409-0.253-0.441-0.291 0-0.059 0.009-0.091 0.012-0.106 0.084-0.069 0.381-0.162 0.563-0.219 0.847-0.269 2.425-0.769 2.425-3.15 0-1.431-0.916-2.663-2.578-3.472-1.369-0.666-3.228-1.031-5.231-1.031-3.197 0-6.369 0.909-8.7 2.494-2.937 1.997-4.491 4.938-4.491 8.509 0 1.6 0.294 3.109 0.875 4.484 0.566 1.338 1.388 2.512 2.441 3.497 1.038 0.969 2.272 1.722 3.663 2.238 1.4 0.519 2.919 0.781 4.519 0.781 1.575 0 3.122-0.209 4.597-0.625 1.475-0.413 2.803-1.009 3.953-1.775 2.55-1.688 3.953-4.031 3.953-6.6 0-1.219-0.537-2.219-1.6-2.981zM18.947 18.934c-1.975 1.313-4.691 2.066-7.447 2.066-5.594 0-9.5-3.7-9.5-9 0-2.919 1.216-5.225 3.612-6.856 2.009-1.366 4.772-2.15 7.578-2.15 3.256 0.003 5.809 1.103 5.809 2.506 0 0.919-0.259 1-1.028 1.244-0.387 0.122-0.828 0.262-1.206 0.563-0.35 0.278-0.766 0.797-0.766 1.691 0 0.756 0.403 1.384 1.197 1.866 0.522 0.316 1.166 0.544 1.844 0.788 1.788 0.638 2.959 1.147 2.959 2.347 0 1.878-1.084 3.631-3.053 4.938z" }),
_('path', { d: "M7 12.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5zM5.5 13c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M7.5 15c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM7.5 17c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M7.5 7c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM7.5 9c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M11.5 5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5zM11.5 7c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M16.941 13.031c-0.725-0.1-1.509 0.044-2.209 0.403-0.847 0.434-1.45 1.128-1.656 1.897-0.153 0.569-0.072 1.141 0.228 1.609 0.356 0.559 0.981 0.925 1.753 1.028 0.15 0.022 0.303 0.031 0.456 0.031 0.591 0 1.197-0.15 1.753-0.434 0.847-0.434 1.45-1.128 1.656-1.897 0.153-0.569 0.072-1.141-0.228-1.609-0.356-0.559-0.981-0.925-1.753-1.028zM17.959 15.409c-0.131 0.491-0.563 0.966-1.15 1.269-1.013 0.522-2.231 0.394-2.663-0.275-0.188-0.294-0.162-0.603-0.106-0.809 0.131-0.491 0.563-0.966 1.15-1.269 0.422-0.216 0.878-0.322 1.3-0.322 0.591 0 1.113 0.206 1.362 0.597 0.188 0.294 0.162 0.603 0.106 0.809z" })
            );
        }
        function Palette({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PaletteSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Palette.SVG = PaletteSVG;
        return Palette;
    })();
export const Palm = /*#__PURE__*/ (() => {
    function PalmSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18.834 4.016c-0.409-1.172-1.525-2.016-2.834-2.016-0.237 0-0.469 0.028-0.697 0.081-0.55-0.659-1.378-1.081-2.303-1.081-0.922 0-1.753 0.419-2.306 1.081-0.225-0.053-0.459-0.081-0.694-0.081-1.653 0-3 1.347-3 3v7.15l-1.128-0.738c-0.406-0.266-0.881-0.409-1.372-0.409-1.378 0-2.5 1.119-2.5 2.497 0 0.541 0.172 1.059 0.497 1.497 0 0.003 0.003 0.003 0.003 0.006l4.525 6.034c0.922 1.228 2.394 1.962 3.934 1.962h4.887c1.85 0 3.525-1.019 4.372-2.656 0 0 0-0.003 0-0.003 1.166-2.262 1.781-4.803 1.781-7.341v-5.5c0-1.819-1.391-3.316-3.166-3.484zM15.5 4.134c0.15-0.087 0.322-0.134 0.5-0.134 0.55 0 1 0.45 1 1v8h1v-6.916c0.159-0.056 0.328-0.084 0.5-0.084 0.828 0 1.5 0.672 1.5 1.5v5.5c0 2.222-0.537 4.444-1.556 6.425-0.503 0.972-1.497 1.575-2.597 1.575h-4.887c-0.916 0-1.788-0.434-2.334-1.163l-4.522-6.031c-0.047-0.063-0.103-0.169-0.103-0.306 0-0.275 0.225-0.497 0.5-0.497 0.1 0 0.194 0.028 0.275 0.081l2.678 1.753c0.306 0.2 0.7 0.219 1.022 0.044s0.525-0.513 0.525-0.881v-9c0-0.55 0.45-1 1-1 0.178 0 0.35 0.047 0.5 0.134 0.153 0.087 0.278 0.216 0.366 0.366 0.087 0.153 0.134 0.325 0.134 0.5v7h1v-8c0-0.019 0-0.041 0.003-0.059 0.028-0.528 0.466-0.941 0.997-0.941 0.55 0 1 0.45 1 1v8h1v-7c0-0.175 0.047-0.347 0.134-0.5s0.213-0.278 0.366-0.366z" })
        );
    }
    function Palm({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PalmSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Palm.SVG = PalmSVG;
    return Palm;
})();
export const Panorama = /*#__PURE__*/ (() => {
        function PanoramaSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.575 4.181c-0.266-0.188-0.609-0.231-0.916-0.122-7.072 2.572-14.244 2.572-21.316 0-0.306-0.112-0.647-0.066-0.916 0.122s-0.428 0.494-0.428 0.819v14c0 0.325 0.159 0.631 0.425 0.819s0.609 0.231 0.916 0.122c7.072-2.572 14.244-2.572 21.316 0 0.113 0.041 0.228 0.059 0.341 0.059 0.203 0 0.403-0.063 0.575-0.181 0.266-0.188 0.425-0.494 0.425-0.819v-14c0.003-0.325-0.156-0.631-0.422-0.819zM18 7.422v6.75l-1.584-1.587c-0.781-0.778-2.050-0.778-2.828 0l-3.475 3.472c-1.369 0.084-2.741 0.256-4.113 0.522v-9.156c2.003 0.384 4.009 0.578 6 0.578s3.997-0.194 6-0.578zM2 6.397c0.997 0.319 1.997 0.591 3 0.816v9.575c-1.003 0.225-2.003 0.497-3 0.816v-11.206zM11.581 16.003l2.712-2.712c0.391-0.387 1.025-0.387 1.416 0l2.291 2.297v0.991c-2.003-0.384-4.009-0.578-6-0.578-0.141 0-0.278 0-0.419 0.003zM22 17.603c-0.997-0.319-1.997-0.591-3-0.816v-9.575c1.003-0.225 2.003-0.497 3-0.816v11.206z" }),
_('path', { d: "M9.5 12c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM9.5 10c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" })
            );
        }
        function Panorama({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PanoramaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Panorama.SVG = PanoramaSVG;
        return Panorama;
    })();
export const Pants = /*#__PURE__*/ (() => {
    function PantsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.987 21.847l-2.988-19.422v-1.925c0-0.275-0.225-0.5-0.5-0.5h-13c-0.275 0-0.5 0.225-0.5 0.5v1.925l-2.988 19.422c-0.081 0.528 0.269 1.028 0.794 1.131l5 1c0.509 0.103 1.016-0.206 1.156-0.706l3.037-10.631 3.037 10.634c0.125 0.438 0.522 0.725 0.959 0.725 0.066 0 0.131-0.006 0.197-0.019l5-1c0.528-0.106 0.875-0.603 0.794-1.134zM17.066 3l0.456 2.975c-0.703-0.078-1.244-0.344-1.647-0.803-0.431-0.491-0.706-1.219-0.828-2.169h2.019zM18 2h-5v-1h5v1zM6 1h5v1h-5v-1zM6.934 3h2.016c-0.122 0.95-0.397 1.678-0.828 2.169-0.403 0.459-0.944 0.725-1.647 0.803l0.459-2.972zM16.709 21.837l-3.747-13.113c-0.122-0.428-0.516-0.725-0.963-0.725s-0.837 0.297-0.963 0.725l-3.747 13.113-3.159-0.631 2.187-14.216c1.55-0.094 3.291-0.912 3.638-3.991h4.084c0.347 3.078 2.088 3.897 3.637 3.991l2.187 14.216-3.156 0.631z" })
        );
    }
    function Pants({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PantsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pants.SVG = PantsSVG;
    return Pants;
})();
export const PaperCup = /*#__PURE__*/ (() => {
        function PaperCupSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.5 2h-0.691l-0.863-1.725c-0.084-0.169-0.256-0.275-0.447-0.275h-11c-0.191 0-0.363 0.106-0.447 0.275l-0.862 1.725h-0.691c-0.828 0-1.5 0.672-1.5 1.5v2c0 0.275 0.225 0.5 0.5 0.5h0.55l1.956 17.112c0.056 0.506 0.484 0.888 0.994 0.888h10c0.509 0 0.934-0.381 0.994-0.888l1.956-17.112h0.55c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.828-0.672-1.5-1.5-1.5zM6.809 1h10.381l0.5 1h-11.381l0.5-1zM6.522 10h10.959l-0.916 8h-9.131l-0.912-8zM7.894 22l-0.344-3h8.9l-0.344 3h-8.212zM17.594 9h-11.187l-0.344-3h11.875l-0.344 3zM20 5h-16v-1.5c0-0.275 0.225-0.5 0.5-0.5h15c0.275 0 0.5 0.225 0.5 0.5v1.5z" }),
_('path', { d: "M13.725 12.028c-0.306-0.681-0.884-1.028-1.725-1.028s-1.419 0.347-1.725 1.028c-0.253 0.569-0.275 1.316-0.275 1.972s0.022 1.403 0.275 1.972c0.306 0.681 0.884 1.028 1.725 1.028s1.419-0.347 1.725-1.028c0.253-0.569 0.275-1.316 0.275-1.972s-0.022-1.403-0.275-1.972zM12 16c-0.738 0-1-0.303-1-2s0.263-2 1-2 1 0.303 1 2-0.263 2-1 2z" })
            );
        }
        function PaperCup({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PaperCupSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PaperCup.SVG = PaperCupSVG;
        return PaperCup;
    })();
export const PaperPlane = /*#__PURE__*/ (() => {
    function PaperPlaneSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.656 1.244c-0.297-0.256-0.712-0.319-1.069-0.156l-22 10c-0.384 0.175-0.616 0.569-0.584 0.987s0.319 0.772 0.722 0.888l6.275 1.791v7.247c0 0.441 0.288 0.828 0.709 0.956 0.097 0.028 0.194 0.044 0.291 0.044 0.328 0 0.644-0.162 0.831-0.447l3.513-5.262 5.209 2.606c0.266 0.131 0.575 0.141 0.847 0.022s0.478-0.35 0.559-0.634l5-17c0.109-0.378-0.009-0.784-0.303-1.041zM3.888 11.784l14.078-6.4-9.603 7.684c-0.028-0.012-0.059-0.022-0.087-0.031l-4.387-1.253zM9 18.697v-4.697c0-0.050-0.003-0.1-0.012-0.15l10.472-8.378-8.228 9.888c-0.022 0.028-0.044 0.056-0.063 0.084l-2.169 3.253zM17.378 17.572l-4.722-2.362 8.375-10.066-3.653 12.428z" })
        );
    }
    function PaperPlane({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PaperPlaneSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PaperPlane.SVG = PaperPlaneSVG;
    return PaperPlane;
})();
export const PaperTowel = /*#__PURE__*/ (() => {
        function PaperTowelSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5.047 5.672c0.531 0.213 1.225 0.328 1.953 0.328s1.425-0.116 1.953-0.328c0.909-0.366 1.047-0.891 1.047-1.172s-0.138-0.806-1.047-1.172c-0.528-0.213-1.222-0.328-1.953-0.328s-1.425 0.116-1.953 0.328c-0.909 0.366-1.047 0.891-1.047 1.172s0.138 0.806 1.047 1.172zM7 4c1.175 0 1.859 0.338 1.987 0.5-0.128 0.162-0.813 0.5-1.987 0.5s-1.859-0.338-1.988-0.5c0.128-0.162 0.813-0.5 1.988-0.5z" }),
_('path', { d: "M23.353 4.066c-2.634-0.994-4.734-1.291-6.616-0.934-1.062 0.203-1.947 0.594-2.753 1.050-0.059-0.569-0.278-1.128-0.644-1.631-0.384-0.531-0.919-0.997-1.591-1.391-1.287-0.747-2.972-1.159-4.75-1.159s-3.462 0.413-4.747 1.163c-0.672 0.391-1.206 0.859-1.591 1.387-0.434 0.597-0.663 1.272-0.663 1.95v15c0 0.678 0.228 1.353 0.663 1.95 0.384 0.531 0.919 0.997 1.591 1.391 1.284 0.75 2.969 1.163 4.747 1.163 3.169 0 5.044-1.216 6.697-2.288 2.259-1.466 4.044-2.625 8.95-0.775 0.306 0.116 0.653 0.072 0.922-0.113 0.269-0.188 0.431-0.494 0.431-0.822v-15.006c0-0.416-0.256-0.787-0.647-0.934zM3.262 2.888c0.966-0.563 2.331-0.888 3.738-0.888s2.772 0.325 3.738 0.888c0.8 0.469 1.263 1.056 1.263 1.613s-0.459 1.144-1.263 1.613c-0.925 0.541-2.209 0.859-3.547 0.888-0.063 0-0.125 0.003-0.191 0.003-1.406 0-2.772-0.325-3.738-0.888-0.803-0.472-1.263-1.059-1.263-1.616s0.459-1.144 1.263-1.612zM22 18.603c-2.019-0.616-3.716-0.762-5.262-0.469-1.694 0.322-2.931 1.125-4.128 1.9-1.559 1.009-3.031 1.966-5.609 1.966-1.406 0-2.772-0.325-3.738-0.888-0.803-0.469-1.263-1.056-1.263-1.612v-11.816c0.081 0.053 0.166 0.106 0.253 0.156 1.284 0.75 2.969 1.163 4.747 1.163 0.056 0 0.109 0 0.166 0 0.003 0 0.003 0 0.006 0 3.066-0.044 4.903-1.234 6.525-2.288 2.156-1.4 3.881-2.519 8.303-1.009v12.897z" }),
_('path', { d: "M15 7h1v2h-1v-2z" }),
_('path', { d: "M15 10h1v2h-1v-2z" }),
_('path', { d: "M15 13h1v2h-1v-2z" }),
_('path', { d: "M15 16h1v2h-1v-2z" }),
_('path', { d: "M7 10h1v2h-1v-2z" }),
_('path', { d: "M7 13h1v2h-1v-2z" }),
_('path', { d: "M7 16h1v2h-1v-2z" }),
_('path', { d: "M7 19h1v2h-1v-2z" })
            );
        }
        function PaperTowel({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PaperTowelSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PaperTowel.SVG = PaperTowelSVG;
        return PaperTowel;
    })();
export const Paper = /*#__PURE__*/ (() => {
        function PaperSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 0h-14c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM19 22h-14v-20h14v20c0 0 0 0 0 0z" }),
_('path', { d: "M7 4h10v1h-10v-1z" }),
_('path', { d: "M7 6h4v1h-4v-1z" }),
_('path', { d: "M7 10h4v1h-4v-1z" }),
_('path', { d: "M7 12h4v1h-4v-1z" }),
_('path', { d: "M7 8h4v1h-4v-1z" }),
_('path', { d: "M7 15h10v1h-10v-1z" }),
_('path', { d: "M7 17h8v1h-8v-1z" }),
_('path', { d: "M7 19h10v1h-10v-1z" }),
_('path', { d: "M13 6h4v1h-4v-1z" }),
_('path', { d: "M13 10h4v1h-4v-1z" }),
_('path', { d: "M13 12h4v1h-4v-1z" }),
_('path', { d: "M13 8h4v1h-4v-1z" })
            );
        }
        function Paper({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PaperSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Paper.SVG = PaperSVG;
        return Paper;
    })();
export const Paperclip = /*#__PURE__*/ (() => {
    function PaperclipSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 7v11c0 2.206-1.794 4-4 4s-4-1.794-4-4v-13.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5v13.5c0 0.55-0.45 1-1 1s-1-0.45-1-1v-11h-2v11c0 1.653 1.347 3 3 3s3-1.347 3-3v-13.5c0-2.481-2.019-4.5-4.5-4.5s-4.5 2.019-4.5 4.5v13.5c0 3.309 2.691 6 6 6s6-2.691 6-6v-11h-2z" })
        );
    }
    function Paperclip({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PaperclipSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Paperclip.SVG = PaperclipSVG;
    return Paperclip;
})();
export const Paste = /*#__PURE__*/ (() => {
    function PasteSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18 8.028v-4.028c0-1.103-0.897-2-2-2h-1.528c-0.494-0.55-1.091-1.013-1.747-1.347-0.837-0.428-1.778-0.653-2.725-0.653s-1.887 0.225-2.725 0.653c-0.656 0.334-1.253 0.797-1.747 1.347h-1.528c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h6v1.5c0 0.275 0.225 0.5 0.5 0.5h11c0.275 0 0.5-0.225 0.5-0.5v-11c0-2.313-1.753-4.222-4-4.472zM20.966 12h-2.966v-2.966c1.531 0.222 2.744 1.434 2.966 2.966zM10 2c1.162 0 2.241 0.491 3 1.353v0.647h-6v-0.647c0.759-0.862 1.837-1.353 3-1.353zM10 8.5v11.5h-6v-16h2v0.5c0 0.275 0.225 0.5 0.5 0.5h7c0.275 0 0.5-0.225 0.5-0.5v-0.5h2v4h-5.5c-0.275 0-0.5 0.225-0.5 0.5zM11 23v-14h6v3.5c0 0.275 0.225 0.5 0.5 0.5h3.5v10h-10z" })
        );
    }
    function Paste({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PasteSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Paste.SVG = PasteSVG;
    return Paste;
})();
export const Paste2 = /*#__PURE__*/ (() => {
        function Paste2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 8.028v-4.028c0-1.103-0.897-2-2-2h-1.528c-0.494-0.55-1.091-1.013-1.747-1.347-0.837-0.428-1.778-0.653-2.725-0.653s-1.887 0.225-2.725 0.653c-0.656 0.334-1.253 0.797-1.747 1.347h-1.528c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h6v1.5c0 0.275 0.225 0.5 0.5 0.5h11c0.275 0 0.5-0.225 0.5-0.5v-11c0-2.313-1.753-4.222-4-4.472zM20.966 12h-2.966v-2.966c1.531 0.222 2.744 1.434 2.966 2.966zM10 2c1.162 0 2.241 0.491 3 1.353v0.647h-6v-0.647c0.759-0.862 1.837-1.353 3-1.353zM10 8.5v11.5h-6v-16h2v0.5c0 0.275 0.225 0.5 0.5 0.5h7c0.275 0 0.5-0.225 0.5-0.5v-0.5h2v4h-5.5c-0.275 0-0.5 0.225-0.5 0.5zM11 23v-14h6v3.5c0 0.275 0.225 0.5 0.5 0.5h3.5v10h-10z" }),
_('path', { d: "M16 11h-4v-1h4v1zM16 13h-4v1h4v-1zM12 18h8v-1h-8v1zM12 20h8v-1h-8v1zM12 16h8v-1h-8v1zM12 22h6v-1h-6v1z" })
            );
        }
        function Paste2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Paste2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Paste2.SVG = Paste2SVG;
        return Paste2;
    })();
export const PauseCircle = /*#__PURE__*/ (() => {
        function PauseCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M10 8h1v8h-1v-8z" }),
_('path', { d: "M13 8h1v8h-1v-8z" })
            );
        }
        function PauseCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PauseCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PauseCircle.SVG = PauseCircleSVG;
        return PauseCircle;
    })();
export const PauseSquare = /*#__PURE__*/ (() => {
        function PauseSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M10 8h1v8h-1v-8z" }),
_('path', { d: "M13 8h1v8h-1v-8z" })
            );
        }
        function PauseSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PauseSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PauseSquare.SVG = PauseSquareSVG;
        return PauseSquare;
    })();
export const Pause = /*#__PURE__*/ (() => {
        function PauseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 2h2v20h-2v-20z" }),
_('path', { d: "M15 2h2v20h-2v-20z" })
            );
        }
        function Pause({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PauseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pause.SVG = PauseSVG;
        return Pause;
    })();
export const Paw = /*#__PURE__*/ (() => {
        function PawSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.591 10.406c-0.906-0.906-2.116-1.406-3.4-1.406-0.716 0-1.241 0.141-1.706 0.266-0.363 0.097-0.647 0.175-0.987 0.175-0.391 0-0.8-0.1-1.234-0.206-0.469-0.116-0.95-0.234-1.459-0.234-1.284 0-2.491 0.5-3.4 1.406s-1.406 2.116-1.406 3.4c0 0.509 0.119 0.991 0.234 1.459 0.106 0.431 0.206 0.841 0.206 1.234 0 0.341-0.078 0.625-0.175 0.987-0.125 0.462-0.266 0.987-0.266 1.706 0 1.284 0.5 2.491 1.406 3.4 0.938 0.938 2.169 1.406 3.4 1.406s2.463-0.469 3.4-1.406c0.8-0.8 1.031-1.478 1.219-2.025 0.166-0.478 0.281-0.825 0.8-1.341 0.519-0.519 0.862-0.634 1.341-0.8 0.547-0.188 1.225-0.422 2.025-1.219 1.878-1.878 1.878-4.928 0.003-6.803zM21.178 15.794c-0.472 0.472-0.803 0.584-1.259 0.741-0.563 0.194-1.263 0.434-2.106 1.278s-1.084 1.544-1.278 2.106c-0.156 0.456-0.272 0.788-0.741 1.259-1.094 1.094-2.875 1.094-3.972 0-0.531-0.531-0.822-1.234-0.822-1.984 0-0.45 0.091-0.791 0.197-1.184 0.116-0.422 0.244-0.903 0.244-1.509 0-0.634-0.141-1.206-0.266-1.713-0.091-0.369-0.175-0.716-0.175-0.981 0-0.75 0.291-1.456 0.822-1.984s1.234-0.822 1.984-0.822c0.266 0 0.612 0.084 0.981 0.175 0.506 0.125 1.078 0.266 1.713 0.266 0.606 0 1.084-0.128 1.509-0.244 0.394-0.106 0.734-0.197 1.184-0.197 0.75 0 1.456 0.291 1.984 0.822 1.094 1.094 1.094 2.875 0 3.972z" }),
_('path', { d: "M4.463 12c0.7 0 1.344-0.234 1.825-0.712 1.175-1.175 0.869-3.319-0.694-4.881s-3.706-1.869-4.881-0.694v0c-1.175 1.175-0.869 3.319 0.694 4.881 0.922 0.922 2.047 1.406 3.056 1.406zM2.128 7.128c0.272-0.272 1.228-0.131 2.053 0.694s0.963 1.781 0.694 2.053c-0.272 0.272-1.228 0.131-2.053-0.694-0.828-0.828-0.966-1.784-0.694-2.053z" }),
_('path', { d: "M9.462 7c0.7 0 1.344-0.234 1.825-0.713 1.175-1.175 0.869-3.319-0.694-4.881s-3.706-1.869-4.881-0.694v0c-1.175 1.175-0.869 3.319 0.694 4.881 0.922 0.922 2.047 1.406 3.056 1.406zM7.128 2.128c0.272-0.272 1.228-0.131 2.053 0.694s0.963 1.781 0.694 2.053c-0.272 0.272-1.228 0.131-2.053-0.694-0.828-0.828-0.966-1.784-0.694-2.053z" }),
_('path', { d: "M6.594 14.406c-0.694-0.694-1.541-1.169-2.388-1.338-0.978-0.197-1.887 0.041-2.494 0.644-0.606 0.606-0.841 1.516-0.644 2.494 0.169 0.847 0.644 1.694 1.338 2.388s1.541 1.169 2.388 1.338c0.225 0.044 0.447 0.069 0.663 0.069 0.719 0 1.362-0.247 1.828-0.713 0.606-0.606 0.841-1.516 0.644-2.494-0.166-0.847-0.641-1.694-1.334-2.388zM5.872 17.872c-0.122 0.122-0.378 0.159-0.687 0.097-0.456-0.091-0.953-0.378-1.366-0.791s-0.7-0.909-0.791-1.366c-0.063-0.306-0.025-0.563 0.097-0.687v0c0.084-0.084 0.228-0.128 0.409-0.128 0.084 0 0.178 0.009 0.275 0.028 0.456 0.091 0.953 0.378 1.366 0.791s0.7 0.909 0.791 1.366c0.066 0.312 0.031 0.569-0.094 0.691z" }),
_('path', { d: "M14.406 6.594c0.694 0.694 1.541 1.169 2.388 1.338 0.225 0.044 0.447 0.069 0.663 0.069 0.719 0 1.362-0.247 1.828-0.712 0.606-0.606 0.841-1.516 0.644-2.494-0.169-0.847-0.644-1.694-1.338-2.388s-1.541-1.169-2.388-1.338c-0.978-0.197-1.887 0.041-2.494 0.644-0.606 0.606-0.841 1.516-0.644 2.494 0.172 0.847 0.647 1.694 1.341 2.388zM15.128 3.128v0c0.084-0.084 0.228-0.128 0.409-0.128 0.084 0 0.178 0.009 0.275 0.028 0.456 0.091 0.953 0.378 1.366 0.791s0.7 0.909 0.791 1.366c0.063 0.306 0.025 0.563-0.097 0.687-0.122 0.122-0.378 0.159-0.687 0.097-0.456-0.091-0.953-0.378-1.366-0.791s-0.7-0.909-0.791-1.366c-0.059-0.306-0.025-0.563 0.1-0.684z" })
            );
        }
        function Paw({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PawSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Paw.SVG = PawSVG;
        return Paw;
    })();
export const PenDrawing = /*#__PURE__*/ (() => {
    function PenDrawingSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.706 8.294l-4-4c-0.341-0.341-0.872-0.391-1.269-0.119-1.403 0.953-3.744 2.275-5.725 2.869-0.387 0.116-0.669 0.453-0.709 0.856-0.234 2.303-1.409 6.65-2.9 9.656-0.106 0.216-0.131 0.453-0.078 0.675-0.819 0.769-1.931 1.331-3.156 1.597-1.219 0.262-2.434 0.2-3.334-0.172-0.7-0.291-1.534-0.903-1.534-2.184 0-1.5 1.259-3.588 2.478-5.603 1.653-2.738 3.213-5.322 2.203-7.109-0.334-0.594-0.938-1.041-1.791-1.328-0.853-0.291-1.962-0.431-3.391-0.431h-0.5v1h0.5c2.394 0 3.844 0.422 4.313 1.25 0.722 1.281-0.756 3.731-2.191 6.1-1.287 2.138-2.622 4.344-2.622 6.122 0 1.428 0.766 2.534 2.153 3.109 0.659 0.275 1.428 0.412 2.244 0.412 0.544 0 1.113-0.063 1.684-0.188 1.4-0.303 2.684-0.956 3.631-1.847 0.094 0.028 0.191 0.041 0.288 0.041 0.15 0 0.303-0.034 0.444-0.103 3.006-1.494 7.353-2.669 9.656-2.9 0.403-0.041 0.741-0.322 0.856-0.709 0.594-1.981 1.916-4.322 2.869-5.725 0.272-0.397 0.222-0.931-0.119-1.269zM19.247 14.088c-1.225 0.178-2.763 0.525-4.331 0.987-0.641 0.188-1.272 0.391-1.881 0.6l3.822-3.822c0.197 0.094 0.416 0.147 0.647 0.147 0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5c0 0.231 0.053 0.45 0.147 0.647l-3.825 3.819c0.213-0.609 0.413-1.241 0.6-1.881 0.459-1.569 0.809-3.106 0.987-4.331 1.728-0.609 3.588-1.609 4.953-2.472l2.853 2.853c-0.862 1.366-1.863 3.225-2.472 4.953zM17 10.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5z" })
        );
    }
    function PenDrawing({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PenDrawingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PenDrawing.SVG = PenDrawingSVG;
    return PenDrawing;
})();
export const PenMinus = /*#__PURE__*/ (() => {
        function PenMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.391 11.281c0.128-0.434 0.256-0.866 0.378-1.281h2.731c0.828 0 1.5-0.672 1.5-1.5 0-0.131-0.053-0.259-0.147-0.353l-8-8c-0.094-0.094-0.222-0.147-0.353-0.147-0.828 0-1.5 0.672-1.5 1.5v2.731c-2.337 0.697-4.747 1.406-7.153 1.781-0.503 0.078-0.866 0.522-0.847 1.028 0.131 3.231-1.306 7.488-4.394 12.997-0.381 0.075-0.738 0.262-1.025 0.547-0.375 0.381-0.584 0.881-0.584 1.416s0.209 1.038 0.584 1.416c0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584c0.284-0.284 0.472-0.641 0.547-1.025 2.734-1.534 5.109-2.637 7.222-3.359 0.691 2.847 3.263 4.969 6.319 4.969 3.584 0 6.5-2.916 6.5-6.5 0-2.928-1.944-5.409-4.609-6.219zM15.325 1.031l7.644 7.644c-0.072 0.191-0.253 0.325-0.469 0.325h-2.084l-5.416-5.416v-2.084c0-0.213 0.134-0.397 0.325-0.469zM6.475 14.525c0.953-2.484 1.463-4.728 1.525-6.681 2.287-0.422 4.522-1.084 6.694-1.734l3.194 3.194c-0.162 0.544-0.334 1.116-0.5 1.697-1.247 0.022-2.406 0.394-3.387 1.025 0-0.009 0-0.016 0-0.025 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 0.372 0.1 0.719 0.278 1.016l-5.681 5.681c0.759-1.491 1.381-2.869 1.878-4.172zM11.022 16.978c-1.734 0.556-3.625 1.359-5.719 2.425l5.681-5.681c0.297 0.175 0.644 0.278 1.016 0.278 0.009 0 0.016 0 0.025 0-0.559 0.872-0.919 1.887-1.003 2.978zM12 13c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M15 17h5v1h-5v-1z" })
            );
        }
        function PenMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PenMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PenMinus.SVG = PenMinusSVG;
        return PenMinus;
    })();
export const PenPlus = /*#__PURE__*/ (() => {
        function PenPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.391 11.281c0.128-0.434 0.256-0.866 0.378-1.281h2.731c0.828 0 1.5-0.672 1.5-1.5 0-0.131-0.053-0.259-0.147-0.353l-8-8c-0.094-0.094-0.222-0.147-0.353-0.147-0.828 0-1.5 0.672-1.5 1.5v2.731c-2.337 0.697-4.747 1.406-7.153 1.781-0.503 0.078-0.866 0.522-0.847 1.028 0.131 3.231-1.306 7.488-4.394 12.997-0.381 0.075-0.738 0.262-1.025 0.547-0.375 0.381-0.584 0.881-0.584 1.416s0.209 1.038 0.584 1.416c0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584c0.284-0.284 0.472-0.641 0.547-1.025 2.734-1.534 5.109-2.637 7.222-3.359 0.691 2.847 3.263 4.969 6.319 4.969 3.584 0 6.5-2.916 6.5-6.5 0-2.928-1.944-5.409-4.609-6.219zM15.325 1.031l7.644 7.644c-0.072 0.191-0.253 0.325-0.469 0.325h-2.084l-5.416-5.416v-2.084c0-0.213 0.134-0.397 0.325-0.469zM6.475 14.525c0.953-2.484 1.463-4.728 1.525-6.681 2.287-0.422 4.522-1.084 6.694-1.734l3.194 3.194c-0.162 0.544-0.334 1.116-0.5 1.697-1.247 0.022-2.406 0.394-3.387 1.025 0-0.009 0-0.016 0-0.025 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 0.372 0.1 0.719 0.278 1.016l-5.681 5.681c0.759-1.491 1.381-2.869 1.878-4.172zM11.022 16.978c-1.734 0.556-3.625 1.359-5.719 2.425l5.681-5.681c0.297 0.175 0.644 0.278 1.016 0.278 0.009 0 0.016 0 0.025 0-0.559 0.872-0.919 1.887-1.003 2.978zM12 13c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18 15h-1v2h-2v1h2v2h1v-2h2v-1h-2z" })
            );
        }
        function PenPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PenPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PenPlus.SVG = PenPlusSVG;
        return PenPlus;
    })();
export const Pen = /*#__PURE__*/ (() => {
        function PenSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.375 0.625c-0.828-0.828-2.175-0.828-3 0l-0.888 0.888c-0.141-0.038-0.291-0.044-0.441-0.019-1.122 0.206-2.619 1.003-4.447 2.372-1.737 1.3-3.622 3.006-5.453 4.938-1.975 2.084-3.813 4.359-5.309 6.578-1.719 2.547-2.994 5-3.784 7.291-0.125 0.363-0.031 0.762 0.237 1.034 0.191 0.191 0.447 0.294 0.706 0.294 0.109 0 0.219-0.019 0.325-0.056 2.291-0.791 4.744-2.063 7.294-3.784 2.219-1.497 4.491-3.331 6.578-5.309 1.931-1.828 3.638-3.716 4.938-5.453 1.369-1.828 2.166-3.325 2.372-4.447 0.028-0.147 0.019-0.297-0.019-0.441l0.891-0.884c0.828-0.828 0.828-2.172 0-3zM4.825 17.534l1.641 1.641c-1.244 0.784-2.469 1.459-3.65 2.009 0.55-1.184 1.225-2.409 2.009-3.65zM13.819 13.403c-2.106 1.997-4.316 3.766-6.494 5.216l-1.944-1.944c1.453-2.178 3.222-4.387 5.219-6.494 0.475-0.5 0.95-0.984 1.428-1.447l3.241 3.241c-0.466 0.475-0.95 0.953-1.45 1.428zM18.531 8.2c-0.731 0.978-1.6 2.006-2.575 3.050l-3.206-3.206c1.041-0.972 2.072-1.844 3.050-2.575 1.559-1.166 2.559-1.659 3.134-1.869l1.469 1.469c-0.213 0.572-0.706 1.575-1.872 3.131zM22.669 2.919l-0.794 0.794-1.587-1.587 0.794-0.794c0.438-0.438 1.15-0.438 1.587 0s0.438 1.15 0 1.587z" }),
_('path', { d: "M9.728 6.734c1.447-1.416 2.937-2.703 4.306-3.719 0.609-0.45 1.191-0.841 1.725-1.166l0.428-0.259-0.519-0.856-0.428 0.259c-0.559 0.341-1.166 0.75-1.8 1.216-1.428 1.059-2.913 2.341-4.413 3.809l-0.356 0.35 0.7 0.716 0.356-0.35z" })
            );
        }
        function Pen({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pen.SVG = PenSVG;
        return Pen;
    })();
export const Pen2 = /*#__PURE__*/ (() => {
    function Pen2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.853 8.147l-8-8c-0.094-0.094-0.222-0.147-0.353-0.147-0.828 0-1.5 0.672-1.5 1.5v2.731c-2.337 0.697-4.747 1.406-7.153 1.781-0.503 0.078-0.866 0.522-0.847 1.028 0.131 3.231-1.306 7.488-4.394 12.997-0.381 0.075-0.738 0.263-1.025 0.547-0.781 0.781-0.781 2.050 0 2.831 0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584c0.284-0.284 0.472-0.641 0.547-1.025 5.512-3.087 9.766-4.525 13-4.391 0.509 0.019 0.95-0.344 1.028-0.847 0.375-2.406 1.084-4.819 1.781-7.153h2.731c0.828 0 1.5-0.672 1.5-1.5 0-0.131-0.053-0.259-0.147-0.353zM16.156 15.997c-1.953 0.063-4.197 0.575-6.681 1.525-1.303 0.5-2.681 1.119-4.172 1.878l5.681-5.681c0.297 0.175 0.644 0.278 1.016 0.278 1.103 0 2-0.897 2-2s-0.897-2-2-2c-1.103 0-2 0.897-2 2 0 0.372 0.1 0.719 0.278 1.016l-5.681 5.684c0.759-1.491 1.381-2.869 1.878-4.172 0.953-2.484 1.462-4.728 1.525-6.681 2.288-0.422 4.522-1.084 6.694-1.734l3.194 3.194c-0.647 2.172-1.309 4.406-1.731 6.694zM11 12c0-0.55 0.45-1 1-1s1 0.45 1 1c0 0.55-0.45 1-1 1s-1-0.45-1-1zM22.5 9h-2.084l-5.416-5.416v-2.084c0-0.213 0.134-0.397 0.325-0.469l7.644 7.644c-0.072 0.191-0.256 0.325-0.469 0.325z" })
        );
    }
    function Pen2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Pen2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pen2.SVG = Pen2SVG;
    return Pen2;
})();
export const PencilRuler = /*#__PURE__*/ (() => {
        function PencilRulerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.381 0.075c-0.375-0.156-0.803-0.069-1.091 0.216l-22 22c-0.288 0.288-0.372 0.716-0.216 1.091s0.519 0.619 0.925 0.619h21c1.103 0 2-0.897 2-2v-21c0-0.403-0.244-0.769-0.619-0.925zM20 22v-1h-1v1h-2v-1h-1v1h-2v-1h-1v1h-2v-1h-1v1h-2v-1h-1v1h-3.584l18.584-18.584v3.584h-1v1h1v2h-1v1h1v2h-1v1h1v2h-1v1h1v2h-1v1h1v2h-2z" }),
_('path', { d: "M18.691 12.038c-0.188-0.078-0.403-0.034-0.544 0.109l-6 6c-0.144 0.144-0.184 0.359-0.109 0.544s0.259 0.309 0.462 0.309h6c0.275 0 0.5-0.225 0.5-0.5v-6c0-0.203-0.122-0.384-0.309-0.462zM18 18h-4.294l4.294-4.294v4.294z" }),
_('path', { d: "M0.5 15c0.041 0 0.081-0.006 0.122-0.016l4-1c0.087-0.022 0.169-0.069 0.231-0.131l9.375-9.375c1.022-1.022 1.022-2.684 0-3.706s-2.684-1.022-3.706 0l-9.375 9.375c-0.066 0.066-0.109 0.144-0.131 0.231l-1 4c-0.044 0.172 0.006 0.35 0.131 0.475 0.094 0.097 0.222 0.147 0.353 0.147zM13.522 1.478c0.631 0.631 0.631 1.659 0 2.294l-0.522 0.522-2.294-2.294 0.522-0.522c0.631-0.631 1.662-0.631 2.294 0zM1.95 10.756l8.050-8.050 2.294 2.294-8.050 8.050-3.056 0.762 0.762-3.056z" })
            );
        }
        function PencilRuler({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PencilRulerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PencilRuler.SVG = PencilRulerSVG;
        return PencilRuler;
    })();
export const PencilRuler2 = /*#__PURE__*/ (() => {
    function PencilRuler2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.888 19.113l-6.294-6.294 5.078-5.078c1.769-1.769 1.769-4.647 0-6.416-0.856-0.853-1.994-1.325-3.206-1.325s-2.35 0.472-3.206 1.328l-5.078 5.078-6.294-6.294c-0.194-0.194-0.513-0.194-0.706 0l-4.034 4.034c-0.194 0.194-0.194 0.513 0 0.706l6.294 6.294-4.147 4.147c-0.119 0.119-0.206 0.269-0.253 0.431l-2 7c-0.1 0.35-0.003 0.725 0.253 0.981 0.191 0.191 0.447 0.294 0.706 0.294 0.091 0 0.184-0.012 0.275-0.038l7-2c0.162-0.047 0.312-0.134 0.431-0.253l4.147-4.147 6.294 6.294c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.034-4.034c0.197-0.197 0.197-0.516 0-0.709zM16.059 4.353l0.794-0.794 3.584 3.584-0.794 0.794-3.584-3.584zM16.794 6.5l-10.494 10.491c-0.741-0.059-1.413-0.453-1.838-1.044l10.887-10.887 1.444 1.441zM4.397 17.297c0.484 0.366 1.044 0.594 1.634 0.672 0.078 0.594 0.306 1.15 0.672 1.634 0.159 0.209 0.341 0.403 0.544 0.572l-1.841 0.525-2.106-2.106 0.525-1.837c0.169 0.2 0.359 0.381 0.572 0.541zM7.009 17.7l10.491-10.494 1.441 1.441-10.891 10.887c-0.591-0.422-0.981-1.097-1.041-1.834zM19.466 2c0.678 0 1.313 0.262 1.794 0.744 0.987 0.987 0.987 2.597 0 3.584l-0.113 0.113-3.588-3.588 0.113-0.112c0.481-0.478 1.116-0.741 1.794-0.741zM1.206 4.5l3.328-3.328 0.794 0.794-1.534 1.534 0.706 0.706 1.534-1.534 1.294 1.294-1.534 1.534 0.706 0.706 1.534-1.534 1.294 1.294-1.534 1.534 0.706 0.706 1.534-1.534 0.441 0.441-3.328 3.328-5.941-5.941zM2.984 19.694l1.322 1.322-1.853 0.528 0.531-1.85zM19.5 22.794l-5.941-5.941 3.328-3.328 0.441 0.441-1.534 1.534 0.706 0.706 1.534-1.534 1.294 1.294-1.534 1.534 0.706 0.706 1.534-1.534 1.294 1.294-1.534 1.534 0.706 0.706 1.534-1.534 0.794 0.794-3.328 3.328z" })
        );
    }
    function PencilRuler2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PencilRuler2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PencilRuler2.SVG = PencilRuler2SVG;
    return PencilRuler2;
})();
export const Pencil = /*#__PURE__*/ (() => {
    function PencilSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.672 1.328c-0.856-0.856-1.994-1.328-3.206-1.328s-2.35 0.472-3.206 1.328l-13.966 13.966c-0.119 0.119-0.206 0.269-0.253 0.431l-2 7c-0.1 0.35-0.003 0.725 0.253 0.981 0.191 0.191 0.447 0.294 0.706 0.294 0.091 0 0.184-0.012 0.275-0.038l7-2c0.162-0.047 0.312-0.134 0.431-0.253l13.966-13.966c1.769-1.772 1.769-4.647 0-6.416zM4.559 15.853l10.794-10.794 3.584 3.584-10.791 10.797-3.588-3.588zM16.059 4.353l0.794-0.794 3.584 3.584-0.794 0.794-3.584-3.584zM3.875 16.581l3.544 3.544-4.962 1.419 1.419-4.962zM21.259 6.328l-0.112 0.113-3.588-3.588 0.112-0.112c0.481-0.478 1.116-0.741 1.794-0.741s1.313 0.262 1.794 0.744c0.987 0.987 0.987 2.594 0 3.584z" })
        );
    }
    function Pencil({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PencilSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pencil.SVG = PencilSVG;
    return Pencil;
})();
export const Pencil2 = /*#__PURE__*/ (() => {
    function Pencil2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.706 4.294l-4-4c-0.391-0.391-1.025-0.391-1.416 0l-16.5 16.5c-0.122 0.122-0.213 0.275-0.256 0.444l-1.5 5.5c-0.094 0.347 0.003 0.716 0.256 0.969 0.191 0.191 0.447 0.294 0.706 0.294 0.087 0 0.175-0.012 0.262-0.034l5.5-1.5c0.169-0.047 0.322-0.134 0.444-0.256l16.5-16.5c0.394-0.394 0.394-1.025 0.003-1.416zM5.981 20.606l-3.556 0.969 0.969-3.556 15.606-15.603 2.584 2.584-15.603 15.606z" })
        );
    }
    function Pencil2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Pencil2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pencil2.SVG = Pencil2SVG;
    return Pencil2;
})();
export const Pencil3 = /*#__PURE__*/ (() => {
    function Pencil3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.672 1.328c-0.856-0.856-1.994-1.328-3.206-1.328s-2.35 0.472-3.206 1.328l-13.966 13.966c-0.119 0.119-0.206 0.269-0.253 0.431l-2 7c-0.1 0.35-0.003 0.725 0.253 0.981 0.191 0.191 0.447 0.294 0.706 0.294 0.091 0 0.184-0.012 0.275-0.038l7-2c0.162-0.047 0.312-0.134 0.431-0.253l13.966-13.966c1.769-1.772 1.769-4.647 0-6.416zM6.3 16.991c-0.741-0.059-1.413-0.453-1.838-1.044l10.887-10.887 1.441 1.441-10.491 10.491zM4.397 17.297c0.484 0.366 1.044 0.594 1.634 0.672 0.078 0.594 0.306 1.15 0.672 1.634 0.159 0.209 0.341 0.403 0.544 0.572l-1.841 0.525-2.106-2.106 0.525-1.837c0.169 0.2 0.359 0.381 0.572 0.541zM7.009 17.7l10.491-10.494 1.441 1.441-10.891 10.887c-0.591-0.422-0.981-1.097-1.041-1.834zM16.059 4.353l0.794-0.794 3.584 3.584-0.794 0.794-3.584-3.584zM2.984 19.694l1.322 1.322-1.853 0.528 0.531-1.85zM21.259 6.328l-0.112 0.113-3.588-3.588 0.112-0.112c0.481-0.478 1.116-0.741 1.794-0.741s1.313 0.262 1.794 0.744c0.987 0.987 0.987 2.594 0 3.584z" })
        );
    }
    function Pencil3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Pencil3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pencil3.SVG = Pencil3SVG;
    return Pencil3;
})();
export const PercentCircle = /*#__PURE__*/ (() => {
        function PercentCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M8.042 14.543l6.501-6.501 1.414 1.414-6.501 6.501-1.414-1.414z" }),
_('path', { d: "M14.5 13c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM14.5 15c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M9.5 11c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM9.5 9c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" })
            );
        }
        function PercentCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PercentCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PercentCircle.SVG = PercentCircleSVG;
        return PercentCircle;
    })();
export const PercentSquare = /*#__PURE__*/ (() => {
        function PercentSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M8.042 14.543l6.501-6.501 1.414 1.414-6.501 6.501-1.414-1.414z" }),
_('path', { d: "M14.5 13c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM14.5 15c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M9.5 11c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM9.5 9c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" })
            );
        }
        function PercentSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PercentSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PercentSquare.SVG = PercentSquareSVG;
        return PercentSquare;
    })();
export const Percent = /*#__PURE__*/ (() => {
        function PercentSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.042 19.544l16.5-16.5 1.414 1.414-16.5 16.5-1.414-1.414z" }),
_('path', { d: "M18 14c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zM18 20c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2z" }),
_('path', { d: "M6 10c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zM6 4c1.103 0 2 0.897 2 2s-0.897 2-2 2-2-0.897-2-2 0.897-2 2-2z" })
            );
        }
        function Percent({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PercentSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Percent.SVG = PercentSVG;
        return Percent;
    })();
export const Phone24 = /*#__PURE__*/ (() => {
        function Phone24SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 0c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17.816 14.616c-0.378-0.378-0.878-0.588-1.409-0.588h-0.003c-0.534 0-1.034 0.209-1.413 0.591l-0.5 0.5c-0.237 0.237-0.409 0.528-0.506 0.85-0.078 0.172-0.616 0.794-1.547 0.975-1.159 0.228-2.456-0.338-3.75-1.631-1.294-1.297-1.856-2.594-1.628-3.756 0.184-0.931 0.806-1.466 0.975-1.544 0.328-0.1 0.616-0.269 0.853-0.506l0.5-0.5c0.781-0.781 0.781-2.053 0-2.834l-3.597-3.594c-0.781-0.781-2.053-0.781-2.831-0.003l-0.706 0.703c-1.062 1.066-1.759 2.331-2.069 3.762-0.281 1.3-0.237 2.709 0.128 4.191 0.656 2.653 2.316 5.416 4.678 7.775 2.356 2.366 5.119 4.025 7.772 4.681 0.841 0.206 1.656 0.312 2.441 0.312 0.603 0 1.188-0.063 1.75-0.184 1.431-0.309 2.697-1.006 3.762-2.072 0 0 0.003-0.003 0.003-0.003l0.697-0.703c0.778-0.781 0.778-2.050-0.003-2.831l-3.597-3.591zM15.903 16.531l0.5-0.5c0 0 0 0 0 0l3.594 3.591c0 0 0 0.006 0 0.006s-0.003 0.003-0.003 0.003l-0.694 0.7c-0.044 0.044-0.087 0.087-0.134 0.128l-3.466-3.466c0.091-0.156 0.159-0.312 0.2-0.456 0.003-0.003 0.003-0.003 0.003-0.006zM4.369 3.997c0 0 0.003 0 0 0 0.003 0 0.006 0 0.006 0l3.597 3.594c0 0 0 0.006 0 0.006l-0.5 0.5c0 0-0.006 0.003-0.016 0.006-0.144 0.044-0.297 0.109-0.45 0.2l-3.469-3.469c0.041-0.044 0.084-0.087 0.128-0.131l0.703-0.706zM13.244 21.744c-2.272-0.563-4.766-2.072-6.841-4.15-2.078-2.072-3.591-4.566-4.15-6.837-0.356-1.437-0.478-3.4 0.659-5.137l3.316 3.319c-0.459 0.494-0.866 1.169-1.072 1.969-0.231 0.888-0.194 1.809 0.106 2.741 0.338 1.050 1.016 2.088 2.009 3.081s2.031 1.672 3.078 2.009c0.928 0.3 1.85 0.337 2.741 0.106 0.803-0.206 1.481-0.616 1.975-1.075l3.312 3.312c-1.737 1.141-3.697 1.019-5.134 0.663z" }),
_('path', { d: "M17 5.5c0-0.45-0.172-0.85-0.481-1.125-0.272-0.244-0.634-0.378-1.019-0.378s-0.747 0.134-1.019 0.378c-0.309 0.275-0.481 0.675-0.481 1.125v0.5h1v-0.5c0-0.478 0.416-0.5 0.5-0.5 0.138 0 0.266 0.044 0.356 0.125 0.097 0.084 0.144 0.213 0.144 0.378 0 0.612-0.341 0.9-0.897 1.319-0.491 0.366-1.103 0.822-1.103 1.678 0 0.275 0.225 0.5 0.5 0.5h2.5v-1h-1.766c0.116-0.116 0.272-0.234 0.466-0.381 0.55-0.412 1.3-0.975 1.3-2.119z" }),
_('path', { d: "M20 7h-0.806l0.938-2.816-0.95-0.316-1.159 3.475c-0.050 0.153-0.025 0.319 0.069 0.45s0.244 0.206 0.406 0.206h1.5v1h1v-3h-1v1z" })
            );
        }
        function Phone24({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Phone24SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Phone24.SVG = Phone24SVG;
        return Phone24;
    })();
export const PhoneBubble = /*#__PURE__*/ (() => {
        function PhoneBubbleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.819 14.616c-0.378-0.378-0.881-0.584-1.413-0.584h-0.003c-0.534 0-1.034 0.209-1.413 0.591l-0.5 0.5c-0.237 0.237-0.409 0.531-0.506 0.853-0.078 0.172-0.616 0.794-1.547 0.975-1.159 0.228-2.456-0.338-3.75-1.631-1.294-1.297-1.856-2.594-1.628-3.756 0.184-0.931 0.806-1.466 0.975-1.541 0.328-0.1 0.616-0.269 0.853-0.506l0.5-0.5c0.378-0.378 0.588-0.881 0.588-1.416s-0.209-1.038-0.588-1.419l-3.597-3.594c-0.781-0.781-2.053-0.781-2.831-0.003l-0.706 0.703c-1.062 1.066-1.759 2.328-2.069 3.759-0.281 1.3-0.237 2.709 0.128 4.191 0.656 2.653 2.316 5.416 4.678 7.775 2.359 2.359 5.122 4.022 7.775 4.675 0.841 0.206 1.656 0.312 2.444 0.312 0.603 0 1.188-0.063 1.75-0.184 1.431-0.309 2.697-1.006 3.762-2.072l0.003-0.003 0.697-0.703c0.375-0.378 0.584-0.881 0.584-1.416s-0.209-1.041-0.588-1.419l-3.6-3.588zM15.903 16.534l0.5-0.5c0 0 0 0 0 0l3.594 3.591c0 0 0 0.006 0 0.006l-0.003 0.003-0.697 0.703c-0.044 0.044-0.087 0.087-0.131 0.128l-3.469-3.469c0.091-0.156 0.159-0.309 0.2-0.456 0.003-0.003 0.006-0.006 0.006-0.006zM4.369 4c0 0 0.003 0 0.003 0s0.003 0 0.003 0l3.597 3.594c0 0 0 0.006 0 0.006l-0.5 0.5c0 0-0.006 0.003-0.016 0.006-0.144 0.041-0.294 0.109-0.447 0.197l-3.469-3.472c0.041-0.044 0.084-0.087 0.125-0.131l0.703-0.7zM13.244 21.747c-2.272-0.563-4.766-2.075-6.841-4.15s-3.588-4.566-4.15-6.837c-0.356-1.437-0.478-3.4 0.663-5.137l3.316 3.316c-0.459 0.494-0.866 1.169-1.075 1.972-0.231 0.888-0.194 1.809 0.106 2.741 0.337 1.050 1.016 2.088 2.009 3.081s2.031 1.672 3.078 2.009c0.928 0.3 1.85 0.337 2.737 0.106 0.803-0.206 1.481-0.616 1.975-1.075l3.312 3.312c-1.734 1.141-3.694 1.019-5.131 0.663z" }),
_('path', { d: "M22.206 1.431c-1.128-0.922-2.622-1.431-4.206-1.431s-3.078 0.509-4.206 1.431c-1.156 0.947-1.794 2.216-1.794 3.569 0 1.45 0.734 2.8 2.028 3.75-0.106 0.875-0.738 1.291-0.788 1.322-0.197 0.112-0.288 0.341-0.228 0.559s0.259 0.369 0.487 0.369c1.072 0 2.422-0.3 3.194-1.119 0.431 0.078 0.869 0.119 1.306 0.119 1.584 0 3.078-0.509 4.206-1.431 1.156-0.947 1.794-2.216 1.794-3.569s-0.638-2.622-1.794-3.569zM18 9c-0.469 0-0.934-0.053-1.388-0.156-0.197-0.044-0.403 0.034-0.522 0.2-0.272 0.387-0.791 0.65-1.366 0.8 0.181-0.356 0.319-0.8 0.319-1.344 0-0.169-0.084-0.325-0.225-0.416-1.156-0.766-1.819-1.887-1.819-3.084 0-2.206 2.244-4 5-4s5 1.794 5 4-2.244 4-5 4z" })
            );
        }
        function PhoneBubble({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneBubbleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhoneBubble.SVG = PhoneBubbleSVG;
        return PhoneBubble;
    })();
export const PhoneCross = /*#__PURE__*/ (() => {
        function PhoneCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 0c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 3.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" }),
_('path', { d: "M17.819 14.616c-0.378-0.378-0.881-0.584-1.413-0.584h-0.003c-0.534 0-1.034 0.209-1.413 0.591l-0.5 0.5c-0.237 0.237-0.409 0.531-0.506 0.853-0.078 0.172-0.616 0.794-1.547 0.975-1.159 0.228-2.456-0.338-3.75-1.631-1.294-1.297-1.856-2.594-1.628-3.756 0.184-0.931 0.806-1.466 0.975-1.541 0.328-0.1 0.616-0.269 0.853-0.506l0.5-0.5c0.378-0.378 0.588-0.881 0.588-1.416s-0.209-1.038-0.588-1.419l-3.597-3.594c-0.781-0.781-2.053-0.781-2.831-0.003l-0.706 0.703c-1.062 1.066-1.759 2.328-2.069 3.759-0.281 1.3-0.237 2.709 0.128 4.191 0.656 2.653 2.316 5.416 4.678 7.775 2.359 2.359 5.122 4.022 7.775 4.675 0.841 0.206 1.656 0.312 2.444 0.312 0.603 0 1.188-0.063 1.75-0.184 1.431-0.309 2.697-1.006 3.762-2.072l0.003-0.003 0.697-0.703c0.375-0.378 0.584-0.881 0.584-1.416s-0.209-1.041-0.588-1.419l-3.6-3.588zM15.903 16.534l0.5-0.5c0 0 0 0 0 0l3.594 3.591c0 0 0 0.006 0 0.006l-0.003 0.003-0.697 0.703c-0.044 0.044-0.087 0.087-0.131 0.128l-3.469-3.469c0.091-0.156 0.159-0.309 0.2-0.456 0.003-0.003 0.006-0.006 0.006-0.006zM4.369 4c0 0 0.003 0 0.003 0s0.003 0 0.003 0l3.597 3.594c0 0 0 0.006 0 0.006l-0.5 0.5c0 0-0.006 0.003-0.016 0.006-0.144 0.041-0.294 0.109-0.447 0.197l-3.469-3.472c0.041-0.044 0.084-0.087 0.125-0.131l0.703-0.7zM13.244 21.747c-2.272-0.563-4.766-2.075-6.841-4.15s-3.588-4.566-4.15-6.837c-0.356-1.437-0.478-3.4 0.663-5.137l3.316 3.316c-0.459 0.494-0.866 1.169-1.075 1.972-0.231 0.888-0.194 1.809 0.106 2.741 0.337 1.050 1.016 2.088 2.009 3.081s2.031 1.672 3.078 2.009c0.928 0.3 1.85 0.337 2.737 0.106 0.803-0.206 1.481-0.616 1.975-1.075l3.312 3.312c-1.734 1.141-3.694 1.019-5.131 0.663z" })
            );
        }
        function PhoneCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhoneCross.SVG = PhoneCrossSVG;
        return PhoneCross;
    })();
export const PhoneEnd = /*#__PURE__*/ (() => {
    function PhoneEndSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.913 10.987c-0.659-1.097-1.603-2.047-2.803-2.825-2.153-1.394-5.031-2.163-8.103-2.163h-0.003c-3.072 0-5.95 0.769-8.106 2.159-1.203 0.778-2.147 1.728-2.806 2.828-0.725 1.2-1.091 2.553-1.091 4.016 0 0 0 0.003 0 0.003l0.003 0.987c0 1.103 0.888 2 1.975 2l5.053-0.003c0.522 0 1.012-0.206 1.384-0.575 0.378-0.378 0.584-0.884 0.584-1.425v-0.706c0-0.334-0.084-0.666-0.241-0.963-0.097-0.181-0.309-0.816-0.006-1.325 0.384-0.644 1.538-1 3.244-1h0.006c1.709 0 2.862 0.356 3.247 1 0.303 0.509 0.091 1.144-0.006 1.325-0.003 0.003-0.003 0.009-0.006 0.012-0.156 0.3-0.234 0.619-0.234 0.95v0.706c0 1.103 0.884 2.003 1.975 2.003l5.053-0.003c1.088 0 1.972-0.9 1.972-2l0.003-0.994c-0.006-1.459-0.372-2.809-1.094-4.009zM6.997 15.997l-4.994 0.003c0 0 0-0.003 0-0.003s0-0.003 0-0.003l-0.003-0.991c0 0 0-0.003 0-0.003h4.866c0.041 0.1 0.084 0.194 0.128 0.272 0 0.003 0.003 0.006 0.003 0.016v0.709zM12 10h-0.006c-2.509 0-4.178 0.663-4.959 1.972-0.406 0.681-0.484 1.406-0.419 2.028h-4.534c0.344-2.081 1.722-3.397 2.903-4.159 1.809-1.169 4.369-1.841 7.019-1.841h0.003c2.65 0 5.209 0.672 7.016 1.841 1.181 0.762 2.556 2.078 2.897 4.159h-4.538c0.069-0.622-0.009-1.344-0.416-2.025-0.781-1.309-2.453-1.975-4.966-1.975zM21.997 15.994c0 0 0 0.003 0 0.003l-5 0.003c0 0 0-0.003 0-0.003v-0.706c0-0.003 0-0.009 0.006-0.025 0.041-0.078 0.084-0.166 0.125-0.266h4.872l-0.003 0.994z" })
        );
    }
    function PhoneEnd({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PhoneEndSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PhoneEnd.SVG = PhoneEndSVG;
    return PhoneEnd;
})();
export const PhoneInOut = /*#__PURE__*/ (() => {
        function PhoneInOutSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.819 14.616c-0.378-0.378-0.881-0.584-1.413-0.584h-0.003c-0.534 0-1.034 0.209-1.413 0.591l-0.5 0.5c-0.237 0.237-0.409 0.531-0.506 0.853-0.078 0.172-0.616 0.794-1.547 0.975-1.159 0.228-2.456-0.338-3.75-1.631-1.294-1.297-1.856-2.594-1.628-3.756 0.184-0.931 0.806-1.466 0.975-1.541 0.328-0.1 0.616-0.269 0.853-0.506l0.5-0.5c0.378-0.378 0.588-0.881 0.588-1.416s-0.209-1.038-0.588-1.419l-3.597-3.594c-0.781-0.781-2.053-0.781-2.831-0.003l-0.706 0.703c-1.062 1.066-1.759 2.328-2.069 3.759-0.281 1.3-0.237 2.709 0.128 4.191 0.656 2.653 2.316 5.416 4.678 7.775 2.359 2.359 5.122 4.022 7.775 4.675 0.841 0.206 1.656 0.312 2.444 0.312 0.603 0 1.188-0.063 1.75-0.184 1.431-0.309 2.697-1.006 3.762-2.072l0.003-0.003 0.697-0.703c0.375-0.378 0.584-0.881 0.584-1.416s-0.209-1.041-0.588-1.419l-3.6-3.588zM15.903 16.534l0.5-0.5c0 0 0 0 0 0l3.594 3.591c0 0 0 0.006 0 0.006l-0.003 0.003-0.697 0.703c-0.044 0.044-0.087 0.087-0.131 0.128l-3.469-3.469c0.091-0.156 0.159-0.309 0.2-0.456 0.003-0.003 0.006-0.006 0.006-0.006zM4.369 4c0 0 0.003 0 0.003 0s0.003 0 0.003 0l3.597 3.594c0 0 0 0.006 0 0.006l-0.5 0.5c0 0-0.006 0.003-0.016 0.006-0.144 0.041-0.294 0.109-0.447 0.197l-3.469-3.472c0.041-0.044 0.084-0.087 0.125-0.131l0.703-0.7zM13.244 21.747c-2.272-0.563-4.766-2.075-6.841-4.15s-3.588-4.566-4.15-6.837c-0.356-1.437-0.478-3.4 0.663-5.137l3.316 3.316c-0.459 0.494-0.866 1.169-1.075 1.972-0.231 0.888-0.194 1.809 0.106 2.741 0.337 1.050 1.016 2.088 2.009 3.081s2.031 1.672 3.078 2.009c0.928 0.3 1.85 0.337 2.737 0.106 0.803-0.206 1.481-0.616 1.975-1.075l3.312 3.312c-1.734 1.141-3.694 1.019-5.131 0.663z" }),
_('path', { d: "M17.5 0c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17 6h-1.294l2.5-2.5-0.706-0.706-2.5 2.5v-1.294h-1v2.5c0 0.275 0.225 0.5 0.5 0.5h2.5v-1z" }),
_('path', { d: "M20.5 6h-2.5v1h1.294l-2.5 2.5 0.706 0.706 2.5-2.5v1.294h1v-2.5c0-0.275-0.225-0.5-0.5-0.5z" })
            );
        }
        function PhoneInOut({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneInOutSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhoneInOut.SVG = PhoneInOutSVG;
        return PhoneInOut;
    })();
export const PhoneIncoming = /*#__PURE__*/ (() => {
        function PhoneIncomingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.819 14.616c-0.378-0.378-0.881-0.584-1.413-0.584h-0.003c-0.534 0-1.034 0.209-1.413 0.591l-0.5 0.5c-0.237 0.237-0.409 0.531-0.506 0.853-0.078 0.172-0.616 0.794-1.547 0.975-1.159 0.228-2.456-0.338-3.75-1.631-1.294-1.297-1.856-2.594-1.628-3.756 0.184-0.931 0.806-1.466 0.975-1.541 0.328-0.1 0.616-0.269 0.853-0.506l0.5-0.5c0.378-0.378 0.588-0.881 0.588-1.416s-0.209-1.038-0.588-1.419l-3.597-3.594c-0.781-0.781-2.053-0.781-2.831-0.003l-0.706 0.703c-1.062 1.066-1.759 2.328-2.069 3.759-0.281 1.3-0.237 2.709 0.128 4.191 0.656 2.653 2.316 5.416 4.678 7.775 2.359 2.359 5.122 4.022 7.775 4.675 0.841 0.206 1.656 0.312 2.444 0.312 0.603 0 1.188-0.063 1.75-0.184 1.431-0.309 2.697-1.006 3.762-2.072l0.003-0.003 0.697-0.703c0.375-0.378 0.584-0.881 0.584-1.416s-0.209-1.041-0.588-1.419l-3.6-3.588zM15.903 16.534l0.5-0.5c0 0 0 0 0 0l3.594 3.591c0 0 0 0.006 0 0.006l-0.003 0.003-0.697 0.703c-0.044 0.044-0.087 0.087-0.131 0.128l-3.469-3.469c0.091-0.156 0.159-0.309 0.2-0.456 0.003-0.003 0.006-0.006 0.006-0.006zM4.369 4c0 0 0.003 0 0.003 0s0.003 0 0.003 0l3.597 3.594c0 0 0 0.006 0 0.006l-0.5 0.5c0 0-0.006 0.003-0.016 0.006-0.144 0.041-0.294 0.109-0.447 0.197l-3.469-3.472c0.041-0.044 0.084-0.087 0.125-0.131l0.703-0.7zM13.244 21.747c-2.272-0.563-4.766-2.075-6.841-4.15s-3.588-4.566-4.15-6.837c-0.356-1.437-0.478-3.4 0.663-5.137l3.316 3.316c-0.459 0.494-0.866 1.169-1.075 1.972-0.231 0.888-0.194 1.809 0.106 2.741 0.337 1.050 1.016 2.088 2.009 3.081s2.031 1.672 3.078 2.009c0.928 0.3 1.85 0.337 2.737 0.106 0.803-0.206 1.481-0.616 1.975-1.075l3.312 3.312c-1.734 1.141-3.694 1.019-5.131 0.663z" }),
_('path', { d: "M17.5 0c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 3.794l-3.5 3.5v-1.294h-1v2.5c0 0.275 0.225 0.5 0.5 0.5h2.5v-1h-1.294l3.5-3.5-0.706-0.706z" })
            );
        }
        function PhoneIncoming({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneIncomingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhoneIncoming.SVG = PhoneIncomingSVG;
        return PhoneIncoming;
    })();
export const PhoneLock = /*#__PURE__*/ (() => {
        function PhoneLockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 0c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M20.5 6h-0.5v-0.5c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5v0.5h-0.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h6c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5zM16 5.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5v0.5h-3v-0.5zM20 9h-5v-2h5v2z" }),
_('path', { d: "M17.819 14.616c-0.378-0.378-0.881-0.584-1.413-0.584h-0.003c-0.534 0-1.034 0.209-1.413 0.591l-0.5 0.5c-0.237 0.237-0.409 0.531-0.506 0.853-0.078 0.172-0.616 0.794-1.547 0.975-1.159 0.228-2.456-0.338-3.75-1.631-1.294-1.297-1.856-2.594-1.628-3.756 0.184-0.931 0.806-1.466 0.975-1.541 0.328-0.1 0.616-0.269 0.853-0.506l0.5-0.5c0.378-0.378 0.588-0.881 0.588-1.416s-0.209-1.038-0.588-1.419l-3.597-3.594c-0.781-0.781-2.053-0.781-2.831-0.003l-0.706 0.703c-1.062 1.066-1.759 2.328-2.069 3.759-0.281 1.3-0.237 2.709 0.128 4.191 0.656 2.653 2.316 5.416 4.678 7.775 2.359 2.359 5.122 4.022 7.775 4.675 0.841 0.206 1.656 0.312 2.444 0.312 0.603 0 1.188-0.063 1.75-0.184 1.431-0.309 2.697-1.006 3.762-2.072l0.003-0.003 0.697-0.703c0.375-0.378 0.584-0.881 0.584-1.416s-0.209-1.041-0.588-1.419l-3.6-3.588zM15.903 16.534l0.5-0.5c0 0 0 0 0 0l3.594 3.591c0 0 0 0.006 0 0.006l-0.003 0.003-0.697 0.703c-0.044 0.044-0.087 0.087-0.131 0.128l-3.469-3.469c0.091-0.156 0.159-0.309 0.2-0.456 0.003-0.003 0.006-0.006 0.006-0.006zM4.369 4c0 0 0.003 0 0.003 0s0.003 0 0.003 0l3.597 3.594c0 0 0 0.006 0 0.006l-0.5 0.5c0 0-0.006 0.003-0.016 0.006-0.144 0.041-0.294 0.109-0.447 0.197l-3.469-3.472c0.041-0.044 0.084-0.087 0.125-0.131l0.703-0.7zM13.244 21.747c-2.272-0.563-4.766-2.075-6.841-4.15s-3.588-4.566-4.15-6.837c-0.356-1.437-0.478-3.4 0.663-5.137l3.316 3.316c-0.459 0.494-0.866 1.169-1.075 1.972-0.231 0.888-0.194 1.809 0.106 2.741 0.337 1.050 1.016 2.088 2.009 3.081s2.031 1.672 3.078 2.009c0.928 0.3 1.85 0.337 2.737 0.106 0.803-0.206 1.481-0.616 1.975-1.075l3.312 3.312c-1.734 1.141-3.694 1.019-5.131 0.663z" })
            );
        }
        function PhoneLock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneLockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhoneLock.SVG = PhoneLockSVG;
        return PhoneLock;
    })();
export const PhoneLoudspeaker = /*#__PURE__*/ (() => {
        function PhoneLoudspeakerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 10h1c0-2.206-1.794-4-4-4v1c1.653 0 3 1.347 3 3z" }),
_('path', { d: "M20 10h1c0-1.869-0.728-3.628-2.050-4.95s-3.081-2.050-4.95-2.050v1c3.309 0 6 2.691 6 6z" }),
_('path', { d: "M21.072 2.928c-1.891-1.887-4.4-2.928-7.072-2.928v1c4.962 0 9 4.038 9 9h1c0-2.672-1.041-5.181-2.928-7.072z" }),
_('path', { d: "M17.819 14.616c-0.378-0.378-0.881-0.584-1.413-0.584h-0.003c-0.534 0-1.034 0.209-1.413 0.591l-0.5 0.5c-0.237 0.237-0.409 0.531-0.506 0.853-0.078 0.172-0.616 0.794-1.547 0.975-1.159 0.228-2.456-0.338-3.75-1.631-1.294-1.297-1.856-2.594-1.628-3.756 0.184-0.931 0.806-1.466 0.975-1.541 0.328-0.1 0.616-0.269 0.853-0.506l0.5-0.5c0.378-0.378 0.588-0.881 0.588-1.416s-0.209-1.038-0.588-1.419l-3.597-3.594c-0.781-0.781-2.053-0.781-2.831-0.003l-0.706 0.703c-1.062 1.066-1.759 2.328-2.069 3.759-0.281 1.3-0.237 2.709 0.128 4.191 0.656 2.653 2.316 5.416 4.678 7.775 2.359 2.359 5.122 4.022 7.775 4.675 0.841 0.206 1.656 0.312 2.444 0.312 0.603 0 1.188-0.063 1.75-0.184 1.431-0.309 2.697-1.006 3.762-2.072l0.003-0.003 0.697-0.703c0.375-0.378 0.584-0.881 0.584-1.416s-0.209-1.041-0.588-1.419l-3.6-3.588zM15.903 16.534l0.5-0.5c0 0 0 0 0 0l3.594 3.591c0 0 0 0.006 0 0.006l-0.003 0.003-0.697 0.703c-0.044 0.044-0.087 0.087-0.131 0.128l-3.469-3.469c0.091-0.156 0.159-0.309 0.2-0.456 0.003-0.003 0.006-0.006 0.006-0.006zM4.369 4c0 0 0.003 0 0.003 0s0.003 0 0.003 0l3.597 3.594c0 0 0 0.006 0 0.006l-0.5 0.5c0 0-0.006 0.003-0.016 0.006-0.144 0.041-0.294 0.109-0.447 0.197l-3.469-3.472c0.041-0.044 0.084-0.087 0.125-0.131l0.703-0.7zM13.244 21.747c-2.272-0.563-4.766-2.075-6.841-4.15s-3.588-4.566-4.15-6.837c-0.356-1.437-0.478-3.4 0.663-5.137l3.316 3.316c-0.459 0.494-0.866 1.169-1.075 1.972-0.231 0.888-0.194 1.809 0.106 2.741 0.337 1.050 1.016 2.088 2.009 3.081s2.031 1.672 3.078 2.009c0.928 0.3 1.85 0.337 2.737 0.106 0.803-0.206 1.481-0.616 1.975-1.075l3.312 3.312c-1.734 1.141-3.694 1.019-5.131 0.663z" })
            );
        }
        function PhoneLoudspeaker({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneLoudspeakerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhoneLoudspeaker.SVG = PhoneLoudspeakerSVG;
        return PhoneLoudspeaker;
    })();
export const PhoneMinus = /*#__PURE__*/ (() => {
        function PhoneMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 0c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M15.003 6h4.997v1h-4.997v-1z" }),
_('path', { d: "M17.819 14.616c-0.378-0.378-0.881-0.584-1.413-0.584h-0.003c-0.534 0-1.034 0.209-1.413 0.591l-0.5 0.5c-0.237 0.237-0.409 0.531-0.506 0.853-0.078 0.172-0.616 0.794-1.547 0.975-1.159 0.228-2.456-0.338-3.75-1.631-1.294-1.297-1.856-2.594-1.628-3.756 0.184-0.931 0.806-1.466 0.975-1.541 0.328-0.1 0.616-0.269 0.853-0.506l0.5-0.5c0.378-0.378 0.588-0.881 0.588-1.416s-0.209-1.038-0.588-1.419l-3.597-3.594c-0.781-0.781-2.053-0.781-2.831-0.003l-0.706 0.703c-1.062 1.066-1.759 2.328-2.069 3.759-0.281 1.3-0.237 2.709 0.128 4.191 0.656 2.653 2.316 5.416 4.678 7.775 2.359 2.359 5.122 4.022 7.775 4.675 0.841 0.206 1.656 0.312 2.444 0.312 0.603 0 1.188-0.063 1.75-0.184 1.431-0.309 2.697-1.006 3.762-2.072l0.003-0.003 0.697-0.703c0.375-0.378 0.584-0.881 0.584-1.416s-0.209-1.041-0.588-1.419l-3.6-3.588zM15.903 16.534l0.5-0.5c0 0 0 0 0 0l3.594 3.591c0 0 0 0.006 0 0.006l-0.003 0.003-0.697 0.703c-0.044 0.044-0.087 0.087-0.131 0.128l-3.469-3.469c0.091-0.156 0.159-0.309 0.2-0.456 0.003-0.003 0.006-0.006 0.006-0.006zM4.369 4c0 0 0.003 0 0.003 0s0.003 0 0.003 0l3.597 3.594c0 0 0 0.006 0 0.006l-0.5 0.5c0 0-0.006 0.003-0.016 0.006-0.144 0.041-0.294 0.109-0.447 0.197l-3.469-3.472c0.041-0.044 0.084-0.087 0.125-0.131l0.703-0.7zM13.244 21.747c-2.272-0.563-4.766-2.075-6.841-4.15s-3.588-4.566-4.15-6.837c-0.356-1.437-0.478-3.4 0.663-5.137l3.316 3.316c-0.459 0.494-0.866 1.169-1.075 1.972-0.231 0.888-0.194 1.809 0.106 2.741 0.337 1.050 1.016 2.088 2.009 3.081s2.031 1.672 3.078 2.009c0.928 0.3 1.85 0.337 2.737 0.106 0.803-0.206 1.481-0.616 1.975-1.075l3.312 3.312c-1.734 1.141-3.694 1.019-5.131 0.663z" })
            );
        }
        function PhoneMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhoneMinus.SVG = PhoneMinusSVG;
        return PhoneMinus;
    })();
export const PhoneOutgoing = /*#__PURE__*/ (() => {
        function PhoneOutgoingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 0c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 4h-2.5v1h1.294l-3.5 3.5 0.706 0.706 3.5-3.5v1.294h1v-2.5c0-0.275-0.225-0.5-0.5-0.5z" }),
_('path', { d: "M17.819 14.616c-0.378-0.378-0.881-0.584-1.413-0.584h-0.003c-0.534 0-1.034 0.209-1.413 0.591l-0.5 0.5c-0.237 0.237-0.409 0.531-0.506 0.853-0.078 0.172-0.616 0.794-1.547 0.975-1.159 0.228-2.456-0.338-3.75-1.631-1.294-1.297-1.856-2.594-1.628-3.756 0.184-0.931 0.806-1.466 0.975-1.541 0.328-0.1 0.616-0.269 0.853-0.506l0.5-0.5c0.378-0.378 0.588-0.881 0.588-1.416s-0.209-1.038-0.588-1.419l-3.597-3.594c-0.781-0.781-2.053-0.781-2.831-0.003l-0.706 0.703c-1.062 1.066-1.759 2.328-2.069 3.759-0.281 1.3-0.237 2.709 0.128 4.191 0.656 2.653 2.316 5.416 4.678 7.775 2.359 2.359 5.122 4.022 7.775 4.675 0.841 0.206 1.656 0.312 2.444 0.312 0.603 0 1.188-0.063 1.75-0.184 1.431-0.309 2.697-1.006 3.762-2.072l0.003-0.003 0.697-0.703c0.375-0.378 0.584-0.881 0.584-1.416s-0.209-1.041-0.588-1.419l-3.6-3.588zM15.903 16.534l0.5-0.5c0 0 0 0 0 0l3.594 3.591c0 0 0 0.006 0 0.006l-0.003 0.003-0.697 0.703c-0.044 0.044-0.087 0.087-0.131 0.128l-3.469-3.469c0.091-0.156 0.159-0.309 0.2-0.456 0.003-0.003 0.006-0.006 0.006-0.006zM4.369 4c0 0 0.003 0 0.003 0s0.003 0 0.003 0l3.597 3.594c0 0 0 0.006 0 0.006l-0.5 0.5c0 0-0.006 0.003-0.016 0.006-0.144 0.041-0.294 0.109-0.447 0.197l-3.469-3.472c0.041-0.044 0.084-0.087 0.125-0.131l0.703-0.7zM13.244 21.747c-2.272-0.563-4.766-2.075-6.841-4.15s-3.588-4.566-4.15-6.837c-0.356-1.437-0.478-3.4 0.663-5.137l3.316 3.316c-0.459 0.494-0.866 1.169-1.075 1.972-0.231 0.888-0.194 1.809 0.106 2.741 0.337 1.050 1.016 2.088 2.009 3.081s2.031 1.672 3.078 2.009c0.928 0.3 1.85 0.337 2.737 0.106 0.803-0.206 1.481-0.616 1.975-1.075l3.312 3.312c-1.734 1.141-3.694 1.019-5.131 0.663z" })
            );
        }
        function PhoneOutgoing({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneOutgoingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhoneOutgoing.SVG = PhoneOutgoingSVG;
        return PhoneOutgoing;
    })();
export const PhonePause = /*#__PURE__*/ (() => {
        function PhonePauseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.819 14.616c-0.378-0.378-0.881-0.584-1.413-0.584h-0.003c-0.534 0-1.034 0.209-1.413 0.591l-0.5 0.5c-0.237 0.237-0.409 0.531-0.506 0.853-0.078 0.172-0.616 0.794-1.547 0.975-1.159 0.228-2.456-0.338-3.75-1.631-1.294-1.297-1.856-2.594-1.628-3.756 0.184-0.931 0.806-1.466 0.975-1.541 0.328-0.1 0.616-0.269 0.853-0.506l0.5-0.5c0.378-0.378 0.588-0.881 0.588-1.416s-0.209-1.038-0.588-1.419l-3.597-3.594c-0.781-0.781-2.053-0.781-2.831-0.003l-0.706 0.703c-1.062 1.066-1.759 2.328-2.069 3.759-0.281 1.3-0.237 2.709 0.128 4.191 0.656 2.653 2.316 5.416 4.678 7.775 2.359 2.359 5.122 4.022 7.775 4.675 0.841 0.206 1.656 0.312 2.444 0.312 0.603 0 1.188-0.063 1.75-0.184 1.431-0.309 2.697-1.006 3.762-2.072l0.003-0.003 0.697-0.703c0.375-0.378 0.584-0.881 0.584-1.416s-0.209-1.041-0.588-1.419l-3.6-3.588zM15.903 16.534l0.5-0.5c0 0 0 0 0 0l3.594 3.591c0 0 0 0.006 0 0.006l-0.003 0.003-0.697 0.703c-0.044 0.044-0.087 0.087-0.131 0.128l-3.469-3.469c0.091-0.156 0.159-0.309 0.2-0.456 0.003-0.003 0.006-0.006 0.006-0.006zM4.369 4c0 0 0.003 0 0.003 0s0.003 0 0.003 0l3.597 3.594c0 0 0 0.006 0 0.006l-0.5 0.5c0 0-0.006 0.003-0.016 0.006-0.144 0.041-0.294 0.109-0.447 0.197l-3.469-3.472c0.041-0.044 0.084-0.087 0.125-0.131l0.703-0.7zM13.244 21.747c-2.272-0.563-4.766-2.075-6.841-4.15s-3.588-4.566-4.15-6.837c-0.356-1.437-0.478-3.4 0.663-5.137l3.316 3.316c-0.459 0.494-0.866 1.169-1.075 1.972-0.231 0.888-0.194 1.809 0.106 2.741 0.337 1.050 1.016 2.088 2.009 3.081s2.031 1.672 3.078 2.009c0.928 0.3 1.85 0.337 2.737 0.106 0.803-0.206 1.481-0.616 1.975-1.075l3.312 3.312c-1.734 1.141-3.694 1.019-5.131 0.663z" }),
_('path', { d: "M17.5 0c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18 4h1v5h-1v-5z" }),
_('path', { d: "M16 4h1v5h-1v-5z" })
            );
        }
        function PhonePause({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhonePauseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhonePause.SVG = PhonePauseSVG;
        return PhonePause;
    })();
export const PhonePlus = /*#__PURE__*/ (() => {
        function PhonePlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 0c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18 4.003h-1v1.997h-1.997v1h1.997v2h1v-2h2v-1h-2z" }),
_('path', { d: "M17.819 14.616c-0.378-0.378-0.881-0.584-1.413-0.584h-0.003c-0.534 0-1.034 0.209-1.413 0.591l-0.5 0.5c-0.237 0.237-0.409 0.531-0.506 0.853-0.078 0.172-0.616 0.794-1.547 0.975-1.159 0.228-2.456-0.338-3.75-1.631-1.294-1.297-1.856-2.594-1.628-3.756 0.184-0.931 0.806-1.466 0.975-1.541 0.328-0.1 0.616-0.269 0.853-0.506l0.5-0.5c0.378-0.378 0.588-0.881 0.588-1.416s-0.209-1.038-0.588-1.419l-3.597-3.594c-0.781-0.781-2.053-0.781-2.831-0.003l-0.706 0.703c-1.062 1.066-1.759 2.328-2.069 3.759-0.281 1.3-0.237 2.709 0.128 4.191 0.656 2.653 2.316 5.416 4.678 7.775 2.359 2.359 5.122 4.022 7.775 4.675 0.841 0.206 1.656 0.312 2.444 0.312 0.603 0 1.188-0.063 1.75-0.184 1.431-0.309 2.697-1.006 3.762-2.072l0.003-0.003 0.697-0.703c0.375-0.378 0.584-0.881 0.584-1.416s-0.209-1.041-0.588-1.419l-3.6-3.588zM15.903 16.534l0.5-0.5c0 0 0 0 0 0l3.594 3.591c0 0 0 0.006 0 0.006l-0.003 0.003-0.697 0.703c-0.044 0.044-0.087 0.087-0.131 0.128l-3.469-3.469c0.091-0.156 0.159-0.309 0.2-0.456 0.003-0.003 0.006-0.006 0.006-0.006zM4.369 4c0 0 0.003 0 0.003 0s0.003 0 0.003 0l3.597 3.594c0 0 0 0.006 0 0.006l-0.5 0.5c0 0-0.006 0.003-0.016 0.006-0.144 0.041-0.294 0.109-0.447 0.197l-3.469-3.472c0.041-0.044 0.084-0.087 0.125-0.131l0.703-0.7zM13.244 21.747c-2.272-0.563-4.766-2.075-6.841-4.15s-3.588-4.566-4.15-6.837c-0.356-1.437-0.478-3.4 0.663-5.137l3.316 3.316c-0.459 0.494-0.866 1.169-1.075 1.972-0.231 0.888-0.194 1.809 0.106 2.741 0.337 1.050 1.016 2.088 2.009 3.081s2.031 1.672 3.078 2.009c0.928 0.3 1.85 0.337 2.737 0.106 0.803-0.206 1.481-0.616 1.975-1.075l3.312 3.312c-1.734 1.141-3.694 1.019-5.131 0.663z" })
            );
        }
        function PhonePlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhonePlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhonePlus.SVG = PhonePlusSVG;
        return PhonePlus;
    })();
export const PhoneSip = /*#__PURE__*/ (() => {
        function PhoneSipSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.413 17.209l-3.597-3.594c-0.378-0.378-0.878-0.588-1.409-0.588h-0.003c-0.534 0-1.034 0.209-1.413 0.591l-0.5 0.5c-0.237 0.237-0.409 0.528-0.506 0.85-0.078 0.172-0.616 0.794-1.547 0.975-1.163 0.228-2.456-0.337-3.75-1.631-1.294-1.297-1.856-2.594-1.628-3.756 0.184-0.931 0.806-1.466 0.975-1.544 0.328-0.1 0.616-0.269 0.853-0.506l0.5-0.5c0.781-0.781 0.781-2.053 0-2.834l-3.597-3.594c-0.781-0.781-2.053-0.781-2.831-0.003l-0.706 0.703c-1.062 1.066-1.759 2.331-2.069 3.762-0.281 1.3-0.237 2.709 0.128 4.191 0.656 2.653 2.316 5.416 4.678 7.775 2.356 2.366 5.119 4.025 7.772 4.681 0.841 0.206 1.656 0.312 2.441 0.312 0.603 0 1.188-0.063 1.75-0.184 1.431-0.309 2.697-1.006 3.762-2.072 0 0 0.003-0.003 0.003-0.003l0.697-0.703c0.778-0.778 0.778-2.050-0.003-2.828zM16.903 15.531l0.5-0.5c0 0 0 0 0 0l3.594 3.591c0 0 0 0.006 0 0.006s-0.003 0.003-0.003 0.003l-0.694 0.7c-0.044 0.044-0.087 0.087-0.134 0.128l-3.466-3.466c0.091-0.156 0.159-0.312 0.2-0.456 0.003-0.003 0.003-0.003 0.003-0.006zM5.369 2.997c0 0 0.003 0 0 0 0.003 0 0.006 0 0.006 0l3.597 3.594c0 0 0 0.006 0 0.006l-0.5 0.5c0 0-0.006 0.003-0.016 0.006-0.144 0.044-0.297 0.109-0.45 0.2l-3.469-3.469c0.041-0.044 0.084-0.087 0.128-0.131l0.703-0.706zM14.244 20.744c-2.272-0.563-4.766-2.072-6.841-4.15-2.078-2.072-3.591-4.566-4.15-6.837-0.356-1.437-0.478-3.4 0.659-5.137l3.316 3.319c-0.459 0.494-0.866 1.169-1.072 1.969-0.231 0.888-0.194 1.809 0.106 2.741 0.337 1.050 1.016 2.088 2.009 3.081s2.031 1.672 3.078 2.009c0.928 0.3 1.85 0.338 2.741 0.106 0.803-0.206 1.481-0.616 1.975-1.075l3.312 3.312c-1.737 1.141-3.697 1.019-5.134 0.663z" }),
_('path', { d: "M16 7.5c0-0.828-0.672-1.5-1.5-1.5-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h1.5v-1h-1.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-1.5v1h1.5c0.828 0 1.5-0.672 1.5-1.5z" }),
_('path', { d: "M17 4h1v5h-1v-5z" }),
_('path', { d: "M20 7h0.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-1c-0.275 0-0.5 0.225-0.5 0.5v4.5h1v-2zM20 5h0.5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-0.5v-1z" })
            );
        }
        function PhoneSip({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneSipSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhoneSip.SVG = PhoneSipSVG;
        return PhoneSip;
    })();
export const PhoneTime = /*#__PURE__*/ (() => {
        function PhoneTimeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.816 14.616c-0.378-0.378-0.878-0.588-1.409-0.588h-0.003c-0.534 0-1.034 0.209-1.413 0.591l-0.5 0.5c-0.237 0.237-0.409 0.528-0.506 0.85-0.078 0.172-0.616 0.794-1.547 0.975-1.159 0.228-2.456-0.338-3.75-1.631-1.294-1.297-1.856-2.594-1.628-3.756 0.184-0.931 0.806-1.466 0.975-1.544 0.328-0.1 0.616-0.269 0.853-0.506l0.5-0.5c0.781-0.781 0.781-2.053 0-2.834l-3.597-3.594c-0.781-0.781-2.053-0.781-2.831-0.003l-0.706 0.703c-1.062 1.066-1.759 2.331-2.069 3.762-0.281 1.3-0.237 2.709 0.128 4.191 0.656 2.653 2.316 5.416 4.678 7.775 2.356 2.366 5.119 4.025 7.772 4.681 0.841 0.206 1.656 0.312 2.441 0.312 0.603 0 1.188-0.063 1.75-0.184 1.431-0.309 2.697-1.006 3.762-2.072 0 0 0.003-0.003 0.003-0.003l0.697-0.703c0.778-0.781 0.778-2.050-0.003-2.831l-3.597-3.591zM15.903 16.531l0.5-0.5c0 0 0 0 0 0l3.594 3.591c0 0 0 0.006 0 0.006s-0.003 0.003-0.003 0.003l-0.694 0.7c-0.044 0.044-0.087 0.087-0.134 0.128l-3.466-3.466c0.091-0.156 0.159-0.312 0.2-0.456 0.003-0.003 0.003-0.003 0.003-0.006zM4.369 3.997c0 0 0.003 0 0 0 0.003 0 0.006 0 0.006 0l3.597 3.594c0 0 0 0.006 0 0.006l-0.5 0.5c0 0-0.006 0.003-0.016 0.006-0.144 0.044-0.297 0.109-0.45 0.2l-3.469-3.469c0.041-0.044 0.084-0.087 0.128-0.131l0.703-0.706zM13.244 21.744c-2.272-0.563-4.766-2.072-6.841-4.15-2.078-2.072-3.591-4.566-4.15-6.837-0.356-1.437-0.478-3.4 0.659-5.137l3.316 3.319c-0.459 0.494-0.866 1.169-1.072 1.969-0.231 0.888-0.194 1.809 0.106 2.741 0.338 1.050 1.016 2.088 2.009 3.081s2.031 1.672 3.078 2.009c0.928 0.3 1.85 0.337 2.741 0.106 0.803-0.206 1.481-0.616 1.975-1.075l3.312 3.312c-1.737 1.141-3.697 1.019-5.134 0.663z" }),
_('path', { d: "M17.5 0c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zM18 11.978v-1.978h-1v1.978c-2.634-0.237-4.737-2.344-4.978-4.978h1.978v-1h-1.978c0.237-2.634 2.344-4.737 4.978-4.978v1.978h1v-1.978c2.634 0.237 4.737 2.344 4.978 4.978h-1.978v1h1.978c-0.241 2.634-2.344 4.737-4.978 4.978z" }),
_('path', { d: "M17.422 6.716l-1.922-1.922-0.706 0.706 2.353 2.353c0.094 0.094 0.222 0.147 0.353 0.147 0.016 0 0.034 0 0.050-0.003 0.15-0.016 0.284-0.097 0.366-0.219l2.278-3.416-0.831-0.556-1.941 2.909z" })
            );
        }
        function PhoneTime({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneTimeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhoneTime.SVG = PhoneTimeSVG;
        return PhoneTime;
    })();
export const PhoneUser = /*#__PURE__*/ (() => {
        function PhoneUserSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.819 14.616c-0.378-0.378-0.881-0.584-1.413-0.584h-0.003c-0.534 0-1.034 0.209-1.413 0.591l-0.5 0.5c-0.237 0.237-0.409 0.531-0.506 0.853-0.078 0.172-0.616 0.794-1.547 0.975-1.159 0.228-2.456-0.338-3.75-1.631-1.294-1.297-1.856-2.594-1.628-3.756 0.184-0.931 0.806-1.466 0.975-1.541 0.328-0.1 0.616-0.269 0.853-0.506l0.5-0.5c0.378-0.378 0.588-0.881 0.588-1.416s-0.209-1.038-0.588-1.419l-3.597-3.594c-0.781-0.781-2.053-0.781-2.831-0.003l-0.706 0.703c-1.062 1.066-1.759 2.328-2.069 3.759-0.281 1.3-0.237 2.709 0.128 4.191 0.656 2.653 2.316 5.416 4.678 7.775 2.359 2.359 5.122 4.022 7.775 4.675 0.841 0.206 1.656 0.312 2.444 0.312 0.603 0 1.188-0.063 1.75-0.184 1.431-0.309 2.697-1.006 3.762-2.072l0.003-0.003 0.697-0.703c0.375-0.378 0.584-0.881 0.584-1.416s-0.209-1.041-0.588-1.419l-3.6-3.588zM15.903 16.534l0.5-0.5c0 0 0 0 0 0l3.594 3.591c0 0 0 0.006 0 0.006l-0.003 0.003-0.697 0.703c-0.044 0.044-0.087 0.087-0.131 0.128l-3.469-3.469c0.091-0.156 0.159-0.309 0.2-0.456 0.003-0.003 0.006-0.006 0.006-0.006zM4.369 4c0 0 0.003 0 0.003 0s0.003 0 0.003 0l3.597 3.594c0 0 0 0.006 0 0.006l-0.5 0.5c0 0-0.006 0.003-0.016 0.006-0.144 0.041-0.294 0.109-0.447 0.197l-3.469-3.472c0.041-0.044 0.084-0.087 0.125-0.131l0.703-0.7zM13.244 21.747c-2.272-0.563-4.766-2.075-6.841-4.15s-3.588-4.566-4.15-6.837c-0.356-1.437-0.478-3.4 0.663-5.137l3.316 3.316c-0.459 0.494-0.866 1.169-1.075 1.972-0.231 0.888-0.194 1.809 0.106 2.741 0.337 1.050 1.016 2.088 2.009 3.081s2.031 1.672 3.078 2.009c0.928 0.3 1.85 0.337 2.737 0.106 0.803-0.206 1.481-0.616 1.975-1.075l3.312 3.312c-1.734 1.141-3.694 1.019-5.131 0.663z" }),
_('path', { d: "M17.5 0c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zM14.125 10.841c0.412-1.066 1.8-1.841 3.375-1.841s2.959 0.772 3.375 1.841c-0.931 0.728-2.103 1.159-3.375 1.159s-2.444-0.434-3.375-1.159zM15 5.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5-2.5-1.122-2.5-2.5zM21.641 10.119c-0.422-0.769-1.184-1.387-2.131-1.753 0.9-0.634 1.491-1.681 1.491-2.866 0-1.931-1.569-3.5-3.5-3.5s-3.5 1.569-3.5 3.5c0 1.181 0.591 2.231 1.491 2.862-0.947 0.366-1.709 0.981-2.131 1.753-0.847-0.969-1.359-2.234-1.359-3.616 0-3.031 2.469-5.5 5.5-5.5s5.5 2.469 5.5 5.5c0 1.384-0.513 2.65-1.359 3.619z" })
            );
        }
        function PhoneUser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneUserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhoneUser.SVG = PhoneUserSVG;
        return PhoneUser;
    })();
export const PhotoAlbum = /*#__PURE__*/ (() => {
        function PhotoAlbumSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 5c0-1.103-0.897-2-2-2 0-1.103-0.897-2-2-2h-8c-1.103 0-2 0.897-2 2-1.103 0-2 0.897-2 2-1.103 0-2 0.897-2 2v14c0 1.103 0.897 2 2 2h16c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM8 2h8c0.55 0 1 0.45 1 1h-10c0-0.55 0.45-1 1-1zM6 4h12c0.55 0 1 0.45 1 1h-14c0-0.55 0.45-1 1-1zM20 21h-16v-14h16v14c0.003 0 0 0 0 0z" }),
_('path', { d: "M17.5 9h-11c-0.275 0-0.5 0.225-0.5 0.5v9c0 0.275 0.225 0.5 0.5 0.5h11c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.225-0.5-0.5-0.5zM7 10h10v5.169l-0.584-0.584c-0.781-0.778-2.050-0.778-2.828 0l-3.416 3.416h-3.172v-8zM11.584 18l2.709-2.709c0.387-0.387 1.025-0.387 1.416 0l1.291 1.291v1.419h-5.416z" }),
_('path', { d: "M11 12.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5zM9 12.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5z" })
            );
        }
        function PhotoAlbum({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhotoAlbumSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhotoAlbum.SVG = PhotoAlbumSVG;
        return PhotoAlbum;
    })();
export const Piano = /*#__PURE__*/ (() => {
    function PianoSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 4h-20c-1.103 0-2 0.897-2 2v12c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-12c0-1.103-0.897-2-2-2zM4 13v-7h1v7h-1zM5.5 14c0.275 0 0.5-0.225 0.5-0.5v-7.5h2v7.5c0 0.275 0.225 0.5 0.5 0.5h0.5v4h-4v-4h0.5zM9 13v-7h1v7h-1zM10 14h0.5c0.275 0 0.5-0.225 0.5-0.5v-7.5h2v7.5c0 0.275 0.225 0.5 0.5 0.5h0.5v4h-4v-4zM14 13v-7h1v7h-1zM15 14h0.5c0.275 0 0.5-0.225 0.5-0.5v-7.5h2v7.5c0 0.275 0.225 0.5 0.5 0.5h0.5v4h-4v-4zM19 13v-7h1v7h-1zM1 18v-12h2v7.5c0 0.275 0.225 0.5 0.5 0.5h0.5v4h-3zM20 18v-4h0.5c0.275 0 0.5-0.225 0.5-0.5v-7.5h2v12h-3z" })
        );
    }
    function Piano({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PianoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Piano.SVG = PianoSVG;
    return Piano;
})();
export const Pickaxe = /*#__PURE__*/ (() => {
    function PickaxeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.269 19.731l-11.353-11.353c0.050-0.15 0.075-0.309 0.075-0.472 0-0.288-0.081-0.563-0.231-0.8 2.297-2.022 5.497-4.616 8.003-6.181 0.191-0.119 0.278-0.353 0.213-0.569s-0.266-0.363-0.491-0.356c-1.984 0.059-4.131 0.497-6.381 1.3-1.694 0.606-3.391 1.409-4.816 2.281l-0.131-0.131c-0.284-0.284-0.659-0.441-1.059-0.441-0.162 0-0.322 0.025-0.472 0.075l-0.537-0.537c-0.547-0.547-1.231-0.697-1.884-0.412-0.422 0.184-0.756 0.519-1.078 0.841l-0.131 0.131c-0.466 0.462-0.994 0.984-0.994 1.741 0 0.45 0.184 0.866 0.553 1.237l0.537 0.537c-0.050 0.15-0.075 0.309-0.075 0.475 0 0.4 0.156 0.778 0.441 1.059l0.131 0.131c-0.878 1.425-1.681 3.122-2.288 4.816-0.803 2.25-1.241 4.397-1.3 6.381-0.006 0.225 0.141 0.428 0.356 0.494 0.047 0.016 0.097 0.022 0.144 0.022 0.172 0 0.334-0.087 0.425-0.237 1.544-2.519 4.212-5.8 6.169-8.009 0.241 0.156 0.519 0.237 0.813 0.237 0.162 0 0.322-0.025 0.475-0.078l11.353 11.35c0.487 0.487 1.125 0.728 1.766 0.728s1.281-0.244 1.769-0.728c0.972-0.969 0.975-2.553 0-3.531zM4.397 4.525l0.138-0.138c0.084-0.084 0.191-0.191 0.288-0.278l0.275 0.275-0.709 0.709-0.278-0.278c0.087-0.094 0.2-0.206 0.288-0.291zM7.553 10.847l-1.053-1.053-0.706 0.706 0.572 0.572c-1.634 1.841-3.634 4.272-5.181 6.484 0.534-3.506 2.103-6.959 3.45-9.072 0.125-0.197 0.097-0.456-0.069-0.622l-0.413-0.413c-0.194-0.194-0.194-0.513 0-0.706l2.584-2.584c0.194-0.194 0.513-0.194 0.706 0l0.412 0.412c0.166 0.166 0.425 0.194 0.622 0.069 2.119-1.35 5.584-2.925 9.1-3.456-2.212 1.559-4.65 3.563-6.503 5.194l-0.575-0.584-0.706 0.706 1.053 1.053c0.194 0.194 0.194 0.513 0 0.706l-2.584 2.584c-0.197 0.197-0.516 0.197-0.709 0.003zM21.856 21.85c-0.197 0.197-0.516 0.197-0.709 0.003l-11.241-11.241 0.706-0.706 11.241 11.238c0.197 0.197 0.197 0.513 0.003 0.706z" })
        );
    }
    function Pickaxe({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PickaxeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pickaxe.SVG = PickaxeSVG;
    return Pickaxe;
})();
export const Picture = /*#__PURE__*/ (() => {
        function PictureSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20l-0.003-20c0 0 0 0 0.003 0h20v20z" }),
_('path', { d: "M3.5 21h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5zM7.672 20l7.416-7.413c0.378-0.378 0.878-0.584 1.413-0.584s1.038 0.206 1.413 0.584l2.084 2.084v5.328h-12.325zM20 4v9.259l-1.378-1.378c-0.566-0.566-1.319-0.878-2.122-0.878s-1.556 0.312-2.122 0.878l-8.119 8.119h-2.259v-2.416l3.294-3.294c0.387-0.387 1.025-0.387 1.416 0l0.916 0.916 0.706-0.706-0.916-0.916c-0.781-0.778-2.050-0.778-2.828 0l-2.588 2.587v-12.172h16z" }),
_('path', { d: "M8.5 11c1.378 0 2.5-1.122 2.5-2.5s-1.122-2.5-2.5-2.5-2.5 1.122-2.5 2.5 1.122 2.5 2.5 2.5zM8.5 7c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5z" })
            );
        }
        function Picture({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PictureSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Picture.SVG = PictureSVG;
        return Picture;
    })();
export const Picture2 = /*#__PURE__*/ (() => {
        function Picture2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20l-0.003-20c0 0 0 0 0.003 0h20v20z" }),
_('path', { d: "M3.5 17h17c0.275 0 0.5-0.225 0.5-0.5v-13c0-0.275-0.225-0.5-0.5-0.5h-17c-0.275 0-0.5 0.225-0.5 0.5v13c0 0.275 0.225 0.5 0.5 0.5zM10.584 16l6.709-6.709c0.387-0.387 1.025-0.387 1.416 0l1.291 1.291v5.419h-9.416zM20 4v5.169l-0.584-0.584c-0.781-0.778-2.050-0.778-2.828 0l-7.416 7.416h-4.587l4.709-4.709c0.387-0.387 1.025-0.387 1.416 0l0.916 0.916 0.706-0.706-0.916-0.916c-0.781-0.778-2.050-0.778-2.828 0l-4.587 4.587v-11.172h16z" }),
_('path', { d: "M7 9c1.103 0 2-0.897 2-2s-0.897-2-2-2-2 0.897-2 2 0.897 2 2 2zM7 6c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M8 19h8v1h-8v-1z" })
            );
        }
        function Picture2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Picture2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Picture2.SVG = Picture2SVG;
        return Picture2;
    })();
export const PieChart = /*#__PURE__*/ (() => {
        function PieChartSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 13h-8v-8c0-0.553-0.447-1-1-1-2.672 0-5.181 1.041-7.072 2.928-1.887 1.891-2.928 4.4-2.928 7.072s1.041 5.181 2.928 7.072c1.891 1.887 4.4 2.928 7.072 2.928s5.181-1.041 7.072-2.928c1.887-1.891 2.928-4.4 2.928-7.072 0-0.553-0.447-1-1-1zM10 22c-4.413 0-8-3.588-8-8 0-4.072 3.059-7.444 7-7.938v7.938c0 0.553 0.447 1 1 1h7.938c-0.494 3.941-3.866 7-7.938 7z" }),
_('path', { d: "M12.397 11.991c0.034 0.006 0.069 0.012 0.103 0.012 0.194 0 0.375-0.113 0.456-0.297l4.469-10.053c0.113-0.253 0-0.547-0.253-0.659-1.475-0.663-3.047-0.994-4.672-0.994-0.275 0-0.5 0.225-0.5 0.5v11c0 0.237 0.166 0.441 0.397 0.491zM13 1.013c1.141 0.053 2.247 0.288 3.303 0.697l-3.303 7.434v-8.131z" }),
_('path', { d: "M22.541 6.441c-0.925-1.472-2.238-2.663-3.791-3.441-0.119-0.059-0.256-0.069-0.381-0.028s-0.231 0.131-0.291 0.25l-4.025 8.053c-0.078 0.156-0.069 0.337 0.022 0.488s0.253 0.237 0.425 0.237h9c0.275 0 0.5-0.225 0.5-0.5 0-1.797-0.503-3.547-1.459-5.059zM15.309 11l3.434-6.869c2.494 1.434 4.078 3.997 4.244 6.869h-7.678z" })
            );
        }
        function PieChart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PieChartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PieChart.SVG = PieChartSVG;
        return PieChart;
    })();
export const Pig = /*#__PURE__*/ (() => {
        function PigSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 10c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM16 11c0 0 0 0 0 0v0z" }),
_('path', { d: "M23.675 11.262c-0.206-0.191-0.484-0.281-0.766-0.256-0.003 0-0.45 0.041-0.959 0.012-0.519-0.028-0.816-0.113-0.95-0.172-0.028-0.925-0.297-1.781-0.8-2.547-0.216-0.328-0.472-0.634-0.766-0.919l1.503-2.631c0.087-0.156 0.087-0.344-0.003-0.5-0.091-0.153-0.253-0.25-0.431-0.25-1.353 0-3.5 0-4.972 1.394-0.984-0.237-2.056-0.363-3.162-0.363-1.241 0-2.459 0.153-3.622 0.456-1.237 0.322-2.347 0.8-3.3 1.416-0.856 0.553-1.563 1.209-2.109 1.953-1.091-0.591-1.672-1.297-1.981-1.966 0.203 0.069 0.419 0.106 0.647 0.106 1.103 0 2-0.897 2-2s-0.9-1.997-2.003-1.997c-0.266 0-0.522 0.053-0.753 0.147 0.053-0.144 0.113-0.275 0.181-0.391 0.309-0.516 0.809-0.756 1.572-0.756v-1c-1.116 0-1.934 0.419-2.428 1.244-0.391 0.647-0.572 1.522-0.572 2.756 0 0 0 0 0 0s0 0 0 0 0 0 0 0.003c0 0.8 0 3.147 2.8 4.703-0.531 0.994-0.8 2.103-0.8 3.294 0 2.591 0.378 4.819 1.119 6.619 0.622 1.506 1.362 2.384 1.878 2.856 0.369 0.337 0.85 0.525 1.35 0.525h1.653c1.103 0 2-0.897 2-2v-1.153c1.266 0.153 2.619 0.178 4 0.075v1.081c0 1.103 0.897 2 2 2h1.306c0.828 0 1.581-0.522 1.875-1.3l1.25-3.331c0.169-0.069 0.334-0.134 0.5-0.2 0.656-0.262 1.275-0.509 1.788-0.825 0.738-0.456 1.153-1.006 1.272-1.675 0.009-0.056 0.016-0.112 0.016-0.172v-3.5c-0.006-0.281-0.125-0.55-0.331-0.738zM2 4c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM19.631 5.009l-0.987 1.725c-0.153-0.106-0.309-0.206-0.475-0.306-0.447-0.266-0.941-0.494-1.469-0.684 0.881-0.563 1.975-0.7 2.931-0.734zM22 15.363c-0.034 0.056-0.128 0.153-0.337 0.284-0.366 0.225-0.903 0.441-1.475 0.669-0.303 0.122-0.619 0.247-0.941 0.387-0.25 0.109-0.444 0.312-0.537 0.566l-1.4 3.734h-1.309v-2.187c0-0.288-0.122-0.559-0.337-0.75-0.184-0.162-0.419-0.25-0.663-0.25-0.041 0-0.084 0.003-0.125 0.006-1.978 0.247-3.997 0.203-5.684-0.128-0.294-0.056-0.597 0.019-0.828 0.209s-0.366 0.472-0.366 0.772v2.325h-1.65c-0.297-0.275-0.872-0.916-1.381-2.147-0.644-1.556-0.969-3.528-0.969-5.856 0-1.841 0.853-3.328 2.534-4.416 1.522-0.987 3.65-1.553 5.834-1.553 1.859 0 3.556 0.4 4.784 1.122 1.228 0.725 1.85 1.684 1.85 2.85 0 0.491 0.203 0.944 0.572 1.278 0.478 0.434 1.219 0.675 2.262 0.734 0.056 0.003 0.113 0.006 0.166 0.006v2.344z" })
            );
        }
        function Pig({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PigSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pig.SVG = PigSVG;
        return Pig;
    })();
export const PiggyBank = /*#__PURE__*/ (() => {
        function PiggyBankSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 11c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1c0-0.55-0.45-1-1-1zM16 12c0 0 0 0 0 0v0z" }),
_('path', { d: "M23.675 12.263c-0.206-0.191-0.484-0.284-0.766-0.256-0.003 0-0.45 0.041-0.959 0.012-0.519-0.028-0.816-0.112-0.95-0.172-0.028-0.925-0.297-1.781-0.8-2.547-0.216-0.328-0.472-0.634-0.766-0.919l1.503-2.631c0.087-0.156 0.087-0.344-0.003-0.5-0.091-0.153-0.253-0.25-0.431-0.25-0.841 0-1.987 0-3.087 0.334-0.747 0.228-1.375 0.581-1.881 1.059-0.987-0.237-2.056-0.363-3.166-0.363-1.241 0-2.459 0.153-3.622 0.456-1.238 0.322-2.347 0.8-3.3 1.416-0.856 0.553-1.563 1.209-2.109 1.953-1.091-0.591-1.672-1.297-1.981-1.966 0.203 0.069 0.419 0.106 0.647 0.106 1.103 0 2-0.897 2-2s-0.897-2-2-2c-0.266 0-0.522 0.053-0.753 0.147 0.053-0.144 0.112-0.275 0.181-0.391 0.306-0.513 0.806-0.753 1.569-0.753v-1c-1.116 0-1.934 0.419-2.428 1.244-0.391 0.647-0.572 1.522-0.572 2.753 0 0 0 0 0 0.003 0 0 0 0 0 0s0 0 0 0.003c0 0.8 0 3.147 2.8 4.7-0.531 0.997-0.8 2.106-0.8 3.297 0 2.591 0.378 4.819 1.119 6.619 0.622 1.506 1.362 2.384 1.875 2.856 0.372 0.337 0.85 0.525 1.353 0.525h1.653c1.103 0 2-0.897 2-2v-1.156c1.266 0.153 2.619 0.178 4 0.075v1.081c0 1.103 0.897 2 2 2h1.306c0.828 0 1.581-0.522 1.872-1.297l1.25-3.328c0.169-0.069 0.334-0.134 0.5-0.2 0.656-0.263 1.275-0.509 1.788-0.825 0.741-0.456 1.156-1.006 1.272-1.678 0.009-0.056 0.016-0.113 0.016-0.172v-3.5c-0.003-0.281-0.122-0.55-0.328-0.738zM2 5c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM19.631 6.009l-0.987 1.725c-0.153-0.106-0.309-0.206-0.475-0.306-0.447-0.262-0.941-0.494-1.469-0.684 0.881-0.566 1.969-0.7 2.931-0.734zM22 16.362c-0.034 0.056-0.128 0.153-0.337 0.281-0.363 0.225-0.903 0.441-1.478 0.669-0.303 0.122-0.619 0.247-0.941 0.387-0.25 0.109-0.444 0.312-0.537 0.566l-1.4 3.734h-1.306v-2.187c0-0.288-0.122-0.559-0.337-0.75-0.184-0.162-0.419-0.25-0.663-0.25-0.041 0-0.084 0.003-0.125 0.006-1.978 0.247-3.997 0.203-5.684-0.128-0.294-0.056-0.597 0.019-0.828 0.209s-0.366 0.472-0.366 0.772v2.328h-1.653c-0.297-0.275-0.872-0.916-1.378-2.144-0.644-1.556-0.969-3.528-0.969-5.856 0-1.841 0.853-3.328 2.534-4.416 1.522-0.987 3.65-1.553 5.834-1.553 1.859 0 3.556 0.4 4.784 1.122s1.85 1.681 1.85 2.847c0 0.491 0.203 0.944 0.572 1.278 0.478 0.434 1.219 0.675 2.262 0.734 0.056 0.003 0.113 0.006 0.166 0.006v2.344z" }),
_('path', { d: "M10 9h4v1h-4v-1z" }),
_('path', { d: "M11.5 5c1.378 0 2.5-1.122 2.5-2.5s-1.122-2.5-2.5-2.5-2.5 1.122-2.5 2.5 1.122 2.5 2.5 2.5zM11.5 1c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5z" })
            );
        }
        function PiggyBank({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PiggyBankSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PiggyBank.SVG = PiggyBankSVG;
        return PiggyBank;
    })();
export const Pilcrow = /*#__PURE__*/ (() => {
    function PilcrowSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19 2v-1h-8c-1.603 0-3.109 0.625-4.244 1.756s-1.756 2.641-1.756 4.244 0.625 3.109 1.756 4.244 2.641 1.756 4.244 1.756h1v9h-2v1h9v-1h-2v-20h2zM11 11c-2.206 0-4-1.794-4-4s1.794-4 4-4h1v8h-1zM16 22h-2v-20h2v20z" })
        );
    }
    function Pilcrow({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PilcrowSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pilcrow.SVG = PilcrowSVG;
    return Pilcrow;
})();
export const Pills = /*#__PURE__*/ (() => {
        function PillsSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.5 13c-3.031 0-5.5 2.469-5.5 5.5s2.469 5.5 5.5 5.5 5.5-2.469 5.5-5.5-2.469-5.5-5.5-5.5zM18.5 15c0.784 0 1.509 0.259 2.094 0.697l-4.897 4.897c-0.438-0.584-0.697-1.309-0.697-2.094 0-1.931 1.569-3.5 3.5-3.5zM18.5 22c-0.784 0-1.509-0.259-2.094-0.697l4.897-4.897c0.438 0.584 0.697 1.309 0.697 2.094 0 1.931-1.569 3.5-3.5 3.5z" }),
_('path', { d: "M18.363 1.638c-2.181-2.181-5.731-2.181-7.912 0l-8.813 8.809c-2.181 2.181-2.181 5.731 0 7.913 1.091 1.091 2.525 1.638 3.956 1.638s2.866-0.547 3.956-1.638l8.809-8.809c2.184-2.181 2.184-5.728 0.003-7.912zM8.137 16.947c-0.7 0.7-1.622 1.050-2.544 1.050s-1.841-0.35-2.544-1.050c-1.403-1.403-1.403-3.681 0-5.084l4.053-4.050 5.084 5.084-4.050 4.050zM16.947 8.137l-4.050 4.050-5.084-5.084 4.050-4.050c0.7-0.7 1.622-1.050 2.544-1.050s1.841 0.35 2.544 1.050c1.4 1.403 1.4 3.681-0.003 5.084z" }),
_('path', { d: "M12.531 3.759l-2.738 2.741 0.706 0.706 2.741-2.741c0.312-0.312 0.775-0.488 1.237-0.466l0.5 0.022 0.044-1-0.5-0.022c-0.738-0.031-1.481 0.253-1.991 0.759z" })
            );
        }
        function Pills({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PillsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pills.SVG = PillsSVG;
        return Pills;
    })();
export const PingPong = /*#__PURE__*/ (() => {
        function PingPongSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 20.478c-0.006-0.141-0.072-0.272-0.178-0.363l-5.981-4.981c-0.612-0.65-0.841-1.366-0.841-2.634v-0.122c0.481-0.659 0.953-1.766 0.997-3.178 0.044-1.356-0.309-3.459-2.225-5.772-1.697-2.047-4.219-3.291-6.916-3.419-2.513-0.116-4.878 0.744-6.491 2.356s-2.472 3.978-2.356 6.491c0.125 2.7 1.372 5.219 3.419 6.919 2.194 1.819 4.2 2.228 5.559 2.228 0.072 0 0.144 0 0.213-0.003 1.413-0.044 2.519-0.516 3.178-0.997h0.122c1.269 0 1.984 0.228 2.634 0.841l4.981 5.978c0.091 0.109 0.222 0.172 0.363 0.178 0.006 0 0.016 0 0.022 0 0.131 0 0.259-0.053 0.353-0.147l3-3c0.1-0.1 0.153-0.234 0.147-0.375zM16.434 14.856l-1.578 1.578c-0.425-0.206-0.9-0.334-1.469-0.394l2.653-2.653c0.063 0.572 0.188 1.047 0.394 1.469zM9.138 15.997c-1.012 0.031-2.603-0.247-4.431-1.766-1.616-1.338-2.597-3.331-2.697-5.472-0.091-1.947 0.553-3.762 1.772-4.978 1.216-1.219 3.031-1.863 4.981-1.772 2.137 0.1 4.131 1.081 5.472 2.697 1.516 1.828 1.797 3.419 1.766 4.431-0.041 1.238-0.537 2.006-0.706 2.178l-3.981 3.975c-0.172 0.172-0.938 0.669-2.175 0.706zM20.534 22.759l-4.65-5.578c-0.012-0.016-0.025-0.028-0.037-0.041-0.047-0.047-0.097-0.091-0.144-0.134l1.303-1.303c0.044 0.050 0.087 0.097 0.134 0.144 0.012 0.012 0.025 0.025 0.041 0.037l5.578 4.65-2.225 2.225z" }),
_('path', { d: "M2.5 19c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.122-2.5-2.5-2.5zM2.5 23c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" })
            );
        }
        function PingPong({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PingPongSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PingPong.SVG = PingPongSVG;
        return PingPong;
    })();
export const Pitcher = /*#__PURE__*/ (() => {
        function PitcherSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.803 5.784c-0.275-0.969-0.772-1.828-1.434-2.484-0.678-0.672-1.506-1.103-2.388-1.253-0.847-0.144-1.688-0.022-2.472 0.341 0.112-0.306 0.247-0.628 0.403-0.972 0.141-0.309 0.116-0.669-0.069-0.956s-0.503-0.459-0.844-0.459h-10c-2.588 0-3.844 2.45-3.894 2.553-0.134 0.269-0.141 0.581-0.019 0.853s0.359 0.478 0.647 0.556c1.25 0.344 2.034 0.784 2.213 1.237 0.266 0.687-0.6 2.059-1.434 3.384-1.178 1.869-2.513 3.987-2.513 6.416 0 2.484 1.019 4.828 2.872 6.597 0.762 0.728 1.647 1.338 2.559 1.763 0.9 0.419 1.788 0.641 2.569 0.641h3.125c0.056 0 0.109-0.003 0.162-0.012 3.256-0.541 6.713-3.525 6.713-7.988 0-0.184-0.003-0.369-0.009-0.547 1.681-1.547 2.862-3.2 3.509-4.925 0.616-1.634 0.719-3.275 0.303-4.744zM6.813 4.478c-0.319-0.825-1.013-1.463-2.147-1.959 0.341-0.281 0.791-0.519 1.334-0.519h8.525c-1.125 3.35-0.188 5.331 0.8 7.416 0.825 1.737 1.675 3.534 1.675 6.584 0 0.222-0.012 0.441-0.034 0.653-0.888 0.422-1.812 0.456-2.859 0.119-1.25-0.406-2.544-1.306-3.794-2.178-1.309-0.912-2.666-1.859-4.056-2.309-0.863-0.281-1.678-0.35-2.456-0.206 0.409-0.837 0.922-1.653 1.406-2.419 1.147-1.831 2.234-3.553 1.606-5.181zM12.041 22h-3.041c-0.903 0-2.412-0.572-3.747-1.847-1.028-0.984-2.253-2.675-2.253-5.153 0-0.584 0.116-1.169 0.309-1.75 0.819-0.328 1.678-0.331 2.637-0.022 1.25 0.406 2.544 1.306 3.794 2.178 1.309 0.912 2.666 1.859 4.056 2.309 0.575 0.188 1.125 0.278 1.659 0.278 0.434 0 0.859-0.063 1.275-0.188-0.716 2.322-2.744 3.841-4.691 4.194zM18.7 12.9c-0.369-1.812-1.012-3.169-1.566-4.338s-1.013-2.134-1.106-3.262c0.781-0.981 1.7-1.431 2.619-1.278 1.006 0.172 1.884 1.078 2.234 2.313 0.563 1.994-0.244 4.366-2.181 6.566z" }),
_('path', { d: "M13.531 10.169c0.653 1.244 1.331 2.531 1.472 4.863l0.997-0.063c-0.153-2.547-0.912-3.991-1.584-5.269l-0.050-0.094c-0.681-1.297-1.212-2.388-1.369-3.669l-0.994 0.122c0.178 1.447 0.775 2.675 1.478 4.013l0.050 0.097z" })
            );
        }
        function Pitcher({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PitcherSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pitcher.SVG = PitcherSVG;
        return Pitcher;
    })();
export const Pizza = /*#__PURE__*/ (() => {
        function PizzaSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 12c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12 15c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M18 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M23.706 0.294c-0.294-0.294-0.738-0.375-1.116-0.206l-21.231 9.522c-0.531 0.237-0.95 0.666-1.178 1.206-0.225 0.537-0.241 1.134-0.041 1.684 0.941 2.584 2.472 4.984 4.425 6.938s4.353 3.484 6.938 4.425c0.256 0.094 0.522 0.141 0.787 0.141 0.303 0 0.609-0.059 0.894-0.181 0.537-0.228 0.966-0.644 1.206-1.178l9.522-21.234c0.169-0.378 0.087-0.822-0.206-1.116zM14 7.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.006 0-0.016 0-0.022l2.481-1.113c0.319 0.278 0.519 0.687 0.519 1.134zM12.566 21.822c-0.066 0.144-0.231 0.213-0.378 0.159-4.737-1.725-8.444-5.431-10.169-10.169-0.053-0.147 0.016-0.316 0.159-0.378l2.619-1.175 0.141 0.328c0.106 0.387 0.084 0.853 0.059 1.344-0.034 0.694-0.072 1.413 0.272 2.022 0.378 0.672 1.084 1.034 1.709 1.353 0.413 0.209 0.8 0.409 1.053 0.666 0.256 0.256 0.453 0.644 0.666 1.053 0.319 0.625 0.681 1.331 1.353 1.709 0.606 0.341 1.325 0.306 2.016 0.269 0.5-0.025 0.972-0.050 1.366 0.066l0.322 0.109-1.188 2.644zM14.163 18.259l-0.422-0.144c-0.006-0.003-0.012-0.003-0.019-0.006-0.559-0.166-1.144-0.134-1.709-0.106-0.575 0.028-1.122 0.056-1.475-0.144-0.409-0.231-0.675-0.747-0.953-1.294-0.237-0.462-0.481-0.941-0.847-1.306s-0.844-0.609-1.306-0.847c-0.547-0.281-1.062-0.544-1.294-0.956-0.203-0.356-0.175-0.903-0.144-1.478 0.028-0.563 0.059-1.147-0.106-1.703-0.006-0.019-0.012-0.038-0.022-0.056l-0.159-0.369 4.325-1.941c0.2 1.184 1.231 2.091 2.469 2.091 1.378 0 2.5-1.122 2.5-2.5 0-0.588-0.206-1.134-0.553-1.569l6.566-2.944-6.85 15.272z" })
            );
        }
        function Pizza({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PizzaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pizza.SVG = PizzaSVG;
        return Pizza;
    })();
export const Planet = /*#__PURE__*/ (() => {
    function PlanetSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.85 4.744c-0.353-0.653-1.222-0.878-2.581-0.669-0.938 0.144-2.128 0.497-3.481 1.028-1.622-1.359-3.647-2.103-5.787-2.103-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363c0 0.719 0.084 1.422 0.247 2.103-1.044 0.944-1.869 1.825-2.416 2.581-0.797 1.103-1.019 1.944-0.681 2.572 0.119 0.222 0.375 0.516 0.903 0.656 0.225 0.059 0.484 0.087 0.766 0.087 1.259 0 2.972-0.55 4.3-1.062 0.034-0.012 0.066-0.025 0.1-0.037 1.616 1.356 3.641 2.1 5.781 2.1 2.403 0 4.666-0.938 6.363-2.637 1.7-1.697 2.637-3.959 2.637-6.363 0-0.719-0.084-1.422-0.247-2.103 0.234-0.213 0.459-0.422 0.675-0.631 0.947-0.916 1.644-1.741 2.069-2.444 0.519-0.853 0.634-1.553 0.353-2.078zM12 5c3.263 0 6.009 2.244 6.784 5.269-1.603 1.309-3.528 2.666-5.613 3.947-2.103 1.294-4.047 2.316-5.744 3.081-1.488-1.284-2.428-3.184-2.428-5.297 0-3.859 3.141-7 7-7zM1.313 18.944c-0.103-0.028-0.234-0.078-0.281-0.166-0.094-0.175 0.009-0.675 0.609-1.506 0.447-0.616 1.103-1.334 1.928-2.106 0.409 1.088 1.028 2.094 1.841 2.966-1.969 0.731-3.413 0.997-4.097 0.813zM19 12c0 3.859-3.141 7-7 7-1.334 0-2.584-0.375-3.647-1.028 1.694-0.794 3.506-1.778 5.341-2.906 1.931-1.188 3.734-2.444 5.281-3.669 0.016 0.2 0.025 0.4 0.025 0.603zM20.731 8.547c-0.1 0.097-0.2 0.191-0.303 0.288-0.409-1.091-1.028-2.094-1.844-2.966 1.1-0.409 2.066-0.684 2.831-0.803 1-0.153 1.459-0.012 1.55 0.156 0.147 0.262-0.138 1.297-2.234 3.325z" })
        );
    }
    function Planet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PlanetSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Planet.SVG = PlanetSVG;
    return Planet;
})();
export const Platter = /*#__PURE__*/ (() => {
        function PlatterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 18v-2c0-1.484-0.291-2.925-0.866-4.281-0.553-1.309-1.347-2.487-2.356-3.497s-2.187-1.803-3.497-2.356c-0.847-0.359-1.725-0.606-2.628-0.741 0.219-0.322 0.347-0.706 0.347-1.122 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 0.416 0.128 0.803 0.347 1.122-0.903 0.134-1.781 0.384-2.628 0.741-1.309 0.553-2.487 1.347-3.497 2.356s-1.803 2.187-2.356 3.497c-0.575 1.356-0.866 2.797-0.866 4.281v2h-1v2h1c0 1.103 0.897 2 2 2h18c1.103 0 2-0.897 2-2h1v-2h-1zM11 4c0-0.55 0.45-1 1-1s1 0.45 1 1-0.45 1-1 1c-0.55 0-1-0.45-1-1zM3 16c0-4.962 4.038-9 9-9s9 4.038 9 9v2h-18v-2zM21 21h-18c-0.55 0-1-0.45-1-1h20c0 0.55-0.45 1-1 1z" }),
_('path', { d: "M12 8v1c3.859 0 7 3.141 7 7h1c0-4.413-3.588-8-8-8z" })
            );
        }
        function Platter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PlatterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Platter.SVG = PlatterSVG;
        return Platter;
    })();
export const PlayCircle = /*#__PURE__*/ (() => {
        function PlayCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M15.753 11.569l-6-3.5c-0.153-0.091-0.347-0.091-0.5-0.003-0.156 0.091-0.25 0.253-0.25 0.434v7c0 0.178 0.097 0.344 0.25 0.434 0.078 0.044 0.162 0.066 0.25 0.066s0.175-0.022 0.253-0.069l6-3.5c0.153-0.091 0.247-0.253 0.247-0.431s-0.097-0.344-0.25-0.431zM10 14.628v-5.256l4.506 2.628-4.506 2.628z" })
            );
        }
        function PlayCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PlayCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PlayCircle.SVG = PlayCircleSVG;
        return PlayCircle;
    })();
export const PlaySquare = /*#__PURE__*/ (() => {
        function PlaySquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M9.25 15.934c0.078 0.044 0.162 0.066 0.25 0.066s0.175-0.022 0.253-0.069l6-3.5c0.153-0.091 0.247-0.253 0.247-0.431s-0.094-0.344-0.247-0.431l-6-3.5c-0.153-0.091-0.347-0.091-0.5-0.003-0.156 0.091-0.25 0.253-0.25 0.434v7c-0.003 0.178 0.094 0.344 0.247 0.434zM10 9.372l4.506 2.628-4.506 2.628v-5.256z" })
            );
        }
        function PlaySquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PlaySquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PlaySquare.SVG = PlaySquareSVG;
        return PlaySquare;
    })();
export const Play = /*#__PURE__*/ (() => {
    function PlaySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.516 11.144l-15-9c-0.309-0.184-0.694-0.191-1.006-0.012-0.316 0.175-0.509 0.509-0.509 0.869v18c0 0.359 0.194 0.694 0.506 0.869 0.153 0.087 0.322 0.131 0.494 0.131 0.178 0 0.356-0.047 0.516-0.144l15-9c0.3-0.181 0.484-0.506 0.484-0.856s-0.184-0.678-0.484-0.856zM6 19.234v-14.469l12.056 7.234-12.056 7.234z" })
        );
    }
    function Play({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PlaySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Play.SVG = PlaySVG;
    return Play;
})();
export const Playlist = /*#__PURE__*/ (() => {
        function PlaylistSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3 4c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM3 5c0 0 0 0 0 0v0z" }),
_('path', { d: "M3 9c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM3 10c0 0 0 0 0 0v0z" }),
_('path', { d: "M3 14c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM3 15c0 0 0 0 0 0v0z" }),
_('path', { d: "M6 4h16v2h-16v-2z" }),
_('path', { d: "M6 9h16v2h-16v-2z" }),
_('path', { d: "M6 14h6v2h-6v-2z" }),
_('path', { d: "M21 14.5c0-0.228-0.156-0.428-0.378-0.484l-4-1c-0.15-0.037-0.306-0.003-0.428 0.091s-0.194 0.241-0.194 0.394v2.544c-0.216-0.056-0.447-0.066-0.678-0.019-0.8 0.162-1.378 0.919-1.313 1.719 0.031 0.4 0.222 0.747 0.531 0.978 0.237 0.178 0.531 0.272 0.837 0.272 0.1 0 0.203-0.009 0.303-0.031 0.769-0.156 1.331-0.856 1.319-1.619v-3.203l3 0.75v2.153c-0.216-0.056-0.447-0.066-0.678-0.019-0.8 0.162-1.378 0.919-1.313 1.719 0.031 0.4 0.222 0.747 0.531 0.978 0.237 0.178 0.531 0.272 0.837 0.272 0.1 0 0.203-0.009 0.303-0.031 0.769-0.156 1.331-0.856 1.319-1.619v-3.844zM15.481 17.984c-0.131 0.028-0.253 0.006-0.341-0.063-0.078-0.059-0.125-0.15-0.134-0.259-0.022-0.288 0.219-0.597 0.519-0.656 0.038-0.006 0.072-0.012 0.106-0.012 0.091 0 0.172 0.025 0.234 0.072 0.078 0.059 0.125 0.15 0.134 0.259 0 0.009 0 0.022 0 0.031v0.012c-0.003 0.278-0.234 0.559-0.519 0.616zM19.481 18.984c-0.131 0.028-0.253 0.006-0.341-0.063-0.078-0.059-0.125-0.15-0.134-0.259-0.022-0.288 0.219-0.597 0.519-0.656 0.037-0.006 0.072-0.012 0.106-0.012 0.091 0 0.172 0.025 0.234 0.072 0.078 0.059 0.125 0.15 0.134 0.259 0 0.009 0 0.022 0 0.031v0.012c-0.003 0.278-0.234 0.559-0.519 0.616z" })
            );
        }
        function Playlist({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PlaylistSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Playlist.SVG = PlaylistSVG;
        return Playlist;
    })();
export const Playlist2 = /*#__PURE__*/ (() => {
        function Playlist2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 5c0-1.103-0.897-2-2-2 0-1.103-0.897-2-2-2h-8c-1.103 0-2 0.897-2 2-1.103 0-2 0.897-2 2-1.103 0-2 0.897-2 2v14c0 1.103 0.897 2 2 2h16c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM8 2h8c0.55 0 1 0.45 1 1h-10c0-0.55 0.45-1 1-1zM6 4h12c0.55 0 1 0.45 1 1h-14c0-0.55 0.45-1 1-1zM20 21h-16v-14h16v14c0.003 0 0 0 0 0z" }),
_('path', { d: "M15.753 13.569l-6-3.5c-0.153-0.091-0.347-0.091-0.5-0.003-0.156 0.091-0.25 0.253-0.25 0.434v7c0 0.178 0.097 0.344 0.25 0.434 0.078 0.044 0.162 0.066 0.25 0.066s0.175-0.022 0.253-0.069l6-3.5c0.153-0.091 0.247-0.253 0.247-0.431s-0.097-0.344-0.25-0.431zM10 16.628v-5.256l4.506 2.628-4.506 2.628z" })
            );
        }
        function Playlist2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Playlist2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Playlist2.SVG = Playlist2SVG;
        return Playlist2;
    })();
export const Pleased = /*#__PURE__*/ (() => {
        function PleasedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M11.206 8.5l-2.353-2.353c-0.194-0.194-0.513-0.194-0.706 0l-2.353 2.353 0.706 0.706 2-2 2 2 0.706-0.706z" }),
_('path', { d: "M15.147 6.147l-2.353 2.353 0.706 0.706 2-2 2 2 0.706-0.706-2.353-2.353c-0.194-0.197-0.513-0.197-0.706 0z" }),
_('path', { d: "M12 17c-1.103 0-2-0.897-2-2h-1c0 1.653 1.347 3 3 3s3-1.347 3-3h-1c0 1.103-0.897 2-2 2z" })
            );
        }
        function Pleased({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PleasedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pleased.SVG = PleasedSVG;
        return Pleased;
    })();
export const Plotter = /*#__PURE__*/ (() => {
        function PlotterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21 1h-18c-1.653 0-3 1.347-3 3v4c0 0.553 0.447 1 1 1h1v13h-1v1h4v-1h-1v-13h2v10.5c0 0.275 0.225 0.5 0.5 0.5h11c0.275 0 0.5-0.225 0.5-0.5v-10.5h2v13h-1v1h4v-1h-1v-13h1c0.553 0 1-0.447 1-1v-4c0-1.653-1.347-3-3-3zM17 19h-10v-13h5.172l4.828 4.828v4.584l-2.709-2.709c-0.387-0.387-0.387-1.025 0-1.416l0.916-0.916-0.706-0.703-0.916 0.916c-0.778 0.781-0.778 2.050 0 2.828l3.416 3.416v2.172zM13.584 6h3.416v3.416l-3.416-3.416zM22 7h-4v-1h1v-1h-14v1h1v1h-4v-3c0-0.55 0.45-1 1-1h18c0.55 0 1 0.45 1 1v3z" }),
_('path', { d: "M20 4h1v1h-1v-1z" }),
_('path', { d: "M10 13c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM10 16c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
            );
        }
        function Plotter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PlotterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Plotter.SVG = PlotterSVG;
        return Plotter;
    })();
export const PlugCross = /*#__PURE__*/ (() => {
        function PlugCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16.981 10.709c-0.072 0.109-0.138 0.219-0.203 0.331-3.244 0.359-5.778 3.119-5.778 6.459 0 1.709 0.666 3.269 1.747 4.431-0.244 0.047-0.494 0.069-0.747 0.069-2.206 0-4-1.794-4-4v-3h0.5c0.275 0 0.5-0.225 0.5-0.5v-1.919c1.766-0.772 3-2.538 3-4.581v-2h2v-2h-3v-4h-2v4h-4v-4h-2v4h-3v2h2v2c0 2.047 1.234 3.809 3 4.581v1.919c0 0.275 0.225 0.5 0.5 0.5h0.5v3c0 1.603 0.625 3.109 1.756 4.244s2.641 1.756 4.244 1.756c0.947 0 1.853-0.216 2.694-0.638 0.85 0.409 1.803 0.638 2.806 0.638 3.584 0 6.5-2.916 6.5-6.5 0-3.019-2.069-5.566-4.866-6.291 0.747-0.769 1.772-1.209 2.866-1.209h2v-2h-2c-2.028 0-3.903 1.013-5.019 2.709zM4 8v-2h6v2c0 1.653-1.347 3-3 3s-3-1.347-3-3zM7 13c0.344 0 0.678-0.034 1-0.1v1.1h-2v-1.1c0.322 0.066 0.656 0.1 1 0.1zM23 17.5c0 3.031-2.469 5.5-5.5 5.5s-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5z" }),
_('path', { d: "M15.5 14.794l-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2-0.706-0.706-2 2z" })
            );
        }
        function PlugCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PlugCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PlugCross.SVG = PlugCrossSVG;
        return PlugCross;
    })();
export const Plug = /*#__PURE__*/ (() => {
    function PlugSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 4h3v-4h2v4h4v-4h2v4h3v2h-2v2c0 2.047-1.234 3.809-3 4.581v1.919c0 0.275-0.225 0.5-0.5 0.5h-0.5v3c0 2.206 1.794 4 4 4s4-1.794 4-4v-4c0-3.309 2.691-6 6-6h2v2h-2c-2.206 0-4 1.794-4 4v4c0 3.309-2.691 6-6 6s-6-2.691-6-6v-3h-0.5c-0.275 0-0.5-0.225-0.5-0.5v-1.919c-1.766-0.772-3-2.538-3-4.581v-2h-2v-2zM6 14h2v-1.1c-0.322 0.066-0.656 0.1-1 0.1s-0.678-0.034-1-0.1v1.1zM4 8c0 1.653 1.347 3 3 3s3-1.347 3-3v-2h-6v2z" })
        );
    }
    function Plug({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PlugSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Plug.SVG = PlugSVG;
    return Plug;
})();
export const Plunger = /*#__PURE__*/ (() => {
    function PlungerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16.981 21.012c-0.162-2.041-1.344-3.762-2.981-4.553v-0.459c0-0.738-0.403-1.384-1-1.731v-14.269h-2v14.269c-0.597 0.347-1 0.994-1 1.731v0.459c-1.634 0.788-2.816 2.512-2.981 4.553-1.131 0.122-2.019 1.191-2.019 2.487 0 0.275 0.225 0.5 0.5 0.5h13c0.275 0 0.5-0.225 0.5-0.5 0-1.297-0.888-2.369-2.019-2.487zM11 16c0-0.55 0.45-1 1-1s1 0.45 1 1v0.109c-0.322-0.072-0.656-0.109-1-0.109s-0.678 0.038-1 0.109v-0.109zM12 17c2.056 0 3.753 1.753 3.975 4h-7.95c0.222-2.247 1.919-4 3.975-4zM6.072 23c0.169-0.581 0.628-1 1.163-1h9.534c0.537 0 0.994 0.419 1.163 1h-11.859z" })
        );
    }
    function Plunger({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PlungerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Plunger.SVG = PlungerSVG;
    return Plunger;
})();
export const PlusCircle = /*#__PURE__*/ (() => {
        function PlusCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M13 8h-2v3h-3v2h3v3h2v-3h3v-2h-3z" })
            );
        }
        function PlusCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PlusCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PlusCircle.SVG = PlusCircleSVG;
        return PlusCircle;
    })();
export const PlusMinusCircle = /*#__PURE__*/ (() => {
        function PlusMinusCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M13 6h-2v3h-3v2h3v3h2v-3h3v-2h-3z" }),
_('path', { d: "M8 15h8v2h-8v-2z" })
            );
        }
        function PlusMinusCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PlusMinusCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PlusMinusCircle.SVG = PlusMinusCircleSVG;
        return PlusMinusCircle;
    })();
export const PlusMinusSquare = /*#__PURE__*/ (() => {
        function PlusMinusSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M11 14h2v-3h3v-2h-3v-3h-2v3h-3v2h3z" }),
_('path', { d: "M8 15h8v2h-8v-2z" })
            );
        }
        function PlusMinusSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PlusMinusSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PlusMinusSquare.SVG = PlusMinusSquareSVG;
        return PlusMinusSquare;
    })();
export const PlusMinus = /*#__PURE__*/ (() => {
        function PlusMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 9v-8h-2v8h-9v2h9v8h2v-8h9v-2z" }),
_('path', { d: "M2 21h20v2h-20v-2z" })
            );
        }
        function PlusMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PlusMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PlusMinus.SVG = PlusMinusSVG;
        return PlusMinus;
    })();
export const PlusSquare = /*#__PURE__*/ (() => {
        function PlusSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M11 16h2v-3h3v-2h-3v-3h-2v3h-3v2h3z" })
            );
        }
        function PlusSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PlusSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PlusSquare.SVG = PlusSquareSVG;
        return PlusSquare;
    })();
export const Plus = /*#__PURE__*/ (() => {
    function PlusSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 11h-9v-9h-2v9h-9v2h9v9h2v-9h9z" })
        );
    }
    function Plus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Plus.SVG = PlusSVG;
    return Plus;
})();
export const PocketKnife = /*#__PURE__*/ (() => {
        function PocketKnifeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.234 11.528l-9.381-9.381c-0.1-0.1-0.237-0.153-0.378-0.147s-0.272 0.072-0.363 0.181c-1.25 1.512-1.459 3.334-0.6 5.266 0.619 1.391 1.572 2.347 1.634 2.406l2.903 2.903c-0.759 0.147-1.744 0.244-3.050 0.244-3.45 0-4.281-0.675-4.887-1.169-0.459-0.372-1.025-0.831-2.112-0.831-0.55 0-1-0.45-1-1s0.45-1 1-1v-1c-0.55 0-1-0.45-1-1s0.45-1 1-1v-1c-0.55 0-1-0.45-1-1s0.45-1 1-1v-1c-1.103 0-2 0.897-2 2 0 0.597 0.262 1.134 0.678 1.5-0.416 0.366-0.678 0.903-0.678 1.5s0.262 1.134 0.678 1.5c-0.416 0.366-0.678 0.903-0.678 1.5 0 0.472 0.166 0.906 0.441 1.25-1.997 0.656-3.441 2.538-3.441 4.75 0 2.756 2.244 5 5 5h14c2.756 0 5-2.244 5-5 0-1.953-1.128-3.65-2.766-4.472zM12.853 9.147c0 0 0-0.003 0 0-0.012-0.012-0.878-0.872-1.425-2.106-0.619-1.394-0.575-2.662 0.131-3.775l7.744 7.744c-0.1-0.006-0.2-0.009-0.303-0.009-0.647 0-1.075 0.35-1.422 0.631-0.294 0.241-0.681 0.556-1.416 0.825l-3.309-3.309zM19 19h-14c-1.653 0-3-1.347-3-3s1.347-3 3-3c0.378 0 0.478 0.081 0.85 0.384 0.394 0.319 0.931 0.756 1.916 1.087 1.053 0.356 2.438 0.528 4.234 0.528 1.988 0 3.544-0.206 4.766-0.634 1.097-0.384 1.688-0.866 2.078-1.184 0.078-0.063 0.172-0.141 0.228-0.181 1.619 0.041 2.925 1.369 2.925 3 0.003 1.653-1.344 3-2.997 3z" }),
_('path', { d: "M19 15c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM19 16c0 0 0 0 0 0v0z" }),
_('path', { d: "M5 15c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM5 16c0 0 0 0 0 0v0z" })
            );
        }
        function PocketKnife({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PocketKnifeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PocketKnife.SVG = PocketKnifeSVG;
        return PocketKnife;
    })();
export const Podium = /*#__PURE__*/ (() => {
        function PodiumSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 9h-5v-5c0-1.103-0.897-2-2-2h-6c-1.103 0-2 0.897-2 2v2h-5c-1.103 0-2 0.897-2 2v13c0 0.553 0.447 1 1 1h22c0.553 0 1-0.447 1-1v-10c0-1.103-0.897-2-2-2zM15 4v16h-6v-16h6zM2 8h5v12h-5v-12zM22 20h-5v-9h5v9z" }),
_('path', { d: "M4.703 12.619c0.547-0.412 1.297-0.975 1.297-2.119 0-0.45-0.172-0.85-0.481-1.125-0.272-0.244-0.634-0.378-1.019-0.378s-0.747 0.134-1.019 0.378c-0.309 0.275-0.481 0.675-0.481 1.125v0.5h1v-0.5c0-0.478 0.416-0.5 0.5-0.5 0.138 0 0.266 0.044 0.356 0.125 0.097 0.084 0.144 0.213 0.144 0.378 0 0.612-0.341 0.9-0.897 1.319-0.491 0.366-1.103 0.822-1.103 1.678 0 0.275 0.225 0.5 0.5 0.5h2.5v-1h-1.766c0.116-0.116 0.272-0.234 0.469-0.381z" }),
_('path', { d: "M19.5 16h-1.5v1h1.5c0.828 0 1.5-0.672 1.5-1.5 0-0.672-0.444-1.241-1.050-1.431l0.95-1.269c0.113-0.15 0.131-0.353 0.047-0.525-0.084-0.169-0.259-0.275-0.447-0.275h-2.5v1h1.5l-0.9 1.2c-0.112 0.15-0.131 0.353-0.047 0.525 0.084 0.169 0.259 0.275 0.447 0.275h0.5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M12 6.706v3.294h1v-4.5c0-0.203-0.122-0.384-0.309-0.462s-0.403-0.034-0.544 0.109l-1.353 1.353 0.706 0.706 0.5-0.5z" })
            );
        }
        function Podium({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PodiumSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Podium.SVG = PodiumSVG;
        return Podium;
    })();
export const PointerDown = /*#__PURE__*/ (() => {
    function PointerDownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5.5 15c0.087 0 0.172-0.003 0.256-0.009 0.55 0.619 1.353 1.009 2.244 1.009 0.237 0 0.469-0.028 0.697-0.081 0.55 0.659 1.378 1.081 2.303 1.081v2c0 1.653 1.347 3 3 3s3-1.347 3-3v-7.15l1.128 0.738c0.406 0.266 0.881 0.409 1.372 0.409 1.378 0 2.5-1.119 2.5-2.497 0-0.541-0.172-1.059-0.497-1.497 0-0.003-0.003-0.003-0.003-0.006l-4.525-6.034c-0.922-1.228-2.394-1.962-3.934-1.962h-4.887c-1.85 0-3.525 1.019-4.372 2.656v0.003c-1.166 2.262-1.781 4.803-1.781 7.341v0.5c0 1.931 1.569 3.5 3.5 3.5zM8.5 13.866c-0.15 0.087-0.322 0.134-0.5 0.134-0.55 0-1-0.45-1-1v-2h-1v1.916c-0.159 0.056-0.328 0.084-0.5 0.084-0.828 0-1.5-0.672-1.5-1.5v-0.5c0-2.222 0.537-4.444 1.556-6.425 0.503-0.972 1.497-1.575 2.597-1.575h4.887c0.916 0 1.788 0.434 2.334 1.162l4.522 6.031c0.047 0.063 0.103 0.169 0.103 0.306 0 0.275-0.225 0.497-0.5 0.497-0.1 0-0.194-0.028-0.275-0.081l-2.678-1.753c-0.306-0.2-0.7-0.219-1.022-0.044s-0.525 0.513-0.525 0.881v9c0 0.55-0.45 1-1 1s-1-0.45-1-1v-7h-1v2c0 0.175-0.047 0.347-0.134 0.5s-0.216 0.278-0.366 0.366c-0.15 0.087-0.322 0.134-0.5 0.134-0.55 0-1-0.45-1-1v-2h-1v1c0 0.175-0.047 0.347-0.134 0.5s-0.213 0.278-0.366 0.366z" })
        );
    }
    function PointerDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PointerDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PointerDown.SVG = PointerDownSVG;
    return PointerDown;
})();
export const PointerLeft = /*#__PURE__*/ (() => {
    function PointerLeftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 5.5c0 0.087 0.003 0.172 0.009 0.256-0.619 0.55-1.009 1.353-1.009 2.244 0 0.237 0.028 0.469 0.081 0.697-0.659 0.55-1.081 1.378-1.081 2.303h-2c-1.653 0-3 1.347-3 3s1.347 3 3 3h7.15l-0.738 1.128c-0.266 0.406-0.409 0.881-0.409 1.372 0 1.378 1.119 2.5 2.497 2.5 0.541 0 1.059-0.172 1.497-0.497 0.003 0 0.003-0.003 0.006-0.003l6.034-4.525c1.228-0.922 1.962-2.394 1.962-3.934v-4.887c0-1.85-1.019-3.525-2.656-4.372h-0.003c-2.262-1.166-4.803-1.781-7.341-1.781h-0.5c-1.931 0-3.5 1.569-3.5 3.5zM10.134 8.5c-0.087-0.15-0.134-0.322-0.134-0.5 0-0.55 0.45-1 1-1h2v-1h-1.916c-0.056-0.159-0.084-0.328-0.084-0.5 0-0.828 0.672-1.5 1.5-1.5h0.5c2.222 0 4.444 0.537 6.425 1.556 0.972 0.503 1.575 1.497 1.575 2.597v4.887c0 0.916-0.434 1.788-1.162 2.334l-6.031 4.522c-0.063 0.047-0.169 0.103-0.306 0.103-0.275 0-0.497-0.225-0.497-0.5 0-0.1 0.028-0.194 0.081-0.275l1.753-2.678c0.2-0.306 0.219-0.7 0.044-1.022s-0.513-0.525-0.881-0.525h-9c-0.55 0-1-0.45-1-1s0.45-1 1-1h7v-1h-2c-0.175 0-0.347-0.047-0.5-0.134s-0.278-0.216-0.366-0.366c-0.087-0.15-0.134-0.322-0.134-0.5 0-0.55 0.45-1 1-1h2v-1h-1c-0.175 0-0.347-0.047-0.5-0.134s-0.278-0.213-0.366-0.366z" })
        );
    }
    function PointerLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PointerLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PointerLeft.SVG = PointerLeftSVG;
    return PointerLeft;
})();
export const PointerRight = /*#__PURE__*/ (() => {
    function PointerRightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 18.5c0-0.087-0.003-0.172-0.009-0.256 0.619-0.55 1.009-1.353 1.009-2.244 0-0.237-0.028-0.469-0.081-0.697 0.659-0.55 1.081-1.378 1.081-2.303h2c1.653 0 3-1.347 3-3s-1.347-3-3-3h-7.15l0.738-1.128c0.266-0.406 0.409-0.881 0.409-1.372 0-1.378-1.119-2.5-2.497-2.5-0.541 0-1.059 0.172-1.497 0.497-0.003 0-0.003 0.003-0.006 0.003l-6.034 4.525c-1.228 0.922-1.962 2.394-1.962 3.934v4.887c0 1.85 1.019 3.525 2.656 4.372h0.003c2.262 1.166 4.803 1.781 7.341 1.781h0.5c1.931 0 3.5-1.569 3.5-3.5zM13.866 15.5c0.087 0.15 0.134 0.322 0.134 0.5 0 0.55-0.45 1-1 1h-2v1h1.916c0.056 0.159 0.084 0.328 0.084 0.5 0 0.828-0.672 1.5-1.5 1.5h-0.5c-2.222 0-4.444-0.537-6.425-1.556-0.972-0.503-1.575-1.497-1.575-2.597v-4.887c0-0.916 0.434-1.788 1.162-2.334l6.031-4.522c0.063-0.047 0.169-0.103 0.306-0.103 0.275 0 0.497 0.225 0.497 0.5 0 0.1-0.028 0.194-0.081 0.275l-1.753 2.678c-0.2 0.306-0.219 0.7-0.044 1.022s0.513 0.525 0.881 0.525h9c0.55 0 1 0.45 1 1s-0.45 1-1 1h-7v1h2c0.175 0 0.347 0.047 0.5 0.134s0.278 0.216 0.366 0.366c0.087 0.15 0.134 0.322 0.134 0.5 0 0.55-0.45 1-1 1h-2v1h1c0.175 0 0.347 0.047 0.5 0.134s0.278 0.213 0.366 0.366z" })
        );
    }
    function PointerRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PointerRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PointerRight.SVG = PointerRightSVG;
    return PointerRight;
})();
export const PointerUp = /*#__PURE__*/ (() => {
    function PointerUpSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18.5 9c-0.087 0-0.172 0.003-0.256 0.009-0.55-0.619-1.353-1.009-2.244-1.009-0.237 0-0.469 0.028-0.697 0.081-0.55-0.659-1.378-1.081-2.303-1.081v-2c0-1.653-1.347-3-3-3s-3 1.347-3 3v7.15l-1.128-0.738c-0.406-0.266-0.881-0.409-1.372-0.409-1.378 0-2.5 1.119-2.5 2.497 0 0.541 0.172 1.059 0.497 1.497 0 0.003 0.003 0.003 0.003 0.006l4.525 6.034c0.922 1.228 2.394 1.962 3.934 1.962h4.887c1.85 0 3.525-1.019 4.372-2.656 0 0 0-0.003 0-0.003 1.166-2.262 1.781-4.803 1.781-7.341v-0.5c0-1.931-1.569-3.5-3.5-3.5zM15.5 10.134c0.15-0.087 0.322-0.134 0.5-0.134 0.55 0 1 0.45 1 1v2h1v-1.916c0.159-0.056 0.328-0.084 0.5-0.084 0.828 0 1.5 0.672 1.5 1.5v0.5c0 2.222-0.537 4.444-1.556 6.425-0.503 0.972-1.497 1.575-2.597 1.575h-4.887c-0.916 0-1.788-0.434-2.334-1.162l-4.522-6.031c-0.047-0.063-0.103-0.169-0.103-0.306 0-0.275 0.225-0.497 0.5-0.497 0.1 0 0.194 0.028 0.275 0.081l2.678 1.753c0.306 0.2 0.7 0.219 1.022 0.044s0.525-0.513 0.525-0.881v-9c0-0.55 0.45-1 1-1s1 0.45 1 1v7h1v-2c0-0.175 0.047-0.347 0.134-0.5s0.216-0.278 0.366-0.366c0.15-0.087 0.322-0.134 0.5-0.134 0.55 0 1 0.45 1 1v2h1v-1c0-0.175 0.047-0.347 0.134-0.5s0.213-0.278 0.366-0.366z" })
        );
    }
    function PointerUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PointerUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PointerUp.SVG = PointerUpSVG;
    return PointerUp;
})();
export const Pointer = /*#__PURE__*/ (() => {
    function PointerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19.706 13.294l-12-12c-0.288-0.288-0.716-0.372-1.091-0.216s-0.619 0.519-0.619 0.925v17c0 0.403 0.244 0.769 0.619 0.925s0.803 0.069 1.091-0.216l2.956-2.956 2.419 5.644c0.109 0.253 0.316 0.45 0.575 0.544 0.112 0.041 0.228 0.059 0.344 0.059 0.153 0 0.306-0.034 0.447-0.106l2.991-1.5c0.481-0.241 0.684-0.822 0.459-1.313l-2.337-5.084h3.441c0.403 0 0.769-0.244 0.925-0.619 0.153-0.372 0.069-0.803-0.219-1.087zM14 13c-0.341 0-0.659 0.175-0.841 0.459-0.184 0.288-0.209 0.647-0.066 0.956l2.588 5.622-1.181 0.594-2.581-6.025c-0.131-0.306-0.403-0.525-0.731-0.588-0.063-0.012-0.125-0.019-0.191-0.019-0.262 0-0.519 0.103-0.706 0.294l-2.291 2.291v-12.169l8.584 8.584h-2.584z" })
        );
    }
    function Pointer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PointerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pointer.SVG = PointerSVG;
    return Pointer;
})();
export const PokerFace = /*#__PURE__*/ (() => {
        function PokerFaceSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M8.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM8.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M15.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM15.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M4 11h16v1h-16v-1z" })
            );
        }
        function PokerFace({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PokerFaceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PokerFace.SVG = PokerFaceSVG;
        return PokerFace;
    })();
export const Police = /*#__PURE__*/ (() => {
        function PoliceSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 9h-1.25c-0.322 0-0.653 0.197-0.809 0.475l-0.422 0.756c-0.106-0.275-0.203-0.578-0.303-0.9-0.206-0.663-0.444-1.416-0.862-2.103-0.594-0.975-1.803-1.612-3.691-1.953-0.513-0.091-1.062-0.159-1.662-0.206v-2.069c0-1.103-0.897-2-2-2s-2 0.897-2 2v2.069c-0.6 0.047-1.15 0.116-1.662 0.206-1.887 0.341-3.094 0.978-3.691 1.95-0.422 0.687-0.656 1.441-0.866 2.103-0.1 0.322-0.197 0.625-0.303 0.9l-0.422-0.756c0 0 0-0.003-0.003-0.003-0.156-0.278-0.491-0.472-0.806-0.472h-1.247c-0.55 0-1 0.45-1 1s0.45 1 1 1h1.762l0.119 0.213c-0.009 0.009-0.022 0.019-0.031 0.028-0.619 0.531-1.156 1.053-1.472 2.072-0.272 0.869-0.375 2.041-0.375 4.188v1c0 0.744 0.4 1.481 1 1.928v2.075c0 0.828 0.672 1.5 1.5 1.5h2c0.828 0 1.5-0.672 1.5-1.5v-0.825c1.394 0.184 3.081 0.325 5 0.325s3.606-0.141 5-0.325v0.825c0 0.828 0.672 1.5 1.5 1.5h2c0.828 0 1.5-0.672 1.5-1.5v-2.072c0.6-0.45 1-1.188 1-1.928v-1c0-2.069-0.122-3.331-0.406-4.219-0.325-1.019-0.869-1.547-1.441-2.041-0.012-0.009-0.022-0.019-0.034-0.028l0.119-0.213h1.759c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 16c-1.1 0-2.216 0.172-3.028 0.334-0.022-0.066-0.059-0.128-0.113-0.181-0.081-0.084-2.016-2.059-5.603-2.15 0.15-0.519 0.372-0.781 0.678-1.059 4.916-1.263 11.203-1.266 16.122 0 0.284 0.259 0.506 0.525 0.663 1.059-3.572 0.097-5.5 2.066-5.581 2.15-0.050 0.053-0.087 0.116-0.112 0.181-0.809-0.162-1.925-0.334-3.025-0.334zM3.087 15c1.684 0.016 2.956 0.506 3.731 0.919 0.409 0.219 0.728 0.438 0.947 0.606l-0.472 0.475c-2.128-0.006-3.144-0.138-4.278-0.775 0.012-0.484 0.038-0.888 0.072-1.225zM16.234 16.528c0.222-0.172 0.541-0.391 0.947-0.606 0.775-0.413 2.044-0.9 3.719-0.919 0.038 0.341 0.063 0.744 0.078 1.225-1.131 0.637-2.147 0.766-4.275 0.775l-0.469-0.475zM11 3c0-0.55 0.45-1 1-1s1 0.45 1 1v2.016c-0.322-0.009-0.653-0.016-1-0.016s-0.678 0.006-1 0.016v-2.016zM5.691 9.928c0.191-0.606 0.369-1.178 0.663-1.659 0.375-0.612 2.056-1.269 5.647-1.269s5.272 0.656 5.647 1.272c0.294 0.478 0.472 1.050 0.663 1.656 0.178 0.566 0.369 1.178 0.678 1.741-1.563-0.319-3.225-0.525-4.919-0.616l2.125-1.416-0.556-0.831-3.291 2.194c-1.128-0.009-2.262 0.028-3.375 0.119l2.222-1.481-0.556-0.831-3.828 2.556c-0.609 0.087-1.209 0.191-1.794 0.312 0.306-0.569 0.5-1.178 0.675-1.747zM6 22.5c0 0.275-0.225 0.5-0.5 0.5h-2c-0.275 0-0.5-0.225-0.5-0.5v-1.625c0.513 0.147 1.547 0.416 3 0.653v0.972zM3.266 18.866h-0.003c-0.109-0.038-0.263-0.247-0.263-0.366v-1c0-0.053 0-0.109 0-0.162 1.212 0.559 2.444 0.663 4.5 0.663 0.131 0 0.259-0.053 0.353-0.147l0.306-0.306c0.469-0.122 2.206-0.547 3.841-0.547 1.638 0 3.372 0.425 3.841 0.547l0.306 0.306c0.094 0.094 0.222 0.147 0.353 0.147 2.056 0 3.288-0.103 4.5-0.663 0 0.053 0 0.106 0 0.162v1c0 0.119-0.153 0.328-0.266 0.366-0.034 0.012-3.484 1.134-8.734 1.134s-8.7-1.122-8.734-1.134zM20.5 23h-2c-0.275 0-0.5-0.225-0.5-0.5v-0.972c1.453-0.237 2.487-0.503 3-0.653v1.625c0 0.275-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M14.846 1.233l2.923-1.233 0.389 0.921-2.923 1.233-0.389-0.921z" }),
_('path', { d: "M16 3h3v1h-3v-1z" }),
_('path', { d: "M5.846 0.923l0.389-0.921 2.923 1.233-0.389 0.921-2.923-1.233z" }),
_('path', { d: "M5 3h3v1h-3v-1z" })
            );
        }
        function Police({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PoliceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Police.SVG = PoliceSVG;
        return Police;
    })();
export const Polygon = /*#__PURE__*/ (() => {
    function PolygonSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.119 20.003l-8.45-16.903c0.209-0.316 0.331-0.694 0.331-1.1 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 0.288 0.063 0.563 0.172 0.813l-5.963 8.2c-0.069-0.006-0.141-0.012-0.209-0.012-1.103 0-2 0.897-2 2s0.897 2 2 2c0.406 0 0.784-0.122 1.1-0.331l14.903 7.45c0.063 1.047 0.934 1.881 1.997 1.881 1.103 0 2-0.897 2-2 0-1.062-0.834-1.934-1.881-1.997zM4.828 12.188l5.962-8.2c0.031 0.003 0.059 0.006 0.091 0.006l7.884 15.769-13.769-6.881c-0.016-0.247-0.075-0.478-0.169-0.694zM11 1c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM3 14c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM21 23c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
        );
    }
    function Polygon({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PolygonSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Polygon.SVG = PolygonSVG;
    return Polygon;
})();
export const Polygon2 = /*#__PURE__*/ (() => {
    function Polygon2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.25 19.016l-6.656-15.809c0.256-0.334 0.406-0.753 0.406-1.206 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 0.044 0.003 0.084 0.003 0.128l-9.119 6.078c-0.269-0.131-0.569-0.206-0.884-0.206-1.103 0-2 0.897-2 2 0 1.062 0.834 1.934 1.881 1.997l4.45 8.903c-0.209 0.316-0.331 0.694-0.331 1.1 0 1.103 0.897 2 2 2 0.791 0 1.475-0.459 1.8-1.125l10.544-0.753c0.359 0.531 0.969 0.878 1.656 0.878 1.103 0 2-0.897 2-2 0-1.019-0.766-1.859-1.75-1.984zM14 1c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM1 10c0-0.55 0.45-1 1-1s1 0.45 1 1-0.45 1-1 1-1-0.45-1-1zM8 23c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM8.119 20.003l-4.45-8.903c0.209-0.316 0.331-0.694 0.331-1.1 0-0.044-0.003-0.084-0.003-0.128l9.119-6.078c0.197 0.097 0.409 0.162 0.637 0.191l6.656 15.809c-0.078 0.103-0.147 0.216-0.206 0.334l-10.547 0.75c-0.341-0.497-0.897-0.837-1.538-0.875zM22 22c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
        );
    }
    function Polygon2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Polygon2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Polygon2.SVG = Polygon2SVG;
    return Polygon2;
})();
export const Polygon3 = /*#__PURE__*/ (() => {
    function Polygon3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.803 17.169l-0.619-5.559c0.494-0.366 0.816-0.95 0.816-1.609 0-1.103-0.897-2-2-2-0.319 0-0.619 0.075-0.888 0.206l-9.116-6.078c0.003-0.044 0.003-0.084 0.003-0.128 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 0.334 0.081 0.647 0.228 0.925l-5.141 8.078c-0.028 0-0.056-0.003-0.087-0.003-1.103 0-2 0.897-2 2s0.897 2 2 2c0.138 0 0.272-0.016 0.403-0.041l5.697 6.409c-0.066 0.197-0.103 0.409-0.103 0.631 0 1.103 0.897 2 2 2 0.912 0 1.684-0.612 1.922-1.45l8.644-2.159c0.363 0.375 0.875 0.609 1.437 0.609 1.103 0 2-0.897 2-2 0-0.819-0.494-1.522-1.197-1.831zM20.078 18.45l-8.641 2.159c-0.363-0.375-0.875-0.609-1.437-0.609-0.138 0-0.272 0.016-0.403 0.041l-5.7-6.409c0.066-0.197 0.103-0.409 0.103-0.631 0-0.334-0.081-0.647-0.228-0.925l5.141-8.078c0.028 0 0.056 0.003 0.087 0.003 0.319 0 0.619-0.075 0.888-0.206l9.119 6.078c-0.003 0.044-0.003 0.084-0.003 0.128 0 0.819 0.494 1.522 1.197 1.831l0.619 5.559c-0.356 0.259-0.619 0.628-0.741 1.059zM22 10c0 0.55-0.45 1-1 1s-1-0.45-1-1 0.45-1 1-1 1 0.45 1 1zM9 1c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM1 13c0-0.55 0.45-1 1-1s1 0.45 1 1-0.45 1-1 1-1-0.45-1-1zM10 23c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM22 20c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
        );
    }
    function Polygon3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Polygon3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Polygon3.SVG = Polygon3SVG;
    return Polygon3;
})();
export const Pool = /*#__PURE__*/ (() => {
        function PoolSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 6c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zM12 17c-2.756 0-5-2.244-5-5s2.244-5 5-5c2.756 0 5 2.244 5 5s-2.244 5-5 5z" }),
_('path', { d: "M14.416 11.584c-0.384-0.381-0.897-0.584-1.416-0.584 0-0.519-0.203-1.031-0.584-1.416-0.781-0.781-2.050-0.781-2.828 0-0.781 0.781-0.781 2.050 0 2.828 0.381 0.384 0.894 0.588 1.413 0.588 0 0.519 0.203 1.031 0.584 1.416 0.378 0.378 0.881 0.584 1.416 0.584s1.038-0.209 1.416-0.584 0.584-0.881 0.584-1.416-0.209-1.038-0.584-1.416c0 0 0 0 0 0zM10.294 11.706c-0.391-0.391-0.391-1.025 0-1.416s1.025-0.391 1.416 0c0.281 0.281 0.369 0.7 0.225 1.066l-0.575 0.575c-0.366 0.144-0.784 0.056-1.066-0.225zM13.706 13.706c-0.188 0.188-0.441 0.294-0.706 0.294s-0.519-0.103-0.706-0.294c-0.281-0.281-0.369-0.7-0.225-1.066l0.575-0.575c0.366-0.141 0.784-0.053 1.066 0.225 0.188 0.188 0.294 0.441 0.294 0.706s-0.106 0.522-0.297 0.709z" }),
_('path', { d: "M12 3v1c4.413 0 8 3.588 8 8h1c0-2.403-0.938-4.666-2.637-6.363-1.697-1.7-3.959-2.637-6.363-2.637z" })
            );
        }
        function Pool({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PoolSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pool.SVG = PoolSVG;
        return Pool;
    })();
export const Poop = /*#__PURE__*/ (() => {
        function PoopSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.494 15.119c-3.128-1.684-4.941-3.438-5.391-5.206-0.275-1.084-0.031-2.184 0.741-3.363 0.25-0.381 0.213-0.888-0.097-1.225s-0.806-0.422-1.209-0.206c-2.647 1.419-3.513 3.422-4.206 5.028-0.641 1.488-1.066 2.469-2.597 2.888-1.744 0.475-3.294 1.491-4.366 2.856-1.025 1.306-1.509 2.806-1.334 4.109 0.119 0.897 0.544 1.65 1.222 2.178 0.697 0.547 1.619 0.822 2.737 0.822h14.025c2.903 0 3.687-1.387 3.897-2.216 0.506-2.016-1.359-4.556-3.422-5.666zM20.975 20.294c-0.159 0.638-1.422 0.706-1.956 0.706h-14.025c-1.2 0-1.866-0.425-1.978-1.263-0.103-0.762 0.244-1.741 0.928-2.613 0.806-1.031 1.984-1.797 3.316-2.163 1.113-0.303 1.978-0.859 2.644-1.694 0.563-0.706 0.919-1.531 1.263-2.328 0.253-0.588 0.503-1.166 0.828-1.713 0.012 0.394 0.069 0.784 0.169 1.175 0.363 1.431 1.303 2.806 2.8 4.094 0.956 0.822 2.128 1.603 3.578 2.384 0.712 0.384 1.425 1.041 1.903 1.756 0.428 0.631 0.631 1.269 0.531 1.656z" }),
_('path', { d: "M3.5 8.206l0.706-0.706-0.353-0.353c-0.831-0.831-0.831-1.134-0.825-1.184 0.019-0.122 0.366-0.3 0.619-0.428 0.334-0.172 0.713-0.366 0.994-0.675 0.363-0.4 0.478-0.894 0.344-1.472l-0.109-0.487-0.975 0.225 0.112 0.488c0.109 0.478-0.075 0.647-0.819 1.028-0.494 0.253-1.053 0.541-1.153 1.163-0.087 0.563 0.253 1.197 1.106 2.047l0.353 0.356z" }),
_('path', { d: "M19.5 6.206l0.706-0.706-0.353-0.353c-0.831-0.831-0.831-1.134-0.825-1.184 0.019-0.122 0.366-0.3 0.619-0.428 0.334-0.172 0.712-0.366 0.994-0.675 0.363-0.4 0.478-0.894 0.344-1.472l-0.109-0.487-0.975 0.225 0.112 0.488c0.109 0.478-0.075 0.647-0.819 1.028-0.494 0.253-1.053 0.541-1.153 1.162-0.087 0.563 0.253 1.197 1.106 2.047l0.353 0.356z" })
            );
        }
        function Poop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PoopSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Poop.SVG = PoopSVG;
        return Poop;
    })();
export const PortraitFemale = /*#__PURE__*/ (() => {
    function PortraitFemaleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.931 19.459c-0.709-0.509-1.538-0.928-2.359-1.294 1.391-0.244 2.444-0.663 3.234-1.272 0.109-0.084 0.181-0.213 0.194-0.35s-0.034-0.275-0.125-0.378c-1.784-1.984-2.875-3.416-2.875-7.666 0-2.725-0.494-4.722-1.506-6.109-0.581-0.797-1.344-1.403-2.262-1.8-0.903-0.391-1.991-0.591-3.231-0.591s-2.328 0.2-3.231 0.591c-0.919 0.397-1.681 1.003-2.262 1.8-1.012 1.387-1.506 3.384-1.506 6.109 0 4.25-1.091 5.681-2.872 7.666-0.094 0.103-0.138 0.241-0.125 0.378s0.081 0.266 0.194 0.35c0.791 0.609 1.847 1.028 3.234 1.272-0.822 0.366-1.65 0.784-2.359 1.294-1.375 0.987-2.072 2.178-2.072 3.541v0.5c0 0.275 0.225 0.5 0.5 0.5h21c0.275 0 0.5-0.225 0.5-0.5v-0.5c0-1.362-0.697-2.553-2.069-3.541zM8.047 19.975c-0.003-0.244-0.006-0.491-0.012-0.741 0.594-0.253 1.144-0.506 1.594-0.781 0.341-0.206 1.372-0.834 1.372-1.953v-0.219c0-1-0.509-1.913-1.362-2.438-1.681-1.038-2.525-2.587-2.628-4.853 1.55-0.066 2.931-0.363 4.113-0.894 1.353-0.603 2.491-1.525 3.394-2.741 0.697 0.831 1.506 1.35 2.412 1.55 0.047 0.491 0.069 1.022 0.069 1.594 0 2.538-0.837 4.234-2.637 5.344-0.853 0.525-1.362 1.437-1.362 2.438v0.219c0 1.119 1.031 1.747 1.372 1.953 0.453 0.275 1 0.528 1.594 0.781-0.006 0.25-0.009 0.497-0.012 0.741-0.019 1.153-0.031 2.166-0.303 3.025h-7.297c-0.269-0.859-0.284-1.872-0.303-3.025zM20.747 16.403c-0.928 0.534-2.259 0.856-4.034 0.975-0.394-0.169-0.759-0.334-1.059-0.497-0.444-0.237-0.603-0.391-0.653-0.45v-0.15c0-0.3 0.153-0.575 0.409-0.734 1.394-0.859 2.375-1.988 2.953-3.416 0.444 1.819 1.269 2.991 2.384 4.272zM8.122 3.569c0.769-1.056 2.037-1.569 3.878-1.569s3.109 0.513 3.881 1.569c0.416 0.569 0.712 1.316 0.897 2.253-0.697-0.256-1.313-0.784-1.863-1.6-0.094-0.141-0.253-0.222-0.422-0.222-0.169 0.003-0.325 0.091-0.416 0.231-1.509 2.384-3.828 3.619-7.072 3.759 0.053-2.019 0.419-3.466 1.116-4.422zM5.634 12.131c0.581 1.428 1.559 2.559 2.953 3.416 0.256 0.159 0.409 0.434 0.409 0.734v0.15c-0.050 0.059-0.206 0.213-0.653 0.45-0.303 0.162-0.666 0.325-1.059 0.497-1.775-0.119-3.106-0.441-4.034-0.975 1.119-1.281 1.944-2.453 2.384-4.272zM4.238 21.084c0.781-0.559 1.828-1.025 2.806-1.434 0.003 0.113 0.003 0.228 0.006 0.341 0.016 1.066 0.031 2.084 0.266 3.009h-4.316c0-0.441 0.128-1.119 1.237-1.916zM16.688 23c0.234-0.925 0.25-1.944 0.266-3.009 0.003-0.112 0.003-0.225 0.006-0.341 0.978 0.409 2.025 0.875 2.806 1.434 1.109 0.797 1.238 1.475 1.238 1.916h-4.316z" })
        );
    }
    function PortraitFemale({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PortraitFemaleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PortraitFemale.SVG = PortraitFemaleSVG;
    return PortraitFemale;
})();
export const PortraitMale = /*#__PURE__*/ (() => {
    function PortraitMaleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.931 19.459c-1.062-0.762-2.388-1.316-3.556-1.803-0.647-0.269-1.256-0.525-1.722-0.775-0.444-0.237-0.603-0.391-0.653-0.45v-0.15c0-0.3 0.153-0.575 0.409-0.734 2.416-1.488 3.591-3.794 3.591-7.047 0-2.725-0.494-4.722-1.506-6.109-0.581-0.797-1.344-1.403-2.262-1.8-0.903-0.391-1.991-0.591-3.231-0.591s-2.328 0.2-3.231 0.591c-0.919 0.397-1.681 1.003-2.262 1.8-1.012 1.387-1.506 3.384-1.506 6.109 0 3.253 1.175 5.559 3.591 7.047 0.256 0.159 0.409 0.434 0.409 0.734v0.15c-0.050 0.059-0.206 0.213-0.653 0.45-0.466 0.25-1.075 0.503-1.722 0.775-1.169 0.487-2.494 1.044-3.556 1.803-1.372 0.987-2.069 2.178-2.069 3.541v0.5c0 0.275 0.225 0.5 0.5 0.5h21c0.275 0 0.5-0.225 0.5-0.5v-0.5c0-1.362-0.697-2.553-2.069-3.541zM12 2c1.841 0 3.109 0.513 3.881 1.569 0.575 0.788 0.925 1.916 1.059 3.419-2.675-0.097-4.731-0.725-6.119-1.872-0.091-0.075-0.203-0.116-0.319-0.116-1.125 0-2.247 0.425-3.353 1.266 0.172-1.15 0.494-2.041 0.975-2.697 0.766-1.056 2.034-1.569 3.875-1.569zM9.628 18.453c0.341-0.206 1.372-0.834 1.372-1.953v-0.219c0-1-0.509-1.913-1.362-2.438-1.8-1.109-2.637-2.806-2.637-5.344 0-0.278 0.006-0.547 0.016-0.806 1.116-1.069 2.228-1.638 3.312-1.691 0.8 0.625 1.775 1.109 2.903 1.441 1.091 0.319 2.353 0.503 3.762 0.547 0.003 0.166 0.006 0.337 0.006 0.509 0 2.538-0.837 4.234-2.637 5.344-0.853 0.525-1.362 1.437-1.362 2.437v0.219c0 1.119 1.031 1.747 1.372 1.953 0.369 0.225 0.8 0.431 1.269 0.637-0.194 0.175-0.434 0.309-0.659 0.406-0.738 0.325-1.794 0.503-2.981 0.503s-2.244-0.178-2.981-0.503c-0.222-0.097-0.466-0.231-0.659-0.406 0.469-0.206 0.903-0.416 1.269-0.637zM3 23c0-0.441 0.128-1.119 1.238-1.916 0.875-0.628 2.084-1.134 3.153-1.581 0.275 0.363 0.687 0.669 1.228 0.906 0.869 0.387 2.041 0.591 3.381 0.591s2.513-0.203 3.384-0.588c0.541-0.237 0.953-0.547 1.228-0.906 1.069 0.447 2.278 0.953 3.153 1.581 1.109 0.797 1.238 1.475 1.238 1.916h-18.003z" })
        );
    }
    function PortraitMale({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PortraitMaleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PortraitMale.SVG = PortraitMaleSVG;
    return PortraitMale;
})();
export const Portrait = /*#__PURE__*/ (() => {
        function PortraitSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20l-0.003-20c0 0 0 0 0.003 0h20v20z" }),
_('path', { d: "M3.5 21h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5zM4 4h16v16h-16v-16z" }),
_('path', { d: "M15.462 14.194c-0.444-0.322-0.906-0.584-1.384-0.778 1.15-0.703 1.922-1.972 1.922-3.416 0-2.206-1.794-4-4-4s-4 1.794-4 4c0 1.444 0.772 2.712 1.922 3.416-0.478 0.194-0.941 0.453-1.384 0.778-0.963 0.703-1.797 1.681-2.419 2.831-0.144 0.266-0.159 0.584-0.041 0.863s0.356 0.491 0.647 0.575c1.731 0.497 3.556 0.537 5.275 0.537s3.544-0.041 5.275-0.537c0.291-0.084 0.528-0.294 0.647-0.575s0.103-0.597-0.041-0.863c-0.622-1.15-1.459-2.131-2.419-2.831zM9 10c0-1.653 1.347-3 3-3s3 1.347 3 3-1.347 3-3 3-3-1.347-3-3zM12 17c-1.106 0-2.253-0.019-3.35-0.175 0.944-1.15 2.156-1.825 3.35-1.825s2.406 0.675 3.35 1.825c-1.097 0.156-2.244 0.175-3.35 0.175z" })
            );
        }
        function Portrait({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PortraitSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Portrait.SVG = PortraitSVG;
        return Portrait;
    })();
export const Portrait2 = /*#__PURE__*/ (() => {
        function Portrait2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20l-0.003-20c0 0 0 0 0.003 0h20v20z" }),
_('path', { d: "M3.5 17h17c0.275 0 0.5-0.225 0.5-0.5v-13c0-0.275-0.225-0.5-0.5-0.5h-17c-0.275 0-0.5 0.225-0.5 0.5v13c0 0.275 0.225 0.5 0.5 0.5zM15.491 16h-6.981c0.966-1.256 2.238-2 3.491-2s2.525 0.744 3.491 2zM4 4h16v12h-2.134c-0.619-1.141-1.45-2.109-2.406-2.806-0.444-0.322-0.906-0.584-1.384-0.778 1.153-0.703 1.925-1.972 1.925-3.416 0-2.206-1.794-4-4-4s-4 1.794-4 4c0 1.444 0.772 2.712 1.922 3.416-0.478 0.194-0.941 0.453-1.384 0.778-0.953 0.697-1.784 1.666-2.406 2.806h-2.131v-12zM12 12c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" }),
_('path', { d: "M12 19h8v1h-8v-1z" })
            );
        }
        function Portrait2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Portrait2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Portrait2.SVG = Portrait2SVG;
        return Portrait2;
    })();
export const PotHot = /*#__PURE__*/ (() => {
        function PotHotSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.5 12h-1c0.275 0 0.5-0.225 0.5-0.5v-0.5c0-0.9-0.366-1.747-1.059-2.45-0.575-0.581-1.375-1.081-2.384-1.478-1.509-0.597-3.453-0.963-5.556-1.050v-1.022h1v-1h-4v1h1v1.022c-2.1 0.087-4.044 0.453-5.556 1.050-1.009 0.4-1.809 0.897-2.384 1.478-0.694 0.703-1.059 1.55-1.059 2.45v0.5c0 0.275 0.225 0.5 0.5 0.5h-1c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h1.5v7c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-7h1.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5zM6.181 8.931c1.494-0.594 3.616-0.931 5.819-0.931s4.325 0.338 5.819 0.931c0.997 0.391 2.181 1.069 2.181 2.069h-16c0-1 1.184-1.678 2.181-2.069zM1.5 14c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h1.5v1h-1.5zM5 22v-10h12v6h1v-6h1v10h-14zM22.5 14h-1.5v-1h1.5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M5.116 4.856l0.356 0.35 0.7-0.716-0.356-0.35c-0.837-0.819-0.819-1.106-0.816-1.134 0.019-0.109 0.387-0.297 0.612-0.406 0.331-0.166 0.709-0.356 0.987-0.656 0.363-0.394 0.481-0.881 0.347-1.45l-0.116-0.488-0.972 0.231 0.116 0.488c0.106 0.45-0.075 0.616-0.809 0.981-0.494 0.247-1.053 0.528-1.15 1.147-0.091 0.553 0.25 1.172 1.1 2.003z" }),
_('path', { d: "M18.116 4.856l0.356 0.35 0.7-0.716-0.356-0.35c-0.837-0.819-0.819-1.106-0.816-1.134 0.019-0.109 0.387-0.297 0.612-0.406 0.331-0.166 0.709-0.356 0.987-0.656 0.363-0.394 0.481-0.881 0.347-1.45l-0.116-0.488-0.972 0.231 0.116 0.488c0.106 0.45-0.075 0.616-0.809 0.981-0.494 0.247-1.053 0.528-1.15 1.147-0.091 0.553 0.25 1.172 1.1 2.003z" })
            );
        }
        function PotHot({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PotHotSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PotHot.SVG = PotHotSVG;
        return PotHot;
    })();
export const PotTime = /*#__PURE__*/ (() => {
        function PotTimeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21 12.025v-1.025h1.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-1c0.275 0 0.5-0.225 0.5-0.5v-0.5c0-0.9-0.366-1.747-1.059-2.453-0.575-0.581-1.375-1.081-2.384-1.478-1.509-0.597-3.456-0.959-5.556-1.050v-1.019h1v-1h-4v1h1v1.019c-2.1 0.087-4.047 0.453-5.556 1.050-1.009 0.4-1.809 0.897-2.384 1.478-0.694 0.706-1.059 1.553-1.059 2.453v0.5c0 0.275 0.225 0.5 0.5 0.5h-1c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h1.5v7c0 1.103 0.897 2 2 2h6.5c0.981 2.347 3.3 4 6 4 3.584 0 6.5-2.916 6.5-6.5 0-2.297-1.197-4.319-3-5.475zM22.5 9c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-1.5v-1h1.5zM6.181 4.928c1.494-0.591 3.616-0.928 5.819-0.928s4.325 0.341 5.819 0.931c0.997 0.391 2.181 1.069 2.181 2.069h-16c0-1 1.184-1.678 2.181-2.072zM1.5 10c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h1.5v1h-1.5zM5 18v-10h14v3.175c-0.481-0.116-0.984-0.175-1.5-0.175-3.584 0-6.5 2.916-6.5 6.5 0 0.169 0.006 0.334 0.019 0.5h-6.019zM18 22.978v-1.978h-1v1.978c-2.634-0.237-4.737-2.344-4.978-4.978h1.978v-1h-1.978c0.237-2.634 2.344-4.737 4.978-4.978v1.978h1v-1.978c2.634 0.237 4.737 2.344 4.978 4.978h-1.978v1h1.978c-0.241 2.634-2.344 4.737-4.978 4.978z" }),
_('path', { d: "M17.422 17.716l-1.922-1.922-0.706 0.706 2.353 2.353c0.094 0.094 0.222 0.147 0.353 0.147 0.016 0 0.034 0 0.050-0.003 0.15-0.016 0.284-0.097 0.366-0.219l2.278-3.416-0.831-0.556-1.941 2.909z" })
            );
        }
        function PotTime({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PotTimeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PotTime.SVG = PotTimeSVG;
        return PotTime;
    })();
export const Pot = /*#__PURE__*/ (() => {
    function PotSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.5 10h-1c0.275 0 0.5-0.225 0.5-0.5v-0.5c0-0.9-0.366-1.747-1.059-2.45-0.575-0.581-1.375-1.081-2.384-1.478-1.509-0.597-3.453-0.963-5.556-1.050v-1.022h1v-1h-4v1h1v1.022c-2.1 0.087-4.044 0.453-5.556 1.050-1.009 0.4-1.809 0.897-2.384 1.478-0.694 0.703-1.059 1.55-1.059 2.45v0.5c0 0.275 0.225 0.5 0.5 0.5h-1c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h1.5v7c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-7h1.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5zM6.181 6.931c1.494-0.594 3.616-0.931 5.819-0.931s4.325 0.337 5.819 0.931c0.997 0.391 2.181 1.069 2.181 2.069h-16c0-1 1.184-1.678 2.181-2.069zM1.5 12c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h1.5v1h-1.5zM5 20v-10h12v6h1v-6h1v10h-14zM22.5 12h-1.5v-1h1.5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5z" })
        );
    }
    function Pot({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PotSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pot.SVG = PotSVG;
    return Pot;
})();
export const PowerAuto = /*#__PURE__*/ (() => {
        function PowerAutoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 11c-0.022 0-0.041 0-0.063 0l0.297-0.322c0.269-0.291 0.341-0.716 0.181-1.078s-0.519-0.6-0.916-0.6h-5.613l2.562-7.684c0.15-0.447-0.034-0.938-0.441-1.178s-0.925-0.162-1.244 0.181l-12 13c-0.269 0.291-0.341 0.716-0.181 1.078 0.159 0.369 0.519 0.603 0.916 0.603h5.613l-2.562 7.684c-0.15 0.447 0.034 0.938 0.441 1.178 0.159 0.094 0.334 0.141 0.509 0.138 0.272 0 0.541-0.109 0.734-0.322l5.281-5.722c0.234 3.372 3.053 6.044 6.484 6.044 3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5zM3.284 13l7.297-7.906-1.528 4.587c-0.103 0.306-0.050 0.641 0.138 0.9s0.491 0.416 0.813 0.416h4.716l-1.456 1.575c-0.378 0.325-0.716 0.694-1.009 1.094l-4.834 5.241 1.528-4.587c0.103-0.306 0.050-0.641-0.138-0.9s-0.491-0.416-0.813-0.416h-4.713zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17.5 14c-0.216 0-0.406 0.138-0.475 0.341l-2.159 6.475 0.95 0.316 0.709-2.131h1.947l0.709 2.131 0.95-0.316-2.159-6.475c-0.066-0.203-0.256-0.341-0.472-0.341zM16.859 18l0.641-1.919 0.641 1.919h-1.281z" })
            );
        }
        function PowerAuto({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PowerAutoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PowerAuto.SVG = PowerAutoSVG;
        return PowerAuto;
    })();
export const PowerCross = /*#__PURE__*/ (() => {
        function PowerCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 11c-0.022 0-0.041 0-0.063 0l0.297-0.322c0.269-0.291 0.341-0.716 0.181-1.078s-0.519-0.6-0.916-0.6h-5.613l2.562-7.684c0.15-0.447-0.034-0.938-0.441-1.178s-0.925-0.162-1.244 0.181l-12 13c-0.269 0.291-0.341 0.716-0.181 1.078 0.159 0.369 0.519 0.603 0.916 0.603h5.613l-2.562 7.684c-0.15 0.447 0.034 0.938 0.441 1.178 0.159 0.094 0.334 0.141 0.509 0.138 0.272 0 0.541-0.109 0.734-0.322l5.281-5.722c0.234 3.372 3.053 6.044 6.484 6.044 3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5zM3.284 13l7.297-7.906-1.528 4.587c-0.103 0.306-0.050 0.641 0.138 0.9s0.491 0.416 0.813 0.416h4.716l-1.456 1.575c-0.378 0.325-0.716 0.694-1.009 1.094l-4.834 5.241 1.528-4.587c0.103-0.306 0.050-0.641-0.138-0.9s-0.491-0.416-0.813-0.416h-4.713zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 14.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function PowerCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PowerCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PowerCross.SVG = PowerCrossSVG;
        return PowerCross;
    })();
export const PowerDollar = /*#__PURE__*/ (() => {
        function PowerDollarSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 11c-0.022 0-0.041 0-0.063 0l0.297-0.322c0.269-0.291 0.341-0.716 0.181-1.078-0.159-0.366-0.519-0.6-0.916-0.6h-5.613l2.562-7.684c0.15-0.447-0.034-0.938-0.441-1.178s-0.925-0.162-1.244 0.181l-12 13c-0.269 0.291-0.341 0.716-0.181 1.078 0.159 0.369 0.519 0.603 0.916 0.603h5.613l-2.562 7.684c-0.15 0.447 0.034 0.938 0.441 1.178 0.159 0.094 0.334 0.141 0.509 0.141 0.272 0 0.541-0.109 0.734-0.322l5.281-5.719c0.237 3.369 3.053 6.037 6.484 6.037 3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5zM3.284 13l7.297-7.906-1.528 4.587c-0.103 0.306-0.050 0.641 0.138 0.9s0.491 0.416 0.813 0.416h4.716l-1.456 1.578c-0.378 0.325-0.716 0.694-1.013 1.097l-4.831 5.234 1.531-4.591c0.103-0.306 0.050-0.641-0.138-0.9s-0.491-0.416-0.813-0.416h-4.716zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18 13h-1v2h-0.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h2c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-3.5v1h2v2h1v-2h0.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-2c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3.5v-1h-2v-2z" })
            );
        }
        function PowerDollar({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PowerDollarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PowerDollar.SVG = PowerDollarSVG;
        return PowerDollar;
    })();
export const PowerSwitch = /*#__PURE__*/ (() => {
        function PowerSwitchSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.734 4.922l-0.441-0.234-0.469 0.884 0.441 0.234c2.303 1.219 3.734 3.591 3.734 6.194 0 3.859-3.141 7-7 7s-7-3.141-7-7c0-2.603 1.431-4.975 3.734-6.194l0.441-0.234-0.469-0.884-0.441 0.234c-2.631 1.394-4.266 4.103-4.266 7.078 0 2.138 0.831 4.147 2.344 5.656s3.519 2.344 5.656 2.344 4.147-0.831 5.656-2.344 2.344-3.519 2.344-5.656c0-2.975-1.634-5.688-4.266-7.078z" }),
_('path', { d: "M11 4h2v10h-2v-10z" }),
_('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" })
            );
        }
        function PowerSwitch({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PowerSwitchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PowerSwitch.SVG = PowerSwitchSVG;
        return PowerSwitch;
    })();
export const PowerSwitch2 = /*#__PURE__*/ (() => {
        function PowerSwitch2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 4c-2.137 0-4.147 0.831-5.656 2.344s-2.344 3.519-2.344 5.656 0.831 4.147 2.344 5.656 3.519 2.344 5.656 2.344 4.147-0.831 5.656-2.344 2.344-3.519 2.344-5.656-0.831-4.147-2.344-5.656-3.519-2.344-5.656-2.344zM12 19c-3.859 0-7-3.141-7-7s3.141-7 7-7c3.859 0 7 3.141 7 7s-3.141 7-7 7z" }),
_('path', { d: "M11 7h2v10h-2v-10z" })
            );
        }
        function PowerSwitch2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PowerSwitch2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PowerSwitch2.SVG = PowerSwitch2SVG;
        return PowerSwitch2;
    })();
export const PowerWarning = /*#__PURE__*/ (() => {
        function PowerWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.916 9.6c-0.159-0.363-0.519-0.6-0.916-0.6h-5.613l2.562-7.684c0.15-0.447-0.034-0.938-0.441-1.178s-0.925-0.162-1.244 0.181l-12 13c-0.269 0.291-0.341 0.716-0.181 1.078 0.159 0.369 0.519 0.603 0.916 0.603h5.613l-2.562 7.684c-0.15 0.447 0.034 0.938 0.441 1.178 0.159 0.094 0.334 0.141 0.509 0.138 0.272 0 0.541-0.109 0.734-0.322l12-13c0.269-0.291 0.341-0.716 0.181-1.078zM7.419 18.906l1.528-4.587c0.103-0.306 0.050-0.641-0.138-0.9s-0.491-0.416-0.813-0.416h-4.713l7.297-7.906-1.528 4.587c-0.103 0.306-0.050 0.641 0.138 0.9s0.491 0.416 0.813 0.416h4.716l-7.3 7.906z" }),
_('path', { d: "M18 21h1v1h-1v-1z" }),
_('path', { d: "M18 16h1v4h-1v-4z" }),
_('path', { d: "M23.841 21.828l-4-7.997c-0.25-0.506-0.778-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-4 7.997c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h8c0.828 0 1.5-0.672 1.5-1.5 0-0.231-0.056-0.462-0.159-0.669zM22.5 23h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5z" })
            );
        }
        function PowerWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PowerWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PowerWarning.SVG = PowerWarningSVG;
        return PowerWarning;
    })();
export const Power = /*#__PURE__*/ (() => {
    function PowerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18.891 8.544c-0.172-0.334-0.516-0.544-0.891-0.544h-4.381l3.275-6.553c0.156-0.309 0.138-0.678-0.044-0.972-0.181-0.297-0.503-0.475-0.85-0.475h-8.156c-0.494 0-0.912 0.359-0.987 0.847l-1.844 12c-0.044 0.288 0.041 0.581 0.228 0.803 0.191 0.222 0.466 0.35 0.759 0.35h2.781l-1.759 8.803c-0.094 0.462 0.15 0.925 0.584 1.113 0.128 0.056 0.262 0.081 0.397 0.081 0.316 0 0.622-0.15 0.816-0.419l10-14c0.213-0.303 0.241-0.703 0.072-1.034zM9.894 18.628l1.088-5.431c0.059-0.294-0.019-0.597-0.206-0.831s-0.475-0.366-0.775-0.366h-2.834l1.537-10h5.681l-3.278 6.553c-0.156 0.309-0.138 0.678 0.044 0.972s0.503 0.475 0.85 0.475h4.056l-6.162 8.628z" })
        );
    }
    function Power({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PowerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Power.SVG = PowerSVG;
    return Power;
})();
export const Power2 = /*#__PURE__*/ (() => {
    function Power2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.916 9.6c-0.159-0.363-0.519-0.6-0.916-0.6h-5.613l2.562-7.684c0.15-0.447-0.034-0.938-0.441-1.178s-0.925-0.162-1.244 0.181l-12 13c-0.269 0.291-0.341 0.716-0.181 1.078s0.519 0.6 0.916 0.6h5.613l-2.562 7.684c-0.15 0.447 0.034 0.938 0.441 1.178 0.159 0.094 0.334 0.141 0.509 0.138 0.272 0 0.541-0.109 0.734-0.322l12-13c0.269-0.288 0.341-0.712 0.181-1.075zM10.419 18.906l1.528-4.587c0.103-0.306 0.050-0.641-0.138-0.9s-0.491-0.416-0.813-0.416h-4.713l7.297-7.906-1.528 4.587c-0.103 0.306-0.050 0.641 0.138 0.9s0.491 0.416 0.813 0.416h4.716l-7.3 7.906z" })
        );
    }
    function Power2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Power2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Power2.SVG = Power2SVG;
    return Power2;
})();
export const PreviousCircle = /*#__PURE__*/ (() => {
        function PreviousCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M15.75 8.066c-0.156-0.091-0.347-0.087-0.5 0.003l-6 3.5c-0.153 0.091-0.247 0.253-0.247 0.431s0.094 0.344 0.247 0.431l6 3.5c0.078 0.047 0.166 0.069 0.253 0.069s0.172-0.022 0.25-0.066c0.156-0.091 0.25-0.253 0.25-0.434v-7c-0.003-0.178-0.1-0.344-0.253-0.434zM15 14.628l-4.506-2.628 4.506-2.628v5.256z" }),
_('path', { d: "M8 8h1v8h-1v-8z" })
            );
        }
        function PreviousCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PreviousCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PreviousCircle.SVG = PreviousCircleSVG;
        return PreviousCircle;
    })();
export const PreviousFrameCircle = /*#__PURE__*/ (() => {
        function PreviousFrameCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M13.75 8.066c-0.156-0.091-0.347-0.087-0.5 0.003l-6 3.5c-0.153 0.091-0.247 0.253-0.247 0.431s0.094 0.344 0.247 0.431l6 3.5c0.078 0.047 0.166 0.069 0.253 0.069s0.172-0.022 0.25-0.066c0.156-0.091 0.25-0.253 0.25-0.434v-7c-0.003-0.178-0.1-0.344-0.253-0.434zM13 14.628l-4.506-2.628 4.506-2.628v5.256z" }),
_('path', { d: "M15 8h1v8h-1v-8z" })
            );
        }
        function PreviousFrameCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PreviousFrameCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PreviousFrameCircle.SVG = PreviousFrameCircleSVG;
        return PreviousFrameCircle;
    })();
export const PreviousFrameSquare = /*#__PURE__*/ (() => {
        function PreviousFrameSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M7.247 12.431l6 3.5c0.078 0.047 0.166 0.069 0.253 0.069s0.172-0.022 0.25-0.066c0.156-0.091 0.25-0.253 0.25-0.434v-7c0-0.178-0.097-0.344-0.25-0.434s-0.347-0.087-0.5 0.003l-6 3.5c-0.153 0.091-0.247 0.253-0.247 0.431s0.091 0.344 0.244 0.431zM13 9.372v5.259l-4.506-2.631 4.506-2.628z" }),
_('path', { d: "M15 8h1v8h-1v-8z" })
            );
        }
        function PreviousFrameSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PreviousFrameSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PreviousFrameSquare.SVG = PreviousFrameSquareSVG;
        return PreviousFrameSquare;
    })();
export const PreviousFrame = /*#__PURE__*/ (() => {
        function PreviousFrameSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.494 2.131c-0.312-0.178-0.697-0.172-1.006 0.012l-15 9c-0.303 0.178-0.487 0.506-0.487 0.856s0.184 0.678 0.484 0.856l15 9c0.159 0.094 0.337 0.144 0.516 0.144 0.169 0 0.341-0.044 0.494-0.131 0.312-0.178 0.506-0.509 0.506-0.869v-18c0-0.359-0.194-0.694-0.506-0.869zM16 19.234l-12.056-7.234 12.056-7.234v14.469z" }),
_('path', { d: "M20 2h2v20h-2v-20z" })
            );
        }
        function PreviousFrame({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PreviousFrameSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PreviousFrame.SVG = PreviousFrameSVG;
        return PreviousFrame;
    })();
export const PreviousSquare = /*#__PURE__*/ (() => {
        function PreviousSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M9.247 12.431l6 3.5c0.078 0.047 0.166 0.069 0.253 0.069s0.172-0.022 0.25-0.066c0.156-0.091 0.25-0.253 0.25-0.434v-7c0-0.178-0.097-0.344-0.25-0.434s-0.347-0.087-0.5 0.003l-6 3.5c-0.153 0.091-0.247 0.253-0.247 0.431s0.091 0.344 0.244 0.431zM15 9.372v5.259l-4.506-2.631 4.506-2.628z" }),
_('path', { d: "M8 8h1v8h-1v-8z" })
            );
        }
        function PreviousSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PreviousSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PreviousSquare.SVG = PreviousSquareSVG;
        return PreviousSquare;
    })();
export const Previous = /*#__PURE__*/ (() => {
    function PreviousSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.494 2.131c-0.312-0.178-0.697-0.172-1.006 0.012l-14.487 8.691v-8.834h-2v20h2v-8.834l14.484 8.691c0.159 0.094 0.337 0.144 0.516 0.144 0.169 0 0.341-0.044 0.494-0.131 0.312-0.178 0.506-0.509 0.506-0.869v-18c0-0.359-0.194-0.694-0.506-0.869zM19 19.234l-12.056-7.234 12.056-7.234v14.469z" })
        );
    }
    function Previous({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PreviousSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Previous.SVG = PreviousSVG;
    return Previous;
})();
export const Printer3D = /*#__PURE__*/ (() => {
    function Printer3DSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.5 21h-21c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h21c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-21c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h7c1.931 0 3.5-1.569 3.5-3.5v-1.5h1c0.431 0 0.813-0.275 0.95-0.684l1.437-4.316h2.613c0.553 0 1-0.447 1-1v-4.5c0-0.275-0.225-0.5-0.5-0.5h-14c-0.275 0-0.5 0.225-0.5 0.5v4.5c0 0.553 0.447 1 1 1h2.613l1.437 4.316c0.138 0.409 0.519 0.684 0.95 0.684h1v1.5c0 1.378-1.122 2.5-2.5 2.5h-7c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h21c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-21c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h21c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-22.5v1h22.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5zM8 3c-0.322 0-0.622 0.153-0.813 0.416-0.125 0.172-0.188 0.378-0.188 0.584h-1v-3h11v3h-1c0-0.206-0.066-0.413-0.188-0.584-0.188-0.259-0.491-0.416-0.813-0.416h-7zM9.387 5h4.225l-1.334 4h-1.559l-1.331-4z" })
        );
    }
    function Printer3D({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Printer3DSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Printer3D.SVG = Printer3DSVG;
    return Printer3D;
})();
export const Printer = /*#__PURE__*/ (() => {
        function PrinterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21 9h-18c-1.653 0-3 1.347-3 3v6c0 0.553 0.447 1 1 1h5v4c0 0.553 0.447 1 1 1h10c0.553 0 1-0.447 1-1v-4h5c0.553 0 1-0.447 1-1v-6c0-1.653-1.347-3-3-3zM16 22h-8v-6h8v6zM22 17h-5v-1.5c0-0.275-0.225-0.5-0.5-0.5h-9c-0.275 0-0.5 0.225-0.5 0.5v1.5h-5v-5c0-0.55 0.45-1 1-1h18c0.55 0 1 0.45 1 1v5z" }),
_('path', { d: "M7 1h6v3.5c0 0.275 0.225 0.5 0.5 0.5h3.5v3h1v-3.5c0-2.481-2.019-4.5-4.5-4.5h-7c-0.275 0-0.5 0.225-0.5 0.5v7.5h1v-7zM16.966 4h-2.966v-2.966c1.531 0.222 2.744 1.434 2.966 2.966z" }),
_('path', { d: "M18 13h2v1h-2v-1z" })
            );
        }
        function Printer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PrinterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Printer.SVG = PrinterSVG;
        return Printer;
    })();
export const PriorityDecrease = /*#__PURE__*/ (() => {
        function PriorityDecreaseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 14h14v2h-14v-2z" }),
_('path', { d: "M10 8h14v2h-14v-2z" }),
_('path', { d: "M10 20h14v2h-14v-2z" }),
_('path', { d: "M10 2h14v2h-14v-2z" }),
_('path', { d: "M5.5 12.794l-0.706 0.706 1.5 1.5h-2.294c-1.653 0-3-1.347-3-3s1.347-3 3-3h3v-1h-3c-2.206 0-4 1.794-4 4s1.794 4 4 4h2.294l-1.5 1.5 0.706 0.706 2.353-2.353c0.194-0.194 0.194-0.513 0-0.706l-2.353-2.353z" })
            );
        }
        function PriorityDecrease({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PriorityDecreaseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PriorityDecrease.SVG = PriorityDecreaseSVG;
        return PriorityDecrease;
    })();
export const PriorityIncrease = /*#__PURE__*/ (() => {
        function PriorityIncreaseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 8h14v2h-14v-2z" }),
_('path', { d: "M10 14h14v2h-14v-2z" }),
_('path', { d: "M10 2h14v2h-14v-2z" }),
_('path', { d: "M10 20h14v2h-14v-2z" }),
_('path', { d: "M5.5 5.794l-0.706 0.706 1.5 1.5h-2.294c-2.206 0-4 1.794-4 4s1.794 4 4 4h3v-1h-3c-1.653 0-3-1.347-3-3s1.347-3 3-3h2.294l-1.5 1.5 0.706 0.706 2.353-2.353c0.194-0.194 0.194-0.513 0-0.706l-2.353-2.353z" })
            );
        }
        function PriorityIncrease({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PriorityIncreaseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PriorityIncrease.SVG = PriorityIncreaseSVG;
        return PriorityIncrease;
    })();
export const ProjectorScreenChart = /*#__PURE__*/ (() => {
        function ProjectorScreenChartSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.416 0.222c-0.094-0.141-0.25-0.222-0.416-0.222h-22c-0.166 0-0.322 0.084-0.416 0.222-0.775 1.162-0.775 2.391 0 3.556 0.094 0.141 0.25 0.222 0.416 0.222h1v16c0 1.103 0.897 2 2 2h5v1.5c0 0.275 0.225 0.5 0.5 0.5h5c0.275 0 0.5-0.225 0.5-0.5v-1.5h5c1.103 0 2-0.897 2-2v-16h1c0.166 0 0.322-0.084 0.416-0.222 0.775-1.162 0.775-2.394 0-3.556zM14 23h-4v-1h4v1zM20 20h-16v-16h16v16zM22.719 3h-21.438c-0.375-0.678-0.375-1.322 0-2h21.438c0.375 0.678 0.375 1.322 0 2z" }),
_('path', { d: "M6.422 17.203l5.106-4.084 2.697 1.797c0.134 0.087 0.3 0.109 0.45 0.053s0.266-0.178 0.309-0.331l1.647-5.766 0.65 1.3 0.894-0.447-1.225-2.447c-0.125-0.247-0.425-0.347-0.672-0.225l-2.447 1.225 0.447 0.894 1.428-0.716-1.5 5.247-2.431-1.619c-0.181-0.122-0.419-0.109-0.591 0.025l-5.391 4.313 0.628 0.781z" })
            );
        }
        function ProjectorScreenChart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ProjectorScreenChartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ProjectorScreenChart.SVG = ProjectorScreenChartSVG;
        return ProjectorScreenChart;
    })();
export const ProjectorScreenCollapsed = /*#__PURE__*/ (() => {
    function ProjectorScreenCollapsedSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.416 2.222c-0.094-0.141-0.25-0.222-0.416-0.222h-22c-0.166 0-0.322 0.084-0.416 0.222-0.775 1.163-0.775 2.391 0 3.556 0.094 0.141 0.25 0.222 0.416 0.222h1v2c0 1.103 0.897 2 2 2h5v1.5c0 0.275 0.225 0.5 0.5 0.5h1.375c-0.697 0.947-0.966 1.725-0.853 2.422 0.153 0.934 0.966 1.453 1.681 1.913 0.609 0.391 1.188 0.759 1.278 1.294 0.072 0.416-0.125 0.975-0.594 1.666-0.25-0.184-0.559-0.294-0.894-0.294-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.828 0 1.5-0.672 1.5-1.5 0-0.1-0.009-0.2-0.028-0.294 0.819-1.094 1.134-1.972 1-2.75-0.169-0.966-0.997-1.494-1.725-1.962-0.594-0.381-1.153-0.738-1.234-1.234-0.075-0.462 0.222-1.116 0.884-1.947 0 0 0.003-0.003 0.003-0.003l0.241-0.309h2.366c0.275 0 0.5-0.225 0.5-0.5v-1.5h5c1.103 0 2-0.897 2-2v-2h1c0.166 0 0.322-0.084 0.416-0.222 0.775-1.162 0.775-2.394 0-3.556zM11.5 21c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5zM14 11h-4v-1h4v1zM20 8h-16v-2h16v2zM22.719 5h-21.438c-0.375-0.678-0.375-1.322 0-2h21.438c0.375 0.678 0.375 1.322 0 2z" })
        );
    }
    function ProjectorScreenCollapsed({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ProjectorScreenCollapsedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ProjectorScreenCollapsed.SVG = ProjectorScreenCollapsedSVG;
    return ProjectorScreenCollapsed;
})();
export const ProjectorScreenPlay = /*#__PURE__*/ (() => {
        function ProjectorScreenPlaySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.416 0.222c-0.094-0.141-0.25-0.222-0.416-0.222h-22c-0.166 0-0.322 0.084-0.416 0.222-0.775 1.162-0.775 2.391 0 3.556 0.094 0.141 0.25 0.222 0.416 0.222h1v16c0 1.103 0.897 2 2 2h5v1.5c0 0.275 0.225 0.5 0.5 0.5h5c0.275 0 0.5-0.225 0.5-0.5v-1.5h5c1.103 0 2-0.897 2-2v-16h1c0.166 0 0.322-0.084 0.416-0.222 0.775-1.162 0.775-2.394 0-3.556zM14 23h-4v-1h4v1zM20 20h-16v-16h16v16zM22.719 3h-21.438c-0.375-0.678-0.375-1.322 0-2h21.438c0.375 0.678 0.375 1.322 0 2z" }),
_('path', { d: "M9.25 15.934c0.078 0.044 0.162 0.066 0.25 0.066s0.175-0.022 0.253-0.069l6-3.5c0.153-0.091 0.247-0.253 0.247-0.431s-0.094-0.344-0.247-0.431l-6-3.5c-0.153-0.091-0.347-0.091-0.5-0.003-0.156 0.091-0.25 0.253-0.25 0.434v7c-0.003 0.178 0.094 0.344 0.247 0.434zM10 9.372l4.506 2.628-4.506 2.628v-5.256z" })
            );
        }
        function ProjectorScreenPlay({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ProjectorScreenPlaySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ProjectorScreenPlay.SVG = ProjectorScreenPlaySVG;
        return ProjectorScreenPlay;
    })();
export const Pulse = /*#__PURE__*/ (() => {
        function PulseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 15c-0.4 0-0.762 0.237-0.919 0.606l-1.691 3.947-3.406-18.731c-0.087-0.472-0.497-0.819-0.975-0.822-0.003 0-0.006 0-0.009 0-0.475 0-0.888 0.338-0.981 0.803l-2.838 14.197h-9.181v2h10c0.478 0 0.888-0.338 0.981-0.803l1.972-9.863 3.063 16.847c0.078 0.434 0.434 0.766 0.872 0.816 0.038 0.003 0.075 0.006 0.113 0.006 0.397 0 0.759-0.234 0.919-0.606l2.741-6.397h3.341v-2h-4z" }),
_('path', { d: "M2.159 8.303c1.025 0.959 2.034 1.594 2.078 1.622 0.081 0.050 0.172 0.075 0.266 0.075s0.184-0.025 0.266-0.075c0.044-0.028 1.053-0.663 2.078-1.622 1.431-1.344 2.159-2.622 2.159-3.803 0-1.378-1.122-2.5-2.5-2.5-0.816 0-1.544 0.394-2 1.003-0.462-0.609-1.191-1.003-2.006-1.003-1.378 0-2.5 1.122-2.5 2.5 0 1.181 0.725 2.459 2.159 3.803zM2.5 3c0.828 0 1.5 0.672 1.5 1.5v0.5h1v-0.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 1.681-2.322 3.603-3.5 4.403-1.178-0.8-3.5-2.722-3.5-4.403 0-0.828 0.672-1.5 1.5-1.5z" })
            );
        }
        function Pulse({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PulseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pulse.SVG = PulseSVG;
        return Pulse;
    })();
export const PushpinCross = /*#__PURE__*/ (() => {
        function PushpinCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.225 11.231l1.341-2.231h1.434c0.378 0 0.725-0.213 0.894-0.553l1-2c0.194-0.384 0.116-0.85-0.188-1.153l-5-5c-0.303-0.303-0.769-0.381-1.153-0.188l-2 1c-0.341 0.169-0.553 0.516-0.553 0.894v1.434l-4.044 2.425-1.509-0.753c-0.384-0.194-0.85-0.116-1.153 0.188l-2 2c-0.391 0.391-0.391 1.025 0 1.416l3.181 3.181-9.344 10.272c-0.084 0.094-0.131 0.213-0.131 0.337v1c0 0.275 0.225 0.5 0.5 0.5h1c0.125 0 0.244-0.047 0.338-0.131l9.609-8.734c-0.288 0.734-0.447 1.531-0.447 2.366 0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5c0-2.988-2.025-5.509-4.775-6.269zM9.197 7.216l1.356 0.678c0.306 0.153 0.669 0.138 0.963-0.038l5-3c0.3-0.181 0.484-0.506 0.484-0.856v-1.381l0.803-0.4 3.981 3.981-0.403 0.8h-1.381c-0.35 0-0.678 0.184-0.856 0.484l-2.106 3.513 0.028 0.016c-1.516 0.1-2.887 0.725-3.944 1.688l-4.706-4.7 0.781-0.784zM1.306 23h-0.306v-0.306l9.181-10.1 1.225 1.225-10.1 9.181zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 14.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" }),
_('path', { d: "M12.854 8.448l3.679-2.719 0.594 0.804-3.679 2.719-0.594-0.804z" })
            );
        }
        function PushpinCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PushpinCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PushpinCross.SVG = PushpinCrossSVG;
        return PushpinCross;
    })();
export const Pushpin = /*#__PURE__*/ (() => {
        function PushpinSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.706 5.294l-5-5c-0.303-0.303-0.769-0.381-1.153-0.188l-2 1c-0.341 0.169-0.553 0.516-0.553 0.894v1.434l-4.044 2.425-1.509-0.753c-0.384-0.194-0.85-0.116-1.153 0.188l-2 2c-0.391 0.391-0.391 1.025 0 1.416l3.181 3.181-9.344 10.272c-0.084 0.094-0.131 0.213-0.131 0.337v1c0 0.275 0.225 0.5 0.5 0.5h1c0.125 0 0.244-0.047 0.338-0.131l10.278-9.344 3.181 3.181c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l2-2c0.303-0.303 0.381-0.769 0.188-1.153l-0.753-1.509 2.422-4.044h1.434c0.378 0 0.725-0.213 0.894-0.553l1-2c0.194-0.384 0.119-0.85-0.188-1.153zM1.306 23h-0.306v-0.306l9.181-10.1 1.225 1.225-10.1 9.181zM21.381 7h-1.381c-0.35 0-0.678 0.184-0.856 0.484l-3 5c-0.175 0.294-0.191 0.656-0.038 0.963l0.678 1.356-0.784 0.781-7.584-7.584 0.784-0.784 1.356 0.678c0.306 0.153 0.669 0.138 0.963-0.038l5-3c0.3-0.181 0.484-0.506 0.484-0.856v-1.381l0.803-0.4 3.981 3.981-0.406 0.8z" }),
_('path', { d: "M12.854 8.448l3.679-2.719 0.594 0.804-3.679 2.719-0.594-0.804z" })
            );
        }
        function Pushpin({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PushpinSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pushpin.SVG = PushpinSVG;
        return Pushpin;
    })();
export const Pushpin2 = /*#__PURE__*/ (() => {
        function Pushpin2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 5c0-2.756-2.244-5-5-5s-5 2.244-5 5c0 2.062 1.253 3.834 3.038 4.6l0.963 13.934c0.012 0.197 0.141 0.366 0.325 0.434 0.056 0.022 0.116 0.031 0.175 0.031 0.131 0 0.259-0.050 0.353-0.147l1-1c0.084-0.084 0.138-0.197 0.144-0.316l0.959-12.934c1.788-0.766 3.044-2.541 3.044-4.603zM12.016 22.278l-0.091 0.091-0.863-12.456c0.303 0.056 0.616 0.087 0.938 0.087 0.319 0 0.628-0.031 0.931-0.087l-0.916 12.366zM12 8c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" }),
_('path', { d: "M12 3v1c0.55 0 1 0.45 1 1h1c0-1.103-0.897-2-2-2z" })
            );
        }
        function Pushpin2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Pushpin2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pushpin2.SVG = Pushpin2SVG;
        return Pushpin2;
    })();
export const PuzzleCheck = /*#__PURE__*/ (() => {
        function PuzzleCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.972 1.816c-1.716-0.947-4.025-1.084-5.75-0.338-0.509 0.219-0.906 0.647-1.091 1.169s-0.144 1.1 0.112 1.587c0.128 0.247 0.194 0.503 0.194 0.766 0 0.6-0.188 2-1.938 2-1.722 0-1.906-1.4-1.906-2 0-0.266 0.066-0.522 0.191-0.759 0 0 0-0.003 0.003-0.003 0.256-0.484 0.297-1.059 0.116-1.581-0.184-0.525-0.581-0.953-1.094-1.178-1.547-0.672-4.081-0.631-5.65 0.091-0.487 0.225-0.853 0.628-1.038 1.131-0.181 0.506-0.156 1.050 0.075 1.534 0.703 1.472 0.847 2.381 0.491 3.134 0 0 0 0-0.003 0-0.678-0.319-1.437-0.438-2.191-0.344-0.803 0.1-1.578 0.428-2.3 0.975-0.072 0.053-0.134 0.119-0.191 0.191-1.084 1.425-1.306 3.138-0.594 4.578 0.325 0.656 0.825 1.212 1.447 1.606 0.641 0.406 1.378 0.619 2.137 0.619 0.569 0 1.119-0.116 1.634-0.347 0.006-0.003 0.012-0.003 0.016-0.003s0.006 0 0.006 0c0 0 0 0 0 0 0.387 0.853 0.259 1.819-0.419 3.131-0.25 0.484-0.294 1.034-0.125 1.55 0.166 0.509 0.522 0.922 1 1.163 0 0 0.003 0 0.003 0 0.837 0.416 1.853 0.509 2.619 0.509 0.063 0 0.125 0 0.184-0.003 1.012-0.019 2.041-0.213 2.819-0.528l0.481-0.194c1.181 1.653 3.109 2.728 5.287 2.728 3.584 0 6.5-2.916 6.5-6.5v-12.938c0-0.728-0.394-1.4-1.028-1.747zM10.981 18.616c-1.172 0.475-3.1 0.516-3.972 0.084 0-0.003 0.003-0.006 0.003-0.009 0.444-0.859 0.709-1.634 0.809-2.369 0.122-0.884 0.006-1.728-0.347-2.506-0.222-0.487-0.622-0.859-1.122-1.047-0.494-0.184-1.038-0.169-1.525 0.047-0.003 0-0.006 0.003-0.009 0.003-0.256 0.116-0.534 0.175-0.822 0.175-0.766 0-1.453-0.425-1.794-1.113-0.359-0.722-0.244-1.578 0.312-2.369 0.775-0.544 1.616-0.666 2.328-0.331 0.478 0.222 1.012 0.25 1.506 0.081 0.506-0.175 0.912-0.534 1.141-1.019 0.359-0.753 0.469-1.594 0.322-2.503-0.113-0.694-0.366-1.444-0.803-2.359 1.047-0.475 2.988-0.509 4.003-0.069 0 0 0.003 0 0.003 0.003-0.275 0.522-0.419 1.103-0.419 1.688 0 1.103 0.341 2.069 0.981 2.787 0.709 0.794 1.719 1.212 2.925 1.212 1.203 0 2.219-0.419 2.934-1.206 0.647-0.712 1.003-1.703 1.003-2.794 0-0.578-0.147-1.162-0.422-1.688 1.147-0.497 2.819-0.391 3.984 0.25v8.25c-1.169-1.122-2.756-1.812-4.5-1.812-3.584 0-6.5 2.916-6.5 6.5 0 0.691 0.109 1.359 0.309 1.984l-0.331 0.128zM17.5 22c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16.5 17.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4z" })
            );
        }
        function PuzzleCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PuzzleCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PuzzleCheck.SVG = PuzzleCheckSVG;
        return PuzzleCheck;
    })();
export const PuzzleCross = /*#__PURE__*/ (() => {
        function PuzzleCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.972 1.816c-1.716-0.947-4.025-1.084-5.75-0.338-0.509 0.219-0.906 0.647-1.091 1.169s-0.144 1.1 0.112 1.587c0.128 0.247 0.194 0.503 0.194 0.766 0 0.6-0.188 2-1.938 2-1.722 0-1.906-1.4-1.906-2 0-0.266 0.066-0.522 0.191-0.759 0 0 0-0.003 0.003-0.003 0.256-0.484 0.297-1.059 0.116-1.581-0.184-0.525-0.581-0.953-1.094-1.178-1.547-0.672-4.081-0.631-5.65 0.091-0.487 0.225-0.853 0.628-1.038 1.131-0.181 0.506-0.156 1.050 0.075 1.534 0.703 1.472 0.847 2.381 0.491 3.134 0 0 0 0-0.003 0-0.678-0.319-1.437-0.438-2.191-0.344-0.803 0.1-1.578 0.428-2.3 0.975-0.072 0.053-0.134 0.119-0.191 0.191-1.084 1.425-1.306 3.138-0.594 4.578 0.325 0.656 0.825 1.212 1.447 1.606 0.641 0.406 1.378 0.619 2.137 0.619 0.569 0 1.119-0.116 1.634-0.347 0.006-0.003 0.012-0.003 0.016-0.003s0.006 0 0.006 0c0 0 0 0 0 0 0.387 0.853 0.259 1.819-0.419 3.131-0.25 0.484-0.294 1.034-0.125 1.55 0.166 0.509 0.522 0.922 1 1.163 0 0 0.003 0 0.003 0 0.837 0.416 1.853 0.509 2.619 0.509 0.063 0 0.125 0 0.184-0.003 1.012-0.019 2.041-0.213 2.819-0.528l0.481-0.194c1.181 1.653 3.109 2.728 5.287 2.728 3.584 0 6.5-2.916 6.5-6.5v-12.938c0-0.728-0.394-1.4-1.028-1.747zM10.981 18.616c-1.172 0.475-3.1 0.516-3.972 0.084 0-0.003 0.003-0.006 0.003-0.009 0.444-0.859 0.709-1.634 0.809-2.369 0.122-0.884 0.006-1.728-0.347-2.506-0.222-0.487-0.622-0.859-1.122-1.047-0.494-0.184-1.038-0.169-1.525 0.047-0.003 0-0.006 0.003-0.009 0.003-0.256 0.116-0.534 0.175-0.822 0.175-0.766 0-1.453-0.425-1.794-1.113-0.359-0.722-0.244-1.578 0.312-2.369 0.775-0.544 1.616-0.666 2.328-0.331 0.478 0.222 1.012 0.25 1.506 0.081 0.506-0.175 0.912-0.534 1.141-1.019 0.359-0.753 0.469-1.594 0.322-2.503-0.113-0.694-0.366-1.444-0.803-2.359 1.047-0.475 2.988-0.509 4.003-0.069 0 0 0.003 0 0.003 0.003-0.275 0.522-0.419 1.103-0.419 1.688 0 1.103 0.341 2.069 0.981 2.787 0.709 0.794 1.719 1.212 2.925 1.212 1.203 0 2.219-0.419 2.934-1.206 0.647-0.712 1.003-1.703 1.003-2.794 0-0.578-0.147-1.162-0.422-1.688 1.147-0.497 2.819-0.391 3.984 0.25v8.25c-1.169-1.122-2.756-1.812-4.5-1.812-3.584 0-6.5 2.916-6.5 6.5 0 0.691 0.109 1.359 0.309 1.984l-0.331 0.128zM17.5 22c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 13.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function PuzzleCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PuzzleCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PuzzleCross.SVG = PuzzleCrossSVG;
        return PuzzleCross;
    })();
export const PuzzleDown = /*#__PURE__*/ (() => {
        function PuzzleDownSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.972 1.816c-1.716-0.947-4.025-1.084-5.75-0.338-0.509 0.219-0.906 0.647-1.091 1.169s-0.144 1.1 0.112 1.587c0.128 0.247 0.194 0.503 0.194 0.766 0 0.6-0.188 2-1.938 2-1.722 0-1.906-1.4-1.906-2 0-0.266 0.066-0.522 0.191-0.759 0 0 0-0.003 0.003-0.003 0.256-0.484 0.297-1.059 0.116-1.581-0.184-0.525-0.581-0.953-1.094-1.178-1.547-0.672-4.081-0.631-5.65 0.091-0.487 0.225-0.853 0.628-1.038 1.131-0.181 0.506-0.156 1.050 0.075 1.534 0.703 1.472 0.847 2.381 0.491 3.134 0 0 0 0-0.003 0-0.678-0.319-1.437-0.438-2.191-0.344-0.803 0.1-1.578 0.428-2.3 0.975-0.072 0.053-0.134 0.119-0.191 0.191-1.084 1.425-1.306 3.138-0.594 4.578 0.325 0.656 0.825 1.212 1.447 1.606 0.641 0.406 1.378 0.619 2.137 0.619 0.569 0 1.119-0.116 1.634-0.347 0.006-0.003 0.012-0.003 0.016-0.003s0.006 0 0.006 0c0 0 0 0 0 0 0.387 0.853 0.259 1.819-0.419 3.131-0.25 0.484-0.294 1.034-0.125 1.55 0.166 0.509 0.522 0.922 1 1.163 0 0 0.003 0 0.003 0 0.837 0.416 1.853 0.509 2.619 0.509 0.063 0 0.125 0 0.184-0.003 1.012-0.019 2.041-0.213 2.819-0.528l0.481-0.194c1.181 1.653 3.109 2.728 5.287 2.728 3.584 0 6.5-2.916 6.5-6.5v-12.938c0-0.728-0.394-1.4-1.028-1.747zM10.981 18.616c-1.172 0.475-3.1 0.516-3.972 0.084 0-0.003 0.003-0.006 0.003-0.009 0.444-0.859 0.709-1.634 0.809-2.369 0.122-0.884 0.006-1.728-0.347-2.506-0.222-0.487-0.622-0.859-1.122-1.047-0.494-0.184-1.038-0.169-1.525 0.047-0.003 0-0.006 0.003-0.009 0.003-0.256 0.116-0.534 0.175-0.822 0.175-0.766 0-1.453-0.425-1.794-1.113-0.359-0.722-0.244-1.578 0.312-2.369 0.775-0.544 1.616-0.666 2.328-0.331 0.478 0.222 1.012 0.25 1.506 0.081 0.506-0.175 0.912-0.534 1.141-1.019 0.359-0.753 0.469-1.594 0.322-2.503-0.113-0.694-0.366-1.444-0.803-2.359 1.047-0.475 2.988-0.509 4.003-0.069 0 0 0.003 0 0.003 0.003-0.275 0.522-0.419 1.103-0.419 1.688 0 1.103 0.341 2.069 0.981 2.787 0.709 0.794 1.719 1.212 2.925 1.212 1.203 0 2.219-0.419 2.934-1.206 0.647-0.712 1.003-1.703 1.003-2.794 0-0.578-0.147-1.162-0.422-1.688 1.147-0.497 2.819-0.391 3.984 0.25v8.25c-1.169-1.122-2.756-1.812-4.5-1.812-3.584 0-6.5 2.916-6.5 6.5 0 0.691 0.109 1.359 0.309 1.984l-0.331 0.128zM17.5 22c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18 18.294v-5.294h-1v5.294l-1.5-1.5-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l2.353-2.353-0.706-0.706-1.5 1.5z" })
            );
        }
        function PuzzleDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PuzzleDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PuzzleDown.SVG = PuzzleDownSVG;
        return PuzzleDown;
    })();
export const Puzzle = /*#__PURE__*/ (() => {
    function PuzzleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.972 2.813c-1.716-0.947-4.025-1.084-5.747-0.338-0.509 0.222-0.906 0.647-1.094 1.172-0.184 0.522-0.144 1.1 0.113 1.584 0.128 0.244 0.194 0.5 0.194 0.766 0 0.6-0.188 2-1.938 2-1.722 0-1.906-1.397-1.906-2 0-0.266 0.066-0.522 0.194-0.766 0.256-0.487 0.297-1.062 0.112-1.584-0.184-0.525-0.584-0.953-1.094-1.172-1.547-0.669-4.081-0.628-5.644 0.094-0.487 0.225-0.856 0.628-1.038 1.134s-0.156 1.050 0.075 1.534c0.694 1.45 0.841 2.388 0.491 3.134 0 0 0 0 0 0-0.678-0.319-1.437-0.438-2.191-0.344-0.809 0.1-1.584 0.428-2.303 0.975-0.072 0.053-0.134 0.119-0.191 0.191-1.084 1.425-1.306 3.134-0.594 4.575 0.325 0.659 0.825 1.212 1.447 1.606 0.641 0.406 1.378 0.619 2.137 0.619 0.572 0 1.125-0.119 1.644-0.353 0.003 0 0.006-0.003 0.009-0.003 0.387 0.853 0.259 1.819-0.419 3.131-0.25 0.484-0.294 1.038-0.125 1.553 0.169 0.509 0.525 0.922 1.003 1.159 0.834 0.416 1.853 0.509 2.616 0.509 0.063 0 0.125 0 0.188-0.003 1.012-0.022 2.037-0.213 2.819-0.528 0.509-0.206 0.916-0.619 1.113-1.134 0.2-0.522 0.172-1.109-0.078-1.613-0.116-0.231-0.172-0.475-0.172-0.725 0-0.6 0.184-2 1.906-2 1.75 0 1.938 1.397 1.938 2 0 0.266-0.066 0.522-0.194 0.766-0.256 0.487-0.297 1.062-0.113 1.584 0.184 0.525 0.584 0.953 1.094 1.172 0.741 0.322 1.591 0.478 2.456 0.478 1.144 0 2.316-0.275 3.291-0.816 0.634-0.35 1.028-1.019 1.028-1.747v-14.862c0-0.728-0.394-1.4-1.028-1.75zM22 4.563v14.875c-1.163 0.641-2.838 0.744-3.981 0.25 0.278-0.531 0.419-1.1 0.419-1.688 0-1.087-0.356-2.081-1.003-2.794-0.716-0.791-1.731-1.206-2.934-1.206s-2.216 0.419-2.925 1.212c-0.644 0.719-0.981 1.684-0.981 2.787 0 0.559 0.128 1.103 0.378 1.612 0.003 0.003 0.003 0.009 0.003 0.009-1.172 0.469-3.094 0.509-3.969 0.081 0-0.003 0-0.006 0.003-0.009 0.444-0.859 0.709-1.634 0.809-2.369 0.122-0.884 0.006-1.728-0.347-2.506-0.456-1.003-1.644-1.45-2.653-0.994-0.259 0.116-0.534 0.175-0.822 0.175-0.766 0-1.453-0.428-1.794-1.113-0.359-0.722-0.244-1.578 0.312-2.369 1.047-0.741 1.903-0.528 2.328-0.331 0.275 0.128 0.563 0.188 0.847 0.188 0.744 0 1.459-0.416 1.8-1.125 0.359-0.753 0.469-1.594 0.322-2.503-0.113-0.694-0.366-1.447-0.803-2.363 1.041-0.478 2.984-0.513 4.003-0.072-0.278 0.531-0.419 1.1-0.419 1.688 0 1.103 0.341 2.069 0.981 2.787 0.709 0.794 1.719 1.212 2.925 1.212 1.203 0 2.219-0.416 2.934-1.206 0.647-0.712 1.003-1.706 1.003-2.794 0-0.591-0.141-1.159-0.419-1.688 1.147-0.497 2.819-0.391 3.981 0.25v0z" })
        );
    }
    function Puzzle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PuzzleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Puzzle.SVG = PuzzleSVG;
    return Puzzle;
})();
export const Qrcode = /*#__PURE__*/ (() => {
        function QrcodeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 0h-9c-0.553 0-1 0.447-1 1v9c0 0.553 0.447 1 1 1h9c0.553 0 1-0.447 1-1v-9c0-0.553-0.447-1-1-1zM9 9h-7v-7h7v7z" }),
_('path', { d: "M23 0h-9c-0.553 0-1 0.447-1 1v9c0 0.553 0.447 1 1 1h9c0.553 0 1-0.447 1-1v-9c0-0.553-0.447-1-1-1zM22 9h-7v-7h7v7z" }),
_('path', { d: "M10 13h-9c-0.553 0-1 0.447-1 1v9c0 0.553 0.447 1 1 1h9c0.553 0 1-0.447 1-1v-9c0-0.553-0.447-1-1-1zM9 22h-7v-7h7v7z" }),
_('path', { d: "M3.5 8h4c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5h-4c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5zM4 4h3v3h-3v-3z" }),
_('path', { d: "M16.5 8h4c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5h-4c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5zM17 4h3v3h-3v-3z" }),
_('path', { d: "M3.5 21h4c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5h-4c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5zM4 17h3v3h-3v-3z" }),
_('path', { d: "M13 13h2v2h-2v-2z" }),
_('path', { d: "M17 13h2v2h-2v-2z" }),
_('path', { d: "M13 17h2v2h-2v-2z" }),
_('path', { d: "M15 15h2v2h-2v-2z" }),
_('path', { d: "M19 17h-1.5c-0.275 0-0.5 0.225-0.5 0.5v1.5h-2v2h2v1.5c0 0.275 0.225 0.5 0.5 0.5h5c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5h-1.5v-2h-2v2zM22 18v4h-4v-4h4z" }),
_('path', { d: "M13 21h2v2h-2v-2z" }),
_('path', { d: "M21 13h2v2h-2v-2z" }),
_('path', { d: "M19 19h2v2h-2v-2z" })
            );
        }
        function Qrcode({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( QrcodeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Qrcode.SVG = QrcodeSVG;
        return Qrcode;
    })();
export const Quadcopter = /*#__PURE__*/ (() => {
        function QuadcopterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 9c-1.653 0-3 1.347-3 3s1.347 3 3 3c1.653 0 3-1.347 3-3s-1.347-3-3-3zM12 14c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2c0 1.103-0.897 2-2 2z" }),
_('path', { d: "M23.416 15.584c-0.781-0.781-2.050-0.781-2.828 0-0.419 0.419-0.788 1.087-1.1 1.994-0.953-1.544-1.488-3.522-1.488-5.578s0.534-4.034 1.488-5.578c0.312 0.906 0.681 1.575 1.1 1.991 0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584v0c0.781-0.781 0.781-2.050 0-2.828-0.472-0.472-1.269-0.884-2.363-1.219-0.45-0.138-0.856-0.234-1.128-0.291-0.059-0.272-0.153-0.678-0.291-1.125-0.334-1.094-0.747-1.891-1.219-2.362-0.381-0.378-0.884-0.588-1.419-0.588s-1.038 0.209-1.416 0.584c-0.781 0.781-0.781 2.050 0 2.828 0.419 0.419 1.088 0.788 1.994 1.1-1.544 0.953-3.522 1.488-5.578 1.488s-4.034-0.534-5.578-1.488c0.906-0.312 1.575-0.681 1.991-1.1 0.378-0.375 0.588-0.878 0.588-1.413s-0.209-1.038-0.584-1.416v0c-0.781-0.781-2.050-0.781-2.828 0-0.472 0.472-0.884 1.269-1.219 2.363-0.138 0.45-0.234 0.856-0.291 1.125-0.272 0.059-0.678 0.153-1.125 0.291-1.094 0.334-1.891 0.747-2.362 1.219-0.381 0.381-0.591 0.884-0.591 1.419s0.206 1.034 0.584 1.413c0 0 0.003 0.003 0.003 0.003 0.387 0.387 0.9 0.584 1.413 0.584s1.025-0.194 1.416-0.584c0.419-0.419 0.788-1.087 1.1-1.994 0.95 1.544 1.484 3.522 1.484 5.578s-0.534 4.034-1.488 5.578c-0.312-0.906-0.681-1.575-1.1-1.991-0.781-0.781-2.050-0.781-2.828 0 0 0-0.003 0.003-0.003 0.003-0.375 0.375-0.581 0.875-0.581 1.409s0.209 1.038 0.584 1.416c0.472 0.472 1.269 0.884 2.362 1.219 0.45 0.138 0.856 0.234 1.125 0.291 0.059 0.272 0.153 0.678 0.291 1.128 0.334 1.094 0.747 1.891 1.219 2.362 0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584c0 0 0.003-0.003 0.003-0.003 0.375-0.378 0.584-0.878 0.584-1.413s-0.209-1.038-0.584-1.416c-0.419-0.419-1.088-0.787-1.994-1.1 1.544-0.95 3.522-1.484 5.578-1.484s4.034 0.534 5.578 1.488c-0.906 0.312-1.575 0.681-1.994 1.1-0.778 0.778-0.781 2.044-0.003 2.825 0 0 0.003 0.003 0.003 0.003 0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584c0.472-0.472 0.884-1.269 1.219-2.362 0.138-0.45 0.234-0.856 0.291-1.128 0.272-0.059 0.678-0.153 1.128-0.291 1.094-0.334 1.891-0.747 2.363-1.219 0.778-0.781 0.778-2.050 0-2.831v0zM22.706 6.294c0.391 0.391 0.391 1.025 0 1.416v0c-0.391 0.391-1.025 0.391-1.416 0-0.534-0.534-0.925-1.706-1.141-2.553 0.85 0.213 2.022 0.6 2.556 1.137zM16.294 1.294v0c0.194-0.194 0.45-0.294 0.706-0.294s0.513 0.097 0.706 0.294c0.534 0.534 0.925 1.706 1.141 2.553-0.847-0.213-2.016-0.603-2.553-1.141-0.391-0.387-0.391-1.022 0-1.413zM6.294 1.294c0.194-0.194 0.45-0.294 0.706-0.294s0.513 0.097 0.706 0.294c0 0 0 0 0 0 0.188 0.188 0.294 0.441 0.294 0.706s-0.103 0.519-0.294 0.706c-0.534 0.534-1.706 0.925-2.553 1.141 0.216-0.847 0.603-2.019 1.141-2.553zM2.706 7.706c-0.391 0.391-1.022 0.391-1.413 0.003 0 0 0 0-0.003-0.003-0.188-0.188-0.294-0.441-0.294-0.706s0.103-0.519 0.294-0.706c0.534-0.534 1.706-0.925 2.553-1.141-0.213 0.847-0.6 2.019-1.137 2.553zM1.294 17.706c-0.188-0.188-0.294-0.441-0.294-0.706s0.103-0.519 0.294-0.706c0 0 0 0 0.003-0.003 0.391-0.387 1.022-0.387 1.413 0.003 0.534 0.534 0.925 1.706 1.141 2.553-0.85-0.216-2.022-0.603-2.556-1.141zM8 22c0 0.266-0.103 0.519-0.294 0.706 0 0 0 0-0.003 0.003-0.391 0.387-1.022 0.387-1.413-0.003-0.534-0.534-0.925-1.706-1.141-2.553 0.847 0.216 2.019 0.603 2.553 1.141 0.194 0.188 0.297 0.441 0.297 0.706zM12 16c-1.462 0-2.875 0.222-4.203 0.663-0.247 0.081-0.487 0.172-0.725 0.266 0.097-0.237 0.184-0.481 0.266-0.731 0.438-1.325 0.659-2.737 0.659-4.197 0-1.462-0.222-2.875-0.663-4.203-0.081-0.247-0.172-0.487-0.266-0.725 0.237 0.097 0.481 0.184 0.731 0.266 1.325 0.438 2.738 0.659 4.197 0.659 1.463 0 2.875-0.222 4.203-0.663 0.247-0.081 0.487-0.172 0.725-0.266-0.097 0.237-0.184 0.481-0.266 0.731-0.438 1.325-0.659 2.738-0.659 4.197 0 1.463 0.222 2.875 0.663 4.203 0.081 0.247 0.172 0.487 0.266 0.725-0.237-0.097-0.481-0.184-0.731-0.266-1.325-0.438-2.737-0.659-4.197-0.659zM17.706 22.706c-0.387 0.387-1.022 0.391-1.413 0.003 0 0-0.003-0.003-0.003-0.003-0.391-0.391-0.391-1.025 0-1.416 0.534-0.534 1.706-0.925 2.553-1.141-0.213 0.85-0.6 2.022-1.137 2.556zM22.706 17.706c-0.534 0.534-1.706 0.925-2.553 1.141 0.216-0.847 0.603-2.019 1.141-2.553 0.194-0.194 0.45-0.294 0.706-0.294s0.513 0.097 0.706 0.294v0c0.391 0.391 0.391 1.025 0 1.413z" })
            );
        }
        function Quadcopter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( QuadcopterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Quadcopter.SVG = QuadcopterSVG;
        return Quadcopter;
    })();
export const QuestionCircle = /*#__PURE__*/ (() => {
        function QuestionCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M11 16h2v2h-2v-2z" }),
_('path', { d: "M14.731 6.837c-0.709-0.547-1.656-0.837-2.731-0.837s-2.019 0.291-2.731 0.837c-0.819 0.628-1.269 1.575-1.269 2.662v0.5h2v-0.5c0-1.353 1.4-1.5 2-1.5s2 0.147 2 1.5c0 0.781-0.419 1.131-1.222 1.728-0.391 0.291-0.794 0.591-1.125 0.991-0.434 0.525-0.653 1.125-0.653 1.781v1h2v-1c0-0.403 0.266-0.641 0.972-1.166 0.856-0.641 2.028-1.512 2.028-3.334 0-1.087-0.45-2.034-1.269-2.662z" })
            );
        }
        function QuestionCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( QuestionCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        QuestionCircle.SVG = QuestionCircleSVG;
        return QuestionCircle;
    })();
export const QuestionSquare = /*#__PURE__*/ (() => {
        function QuestionSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 16h2v2h-2v-2z" }),
_('path', { d: "M10 9.5c0-1.353 1.4-1.5 2-1.5s2 0.147 2 1.5c0 0.781-0.419 1.131-1.222 1.728-0.391 0.291-0.794 0.591-1.125 0.991-0.434 0.525-0.653 1.125-0.653 1.781v1h2v-1c0-0.403 0.266-0.641 0.972-1.166 0.856-0.641 2.028-1.512 2.028-3.334 0-1.088-0.45-2.034-1.269-2.662-0.709-0.547-1.656-0.837-2.731-0.837s-2.019 0.291-2.731 0.837c-0.819 0.628-1.269 1.575-1.269 2.663v0.5h2v-0.5z" }),
_('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" })
            );
        }
        function QuestionSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( QuestionSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        QuestionSquare.SVG = QuestionSquareSVG;
        return QuestionSquare;
    })();
export const Question = /*#__PURE__*/ (() => {
        function QuestionSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 20h2v2h-2v-2z" }),
_('path', { d: "M18.416 5.184c-0.369-0.709-0.903-1.322-1.587-1.816-1.241-0.897-2.909-1.369-4.828-1.369s-3.588 0.472-4.828 1.369c-0.684 0.494-1.219 1.106-1.587 1.816-0.387 0.747-0.584 1.587-0.584 2.503v1.313h2v-1.313c0-2.719 2.584-3.687 5-3.687s5 0.969 5 3.687c0 1.953-1.309 2.869-2.822 3.925-1.491 1.041-3.178 2.222-3.178 4.512v1.875h2v-1.875c0-1.188 0.881-1.866 2.322-2.872 1.638-1.144 3.678-2.569 3.678-5.566 0-0.916-0.197-1.756-0.584-2.503z" })
            );
        }
        function Question({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( QuestionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Question.SVG = QuestionSVG;
        return Question;
    })();
export const Quill = /*#__PURE__*/ (() => {
    function QuillSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.866 1.503c-0.178-0.312-0.506-0.503-0.866-0.503-2.319 0-4.803 0.503-7.178 1.45-2.463 0.984-4.803 2.45-6.769 4.237-2.163 1.969-3.866 4.294-5.066 6.906-1.319 2.881-1.987 6.047-1.987 9.406h2c0-2.288 0.328-4.319 0.869-6.113 1.131-1.9 2.109-1.906 3.856-1.919 1.644-0.012 3.687-0.028 6.244-1.688 2.822-1.831 5.731-5.359 8.894-10.778 0.181-0.309 0.184-0.691 0.003-1zM18.225 6.041c-1.266 0.112-3.844 0.525-6.012 2.050l-0.409 0.288 0.575 0.819 0.409-0.288c1.534-1.078 3.341-1.547 4.609-1.753-1.572 2.037-3.069 3.506-4.516 4.447-2.066 1.341-3.644 1.353-5.169 1.366-0.756 0.006-1.522 0.012-2.275 0.2 1.181-2.137 2.631-3.784 3.966-5 3.056-2.784 6.972-4.603 10.766-5.056-0.663 1.066-1.309 2.044-1.944 2.928z" })
        );
    }
    function Quill({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( QuillSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Quill.SVG = QuillSVG;
    return Quill;
})();
export const QuoteLeft = /*#__PURE__*/ (() => {
        function QuoteLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 10h-4.9c0.466-2.278 2.484-4 4.9-4h1v-2h-1c-1.869 0-3.628 0.728-4.95 2.050s-2.050 3.081-2.050 4.95v6c0 1.103 0.897 2 2 2h5c1.103 0 2-0.897 2-2v-5c0-1.103-0.897-2-2-2zM9 17h-5v-5h5v5z" }),
_('path', { d: "M20 10h-4.9c0.466-2.278 2.484-4 4.9-4h1v-2h-1c-1.869 0-3.628 0.728-4.95 2.050s-2.050 3.081-2.050 4.95v6c0 1.103 0.897 2 2 2h5c1.103 0 2-0.897 2-2v-5c0-1.103-0.897-2-2-2zM20 17h-5v-5h5v5z" })
            );
        }
        function QuoteLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( QuoteLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        QuoteLeft.SVG = QuoteLeftSVG;
        return QuoteLeft;
    })();
export const QuoteRight = /*#__PURE__*/ (() => {
        function QuoteRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 5h-5c-1.103 0-2 0.897-2 2v5c0 1.103 0.897 2 2 2h4.9c-0.466 2.278-2.484 4-4.9 4h-1v2h1c1.869 0 3.628-0.728 4.95-2.050s2.050-3.081 2.050-4.95v-6c0-1.103-0.897-2-2-2zM15 7h5v5h-5v-5z" }),
_('path', { d: "M9 5h-5c-1.103 0-2 0.897-2 2v5c0 1.103 0.897 2 2 2h4.9c-0.466 2.278-2.484 4-4.9 4h-1v2h1c1.869 0 3.628-0.728 4.95-2.050s2.050-3.081 2.050-4.95v-6c0-1.103-0.897-2-2-2zM4 7h5v5h-5v-5z" })
            );
        }
        function QuoteRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( QuoteRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        QuoteRight.SVG = QuoteRightSVG;
        return QuoteRight;
    })();
export const RadioChecked = /*#__PURE__*/ (() => {
        function RadioCheckedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M12 7c-2.756 0-5 2.244-5 5s2.244 5 5 5c2.756 0 5-2.244 5-5s-2.244-5-5-5zM12 15c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" })
            );
        }
        function RadioChecked({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RadioCheckedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        RadioChecked.SVG = RadioCheckedSVG;
        return RadioChecked;
    })();
export const RadioUnchecked = /*#__PURE__*/ (() => {
        function RadioUncheckedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" })
            );
        }
        function RadioUnchecked({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RadioUncheckedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        RadioUnchecked.SVG = RadioUncheckedSVG;
        return RadioUnchecked;
    })();
export const Radio = /*#__PURE__*/ (() => {
        function RadioSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 7h-4.744l-12.259-3.381c0.003-0.037 0.003-0.078 0.003-0.119 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5c0.422 0 0.806-0.175 1.078-0.459l8.916 2.459h-11.494c-1.103 0-2 0.897-2 2v11c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-11c0-1.103-0.897-2-2-2zM3.5 4c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5zM22 20h-20v-11h20v11z" }),
_('path', { d: "M15.5 19c2.481 0 4.5-2.019 4.5-4.5s-2.019-4.5-4.5-4.5-4.5 2.019-4.5 4.5c0 2.481 2.019 4.5 4.5 4.5zM16.547 11.159c0.381 0.119 0.734 0.303 1.047 0.537l-4.897 4.897c-0.234-0.312-0.419-0.666-0.537-1.047l4.387-4.388zM14.453 17.841c-0.381-0.119-0.734-0.303-1.047-0.537l4.897-4.897c0.234 0.312 0.419 0.666 0.537 1.047l-4.388 4.388zM15.712 17.994l3.281-3.281c-0.106 1.763-1.519 3.175-3.281 3.281zM15.288 11.006l-3.281 3.281c0.106-1.763 1.519-3.175 3.281-3.281z" }),
_('path', { d: "M5.5 15c1.378 0 2.5-1.122 2.5-2.5s-1.122-2.5-2.5-2.5-2.5 1.122-2.5 2.5 1.122 2.5 2.5 2.5zM5.5 11c0.653 0 1.209 0.419 1.416 1h-0.916v1h0.916c-0.206 0.581-0.762 1-1.416 1-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5z" }),
_('path', { d: "M3 18h2v1h-2v-1z" }),
_('path', { d: "M6 18h2v1h-2v-1z" })
            );
        }
        function Radio({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RadioSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Radio.SVG = RadioSVG;
        return Radio;
    })();
export const Rank = /*#__PURE__*/ (() => {
    function RankSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.684 9.272c-0.384-0.359-0.984-0.359-1.369 0-2.491 2.334-6.184 3.728-8.316 3.728v2c2.678 0 6.4-1.541 9-3.672 2.6 2.131 6.322 3.672 9 3.672v-2c-2.131 0-5.825-1.394-8.316-3.728z" })
        );
    }
    function Rank({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RankSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Rank.SVG = RankSVG;
    return Rank;
})();
export const Rank2 = /*#__PURE__*/ (() => {
        function Rank2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.316 11.272c-2.491 2.334-6.184 3.728-8.316 3.728v2c2.678 0 6.4-1.541 9-3.672 2.6 2.131 6.322 3.672 9 3.672v-2c-2.131 0-5.825-1.394-8.316-3.728-0.384-0.363-0.984-0.363-1.369 0z" }),
_('path', { d: "M12.684 7.272c-0.384-0.359-0.984-0.359-1.369 0-2.491 2.334-6.184 3.728-8.316 3.728v2c2.678 0 6.4-1.541 9-3.672 2.6 2.131 6.322 3.672 9 3.672v-2c-2.131 0-5.825-1.394-8.316-3.728z" })
            );
        }
        function Rank2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Rank2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Rank2.SVG = Rank2SVG;
        return Rank2;
    })();
export const Rank3 = /*#__PURE__*/ (() => {
        function Rank3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.316 13.272c-2.491 2.334-6.184 3.728-8.316 3.728v2c2.678 0 6.4-1.541 9-3.672 2.6 2.131 6.322 3.672 9 3.672v-2c-2.131 0-5.825-1.394-8.316-3.728-0.384-0.363-0.984-0.363-1.369 0z" }),
_('path', { d: "M11.316 9.272c-2.491 2.334-6.184 3.728-8.316 3.728v2c2.678 0 6.4-1.541 9-3.672 2.6 2.131 6.322 3.672 9 3.672v-2c-2.131 0-5.825-1.394-8.316-3.728-0.384-0.363-0.984-0.363-1.369 0z" }),
_('path', { d: "M12.684 5.272c-0.384-0.359-0.984-0.359-1.369 0-2.491 2.334-6.184 3.728-8.316 3.728v2c2.678 0 6.4-1.541 9-3.672 2.6 2.131 6.322 3.672 9 3.672v-2c-2.131 0-5.825-1.394-8.316-3.728z" })
            );
        }
        function Rank3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Rank3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Rank3.SVG = Rank3SVG;
        return Rank3;
    })();
export const Razor = /*#__PURE__*/ (() => {
    function RazorSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23 0.269c-0.462-0.266-1-0.338-1.516-0.2-0.497 0.131-0.912 0.441-1.181 0.875-0.084 0.112-0.359 0.481-0.797 1.056h-17.506c-1.103 0-2 0.897-2 2v2.5c0 0.275 0.225 0.5 0.5 0.5h8c1.356 0 2.103-0.547 2.763-1.028 0.684-0.5 1.331-0.972 2.737-0.972h3.162c-2.847 3.566-7.331 8.928-12.281 13.878-1.169 1.169-1.169 3.072 0 4.244 0.566 0.566 1.319 0.878 2.119 0.878s1.553-0.312 2.122-0.878c2.741-2.741 6.034-6.959 9.784-12.541 2.784-4.144 4.8-7.537 4.819-7.572l0.006-0.012c0.55-0.956 0.222-2.181-0.731-2.728zM14 4c-1.731 0-2.578 0.619-3.325 1.166-0.641 0.466-1.144 0.834-2.175 0.834h-7.5v-2c0-0.55 0.45-1 1-1h16.734c-0.237 0.306-0.497 0.641-0.781 1h-3.953zM7.709 21.706c-0.391 0.391-1.025 0.391-1.413 0-0.391-0.391-0.391-1.025 0-1.413 4.419-4.419 8.437-9.131 11.028-12.303 2.806-3.441 4.597-5.875 4.616-5.897l0.022-0.031c-0.631 1.053-8.156 13.547-14.253 19.644z" })
        );
    }
    function Razor({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RazorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Razor.SVG = RazorSVG;
    return Razor;
})();
export const RbFlaskWarning = /*#__PURE__*/ (() => {
        function RbFlaskWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 12h1v1h-1v-1z" }),
_('path', { d: "M17 7h1v4h-1v-4z" }),
_('path', { d: "M22.841 12.828l-4-7.997c-0.25-0.506-0.778-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-2.378 4.759c-0.547-0.409-1.15-0.747-1.781-1.003v-6.584h1v-2h-8v2h1v6.584c-1.328 0.541-2.509 1.441-3.381 2.591-1.059 1.397-1.619 3.066-1.619 4.825 0 2.138 0.831 4.147 2.344 5.656 1.512 1.512 3.519 2.344 5.656 2.344s4.147-0.831 5.656-2.344c1.512-1.512 2.344-3.519 2.344-5.656 0-0.334-0.022-0.669-0.063-1h4.563c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672zM9 22c-3.309 0-6-2.691-6-6 0-0.228 0.012-0.453 0.041-0.675 1.913-0.837 3.772 0.116 5.731 1.122 1.072 0.55 2.178 1.119 3.316 1.387 0.462 0.109 0.909 0.166 1.341 0.166 0.444 0 0.872-0.059 1.287-0.175-0.772 2.419-3.044 4.175-5.716 4.175zM15 16c0 0.228-0.012 0.453-0.038 0.675-1.912 0.841-3.772-0.112-5.734-1.119-1.072-0.55-2.178-1.119-3.316-1.388-0.934-0.222-1.803-0.222-2.625 0.009 0.597-1.85 2.075-3.356 3.997-3.925 0.425-0.125 0.716-0.516 0.716-0.959v-7.294h2v7.291c0 0.444 0.291 0.831 0.716 0.959 0.784 0.234 1.522 0.634 2.153 1.166l-0.706 1.413c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h1.416c0.053 0.328 0.081 0.666 0.081 1zM21.5 14h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5z" })
            );
        }
        function RbFlaskWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RbFlaskWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        RbFlaskWarning.SVG = RbFlaskWarningSVG;
        return RbFlaskWarning;
    })();
export const RbFlask = /*#__PURE__*/ (() => {
        function RbFlaskSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.381 11.175c-0.872-1.15-2.053-2.053-3.381-2.594v-6.581h1v-2h-8v2h1v6.584c-1.328 0.541-2.509 1.441-3.381 2.591-1.059 1.397-1.619 3.066-1.619 4.825 0 2.138 0.831 4.147 2.344 5.656 1.512 1.512 3.519 2.344 5.656 2.344s4.147-0.831 5.656-2.344c1.512-1.512 2.344-3.519 2.344-5.656 0-1.756-0.559-3.425-1.619-4.825zM10.284 10.25c0.425-0.125 0.716-0.516 0.716-0.959v-7.291h2v7.291c0 0.444 0.291 0.831 0.716 0.959 2.522 0.75 4.284 3.113 4.284 5.75 0 0.228-0.012 0.453-0.038 0.675-1.913 0.841-3.772-0.113-5.734-1.119-1.072-0.55-2.178-1.119-3.316-1.387-0.934-0.222-1.803-0.222-2.625 0.009 0.6-1.853 2.078-3.359 3.997-3.928zM12 22c-3.309 0-6-2.691-6-6 0-0.228 0.012-0.453 0.041-0.675 1.912-0.837 3.772 0.116 5.731 1.122 1.072 0.55 2.178 1.119 3.316 1.387 0.462 0.109 0.909 0.166 1.341 0.166 0.444 0 0.872-0.059 1.287-0.175-0.772 2.419-3.044 4.175-5.716 4.175z" }),
_('path', { d: "M16 16h1c0-2.756-2.244-5-5-5v1c2.206 0 4 1.794 4 4z" })
            );
        }
        function RbFlask({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RbFlaskSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        RbFlask.SVG = RbFlaskSVG;
        return RbFlask;
    })();
export const Read = /*#__PURE__*/ (() => {
    function ReadSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23 10.084v-3.084c0-0.3-0.134-0.584-0.366-0.775s-0.537-0.266-0.831-0.206c-2.163 0.434-4.094 1.053-5.747 1.838-0.559-0.25-1.147-0.45-1.75-0.591 1.025-0.725 1.694-1.919 1.694-3.266 0-2.206-1.794-4-4-4s-4 1.794-4 4c0 1.347 0.669 2.541 1.694 3.266-0.603 0.141-1.191 0.341-1.75 0.591-1.653-0.784-3.584-1.403-5.747-1.837-0.294-0.059-0.6 0.016-0.831 0.206s-0.366 0.475-0.366 0.775v3.084c-0.581 0.206-1 0.762-1 1.416v1c0 0.653 0.419 1.209 1 1.416v4.084c0 0.475 0.337 0.888 0.803 0.981 4.266 0.856 7.359 2.394 9.459 4.694 0.191 0.206 0.456 0.325 0.738 0.325s0.55-0.119 0.738-0.325c2.1-2.3 5.194-3.837 9.459-4.694 0.466-0.094 0.803-0.503 0.803-0.981v-4.084c0.581-0.206 1-0.762 1-1.416v-1c0-0.653-0.419-1.209-1-1.416zM9 4c0-1.653 1.347-3 3-3s3 1.347 3 3-1.347 3-3 3-3-1.347-3-3zM14.881 8.469c-1.075 0.612-2.041 1.319-2.881 2.109-0.844-0.791-1.806-1.497-2.881-2.109 0.912-0.309 1.887-0.469 2.881-0.469s1.969 0.159 2.881 0.469zM1 11.5c0-0.275 0.225-0.5 0.5-0.5h0.5c0.269 0 0.525 0.106 0.713 0.3 0.191 0.194 0.291 0.447 0.288 0.719-0.009 0.541-0.469 0.981-1.025 0.981h-0.475c-0.275 0-0.5-0.225-0.5-0.5v-1zM8.103 18.934c-1.481-0.722-3.197-1.306-5.103-1.744v-3.469c0.588-0.344 0.987-0.972 1-1.688 0.009-0.541-0.194-1.050-0.575-1.437-0.128-0.131-0.272-0.241-0.425-0.331v-2.022c3.491 0.853 6.119 2.219 8 4.15v8.328c-0.866-0.672-1.834-1.272-2.897-1.788zM15.897 18.934c-1.062 0.516-2.028 1.116-2.897 1.791v-8.328c1.881-1.931 4.509-3.297 8-4.15v2.022c-0.153 0.091-0.297 0.2-0.425 0.331-0.378 0.384-0.581 0.897-0.575 1.437 0.012 0.716 0.412 1.344 1 1.688v3.469c-1.906 0.434-3.622 1.019-5.103 1.741zM23 12.5c0 0.275-0.225 0.5-0.5 0.5h-0.475c-0.556 0-1.016-0.441-1.025-0.981-0.003-0.272 0.097-0.525 0.288-0.719s0.444-0.3 0.712-0.3h0.5c0.275 0 0.5 0.225 0.5 0.5v1z" })
        );
    }
    function Read({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ReadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Read.SVG = ReadSVG;
    return Read;
})();
export const Receipt = /*#__PURE__*/ (() => {
        function ReceiptSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 1h-14c-2.756 0-5 2.244-5 5v4.5c0 0.275 0.225 0.5 0.5 0.5h2c0.078 0 0.153-0.019 0.225-0.053l1.775-0.888 1.775 0.888c0.072 0.034 0.147 0.053 0.225 0.053s0.153-0.019 0.225-0.053l1.275-0.637v12.191c0 0.275 0.225 0.5 0.5 0.5h2c0.078 0 0.153-0.019 0.225-0.053l1.775-0.888 1.775 0.888c0.141 0.072 0.306 0.072 0.447 0l1.775-0.888 1.775 0.888c0.072 0.034 0.147 0.053 0.225 0.053s0.153-0.019 0.225-0.053l1.775-0.888 1.775 0.888c0.069 0.034 0.147 0.053 0.225 0.053h1c0.275 0 0.5-0.225 0.5-0.5v-16.5c0.003-2.756-2.241-5-4.997-5zM6.5 9.941l-1.775-0.888c-0.141-0.072-0.306-0.072-0.447 0l-1.897 0.947h-0.381v-4c0-1.653 1.347-3 3-3s3 1.347 3 3v3.191l-1.5 0.75zM20.275 21.053l-1.775 0.888-1.775-0.888c-0.141-0.072-0.306-0.072-0.447 0l-1.778 0.888-1.775-0.888c-0.141-0.072-0.306-0.072-0.447 0l-1.897 0.947h-0.381v-16c0-1.125-0.372-2.163-1.003-3h10.003c1.653 0 3 1.347 3 3v15.691l-1.275-0.637c-0.141-0.072-0.309-0.072-0.45 0z" }),
_('path', { d: "M12 6h8v1h-8v-1z" }),
_('path', { d: "M12 8h8v1h-8v-1z" }),
_('path', { d: "M17 10h-1v2h-0.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h2c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-3.5v1h2v2h1v-2h0.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-2c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3.5v-1h-2v-2z" })
            );
        }
        function Receipt({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ReceiptSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Receipt.SVG = ReceiptSVG;
        return Receipt;
    })();
export const Record = /*#__PURE__*/ (() => {
    function RecordSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19.072 4.928c-1.891-1.887-4.4-2.928-7.072-2.928s-5.181 1.041-7.072 2.928c-1.887 1.891-2.928 4.4-2.928 7.072s1.041 5.181 2.928 7.072c1.891 1.887 4.4 2.928 7.072 2.928s5.181-1.041 7.072-2.928c1.887-1.891 2.928-4.4 2.928-7.072s-1.041-5.181-2.928-7.072zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" })
        );
    }
    function Record({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RecordSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Record.SVG = RecordSVG;
    return Record;
})();
export const Recycle = /*#__PURE__*/ (() => {
        function RecycleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.572 16.456l-3.819-6.366-1.716 1.028 3.822 6.369c0.091 0.153 0.141 0.328 0.141 0.513 0 0.55-0.45 1-1 1h-7c-0.403 0-0.769 0.244-0.925 0.619s-0.069 0.803 0.216 1.091l3.25 3.25 1.416-1.416-1.541-1.544h4.584c1.653 0 3-1.347 3-3 0-0.547-0.147-1.081-0.428-1.544z" }),
_('path', { d: "M2 18c0-0.181 0.050-0.359 0.141-0.513 0 0 0-0.003 0.003-0.003l3.45-5.753c0.209-0.347 0.188-0.784-0.053-1.109s-0.653-0.472-1.047-0.375l-4.453 1.113 0.484 1.941 2.112-0.528-2.209 3.684c-0.281 0.462-0.428 0.997-0.428 1.544 0 1.653 1.347 3 3 3h7v-2h-7c-0.55 0-1-0.45-1-1z" }),
_('path', { d: "M11.141 2.487c0.184-0.306 0.506-0.488 0.859-0.488s0.675 0.181 0.859 0.488l3.488 5.816c0.181 0.303 0.509 0.484 0.856 0.484 0.050 0 0.097-0.003 0.147-0.009 0.4-0.059 0.725-0.353 0.822-0.747l1.116-4.453-1.941-0.484-0.528 2.112-2.247-3.75c-0.541-0.897-1.525-1.456-2.572-1.456s-2.031 0.559-2.572 1.456l-3.487 5.813 1.716 1.028 3.484-5.809z" }),
_('path', { d: "M12 3.472v0c-0.175 0-0.337 0.091-0.428 0.244l-8.119 13.528c-0.094 0.153-0.094 0.347-0.006 0.503s0.256 0.253 0.434 0.253h16.228c0.181 0 0.347-0.097 0.434-0.253s0.087-0.35-0.006-0.503l-8.109-13.528c-0.091-0.153-0.253-0.244-0.428-0.244zM4.766 17l7.234-12.056 7.228 12.056h-14.463z" })
            );
        }
        function Recycle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RecycleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Recycle.SVG = RecycleSVG;
        return Recycle;
    })();
export const Recycle2 = /*#__PURE__*/ (() => {
        function Recycle2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.572 16.456l-3.819-6.366-1.716 1.028 3.822 6.369c0.091 0.153 0.141 0.328 0.141 0.513 0 0.55-0.45 1-1 1h-4.587l1.541-1.544-1.416-1.413-3.244 3.25c-0.391 0.391-0.391 1.022 0 1.413l3.25 3.25 1.416-1.416-1.544-1.541h4.584c1.653 0 3-1.347 3-3 0-0.547-0.147-1.081-0.428-1.544z" }),
_('path', { d: "M2 18c0-0.181 0.050-0.359 0.141-0.513l2.213-3.687 0.528 2.112 1.941-0.484-1.113-4.453c-0.066-0.256-0.228-0.478-0.456-0.616s-0.5-0.178-0.756-0.113l-4.456 1.113 0.484 1.941 2.112-0.528-2.209 3.684c-0.281 0.462-0.428 0.997-0.428 1.544 0 1.653 1.347 3 3 3h7v-2h-7c-0.55 0-1-0.45-1-1z" }),
_('path', { d: "M12.506 7.644l4.453 1.116c0.081 0.019 0.162 0.031 0.244 0.031 0.178 0 0.356-0.047 0.516-0.144 0.228-0.138 0.391-0.356 0.456-0.616l1.116-4.453-1.941-0.484-0.528 2.112-2.25-3.75c-0.541-0.897-1.525-1.456-2.572-1.456s-2.031 0.559-2.572 1.456l-3.487 5.813 1.716 1.028 3.488-5.813c0.181-0.303 0.503-0.484 0.856-0.484s0.675 0.181 0.859 0.488l2.247 3.744-2.112-0.528-0.487 1.941z" })
            );
        }
        function Recycle2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Recycle2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Recycle2.SVG = Recycle2SVG;
        return Recycle2;
    })();
export const Redo = /*#__PURE__*/ (() => {
        function RedoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 6v3.059c-0.725-0.647-1.525-1.209-2.384-1.666-1.716-0.912-3.659-1.394-5.616-1.394-4.072 0-7.831 2.037-10.059 5.453l1.675 1.094c1.856-2.847 4.991-4.547 8.384-4.547 2.703 0 5.275 1.1 7.141 3h-4.141v2h6c0.553 0 1-0.447 1-1v-6h-2z" }),
_('path', { d: "M3 18h1c0-4.413 3.588-8 8-8v-1c-2.403 0-4.662 0.938-6.363 2.637s-2.637 3.959-2.637 6.363z" })
            );
        }
        function Redo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RedoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Redo.SVG = RedoSVG;
        return Redo;
    })();
export const Reel = /*#__PURE__*/ (() => {
        function ReelSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 3c-2.403 0-4.666 0.938-6.363 2.637v0c-1.7 1.697-2.637 3.959-2.637 6.363s0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363 0-1.703-0.472-3.337-1.35-4.747 2.303 1.194 2.581 3.491 2.853 5.728 0.153 1.266 0.3 2.463 0.819 3.387 0.616 1.097 1.653 1.631 3.178 1.631h0.5v-1h-0.5c-1.488 0-2.013-0.597-2.303-1.119-0.422-0.753-0.556-1.856-0.697-3.022-0.169-1.391-0.363-2.966-1.1-4.294-0.791-1.422-2.072-2.341-3.909-2.8-0.041-0.044-0.084-0.084-0.125-0.128-1.7-1.7-3.963-2.637-6.366-2.637zM13.95 16.95c-2.728 2.728-7.169 2.728-9.9 0-1.366-1.366-2.047-3.156-2.047-4.95s0.681-3.584 2.047-4.95c2.728-2.728 7.169-2.728 9.9 0 2.728 2.728 2.728 7.172 0 9.9z" }),
_('path', { d: "M8 12c0 0.55 0.45 1 1 1s1-0.45 1-1c0-0.55-0.45-1-1-1s-1 0.45-1 1zM9 12c0 0 0 0 0 0v0z" }),
_('path', { d: "M6.762 13.472c0.041-0.006 0.084-0.016 0.122-0.034 0.194-0.078 0.312-0.266 0.312-0.462 0-0.063-0.012-0.125-0.034-0.184l-0.006-0.016c-0.003-0.006-0.003-0.009-0.006-0.016-0.1-0.244-0.15-0.5-0.15-0.756 0-0.262 0.050-0.522 0.153-0.766 0.050-0.122 0.050-0.259 0-0.384-0.050-0.122-0.147-0.219-0.272-0.272l-2.772-1.147c-0.25-0.103-0.534 0.009-0.647 0.256l-0.016 0.034c-0.003 0.006-0.006 0.012-0.006 0.019-0.591 1.444-0.584 3.103 0.016 4.553 0.106 0.256 0.397 0.375 0.653 0.272l2.653-1.097zM4.212 10.563l1.866 0.772c-0.1 0.438-0.1 0.897 0 1.338l-1.863 0.772c-0.284-0.938-0.284-1.95-0.003-2.881z" }),
_('path', { d: "M10.437 14.116c-0.103-0.253-0.394-0.378-0.647-0.275l-0.016 0.006c-0.006 0.003-0.009 0.003-0.016 0.006-0.244 0.1-0.5 0.15-0.756 0.15-0.262 0-0.522-0.050-0.766-0.153-0.122-0.050-0.259-0.050-0.384 0s-0.219 0.147-0.272 0.272l-1.144 2.769c-0.103 0.25 0.009 0.534 0.256 0.647l0.034 0.016c0.006 0.003 0.012 0.006 0.019 0.006 1.444 0.591 3.103 0.584 4.553-0.016 0.194-0.081 0.309-0.266 0.309-0.462 0-0.063-0.012-0.128-0.038-0.191l-1.097-2.653c-0.009-0.041-0.022-0.081-0.037-0.122zM10.444 16.788c-0.938 0.281-1.947 0.281-2.881 0.003l0.772-1.866c0.219 0.050 0.444 0.075 0.669 0.075s0.45-0.025 0.669-0.075l0.772 1.863z" }),
_('path', { d: "M11.238 10.528c-0.041 0.006-0.084 0.016-0.122 0.034-0.253 0.103-0.378 0.394-0.275 0.647l0.006 0.016c0.003 0.006 0.003 0.009 0.006 0.016 0.1 0.244 0.15 0.5 0.15 0.756 0 0.263-0.050 0.522-0.153 0.766-0.050 0.122-0.050 0.259 0 0.384 0.050 0.122 0.147 0.219 0.272 0.272l2.769 1.144c0.25 0.103 0.534-0.009 0.647-0.256l0.016-0.034c0.003-0.006 0.006-0.012 0.006-0.019 0.294-0.716 0.438-1.484 0.438-2.253 0-0.784-0.153-1.569-0.456-2.3-0.106-0.256-0.397-0.375-0.653-0.272l-2.65 1.1zM13.788 13.437l-1.866-0.772c0.1-0.438 0.1-0.897 0-1.338l1.863-0.772c0.284 0.938 0.284 1.95 0.003 2.881z" }),
_('path', { d: "M11.306 6.462l-0.034-0.016c-0.006-0.003-0.012-0.006-0.019-0.006-1.444-0.591-3.103-0.584-4.553 0.016-0.256 0.106-0.375 0.397-0.272 0.653l1.097 2.653c0.006 0.041 0.016 0.084 0.034 0.125 0.103 0.253 0.394 0.378 0.65 0.275l0.016-0.006c0.006-0.003 0.009-0.003 0.016-0.006 0.244-0.1 0.5-0.15 0.756-0.15 0.262 0 0.522 0.050 0.766 0.153 0.122 0.050 0.259 0.050 0.384 0 0.122-0.050 0.219-0.147 0.272-0.272l1.147-2.772c0.025-0.063 0.037-0.128 0.037-0.191-0.003-0.191-0.112-0.372-0.297-0.456zM10.437 7.212l-0.772 1.866c-0.219-0.050-0.444-0.075-0.669-0.075s-0.45 0.025-0.669 0.075l-0.772-1.863c0.938-0.284 1.95-0.284 2.881-0.003z" })
            );
        }
        function Reel({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ReelSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Reel.SVG = ReelSVG;
        return Reel;
    })();
export const Reflection = /*#__PURE__*/ (() => {
    function ReflectionSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 10v-2.5c0-0.275-0.225-0.5-0.5-0.5h-2.5v1h1.294l-7.794 7.794-1.794-1.794 5.294-5.294v1.294h1v-2.5c0-0.275-0.225-0.5-0.5-0.5h-2.5v1h1.294l-5.294 5.294-10.5-10.5-0.706 0.706 10.5 10.5-1.794 1.794-8-8-0.706 0.706 8 8-1.794 1.794-5.5-5.5-0.706 0.706 5.5 5.5h-6.294v2h24v-2h-6.294l5.294-5.294v1.294h1v-2.5c0-0.275-0.225-0.5-0.5-0.5h-2.5v1h1.294l-5.294 5.294-1.794-1.794 7.794-7.794v1.294h1zM12 14.706l1.794 1.794-1.794 1.794-1.794-1.794 1.794-1.794zM9.5 17.206l1.794 1.794h-3.588l1.794-1.794zM16.294 19h-3.588l1.794-1.794 1.794 1.794z" })
        );
    }
    function Reflection({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ReflectionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Reflection.SVG = ReflectionSVG;
    return Reflection;
})();
export const RefreshLocked = /*#__PURE__*/ (() => {
        function RefreshLockedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 7c-1.653 0-3 1.347-3 3v1h-0.5c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5h7c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5h-0.5v-1c0-1.653-1.347-3-3-3zM10 10c0-1.103 0.897-2 2-2s2 0.897 2 2v1h-4v-1zM15 15h-6v-3h6v3z" }),
_('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813s-2.384-1.966-3.813-2.572c-1.481-0.625-3.053-0.944-4.672-0.944-1.956 0-3.9 0.481-5.616 1.394-0.856 0.456-1.659 1.016-2.384 1.666v-3.059h-2v6c0 0.553 0.447 1 1 1h6v-2h-4.141c1.866-1.9 4.437-3 7.141-3 5.513 0 10 4.488 10 10s-4.488 10-10 10c-3.394 0-6.528-1.7-8.384-4.547l-1.675 1.094c2.228 3.416 5.988 5.453 10.059 5.453 1.619 0 3.191-0.319 4.672-0.944 1.428-0.603 2.712-1.469 3.813-2.572s1.966-2.384 2.572-3.813c0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672z" }),
_('path', { d: "M4 12h-1c0 2.403 0.938 4.662 2.637 6.363s3.959 2.637 6.363 2.637c2.403 0 4.662-0.938 6.363-2.637s2.637-3.959 2.637-6.363c0-2.403-0.938-4.662-2.637-6.363s-3.959-2.637-6.363-2.637v1c4.413 0 8 3.588 8 8s-3.588 8-8 8c-4.413 0-8-3.588-8-8z" })
            );
        }
        function RefreshLocked({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RefreshLockedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        RefreshLocked.SVG = RefreshLockedSVG;
        return RefreshLocked;
    })();
export const Refrigerator = /*#__PURE__*/ (() => {
        function RefrigeratorSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 0h-12c-1.103 0-2 0.897-2 2v19c0 1.103 0.897 2 2 2v1h2v-1h8v1h2v-1c1.103 0 2-0.897 2-2v-19c0-1.103-0.897-2-2-2zM6 2h5v19h-5v-19zM18 21h-6v-19h6v19c0 0 0 0 0 0z" }),
_('path', { d: "M9 9h1v7h-1v-7z" }),
_('path', { d: "M13 9h1v7h-1v-7z" })
            );
        }
        function Refrigerator({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RefrigeratorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Refrigerator.SVG = RefrigeratorSVG;
        return Refrigerator;
    })();
export const Refund = /*#__PURE__*/ (() => {
        function RefundSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813s-2.384-1.966-3.813-2.572c-1.481-0.625-3.053-0.944-4.672-0.944-1.956 0-3.9 0.481-5.616 1.394-0.856 0.456-1.659 1.016-2.384 1.666v-3.059h-2v6c0 0.553 0.447 1 1 1h6v-2h-4.141c1.866-1.9 4.437-3 7.141-3 5.513 0 10 4.488 10 10s-4.488 10-10 10c-3.394 0-6.528-1.7-8.384-4.547l-1.675 1.094c2.228 3.416 5.988 5.453 10.059 5.453 1.619 0 3.191-0.319 4.672-0.944 1.428-0.603 2.712-1.469 3.813-2.572s1.966-2.384 2.572-3.813c0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672z" }),
_('path', { d: "M4 12h-1c0 2.403 0.938 4.662 2.637 6.363s3.959 2.637 6.363 2.637c2.403 0 4.662-0.938 6.363-2.637s2.637-3.959 2.637-6.363c0-2.403-0.938-4.662-2.637-6.363s-3.959-2.637-6.363-2.637v1c4.413 0 8 3.588 8 8s-3.588 8-8 8c-4.413 0-8-3.588-8-8z" }),
_('path', { d: "M11.819 14.978c-0.828 0.109-1.831-0.222-2.053-1.050l-0.966 0.259c0.284 1.056 1.212 1.631 2.2 1.775v2.037h1v-2.037c0.528-0.078 0.991-0.272 1.341-0.566 0.431-0.363 0.659-0.847 0.659-1.397 0-0.666-0.294-1.175-0.878-1.506-0.444-0.253-0.991-0.372-1.519-0.484-1.116-0.241-1.603-0.406-1.603-1.009 0-0.784 0.984-0.953 1.181-0.978 0.828-0.109 1.831 0.222 2.053 1.050l0.966-0.259c-0.284-1.056-1.212-1.631-2.203-1.775v-2.037h-1v2.037c-0.528 0.078-0.991 0.272-1.341 0.566-0.428 0.363-0.656 0.847-0.656 1.397 0 0.666 0.294 1.172 0.875 1.503 0.441 0.253 0.987 0.369 1.519 0.484 1.116 0.241 1.606 0.406 1.606 1.013 0 0.784-0.984 0.953-1.181 0.978z" })
            );
        }
        function Refund({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RefundSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Refund.SVG = RefundSVG;
        return Refund;
    })();
export const Register = /*#__PURE__*/ (() => {
        function RegisterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 10.916c0-0.509-0.2-0.991-0.563-1.353-0.663-0.663-1.694-0.738-2.438-0.225v-7.338c0-1.103-0.897-2-2-2h-13c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h13c1.103 0 2-0.897 2-2v-7.294l2.438-2.438c0.363-0.363 0.563-0.844 0.563-1.353zM14.753 18.541l-1.616 0.322 0.322-1.616 6.041-6.041 1.294 1.294-6.041 6.041zM5 22v-20h13v9.294l-5.353 5.353c-0.069 0.069-0.119 0.159-0.138 0.256l-0.5 2.5c-0.031 0.162 0.019 0.334 0.138 0.453 0.094 0.094 0.222 0.147 0.353 0.147 0.031 0 0.066-0.003 0.097-0.009l2.5-0.5c0.097-0.019 0.184-0.066 0.256-0.138l2.647-2.647v5.291h-13zM21.731 11.562l-0.231 0.231-1.294-1.294 0.231-0.231c0.356-0.356 0.938-0.356 1.294 0 0.172 0.172 0.269 0.403 0.269 0.647s-0.097 0.472-0.269 0.647z" }),
_('path', { d: "M15 5h-8v-1h8v1zM16.175 6h-9.175v1h9.175v-1zM14 8h-7v1h7v-1zM16 10h-9v1h9v-1zM12 12h-5v1h5v-1z" }),
_('path', { d: "M7 19h4v1h-4v-1z" })
            );
        }
        function Register({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RegisterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Register.SVG = RegisterSVG;
        return Register;
    })();
export const Reminder = /*#__PURE__*/ (() => {
    function ReminderSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18.5 9c-0.087 0-0.172 0.003-0.256 0.009-0.55-0.619-1.353-1.009-2.244-1.009-0.237 0-0.469 0.028-0.697 0.081-0.55-0.659-1.378-1.081-2.303-1.081v-0.084c0.581-0.206 1-0.762 1-1.416s-0.419-1.209-1-1.416v-0.084c0-1.653-1.347-3-3-3s-3 1.347-3 3v0.084c-0.266 0.094-0.497 0.263-0.672 0.478-0.825-0.669-1.85-0.631-2.922-0.588-0.291 0.012-0.594 0.025-0.906 0.025h-0.5v1h0.5c0.334 0 0.644-0.012 0.947-0.025 0.803-0.031 1.372-0.041 1.819 0.119-0.925 0.156-1.628 0.513-2.134 1.069l-0.337 0.369 0.741 0.672 0.338-0.369c0.453-0.5 1.181-0.772 2.219-0.825 0.153 0.422 0.487 0.753 0.909 0.903v5.234l-1.128-0.738c-0.406-0.266-0.881-0.409-1.372-0.409-1.378 0-2.5 1.119-2.5 2.497 0 0.541 0.172 1.059 0.497 1.497 0 0.003 0.003 0.003 0.003 0.006l4.525 6.034c0.922 1.228 2.394 1.962 3.934 1.962h4.887c1.85 0 3.525-1.019 4.372-2.656 0 0 0-0.003 0-0.003 1.166-2.259 1.781-4.8 1.781-7.338v-0.5c0-1.931-1.569-3.5-3.5-3.5zM10 3c0.55 0 1 0.45 1 1h-2c0-0.55 0.45-1 1-1zM7.5 5h5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-5c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5zM20 13c0 2.222-0.537 4.444-1.556 6.425-0.503 0.972-1.497 1.575-2.597 1.575h-4.887c-0.916 0-1.788-0.434-2.334-1.163l-4.522-6.031c-0.047-0.063-0.103-0.169-0.103-0.306 0-0.275 0.225-0.497 0.5-0.497 0.1 0 0.194 0.028 0.275 0.081l2.678 1.753c0.306 0.2 0.7 0.219 1.022 0.044s0.525-0.513 0.525-0.881v-7h2v5h1v-2c0-0.175 0.047-0.35 0.134-0.5 0.075-0.131 0.181-0.247 0.309-0.331v0c0.166-0.109 0.359-0.169 0.556-0.169 0.55 0 1 0.45 1 1v2h1v-1c0-0.175 0.047-0.35 0.134-0.5 0.075-0.131 0.181-0.247 0.309-0.331v0c0.166-0.109 0.359-0.169 0.556-0.169 0.55 0 1 0.45 1 1v2h1v-1.912c0.159-0.056 0.328-0.087 0.5-0.087 0.828 0 1.5 0.672 1.5 1.5v0.5z" })
        );
    }
    function Reminder({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ReminderSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Reminder.SVG = ReminderSVG;
    return Reminder;
})();
export const RemoteControl = /*#__PURE__*/ (() => {
        function RemoteControlSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.969 7.756c-0.084-0.331-0.328-0.597-0.653-0.706l-3-1c-0.472-0.156-0.987 0.056-1.209 0.5l-0.725 1.45h-4.381v-8h-2v8h-4.381l-0.725-1.447c-0.222-0.444-0.738-0.659-1.209-0.5l-3 1c-0.328 0.109-0.578 0.381-0.656 0.719-1.372 5.772-1.369 9.291 0.006 14.484 0.087 0.325 0.331 0.588 0.65 0.694l3 1c0.472 0.156 0.987-0.056 1.209-0.5l0.725-1.447h10.763l0.725 1.447c0.172 0.347 0.525 0.553 0.894 0.553 0.106 0 0.213-0.016 0.316-0.050l3-1c0.325-0.109 0.572-0.375 0.653-0.706 1.372-5.487 1.372-9.006 0-14.491zM10 10h4v0.5c0 0.275-0.225 0.5-0.5 0.5h-3c-0.275 0-0.5-0.225-0.5-0.5v-0.5zM21.159 21.225l-1.653 0.55-0.612-1.225c-0.169-0.337-0.516-0.553-0.894-0.553h-12c-0.378 0-0.725 0.213-0.894 0.553l-0.612 1.225-1.662-0.553c-1.116-4.434-1.113-7.5 0.016-12.453l1.647-0.55 0.612 1.225c0.169 0.337 0.516 0.553 0.894 0.553h3v0.5c0 0.828 0.672 1.5 1.5 1.5h3c0.828 0 1.5-0.672 1.5-1.5v-0.5h3c0.378 0 0.725-0.213 0.894-0.553l0.612-1.225 1.653 0.55c1.122 4.7 1.122 7.763 0 12.456z" }),
_('path', { d: "M17.5 12c-1.931 0-3.5 1.569-3.5 3.5s1.569 3.5 3.5 3.5 3.5-1.569 3.5-3.5-1.569-3.5-3.5-3.5zM17.5 18c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5c0.509 0 0.981 0.153 1.378 0.416l-2.084 2.084 0.706 0.706 2.084-2.084c0.262 0.397 0.416 0.869 0.416 1.378 0 1.378-1.122 2.5-2.5 2.5z" }),
_('path', { d: "M6.5 12c-1.931 0-3.5 1.569-3.5 3.5s1.569 3.5 3.5 3.5 3.5-1.569 3.5-3.5-1.569-3.5-3.5-3.5zM6.5 18c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5c1.206 0 2.219 0.859 2.45 2h-2.95v1h2.95c-0.231 1.141-1.244 2-2.45 2z" }),
_('path', { d: "M11 14h2v1h-2v-1z" }),
_('path', { d: "M11 16h2v1h-2v-1z" })
            );
        }
        function RemoteControl({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RemoteControlSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        RemoteControl.SVG = RemoteControlSVG;
        return RemoteControl;
    })();
export const RemoteControl2 = /*#__PURE__*/ (() => {
        function RemoteControl2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9.878 7.878c1.169-1.169 3.072-1.169 4.244 0l0.353 0.353 0.706-0.706-0.353-0.353c-1.559-1.559-4.097-1.559-5.656 0l-0.353 0.353 0.706 0.706 0.353-0.353z" }),
_('path', { d: "M12 3c-1.869 0-3.628 0.728-4.95 2.050l-0.353 0.353 0.706 0.706 0.353-0.353c2.337-2.337 6.147-2.337 8.487 0l0.353 0.353 0.706-0.706-0.353-0.353c-1.322-1.322-3.081-2.050-4.95-2.050z" }),
_('path', { d: "M19.069 2.928c-1.887-1.887-4.4-2.928-7.069-2.928s-5.184 1.041-7.072 2.928l-0.353 0.353 0.706 0.706 0.353-0.353c3.509-3.509 9.219-3.509 12.728 0l0.353 0.353 0.706-0.706-0.353-0.353z" }),
_('path', { d: "M15 10h-6c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h6c1.103 0 2-0.897 2-2v-10c0-1.103-0.897-2-2-2zM15 22h-6v-10h6v10c0 0 0 0 0 0z" }),
_('path', { d: "M12 13c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12 16c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M11 20h2v1h-2v-1z" })
            );
        }
        function RemoteControl2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RemoteControl2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        RemoteControl2.SVG = RemoteControl2SVG;
        return RemoteControl2;
    })();
export const RepeatInfinite = /*#__PURE__*/ (() => {
        function RepeatInfiniteSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 6h18.584l-1.544 1.544 1.416 1.416 3.25-3.25c0.391-0.391 0.391-1.025 0-1.416l-3.25-3.25-1.416 1.416 1.544 1.544h-18.584c-1.103 0-2 0.897-2 2v8h2v-8.003z" }),
_('path', { d: "M22 18h-18.584l1.544-1.544-1.416-1.416-3.25 3.25c-0.391 0.391-0.391 1.025 0 1.416l3.25 3.25 1.416-1.416-1.544-1.541h18.584c1.103 0 2-0.897 2-2v-8h-2v8z" }),
_('path', { d: "M16.194 9.113c-0.453-0.153-1.191-0.228-2.134 0.275-0.669 0.356-1.359 0.963-2.059 1.8-0.7-0.837-1.391-1.441-2.059-1.8-0.944-0.503-1.681-0.428-2.134-0.275-0.559 0.188-1.031 0.594-1.359 1.175-0.288 0.506-0.447 1.109-0.447 1.703v0.006c0 0.594 0.159 1.197 0.447 1.703 0.331 0.581 0.8 0.987 1.359 1.175 0.453 0.153 1.191 0.228 2.134-0.275 0.669-0.356 1.359-0.963 2.059-1.8 0.7 0.837 1.391 1.441 2.059 1.8 0.55 0.294 1.028 0.391 1.422 0.391 0.284 0 0.522-0.050 0.712-0.112 0.559-0.188 1.031-0.594 1.359-1.175 0.288-0.506 0.447-1.109 0.447-1.703v-0.006c0-0.594-0.159-1.197-0.447-1.703-0.328-0.581-0.8-0.987-1.359-1.178zM8.519 13.994c-0.138 0-0.269-0.022-0.394-0.063-0.731-0.247-1.125-1.178-1.125-1.931v-0.006c0-0.753 0.394-1.688 1.125-1.931 0.125-0.041 0.256-0.063 0.394-0.063 0.8 0 1.806 0.703 2.85 1.997-1.044 1.297-2.050 1.997-2.85 1.997zM17 12c0 0.753-0.394 1.688-1.125 1.931-0.85 0.284-2.022-0.419-3.244-1.934 1.222-1.519 2.394-2.222 3.244-1.934 0.731 0.247 1.125 1.178 1.125 1.931v0.006z" })
            );
        }
        function RepeatInfinite({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RepeatInfiniteSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        RepeatInfinite.SVG = RepeatInfiniteSVG;
        return RepeatInfinite;
    })();
export const RepeatOnce = /*#__PURE__*/ (() => {
        function RepeatOnceSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 6h18.584l-1.544 1.544 1.416 1.416 3.25-3.25c0.391-0.391 0.391-1.025 0-1.416l-3.25-3.25-1.416 1.416 1.544 1.544h-18.584c-1.103 0-2 0.897-2 2v8h2v-8.003z" }),
_('path', { d: "M22 18h-18.584l1.544-1.544-1.416-1.416-3.25 3.25c-0.391 0.391-0.391 1.025 0 1.416l3.25 3.25 1.416-1.416-1.544-1.541h18.584c1.103 0 2-0.897 2-2v-8h-2v8z" }),
_('path', { d: "M13 15v-5.5c0-0.203-0.122-0.384-0.309-0.462s-0.403-0.034-0.544 0.109l-1.353 1.353 0.706 0.706 0.5-0.5v4.294h1z" })
            );
        }
        function RepeatOnce({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RepeatOnceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        RepeatOnce.SVG = RepeatOnceSVG;
        return RepeatOnce;
    })();
export const Repeat = /*#__PURE__*/ (() => {
        function RepeatSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 6h18.584l-1.544 1.544 1.416 1.416 3.25-3.25c0.391-0.391 0.391-1.025 0-1.416l-3.25-3.25-1.416 1.416 1.544 1.544h-18.584c-1.103 0-2 0.897-2 2v8h2v-8.003z" }),
_('path', { d: "M22 18h-18.584l1.544-1.544-1.416-1.416-3.25 3.25c-0.391 0.391-0.391 1.025 0 1.416l3.25 3.25 1.416-1.416-1.544-1.541h18.584c1.103 0 2-0.897 2-2v-8h-2v8z" })
            );
        }
        function Repeat({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RepeatSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Repeat.SVG = RepeatSVG;
        return Repeat;
    })();
export const ReplyAll = /*#__PURE__*/ (() => {
        function ReplyAllSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.95 11.050c-1.322-1.322-3.081-2.050-4.95-2.050h-8.584l4.544-4.544-1.416-1.416-6.25 6.25c-0.391 0.391-0.391 1.025 0 1.416l6.25 6.25 1.416-1.416-4.544-4.541h8.584c2.756 0 5 2.244 5 5v5h2v-5c0-1.869-0.728-3.628-2.050-4.95z" }),
_('path', { d: "M7.956 4.456l-1.416-1.416-6.25 6.25c-0.391 0.391-0.391 1.025 0 1.416l6.25 6.25 1.416-1.416-5.541-5.541 5.541-5.544z" })
            );
        }
        function ReplyAll({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ReplyAllSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ReplyAll.SVG = ReplyAllSVG;
        return ReplyAll;
    })();
export const Reply = /*#__PURE__*/ (() => {
    function ReplySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 9h-9.584l4.544-4.544-1.416-1.416-6.25 6.25c-0.391 0.391-0.391 1.025 0 1.416l6.25 6.25 1.416-1.416-4.544-4.541h9.584c2.756 0 5 2.244 5 5v5h2v-5c0-3.859-3.141-7-7-7z" })
        );
    }
    function Reply({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ReplySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Reply.SVG = ReplySVG;
    return Reply;
})();
export const Resistor = /*#__PURE__*/ (() => {
    function ResistorSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.041 9h-0.166c-0.444-1.722-2.013-3-3.875-3-1.609 0-2.266 0.262-2.959 0.606-0.425 0.213-0.794 0.394-2.041 0.394-1.456 0-2.056-0.244-2.691-0.503-0.572-0.234-1.222-0.497-2.309-0.497-1.859 0-3.428 1.278-3.875 3h-0.125c-1.653 0-3 1.347-3 3v6h1v-6c0-1.103 0.897-2 2-2 0 2.206 1.794 4 4 4 1.091 0 1.737-0.266 2.309-0.497 0.634-0.259 1.231-0.503 2.691-0.503 1.247 0 1.616 0.181 2.041 0.394 0.691 0.344 1.35 0.606 2.959 0.606 2.206 0 4-1.794 4-4h0.041c1.103 0 2 0.897 2 2v6h1v-6c0-1.653-1.347-3-3-3zM15 8.363c0.263-0.128 0.522-0.244 1-0.309v3.891c-0.478-0.066-0.738-0.178-1-0.309v-3.272zM5 10c0-1.103 0.897-2 2-2v4c-1.103 0-2-0.897-2-2zM8.556 11.65c-0.197 0.081-0.372 0.153-0.556 0.209v-3.719c0.184 0.056 0.359 0.128 0.556 0.209 0.709 0.291 1.597 0.65 3.444 0.65 0.916 0 1.522-0.087 2-0.225v2.45c-0.478-0.138-1.084-0.225-2-0.225-1.85 0-2.734 0.359-3.444 0.65zM17 12v-4c1.103 0 2 0.897 2 2s-0.897 2-2 2z" })
        );
    }
    function Resistor({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ResistorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Resistor.SVG = ResistorSVG;
    return Resistor;
})();
export const Resize = /*#__PURE__*/ (() => {
        function ResizeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 8v1.294l-4.294-4.294h1.294v-1h-2.5c-0.275 0-0.5 0.225-0.5 0.5v2.5h1v-1.294l4.294 4.294h-1.294v1h2.5c0.275 0 0.5-0.225 0.5-0.5v-2.5h-1z" }),
_('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM2 2h20v10h-8c-1.103 0-2 0.897-2 2v8h-10v-20zM22 22h-8v-8h8v8c0 0 0 0 0 0z" })
            );
        }
        function Resize({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ResizeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Resize.SVG = ResizeSVG;
        return Resize;
    })();
export const Rewind10S = /*#__PURE__*/ (() => {
        function Rewind10SSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813s-2.384-1.966-3.813-2.572c-1.481-0.625-3.053-0.944-4.672-0.944-1.956 0-3.9 0.481-5.616 1.394-0.856 0.456-1.659 1.016-2.384 1.666v-3.059h-2v6c0 0.553 0.447 1 1 1h6v-2h-4.141c1.866-1.9 4.437-3 7.141-3 5.513 0 10 4.488 10 10s-4.488 10-10 10c-3.394 0-6.528-1.7-8.384-4.547l-1.675 1.094c2.228 3.416 5.988 5.453 10.059 5.453 1.619 0 3.191-0.319 4.672-0.944 1.428-0.603 2.712-1.469 3.813-2.572s1.966-2.384 2.572-3.813c0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672z" }),
_('path', { d: "M4 12h-1c0 2.403 0.938 4.662 2.637 6.363s3.959 2.637 6.363 2.637c2.403 0 4.662-0.938 6.363-2.637s2.637-3.959 2.637-6.363c0-2.403-0.938-4.662-2.637-6.363s-3.959-2.637-6.363-2.637v1c4.413 0 8 3.588 8 8s-3.588 8-8 8c-4.413 0-8-3.588-8-8z" }),
_('path', { d: "M13.5 16c0.706 0 1.356-0.391 1.831-1.1 0.431-0.647 0.669-1.5 0.669-2.4s-0.237-1.75-0.669-2.4c-0.475-0.709-1.125-1.1-1.831-1.1s-1.356 0.391-1.831 1.1c-0.431 0.65-0.669 1.5-0.669 2.4s0.237 1.75 0.669 2.4c0.475 0.709 1.125 1.1 1.831 1.1zM13.5 10c0.813 0 1.5 1.144 1.5 2.5s-0.687 2.5-1.5 2.5-1.5-1.144-1.5-2.5 0.687-2.5 1.5-2.5z" }),
_('path', { d: "M10 16v-6.5c0-0.203-0.122-0.384-0.309-0.462s-0.403-0.034-0.544 0.109l-1.353 1.353 0.706 0.706 0.5-0.5v5.294h1z" })
            );
        }
        function Rewind10S({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Rewind10SSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Rewind10S.SVG = Rewind10SSVG;
        return Rewind10S;
    })();
export const Rewind5S = /*#__PURE__*/ (() => {
        function Rewind5SSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813s-2.384-1.966-3.813-2.572c-1.481-0.625-3.053-0.944-4.672-0.944-1.956 0-3.9 0.481-5.616 1.394-0.856 0.456-1.659 1.016-2.384 1.666v-3.059h-2v6c0 0.553 0.447 1 1 1h6v-2h-4.141c1.866-1.9 4.437-3 7.141-3 5.513 0 10 4.488 10 10s-4.488 10-10 10c-3.394 0-6.528-1.7-8.384-4.547l-1.675 1.094c2.228 3.416 5.988 5.453 10.059 5.453 1.619 0 3.191-0.319 4.672-0.944 1.428-0.603 2.712-1.469 3.813-2.572s1.966-2.384 2.572-3.813c0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672z" }),
_('path', { d: "M4 12h-1c0 2.403 0.938 4.662 2.637 6.363s3.959 2.637 6.363 2.637c2.403 0 4.662-0.938 6.363-2.637s2.637-3.959 2.637-6.363c0-2.403-0.938-4.662-2.637-6.363s-3.959-2.637-6.363-2.637v1c4.413 0 8 3.588 8 8s-3.588 8-8 8c-4.413 0-8-3.588-8-8z" }),
_('path', { d: "M13 10v-1h-3c-0.244 0-0.453 0.178-0.494 0.419l-0.5 3c-0.025 0.144 0.016 0.294 0.113 0.406s0.234 0.178 0.381 0.178h0.269c0.178 0 0.344-0.097 0.434-0.25 0.266-0.462 0.762-0.75 1.297-0.75 0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5c-0.531 0-1.028-0.288-1.3-0.75l-0.25-0.431-0.866 0.503 0.25 0.431c0.447 0.769 1.278 1.25 2.163 1.25 1.378 0 2.5-1.122 2.5-2.5s-1.122-2.5-2.5-2.5c-0.469 0-0.919 0.131-1.303 0.369l0.228-1.369h2.578z" })
            );
        }
        function Rewind5S({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Rewind5SSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Rewind5S.SVG = Rewind5SSVG;
        return Rewind5S;
    })();
export const Ring = /*#__PURE__*/ (() => {
        function RingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.819 6.181l2.059-2.353c0.134-0.153 0.162-0.372 0.072-0.553l-1-2c-0.084-0.169-0.259-0.275-0.447-0.275h-5.003c-0.191 0-0.363 0.106-0.447 0.275l-1 2c-0.091 0.181-0.063 0.4 0.072 0.553l2.059 2.353c-1.713 0.35-3.284 1.191-4.547 2.453-1.7 1.7-2.637 3.963-2.637 6.366s0.937 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.263-1.266-2.834-2.106-4.544-2.456zM9.809 2h4.381l0.5 1h-5.381l0.5-1zM9.603 4h4.797l-1.769 2.022c-0.209-0.016-0.419-0.022-0.628-0.022-0.213 0-0.422 0.006-0.628 0.022l-1.772-2.022zM12 22c-3.859 0-7-3.141-7-7 0-3.331 2.341-6.128 5.463-6.831l0.684 0.684c0.094 0.094 0.222 0.147 0.353 0.147h1c0.131 0 0.259-0.053 0.353-0.147l0.684-0.684c3.122 0.703 5.463 3.5 5.463 6.831 0 3.859-3.141 7-7 7z" }),
_('path', { d: "M23.5 6c-0.275 0-0.5-0.225-0.5-0.5v-0.5h-1v0.5c0 0.275-0.225 0.5-0.5 0.5h-0.5v1h0.5c0.275 0 0.5 0.225 0.5 0.5v0.5h1v-0.5c0-0.275 0.225-0.5 0.5-0.5h0.5v-1h-0.5z" }),
_('path', { d: "M3 7h1v-0.5c0-0.828 0.672-1.5 1.5-1.5h0.5v-1h-0.5c-0.828 0-1.5-0.672-1.5-1.5v-0.5h-1v0.5c0 0.828-0.672 1.5-1.5 1.5h-0.5v1h0.5c0.828 0 1.5 0.672 1.5 1.5v0.5zM2.997 4.5c0.191-0.144 0.359-0.312 0.503-0.503 0.144 0.191 0.312 0.359 0.503 0.503-0.191 0.144-0.359 0.312-0.503 0.503-0.144-0.191-0.312-0.359-0.503-0.503z" }),
_('path', { d: "M19 2.5v0.5h1v-0.5c0-0.275 0.225-0.5 0.5-0.5h0.5v-1h-0.5c-0.275 0-0.5-0.225-0.5-0.5v-0.5h-1v0.5c0 0.275-0.225 0.5-0.5 0.5h-0.5v1h0.5c0.275 0 0.5 0.225 0.5 0.5z" })
            );
        }
        function Ring({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ring.SVG = RingSVG;
        return Ring;
    })();
export const RoadSign = /*#__PURE__*/ (() => {
    function RoadSignSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18 11h-4v-1h2c0.266 0 0.519-0.106 0.706-0.294l3-3c0.391-0.391 0.391-1.025 0-1.416l-3-3c-0.188-0.188-0.441-0.294-0.706-0.294h-2c0-1.103-0.897-2-2-2s-2 0.897-2 2h-2c-1.103 0-2 0.897-2 2v4c0 1.103 0.897 2 2 2h2v1h-4c-0.266 0-0.519 0.106-0.706 0.294l-3 3c-0.391 0.391-0.391 1.025 0 1.416l3 3c0.188 0.188 0.441 0.294 0.706 0.294h4v4.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-4.5h4c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM12 1c0.55 0 1 0.45 1 1h-2c0-0.55 0.45-1 1-1zM8 4h7.584l2 2-2 2h-7.584v-4zM11 10h2v1h-2v-1zM13 23h-2v-4h2v4zM18 17h-11.584l-2-2 2-2h11.584v4z" })
        );
    }
    function RoadSign({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RoadSignSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    RoadSign.SVG = RoadSignSVG;
    return RoadSign;
})();
export const Road = /*#__PURE__*/ (() => {
        function RoadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 0.144l-4.978 23.397c-0.016 0.069-0.022 0.138-0.022 0.209v0.25h2v-0.144l4.978-23.397c0.016-0.069 0.022-0.138 0.022-0.209v-0.25h-2v0.144z" }),
_('path', { d: "M22.978 23.541l-4.978-23.397v-0.144h-2v0.25c0 0.069 0.006 0.141 0.022 0.209l4.978 23.397v0.144h2v-0.25c0-0.069-0.006-0.141-0.022-0.209z" }),
_('path', { d: "M11 0h2v4h-2v-4z" }),
_('path', { d: "M11 7h2v6h-2v-6z" }),
_('path', { d: "M11 17h2v7h-2v-7z" })
            );
        }
        function Road({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RoadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Road.SVG = RoadSVG;
        return Road;
    })();
export const RobotArm = /*#__PURE__*/ (() => {
        function RobotArmSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 16c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM6.5 18c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M22 0h-3c-1.103 0-2 0.897-2 2h-2.5c-0.456-0.606-1.181-1-2-1-0.259 0-0.513 0.041-0.747 0.116v0l-9.65 3.022c-1.219 0.381-2.103 1.522-2.103 2.862 0 0.197 0.019 0.391 0.056 0.578l2.022 10.756c0.112 0.6 0.347 1.166 0.681 1.666h-0.759c-1.103 0-2 0.897-2 2v1.5c0 0.275 0.225 0.5 0.5 0.5h13c0.275 0 0.5-0.225 0.5-0.5v-1.5c0-1.103-0.897-2-2-2h-1.759c0.487-0.728 0.759-1.594 0.759-2.5 0-0.712-0.166-1.388-0.462-1.984v0l-3.444-6.997 6.384-2.719c0.406-0.175 0.759-0.453 1.022-0.8h2.5v2c0 0.959 0.678 1.763 1.578 1.956l-0.544 1.359c-0.053 0.131-0.047 0.281 0.016 0.409l1.225 2.447 0.894-0.447-1.122-2.247 0.591-1.478h1.722l0.591 1.478-1.122 2.247 0.894 0.447 1.225-2.447c0.063-0.128 0.069-0.278 0.016-0.409l-0.544-1.359c0.9-0.194 1.578-0.997 1.578-1.956v-5c0.003-1.103-0.894-2-1.997-2zM19 2h3v5c0 0 0 0 0 0h-3v-5zM3.353 14.288l-0.813-4.322c0.15 0.022 0.303 0.034 0.459 0.034 0.841 0 1.6-0.347 2.147-0.906l1.944 3.944c-0.194-0.025-0.391-0.037-0.591-0.037-1.225 0-2.334 0.491-3.147 1.287zM5.994 6.813c-0.038-0.603-0.253-1.156-0.597-1.613l4.616-1.447c0.044 0.428 0.197 0.828 0.431 1.166l-4.45 1.894zM3 5c1.103 0 2 0.897 2 2s-0.897 2-2 2-2-0.897-2-2 0.897-2 2-2zM12 23h-10v-1h10v1zM4.050 20c-0.663-0.65-1.050-1.547-1.050-2.5 0-1.931 1.569-3.5 3.5-3.5s3.5 1.569 3.5 3.5c0 0.953-0.387 1.85-1.050 2.5h-4.9zM12.5 5c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5zM14.95 4c0.034-0.162 0.050-0.328 0.050-0.5s-0.019-0.337-0.050-0.5h2.050v1h-2.050z" }),
_('path', { d: "M13 3.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M3 8c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM3 7v0c0 0 0 0 0 0z" })
            );
        }
        function RobotArm({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RobotArmSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        RobotArm.SVG = RobotArmSVG;
        return RobotArm;
    })();
export const Robot = /*#__PURE__*/ (() => {
        function RobotSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 11v-5c0-1.103-0.897-2-2-2v-1c0-1.103-0.897-2-2-2h-16c-1.103 0-2 0.897-2 2v1c-1.103 0-2 0.897-2 2v5c0 1.103 0.897 2 2 2v3c-1.103 0-2 0.897-2 2v4.5c0 0.275 0.225 0.5 0.5 0.5h23c0.275 0 0.5-0.225 0.5-0.5v-4.5c0-1.103-0.897-2-2-2v-3c1.103 0 2-0.897 2-2zM23 6v5c0 0.55-0.45 1-1 1v-7c0.55 0 1 0.45 1 1zM1 11v-5c0-0.55 0.45-1 1-1v7c-0.55 0-1-0.45-1-1zM2 22v-4h20v4h-20zM4 16v-13h16v13h-16z" }),
_('path', { d: "M11 7c0-1.653-1.347-3-3-3s-3 1.347-3 3 1.347 3 3 3 3-1.347 3-3zM6 7c0-1.103 0.897-2 2-2s2 0.897 2 2-0.897 2-2 2-2-0.897-2-2z" }),
_('path', { d: "M16 4c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM16 9c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2z" }),
_('path', { d: "M7 12h10v2h-10v-2z" })
            );
        }
        function Robot({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RobotSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Robot.SVG = RobotSVG;
        return Robot;
    })();
export const Rocket = /*#__PURE__*/ (() => {
        function RocketSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 0c-0.262 0-6.453 0.038-9.706 3.294-0.025 0.025-0.050 0.053-0.075 0.081l-2.9 3.625h-4.319c-0.322 0-0.625 0.156-0.813 0.419l-5 7c-0.237 0.334-0.25 0.778-0.025 1.125 0.188 0.288 0.506 0.456 0.841 0.456 0.066 0 0.131-0.006 0.197-0.019l4.475-0.894 3.244 3.244-0.894 4.475c-0.081 0.403 0.094 0.813 0.438 1.034 0.166 0.106 0.353 0.159 0.544 0.159 0.203 0 0.406-0.063 0.581-0.188l7-5c0.262-0.188 0.419-0.491 0.419-0.813v-4.319l3.619-2.9c0.028-0.022 0.056-0.047 0.081-0.075 3.256-3.253 3.294-9.444 3.294-9.706 0-0.553-0.447-1-1-1zM6.516 9h2.203l-3.272 4.091-2.163 0.431 3.231-4.522zM8.619 12.325l3.053 3.053-1.6 1.278-2.734-2.734 1.281-1.597zM15 17.484l-4.525 3.231 0.431-2.163 4.094-3.272v2.203zM19.331 9.256l-6.872 5.497-3.213-3.213 5.497-6.872c1.962-1.925 5.45-2.463 7.197-2.613-0.147 1.747-0.684 5.234-2.609 7.2z" }),
_('path', { d: "M18 8c1.103 0 2-0.897 2-2s-0.897-2-2-2-2 0.897-2 2 0.897 2 2 2zM18 5c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M4.5 17c-2.328 0-3.959 2.269-4.484 4.378-0.050 0.2 0.028 0.409 0.194 0.528s0.391 0.125 0.562 0.016c0.447-0.288 0.831-0.509 1.156-0.669-0.122 0.675-0.4 1.322-0.841 1.966-0.119 0.175-0.116 0.406 0.009 0.578 0.097 0.131 0.247 0.203 0.403 0.203 0.047 0 0.097-0.006 0.144-0.022 0.053-0.016 1.316-0.397 2.597-1.103 1.831-1.006 2.759-2.144 2.759-3.375 0-1.378-1.122-2.5-2.5-2.5zM3.772 21.991c-0.416 0.228-0.831 0.422-1.2 0.578 0.275-0.669 0.419-1.359 0.428-2.063 0.003-0.153-0.066-0.3-0.188-0.397-0.091-0.072-0.2-0.109-0.312-0.109-0.038 0-0.078 0.003-0.116 0.012-0.272 0.066-0.581 0.184-0.941 0.363 0.237-0.484 0.534-0.928 0.866-1.287 0.453-0.497 1.2-1.088 2.191-1.088 0.828 0 1.5 0.672 1.5 1.5 0 1.044-1.212 1.931-2.228 2.491z" })
            );
        }
        function Rocket({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RocketSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Rocket.SVG = RocketSVG;
        return Rocket;
    })();
export const RollingPin = /*#__PURE__*/ (() => {
    function RollingPinSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.416 3.416c0.375-0.378 0.584-0.881 0.584-1.416s-0.209-1.038-0.584-1.416c-0.378-0.375-0.881-0.584-1.416-0.584s-1.038 0.209-1.416 0.584c-0.553 0.553-1.031 1.2-1.534 1.881-0.303 0.409-0.612 0.828-0.941 1.228l-0.694-0.694c-0.378-0.378-0.881-0.584-1.416-0.584s-1.038 0.209-1.416 0.584l-11.584 11.584c-0.378 0.378-0.584 0.881-0.584 1.416s0.209 1.038 0.584 1.416l0.697 0.697c-0.4 0.328-0.819 0.638-1.228 0.941-0.681 0.503-1.328 0.978-1.881 1.534-0.378 0.375-0.588 0.878-0.588 1.413s0.209 1.038 0.584 1.416c0.378 0.375 0.881 0.584 1.416 0.584s1.038-0.209 1.416-0.584c0.553-0.553 1.031-1.2 1.534-1.881 0.303-0.409 0.612-0.828 0.941-1.228l0.697 0.697c0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584l11.581-11.588c0 0 0 0 0 0 0.781-0.781 0.781-2.050 0-2.828l-0.697-0.697c0.4-0.328 0.819-0.638 1.228-0.941 0.684-0.506 1.328-0.981 1.884-1.534zM14.353 6.059l3.584 3.584-8.291 8.297-3.588-3.588 8.294-8.294zM4.144 20.937c-0.481 0.65-0.934 1.266-1.437 1.769-0.391 0.391-1.025 0.391-1.416 0-0.188-0.188-0.294-0.441-0.294-0.706s0.103-0.519 0.294-0.706c0.503-0.503 1.116-0.956 1.769-1.437 0.447-0.331 0.906-0.669 1.344-1.038l0.775 0.775c-0.366 0.441-0.703 0.897-1.034 1.344zM4.416 16l0.941-0.941 3.584 3.584-0.941 0.941-3.584-3.584zM19.584 8l-0.941 0.941-3.584-3.588 0.941-0.941 3.584 3.588c0.003 0 0.003 0 0 0v0zM19.594 5.181l-0.775-0.775c0.369-0.441 0.706-0.897 1.038-1.344 0.481-0.65 0.934-1.266 1.437-1.769 0.188-0.188 0.441-0.294 0.706-0.294s0.519 0.103 0.706 0.294c0.391 0.391 0.391 1.025 0 1.416-0.503 0.503-1.116 0.956-1.769 1.437-0.447 0.328-0.903 0.666-1.344 1.034z" })
        );
    }
    function RollingPin({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RollingPinSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    RollingPin.SVG = RollingPinSVG;
    return RollingPin;
})();
export const RoundCorner = /*#__PURE__*/ (() => {
        function RoundCornerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 0h1v1h-1v-1z" }),
_('path', { d: "M23 14h1v1h-1v-1z" }),
_('path', { d: "M19.794 11.5l1.353 1.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l1.353-1.353-0.706-0.706-0.522 0.522c-0.162-2.412-1.178-4.659-2.906-6.387-1.725-1.725-3.972-2.744-6.387-2.906l0.522-0.522-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706-0.469-0.469c4.375 0.356 7.878 3.856 8.234 8.234l-0.469-0.469-0.709 0.703z" }),
_('path', { d: "M18 12c0-1.603-0.625-3.109-1.756-4.244-1.134-1.131-2.641-1.756-4.244-1.756h-2v-1h-1v1h-8c-0.553 0-1 0.447-1 1v16c0 0.553 0.447 1 1 1h16c0.553 0 1-0.447 1-1v-8h1v-1h-1v-2zM16 22h-14v-14h10c2.206 0 4 1.794 4 4v10z" }),
_('path', { d: "M9 2h1v2h-1v-2z" }),
_('path', { d: "M20 14h2v1h-2v-1z" })
            );
        }
        function RoundCorner({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RoundCornerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        RoundCorner.SVG = RoundCornerSVG;
        return RoundCorner;
    })();
export const RouterWarning = /*#__PURE__*/ (() => {
        function RouterWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 16h-15v-7.084c0.581-0.206 1-0.762 1-1.416 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.653 0.419 1.209 1 1.416v7.084h-4c-1.103 0-2 0.897-2 2v3c0 1.103 0.897 2 2 2h1v1h2v-1h14v1h2v-1h1c1.103 0 2-0.897 2-2v-3c0-1.103-0.897-2-2-2zM6.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM22 21h-20v-3h20v3z" }),
_('path', { d: "M19 19h2v1h-2v-1z" }),
_('path', { d: "M16 19h2v1h-2v-1z" }),
_('path', { d: "M3.319 4.319l-0.353 0.353 0.706 0.706 0.353-0.353c0.663-0.659 1.541-1.025 2.475-1.025 0.938 0 1.816 0.363 2.475 1.025l0.353 0.353 0.709-0.706-0.353-0.353c-0.85-0.85-1.978-1.319-3.184-1.319-1.203 0-2.331 0.469-3.181 1.319z" }),
_('path', { d: "M1.906 2.903c1.228-1.228 2.859-1.903 4.594-1.903s3.366 0.675 4.597 1.903l0.353 0.353 0.706-0.706-0.353-0.353c-1.419-1.416-3.303-2.197-5.303-2.197-2.003 0-3.884 0.781-5.3 2.197l-0.353 0.353 0.706 0.706 0.353-0.353z" }),
_('path', { d: "M3 19h2v1h-2v-1z" }),
_('path', { d: "M13 19h2v1h-2v-1z" }),
_('path', { d: "M18 10h1v1h-1v-1z" }),
_('path', { d: "M18 5h1v4h-1v-4z" }),
_('path', { d: "M14.5 13h8c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672l-4-7.997c-0.25-0.506-0.775-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-4 7.997c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.831 0.672 1.503 1.5 1.503zM14.050 11.281l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.275l4.003 8.006c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219z" })
            );
        }
        function RouterWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RouterWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        RouterWarning.SVG = RouterWarningSVG;
        return RouterWarning;
    })();
export const Router = /*#__PURE__*/ (() => {
        function RouterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 16h-15v-7.084c0.581-0.206 1-0.762 1-1.416 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.653 0.419 1.209 1 1.416v7.084h-4c-1.103 0-2 0.897-2 2v3c0 1.103 0.897 2 2 2h1v1h2v-1h14v1h2v-1h1c1.103 0 2-0.897 2-2v-3c0-1.103-0.897-2-2-2zM6.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5zM22 21h-20v-3h20v3z" }),
_('path', { d: "M19 19h2v1h-2v-1z" }),
_('path', { d: "M16 19h2v1h-2v-1z" }),
_('path', { d: "M3.319 4.319l-0.353 0.353 0.706 0.706 0.353-0.353c0.663-0.659 1.541-1.025 2.475-1.025 0.938 0 1.816 0.363 2.475 1.025l0.353 0.353 0.709-0.706-0.353-0.353c-0.85-0.85-1.978-1.319-3.184-1.319-1.203 0-2.331 0.469-3.181 1.319z" }),
_('path', { d: "M1.906 2.903c1.228-1.228 2.859-1.903 4.594-1.903s3.366 0.675 4.597 1.903l0.353 0.353 0.706-0.706-0.353-0.353c-1.419-1.416-3.303-2.197-5.303-2.197-2.003 0-3.884 0.781-5.3 2.197l-0.353 0.353 0.706 0.706 0.353-0.353z" }),
_('path', { d: "M3 19h2v1h-2v-1z" }),
_('path', { d: "M13 19h2v1h-2v-1z" })
            );
        }
        function Router({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RouterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Router.SVG = RouterSVG;
        return Router;
    })();
export const Rowing = /*#__PURE__*/ (() => {
    function RowingSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.5 11h-9.794l5.247-5.247c0.288 0.166 0.612 0.253 0.953 0.253 0.513 0 0.991-0.2 1.353-0.559l2.594-2.594c0.194-0.194 0.194-0.513 0-0.706l-2-2c-0.194-0.194-0.513-0.194-0.706 0l-2.594 2.594c0 0 0 0 0 0-0.625 0.625-0.725 1.575-0.306 2.306l-2.953 2.953h-0.794c-1.272 0-2.041 0-2.441-0.172-0.306-0.128-0.581-0.444-1.234-1.394-0.178-0.259-0.466-0.419-0.778-0.434-0.016 0-0.028 0-0.044 0 1.1-0.003 1.994-0.9 1.994-2 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 1.103 0.897 1.997 1.997 2-0.294 0-0.575 0.131-0.766 0.359-1.169 1.4-1.913 3.841-2.134 4.641h-6.594c-0.275 0-0.5 0.225-0.5 0.5v0.5c0 1 0.194 1.769 0.609 2.422 0.453 0.712 1.159 1.247 2.156 1.631 0.909 0.35 2.106 0.594 3.728 0.747l-1.447 1.447c-0.731-0.419-1.681-0.319-2.306 0.306l-2.594 2.594c-0.194 0.194-0.194 0.513 0 0.706l2 2c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l2.594-2.594c0.363-0.363 0.559-0.844 0.559-1.353 0-0.341-0.087-0.666-0.253-0.953l2.056-2.056c1.191 0.072 2.575 0.103 4.191 0.103 4.481 0 7.425-0.363 9.266-1.141s2.734-2.041 2.734-3.859v-0.5c0-0.275-0.225-0.5-0.5-0.5zM4.741 20.553c0 0 0 0 0 0l-2.241 2.241-1.294-1.294 2.241-2.241c0.356-0.356 0.938-0.356 1.294 0 0.172 0.172 0.269 0.403 0.269 0.647s-0.097 0.475-0.269 0.647zM19.259 3.447v0l2.241-2.241 1.294 1.294-2.241 2.241c-0.172 0.172-0.403 0.269-0.647 0.269s-0.475-0.094-0.647-0.269c-0.356-0.356-0.356-0.937 0-1.294zM9 4c0-0.55 0.45-1 1-1s1 0.45 1 1-0.45 1-1 1-1-0.45-1-1zM10.069 8.759c0.359 0.406 0.731 0.709 1.209 0.912 0.553 0.234 1.153 0.303 2.025 0.322l-1.009 1.006h-3.109c0.2-0.644 0.509-1.494 0.884-2.241zM3.484 14.184c-1.125-0.434-1.484-0.966-1.484-2.184h9.294l-2.925 2.925c-2.319-0.112-3.878-0.353-4.884-0.741zM12 15c-0.816 0-1.569-0.009-2.266-0.025l2.975-2.975h9.291c0 1.047 0 3-10 3z" })
        );
    }
    function Rowing({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RowingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Rowing.SVG = RowingSVG;
    return Rowing;
})();
export const RubberDuck = /*#__PURE__*/ (() => {
        function RubberDuckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.847 5.141c-0.1-0.097-0.234-0.147-0.372-0.141-0.709 0.034-1.844 0.009-2.65-0.156-0.012-0.041-0.022-0.078-0.034-0.119-0.397-1.284-1.241-2.363-2.372-3.034-1.191-0.703-2.581-0.881-3.922-0.5-1.25 0.356-2.281 1.203-2.903 2.378-0.647 1.222-0.766 2.681-0.328 4.006 0.284 0.953 0.759 1.475 1.141 1.897 0.394 0.431 0.591 0.65 0.591 1.359 0 0.659-0.878 1.072-1.744 1.141-0.1 0.009-0.203 0.012-0.303 0.012-0.966 0-1.956-0.353-2.759-0.994-1.128-0.897-1.878-2.334-2.166-4.156-0.066-0.409-0.378-0.738-0.784-0.822s-0.825 0.091-1.047 0.444c-1.241 1.95-1.953 3.963-2.119 5.984-0.159 1.956 0.222 3.841 1.106 5.45 1.775 3.247 5.366 5.109 9.841 5.109 3.663 0 5.775-1.406 6.903-2.587 1.291-1.353 2.031-3.162 2.031-4.966 0-2.031-0.987-3.45-2.403-3.45-0.259 0-0.428-0.019-0.531-0.041 0.019-0.081 0.053-0.2 0.119-0.366 0.125-0.328 0.319-0.725 0.522-1.144 0.131-0.269 0.269-0.553 0.406-0.853 1.131-0.322 2.037-0.8 2.703-1.422 0.791-0.734 1.216-1.659 1.228-2.669 0.003-0.134-0.053-0.269-0.153-0.363zM18.547 13.997c0.044 0.025 0.203 0.188 0.312 0.612 0.131 0.516 0.128 1.163-0.009 1.819-0.222 1.072-1.381 4.572-6.828 4.572-3.725 0-6.672-1.481-8.094-4.069-1.141-2.075-1.175-4.672-0.159-7.247 0.516 1.169 1.247 2.144 2.172 2.875 1.281 1.019 2.909 1.531 4.466 1.409 2.112-0.166 3.588-1.453 3.588-3.134 0-1.484-0.616-2.163-1.113-2.706-0.309-0.341-0.553-0.609-0.706-1.131-0.003-0.012-0.006-0.022-0.009-0.034-0.272-0.816-0.2-1.709 0.194-2.459 0.366-0.691 0.963-1.184 1.684-1.391 1.816-0.519 3.375 0.713 3.834 2.2 0.409 1.328-0.347 2.884-1.016 4.256-0.278 0.575-0.544 1.119-0.703 1.616-0.091 0.281-0.363 1.137 0.1 1.875 0.584 0.934 1.859 0.938 2.288 0.938zM19.566 8.369c0.272-0.784 0.456-1.625 0.422-2.481 0.703 0.109 1.447 0.128 1.953 0.125-0.219 1.006-1.047 1.819-2.375 2.356z" }),
_('path', { d: "M17 6c0-0.55-0.45-1-1-1s-1 0.45-1 1 0.45 1 1 1 1-0.45 1-1zM16 6c0 0 0 0 0 0v0z" })
            );
        }
        function RubberDuck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RubberDuckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        RubberDuck.SVG = RubberDuckSVG;
        return RubberDuck;
    })();
export const Ruby = /*#__PURE__*/ (() => {
        function RubySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.706 7.294l-6-6c-0.188-0.188-0.441-0.294-0.706-0.294h-8c-0.266 0-0.519 0.106-0.706 0.294l-6 6c-0.188 0.188-0.294 0.441-0.294 0.706v8c0 0.266 0.106 0.519 0.294 0.706l6 6c0.188 0.188 0.441 0.294 0.706 0.294h8c0.266 0 0.519-0.106 0.706-0.294l6-6c0.188-0.188 0.294-0.441 0.294-0.706v-8c0-0.266-0.106-0.519-0.294-0.706zM18 13.803v-3.606l3-1.244v6.091l-3-1.241zM20.619 8.031l-3 1.244-2.891-2.891 1.244-3 4.647 4.647zM10.197 18h3.603l1.244 3h-6.087l1.241-3zM13.928 17h-3.856l-3.072-3.072v-3.856l3.072-3.072h3.859l3.072 3.072v3.859l-3.075 3.069zM13.803 6h-3.606l-1.244-3h6.091l-1.241 3zM8.031 3.381l1.244 3-2.891 2.891-3-1.244 4.647-4.647zM6 10.197v3.603l-3 1.244v-6.087l3 1.241zM3.381 15.969l3-1.244 2.891 2.891-1.244 3-4.647-4.647zM15.969 20.619l-1.244-3 2.891-2.891 3 1.244-4.647 4.647z" }),
_('path', { d: "M13.853 8.147c-0.094-0.094-0.222-0.147-0.353-0.147h-1.5v1h1.294l1.706 1.706v1.294h1v-1.5c0-0.131-0.053-0.259-0.147-0.353l-2-2z" })
            );
        }
        function Ruby({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RubySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ruby.SVG = RubySVG;
        return Ruby;
    })();
export const Ruler = /*#__PURE__*/ (() => {
    function RulerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.031 8h-20c-1.103 0-2 0.897-2 2v4c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM22.031 14h-2.031v-1h-1v1h-2v-1h-1v1h-2v-2h-1v2h-2v-1h-1v1h-2v-1h-1v1h-2v-2h-1v2h-1.969v-4h20v4c0 0 0 0 0 0z" })
        );
    }
    function Ruler({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RulerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Ruler.SVG = RulerSVG;
    return Ruler;
})();
export const Rulers = /*#__PURE__*/ (() => {
    function RulersSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.031 2h-12.031v-1.5c0-0.275-0.225-0.5-0.5-0.5h-5c-0.275 0-0.5 0.225-0.5 0.5v1.5h-1.969c-1.103 0-2 0.897-2 2v4c0 1.103 0.897 2 2 2h1.969v13.5c0 0.275 0.225 0.5 0.5 0.5h5c0.275 0 0.5-0.225 0.5-0.5v-13.5h12.031c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM5 1h4v1h-4v-1zM9 11h-2v1h2v2h-1v1h1v2h-1v1h1v2h-2v1h2v2h-4v-13h4v1zM22.031 8h-2.031v-1h-1v1h-2v-1h-1v1h-2v-2h-1v2h-2v-1h-1v1h-2v-1h-1v1h-2v-2h-1v2h-1.969v-4h20v4c0 0 0 0 0 0z" })
        );
    }
    function Rulers({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RulersSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Rulers.SVG = RulersSVG;
    return Rulers;
})();
export const Running = /*#__PURE__*/ (() => {
        function RunningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 6c1.103 0 2-0.897 2-2s-0.897-2-2-2-2 0.897-2 2 0.897 2 2 2zM16 3c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M20.781 7.866l-3.344 1.772-1.544-3.084c-0.159-0.319-0.475-0.528-0.831-0.55-0.022 0-0.041-0.003-0.063-0.003v0h-5c-0.312 0-0.606 0.144-0.794 0.394l-3.25 4.25 1.587 1.216 2.95-3.859h2.637l-2.941 4.409c-1.194 1.494-1.887 2.309-2.825 2.591h-4.366v2h4.5c0.081 0 0.162-0.009 0.244-0.031 1.441-0.359 2.4-1.341 3.453-2.622 1.219 0.884 2.109 1.788 2.7 2.737l-1.831 4.806 1.869 0.712 2-5.25c0.103-0.269 0.084-0.572-0.050-0.825-0.725-1.362-1.875-2.609-3.503-3.797l2.494-3.744 1.228 2.459c0.122 0.241 0.334 0.422 0.591 0.506 0.256 0.081 0.534 0.056 0.772-0.069l4.25-2.25-0.934-1.769z" })
            );
        }
        function Running({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RunningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Running.SVG = RunningSVG;
        return Running;
    })();
export const Sad = /*#__PURE__*/ (() => {
        function SadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M8.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM8.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M15.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM15.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M12 12c-1.847 0-3.706 1-5.853 3.147l-0.353 0.353 0.706 0.706 0.353-0.353c1.947-1.947 3.581-2.853 5.147-2.853s3.2 0.906 5.147 2.853l0.353 0.353 0.706-0.706-0.353-0.353c-2.147-2.147-4.006-3.147-5.853-3.147z" })
            );
        }
        function Sad({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Sad.SVG = SadSVG;
        return Sad;
    })();
export const Safe = /*#__PURE__*/ (() => {
        function SafeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v19c0 1.103 0.897 2 2 2h1v0.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-0.5h10v0.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-0.5h1c1.103 0 2-0.897 2-2v-19c0-1.103-0.897-2-2-2zM22 21h-20v-19h20v19c0 0 0 0 0 0z" }),
_('path', { d: "M8.5 16.206l2.622-2.622c0.397 0.262 0.869 0.416 1.378 0.416s0.981-0.153 1.378-0.416l2.622 2.622 0.706-0.706-2.622-2.622c0.262-0.397 0.416-0.869 0.416-1.378s-0.153-0.981-0.416-1.378l2.622-2.622-0.706-0.706-2.622 2.622c-0.397-0.263-0.869-0.416-1.378-0.416s-0.981 0.153-1.378 0.416l-2.622-2.622-0.706 0.706 2.622 2.622c-0.263 0.397-0.416 0.869-0.416 1.378s0.153 0.981 0.416 1.378l-2.622 2.622 0.706 0.706zM14 11.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M19 3h-13c-1.103 0-2 0.897-2 2v1h-0.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h0.5v3h-0.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h0.5v1c0 1.103 0.897 2 2 2h13c1.103 0 2-0.897 2-2v-13c0-1.103-0.897-2-2-2zM4 7h1v2h-1v-2zM4 14h1v2h-1v-2zM19 18h-13v-13h13v13z" })
            );
        }
        function Safe({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SafeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Safe.SVG = SafeSVG;
        return Safe;
    })();
export const SatelliteDish = /*#__PURE__*/ (() => {
    function SatelliteDishSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.853 17.147l-1.853-1.853v-9.462l1.416-1.416c0.778-0.778 0.778-2.047 0-2.828-0.778-0.778-2.047-0.778-2.828 0l-1.413 1.413h-9.469l-1.853-1.853c-0.194-0.194-0.513-0.194-0.706 0v0 0l-0.353 0.353c-0.906 0.906-1.478 2.006-1.697 3.269-0.194 1.125-0.103 2.359 0.275 3.663 0.438 1.506 1.241 3.069 2.334 4.559l-3.628 8.622c-0.131 0.309-0.097 0.663 0.087 0.941 0.188 0.278 0.5 0.447 0.834 0.447h10c0.341 0 0.659-0.175 0.844-0.462s0.209-0.647 0.066-0.959l-1.241-2.684c0.638 0.303 1.275 0.55 1.903 0.731 0.862 0.25 1.694 0.375 2.481 0.375 0.406 0 0.8-0.034 1.181-0.1 1.263-0.219 2.363-0.787 3.269-1.697l0.353-0.353c0.194-0.191 0.194-0.509-0.003-0.703zM6.206 2.913l13.878 13.878c-0.275 0.275-0.575 0.506-0.9 0.687l-13.666-13.666c0.184-0.322 0.412-0.622 0.687-0.9zM14.206 9.5l2.775-2.775c0.312 0.184 0.666 0.275 1.016 0.275 0.347 0 0.691-0.087 1-0.266v7.559l-4.791-4.794zM19.294 2.294c0.391-0.391 1.028-0.391 1.416-0.003 0.391 0.391 0.391 1.028 0 1.416l-2 2c-0.391 0.391-1.028 0.391-1.416 0.003-0.391-0.391-0.391-1.028 0-1.416l2-2zM16.269 4c-0.359 0.622-0.356 1.394 0.009 2.016l-2.778 2.778-4.794-4.794h7.563zM11.9 22h-7.812l3.063-7.272c0.178 0.194 0.363 0.384 0.553 0.572 0.603 0.603 1.231 1.156 1.875 1.659l2.322 5.041zM15.125 17.706c-1.962-0.569-4.156-1.959-6.012-3.819-1.859-1.859-3.25-4.050-3.819-6.012-0.331-1.141-0.387-2.159-0.172-3.044l13.050 13.050c-0.35 0.084-0.719 0.128-1.109 0.128-0.6-0.003-1.244-0.103-1.938-0.303z" })
        );
    }
    function SatelliteDish({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SatelliteDishSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SatelliteDish.SVG = SatelliteDishSVG;
    return SatelliteDish;
})();
export const Satellite = /*#__PURE__*/ (() => {
        function SatelliteSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.853 20.147l-6-6c-0.094-0.094-0.222-0.147-0.353-0.147h-0.794l-0.647-0.647 2.347-2.347c0 0 0 0 0 0 0.781-0.781 0.781-2.050 0-2.828l-2.584-2.584c-0.378-0.378-0.881-0.584-1.416-0.584s-1.038 0.209-1.416 0.584l-2.347 2.347-0.644-0.647v-0.794c0-0.131-0.053-0.259-0.147-0.353l-6-6c-0.194-0.194-0.513-0.194-0.706 0l-3 3c-0.194 0.194-0.194 0.513 0 0.706l6 6c0.094 0.094 0.222 0.147 0.353 0.147h0.794l0.647 0.647-0.347 0.344c-0.378 0.378-0.584 0.881-0.584 1.416s0.209 1.038 0.584 1.416l2.584 2.584c0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584l0.347-0.347 0.647 0.647v0.794c0 0.131 0.053 0.259 0.147 0.353l6 6c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l3-3c0.194-0.194 0.194-0.513-0.003-0.706zM7.853 9.147c-0.094-0.094-0.222-0.147-0.353-0.147h-0.794l-5.5-5.5 2.294-2.294 5.5 5.5v0.794c0 0.131 0.053 0.259 0.147 0.353l0.794 0.794-1.294 1.294-0.794-0.794zM9.009 12.406l5.397-5.397 2.587 2.584c0 0 0 0 0 0v0l-5.4 5.397-2.584-2.584zM20.5 22.794l-5.5-5.5v-0.794c0-0.131-0.053-0.259-0.147-0.353l-0.794-0.794 1.294-1.294 0.794 0.794c0.094 0.094 0.222 0.147 0.353 0.147h0.794l5.5 5.5-2.294 2.294z" }),
_('path', { d: "M1 15.5v-0.5h-1v0.5c0 2.272 0.884 4.406 2.491 6.009s3.738 2.491 6.009 2.491h0.5v-1h-0.5c-4.134 0-7.5-3.366-7.5-7.5z" }),
_('path', { d: "M4 15.5v-0.5h-1v0.5c0 3.031 2.469 5.5 5.5 5.5h0.5v-1h-0.5c-2.481 0-4.5-2.019-4.5-4.5z" }),
_('path', { d: "M7 15.5v-0.5h-1v0.5c0 1.378 1.122 2.5 2.5 2.5h0.5v-1h-0.5c-0.828 0-1.5-0.672-1.5-1.5z" })
            );
        }
        function Satellite({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SatelliteSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Satellite.SVG = SatelliteSVG;
        return Satellite;
    })();
export const Saw = /*#__PURE__*/ (() => {
        function SawSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.022 18.009c-0.6-1.534-1.688-3.619-3.456-4.834-0.253-0.175-0.563-0.216-0.844-0.138l-16.3-12.703c-0.453-0.356-1.059-0.419-1.578-0.166-0.522 0.253-0.844 0.769-0.844 1.347v2.984c0 0.275 0.225 0.5 0.5 0.5h1.5v1.5c0 0.275 0.225 0.5 0.5 0.5h1.5v1.5c0 0.275 0.225 0.5 0.5 0.5h1.5v1.5c0 0.275 0.225 0.5 0.5 0.5h1.5v1.5c0 0.275 0.225 0.5 0.5 0.5h1.5v1.5c0 0.275 0.225 0.5 0.5 0.5h1.5v1.5c0 0.275 0.225 0.5 0.5 0.5h1.794l0.147 0.147-0.147 0.147c-0.288 0.288-0.372 0.716-0.216 1.091s0.519 0.619 0.925 0.619c1.234 0 1.866 1.1 2.625 2.653 0.253 0.519 0.491 1.009 0.775 1.403 0.45 0.625 0.991 0.944 1.6 0.944 1.522 0 2.288 0 2.834-0.169 0.472-0.147 0.806-0.428 0.994-0.834 0.15-0.325 0.172-0.672 0.172-0.997-0.003-0.728-0.347-2.372-0.981-3.994zM15.147 16.441l-0.294-0.294c-0.094-0.094-0.222-0.147-0.353-0.147h-1.5v-1.5c0-0.275-0.225-0.5-0.5-0.5h-1.5v-1.5c0-0.275-0.225-0.5-0.5-0.5h-1.5v-1.5c0-0.275-0.225-0.5-0.5-0.5h-1.5v-1.5c0-0.275-0.225-0.5-0.5-0.5h-1.5v-1.5c0-0.275-0.225-0.5-0.5-0.5h-1.5v-1.5c0-0.275-0.225-0.5-0.5-0.5h-1.5v-2.484c0-0.194 0.106-0.363 0.281-0.447s0.372-0.066 0.528 0.056l16.103 12.553-2.766 2.763zM20.112 22c-0.188-0.194-0.484-0.806-0.687-1.225-0.375-0.769-0.8-1.644-1.441-2.369-0.331-0.375-0.691-0.675-1.075-0.903l2.159-2.159c0.997 0.963 1.678 2.331 2.094 3.394 0.606 1.553 0.822 2.866 0.837 3.222-0.391 0.038-1.116 0.041-1.887 0.041z" }),
_('path', { d: "M21 20.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Saw({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SawSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Saw.SVG = SawSVG;
        return Saw;
    })();
export const ScaleDown = /*#__PURE__*/ (() => {
        function ScaleDownSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 9.294l-5.5-5.5-0.706 0.706 5.5 5.5h-1.294v1h2.5c0.275 0 0.5-0.225 0.5-0.5v-2.5h-1v1.294z" }),
_('path', { d: "M23.5 0h-23c-0.275 0-0.5 0.225-0.5 0.5v23c0 0.275 0.225 0.5 0.5 0.5h21.5c1.103 0 2-0.897 2-2v-21.5c0-0.275-0.225-0.5-0.5-0.5zM1 23v-22h22v11h-9c-1.103 0-2 0.897-2 2v9h-11zM22 22h-8v-8h8v8z" })
            );
        }
        function ScaleDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ScaleDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ScaleDown.SVG = ScaleDownSVG;
        return ScaleDown;
    })();
export const ScaleUp = /*#__PURE__*/ (() => {
        function ScaleUpSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 5v-1h-2.5c-0.275 0-0.5 0.225-0.5 0.5v2.5h1v-1.294l5.5 5.5 0.706-0.706-5.5-5.5h1.294z" }),
_('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h21.5c0.275 0 0.5-0.225 0.5-0.5v-21.5c0-1.103-0.897-2-2-2zM12 12.5v9.5h-10v-20h20v10h-9.5c-0.275 0-0.5 0.225-0.5 0.5zM23 23h-10v-10h10v10z" })
            );
        }
        function ScaleUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ScaleUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ScaleUp.SVG = ScaleUpSVG;
        return ScaleUp;
    })();
export const Scared = /*#__PURE__*/ (() => {
        function ScaredSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 14c-2.244 0-4 1.097-4 2.5 0 0.372 0.122 0.684 0.366 0.925 0.591 0.588 1.731 0.581 3.175 0.575 0.3 0 0.619 0 0.922 0 0.147 0 0.291 0 0.431 0 1.237 0 2.212-0.050 2.741-0.578 0.244-0.241 0.366-0.553 0.366-0.925 0-1.4-1.756-2.497-4-2.497zM14.928 16.716c-0.297 0.294-1.397 0.291-2.466 0.284-0.303 0-0.625 0-0.931 0-1.066 0.006-2.169 0.009-2.466-0.284-0.022-0.022-0.072-0.072-0.072-0.216 0-0.709 1.231-1.5 3-1.5s3 0.791 3 1.5c0.006 0.147-0.041 0.194-0.066 0.216z" }),
_('path', { d: "M11 8.5c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5 1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5zM7 8.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5z" }),
_('path', { d: "M15.5 6c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.122-2.5-2.5-2.5zM15.5 10c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" }),
_('path', { d: "M9 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M16 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Scared({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ScaredSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Scared.SVG = ScaredSVG;
        return Scared;
    })();
export const Scatterplot = /*#__PURE__*/ (() => {
        function ScatterplotSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.706 20.294l-2.25-2.25-1.416 1.416 0.544 0.544h-16.584v-16.587l0.544 0.544 1.416-1.416-2.25-2.25c-0.391-0.391-1.025-0.391-1.416 0l-2.25 2.25 1.416 1.416 0.541-0.544v17.584c0 0.553 0.447 1 1 1h17.584l-0.544 0.544 1.416 1.416 2.25-2.25c0.391-0.394 0.391-1.025 0-1.416z" }),
_('path', { d: "M7 16.5c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5zM9 16.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5z" }),
_('path', { d: "M12.5 13c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5zM12.5 11c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M7.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM7.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M17.5 17c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM17.5 15c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M19.5 11c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM19.5 9c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M14.5 7c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM14.5 5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" })
            );
        }
        function Scatterplot({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ScatterplotSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Scatterplot.SVG = ScatterplotSVG;
        return Scatterplot;
    })();
export const Scissors = /*#__PURE__*/ (() => {
        function ScissorsSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 11c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 12c0 0 0 0 0 0v0z" }),
_('path', { d: "M22.991 19.209c-0.075-1.287-0.584-2.531-1.434-3.5-0.95-1.084-2.234-1.706-3.522-1.706-0.381 0-0.75 0.053-1.103 0.156l-1.853-2.15c1.316-1.553 2.497-2.969 3.066-3.7 1.834-2.363 1.856-7.587 1.856-7.809 0-0.209-0.131-0.397-0.325-0.469-0.197-0.072-0.416-0.016-0.553 0.144l-7.122 8.259-7.122-8.259c-0.138-0.159-0.356-0.216-0.553-0.144-0.194 0.072-0.325 0.259-0.325 0.469 0 0.222 0.022 5.447 1.856 7.806 0.516 0.663 1.625 2 3.066 3.697l-1.856 2.153c-0.35-0.103-0.722-0.156-1.1-0.156-1.291 0-2.575 0.622-3.522 1.706-0.85 0.972-1.359 2.212-1.434 3.5-0.078 1.328 0.316 2.559 1.103 3.459 0.75 0.859 1.788 1.331 2.922 1.331 1.291 0 2.575-0.622 3.522-1.706 0.85-0.972 1.359-2.212 1.434-3.5 0.016-0.284 0.012-0.563-0.012-0.831 0.478-0.553 1.2-1.391 2.025-2.35 0.841 0.978 1.553 1.803 2.022 2.347-0.025 0.272-0.031 0.553-0.012 0.834 0.075 1.287 0.584 2.531 1.434 3.5 0.95 1.084 2.234 1.706 3.522 1.706 1.131 0 2.169-0.472 2.922-1.331 0.784-0.9 1.178-2.128 1.1-3.456zM6.644 7.694c-1.081-1.394-1.453-4.106-1.578-5.772l6.275 7.278-1.756 2.037c-1.384-1.628-2.444-2.906-2.941-3.544zM7.994 18.675c-0.050 0.847-0.384 1.662-0.941 2.3-0.572 0.65-1.306 1.025-2.019 1.025-0.556 0-1.044-0.225-1.416-0.647-0.441-0.506-0.659-1.225-0.612-2.028 0.050-0.847 0.384-1.662 0.941-2.3 0.569-0.65 1.306-1.025 2.019-1.025 0.556 0 1.044 0.225 1.416 0.647 0.441 0.506 0.659 1.225 0.612 2.028zM8.887 15.331c-0.259-0.297-0.55-0.547-0.869-0.747l10.916-12.663c-0.125 1.666-0.497 4.375-1.581 5.772-1.241 1.6-5.594 6.663-7.647 9.047-0.184-0.525-0.462-1-0.819-1.409zM15.112 15.331c-0.356 0.409-0.634 0.884-0.822 1.406-0.447-0.519-1.006-1.166-1.631-1.897 0.572-0.669 1.172-1.372 1.762-2.063l1.559 1.809c-0.319 0.2-0.609 0.45-0.869 0.744zM20.381 21.353c-0.372 0.425-0.859 0.647-1.416 0.647-0.713 0-1.45-0.375-2.019-1.025-0.559-0.637-0.894-1.453-0.941-2.3-0.047-0.803 0.172-1.522 0.612-2.028 0.372-0.425 0.859-0.647 1.416-0.647 0.712 0 1.45 0.375 2.019 1.025 0.559 0.637 0.894 1.453 0.941 2.3 0.047 0.803-0.172 1.522-0.612 2.028z" })
            );
        }
        function Scissors({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ScissorsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Scissors.SVG = ScissorsSVG;
        return Scissors;
    })();
export const Screwdriver = /*#__PURE__*/ (() => {
    function ScrewdriverSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.269 18.769l-5.031-5.031c0 0 0 0-0.003-0.003-0.697-0.694-1.703-0.891-2.575-0.597-0.441-0.712-0.659-1.581-0.659-2.637 0-0.131-0.053-0.259-0.147-0.353l-1-1c-0.194-0.194-0.513-0.194-0.706 0l-1.647 1.647-5.747-5.747c0.419-0.731 0.319-1.681-0.306-2.306-0.019-0.019-0.041-0.037-0.059-0.053l-3.594-2.594c-0.2-0.144-0.475-0.122-0.647 0.053l-1 1c-0.175 0.172-0.197 0.447-0.053 0.647l2.594 3.594c0.016 0.022 0.034 0.041 0.053 0.059 0.372 0.372 0.862 0.559 1.353 0.559 0.328 0 0.659-0.084 0.953-0.253l5.747 5.747-1.647 1.647c-0.194 0.194-0.194 0.513 0 0.706l1 1c0.094 0.094 0.222 0.147 0.353 0.147 1.056 0 1.928 0.219 2.641 0.663-0.297 0.875-0.097 1.881 0.597 2.575l5.031 5.031c0.488 0.488 1.125 0.728 1.766 0.728s1.281-0.244 1.769-0.728l0.966-0.966c0.972-0.972 0.975-2.556 0-3.534zM3.472 4.766l-2.319-3.213 0.397-0.397 3.213 2.319c0.331 0.359 0.322 0.919-0.025 1.266s-0.906 0.356-1.266 0.025zM13.734 14.703c-0.031 0.031-0.059 0.063-0.087 0.094-0.722-0.447-1.566-0.703-2.547-0.775l2.922-2.922c0.072 0.981 0.328 1.825 0.775 2.547-0.031 0.028-0.066 0.059-0.094 0.091l-0.969 0.966zM21.856 20.891l-0.963 0.963c-0.197 0.197-0.516 0.197-0.709 0.003l-5.031-5.031c-0.194-0.194-0.194-0.513 0-0.706l0.966-0.966c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.356 0.147l5.028 5.028c0.194 0.197 0.194 0.513 0 0.709z" })
        );
    }
    function Screwdriver({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ScrewdriverSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Screwdriver.SVG = ScrewdriverSVG;
    return Screwdriver;
})();
export const ScrollDown = /*#__PURE__*/ (() => {
    function ScrollDownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.344 2.781v0c-2.266-1.166-4.806-1.781-7.344-1.781h-0.5c-1.931 0-3.5 1.569-3.5 3.5 0 0.087 0.003 0.172 0.009 0.256-0.619 0.55-1.009 1.353-1.009 2.244h-4c-1.653 0-3 1.347-3 3 0 0.925 0.422 1.753 1.081 2.303-0.053 0.228-0.081 0.459-0.081 0.697 0 1.303 0.837 2.416 2 2.828v5.466l-1.5-1.5-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l2.353-2.353-0.706-0.706-1.5 1.5v-5.294h7.15l-0.738 1.128c-0.266 0.406-0.409 0.881-0.409 1.372 0 1.378 1.119 2.5 2.497 2.5 0.541 0 1.059-0.172 1.497-0.497 0.003 0 0.003-0.003 0.006-0.003l6.034-4.525c1.228-0.922 1.962-2.394 1.962-3.934v-4.887c0-1.85-1.019-3.525-2.656-4.372zM21 12.041c0 0.916-0.434 1.788-1.163 2.334l-6.031 4.522c-0.063 0.047-0.169 0.103-0.306 0.103-0.275 0-0.497-0.225-0.497-0.5 0-0.1 0.028-0.194 0.081-0.275l1.753-2.678c0.2-0.306 0.219-0.7 0.044-1.022s-0.513-0.525-0.881-0.525h-9c-0.55 0-1-0.45-1-1 0-0.2 0.059-0.391 0.169-0.559 0.084-0.125 0.197-0.231 0.331-0.309 0.153-0.087 0.325-0.134 0.5-0.134h7v-1h-8c-0.55 0-1-0.45-1-1s0.45-1 1-1h8v-1h-1c-0.175 0-0.35-0.047-0.5-0.134-0.134-0.072-0.247-0.178-0.331-0.306-0.109-0.166-0.169-0.359-0.169-0.556 0-0.55 0.45-1 1-1h2v-1h-1.912c-0.056-0.159-0.087-0.328-0.087-0.5 0-0.828 0.672-1.5 1.5-1.5h0.5c2.222 0 4.444 0.537 6.425 1.556 0.972 0.503 1.575 1.497 1.575 2.597v4.887z" })
        );
    }
    function ScrollDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ScrollDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ScrollDown.SVG = ScrollDownSVG;
    return ScrollDown;
})();
export const ScrollHorizontal = /*#__PURE__*/ (() => {
    function ScrollHorizontalSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.5 7.206l2.353-2.353c0.194-0.194 0.194-0.513 0-0.706l-2.353-2.353-0.706 0.706 1.5 1.5h-5.294c0-1.653-1.347-3-3-3-0.925 0-1.753 0.422-2.303 1.081-0.228-0.053-0.459-0.081-0.697-0.081-1.303 0-2.416 0.837-2.828 2h-5.466l1.5-1.5-0.706-0.706-2.353 2.353c-0.194 0.194-0.194 0.513 0 0.706l2.353 2.353 0.706-0.706-1.5-1.5h5.294v7.15l-1.128-0.738c-0.406-0.266-0.881-0.409-1.372-0.409-1.378 0-2.5 1.119-2.5 2.497 0 0.541 0.172 1.059 0.497 1.497 0 0.003 0.003 0.003 0.003 0.006l4.525 6.034c0.922 1.228 2.394 1.962 3.934 1.962h4.887c1.85 0 3.525-1.019 4.372-2.656v-0.003c1.166-2.262 1.781-4.803 1.781-7.341v-0.5c0-1.931-1.569-3.5-3.5-3.5-0.087 0-0.172 0.003-0.256 0.009-0.55-0.619-1.353-1.009-2.244-1.009v-3h5.294l-1.5 1.5 0.706 0.706zM17 11v2h1v-1.912c0.159-0.056 0.328-0.087 0.5-0.087 0.828 0 1.5 0.672 1.5 1.5v0.5c0 2.222-0.537 4.444-1.556 6.425-0.503 0.972-1.497 1.575-2.597 1.575h-4.887c-0.916 0-1.788-0.434-2.334-1.163l-4.522-6.031c-0.047-0.063-0.103-0.169-0.103-0.306 0-0.275 0.225-0.497 0.5-0.497 0.1 0 0.194 0.028 0.275 0.081l2.678 1.753c0.306 0.2 0.7 0.219 1.022 0.044s0.525-0.513 0.525-0.881v-9c0-0.55 0.45-1 1-1 0.2 0 0.391 0.059 0.559 0.169 0.125 0.084 0.231 0.197 0.309 0.331 0.087 0.153 0.134 0.325 0.134 0.5v7h1v-8c0-0.55 0.45-1 1-1s1 0.45 1 1v8h1v-1c0-0.175 0.047-0.35 0.134-0.5 0.072-0.134 0.178-0.247 0.306-0.331 0.166-0.109 0.359-0.169 0.556-0.169 0.55 0 1 0.45 1 1z" })
        );
    }
    function ScrollHorizontal({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ScrollHorizontalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ScrollHorizontal.SVG = ScrollHorizontalSVG;
    return ScrollHorizontal;
})();
export const ScrollLeft = /*#__PURE__*/ (() => {
    function ScrollLeftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19.5 9c-0.087 0-0.172 0.003-0.256 0.009-0.55-0.619-1.353-1.009-2.244-1.009v-4c0-1.653-1.347-3-3-3-0.925 0-1.753 0.422-2.303 1.081-0.228-0.053-0.459-0.081-0.697-0.081-1.303 0-2.416 0.837-2.828 2h-5.466l1.5-1.5-0.706-0.706-2.353 2.353c-0.194 0.194-0.194 0.513 0 0.706l2.353 2.353 0.706-0.706-1.5-1.5h5.294v7.15l-1.128-0.738c-0.406-0.266-0.881-0.409-1.372-0.409-1.378 0-2.5 1.119-2.5 2.497 0 0.541 0.172 1.059 0.497 1.497 0 0.003 0.003 0.003 0.003 0.006l4.525 6.034c0.922 1.228 2.394 1.962 3.934 1.962h4.887c1.85 0 3.525-1.019 4.372-2.656v-0.003c1.166-2.262 1.781-4.803 1.781-7.341v-0.5c0-1.931-1.569-3.5-3.5-3.5zM21 13c0 2.222-0.537 4.444-1.556 6.425-0.503 0.972-1.497 1.575-2.597 1.575h-4.887c-0.916 0-1.788-0.434-2.334-1.163l-4.522-6.031c-0.047-0.063-0.103-0.169-0.103-0.306 0-0.275 0.225-0.497 0.5-0.497 0.1 0 0.194 0.028 0.275 0.081l2.678 1.753c0.306 0.2 0.7 0.219 1.022 0.044s0.525-0.513 0.525-0.881v-9c0-0.55 0.45-1 1-1 0.2 0 0.391 0.059 0.559 0.169 0.125 0.084 0.231 0.197 0.309 0.331 0.087 0.153 0.134 0.325 0.134 0.5v7h1v-8c0-0.55 0.45-1 1-1s1 0.45 1 1v8h1v-1c0-0.175 0.047-0.35 0.134-0.5 0.072-0.134 0.178-0.247 0.306-0.331 0.166-0.109 0.359-0.169 0.556-0.169 0.55 0 1 0.45 1 1v2h1v-1.912c0.159-0.056 0.328-0.087 0.5-0.087 0.828 0 1.5 0.672 1.5 1.5v0.5z" })
        );
    }
    function ScrollLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ScrollLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ScrollLeft.SVG = ScrollLeftSVG;
    return ScrollLeft;
})();
export const ScrollRight = /*#__PURE__*/ (() => {
    function ScrollRightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.5 7.206l2.353-2.353c0.194-0.194 0.194-0.513 0-0.706l-2.353-2.353-0.706 0.706 1.5 1.5h-5.294c0-1.653-1.347-3-3-3-0.925 0-1.753 0.422-2.303 1.081-0.228-0.053-0.459-0.081-0.697-0.081-1.653 0-3 1.347-3 3v7.15l-1.128-0.738c-0.406-0.266-0.881-0.409-1.372-0.409-1.378 0-2.5 1.119-2.5 2.497 0 0.541 0.172 1.059 0.497 1.497 0 0.003 0.003 0.003 0.003 0.006l4.525 6.034c0.922 1.228 2.394 1.962 3.934 1.962h4.887c1.85 0 3.525-1.019 4.372-2.656v-0.003c1.166-2.262 1.781-4.803 1.781-7.341v-0.5c0-1.931-1.569-3.5-3.5-3.5-0.087 0-0.172 0.003-0.256 0.009-0.55-0.619-1.353-1.009-2.244-1.009v-3h5.294l-1.5 1.5 0.706 0.706zM17 11v2h1v-1.912c0.159-0.056 0.328-0.087 0.5-0.087 0.828 0 1.5 0.672 1.5 1.5v0.5c0 2.222-0.537 4.444-1.556 6.425-0.503 0.972-1.497 1.575-2.597 1.575h-4.887c-0.916 0-1.788-0.434-2.334-1.163l-4.522-6.031c-0.047-0.063-0.103-0.169-0.103-0.306 0-0.275 0.225-0.497 0.5-0.497 0.1 0 0.194 0.028 0.275 0.081l2.678 1.753c0.306 0.2 0.7 0.219 1.022 0.044s0.525-0.513 0.525-0.881v-9c0-0.55 0.45-1 1-1 0.2 0 0.391 0.059 0.559 0.169 0.125 0.084 0.231 0.197 0.309 0.331 0.087 0.153 0.134 0.325 0.134 0.5v7h1v-8c0-0.55 0.45-1 1-1s1 0.45 1 1v8h1v-1c0-0.175 0.047-0.35 0.134-0.5 0.072-0.134 0.178-0.247 0.306-0.331 0.166-0.109 0.359-0.169 0.556-0.169 0.55 0 1 0.45 1 1z" })
        );
    }
    function ScrollRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ScrollRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ScrollRight.SVG = ScrollRightSVG;
    return ScrollRight;
})();
export const ScrollUp = /*#__PURE__*/ (() => {
    function ScrollUpSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.344 3.781v0c-2.266-1.166-4.806-1.781-7.344-1.781h-0.5c-1.931 0-3.5 1.569-3.5 3.5 0 0.087 0.003 0.172 0.009 0.256-0.619 0.55-1.009 1.353-1.009 2.244h-3v-5.294l1.5 1.5 0.706-0.706-2.353-2.353c-0.194-0.194-0.513-0.194-0.706 0l-2.353 2.353 0.706 0.706 1.5-1.5v5.294c-1.653 0-3 1.347-3 3 0 0.925 0.422 1.753 1.081 2.303-0.053 0.228-0.081 0.459-0.081 0.697 0 1.653 1.347 3 3 3h7.15l-0.738 1.128c-0.266 0.406-0.409 0.881-0.409 1.372 0 1.378 1.119 2.5 2.497 2.5 0.541 0 1.059-0.172 1.497-0.497 0.003 0 0.003-0.003 0.006-0.003l6.034-4.525c1.228-0.922 1.962-2.394 1.962-3.934v-4.887c0-1.85-1.019-3.525-2.656-4.372zM21 13.041c0 0.916-0.434 1.788-1.163 2.334l-6.031 4.522c-0.063 0.047-0.169 0.103-0.306 0.103-0.275 0-0.497-0.225-0.497-0.5 0-0.1 0.028-0.194 0.081-0.275l1.753-2.678c0.2-0.306 0.219-0.7 0.044-1.022s-0.513-0.525-0.881-0.525h-9c-0.55 0-1-0.45-1-1 0-0.2 0.059-0.391 0.169-0.559 0.084-0.125 0.197-0.231 0.331-0.309 0.153-0.087 0.325-0.134 0.5-0.134h7v-1h-8c-0.55 0-1-0.45-1-1s0.45-1 1-1h8v-1h-1c-0.175 0-0.35-0.047-0.5-0.134-0.134-0.072-0.247-0.178-0.331-0.306-0.109-0.166-0.169-0.359-0.169-0.556 0-0.55 0.45-1 1-1h2v-1h-1.912c-0.056-0.159-0.087-0.328-0.087-0.5 0-0.828 0.672-1.5 1.5-1.5h0.5c2.222 0 4.444 0.537 6.425 1.556 0.972 0.503 1.575 1.497 1.575 2.597v4.887z" })
        );
    }
    function ScrollUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ScrollUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ScrollUp.SVG = ScrollUpSVG;
    return ScrollUp;
})();
export const ScrollVertical = /*#__PURE__*/ (() => {
    function ScrollVerticalSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.344 3.781v0c-2.266-1.166-4.806-1.781-7.344-1.781h-0.5c-1.931 0-3.5 1.569-3.5 3.5 0 0.087 0.003 0.172 0.009 0.256-0.619 0.55-1.009 1.353-1.009 2.244h-3v-5.294l1.5 1.5 0.706-0.706-2.353-2.353c-0.194-0.194-0.513-0.194-0.706 0l-2.353 2.353 0.706 0.706 1.5-1.5v5.294c-1.653 0-3 1.347-3 3 0 0.925 0.422 1.753 1.081 2.303-0.053 0.228-0.081 0.459-0.081 0.697 0 1.303 0.837 2.416 2 2.828v5.466l-1.5-1.5-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l2.353-2.353-0.706-0.706-1.5 1.5v-5.294h7.15l-0.738 1.128c-0.266 0.406-0.409 0.881-0.409 1.372 0 1.378 1.119 2.5 2.497 2.5 0.541 0 1.059-0.172 1.497-0.497 0.003 0 0.003-0.003 0.006-0.003l6.034-4.525c1.228-0.922 1.962-2.394 1.962-3.934v-4.887c0-1.85-1.019-3.525-2.656-4.372zM21 13.041c0 0.916-0.434 1.788-1.163 2.334l-6.031 4.522c-0.063 0.047-0.169 0.103-0.306 0.103-0.275 0-0.497-0.225-0.497-0.5 0-0.1 0.028-0.194 0.081-0.275l1.753-2.678c0.2-0.306 0.219-0.7 0.044-1.022s-0.513-0.525-0.881-0.525h-9c-0.55 0-1-0.45-1-1 0-0.2 0.059-0.391 0.169-0.559 0.084-0.125 0.197-0.231 0.331-0.309 0.153-0.087 0.325-0.134 0.5-0.134h7v-1h-8c-0.55 0-1-0.45-1-1s0.45-1 1-1h8v-1h-1c-0.175 0-0.35-0.047-0.5-0.134-0.134-0.072-0.247-0.178-0.331-0.306-0.109-0.166-0.169-0.359-0.169-0.556 0-0.55 0.45-1 1-1h2v-1h-1.912c-0.056-0.159-0.087-0.328-0.087-0.5 0-0.828 0.672-1.5 1.5-1.5h0.5c2.222 0 4.444 0.537 6.425 1.556 0.972 0.503 1.575 1.497 1.575 2.597v4.887z" })
        );
    }
    function ScrollVertical({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ScrollVerticalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ScrollVertical.SVG = ScrollVerticalSVG;
    return ScrollVertical;
})();
export const Search = /*#__PURE__*/ (() => {
        function SearchSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.803 2.197c-1.416-1.416-3.3-2.197-5.303-2.197s-3.888 0.781-5.303 2.197c-1.416 1.416-2.197 3.3-2.197 5.303 0 1.666 0.541 3.25 1.538 4.55l-1.125 1.125c-0.897-0.35-1.959-0.166-2.681 0.556l-6.003 6c-0.972 0.975-0.972 2.562 0.003 3.537 0.488 0.484 1.128 0.728 1.769 0.728s1.281-0.244 1.766-0.731l6.003-6.003c0.719-0.722 0.906-1.781 0.556-2.675l1.125-1.125c1.3 0.997 2.884 1.537 4.55 1.537 2.003 0 3.888-0.781 5.303-2.197s2.197-3.3 2.197-5.303-0.781-3.888-2.197-5.303zM8.853 15.853l-6 6c-0.194 0.194-0.513 0.194-0.706 0s-0.194-0.513 0-0.706l6-6c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.194 0.194 0.194 0.509 0 0.706zM16.5 13c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M20 7v0.5c0 1.931-1.569 3.5-3.5 3.5h-0.5v1h0.5c2.481 0 4.5-2.019 4.5-4.5v-0.5h-1z" })
            );
        }
        function Search({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SearchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Search.SVG = SearchSVG;
        return Search;
    })();
export const Select = /*#__PURE__*/ (() => {
    function SelectSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 0.5c0-0.275-0.225-0.5-0.5-0.5h-23c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h9.5v2c0 0.403 0.244 0.769 0.619 0.925s0.803 0.069 1.091-0.216l2.956-2.956 2.419 5.644c0.109 0.253 0.316 0.45 0.575 0.544 0.113 0.041 0.228 0.059 0.344 0.059 0.153 0 0.306-0.034 0.447-0.106l2.991-1.5c0.481-0.241 0.684-0.822 0.459-1.313l-2.341-5.081h3.441c0.403 0 0.769-0.244 0.925-0.619 0.050-0.125 0.075-0.253 0.075-0.381v0-14.5zM18 14c-0.341 0-0.659 0.175-0.841 0.459-0.184 0.288-0.209 0.647-0.066 0.956l2.587 5.622-1.181 0.594-2.581-6.025c-0.131-0.306-0.403-0.525-0.731-0.588-0.063-0.012-0.125-0.019-0.191-0.019-0.263 0-0.519 0.103-0.706 0.294l-2.291 2.291v-12.169l8.584 8.584h-2.584zM11.706 2.294c-0.288-0.288-0.716-0.372-1.091-0.216s-0.619 0.519-0.619 0.925v14h-8.997v-16.003h22v12.584l-11.294-11.291z" })
        );
    }
    function Select({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SelectSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Select.SVG = SelectSVG;
    return Select;
})();
export const SelfTimer = /*#__PURE__*/ (() => {
        function SelfTimerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 2h-6c-0.553 0-1 0.447-1 1v6h2v-4.141c1.9 1.866 3 4.437 3 7.141 0 5.513-4.488 10-10 10s-10-4.488-10-10c0-3.394 1.7-6.528 4.547-8.384l-1.094-1.675c-3.416 2.228-5.453 5.988-5.453 10.059 0 1.619 0.319 3.191 0.944 4.672 0.603 1.428 1.469 2.712 2.572 3.813s2.384 1.966 3.813 2.572c1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572s1.966-2.384 2.572-3.813c0.625-1.481 0.944-3.053 0.944-4.672 0-1.956-0.481-3.9-1.394-5.616-0.456-0.856-1.016-1.659-1.666-2.384h3.059v-2z" }),
_('path', { d: "M5.128 7.188c-0.325 0.384-0.312 0.953 0.025 1.322l5.384 5.862c0.047 0.047 0.1 0.103 0.166 0.159l0.003 0.003c0.375 0.312 0.831 0.466 1.287 0.466 0.572 0 1.137-0.241 1.531-0.706 0.713-0.841 0.606-2.106-0.234-2.819-0.072-0.059-0.138-0.109-0.206-0.153l-6.647-4.328c-0.419-0.275-0.984-0.191-1.309 0.194zM12.556 12.169c0.028 0.016 0.056 0.037 0.091 0.069 0.422 0.356 0.472 0.987 0.116 1.409-0.356 0.419-0.991 0.475-1.416 0.122-0.028-0.025-0.056-0.053-0.091-0.091l-5.363-5.847 6.663 4.338z" })
            );
        }
        function SelfTimer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SelfTimerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SelfTimer.SVG = SelfTimerSVG;
        return SelfTimer;
    })();
export const SelfTimer2 = /*#__PURE__*/ (() => {
        function SelfTimer2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.522 15.356l0.016 0.016c0.009 0.009 0.019 0.019 0.028 0.028 0.038 0.037 0.078 0.078 0.128 0.125l0.009 0.009c0.375 0.312 0.831 0.466 1.287 0.466 0.572 0 1.137-0.241 1.534-0.706 0.344-0.406 0.509-0.925 0.466-1.456s-0.291-1.013-0.697-1.359c-0.063-0.056-0.131-0.106-0.203-0.153l-6.656-4.334c-0.425-0.272-0.987-0.188-1.309 0.197s-0.312 0.953 0.028 1.322l5.369 5.847zM6.891 8.831c0 0 0.003 0 0.006 0l6.653 4.331c0.034 0.022 0.066 0.047 0.094 0.072l0.003 0.003c0.203 0.172 0.328 0.413 0.35 0.678s-0.059 0.525-0.234 0.728c-0.356 0.419-0.987 0.475-1.413 0.125-0.022-0.019-0.044-0.044-0.069-0.069-0.009-0.009-0.019-0.019-0.028-0.028l-5.363-5.841c0 0.003 0 0.003 0 0z" }),
_('path', { d: "M14.5 5c1.378 0 2.5-1.122 2.5-2.5s-1.122-2.5-2.5-2.5-2.5 1.122-2.5 2.5 1.122 2.5 2.5 2.5zM14.5 1c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5z" }),
_('path', { d: "M21.722 7.85c-0.809-1.525-1.984-2.856-3.397-3.85l-1.15 1.634c2.394 1.688 3.825 4.441 3.825 7.366 0 4.962-4.038 9-9 9s-9-4.038-9-9h-2c0 1.484 0.291 2.925 0.866 4.281 0.553 1.309 1.347 2.487 2.356 3.497s2.187 1.803 3.497 2.356c1.356 0.575 2.797 0.866 4.281 0.866s2.925-0.291 4.281-0.866c1.309-0.553 2.487-1.347 3.497-2.356s1.803-2.187 2.356-3.497c0.575-1.356 0.866-2.797 0.866-4.281 0-1.794-0.441-3.575-1.278-5.15z" })
            );
        }
        function SelfTimer2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SelfTimer2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SelfTimer2.SVG = SelfTimer2SVG;
        return SelfTimer2;
    })();
export const SendBackward = /*#__PURE__*/ (() => {
        function SendBackwardSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 8h-9c-1.103 0-2 0.897-2 2v4c0 1.103 0.897 2 2 2h9c1.103 0 2-0.897 2-2v-4c0-1.103-0.897-2-2-2zM22 14h-9v-4h9v4c0 0 0 0 0 0z" }),
_('path', { d: "M23.5 18h-12c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h12c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5zM23 23h-11v-4h11v4z" }),
_('path', { d: "M23.5 0h-12c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h12c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5zM23 5h-11v-4h11v4z" }),
_('path', { d: "M5 10.584v-10.584h-2v10.584l-1.544-1.544-1.413 1.416 3.25 3.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l3.25-3.25-1.416-1.416-1.541 1.544z" })
            );
        }
        function SendBackward({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SendBackwardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SendBackward.SVG = SendBackwardSVG;
        return SendBackward;
    })();
export const Server = /*#__PURE__*/ (() => {
        function ServerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 10v-4c0-0.472-0.166-0.909-0.441-1.253v0l-3.669-4.559c-0.094-0.119-0.237-0.188-0.391-0.188h-13c-0.15 0-0.294 0.069-0.391 0.188l-3.669 4.563c-0.275 0.341-0.441 0.778-0.441 1.25v4c0 0.597 0.263 1.134 0.678 1.5-0.416 0.366-0.678 0.903-0.678 1.5v2c0 0.597 0.262 1.134 0.678 1.5-0.416 0.366-0.678 0.903-0.678 1.5v4c0 1.103 0.897 2 2 2h18c1.103 0 2-0.897 2-2v-4c0-0.597-0.263-1.134-0.678-1.5 0.416-0.366 0.678-0.903 0.678-1.5v-2c0-0.597-0.263-1.134-0.678-1.5 0.416-0.366 0.678-0.903 0.678-1.5zM5.741 1h12.522l2.412 3h-17.35l2.416-3zM21 22h-18l-0.003-4c0 0 0 0 0.003 0v-1h18v5zM21.003 15c0 0-0.003 0 0 0l-0.003 1h-18v-1l-0.003-2c0 0 0 0 0.003 0v-1h18v1l0.003 2zM3 11v-5h18v5h-18z" }),
_('path', { d: "M17 8h3v1h-3v-1z" }),
_('path', { d: "M15 8h1v1h-1v-1z" }),
_('path', { d: "M17 13h3v1h-3v-1z" }),
_('path', { d: "M15 13h1v1h-1v-1z" }),
_('path', { d: "M4 18h1v1h-1v-1z" }),
_('path', { d: "M6 18h1v1h-1v-1z" }),
_('path', { d: "M8 18h1v1h-1v-1z" }),
_('path', { d: "M10 18h1v1h-1v-1z" }),
_('path', { d: "M17 20h3v1h-3v-1z" }),
_('path', { d: "M15 20h1v1h-1v-1z" })
            );
        }
        function Server({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ServerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Server.SVG = ServerSVG;
        return Server;
    })();
export const SettingsIcons = /*#__PURE__*/ (() => {
        function SettingsIconsSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-13c-1.103 0-2 0.897-2 2v13c0 1.103 0.897 2 2 2h13c1.103 0 2-0.897 2-2v-13c0-1.103-0.897-2-2-2zM22 15h-13v-13h13v13z" }),
_('path', { d: "M15.5 10c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM15.5 8c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M10.184 10.006c-0.034 0.128-0.016 0.266 0.050 0.378l1 1.731c0.138 0.237 0.444 0.322 0.681 0.184l1.591-0.919c0.078 0.053 0.156 0.103 0.241 0.153s0.166 0.094 0.25 0.131v1.838c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-1.838c0.081-0.041 0.166-0.084 0.25-0.131 0.081-0.047 0.162-0.1 0.241-0.153l1.591 0.912c0.237 0.138 0.544 0.056 0.681-0.184l1-1.731c0.066-0.116 0.084-0.25 0.050-0.378s-0.119-0.237-0.234-0.303l-1.591-0.919c0.006-0.091 0.009-0.184 0.009-0.281 0-0.094-0.003-0.188-0.009-0.281l1.591-0.919c0.116-0.066 0.2-0.175 0.234-0.303s0.016-0.266-0.050-0.378l-1-1.731c-0.138-0.237-0.444-0.322-0.681-0.184l-1.591 0.919c-0.078-0.053-0.156-0.103-0.241-0.153s-0.166-0.094-0.25-0.131v-1.838c0-0.275-0.225-0.5-0.5-0.5h-2c-0.275 0-0.5 0.225-0.5 0.5v1.838c-0.081 0.041-0.166 0.084-0.25 0.131-0.081 0.047-0.162 0.1-0.241 0.153l-1.591-0.912c-0.237-0.138-0.544-0.056-0.681 0.184l-1 1.731c-0.066 0.116-0.084 0.25-0.050 0.378s0.119 0.237 0.234 0.303l1.591 0.919c-0.006 0.091-0.009 0.184-0.009 0.281 0 0.094 0.003 0.188 0.009 0.281l-1.591 0.919c-0.116 0.066-0.2 0.175-0.234 0.303zM12.8 9.484c0.184-0.106 0.281-0.319 0.241-0.528-0.028-0.141-0.041-0.294-0.041-0.453 0-0.162 0.012-0.312 0.041-0.45 0.041-0.209-0.056-0.422-0.241-0.528l-1.447-0.837 0.5-0.866 1.45 0.831c0.184 0.106 0.416 0.084 0.575-0.056 0.112-0.097 0.237-0.188 0.372-0.266 0.144-0.081 0.278-0.144 0.413-0.191 0.2-0.069 0.337-0.259 0.337-0.472v-1.672h1v1.672c0 0.213 0.134 0.403 0.337 0.472 0.134 0.047 0.272 0.109 0.413 0.191 0.134 0.078 0.259 0.166 0.372 0.266 0.162 0.138 0.394 0.162 0.575 0.056l1.447-0.834 0.5 0.866-1.447 0.834c-0.184 0.106-0.281 0.319-0.241 0.528 0.028 0.141 0.041 0.294 0.041 0.453 0 0.162-0.012 0.312-0.041 0.45-0.041 0.209 0.056 0.422 0.241 0.528l1.447 0.834-0.5 0.866-1.45-0.831c-0.184-0.106-0.416-0.084-0.575 0.056-0.112 0.097-0.237 0.188-0.372 0.266-0.144 0.081-0.278 0.144-0.413 0.191-0.2 0.069-0.337 0.259-0.337 0.472v1.672h-1v-1.672c0-0.213-0.134-0.403-0.337-0.472-0.134-0.047-0.272-0.109-0.413-0.191-0.134-0.078-0.259-0.166-0.372-0.266-0.162-0.138-0.394-0.162-0.575-0.056l-1.45 0.834-0.5-0.866 1.45-0.831z" }),
_('path', { d: "M5.5 4h-5c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h5c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5zM5 9h-4v-4h4v4z" }),
_('path', { d: "M5.5 11h-5c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h5c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5zM5 16h-4v-4h4v4z" }),
_('path', { d: "M5.5 18h-5c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h5c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5zM5 23h-4v-4h4v4z" }),
_('path', { d: "M12.5 18h-5c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h5c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5zM12 23h-4v-4h4v4z" }),
_('path', { d: "M19.5 18h-5c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h5c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5zM19 23h-4v-4h4v4z" })
            );
        }
        function SettingsIcons({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SettingsIconsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SettingsIcons.SVG = SettingsIconsSVG;
        return SettingsIcons;
    })();
export const Share = /*#__PURE__*/ (() => {
        function ShareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 18h2v-5c0-2.756 2.244-5 5-5h7.584l-2.544 2.544 1.416 1.416 4.25-4.25c0.391-0.391 0.391-1.025 0-1.416l-4.25-4.25-1.416 1.416 2.544 2.544h-7.584c-3.859 0-7 3.141-7 7v4.997z" }),
_('path', { d: "M23 21h-22v-15h5v-1h-5.5c-0.275 0-0.5 0.225-0.5 0.5v16c0 0.275 0.225 0.5 0.5 0.5h23c0.275 0 0.5-0.225 0.5-0.5v-9.5h-1v9z" })
            );
        }
        function Share({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Share.SVG = ShareSVG;
        return Share;
    })();
export const Share2 = /*#__PURE__*/ (() => {
    function Share2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19.5 15c-1.538 0-2.897 0.775-3.709 1.956l-7.109-3.794c0.206-0.516 0.319-1.075 0.319-1.662 0-0.503-0.084-0.987-0.234-1.437l6.897-3.219c0.791 1.294 2.216 2.156 3.841 2.156 2.481 0 4.5-2.019 4.5-4.5s-2.022-4.5-4.503-4.5-4.5 2.019-4.5 4.5c0 0.503 0.084 0.987 0.234 1.437l-6.894 3.219c-0.791-1.294-2.216-2.156-3.841-2.156-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5c1.537 0 2.897-0.775 3.709-1.956l7.109 3.791c-0.206 0.516-0.319 1.075-0.319 1.662 0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5-2.019-4.497-4.5-4.497zM19.5 2c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5-2.5-1.122-2.5-2.5 1.122-2.5 2.5-2.5zM4.5 14c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5zM19.5 22c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5z" })
        );
    }
    function Share2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Share2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Share2.SVG = Share2SVG;
    return Share2;
})();
export const Share3 = /*#__PURE__*/ (() => {
        function Share3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 6c1.669 0 3.275 0.703 4.406 1.928l1.469-1.356c-0.741-0.803-1.622-1.434-2.616-1.878-1.028-0.459-2.125-0.694-3.259-0.694-4.028 0-7.441 3.009-7.938 7h-4.062v2h4.062c1.006 0 1.859-0.753 1.984-1.75 0.372-2.994 2.931-5.25 5.953-5.25z" }),
_('path', { d: "M19.938 11c-1.006 0-1.859 0.753-1.984 1.75-0.372 2.994-2.931 5.25-5.953 5.25-1.669 0-3.275-0.703-4.406-1.928l-1.469 1.356c0.741 0.803 1.622 1.434 2.616 1.878 1.028 0.459 2.125 0.694 3.259 0.694 4.028 0 7.441-3.009 7.938-7h4.062v-2h-4.062z" }),
_('path', { d: "M8 12c0 2.206 1.794 4 4 4s4-1.794 4-4c0-2.206-1.794-4-4-4s-4 1.794-4 4zM15 12c0 1.653-1.347 3-3 3s-3-1.347-3-3 1.347-3 3-3 3 1.347 3 3z" })
            );
        }
        function Share3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Share3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Share3.SVG = Share3SVG;
        return Share3;
    })();
export const ShieldBolt = /*#__PURE__*/ (() => {
        function ShieldBoltSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.713 4.3c-0.188-0.191-0.444-0.3-0.712-0.3-1.328 0-3.169-0.481-5.181-1.356-1.688-0.731-3.322-1.675-4.166-2.4-0.375-0.322-0.931-0.322-1.306 0-0.844 0.728-2.478 1.672-4.166 2.403-2.013 0.872-3.853 1.353-5.181 1.353-0.269 0-0.525 0.109-0.712 0.3s-0.291 0.45-0.288 0.719c0.003 0.119 0.069 2.953 1.381 6.687 0.769 2.187 1.812 4.241 3.1 6.097 1.609 2.325 3.606 4.347 5.937 6.009 0.175 0.125 0.378 0.188 0.581 0.188s0.406-0.063 0.581-0.188c2.328-1.662 4.325-3.684 5.937-6.009 1.287-1.856 2.328-3.909 3.1-6.097 1.313-3.734 1.381-6.569 1.381-6.687 0.006-0.269-0.097-0.528-0.288-0.719zM19.706 11.112c-1.547 4.35-4.137 7.928-7.706 10.644-3.569-2.719-6.159-6.297-7.706-10.644-0.787-2.216-1.097-4.106-1.219-5.181 1.75-0.213 3.578-0.878 4.9-1.453 1.528-0.659 2.994-1.469 4.025-2.212 1.031 0.741 2.497 1.55 4.022 2.212 1.322 0.575 3.15 1.241 4.9 1.453-0.119 1.075-0.428 2.969-1.216 5.181z" }),
_('path', { d: "M15.5 10h-2.191l1.638-3.275c0.078-0.156 0.069-0.341-0.022-0.488s-0.253-0.237-0.425-0.237h-4c-0.244 0-0.453 0.178-0.494 0.419l-1 6c-0.025 0.144 0.016 0.294 0.113 0.406s0.234 0.178 0.381 0.178h1.391l-0.881 4.403c-0.047 0.231 0.075 0.462 0.291 0.556 0.066 0.028 0.131 0.041 0.2 0.041 0.156 0 0.309-0.075 0.406-0.209l5-7c0.109-0.153 0.122-0.353 0.037-0.519s-0.256-0.275-0.444-0.275zM11.447 15.312l0.544-2.716c0.028-0.147-0.009-0.3-0.103-0.416s-0.237-0.184-0.387-0.184h-1.409l0.834-5h2.769l-1.638 3.275c-0.078 0.156-0.069 0.341 0.022 0.488s0.253 0.237 0.425 0.237h2.028l-3.084 4.316z" })
            );
        }
        function ShieldBolt({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShieldBoltSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ShieldBolt.SVG = ShieldBoltSVG;
        return ShieldBolt;
    })();
export const ShieldCheck = /*#__PURE__*/ (() => {
        function ShieldCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16.5 9c0.128 0 0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147z" }),
_('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5-1.544 0-2.962 0.541-4.078 1.441-0.744-0.428-1.366-0.85-1.769-1.197-0.375-0.325-0.931-0.325-1.306 0-0.844 0.728-2.478 1.672-4.166 2.403-2.013 0.872-3.853 1.353-5.181 1.353-0.269 0-0.525 0.109-0.712 0.3s-0.291 0.45-0.288 0.719c0.003 0.119 0.069 2.953 1.381 6.687 0.769 2.187 1.812 4.241 3.1 6.097 1.609 2.325 3.606 4.347 5.937 6.009 0.175 0.125 0.378 0.188 0.581 0.188s0.406-0.063 0.581-0.188c2.112-1.506 3.956-3.316 5.478-5.372 1.253-1.691 2.3-3.563 3.112-5.562v0c0.078-0.191 0.15-0.375 0.219-0.559 2.137-1.066 3.609-3.272 3.609-5.819zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM15.503 12.687c-1.144 2.403-2.784 4.647-4.503 6.156-3.003-2.637-5.575-7.359-5.963-10.938 2.513-0.522 4.334-1.644 5.963-2.794 0.044 0.031 0.087 0.063 0.131 0.091-0.084 0.419-0.131 0.853-0.131 1.297 0 2.888 1.894 5.341 4.503 6.188zM11 21.756c-3.569-2.719-6.159-6.297-7.706-10.644-0.787-2.216-1.097-4.106-1.219-5.181 1.75-0.213 3.578-0.878 4.9-1.453 1.528-0.659 2.994-1.469 4.025-2.213 0.312 0.222 0.666 0.453 1.053 0.687-0.25 0.384-0.462 0.797-0.628 1.231-0.044-0.031-0.087-0.063-0.134-0.097-0.175-0.125-0.406-0.125-0.581 0-1.706 1.219-3.6 2.45-6.294 2.916-0.25 0.044-0.428 0.269-0.412 0.522 0.119 1.984 0.884 4.362 2.159 6.691 1.25 2.284 2.856 4.297 4.525 5.666 0.091 0.075 0.203 0.112 0.316 0.112s0.225-0.038 0.316-0.112c1.988-1.631 3.903-4.212 5.178-6.963 0.328 0.050 0.663 0.078 1.003 0.078 0.153 0 0.303-0.006 0.453-0.016-1.587 3.525-3.922 6.469-6.953 8.775z" })
            );
        }
        function ShieldCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShieldCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ShieldCheck.SVG = ShieldCheckSVG;
        return ShieldCheck;
    })();
export const ShieldCross = /*#__PURE__*/ (() => {
        function ShieldCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5-1.544 0-2.962 0.541-4.078 1.441-0.744-0.428-1.366-0.85-1.769-1.197-0.375-0.325-0.931-0.325-1.306 0-0.844 0.728-2.478 1.672-4.166 2.403-2.013 0.872-3.853 1.353-5.181 1.353-0.269 0-0.525 0.109-0.712 0.3s-0.291 0.45-0.288 0.719c0.003 0.119 0.069 2.953 1.381 6.687 0.769 2.187 1.812 4.241 3.1 6.097 1.609 2.325 3.606 4.347 5.937 6.009 0.175 0.125 0.378 0.188 0.581 0.188s0.406-0.063 0.581-0.188c2.112-1.506 3.956-3.316 5.478-5.372 1.253-1.691 2.3-3.563 3.112-5.562v0c0.078-0.191 0.15-0.375 0.219-0.559 2.137-1.066 3.609-3.272 3.609-5.819zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM15.503 12.687c-1.144 2.403-2.784 4.647-4.503 6.156-3.003-2.637-5.575-7.359-5.963-10.938 2.513-0.522 4.334-1.644 5.963-2.794 0.044 0.031 0.087 0.063 0.131 0.091-0.084 0.419-0.131 0.853-0.131 1.297 0 2.888 1.894 5.341 4.503 6.188zM11 21.756c-3.569-2.719-6.159-6.297-7.706-10.644-0.787-2.216-1.097-4.106-1.219-5.181 1.75-0.213 3.578-0.878 4.9-1.453 1.528-0.659 2.994-1.469 4.025-2.213 0.312 0.222 0.666 0.453 1.053 0.687-0.25 0.384-0.462 0.797-0.628 1.231-0.044-0.031-0.087-0.063-0.134-0.097-0.175-0.125-0.406-0.125-0.581 0-1.706 1.219-3.6 2.45-6.294 2.916-0.25 0.044-0.428 0.269-0.412 0.522 0.119 1.984 0.884 4.362 2.159 6.691 1.25 2.284 2.856 4.297 4.525 5.666 0.091 0.075 0.203 0.112 0.316 0.112s0.225-0.038 0.316-0.112c1.988-1.631 3.903-4.212 5.178-6.963 0.328 0.050 0.663 0.078 1.003 0.078 0.153 0 0.303-0.006 0.453-0.016-1.587 3.525-3.922 6.469-6.953 8.775z" }),
_('path', { d: "M15.5 9.206l2-2 2 2 0.706-0.706-2-2 2-2-0.706-0.706-2 2-2-2-0.706 0.706 2 2-2 2z" })
            );
        }
        function ShieldCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShieldCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ShieldCross.SVG = ShieldCrossSVG;
        return ShieldCross;
    })();
export const ShieldDroplet = /*#__PURE__*/ (() => {
        function ShieldDropletSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1.287 4.3c0.188-0.191 0.444-0.3 0.712-0.3 1.328 0 3.169-0.481 5.181-1.356 1.687-0.731 3.322-1.675 4.166-2.4 0.375-0.322 0.931-0.322 1.306 0 0.844 0.728 2.478 1.672 4.166 2.403 2.013 0.872 3.853 1.353 5.181 1.353 0.269 0 0.525 0.109 0.713 0.3s0.291 0.45 0.288 0.719c-0.003 0.119-0.069 2.953-1.381 6.687-0.769 2.187-1.812 4.241-3.1 6.097-1.609 2.325-3.606 4.347-5.937 6.009-0.175 0.125-0.378 0.188-0.581 0.188s-0.406-0.063-0.581-0.188c-2.328-1.662-4.325-3.684-5.937-6.009-1.287-1.856-2.328-3.909-3.1-6.097-1.312-3.734-1.381-6.569-1.381-6.687-0.006-0.269 0.097-0.528 0.288-0.719zM4.294 11.112c1.547 4.35 4.137 7.928 7.706 10.644 3.569-2.719 6.159-6.297 7.706-10.644 0.788-2.216 1.097-4.106 1.219-5.181-1.75-0.213-3.578-0.878-4.9-1.453-1.528-0.659-2.994-1.469-4.025-2.212-1.031 0.741-2.497 1.55-4.022 2.212-1.322 0.575-3.15 1.241-4.9 1.453 0.119 1.075 0.428 2.969 1.216 5.181z" }),
_('path', { d: "M11.506 5.422c0.038-0.244 0.247-0.422 0.494-0.422 0 0 0 0 0 0 0.247 0 0.456 0.178 0.494 0.422 0.147 0.941 0.8 2.031 1.494 3.187 0.944 1.575 2.013 3.363 2.013 5.213 0 1.081-0.378 2.103-1.069 2.881-0.741 0.837-1.784 1.3-2.931 1.3-1.15 0-2.191-0.462-2.931-1.297-0.687-0.775-1.069-1.8-1.069-2.881 0-1.85 1.069-3.634 2.013-5.213 0.691-1.159 1.344-2.25 1.494-3.191zM12 17c1.95 0 3-1.638 3-3.178 0-1.572-0.95-3.162-1.872-4.7-0.419-0.697-0.822-1.375-1.128-2.034-0.306 0.659-0.712 1.338-1.128 2.037-0.919 1.537-1.872 3.125-1.872 4.697 0 1.541 1.050 3.178 3 3.178z" }),
_('path', { d: "M12 15v1c-1.103 0-2-0.897-2-2h1c0 0.55 0.45 1 1 1z" })
            );
        }
        function ShieldDroplet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShieldDropletSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ShieldDroplet.SVG = ShieldDropletSVG;
        return ShieldDroplet;
    })();
export const ShieldInfo = /*#__PURE__*/ (() => {
        function ShieldInfoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5-1.544 0-2.962 0.541-4.078 1.441-0.744-0.428-1.366-0.85-1.769-1.197-0.375-0.325-0.931-0.325-1.306 0-0.844 0.728-2.478 1.672-4.166 2.403-2.013 0.872-3.853 1.353-5.181 1.353-0.269 0-0.525 0.109-0.712 0.3s-0.291 0.45-0.288 0.719c0.003 0.119 0.069 2.953 1.381 6.687 0.769 2.187 1.812 4.241 3.1 6.097 1.609 2.325 3.606 4.347 5.937 6.009 0.175 0.125 0.378 0.188 0.581 0.188s0.406-0.063 0.581-0.188c2.112-1.506 3.956-3.316 5.478-5.372 1.209-1.631 2.228-3.434 3.028-5.359 0.003-0.009 0.006-0.016 0.009-0.025 0.025-0.059 0.050-0.119 0.075-0.178v0c0.078-0.191 0.15-0.378 0.219-0.559 2.137-1.066 3.609-3.272 3.609-5.819zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM15.503 12.684c-1.144 2.406-2.784 4.65-4.503 6.159-3.003-2.637-5.575-7.359-5.963-10.938 2.513-0.522 4.334-1.644 5.963-2.794 0.044 0.031 0.087 0.059 0.131 0.091-0.084 0.419-0.131 0.853-0.131 1.297 0 2.888 1.894 5.341 4.503 6.184zM11 21.756c-3.569-2.719-6.159-6.297-7.706-10.644-0.787-2.216-1.097-4.106-1.219-5.181 1.75-0.213 3.578-0.878 4.9-1.453 1.528-0.659 2.994-1.469 4.025-2.213 0.312 0.222 0.666 0.453 1.053 0.691-0.25 0.384-0.462 0.797-0.628 1.231-0.044-0.031-0.091-0.066-0.134-0.097-0.175-0.125-0.406-0.125-0.581 0-1.706 1.219-3.6 2.45-6.294 2.916-0.25 0.044-0.428 0.269-0.412 0.522 0.119 1.984 0.884 4.362 2.159 6.691 1.25 2.284 2.856 4.297 4.525 5.666 0.094 0.075 0.203 0.112 0.316 0.112s0.225-0.038 0.316-0.112c1.988-1.631 3.903-4.212 5.178-6.966 0.328 0.050 0.663 0.078 1.003 0.078 0.153 0 0.303-0.006 0.453-0.016-1.587 3.522-3.922 6.469-6.953 8.775z" }),
_('path', { d: "M19 9h-1v-3.5c0-0.275-0.225-0.5-0.5-0.5h-1.5v1h1v3h-1v1h3v-1z" }),
_('path', { d: "M17 3h1v1h-1v-1z" })
            );
        }
        function ShieldInfo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShieldInfoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ShieldInfo.SVG = ShieldInfoSVG;
        return ShieldInfo;
    })();
export const ShieldPlus = /*#__PURE__*/ (() => {
        function ShieldPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5-1.544 0-2.962 0.541-4.078 1.441-0.744-0.428-1.366-0.85-1.769-1.197-0.375-0.325-0.931-0.325-1.306 0-0.844 0.728-2.478 1.672-4.166 2.403-2.013 0.872-3.853 1.353-5.181 1.353-0.269 0-0.525 0.109-0.712 0.3s-0.291 0.45-0.288 0.719c0.003 0.119 0.069 2.953 1.381 6.687 0.769 2.187 1.812 4.241 3.1 6.097 1.609 2.325 3.606 4.347 5.937 6.009 0.175 0.125 0.378 0.188 0.581 0.188s0.406-0.063 0.581-0.188c2.112-1.506 3.956-3.316 5.478-5.372 1.253-1.691 2.3-3.563 3.112-5.562v0c0.078-0.191 0.15-0.375 0.219-0.559 2.137-1.066 3.609-3.272 3.609-5.819zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM15.503 12.687c-1.144 2.403-2.784 4.647-4.503 6.156-3.003-2.637-5.575-7.359-5.963-10.938 2.513-0.522 4.334-1.644 5.963-2.794 0.044 0.031 0.087 0.059 0.131 0.091-0.084 0.419-0.128 0.853-0.128 1.294-0.003 2.891 1.891 5.344 4.5 6.191zM11 21.756c-3.569-2.719-6.159-6.297-7.706-10.644-0.787-2.216-1.097-4.106-1.219-5.181 1.75-0.213 3.578-0.878 4.9-1.453 1.528-0.659 2.994-1.469 4.025-2.213 0.312 0.222 0.666 0.453 1.053 0.687-0.25 0.384-0.462 0.797-0.628 1.231-0.044-0.031-0.091-0.063-0.134-0.097-0.175-0.125-0.406-0.125-0.581 0-1.706 1.219-3.6 2.45-6.294 2.916-0.25 0.044-0.428 0.269-0.412 0.522 0.119 1.984 0.884 4.362 2.159 6.691 1.25 2.284 2.856 4.297 4.525 5.666 0.094 0.075 0.203 0.112 0.316 0.112s0.225-0.038 0.316-0.112c1.988-1.631 3.903-4.212 5.178-6.963 0.328 0.050 0.663 0.078 1.003 0.078 0.153 0 0.303-0.006 0.453-0.016-1.587 3.525-3.922 6.469-6.953 8.775z" }),
_('path', { d: "M17 9h1v-2h2v-1h-2v-2h-1v2h-2v1h2z" })
            );
        }
        function ShieldPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShieldPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ShieldPlus.SVG = ShieldPlusSVG;
        return ShieldPlus;
    })();
export const ShieldStar = /*#__PURE__*/ (() => {
        function ShieldStarSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.713 4.3c-0.188-0.191-0.444-0.3-0.712-0.3-1.328 0-3.169-0.481-5.181-1.356-1.688-0.731-3.322-1.675-4.166-2.4-0.375-0.322-0.931-0.322-1.306 0-0.844 0.728-2.478 1.672-4.166 2.403-2.013 0.872-3.853 1.353-5.181 1.353-0.269 0-0.525 0.109-0.712 0.3s-0.291 0.45-0.288 0.719c0.003 0.119 0.069 2.953 1.381 6.687 0.769 2.187 1.812 4.241 3.1 6.097 1.609 2.325 3.606 4.347 5.937 6.009 0.175 0.125 0.378 0.188 0.581 0.188s0.406-0.063 0.581-0.188c2.328-1.662 4.325-3.684 5.937-6.009 1.287-1.856 2.328-3.909 3.1-6.097 1.313-3.734 1.381-6.569 1.381-6.687 0.006-0.269-0.097-0.528-0.288-0.719zM19.706 11.112c-1.547 4.35-4.137 7.928-7.706 10.644-3.569-2.719-6.159-6.297-7.706-10.644-0.787-2.216-1.097-4.106-1.219-5.181 1.75-0.213 3.578-0.878 4.9-1.453 1.528-0.659 2.994-1.469 4.025-2.212 1.031 0.741 2.497 1.55 4.022 2.212 1.322 0.575 3.15 1.241 4.9 1.453-0.119 1.075-0.428 2.969-1.216 5.181z" }),
_('path', { d: "M12.447 6.275c-0.084-0.169-0.259-0.275-0.447-0.275s-0.363 0.106-0.447 0.275l-1.362 2.725h-2.691c-0.213 0-0.4 0.134-0.472 0.334-0.069 0.2-0.006 0.422 0.159 0.556l2.241 1.791-0.909 3.181c-0.056 0.2 0.016 0.419 0.188 0.541 0.087 0.063 0.191 0.097 0.294 0.097 0.097 0 0.194-0.028 0.278-0.084l2.722-1.816 2.722 1.816c0.175 0.116 0.406 0.113 0.575-0.012s0.244-0.344 0.181-0.544l-0.941-3.175 2.272-1.791c0.169-0.131 0.231-0.356 0.162-0.556s-0.259-0.337-0.472-0.337h-2.691l-1.362-2.725zM13.653 11.106c-0.159 0.128-0.228 0.337-0.169 0.534l0.644 2.175-1.85-1.234c-0.169-0.112-0.387-0.112-0.556 0l-1.869 1.247 0.625-2.191c0.056-0.194-0.012-0.403-0.169-0.528l-1.384-1.109h1.575c0.191 0 0.363-0.106 0.447-0.275l1.053-2.106 1.053 2.106c0.084 0.169 0.259 0.275 0.447 0.275h1.559l-1.406 1.106z" })
            );
        }
        function ShieldStar({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShieldStarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ShieldStar.SVG = ShieldStarSVG;
        return ShieldStar;
    })();
export const ShieldSync = /*#__PURE__*/ (() => {
        function ShieldSyncSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5-1.544 0-2.962 0.541-4.078 1.441-0.744-0.428-1.366-0.85-1.769-1.197-0.375-0.325-0.931-0.325-1.306 0-0.844 0.728-2.478 1.672-4.166 2.403-2.013 0.872-3.853 1.353-5.181 1.353-0.269 0-0.525 0.109-0.712 0.3s-0.291 0.45-0.288 0.719c0.003 0.119 0.069 2.953 1.381 6.687 0.769 2.187 1.812 4.241 3.1 6.097 1.609 2.325 3.606 4.347 5.937 6.009 0.175 0.125 0.378 0.188 0.581 0.188s0.406-0.063 0.581-0.188c2.112-1.506 3.956-3.316 5.478-5.372 1.253-1.691 2.3-3.563 3.112-5.562v0c0.078-0.191 0.15-0.375 0.219-0.559 2.137-1.066 3.609-3.272 3.609-5.819zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM15.503 12.687c-1.144 2.403-2.784 4.647-4.503 6.156-3.003-2.637-5.575-7.359-5.963-10.938 2.513-0.522 4.334-1.644 5.963-2.794 0.044 0.031 0.087 0.063 0.131 0.091-0.084 0.419-0.131 0.853-0.131 1.297 0 2.888 1.894 5.341 4.503 6.188zM11 21.756c-3.569-2.719-6.159-6.297-7.706-10.644-0.787-2.216-1.097-4.106-1.219-5.181 1.75-0.213 3.578-0.878 4.9-1.453 1.528-0.659 2.994-1.469 4.025-2.213 0.312 0.222 0.666 0.453 1.053 0.687-0.25 0.384-0.462 0.797-0.628 1.231-0.044-0.031-0.087-0.063-0.134-0.097-0.175-0.125-0.406-0.125-0.581 0-1.706 1.219-3.6 2.45-6.294 2.916-0.25 0.044-0.428 0.269-0.412 0.522 0.119 1.984 0.884 4.362 2.159 6.691 1.25 2.284 2.856 4.297 4.525 5.666 0.091 0.075 0.203 0.112 0.316 0.112s0.225-0.038 0.316-0.112c1.988-1.631 3.903-4.212 5.178-6.963 0.328 0.050 0.663 0.078 1.003 0.078 0.153 0 0.303-0.006 0.453-0.016-1.587 3.525-3.922 6.469-6.953 8.775z" }),
_('path', { d: "M15 6.5c0-1.306 1.006-2.381 2.284-2.491l-0.491 0.491 0.706 0.706 1.353-1.353c0.194-0.194 0.194-0.513 0-0.706l-1.353-1.353-0.706 0.706 0.506 0.506c-1.837 0.103-3.3 1.631-3.3 3.494v0.5h1v-0.5z" }),
_('path', { d: "M18.206 8.5l-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706-0.506-0.506c1.837-0.103 3.3-1.631 3.3-3.494v-0.5h-1v0.5c0 1.306-1.006 2.381-2.284 2.491l0.491-0.491z" })
            );
        }
        function ShieldSync({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShieldSyncSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ShieldSync.SVG = ShieldSyncSVG;
        return ShieldSync;
    })();
export const ShieldUser = /*#__PURE__*/ (() => {
        function ShieldUserSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.713 4.3c-0.188-0.191-0.444-0.3-0.712-0.3-1.328 0-3.169-0.481-5.181-1.356-1.688-0.731-3.322-1.675-4.166-2.4-0.375-0.322-0.931-0.322-1.306 0-0.844 0.728-2.478 1.672-4.166 2.403-2.013 0.872-3.853 1.353-5.181 1.353-0.269 0-0.525 0.109-0.712 0.3s-0.291 0.45-0.288 0.719c0.003 0.119 0.069 2.953 1.381 6.687 0.769 2.187 1.812 4.241 3.1 6.097 1.609 2.325 3.606 4.347 5.937 6.009 0.175 0.125 0.378 0.188 0.581 0.188s0.406-0.063 0.581-0.188c2.328-1.662 4.325-3.684 5.937-6.009 1.287-1.856 2.328-3.909 3.1-6.097 1.313-3.734 1.381-6.569 1.381-6.687 0.006-0.269-0.097-0.528-0.288-0.719zM19.706 11.112c-1.547 4.35-4.137 7.928-7.706 10.644-3.569-2.719-6.159-6.297-7.706-10.644-0.787-2.216-1.097-4.106-1.219-5.181 1.75-0.213 3.578-0.878 4.9-1.453 1.528-0.659 2.994-1.469 4.025-2.212 1.031 0.741 2.497 1.55 4.022 2.212 1.322 0.575 3.15 1.241 4.9 1.453-0.119 1.075-0.428 2.969-1.216 5.181z" }),
_('path', { d: "M14.322 11.578c-0.147-0.087-0.3-0.162-0.456-0.231 0.691-0.55 1.134-1.397 1.134-2.347 0-1.653-1.347-3-3-3s-3 1.347-3 3c0 0.95 0.444 1.797 1.134 2.347-0.156 0.066-0.309 0.144-0.456 0.231-0.631 0.372-1.156 0.916-1.606 1.666-0.141 0.231-0.069 0.534 0.159 0.681 1.144 0.722 2.378 1.075 3.769 1.075s2.625-0.353 3.769-1.078c0.228-0.147 0.3-0.447 0.159-0.681-0.45-0.747-0.975-1.291-1.606-1.662zM10 9c0-1.103 0.897-2 2-2s2 0.897 2 2-0.897 2-2 2c-1.103 0-2-0.897-2-2zM12 14c-1.019 0-1.934-0.219-2.787-0.666 0.691-0.919 1.569-1.334 2.787-1.334s2.097 0.416 2.787 1.334c-0.853 0.447-1.769 0.666-2.787 0.666z" })
            );
        }
        function ShieldUser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShieldUserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ShieldUser.SVG = ShieldUserSVG;
        return ShieldUser;
    })();
export const ShieldWarning = /*#__PURE__*/ (() => {
        function ShieldWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.841 8.828l-4-7.997c-0.25-0.506-0.775-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-0.984 1.966c-2.059-0.85-3.769-1.903-4.522-2.55-0.375-0.322-0.931-0.322-1.306 0-0.844 0.728-2.478 1.672-4.166 2.403-2.013 0.872-3.853 1.353-5.181 1.353-0.269 0-0.525 0.109-0.712 0.3s-0.291 0.45-0.288 0.719c0.003 0.119 0.069 2.953 1.381 6.687 0.769 2.187 1.812 4.241 3.1 6.097 1.609 2.325 3.606 4.347 5.937 6.009 0.175 0.125 0.378 0.188 0.581 0.188s0.406-0.063 0.581-0.188c2.5-1.788 4.616-3.984 6.284-6.528 1.263-1.925 2.266-4.038 2.988-6.284h1.647c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672zM11 21.756c-3.569-2.719-6.159-6.294-7.706-10.644-0.787-2.216-1.097-4.106-1.219-5.181 1.75-0.213 3.578-0.878 4.9-1.453 1.528-0.659 2.994-1.472 4.025-2.213 1.097 0.787 2.681 1.647 4.278 2.322l-0.738 1.475c-1.263-0.578-2.334-1.316-3.25-1.972-0.175-0.125-0.406-0.125-0.581 0-1.706 1.219-3.6 2.45-6.294 2.916-0.25 0.044-0.428 0.269-0.413 0.522 0.119 1.984 0.884 4.362 2.159 6.691 1.25 2.284 2.856 4.297 4.525 5.666 0.094 0.075 0.203 0.112 0.316 0.112s0.225-0.038 0.316-0.112c2.494-2.047 4.803-5.5 5.95-8.884h1.475c-1.128 3.219-3.356 7.413-7.744 10.756zM14.5 11h1.709c-1.072 2.969-3.050 5.95-5.209 7.844-3.003-2.637-5.575-7.359-5.962-10.938 2.513-0.522 4.334-1.644 5.962-2.794 0.884 0.622 1.9 1.294 3.094 1.844l-0.934 1.869c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.831 0.672 1.503 1.5 1.503zM22.5 10h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M18 8h1v1h-1v-1z" }),
_('path', { d: "M18 3h1v4h-1v-4z" })
            );
        }
        function ShieldWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShieldWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ShieldWarning.SVG = ShieldWarningSVG;
        return ShieldWarning;
    })();
export const ShieldWeb = /*#__PURE__*/ (() => {
    function ShieldWebSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5-1.544 0-2.962 0.541-4.078 1.441-0.744-0.428-1.366-0.85-1.769-1.197-0.375-0.325-0.931-0.325-1.306 0-0.844 0.728-2.478 1.672-4.166 2.403-2.013 0.872-3.853 1.353-5.181 1.353-0.269 0-0.525 0.109-0.712 0.3s-0.291 0.45-0.288 0.719c0.003 0.119 0.069 2.953 1.381 6.687 0.769 2.187 1.812 4.241 3.1 6.097 1.609 2.325 3.606 4.347 5.937 6.009 0.175 0.125 0.378 0.188 0.581 0.188s0.406-0.063 0.581-0.188c2.112-1.506 3.956-3.316 5.478-5.372 1.209-1.631 2.228-3.434 3.028-5.359 0.003-0.009 0.006-0.016 0.009-0.025 0.025-0.059 0.050-0.119 0.075-0.178v0c0.078-0.191 0.15-0.378 0.219-0.559 2.137-1.066 3.609-3.272 3.609-5.819zM12.603 4h1.656c-0.138 0.631-0.222 1.303-0.25 2h-1.987c0.066-0.716 0.269-1.391 0.581-2zM22.978 6h-1.987c-0.028-0.697-0.113-1.369-0.25-2h1.656c0.312 0.609 0.516 1.284 0.581 2zM14.009 7c0.028 0.697 0.112 1.369 0.25 2h-1.656c-0.312-0.609-0.513-1.284-0.578-2h1.984zM15.284 9c-0.15-0.622-0.244-1.297-0.275-2h1.991v2h-1.716zM17 10v1.875c-0.425-0.209-0.834-0.678-1.175-1.356-0.081-0.166-0.159-0.338-0.228-0.519h1.403zM14.534 10c0.116 0.344 0.247 0.666 0.397 0.966 0.097 0.197 0.203 0.378 0.312 0.55-0.772-0.35-1.45-0.872-1.981-1.516h1.272zM18 11.875v-1.875h1.403c-0.072 0.181-0.147 0.353-0.228 0.519-0.341 0.678-0.75 1.147-1.175 1.356zM18 9v-2h1.991c-0.031 0.703-0.122 1.378-0.275 2h-1.716zM20.991 7h1.987c-0.066 0.716-0.266 1.391-0.578 2h-1.656c0.134-0.631 0.219-1.303 0.247-2zM19.991 6h-1.991v-2h1.716c0.15 0.622 0.244 1.297 0.275 2zM18 3v-1.875c0.425 0.209 0.834 0.678 1.175 1.356 0.081 0.166 0.159 0.337 0.228 0.519h-1.403zM17 1.125v1.875h-1.403c0.072-0.181 0.147-0.353 0.228-0.519 0.341-0.678 0.75-1.147 1.175-1.356zM17 4v2h-1.991c0.031-0.703 0.122-1.378 0.275-2h1.716zM15.503 12.684c-1.144 2.406-2.784 4.65-4.503 6.159-3.003-2.637-5.575-7.359-5.963-10.938 2.513-0.522 4.334-1.644 5.963-2.794 0.044 0.031 0.087 0.059 0.131 0.091-0.084 0.419-0.131 0.853-0.131 1.297 0 2.888 1.894 5.341 4.503 6.184zM19.756 11.516c0.109-0.169 0.213-0.353 0.312-0.55 0.15-0.3 0.284-0.622 0.397-0.966h1.272c-0.531 0.644-1.209 1.166-1.981 1.516zM21.741 3h-1.272c-0.116-0.344-0.247-0.666-0.397-0.966-0.097-0.197-0.203-0.378-0.312-0.55 0.769 0.35 1.447 0.872 1.981 1.516zM15.244 1.484c-0.109 0.169-0.213 0.353-0.312 0.55-0.15 0.3-0.281 0.622-0.397 0.966h-1.272c0.531-0.644 1.209-1.166 1.981-1.516zM11 21.756c-3.569-2.719-6.159-6.297-7.706-10.644-0.787-2.216-1.097-4.106-1.219-5.181 1.75-0.213 3.578-0.878 4.9-1.453 1.528-0.659 2.994-1.469 4.025-2.213 0.312 0.222 0.666 0.453 1.053 0.691-0.25 0.384-0.462 0.797-0.628 1.231-0.044-0.031-0.091-0.066-0.134-0.097-0.175-0.125-0.406-0.125-0.581 0-1.706 1.219-3.6 2.45-6.294 2.916-0.25 0.044-0.428 0.269-0.412 0.522 0.119 1.984 0.884 4.362 2.159 6.691 1.25 2.284 2.856 4.297 4.525 5.666 0.094 0.075 0.203 0.112 0.316 0.112s0.225-0.038 0.316-0.112c1.988-1.631 3.903-4.212 5.178-6.966 0.328 0.050 0.663 0.078 1.003 0.078 0.153 0 0.303-0.006 0.453-0.016-1.587 3.522-3.922 6.469-6.953 8.775z" })
        );
    }
    function ShieldWeb({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ShieldWebSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ShieldWeb.SVG = ShieldWebSVG;
    return ShieldWeb;
})();
export const Shield = /*#__PURE__*/ (() => {
        function ShieldSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.713 4.3c-0.188-0.191-0.444-0.3-0.712-0.3-1.328 0-3.169-0.481-5.181-1.356-1.688-0.731-3.322-1.675-4.166-2.4-0.375-0.322-0.931-0.322-1.306 0-0.844 0.728-2.478 1.672-4.166 2.403-2.013 0.872-3.853 1.353-5.181 1.353-0.269 0-0.525 0.109-0.712 0.3s-0.291 0.45-0.288 0.719c0.003 0.119 0.069 2.953 1.381 6.687 0.769 2.187 1.812 4.241 3.1 6.097 1.609 2.325 3.606 4.347 5.937 6.009 0.175 0.125 0.378 0.188 0.581 0.188s0.406-0.063 0.581-0.188c2.328-1.662 4.325-3.684 5.937-6.009 1.287-1.856 2.328-3.909 3.1-6.097 1.313-3.734 1.381-6.569 1.381-6.687 0.006-0.269-0.097-0.528-0.288-0.719zM19.706 11.112c-1.547 4.35-4.137 7.928-7.706 10.644-3.569-2.719-6.159-6.297-7.706-10.644-0.787-2.216-1.097-4.106-1.219-5.181 1.75-0.213 3.578-0.878 4.9-1.453 1.528-0.659 2.994-1.469 4.025-2.212 1.031 0.741 2.497 1.55 4.022 2.212 1.322 0.575 3.15 1.241 4.9 1.453-0.119 1.075-0.428 2.969-1.216 5.181z" }),
_('path', { d: "M11.709 4.094c-1.706 1.219-3.6 2.45-6.294 2.916-0.25 0.044-0.428 0.269-0.412 0.522 0.119 1.984 0.884 4.362 2.159 6.691 1.25 2.284 2.856 4.297 4.525 5.666 0.094 0.075 0.206 0.112 0.319 0.112s0.225-0.038 0.319-0.112c1.669-1.369 3.275-3.381 4.525-5.666 1.275-2.328 2.041-4.706 2.159-6.691 0.016-0.253-0.162-0.478-0.413-0.522-2.706-0.469-4.6-1.697-6.306-2.916-0.175-0.125-0.406-0.125-0.581 0zM12 18.844c-3.003-2.637-5.575-7.359-5.962-10.938 2.513-0.522 4.334-1.644 5.962-2.794 1.631 1.15 3.453 2.272 5.962 2.794-0.387 3.578-2.959 8.3-5.962 10.938z" })
            );
        }
        function Shield({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShieldSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Shield.SVG = ShieldSVG;
        return Shield;
    })();
export const Ship = /*#__PURE__*/ (() => {
        function ShipSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9.5 12c-0.841 0-1.5 0.878-1.5 2s0.659 2 1.5 2 1.5-0.878 1.5-2-0.659-2-1.5-2zM9.5 15c-0.203 0-0.5-0.391-0.5-1s0.297-1 0.5-1 0.5 0.391 0.5 1-0.297 1-0.5 1z" }),
_('path', { d: "M14.5 12c-0.841 0-1.5 0.878-1.5 2s0.659 2 1.5 2 1.5-0.878 1.5-2-0.659-2-1.5-2zM14.5 15c-0.203 0-0.5-0.391-0.5-1s0.297-1 0.5-1 0.5 0.391 0.5 1-0.297 1-0.5 1z" }),
_('path', { d: "M10 2h4v1h-4v-1z" }),
_('path', { d: "M21.984 17.378c-0.047-0.188-0.197-0.331-0.387-0.369-0.044-0.009-0.084-0.012-0.128-0.009 0.406-1.509 0.891-2.759 1.353-3.438 0.303-0.447 0.2-1.050-0.234-1.369-0.806-0.591-1.716-1.137-2.725-1.641l-0.875-5.134c-0.031-0.188-0.166-0.338-0.347-0.394-0.528-0.162-1.059-0.306-1.591-0.431l-1.084-3.25c-0.037-0.116-0.119-0.216-0.225-0.275-2.487-1.422-5.009-1.422-7.497 0-0.106 0.063-0.188 0.159-0.225 0.275l-1.084 3.25c-0.531 0.125-1.062 0.269-1.591 0.431-0.181 0.056-0.316 0.209-0.347 0.394l-0.875 5.134c-1.009 0.503-1.919 1.050-2.725 1.641-0.434 0.319-0.537 0.925-0.234 1.369 0.525 0.769 1.088 2.294 1.519 4.091-0.516 0.534-1.512 1.347-2.681 1.347v1c1.478 0 2.688-0.934 3.347-1.584 0.069 0.125 0.153 0.253 0.253 0.384 0.588 0.784 1.419 1.2 2.4 1.2 1.478 0 2.688-0.934 3.347-1.584 0.069 0.125 0.153 0.253 0.253 0.384 0.588 0.784 1.419 1.2 2.4 1.2 1.478 0 2.688-0.934 3.347-1.584 0.069 0.125 0.153 0.253 0.253 0.384 0.588 0.784 1.419 1.2 2.4 1.2 1.478 0 2.688-0.934 3.347-1.584 0.069 0.125 0.153 0.253 0.253 0.384 0.588 0.784 1.419 1.2 2.4 1.2v-1c-1.575 0-1.997-1.556-2.016-1.622zM8.913 1.844c2.075-1.128 4.1-1.128 6.175 0l0.837 2.516c-1.309-0.241-2.622-0.359-3.925-0.359s-2.616 0.119-3.925 0.356l0.837-2.513zM5.941 5.891c4.022-1.178 8.097-1.178 12.119 0l0.706 4.147c-0.931-0.406-1.931-0.778-3-1.116-2.031-0.637-3.534-0.897-3.597-0.906-0.109-0.019-0.222-0.019-0.334 0-0.063 0.009-1.569 0.269-3.597 0.906-1.069 0.338-2.072 0.709-3 1.116l0.703-4.147zM19.131 18.228c-0.041 0.194-0.078 0.384-0.113 0.575-0.319 0.122-0.659 0.197-1.019 0.197-1.575 0-1.997-1.556-2.016-1.622-0.047-0.188-0.197-0.331-0.387-0.369-0.188-0.037-0.384 0.034-0.5 0.191-0.009 0.019-1.366 1.8-3.097 1.8-1.575 0-1.997-1.556-2.016-1.622-0.047-0.188-0.197-0.331-0.387-0.369s-0.384 0.034-0.5 0.191c-0.009 0.019-1.366 1.8-3.097 1.8-0.422 0-0.762-0.112-1.034-0.278-0.037-0.206-0.078-0.416-0.122-0.625-0.203-0.981-0.716-3.172-1.519-4.794 3.403-2.184 7.775-3.113 8.675-3.288 0.903 0.175 5.266 1.097 8.675 3.288-0.819 1.662-1.338 3.916-1.544 4.925z" }),
_('path', { d: "M21.984 21.378c-0.047-0.188-0.197-0.331-0.387-0.369s-0.384 0.034-0.5 0.191c-0.009 0.019-1.366 1.8-3.097 1.8-1.575 0-1.997-1.556-2.016-1.622-0.047-0.188-0.197-0.331-0.387-0.369-0.188-0.038-0.384 0.034-0.5 0.191-0.009 0.019-1.366 1.8-3.097 1.8-1.575 0-1.997-1.556-2.016-1.622-0.047-0.188-0.197-0.331-0.387-0.369s-0.384 0.034-0.5 0.191c-0.009 0.019-1.366 1.8-3.097 1.8-1.575 0-1.997-1.556-2.016-1.622-0.047-0.188-0.197-0.331-0.387-0.369s-0.384 0.034-0.5 0.191c-0.009 0.019-1.366 1.8-3.097 1.8v1c1.478 0 2.688-0.934 3.347-1.584 0.069 0.125 0.153 0.253 0.253 0.384 0.588 0.784 1.419 1.2 2.4 1.2 1.478 0 2.688-0.934 3.347-1.584 0.069 0.125 0.153 0.253 0.253 0.384 0.588 0.784 1.419 1.2 2.4 1.2 1.478 0 2.688-0.934 3.347-1.584 0.069 0.125 0.153 0.253 0.253 0.384 0.588 0.784 1.419 1.2 2.4 1.2 1.478 0 2.688-0.934 3.347-1.584 0.069 0.125 0.153 0.253 0.253 0.384 0.588 0.784 1.419 1.2 2.4 1.2v-1c-1.575 0-1.997-1.556-2.016-1.622z" }),
_('path', { d: "M11 6c-0.081 0-2.037 0.012-3.762 1.075l-0.425 0.262 0.525 0.853 0.425-0.262c1.478-0.912 3.222-0.928 3.237-0.928v-1z" }),
_('path', { d: "M16.662 8.187l0.525-0.853-0.425-0.263c-1.725-1.059-3.681-1.072-3.762-1.072v1c0.019 0 1.759 0.016 3.237 0.925l0.425 0.262z" })
            );
        }
        function Ship({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShipSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ship.SVG = ShipSVG;
        return Ship;
    })();
export const Shirt = /*#__PURE__*/ (() => {
        function ShirtSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.706 7.294l-3.828-3.828c-0.944-0.947-2.2-1.466-3.534-1.466h-0.844c-0.275 0-0.5 0.225-0.5 0.5v0.5c0 0.509-0.281 0.994-0.794 1.362-0.566 0.413-1.35 0.638-2.206 0.638s-1.641-0.225-2.206-0.638c-0.513-0.369-0.794-0.853-0.794-1.362v-0.5c0-0.275-0.225-0.5-0.5-0.5h-0.844c-1.334 0-2.591 0.519-3.534 1.466l-3.828 3.828c-0.391 0.391-0.391 1.025 0 1.416l3 3c0.337 0.337 0.866 0.391 1.263 0.125l1.278-0.85-0.828 9.937c-0.022 0.278 0.072 0.553 0.259 0.759 0.191 0.206 0.456 0.322 0.734 0.322h12c0.278 0 0.547-0.116 0.734-0.322 0.191-0.206 0.284-0.481 0.259-0.759l-0.828-9.937 1.278 0.85c0.397 0.266 0.925 0.213 1.263-0.125l3-3c0.391-0.394 0.391-1.025 0-1.416zM19.872 9.712l-2.319-1.544c-0.319-0.213-0.731-0.225-1.062-0.028-0.331 0.194-0.522 0.563-0.487 0.944l0.909 10.916h-9.825l0.909-10.916c0.031-0.381-0.159-0.75-0.488-0.944-0.331-0.194-0.744-0.184-1.062 0.028l-2.319 1.544-1.713-1.713 3.122-3.122c0.566-0.566 1.319-0.878 2.119-0.878h0.559c0.2 0.444 0.534 0.844 0.991 1.172 0.738 0.534 1.728 0.828 2.794 0.828s2.056-0.294 2.794-0.828c0.456-0.328 0.791-0.731 0.991-1.172h0.559c0.8 0 1.556 0.312 2.122 0.878l3.122 3.122-1.716 1.713z" }),
_('path', { d: "M14.5 8h-3c-0.275 0-0.5 0.225-0.5 0.5v2.5c0 0.216 0.138 0.406 0.341 0.475l1.5 0.5c0.050 0.016 0.106 0.025 0.159 0.025s0.106-0.009 0.159-0.025l1.5-0.5c0.203-0.069 0.341-0.259 0.341-0.475v-2.5c0-0.275-0.225-0.5-0.5-0.5zM14 10.641l-1 0.334-1-0.334v-1.641h2v1.641z" })
            );
        }
        function Shirt({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShirtSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Shirt.SVG = ShirtSVG;
        return Shirt;
    })();
export const Shocked = /*#__PURE__*/ (() => {
        function ShockedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M10 7.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5zM8 7.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5z" }),
_('path', { d: "M15.5 6c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM15.5 8c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M12 11c-2.206 0-4 2.019-4 4.5s1.794 4.5 4 4.5c2.206 0 4-2.019 4-4.5s-1.794-4.5-4-4.5zM12 19c-1.653 0-3-1.569-3-3.5s1.347-3.5 3-3.5 3 1.569 3 3.5-1.347 3.5-3 3.5z" })
            );
        }
        function Shocked({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShockedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Shocked.SVG = ShockedSVG;
        return Shocked;
    })();
export const Shocked2 = /*#__PURE__*/ (() => {
        function Shocked2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M14.766 13.825c-0.744-0.531-1.728-0.825-2.766-0.825s-2.022 0.294-2.766 0.825c-0.797 0.569-1.234 1.341-1.234 2.175s0.438 1.606 1.234 2.175c0.744 0.531 1.728 0.825 2.766 0.825s2.022-0.294 2.766-0.825c0.797-0.569 1.234-1.341 1.234-2.175s-0.438-1.606-1.234-2.175zM14.184 17.359c-0.578 0.413-1.353 0.641-2.184 0.641s-1.606-0.228-2.184-0.641c-0.525-0.375-0.816-0.859-0.816-1.359s0.291-0.984 0.816-1.359c0.578-0.413 1.353-0.641 2.184-0.641s1.606 0.228 2.184 0.641c0.525 0.375 0.816 0.859 0.816 1.359s-0.291 0.984-0.816 1.359z" }),
_('path', { d: "M17.725 5.828l-4.447 2.225c-0.181 0.091-0.291 0.281-0.275 0.481s0.15 0.375 0.341 0.438l3.475 1.159 0.316-0.95-2.331-0.775 3.369-1.684-0.447-0.894z" }),
_('path', { d: "M11 8.534c0.016-0.203-0.094-0.394-0.275-0.481l-4.447-2.225-0.447 0.894 3.366 1.684-2.328 0.775 0.316 0.95 3.475-1.159c0.191-0.063 0.325-0.234 0.341-0.438z" })
            );
        }
        function Shocked2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Shocked2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Shocked2.SVG = Shocked2SVG;
        return Shocked2;
    })();
export const Shoe = /*#__PURE__*/ (() => {
    function ShoeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.878 8.519c-0.266-0.484-0.872-0.663-1.356-0.397l-0.875 0.481c-0.303 0.166-0.575 0.378-0.837 0.584-0.534 0.419-1.041 0.813-1.806 0.813-1.662 0-2.894-1.266-3.553-1.947l-0.047-0.050-0.681-0.7c-0.197-0.203-0.472-0.312-0.756-0.303-0.284 0.012-0.55 0.141-0.731 0.359-2.262 2.716-6.1 3.397-8.641 3.85-0.844 0.15-1.575 0.278-2.128 0.459-0.375 0.122-0.653 0.259-0.878 0.431-0.378 0.294-0.588 0.703-0.588 1.15v1.75c0 0.384 0.219 0.731 0.563 0.9 1.113 0.541 3.716 0.956 6.631 1.059 3.078 0.109 6.166-0.141 8.841-0.703 0.113 0.428 0.503 0.747 0.969 0.747h6c0.553 0 1-0.447 1-1-0.003-2.797-0.003-5.434-1.125-7.484zM18 15c0-0.309-0.144-0.603-0.387-0.791-0.244-0.191-0.563-0.253-0.862-0.175-2.75 0.716-6.119 1.044-9.488 0.925-2.531-0.087-4.328-0.394-5.262-0.659v-0.706c0.409-0.144 1.278-0.297 1.944-0.416 1.391-0.247 3.122-0.553 4.866-1.2 2.084-0.772 3.687-1.838 4.894-3.259l0.028 0.028c0.709 0.731 2.187 2.25 4.272 2.25 1.109 0 1.806-0.544 2.422-1.025 0.241-0.188 0.469-0.366 0.7-0.494l0.003 0.006c0.756 1.388 0.859 3.366 0.872 5.512h-4z" })
        );
    }
    function Shoe({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ShoeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shoe.SVG = ShoeSVG;
    return Shoe;
})();
export const Shorts = /*#__PURE__*/ (() => {
    function ShortsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.984 17.828l-1.984-11.416v-1.912c0-0.275-0.225-0.5-0.5-0.5h-17c-0.275 0-0.5 0.225-0.5 0.5v1.912l-1.984 11.416c-0.047 0.269 0.019 0.547 0.181 0.766s0.409 0.363 0.681 0.397l8 1c0.491 0.059 0.95-0.244 1.084-0.719l1.038-3.631 1.038 3.634c0.125 0.434 0.519 0.725 0.959 0.725 0.041 0 0.084-0.003 0.125-0.006l8-1c0.272-0.034 0.516-0.178 0.681-0.397 0.162-0.222 0.228-0.5 0.181-0.769zM19.591 9.981c-1.606-0.134-3.172-1.075-3.528-2.981h3.009l0.519 2.981zM20 6h-7v-1h7v1zM4 5h7v1h-7v-1zM4.928 7h3.009c-0.353 1.906-1.922 2.847-3.528 2.981l0.519-2.981zM14.725 17.9l-1.766-6.175c-0.122-0.428-0.516-0.725-0.963-0.725s-0.837 0.297-0.963 0.725l-1.766 6.175-6.109-0.762 1.069-6.144c1.156-0.047 2.241-0.434 3.078-1.106 0.9-0.719 1.459-1.713 1.638-2.891h6.1c0.178 1.178 0.738 2.169 1.638 2.891 0.837 0.672 1.925 1.059 3.078 1.106l1.069 6.144-6.103 0.762z" })
        );
    }
    function Shorts({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ShortsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shorts.SVG = ShortsSVG;
    return Shorts;
})();
export const Shovel = /*#__PURE__*/ (() => {
    function ShovelSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.853 5.147l-5-5c-0.094-0.094-0.222-0.147-0.353-0.147-0.828 0-1.5 0.672-1.5 1.5v1.294l-0.553 0.553c-0.306 0.306-0.45 0.709-0.438 1.113l-6.656 6.656c-0.188-0.066-0.381-0.103-0.581-0.103 0 0 0 0 0 0-0.488 0-0.941 0.216-1.391 0.659l-1.237-1.238c-0.509-0.509-1.313-0.584-1.903-0.178-1.141 0.775-2.147 2-2.909 3.55-0.687 1.394-1.144 2.988-1.284 4.488-0.191 2.037 0.197 3.656 1.1 4.559 0.75 0.75 2 1.147 3.575 1.147 0.312 0 0.641-0.016 0.978-0.047 1.5-0.141 3.097-0.597 4.491-1.284 1.55-0.762 2.778-1.769 3.556-2.906 0.403-0.597 0.328-1.397-0.178-1.903l-1.238-1.237c0.444-0.447 0.659-0.903 0.659-1.388 0-0.203-0.038-0.397-0.103-0.581l6.659-6.656c0.016 0 0.031 0 0.047 0 0.384 0 0.769-0.147 1.062-0.438l0.553-0.553h1.291c0.828 0 1.5-0.672 1.5-1.5 0-0.138-0.053-0.266-0.147-0.359zM8.769 12.012c0 0 0 0 0 0 0.472 0 1.072 0.6 1.706 1.237 0.047 0.047 0.091 0.094 0.138 0.141s0.094 0.094 0.138 0.138c0.637 0.634 1.237 1.234 1.237 1.706 0 0.213-0.122 0.438-0.378 0.694-0.4 0.4-1.572 1.119-2.775 1.591-1.269 0.497-2.266 0.594-2.606 0.253s-0.244-1.338 0.253-2.606c0.469-1.2 1.191-2.375 1.591-2.775 0.256-0.256 0.484-0.378 0.697-0.378zM12.922 19.2c-1.537 2.253-4.869 3.528-7.312 3.759-1.709 0.159-3.078-0.134-3.756-0.813s-0.972-2.047-0.813-3.759c0.231-2.444 1.503-5.772 3.759-7.306 0.197-0.134 0.462-0.109 0.631 0.059l1.325 1.325c-0.431 0.653-0.884 1.522-1.203 2.334-0.475 1.216-0.866 2.841-0.028 3.678 0.356 0.356 0.853 0.491 1.403 0.491 0.744 0 1.578-0.247 2.275-0.519 0.816-0.319 1.681-0.772 2.334-1.203l1.325 1.325c0.169 0.162 0.194 0.431 0.059 0.628zM11.456 12.819c-0.047-0.047-0.091-0.091-0.138-0.138s-0.091-0.094-0.138-0.138c-0.072-0.072-0.144-0.144-0.216-0.216l6.169-6.169 0.706 0.706-6.169 6.169c-0.072-0.072-0.144-0.144-0.216-0.216zM19.237 6.847l-2.084-2.084c-0.197-0.197-0.197-0.513 0-0.709l0.097-0.097 2.794 2.794-0.097 0.097c-0.197 0.194-0.513 0.194-0.709 0zM22.5 6h-1.5c-0.081 0-0.162 0.022-0.234 0.059l-2.825-2.825c0.038-0.072 0.059-0.153 0.059-0.234v-1.5c0-0.213 0.134-0.397 0.325-0.469l4.644 4.644c-0.072 0.191-0.256 0.325-0.469 0.325z" })
        );
    }
    function Shovel({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ShovelSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shovel.SVG = ShovelSVG;
    return Shovel;
})();
export const Shredder = /*#__PURE__*/ (() => {
        function ShredderSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21 9h-18c-1.653 0-3 1.347-3 3v6c0 0.553 0.447 1 1 1h5c0.553 0 1-0.447 1-1v5h1v-6h1v7h1v-7h1v6h1v-6h1v7h1v-7h1v6h1v-6h1v7h1v-5h5c0.553 0 1-0.447 1-1v-6c0-1.653-1.347-3-3-3zM22 17h-3v-1c0-0.553-0.447-1-1-1h-12c-0.553 0-1 0.447-1 1v1h-3v-5c0-0.55 0.45-1 1-1h18c0.55 0 1 0.45 1 1v5z" }),
_('path', { d: "M7 1h6v3.5c0 0.275 0.225 0.5 0.5 0.5h3.5v3h1v-3.5c0-2.481-2.019-4.5-4.5-4.5h-7c-0.275 0-0.5 0.225-0.5 0.5v7.5h1v-7zM16.966 4h-2.966v-2.966c1.531 0.222 2.744 1.434 2.966 2.966z" }),
_('path', { d: "M18 13h2v1h-2v-1z" })
            );
        }
        function Shredder({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShredderSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Shredder.SVG = ShredderSVG;
        return Shredder;
    })();
export const ShrinkHorizontal = /*#__PURE__*/ (() => {
        function ShrinkHorizontalSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.956 6.456l-1.416-1.416-6.25 6.25c-0.391 0.391-0.391 1.025 0 1.416l6.25 6.25 1.416-1.416-5.541-5.541 5.541-5.544z" }),
_('path', { d: "M1.456 5.044l-1.413 1.413 5.541 5.544-5.541 5.544 1.416 1.416 6.25-6.25c0.391-0.391 0.391-1.025 0-1.416l-6.253-6.25z" })
            );
        }
        function ShrinkHorizontal({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShrinkHorizontalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ShrinkHorizontal.SVG = ShrinkHorizontalSVG;
        return ShrinkHorizontal;
    })();
export const ShrinkSquare = /*#__PURE__*/ (() => {
        function ShrinkSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M15 8.294v-1.294h-1v2.5c0 0.275 0.225 0.5 0.5 0.5h2.5v-1h-1.294l4.5-4.5-0.706-0.706-4.5 4.5z" }),
_('path', { d: "M9.5 14h-2.5v1h1.294l-4.5 4.5 0.706 0.706 4.5-4.5v1.294h1v-2.5c0-0.275-0.225-0.5-0.5-0.5z" }),
_('path', { d: "M9 8.294l-4.5-4.5-0.706 0.706 4.5 4.5h-1.294v1h2.5c0.275 0 0.5-0.225 0.5-0.5v-2.5h-1v1.294z" }),
_('path', { d: "M17 15v-1h-2.5c-0.275 0-0.5 0.225-0.5 0.5v2.5h1v-1.294l4.5 4.5 0.706-0.706-4.5-4.5h1.294z" })
            );
        }
        function ShrinkSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShrinkSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ShrinkSquare.SVG = ShrinkSquareSVG;
        return ShrinkSquare;
    })();
export const ShrinkVertical = /*#__PURE__*/ (() => {
        function ShrinkVerticalSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.294 16.294l-6.25 6.25 1.416 1.416 5.541-5.544 5.544 5.544 1.416-1.416-6.25-6.25c-0.394-0.391-1.025-0.391-1.416 0z" }),
_('path', { d: "M12 8c0.256 0 0.513-0.097 0.706-0.294l6.25-6.25-1.413-1.413-5.544 5.541-5.544-5.541-1.416 1.416 6.25 6.25c0.197 0.194 0.453 0.291 0.709 0.291z" })
            );
        }
        function ShrinkVertical({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShrinkVerticalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ShrinkVertical.SVG = ShrinkVerticalSVG;
        return ShrinkVertical;
    })();
export const Shrink = /*#__PURE__*/ (() => {
        function ShrinkSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 5.584l-5.544-5.541-1.413 1.413 5.541 5.544h-3.584v2h6c0.553 0 1-0.447 1-1v-6h-2v3.584z" }),
_('path', { d: "M8 15h-6v2h3.584l-5.541 5.544 1.416 1.416 5.541-5.544v3.584h2v-6c0-0.553-0.447-1-1-1z" }),
_('path', { d: "M22 17v-2h-6c-0.553 0-1 0.447-1 1v6h2v-3.584l5.544 5.544 1.416-1.416-5.544-5.544h3.584z" }),
_('path', { d: "M16 9h6v-2h-3.584l5.541-5.544-1.413-1.413-5.544 5.541v-3.584h-2v6c0 0.553 0.447 1 1 1z" })
            );
        }
        function Shrink({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShrinkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Shrink.SVG = ShrinkSVG;
        return Shrink;
    })();
export const Shrink2 = /*#__PURE__*/ (() => {
        function Shrink2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 14h-6v2h3.584l-6.541 6.544 1.416 1.416 6.541-6.544v3.584h2v-6c0-0.553-0.447-1-1-1z" }),
_('path', { d: "M23.956 1.456l-1.413-1.413-6.544 6.541v-3.584h-2v6c0 0.553 0.447 1 1 1h6v-2h-3.584l6.541-6.544z" })
            );
        }
        function Shrink2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Shrink2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Shrink2.SVG = Shrink2SVG;
        return Shrink2;
    })();
export const Shuffle = /*#__PURE__*/ (() => {
    function ShuffleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.456 14.044l-1.416 1.416 1.541 1.541h-3.119l-4.228-5 4.228-4.997h3.119l-1.541 1.541 1.416 1.416 3.25-3.25c0.391-0.391 0.391-1.025 0-1.416l-3.25-3.25-1.416 1.416 1.547 1.547h-3.125c-0.588 0-1.144 0.256-1.525 0.706l-4.013 4.741-4.863-5.747c-0.381-0.45-0.938-0.706-1.525-0.706h-5.538v2h5.538l5.078 6-5.078 6h-5.538v2h5.538c0.588 0 1.144-0.256 1.525-0.706l4.863-5.744 4.012 4.741c0.381 0.45 0.938 0.706 1.525 0.706h3.125l-1.547 1.547 1.416 1.416 3.25-3.25c0.391-0.391 0.391-1.025 0-1.416l-3.25-3.25z" })
        );
    }
    function Shuffle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ShuffleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shuffle.SVG = ShuffleSVG;
    return Shuffle;
})();
export const Shutter = /*#__PURE__*/ (() => {
    function ShutterSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM21.166 8h-10.322l3.328-5.763c3.141 0.697 5.728 2.878 6.994 5.763zM13.731 15h-3.462l-1.731-3 1.731-3h3.466l1.731 3-1.734 3zM12 2c0.378 0 0.75 0.022 1.119 0.063l-5.159 8.937-3.325-5.756c1.828-1.994 4.453-3.244 7.366-3.244zM3.956 6.066l5.156 8.934h-6.653c-0.297-0.947-0.459-1.956-0.459-3 0-2.219 0.728-4.272 1.956-5.934zM2.834 16h10.322l-3.328 5.763c-3.141-0.697-5.728-2.878-6.994-5.763zM12 22c-0.378 0-0.75-0.022-1.119-0.063l5.159-8.937 3.325 5.756c-1.828 1.994-4.453 3.244-7.366 3.244zM20.044 17.934l-5.156-8.934h6.653c0.3 0.947 0.459 1.956 0.459 3 0 2.219-0.728 4.272-1.956 5.934z" })
        );
    }
    function Shutter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ShutterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shutter.SVG = ShutterSVG;
    return Shutter;
})();
export const SideUpCircle = /*#__PURE__*/ (() => {
        function SideUpCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M14.147 7.147l-2.147 2.147-2.147-2.147c-0.194-0.194-0.513-0.194-0.706 0l-2.353 2.353 0.706 0.706 1.5-1.5v6.294h1v-6.294l1.5 1.5 0.5-0.5 0.5 0.5 1.5-1.5v6.294h1v-6.294l1.5 1.5 0.706-0.706-2.353-2.353c-0.194-0.197-0.513-0.197-0.706 0z" }),
_('path', { d: "M7 16h10v1h-10v-1z" })
            );
        }
        function SideUpCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SideUpCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SideUpCircle.SVG = SideUpCircleSVG;
        return SideUpCircle;
    })();
export const SideUpSquare = /*#__PURE__*/ (() => {
        function SideUpSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M9 8.706v6.294h1v-6.294l1.5 1.5 0.5-0.5 0.5 0.5 1.5-1.5v6.294h1v-6.294l1.5 1.5 0.706-0.706-2.353-2.353c-0.194-0.194-0.513-0.194-0.706 0l-2.147 2.147-2.147-2.147c-0.194-0.194-0.513-0.194-0.706 0l-2.353 2.353 0.706 0.706 1.5-1.5z" }),
_('path', { d: "M7 16h10v1h-10v-1z" })
            );
        }
        function SideUpSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SideUpSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SideUpSquare.SVG = SideUpSquareSVG;
        return SideUpSquare;
    })();
export const Sigma = /*#__PURE__*/ (() => {
    function SigmaSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19 2h-13c-0.369 0-0.706 0.203-0.881 0.528s-0.156 0.719 0.050 1.028l5.628 8.444-5.628 8.447c-0.203 0.306-0.225 0.7-0.050 1.025s0.513 0.528 0.881 0.528h13v-2h-11.131l4.962-7.447c0.225-0.334 0.225-0.775 0-1.109l-4.962-7.444h11.131v-2z" })
        );
    }
    function Sigma({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SigmaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sigma.SVG = SigmaSVG;
    return Sigma;
})();
export const Signal1Of4 = /*#__PURE__*/ (() => {
        function Signal1Of4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 20h-2c-0.553 0-1 0.447-1 1v2.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-2.5c0-0.553-0.447-1-1-1zM2 23v-1h1v1h-1z" }),
_('path', { d: "M19 22h4v2h-4v-2z" }),
_('path', { d: "M13 22h4v2h-4v-2z" }),
_('path', { d: "M7 22h4v2h-4v-2z" })
            );
        }
        function Signal1Of4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Signal1Of4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Signal1Of4.SVG = Signal1Of4SVG;
        return Signal1Of4;
    })();
export const Signal2Of4 = /*#__PURE__*/ (() => {
        function Signal2Of4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 17h-2c-0.553 0-1 0.447-1 1v5.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-5.5c0-0.553-0.447-1-1-1zM8 23v-4h1v4h-1z" }),
_('path', { d: "M4 20h-2c-0.553 0-1 0.447-1 1v2.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-2.5c0-0.553-0.447-1-1-1zM2 23v-1h1v1h-1z" }),
_('path', { d: "M19 22h4v2h-4v-2z" }),
_('path', { d: "M13 22h4v2h-4v-2z" })
            );
        }
        function Signal2Of4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Signal2Of4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Signal2Of4.SVG = Signal2Of4SVG;
        return Signal2Of4;
    })();
export const Signal3Of4 = /*#__PURE__*/ (() => {
        function Signal3Of4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 12h-2c-0.553 0-1 0.447-1 1v10.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-10.5c0-0.553-0.447-1-1-1zM14 23v-9h1v9h-1z" }),
_('path', { d: "M10 17h-2c-0.553 0-1 0.447-1 1v5.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-5.5c0-0.553-0.447-1-1-1zM8 23v-4h1v4h-1z" }),
_('path', { d: "M4 20h-2c-0.553 0-1 0.447-1 1v2.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-2.5c0-0.553-0.447-1-1-1zM2 23v-1h1v1h-1z" }),
_('path', { d: "M19 22h4v2h-4v-2z" })
            );
        }
        function Signal3Of4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Signal3Of4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Signal3Of4.SVG = Signal3Of4SVG;
        return Signal3Of4;
    })();
export const SignalError = /*#__PURE__*/ (() => {
        function SignalErrorSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 22h4v2h-4v-2z" }),
_('path', { d: "M13 22h4v2h-4v-2z" }),
_('path', { d: "M7 22h4v2h-4v-2z" }),
_('path', { d: "M1 22h4v2h-4v-2z" }),
_('path', { d: "M8.5 3.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" }),
_('path', { d: "M6.5 0c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zM6.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" })
            );
        }
        function SignalError({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SignalErrorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SignalError.SVG = SignalErrorSVG;
        return SignalError;
    })();
export const SignalLock = /*#__PURE__*/ (() => {
        function SignalLockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-2c-0.553 0-1 0.447-1 1v18.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-18.5c0-0.553-0.447-1-1-1zM20 23v-17h1v17h-1z" }),
_('path', { d: "M16 12h-2c-0.553 0-1 0.447-1 1v10.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-10.5c0-0.553-0.447-1-1-1zM14 23v-9h1v9h-1z" }),
_('path', { d: "M10 17h-2c-0.553 0-1 0.447-1 1v5.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-5.5c0-0.553-0.447-1-1-1zM8 23v-4h1v4h-1z" }),
_('path', { d: "M4 20h-2c-0.553 0-1 0.447-1 1v2.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-2.5c0-0.553-0.447-1-1-1zM2 23v-1h1v1h-1z" }),
_('path', { d: "M6.5 0c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zM6.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M9.5 6h-0.5v-0.5c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5v0.5h-0.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h6c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5zM5 5.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5v0.5h-3v-0.5zM9 9h-5v-2h5v2z" })
            );
        }
        function SignalLock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SignalLockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SignalLock.SVG = SignalLockSVG;
        return SignalLock;
    })();
export const Signal = /*#__PURE__*/ (() => {
        function SignalSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-2c-0.553 0-1 0.447-1 1v18.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-18.5c0-0.553-0.447-1-1-1zM20 23v-17h1v17h-1z" }),
_('path', { d: "M16 12h-2c-0.553 0-1 0.447-1 1v10.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-10.5c0-0.553-0.447-1-1-1zM14 23v-9h1v9h-1z" }),
_('path', { d: "M10 17h-2c-0.553 0-1 0.447-1 1v5.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-5.5c0-0.553-0.447-1-1-1zM8 23v-4h1v4h-1z" }),
_('path', { d: "M4 20h-2c-0.553 0-1 0.447-1 1v2.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-2.5c0-0.553-0.447-1-1-1zM2 23v-1h1v1h-1z" })
            );
        }
        function Signal({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SignalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Signal.SVG = SignalSVG;
        return Signal;
    })();
export const Sim = /*#__PURE__*/ (() => {
        function SimSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 0h-9.584c-0.534 0-1.038 0.209-1.416 0.584l-4.416 4.416c-0.375 0.378-0.584 0.881-0.584 1.416v15.584c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM19 22h-14v-15.584l4.416-4.416h9.584v20z" }),
_('path', { d: "M7 13v5c0 1.103 0.897 2 2 2h6c1.103 0 2-0.897 2-2v-5c0-1.103-0.897-2-2-2h-6c-1.103 0-2 0.897-2 2zM9 12h1v3h-2v-2c0-0.55 0.45-1 1-1zM11 15v-3h2v3h-2zM13 16v3h-2v-3h2zM8 18v-2h2v3h-1c-0.55 0-1-0.45-1-1zM15 19h-1v-3h2v2c0 0.55-0.45 1-1 1zM16 13v2h-2v-3h1c0.55 0 1 0.45 1 1z" })
            );
        }
        function Sim({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SimSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Sim.SVG = SimSVG;
        return Sim;
    })();
export const Sine = /*#__PURE__*/ (() => {
    function SineSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.853 13.147l-1.353-1.353-0.706 0.706 0.5 0.5h-9.656c-0.519-1.581-1.056-3.197-1.737-4.447-0.416-0.766-0.856-1.338-1.341-1.753-0.619-0.531-1.313-0.8-2.063-0.8s-1.444 0.269-2.063 0.8c-0.484 0.416-0.922 0.987-1.341 1.753-0.409 0.75-0.766 1.631-1.1 2.559v-8.406l0.5 0.5 0.713-0.706-1.353-1.353c-0.194-0.194-0.513-0.194-0.706 0l-1.353 1.353 0.706 0.706 0.5-0.5v20.294h1v-9h7.863c0.519 1.581 1.056 3.197 1.737 4.447 0.416 0.766 0.856 1.338 1.341 1.753 0.619 0.531 1.313 0.8 2.063 0.8s1.444-0.269 2.063-0.8c0.484-0.416 0.922-0.987 1.341-1.753 0.681-1.25 1.219-2.866 1.737-4.447h1.153l-0.5 0.5 0.706 0.706 1.353-1.353c0.194-0.194 0.194-0.513-0.003-0.706zM5.853 9.509c0.825-1.509 1.444-1.509 1.647-1.509s0.822 0 1.647 1.509c0.513 0.941 0.959 2.203 1.387 3.491h-6.069c0.428-1.287 0.875-2.55 1.388-3.491zM17.647 17.491c-0.825 1.509-1.444 1.509-1.647 1.509s-0.822 0-1.647-1.509c-0.513-0.941-0.959-2.203-1.388-3.491h6.066c-0.425 1.287-0.872 2.55-1.384 3.491z" })
        );
    }
    function Sine({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SineSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sine.SVG = SineSVG;
    return Sine;
})();
export const Sink = /*#__PURE__*/ (() => {
    function SinkSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.544 6.744c-0.381-0.472-0.95-0.744-1.556-0.744h-1.988v-1.5c0-0.434-0.281-0.837-0.788-1.137-0.378-0.225-0.844-0.363-1.212-0.363s-0.834 0.138-1.212 0.363c-0.506 0.3-0.788 0.703-0.788 1.137v1.5h-3v-2h1.5c0.275 0 0.5-0.225 0.5-0.5v-1c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5v3.5h-2v-1.5c0-0.434-0.281-0.837-0.788-1.137-0.378-0.225-0.844-0.363-1.212-0.363s-0.834 0.138-1.212 0.363c-0.506 0.3-0.787 0.703-0.787 1.137v1.5h-1.988c-0.606 0-1.175 0.272-1.556 0.744s-0.525 1.081-0.4 1.675c0.35 1.625 1.297 3.147 2.737 4.403 1.172 1.022 2.631 1.837 4.263 2.384l-1.125 8.222c-0.019 0.144 0.025 0.288 0.119 0.397s0.231 0.172 0.378 0.172h11.147c0.144 0 0.281-0.063 0.378-0.172s0.138-0.253 0.119-0.397l-1.125-8.222c1.631-0.55 3.091-1.366 4.263-2.384 1.444-1.259 2.391-2.781 2.738-4.403 0.122-0.594-0.022-1.203-0.403-1.675zM17 4.5c0.003-0.025 0.072-0.15 0.325-0.294s0.528-0.206 0.675-0.206 0.422 0.066 0.675 0.206c0.253 0.144 0.322 0.272 0.325 0.294v1.5h-2v-1.5zM11 2.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5v0.5h-1v-1h-1v4h-1v-3.5zM5 4.5c0.003-0.025 0.072-0.15 0.325-0.294s0.528-0.206 0.675-0.206 0.422 0.066 0.675 0.206c0.253 0.144 0.322 0.272 0.325 0.294v1.5h-2v-1.5zM9.141 14.728c0.928 0.181 1.884 0.272 2.859 0.272 0.972 0 1.931-0.091 2.859-0.272l1.131 8.272h-7.981l1.131-8.272zM21.987 8c-0.525 2.45-3.044 4.622-6.413 5.534 0 0 0 0 0 0v0c-1.141 0.309-2.344 0.466-3.575 0.466s-2.434-0.156-3.575-0.466c0 0 0 0 0 0-3.369-0.912-5.884-3.081-6.412-5.534 0 0 0 0 0 0h19.975c0 0 0 0 0 0z" })
        );
    }
    function Sink({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SinkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sink.SVG = SinkSVG;
    return Sink;
})();
export const Sink2 = /*#__PURE__*/ (() => {
        function Sink2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 11h-5.584l1.544-1.544-1.416-1.416-3.25 3.25c-0.391 0.391-0.391 1.025 0 1.416l3.25 3.25 1.416-1.416-1.544-1.541h5.584v-2z" }),
_('path', { d: "M12 9c0.256 0 0.513-0.097 0.706-0.294l3.25-3.25-1.416-1.416-1.541 1.544v-5.584h-2v5.584l-1.544-1.544-1.416 1.416 3.25 3.25c0.197 0.197 0.453 0.294 0.709 0.294z" }),
_('path', { d: "M8.706 11.294l-3.25-3.25-1.416 1.416 1.544 1.544h-5.584v2h5.584l-1.544 1.544 1.416 1.416 3.25-3.25c0.391-0.397 0.391-1.028 0-1.419z" }),
_('path', { d: "M11.294 15.294l-3.25 3.25 1.416 1.416 1.544-1.544v5.584h2v-5.584l1.544 1.544 1.416-1.416-3.25-3.25c-0.397-0.391-1.028-0.391-1.419 0z" }),
_('path', { d: "M10 12c0 1.103 0.897 2 2 2s2-0.897 2-2c0-1.103-0.897-2-2-2s-2 0.897-2 2zM13 12c0 0.55-0.45 1-1 1s-1-0.45-1-1c0-0.55 0.45-1 1-1s1 0.45 1 1z" })
            );
        }
        function Sink2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Sink2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Sink2.SVG = Sink2SVG;
        return Sink2;
    })();
export const SirenBright = /*#__PURE__*/ (() => {
        function SirenBrightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.828 9.277l2.896-1.448 0.447 0.894-2.896 1.448-0.447-0.894z" }),
_('path', { d: "M17.792 5.501l2.707-2.707 0.707 0.707-2.707 2.707-0.707-0.707z" }),
_('path', { d: "M13.867 4.816l1.316-3.949 0.949 0.316-1.316 3.949-0.949-0.316z" }),
_('path', { d: "M0.828 8.723l0.447-0.894 2.896 1.448-0.447 0.894-2.896-1.448z" }),
_('path', { d: "M2.792 3.499l0.707-0.707 2.707 2.707-0.707 0.707-2.707-2.707z" }),
_('path', { d: "M7.868 1.184l0.949-0.316 1.316 3.949-0.949 0.316-1.316-3.949z" }),
_('path', { d: "M20 18h-0.166l-1.85-10.178c-0.041-0.219-0.153-0.419-0.319-0.569-1.272-1.131-4.387-1.253-5.666-1.253s-4.394 0.122-5.666 1.253c-0.166 0.15-0.278 0.35-0.319 0.569l-1.85 10.178h-0.166c-1.103 0-2 0.897-2 2v3.5c0 0.275 0.225 0.5 0.5 0.5h19c0.275 0 0.5-0.225 0.5-0.5v-3.5c0-1.103-0.897-2-2-2zM7.906 8.6c0.216-0.103 0.603-0.244 1.263-0.366 0.803-0.15 1.809-0.234 2.831-0.234s2.028 0.081 2.831 0.234c0.659 0.122 1.044 0.263 1.263 0.366l1.709 9.4h-11.606l1.709-9.4zM4 23v-3h16v3h-16z" }),
_('path', { d: "M13.912 10.108l0.981-0.196 1.196 5.982-0.981 0.196-1.196-5.982z" })
            );
        }
        function SirenBright({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SirenBrightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SirenBright.SVG = SirenBrightSVG;
        return SirenBright;
    })();
export const Siren = /*#__PURE__*/ (() => {
        function SirenSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 15h-0.166l-1.85-10.178c-0.041-0.219-0.153-0.419-0.319-0.569-1.272-1.131-4.387-1.253-5.666-1.253s-4.394 0.122-5.666 1.253c-0.166 0.15-0.278 0.35-0.319 0.569l-1.85 10.178h-0.166c-1.103 0-2 0.897-2 2v3.5c0 0.275 0.225 0.5 0.5 0.5h19c0.275 0 0.5-0.225 0.5-0.5v-3.5c0-1.103-0.897-2-2-2zM7.906 5.6c0.216-0.103 0.603-0.244 1.263-0.366 0.803-0.15 1.809-0.234 2.831-0.234s2.028 0.081 2.831 0.234c0.659 0.122 1.044 0.262 1.263 0.366l1.709 9.4h-11.606l1.709-9.4zM4 20v-3h16v3h-16z" }),
_('path', { d: "M13.912 7.108l0.981-0.196 1.196 5.982-0.981 0.196-1.196-5.982z" })
            );
        }
        function Siren({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SirenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Siren.SVG = SirenSVG;
        return Siren;
    })();
export const Skating = /*#__PURE__*/ (() => {
        function SkatingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 4c1.103 0 2-0.897 2-2s-0.897-2-2-2-2 0.897-2 2 0.897 2 2 2zM18 1c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M22.966 19.812c-2.013 0.134-4.344 0.216-6.741 0.241l1.713-4.713c0.097-0.266 0.075-0.559-0.056-0.809-0.722-1.362-1.875-2.609-3.506-3.797l2.5-3.747 1.228 2.459c0.122 0.241 0.334 0.422 0.591 0.506 0.256 0.081 0.534 0.056 0.772-0.069l4.25-2.25-0.934-1.769-3.344 1.772-1.544-3.084c-0.159-0.319-0.475-0.528-0.831-0.55-0.022 0-0.041-0.003-0.063-0.003v0h-5c-0.312 0-0.606 0.144-0.794 0.394l-3.25 4.25 1.587 1.216 2.95-3.859h2.637l-2.941 4.409c-1.197 1.494-1.891 2.309-2.825 2.591h-4.366v2h4.5c0.081 0 0.162-0.009 0.244-0.031 1.437-0.359 2.4-1.341 3.453-2.622 1.222 0.888 2.116 1.794 2.706 2.747l-1.809 4.969c-2.85-0.006-5.681-0.091-8.063-0.25l-0.066 0.997c0.441 0.028 0.9 0.056 1.369 0.081-0.209 0.319-0.334 0.7-0.334 1.109 0 1.103 0.897 2 2 2s2-0.897 2-2c0-0.356-0.094-0.691-0.259-0.981 1.228 0.028 2.494 0.044 3.759 0.044s2.531-0.016 3.759-0.044c-0.166 0.291-0.259 0.625-0.259 0.981 0 1.103 0.897 2 2 2s2-0.897 2-2c0-0.409-0.125-0.791-0.334-1.109 0.469-0.025 0.928-0.050 1.369-0.081l-0.069-0.997zM9 23c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM20 23c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M2 3h5v1h-5v-1z" }),
_('path', { d: "M1 5h4v1h-4v-1z" }),
_('path', { d: "M0 7h6v1h-6v-1z" })
            );
        }
        function Skating({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SkatingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Skating.SVG = SkatingSVG;
        return Skating;
    })();
export const Skeptical = /*#__PURE__*/ (() => {
        function SkepticalSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M8 15h8v1h-8v-1z" }),
_('path', { d: "M10 9.5c0-0.175-0.031-0.344-0.084-0.5h1.084v-1h-5v1h1.084c-0.056 0.156-0.084 0.325-0.084 0.5 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5zM8 9.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5z" }),
_('path', { d: "M13 8v1h1.084c-0.056 0.156-0.084 0.325-0.084 0.5 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.175-0.031-0.344-0.084-0.5h1.084v-1h-5zM16 9.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5z" })
            );
        }
        function Skeptical({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SkepticalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Skeptical.SVG = SkepticalSVG;
        return Skeptical;
    })();
export const Skull = /*#__PURE__*/ (() => {
        function SkullSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 2c-5.887 0-10 3.497-10 8.5 0 2.159 1.184 4.378 3.337 6.247 0.422 0.369 0.663 0.894 0.663 1.441v1.469c0 0.987 0.709 1.819 1.684 1.975 1.531 0.244 2.922 0.369 4.312 0.369s2.781-0.122 4.316-0.369c0.978-0.156 1.684-0.987 1.684-1.975v-1.469c0-0.547 0.241-1.069 0.663-1.437 0.975-0.85 1.756-1.772 2.322-2.737 0.678-1.153 1.019-2.334 1.019-3.513 0-5.003-4.113-8.5-10-8.5zM17.35 15.244c-0.859 0.747-1.35 1.819-1.35 2.944l-0.003 1.469c-0.697 0.112-1.356 0.197-1.997 0.253v-1.909h-1v1.978c-0.672 0.031-1.331 0.031-2 0v-1.978h-1v1.909c-0.641-0.056-1.3-0.141-1.997-0.253 0 0 0 0-0.003 0 0 0 0 0 0 0v-1.469c0-1.125-0.491-2.2-1.35-2.95-0.991-0.859-2.65-2.619-2.65-4.737 0-3.888 3.216-6.5 8-6.5s8 2.613 8 6.5c0 2.119-1.659 3.881-2.65 4.744z" }),
_('path', { d: "M12.859 12.5c-0.181-0.312-0.5-0.5-0.859-0.5h-0.003c-0.359 0-0.678 0.188-0.856 0.5l-0.984 1.722c-0.213 0.372-0.209 0.816 0.003 1.188 0.216 0.372 0.6 0.591 1.028 0.591h1.619c0.428 0 0.813-0.222 1.028-0.594s0.216-0.813 0.006-1.184l-0.981-1.722zM12.972 14.906c-0.022 0.034-0.069 0.094-0.162 0.094h-1.619c-0.094 0-0.144-0.059-0.166-0.094s-0.047-0.106 0-0.188l0.975-1.706 0.975 1.706c0.047 0.081 0.019 0.15-0.003 0.188z" }),
_('path', { d: "M11 10c0-0.65-0.256-1.384-0.684-1.962-0.497-0.669-1.144-1.038-1.816-1.038-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5c0.697 0 1.263-0.141 1.688-0.419 0.531-0.347 0.813-0.894 0.813-1.581zM8.5 11c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.772 0 1.5 1.128 1.5 2 0 0.247 0 1-1.5 1z" }),
_('path', { d: "M15.5 7c-0.672 0-1.319 0.369-1.816 1.038-0.428 0.578-0.684 1.313-0.684 1.962 0 0.687 0.281 1.234 0.813 1.581 0.425 0.278 0.991 0.419 1.688 0.419 1.378 0 2.5-1.122 2.5-2.5s-1.122-2.5-2.5-2.5zM15.5 11c-1.5 0-1.5-0.753-1.5-1 0-0.872 0.728-2 1.5-2 0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5z" })
            );
        }
        function Skull({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SkullSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Skull.SVG = SkullSVG;
        return Skull;
    })();
export const Slingshot = /*#__PURE__*/ (() => {
    function SlingshotSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 2c0-1.159-1.263-2-3-2s-3 0.841-3 2c0 1.344-0.597 2.872-1.641 4.194-0.984 1.247-1.972 1.806-2.359 1.806s-1.375-0.559-2.359-1.806c-1.044-1.322-1.641-2.85-1.641-4.194 0-1.159-1.263-2-3-2s-3 0.841-3 2c0 0.844 0.153 1.788 0.438 2.766-1.581 1.816-2.906 4.188-3.691 6.625-0.431 1.341-0.678 2.625-0.734 3.816-0.063 1.275 0.1 2.378 0.481 3.278 0.694 1.647 2.066 2.516 3.969 2.516 1.887 0 3.241-0.622 4.675-1.278 0.581-0.266 1.184-0.544 1.863-0.797v3.075c0 1.159 1.263 2 3 2s3-0.841 3-2v-4.028c1.256-0.125 2.334-0.659 3.209-1.6 0.825-0.884 1.472-2.141 1.928-3.734 0.572-2 0.772-4.228 0.834-6.225 0.659-1.55 1.028-3.103 1.028-4.413zM21 2c0.491 0 0.834 0.113 0.997 0.2-0.022 0.541-0.125 1.153-0.3 1.8h-1.987c0.172-0.606 0.269-1.209 0.288-1.794 0.156-0.091 0.503-0.206 1.003-0.206zM10.072 7.431c0.569 0.722 1.209 1.341 1.853 1.788 0.744 0.519 1.444 0.781 2.078 0.781s1.334-0.263 2.078-0.781c0.641-0.447 1.281-1.066 1.853-1.788 0.6-0.762 1.084-1.587 1.434-2.431h2.006c-0.997 2.712-3.103 5.716-5.725 6.691-0.391 0.147-0.65 0.519-0.65 0.938v4.422c-0.731 0.053-1.394 0.144-2 0.266v-4.684c0-0.419-0.259-0.791-0.65-0.938-2.622-0.978-4.728-3.981-5.725-6.694h2.013c0.35 0.844 0.834 1.669 1.434 2.431zM7 2c0.5 0 0.847 0.116 1.003 0.206 0.019 0.584 0.116 1.191 0.288 1.794h-1.988c-0.175-0.647-0.278-1.259-0.3-1.8 0.162-0.087 0.506-0.2 0.997-0.2zM8.722 18.813c-1.387 0.637-2.588 1.188-4.256 1.188-1.491 0-2.516-0.641-3.050-1.903-0.641-1.512-0.537-3.847 0.284-6.4 0.681-2.116 1.788-4.172 3.112-5.822 0.347 0.906 0.794 1.819 1.325 2.691 1.344 2.197 3.050 3.85 4.863 4.719v4.572c-0.847 0.297-1.581 0.634-2.278 0.956zM14 22c-0.494 0-0.841-0.116-1-0.203v-3.459c0.603-0.128 1.263-0.228 2-0.284v3.744c-0.159 0.087-0.506 0.203-1 0.203zM17 16.966v-3.678c1.8-0.866 3.497-2.503 4.837-4.681-0.119 1.272-0.322 2.562-0.663 3.756-0.816 2.853-2.184 4.366-4.175 4.603z" })
        );
    }
    function Slingshot({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SlingshotSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Slingshot.SVG = SlingshotSVG;
    return Slingshot;
})();
export const SmartphoneBackup = /*#__PURE__*/ (() => {
        function SmartphoneBackupSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 11.5c0-2.7-1.653-5.019-4-6v-3.5c0-1.103-0.897-2-2-2h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-4.5c2.347-0.981 4-3.3 4-6zM16 2v1h-10v-1h10zM6 21h4v1h-4v-1zM12 22v-1h4v1h-4zM16 20h-10v-16h10v1.019c-0.166-0.012-0.331-0.019-0.5-0.019-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5c0.169 0 0.334-0.006 0.5-0.019v2.019zM15.5 17c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18.853 9.147c-0.194-0.194-0.513-0.194-0.706 0l-1.353 1.353 0.706 0.706 0.5-0.5v0.794c0 1.378-1.122 2.5-2.5 2.5s-2.5-1.122-2.5-2.5 1.122-2.5 2.5-2.5h0.5v-1h-0.5c-1.931 0-3.5 1.569-3.5 3.5s1.569 3.5 3.5 3.5 3.5-1.569 3.5-3.5v-0.794l0.5 0.5 0.706-0.706-1.353-1.353z" })
            );
        }
        function SmartphoneBackup({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmartphoneBackupSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SmartphoneBackup.SVG = SmartphoneBackupSVG;
        return SmartphoneBackup;
    })();
export const SmartphoneCheck = /*#__PURE__*/ (() => {
        function SmartphoneCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 11.5c0-2.7-1.653-5.019-4-6v-3.5c0-1.103-0.897-2-2-2h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-4.5c2.347-0.981 4-3.3 4-6zM16 2v1h-10v-1h10zM6 21h4v1h-4v-1zM12 22v-1h4v1h-4zM16 20h-10v-16h10v1.019c-0.166-0.012-0.331-0.019-0.5-0.019-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5c0.169 0 0.334-0.006 0.5-0.019v2.019zM15.5 17c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M14.5 12.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4z" })
            );
        }
        function SmartphoneCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmartphoneCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SmartphoneCheck.SVG = SmartphoneCheckSVG;
        return SmartphoneCheck;
    })();
export const SmartphoneCode = /*#__PURE__*/ (() => {
        function SmartphoneCodeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.206 9.5l-2 2 2 2-0.706 0.706-2.353-2.353c-0.194-0.194-0.194-0.513 0-0.706l2.353-2.353 0.706 0.706zM18.5 8.794l-0.706 0.706 2 2-2 2 0.706 0.706 2.353-2.353c0.194-0.194 0.194-0.513 0-0.706l-2.353-2.353zM13.869 14.816l0.95 0.316 2.316-6.95-0.95-0.316-2.316 6.95z" }),
_('path', { d: "M17.5 5h-1.5v-3c0-1.103-0.897-2-2-2h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-4h1.5c3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5zM14 2v1h-10v-1h10zM4 21h4v1h-4v-1zM10 22v-1h4v1h-4zM14 20h-10v-16h10v1h-0.5c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5h0.5v2zM17.5 17h-4c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5h4c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5z" })
            );
        }
        function SmartphoneCode({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmartphoneCodeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SmartphoneCode.SVG = SmartphoneCodeSVG;
        return SmartphoneCode;
    })();
export const SmartphoneInfo = /*#__PURE__*/ (() => {
        function SmartphoneInfoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 11.5c0-2.7-1.653-5.019-4-6v-3.5c0-1.103-0.897-2-2-2h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-4.5c2.347-0.981 4-3.3 4-6zM16 2v1h-10v-1h10zM6 21h4v1h-4v-1zM12 22v-1h4v1h-4zM16 20h-10v-16h10v1.019c-0.166-0.012-0.331-0.019-0.5-0.019-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5c0.169 0 0.334-0.006 0.5-0.019v2.019zM15.5 17c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16 10.5c0-0.275-0.225-0.5-0.5-0.5h-1.5v1h1v3h-1v1h3v-1h-1v-3.5z" }),
_('path', { d: "M15 8h1v1h-1v-1z" })
            );
        }
        function SmartphoneInfo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmartphoneInfoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SmartphoneInfo.SVG = SmartphoneInfoSVG;
        return SmartphoneInfo;
    })();
export const SmartphoneLock = /*#__PURE__*/ (() => {
        function SmartphoneLockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 11.5c0-2.7-1.653-5.019-4-6v-3.5c0-1.103-0.897-2-2-2h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-4.5c2.347-0.981 4-3.3 4-6zM6 2h10v1h-10v-1zM6 21h4v1h-4v-1zM12 22v-1h4v1h-4zM16 20h-10v-16h10v1.019c-0.166-0.012-0.331-0.019-0.5-0.019-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5c0.169 0 0.334-0.006 0.5-0.019v2.019zM15.5 17c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18.5 11h-0.5v-0.5c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5v0.5h-0.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h6c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5zM14 10.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5v0.5h-3v-0.5zM18 14h-5v-2h5v2z" })
            );
        }
        function SmartphoneLock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmartphoneLockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SmartphoneLock.SVG = SmartphoneLockSVG;
        return SmartphoneLock;
    })();
export const SmartphonePencil = /*#__PURE__*/ (() => {
    function SmartphonePencilSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21 6.916c0-0.509-0.2-0.991-0.563-1.353-0.663-0.663-1.694-0.738-2.438-0.225v-3.337c0-1.103-0.897-2-2-2h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-11.294l2.438-2.438c0.363-0.363 0.563-0.844 0.563-1.353zM12.753 14.541l-1.616 0.322 0.322-1.616 6.041-6.041 1.294 1.294-6.041 6.041zM6 2h10v1h-10v-1zM16 4v3.294l-5.353 5.353c-0.069 0.069-0.119 0.159-0.138 0.256l-0.5 2.5c-0.031 0.162 0.019 0.334 0.138 0.453 0.094 0.094 0.222 0.147 0.353 0.147 0.031 0 0.066-0.003 0.097-0.009l2.5-0.5c0.097-0.019 0.184-0.066 0.256-0.138l2.647-2.647v7.291h-10v-16h10zM6 21h4v1h-4v-1zM12 22v-1h4v1h-4zM19.731 7.563l-0.231 0.231-1.294-1.294 0.231-0.231c0.356-0.356 0.938-0.356 1.294 0 0.172 0.172 0.269 0.403 0.269 0.647s-0.097 0.472-0.269 0.647z" })
        );
    }
    function SmartphonePencil({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SmartphonePencilSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SmartphonePencil.SVG = SmartphonePencilSVG;
    return SmartphonePencil;
})();
export const SmartphoneRingtone = /*#__PURE__*/ (() => {
        function SmartphoneRingtoneSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 11.5c0-2.7-1.653-5.019-4-6v-3.5c0-1.103-0.897-2-2-2h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-4.5c2.347-0.981 4-3.3 4-6zM6 2h10v1h-10v-1zM6 21h4v1h-4v-1zM12 22v-1h4v1h-4zM16 20h-10v-16h10v1.019c-0.166-0.012-0.331-0.019-0.5-0.019-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5c0.169 0 0.334-0.006 0.5-0.019v2.019zM15.5 17c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17 8h-1v4.131c-0.353-0.125-0.762-0.162-1.191-0.103-1.109 0.156-1.903 0.922-1.803 1.747 0.041 0.328 0.213 0.616 0.5 0.837 0.334 0.256 0.803 0.397 1.303 0.397 0.125 0 0.253-0.009 0.381-0.028 1.047-0.147 1.812-0.837 1.809-1.606v0-3.141c0.531 0.475 1.231 0.766 2 0.766v-1c-1.103 0-2-0.897-2-2zM15.050 13.991c-0.366 0.050-0.731-0.016-0.934-0.172-0.050-0.038-0.109-0.097-0.116-0.166-0.025-0.197 0.341-0.55 0.947-0.634 0.087-0.012 0.172-0.019 0.253-0.019 0.319 0 0.553 0.091 0.681 0.188 0.072 0.053 0.109 0.109 0.116 0.166v0c0.025 0.197-0.341 0.55-0.947 0.638z" })
            );
        }
        function SmartphoneRingtone({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmartphoneRingtoneSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SmartphoneRingtone.SVG = SmartphoneRingtoneSVG;
        return SmartphoneRingtone;
    })();
export const SmartphoneRotate = /*#__PURE__*/ (() => {
        function SmartphoneRotateSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 10h-20c-1.103 0-2 0.897-2 2v10c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-10c0-1.103-0.897-2-2-2zM4 12h16v10h-16v-10zM3 12v4h-1v-4h1zM2 22v-4h1v4.003l-1-0.003c0 0.003 0 0 0 0zM22 22h-1v-10h1v10z" }),
_('path', { d: "M16.5 4.206l0.706-0.706-0.5-0.5h0.794c1.931 0 3.5 1.569 3.5 3.5v0.794l-0.5-0.5-0.706 0.706 1.353 1.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l1.353-1.353-0.706-0.706-0.5 0.5v-0.794c0-2.481-2.019-4.5-4.5-4.5h-0.794l0.5-0.5-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353z" }),
_('path', { d: "M2 4h10v5h2v-7c0-1.103-0.897-2-2-2h-10c-1.103 0-2 0.897-2 2v7h2v-5zM12 2v1h-10v-1h10z" })
            );
        }
        function SmartphoneRotate({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmartphoneRotateSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SmartphoneRotate.SVG = SmartphoneRotateSVG;
        return SmartphoneRotate;
    })();
export const SmartphoneSilent = /*#__PURE__*/ (() => {
    function SmartphoneSilentSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 11.5c0-2.7-1.653-5.019-4-6v-3.5c0-1.103-0.897-2-2-2h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-4.5c2.347-0.981 4-3.3 4-6zM21 11.5c0 1.338-0.478 2.562-1.275 3.519l-2.725-2.725v-2.059c0.531 0.475 1.231 0.766 2 0.766v-1c-1.103 0-2-0.897-2-2h-1v3.294l-4.019-4.019c0.956-0.797 2.181-1.275 3.519-1.275 3.031 0 5.5 2.469 5.5 5.5zM11.275 7.981l4.019 4.019c-0.156-0.006-0.319 0.003-0.484 0.025-1.109 0.156-1.903 0.922-1.803 1.747 0.041 0.328 0.213 0.616 0.5 0.837 0.334 0.256 0.803 0.397 1.303 0.397 0.125 0 0.253-0.009 0.381-0.028 0.912-0.128 1.606-0.666 1.772-1.313l2.056 2.056c-0.956 0.8-2.181 1.278-3.519 1.278-3.031 0-5.5-2.469-5.5-5.5 0-1.338 0.478-2.562 1.275-3.519zM15.050 13.991c-0.366 0.050-0.731-0.016-0.934-0.172-0.050-0.038-0.109-0.097-0.116-0.166-0.025-0.197 0.341-0.55 0.947-0.634 0.087-0.012 0.172-0.019 0.253-0.019 0.319 0 0.553 0.091 0.681 0.188 0.072 0.053 0.109 0.109 0.116 0.166v0c0.025 0.197-0.341 0.55-0.947 0.638zM16 2v1h-10v-1h10zM6 21h4v1h-4v-1zM12 22v-1h4v1h-4zM16 20h-10v-16h10v1.019c-0.166-0.012-0.331-0.019-0.5-0.019-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5c0.169 0 0.334-0.006 0.5-0.019v2.019z" })
        );
    }
    function SmartphoneSilent({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SmartphoneSilentSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SmartphoneSilent.SVG = SmartphoneSilentSVG;
    return SmartphoneSilent;
})();
export const SmartphoneSpeakers = /*#__PURE__*/ (() => {
        function SmartphoneSpeakersSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 0h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM7 2h10v1h-10v-1zM7 4h10v16h-10v-16zM11 22h-4v-1h4v1zM17 22h-4v-1h4.003l-0.003 1c0.003 0 0 0 0 0z" }),
_('path', { d: "M2 4.5c0 0.828 0.672 1.5 1.5 1.5h0.5v-1h-0.5c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h0.5v-1h-0.5c-0.828 0-1.5 0.672-1.5 1.5z" }),
_('path', { d: "M0 4.5c0 1.931 1.569 3.5 3.5 3.5h0.5v-1h-0.5c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5h0.5v-1h-0.5c-1.931 0-3.5 1.569-3.5 3.5z" }),
_('path', { d: "M22 4.5c0-0.828-0.672-1.5-1.5-1.5h-0.5v1h0.5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-0.5v1h0.5c0.828 0 1.5-0.672 1.5-1.5z" }),
_('path', { d: "M20.5 1h-0.5v1h0.5c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5h-0.5v1h0.5c1.931 0 3.5-1.569 3.5-3.5s-1.569-3.5-3.5-3.5z" })
            );
        }
        function SmartphoneSpeakers({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmartphoneSpeakersSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SmartphoneSpeakers.SVG = SmartphoneSpeakersSVG;
        return SmartphoneSpeakers;
    })();
export const SmartphoneSync = /*#__PURE__*/ (() => {
        function SmartphoneSyncSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 11.5c0-2.7-1.653-5.019-4-6v-3.5c0-1.103-0.897-2-2-2h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-4.5c2.347-0.981 4-3.3 4-6zM6 2h10v1h-10v-1zM6 21h4v1h-4v-1zM12 22v-1h4v1h-4zM16 20h-10v-16h10v1.019c-0.166-0.012-0.331-0.019-0.5-0.019-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5c0.169 0 0.334-0.006 0.5-0.019v2.019zM15.5 17c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M14.794 9.5l0.706 0.706 1.353-1.353c0.194-0.194 0.194-0.513 0-0.706l-1.353-1.353-0.706 0.706 0.506 0.506c-1.837 0.103-3.3 1.631-3.3 3.494v0.5h1v-0.5c0-1.306 1.006-2.381 2.284-2.491l-0.491 0.491z" }),
_('path', { d: "M18 11.5c0 1.306-1.006 2.381-2.284 2.491l0.491-0.491-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706-0.506-0.506c1.837-0.103 3.3-1.631 3.3-3.494v-0.5h-1v0.5z" })
            );
        }
        function SmartphoneSync({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmartphoneSyncSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SmartphoneSync.SVG = SmartphoneSyncSVG;
        return SmartphoneSync;
    })();
export const SmartphoneText = /*#__PURE__*/ (() => {
        function SmartphoneTextSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.5 6h-5.5v-4c0-1.103-0.897-2-2-2h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-7h5.5c0.275 0 0.5-0.225 0.5-0.5v-8c0-0.275-0.225-0.5-0.5-0.5zM14 2v1h-10v-1h10zM4 21h4v1h-4v-1zM10 22v-1h4v1h-4zM14 20h-10v-16h10v2h-5.5c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.203 0.122 0.384 0.309 0.462 0.063 0.025 0.128 0.038 0.191 0.038 0.131 0 0.259-0.050 0.353-0.147l2.853-2.853h2.294v5zM21 14h-9.5c-0.131 0-0.259 0.053-0.353 0.147l-2.147 2.147v-9.294h12v7z" }),
_('path', { d: "M11 9h8v1h-8v-1z" }),
_('path', { d: "M11 11h8v1h-8v-1z" })
            );
        }
        function SmartphoneText({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmartphoneTextSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SmartphoneText.SVG = SmartphoneTextSVG;
        return SmartphoneText;
    })();
export const SmartphoneTime = /*#__PURE__*/ (() => {
        function SmartphoneTimeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 11.5c0-2.7-1.653-5.019-4-6v-3.5c0-1.103-0.897-2-2-2h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-4.5c2.347-0.981 4-3.3 4-6zM16 2v1h-10v-1h10zM6 21h4v1h-4v-1zM12 22v-1h4v1h-4zM16 20h-10v-16h10v1.019c-0.166-0.012-0.331-0.019-0.5-0.019-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5c0.169 0 0.334-0.006 0.5-0.019v2.019zM16 16.978v-1.978h-1v1.978c-2.634-0.237-4.737-2.344-4.978-4.978h1.978v-1h-1.978c0.237-2.634 2.344-4.737 4.978-4.978v1.978h1v-1.978c2.634 0.237 4.737 2.344 4.978 4.978h-1.978v1h1.978c-0.241 2.634-2.344 4.737-4.978 4.978z" }),
_('path', { d: "M15.422 11.716l-1.922-1.922-0.706 0.706 2.353 2.353c0.094 0.094 0.222 0.147 0.353 0.147 0.016 0 0.034 0 0.050-0.003 0.15-0.016 0.284-0.097 0.366-0.219l2.278-3.416-0.831-0.556-1.941 2.909z" })
            );
        }
        function SmartphoneTime({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmartphoneTimeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SmartphoneTime.SVG = SmartphoneTimeSVG;
        return SmartphoneTime;
    })();
export const SmartphoneTransfer = /*#__PURE__*/ (() => {
        function SmartphoneTransferSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 2v1h-10v-1h10zM12 20v-16h10v16h-10zM12 21h4v1h-4v-1zM22 22h-4v-1h4.003l-0.003 1c0.003 0 0 0 0 0z" }),
_('path', { d: "M8 13.5v-13c0-0.275-0.225-0.5-0.5-0.5h-7c-0.275 0-0.5 0.225-0.5 0.5v13c0 0.275 0.225 0.5 0.5 0.5h7c0.275 0 0.5-0.225 0.5-0.5zM7 13h-6v-12h6v12z" }),
_('path', { d: "M3 11h2v1h-2v-1z" }),
_('path', { d: "M7.5 19.794l-0.706 0.706 0.5 0.5h-0.794c-1.931 0-3.5-1.569-3.5-3.5v-0.794l0.5 0.5 0.706-0.706-1.353-1.353c-0.194-0.194-0.513-0.194-0.706 0l-1.353 1.353 0.706 0.706 0.5-0.5v0.794c0 2.481 2.019 4.5 4.5 4.5h0.794l-0.5 0.5 0.706 0.706 1.353-1.353c0.194-0.194 0.194-0.513 0-0.706l-1.353-1.353z" })
            );
        }
        function SmartphoneTransfer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmartphoneTransferSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SmartphoneTransfer.SVG = SmartphoneTransferSVG;
        return SmartphoneTransfer;
    })();
export const SmartphoneUser = /*#__PURE__*/ (() => {
        function SmartphoneUserSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 0h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM17 2v1h-10v-1h10zM7 20v-16h10v16h-10zM7 21h4v1h-4v-1zM17 22h-4v-1h4.003l-0.003 1c0.003 0 0 0 0 0z" }),
_('path', { d: "M15.928 14.244c-0.45-0.75-0.975-1.294-1.606-1.666-0.147-0.087-0.3-0.162-0.456-0.231 0.691-0.55 1.134-1.397 1.134-2.347 0-1.653-1.347-3-3-3s-3 1.347-3 3c0 0.95 0.444 1.797 1.134 2.347-0.156 0.066-0.309 0.144-0.456 0.231-0.631 0.372-1.156 0.916-1.606 1.666-0.141 0.231-0.069 0.534 0.159 0.681 1.144 0.722 2.378 1.075 3.769 1.075s2.625-0.353 3.769-1.078c0.228-0.144 0.3-0.447 0.159-0.678zM10 10c0-1.103 0.897-2 2-2s2 0.897 2 2-0.897 2-2 2c-1.103 0-2-0.897-2-2zM12 15c-1.019 0-1.934-0.219-2.787-0.666 0.691-0.919 1.569-1.334 2.787-1.334s2.097 0.416 2.787 1.334c-0.853 0.447-1.769 0.666-2.787 0.666z" })
            );
        }
        function SmartphoneUser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmartphoneUserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SmartphoneUser.SVG = SmartphoneUserSVG;
        return SmartphoneUser;
    })();
export const SmartphoneVibration = /*#__PURE__*/ (() => {
        function SmartphoneVibrationSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 0h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM17 2v1h-10v-1h10zM7 20v-16h10v16h-10zM7 21h4v1h-4v-1zM17 22h-4v-1h4.003l-0.003 1c0.003 0 0 0 0 0z" }),
_('path', { d: "M22.853 17.853c0.194-0.194 0.194-0.513 0-0.706l-1.647-1.647 1.647-1.647c0.194-0.194 0.194-0.513 0-0.706l-1.647-1.647 1.647-1.647c0.194-0.194 0.194-0.513 0-0.706l-1.647-1.647 1.647-1.647c0.194-0.194 0.194-0.513 0-0.706l-1.647-1.647 2-2-0.706-0.706-2.353 2.353c-0.194 0.194-0.194 0.513 0 0.706l1.647 1.647-1.647 1.647c-0.194 0.194-0.194 0.513 0 0.706l1.647 1.647-1.647 1.647c-0.194 0.194-0.194 0.513 0 0.706l1.647 1.647-1.647 1.647c-0.194 0.194-0.194 0.513 0 0.706l1.647 1.647-1.647 1.647c-0.194 0.194-0.194 0.513 0 0.706l2.353 2.353 0.706-0.706-2-2 1.647-1.647z" }),
_('path', { d: "M3.853 3.147l-2.353-2.353-0.706 0.706 2 2-1.647 1.647c-0.194 0.194-0.194 0.513 0 0.706l1.647 1.647-1.647 1.647c-0.194 0.194-0.194 0.513 0 0.706l1.647 1.647-1.647 1.647c-0.194 0.194-0.194 0.513 0 0.706l1.647 1.647-1.647 1.647c-0.194 0.194-0.194 0.513 0 0.706l1.647 1.647-2 2 0.706 0.706 2.353-2.353c0.194-0.194 0.194-0.513 0-0.706l-1.647-1.647 1.647-1.647c0.194-0.194 0.194-0.513 0-0.706l-1.647-1.647 1.647-1.647c0.194-0.194 0.194-0.513 0-0.706l-1.647-1.647 1.647-1.647c0.194-0.194 0.194-0.513 0-0.706l-1.647-1.647 1.647-1.647c0.197-0.194 0.197-0.513 0-0.706z" })
            );
        }
        function SmartphoneVibration({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmartphoneVibrationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SmartphoneVibration.SVG = SmartphoneVibrationSVG;
        return SmartphoneVibration;
    })();
export const SmartphoneWarning = /*#__PURE__*/ (() => {
        function SmartphoneWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 14h1v1h-1v-1z" }),
_('path', { d: "M15 9h1v4h-1v-4z" }),
_('path', { d: "M20.841 14.828l-2.841-5.681v-7.147c0-1.103-0.897-2-2-2h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-5h1.5c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672zM6 2h10v1h-10v-1zM6 21h4v1h-4v-1zM12 22v-1h4v1h-4zM16 20h-10v-16h10v2.088c-0.159-0.056-0.328-0.087-0.5-0.087-0.566 0-1.091 0.325-1.341 0.828l-4 7.997c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h4.5v3.003zM19.5 16h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5z" })
            );
        }
        function SmartphoneWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmartphoneWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SmartphoneWarning.SVG = SmartphoneWarningSVG;
        return SmartphoneWarning;
    })();
export const Smartphone = /*#__PURE__*/ (() => {
        function SmartphoneSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 0h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM17 22h-10v-20h10v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M11 3h2v1h-2v-1z" }),
_('path', { d: "M16 3.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M12 19c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 20c0 0 0 0 0 0v0z" })
            );
        }
        function Smartphone({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmartphoneSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Smartphone.SVG = SmartphoneSVG;
        return Smartphone;
    })();
export const Smartphone2 = /*#__PURE__*/ (() => {
    function Smartphone2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17 0h-10c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM17 2v1h-10v-1h10zM7 20v-16h10v16h-10zM7 21h4v1h-4v-1zM17 22h-4v-1h4.003l-0.003 1c0.003 0 0 0 0 0z" })
        );
    }
    function Smartphone2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Smartphone2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Smartphone2.SVG = Smartphone2SVG;
    return Smartphone2;
})();
export const Smiley = /*#__PURE__*/ (() => {
        function SmileySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M8.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM8.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M15.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM15.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M12 19c-3.859 0-7-3.141-7-7h-1c0 2.138 0.831 4.147 2.344 5.656s3.519 2.344 5.656 2.344 4.147-0.831 5.656-2.344 2.344-3.519 2.344-5.656h-1c0 3.859-3.141 7-7 7z" })
            );
        }
        function Smiley({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmileySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Smiley.SVG = SmileySVG;
        return Smiley;
    })();
export const SmirkWink = /*#__PURE__*/ (() => {
        function SmirkWinkSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M8.5 6c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM8.5 8c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M12 19v1c4.413 0 8-3.588 8-8h-1c0 3.859-3.141 7-7 7z" }),
_('path', { d: "M17.791 7.969l0.431-0.253-0.506-0.862-0.431 0.253c-0.969 0.569-2.347 0.894-3.784 0.894h-0.5v1h0.5c1.634 0 3.156-0.366 4.291-1.031z" })
            );
        }
        function SmirkWink({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmirkWinkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SmirkWink.SVG = SmirkWinkSVG;
        return SmirkWink;
    })();
export const Smirk = /*#__PURE__*/ (() => {
        function SmirkSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M8.5 6c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM8.5 8c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M15.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM15.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M12 19v1c4.413 0 8-3.588 8-8h-1c0 3.859-3.141 7-7 7z" })
            );
        }
        function Smirk({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SmirkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Smirk.SVG = SmirkSVG;
        return Smirk;
    })();
export const Snorkeling = /*#__PURE__*/ (() => {
        function SnorkelingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16.947 14.678c-0.138-0.406-0.519-0.678-0.947-0.678h-6c-1.653 0-3.537-0.050-5.066-0.422l-3.594-2.634-1.181 1.613 3.75 2.75c0.1 0.075 0.216 0.128 0.338 0.159 1.156 0.306 2.459 0.438 3.738 0.494-0.194 0.909-0.881 1.65-1.422 2.106l-4.759 0.953 0.394 1.962 5-1c0.153-0.031 0.3-0.097 0.422-0.194 0.794-0.625 1.406-1.325 1.822-2.084 0.303-0.556 0.494-1.125 0.563-1.703h5.319c1.378 3 4.184 3 6.678 3v-2c-2.803 0-4.3-0.103-5.053-2.322z" }),
_('path', { d: "M22 6.444v-3.444h-1v3.878c-0.266 0.075-0.581 0.122-1 0.122-0.881 0-1.297-0.206-1.775-0.447-0.519-0.259-1.106-0.553-2.225-0.553s-1.706 0.294-2.225 0.553c-0.481 0.241-0.894 0.447-1.775 0.447s-1.297-0.206-1.775-0.447c-0.519-0.259-1.106-0.553-2.225-0.553s-1.706 0.294-2.225 0.553c-0.481 0.241-0.894 0.447-1.775 0.447s-1.297-0.206-1.775-0.447c-0.519-0.259-1.106-0.553-2.225-0.553v1c0.881 0 1.297 0.206 1.775 0.447 0.519 0.259 1.106 0.553 2.225 0.553s1.706-0.294 2.225-0.553c0.481-0.241 0.894-0.447 1.775-0.447s1.297 0.206 1.775 0.447c0.519 0.259 1.106 0.553 2.225 0.553s1.706-0.294 2.225-0.553c0.481-0.241 0.894-0.447 1.775-0.447s1.297 0.206 1.775 0.447c0.519 0.259 1.106 0.553 2.225 0.553 0.391 0 0.719-0.037 1-0.094v2.094c0 0.55-0.45 1-1 1h-0.269c-0.347-0.597-0.994-1-1.731-1-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2c1.103 0 2-0.897 2-2v-2.444c0.078-0.037 0.15-0.075 0.225-0.109 0.481-0.241 0.894-0.447 1.775-0.447v-1c-0.963 0-1.531 0.216-2 0.444zM18 13c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1c0 0.55-0.45 1-1 1z" })
            );
        }
        function Snorkeling({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SnorkelingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Snorkeling.SVG = SnorkelingSVG;
        return Snorkeling;
    })();
export const Snowflake = /*#__PURE__*/ (() => {
    function SnowflakeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.891 14.669l-3.081-0.825 2.016-1.163-0.5-0.866-2.881 1.662-1.366-0.366 2.016-1.162-0.5-0.866-2.306 1.331-0.916-3.416h2.663v-1h-2.328l1-1h3.328v-1h-2.328l2.256-2.256-0.706-0.706-2.256 2.256v-2.328h-1v3.328l-1 1v-2.328h-1v2.662l-3.412-0.916 1.331-2.306-0.866-0.5-1.163 2.016-0.366-1.366 1.662-2.881-0.866-0.5-1.166 2.016-0.825-3.081-0.966 0.259 0.825 3.081-2.016-1.162-0.5 0.866 2.881 1.662 0.366 1.366-2.016-1.162-0.5 0.866 2.303 1.331-2.497 2.497-1.331-2.303-0.866 0.5 1.163 2.016-1.366-0.366-1.662-2.881-0.866 0.5 1.163 2.016-3.081-0.825-0.259 0.966 3.081 0.825-2.016 1.162 0.5 0.866 2.881-1.662 1.366 0.366-2.016 1.163 0.5 0.866 2.306-1.331 0.919 3.412h-2.662v1h2.328l-1 1h-3.328v1h2.328l-2.256 2.256 0.706 0.706 2.256-2.256v2.328h1v-3.328l1-1v2.328h1v-2.662l3.412 0.916-1.331 2.306 0.866 0.5 1.162-2.016 0.366 1.366-1.662 2.881 0.866 0.5 1.162-2.016 0.825 3.081 0.966-0.259-0.825-3.081 2.016 1.163 0.5-0.866-2.881-1.662-0.366-1.366 2.016 1.163 0.5-0.866-2.303-1.331 2.497-2.497 1.331 2.303 0.866-0.5-1.162-2.016 1.366 0.366 1.662 2.881 0.866-0.5-1.163-2.016 3.081 0.825 0.259-0.963zM12.897 15.347l-3.347-0.897-0.897-3.347 2.45-2.45 3.347 0.897 0.897 3.347-2.45 2.45z" })
        );
    }
    function Snowflake({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SnowflakeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Snowflake.SVG = SnowflakeSVG;
    return Snowflake;
})();
export const Snowflake2 = /*#__PURE__*/ (() => {
    function Snowflake2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.697 14.472l-3.016 0.806-1.372-0.791 3.416-0.916-0.259-0.966-4.384 1.172-3.081-1.778 3.081-1.778 4.384 1.172 0.259-0.966-3.416-0.916 1.372-0.791 3.016 0.806 0.259-0.966-2.050-0.55 1.987-1.147-1-1.731-1.988 1.147 0.55-2.050-0.966-0.259-0.809 3.016-1.372 0.794 0.916-3.416-0.966-0.259-1.178 4.381-3.081 1.781v-3.562l3.206-3.206-0.706-0.706-2.5 2.5v-1.587l2.206-2.206-0.706-0.706-1.5 1.5v-2.294h-2v2.294l-1.5-1.5-0.706 0.706 2.206 2.206v1.587l-2.5-2.5-0.706 0.706 3.206 3.206v3.562l-3.081-1.781-1.178-4.381-0.966 0.259 0.916 3.416-1.372-0.794-0.809-3.016-0.966 0.259 0.55 2.050-1.987-1.147-1 1.731 1.987 1.147-2.050 0.55 0.259 0.966 3.016-0.806 1.372 0.791-3.416 0.916 0.259 0.966 4.384-1.172 3.081 1.778-3.081 1.778-4.384-1.172-0.259 0.966 3.416 0.916-1.372 0.791-3.016-0.806-0.259 0.966 2.050 0.55-1.987 1.147 1 1.731 1.987-1.147-0.55 2.050 0.966 0.259 0.809-3.016 1.372-0.794-0.916 3.416 0.966 0.259 1.178-4.381 3.081-1.781v3.563l-3.206 3.206 0.706 0.706 2.5-2.5v1.587l-2.206 2.206 0.706 0.706 1.5-1.5v2.294h2v-2.294l1.5 1.5 0.706-0.706-2.206-2.206v-1.587l2.5 2.5 0.706-0.706-3.206-3.206v-3.563l3.081 1.781 1.178 4.381 0.966-0.259-0.916-3.416 1.372 0.794 0.809 3.016 0.966-0.259-0.55-2.050 1.988 1.147 1-1.731-1.987-1.147 2.050-0.55z" })
        );
    }
    function Snowflake2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Snowflake2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Snowflake2.SVG = Snowflake2SVG;
    return Snowflake2;
})();
export const Snowman = /*#__PURE__*/ (() => {
        function SnowmanSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 13c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 14c0 0 0 0 0 0v0z" }),
_('path', { d: "M12 16c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 17c0 0 0 0 0 0v0z" }),
_('path', { d: "M12 19c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 20c0 0 0 0 0 0v0z" }),
_('path', { d: "M11 5.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M14 5.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M24 10v-1h-2.294l1.5-1.5-0.706-0.706-1.5 1.5v-2.294h-1v3.294l-2.2 2.2c-0.031-0.034-0.063-0.066-0.097-0.1 0.184-0.25 0.294-0.559 0.294-0.891 0-0.441-0.191-0.837-0.494-1.113 0.325-0.75 0.494-1.563 0.494-2.388 0-1.491-0.553-2.913-1.528-4h2.531v-1.003h-2c0-1.103-0.897-2-2-2h-6c-1.103 0-2 0.897-2 2h-2v1h2.528c-0.972 1.087-1.528 2.509-1.528 4 0 0.825 0.169 1.638 0.494 2.388-0.303 0.275-0.494 0.672-0.494 1.113 0 0.334 0.109 0.644 0.294 0.891-0.031 0.034-0.066 0.066-0.097 0.1l-2.197-2.197v-3.294h-1v2.294l-1.5-1.5-0.706 0.706 1.5 1.5h-2.294v1h3.294l2.262 2.262c-1.003 1.362-1.556 3.019-1.556 4.737 0 1.403 0.369 2.784 1.069 3.997 0.203 0.353 0.434 0.687 0.687 1.003h-2.756v2h18v-2h-2.756c0.253-0.316 0.484-0.653 0.687-1.003 0.7-1.212 1.069-2.594 1.069-3.997 0-1.719-0.553-3.375-1.553-4.737l2.262-2.262h3.291zM7.5 11c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h9c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-9zM14.313 3.734c1.059 0.75 1.688 1.966 1.688 3.266 0 0.703-0.184 1.394-0.534 2v0h-1.231c0.475-0.531 0.766-1.231 0.766-2h-1c0 1.103-0.897 2-2 2s-2-0.897-2-2h-1c0 0.769 0.291 1.469 0.766 2h-1.231c-0.35-0.603-0.534-1.297-0.534-2 0-1.297 0.631-2.513 1.688-3.266 0.678-0.481 1.478-0.734 2.313-0.734s1.634 0.253 2.313 0.734zM9 1h6c0.55 0 1 0.45 1 1h-8c0-0.55 0.45-1 1-1zM15.963 12.494c1.297 1.141 2.037 2.781 2.037 4.506 0 2.034-0.997 3.884-2.681 5h-6.638c-1.684-1.116-2.681-2.966-2.681-5 0-1.725 0.741-3.366 2.037-4.506 0.203-0.178 0.419-0.344 0.644-0.494h6.637c0.225 0.15 0.441 0.316 0.644 0.494z" })
            );
        }
        function Snowman({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SnowmanSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Snowman.SVG = SnowmanSVG;
        return Snowman;
    })();
export const Soccer = /*#__PURE__*/ (() => {
        function SoccerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM21.897 10.563l-1.1 1.156-1.775-2 0.259-2.663 1.566 0.288c0.522 0.987 0.884 2.072 1.050 3.219zM13.694 2.144l0.759 1.403-2.453 1.069-2.45-1.069 0.759-1.403c0.55-0.094 1.116-0.144 1.694-0.144 0.575 0 1.137 0.050 1.691 0.144zM3.153 7.344l1.566-0.288 0.259 2.662-1.775 2-1.1-1.156c0.166-1.147 0.528-2.231 1.050-3.219zM4.838 18.972l0.209-1.572 2.613 0.575 1.353 2.306-1.434 0.687c-1.025-0.509-1.95-1.188-2.741-1.997zM16.422 20.969l-1.434-0.687 1.353-2.306 2.613-0.575 0.209 1.572c-0.791 0.809-1.716 1.488-2.741 1.997zM20.034 17.947l-0.162-1.222c-0.019-0.138-0.094-0.262-0.209-0.344s-0.256-0.109-0.394-0.078l-3.356 0.738c-0.134 0.031-0.253 0.116-0.325 0.234l-1.741 2.963c-0.072 0.122-0.087 0.266-0.047 0.4s0.138 0.244 0.263 0.306l1.116 0.534c-1 0.337-2.069 0.519-3.181 0.519s-2.181-0.181-3.181-0.519l1.116-0.534c0.125-0.059 0.222-0.172 0.262-0.306s0.025-0.278-0.047-0.4l-1.741-2.963c-0.072-0.119-0.188-0.206-0.325-0.234l-3.356-0.738c-0.138-0.031-0.278 0-0.394 0.078s-0.191 0.206-0.209 0.344l-0.162 1.222c-1.228-1.662-1.959-3.722-1.959-5.947 0-0.031 0-0.063 0-0.094l0.853 0.894c0.094 0.1 0.225 0.156 0.363 0.156 0.003 0 0.006 0 0.009 0 0.141-0.003 0.272-0.063 0.366-0.169l2.281-2.569c0.094-0.103 0.138-0.241 0.125-0.381l-0.334-3.419c-0.012-0.141-0.084-0.266-0.197-0.35s-0.253-0.119-0.391-0.094l-1.212 0.222c1.25-1.747 3.047-3.078 5.141-3.738l-0.588 1.088c-0.066 0.122-0.078 0.269-0.034 0.4 0.047 0.131 0.144 0.241 0.272 0.297l3.15 1.375c0.063 0.028 0.131 0.041 0.2 0.041s0.138-0.012 0.2-0.041l3.15-1.375c0.128-0.056 0.228-0.162 0.272-0.297s0.034-0.278-0.034-0.4l-0.591-1.088c2.094 0.659 3.891 1.991 5.141 3.738l-1.212-0.222c-0.138-0.025-0.278 0.009-0.391 0.094s-0.184 0.213-0.197 0.35l-0.334 3.419c-0.012 0.138 0.031 0.275 0.125 0.381l2.281 2.569c0.094 0.103 0.225 0.166 0.366 0.169 0.003 0 0.006 0 0.009 0 0.138 0 0.269-0.056 0.363-0.156l0.85-0.894c0 0.031 0 0.063 0 0.094 0 2.225-0.731 4.284-1.966 5.947z" }),
_('path', { d: "M16.5 10.15l-4.206-3.056c-0.175-0.128-0.413-0.128-0.588 0l-4.206 3.056c-0.175 0.128-0.25 0.353-0.181 0.559l1.606 4.944c0.066 0.206 0.259 0.347 0.475 0.347h5.2c0.216 0 0.409-0.141 0.475-0.347l1.606-4.944c0.066-0.206-0.006-0.431-0.181-0.559zM14.238 15h-4.475l-1.381-4.253 3.619-2.628 3.619 2.628-1.381 4.253z" })
            );
        }
        function Soccer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SoccerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Soccer.SVG = SoccerSVG;
        return Soccer;
    })();
export const SockDirty = /*#__PURE__*/ (() => {
        function SockDirtySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.5 0h-10c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h0.5v4.313c-3.578 1.387-6.844 2.884-9.484 4.347-0.006 0.003-0.009 0.006-0.016 0.009-2.388 1.381-3.209 4.444-1.831 6.831 0.925 1.603 2.609 2.5 4.341 2.5 0.847 0 1.703-0.216 2.487-0.666l0.312-0.178c2.716-1.55 5.522-3.156 7.191-3.156 0.016 0 0.028 0 0.044 0 2.7-0.116 4.291-0.7 5.159-1.891 0.819-1.122 0.809-2.506 0.8-4.109v-8h0.5c0.275 0 0.5-0.225 0.5-0.5v-5c-0.003-0.275-0.228-0.5-0.503-0.5zM19 5v-4h1v4h-1zM15 5v-4h1v4h-1zM17 1h1v4h-1v-4zM13 1h1v4h-1v-4zM10.931 15.041c-0.184 0.6-0.719 0.959-1.431 0.959-0.659 0-1.172 0.231-1.522 0.684-0.284 0.369-0.422 0.828-0.541 1.231-0.237 0.803-0.369 1.084-0.909 1.084-0.594 0-0.775-0.328-1.225-1.619-0.122-0.35-0.263-0.75-0.441-1.181 1.684-0.916 3.622-1.841 5.725-2.744 0.431 0.553 0.472 1.159 0.344 1.584zM19.584 16.931c-0.456 0.628-1.619 0.978-3.55 1.069 0.169-2.353 1.041-3.719 3.966-3.959 0.009 1.284 0.012 2.303-0.416 2.891zM20 13.034c-1.781 0.131-3.009 0.644-3.816 1.578-0.691 0.8-1.059 1.894-1.156 3.478-2.022 0.363-4.456 1.753-7.209 3.325l-0.312 0.178c0 0-0.003 0-0.003 0.003-1.434 0.825-3.275 0.334-4.1-1.1-0.722-1.253-0.434-2.819 0.609-3.747 0.134 0.338 0.247 0.656 0.35 0.956 0.213 0.612 0.397 1.141 0.687 1.544 0.363 0.503 0.847 0.747 1.481 0.747 0.591 0 1.053-0.219 1.375-0.65 0.253-0.341 0.375-0.753 0.494-1.15 0.259-0.872 0.422-1.2 1.106-1.2 1.156 0 2.072-0.638 2.388-1.666 0.169-0.547 0.141-1.159-0.075-1.722-0.075-0.191-0.169-0.375-0.281-0.55 0.916-0.381 1.859-0.756 2.825-1.125 0.387-0.147 0.644-0.519 0.644-0.934v-5h5v7.034zM22 5h-1v-4h1v4z" }),
_('path', { d: "M7.5 9.206l0.706-0.706-0.353-0.353c-0.831-0.831-0.831-1.134-0.825-1.184 0.019-0.122 0.366-0.3 0.619-0.428 0.334-0.172 0.712-0.366 0.994-0.675 0.363-0.4 0.478-0.894 0.344-1.472l-0.113-0.487-0.975 0.225 0.112 0.488c0.109 0.478-0.075 0.647-0.819 1.028-0.494 0.253-1.053 0.541-1.153 1.162-0.087 0.563 0.253 1.197 1.106 2.047l0.356 0.356z" }),
_('path', { d: "M2.5 10.206l0.706-0.706-0.353-0.353c-0.831-0.831-0.831-1.134-0.825-1.184 0.019-0.122 0.366-0.3 0.619-0.428 0.334-0.172 0.713-0.366 0.994-0.675 0.363-0.4 0.478-0.894 0.344-1.472l-0.113-0.488-0.972 0.225 0.112 0.487c0.109 0.478-0.075 0.647-0.819 1.028-0.494 0.253-1.053 0.541-1.153 1.163-0.087 0.563 0.253 1.197 1.106 2.047l0.353 0.356z" })
            );
        }
        function SockDirty({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SockDirtySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SockDirty.SVG = SockDirtySVG;
        return SockDirty;
    })();
export const Sock = /*#__PURE__*/ (() => {
    function SockSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.5 0h-10c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h0.5v4.313c-3.588 1.391-6.853 2.891-9.484 4.347-0.006 0.003-0.009 0.006-0.016 0.009-2.388 1.378-3.209 4.444-1.831 6.831 0.925 1.603 2.609 2.5 4.338 2.5 0.847 0 1.703-0.216 2.487-0.669l0.319-0.181c2.716-1.547 5.522-3.15 7.188-3.15 0.016 0 0.028 0 0.044 0 2.7-0.116 4.291-0.7 5.159-1.891 0.819-1.122 0.809-2.509 0.8-4.113v-7.997h0.5c0.275 0 0.5-0.225 0.5-0.5v-5c-0.003-0.275-0.228-0.5-0.503-0.5zM19 5v-4h1v4h-1zM15 5v-4h1v4h-1zM17 1h1v4h-1v-4zM13 1h1v4h-1v-4zM19.584 16.928c-0.456 0.628-1.619 0.978-3.553 1.069 0.169-2.353 1.041-3.719 3.966-3.959 0.012 1.287 0.016 2.306-0.413 2.891zM20 13.034c-1.781 0.131-3.009 0.644-3.816 1.581-0.691 0.8-1.059 1.894-1.156 3.478-2.022 0.363-4.453 1.75-7.203 3.322l-0.319 0.181c0 0-0.003 0.003-0.003 0.003-1.431 0.828-3.272 0.334-4.097-1.097s-0.337-3.266 1.091-4.094c2.703-1.5 6.116-3.044 9.863-4.472 0.387-0.147 0.644-0.519 0.644-0.934v-5.003h5v7.034zM22 5h-1v-4h1v4z" })
        );
    }
    function Sock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sock.SVG = SockSVG;
    return Sock;
})();
export const Socket = /*#__PURE__*/ (() => {
        function SocketSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.997 7.131c-0.678-1.597-1.678-3.081-2.975-4.413-0.466-0.478-0.981-0.719-1.528-0.719h-12.984c-0.55 0-1.062 0.241-1.528 0.719-1.297 1.331-2.3 2.816-2.975 4.413-0.669 1.569-1.006 3.206-1.006 4.869s0.338 3.3 1.003 4.869c0.678 1.597 1.678 3.081 2.975 4.413 0.466 0.478 0.981 0.719 1.528 0.719h12.984c0.55 0 1.062-0.241 1.528-0.719 1.297-1.331 2.3-2.816 2.975-4.413 0.669-1.569 1.006-3.206 1.006-4.869s-0.337-3.3-1.003-4.869zM18.588 19.884c-0.069 0.069-0.112 0.103-0.134 0.116h-12.909c-0.022-0.012-0.066-0.047-0.134-0.116-4.525-4.644-4.525-11.128 0-15.769 0.069-0.069 0.113-0.103 0.134-0.116h12.909c0.022 0.012 0.066 0.047 0.134 0.116 4.525 4.641 4.525 11.128 0 15.769z" }),
_('path', { d: "M12 14c-1.103 0-2 0.897-2 2v1.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-1.5c0-1.103-0.897-2-2-2zM13 17h-2v-1c0-0.55 0.45-1 1-1s1 0.45 1 1v1z" }),
_('path', { d: "M14 6h2v6h-2v-6z" }),
_('path', { d: "M8 6h2v6h-2v-6z" })
            );
        }
        function Socket({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SocketSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Socket.SVG = SocketSVG;
        return Socket;
    })();
export const SolarPanel = /*#__PURE__*/ (() => {
        function SolarPanelSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.966 21.316l-2.163-5.409 2.131-5.544c0.119-0.306 0.078-0.653-0.109-0.925s-0.494-0.434-0.825-0.434h-7.084c-0.475-2.838-2.947-5.003-5.916-5.003-3.309 0-6 2.691-6 6 0 1.238 0.372 2.425 1.081 3.434 0.497 0.709 1.128 1.297 1.863 1.728l-2.875 7.478c-0.119 0.306-0.078 0.653 0.109 0.925s0.494 0.434 0.822 0.434h13c0.413 0 0.784-0.256 0.934-0.641l0.522-1.359h4.044c0.166 0 0.322-0.081 0.413-0.219 0.094-0.138 0.113-0.312 0.053-0.466zM18.853 18h-2.894l1.153-3h2.894l-1.153 3zM11.959 18l1.153-3h2.928l-1.153 3h-2.928zM14.503 19l-1.153 3h-2.928l1.153-3h2.928zM17.578 11l-1.153 3h-2.928l1.153-3h2.928zM12.425 14h-2.894l1.153-3h2.894l-1.153 3zM9.147 15h2.894l-1.153 3h-2.894l1.153-3zM20.391 14h-2.894l1.153-3h2.894l-1.153 3zM6 10c0-2.206 1.794-4 4-4 1.859 0 3.428 1.278 3.875 3h-3.875c-0.413 0-0.784 0.256-0.934 0.641l-1.391 3.612c-1.028-0.741-1.675-1.95-1.675-3.253zM7.609 19h2.894l-1.153 3h-2.894l1.153-3zM17.313 22h-2.894l1.153-3h2.894l-1.153 3zM19.841 21l1.431-3.722 1.491 3.722h-2.922z" }),
_('path', { d: "M0 9h3v2h-3v-2z" }),
_('path', { d: "M9 0h2v3h-2v-3z" }),
_('path', { d: "M14.042 4.544l2.499-2.499 1.414 1.414-2.499 2.499-1.414-1.414z" }),
_('path', { d: "M2.042 3.456l1.414-1.414 2.499 2.499-1.414 1.414-2.499-2.499z" })
            );
        }
        function SolarPanel({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SolarPanelSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SolarPanel.SVG = SolarPanelSVG;
        return SolarPanel;
    })();
export const SolarPower = /*#__PURE__*/ (() => {
        function SolarPowerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 15v-1h-3v-2h-1v1h-0.5c-1.759 0-3.222 1.306-3.466 3h-0.034c-2.206 0-4 1.794-4 4v1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-8.528c2.247-0.25 4-2.159 4-4.472 0-2.481-2.019-4.5-4.5-4.5s-4.5 2.019-4.5 4.5c0 2.313 1.753 4.222 4 4.472v8.528c0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5v-1.5c0-1.653 1.347-3 3-3h0.034c0.244 1.694 1.703 3 3.466 3h0.5v1h1v-2h3v-1h-3v-3h3zM6 8.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5-2.5-1.122-2.5-2.5zM19.5 19c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5h0.5v5h-0.5z" }),
_('path', { d: "M14 8h3v1h-3v-1z" }),
_('path', { d: "M8 0h1v3h-1v-3z" }),
_('path', { d: "M0 8h3v1h-3v-1z" }),
_('path', { d: "M10.829 3.724l1.448-2.896 0.894 0.447-1.448 2.896-0.894-0.447z" }),
_('path', { d: "M12.828 5.277l2.896-1.448 0.447 0.894-2.896 1.448-0.447-0.894z" }),
_('path', { d: "M12.828 11.723l0.447-0.894 2.896 1.448-0.447 0.894-2.896-1.448z" }),
_('path', { d: "M10.828 13.276l0.894-0.447 1.448 2.896-0.894 0.447-1.448-2.896z" }),
_('path', { d: "M0.828 4.723l0.447-0.894 2.896 1.448-0.447 0.894-2.896-1.448z" }),
_('path', { d: "M3.829 1.276l0.894-0.447 1.448 2.896-0.894 0.447-1.448-2.896z" }),
_('path', { d: "M3.828 15.724l1.448-2.896 0.894 0.447-1.448 2.896-0.894-0.447z" }),
_('path', { d: "M0.828 12.276l2.896-1.448 0.447 0.894-2.896 1.448-0.447-0.894z" })
            );
        }
        function SolarPower({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SolarPowerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SolarPower.SVG = SolarPowerSVG;
        return SolarPower;
    })();
export const SolarPower2 = /*#__PURE__*/ (() => {
        function SolarPower2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 1h2v4h-2v-4z" }),
_('path', { d: "M0 12h4v2h-4v-2z" }),
_('path', { d: "M4.936 2.332l1.627-1.162 2.499 3.499-1.627 1.162-2.499-3.499z" }),
_('path', { d: "M0.169 7.564l1.162-1.627 3.499 2.499-1.162 1.627-3.499-2.499z" }),
_('path', { d: "M0.168 18.435l3.499-2.499 1.162 1.627-3.499 2.499-1.162-1.627z" }),
_('path', { d: "M19.168 8.436l3.499-2.499 1.162 1.627-3.499 2.499-1.162-1.627z" }),
_('path', { d: "M14.936 4.669l2.499-3.499 1.627 1.162-2.499 3.499-1.627-1.162z" }),
_('path', { d: "M24 18v-1h-3v-2h-1v1h-0.5c-1.522 0-2.819 0.837-3.3 2h-4.2c-2.756 0-5-2.244-5-5 0-2.753 2.238-4.994 4.991-5 0.003 0 0.006 0 0.009 0 1.313 0 2.556 0.522 3.503 1.466 0.966 0.966 1.497 2.238 1.497 3.584h2c0-0.95-0.188-1.875-0.563-2.75-0.359-0.844-0.872-1.6-1.522-2.25-1.325-1.322-3.072-2.050-4.916-2.050-0.003 0-0.009 0-0.012 0-1.866 0.003-3.622 0.734-4.941 2.053-1.319 1.322-2.047 3.078-2.047 4.947s0.728 3.628 2.050 4.95c1.322 1.322 3.081 2.050 4.95 2.050h4.2c0.481 1.163 1.778 2 3.3 2h0.5v1h1v-2h3v-1h-3v-2h3zM19.5 21c-1.378 0-2.5-0.897-2.5-2s1.122-2 2.5-2h0.5v4h-0.5z" })
            );
        }
        function SolarPower2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SolarPower2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SolarPower2.SVG = SolarPower2SVG;
        return SolarPower2;
    })();
export const Sophisticated = /*#__PURE__*/ (() => {
        function SophisticatedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c0.828-0.35 1.606-0.787 2.328-1.306v2.25h1v-3.056c0.166-0.147 0.328-0.3 0.484-0.459 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM20 17.994v-9.494c0-0.828-0.672-1.5-1.5-1.5-0.228 0-0.438 0.078-0.606 0.206-0.35-1.272-1.516-2.206-2.894-2.206-1.653 0-3 1.347-3 3s1.347 3 3 3c1.378 0 2.544-0.934 2.894-2.206 0.169 0.128 0.378 0.206 0.606 0.206 0.181 0 0.353-0.050 0.5-0.134v10.269c-1.806 1.772-4.278 2.866-7 2.866-5.512 0-10-4.488-10-10s4.488-10 10-10c5.512 0 10 4.488 10 10 0 2.247-0.744 4.322-2 5.994zM18.5 8v0c0 0 0 0 0 0zM17 8c0 1.103-0.897 2-2 2s-2-0.897-2-2 0.897-2 2-2 2 0.897 2 2z" }),
_('path', { d: "M8.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM8.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M10.5 13c-0.591 0-1.047 0.309-1.453 0.584-0.331 0.225-0.619 0.419-0.912 0.419h-0.003c-0.344 0-0.769-0.281-1.259-0.834-0.138-0.156-0.356-0.209-0.55-0.134s-0.322 0.259-0.322 0.469c0 1.134 0.434 2.266 1.191 3.109 0.806 0.897 1.894 1.391 3.059 1.391 0.731 0 1.328-0.219 1.75-0.628 0.422 0.409 1.019 0.628 1.75 0.628 1.169 0 2.253-0.494 3.059-1.391 0.756-0.841 1.191-1.975 1.191-3.109 0-0.206-0.128-0.394-0.322-0.469s-0.413-0.019-0.55 0.134c-0.491 0.553-0.916 0.834-1.259 0.834h-0.003c-0.294 0-0.581-0.194-0.912-0.419-0.403-0.272-0.862-0.584-1.453-0.584-0.603 0-1.122 0.209-1.5 0.591-0.378-0.381-0.897-0.591-1.5-0.591zM12.466 14.684c0.181-0.453 0.528-0.684 1.034-0.684 0.284 0 0.566 0.191 0.894 0.413 0.409 0.275 0.869 0.588 1.469 0.591 0.306 0 0.606-0.078 0.912-0.241-0.444 1.219-1.519 2.241-3.022 2.241-0.987 0-1.216-0.525-1.291-0.7-0.078-0.184-0.259-0.3-0.459-0.3s-0.378 0.119-0.459 0.3c-0.075 0.172-0.303 0.7-1.291 0.7-1.503 0-2.578-1.019-3.022-2.241 0.303 0.162 0.603 0.241 0.906 0.241h0.003c0.6 0 1.062-0.312 1.469-0.591 0.328-0.222 0.609-0.413 0.894-0.413 0.506 0 0.853 0.231 1.034 0.684 0.075 0.191 0.259 0.316 0.466 0.316 0.203 0 0.384-0.125 0.462-0.316z" })
            );
        }
        function Sophisticated({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SophisticatedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Sophisticated.SVG = SophisticatedSVG;
        return Sophisticated;
    })();
export const SortAlphaAsc = /*#__PURE__*/ (() => {
        function SortAlphaAscSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5.941 15.266c-0.087-0.162-0.256-0.266-0.441-0.266h-4.5v1h3.566l-3.481 5.222c-0.103 0.153-0.112 0.35-0.025 0.513s0.256 0.266 0.441 0.266h4.5v-1h-3.566l3.481-5.222c0.103-0.153 0.112-0.35 0.025-0.513z" }),
_('path', { d: "M3.5 2c-0.216 0-0.406 0.138-0.475 0.341l-2.156 6.475 0.95 0.316 0.709-2.131h1.947l0.709 2.131 0.95-0.316-2.159-6.475c-0.069-0.203-0.259-0.341-0.475-0.341zM2.859 6l0.641-1.919 0.641 1.919h-1.281z" }),
_('path', { d: "M21.544 17.044l-3.544 3.541v-20.584h-2v20.584l-3.544-3.541-1.416 1.416 5.25 5.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l5.25-5.25-1.409-1.416z" })
            );
        }
        function SortAlphaAsc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SortAlphaAscSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SortAlphaAsc.SVG = SortAlphaAscSVG;
        return SortAlphaAsc;
    })();
export const SortAlphaDesc = /*#__PURE__*/ (() => {
        function SortAlphaDescSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1.059 8.734c0.087 0.162 0.256 0.266 0.441 0.266h4.5v-1h-3.566l3.481-5.222c0.103-0.153 0.112-0.35 0.025-0.513s-0.256-0.266-0.441-0.266h-4.5v1h3.566l-3.481 5.222c-0.103 0.153-0.112 0.35-0.025 0.513z" }),
_('path', { d: "M3.5 15c-0.216 0-0.406 0.138-0.475 0.341l-2.156 6.475 0.95 0.316 0.709-2.131h1.947l0.709 2.131 0.95-0.316-2.159-6.475c-0.069-0.203-0.259-0.341-0.475-0.341zM2.859 19l0.641-1.919 0.641 1.919h-1.281z" }),
_('path', { d: "M21.544 17.044l-3.544 3.541v-20.584h-2v20.584l-3.544-3.541-1.416 1.416 5.25 5.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l5.25-5.25-1.409-1.416z" })
            );
        }
        function SortAlphaDesc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SortAlphaDescSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SortAlphaDesc.SVG = SortAlphaDescSVG;
        return SortAlphaDesc;
    })();
export const SortNumericAsc = /*#__PURE__*/ (() => {
        function SortNumericAscSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.544 17.044l-3.544 3.541v-20.584h-2v20.584l-3.544-3.541-1.416 1.416 5.25 5.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l5.25-5.25-1.409-1.416z" }),
_('path', { d: "M3.5 15c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5c0.234 0 0.459-0.031 0.675-0.094-0.547 0.672-1.319 1.094-2.175 1.094v1c1.081 0 2.094-0.478 2.853-1.344 0.741-0.844 1.147-1.966 1.147-3.156 0-1.378-1.122-2.5-2.5-2.5zM3.5 19c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" }),
_('path', { d: "M3.5 2c-0.706 0-1.356 0.391-1.831 1.1-0.431 0.65-0.669 1.5-0.669 2.4s0.237 1.75 0.669 2.4c0.475 0.709 1.125 1.1 1.831 1.1s1.356-0.391 1.831-1.1c0.431-0.647 0.669-1.5 0.669-2.4s-0.237-1.75-0.669-2.4c-0.475-0.709-1.125-1.1-1.831-1.1zM3.5 8c-0.813 0-1.5-1.144-1.5-2.5s0.687-2.5 1.5-2.5 1.5 1.144 1.5 2.5-0.687 2.5-1.5 2.5z" })
            );
        }
        function SortNumericAsc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SortNumericAscSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SortNumericAsc.SVG = SortNumericAscSVG;
        return SortNumericAsc;
    })();
export const SortNumericDesc = /*#__PURE__*/ (() => {
        function SortNumericDescSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.544 17.044l-3.544 3.541v-20.584h-2v20.584l-3.544-3.541-1.416 1.416 5.25 5.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l5.25-5.25-1.409-1.416z" }),
_('path', { d: "M3.5 2c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5c0.234 0 0.459-0.031 0.675-0.094-0.547 0.672-1.319 1.094-2.175 1.094v1c1.081 0 2.094-0.478 2.853-1.344 0.741-0.844 1.147-1.966 1.147-3.156 0-1.378-1.122-2.5-2.5-2.5zM3.5 6c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" }),
_('path', { d: "M3.5 15c-0.706 0-1.356 0.391-1.831 1.1-0.431 0.65-0.669 1.5-0.669 2.4s0.237 1.75 0.669 2.4c0.475 0.709 1.125 1.1 1.831 1.1s1.356-0.391 1.831-1.1c0.431-0.647 0.669-1.5 0.669-2.4s-0.237-1.75-0.669-2.4c-0.475-0.709-1.125-1.1-1.831-1.1zM3.5 21c-0.813 0-1.5-1.144-1.5-2.5s0.687-2.5 1.5-2.5 1.5 1.144 1.5 2.5-0.687 2.5-1.5 2.5z" })
            );
        }
        function SortNumericDesc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SortNumericDescSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SortNumericDesc.SVG = SortNumericDescSVG;
        return SortNumericDesc;
    })();
export const SortSizeAsc = /*#__PURE__*/ (() => {
        function SortSizeAscSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.544 17.044l-3.544 3.541v-20.584h-2v20.584l-3.544-3.541-1.416 1.416 5.25 5.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l5.25-5.25-1.409-1.416z" }),
_('path', { d: "M8.5 18h-8c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h8c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5zM8 20h-7v-1h7v1z" }),
_('path', { d: "M8.5 13h-6c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h6c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5zM8 15h-5v-1h5v1z" }),
_('path', { d: "M8.5 8h-4c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h4c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5zM8 10h-3v-1h3v1z" }),
_('path', { d: "M8.5 3h-3c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5zM8 5h-2v-1h2v1z" })
            );
        }
        function SortSizeAsc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SortSizeAscSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SortSizeAsc.SVG = SortSizeAscSVG;
        return SortSizeAsc;
    })();
export const SortSizeDesc = /*#__PURE__*/ (() => {
        function SortSizeDescSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.544 17.044l-3.544 3.541v-20.584h-2v20.584l-3.544-3.541-1.416 1.416 5.25 5.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l5.25-5.25-1.409-1.416z" }),
_('path', { d: "M8.5 3h-8c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h8c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5zM8 5h-7v-1h7v1z" }),
_('path', { d: "M8.5 8h-6c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h6c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5zM8 10h-5v-1h5v1z" }),
_('path', { d: "M8.5 13h-4c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h4c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5zM8 15h-3v-1h3v1z" }),
_('path', { d: "M8.5 18h-3c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5zM8 20h-2v-1h2v1z" })
            );
        }
        function SortSizeDesc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SortSizeDescSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SortSizeDesc.SVG = SortSizeDescSVG;
        return SortSizeDesc;
    })();
export const SortTimeAsc = /*#__PURE__*/ (() => {
        function SortTimeAscSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.544 17.044l-3.544 3.541v-20.584h-2v20.584l-3.544-3.541-1.416 1.416 5.25 5.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l5.25-5.25-1.409-1.416z" }),
_('path', { d: "M6 3c-2.756 0-5 2.244-5 5v1h1v-1c0-2.206 1.794-4 4-4s4 1.794 4 4c0 1.938-1.384 3.556-3.216 3.922l0.422-0.422-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706-0.544-0.544c2.447-0.325 4.338-2.425 4.338-4.956 0-2.756-2.244-5-5-5z" }),
_('path', { d: "M6.4 8.8l1.8-2.4-0.8-0.6-1.65 2.2h-1.75v1h2c0.156 0 0.306-0.075 0.4-0.2z" })
            );
        }
        function SortTimeAsc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SortTimeAscSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SortTimeAsc.SVG = SortTimeAscSVG;
        return SortTimeAsc;
    })();
export const SortTimeDesc = /*#__PURE__*/ (() => {
        function SortTimeDescSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.544 17.044l-3.544 3.541v-20.584h-2v20.584l-3.544-3.541-1.416 1.416 5.25 5.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l5.25-5.25-1.409-1.416z" }),
_('path', { d: "M6 3c-2.756 0-5 2.244-5 5 0 2.531 1.891 4.631 4.338 4.956l-0.544 0.544 0.706 0.706 1.353-1.353c0.194-0.194 0.194-0.513 0-0.706l-1.353-1.353-0.706 0.706 0.422 0.422c-1.831-0.366-3.216-1.984-3.216-3.922 0-2.206 1.794-4 4-4s4 1.794 4 4v1h1v-1c0-2.756-2.244-5-5-5z" }),
_('path', { d: "M4 8v1h2c0.156 0 0.306-0.075 0.4-0.2l1.8-2.4-0.8-0.6-1.65 2.2h-1.75z" })
            );
        }
        function SortTimeDesc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SortTimeDescSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SortTimeDesc.SVG = SortTimeDescSVG;
        return SortTimeDesc;
    })();
export const Source = /*#__PURE__*/ (() => {
        function SourceSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 3.416v5.584h2v-5.584l1.544 1.544 1.416-1.416-3.25-3.25c-0.391-0.391-1.025-0.391-1.416 0l-3.25 3.25 1.416 1.416 1.541-1.544z" }),
_('path', { d: "M9 13v-2h-5.584l1.544-1.544-1.416-1.416-3.25 3.25c-0.391 0.391-0.391 1.025 0 1.416l3.25 3.25 1.416-1.416-1.544-1.541h5.584z" }),
_('path', { d: "M13 20.584v-5.584h-2v5.584l-1.544-1.544-1.416 1.416 3.25 3.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l3.25-3.25-1.416-1.416-1.537 1.544z" }),
_('path', { d: "M23.706 11.294l-3.25-3.25-1.416 1.416 1.544 1.544h-5.584v2h5.584l-1.544 1.544 1.416 1.416 3.25-3.25c0.391-0.397 0.391-1.028 0-1.419z" }),
_('path', { d: "M10 12c0 1.103 0.897 2 2 2s2-0.897 2-2c0-1.103-0.897-2-2-2s-2 0.897-2 2zM13 12c0 0.55-0.45 1-1 1s-1-0.45-1-1c0-0.55 0.45-1 1-1s1 0.45 1 1z" })
            );
        }
        function Source({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SourceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Source.SVG = SourceSVG;
        return Source;
    })();
export const Spades = /*#__PURE__*/ (() => {
    function SpadesSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 14c0-1.622-0.559-3.178-1.713-4.759-0.963-1.319-2.2-2.484-3.4-3.612-2-1.878-3.888-3.656-3.888-5.628h-2c0 1.972-1.887 3.75-3.888 5.628-1.2 1.128-2.441 2.294-3.4 3.612-1.153 1.581-1.713 3.138-1.713 4.759 0 2.756 2.244 5 5 5 0.537 0 1.172-0.109 1.803-0.309-0.484 2.056-1.872 3.309-3.803 3.309v2h14v-2c-1.931 0-3.319-1.253-3.803-3.309 0.631 0.2 1.266 0.309 1.803 0.309 2.756 0 5-2.244 5-5zM14.694 16.241c-0.291-0.272-0.716-0.347-1.081-0.188s-0.603 0.519-0.603 0.919c0 2.031 0.559 3.769 1.616 5.031h-5.25c1.056-1.263 1.616-3 1.616-5.031 0-0.4-0.237-0.759-0.603-0.919s-0.791-0.084-1.081 0.188c-0.353 0.331-1.534 0.759-2.306 0.759-1.653 0-3-1.347-3-3 0-2.7 2.278-4.841 4.481-6.916 1.075-1.009 2.187-2.056 3.019-3.159 0.184-0.244 0.35-0.484 0.5-0.725 0.15 0.241 0.316 0.481 0.5 0.725 0.834 1.103 1.944 2.15 3.019 3.159 2.203 2.075 4.481 4.216 4.481 6.916 0 1.653-1.347 3-3 3-0.772 0-1.953-0.428-2.306-0.759z" })
        );
    }
    function Spades({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SpadesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Spades.SVG = SpadesSVG;
    return Spades;
})();
export const Spades2 = /*#__PURE__*/ (() => {
        function Spades2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 14c0-1.622-0.559-3.178-1.713-4.759-0.963-1.319-2.2-2.484-3.4-3.612-2-1.878-3.888-3.656-3.888-5.628h-2c0 1.972-1.887 3.75-3.888 5.628-1.2 1.128-2.441 2.294-3.4 3.612-1.153 1.581-1.713 3.138-1.713 4.759 0 2.756 2.244 5 5 5 0.537 0 1.172-0.109 1.803-0.309-0.484 2.056-1.872 3.309-3.803 3.309v2h14v-2c-1.931 0-3.319-1.253-3.803-3.309 0.631 0.2 1.266 0.309 1.803 0.309 2.756 0 5-2.244 5-5zM14.694 16.241c-0.291-0.272-0.716-0.347-1.081-0.188s-0.603 0.519-0.603 0.919c0 2.031 0.559 3.769 1.616 5.031h-5.25c1.056-1.263 1.616-3 1.616-5.031 0-0.4-0.237-0.759-0.603-0.919s-0.791-0.084-1.081 0.188c-0.353 0.331-1.534 0.759-2.306 0.759-1.653 0-3-1.347-3-3 0-2.7 2.278-4.841 4.481-6.916 1.075-1.009 2.187-2.056 3.019-3.159 0.184-0.244 0.35-0.484 0.5-0.725 0.15 0.241 0.316 0.481 0.5 0.725 0.834 1.103 1.944 2.15 3.019 3.159 2.203 2.075 4.481 4.216 4.481 6.916 0 1.653-1.347 3-3 3-0.772 0-1.953-0.428-2.306-0.759z" }),
_('path', { d: "M18.069 11.619l-0.288-0.409c-0.778-1.1-1.894-2.15-3.075-3.259-0.281-0.266-0.572-0.537-0.856-0.813l-0.359-0.347-0.694 0.722 0.359 0.347c0.291 0.278 0.581 0.553 0.866 0.819 1.144 1.075 2.222 2.091 2.944 3.109l0.288 0.409 0.816-0.578z" })
            );
        }
        function Spades2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Spades2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Spades2.SVG = Spades2SVG;
        return Spades2;
    })();
export const SpeedFast = /*#__PURE__*/ (() => {
        function SpeedFastSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.809 15.603c0.359 0.269 0.781 0.397 1.197 0.397 0.612 0 1.216-0.278 1.609-0.803 0 0 0-0.003 0.003-0.003 0.084-0.112 0.153-0.228 0.203-0.344l2.084-4.422c0.203-0.428 0.075-0.944-0.306-1.225-0.378-0.284-0.909-0.262-1.266 0.053l-3.663 3.253c0 0-0.003 0.003-0.003 0.003-0.094 0.084-0.181 0.181-0.262 0.284 0 0.003-0.003 0.003-0.003 0.006-0.322 0.428-0.456 0.956-0.378 1.484 0.075 0.531 0.353 1 0.784 1.316zM11.197 13.409c0.044-0.056 0.091-0.106 0.141-0.153l3.659-3.256c0 0 0 0 0 0l-2.084 4.425-0.003 0.009c-0.025 0.053-0.056 0.109-0.1 0.166-0.331 0.441-0.959 0.531-1.406 0.2-0.216-0.159-0.353-0.391-0.394-0.653-0.037-0.263 0.028-0.525 0.188-0.738z" }),
_('path', { d: "M8 18h8v1h-8v-1z" }),
_('path', { d: "M23.056 9.328c-0.603-1.428-1.469-2.712-2.572-3.816s-2.384-1.966-3.813-2.572c-1.481-0.622-3.053-0.941-4.672-0.941s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572s-1.966 2.384-2.572 3.816c-0.625 1.478-0.944 3.050-0.944 4.669 0 1.419 0.244 2.806 0.728 4.128 0.466 1.275 1.144 2.456 2.013 3.509 0.191 0.231 0.472 0.363 0.772 0.363h16.975c0.3 0 0.581-0.134 0.772-0.363 0.869-1.053 1.544-2.234 2.013-3.509 0.484-1.322 0.728-2.709 0.728-4.128 0-1.619-0.319-3.191-0.944-4.672zM20.003 20h-16.006c-1.091-1.456-1.766-3.194-1.947-5h1.95v-2h-1.95c0.2-2.009 0.997-3.844 2.209-5.325l1.281 1.281 1.416-1.416-1.281-1.281c1.481-1.212 3.316-2.009 5.322-2.209v1.95h2v-1.95c2.009 0.2 3.847 0.997 5.328 2.213l-1.281 1.281 1.416 1.416 1.281-1.281c1.212 1.478 2.009 3.312 2.209 5.322h-1.95v2h1.95c-0.181 1.806-0.856 3.544-1.947 5z" })
            );
        }
        function SpeedFast({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SpeedFastSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SpeedFast.SVG = SpeedFastSVG;
        return SpeedFast;
    })();
export const SpeedMedium = /*#__PURE__*/ (() => {
        function SpeedMediumSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 18h8v1h-8v-1z" }),
_('path', { d: "M10.591 15.422c0.375 0.372 0.872 0.578 1.397 0.578 0.006 0 0.009 0 0.016 0 1.106-0.003 2.003-0.906 1.997-2.006 0-0.144-0.016-0.278-0.044-0.403l-0.981-4.791c-0.091-0.462-0.5-0.8-0.978-0.8-0.475 0-0.888 0.338-0.981 0.803l-0.978 4.803c0 0.003 0 0.003 0 0.006-0.028 0.141-0.041 0.269-0.041 0.394 0.003 0.537 0.213 1.041 0.594 1.416zM11.022 13.803l0.978-4.8 0.981 4.791c0 0.003 0 0.006 0.003 0.009 0.012 0.056 0.019 0.122 0.019 0.191 0.003 0.553-0.447 1.003-1.003 1.003-0.262 0.003-0.513-0.1-0.703-0.288s-0.294-0.441-0.294-0.706c-0.003-0.056 0.003-0.125 0.019-0.2z" }),
_('path', { d: "M23.056 9.328c-0.603-1.428-1.469-2.712-2.572-3.816s-2.384-1.966-3.813-2.572c-1.481-0.622-3.053-0.941-4.672-0.941s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572s-1.966 2.384-2.572 3.816c-0.625 1.478-0.944 3.050-0.944 4.669 0 1.419 0.244 2.806 0.728 4.128 0.466 1.275 1.144 2.456 2.013 3.509 0.191 0.231 0.472 0.363 0.772 0.363h16.975c0.3 0 0.581-0.134 0.772-0.363 0.869-1.053 1.544-2.234 2.013-3.509 0.484-1.322 0.728-2.709 0.728-4.128 0-1.619-0.319-3.191-0.944-4.672zM20.003 20h-16.006c-1.091-1.456-1.766-3.194-1.947-5h1.95v-2h-1.95c0.2-2.009 0.997-3.844 2.209-5.325l1.281 1.281 1.416-1.416-1.281-1.281c1.481-1.212 3.316-2.009 5.322-2.209v1.95h2v-1.95c2.009 0.2 3.847 0.997 5.328 2.213l-1.281 1.281 1.416 1.416 1.281-1.281c1.212 1.478 2.009 3.312 2.209 5.322h-1.95v2h1.95c-0.181 1.806-0.856 3.544-1.947 5z" })
            );
        }
        function SpeedMedium({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SpeedMediumSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SpeedMedium.SVG = SpeedMediumSVG;
        return SpeedMedium;
    })();
export const SpeedSlow = /*#__PURE__*/ (() => {
        function SpeedSlowSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 9.328c-0.603-1.428-1.469-2.712-2.572-3.816s-2.384-1.966-3.813-2.572c-1.481-0.622-3.053-0.941-4.672-0.941s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572s-1.966 2.384-2.572 3.816c-0.625 1.478-0.944 3.050-0.944 4.669 0 1.419 0.244 2.806 0.728 4.128 0.466 1.275 1.144 2.456 2.013 3.509 0.191 0.231 0.472 0.363 0.772 0.363h16.975c0.3 0 0.581-0.134 0.772-0.363 0.869-1.053 1.544-2.234 2.013-3.509 0.484-1.322 0.728-2.709 0.728-4.128 0-1.619-0.319-3.191-0.944-4.672zM20.003 20h-16.006c-1.091-1.456-1.766-3.194-1.947-5h1.95v-2h-1.95c0.2-2.009 0.997-3.844 2.209-5.325l1.281 1.281 1.416-1.416-1.281-1.281c1.481-1.212 3.319-2.013 5.328-2.213v1.953h2v-1.95c2.006 0.2 3.841 0.997 5.322 2.209l-1.281 1.281 1.416 1.416 1.281-1.281c1.212 1.481 2.009 3.316 2.209 5.325h-1.95v2h1.95c-0.181 1.806-0.856 3.544-1.947 5z" }),
_('path', { d: "M8 18h8v1h-8v-1z" }),
_('path', { d: "M10.181 14.847c0.053 0.116 0.122 0.231 0.203 0.344 0 0 0 0.003 0.003 0.003 0.394 0.528 0.997 0.803 1.609 0.803 0.416 0 0.837-0.128 1.194-0.397 0.431-0.319 0.709-0.784 0.787-1.313s-0.056-1.056-0.378-1.484c0-0.003-0.003-0.003-0.003-0.006-0.081-0.103-0.169-0.2-0.262-0.284 0 0-0.003-0.003-0.003-0.003l-3.666-3.256c-0.356-0.316-0.888-0.337-1.263-0.056-0.381 0.284-0.513 0.8-0.306 1.228l2.084 4.422zM9.003 10l3.659 3.256c0.050 0.044 0.097 0.097 0.141 0.153 0.159 0.213 0.225 0.475 0.188 0.738s-0.178 0.497-0.394 0.656c-0.444 0.331-1.075 0.241-1.406-0.203-0.044-0.056-0.075-0.112-0.1-0.166 0-0.003-0.003-0.006-0.003-0.009l-2.084-4.425c0 0 0 0 0 0z" })
            );
        }
        function SpeedSlow({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SpeedSlowSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SpeedSlow.SVG = SpeedSlowSVG;
        return SpeedSlow;
    })();
export const SpellCheck = /*#__PURE__*/ (() => {
        function SpellCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.544 7.044l-11.544 11.541-4.544-4.541-1.416 1.416 5.25 5.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l12.25-12.25-1.409-1.416z" }),
_('path', { d: "M4.472 8l0.709 2.131 0.95-0.316-2.159-6.475c-0.066-0.203-0.256-0.341-0.472-0.341s-0.406 0.138-0.475 0.341l-2.156 6.475 0.95 0.316 0.709-2.131h1.944zM3.5 5.081l0.641 1.919h-1.281l0.641-1.919z" }),
_('path', { d: "M7.5 10h2.5c1.103 0 2-0.897 2-2 0-0.597-0.262-1.134-0.678-1.5 0.416-0.366 0.678-0.903 0.678-1.5 0-1.103-0.897-2-2-2h-2.5c-0.275 0-0.5 0.225-0.5 0.5v6c0 0.275 0.225 0.5 0.5 0.5zM8 4h2c0.55 0 1 0.45 1 1s-0.45 1-1 1h-2v-2zM8 7h2c0.55 0 1 0.45 1 1s-0.45 1-1 1h-2v-2z" }),
_('path', { d: "M15.5 9.994c0.066 0.006 0.131 0.006 0.197 0.006 1.15 0 2.122-0.794 2.297-1.909l-0.987-0.156c-0.119 0.753-0.825 1.109-1.428 1.059-0.762-0.056-1.578-0.744-1.578-2.494s0.816-2.438 1.578-2.497c0.603-0.047 1.309 0.309 1.428 1.059l0.987-0.156c-0.184-1.181-1.256-2-2.494-1.903-1.153 0.091-2.5 1.059-2.5 3.494s1.347 3.406 2.5 3.497z" })
            );
        }
        function SpellCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SpellCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SpellCheck.SVG = SpellCheckSVG;
        return SpellCheck;
    })();
export const Spinner = /*#__PURE__*/ (() => {
        function SpinnerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 2v-2c-1.619 0-3.191 0.319-4.672 0.944-1.428 0.603-2.712 1.469-3.813 2.572s-1.966 2.384-2.572 3.813c-0.625 1.481-0.944 3.053-0.944 4.672h2c0-5.512 4.488-10 10-10z" }),
_('path', { d: "M18.363 5.637c-1.697-1.7-3.959-2.637-6.363-2.637s-4.666 0.938-6.363 2.637-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" })
            );
        }
        function Spinner({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SpinnerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Spinner.SVG = SpinnerSVG;
        return Spinner;
    })();
export const Spinner2 = /*#__PURE__*/ (() => {
        function Spinner2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.816s-2.384-1.966-3.816-2.572c-1.478-0.622-3.050-0.941-4.669-0.941s-3.191 0.319-4.672 0.944c-1.256 0.531-2.4 1.266-3.409 2.184-0.009 0.009-0.019 0.019-0.031 0.028-0.006 0.006-0.016 0.012-0.022 0.022-0.019 0.016-0.034 0.031-0.053 0.047-0.006 0.006-0.012 0.012-0.019 0.019-0.069 0.063-0.134 0.128-0.2 0.191-0.003 0.003-0.003 0.003-0.006 0.006-0.025 0.025-0.050 0.050-0.075 0.075s-0.050 0.050-0.075 0.075c-0.003 0.003-0.003 0.003-0.006 0.006-0.066 0.066-0.128 0.131-0.191 0.2-0.006 0.006-0.012 0.012-0.019 0.019-0.016 0.019-0.031 0.034-0.047 0.053-0.006 0.006-0.012 0.016-0.022 0.022-0.009 0.009-0.019 0.019-0.028 0.031-0.919 1.006-1.653 2.15-2.184 3.409-0.622 1.478-0.941 3.050-0.941 4.669s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.816s2.384 1.966 3.816 2.572c1.481 0.625 3.050 0.944 4.672 0.944 1.619 0 3.191-0.319 4.672-0.944 1.428-0.603 2.712-1.469 3.816-2.572s1.966-2.384 2.572-3.816c0.625-1.481 0.944-3.050 0.944-4.672-0.006-1.619-0.325-3.191-0.95-4.672zM12 23c-6.066 0-11-4.934-11-11h1c0-5.512 4.488-10 10-10v-1c6.066 0 11 4.934 11 11s-4.934 11-11 11z" }),
_('path', { d: "M12 4v-1c-2.403 0-4.666 0.938-6.363 2.637-1.7 1.697-2.637 3.959-2.637 6.363h1c0 2.138 0.831 4.147 2.344 5.656s3.519 2.344 5.656 2.344 4.147-0.831 5.656-2.344 2.344-3.519 2.344-5.656-0.831-4.147-2.344-5.656-3.519-2.344-5.656-2.344zM12 19c-3.859 0-7-3.141-7-7s3.141-7 7-7c3.859 0 7 3.141 7 7s-3.141 7-7 7z" })
            );
        }
        function Spinner2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Spinner2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Spinner2.SVG = Spinner2SVG;
        return Spinner2;
    })();
export const Spinner3 = /*#__PURE__*/ (() => {
        function Spinner3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M4 12h1c0-3.859 3.141-7 7-7v-1c-4.413 0-8 3.588-8 8z" })
            );
        }
        function Spinner3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Spinner3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Spinner3.SVG = Spinner3SVG;
        return Spinner3;
    })();
export const Spinner4 = /*#__PURE__*/ (() => {
        function Spinner4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.816s-2.384-1.966-3.816-2.572c-1.478-0.622-3.050-0.941-4.669-0.941s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.816 2.572s-1.966 2.384-2.572 3.816c-0.622 1.478-0.941 3.050-0.941 4.669s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.816s2.384 1.966 3.816 2.572c1.481 0.625 3.050 0.944 4.672 0.944 1.619 0 3.191-0.319 4.672-0.944 1.428-0.603 2.712-1.469 3.816-2.572s1.966-2.384 2.572-3.816c0.625-1.481 0.944-3.050 0.944-4.672-0.006-1.619-0.325-3.191-0.95-4.672zM12 23c-6.066 0-11-4.934-11-11s4.934-11 11-11c6.066 0 11 4.934 11 11s-4.934 11-11 11z" }),
_('path', { d: "M12 4v-2c-2.672 0-5.184 1.041-7.072 2.928s-2.928 4.4-2.928 7.072h2c0-4.413 3.588-8 8-8z" }),
_('path', { d: "M12 5c-1.869 0-3.628 0.728-4.95 2.050s-2.050 3.081-2.050 4.95c0 1.869 0.728 3.628 2.050 4.95s3.081 2.050 4.95 2.050c1.869 0 3.628-0.728 4.95-2.050s2.050-3.081 2.050-4.95c0-1.869-0.728-3.628-2.050-4.95s-3.081-2.050-4.95-2.050zM12 18c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z" })
            );
        }
        function Spinner4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Spinner4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Spinner4.SVG = Spinner4SVG;
        return Spinner4;
    })();
export const Split = /*#__PURE__*/ (() => {
        function SplitSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 0h-7v2h4.584l-10.291 10.294c-0.188 0.188-0.294 0.441-0.294 0.706v11h2v-10.584l10-10v4.584h2v-7c0-0.553-0.447-1-1-1z" }),
_('path', { d: "M10.956 9.544l-7.541-7.544h4.584v-2h-7c-0.553 0-1 0.447-1 1v7h2v-4.584l7.544 7.544 1.413-1.416z" })
            );
        }
        function Split({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SplitSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Split.SVG = SplitSVG;
        return Split;
    })();
export const Spoon = /*#__PURE__*/ (() => {
        function SpoonSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.269 19.731c-1.841-1.841-4.084-3.584-6.459-5.428-2.194-1.703-4.453-3.459-6.391-5.313 0.628-0.981 0.75-2.088 0.347-3.247-0.319-0.922-0.959-1.869-1.906-2.816-1.319-1.319-2.891-2.278-4.422-2.7-1.563-0.434-2.9-0.237-3.672 0.534-0.775 0.775-0.972 2.112-0.541 3.678 0.422 1.531 1.381 3.1 2.7 4.422 0.944 0.944 1.891 1.584 2.816 1.906 0.447 0.156 0.888 0.231 1.316 0.231 0.681 0 1.334-0.197 1.938-0.581 1.856 1.941 3.616 4.206 5.322 6.403 1.841 2.369 3.578 4.609 5.416 6.45l0.003 0.003c0.487 0.484 1.128 0.728 1.766 0.728 0.641 0 1.281-0.244 1.769-0.731 0.972-0.981 0.972-2.566 0-3.541zM6.069 9.822c-0.778-0.269-1.597-0.831-2.434-1.669-1.2-1.2-2.069-2.613-2.444-3.981-0.328-1.191-0.222-2.2 0.281-2.703 0.309-0.309 0.813-0.469 1.428-0.469 0.384 0 0.816 0.063 1.275 0.188 1.366 0.378 2.781 1.247 3.981 2.444 0.837 0.837 1.397 1.656 1.669 2.434 0.391 1.125 0.144 2.109-0.75 3.003-0.625 0.625-1.287 0.931-2.013 0.931-0.319 0-0.65-0.059-0.994-0.178zM21.853 21.853c-0.194 0.194-0.513 0.194-0.709 0-1.403-1.403-2.775-3.091-4.191-4.9 1.809 1.419 3.497 2.791 4.9 4.194 0.197 0.194 0.194 0.513 0 0.706z" }),
_('path', { d: "M3.872 5.281l-0.269-0.422-0.844 0.537 0.269 0.422c0.366 0.575 0.806 1.125 1.312 1.628 0.959 0.959 1.978 1.553 2.659 1.553v-1c-0.288 0-1.081-0.391-1.95-1.259-0.456-0.453-0.85-0.944-1.178-1.459z" })
            );
        }
        function Spoon({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SpoonSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Spoon.SVG = SpoonSVG;
        return Spoon;
    })();
export const Spotlights = /*#__PURE__*/ (() => {
    function SpotlightsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.441 17.922c-0.181-0.237-0.4-0.456-0.656-0.656l-7.278-6.156 4.403-9.697c0.203-0.444 0.053-0.969-0.35-1.244-0.403-0.272-0.947-0.216-1.284 0.138l-6.938 7.275-8.691-7.344c-0.378-0.319-0.931-0.316-1.303 0.009s-0.453 0.872-0.188 1.291l6.372 10.047-6.687 7.013c-0.103 0.103-0.197 0.213-0.284 0.325-0.363 0.478-0.556 1.025-0.556 1.578s0.194 1.1 0.559 1.578c0.309 0.409 0.741 0.766 1.275 1.062 0.994 0.553 2.297 0.859 3.666 0.859s2.672-0.306 3.669-0.859c0.534-0.297 0.963-0.656 1.275-1.062 0.128-0.169 0.237-0.35 0.322-0.534v0l1.284-2.828 1.306 2.063c0.059 0.103 0.128 0.203 0.2 0.3 0.309 0.409 0.741 0.766 1.275 1.062 0.997 0.553 2.3 0.859 3.669 0.859s2.672-0.306 3.669-0.859c0.534-0.297 0.963-0.656 1.275-1.062 0.366-0.478 0.559-1.025 0.559-1.578s-0.197-1.1-0.563-1.578zM9.984 18.431c-0.234-0.209-0.509-0.4-0.816-0.572-0.997-0.553-2.3-0.859-3.669-0.859-0.128 0-0.256 0.003-0.381 0.009l3.513-3.684 2.141 3.375-0.788 1.731zM11.266 15.612l-1.922-3.031 2.834-2.975 1.313 1.109-2.225 4.897zM13.919 9.769l-1.050-0.888 2.775-2.913-1.725 3.8zM6.344 5.981l3.612 3.056-1.006 1.056-2.606-4.113zM5.5 22c-2.103 0-3.5-0.903-3.5-1.5 0-0.138 0.075-0.291 0.213-0.447v0l0.072-0.075c0.509-0.494 1.672-0.978 3.216-0.978 2.103 0 3.5 0.903 3.5 1.5 0 0.059-0.012 0.119-0.041 0.181l-0.016 0.038c-0.278 0.575-1.584 1.281-3.444 1.281zM14.647 13.003l3.553 3.003c-1.256 0.041-2.444 0.341-3.366 0.853-0.428 0.237-0.788 0.513-1.072 0.822l-0.722-1.137 1.606-3.541zM18.5 21c-1.709 0-2.953-0.597-3.359-1.141l-0.078-0.122c-0.044-0.081-0.066-0.162-0.066-0.237 0-0.597 1.397-1.5 3.5-1.5s3.5 0.903 3.5 1.5-1.394 1.5-3.497 1.5z" })
        );
    }
    function Spotlights({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SpotlightsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Spotlights.SVG = SpotlightsSVG;
    return Spotlights;
})();
export const SprayBug = /*#__PURE__*/ (() => {
        function SprayBugSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16.5 17h-0.531c-0.034-0.241-0.097-0.428-0.181-0.584l0.938-0.469c0.169-0.084 0.278-0.259 0.278-0.447v-1.5h-1v1.191l-0.978 0.487c-0.006-0.006-0.016-0.012-0.022-0.016v-0.162c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5v0.162c-0.006 0.006-0.016 0.012-0.022 0.016l-0.981-0.487v-1.191h-1v1.5c0 0.191 0.106 0.363 0.278 0.447l0.938 0.466c-0.084 0.156-0.147 0.344-0.181 0.584h-0.531c-0.131 0-0.259 0.053-0.353 0.147l-1.356 1.356 0.706 0.706 1.206-1.206h0.319c0.056 0.566 0.209 1.097 0.444 1.556l-0.575 2.306 0.969 0.241 0.391-1.563c0.372 0.303 0.8 0.459 1.247 0.459s0.875-0.156 1.247-0.456l0.391 1.563 0.969-0.241-0.575-2.309c0.237-0.459 0.387-0.991 0.444-1.556h0.319l1.206 1.206 0.706-0.706-1.353-1.353c-0.094-0.094-0.222-0.147-0.353-0.147zM13.5 20c-0.363 0-0.7-0.228-0.963-0.597l0.009-0.031-0.037-0.009c-0.312-0.462-0.509-1.131-0.509-1.863 0-0.344 0.025-0.513 0.113-0.637l0.016 0.009 0.038-0.075c0.063-0.066 0.147-0.125 0.259-0.206 0.119-0.084 0.253-0.181 0.406-0.312 0.109-0.094 0.172-0.231 0.172-0.378v-0.4c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v0.4c0 0.144 0.063 0.281 0.172 0.378 0.15 0.131 0.284 0.228 0.403 0.312 0.112 0.081 0.2 0.144 0.262 0.209l0.034 0.072 0.016-0.006c0.084 0.125 0.113 0.294 0.113 0.638 0 0.731-0.2 1.4-0.509 1.863l-0.037 0.009 0.009 0.031c-0.266 0.366-0.603 0.594-0.966 0.594z" }),
_('path', { d: "M14 11.019v-0.019c0-0.806-0.478-1.5-1.166-1.816 0.106-0.206 0.166-0.438 0.166-0.684 0-0.828-0.672-1.5-1.5-1.5h-1.5v-1h0.5c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5h-2c-0.131 0-0.259 0.053-0.353 0.147l-2 2c-0.094 0.094-0.147 0.222-0.147 0.353v2c0 0.275 0.225 0.5 0.5 0.5h0.5v1h-1.5c-0.828 0-1.5 0.672-1.5 1.5 0 0.247 0.059 0.478 0.166 0.684-0.687 0.316-1.166 1.009-1.166 1.816v11c0 1.103 0.897 2 2 2h8.5c3.584 0 6.5-2.916 6.5-6.5 0-3.416-2.65-6.225-6-6.481zM7 3.706l1.706-1.706h1.294v1h-1v1h1v1h-3v-1.294zM8 6h1v1h-1v-1zM5.5 8h6c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-6c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5zM5 11h7v0.175c-2.862 0.678-5 3.256-5 6.325 0 1.744 0.691 3.331 1.812 4.5h-3.813v-11zM13.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M13 4h-1v-1h1v1zM15 2h-1v1h1v-1zM15 4h-1v1h1v-1zM17 5h-1v1h1v-1zM17 3h-1v1h1v-1zM17 1h-1v1h1v-1zM19 0h-1v1h1v-1zM19 2h-1v1h1v-1zM19 4h-1v1h1v-1zM19 6h-1v1h1v-1zM20 0v1h1v-1h-1zM20 3h1v-1h-1v1zM20 5h1v-1h-1v1zM20 7h1v-1h-1v1z" })
            );
        }
        function SprayBug({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SprayBugSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SprayBug.SVG = SprayBugSVG;
        return SprayBug;
    })();
export const SprayCross = /*#__PURE__*/ (() => {
        function SprayCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 4h-1v-1h1v1zM15 2h-1v1h1v-1zM15 4h-1v1h1v-1zM17 5h-1v1h1v-1zM17 3h-1v1h1v-1zM17 1h-1v1h1v-1zM19 0h-1v1h1v-1zM19 2h-1v1h1v-1zM19 4h-1v1h1v-1zM19 6h-1v1h1v-1zM20 0v1h1v-1h-1zM20 3h1v-1h-1v1zM20 5h1v-1h-1v1zM20 7h1v-1h-1v1z" }),
_('path', { d: "M14 11.019v-0.019c0-0.806-0.478-1.5-1.166-1.816 0.106-0.206 0.166-0.438 0.166-0.684 0-0.828-0.672-1.5-1.5-1.5h-1.5v-1h0.5c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5h-2c-0.131 0-0.259 0.053-0.353 0.147l-2 2c-0.094 0.094-0.147 0.222-0.147 0.353v2c0 0.275 0.225 0.5 0.5 0.5h0.5v1h-1.5c-0.828 0-1.5 0.672-1.5 1.5 0 0.247 0.059 0.478 0.166 0.684-0.687 0.316-1.166 1.009-1.166 1.816v11c0 1.103 0.897 2 2 2h8.5c3.584 0 6.5-2.916 6.5-6.5 0-3.416-2.65-6.225-6-6.481zM7 3.706l1.706-1.706h1.294v1h-1v1h1v1h-3v-1.294zM8 6h1v1h-1v-1zM5.5 8h6c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-6c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5zM5 11h7v0.175c-2.862 0.678-5 3.256-5 6.325 0 1.744 0.691 3.331 1.812 4.5h-3.813v-11zM13.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M15.5 14.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function SprayCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SprayCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SprayCross.SVG = SprayCrossSVG;
        return SprayCross;
    })();
export const Spray = /*#__PURE__*/ (() => {
        function SpraySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12.834 9.184c0.106-0.206 0.166-0.438 0.166-0.684 0-0.828-0.672-1.5-1.5-1.5h-1.5v-1h0.5c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5h-2c-0.131 0-0.259 0.053-0.353 0.147l-2 2c-0.094 0.094-0.147 0.222-0.147 0.353v2c0 0.275 0.225 0.5 0.5 0.5h0.5v1h-1.5c-0.828 0-1.5 0.672-1.5 1.5 0 0.247 0.059 0.478 0.166 0.684-0.687 0.316-1.166 1.009-1.166 1.816v11c0 1.103 0.897 2 2 2h7c1.103 0 2-0.897 2-2v-11c0-0.806-0.478-1.5-1.166-1.816zM7 3.706l1.706-1.706h1.294v1h-1v1h1v1h-3v-1.294zM8 6h1v1h-1v-1zM5.5 8h6c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-6c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5zM12 22h-7l-0.003-11c0 0 0 0 0.003 0h5v7h1v-7h1v11z" }),
_('path', { d: "M13 4h-1v-1h1v1zM14 3h1v-1h-1v1zM14 5h1v-1h-1v1zM16 6h1v-1h-1v1zM16 4h1v-1h-1v1zM16 2h1v-1h-1v1zM18 1h1v-1h-1v1zM18 3h1v-1h-1v1zM18 5h1v-1h-1v1zM18 7h1v-1h-1v1zM20 0v1h1v-1h-1zM20 3h1v-1h-1v1zM20 5h1v-1h-1v1zM20 7h1v-1h-1v1z" })
            );
        }
        function Spray({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SpraySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Spray.SVG = SpraySVG;
        return Spray;
    })();
export const Spray2 = /*#__PURE__*/ (() => {
        function Spray2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12.228 5h1.272c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5h-9c-1.378 0-2.5 1.122-2.5 2.5 0 0.134 0.056 0.266 0.153 0.359s0.228 0.144 0.363 0.141c0.794-0.025 1.403 0.087 1.806 0.334 0.406 0.247 0.625 0.634 0.681 1.216 0.025 0.256 0.241 0.45 0.497 0.45h0.5v1h-0.5c-0.275 0-0.5 0.225-0.5 0.5v1.594c-0.497 0.159-0.919 0.506-1.166 0.984 0 0 0 0 0 0.003l-3.606 6.994c-0.3 0.581-0.297 1.272 0.009 1.853 0 0 0 0.003 0.003 0.003l1.597 3.006c0.347 0.656 1.025 1.062 1.766 1.062h6.797c0.741 0 1.419-0.406 1.769-1.062l1.597-3.006c0 0 0-0.003 0.003-0.003 0.306-0.581 0.309-1.272 0.009-1.853l-3.612-6.994c-0.25-0.478-0.669-0.828-1.166-0.984v-1.594c0-0.275-0.225-0.5-0.5-0.5h-0.5v-1h0.5c0.1 0 0.194-0.028 0.278-0.084l0.5-0.331c0.612 0.922 2.516 3.412 5.222 3.412 0.203 0 0.384-0.122 0.462-0.309s0.034-0.403-0.109-0.544c-1.338-1.341-2.222-3.178-2.625-4.147zM3.603 22l-1.441-2.709c1.544-0.678 3.047-0.025 4.638 0.672 0.844 0.369 1.716 0.747 2.613 0.931 0.366 0.075 0.716 0.113 1.059 0.113 0.159 0 0.319-0.009 0.475-0.025l-0.547 1.019h-6.797zM11.997 18.991c0 0 0 0.003 0 0.006l-0.441 0.828c-1.444 0.491-2.862-0.128-4.356-0.778-0.844-0.369-1.716-0.747-2.613-0.931-0.766-0.156-1.472-0.147-2.144 0.022l3.166-6.138h2.778l3.609 6.991zM8 10h-2v-1h2v1zM13 4h-1v-1h1v1zM8.35 6h-2.425c-0.159-0.672-0.525-1.181-1.084-1.522-0.459-0.278-1.038-0.434-1.756-0.472 0.203-0.584 0.762-1.006 1.416-1.006h6.5v1.231l-2.65 1.769zM10.109 6.028l1.144-0.762c0.316 0.778 0.956 2.178 1.934 3.478-1.537-0.6-2.662-2.097-3.078-2.716z" }),
_('path', { d: "M6.826 13.332l0.889-0.458 2.495 4.842-0.889 0.458-2.495-4.842z" }),
_('path', { d: "M15 3h1v1h-1v-1z" }),
_('path', { d: "M17 2h1v1h-1v-1z" }),
_('path', { d: "M17 4h1v1h-1v-1z" }),
_('path', { d: "M19 5h1v1h-1v-1z" }),
_('path', { d: "M19 3h1v1h-1v-1z" }),
_('path', { d: "M19 1h1v1h-1v-1z" }),
_('path', { d: "M21 0h1v1h-1v-1z" }),
_('path', { d: "M21 2h1v1h-1v-1z" }),
_('path', { d: "M21 4h1v1h-1v-1z" }),
_('path', { d: "M21 6h1v1h-1v-1z" }),
_('path', { d: "M23 0h1v1h-1v-1z" }),
_('path', { d: "M23 2h1v1h-1v-1z" }),
_('path', { d: "M23 4h1v1h-1v-1z" }),
_('path', { d: "M23 6h1v1h-1v-1z" })
            );
        }
        function Spray2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Spray2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Spray2.SVG = Spray2SVG;
        return Spray2;
    })();
export const Squash = /*#__PURE__*/ (() => {
        function SquashSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21 12h-4v-11.5c0-0.275-0.225-0.5-0.5-0.5h-9c-0.275 0-0.5 0.225-0.5 0.5v11.5h-4c-1.103 0-2 0.897-2 2v8c0 1.103 0.897 2 2 2h18c1.103 0 2-0.897 2-2v-8c0-1.103-0.897-2-2-2zM8 1h8v11h-8v-11zM21 22h-18v-8h18v8z" }),
_('path', { d: "M2.206 9.5l-0.5-0.5h0.794c1.378 0 2.5-1.122 2.5-2.5v-3.5h-1v3.5c0 0.828-0.672 1.5-1.5 1.5h-0.794l0.5-0.5-0.706-0.706-1.353 1.353c-0.194 0.194-0.194 0.513 0 0.706l1.353 1.353 0.706-0.706z" }),
_('path', { d: "M23.853 8.147l-1.353-1.353-0.706 0.706 0.5 0.5h-0.794c-0.828 0-1.5-0.672-1.5-1.5v-3.5h-1v3.5c0 1.378 1.122 2.5 2.5 2.5h0.794l-0.5 0.5 0.706 0.706 1.353-1.353c0.197-0.194 0.197-0.513 0-0.706z" })
            );
        }
        function Squash({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SquashSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Squash.SVG = SquashSVG;
        return Squash;
    })();
export const Stairs = /*#__PURE__*/ (() => {
    function StairsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.5 1h-3.5c-1.103 0-2 0.897-2 2v2h-2c-1.103 0-2 0.897-2 2v2h-2c-1.103 0-2 0.897-2 2v2h-2c-1.103 0-2 0.897-2 2v2h-2c-1.103 0-2 0.897-2 2v3.5c0 0.275 0.225 0.5 0.5 0.5h21c0.275 0 0.5-0.225 0.5-0.5v-21c0-0.275-0.225-0.5-0.5-0.5zM22 22h-19v-3h3c0.553 0 1-0.447 1-1v-3h3c0.553 0 1-0.447 1-1v-3h3c0.553 0 1-0.447 1-1v-3h3c0.553 0 1-0.447 1-1v-3h3v19z" })
        );
    }
    function Stairs({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StairsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Stairs.SVG = StairsSVG;
    return Stairs;
})();
export const Stamp = /*#__PURE__*/ (() => {
        function StampSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 4v-1c-1.103 0-2 0.897-2 2h1c0-0.55 0.45-1 1-1z" }),
_('path', { d: "M19.881 17.362c-0.488-0.288-1.153-0.537-1.981-0.744-0.856-0.216-1.863-0.378-2.956-0.481-0.053-0.316-0.147-0.55-0.275-0.862-0.072-0.172-0.153-0.369-0.247-0.634-0.422-1.203-0.703-3.053 0.122-5.337 1.469-0.872 2.453-2.475 2.453-4.3 0.003-2.759-2.241-5.003-4.997-5.003s-5 2.244-5 5c0 1.828 0.984 3.428 2.453 4.3 0.825 2.284 0.544 4.134 0.122 5.337-0.094 0.266-0.175 0.462-0.247 0.634-0.128 0.309-0.222 0.547-0.275 0.862-1.091 0.103-2.097 0.266-2.956 0.481-0.828 0.206-1.494 0.459-1.981 0.744-0.922 0.55-1.116 1.194-1.116 1.641v2c0 0.553 0.447 1 1 1 0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2 0.553 0 1-0.447 1-1v-2c0-0.447-0.194-1.091-1.119-1.638zM12 2c1.653 0 3 1.347 3 3s-1.347 3-3 3-3-1.347-3-3 1.347-3 3-3zM10.253 15.656c0.072-0.175 0.162-0.394 0.266-0.687 0.422-1.206 0.722-2.984 0.144-5.15 0.425 0.119 0.875 0.181 1.338 0.181s0.912-0.063 1.338-0.181c-0.578 2.166-0.278 3.944 0.144 5.15 0.103 0.294 0.194 0.513 0.266 0.687 0.063 0.153 0.116 0.275 0.153 0.4-0.616-0.038-1.253-0.056-1.9-0.056s-1.284 0.019-1.9 0.056c0.037-0.125 0.091-0.247 0.153-0.4zM5 19.172c0.2-0.153 0.803-0.466 2.109-0.734 1.366-0.281 3.1-0.438 4.891-0.438s3.528 0.156 4.891 0.438c1.306 0.269 1.909 0.581 2.109 0.734v0.828h-14v-0.828zM18 23h-12c-0.55 0-1-0.45-1-1h14c0 0.55-0.45 1-1 1z" })
            );
        }
        function Stamp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StampSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Stamp.SVG = StampSVG;
        return Stamp;
    })();
export const Standing = /*#__PURE__*/ (() => {
    function StandingSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16.484 12.894l1.531-1.287-5.25-6.25c-0.191-0.228-0.472-0.356-0.759-0.356 1.1-0.003 1.994-0.9 1.994-2 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 1.1 0.894 1.997 1.994 2-0.113 0-0.225 0.022-0.334 0.059-0.169 0.063-0.316 0.166-0.425 0.3l-5.25 6.247 1.531 1.287 3.484-4.15v5.094l-2.95 8.847 1.897 0.631 2.053-6.153 2.050 6.153 1.897-0.631-2.947-8.847v-5.094l3.484 4.15zM11 3c0-0.55 0.45-1 1-1s1 0.45 1 1-0.45 1-1 1c-0.55 0-1-0.45-1-1z" })
        );
    }
    function Standing({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StandingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Standing.SVG = StandingSVG;
    return Standing;
})();
export const StarEmpty = /*#__PURE__*/ (() => {
    function StarEmptySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.984 9.784c-0.044-0.181-0.188-0.322-0.366-0.366l-7.516-1.834-3.656-7.309c-0.084-0.169-0.256-0.275-0.447-0.275s-0.363 0.106-0.447 0.275l-3.653 7.309-7.519 1.838c-0.181 0.044-0.322 0.184-0.366 0.366-0.047 0.178 0.012 0.369 0.153 0.494l5.716 5.084-1.809 8.025c-0.044 0.191 0.028 0.391 0.184 0.509s0.366 0.134 0.541 0.044l7.2-3.875 7.2 3.872c0.075 0.041 0.156 0.059 0.237 0.059 0.106 0 0.213-0.034 0.303-0.103 0.156-0.119 0.228-0.316 0.184-0.509l-1.809-8.025 5.719-5.084c0.138-0.122 0.197-0.312 0.15-0.494zM17.231 14.813c-0.134 0.122-0.197 0.306-0.156 0.484l1.634 7.244-6.472-3.481c-0.075-0.041-0.156-0.059-0.237-0.059s-0.162 0.019-0.237 0.059l-6.472 3.481 1.634-7.244c0.041-0.178-0.019-0.363-0.156-0.484l-5.225-4.647 6.816-1.666c0.144-0.034 0.262-0.131 0.328-0.262l3.312-6.619 3.309 6.622c0.066 0.131 0.184 0.228 0.328 0.263l6.816 1.666-5.222 4.644z" })
        );
    }
    function StarEmpty({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StarEmptySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StarEmpty.SVG = StarEmptySVG;
    return StarEmpty;
})();
export const StarHalf = /*#__PURE__*/ (() => {
    function StarHalfSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.984 9.784c-0.044-0.181-0.188-0.322-0.366-0.366l-7.5-1.831-3.159-7.287c-0.081-0.181-0.259-0.3-0.459-0.3h-0.5c-0.391 0-0.756 0.231-0.919 0.603l-3.047 7.031-7.222 1.384c-0.381 0.072-0.684 0.356-0.781 0.731s0.031 0.772 0.328 1.019l5.519 4.597-1.847 7.391c-0.097 0.387 0.047 0.797 0.366 1.041 0.178 0.134 0.391 0.203 0.603 0.203 0.172 0 0.341-0.044 0.497-0.131l6.769-3.869h0.347l6.569 3.928c0.078 0.047 0.169 0.072 0.256 0.072 0.103 0 0.206-0.031 0.294-0.094 0.162-0.119 0.237-0.319 0.194-0.516l-1.809-8.025 5.719-5.084c0.138-0.125 0.197-0.316 0.15-0.497zM11 18.419l-4.463 2.55 1.431-5.725c0.094-0.372-0.034-0.766-0.331-1.009l-4.375-3.65 5.666-1.087c0.325-0.063 0.597-0.281 0.728-0.584l1.341-3.094v12.6zM17.231 14.813c-0.134 0.122-0.197 0.306-0.156 0.484l1.619 7.175-5.688-3.4c-0.003-0.003-0.006-0.003-0.009-0.006 0-0.022 0.003-0.044 0.003-0.066v-16.091l2.3 5.303c0.063 0.144 0.188 0.25 0.341 0.288l6.816 1.666-5.225 4.647z" })
        );
    }
    function StarHalf({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StarHalfSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StarHalf.SVG = StarHalfSVG;
    return StarHalf;
})();
export const Star = /*#__PURE__*/ (() => {
    function StarSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.969 9.75c-0.097-0.375-0.4-0.659-0.781-0.731l-7.222-1.384-3.047-7.031c-0.159-0.366-0.519-0.603-0.919-0.603s-0.759 0.237-0.919 0.603l-3.047 7.031-7.222 1.384c-0.381 0.072-0.684 0.356-0.781 0.731s0.031 0.772 0.328 1.019l5.519 4.597-1.847 7.391c-0.097 0.387 0.047 0.797 0.366 1.041 0.319 0.241 0.753 0.269 1.1 0.072l6.503-3.716 6.503 3.716c0.153 0.087 0.325 0.131 0.497 0.131 0.213 0 0.425-0.069 0.603-0.203 0.319-0.241 0.462-0.65 0.366-1.041l-1.847-7.391 5.519-4.597c0.297-0.247 0.425-0.644 0.328-1.019zM16.359 14.231c-0.294 0.247-0.422 0.638-0.331 1.009l1.434 5.728-4.966-2.838c-0.153-0.087-0.325-0.131-0.497-0.131s-0.344 0.044-0.497 0.131l-4.966 2.838 1.431-5.725c0.094-0.372-0.034-0.766-0.331-1.009l-4.375-3.65 5.666-1.087c0.325-0.063 0.597-0.281 0.728-0.584l2.344-5.397 2.341 5.4c0.131 0.303 0.403 0.522 0.728 0.584l5.666 1.087-4.375 3.644z" })
        );
    }
    function Star({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Star.SVG = StarSVG;
    return Star;
})();
export const Steak = /*#__PURE__*/ (() => {
        function SteakSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12.784 14.459c0.466 0.35 1.075 0.541 1.716 0.541s1.25-0.191 1.716-0.541c0.5-0.375 0.784-0.906 0.784-1.459s-0.288-1.088-0.784-1.459c-0.466-0.35-1.075-0.541-1.716-0.541s-1.25 0.191-1.716 0.541c-0.5 0.375-0.784 0.906-0.784 1.459s0.288 1.088 0.784 1.459zM14.5 12c0.813 0 1.5 0.459 1.5 1s-0.687 1-1.5 1-1.5-0.459-1.5-1 0.687-1 1.5-1z" }),
_('path', { d: "M13.278 18c1.906 0 3.828-0.519 5.562-1.5 0.791-0.45 1.375-0.987 1.734-1.603 0.375-0.641 0.503-1.344 0.381-2.094-0.128-0.778-0.541-1.553-1.156-2.175-0.656-0.666-1.509-1.131-2.469-1.347-3.231-0.725-5.094-2.597-6.591-4.103-1.425-1.431-2.231-2.178-3.55-2.178-0.822 0-1.559 0.237-2.194 0.706-0.472 0.35-0.875 0.819-1.203 1.397-1.113 1.984-1.259 5.337 0.928 8.366 2.106 2.922 5.147 4.531 8.556 4.531zM4.666 5.594c0.597-1.059 1.444-1.594 2.525-1.594 0.847 0 1.366 0.4 2.844 1.884 1.587 1.597 3.563 3.584 7.078 4.372 0.769 0.175 1.453 0.544 1.975 1.072 0.472 0.478 0.784 1.059 0.881 1.638 0.175 1.056-0.372 1.953-1.622 2.666-1.584 0.894-3.337 1.369-5.069 1.369-3.078 0-5.831-1.462-7.744-4.119-1.931-2.666-1.825-5.581-0.869-7.287z" }),
_('path', { d: "M24 13.338v0c0-0.306-0.022-0.616-0.069-0.925-0.441-2.909-2.831-5.341-5.953-6.050-2.278-0.519-3.631-1.9-4.944-3.237-1.506-1.537-3.063-3.125-5.778-3.125-1.375 0-2.631 0.369-3.741 1.097-1.022 0.672-1.881 1.647-2.487 2.822-0.697 1.35-1.047 2.906-1.028 4.541v2.878c0 0.328 0.016 0.663 0.044 0.994 0.184 2.053 0.944 4.069 2.197 5.828 1.362 1.916 3.050 3.397 5.019 4.403 1.863 0.953 3.881 1.437 6.003 1.437 2.45 0 4.903-0.669 7.094-1.931 1.372-0.794 2.381-1.809 2.997-3.019 0.431-0.847 0.647-1.759 0.65-2.709v0-3.003zM2.806 4.834c0.944-1.828 2.525-2.834 4.45-2.834 1.878 0 2.969 1.113 4.35 2.525 1.444 1.472 3.078 3.141 5.928 3.788 2.325 0.528 4.1 2.297 4.419 4.4 0.281 1.853-0.644 3.497-2.597 4.625-5.472 3.156-11.841 1.784-15.484-3.337-2.041-2.866-2.459-6.462-1.066-9.166zM19.856 21.203c-2.037 1.175-4.319 1.797-6.594 1.797-1.959 0-3.825-0.447-5.547-1.328-1.822-0.931-3.391-2.309-4.659-4.094-0.897-1.259-1.519-2.663-1.828-4.109 0.291 0.584 0.628 1.15 1.013 1.691 1.091 1.531 2.4 2.794 3.894 3.756 1.425 0.916 2.988 1.541 4.647 1.853 0.819 0.156 1.647 0.231 2.478 0.231 2.441 0 4.891-0.659 7.097-1.931 1.131-0.653 2.016-1.456 2.634-2.397-0.044 0.672-0.222 1.319-0.528 1.925-0.528 1.034-1.403 1.913-2.606 2.606z" })
            );
        }
        function Steak({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SteakSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Steak.SVG = SteakSVG;
        return Steak;
    })();
export const Stethoscope = /*#__PURE__*/ (() => {
    function StethoscopeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.5 5h-1c-0.275 0-0.5 0.225-0.5 0.5v0.691l-1 0.5v-0.691h-1v1c-2.206 0-4 1.794-4 4.003l0.012 6.997c0 2.291-2.375 4-4.5 4s-4.5-1.709-4.5-4c0-0.056-0.003-0.109-0.012-0.162v-2.838h1v-1.397c0.872-0.363 1.653-0.969 2.284-1.788 1.122-1.453 1.716-3.462 1.716-5.816v-2.5c0-1.306-1.006-2.381-2.284-2.491l-0.863-0.862c-0.094-0.094-0.222-0.147-0.353-0.147h-1c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h1c0.131 0 0.259-0.053 0.353-0.147l0.841-0.841c0.738 0.097 1.306 0.725 1.306 1.488v2.5h-0.016c0 2.206-2.238 4-4.984 4s-4.984-1.794-4.984-4h-0.016v-2.5c0-0.762 0.569-1.391 1.306-1.488l0.841 0.841c0.094 0.094 0.222 0.147 0.353 0.147h1c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.275-0.225-0.5-0.5-0.5h-1c-0.131 0-0.259 0.053-0.353 0.147l-0.862 0.862c-1.278 0.109-2.284 1.184-2.284 2.491v2.5c0 2.353 0.594 4.362 1.716 5.816 0.634 0.819 1.413 1.425 2.284 1.788v1.397h1v3c0 0.063 0.006 0.122 0.016 0.181 0.025 0.762 0.219 1.506 0.575 2.212 0.353 0.706 0.85 1.341 1.478 1.894 1.238 1.087 2.859 1.713 4.444 1.713 1.587 0 3.206-0.625 4.447-1.713 0.628-0.55 1.125-1.188 1.478-1.894 0.384-0.762 0.578-1.569 0.578-2.397l-0.016-6.997c0-1.103 0.897-2 2-2v1h1v-0.691l1 0.5v0.691c0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5zM8.294 2h-0.294v-1h0.294l0.5 0.5-0.5 0.5zM3.706 1h0.294v1h-0.294l-0.5-0.5 0.5-0.5zM2.506 11.206c-0.419-0.544-0.756-1.181-1.003-1.9 0.097 0.091 0.197 0.178 0.3 0.266 1.125 0.922 2.616 1.431 4.194 1.431s3.069-0.509 4.194-1.431c0.103-0.084 0.206-0.175 0.3-0.266-0.247 0.719-0.581 1.356-1.003 1.9-0.894 1.156-2.134 1.794-3.494 1.794s-2.594-0.638-3.488-1.794zM23 9.5c0-0.191-0.106-0.363-0.275-0.447l-1.725-0.862v-0.381l1.725-0.862c0.169-0.084 0.275-0.259 0.275-0.447v3z" })
        );
    }
    function Stethoscope({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StethoscopeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Stethoscope.SVG = StethoscopeSVG;
    return Stethoscope;
})();
export const Sticker = /*#__PURE__*/ (() => {
        function StickerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21 1h-18c-1.103 0-2 0.897-2 2v18c0 1.103 0.897 2 2 2h8c0.288 0 0.55-0.122 0.731-0.319l10.95-10.95c0.197-0.181 0.319-0.444 0.319-0.731v-8c0-1.103-0.897-2-2-2zM10 12v9h-7v-18h18v7h-9c-1.103 0-2 0.897-2 2zM21 12l-9 9v-9h9z" }),
_('path', { d: "M14 22h2v1h-2v-1z" }),
_('path', { d: "M22 14h1v2h-1v-2z" }),
_('path', { d: "M22 21c0 0.55-0.45 1-1 1h-1v1h1c1.103 0 2-0.897 2-2v-1h-1v1z" }),
_('path', { d: "M17 22h2v1h-2v-1z" }),
_('path', { d: "M22 17h1v2h-1v-2z" })
            );
        }
        function Sticker({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StickerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Sticker.SVG = StickerSVG;
        return Sticker;
    })();
export const StopCircle = /*#__PURE__*/ (() => {
        function StopCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M15.5 8h-7c-0.275 0-0.5 0.225-0.5 0.5v7c0 0.275 0.225 0.5 0.5 0.5h7c0.275 0 0.5-0.225 0.5-0.5v-7c0-0.275-0.225-0.5-0.5-0.5zM15 15h-6v-6h6v6z" })
            );
        }
        function StopCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StopCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        StopCircle.SVG = StopCircleSVG;
        return StopCircle;
    })();
export const StopSquare = /*#__PURE__*/ (() => {
        function StopSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M8.5 16h7c0.275 0 0.5-0.225 0.5-0.5v-7c0-0.275-0.225-0.5-0.5-0.5h-7c-0.275 0-0.5 0.225-0.5 0.5v7c0 0.275 0.225 0.5 0.5 0.5zM9 9h6v6h-6v-6z" })
            );
        }
        function StopSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StopSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        StopSquare.SVG = StopSquareSVG;
        return StopSquare;
    })();
export const Stop = /*#__PURE__*/ (() => {
    function StopSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21 2h-18c-0.553 0-1 0.447-1 1v18c0 0.553 0.447 1 1 1h18c0.553 0 1-0.447 1-1v-18c0-0.553-0.447-1-1-1zM20 20h-16v-16h16v16z" })
        );
    }
    function Stop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StopSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Stop.SVG = StopSVG;
    return Stop;
})();
export const Stop2 = /*#__PURE__*/ (() => {
        function Stop2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.706 6.738l-6.444-6.444c-0.188-0.188-0.441-0.294-0.706-0.294h-9.113c-0.266 0-0.519 0.106-0.706 0.294l-6.444 6.444c-0.188 0.188-0.294 0.441-0.294 0.706v9.112c0 0.266 0.106 0.519 0.294 0.706l6.444 6.444c0.188 0.188 0.441 0.294 0.706 0.294h9.113c0.266 0 0.519-0.106 0.706-0.294l6.444-6.444c0.188-0.188 0.294-0.441 0.294-0.706v-9.112c0-0.266-0.106-0.519-0.294-0.706zM22 16.141l-5.859 5.859h-8.281l-5.859-5.859v-8.281l5.859-5.859h8.284l5.856 5.859v8.281z" }),
_('path', { d: "M16 7.522c0-0.409-0.169-0.806-0.462-1.094-0.291-0.284-0.672-0.438-1.072-0.428-0.181 0.003-0.356 0.041-0.522 0.103-0.172-0.634-0.753-1.103-1.444-1.103s-1.275 0.469-1.447 1.106c-0.172-0.069-0.356-0.106-0.553-0.106-0.828 0-1.5 0.672-1.5 1.5v0.584c-0.15-0.053-0.306-0.081-0.469-0.084-0.4-0.009-0.781 0.144-1.072 0.428-0.294 0.288-0.462 0.684-0.462 1.094v3.478c0 1.769 0.316 3.259 0.909 4.309 0.619 1.091 1.538 1.691 2.591 1.691h3.331c1.216 0 2.319-0.669 2.881-1.747l2.109-4.044c0.003-0.006 0.006-0.009 0.009-0.016 0.125-0.241 0.181-0.509 0.166-0.781-0.044-0.75-0.641-1.356-1.391-1.406-0.509-0.034-1 0.188-1.306 0.597l-0.297 0.397v-4.478zM17.1 12.2c0.103-0.138 0.266-0.209 0.438-0.2 0.244 0.016 0.447 0.222 0.462 0.469 0.006 0.087-0.012 0.172-0.050 0.25-0.003 0.003-0.003 0.006-0.006 0.009l-2.116 4.059c-0.391 0.75-1.153 1.212-1.997 1.212h-3.331c-0.869 0-1.416-0.644-1.722-1.184-0.509-0.9-0.778-2.219-0.778-3.816v-3.478c0-0.141 0.059-0.278 0.159-0.381 0.097-0.094 0.222-0.147 0.35-0.144 0.275 0.006 0.488 0.225 0.488 0.5v3.5h1v-5.497c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v4.5h1v-5.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v5.5h1v-4.5c0-0.275 0.216-0.494 0.487-0.5 0.131-0.003 0.253 0.047 0.35 0.144 0.103 0.1 0.159 0.237 0.159 0.381v5.975c0 0.216 0.138 0.406 0.341 0.475s0.428-0.003 0.559-0.175l1.206-1.6z" })
            );
        }
        function Stop2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Stop2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Stop2.SVG = Stop2SVG;
        return Stop2;
    })();
export const StopwatchCross = /*#__PURE__*/ (() => {
        function StopwatchCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.922 12.741c-0.034-0.278-0.081-0.556-0.144-0.844h-0.003c-0.263-1.219-0.753-2.378-1.437-3.413 0.025-0.022 0.050-0.047 0.075-0.072 0.781-0.781 0.781-2.050 0-2.828-0.375-0.375-0.878-0.584-1.413-0.584s-1.038 0.209-1.416 0.584c-0.025 0.025-0.047 0.047-0.069 0.072-0.65-0.431-1.344-0.781-2.078-1.050-0.787-0.288-1.603-0.475-2.438-0.556v-1.050h0.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-3c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h0.5v1.050c-2.294 0.225-4.422 1.228-6.072 2.878-1.887 1.887-2.928 4.4-2.928 7.072s1.041 5.184 2.928 7.072c1.887 1.887 4.4 2.928 7.072 2.928 0.706 0 1.413-0.075 2.106-0.225v0.003c0.322-0.072 0.641-0.156 0.95-0.256 0.756 0.309 1.581 0.478 2.444 0.478 3.584 0 6.5-2.916 6.5-6.5 0-1.878-0.8-3.572-2.078-4.759zM9 1.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-3c-0.275 0-0.5-0.225-0.5-0.5zM18 6c0.266 0 0.519 0.103 0.706 0.294 0.378 0.378 0.391 0.987 0.034 1.378-0.413-0.503-0.872-0.969-1.378-1.387-0.009-0.009-0.022-0.019-0.031-0.025 0.181-0.169 0.419-0.259 0.669-0.259zM3 14c0-4.413 3.588-8 8-8 3.412 0 6.428 2.184 7.541 5.328-0.644-0.213-1.328-0.328-2.041-0.328-1.406 0-2.709 0.447-3.772 1.209l-0.744-4.381v-0.009c-0.087-0.475-0.503-0.822-0.984-0.822s-0.894 0.341-0.981 0.813l-0.987 5.825c-0.022 0.125-0.031 0.247-0.031 0.366 0 0.822 0.494 1.534 1.216 1.841-0.141 0.531-0.216 1.087-0.216 1.659 0 1.725 0.675 3.297 1.778 4.463-0.259 0.025-0.519 0.037-0.778 0.037-4.413 0-8-3.588-8-8zM10.547 14.891c-0.328-0.166-0.547-0.503-0.547-0.891 0-0.063 0.006-0.128 0.019-0.197l0.978-5.803c0 0 0 0 0 0.003l0.844 4.969c-0.537 0.553-0.978 1.203-1.294 1.919zM16.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18.5 14.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function StopwatchCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StopwatchCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        StopwatchCross.SVG = StopwatchCrossSVG;
        return StopwatchCross;
    })();
export const StopwatchRunning = /*#__PURE__*/ (() => {
        function StopwatchRunningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.741 8.034l1.3-1.672-1.578-1.228-1.209 1.553c-1.253-0.903-2.709-1.466-4.253-1.634v-1.053h0.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-3c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h0.5v1.053c-2.025 0.222-3.903 1.119-5.362 2.581-1.7 1.7-2.637 3.963-2.637 6.366s0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363 0-2.222-0.8-4.319-2.259-5.966zM13 2.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-3c-0.275 0-0.5-0.225-0.5-0.5zM15 21c-3.859 0-7-3.141-7-7s3.141-7 7-7c3.859 0 7 3.141 7 7s-3.141 7-7 7z" }),
_('path', { d: "M0 12h5v1h-5v-1z" }),
_('path', { d: "M0 15h5v1h-5v-1z" }),
_('path', { d: "M1 9h5v1h-5v-1z" }),
_('path', { d: "M3 6h5v1h-5v-1z" }),
_('path', { d: "M1 18h5v1h-5v-1z" }),
_('path', { d: "M3 21h5v1h-5v-1z" }),
_('path', { d: "M16.953 13.572l-0.972-4.772c0 0 0 0 0 0-0.094-0.462-0.506-0.8-0.978-0.8s-0.884 0.338-0.981 0.8l-0.981 4.797c-0.028 0.128-0.044 0.259-0.044 0.403 0 1.103 0.897 2 2 2s2-0.897 2-2c0-0.125-0.012-0.259-0.041-0.397 0-0.012 0-0.022-0.003-0.031zM15 15c-0.55 0-1-0.45-1-1 0-0.072 0.006-0.134 0.019-0.191 0-0.003 0-0.006 0.003-0.009l0.981-4.794 0.978 4.794c0 0.006 0.003 0.009 0.003 0.016 0.012 0.066 0.019 0.128 0.019 0.184-0.003 0.55-0.453 1-1.003 1z" })
            );
        }
        function StopwatchRunning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StopwatchRunningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        StopwatchRunning.SVG = StopwatchRunningSVG;
        return StopwatchRunning;
    })();
export const Stopwatch = /*#__PURE__*/ (() => {
        function StopwatchSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.344 8.481c0.025-0.022 0.047-0.044 0.072-0.069 0.781-0.781 0.781-2.050 0-2.828-0.378-0.375-0.881-0.584-1.416-0.584s-1.038 0.209-1.416 0.584c-0.022 0.022-0.047 0.047-0.069 0.072-1.35-0.897-2.891-1.447-4.519-1.606v-1.050h0.5c0.828 0 1.5-0.672 1.5-1.5s-0.669-1.5-1.497-1.5h-3c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h0.5v1.050c-2.294 0.225-4.419 1.228-6.072 2.881-1.887 1.887-2.928 4.397-2.928 7.069s1.041 5.181 2.928 7.072c1.891 1.887 4.4 2.928 7.072 2.928s5.181-1.041 7.072-2.928c1.887-1.891 2.928-4.4 2.928-7.072 0-1.994-0.578-3.897-1.656-5.519zM10 1.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-3c-0.275 0-0.5-0.225-0.5-0.5zM19 6c0.266 0 0.519 0.103 0.706 0.294 0.378 0.378 0.391 0.984 0.034 1.378-0.209-0.256-0.434-0.503-0.672-0.741s-0.484-0.462-0.741-0.672c0.188-0.169 0.422-0.259 0.672-0.259zM12 22c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M13.969 13.634l-0.984-5.806v-0.009c-0.087-0.475-0.503-0.822-0.984-0.822s-0.894 0.341-0.981 0.813l-0.987 5.825c-0.022 0.125-0.031 0.247-0.031 0.366 0 1.103 0.897 2 2 2s2-0.897 2-2c0-0.116-0.012-0.237-0.031-0.366v0zM12 15c-0.55 0-1-0.45-1-1 0-0.063 0.006-0.128 0.019-0.197l0.978-5.803c0 0 0 0 0 0.003l0.981 5.787h-0.003c0.016 0.075 0.022 0.147 0.022 0.209 0.003 0.55-0.447 1-0.997 1z" })
            );
        }
        function Stopwatch({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StopwatchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Stopwatch.SVG = StopwatchSVG;
        return Stopwatch;
    })();
export const Store24 = /*#__PURE__*/ (() => {
        function Store24SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 11c0-0.216-0.072-0.428-0.2-0.6l-0.594-0.791c0.506-0.925 0.794-1.984 0.794-3.109 0-3.584-2.916-6.5-6.5-6.5-2.7 0-5.019 1.653-6 4h-6c-0.316 0-0.612 0.147-0.8 0.4l-4.5 6c-0.131 0.172-0.2 0.384-0.2 0.6 0 1.103 0.897 2 2 2v9h-2v2h24v-2h-2v-9c1.103 0 2-0.897 2-2zM17.5 1c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM6 6h5.019c-0.012 0.166-0.019 0.331-0.019 0.5 0 1.287 0.375 2.491 1.025 3.5h-9.025l3-4zM4 11c0 1.103 0.897 2 2 2s2-0.897 2-2c0 1.103 0.897 2 2 2s2-0.897 2-2c0 0.738 0.403 1.384 1 1.731v9.269h-9v-11zM14 22v-9c0.444 0 0.872-0.147 1.219-0.413 0.709 0.266 1.478 0.413 2.281 0.413 0.884 0 1.731-0.178 2.5-0.5v9.5h-6z" }),
_('path', { d: "M16 17c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM16 18c0 0 0 0 0 0v0z" }),
_('path', { d: "M5.793 18.5l4.707-4.707 0.707 0.707-4.707 4.707-0.707-0.707z" }),
_('path', { d: "M7.792 19.501l2.707-2.707 0.707 0.707-2.707 2.707-0.707-0.707z" }),
_('path', { d: "M18.5 8h1.5v1h1v-3h-1v1h-0.806l0.938-2.816-0.95-0.316-1.159 3.475c-0.050 0.153-0.025 0.319 0.069 0.45 0.097 0.128 0.25 0.206 0.409 0.206z" }),
_('path', { d: "M15.103 6.819c-0.491 0.369-1.103 0.825-1.103 1.681 0 0.275 0.225 0.5 0.5 0.5h2.5v-1h-1.766c0.116-0.116 0.272-0.234 0.466-0.381 0.55-0.412 1.3-0.975 1.3-2.119 0-0.45-0.172-0.85-0.481-1.125-0.272-0.244-0.634-0.378-1.019-0.378s-0.747 0.134-1.019 0.378c-0.309 0.275-0.481 0.675-0.481 1.125v0.5h1v-0.5c0-0.478 0.416-0.5 0.5-0.5 0.138 0 0.266 0.044 0.356 0.125 0.097 0.084 0.144 0.213 0.144 0.378 0 0.609-0.341 0.897-0.897 1.316z" })
            );
        }
        function Store24({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Store24SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Store24.SVG = Store24SVG;
        return Store24;
    })();
export const Store = /*#__PURE__*/ (() => {
        function StoreSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 11c1.103 0 2-0.897 2-2 0-0.216-0.069-0.428-0.2-0.6l-4.5-6c-0.188-0.253-0.484-0.4-0.8-0.4h-13c-0.316 0-0.612 0.147-0.8 0.4l-4.5 6c-0.131 0.172-0.2 0.384-0.2 0.6 0 1.103 0.897 2 2 2v9h-2v2h24v-2h-2v-9zM16 9c0 1.103 0.897 2 2 2s2-0.897 2-2v11h-6v-9c1.103 0 2-0.897 2-2zM6 4h12l3 4h-18l3-4zM4 9c0 1.103 0.897 2 2 2s2-0.897 2-2c0 1.103 0.897 2 2 2s2-0.897 2-2c0 0.738 0.403 1.384 1 1.731v9.269h-9v-11z" }),
_('path', { d: "M16 17c0.55 0 1-0.45 1-1s-0.45-1-1-1-1 0.45-1 1 0.45 1 1 1zM16 16v0c0 0 0 0 0 0z" }),
_('path', { d: "M5.793 16.5l4.707-4.707 0.707 0.707-4.707 4.707-0.707-0.707z" }),
_('path', { d: "M7.792 17.501l2.707-2.707 0.707 0.707-2.707 2.707-0.707-0.707z" })
            );
        }
        function Store({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StoreSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Store.SVG = StoreSVG;
        return Store;
    })();
export const StreamCheck = /*#__PURE__*/ (() => {
        function StreamCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1.5 21c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM1.5 23c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M1.5 18h-0.5v1h0.5c1.931 0 3.5 1.569 3.5 3.5v0.5h1v-0.5c0-2.481-2.019-4.5-4.5-4.5z" }),
_('path', { d: "M1.5 15h-0.5v1h0.5c3.584 0 6.5 2.916 6.5 6.5v0.5h1v-0.5c0-2.003-0.781-3.888-2.197-5.303s-3.3-2.197-5.303-2.197z" }),
_('path', { d: "M8.925 15.075c-0.966-0.966-2.088-1.722-3.338-2.25-1.297-0.547-2.672-0.825-4.088-0.825h-0.5v1h0.5c5.238 0 9.5 4.263 9.5 9.5v0.5h1v-0.5c0-1.416-0.278-2.791-0.825-4.087-0.528-1.25-1.287-2.372-2.25-3.338z" }),
_('path', { d: "M17.5 0c-2.7 0-5.019 1.653-6 4h-9.5c-1.103 0-2 0.897-2 2v5h2v-5h9.019c-0.012 0.166-0.019 0.331-0.019 0.5s0.006 0.334 0.019 0.5h-7.519c-0.275 0-0.5 0.225-0.5 0.5v3.5h1v-3h7.175c0.678 2.862 3.256 5 6.325 5 0.884 0 1.731-0.178 2.5-0.5v7.5h-7v1h7.5c0.275 0 0.5-0.225 0.5-0.5v-8.525c0.359-0.231 0.694-0.494 1-0.787v10.812h-9v2h9c1.103 0 2-0.897 2-2v-15.5c0-3.584-2.916-6.5-6.5-6.5zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16.5 7.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4z" })
            );
        }
        function StreamCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StreamCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        StreamCheck.SVG = StreamCheckSVG;
        return StreamCheck;
    })();
export const StreamCross = /*#__PURE__*/ (() => {
        function StreamCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1.5 21c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM1.5 23c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M1.5 18h-0.5v1h0.5c1.931 0 3.5 1.569 3.5 3.5v0.5h1v-0.5c0-2.481-2.019-4.5-4.5-4.5z" }),
_('path', { d: "M1.5 15h-0.5v1h0.5c3.584 0 6.5 2.916 6.5 6.5v0.5h1v-0.5c0-2.003-0.781-3.888-2.197-5.303s-3.3-2.197-5.303-2.197z" }),
_('path', { d: "M8.925 15.075c-0.966-0.966-2.088-1.722-3.338-2.25-1.297-0.547-2.672-0.825-4.088-0.825h-0.5v1h0.5c5.238 0 9.5 4.263 9.5 9.5v0.5h1v-0.5c0-1.416-0.278-2.791-0.825-4.087-0.528-1.25-1.287-2.372-2.25-3.338z" }),
_('path', { d: "M17.5 0c-2.7 0-5.019 1.653-6 4h-9.5c-1.103 0-2 0.897-2 2v5h2v-5h9.019c-0.012 0.166-0.019 0.331-0.019 0.5s0.006 0.334 0.019 0.5h-7.519c-0.275 0-0.5 0.225-0.5 0.5v3.5h1v-3h7.175c0.678 2.862 3.256 5 6.325 5 0.884 0 1.731-0.178 2.5-0.5v7.5h-7v1h7.5c0.275 0 0.5-0.225 0.5-0.5v-8.525c0.359-0.231 0.694-0.494 1-0.787v10.812h-9v2h9c1.103 0 2-0.897 2-2v-15.5c0-3.584-2.916-6.5-6.5-6.5zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 3.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function StreamCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StreamCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        StreamCross.SVG = StreamCrossSVG;
        return StreamCross;
    })();
export const StreamWarning = /*#__PURE__*/ (() => {
        function StreamWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1.5 21c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM1.5 23c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M1.5 18h-0.5v1h0.5c1.931 0 3.5 1.569 3.5 3.5v0.5h1v-0.5c0-2.481-2.019-4.5-4.5-4.5z" }),
_('path', { d: "M1.5 15h-0.5v1h0.5c3.584 0 6.5 2.916 6.5 6.5v0.5h1v-0.5c0-2.003-0.781-3.888-2.197-5.303s-3.3-2.197-5.303-2.197z" }),
_('path', { d: "M8.925 15.075c-0.966-0.966-2.088-1.722-3.338-2.25-1.297-0.547-2.672-0.825-4.088-0.825h-0.5v1h0.5c5.238 0 9.5 4.263 9.5 9.5v0.5h1v-0.5c0-1.416-0.278-2.791-0.825-4.087-0.528-1.25-1.287-2.372-2.25-3.338z" }),
_('path', { d: "M18 8h1v1h-1v-1z" }),
_('path', { d: "M18 3h1v4h-1v-4z" }),
_('path', { d: "M23.841 8.828l-4-7.997c-0.25-0.506-0.775-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-1.584 3.172h-13.575c-1.103 0-2 0.897-2 2v5h2v-5h12.575l-0.5 1h-10.575c-0.275 0-0.5 0.225-0.5 0.5v3.5h1v-3h9.575l-0.413 0.828c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h5.5v9h-7.003v1h7.5c0.275 0 0.5-0.225 0.5-0.5v-9.5h1v11h-9v2h9c1.103 0 2-0.897 2-2v-12.5c0-0.234-0.056-0.466-0.159-0.672zM14 9.5c0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5h-8c-0.275 0-0.5-0.225-0.5-0.5z" })
            );
        }
        function StreamWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StreamWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        StreamWarning.SVG = StreamWarningSVG;
        return StreamWarning;
    })();
export const Stream = /*#__PURE__*/ (() => {
        function StreamSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 2h-20c-1.103 0-2 0.897-2 2v5h2v-5h20v16h-9v2h9c1.103 0 2-0.897 2-2v-16c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M1.5 19c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM1.5 21c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M1.5 16h-0.5v1h0.5c1.931 0 3.5 1.569 3.5 3.5v0.5h1v-0.5c0-2.481-2.019-4.5-4.5-4.5z" }),
_('path', { d: "M1.5 13h-0.5v1h0.5c3.584 0 6.5 2.916 6.5 6.5v0.5h1v-0.5c0-2.003-0.781-3.888-2.197-5.303s-3.3-2.197-5.303-2.197z" }),
_('path', { d: "M1.5 10h-0.5v1h0.5c5.238 0 9.5 4.263 9.5 9.5v0.5h1v-0.5c0-2.803-1.094-5.441-3.075-7.425s-4.622-3.075-7.425-3.075z" }),
_('path', { d: "M13 18v1h7.5c0.275 0 0.5-0.225 0.5-0.5v-13c0-0.275-0.225-0.5-0.5-0.5h-17c-0.275 0-0.5 0.225-0.5 0.5v3.5h1v-3h16v12h-7z" })
            );
        }
        function Stream({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StreamSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Stream.SVG = StreamSVG;
        return Stream;
    })();
export const Strikethrough = /*#__PURE__*/ (() => {
    function StrikethroughSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 12h-11v-8h8v-2h-18v2h8v8h-11v1h11v9h2v-9h11z" })
        );
    }
    function Strikethrough({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StrikethroughSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Strikethrough.SVG = StrikethroughSVG;
    return Strikethrough;
})();
export const Stroller = /*#__PURE__*/ (() => {
        function StrollerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8.5 17c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.122-2.5-2.5-2.5zM8.5 21c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" }),
_('path', { d: "M20 21.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M17 18c1.231 0 2.328-0.25 3.266-0.744 0.894-0.469 1.644-1.159 2.228-2.053 1-1.528 1.506-3.616 1.506-6.206 0-2.403-0.938-4.666-2.637-6.363-1.697-1.697-3.959-2.634-6.363-2.634-0.553 0-1 0.447-1 1v6.269c-0.303 0.175-0.556 0.428-0.731 0.731h-7.35c-0.056-0.412-0.153-0.909-0.322-1.409-0.244-0.728-0.581-1.313-1.012-1.744-0.466-0.466-1.022-0.741-1.666-0.822-0.194-0.594-0.756-1.025-1.419-1.025-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.637 0 1.184-0.4 1.4-0.963 1.359 0.266 1.838 1.878 2.006 2.963h-1.906c-0.553 0-1 0.447-1 1 0 3.641 1.012 6.297 2.941 7.75-0.588 0.759-0.941 1.716-0.941 2.75 0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5c0-0.525-0.091-1.031-0.256-1.5h2.256v2c0 1.103 0.897 2 2 2h0.050c0.231 1.141 1.244 2 2.45 2 1.378 0 2.5-1.122 2.5-2.5s-1.122-2.5-2.5-2.5c-1.206 0-2.219 0.859-2.45 2h-0.050c-0.55 0-1-0.45-1-1v-2h1zM1.5 5c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5zM19.5 20c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM15 8c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1zM4.031 10h9.237c0.347 0.597 0.994 1 1.731 1 1.103 0 2-0.897 2-2 0-0.738-0.403-1.384-1-1.731v-5.197c3.387 0.487 6 3.406 6 6.928 0 2.163-0.409 3.931-1.178 5.109-0.834 1.272-2.084 1.891-3.822 1.891h-5.675c-0.772-0.625-1.756-1-2.825-1-0.691 0-1.344 0.156-1.928 0.434-1.825-1.025-2.412-3.353-2.541-5.434zM8.5 23c-1.931 0-3.5-1.569-3.5-3.5s1.569-3.5 3.5-3.5 3.5 1.569 3.5 3.5-1.569 3.5-3.5 3.5z" })
            );
        }
        function Stroller({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StrollerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Stroller.SVG = StrollerSVG;
        return Stroller;
    })();
export const Subscript = /*#__PURE__*/ (() => {
        function SubscriptSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12.544 4.044l-4.044 4.041-4.044-4.041-1.413 1.413 4.041 4.044-4.041 4.044 1.413 1.413 4.044-4.041 4.044 4.041 1.413-1.413-4.041-4.044 4.041-4.044z" }),
_('path', { d: "M18.547 18.209c1.094-0.531 2.453-1.191 2.453-2.709 0-1.641-1.256-2.5-2.5-2.5s-2.5 0.859-2.5 2.5v0.5h1v-0.5c0-1.034 0.753-1.5 1.5-1.5 0.397 0 0.775 0.138 1.044 0.375 0.303 0.269 0.456 0.647 0.456 1.125 0 0.831-0.75 1.256-1.891 1.809-0.987 0.481-2.109 1.022-2.109 2.191 0 0.275 0.225 0.5 0.5 0.5h4.5v-1h-3.772c0.256-0.259 0.712-0.497 1.319-0.791z" })
            );
        }
        function Subscript({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SubscriptSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Subscript.SVG = SubscriptSVG;
        return Subscript;
    })();
export const Subtract = /*#__PURE__*/ (() => {
    function SubtractSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.5 10h-5.5v-7c0-1.103-0.897-2-2-2h-12c-1.103 0-2 0.897-2 2v12c0 1.103 0.897 2 2 2h7v5.5c0 0.275 0.225 0.5 0.5 0.5h12c0.275 0 0.5-0.225 0.5-0.5v-12c0-0.275-0.225-0.5-0.5-0.5zM9 10v5h-6v-12h12v6h-5c-0.553 0-1 0.447-1 1zM22 22h-11v-11h11v11z" })
        );
    }
    function Subtract({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SubtractSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Subtract.SVG = SubtractSVG;
    return Subtract;
})();
export const Suit = /*#__PURE__*/ (() => {
    function SuitSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.316 8.050l-1.684-0.562 2.169-2.891c0.178-0.237 0.241-0.541 0.172-0.831-0.069-0.288-0.262-0.531-0.528-0.666l-4.075-2.025 0.003-0.006-0.372-0.147v-0.422c0-0.162-0.078-0.316-0.213-0.409s-0.303-0.116-0.456-0.059c-3.537 1.287-7.125 1.287-10.659 0-0.153-0.056-0.325-0.034-0.456 0.059-0.134 0.094-0.213 0.247-0.213 0.409v0.425l-0.422 0.169 0.003 0.009-4.031 2.003c-0.266 0.131-0.459 0.375-0.528 0.666-0.069 0.288-0.006 0.594 0.172 0.831l2.169 2.891-1.684 0.563c-0.312 0.103-0.556 0.356-0.647 0.675s-0.019 0.659 0.194 0.916l9.391 11.244 0.037-0.031-0.612 1.831c-0.153 0.462 0.047 0.966 0.475 1.197 0.15 0.081 0.312 0.119 0.475 0.119 0.3 0 0.591-0.134 0.788-0.381l11-14c0.2-0.256 0.266-0.594 0.172-0.906s-0.328-0.566-0.637-0.669zM11.919 17.084l-1.844-5.719 1.791-5.372c0.047 0.003 0.091 0.006 0.138 0.006s0.094-0.003 0.138-0.006l1.734 5.216-1.956 5.875zM10.2 4.9c0.006 0.006 0.016 0.009 0.022 0.016 0.159 0.309 0.4 0.572 0.691 0.762l-1.359 4.081-2.272-7.050 2.919 2.191zM14.403 9.628l-1.316-3.95c0.291-0.191 0.531-0.453 0.691-0.762 0.006-0.006 0.016-0.009 0.022-0.016l2.906-2.178-2.303 6.906zM17 1.2v0.050l-3.356 2.519-0.762-1.269c0 0 0 0 0 0-0.178-0.294-0.481-0.478-0.822-0.497 1.641-0.009 3.3-0.278 4.941-0.803zM12 3c0.016 0 0.022 0.009 0.025 0.012v0l0.866 1.444c-0.166 0.322-0.503 0.544-0.891 0.544s-0.725-0.222-0.891-0.544l0.866-1.444c0.003-0.006 0.009-0.012 0.025-0.012zM7 1.2c1.641 0.525 3.3 0.794 4.938 0.8-0.341 0.019-0.644 0.203-0.822 0.497l-0.762 1.269-3.353-2.516v-0.050zM3.706 9.484l1.609-0.537c0.306-0.103 0.544-0.344 0.637-0.65s0.037-0.641-0.153-0.897l-2.281-3.041 2.794-1.391 5.066 15.7-7.672-9.184zM18.047 8.297c0.097 0.306 0.334 0.55 0.638 0.65l1.653 0.55-8.4 10.691 0.184-0.556 0.034-0.031-0.019-0.022 5.541-16.613 2.803 1.394-2.281 3.041c-0.194 0.256-0.25 0.591-0.153 0.897z" })
        );
    }
    function Suit({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SuitSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Suit.SVG = SuitSVG;
    return Suit;
})();
export const SunFog = /*#__PURE__*/ (() => {
        function SunFogSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1.756 16.244c1.134 1.131 2.641 1.756 4.244 1.756 1.503 0 2.572-0.241 3.603-0.472 1.162-0.259 2.363-0.528 4.397-0.528 1.925 0 3.359 0.237 4.878 0.491 1.512 0.25 3.078 0.509 5.122 0.509v-2c-1.878 0-3.297-0.234-4.794-0.484-1.531-0.253-3.116-0.516-5.206-0.516-0.234 0-0.459 0.003-0.678 0.009 0.444-0.928 0.678-1.953 0.678-3.009 0-1.869-0.728-3.628-2.050-4.95s-3.081-2.050-4.95-2.050-3.628 0.728-4.95 2.050c-1.322 1.322-2.050 3.081-2.050 4.95v6.5c0 1.456 0.669 2.844 1.884 3.912 1.15 1.009 2.65 1.587 4.116 1.587 1.447 0 2.441-0.222 3.494-0.459 1.188-0.266 2.419-0.541 4.506-0.541 1.966 0 3.488 0.253 4.959 0.497 1.494 0.247 3.037 0.503 5.041 0.503v-1c-1.919 0-3.356-0.237-4.878-0.491-1.512-0.25-3.075-0.509-5.122-0.509-2.2 0-3.541 0.3-4.725 0.566-0.997 0.222-1.938 0.434-3.275 0.434-2.359 0-5-1.925-5-4.5v-0.047c0.25 0.341 0.547 0.663 0.884 0.959 1.15 1.009 2.65 1.587 4.116 1.587 1.447 0 2.441-0.222 3.494-0.459 1.188-0.266 2.419-0.541 4.506-0.541 1.966 0 3.488 0.253 4.959 0.497 1.494 0.247 3.038 0.503 5.041 0.503v-1c-1.919 0-3.356-0.237-4.878-0.491-1.512-0.25-3.075-0.509-5.122-0.509-2.2 0-3.541 0.3-4.725 0.566-0.997 0.222-1.938 0.434-3.275 0.434-2.359 0-5-1.925-5-4.5v-0.178c0.219 0.328 0.472 0.637 0.756 0.922zM7 7c2.756 0 5 2.244 5 5 0 1.2-0.422 2.344-1.197 3.247-0.606 0.1-1.134 0.219-1.638 0.331-1.009 0.225-1.884 0.422-3.166 0.422-2.206 0-4-1.794-4-4 0-2.756 2.244-5 5-5z" }),
_('path', { d: "M6 0h2v4h-2v-4z" }),
_('path', { d: "M0.028 1.421l1.634-1.154 2.407 3.408-1.634 1.154-2.407-3.408z" }),
_('path', { d: "M15 11h4v2h-4v-2z" }),
_('path', { d: "M14.169 7.436l3.499-2.499 1.162 1.627-3.499 2.499-1.162-1.627z" }),
_('path', { d: "M9.936 3.669l2.499-3.499 1.627 1.162-2.499 3.499-1.627-1.162z" })
            );
        }
        function SunFog({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SunFogSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SunFog.SVG = SunFogSVG;
        return SunFog;
    })();
export const SunWind = /*#__PURE__*/ (() => {
        function SunWindSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16.5 21c2.034 0 3.153-1.075 3.734-1.978 0.616-0.956 0.756-1.909 0.762-1.95l-0.991-0.141c0 0.006-0.122 0.788-0.612 1.55-0.65 1.006-1.622 1.519-2.894 1.519-1.378 0-2.5-1.122-2.5-2.5 0-0.828 0.672-1.5 1.5-1.5 0.175 0 0.344 0.031 0.5 0.084-0.581 0.206-1 0.762-1 1.416 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5c0 1.931 1.569 3.5 3.5 3.5zM16.5 18c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5c0.275 0 0.497 0.222 0.5 0.494 0 0.003 0 0.003 0 0.006 0 0.275-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M22.188 21.109c-0.025 0.019-2.406 1.891-5.187 1.891-3.466 0-5.109-2.119-6.697-4.169-1.462-1.884-2.975-3.831-5.803-3.831-2.481 0-4.5 2.019-4.5 4.5v0.5h0.034c0.244 1.694 1.703 3 3.466 3 1.931 0 3.5-1.569 3.5-3.5 0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.653-0.419-1.209-1-1.416 0.156-0.056 0.325-0.084 0.5-0.084 0.828 0 1.5 0.672 1.5 1.5 0 1.378-1.122 2.5-2.5 2.5s-2.5-1.122-2.5-2.5c0-1.931 1.569-3.5 3.5-3.5 2.341 0 3.578 1.597 5.013 3.447 1.656 2.134 3.531 4.553 7.488 4.553 3.141 0 5.703-2.025 5.813-2.109l0.391-0.312-0.625-0.781-0.391 0.312zM3.5 20c-0.275 0-0.5-0.225-0.5-0.5 0-0.003 0-0.003 0-0.006 0.003-0.272 0.225-0.494 0.5-0.494s0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M11 0h2v4h-2v-4z" }),
_('path', { d: "M0 11h4v2h-4v-2z" }),
_('path', { d: "M4.936 1.332l1.627-1.162 2.499 3.499-1.627 1.162-2.499-3.499z" }),
_('path', { d: "M20 11h4v2h-4v-2z" }),
_('path', { d: "M19 13v-1c0-1.869-0.728-3.628-2.050-4.95s-3.081-2.050-4.95-2.050c-1.869 0-3.628 0.728-4.95 2.050s-2.050 3.081-2.050 4.95v1h2v-1c0-2.756 2.244-5 5-5s5 2.244 5 5v1h2z" }),
_('path', { d: "M0.169 6.564l1.162-1.627 3.499 2.499-1.162 1.627-3.499-2.499z" }),
_('path', { d: "M19.168 7.436l3.499-2.499 1.162 1.627-3.499 2.499-1.162-1.627z" }),
_('path', { d: "M14.936 3.669l2.499-3.499 1.627 1.162-2.499 3.499-1.627-1.162z" })
            );
        }
        function SunWind({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SunWindSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SunWind.SVG = SunWindSVG;
        return SunWind;
    })();
export const Sun = /*#__PURE__*/ (() => {
        function SunSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 0h2v4h-2v-4z" }),
_('path', { d: "M0 11h4v2h-4v-2z" }),
_('path', { d: "M11 20h2v4h-2v-4z" }),
_('path', { d: "M4.936 1.332l1.627-1.162 2.499 3.499-1.627 1.162-2.499-3.499z" }),
_('path', { d: "M20 11h4v2h-4v-2z" }),
_('path', { d: "M7.050 7.050c-1.322 1.322-2.050 3.081-2.050 4.95s0.728 3.628 2.050 4.95c1.322 1.322 3.081 2.050 4.95 2.050s3.628-0.728 4.95-2.050c1.322-1.322 2.050-3.081 2.050-4.95s-0.728-3.628-2.050-4.95c-1.322-1.322-3.081-2.050-4.95-2.050s-3.628 0.728-4.95 2.050zM17 12c0 2.756-2.244 5-5 5s-5-2.244-5-5c0-2.756 2.244-5 5-5s5 2.244 5 5z" }),
_('path', { d: "M0.169 6.564l1.162-1.627 3.499 2.499-1.162 1.627-3.499-2.499z" }),
_('path', { d: "M0.169 17.435l3.499-2.499 1.162 1.627-3.499 2.499-1.162-1.627z" }),
_('path', { d: "M4.936 22.668l2.499-3.499 1.627 1.162-2.499 3.499-1.627-1.162z" }),
_('path', { d: "M14.935 20.332l1.627-1.162 2.499 3.499-1.627 1.162-2.499-3.499z" }),
_('path', { d: "M19.168 16.564l1.162-1.627 3.499 2.499-1.162 1.627-3.499-2.499z" }),
_('path', { d: "M19.168 7.436l3.499-2.499 1.162 1.627-3.499 2.499-1.162-1.627z" }),
_('path', { d: "M14.936 3.669l2.499-3.499 1.627 1.162-2.499 3.499-1.627-1.162z" })
            );
        }
        function Sun({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SunSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Sun.SVG = SunSVG;
        return Sun;
    })();
export const Sunglasses = /*#__PURE__*/ (() => {
        function SunglassesSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.509 9.087c-0.3-0.513-0.731-0.941-1.281-1.275-1.038-0.628-2.294-0.794-3.228-0.813v0l-14 0.003c-0.931 0.019-2.191 0.181-3.228 0.813-0.55 0.334-0.981 0.762-1.281 1.275-0.325 0.553-0.491 1.194-0.491 1.903 0 1.872 0.375 3.259 1.15 4.247 0.916 1.169 2.381 1.759 4.35 1.759 1.947 0 3.475-0.816 4.416-2.356 0.684-1.125 1.050-2.6 1.081-4.387 0.294-0.166 0.631-0.256 0.981-0.256 0.366 0 0.719 0.1 1.025 0.281 0.034 1.778 0.4 3.244 1.081 4.362 0.941 1.541 2.469 2.356 4.416 2.356 1.969 0 3.434-0.591 4.35-1.759 0.775-0.987 1.15-2.375 1.15-4.247 0-0.709-0.166-1.35-0.491-1.906zM8.209 13.603c-0.575 0.941-1.459 1.397-2.709 1.397-2.55 0-3.5-1.084-3.5-4.006 0-0.597 0.175-1.437 1.691-1.825 0.444-0.113 0.959-0.169 1.5-0.169 0.625 0 1.287 0.075 1.922 0.222 1.15 0.269 1.747 0.669 1.887 0.847-0.009 1.478-0.281 2.7-0.791 3.534zM10.822 9.231c-0.116-0.237-0.297-0.491-0.581-0.741-0.197-0.175-0.434-0.337-0.706-0.488h4.931c-0.272 0.15-0.506 0.316-0.706 0.488-0.291 0.256-0.475 0.516-0.591 0.759-0.372-0.162-0.778-0.247-1.191-0.247-0.403-0.003-0.797 0.075-1.156 0.228zM18.5 15c-1.25 0-2.134-0.456-2.709-1.397-0.509-0.834-0.781-2.053-0.791-3.531 0.138-0.175 0.738-0.578 1.887-0.847 1.188-0.278 2.466-0.297 3.422-0.053 1.516 0.387 1.691 1.225 1.691 1.825 0 2.919-0.95 4.003-3.5 4.003z" }),
_('path', { d: "M17.463 12.556c-0.188-0.303-0.331-0.762-0.416-1.319 0.256-0.072 0.6-0.15 1.009-0.197l-0.113-0.994c-0.769 0.087-1.344 0.272-1.616 0.372-0.213 0.078-0.347 0.291-0.325 0.516 0.084 0.894 0.294 1.634 0.609 2.144 0.209 0.337 0.547 0.744 1.303 0.875l0.169-0.984c-0.381-0.063-0.497-0.209-0.622-0.412z" }),
_('path', { d: "M4.297 12.772c-0.047-0.059-0.275-0.413-0.297-1.606 0.184-0.066 0.519-0.147 1.016-0.162l-0.031-1c-0.828 0.025-1.544 0.222-1.825 0.5-0.066 0.066-0.113 0.147-0.134 0.237-0.016 0.072-0.025 0.156-0.025 0.253 0 1.156 0.172 1.962 0.509 2.394 0.259 0.331 0.731 0.522 1.444 0.588l0.091-0.997c-0.516-0.044-0.713-0.166-0.747-0.206z" })
            );
        }
        function Sunglasses({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SunglassesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Sunglasses.SVG = SunglassesSVG;
        return Sunglasses;
    })();
export const Superscript = /*#__PURE__*/ (() => {
        function SuperscriptSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12.544 9.044l-4.044 4.041-4.044-4.041-1.413 1.413 4.041 4.044-4.041 4.044 1.413 1.413 4.044-4.041 4.044 4.041 1.413-1.413-4.041-4.044 4.041-4.044z" }),
_('path', { d: "M18.547 9.209c1.094-0.531 2.453-1.191 2.453-2.709 0-1.641-1.256-2.5-2.5-2.5s-2.5 0.859-2.5 2.5v0.5h1v-0.5c0-1.034 0.753-1.5 1.5-1.5 0.397 0 0.775 0.138 1.044 0.375 0.303 0.269 0.456 0.647 0.456 1.125 0 0.831-0.75 1.256-1.891 1.809-0.987 0.481-2.109 1.022-2.109 2.191 0 0.275 0.225 0.5 0.5 0.5h4.5v-1h-3.772c0.256-0.259 0.712-0.497 1.319-0.791z" })
            );
        }
        function Superscript({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SuperscriptSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Superscript.SVG = SuperscriptSVG;
        return Superscript;
    })();
export const Support = /*#__PURE__*/ (() => {
        function SupportSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 3c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zM12 13c-2.206 0-4-1.794-4-4s1.794-4 4-4c2.206 0 4 1.794 4 4s-1.794 4-4 4z" }),
_('path', { d: "M12 16c-3.806 0-6.328 0.675-7.709 2.069-1.291 1.3-1.291 2.884-1.291 3.931v0.5c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-0.5c0-1.047 0-2.631-1.291-3.931-1.381-1.394-3.903-2.069-7.709-2.069zM5 22c0-0.888 0-1.809 0.709-2.522 0.422-0.425 1.072-0.762 1.938-1.006 1.106-0.312 2.572-0.472 4.353-0.472s3.247 0.159 4.353 0.472c0.866 0.244 1.516 0.581 1.938 1.006 0.709 0.712 0.709 1.634 0.709 2.522h-14z" }),
_('path', { d: "M4.5 11c0.275 0 0.5-0.225 0.5-0.5v-3c0-3.584 3.141-6.5 7-6.5s7 2.916 7 6.5v3c0 0.275 0.225 0.5 0.5 0.5h0.5c0.275 0 0.537-0.056 0.775-0.156-0.216 0.819-0.591 1.534-1.116 2.137-0.531 0.609-1.075 0.919-1.272 1.019h-1.387v1h1.5c0.066 0 0.128-0.012 0.191-0.038 0.034-0.016 0.866-0.363 1.684-1.278 0.741-0.834 1.625-2.322 1.625-4.684 0-1.103-0.897-2-2-2h-0.019c-0.128-1.822-0.947-3.516-2.337-4.816-1.509-1.409-3.513-2.184-5.644-2.184s-4.134 0.775-5.644 2.184c-1.394 1.3-2.213 2.994-2.337 4.816h-0.019c-1.103 0-2 0.897-2 2s0.897 2 2 2h0.5zM21 9c0 0.55-0.45 1-1 1v-2c0.55 0 1 0.45 1 1zM3 9c0-0.55 0.45-1 1-1v2c-0.55 0-1-0.45-1-1z" })
            );
        }
        function Support({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SupportSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Support.SVG = SupportSVG;
        return Support;
    })();
export const Surveillance = /*#__PURE__*/ (() => {
        function SurveillanceSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.116 6.019c-1.575-0.381-1.969-0.816-2.066-1.041-0.144-0.347 0.153-0.841 0.441-1.319 0.337-0.563 0.684-1.141 0.431-1.719-0.234-0.541-0.866-0.728-1.322-0.825-0.197-0.041-0.403-0.069-0.603-0.084v-0.531c0-0.275-0.225-0.5-0.5-0.5h-11.997c-0.275 0-0.5 0.225-0.5 0.5v1.5c0 1.103 0.897 2 2 2h3v3.338c-1.181 0.563-2 1.769-2 3.162 0 0.375 0.059 0.747 0.178 1.103l-8.903 4.45c-0.172 0.087-0.278 0.263-0.275 0.456s0.116 0.366 0.291 0.447l1.775 0.819 0.353 0.709-1.144 0.572c-0.119 0.059-0.209 0.162-0.25 0.291-0.041 0.125-0.031 0.263 0.028 0.381l1.5 3c0.087 0.175 0.266 0.275 0.447 0.275 0.075 0 0.15-0.016 0.222-0.053l1.144-0.572 0.228 0.459c0.35 0.7 1.059 1.106 1.791 1.106 0.3 0 0.606-0.069 0.891-0.213l13.587-6.794c0.478-0.237 0.834-0.65 1.003-1.156s0.131-1.050-0.109-1.528l-0.628-1.259 0.094-0.047c0.247-0.125 0.347-0.425 0.225-0.672l-0.728-1.453c0.959-0.288 1.725-0.656 2.284-1.097 0.825-0.656 0.997-1.316 0.997-1.756-0.003-0.909-0.741-1.675-1.884-1.95zM8 1h9v1h-9v-1zM12 4h1v3.034c-0.162-0.022-0.331-0.034-0.5-0.034s-0.338 0.012-0.5 0.034v-3.034zM11 10.5c0-0.828 0.672-1.5 1.5-1.5 0.397 0 0.769 0.153 1.044 0.419l-2.531 1.266c-0.009-0.059-0.012-0.122-0.012-0.184zM18.275 8.172l2.053 4.106-13.338 6.669-5.337-2.466 16.622-8.309zM3.225 21.828l-1.053-2.106 0.694-0.347 1.053 2.106-0.694 0.347zM19.972 15.147l-13.587 6.794-1.413-2.825 1.819 0.841c0.066 0.031 0.138 0.047 0.209 0.047 0.078 0 0.153-0.019 0.225-0.053l12.119-6.059 0.628 1.256zM20.266 9.912l-1.319-2.637c-0.125-0.247-0.425-0.347-0.672-0.225l-2.9 1.453c-0.353-0.509-0.828-0.909-1.375-1.169v-3.334h3c1.094 0 1.984-0.881 2-1.969 0.134 0.012 0.269 0.034 0.397 0.059 0.531 0.113 0.609 0.244 0.612 0.247 0 0 0.012 0.056-0.050 0.216-0.069 0.172-0.191 0.375-0.322 0.591-0.375 0.628-0.844 1.409-0.503 2.222 0.306 0.731 1.181 1.247 2.753 1.625 0.678 0.162 1.116 0.55 1.119 0.981-0.006 0.556-0.731 1.375-2.741 1.941z" }),
_('path', { d: "M17 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Surveillance({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SurveillanceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Surveillance.SVG = SurveillanceSVG;
        return Surveillance;
    })();
export const Surveillance2 = /*#__PURE__*/ (() => {
        function Surveillance2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.5 3h-23c-0.275 0-0.5 0.225-0.5 0.5v3.5c0 1.103 0.897 2 2 2v2c0 2.672 1.041 5.181 2.928 7.072 1.891 1.887 4.4 2.928 7.072 2.928s5.181-1.041 7.072-2.928c1.887-1.891 2.928-4.4 2.928-7.072v-2c1.103 0 2-0.897 2-2v-3.5c0-0.275-0.225-0.5-0.5-0.5zM20 11c0 4.413-3.588 8-8 8s-8-3.588-8-8v-2h16v2zM22 7h-20v-3h20v3z" }),
_('path', { d: "M12 18c2.206 0 4-1.794 4-4s-1.794-4-4-4c-2.206 0-4 1.794-4 4s1.794 4 4 4zM12 11c1.653 0 3 1.347 3 3s-1.347 3-3 3-3-1.347-3-3 1.347-3 3-3z" }),
_('path', { d: "M16 5h4v1h-4v-1z" }),
_('path', { d: "M12 15c0.55 0 1-0.45 1-1s-0.45-1-1-1c-0.55 0-1 0.45-1 1s0.45 1 1 1zM12 14v0c0 0 0 0 0 0z" })
            );
        }
        function Surveillance2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Surveillance2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Surveillance2.SVG = Surveillance2SVG;
        return Surveillance2;
    })();
export const SwapCalls = /*#__PURE__*/ (() => {
    function SwapCallsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.956 5.544l-3.25-3.25c-0.391-0.391-1.025-0.391-1.416 0l-3.25 3.25 1.416 1.416 1.544-1.544v11.584c0 1.653-1.347 3-3 3s-3-1.347-3-3v-10c0-2.756-2.244-5-5-5s-5 2.244-5 5v11.584l-1.544-1.544-1.413 1.416 3.25 3.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l3.25-3.25-1.416-1.416-1.541 1.544v-11.584c0-1.653 1.347-3 3-3s3 1.347 3 3v10c0 2.756 2.244 5 5 5s5-2.244 5-5v-11.584l1.544 1.544 1.413-1.416z" })
        );
    }
    function SwapCalls({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SwapCallsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SwapCalls.SVG = SwapCallsSVG;
    return SwapCalls;
})();
export const SwapHorizontal = /*#__PURE__*/ (() => {
        function SwapHorizontalSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5.956 13.456l-1.416-1.416-4.25 4.25c-0.391 0.391-0.391 1.025 0 1.416l4.25 4.25 1.416-1.416-2.541-2.541h14.584v-2h-14.584l2.541-2.544z" }),
_('path', { d: "M23.706 6.294l-4.25-4.25-1.416 1.416 2.544 2.544h-14.584v2h14.584l-2.544 2.544 1.416 1.416 4.25-4.25c0.391-0.397 0.391-1.028 0-1.419z" })
            );
        }
        function SwapHorizontal({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SwapHorizontalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SwapHorizontal.SVG = SwapHorizontalSVG;
        return SwapHorizontal;
    })();
export const SwapVertical = /*#__PURE__*/ (() => {
        function SwapVerticalSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.544 18.044l-2.544 2.541v-14.584h-2v14.584l-2.544-2.544-1.416 1.416 4.25 4.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l4.25-4.25-1.409-1.413z" }),
_('path', { d: "M6.294 0.294l-4.25 4.25 1.416 1.416 2.544-2.544v14.584h2v-14.584l2.544 2.544 1.416-1.416-4.25-4.25c-0.397-0.391-1.028-0.391-1.419 0z" })
            );
        }
        function SwapVertical({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SwapVerticalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SwapVertical.SVG = SwapVerticalSVG;
        return SwapVertical;
    })();
export const SwimmingWarning = /*#__PURE__*/ (() => {
        function SwimmingWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.775 13.553c-0.481 0.241-0.894 0.447-1.775 0.447s-1.297-0.206-1.775-0.447c-0.519-0.259-1.106-0.553-2.225-0.553s-1.706 0.294-2.225 0.553c-0.481 0.241-0.894 0.447-1.775 0.447s-1.297-0.206-1.775-0.447c-0.066-0.034-0.134-0.069-0.206-0.1l3.575-2.65c0.428-0.319 0.531-0.916 0.237-1.359l-1.544-2.319 3.672-3.672-1.416-1.416-4.25 4.25c-0.338 0.337-0.391 0.866-0.125 1.263l1.472 2.209-4.256 3.153-0.541-1.081c-0.25-0.506-0.778-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-1.041 2.078c-0.35-0.081-0.606-0.213-0.897-0.356-0.519-0.256-1.106-0.55-2.225-0.55v1c0.881 0 1.297 0.206 1.775 0.447 0.256 0.128 0.534 0.266 0.888 0.375l-2.503 5.006c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h8c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672l-1.231-2.463c0.056 0.028 0.113 0.056 0.169 0.084 0.519 0.259 1.106 0.553 2.225 0.553s1.706-0.294 2.225-0.553c0.481-0.241 0.894-0.447 1.775-0.447s1.297 0.206 1.775 0.447c0.519 0.259 1.106 0.553 2.225 0.553v-1c-0.881 0-1.297-0.206-1.775-0.447-0.519-0.259-1.106-0.553-2.225-0.553s-1.706 0.294-2.225 0.553c-0.481 0.241-0.894 0.447-1.775 0.447s-1.297-0.206-1.775-0.447c-0.337-0.169-0.716-0.359-1.253-0.466l-1.050-2.091c0.025 0 0.050 0 0.075 0 0.881 0 1.297 0.206 1.775 0.447 0.519 0.259 1.106 0.553 2.225 0.553s1.706-0.294 2.225-0.553c0.481-0.241 0.894-0.447 1.775-0.447s1.297 0.206 1.775 0.447c0.519 0.259 1.106 0.553 2.225 0.553s1.706-0.294 2.225-0.553c0.481-0.241 0.894-0.447 1.775-0.447v-1c-1.119 0-1.706 0.294-2.225 0.553zM9.95 20.281c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003z" }),
_('path', { d: "M14 9c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM16 8c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M5 19h1v1h-1v-1z" }),
_('path', { d: "M5 14h1v4h-1v-4z" })
            );
        }
        function SwimmingWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SwimmingWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SwimmingWarning.SVG = SwimmingWarningSVG;
        return SwimmingWarning;
    })();
export const Swimming = /*#__PURE__*/ (() => {
        function SwimmingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.775 15.553c-0.481 0.241-0.894 0.447-1.775 0.447s-1.297-0.206-1.775-0.447c-0.519-0.259-1.106-0.553-2.225-0.553s-1.706 0.294-2.225 0.553c-0.481 0.241-0.894 0.447-1.775 0.447s-1.297-0.206-1.775-0.447c-0.066-0.034-0.134-0.069-0.206-0.1l3.575-2.65c0.428-0.319 0.531-0.916 0.237-1.359l-1.544-2.319 3.669-3.669-1.416-1.416-4.25 4.25c-0.338 0.337-0.391 0.866-0.125 1.263l1.472 2.209-4.453 3.297c-0.622 0.1-1.034 0.306-1.409 0.494-0.481 0.241-0.894 0.447-1.775 0.447s-1.297-0.206-1.775-0.447c-0.519-0.259-1.106-0.553-2.225-0.553v1c0.881 0 1.297 0.206 1.775 0.447 0.519 0.259 1.106 0.553 2.225 0.553s1.706-0.294 2.225-0.553c0.481-0.241 0.894-0.447 1.775-0.447s1.297 0.206 1.775 0.447c0.519 0.259 1.106 0.553 2.225 0.553s1.706-0.294 2.225-0.553c0.481-0.241 0.894-0.447 1.775-0.447s1.297 0.206 1.775 0.447c0.519 0.259 1.106 0.553 2.225 0.553s1.706-0.294 2.225-0.553c0.481-0.241 0.894-0.447 1.775-0.447v-1c-1.119 0-1.706 0.294-2.225 0.553z" }),
_('path', { d: "M16 18c-1.119 0-1.706 0.294-2.225 0.553-0.481 0.241-0.894 0.447-1.775 0.447s-1.297-0.206-1.775-0.447c-0.519-0.259-1.106-0.553-2.225-0.553s-1.706 0.294-2.225 0.553c-0.481 0.241-0.894 0.447-1.775 0.447v1c1.119 0 1.706-0.294 2.225-0.553 0.481-0.241 0.894-0.447 1.775-0.447s1.297 0.206 1.775 0.447c0.519 0.259 1.106 0.553 2.225 0.553s1.706-0.294 2.225-0.553c0.481-0.241 0.894-0.447 1.775-0.447s1.297 0.206 1.775 0.447c0.519 0.259 1.106 0.553 2.225 0.553v-1c-0.881 0-1.297-0.206-1.775-0.447-0.519-0.259-1.106-0.553-2.225-0.553z" }),
_('path', { d: "M14 11c0 1.103 0.897 2 2 2s2-0.897 2-2-0.897-2-2-2-2 0.897-2 2zM16 10c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" })
            );
        }
        function Swimming({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SwimmingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Swimming.SVG = SwimmingSVG;
        return Swimming;
    })();
export const SwipeDown = /*#__PURE__*/ (() => {
    function SwipeDownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.344 2.781v0c-2.266-1.166-4.806-1.781-7.344-1.781h-0.5c-1.931 0-3.5 1.569-3.5 3.5 0 0.087 0.003 0.172 0.009 0.256-0.619 0.55-1.009 1.353-1.009 2.244 0 0.237 0.028 0.469 0.081 0.697-0.659 0.55-1.081 1.378-1.081 2.303h-2c-1.653 0-3 1.347-3 3 0 1.303 0.837 2.416 2 2.828v5.466l-1.5-1.5-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l2.353-2.353-0.706-0.706-1.5 1.5v-5.294h7.15l-0.738 1.128c-0.266 0.406-0.409 0.881-0.409 1.372 0 1.378 1.119 2.5 2.497 2.5 0.541 0 1.059-0.172 1.497-0.497 0.003 0 0.003-0.003 0.006-0.003l6.034-4.525c1.228-0.922 1.962-2.394 1.962-3.934v-4.887c0-1.85-1.019-3.525-2.656-4.372zM21 12.041c0 0.916-0.434 1.788-1.163 2.334l-6.031 4.522c-0.063 0.047-0.169 0.103-0.306 0.103-0.275 0-0.497-0.225-0.497-0.5 0-0.1 0.028-0.194 0.081-0.275l1.753-2.678c0.2-0.306 0.219-0.7 0.044-1.022s-0.513-0.525-0.881-0.525h-9c-0.55 0-1-0.45-1-1s0.45-1 1-1h7v-1h-2c-0.175 0-0.347-0.047-0.5-0.134s-0.278-0.216-0.366-0.366c-0.087-0.15-0.134-0.322-0.134-0.5 0-0.55 0.45-1 1-1h2v-1h-1c-0.175 0-0.347-0.047-0.5-0.134s-0.278-0.213-0.366-0.366c-0.087-0.15-0.134-0.322-0.134-0.5 0-0.55 0.45-1 1-1h2v-1h-1.916c-0.056-0.159-0.084-0.328-0.084-0.5 0-0.828 0.672-1.5 1.5-1.5h0.5c2.222 0 4.444 0.537 6.425 1.556 0.972 0.503 1.575 1.497 1.575 2.597v4.887z" })
        );
    }
    function SwipeDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SwipeDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SwipeDown.SVG = SwipeDownSVG;
    return SwipeDown;
})();
export const SwipeHorizontal = /*#__PURE__*/ (() => {
    function SwipeHorizontalSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19.5 9c-0.087 0-0.172 0.003-0.256 0.009-0.55-0.619-1.353-1.009-2.244-1.009-0.237 0-0.469 0.028-0.697 0.081-0.55-0.659-1.378-1.081-2.303-1.081v-2h5.294l-1.5 1.5 0.706 0.706 2.353-2.353c0.194-0.194 0.194-0.513 0-0.706l-2.353-2.353-0.706 0.706 1.5 1.5h-5.466c-0.412-1.162-1.525-2-2.828-2s-2.416 0.837-2.828 2h-5.466l1.5-1.5-0.706-0.706-2.353 2.353c-0.194 0.194-0.194 0.513 0 0.706l2.353 2.353 0.706-0.706-1.5-1.5h5.294v7.15l-1.128-0.738c-0.406-0.266-0.881-0.409-1.372-0.409-1.378 0-2.5 1.119-2.5 2.497 0 0.541 0.172 1.059 0.497 1.497 0 0.003 0.003 0.003 0.003 0.006l4.525 6.034c0.922 1.228 2.394 1.962 3.934 1.962h4.887c1.85 0 3.525-1.019 4.372-2.656v-0.003c1.166-2.262 1.781-4.803 1.781-7.341v-0.5c0-1.931-1.569-3.5-3.5-3.5zM21 13c0 2.222-0.537 4.444-1.556 6.425-0.503 0.972-1.497 1.575-2.597 1.575h-4.887c-0.916 0-1.788-0.434-2.334-1.163l-4.522-6.031c-0.047-0.063-0.103-0.169-0.103-0.306 0-0.275 0.225-0.497 0.5-0.497 0.1 0 0.194 0.028 0.275 0.081l2.678 1.753c0.306 0.2 0.7 0.219 1.022 0.044s0.525-0.513 0.525-0.881v-9c0-0.55 0.45-1 1-1s1 0.45 1 1v7h1v-2c0-0.175 0.047-0.347 0.134-0.5s0.216-0.278 0.366-0.366 0.322-0.134 0.5-0.134c0.55 0 1 0.45 1 1v2h1v-1c0-0.175 0.047-0.347 0.134-0.5s0.213-0.278 0.366-0.366c0.15-0.087 0.322-0.134 0.5-0.134 0.55 0 1 0.45 1 1v2h1v-1.916c0.159-0.056 0.328-0.084 0.5-0.084 0.828 0 1.5 0.672 1.5 1.5v0.5z" })
        );
    }
    function SwipeHorizontal({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SwipeHorizontalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SwipeHorizontal.SVG = SwipeHorizontalSVG;
    return SwipeHorizontal;
})();
export const SwipeLeft = /*#__PURE__*/ (() => {
    function SwipeLeftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19.5 9c-0.087 0-0.172 0.003-0.256 0.009-0.55-0.619-1.353-1.009-2.244-1.009-0.237 0-0.469 0.028-0.697 0.081-0.55-0.659-1.378-1.081-2.303-1.081v-2c0-1.653-1.347-3-3-3-1.303 0-2.416 0.837-2.828 2h-5.466l1.5-1.5-0.706-0.706-2.353 2.353c-0.194 0.194-0.194 0.513 0 0.706l2.353 2.353 0.706-0.706-1.5-1.5h5.294v7.15l-1.128-0.738c-0.406-0.266-0.881-0.409-1.372-0.409-1.378 0-2.5 1.119-2.5 2.497 0 0.541 0.172 1.059 0.497 1.497 0 0.003 0.003 0.003 0.003 0.006l4.525 6.034c0.922 1.228 2.394 1.962 3.934 1.962h4.887c1.85 0 3.525-1.019 4.372-2.656v-0.003c1.166-2.262 1.781-4.803 1.781-7.341v-0.5c0-1.931-1.569-3.5-3.5-3.5zM21 13c0 2.222-0.537 4.444-1.556 6.425-0.503 0.972-1.497 1.575-2.597 1.575h-4.887c-0.916 0-1.788-0.434-2.334-1.163l-4.522-6.031c-0.047-0.063-0.103-0.169-0.103-0.306 0-0.275 0.225-0.497 0.5-0.497 0.1 0 0.194 0.028 0.275 0.081l2.678 1.753c0.306 0.2 0.7 0.219 1.022 0.044s0.525-0.513 0.525-0.881v-9c0-0.55 0.45-1 1-1s1 0.45 1 1v7h1v-2c0-0.175 0.047-0.347 0.134-0.5s0.216-0.278 0.366-0.366 0.322-0.134 0.5-0.134c0.55 0 1 0.45 1 1v2h1v-1c0-0.175 0.047-0.347 0.134-0.5s0.213-0.278 0.366-0.366c0.15-0.087 0.322-0.134 0.5-0.134 0.55 0 1 0.45 1 1v2h1v-1.916c0.159-0.056 0.328-0.084 0.5-0.084 0.828 0 1.5 0.672 1.5 1.5v0.5z" })
        );
    }
    function SwipeLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SwipeLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SwipeLeft.SVG = SwipeLeftSVG;
    return SwipeLeft;
})();
export const SwipeRight = /*#__PURE__*/ (() => {
    function SwipeRightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18.5 9c-0.087 0-0.172 0.003-0.256 0.009-0.55-0.619-1.353-1.009-2.244-1.009-0.237 0-0.469 0.028-0.697 0.081-0.55-0.659-1.378-1.081-2.303-1.081v-2h5.294l-1.5 1.5 0.706 0.706 2.353-2.353c0.194-0.194 0.194-0.513 0-0.706l-2.353-2.353-0.706 0.706 1.5 1.5h-5.466c-0.413-1.162-1.525-2-2.828-2-1.653 0-3 1.347-3 3v7.15l-1.128-0.738c-0.406-0.266-0.881-0.409-1.372-0.409-1.378 0-2.5 1.119-2.5 2.497 0 0.541 0.172 1.059 0.497 1.497 0 0.003 0.003 0.003 0.003 0.006l4.525 6.034c0.922 1.228 2.394 1.962 3.934 1.962h4.887c1.85 0 3.525-1.019 4.372-2.656v-0.003c1.166-2.262 1.781-4.803 1.781-7.341v-0.5c0-1.931-1.569-3.5-3.5-3.5zM20 13c0 2.222-0.537 4.444-1.556 6.425-0.503 0.972-1.497 1.575-2.597 1.575h-4.887c-0.916 0-1.788-0.434-2.334-1.163l-4.522-6.031c-0.047-0.063-0.103-0.169-0.103-0.306 0-0.275 0.225-0.497 0.5-0.497 0.1 0 0.194 0.028 0.275 0.081l2.678 1.753c0.306 0.2 0.7 0.219 1.022 0.044s0.525-0.513 0.525-0.881v-9c0-0.55 0.45-1 1-1s1 0.45 1 1v7h1v-2c0-0.175 0.047-0.347 0.134-0.5s0.216-0.278 0.366-0.366 0.322-0.134 0.5-0.134c0.55 0 1 0.45 1 1v2h1v-1c0-0.175 0.047-0.347 0.134-0.5s0.213-0.278 0.366-0.366c0.15-0.087 0.322-0.134 0.5-0.134 0.55 0 1 0.45 1 1v2h1v-1.916c0.159-0.056 0.328-0.084 0.5-0.084 0.828 0 1.5 0.672 1.5 1.5v0.5z" })
        );
    }
    function SwipeRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SwipeRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SwipeRight.SVG = SwipeRightSVG;
    return SwipeRight;
})();
export const SwipeUp = /*#__PURE__*/ (() => {
    function SwipeUpSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.344 3.781v0c-2.266-1.166-4.806-1.781-7.344-1.781h-0.5c-1.931 0-3.5 1.569-3.5 3.5 0 0.087 0.003 0.172 0.009 0.256-0.619 0.55-1.009 1.353-1.009 2.244 0 0.237 0.028 0.469 0.081 0.697-0.659 0.55-1.081 1.378-1.081 2.303h-2v-5.294l1.5 1.5 0.706-0.706-2.353-2.353c-0.194-0.194-0.513-0.194-0.706 0l-2.353 2.353 0.706 0.706 1.5-1.5v5.466c-1.162 0.412-2 1.525-2 2.828 0 1.653 1.347 3 3 3h7.15l-0.738 1.128c-0.266 0.406-0.409 0.881-0.409 1.372 0 1.378 1.119 2.5 2.497 2.5 0.541 0 1.059-0.172 1.497-0.497 0.003 0 0.003-0.003 0.006-0.003l6.034-4.525c1.228-0.922 1.962-2.394 1.962-3.934v-4.887c0-1.85-1.019-3.525-2.656-4.372zM21 13.041c0 0.916-0.434 1.788-1.163 2.334l-6.031 4.522c-0.063 0.047-0.169 0.103-0.306 0.103-0.275 0-0.497-0.225-0.497-0.5 0-0.1 0.028-0.194 0.081-0.275l1.753-2.678c0.2-0.306 0.219-0.7 0.044-1.022s-0.513-0.525-0.881-0.525h-9c-0.55 0-1-0.45-1-1s0.45-1 1-1h7v-1h-2c-0.175 0-0.347-0.047-0.5-0.134s-0.278-0.216-0.366-0.366c-0.087-0.15-0.134-0.322-0.134-0.5 0-0.55 0.45-1 1-1h2v-1h-1c-0.175 0-0.347-0.047-0.5-0.134s-0.278-0.213-0.366-0.366c-0.087-0.15-0.134-0.322-0.134-0.5 0-0.55 0.45-1 1-1h2v-1h-1.916c-0.056-0.159-0.084-0.328-0.084-0.5 0-0.828 0.672-1.5 1.5-1.5h0.5c2.222 0 4.444 0.537 6.425 1.556 0.972 0.503 1.575 1.497 1.575 2.597v4.887z" })
        );
    }
    function SwipeUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SwipeUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SwipeUp.SVG = SwipeUpSVG;
    return SwipeUp;
})();
export const SwipeVertical = /*#__PURE__*/ (() => {
    function SwipeVerticalSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.344 2.781v0c-2.266-1.166-4.806-1.781-7.344-1.781h-0.5c-1.931 0-3.5 1.569-3.5 3.5 0 0.087 0.003 0.172 0.009 0.256-0.619 0.55-1.009 1.353-1.009 2.244 0 0.237 0.028 0.469 0.081 0.697-0.659 0.55-1.081 1.378-1.081 2.303h-2v-5.294l1.5 1.5 0.706-0.706-2.353-2.353c-0.194-0.194-0.513-0.194-0.706 0l-2.353 2.353 0.706 0.706 1.5-1.5v5.466c-1.162 0.413-2 1.525-2 2.828s0.837 2.416 2 2.828v5.466l-1.5-1.5-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l2.353-2.353-0.706-0.706-1.5 1.5v-5.294h7.15l-0.738 1.128c-0.266 0.406-0.409 0.881-0.409 1.372 0 1.378 1.119 2.5 2.497 2.5 0.541 0 1.059-0.172 1.497-0.497 0.003 0 0.003-0.003 0.006-0.003l6.034-4.525c1.228-0.922 1.962-2.394 1.962-3.934v-4.887c0-1.85-1.019-3.525-2.656-4.372zM21 12.041c0 0.916-0.434 1.788-1.163 2.334l-6.031 4.522c-0.063 0.047-0.169 0.103-0.306 0.103-0.275 0-0.497-0.225-0.497-0.5 0-0.1 0.028-0.194 0.081-0.275l1.753-2.678c0.2-0.306 0.219-0.7 0.044-1.022s-0.513-0.525-0.881-0.525h-9c-0.55 0-1-0.45-1-1s0.45-1 1-1h7v-1h-2c-0.175 0-0.347-0.047-0.5-0.134s-0.278-0.216-0.366-0.366c-0.087-0.15-0.134-0.322-0.134-0.5 0-0.55 0.45-1 1-1h2v-1h-1c-0.175 0-0.347-0.047-0.5-0.134s-0.278-0.213-0.366-0.366c-0.087-0.15-0.134-0.322-0.134-0.5 0-0.55 0.45-1 1-1h2v-1h-1.916c-0.056-0.159-0.084-0.328-0.084-0.5 0-0.828 0.672-1.5 1.5-1.5h0.5c2.222 0 4.444 0.537 6.425 1.556 0.972 0.503 1.575 1.497 1.575 2.597v4.887z" })
        );
    }
    function SwipeVertical({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SwipeVerticalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SwipeVertical.SVG = SwipeVerticalSVG;
    return SwipeVertical;
})();
export const SwitchOff = /*#__PURE__*/ (() => {
        function SwitchOffSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 10h-1c0-1.619-0.434-3.203-1.256-4.587-0.797-1.344-1.934-2.463-3.291-3.237-0.356-0.203-0.8-0.169-1.119 0.087l-4.684 3.738h-6.069c-0.406 0-0.775 0.247-0.928 0.625-0.434 1.072-0.653 2.206-0.653 3.375h-1c-1.103 0-2 0.897-2 2v2.5c0 0.275 0.225 0.5 0.5 0.5h23c0.275 0 0.5-0.225 0.5-0.5v-2.5c0-1.103-0.897-2-2-2zM5.287 8h5.712c0.228 0 0.447-0.078 0.625-0.219l4.4-3.513c1.85 1.306 2.975 3.444 2.975 5.731h-14c0-0.684 0.097-1.356 0.288-2zM2 14v-2h20v2h-20z" }),
_('path', { d: "M1.5 19c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM1.5 21c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M4 18.5v3.5h1v-2h1v-1h-1v-0.5c0-0.275 0.225-0.5 0.5-0.5h0.5v-1h-0.5c-0.828 0-1.5 0.672-1.5 1.5z" }),
_('path', { d: "M7 18.5v3.5h1v-2h1v-1h-1v-0.5c0-0.275 0.225-0.5 0.5-0.5h0.5v-1h-0.5c-0.828 0-1.5 0.672-1.5 1.5z" })
            );
        }
        function SwitchOff({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SwitchOffSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SwitchOff.SVG = SwitchOffSVG;
        return SwitchOff;
    })();
export const SwitchOn = /*#__PURE__*/ (() => {
        function SwitchOnSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 10h-1c0-1.169-0.219-2.303-0.653-3.375-0.153-0.378-0.519-0.625-0.928-0.625h-6.069l-4.681-3.738c-0.319-0.256-0.762-0.291-1.119-0.087-1.356 0.775-2.494 1.894-3.291 3.237-0.825 1.384-1.259 2.969-1.259 4.587h-1c-1.103 0-2 0.897-2 2v2.5c0 0.275 0.225 0.5 0.5 0.5h23c0.275 0 0.5-0.225 0.5-0.5v-2.5c0-1.103-0.897-2-2-2zM7.978 4.269l4.397 3.513c0.178 0.141 0.397 0.219 0.625 0.219h5.712c0.191 0.644 0.288 1.316 0.288 2h-14c0-2.287 1.125-4.425 2.978-5.731zM2 14v-2h20v2h-20z" }),
_('path', { d: "M18.5 19c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM18.5 21c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M22.5 19c-0.175 0-0.344 0.031-0.5 0.084v-0.084h-1v3h1v-1.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5v1.5h1v-1.5c0-0.828-0.672-1.5-1.5-1.5z" })
            );
        }
        function SwitchOn({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SwitchOnSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SwitchOn.SVG = SwitchOnSVG;
        return SwitchOn;
    })();
export const Sword = /*#__PURE__*/ (() => {
    function SwordSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21 20c-0.178 0-0.353 0.025-0.519 0.069l-2.066-2.069 1.294-1.294c0.478-0.478 0.687-1.2 0.572-1.978-0.094-0.644-0.394-1.259-0.822-1.688l-1.416 1.416c0.241 0.241 0.312 0.719 0.244 0.841l-0.638 0.641-15.797-15.791c-0.144-0.144-0.359-0.184-0.544-0.109-0.188 0.078-0.309 0.259-0.309 0.462 0 1.828 0.356 3.372 1.091 4.713 0.628 1.15 1.419 1.941 2.056 2.578l0.063 0.063c1.050 1.053 8.412 8.447 10.741 10.784l-0.65 0.65c-0.122 0.069-0.6-0.006-0.841-0.244l-1.416 1.416c0.428 0.428 1.041 0.728 1.688 0.822 0.141 0.022 0.278 0.031 0.416 0.031 0.616 0 1.172-0.209 1.563-0.603l1.294-1.294 2.069 2.069c-0.044 0.166-0.069 0.338-0.069 0.519 0 1.103 0.897 2 2 2s2-0.897 2-2-0.9-2.003-2.003-2.003zM4.912 7.147l-0.063-0.063c-1.056-1.059-2.456-2.459-2.781-5.309l14.872 14.866-1.287 1.287c-2.331-2.337-9.687-9.728-10.741-10.781zM21 23c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
        );
    }
    function Sword({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SwordSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sword.SVG = SwordSVG;
    return Sword;
})();
export const SyncCross = /*#__PURE__*/ (() => {
        function SyncCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 2c2.703 0 5.275 1.1 7.141 3h-4.141v2h6c0.553 0 1-0.447 1-1v-6h-2v3.059c-0.725-0.647-1.525-1.209-2.384-1.666-1.716-0.912-3.659-1.394-5.616-1.394-1.619 0-3.191 0.319-4.672 0.944-1.428 0.603-2.712 1.469-3.813 2.572s-1.966 2.384-2.572 3.813c-0.625 1.481-0.944 3.053-0.944 4.672h2c0-5.512 4.488-10 10-10z" }),
_('path', { d: "M4.859 19h4.141v-2h-6c-0.553 0-1 0.447-1 1v6h2v-3.059c0.725 0.647 1.525 1.209 2.384 1.666 1.719 0.912 3.659 1.394 5.616 1.394v-2c-2.703 0-5.275-1.1-7.141-3z" }),
_('path', { d: "M4 12c0-4.413 3.588-8 8-8v-1c-2.403 0-4.662 0.938-6.363 2.637s-2.637 3.959-2.637 6.363h1z" }),
_('path', { d: "M17.5 9c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zM17.5 21c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 12.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function SyncCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SyncCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SyncCross.SVG = SyncCrossSVG;
        return SyncCross;
    })();
export const SyncGear = /*#__PURE__*/ (() => {
        function SyncGearSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.141 5h-4.141v2h6c0.553 0 1-0.447 1-1v-6h-2v3.059c-0.725-0.647-1.525-1.209-2.384-1.666-1.716-0.912-3.659-1.394-5.616-1.394-1.619 0-3.191 0.319-4.672 0.944-1.428 0.603-2.712 1.469-3.813 2.572s-1.966 2.384-2.572 3.813c-0.625 1.481-0.944 3.053-0.944 4.672h2c0-5.512 4.488-10 10-10 2.703 0 5.275 1.1 7.141 3z" }),
_('path', { d: "M4.859 19h4.141v-2h-6c-0.553 0-1 0.447-1 1v6h2v-3.059c0.725 0.647 1.525 1.209 2.384 1.666 1.719 0.912 3.659 1.394 5.616 1.394v-2c-2.703 0-5.275-1.1-7.141-3z" }),
_('path', { d: "M3 12h1c0-4.413 3.588-8 8-8v-1c-2.403 0-4.662 0.938-6.363 2.637s-2.637 3.959-2.637 6.363z" }),
_('path', { d: "M18.5 15c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM18.5 17c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M23.581 17.694l-1.591-0.919c0.006-0.091 0.009-0.184 0.009-0.281 0-0.094-0.003-0.188-0.009-0.281l1.591-0.919c0.116-0.066 0.2-0.175 0.234-0.303s0.016-0.266-0.050-0.378l-1-1.731c-0.138-0.237-0.444-0.322-0.681-0.184l-1.591 0.919c-0.078-0.053-0.156-0.103-0.241-0.153s-0.166-0.094-0.25-0.131v-1.838c0-0.275-0.225-0.5-0.5-0.5h-2c-0.275 0-0.5 0.225-0.5 0.5v1.838c-0.081 0.041-0.166 0.084-0.25 0.131-0.081 0.047-0.162 0.1-0.241 0.153l-1.591-0.912c-0.237-0.138-0.544-0.056-0.681 0.184l-1 1.731c-0.066 0.116-0.084 0.25-0.050 0.378s0.119 0.237 0.234 0.303l1.591 0.919c-0.006 0.091-0.009 0.184-0.009 0.281 0 0.094 0.003 0.188 0.009 0.281l-1.591 0.919c-0.116 0.066-0.2 0.175-0.234 0.303s-0.016 0.266 0.050 0.378l1 1.731c0.138 0.237 0.444 0.322 0.681 0.184l1.591-0.919c0.078 0.053 0.156 0.103 0.241 0.153s0.166 0.094 0.25 0.131v1.837c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-1.837c0.081-0.041 0.166-0.084 0.25-0.131 0.081-0.047 0.162-0.1 0.241-0.153l1.591 0.912c0.237 0.138 0.544 0.056 0.681-0.184l1-1.731c0.066-0.116 0.084-0.25 0.050-0.378-0.034-0.125-0.119-0.234-0.234-0.303zM22.147 19.178l-1.45-0.831c-0.184-0.106-0.416-0.084-0.575 0.056-0.113 0.097-0.237 0.188-0.372 0.266-0.144 0.081-0.278 0.144-0.412 0.191-0.203 0.069-0.338 0.259-0.338 0.472v1.672h-1v-1.672c0-0.213-0.134-0.403-0.338-0.472-0.134-0.047-0.272-0.109-0.412-0.191-0.134-0.078-0.259-0.166-0.372-0.266-0.162-0.138-0.394-0.159-0.575-0.056l-1.447 0.834-0.5-0.866 1.447-0.834c0.184-0.106 0.281-0.319 0.241-0.528-0.028-0.141-0.041-0.294-0.041-0.453 0-0.162 0.012-0.312 0.041-0.45 0.041-0.209-0.056-0.422-0.241-0.528l-1.45-0.834 0.5-0.866 1.45 0.831c0.184 0.106 0.416 0.084 0.575-0.056 0.113-0.097 0.237-0.188 0.372-0.266 0.144-0.081 0.278-0.144 0.412-0.191 0.203-0.069 0.338-0.259 0.338-0.472v-1.672h1v1.672c0 0.213 0.134 0.403 0.338 0.472 0.134 0.047 0.272 0.109 0.412 0.191 0.134 0.078 0.259 0.166 0.372 0.266 0.162 0.138 0.394 0.159 0.575 0.056l1.447-0.834 0.5 0.866-1.447 0.834c-0.184 0.106-0.281 0.319-0.241 0.528 0.028 0.141 0.041 0.294 0.041 0.453 0 0.162-0.012 0.312-0.041 0.45-0.041 0.209 0.056 0.422 0.241 0.528l1.447 0.834-0.497 0.866z" })
            );
        }
        function SyncGear({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SyncGearSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SyncGear.SVG = SyncGearSVG;
        return SyncGear;
    })();
export const SyncWarning = /*#__PURE__*/ (() => {
        function SyncWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.141 5h-4.141v2h6c0.553 0 1-0.447 1-1v-6h-2v3.059c-0.725-0.647-1.525-1.209-2.384-1.666-1.716-0.912-3.659-1.394-5.616-1.394-1.619 0-3.191 0.319-4.672 0.944-1.428 0.603-2.712 1.469-3.813 2.572s-1.966 2.384-2.572 3.813c-0.625 1.481-0.944 3.053-0.944 4.672h2c0-5.512 4.488-10 10-10 2.703 0 5.275 1.1 7.141 3z" }),
_('path', { d: "M4.859 19h4.141v-2h-6c-0.553 0-1 0.447-1 1v6h2v-3.059c0.725 0.647 1.525 1.209 2.384 1.666 1.719 0.912 3.659 1.394 5.616 1.394v-2c-2.703 0-5.275-1.1-7.141-3z" }),
_('path', { d: "M3 12h1c0-4.413 3.588-8 8-8v-1c-2.403 0-4.662 0.938-6.363 2.637s-2.637 3.959-2.637 6.363z" }),
_('path', { d: "M18 18h1v1h-1v-1z" }),
_('path', { d: "M18 13h1v4h-1v-4z" }),
_('path', { d: "M23.841 18.828l-4-7.997c-0.25-0.506-0.778-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-4 7.997c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h8c0.828 0 1.5-0.672 1.5-1.5 0-0.231-0.056-0.462-0.159-0.669zM22.5 20h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5z" })
            );
        }
        function SyncWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SyncWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SyncWarning.SVG = SyncWarningSVG;
        return SyncWarning;
    })();
export const Sync = /*#__PURE__*/ (() => {
        function SyncSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 2c2.703 0 5.272 1.1 7.141 3h-4.141v2h6c0.553 0 1-0.447 1-1v-6h-2v3.059c-0.725-0.647-1.525-1.209-2.384-1.666-1.716-0.912-3.659-1.394-5.616-1.394-1.619 0-3.191 0.319-4.672 0.944-1.428 0.603-2.712 1.469-3.813 2.572s-1.966 2.384-2.572 3.813c-0.625 1.481-0.944 3.053-0.944 4.672h2c0-5.512 4.488-10 10-10z" }),
_('path', { d: "M22 12c0 5.513-4.488 10-10 10-2.703 0-5.272-1.1-7.141-3h4.141v-2h-6c-0.553 0-1 0.447-1 1v6h2v-3.059c0.725 0.647 1.525 1.209 2.384 1.666 1.719 0.912 3.659 1.394 5.616 1.394 1.619 0 3.191-0.319 4.672-0.944 1.428-0.603 2.712-1.469 3.813-2.572s1.966-2.384 2.572-3.813c0.625-1.481 0.944-3.053 0.944-4.672h-2z" }),
_('path', { d: "M12 3c-2.403 0-4.662 0.938-6.363 2.637s-2.637 3.959-2.637 6.363h1c0-4.413 3.588-8 8-8v-1z" }),
_('path', { d: "M21 12h-1c0 4.413-3.588 8-8 8v1c2.403 0 4.662-0.938 6.363-2.637s2.637-3.959 2.637-6.363z" })
            );
        }
        function Sync({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SyncSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Sync.SVG = SyncSVG;
        return Sync;
    })();
export const Syringe = /*#__PURE__*/ (() => {
    function SyringeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21.856 5.269l0.687 0.687 1.416-1.416-4.5-4.5-1.416 1.416 0.762 0.762c-0.234 0.353-0.625 0.844-1.184 1.403s-1.047 0.95-1.403 1.184l-2.763-2.763-1.416 1.416 1.341 1.341-6.787 6.784c-0.378 0.378-0.584 0.881-0.584 1.416s0.209 1.038 0.584 1.416l0.144 0.144-1.591 1.591c-0.194 0.194-0.194 0.513 0 0.706l0.647 0.647-5 5 0.706 0.703 5-5 0.647 0.647c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l1.591-1.591 0.144 0.144c0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584l6.788-6.788 1.341 1.341 1.416-1.416-2.688-2.688c0.234-0.353 0.625-0.844 1.184-1.403 0.553-0.556 1.044-0.95 1.397-1.184zM7.5 17.794l-1.294-1.294 1.237-1.237 1.294 1.294-1.238 1.238zM16.35 10.644l-1.85-1.85-0.706 0.706 1.85 1.85-0.794 0.794-1.35-1.35-0.706 0.706 1.35 1.35-0.794 0.794-1.85-1.85-0.706 0.706 1.85 1.85-1.644 1.641-2.991-2.991 6.787-6.788 2.991 2.991-1.437 1.441zM18.55 7.137l-1.612-1.612c0.428-0.3 0.912-0.719 1.391-1.197s0.894-0.963 1.197-1.391l1.612 1.612c-0.428 0.3-0.912 0.719-1.391 1.197s-0.894 0.963-1.197 1.391z" })
        );
    }
    function Syringe({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SyringeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Syringe.SVG = SyringeSVG;
    return Syringe;
})();
export const Tab = /*#__PURE__*/ (() => {
        function TabSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8.956 13.456l-1.416-1.416-5.25 5.25c-0.391 0.391-0.391 1.025 0 1.416l5.25 5.25 1.416-1.416-3.541-3.541h18.584v-2h-18.584l3.541-3.544z" }),
_('path', { d: "M15.044 10.544l1.416 1.416 5.25-5.25c0.391-0.391 0.391-1.025 0-1.416l-5.25-5.25-1.416 1.416 3.541 3.541h-18.584v2h18.584l-3.541 3.544z" }),
_('path', { d: "M22 0h2v12h-2v-12z" }),
_('path', { d: "M0 12h2v12h-2v-12z" })
            );
        }
        function Tab({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TabSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Tab.SVG = TabSVG;
        return Tab;
    })();
export const Table = /*#__PURE__*/ (() => {
    function TableSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.156 1.394c-2.194-0.9-5.091-1.394-8.156-1.394s-5.962 0.494-8.156 1.394c-2.478 1.012-3.844 2.472-3.844 4.106v2c0 1.634 1.366 3.094 3.844 4.106 1.709 0.7 3.847 1.153 6.159 1.322v6.203c-1.012 0.138-1.9 0.378-2.578 0.7-1.178 0.556-1.425 1.216-1.425 1.669 0 0.537 0.337 1.3 1.941 1.884 1.091 0.397 2.534 0.616 4.059 0.616s2.969-0.219 4.059-0.616c1.603-0.584 1.941-1.347 1.941-1.884 0-0.453-0.247-1.113-1.419-1.669-0.681-0.322-1.566-0.563-2.581-0.7v-6.203c2.309-0.166 4.447-0.622 6.156-1.322 2.478-1.013 3.844-2.472 3.844-4.106v-2c0-1.634-1.366-3.094-3.844-4.106zM4.6 3.244c1.959-0.803 4.587-1.244 7.4-1.244s5.441 0.441 7.4 1.244c1.603 0.656 2.6 1.522 2.6 2.256s-0.997 1.6-2.6 2.256c-1.959 0.803-4.587 1.244-7.4 1.244s-5.441-0.441-7.4-1.244c-1.603-0.656-2.6-1.522-2.6-2.256s0.997-1.6 2.6-2.256zM17 21.5c0 0.237-0.397 0.622-1.281 0.944-0.984 0.359-2.306 0.556-3.719 0.556s-2.731-0.197-3.719-0.556c-0.884-0.322-1.281-0.706-1.281-0.944 0-0.409 1.038-1.069 3-1.359v0.859c0 0.216 0.1 0.609 0.772 0.85 0.338 0.122 0.772 0.188 1.228 0.188s0.894-0.066 1.228-0.188c0.672-0.241 0.772-0.638 0.772-0.85v-0.859c1.962 0.291 3 0.95 3 1.359zM13 20.866c-0.138 0.069-0.478 0.172-1 0.172s-0.863-0.106-1-0.172l0.003-7.881c0.331 0.012 0.663 0.019 0.997 0.019s0.669-0.006 1-0.019v7.881zM22.228 9.156c-0.556 0.575-1.381 1.087-2.45 1.525-2.078 0.85-4.841 1.319-7.778 1.319s-5.7-0.469-7.778-1.319c-1.069-0.438-1.894-0.95-2.45-1.525-0.416-0.428-0.663-0.875-0.744-1.331 0.65 0.681 1.6 1.284 2.816 1.784 2.194 0.897 5.091 1.394 8.156 1.394s5.963-0.494 8.156-1.394c1.216-0.497 2.166-1.103 2.816-1.784-0.081 0.456-0.328 0.903-0.744 1.331z" })
        );
    }
    function Table({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TableSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Table.SVG = TableSVG;
    return Table;
})();
export const Tablet = /*#__PURE__*/ (() => {
        function TabletSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 0h-16c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h16c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM20 22h-16v-20h16v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M12 3c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 4c0 0 0 0 0 0v0z" }),
_('path', { d: "M15 3.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M11 20h2v1h-2v-1z" })
            );
        }
        function Tablet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TabletSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Tablet.SVG = TabletSVG;
        return Tablet;
    })();
export const Tablet2 = /*#__PURE__*/ (() => {
    function Tablet2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20 0h-16c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h16c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM20 2v1h-16v-1h16zM4 20v-16h16v16h-16zM4 21h7v1h-7v-1zM20 22h-7v-1h7v1c0 0 0 0 0 0z" })
        );
    }
    function Tablet2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Tablet2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tablet2.SVG = Tablet2SVG;
    return Tablet2;
})();
export const Tag = /*#__PURE__*/ (() => {
        function TagSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 2h-5.991c-0.534 0-1.034 0.209-1.413 0.588l-10 10c-0.781 0.781-0.781 2.050 0 2.831l5.991 5.988c0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584l10-10c0.378-0.378 0.588-0.881 0.588-1.413v-6c-0.009-1.1-0.909-1.994-2.006-1.994zM20.003 9.994l-10 10-5.994-5.994 10-10h5.991c0.003 0 0.003 0.003 0.003 0.006v5.988z" }),
_('path', { d: "M17 5c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM17 8c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
            );
        }
        function Tag({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TagSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Tag.SVG = TagSVG;
        return Tag;
    })();
export const Tag2 = /*#__PURE__*/ (() => {
        function Tag2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 5c0-2.756-2.244-5-5-5-2.416 0-4.434 1.722-4.9 4h-2.091c-0.534 0-1.034 0.209-1.413 0.588l-10 10c-0.781 0.781-0.781 2.050 0 2.831l5.991 5.988c0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584l10-10c0.378-0.378 0.588-0.881 0.588-1.413v-2.094c2.275-0.466 3.994-2.487 3.994-4.9zM16 9v0c0 0.55-0.45 1-1 1s-1-0.45-1-1 0.45-1 1-1c0 0 0 0 0 0 0.281 0.375 0.616 0.712 1 1zM18.003 11.994l-10 10-5.994-5.994 10-10h2.091c0.075 0.372 0.194 0.734 0.35 1.075-0.837 0.237-1.453 1.009-1.453 1.925 0 1.103 0.897 2 2 2s2-0.897 2-2c0-0.897-0.594-1.659-1.413-1.913-0.206-0.337-0.363-0.703-0.462-1.088h2.878c0.003 0 0.003 0.003 0.003 0.006v5.988zM20.003 8.872v-2.878c-0.006-1.1-0.906-1.994-2.003-1.994h-2.875c0.444-1.722 2.013-3 3.875-3 2.206 0 4 1.794 4 4 0 1.859-1.275 3.425-2.997 3.872z" }),
_('path', { d: "M4.793 16.5l4.707-4.707 0.707 0.707-4.707 4.707-0.707-0.707z" }),
_('path', { d: "M6.794 18.499l5.708-5.708 0.707 0.707-5.708 5.708-0.707-0.707z" })
            );
        }
        function Tag2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Tag2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Tag2.SVG = Tag2SVG;
        return Tag2;
    })();
export const Tankard = /*#__PURE__*/ (() => {
        function TankardSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.691 8.525c-1.134-0.559-2.497-0.634-3.591-0.397l-0.047-0.319c1.134-0.428 1.947-1.525 1.947-2.809 0-1.653-1.347-3-3-3-0.728 0-1.422 0.263-1.959 0.728-0.372-0.45-0.934-0.728-1.541-0.728-0.322 0-0.638 0.078-0.916 0.222-0.275-0.547-0.672-1.031-1.159-1.406-0.703-0.534-1.541-0.816-2.425-0.816-2.206 0-4 1.794-4 4 0 0.969 0.35 1.903 0.987 2.631 0.291 0.331 0.631 0.612 1.009 0.831l-1.947 13.606c-0.606 0.191-1.050 0.759-1.050 1.431 0 0.828 0.672 1.5 1.5 1.5h14c0.828 0 1.5-0.672 1.5-1.5 0-0.672-0.444-1.241-1.050-1.431l-0.166-1.15c0.466-0.066 0.884-0.169 1.256-0.312 0.775-0.3 1.397-0.791 1.85-1.459 0.778-1.147 1.109-2.834 1.109-5.644 0-1.831-0.819-3.244-2.309-3.978zM6.191 13.231c0.256 0.459 0.747 0.769 1.309 0.769 0.828 0 1.5-0.672 1.5-1.5v-4.5h1v0.5c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-0.5h1.062l1.856 13h-10.837l1.109-7.769zM4 4c0-1.653 1.347-3 3-3 1.325 0 2.513 0.888 2.881 2.163 0.050 0.175 0.194 0.309 0.375 0.35 0.178 0.037 0.366-0.022 0.484-0.162 0.191-0.222 0.469-0.35 0.759-0.35 0.444 0 0.837 0.297 0.959 0.722 0.053 0.184 0.209 0.322 0.4 0.353s0.381-0.050 0.491-0.209c0.375-0.544 0.991-0.866 1.65-0.866 1.103 0 2 0.897 2 2s-0.897 2-2 2h-2.5c-0.275 0-0.5 0.225-0.5 0.5v1c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5v-1c0-0.275-0.225-0.5-0.5-0.5h-2c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5v-5.034c0-0.25-0.181-0.459-0.428-0.494-1.466-0.213-2.572-1.488-2.572-2.972zM17.5 23h-14c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h14c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5zM19.234 17.025c-0.259 0.381-0.675 0.769-1.734 0.916l-1.119-7.822c0.188-0.050 0.419-0.091 0.684-0.106 0.637-0.041 1.253 0.072 1.737 0.309 0.803 0.397 1.194 1.113 1.194 2.187 0.003 2.341-0.231 3.734-0.762 4.516z" }),
_('path', { d: "M7 2c-1.103 0-2 0.897-2 2h1c0-0.55 0.45-1 1-1v-1z" })
            );
        }
        function Tankard({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TankardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Tankard.SVG = TankardSVG;
        return Tankard;
    })();
export const TapAll = /*#__PURE__*/ (() => {
        function TapAllSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.834 5.016c-0.409-1.172-1.525-2.016-2.834-2.016-0.237 0-0.469 0.028-0.697 0.081-0.55-0.659-1.378-1.081-2.303-1.081-0.922 0-1.753 0.419-2.306 1.081-0.225-0.053-0.459-0.081-0.694-0.081-1.653 0-3 1.347-3 3v7.15l-1.128-0.738c-0.406-0.266-0.881-0.409-1.372-0.409-1.378 0-2.5 1.119-2.5 2.497 0 0.541 0.172 1.059 0.497 1.497 0 0.003 0.003 0.003 0.003 0.006l4.525 6.034c0.922 1.228 2.394 1.962 3.934 1.962h4.887c1.85 0 3.525-1.019 4.372-2.656v-0.003c1.166-2.262 1.781-4.803 1.781-7.341v-5.5c0-1.819-1.391-3.316-3.166-3.484zM14.5 5.134c0.15-0.087 0.322-0.134 0.5-0.134 0.55 0 1 0.45 1 1v8h1v-6.916c0.159-0.056 0.328-0.084 0.5-0.084 0.828 0 1.5 0.672 1.5 1.5v5.5c0 2.222-0.537 4.444-1.556 6.425-0.503 0.972-1.497 1.575-2.597 1.575h-4.887c-0.916 0-1.788-0.434-2.334-1.162l-4.522-6.031c-0.047-0.063-0.103-0.169-0.103-0.306 0-0.275 0.225-0.497 0.5-0.497 0.1 0 0.194 0.028 0.275 0.081l2.678 1.753c0.306 0.2 0.7 0.219 1.022 0.044s0.525-0.513 0.525-0.881v-9c0-0.55 0.45-1 1-1 0.178 0 0.35 0.047 0.5 0.134 0.153 0.087 0.278 0.216 0.366 0.366 0.087 0.153 0.134 0.325 0.134 0.5v7h1v-8c0-0.019 0-0.041 0.003-0.059 0.028-0.528 0.466-0.941 0.997-0.941 0.55 0 1 0.45 1 1v8h1v-7c0-0.175 0.047-0.347 0.134-0.5s0.213-0.278 0.366-0.366z" }),
_('path', { d: "M22 5h-1c0-1.103-0.897-2-2-2v-1c1.653 0 3 1.347 3 3zM19 0v1c2.206 0 4 1.794 4 4h1c0-2.756-2.244-5-5-5z" }),
_('path', { d: "M3 5h-1c0-1.653 1.347-3 3-3v1c-1.103 0-2 0.897-2 2zM5 1v-1c-2.756 0-5 2.244-5 5h1c0-2.206 1.794-4 4-4z" })
            );
        }
        function TapAll({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TapAllSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TapAll.SVG = TapAllSVG;
        return TapAll;
    })();
export const TapTwo = /*#__PURE__*/ (() => {
        function TapTwoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.5 9c-0.087 0-0.172 0.003-0.256 0.009-0.55-0.619-1.353-1.009-2.244-1.009v-4c0-1.653-1.347-3-3-3-0.925 0-1.753 0.422-2.303 1.081-0.228-0.053-0.459-0.081-0.697-0.081-1.653 0-3 1.347-3 3v7.15l-1.128-0.738c-0.406-0.266-0.881-0.409-1.372-0.409-1.378 0-2.5 1.119-2.5 2.497 0 0.541 0.172 1.059 0.497 1.497 0 0.003 0.003 0.003 0.003 0.006l4.525 6.034c0.922 1.228 2.394 1.962 3.934 1.962h4.887c1.85 0 3.525-1.019 4.372-2.656 0 0 0-0.003 0-0.003 1.166-2.262 1.781-4.803 1.781-7.341v-0.5c0-1.931-1.569-3.5-3.5-3.5zM15.444 10.169c0.166-0.109 0.359-0.169 0.556-0.169 0.55 0 1 0.45 1 1v2h1v-1.913c0.159-0.056 0.328-0.087 0.5-0.087 0.828 0 1.5 0.672 1.5 1.5v0.5c0 2.222-0.537 4.444-1.556 6.425-0.503 0.972-1.497 1.575-2.597 1.575h-4.887c-0.916 0-1.788-0.434-2.334-1.163l-4.522-6.031c-0.047-0.063-0.103-0.169-0.103-0.306 0-0.275 0.225-0.497 0.5-0.497 0.1 0 0.194 0.028 0.275 0.081l2.678 1.753c0.306 0.2 0.7 0.219 1.022 0.044s0.525-0.513 0.525-0.881v-9c0-0.55 0.45-1 1-1 0.2 0 0.391 0.059 0.559 0.169v0c0.125 0.084 0.231 0.197 0.309 0.331 0.087 0.153 0.134 0.325 0.134 0.5v7h1v-8c0-0.55 0.45-1 1-1s1 0.45 1 1v8h1v-1c0-0.175 0.047-0.35 0.134-0.5 0.072-0.134 0.178-0.247 0.306-0.331z" }),
_('path', { d: "M5.816 3.131l-3.947-1.316 0.316-0.95 3.95 1.316-0.319 0.95zM6.131 4.816l-0.316-0.95-3.947 1.319 0.316 0.95 3.947-1.319zM21.131 1.816l-0.316-0.95-3.947 1.319 0.316 0.95 3.947-1.319zM21.131 5.184l-3.95-1.316-0.316 0.95 3.95 1.316 0.316-0.95z" })
            );
        }
        function TapTwo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TapTwoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TapTwo.SVG = TapTwoSVG;
        return TapTwo;
    })();
export const Tap = /*#__PURE__*/ (() => {
        function TapSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18.5 9c-0.087 0-0.172 0.003-0.256 0.009-0.55-0.619-1.353-1.009-2.244-1.009-0.237 0-0.469 0.028-0.697 0.081-0.55-0.659-1.378-1.081-2.303-1.081v-2c0-1.653-1.347-3-3-3s-3 1.347-3 3v7.15l-1.128-0.738c-0.406-0.266-0.881-0.409-1.372-0.409-1.378 0-2.5 1.119-2.5 2.497 0 0.541 0.172 1.059 0.497 1.497 0 0.003 0.003 0.003 0.003 0.006l4.525 6.034c0.922 1.228 2.394 1.962 3.934 1.962h4.887c1.85 0 3.525-1.019 4.372-2.656v-0.003c1.166-2.262 1.781-4.803 1.781-7.341v-0.5c0-1.931-1.569-3.5-3.5-3.5zM15.5 10.134c0.15-0.087 0.322-0.134 0.5-0.134 0.55 0 1 0.45 1 1v2h1v-1.916c0.159-0.056 0.328-0.084 0.5-0.084 0.828 0 1.5 0.672 1.5 1.5v0.5c0 2.222-0.537 4.444-1.556 6.425-0.503 0.972-1.497 1.575-2.597 1.575h-4.887c-0.916 0-1.788-0.434-2.334-1.162l-4.522-6.031c-0.047-0.063-0.103-0.169-0.103-0.306 0-0.275 0.225-0.497 0.5-0.497 0.1 0 0.194 0.028 0.275 0.081l2.678 1.753c0.306 0.2 0.7 0.219 1.022 0.044s0.525-0.513 0.525-0.881v-9c0-0.55 0.45-1 1-1s1 0.45 1 1v7h1v-2c0-0.175 0.047-0.347 0.134-0.5s0.216-0.278 0.366-0.366c0.15-0.087 0.322-0.134 0.5-0.134 0.55 0 1 0.45 1 1v2h1v-1c0-0.175 0.047-0.347 0.134-0.5s0.213-0.278 0.366-0.366z" }),
_('path', { d: "M5.816 3.131l-3.947-1.316 0.316-0.95 3.95 1.316-0.319 0.95zM6.131 4.816l-0.316-0.95-3.947 1.319 0.316 0.95 3.947-1.319zM18.131 1.816l-0.316-0.95-3.947 1.319 0.316 0.95 3.947-1.319zM18.131 5.184l-3.95-1.316-0.316 0.95 3.95 1.316 0.316-0.95z" })
            );
        }
        function Tap({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TapSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Tap.SVG = TapSVG;
        return Tap;
    })();
export const TapeDispenser = /*#__PURE__*/ (() => {
    function TapeDispenserSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.381 8.075c-0.366-0.153-0.788-0.072-1.072 0.2l-8.197-2.412c-0.859-1.4-2.284-2.444-4.022-2.766-2.941-0.541-5.784 1.169-6.747 3.903h-0.344c-0.35 0-0.678 0.184-0.856 0.484-1.575 2.625-1.966 6-2.141 8.956-0.016 0.247 0.063 0.491 0.219 0.684l2 2.5c0.191 0.237 0.478 0.375 0.781 0.375h18c0.266 0 0.519-0.106 0.706-0.294l2-2c0.188-0.188 0.294-0.441 0.294-0.706v-8c-0.003-0.403-0.247-0.769-0.622-0.925zM21.503 9.081l-3.909 3.912c-1.253-0.041-2.419-0.275-3.556-0.728 0.425-0.656 0.719-1.391 0.866-2.175 0.194-1.044 0.103-2.075-0.219-3.016l6.819 2.006zM9.909 4.084c2.712 0.5 4.509 3.116 4.006 5.825-0.131 0.703-0.403 1.359-0.803 1.938-0.569-0.294-1.137-0.644-1.703-1.056 0.691-0.934 0.806-2.228 0.188-3.294-0.831-1.431-2.669-1.919-4.1-1.091-0.278 0.162-0.525 0.363-0.734 0.594h-2.347c0.909-2.081 3.166-3.347 5.494-2.916zM10.619 10.175c-0.916-0.756-1.844-1.675-2.816-2.778 0.063-0.047 0.128-0.087 0.194-0.128 0.953-0.553 2.181-0.228 2.734 0.728 0.406 0.703 0.337 1.556-0.113 2.178zM22 16.584l-1.416 1.416h-17.103l-1.459-1.822c0.159-2.425 0.494-5.091 1.566-7.178h2.962c1.909 2.119 3.725 3.616 5.544 4.572 1.85 0.975 3.728 1.428 5.906 1.428 0.266 0 0.519-0.106 0.706-0.294l3.294-3.291v5.169z" })
        );
    }
    function TapeDispenser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TapeDispenserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    TapeDispenser.SVG = TapeDispenserSVG;
    return TapeDispenser;
})();
export const TapeMeasure = /*#__PURE__*/ (() => {
        function TapeMeasureSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.5 16h-9.5v-2h1.5c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5h-1.788c-0.328-1.103-0.925-2.112-1.762-2.95-1.322-1.322-3.081-2.050-4.95-2.050s-3.628 0.728-4.95 2.050c-1.322 1.322-2.050 3.081-2.050 4.95v5c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2h9v2h1v-2.5c0-0.275-0.225-0.5-0.5-0.5zM15 11v2h-1v-1c0-0.338-0.025-0.672-0.072-1h1.072zM12 17h-10v-5c0-2.756 2.244-5 5-5s5 2.244 5 5v5z" }),
_('path', { d: "M7 9c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM7 14c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2c0 1.103-0.897 2-2 2z" })
            );
        }
        function TapeMeasure({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TapeMeasureSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TapeMeasure.SVG = TapeMeasureSVG;
        return TapeMeasure;
    })();
export const Tape = /*#__PURE__*/ (() => {
        function TapeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.088 9.447c-0.537-0.706-1.291-1.331-2.238-1.856-1.847-1.025-4.278-1.591-6.85-1.591-5.703 0-11.363-2.978-13.075-5.763-0.116-0.191-0.347-0.281-0.563-0.219-0.213 0.063-0.363 0.256-0.363 0.481v1c0 0.131 0.053 0.259 0.147 0.353l0.647 0.647-0.647 0.647c-0.194 0.194-0.194 0.513 0 0.706l0.647 0.647-0.647 0.647c-0.194 0.194-0.194 0.513 0 0.706l0.647 0.647-0.647 0.647c-0.162 0.162-0.194 0.419-0.072 0.616 0.769 1.25 2.169 2.487 3.991 3.541-0.041 0.231-0.063 0.462-0.063 0.7v6c0 0.9 0.306 1.756 0.912 2.553 0.537 0.706 1.291 1.331 2.238 1.856 1.844 1.022 4.275 1.587 6.847 1.587s5.003-0.566 6.85-1.591c0.947-0.528 1.7-1.153 2.238-1.856 0.606-0.794 0.912-1.653 0.912-2.553v-6c0-0.9-0.306-1.756-0.912-2.553zM1.144 7.563l0.709-0.709c0.194-0.194 0.194-0.513 0-0.706l-0.647-0.647 0.647-0.647c0.194-0.194 0.194-0.513 0-0.706l-0.647-0.647 0.647-0.647c0.019-0.019 0.034-0.034 0.047-0.056 0.997 0.837 2.247 1.622 3.663 2.281 1.366 0.634 2.816 1.122 4.278 1.447-0.981 0.263-1.891 0.622-2.691 1.066-0.947 0.528-1.7 1.153-2.238 1.856-0.216 0.284-0.394 0.578-0.534 0.878-1.413-0.844-2.55-1.809-3.234-2.763zM8.122 9.337c1.553-0.862 3.641-1.338 5.878-1.338s4.325 0.475 5.878 1.338c1.347 0.75 2.122 1.719 2.122 2.663s-0.772 1.913-2.122 2.663c-1.553 0.862-3.641 1.338-5.878 1.338s-4.325-0.475-5.878-1.338c-1.347-0.75-2.122-1.719-2.122-2.663s0.772-1.913 2.122-2.663zM19.878 20.663c-1.553 0.862-3.641 1.338-5.878 1.338s-4.325-0.475-5.878-1.338c-1.347-0.75-2.122-1.719-2.122-2.663v-2.353c0.344 0.272 0.728 0.528 1.15 0.762 1.847 1.025 4.278 1.591 6.85 1.591s5.003-0.566 6.85-1.591c0.422-0.234 0.806-0.491 1.15-0.762v2.353c0 0.944-0.772 1.913-2.122 2.663z" }),
_('path', { d: "M11.328 13.519c0.722 0.309 1.672 0.481 2.672 0.481s1.95-0.172 2.672-0.481c1.156-0.494 1.328-1.166 1.328-1.519 0-0.356-0.172-1.025-1.328-1.519-0.722-0.309-1.672-0.481-2.672-0.481s-1.95 0.172-2.672 0.481c-1.156 0.494-1.328 1.166-1.328 1.519 0 0.356 0.172 1.025 1.328 1.519zM14 11c1.863 0 3 0.647 3 1s-1.137 1-3 1-3-0.647-3-1c0-0.353 1.137-1 3-1z" })
            );
        }
        function Tape({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TapeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Tape.SVG = TapeSVG;
        return Tape;
    })();
export const Target = /*#__PURE__*/ (() => {
        function TargetSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.962 2.309c-0.078-0.188-0.259-0.309-0.462-0.309h-1.5v-1.5c0-0.203-0.122-0.384-0.309-0.462s-0.403-0.034-0.544 0.109l-3 3c-0.094 0.094-0.147 0.222-0.147 0.353v1.794l-1 1c-1.65-1.484-3.762-2.294-6-2.294-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363 0-2.238-0.809-4.35-2.291-6l1-1h1.791c0.131 0 0.259-0.053 0.353-0.147l3-3c0.144-0.144 0.188-0.356 0.109-0.544zM18 13c0 3.859-3.141 7-7 7s-7-3.141-7-7c0-3.859 3.141-7 7-7 1.75 0 3.353 0.647 4.581 1.713l-1.419 1.419c-0.862-0.706-1.962-1.131-3.162-1.131-2.756 0-5 2.244-5 5s2.244 5 5 5c2.756 0 5-2.244 5-5 0-1.2-0.425-2.3-1.131-3.162l1.419-1.419c1.066 1.228 1.713 2.831 1.713 4.581zM14 13c0 1.653-1.347 3-3 3s-3-1.347-3-3 1.347-3 3-3c0.647 0 1.247 0.206 1.737 0.556l-1.478 1.478c-0.081-0.022-0.169-0.034-0.259-0.034-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1c0-0.091-0.012-0.175-0.034-0.259l1.478-1.478c0.35 0.491 0.556 1.091 0.556 1.737zM11 13v0c0 0 0 0 0 0zM20.294 5h-1.294v-1.294l2-2v0.794c0 0.275 0.225 0.5 0.5 0.5h0.794l-2 2z" }),
_('path', { d: "M11 23c-5.512 0-10-4.488-10-10s4.488-10 10-10v-1c-1.484 0-2.925 0.291-4.281 0.866-1.309 0.553-2.487 1.347-3.497 2.356s-1.803 2.184-2.356 3.497c-0.575 1.356-0.866 2.797-0.866 4.281s0.291 2.925 0.866 4.281c0.553 1.309 1.347 2.487 2.356 3.497s2.187 1.803 3.497 2.356c1.356 0.575 2.797 0.866 4.281 0.866s2.925-0.291 4.281-0.866c1.309-0.553 2.487-1.347 3.497-2.356s1.803-2.187 2.356-3.497c0.575-1.356 0.866-2.797 0.866-4.281h-1c0 5.512-4.488 10-10 10z" })
            );
        }
        function Target({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TargetSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Target.SVG = TargetSVG;
        return Target;
    })();
export const Taxi = /*#__PURE__*/ (() => {
    function TaxiSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23 7h-1.25c-0.322 0-0.653 0.197-0.809 0.475l-0.422 0.756c-0.106-0.275-0.203-0.578-0.303-0.9-0.206-0.663-0.444-1.416-0.862-2.103-0.559-0.916-1.656-1.534-3.353-1.887v-0.841c0-0.828-0.672-1.5-1.5-1.5h-5c-0.828 0-1.5 0.672-1.5 1.5v0.841c-1.697 0.353-2.794 0.972-3.353 1.887-0.422 0.687-0.656 1.441-0.866 2.103-0.1 0.322-0.197 0.625-0.303 0.9l-0.422-0.756c0 0 0-0.003-0.003-0.003-0.156-0.278-0.491-0.472-0.806-0.472h-1.247c-0.55 0-1 0.45-1 1s0.45 1 1 1h1.763l0.119 0.213c-0.009 0.009-0.022 0.019-0.031 0.028-0.619 0.531-1.156 1.053-1.472 2.072-0.272 0.869-0.375 2.041-0.375 4.188v1c0 0.744 0.4 1.481 1 1.928v2.072c0 0.828 0.672 1.5 1.5 1.5h2c0.828 0 1.5-0.672 1.5-1.5v-0.825c1.394 0.184 3.081 0.325 5 0.325s3.606-0.141 5-0.325v0.825c0 0.828 0.672 1.5 1.5 1.5h2c0.828 0 1.5-0.672 1.5-1.5v-2.072c0.6-0.45 1-1.188 1-1.928v-1c0-2.069-0.122-3.331-0.406-4.219-0.325-1.019-0.869-1.547-1.441-2.041-0.012-0.009-0.022-0.019-0.034-0.028l0.119-0.213h1.759c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 14c-1.1 0-2.216 0.172-3.028 0.334-0.022-0.066-0.059-0.128-0.113-0.181-0.081-0.084-2.016-2.059-5.603-2.15 0.15-0.519 0.372-0.781 0.678-1.059 4.916-1.263 11.203-1.266 16.122 0 0.284 0.259 0.506 0.525 0.663 1.059-3.572 0.097-5.5 2.066-5.581 2.15-0.050 0.053-0.087 0.116-0.112 0.181-0.809-0.162-1.925-0.334-3.025-0.334zM3.087 13c1.684 0.016 2.956 0.506 3.731 0.919 0.409 0.219 0.728 0.438 0.947 0.606l-0.472 0.475c-2.128-0.006-3.144-0.138-4.278-0.775 0.012-0.484 0.038-0.888 0.072-1.225zM16.234 14.528c0.222-0.172 0.541-0.391 0.947-0.606 0.775-0.413 2.044-0.9 3.719-0.919 0.038 0.341 0.063 0.744 0.078 1.225-1.131 0.638-2.147 0.766-4.275 0.775l-0.469-0.475zM9.5 2h5c0.275 0 0.5 0.225 0.5 0.5v0.675c-0.878-0.116-1.866-0.175-3-0.175s-2.122 0.056-3 0.175v-0.675c0-0.275 0.225-0.5 0.5-0.5zM5.691 7.928c0.191-0.606 0.369-1.178 0.663-1.659 0.375-0.612 2.056-1.269 5.647-1.269s5.272 0.656 5.647 1.272c0.294 0.478 0.472 1.050 0.663 1.656 0.178 0.566 0.369 1.178 0.678 1.741-1.563-0.319-3.225-0.525-4.919-0.616l2.125-1.416-0.556-0.831-3.291 2.194c-1.128-0.009-2.262 0.028-3.375 0.119l2.222-1.481-0.556-0.831-3.828 2.556c-0.609 0.087-1.209 0.191-1.797 0.312 0.309-0.569 0.503-1.178 0.678-1.747zM6 20.5c0 0.275-0.225 0.5-0.5 0.5h-2c-0.275 0-0.5-0.225-0.5-0.5v-1.625c0.513 0.147 1.547 0.416 3 0.653v0.972zM3.266 16.866h-0.003c-0.109-0.038-0.263-0.247-0.263-0.366v-1c0-0.053 0-0.109 0-0.162 1.212 0.559 2.444 0.663 4.5 0.663 0.131 0 0.259-0.053 0.353-0.147l0.306-0.306c0.469-0.122 2.206-0.547 3.841-0.547 1.638 0 3.372 0.425 3.841 0.547l0.306 0.306c0.094 0.094 0.222 0.147 0.353 0.147 2.056 0 3.288-0.103 4.5-0.663 0 0.053 0 0.106 0 0.162v1c0 0.119-0.153 0.328-0.266 0.366-0.034 0.012-3.484 1.134-8.734 1.134s-8.7-1.122-8.734-1.134zM20.5 21h-2c-0.275 0-0.5-0.225-0.5-0.5v-0.972c1.453-0.237 2.487-0.503 3-0.653v1.625c0 0.275-0.225 0.5-0.5 0.5z" })
        );
    }
    function Taxi({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TaxiSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Taxi.SVG = TaxiSVG;
    return Taxi;
})();
export const TeaBag = /*#__PURE__*/ (() => {
        function TeaBagSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 10h3v1h-3v-1z" }),
_('path', { d: "M22.5 2h-4c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.131 0.053 0.259 0.147 0.353l1.85 1.85c-0.075 1.581-1.031 2.303-1.925 2.303-0.522 0-1.013-0.241-1.378-0.681-0.453-0.541-0.691-1.344-0.691-2.325 0-2.269-0.872-3.669-1.603-4.444-0.941-1-2.238-1.572-3.556-1.572-1.3 0-2.494 0.537-3.366 1.516-0.784 0.881-1.269 2.078-1.422 3.5h-1.519c-0.672 0-1.294 0.334-1.662 0.891l-1.534 2.303c0 0 0 0.003-0.003 0.003-0.219 0.331-0.334 0.716-0.334 1.106v8.697c0 1.103 0.897 2 2 2h7c1.103 0 2-0.897 2-2v-8.697c0-0.394-0.116-0.775-0.334-1.106 0 0 0-0.003-0.003-0.003l-1.534-2.3c-0.369-0.559-0.994-0.891-1.666-0.891h-1.406c0.141-1.162 0.534-2.131 1.163-2.834 0.678-0.762 1.609-1.181 2.619-1.181 2.066-0.003 4.159 1.719 4.159 5.013 0 1.216 0.319 2.244 0.925 2.966 0.559 0.669 1.322 1.038 2.147 1.038 1.409 0 2.838-1.131 2.925-3.294l1.856-1.856c0.094-0.094 0.147-0.222 0.147-0.353v-4c0-0.275-0.225-0.5-0.5-0.5zM8.466 9l1.531 2.297c0.003 0.003 0.003 0.006 0.003 0.006v8.697h-7v-8.697c0 0 0-0.003 0.003-0.006l1.531-2.3c0 0 0 0 0 0l3.931 0.003zM22 6.294l-1.5 1.5-1.5-1.5v-3.294h3v3.294z" })
            );
        }
        function TeaBag({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TeaBagSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TeaBag.SVG = TeaBagSVG;
        return TeaBag;
    })();
export const Teacup = /*#__PURE__*/ (() => {
        function TeacupSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.5 19h-6.316c0.044-0.038 0.084-0.078 0.128-0.116 0.528-0.497 1.050-1.156 1.531-1.928 1.491-0.153 2.738-0.697 3.641-1.591 0.978-0.972 1.516-2.344 1.516-3.863 0-0.275-0.225-0.5-0.5-0.5h-2.553c0.034-0.341 0.053-0.678 0.053-1v-0.5c0-0.275-0.225-0.5-0.5-0.5h-16c-0.275 0-0.5 0.225-0.5 0.5v0.5c0 2.006 0.703 4.434 1.881 6.497 0.553 0.969 1.178 1.794 1.806 2.388 0.044 0.041 0.084 0.078 0.128 0.116h-5.316c-0.275 0-0.5 0.225-0.5 0.5v0.5c0 0.453 0.144 1.119 0.828 1.703 0.384 0.331 0.909 0.603 1.563 0.813 1.322 0.419 2.828 0.481 3.609 0.481h10c0.781 0 2.288-0.063 3.612-0.484 0.65-0.206 1.175-0.481 1.563-0.813 0.684-0.588 0.828-1.25 0.828-1.703v-0.5c-0.003-0.275-0.228-0.5-0.503-0.5zM21.975 12c-0.162 1.691-1.166 3.356-3.513 3.853 0.628-1.237 1.088-2.575 1.331-3.853h2.181zM6.619 15.503c-1.013-1.772-1.619-3.831-1.619-5.503h11c0 1.156-0.406 2.656-1.084 4.009-0.234 0.469-0.491 0.894-0.756 1.266l-0.291 0.406 0.813 0.581 0.291-0.406c0.297-0.412 0.578-0.884 0.837-1.4 0.744-1.484 1.191-3.15 1.191-4.456h1c0 1.672-0.606 3.731-1.619 5.503-0.456 0.8-0.956 1.466-1.444 1.925-0.447 0.422-0.784 0.572-0.938 0.572h-5c-0.153 0-0.494-0.15-0.938-0.572-0.488-0.459-0.987-1.125-1.444-1.925zM20.006 20.609c-0.778 0.247-1.872 0.391-3.006 0.391h-10c-1.131 0-2.228-0.144-3.006-0.391-0.725-0.231-0.994-0.497-0.994-0.609h18c0 0.113-0.269 0.378-0.994 0.609z" }),
_('path', { d: "M11.463 6.206l0.709-0.706-0.353-0.353c-0.828-0.831-0.828-1.134-0.819-1.188 0.019-0.122 0.363-0.3 0.616-0.428 0.331-0.172 0.709-0.366 0.987-0.675 0.359-0.397 0.475-0.894 0.341-1.469l-0.112-0.487-0.972 0.225 0.112 0.488c0.109 0.478-0.075 0.65-0.813 1.031-0.491 0.253-1.047 0.537-1.147 1.162-0.087 0.563 0.25 1.194 1.097 2.047l0.353 0.353z" })
            );
        }
        function Teacup({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TeacupSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Teacup.SVG = TeacupSVG;
        return Teacup;
    })();
export const Telephone = /*#__PURE__*/ (() => {
    function TelephoneSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.413 17.209l-3.597-3.594c-0.375-0.378-0.878-0.584-1.409-0.584h-0.003c-0.534 0-1.034 0.209-1.413 0.591l-0.5 0.5c-0.237 0.237-0.409 0.531-0.506 0.853-0.078 0.172-0.616 0.794-1.547 0.975-1.159 0.228-2.456-0.337-3.75-1.631-1.294-1.297-1.856-2.594-1.628-3.756 0.184-0.931 0.806-1.466 0.975-1.541 0.328-0.1 0.616-0.269 0.853-0.506l0.5-0.5c0.378-0.378 0.588-0.881 0.588-1.416s-0.209-1.038-0.588-1.419l-3.597-3.594c-0.781-0.781-2.053-0.781-2.831-0.003l-0.706 0.703c-1.062 1.066-1.759 2.328-2.069 3.759-0.281 1.3-0.237 2.709 0.128 4.191 0.656 2.653 2.316 5.416 4.678 7.775 2.359 2.359 5.122 4.022 7.775 4.675 0.841 0.206 1.656 0.312 2.444 0.312 0.603 0 1.188-0.063 1.75-0.184 1.431-0.309 2.697-1.006 3.762-2.072l0.003-0.003 0.697-0.703c0.375-0.378 0.584-0.881 0.584-1.416-0.006-0.531-0.216-1.034-0.594-1.413zM16.903 15.534l0.5-0.5c0 0 0 0 0 0l3.594 3.591c0 0 0 0.006 0 0.006l-0.003 0.003-0.697 0.703c-0.044 0.044-0.087 0.087-0.131 0.128l-3.469-3.469c0.091-0.156 0.159-0.309 0.2-0.456 0.003-0.003 0.006-0.006 0.006-0.006zM5.369 3c0 0 0.003 0 0.003 0s0.003 0 0.003 0l3.597 3.594c0 0 0 0.006 0 0.006l-0.5 0.5c0 0-0.006 0.003-0.016 0.006-0.144 0.041-0.294 0.109-0.447 0.197l-3.469-3.472c0.041-0.044 0.084-0.087 0.125-0.131l0.703-0.7zM14.244 20.747c-2.272-0.563-4.766-2.075-6.841-4.15s-3.588-4.566-4.15-6.837c-0.356-1.437-0.478-3.4 0.663-5.137l3.316 3.316c-0.459 0.494-0.866 1.169-1.075 1.972-0.231 0.888-0.194 1.809 0.106 2.741 0.337 1.050 1.016 2.088 2.009 3.081s2.031 1.672 3.078 2.009c0.928 0.3 1.85 0.337 2.737 0.106 0.803-0.206 1.481-0.616 1.975-1.075l3.312 3.312c-1.734 1.141-3.694 1.019-5.131 0.663z" })
        );
    }
    function Telephone({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TelephoneSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Telephone.SVG = TelephoneSVG;
    return Telephone;
})();
export const Telephone2 = /*#__PURE__*/ (() => {
        function Telephone2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 12c-2.244 0-4 1.097-4 2.5s1.756 2.5 4 2.5c2.244 0 4-1.097 4-2.5s-1.756-2.5-4-2.5zM12 16c-1.769 0-3-0.791-3-1.5s1.231-1.5 3-1.5 3 0.791 3 1.5-1.231 1.5-3 1.5z" }),
_('path', { d: "M19.209 5.056c-1.919-0.681-4.478-1.056-7.209-1.056s-5.291 0.375-7.209 1.056c-3.134 1.116-3.791 2.759-3.791 3.944v1c0 1.103 0.897 2 2 2h0.378c-0.181 0.25-0.347 0.513-0.497 0.784-0.575 1.041-0.881 2.153-0.881 3.216v2c0 1.103 0.897 2 2 2h16c1.103 0 2-0.897 2-2v-2c0-1.062-0.306-2.175-0.881-3.216-0.15-0.272-0.316-0.534-0.497-0.784h0.378c1.103 0 2-0.897 2-2v-1c0-1.184-0.656-2.828-3.791-3.944zM20 16v2h-16v-2c0-1.419 0.866-3.025 2.134-4h0.866c1.103 0 2-0.897 2-2 0-0.406 1.169-1 3-1 0.897 0 1.753 0.15 2.344 0.412 0.153 0.069 0.656 0.312 0.656 0.588 0 1.103 0.897 2 2 2h0.866c1.269 0.975 2.134 2.581 2.134 4zM21 10h-4c0-0.597-0.241-1.7-1.844-2.412-0.85-0.378-1.972-0.588-3.156-0.588s-2.306 0.209-3.156 0.588c-1.603 0.712-1.844 1.819-1.844 2.412h-4v-1c0-1.028 1.541-1.731 2.459-2.056 1.684-0.6 4.069-0.944 6.541-0.944s4.856 0.344 6.541 0.944c0.919 0.328 2.459 1.028 2.459 2.056v1c0 0 0 0 0 0z" })
            );
        }
        function Telephone2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Telephone2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Telephone2.SVG = Telephone2SVG;
        return Telephone2;
    })();
export const Telephone3 = /*#__PURE__*/ (() => {
        function Telephone3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.5 4h-7c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h7c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5zM20 7h-6v-2h6v2z" }),
_('path', { d: "M21 1h-9.806c-0.103-0.078-0.216-0.147-0.334-0.203-2.228-1.066-4.491-1.066-6.719 0-0.119 0.056-0.231 0.125-0.334 0.203h-0.806c-1.653 0-3 1.347-3 3v16c0 1.653 1.347 3 3 3h0.806c0.103 0.078 0.216 0.147 0.334 0.203 1.116 0.531 2.238 0.8 3.359 0.8s2.244-0.266 3.359-0.8c0.119-0.056 0.231-0.125 0.334-0.203h9.806c1.653 0 3-1.347 3-3v-16c0-1.653-1.347-3-3-3zM2 20v-16c0-0.55 0.45-1 1-1v18c-0.55 0-1-0.45-1-1zM9.997 21.397c-1.681 0.803-3.312 0.803-4.994 0-0.003 0-0.003-0.003-0.003-0.003s0 0 0 0v-18.791c0 0 0-0.003 0.003-0.003 1.681-0.803 3.312-0.803 4.994 0 0.003 0 0.003 0.003 0.003 0.003v18.791c0 0.003 0 0.003-0.003 0.003zM22 20c0 0.55-0.45 1-1 1h-9v-18h9c0.55 0 1 0.45 1 1v16z" }),
_('path', { d: "M14 9c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM14 10c0 0 0 0 0 0v0zM17 9c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM17 10c0 0 0 0 0 0v0zM20 9c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM20 10c0 0 0 0 0 0v0zM14 12c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM14 13c0 0 0 0 0 0v0zM17 12c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM17 13c0 0 0 0 0 0v0zM20 12c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM20 13c0 0 0 0 0 0v0zM14 15c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM14 16c0 0 0 0 0 0v0zM17 15c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM17 16c0 0 0 0 0 0v0zM20 15c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM20 16c0 0 0 0 0 0v0zM17 18c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM17 19c0 0 0 0 0 0v0z" })
            );
        }
        function Telephone3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Telephone3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Telephone3.SVG = Telephone3SVG;
        return Telephone3;
    })();
export const Telescope = /*#__PURE__*/ (() => {
    function TelescopeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.825 5.187c-0.303-1.059-0.984-2.156-1.919-3.094-0.934-0.934-2.034-1.616-3.094-1.919-1.244-0.356-2.369-0.15-3.078 0.559v0l-5 5c-0.603 0.603-0.844 1.466-0.694 2.466l-4.431 4.409c-0.547 0.547-0.728 1.366-0.525 2.272l-4.603 4.603c-0.003 0.003-0.003 0.003-0.006 0.006-0.447 0.453-0.588 1.134-0.381 1.869 0.153 0.544 0.491 1.103 0.953 1.572 0.659 0.669 1.481 1.069 2.206 1.069v0c0.475 0 0.909-0.172 1.219-0.484l4.609-4.609c0.922 0.216 1.756 0.037 2.309-0.516l4.431-4.428c0.347 0.047 0.678 0.050 0.991 0.006 0.572-0.081 1.075-0.325 1.453-0.703l5-5c0.713-0.712 0.916-1.834 0.559-3.078zM16.853 11.853c-0.063 0.063-0.159 0.106-0.281 0.131-0.15-0.019-0.306-0.050-0.472-0.097-0.819-0.234-1.687-0.781-2.447-1.537-0.759-0.759-1.303-1.625-1.537-2.444-0.047-0.169-0.081-0.328-0.1-0.481 0.025-0.116 0.069-0.209 0.131-0.272l3.1-3.1c0.331 0.984 0.981 1.991 1.847 2.859 0.394 0.394 0.819 0.744 1.256 1.038l-2.556 2.55 0.706 0.706 2.744-2.744c0.234 0.113 0.472 0.213 0.706 0.291l-3.097 3.1zM18.266 2.097c0.728 0.206 1.541 0.722 2.228 1.409s1.203 1.5 1.409 2.228c0.147 0.509 0.125 0.938-0.050 1.116-0.178 0.178-0.606 0.197-1.116 0.050-0.728-0.206-1.541-0.722-2.228-1.409s-1.203-1.5-1.409-2.228c-0.147-0.509-0.125-0.938 0.050-1.116v0c0.175-0.175 0.603-0.194 1.116-0.050zM11.672 9.394c0.319 0.566 0.747 1.131 1.275 1.659 0.534 0.534 1.103 0.963 1.675 1.284l-4.628 4.625c-0.544-0.112-1.231-0.481-1.856-1.103-0.622-0.619-0.991-1.306-1.103-1.847l4.638-4.619zM3.172 21.987c-0.144-0.038-0.416-0.169-0.7-0.459-0.303-0.309-0.428-0.603-0.462-0.747l4.859-4.859c0.166 0.222 0.356 0.441 0.559 0.644 0.197 0.197 0.406 0.378 0.622 0.541l-4.878 4.881z" })
        );
    }
    function Telescope({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TelescopeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Telescope.SVG = TelescopeSVG;
    return Telescope;
})();
export const TennisBall = /*#__PURE__*/ (() => {
    function TennisBallSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM16.366 3.006c-2.172 2.669-1.347 4.616-0.475 6.666 0.547 1.281 1.109 2.609 1.109 4.328 0 2.756-2.244 5-5 5s-5-2.244-5-5c0-1.719 0.563-3.047 1.109-4.331 0.872-2.050 1.697-3.994-0.475-6.666 1.319-0.641 2.8-1.003 4.366-1.003s3.047 0.363 4.366 1.006zM12 22c-5.512 0-10-4.488-10-10 0-3.588 1.897-6.738 4.744-8.503 1.938 2.275 1.3 3.772 0.447 5.781-0.556 1.313-1.188 2.797-1.188 4.722 0 3.309 2.691 6 6 6s6-2.691 6-6c0-1.922-0.631-3.409-1.188-4.722-0.853-2.009-1.491-3.509 0.447-5.781 2.841 1.766 4.737 4.916 4.737 8.503 0 5.513-4.488 10-10 10z" })
        );
    }
    function TennisBall({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TennisBallSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    TennisBall.SVG = TennisBallSVG;
    return TennisBall;
})();
export const Tennis = /*#__PURE__*/ (() => {
        function TennisSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.988 20.384c-0.041-0.169-0.166-0.306-0.328-0.359l-1.391-0.462-3.416-3.416c-0.094-0.094-0.222-0.147-0.353-0.147h-1c-0.022 0-0.047 0-0.069 0.003-1.7-1.875-1.844-3.859-1.997-5.953-0.078-1.091-0.162-2.222-0.475-3.325-0.528-1.866-1.719-3.584-3.353-4.841-1.575-1.216-3.391-1.884-5.106-1.884-1.719 0-3.347 0.681-4.581 1.919s-1.919 2.862-1.919 4.581c0 1.716 0.669 3.531 1.884 5.109 1.256 1.631 2.978 2.822 4.841 3.353 1.103 0.312 2.231 0.394 3.325 0.475 2.094 0.153 4.078 0.297 5.953 1.997-0.003 0.022-0.003 0.044-0.003 0.069v1c0 0.131 0.053 0.259 0.147 0.353l3.416 3.413 0.462 1.388c0.056 0.166 0.191 0.288 0.359 0.328 0.038 0.009 0.078 0.012 0.116 0.012 0.131 0 0.259-0.053 0.353-0.147l3-3c0.122-0.119 0.172-0.297 0.134-0.466zM6.813 12.891c0.112-0.091 0.188-0.231 0.188-0.391 0-0.275-0.225-0.5-0.5-0.5s-0.5 0.225-0.5 0.5c0 0.012 0 0.025 0 0.038-1.566-0.803-2.738-2.144-3.397-3.547 0.225-0.050 0.394-0.25 0.394-0.488 0-0.275-0.225-0.5-0.5-0.5-0.091 0-0.178 0.025-0.25 0.069-0.162-0.541-0.247-1.072-0.247-1.572 0-0.541 0.1-1.062 0.284-1.547 0.066 0.031 0.138 0.047 0.216 0.047 0.275 0 0.5-0.225 0.5-0.5 0-0.188-0.103-0.353-0.259-0.438 0.347-0.525 0.797-0.975 1.322-1.322 0.084 0.153 0.25 0.259 0.438 0.259 0.275 0 0.5-0.225 0.5-0.5 0-0.078-0.019-0.15-0.047-0.216 0.484-0.184 1.006-0.284 1.547-0.284 0.5 0 1.031 0.084 1.569 0.25-0.044 0.075-0.069 0.159-0.069 0.25 0 0.275 0.225 0.5 0.5 0.5 0.241 0 0.441-0.169 0.488-0.394 1.403 0.659 2.744 1.831 3.547 3.397-0.012 0-0.025 0-0.037 0-0.275 0-0.5 0.225-0.5 0.5s0.225 0.5 0.5 0.5c0.156 0 0.297-0.072 0.391-0.188 0.053 0.15 0.103 0.303 0.147 0.459 0.15 0.531 0.237 1.087 0.3 1.666-0.791 2.156-2.241 3.609-4.397 4.397-0.578-0.063-1.134-0.147-1.666-0.3-0.156-0.044-0.309-0.094-0.459-0.147zM10.903 13.494c1.069-0.656 1.934-1.522 2.594-2.594 0.084 1.012 0.209 2.072 0.547 3.141-1.072-0.338-2.128-0.462-3.141-0.547zM20.719 22.575l-0.244-0.731c-0.025-0.075-0.066-0.141-0.122-0.197l-3.353-3.353v-0.584l0.706-0.706h0.584l3.353 3.353c0.056 0.056 0.122 0.097 0.197 0.122l0.731 0.244-1.853 1.853z" }),
_('path', { d: "M11 10.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M11 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M9 10.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M9 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M7 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M7 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M5 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M5 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M11 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M11 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M9 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M9 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M7 10.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M7 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M5 10.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M5 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M9 12.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M13 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M7 2.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M3 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M3.5 18c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.122-2.5-2.5-2.5zM3.5 22c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" })
            );
        }
        function Tennis({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TennisSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Tennis.SVG = TennisSVG;
        return Tennis;
    })();
export const TestTube = /*#__PURE__*/ (() => {
    function TestTubeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17 0h-10v2h1v18c0 2.206 1.794 4 4 4s4-1.794 4-4v-18h1v-2zM12 22c-1.103 0-2-0.897-2-2v-12.997c0.453 0.019 0.966 0.353 1.703 0.897 0.513 0.381 1.044 0.772 1.612 0.969 0.234 0.081 0.462 0.122 0.684 0.128v11c0 1.106-0.897 2.003-2 2.003zM14 7.997c-0.453-0.019-0.966-0.353-1.703-0.897-0.513-0.381-1.044-0.772-1.613-0.969-0.234-0.081-0.462-0.122-0.684-0.128v-4.003h4v5.997z" })
        );
    }
    function TestTube({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TestTubeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    TestTube.SVG = TestTubeSVG;
    return TestTube;
})();
export const TextAlignCenter = /*#__PURE__*/ (() => {
        function TextAlignCenterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 2h24v2h-24v-2z" }),
_('path', { d: "M4 6h16v1h-16v-1z" }),
_('path', { d: "M1 9h22v1h-22v-1z" }),
_('path', { d: "M5 12h14v1h-14v-1z" }),
_('path', { d: "M0 15h24v1h-24v-1z" }),
_('path', { d: "M3 18h18v1h-18v-1z" }),
_('path', { d: "M2 21h20v1h-20v-1z" })
            );
        }
        function TextAlignCenter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TextAlignCenterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TextAlignCenter.SVG = TextAlignCenterSVG;
        return TextAlignCenter;
    })();
export const TextAlignJustify = /*#__PURE__*/ (() => {
        function TextAlignJustifySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 2h24v2h-24v-2z" }),
_('path', { d: "M0 6h24v1h-24v-1z" }),
_('path', { d: "M0 9h24v1h-24v-1z" }),
_('path', { d: "M0 12h24v1h-24v-1z" }),
_('path', { d: "M0 15h24v1h-24v-1z" }),
_('path', { d: "M0 18h24v1h-24v-1z" }),
_('path', { d: "M0 21h24v1h-24v-1z" })
            );
        }
        function TextAlignJustify({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TextAlignJustifySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TextAlignJustify.SVG = TextAlignJustifySVG;
        return TextAlignJustify;
    })();
export const TextAlignLeft = /*#__PURE__*/ (() => {
        function TextAlignLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 2h24v2h-24v-2z" }),
_('path', { d: "M0 6h16v1h-16v-1z" }),
_('path', { d: "M0 9h22v1h-22v-1z" }),
_('path', { d: "M0 12h17v1h-17v-1z" }),
_('path', { d: "M0 15h24v1h-24v-1z" }),
_('path', { d: "M0 18h15v1h-15v-1z" }),
_('path', { d: "M0 21h21v1h-21v-1z" })
            );
        }
        function TextAlignLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TextAlignLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TextAlignLeft.SVG = TextAlignLeftSVG;
        return TextAlignLeft;
    })();
export const TextAlignRight = /*#__PURE__*/ (() => {
        function TextAlignRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 2h24v2h-24v-2z" }),
_('path', { d: "M8 6h16v1h-16v-1z" }),
_('path', { d: "M2 9h22v1h-22v-1z" }),
_('path', { d: "M7 12h17v1h-17v-1z" }),
_('path', { d: "M0 15h24v1h-24v-1z" }),
_('path', { d: "M9 18h15v1h-15v-1z" }),
_('path', { d: "M3 21h21v1h-21v-1z" })
            );
        }
        function TextAlignRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TextAlignRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TextAlignRight.SVG = TextAlignRightSVG;
        return TextAlignRight;
    })();
export const TextAround = /*#__PURE__*/ (() => {
        function TextAroundSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 1h9v1h-9v-1z" }),
_('path', { d: "M15 4h9v1h-9v-1z" }),
_('path', { d: "M15 10h9v1h-9v-1z" }),
_('path', { d: "M15 7h9v1h-9v-1z" }),
_('path', { d: "M0 16h24v1h-24v-1z" }),
_('path', { d: "M15 13h9v1h-9v-1z" }),
_('path', { d: "M0 19h24v1h-24v-1z" }),
_('path', { d: "M0 22h24v1h-24v-1z" }),
_('path', { d: "M5.206 10h4.584l1.537 3.637 1.844-0.778-4.75-11.25c-0.156-0.369-0.519-0.609-0.922-0.609s-0.766 0.241-0.922 0.612l-4.75 11.25 1.844 0.778 1.534-3.641zM7.5 4.572l1.447 3.428h-2.897l1.45-3.428z" })
            );
        }
        function TextAround({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TextAroundSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TextAround.SVG = TextAroundSVG;
        return TextAround;
    })();
export const TextColor = /*#__PURE__*/ (() => {
        function TextColorSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 23h20v1h-20v-1z" }),
_('path', { d: "M7.672 13h8.653l3.012 6.663 1.822-0.825-8.25-18.25c-0.159-0.356-0.516-0.588-0.909-0.588s-0.75 0.231-0.912 0.588l-8.25 18.25 1.822 0.825 3.012-6.663zM12 3.428l3.422 7.572h-6.844l3.422-7.572z" })
            );
        }
        function TextColor({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TextColorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TextColor.SVG = TextColorSVG;
        return TextColor;
    })();
export const TextDown = /*#__PURE__*/ (() => {
        function TextDownSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 2h-18v2h8v18h2v-18h8z" }),
_('path', { d: "M4 20.294v-9.294h-1v9.294l-1.5-1.5-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l2.353-2.353-0.706-0.706-1.5 1.5z" })
            );
        }
        function TextDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TextDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TextDown.SVG = TextDownSVG;
        return TextDown;
    })();
export const TextSizeDecrease = /*#__PURE__*/ (() => {
        function TextSizeDecreaseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 2h-18v2h8v18h2v-18h8z" }),
_('path', { d: "M1 13h8v2h-8v-2z" })
            );
        }
        function TextSizeDecrease({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TextSizeDecreaseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TextSizeDecrease.SVG = TextSizeDecreaseSVG;
        return TextSizeDecrease;
    })();
export const TextSizeIncrease = /*#__PURE__*/ (() => {
        function TextSizeIncreaseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 2h-18v2h8v18h2v-18h8z" }),
_('path', { d: "M6 10h-2v3h-3v2h3v3h2v-3h3v-2h-3z" })
            );
        }
        function TextSizeIncrease({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TextSizeIncreaseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TextSizeIncrease.SVG = TextSizeIncreaseSVG;
        return TextSizeIncrease;
    })();
export const TextSize = /*#__PURE__*/ (() => {
        function TextSizeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M24 2h-18v2h8v18h2v-18h8z" }),
_('path', { d: "M0 13h4v9h2v-9h4v-2h-10z" })
            );
        }
        function TextSize({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TextSizeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TextSize.SVG = TextSizeSVG;
        return TextSize;
    })();
export const TextSize2 = /*#__PURE__*/ (() => {
        function TextSize2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 2h-18v2h8v18h2v-18h8z" }),
_('path', { d: "M5.5 11.206l0.706-0.706-2.353-2.353c-0.194-0.194-0.513-0.194-0.706 0l-2.353 2.353 0.706 0.706 1.5-1.5v10.584l-1.5-1.5-0.706 0.709 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l2.353-2.353-0.706-0.706-1.5 1.5v-10.587l1.5 1.5z" })
            );
        }
        function TextSize2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TextSize2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TextSize2.SVG = TextSize2SVG;
        return TextSize2;
    })();
export const Texture = /*#__PURE__*/ (() => {
        function TextureSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0 0 0 0 0 0z" }),
_('path', { d: "M2.792 5.501l2.707-2.707 0.707 0.707-2.707 2.707-0.707-0.707z" }),
_('path', { d: "M2.794 8.499l5.708-5.708 0.707 0.707-5.708 5.708-0.707-0.707z" }),
_('path', { d: "M2.793 11.499l8.706-8.706 0.707 0.707-8.706 8.706-0.707-0.707z" }),
_('path', { d: "M2.793 14.5l11.707-11.707 0.707 0.707-11.707 11.707-0.707-0.707z" }),
_('path', { d: "M2.792 17.5l14.708-14.708 0.707 0.707-14.708 14.708-0.707-0.707z" }),
_('path', { d: "M17.792 20.501l2.707-2.707 0.707 0.707-2.707 2.707-0.707-0.707z" }),
_('path', { d: "M14.793 20.499l5.708-5.708 0.707 0.707-5.708 5.708-0.707-0.707z" }),
_('path', { d: "M11.793 20.5l8.706-8.706 0.707 0.707-8.706 8.706-0.707-0.707z" }),
_('path', { d: "M8.793 20.5l11.707-11.707 0.707 0.707-11.707 11.707-0.707-0.707z" }),
_('path', { d: "M5.792 20.5l14.708-14.708 0.707 0.707-14.708 14.708-0.707-0.707z" }),
_('path', { d: "M2.792 20.5l17.706-17.706 0.707 0.707-17.706 17.706-0.707-0.707z" })
            );
        }
        function Texture({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TextureSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Texture.SVG = TextureSVG;
        return Texture;
    })();
export const Theater = /*#__PURE__*/ (() => {
        function TheaterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.603 5.203c-0.25-0.188-0.575-0.25-0.878-0.162-2.862 0.819-5.319 1.113-7.887 0.888 0.097-1.062 0.15-2.206 0.162-3.419 0.003-0.162-0.075-0.316-0.206-0.409s-0.3-0.122-0.453-0.069c-3.875 1.291-7.806 1.291-11.684 0-0.153-0.050-0.322-0.025-0.453 0.069s-0.206 0.244-0.203 0.406c0.047 4.406 0.638 7.8 1.759 10.087 0.559 1.141 1.253 2.009 2.063 2.578 0.781 0.55 1.684 0.828 2.678 0.828 0.531 0 1.038-0.081 1.512-0.237 0.234 0.853 0.513 1.616 0.834 2.291 0.622 1.316 1.425 2.316 2.384 2.975 0.941 0.644 2.041 0.972 3.269 0.972s2.328-0.328 3.269-0.972c0.959-0.659 1.762-1.659 2.384-2.975 1.244-2.622 1.847-6.566 1.847-12.053 0-0.312-0.147-0.609-0.397-0.797zM7.5 15c-0.784 0-1.494-0.219-2.103-0.647-0.672-0.472-1.256-1.212-1.741-2.2-0.997-2.034-1.547-5.047-1.644-8.966 1.825 0.537 3.666 0.813 5.487 0.813s3.663-0.275 5.487-0.816c-0.022 0.922-0.072 1.8-0.144 2.625-1.141-0.156-2.316-0.416-3.569-0.772-0.303-0.087-0.625-0.025-0.878 0.162-0.25 0.188-0.397 0.484-0.397 0.797 0 1.469 0.044 2.828 0.131 4.081-0.2-0.053-0.413-0.081-0.631-0.081-1.378 0-2.5 1.122-2.5 2.5 0 0.275 0.225 0.5 0.5 0.5h2.941c0.094 0.631 0.203 1.225 0.328 1.788-0.394 0.144-0.819 0.216-1.269 0.216zM8.309 12h-2.222c0.206-0.581 0.762-1 1.416-1 0.263 0 0.506 0.069 0.722 0.184 0.022 0.278 0.053 0.55 0.084 0.816zM19.347 17.197c-0.906 1.913-2.128 2.803-3.847 2.803s-2.941-0.891-3.847-2.803c-1.003-2.116-1.553-5.441-1.641-9.894 1.953 0.472 3.725 0.697 5.487 0.697s3.534-0.225 5.487-0.697c-0.087 4.453-0.641 7.778-1.641 9.894z" }),
_('path', { d: "M17.5 15h-4c-0.275 0-0.5 0.225-0.5 0.5 0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5c0-0.275-0.225-0.5-0.5-0.5zM15.5 17c-0.653 0-1.209-0.419-1.416-1h2.828c-0.203 0.581-0.759 1-1.413 1z" }),
_('path', { d: "M14.5 12.206l0.706-0.706-1.353-1.353c-0.194-0.194-0.513-0.194-0.706 0l-1.353 1.353 0.706 0.706 1-1 1 1z" }),
_('path', { d: "M17.5 11.206l1 1 0.706-0.706-1.353-1.353c-0.194-0.194-0.513-0.194-0.706 0l-1.353 1.353 0.706 0.706 1-1z" }),
_('path', { d: "M5.5 8c0.128 0 0.256-0.050 0.353-0.147l1.353-1.353-0.706-0.706-1 1-1-1-0.706 0.706 1.353 1.353c0.097 0.097 0.225 0.147 0.353 0.147z" })
            );
        }
        function Theater({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TheaterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Theater.SVG = TheaterSVG;
        return Theater;
    })();
export const ThermometerGear = /*#__PURE__*/ (() => {
        function ThermometerGearSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 15v-12c0-1.653 1.347-3 3-3s3 1.347 3 3v12c0.528 0.397 0.975 0.894 1.309 1.466 0.453 0.762 0.691 1.641 0.691 2.534 0 2.756-2.244 5-5 5s-5-2.244-5-5c0-1.581 0.753-3.066 2-4zM9 22c1.653 0 3-1.347 3-3 0-1.069-0.575-2.063-1.5-2.6-0.309-0.178-0.5-0.509-0.5-0.866v-12.534c0-0.55-0.45-1-1-1s-1 0.45-1 1v12.534c0 0.356-0.191 0.687-0.5 0.866-0.925 0.534-1.5 1.531-1.5 2.6 0 1.653 1.347 3 3 3z" }),
_('path', { d: "M9 17v1c0.55 0 1 0.45 1 1s-0.45 1-1 1v1c1.103 0 2-0.897 2-2s-0.897-2-2-2z" }),
_('path', { d: "M4 13h-2v1h2v-1zM4 12h-2v-1h2v1zM4 10h-4v-1h4v1zM2 7h2v1h-2v-1zM2 5h2v1h-2v-1zM4 3v1h-4v-1h4z" }),
_('path', { d: "M18.5 4c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM18.5 6c0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5-0.5 0.225-0.5 0.5 0.225 0.5 0.5 0.5z" }),
_('path', { d: "M13.184 3.994c-0.034-0.128-0.016-0.266 0.050-0.378l1-1.731c0.138-0.237 0.444-0.322 0.681-0.184l1.591 0.919c0.078-0.053 0.156-0.103 0.241-0.153s0.166-0.094 0.25-0.131v-1.837c0-0.275 0.225-0.5 0.5-0.5h2c0.275 0 0.5 0.225 0.5 0.5v1.837c0.081 0.041 0.166 0.084 0.25 0.131 0.081 0.047 0.162 0.1 0.241 0.153l1.594-0.912c0.237-0.138 0.544-0.056 0.681 0.184l1 1.731c0.066 0.116 0.084 0.25 0.050 0.378s-0.119 0.237-0.234 0.303l-1.591 0.919c0.006 0.091 0.009 0.184 0.009 0.281 0 0.094-0.003 0.188-0.009 0.281l1.591 0.919c0.116 0.066 0.2 0.175 0.234 0.303s0.016 0.266-0.050 0.378l-1 1.731c-0.138 0.237-0.444 0.322-0.681 0.184l-1.591-0.919c-0.078 0.053-0.156 0.103-0.241 0.153s-0.166 0.094-0.25 0.131v1.838c0 0.275-0.225 0.5-0.5 0.5h-2c-0.275 0-0.5-0.225-0.5-0.5v-1.838c-0.081-0.041-0.166-0.084-0.25-0.131-0.081-0.047-0.162-0.1-0.241-0.153l-1.591 0.912c-0.237 0.138-0.544 0.056-0.681-0.184l-1-1.731c-0.066-0.116-0.084-0.25-0.050-0.378s0.119-0.237 0.234-0.303l1.591-0.919c-0.006-0.091-0.009-0.184-0.009-0.281 0-0.094 0.003-0.188 0.009-0.281l-1.591-0.919c-0.119-0.066-0.203-0.175-0.237-0.303zM15.8 4.516c0.184 0.106 0.281 0.319 0.241 0.528-0.028 0.141-0.041 0.294-0.041 0.453 0 0.162 0.012 0.312 0.041 0.45 0.041 0.209-0.056 0.422-0.241 0.528l-1.447 0.834 0.5 0.866 1.45-0.831c0.184-0.106 0.416-0.084 0.575 0.056 0.112 0.097 0.237 0.188 0.372 0.266 0.144 0.081 0.278 0.144 0.413 0.191 0.2 0.069 0.337 0.259 0.337 0.472v1.672h1v-1.672c0-0.213 0.134-0.403 0.337-0.472 0.134-0.047 0.272-0.109 0.413-0.191 0.134-0.078 0.259-0.166 0.372-0.266 0.162-0.138 0.394-0.162 0.575-0.056l1.45 0.834 0.5-0.866-1.447-0.834c-0.184-0.106-0.281-0.319-0.241-0.528 0.028-0.141 0.041-0.294 0.041-0.453 0-0.162-0.012-0.312-0.041-0.45-0.041-0.209 0.056-0.422 0.241-0.528l1.447-0.831-0.5-0.866-1.45 0.831c-0.184 0.106-0.416 0.084-0.575-0.056-0.112-0.097-0.237-0.188-0.372-0.266-0.144-0.081-0.278-0.144-0.413-0.191-0.2-0.069-0.337-0.259-0.337-0.472v-1.672h-1v1.672c0 0.213-0.134 0.403-0.337 0.472-0.134 0.047-0.272 0.109-0.413 0.191-0.134 0.078-0.259 0.166-0.372 0.266-0.159 0.138-0.394 0.162-0.575 0.056l-1.45-0.834-0.5 0.866 1.447 0.831z" })
            );
        }
        function ThermometerGear({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ThermometerGearSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ThermometerGear.SVG = ThermometerGearSVG;
        return ThermometerGear;
    })();
export const ThermometerMinus = /*#__PURE__*/ (() => {
        function ThermometerMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 15v-12c0-1.653 1.347-3 3-3s3 1.347 3 3v12c0.528 0.397 0.975 0.894 1.309 1.466 0.453 0.762 0.691 1.641 0.691 2.534 0 2.756-2.244 5-5 5s-5-2.244-5-5c0-1.581 0.753-3.066 2-4zM10 22c1.653 0 3-1.347 3-3 0-1.069-0.575-2.063-1.5-2.6-0.309-0.178-0.5-0.509-0.5-0.866v-12.534c0-0.55-0.45-1-1-1s-1 0.45-1 1v12.534c0 0.356-0.191 0.687-0.5 0.866-0.925 0.534-1.5 1.531-1.5 2.6 0 1.653 1.347 3 3 3z" }),
_('path', { d: "M10 17v1c0.55 0 1 0.45 1 1s-0.45 1-1 1v1c1.103 0 2-0.897 2-2s-0.897-2-2-2z" }),
_('path', { d: "M5 13h-2v1h2v-1zM5 12h-2v-1h2v1zM5 10h-4v-1h4v1zM3 7h2v1h-2v-1zM3 5h2v1h-2v-1zM5 3v1h-4v-1h4z" }),
_('path', { d: "M23 8h-8v2h8v-2z" })
            );
        }
        function ThermometerMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ThermometerMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ThermometerMinus.SVG = ThermometerMinusSVG;
        return ThermometerMinus;
    })();
export const ThermometerPlus = /*#__PURE__*/ (() => {
        function ThermometerPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 15v-12c0-1.653 1.347-3 3-3s3 1.347 3 3v12c0.528 0.397 0.975 0.894 1.309 1.466 0.453 0.762 0.691 1.641 0.691 2.534 0 2.756-2.244 5-5 5s-5-2.244-5-5c0-1.581 0.753-3.066 2-4zM10 22c1.653 0 3-1.347 3-3 0-1.069-0.575-2.063-1.5-2.6-0.309-0.178-0.5-0.509-0.5-0.866v-12.534c0-0.55-0.45-1-1-1s-1 0.45-1 1v12.534c0 0.356-0.191 0.687-0.5 0.866-0.925 0.534-1.5 1.531-1.5 2.6 0 1.653 1.347 3 3 3z" }),
_('path', { d: "M10 17v1c0.55 0 1 0.45 1 1s-0.45 1-1 1v1c1.103 0 2-0.897 2-2s-0.897-2-2-2z" }),
_('path', { d: "M5 13h-2v1h2v-1zM5 12h-2v-1h2v1zM5 10h-4v-1h4v1zM3 7h2v1h-2v-1zM3 5h2v1h-2v-1zM5 3v1h-4v-1h4z" }),
_('path', { d: "M15 10v-2h3v-3h2v3h3v2h-3v3h-2v-3z" })
            );
        }
        function ThermometerPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ThermometerPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ThermometerPlus.SVG = ThermometerPlusSVG;
        return ThermometerPlus;
    })();
export const ThermometerSnow = /*#__PURE__*/ (() => {
        function ThermometerSnowSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 15v-12c0-1.653 1.347-3 3-3s3 1.347 3 3v12c0.528 0.397 0.975 0.894 1.309 1.466 0.453 0.762 0.691 1.641 0.691 2.534 0 2.756-2.244 5-5 5s-5-2.244-5-5c0-1.581 0.753-3.066 2-4zM9 22c1.653 0 3-1.347 3-3 0-1.069-0.575-2.063-1.5-2.6-0.309-0.178-0.5-0.509-0.5-0.866v-12.534c0-0.55-0.45-1-1-1s-1 0.45-1 1v12.534c0 0.356-0.191 0.687-0.5 0.866-0.925 0.534-1.5 1.531-1.5 2.6 0 1.653 1.347 3 3 3z" }),
_('path', { d: "M9 17v1c0.55 0 1 0.45 1 1s-0.45 1-1 1v1c1.103 0 2-0.897 2-2s-0.897-2-2-2z" }),
_('path', { d: "M4 13h-2v1h2v-1zM4 12h-2v-1h2v1zM4 10h-4v-1h4v1zM2 7h2v1h-2v-1zM2 5h2v1h-2v-1zM4 3v1h-4v-1h4z" }),
_('path', { d: "M14.706 6l-1.206 1.206-0.706-0.706 1-1-1-1 0.706-0.706 1.206 1.206h2.428l-1.212-2.103-1.65-0.441 0.259-0.966 1.366 0.366 0.366-1.366 0.966 0.259-0.441 1.647 1.212 2.103 1.212-2.103-0.441-1.647 0.966-0.259 0.366 1.366 1.366-0.366 0.259 0.966-1.65 0.441-1.212 2.103h2.428l1.206-1.206 0.706 0.706-1 1 1 1-0.706 0.706-1.206-1.206h-2.428l1.212 2.103 1.65 0.441-0.259 0.966-1.366-0.366-0.366 1.366-0.966-0.259 0.441-1.647-1.212-2.103-1.212 2.103 0.441 1.647-0.966 0.259-0.366-1.366-1.366 0.366-0.259-0.966 1.65-0.441 1.212-2.103z" })
            );
        }
        function ThermometerSnow({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ThermometerSnowSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ThermometerSnow.SVG = ThermometerSnowSVG;
        return ThermometerSnow;
    })();
export const ThermometerSun = /*#__PURE__*/ (() => {
        function ThermometerSunSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 15v-12c0-1.653 1.347-3 3-3s3 1.347 3 3v12c0.528 0.397 0.975 0.894 1.309 1.466 0.453 0.762 0.691 1.641 0.691 2.534 0 2.756-2.244 5-5 5s-5-2.244-5-5c0-1.581 0.753-3.066 2-4zM9 22c1.653 0 3-1.347 3-3 0-1.069-0.575-2.063-1.5-2.6-0.309-0.178-0.5-0.509-0.5-0.866v-12.534c0-0.55-0.45-1-1-1s-1 0.45-1 1v12.534c0 0.356-0.191 0.687-0.5 0.866-0.925 0.534-1.5 1.531-1.5 2.6 0 1.653 1.347 3 3 3z" }),
_('path', { d: "M9 17v1c0.55 0 1 0.45 1 1s-0.45 1-1 1v1c1.103 0 2-0.897 2-2s-0.897-2-2-2z" }),
_('path', { d: "M4 13h-2v1h2v-1zM4 12h-2v-1h2v1zM4 10h-4v-1h4v1zM2 7h2v1h-2v-1zM2 5h2v1h-2v-1zM4 3v1h-4v-1h4z" }),
_('path', { d: "M18.5 3c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5-2.5-1.122-2.5-2.5 1.122-2.5 2.5-2.5zM18.5 7c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5z" }),
_('path', { d: "M22 6h2v-1h-2v1zM19 11h-1v-2h1v2zM16.206 8.5l-1.706 1.706-0.706-0.706 1.706-1.706 0.706 0.706zM13.794 1.5l0.706-0.706 1.706 1.706-0.706 0.706-1.706-1.706zM20.794 2.5l1.706-1.706 0.706 0.706-1.706 1.706-0.706-0.706zM23.206 9.5l-0.706 0.706-1.706-1.706 0.706-0.706 1.706 1.706zM15 6h-2v-1h2v1zM18 0h1v2h-1v-2z" })
            );
        }
        function ThermometerSun({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ThermometerSunSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ThermometerSun.SVG = ThermometerSunSVG;
        return ThermometerSun;
    })();
export const Thermometer = /*#__PURE__*/ (() => {
        function ThermometerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 15v-12c0-1.653 1.347-3 3-3s3 1.347 3 3v12c0.528 0.397 0.975 0.894 1.309 1.466 0.453 0.762 0.691 1.641 0.691 2.534 0 2.756-2.244 5-5 5s-5-2.244-5-5c0-1.581 0.753-3.066 2-4zM14 22c1.653 0 3-1.347 3-3 0-1.069-0.575-2.063-1.5-2.6-0.309-0.178-0.5-0.509-0.5-0.866v-12.534c0-0.55-0.45-1-1-1s-1 0.45-1 1v12.534c0 0.356-0.191 0.687-0.5 0.866-0.925 0.534-1.5 1.531-1.5 2.6 0 1.653 1.347 3 3 3z" }),
_('path', { d: "M14 17v1c0.55 0 1 0.45 1 1s-0.45 1-1 1v1c1.103 0 2-0.897 2-2s-0.897-2-2-2z" }),
_('path', { d: "M9 13h-2v1h2v-1zM9 11h-2v1h2v-1zM9 9h-4v1h4v-1zM9 7h-2v1h2v-1zM9 5h-2v1h2v-1zM9 3h-4v1h4v-1z" })
            );
        }
        function Thermometer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ThermometerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Thermometer.SVG = ThermometerSVG;
        return Thermometer;
    })();
export const Thin = /*#__PURE__*/ (() => {
        function ThinSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.456 8.044l-1.416 1.416 1.544 1.544h-6.584v2h6.584l-1.544 1.544 1.416 1.416 3.25-3.25c0.391-0.391 0.391-1.025 0-1.416l-3.25-3.253z" }),
_('path', { d: "M24 11h-6.584l1.544-1.544-1.416-1.416-3.25 3.25c-0.194 0.194-0.294 0.45-0.294 0.706s0.097 0.513 0.294 0.706l3.25 3.25 1.416-1.416-1.544-1.538h6.584v-2z" }),
_('path', { d: "M13.5 1h-3c-0.275 0-0.5 0.225-0.5 0.5v21c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-21c0-0.275-0.225-0.5-0.5-0.5zM13 22h-2v-20h2v20z" })
            );
        }
        function Thin({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ThinSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Thin.SVG = ThinSVG;
        return Thin;
    })();
export const ThumbsDown = /*#__PURE__*/ (() => {
    function ThumbsDownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M21 10c0-0.531-0.141-1.050-0.403-1.5 0.259-0.45 0.403-0.969 0.403-1.5 0-0.906-0.409-1.747-1.081-2.306 0.053-0.225 0.081-0.459 0.081-0.694 0-1.653-1.347-3-3-3h-2.716c-2.881 0-5.763 0.709-8.328 2.047 0 0-0.003 0-0.003 0.003-1.822 0.959-2.953 2.844-2.953 4.922v3.503c0 0.853 0.197 1.706 0.572 2.469 0.378 0.769 0.934 1.444 1.609 1.959 0.928 0.706 1.812 1.156 2.666 1.587 1.631 0.828 2.922 1.484 4.059 3.722 0.234 0.588 0.612 1.062 1.106 1.384 0.531 0.347 1.147 0.475 1.741 0.363 0.691-0.131 1.287-0.575 1.684-1.253 0.381-0.653 0.569-1.503 0.556-2.519 0-0.963-0.222-2.147-0.772-3.188h1.781c1.653 0 3-1.347 3-3 0-0.531-0.141-1.050-0.403-1.5 0.259-0.45 0.4-0.969 0.4-1.5zM17 5h-2v1h3c0.156 0 0.303 0.034 0.441 0.103 0.341 0.166 0.559 0.513 0.559 0.897 0 0.247-0.091 0.484-0.253 0.666-0.191 0.213-0.459 0.331-0.744 0.334 0 0-0.003 0-0.003 0h-2v1h2c0 0 0.003 0 0.003 0 0.244 0 0.478 0.091 0.659 0.25 0.216 0.191 0.337 0.462 0.337 0.75s-0.122 0.559-0.337 0.75c-0.181 0.159-0.416 0.25-0.663 0.25h-2v1h2c0.284 0 0.556 0.122 0.747 0.334 0.162 0.181 0.253 0.419 0.253 0.666 0 0.55-0.45 1-1 1h-4c-0.45 0-0.844 0.3-0.963 0.734s0.063 0.894 0.45 1.125c1.034 0.622 1.506 2.166 1.506 3.337 0 0.003 0 0.009 0 0.012 0.016 1.225-0.356 1.741-0.609 1.791-0.191 0.034-0.472-0.141-0.625-0.544-0.012-0.034-0.025-0.066-0.044-0.097-1.437-2.859-3.228-3.769-4.962-4.65-0.775-0.394-1.575-0.8-2.359-1.397-0.872-0.663-1.394-1.722-1.394-2.834v-3.506c0-1.331 0.722-2.541 1.881-3.15 2.281-1.191 4.841-1.822 7.403-1.822h2.716c0.55 0 1 0.45 1 1 0 0.172-0.044 0.338-0.122 0.484-0.178 0.319-0.516 0.516-0.878 0.516z" })
        );
    }
    function ThumbsDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ThumbsDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ThumbsDown.SVG = ThumbsDownSVG;
    return ThumbsDown;
})();
export const ThumbsDown2 = /*#__PURE__*/ (() => {
        function ThumbsDown2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.963 5.256c-0.447-0.931-1-1.675-1.65-2.219-0.825-0.687-1.778-1.038-2.834-1.038-3.012 0-5.425 0.55-7.819 1.778 0 0-0.003 0-0.003 0-0.281 0.147-0.544 0.316-0.788 0.506-0.288-0.75-1.016-1.284-1.869-1.284h-5.5c-0.275 0-0.5 0.225-0.5 0.5v12c0 0.275 0.225 0.5 0.5 0.5h5.5c0.797 0 1.488-0.469 1.809-1.144 0.050 0.041 0.103 0.081 0.153 0.122 0.006 0.006 0.016 0.012 0.022 0.016 1.306 0.925 4.9 3.772 5.822 5.809 0.309 0.687 0.972 1.144 1.728 1.194 0.044 0.003 0.087 0.003 0.131 0.003 0.712 0 1.372-0.366 1.747-0.978 0.378-0.612 0.584-1.313 0.584-1.969 0-1.656-0.531-3.053-1.081-4.053h2.084c0.772 0 2.153-0.316 2.716-2.428 0.284-1.062 0.284-2.272 0.284-3.069 0-1.006-0.325-2.763-1.038-4.247zM7 14h-5v-9h5v2.959h0.003c-0.003 0.066-0.003 0.128-0.003 0.194v5.847zM20.784 12.056c-0.253 0.944-0.6 0.944-0.784 0.944h-4c-0.403 0-0.772 0.241-0.925 0.612-0.156 0.372-0.075 0.797 0.206 1.084 0.056 0.059 1.719 1.853 1.719 4.359 0 0.281-0.109 0.625-0.291 0.922-0.006 0.012-0.016 0.028-0.050 0.025-0.022 0-0.025-0.006-0.031-0.019-0.572-1.266-1.85-2.772-3.794-4.475-1.347-1.178-2.538-2.034-2.681-2.138-0.722-0.547-1.153-1.416-1.153-2.328v-2.888c0-1.097 0.603-2.094 1.575-2.597 2.097-1.078 4.225-1.556 6.903-1.556 1.103 0 2.003 0.713 2.681 2.122 0.612 1.278 0.841 2.75 0.841 3.381 0 0.687 0 1.737-0.216 2.55z" }),
_('path', { d: "M5 11c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1c0-0.55-0.45-1-1-1zM5 12c0 0 0 0 0 0v0z" })
            );
        }
        function ThumbsDown2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ThumbsDown2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ThumbsDown2.SVG = ThumbsDown2SVG;
        return ThumbsDown2;
    })();
export const ThumbsUp = /*#__PURE__*/ (() => {
    function ThumbsUpSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20.597 12.5c0.259-0.45 0.403-0.969 0.403-1.5 0-1.653-1.347-3-3-3h-1.781c0.55-1.041 0.772-2.225 0.772-3.188 0.012-1.019-0.175-1.866-0.556-2.519-0.394-0.678-0.991-1.125-1.684-1.253-0.591-0.112-1.209 0.019-1.741 0.363-0.491 0.319-0.872 0.797-1.106 1.384-1.137 2.238-2.428 2.894-4.059 3.722-0.853 0.434-1.734 0.881-2.666 1.587-0.678 0.516-1.234 1.191-1.609 1.959-0.375 0.762-0.572 1.616-0.572 2.469v3.503c0 2.078 1.131 3.963 2.953 4.922 0 0 0.003 0 0.003 0.003 2.566 1.341 5.447 2.047 8.328 2.047h2.719c1.653 0 3-1.347 3-3 0-0.237-0.028-0.469-0.081-0.694 0.672-0.559 1.081-1.4 1.081-2.306 0-0.531-0.141-1.050-0.403-1.5 0.259-0.45 0.403-0.969 0.403-1.5s-0.141-1.050-0.403-1.5zM17.878 19.516c0.081 0.147 0.122 0.312 0.122 0.484 0 0.55-0.45 1-1 1h-2.716c-2.559 0-5.119-0.628-7.403-1.822-1.163-0.612-1.881-1.819-1.881-3.15v-3.503c0-1.113 0.522-2.172 1.394-2.834 0.788-0.597 1.587-1.003 2.359-1.397 1.731-0.881 3.522-1.791 4.962-4.65 0.016-0.031 0.031-0.063 0.044-0.097 0.15-0.4 0.434-0.578 0.625-0.544 0.253 0.047 0.625 0.563 0.609 1.791 0 0.003 0 0.009 0 0.012 0 1.172-0.472 2.716-1.506 3.338-0.384 0.231-0.569 0.691-0.45 1.125 0.119 0.431 0.513 0.731 0.963 0.731h4c0.55 0 1 0.45 1 1 0 0.247-0.091 0.484-0.253 0.666-0.191 0.213-0.462 0.334-0.747 0.334h-2v1h2c0.244 0 0.481 0.091 0.663 0.25 0.216 0.191 0.337 0.462 0.337 0.75s-0.122 0.559-0.337 0.75c-0.181 0.159-0.416 0.25-0.659 0.25 0 0-0.003 0-0.003 0v0h-2v1h2c0 0 0.003 0 0.003 0 0.281 0 0.553 0.122 0.744 0.334 0.162 0.181 0.253 0.419 0.253 0.666 0 0.384-0.219 0.731-0.559 0.897-0.138 0.069-0.288 0.103-0.441 0.103h-3v1h2c0.363 0 0.7 0.197 0.878 0.516z" })
        );
    }
    function ThumbsUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ThumbsUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ThumbsUp.SVG = ThumbsUpSVG;
    return ThumbsUp;
})();
export const ThumbsUp2 = /*#__PURE__*/ (() => {
        function ThumbsUp2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.716 11.428c-0.563-2.112-1.944-2.428-2.716-2.428h-2.081c0.55-1.003 1.081-2.397 1.081-4.053 0-0.656-0.209-1.353-0.584-1.966-0.4-0.65-1.119-1.022-1.881-0.975-0.756 0.047-1.416 0.506-1.725 1.191-0.922 2.037-4.516 4.887-5.822 5.812-0.006 0.006-0.016 0.009-0.022 0.016-0.053 0.041-0.103 0.078-0.153 0.122-0.325-0.678-1.016-1.147-1.812-1.147h-5.5c-0.275 0-0.5 0.225-0.5 0.5v12c0 0.275 0.225 0.5 0.5 0.5h5.5c0.853 0 1.581-0.534 1.869-1.287 0.244 0.191 0.506 0.363 0.787 0.506 0 0 0.003 0 0.003 0 2.394 1.231 4.806 1.778 7.819 1.778 1.056 0 2.009-0.35 2.834-1.038 0.647-0.541 1.203-1.287 1.65-2.219 0.712-1.481 1.038-3.237 1.038-4.241 0-0.8 0-2.006-0.284-3.072zM7 19h-5v-9h5v9zM20.159 17.878c-0.675 1.406-1.578 2.122-2.681 2.122-2.678 0-4.809-0.481-6.903-1.556-0.972-0.506-1.575-1.5-1.575-2.597v-2.888c0-0.912 0.431-1.781 1.153-2.328 0.144-0.103 1.334-0.956 2.681-2.138 1.947-1.703 3.222-3.209 3.794-4.475 0.006-0.012 0.009-0.019 0.031-0.019 0.034-0.003 0.044 0.012 0.050 0.025 0.181 0.294 0.291 0.638 0.291 0.919 0 2.506-1.662 4.3-1.719 4.359-0.281 0.288-0.363 0.712-0.206 1.084s0.522 0.612 0.925 0.612h4c0.184 0 0.531 0 0.784 0.944 0.216 0.809 0.216 1.859 0.216 2.553 0 0.631-0.228 2.106-0.841 3.381z" }),
_('path', { d: "M5 16c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM5 17c0 0 0 0 0 0v0z" })
            );
        }
        function ThumbsUp2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ThumbsUp2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ThumbsUp2.SVG = ThumbsUp2SVG;
        return ThumbsUp2;
    })();
export const Ticket = /*#__PURE__*/ (() => {
        function TicketSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.706 9.294l-2.731-2.731c-0.391-0.391-1.025-0.391-1.416 0-0.281 0.281-0.659 0.438-1.059 0.438s-0.778-0.156-1.059-0.441c-0.584-0.584-0.584-1.538 0-2.122 0.391-0.391 0.391-1.025 0-1.416l-2.734-2.728c-0.188-0.188-0.441-0.294-0.706-0.294s-0.519 0.106-0.706 0.294l-13 13c-0.391 0.391-0.391 1.025 0 1.416l2.731 2.731c0.188 0.188 0.441 0.294 0.706 0.294s0.519-0.106 0.706-0.294c0.284-0.284 0.659-0.441 1.059-0.441s0.778 0.156 1.059 0.441 0.444 0.659 0.444 1.059c0 0.4-0.156 0.778-0.441 1.059-0.188 0.188-0.294 0.441-0.294 0.706s0.106 0.519 0.294 0.706l2.731 2.731c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l13-13c0.394-0.387 0.394-1.019 0.003-1.409zM10 21.584l-1.422-1.422c0.716-1.325 0.516-3.022-0.603-4.141-0.663-0.656-1.541-1.022-2.475-1.022 0 0 0 0 0 0-0.591 0-1.159 0.147-1.666 0.419l-1.419-1.419 11.584-11.584 1.422 1.422c-0.716 1.325-0.516 3.022 0.603 4.141 0.681 0.681 1.578 1.025 2.475 1.025 0.575 0 1.147-0.141 1.666-0.419l1.422 1.422-11.587 11.578z" }),
_('path', { d: "M12.853 6.147c-0.194-0.194-0.513-0.194-0.706 0l-6 6c-0.194 0.194-0.194 0.513 0 0.706l5 5c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l6-6c0.194-0.194 0.194-0.513 0-0.706l-5-5zM11.5 16.794l-4.294-4.294 5.294-5.294 4.294 4.294-5.294 5.294z" })
            );
        }
        function Ticket({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TicketSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ticket.SVG = TicketSVG;
        return Ticket;
    })();
export const Tile = /*#__PURE__*/ (() => {
        function TileSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M2.793 4.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M2.793 7.5l4.707-4.707 0.707 0.707-4.707 4.707-0.707-0.707z" }),
_('path', { d: "M2.793 10.5l7.707-7.707 0.707 0.707-7.707 7.707-0.707-0.707z" }),
_('path', { d: "M8.793 10.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M5.793 10.5l4.707-4.707 0.707 0.707-4.707 4.707-0.707-0.707z" }),
_('path', { d: "M18.793 20.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M15.793 20.5l4.707-4.707 0.707 0.707-4.707 4.707-0.707-0.707z" }),
_('path', { d: "M12.793 20.5l7.707-7.707 0.707 0.707-7.707 7.707-0.707-0.707z" }),
_('path', { d: "M12.793 14.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M12.793 17.5l4.707-4.707 0.707 0.707-4.707 4.707-0.707-0.707z" }),
_('path', { d: "M18.793 3.501l0.707-0.707 1.708 1.708-0.707 0.707-1.708-1.708z" }),
_('path', { d: "M15.793 3.5l0.707-0.707 4.707 4.707-0.707 0.707-4.707-4.707z" }),
_('path', { d: "M12.793 3.5l0.707-0.707 7.707 7.707-0.707 0.707-7.707-7.707z" }),
_('path', { d: "M12.793 9.501l0.707-0.707 1.708 1.708-0.707 0.707-1.708-1.708z" }),
_('path', { d: "M12.793 6.5l0.707-0.707 4.707 4.707-0.707 0.707-4.707-4.707z" }),
_('path', { d: "M2.793 19.501l0.707-0.707 1.708 1.708-0.707 0.707-1.708-1.708z" }),
_('path', { d: "M2.793 16.5l0.707-0.707 4.707 4.707-0.707 0.707-4.707-4.707z" }),
_('path', { d: "M2.793 13.5l0.707-0.707 7.707 7.707-0.707 0.707-7.707-7.707z" }),
_('path', { d: "M8.793 13.501l0.707-0.707 1.708 1.708-0.707 0.707-1.708-1.708z" }),
_('path', { d: "M5.793 13.5l0.707-0.707 4.707 4.707-0.707 0.707-4.707-4.707z" })
            );
        }
        function Tile({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TileSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Tile.SVG = TileSVG;
        return Tile;
    })();
export const Tissue = /*#__PURE__*/ (() => {
    function TissueSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.559 14.747v0l-3.669-4.559c-0.094-0.119-0.237-0.188-0.391-0.188h-1.519c0.969-2.166 2.275-4.234 3.903-6.178 0.097-0.116 0.134-0.266 0.106-0.412-0.116-0.606-0.766-1.113-1.987-1.547-0.931-0.331-2.131-0.597-3.378-0.747-1.028-0.125-2-0.156-2.737-0.087-0.997 0.094-1.587 0.366-1.8 0.831-0.081 0.178-0.141 0.466 0.028 0.825 0.103 0.222 0.284 0.447 0.55 0.687 0.369 0.331 0.375 0.519 0.338 0.616h-0.003v0.006c-0.009 0.025-0.022 0.044-0.031 0.059-0.256 0.387-1.338 0.844-3.106 0.922-1.816 0.081-3.694-0.256-5.153-0.928-0.213-0.1-0.469-0.034-0.609 0.153s-0.131 0.45 0.022 0.628c1.697 1.95 2.941 3.644 3.784 5.172h-1.406c-0.15 0-0.294 0.069-0.391 0.188l-3.669 4.563c-0.275 0.341-0.441 0.778-0.441 1.25v5c0 1.103 0.897 2 2 2h18c1.103 0 2-0.897 2-2v-5c0-0.472-0.166-0.909-0.441-1.253zM8.906 5.972c0.884-0.041 1.703-0.172 2.359-0.384 0.203-0.066 0.391-0.138 0.559-0.219-0.047 0.172-0.103 0.356-0.159 0.55-0.297 1.003-0.666 2.25-0.666 3.578v0.5h1v-0.5c0-1.181 0.347-2.353 0.625-3.294 0.209-0.706 0.375-1.266 0.375-1.719v-0.378c0.066-0.381-0.028-0.903-0.666-1.478-0.213-0.194-0.288-0.316-0.316-0.369 0.138-0.103 0.663-0.291 1.95-0.266 1.119 0.022 2.475 0.206 3.628 0.491 0.738 0.181 1.356 0.397 1.797 0.622 0.259 0.131 0.416 0.247 0.506 0.334-2.169 2.656-3.772 5.531-4.766 8.559h-6.263c-0.372-1.175-0.975-2.4-1.841-3.738-0.544-0.837-1.194-1.728-1.975-2.688 1.219 0.316 2.55 0.456 3.85 0.397zM5.741 11h1.672c0.156 0.341 0.291 0.675 0.406 1h-0.819v1h10v-1h-0.809c0.116-0.334 0.237-0.669 0.369-1h1.7l2.412 3h-17.347l2.416-3zM21 21h-18v-5h18v5z" })
        );
    }
    function Tissue({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TissueSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tissue.SVG = TissueSVG;
    return Tissue;
})();
export const Toast = /*#__PURE__*/ (() => {
        function ToastSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.906 5.041c-0.275-1.384-1.131-2.637-2.412-3.531-1.413-0.987-3.309-1.509-5.484-1.509h-6.009c-2.175 0-4.072 0.522-5.484 1.509-1.281 0.894-2.138 2.15-2.412 3.531-0.2 1.006-0.081 1.997 0.344 2.866 0.347 0.713 0.878 1.294 1.553 1.706v12.387c0 1.103 0.897 2 2 2h14.009c1.103 0 2-0.897 2-2v-12.391c0.675-0.413 1.206-0.994 1.553-1.706 0.425-0.866 0.544-1.856 0.344-2.862zM19.625 8.075c-0.375 0.156-0.619 0.519-0.619 0.925v13h-14.006v-13c0-0.403-0.244-0.769-0.619-0.925-1.034-0.428-1.553-1.469-1.319-2.647 0.316-1.581 2.059-3.428 5.937-3.428h6.009c3.878 0 5.622 1.847 5.937 3.431 0.231 1.178-0.284 2.216-1.322 2.644z" }),
_('path', { d: "M7.794 12.499l5.708-5.708 0.707 0.707-5.708 5.708-0.707-0.707z" }),
_('path', { d: "M7.793 16.5l7.707-7.707 0.707 0.707-7.707 7.707-0.707-0.707z" }),
_('path', { d: "M9.794 18.499l5.708-5.708 0.707 0.707-5.708 5.708-0.707-0.707z" }),
_('path', { d: "M13.793 18.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M18.447 3.762c-0.884-0.5-2.072-0.762-3.438-0.762h-4.009v1h4.009c2.481 0 3.8 0.944 3.975 1.822 0.012 0.063 0.019 0.119 0.019 0.169l1-0.003c0-0.116-0.012-0.237-0.038-0.363-0.147-0.731-0.687-1.394-1.519-1.863z" }),
_('path', { d: "M7.793 8.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" })
            );
        }
        function Toast({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ToastSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Toast.SVG = ToastSVG;
        return Toast;
    })();
export const Toaster = /*#__PURE__*/ (() => {
        function ToasterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.869 8.047c-2.091-0.675-4.884-1.047-7.869-1.047s-5.778 0.372-7.869 1.050c-3.416 1.1-4.131 2.756-4.131 3.95v10c0 0.553 0.447 1 1 1h1v1h2v-1h16v1h2v-1h1c0.553 0 1-0.447 1-1v-10c0-1.194-0.716-2.85-4.131-3.953zM2 21v-9c0-0.738 1-1.484 2.744-2.050 1.872-0.603 4.516-0.95 7.256-0.95s5.384 0.347 7.256 0.953c1.744 0.563 2.744 1.309 2.744 2.050v7h-12v1h12v1h-20z" }),
_('path', { d: "M6.5 16h-0.5v-4h-1v4h-0.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h0.5v1h1v-1h0.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5zM6.5 18h-2c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h2c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M12.116 4.856l0.356 0.35 0.7-0.716-0.356-0.35c-0.837-0.819-0.819-1.106-0.816-1.134 0.019-0.109 0.387-0.297 0.612-0.406 0.331-0.166 0.709-0.356 0.987-0.656 0.363-0.394 0.481-0.881 0.347-1.45l-0.116-0.488-0.972 0.231 0.116 0.488c0.106 0.45-0.075 0.616-0.809 0.981-0.494 0.247-1.053 0.528-1.15 1.147-0.091 0.553 0.25 1.172 1.1 2.003z" }),
_('path', { d: "M7.116 4.856l0.356 0.35 0.7-0.716-0.356-0.35c-0.837-0.819-0.819-1.106-0.816-1.134 0.019-0.109 0.387-0.297 0.612-0.406 0.331-0.166 0.709-0.356 0.987-0.656 0.363-0.394 0.481-0.881 0.347-1.45l-0.116-0.488-0.972 0.231 0.116 0.488c0.106 0.45-0.075 0.616-0.809 0.981-0.494 0.247-1.053 0.528-1.15 1.147-0.091 0.553 0.25 1.172 1.1 2.003z" }),
_('path', { d: "M17.116 4.856l0.356 0.35 0.7-0.716-0.356-0.35c-0.837-0.819-0.819-1.106-0.816-1.134 0.019-0.109 0.387-0.297 0.612-0.406 0.331-0.166 0.709-0.356 0.987-0.656 0.363-0.394 0.481-0.881 0.347-1.45l-0.116-0.488-0.972 0.231 0.116 0.488c0.106 0.45-0.075 0.616-0.809 0.981-0.494 0.247-1.053 0.528-1.15 1.147-0.091 0.553 0.25 1.172 1.1 2.003z" })
            );
        }
        function Toaster({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ToasterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Toaster.SVG = ToasterSVG;
        return Toaster;
    })();
export const ToggleOff = /*#__PURE__*/ (() => {
        function ToggleOffSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.656 6.344c-1.512-1.512-3.519-2.344-5.656-2.344h-8c-2.137 0-4.147 0.831-5.656 2.344-1.512 1.509-2.344 3.519-2.344 5.656s0.831 4.147 2.344 5.656c1.512 1.512 3.519 2.344 5.656 2.344h8c2.137 0 4.147-0.831 5.656-2.344 1.512-1.512 2.344-3.519 2.344-5.656s-0.831-4.147-2.344-5.656zM16 18h-8c-3.309 0-6-2.691-6-6s2.691-6 6-6h8c3.309 0 6 2.691 6 6s-2.691 6-6 6z" }),
_('path', { d: "M8 7c-2.756 0-5 2.244-5 5s2.244 5 5 5 5-2.244 5-5c0-2.756-2.244-5-5-5zM8 16c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4c0 2.206-1.794 4-4 4z" })
            );
        }
        function ToggleOff({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ToggleOffSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ToggleOff.SVG = ToggleOffSVG;
        return ToggleOff;
    })();
export const ToggleOff2 = /*#__PURE__*/ (() => {
        function ToggleOff2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.95 7.050c-1.322-1.322-3.081-2.050-4.95-2.050-1.847 0-3.581 0.709-4.9 2h-7.1c-2.756 0-5 2.244-5 5s2.244 5 5 5h7.1c1.316 1.291 3.053 2 4.9 2 1.869 0 3.628-0.728 4.95-2.050s2.050-3.081 2.050-4.95c0-1.869-0.728-3.628-2.050-4.95zM1 12c0-2.206 1.794-4 4-4h6.253c-0.816 1.166-1.253 2.55-1.253 4s0.438 2.834 1.253 4h-6.253c-2.206 0-4-1.794-4-4zM17 17c-2.756 0-5-2.244-5-5s2.244-5 5-5 5 2.244 5 5c0 2.756-2.244 5-5 5z" }),
_('path', { d: "M13 12h1c0-1.653 1.347-3 3-3v-1c-2.206 0-4 1.794-4 4z" })
            );
        }
        function ToggleOff2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ToggleOff2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ToggleOff2.SVG = ToggleOff2SVG;
        return ToggleOff2;
    })();
export const ToggleOn = /*#__PURE__*/ (() => {
        function ToggleOnSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.656 6.344c-1.512-1.512-3.519-2.344-5.656-2.344h-8c-2.137 0-4.147 0.831-5.656 2.344-1.512 1.509-2.344 3.519-2.344 5.656s0.831 4.147 2.344 5.656c1.512 1.512 3.519 2.344 5.656 2.344h8c2.137 0 4.147-0.831 5.656-2.344 1.512-1.512 2.344-3.519 2.344-5.656s-0.831-4.147-2.344-5.656zM16 18h-8c-3.309 0-6-2.691-6-6s2.691-6 6-6h8c3.309 0 6 2.691 6 6s-2.691 6-6 6z" }),
_('path', { d: "M16 7c-2.756 0-5 2.244-5 5s2.244 5 5 5 5-2.244 5-5c0-2.756-2.244-5-5-5zM16 16c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4c0 2.206-1.794 4-4 4z" })
            );
        }
        function ToggleOn({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ToggleOnSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ToggleOn.SVG = ToggleOnSVG;
        return ToggleOn;
    })();
export const ToggleOn2 = /*#__PURE__*/ (() => {
        function ToggleOn2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 7h-7.1c-1.316-1.291-3.053-2-4.9-2-1.869 0-3.628 0.728-4.95 2.050s-2.050 3.081-2.050 4.95c0 1.869 0.728 3.628 2.050 4.95s3.081 2.050 4.95 2.050c1.847 0 3.584-0.709 4.9-2h7.1c2.756 0 5-2.244 5-5s-2.244-5-5-5zM7 17c-2.756 0-5-2.244-5-5s2.244-5 5-5 5 2.244 5 5c0 2.756-2.244 5-5 5zM19 16h-6.253c0.816-1.166 1.253-2.55 1.253-4s-0.438-2.834-1.253-4h6.253c2.206 0 4 1.794 4 4s-1.794 4-4 4z" }),
_('path', { d: "M3 12h1c0-1.653 1.347-3 3-3v-1c-2.206 0-4 1.794-4 4z" })
            );
        }
        function ToggleOn2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ToggleOn2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ToggleOn2.SVG = ToggleOn2SVG;
        return ToggleOn2;
    })();
export const ToiletPaper = /*#__PURE__*/ (() => {
        function ToiletPaperSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 11c1.122 0 2-1.319 2-3s-0.878-3-2-3-2 1.319-2 3 0.878 3 2 3zM6 6c0.472 0 1 0.856 1 2s-0.528 2-1 2-1-0.856-1-2 0.528-2 1-2z" }),
_('path', { d: "M22.35 2.469c-0.541-0.756-1.178-1.356-1.894-1.778-0.772-0.459-1.6-0.691-2.456-0.691h-12c-0.856 0-1.684 0.231-2.456 0.691-0.716 0.422-1.353 1.022-1.894 1.778-1.062 1.491-1.65 3.456-1.65 5.531v15.5c0 0.172 0.091 0.334 0.237 0.425s0.331 0.1 0.487 0.022l1.775-0.888 1.775 0.888c0.141 0.072 0.306 0.072 0.447 0l1.775-0.888 1.775 0.888c0.141 0.072 0.306 0.072 0.447 0l1.775-0.888 1.775 0.888c0.141 0.072 0.306 0.072 0.447 0l1.775-0.888 1.775 0.888c0.072 0.034 0.147 0.053 0.225 0.053 0.091 0 0.181-0.025 0.262-0.075 0.147-0.091 0.237-0.253 0.237-0.425v-7.5h1c0.856 0 1.684-0.231 2.456-0.691 0.716-0.425 1.353-1.022 1.894-1.778 1.066-1.491 1.65-3.453 1.65-5.531s-0.578-4.041-1.641-5.531zM3.278 3.631c0.75-1.053 1.719-1.631 2.722-1.631s1.972 0.578 2.722 1.631c0.825 1.153 1.278 2.706 1.278 4.369s-0.453 3.216-1.278 4.369c-0.75 1.053-1.719 1.631-2.722 1.631s-1.972-0.578-2.722-1.631c-0.825-1.153-1.278-2.706-1.278-4.369s0.453-3.216 1.278-4.369zM16 22.691l-1.275-0.638c-0.141-0.072-0.306-0.072-0.447 0l-1.778 0.888-1.775-0.888c-0.141-0.072-0.306-0.072-0.447 0l-1.778 0.888-1.775-0.888c-0.141-0.072-0.306-0.072-0.447 0l-1.778 0.888-1.775-0.888c-0.141-0.072-0.306-0.072-0.447 0l-1.278 0.638v-10.247c0.191 0.384 0.409 0.747 0.65 1.087 0.541 0.756 1.178 1.356 1.894 1.778 0.772 0.456 1.6 0.691 2.456 0.691h10v6.691zM20.722 12.369c-0.75 1.053-1.719 1.631-2.722 1.631h-8.016c0.125-0.15 0.247-0.306 0.366-0.469 1.066-1.491 1.65-3.453 1.65-5.531s-0.588-4.041-1.65-5.531c-0.116-0.162-0.237-0.319-0.366-0.469h8.016c1.003 0 1.969 0.578 2.722 1.631 0.825 1.153 1.278 2.706 1.278 4.369s-0.453 3.216-1.278 4.369z" }),
_('path', { d: "M13 7h2v1h-2v-1z" }),
_('path', { d: "M16 7h2v1h-2v-1z" }),
_('path', { d: "M19 7h2v1h-2v-1z" })
            );
        }
        function ToiletPaper({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ToiletPaperSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ToiletPaper.SVG = ToiletPaperSVG;
        return ToiletPaper;
    })();
export const Tombstone = /*#__PURE__*/ (() => {
        function TombstoneSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21 19h-1.753l2.744-12.391c0.025-0.116 0.009-0.237-0.047-0.344l-3.194-6c-0.087-0.162-0.256-0.266-0.441-0.266h-12.309c-0.366 0-0.703 0.2-0.878 0.522l-3 5.5c-0.116 0.213-0.15 0.459-0.097 0.697l2.728 12.281h-1.753c-1.103 0-2 0.897-2 2v2.5c0 0.275 0.225 0.5 0.5 0.5h21c0.275 0 0.5-0.225 0.5-0.5v-2.5c0-1.103-0.897-2-2-2zM16.247 19l2.666-12h1.962l-2.656 12h-1.972zM20.669 6h-1.8l-2.728-5h1.869l2.659 5zM4.056 6.65l2.538-4.65h7.812l2.538 4.65-2.747 12.35h-7.394l-2.747-12.35zM3 23v-2h18v2h-18z" }),
_('path', { d: "M10 7h1v5h-1v-5z" }),
_('path', { d: "M9 8.5c0-0.828-0.672-1.5-1.5-1.5h-1c-0.275 0-0.5 0.225-0.5 0.5v4.5h1v-2h0.191l1.088 2.172 0.894-0.447-0.953-1.906c0.466-0.256 0.781-0.75 0.781-1.319zM7 8h0.5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-0.5v-1z" }),
_('path', { d: "M15 8.5c0-0.828-0.672-1.5-1.5-1.5h-1c-0.275 0-0.5 0.225-0.5 0.5v4.5h1v-2h0.5c0.828 0 1.5-0.672 1.5-1.5zM13 8h0.5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-0.5v-1z" })
            );
        }
        function Tombstone({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TombstoneSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Tombstone.SVG = TombstoneSVG;
        return Tombstone;
    })();
export const TongueWink = /*#__PURE__*/ (() => {
        function TongueWinkSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M15.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM15.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M10.5 9h0.5v-1h-0.5c-1.437 0-2.816-0.325-3.784-0.894l-0.431-0.253-0.506 0.862 0.431 0.253c1.134 0.666 2.656 1.031 4.291 1.031z" }),
_('path', { d: "M18.341 12.025c-3.912 1.306-8.772 1.306-12.684 0l-0.475-0.159-0.316 0.95 0.475 0.159c2.053 0.684 4.356 1.028 6.659 1.028v1.997c0 1.653 1.347 3 3 3s3-1.347 3-3v-2.819c0.222-0.066 0.441-0.134 0.659-0.206l0.475-0.159-0.316-0.95-0.478 0.159zM17 16c0 1.103-0.897 2-2 2s-2-0.897-2-2v-2.019c1.362-0.059 2.712-0.237 4-0.537v2.556z" })
            );
        }
        function TongueWink({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TongueWinkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TongueWink.SVG = TongueWinkSVG;
        return TongueWink;
    })();
export const Tongue = /*#__PURE__*/ (() => {
        function TongueSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M8.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM8.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M15.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM15.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M18.341 12.025c-3.912 1.303-8.772 1.303-12.684 0l-0.475-0.159-0.316 0.95 0.475 0.159c1.156 0.384 2.391 0.663 3.659 0.831v2.197c0 1.653 1.347 3 3 3s3-1.347 3-3v-2.197c1.269-0.169 2.503-0.444 3.659-0.831l0.475-0.159-0.316-0.95-0.478 0.159zM14 16c0 1.103-0.897 2-2 2s-2-0.897-2-2v-2.084c0.663 0.056 1.331 0.087 2 0.087s1.338-0.028 2-0.087v2.084z" })
            );
        }
        function Tongue({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TongueSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Tongue.SVG = TongueSVG;
        return Tongue;
    })();
export const Toothbrush = /*#__PURE__*/ (() => {
        function ToothbrushSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.472 9c0.225 0 4.778 0.006 6.441 0.006 0.284 0 0.484 0 0.563 0 1.775-0.006 3.209-0.544 4.153-1.553 1.041-1.119 1.494-2.797 1.344-4.984-0.016-0.241-0.203-0.438-0.444-0.462s-0.466 0.125-0.534 0.356c-0.353 1.209-2.656 1.641-4.519 1.641h-7c-1.378 0-2.5 1.122-2.5 2.5s1.119 2.497 2.497 2.497zM3.472 5h7c0.894 0 1.803-0.094 2.559-0.263 0.806-0.181 1.456-0.444 1.941-0.784-0.097 1.206-0.456 2.153-1.078 2.819-0.759 0.816-1.912 1.231-3.425 1.238-0.531 0.003-6.931-0.006-6.997-0.006-0.828 0-1.5-0.672-1.5-1.5s0.675-1.503 1.5-1.503z" }),
_('path', { d: "M23.5 17h-9.466c0.175-2.622 0.938-5.322 0.947-5.35 0.053-0.181-0.003-0.378-0.144-0.506s-0.341-0.166-0.519-0.097c-0.897 0.35-1.706 0.822-2.419 1.406-0.156-0.816-0.497-1.578-1.003-2.241-0.109-0.144-0.291-0.219-0.472-0.191s-0.331 0.15-0.394 0.322c-0.306 0.831-0.738 1.613-1.172 2.15-0.213-0.769-0.622-1.422-0.991-1.819-0.006-0.006-0.009-0.009-0.016-0.016-0.138-0.138-0.422-0.338-1.266-0.481-0.491-0.084-1.103-0.141-1.769-0.162-1.131-0.037-2.581 0.022-3.259 0.306-0.487 0.197-0.559 0.519-0.559 0.691 0 0.053 0.009 0.106 0.025 0.156 0.7 2.103 0.9 4.488 0.956 5.884-1.131 0.241-1.981 1.247-1.981 2.447 0 1.378 1.122 2.5 2.5 2.5h21c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5zM4.534 11.003c1.506 0.028 2.428 0.228 2.613 0.366 0.425 0.469 0.85 1.303 0.85 2.138 0 0.181 0.1 0.35 0.259 0.438s0.353 0.081 0.509-0.016c0.722-0.453 1.362-1.413 1.812-2.334 0.278 0.588 0.422 1.234 0.422 1.909 0 0.206 0.125 0.387 0.316 0.466 0.191 0.075 0.406 0.028 0.547-0.122 0.544-0.575 1.178-1.059 1.891-1.444-0.253 1.072-0.612 2.834-0.722 4.594h-10.053c-0.056-1.387-0.25-3.694-0.897-5.809 0.381-0.103 1.244-0.206 2.453-0.184zM23 20h-20.5c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h20.5v1z" })
            );
        }
        function Toothbrush({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ToothbrushSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Toothbrush.SVG = ToothbrushSVG;
        return Toothbrush;
    })();
export const TopHat = /*#__PURE__*/ (() => {
    function TopHatSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.325 16.381c-0.341-0.341-0.809-0.622-1.434-0.859-0.956-0.363-2.25-0.612-3.744-0.891 0.328-4.678 1.141-9.197 1.831-12.422 0.109-0.516-0.197-1.028-0.703-1.172-2.412-0.687-4.859-1.038-7.275-1.038s-4.863 0.35-7.275 1.041c-0.506 0.144-0.813 0.656-0.703 1.172 0.694 3.225 1.503 7.744 1.831 12.422-1.494 0.278-2.784 0.528-3.741 0.891-0.625 0.237-1.097 0.519-1.437 0.859-0.441 0.441-0.675 1-0.675 1.616 0 1.509 1.378 3.050 3.781 4.228 2.337 1.144 5.256 1.772 8.219 1.772s5.881-0.631 8.219-1.772c2.403-1.175 3.781-2.716 3.781-4.228 0-0.616-0.234-1.175-0.675-1.619zM7.778 13.578c0.178 0.047 0.359 0.087 0.537 0.122 0.987 0.194 2.297 0.303 3.684 0.303s2.697-0.106 3.684-0.303c0.175-0.034 0.359-0.075 0.537-0.122-0.028 0.319-0.050 0.641-0.075 0.963-0.219 0.072-0.541 0.156-1.013 0.234-0.872 0.144-1.987 0.225-3.134 0.225s-2.262-0.081-3.134-0.225c-0.472-0.078-0.797-0.162-1.013-0.234-0.022-0.322-0.047-0.644-0.075-0.963zM16.319 12.497c-0.216 0.081-0.572 0.181-1.147 0.278-0.884 0.147-2.009 0.225-3.172 0.225s-2.287-0.081-3.172-0.225c-0.575-0.094-0.931-0.197-1.147-0.278-0.328-3.356-0.863-6.544-1.381-9.147 1.897 0.431 3.809 0.65 5.7 0.65s3.803-0.219 5.7-0.65c-0.519 2.603-1.053 5.791-1.381 9.147zM8.353 15.697c0.978 0.194 2.275 0.303 3.647 0.303s2.669-0.106 3.647-0.303c0.144-0.028 0.291-0.059 0.434-0.097-0.034 0.65-0.059 1.303-0.075 1.956-0.537 0.184-1.875 0.444-4.006 0.444-2.134 0-3.472-0.259-4.006-0.444-0.012-0.65-0.041-1.303-0.075-1.956 0.144 0.038 0.291 0.069 0.434 0.097zM16.872 2.506c-3.241 0.653-6.5 0.653-9.741 0 3.237-0.669 6.5-0.669 9.741 0zM21.419 19.016c-0.481 0.497-1.2 0.984-2.081 1.416-2.037 0.997-4.713 1.569-7.338 1.569s-5.3-0.572-7.338-1.569c-0.881-0.431-1.6-0.919-2.081-1.416-0.369-0.378-0.581-0.75-0.581-1.016 0-0.072 0-0.297 0.825-0.609 0.747-0.281 1.85-0.506 3.141-0.747 0.019 0.456 0.028 0.912 0.034 1.369 0.006 0.378 0.178 0.906 0.969 1.281 0.325 0.153 0.762 0.288 1.303 0.394 1.006 0.2 2.331 0.312 3.728 0.312 1.4 0 2.725-0.109 3.731-0.312 0.541-0.106 0.978-0.241 1.303-0.394 0.831-0.394 0.963-0.969 0.966-1.284 0.006-0.453 0.019-0.909 0.034-1.366 1.291 0.241 2.4 0.462 3.144 0.747 0.434 0.166 0.638 0.309 0.728 0.403 0.078 0.078 0.091 0.128 0.091 0.206 0.003 0.266-0.209 0.638-0.578 1.016z" })
        );
    }
    function TopHat({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TopHatSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    TopHat.SVG = TopHatSVG;
    return TopHat;
})();
export const Tornado = /*#__PURE__*/ (() => {
        function TornadoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.794 2.016c-0.594-0.419-1.413-0.788-2.434-1.097-1.981-0.591-4.594-0.919-7.359-0.919s-5.378 0.328-7.359 0.922c-1.022 0.306-1.841 0.675-2.434 1.097-0.997 0.706-1.206 1.466-1.206 1.981 0 1.831 0.419 3.347 1.278 4.634 0.734 1.097 1.669 1.828 2.416 2.416 0.631 0.494 1.175 0.919 1.303 1.325 0.134 0.419-0.141 1.106-0.813 2.044-0.597 0.834-0.978 1.669-1.131 2.481-0.103 0.55-0.106 1.094-0.006 1.625-0.322-0.072-0.628-0.147-0.919-0.234-1.678-0.497-2.128-1.044-2.128-1.291h-1c0 0.922 0.984 1.7 2.85 2.247 0.478 0.141 1.003 0.263 1.563 0.366 0.603 1.253 1.809 2.353 3.6 3.272 1.409 0.722 2.675 1.066 2.728 1.081 0.084 0.022 0.172 0.034 0.259 0.034h4c0.428 0 0.809-0.272 0.947-0.678s0-0.853-0.341-1.116c-1.506-1.153-2.175-1.962-2.441-2.519 0.719-0.116 1.387-0.263 1.984-0.438 1.863-0.547 2.85-1.325 2.85-2.247h-1c0 0.247-0.45 0.794-2.131 1.287-0.528 0.156-1.119 0.288-1.75 0.394 0.328-0.725 1.409-1.531 2.628-2.441 1.466-1.097 3.294-2.459 4.725-4.369 1.7-2.269 2.528-4.844 2.528-7.872 0-0.519-0.209-1.278-1.206-1.987zM6.478 2.763c1.769-0.491 4.084-0.762 6.522-0.762s4.753 0.272 6.522 0.762c1.887 0.525 2.425 1.106 2.478 1.247-0.012 0.266-0.659 0.816-2.409 1.275-1.753 0.462-4.094 0.716-6.591 0.716s-4.837-0.253-6.591-0.716c-1.75-0.459-2.397-1.013-2.409-1.275 0.050-0.144 0.591-0.725 2.478-1.247zM13.378 22h-1.237c-0.322-0.097-1.256-0.4-2.25-0.912-0.553-0.288-1.188-0.672-1.725-1.144 0.597 0.038 1.209 0.056 1.834 0.056 0.725 0 1.437-0.025 2.125-0.078 0.181 0.669 0.591 1.35 1.253 2.078zM19.55 11.084c-0.459 0.281-1.253 0.516-2.309 0.672-1.65 0.244-3.531 0.244-4.241 0.244v1c0.728 0 2.662 0 4.384-0.256 0.237-0.034 0.462-0.075 0.678-0.116-0.831 0.753-1.7 1.403-2.516 2.009-1.831 1.369-3.422 2.556-3.528 4.291-0.653 0.047-1.331 0.072-2.022 0.072-0.944 0-1.863-0.047-2.725-0.134-0.066-0.122-0.122-0.244-0.169-0.372-0.309-0.866-0.078-1.819 0.706-2.913 0.684-0.956 1.544-2.391 1.091-3.816-0.309-0.975-1.091-1.6-1.925-2.253 0.413 0.091 0.863 0.169 1.35 0.234 1.847 0.244 3.903 0.253 5.328 0.253 0.059 0 0.119 0 0.175 0h0.166v-1h-0.166c-1.4 0-3.513 0-5.372-0.244-1.934-0.256-2.922-0.687-3.419-1.1-0.409-0.572-0.738-1.269-0.909-2.169 0.506 0.288 1.181 0.544 2.025 0.762 1.834 0.481 4.266 0.75 6.844 0.75s5.009-0.266 6.844-0.75c0.872-0.228 1.563-0.494 2.075-0.794-0.262 2.391-1.184 4.188-2.366 5.628z" }),
_('path', { d: "M3 13.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5zM1 13.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5z" }),
_('path', { d: "M23 18c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1z" }),
_('path', { d: "M4 22.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M23 14.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Tornado({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TornadoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Tornado.SVG = TornadoSVG;
        return Tornado;
    })();
export const Towel = /*#__PURE__*/ (() => {
    function TowelSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.559 2.441c-0.281-0.284-0.659-0.441-1.059-0.441h-2.266c-0.55-0.612-1.347-1-2.234-1h-12c-0.866 0-1.669 0.363-2.238 1h-2.262c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h1.512v13c0 1.103 0.897 2 2 2h1.987v1c0 1.103 0.897 2 2 2h10c1.103 0 2-0.897 2-2v-16h1.5c0.828 0 1.5-0.672 1.5-1.5 0-0.4-0.156-0.778-0.441-1.059zM9 14.706l0.5-0.5 1.647 1.647c0.194 0.194 0.513 0.194 0.706 0l1.647-1.647 1.647 1.647c0.194 0.194 0.513 0.194 0.706 0l1.647-1.647 1.5 1.5v1.584l-1.147-1.147c-0.194-0.194-0.513-0.194-0.706 0l-1.647 1.65-1.647-1.647c-0.194-0.194-0.513-0.194-0.706 0l-1.647 1.647-1.647-1.647c-0.194-0.194-0.513-0.194-0.706 0l-0.147 0.147v-1.587zM18 3c0.55 0 1 0.45 1 1v10.294l-1.147-1.147c-0.194-0.194-0.513-0.194-0.706 0l-1.647 1.647-1.647-1.647c-0.194-0.194-0.513-0.194-0.706 0l-1.647 1.647-1.647-1.647c-0.194-0.194-0.513-0.194-0.706 0l-0.147 0.147v-9.294c0-0.35-0.059-0.687-0.172-1h9.172zM1 3.5c0-0.275 0.225-0.5 0.5-0.5h4.5c0.55 0 1 0.45 1 1h-5.5c-0.275 0-0.5-0.225-0.5-0.5zM5.013 18v-13h1.987v13h-1.988zM9 21v-3.294l0.5-0.5 1.647 1.647c0.194 0.194 0.513 0.194 0.706 0l1.647-1.647 1.647 1.647c0.194 0.194 0.513 0.194 0.706 0l1.647-1.647 1.5 1.5v2.294h-10zM22.853 3.853c-0.094 0.094-0.219 0.147-0.353 0.147h-1.5c0-0.35-0.059-0.687-0.172-1h1.672c0.275 0 0.5 0.225 0.5 0.5 0 0.134-0.053 0.259-0.147 0.353z" })
        );
    }
    function Towel({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TowelSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Towel.SVG = TowelSVG;
    return Towel;
})();
export const TrafficLights = /*#__PURE__*/ (() => {
        function TrafficLightsSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 3c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12 6c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M12 8c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12 11c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M12 13c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12 16c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M20.747 4.934c0.156-0.087 0.253-0.256 0.253-0.434v-1c0-0.275-0.225-0.5-0.5-0.5h-2.5v-1c0-1.103-0.897-2-2-2h-8c-1.103 0-2 0.897-2 2v1h-2.5c-0.275 0-0.5 0.225-0.5 0.5v1c0 0.178 0.097 0.344 0.253 0.434l2.747 1.572v1.494h-2.5c-0.275 0-0.5 0.225-0.5 0.5v1c0 0.178 0.097 0.344 0.253 0.434l2.747 1.572v1.494h-2.5c-0.275 0-0.5 0.225-0.5 0.5v1c0 0.178 0.097 0.344 0.253 0.434l2.747 1.572v1.494c0 1.103 0.897 2 2 2h1v3.5c0 0.275 0.225 0.5 0.5 0.5h5c0.275 0 0.5-0.225 0.5-0.5v-3.5h1c1.103 0 2-0.897 2-2v-1.497l2.747-1.572c0.156-0.087 0.253-0.256 0.253-0.434v-1c0-0.275-0.225-0.5-0.5-0.5h-2.5v-1.497l2.747-1.572c0.156-0.087 0.253-0.256 0.253-0.434v-1c0-0.275-0.225-0.5-0.5-0.5h-2.5v-1.497l2.747-1.563zM4 4.209v-0.209h2v1.353l-2-1.144zM4 9.209v-0.209h2v1.353l-2-1.144zM4 14.209v-0.209h2v1.353l-2-1.144zM20 4v0.209l-2 1.144v-1.353h2zM13 23h-2v-3h2v3zM16 18h-8v-16h8v16c0.003 0 0 0 0 0zM20 14v0.209l-2 1.144v-1.353h2zM20 9v0.209l-2 1.144v-1.353h2z" })
            );
        }
        function TrafficLights({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TrafficLightsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TrafficLights.SVG = TrafficLightsSVG;
        return TrafficLights;
    })();
export const Train = /*#__PURE__*/ (() => {
        function TrainSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 4h-6c-1.653 0-3 1.347-3 3v3.5c0 0.275 0.225 0.5 0.5 0.5h11c0.275 0 0.5-0.225 0.5-0.5v-3.5c0-1.653-1.347-3-3-3zM17 10h-10v-3c0-1.103 0.897-2 2-2h6c1.103 0 2 0.897 2 2v3z" }),
_('path', { d: "M8 12c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM8 15c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M16 12c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM16 15c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M20.4 23.2l0.8-0.6-2.7-3.6h0.5c1.103 0 2-0.897 2-2v-10c0-3.309-2.691-6-6-6h-6c-3.309 0-6 2.691-6 6v10c0 1.103 0.897 2 2 2h0.5l-2.7 3.6 0.8 0.6 3.15-4.2h10.5l3.15 4.2zM5 7c0-2.206 1.794-4 4-4h6c2.206 0 4 1.794 4 4v10c0 0 0 0 0 0h-14v-10z" })
            );
        }
        function Train({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TrainSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Train.SVG = TrainSVG;
        return Train;
    })();
export const TransferCircle = /*#__PURE__*/ (() => {
        function TransferCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12.206 10.5l-2.353-2.353c-0.194-0.194-0.513-0.194-0.706 0l-2.353 2.353 0.706 0.706 1.5-1.5v6.294h1v-6.294l1.5 1.5 0.706-0.706z" }),
_('path', { d: "M15 14.294v-6.294h-1v6.294l-1.5-1.5-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l2.353-2.353-0.706-0.706-1.5 1.5z" }),
_('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" })
            );
        }
        function TransferCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TransferCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TransferCircle.SVG = TransferCircleSVG;
        return TransferCircle;
    })();
export const TransferSquare = /*#__PURE__*/ (() => {
        function TransferSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M9 9.706v6.294h1v-6.294l1.5 1.5 0.706-0.706-2.353-2.353c-0.194-0.194-0.513-0.194-0.706 0l-2.353 2.353 0.706 0.706 1.5-1.5z" }),
_('path', { d: "M11.794 13.5l2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l2.353-2.353-0.706-0.706-1.5 1.5v-6.294h-1v6.294l-1.5-1.5-0.706 0.706z" })
            );
        }
        function TransferSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TransferSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TransferSquare.SVG = TransferSquareSVG;
        return TransferSquare;
    })();
export const Transmission = /*#__PURE__*/ (() => {
        function TransmissionSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 17h2v-4h3v4h2v-4h3v4h2v-10h-2v4h-3v-4h-2v4h-3v-4h-2v4h-4v-4h-2v4c0 1.103 0.897 2 2 2h4v4z" }),
_('path', { d: "M10 1.706v3.294h1v-4.5c0-0.203-0.122-0.384-0.309-0.462s-0.403-0.034-0.544 0.109l-1.353 1.353 0.706 0.706 0.5-0.5z" }),
_('path', { d: "M17 3.5c0-0.672-0.444-1.241-1.050-1.431l0.95-1.269c0.112-0.15 0.131-0.353 0.047-0.525-0.084-0.169-0.256-0.275-0.447-0.275h-2.5v1h1.5l-0.9 1.2c-0.112 0.15-0.131 0.353-0.047 0.525 0.084 0.169 0.259 0.275 0.447 0.275h0.5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-1.5v1h1.5c0.828 0 1.5-0.672 1.5-1.5z" }),
_('path', { d: "M16 22h-0.806l0.938-2.816-0.95-0.316-1.159 3.475c-0.050 0.153-0.025 0.319 0.069 0.45s0.244 0.206 0.406 0.206h1.5v1h1v-3h-1v1z" }),
_('path', { d: "M22 1v-1h-2.5c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-1.5v1h1.5c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5h-0.5v-1h2z" }),
_('path', { d: "M19.847 20.059c-0.547 0.656-0.847 1.522-0.847 2.441 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5c-0.034 0-0.069 0-0.1 0.003 0.366-0.609 0.947-1.003 1.6-1.003v-1c-0.819 0-1.584 0.375-2.153 1.059zM20.5 22c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M3 3h0.191l1.088 2.172 0.894-0.447-0.953-1.906c0.466-0.256 0.781-0.75 0.781-1.316 0-0.828-0.672-1.5-1.5-1.5h-1c-0.275 0-0.5 0.225-0.5 0.5v4.5h1v-2.003zM3 1h0.5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5h-0.5v-1z" }),
_('path', { d: "M12 20.5c0-0.45-0.172-0.85-0.481-1.125-0.272-0.244-0.634-0.378-1.019-0.378s-0.747 0.134-1.019 0.378c-0.309 0.275-0.481 0.675-0.481 1.125v0.5h1v-0.5c0-0.478 0.416-0.5 0.5-0.5 0.138 0 0.266 0.044 0.356 0.125 0.097 0.084 0.144 0.213 0.144 0.378 0 0.612-0.341 0.9-0.897 1.319-0.491 0.366-1.103 0.822-1.103 1.678 0 0.275 0.225 0.5 0.5 0.5h2.5v-1h-1.766c0.116-0.116 0.272-0.234 0.466-0.381 0.55-0.413 1.3-0.975 1.3-2.119z" })
            );
        }
        function Transmission({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TransmissionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Transmission.SVG = TransmissionSVG;
        return Transmission;
    })();
export const TrashCross = /*#__PURE__*/ (() => {
        function TrashCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 8h1v13h-1v-13z" }),
_('path', { d: "M5 8h1v13h-1v-13z" }),
_('path', { d: "M23 6.5c0-3.584-2.916-6.5-6.5-6.5-0.884 0-1.731 0.178-2.5 0.5v0c0-0.275-0.225-0.5-0.5-0.5h-7c-0.275 0-0.5 0.225-0.5 0.5v1.5h-3c-1.103 0-2 0.897-2 2v2.5c0 0.275 0.225 0.5 0.5 0.5h0.5v15c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2v-9.175c2.862-0.678 5-3.256 5-6.325zM7 1h6v0.025c-0.434 0.278-0.831 0.606-1.184 0.975h-4.816v-1zM3 4h7.5c-0.259 0.625-0.428 1.297-0.481 2h-7.019v-2zM4 22v-15h6.019c0.081 1.081 0.431 2.091 0.981 2.959v11.041h1v-9.816c0.575 0.553 1.253 1 2 1.313v8.5h1v-8.172c0.325 0.078 0.659 0.131 1 0.156v9.019h-12zM16.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18.5 3.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function TrashCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TrashCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TrashCross.SVG = TrashCrossSVG;
        return TrashCross;
    })();
export const TrashCross2 = /*#__PURE__*/ (() => {
        function TrashCross2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 8h1v13h-1v-13z" }),
_('path', { d: "M5.022 7.853c-0.678 2.203-1.022 4.441-1.022 6.647s0.344 4.444 1.022 6.647l0.956-0.294c-1.297-4.216-1.297-8.491 0-12.706l-0.956-0.294z" }),
_('path', { d: "M24 6.5c0-3.584-2.916-6.5-6.5-6.5-1.287 0-2.491 0.375-3.5 1.025v-0.525c0-0.275-0.225-0.5-0.5-0.5h-7c-0.275 0-0.5 0.225-0.5 0.5v1.5h-3c-1.103 0-2 0.897-2 2v2.5c0 0.275 0.225 0.5 0.5 0.5h0.184c-1.059 2.534-1.625 5.059-1.681 7.516-0.063 2.822 0.547 5.625 1.809 8.331 0.328 0.7 1.041 1.153 1.812 1.153h12.709c0.816 0 1.544-0.487 1.853-1.247 0.738-1.822 1.259-3.609 1.544-5.313 0.281-1.678 0.344-3.328 0.188-4.906 2.391-0.963 4.081-3.303 4.081-6.034zM7 1h6v0.813c-0.063 0.059-0.125 0.122-0.188 0.188h-5.813v-1zM3 4h8.5c-0.259 0.625-0.428 1.297-0.481 2h-8.019v-2zM16.334 22h-12.709c0 0-0.003 0-0.003 0-2.259-4.841-2.178-9.747 0.247-15h7.131v14h1v-11.041c0.697 1.106 1.719 1.984 2.928 2.509 0.222 2.6-0.081 5.422-0.909 8.397l0.963 0.269c0.816-2.925 1.144-5.722 0.975-8.319 0.497 0.122 1.013 0.184 1.544 0.184 0.15 0 0.303-0.006 0.45-0.016 0.228 2.781-0.316 5.812-1.616 9.016zM17.5 12c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 3.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function TrashCross2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TrashCross2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TrashCross2.SVG = TrashCross2SVG;
        return TrashCross2;
    })();
export const TrashFull = /*#__PURE__*/ (() => {
        function TrashFullSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20.378 7h0.122c0.275 0 0.5-0.225 0.5-0.5v-2.5c0-1.103-0.897-2-2-2h-3v-1.5c0-0.275-0.225-0.5-0.5-0.5h-7c-0.275 0-0.5 0.225-0.5 0.5v1.5h-3c-1.103 0-2 0.897-2 2v2.5c0 0.275 0.225 0.5 0.5 0.5h0.188c-1.062 2.534-1.628 5.059-1.681 7.516-0.063 2.822 0.547 5.625 1.809 8.328 0.328 0.7 1.038 1.153 1.812 1.153h12.709c0.819 0 1.547-0.491 1.853-1.247 1.212-2.991 1.822-5.866 1.816-8.55-0.012-2.509-0.556-4.928-1.628-7.2zM9 1h6v1h-6v-1zM5 4h14v2h-14v-2zM18.334 22c0 0 0 0 0 0h-12.709c-2.259-4.841-2.178-9.747 0.244-15h12.263c2.431 4.434 2.497 9.341 0.203 15z" }),
_('path', { d: "M10 8h1v13h-1v-13z" }),
_('path', { d: "M13 8h1v13h-1v-13z" }),
_('path', { d: "M7.022 7.853c-0.678 2.203-1.022 4.441-1.022 6.647s0.344 4.444 1.022 6.647l0.956-0.294c-1.297-4.216-1.297-8.491 0-12.706l-0.956-0.294z" }),
_('path', { d: "M16.028 8.163c1.309 3.828 1.306 7.984-0.009 12.703l0.963 0.269c0.659-2.366 1-4.653 1.019-6.797 0.019-2.269-0.328-4.453-1.028-6.5l-0.944 0.325z" })
            );
        }
        function TrashFull({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TrashFullSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TrashFull.SVG = TrashFullSVG;
        return TrashFull;
    })();
export const TrashWarning = /*#__PURE__*/ (() => {
        function TrashWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 8h1v13h-1v-13z" }),
_('path', { d: "M11 8h1v13h-1v-13z" }),
_('path', { d: "M5.022 7.853c-0.678 2.203-1.022 4.441-1.022 6.647s0.344 4.444 1.022 6.647l0.956-0.294c-1.297-4.216-1.297-8.491 0-12.706l-0.956-0.294z" }),
_('path', { d: "M18 8h1v1h-1v-1z" }),
_('path', { d: "M18 3h1v4h-1v-4z" }),
_('path', { d: "M23.841 8.828l-4-7.997c-0.25-0.506-0.775-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-0.584 1.172h-2.575v-1.5c0-0.275-0.225-0.5-0.5-0.5h-7c-0.275 0-0.5 0.225-0.5 0.5v1.5h-3c-1.103 0-2 0.897-2 2v2.5c0 0.275 0.225 0.5 0.5 0.5h0.184c-1.059 2.534-1.625 5.059-1.681 7.516-0.063 2.822 0.547 5.625 1.809 8.331 0.328 0.7 1.041 1.153 1.812 1.153h12.709c0.816 0 1.544-0.487 1.853-1.247 0.884-2.178 1.45-4.306 1.688-6.319 0.219-1.869 0.159-3.691-0.178-5.434h2.803c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672zM7 1h6v1h-6v-1zM3 4h12.575l-1 2h-11.575v-2zM16.334 22h-12.709c-0.003 0-0.003 0-0.003 0-2.259-4.841-2.178-9.747 0.247-15h10.203l-0.912 1.828c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h0.244c0.513 3.047 0.272 6.281-0.725 9.866l0.963 0.269c0.525-1.881 0.85-3.716 0.969-5.453 0.109-1.606 0.044-3.178-0.194-4.681h1.894c0.75 3.369 0.319 6.972-1.316 11zM22.5 10h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5z" })
            );
        }
        function TrashWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TrashWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TrashWarning.SVG = TrashWarningSVG;
        return TrashWarning;
    })();
export const Trash = /*#__PURE__*/ (() => {
        function TrashSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 2h-3v-1.5c0-0.275-0.225-0.5-0.5-0.5h-7c-0.275 0-0.5 0.225-0.5 0.5v1.5h-3c-1.103 0-2 0.897-2 2v2.5c0 0.275 0.225 0.5 0.5 0.5h0.5v15c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2v-15h0.5c0.275 0 0.5-0.225 0.5-0.5v-2.5c0-1.103-0.897-2-2-2zM9 1h6v1h-6v-1zM18 22h-12v-15h12v15zM5 6v-2h14v2h-14z" }),
_('path', { d: "M10 8h1v13h-1v-13z" }),
_('path', { d: "M13 8h1v13h-1v-13z" }),
_('path', { d: "M7 8h1v13h-1v-13z" }),
_('path', { d: "M16 8h1v13h-1v-13z" })
            );
        }
        function Trash({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TrashSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Trash.SVG = TrashSVG;
        return Trash;
    })();
export const Traveling = /*#__PURE__*/ (() => {
        function TravelingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 5c1.103 0 2-0.897 2-2s-0.897-2-2-2-2 0.897-2 2 0.897 2 2 2zM18 2c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M19.928 10.153c1.094 0.706 2.369 0.847 4.072 0.847v-2c-1.603 0-2.384-0.138-2.991-0.528-0.663-0.425-1.256-1.247-2.122-2.928-0.213-0.409-0.675-0.622-1.125-0.516-0.184 0.044-0.344 0.138-0.472 0.266v0l-6.25 6.25 0.547 0.547c-0.347 0.156-0.588 0.506-0.588 0.912 0 0.091 0.012 0.175 0.034 0.259l-1.534 1.531-2.294-2.294c-0.666-0.666-1.75-0.666-2.416 0l-4.291 4.294c-0.666 0.666-0.666 1.75 0 2.416l1.519 1.519c-0.012 0.091-0.019 0.181-0.019 0.275 0 0.534 0.209 1.038 0.584 1.416 0.391 0.384 0.903 0.581 1.416 0.581s1.025-0.194 1.416-0.584c0.378-0.378 0.584-0.881 0.584-1.416 0-0.363-0.097-0.712-0.278-1.016l6.019-6.019c0.081 0.022 0.169 0.034 0.259 0.034 0.55 0 1-0.45 1-1 0-0.169-0.044-0.328-0.116-0.469l4.116-4.116v4.456c-0.691 2.588-2.234 6.391-4.047 8.775l1.591 1.209c1.719-2.262 3.178-5.562 4.031-8.262 1.022 0.775 1.931 1.716 2.334 2.434l-1.841 4.6 1.856 0.744 2-5c0.091-0.228 0.097-0.484 0.009-0.719-0.591-1.6-2.522-3.275-3.938-4.209v-3.075c0.291 0.306 0.597 0.569 0.931 0.784zM1.206 17.5l4.294-4.294c0.275-0.275 0.725-0.275 1 0l0.794 0.794-5.294 5.294-0.794-0.794c-0.275-0.275-0.275-0.725 0-1zM4.706 21.706c-0.391 0.391-1.025 0.391-1.416 0-0.188-0.188-0.294-0.441-0.294-0.706s0.103-0.519 0.294-0.706c0.194-0.194 0.45-0.294 0.706-0.294s0.513 0.097 0.706 0.294c0.188 0.188 0.294 0.441 0.294 0.706s-0.1 0.519-0.291 0.706zM5.016 19.278c-0.406-0.241-0.881-0.322-1.334-0.25l4.319-4.322 0.794 0.794-3.778 3.778z" })
            );
        }
        function Traveling({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TravelingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Traveling.SVG = TravelingSVG;
        return Traveling;
    })();
export const TrenCircle = /*#__PURE__*/ (() => {
        function TrenCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.275 7.053l-2.447 1.225 0.447 0.894 1.431-0.716-1.5 5.25-2.431-1.619c-0.197-0.131-0.462-0.106-0.631 0.063l-3.35 3.35 0.706 0.706 3.063-3.063 2.659 1.772c0.134 0.087 0.3 0.109 0.45 0.053s0.266-0.178 0.309-0.331l1.647-5.763 0.65 1.297 0.894-0.447-1.225-2.447c-0.122-0.25-0.422-0.35-0.672-0.225z" }),
_('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" })
            );
        }
        function TrenCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TrenCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TrenCircle.SVG = TrenCircleSVG;
        return TrenCircle;
    })();
export const TrendSquare = /*#__PURE__*/ (() => {
        function TrendSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M11.528 13.119l2.697 1.797c0.134 0.087 0.3 0.109 0.45 0.053s0.266-0.178 0.309-0.331l1.647-5.763 0.65 1.297 0.894-0.447-1.225-2.447c-0.125-0.247-0.425-0.347-0.672-0.225l-2.447 1.225 0.447 0.894 1.431-0.716-1.5 5.25-2.431-1.619c-0.181-0.122-0.419-0.109-0.591 0.025l-5.391 4.312 0.625 0.781 5.106-4.088z" })
            );
        }
        function TrendSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TrendSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TrendSquare.SVG = TrendSquareSVG;
        return TrendSquare;
    })();
export const TrophyFirst = /*#__PURE__*/ (() => {
        function TrophyFirstSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 11c-2.478 0-4.638 1.394-5.734 3.441-0.113-0.434-0.259-0.878-0.434-1.284-0.138-0.325-0.284-0.603-0.431-0.841 0.272-0.206 0.537-0.456 0.797-0.753 0.381-0.438 0.744-0.972 1.084-1.594 0.438-0.066 1.425-0.25 2.422-0.7 1.828-0.822 2.794-2.125 2.794-3.769 0-1.378-1.122-2.5-2.5-2.5-0.219 0-0.431 0.028-0.634 0.081 0.044-0.366 0.078-0.728 0.103-1.081h1.034v-2h-14v2h1.034c0.022 0.353 0.056 0.716 0.103 1.081-0.206-0.053-0.419-0.081-0.638-0.081-1.378 0-2.5 1.122-2.5 2.5 0 1.644 0.966 2.947 2.794 3.769 0.997 0.447 1.981 0.634 2.422 0.7 0.341 0.622 0.703 1.153 1.084 1.594 0.259 0.297 0.525 0.547 0.797 0.753-0.147 0.237-0.291 0.516-0.431 0.841-0.247 0.581-0.444 1.244-0.559 1.844h-1.106c-1.653 0-3 1.347-3 3v3c0 0.087 0.012 0.172 0.031 0.25-0.616 0.341-1.031 0.997-1.031 1.75v0.5c0 0.275 0.225 0.5 0.5 0.5h16c3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5zM15.5 4c0.828 0 1.5 0.672 1.5 1.5 0 1.231-0.734 2.187-2.184 2.847-0.525 0.237-1.056 0.397-1.484 0.497 0.044-0.1 0.087-0.203 0.128-0.306 0.541-1.313 0.966-2.816 1.231-4.3 0.234-0.15 0.513-0.237 0.809-0.237zM3.184 8.347c-1.45-0.659-2.184-1.616-2.184-2.847 0-0.828 0.672-1.5 1.5-1.5 0.297 0 0.575 0.087 0.809 0.237 0.266 1.484 0.691 2.988 1.231 4.3 0.044 0.103 0.084 0.206 0.128 0.306-0.425-0.1-0.959-0.256-1.484-0.497zM6.387 7.775c-0.725-1.759-1.219-3.891-1.353-5.775h5.919c-0.116 1.403-0.459 3-0.95 4.378l-0.169 0.472 0.941 0.334 0.169-0.472c0.528-1.481 0.891-3.206 1.009-4.716h1.003c-0.134 1.884-0.628 4.016-1.353 5.775-0.797 1.962-1.822 3.228-2.603 3.228s-1.806-1.266-2.613-3.225zM8.403 14.194c0.231-0.616 0.456-0.953 0.597-1.109 0.138 0.156 0.366 0.497 0.597 1.109 0.103 0.278 0.188 0.553 0.25 0.806h-1.694c0.063-0.253 0.147-0.528 0.25-0.806zM4 18c0-0.55 0.45-1 1-1h6.019c-0.012 0.166-0.019 0.331-0.019 0.5 0 0.884 0.178 1.731 0.5 2.5h-7.5v-2zM2 23c0-0.55 0.45-1 1-1h9.813c0.366 0.381 0.778 0.716 1.225 1h-12.038zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17.691 14.037c-0.188-0.078-0.403-0.034-0.544 0.109l-1.353 1.353 0.706 0.706 0.5-0.5v5.294h1v-6.5c0-0.203-0.122-0.384-0.309-0.462z" })
            );
        }
        function TrophyFirst({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TrophyFirstSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TrophyFirst.SVG = TrophyFirstSVG;
        return TrophyFirst;
    })();
export const TrophySecond = /*#__PURE__*/ (() => {
        function TrophySecondSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 11c-2.478 0-4.638 1.394-5.734 3.441-0.113-0.434-0.259-0.878-0.434-1.284-0.138-0.325-0.284-0.603-0.431-0.841 0.272-0.206 0.537-0.456 0.797-0.753 0.381-0.438 0.744-0.972 1.084-1.594 0.438-0.066 1.425-0.25 2.422-0.7 1.828-0.822 2.794-2.125 2.794-3.769 0-1.378-1.122-2.5-2.5-2.5-0.219 0-0.431 0.028-0.634 0.081 0.044-0.366 0.078-0.728 0.103-1.081h1.034v-2h-14v2h1.034c0.022 0.353 0.056 0.716 0.103 1.081-0.206-0.053-0.419-0.081-0.638-0.081-1.378 0-2.5 1.122-2.5 2.5 0 1.644 0.966 2.947 2.794 3.769 0.997 0.447 1.981 0.634 2.422 0.7 0.341 0.622 0.703 1.153 1.084 1.594 0.259 0.297 0.525 0.547 0.797 0.753-0.147 0.237-0.291 0.516-0.431 0.841-0.247 0.581-0.444 1.244-0.559 1.844h-1.106c-1.653 0-3 1.347-3 3v3c0 0.087 0.012 0.172 0.031 0.25-0.616 0.341-1.031 0.997-1.031 1.75v0.5c0 0.275 0.225 0.5 0.5 0.5h16c3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5zM15.5 4c0.828 0 1.5 0.672 1.5 1.5 0 1.231-0.734 2.187-2.184 2.847-0.525 0.237-1.056 0.397-1.484 0.497 0.044-0.1 0.087-0.203 0.128-0.306 0.541-1.313 0.966-2.816 1.231-4.3 0.234-0.15 0.513-0.237 0.809-0.237zM3.184 8.347c-1.45-0.659-2.184-1.616-2.184-2.847 0-0.828 0.672-1.5 1.5-1.5 0.297 0 0.575 0.087 0.809 0.237 0.266 1.484 0.691 2.988 1.231 4.3 0.044 0.103 0.084 0.206 0.128 0.306-0.425-0.1-0.959-0.256-1.484-0.497zM6.387 7.775c-0.725-1.759-1.219-3.891-1.353-5.775h5.919c-0.116 1.403-0.459 3-0.95 4.378l-0.169 0.472 0.941 0.334 0.169-0.472c0.528-1.481 0.891-3.206 1.009-4.716h1.003c-0.134 1.884-0.628 4.016-1.353 5.775-0.797 1.962-1.822 3.228-2.603 3.228s-1.806-1.266-2.613-3.225zM8.403 14.194c0.231-0.616 0.456-0.953 0.597-1.109 0.138 0.156 0.366 0.497 0.597 1.109 0.103 0.278 0.188 0.553 0.25 0.806h-1.694c0.063-0.253 0.147-0.528 0.25-0.806zM4 18c0-0.55 0.45-1 1-1h6.019c-0.012 0.166-0.019 0.331-0.019 0.5 0 0.884 0.178 1.731 0.5 2.5h-7.5v-2zM2 23c0-0.55 0.45-1 1-1h9.813c0.366 0.381 0.778 0.716 1.225 1h-12.038zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17.547 19.209c1.094-0.531 2.453-1.191 2.453-2.709 0-1.641-1.256-2.5-2.5-2.5s-2.5 0.859-2.5 2.5v0.5h1v-0.5c0-1.034 0.753-1.5 1.5-1.5 0.397 0 0.775 0.138 1.044 0.375 0.303 0.269 0.456 0.647 0.456 1.125 0 0.831-0.75 1.256-1.891 1.809-0.987 0.481-2.109 1.022-2.109 2.191 0 0.275 0.225 0.5 0.5 0.5h4.5v-1h-3.772c0.256-0.259 0.712-0.497 1.319-0.791z" })
            );
        }
        function TrophySecond({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TrophySecondSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TrophySecond.SVG = TrophySecondSVG;
        return TrophySecond;
    })();
export const TrophyThird = /*#__PURE__*/ (() => {
        function TrophyThirdSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 11c-2.478 0-4.638 1.394-5.734 3.441-0.113-0.434-0.259-0.878-0.434-1.284-0.138-0.325-0.284-0.603-0.431-0.841 0.272-0.206 0.537-0.456 0.797-0.753 0.381-0.438 0.744-0.972 1.084-1.594 0.438-0.066 1.425-0.25 2.422-0.7 1.828-0.822 2.794-2.125 2.794-3.769 0-1.378-1.122-2.5-2.5-2.5-0.219 0-0.431 0.028-0.634 0.081 0.044-0.366 0.078-0.728 0.103-1.081h1.034v-2h-14v2h1.034c0.022 0.353 0.056 0.716 0.103 1.081-0.206-0.053-0.419-0.081-0.638-0.081-1.378 0-2.5 1.122-2.5 2.5 0 1.644 0.966 2.947 2.794 3.769 0.997 0.447 1.981 0.634 2.422 0.7 0.341 0.622 0.703 1.153 1.084 1.594 0.259 0.297 0.525 0.547 0.797 0.753-0.147 0.237-0.291 0.516-0.431 0.841-0.247 0.581-0.444 1.244-0.559 1.844h-1.106c-1.653 0-3 1.347-3 3v3c0 0.087 0.012 0.172 0.031 0.25-0.616 0.341-1.031 0.997-1.031 1.75v0.5c0 0.275 0.225 0.5 0.5 0.5h16c3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5zM15.5 4c0.828 0 1.5 0.672 1.5 1.5 0 1.231-0.734 2.187-2.184 2.847-0.525 0.237-1.056 0.397-1.484 0.497 0.044-0.1 0.087-0.203 0.128-0.306 0.541-1.313 0.966-2.816 1.231-4.3 0.234-0.15 0.513-0.237 0.809-0.237zM3.184 8.347c-1.45-0.659-2.184-1.616-2.184-2.847 0-0.828 0.672-1.5 1.5-1.5 0.297 0 0.575 0.087 0.809 0.237 0.266 1.484 0.691 2.988 1.231 4.3 0.044 0.103 0.084 0.206 0.128 0.306-0.425-0.1-0.959-0.256-1.484-0.497zM6.387 7.775c-0.725-1.759-1.219-3.891-1.353-5.775h5.919c-0.116 1.403-0.459 3-0.95 4.378l-0.169 0.472 0.941 0.334 0.169-0.472c0.528-1.481 0.891-3.206 1.009-4.716h1.003c-0.134 1.884-0.628 4.016-1.353 5.775-0.797 1.962-1.822 3.228-2.603 3.228s-1.806-1.266-2.613-3.225zM8.403 14.194c0.231-0.616 0.456-0.953 0.597-1.109 0.138 0.156 0.366 0.497 0.597 1.109 0.103 0.278 0.188 0.553 0.25 0.806h-1.694c0.063-0.253 0.147-0.528 0.25-0.806zM4 18c0-0.55 0.45-1 1-1h6.019c-0.012 0.166-0.019 0.331-0.019 0.5 0 0.884 0.178 1.731 0.5 2.5h-7.5v-2zM2 23c0-0.55 0.45-1 1-1h9.813c0.366 0.381 0.778 0.716 1.225 1h-12.038zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18.381 16.159l1.019-1.359c0.112-0.15 0.131-0.353 0.047-0.525-0.084-0.169-0.259-0.275-0.447-0.275h-3v1h2l-0.9 1.2c-0.113 0.15-0.131 0.353-0.047 0.525 0.084 0.169 0.259 0.275 0.447 0.275 0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5c-0.531 0-1.028-0.288-1.3-0.75l-0.25-0.431-0.866 0.503 0.25 0.431c0.447 0.769 1.278 1.25 2.163 1.25 1.378 0 2.5-1.122 2.5-2.5 0.003-1.072-0.672-1.987-1.616-2.344z" })
            );
        }
        function TrophyThird({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TrophyThirdSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TrophyThird.SVG = TrophyThirdSVG;
        return TrophyThird;
    })();
export const Trophy = /*#__PURE__*/ (() => {
    function TrophySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18.969 21.25c0.022-0.081 0.031-0.166 0.031-0.25v-3c0-1.653-1.347-3-3-3h-1.106c-0.112-0.603-0.312-1.263-0.559-1.844-0.138-0.325-0.284-0.603-0.431-0.841 0.272-0.206 0.537-0.456 0.797-0.753 0.381-0.438 0.744-0.972 1.084-1.594 0.438-0.066 1.425-0.25 2.422-0.7 1.828-0.822 2.794-2.125 2.794-3.769 0-1.378-1.122-2.5-2.5-2.5-0.219 0-0.431 0.028-0.634 0.081 0.044-0.366 0.078-0.728 0.1-1.081h1.034v-2h-14v2h1.034c0.022 0.353 0.056 0.716 0.1 1.081-0.203-0.053-0.416-0.081-0.634-0.081-1.378 0-2.5 1.122-2.5 2.5 0 1.644 0.966 2.947 2.794 3.769 0.997 0.45 1.984 0.634 2.422 0.7 0.341 0.622 0.703 1.156 1.084 1.594 0.259 0.297 0.525 0.547 0.797 0.753-0.147 0.237-0.291 0.516-0.431 0.841-0.247 0.581-0.444 1.244-0.559 1.844h-1.106c-1.653 0-3 1.347-3 3v3c0 0.087 0.012 0.172 0.031 0.25-0.616 0.341-1.031 0.997-1.031 1.75v0.5c0 0.275 0.225 0.5 0.5 0.5h15c0.275 0 0.5-0.225 0.5-0.5v-0.5c0-0.753-0.416-1.406-1.031-1.75zM18.5 4c0.828 0 1.5 0.672 1.5 1.5 0 1.231-0.734 2.187-2.184 2.847-0.525 0.237-1.059 0.397-1.484 0.497 0.044-0.1 0.087-0.2 0.128-0.306 0.541-1.313 0.966-2.816 1.228-4.3 0.237-0.15 0.516-0.237 0.813-0.237zM6.184 8.347c-1.45-0.659-2.184-1.616-2.184-2.847 0-0.828 0.672-1.5 1.5-1.5 0.297 0 0.575 0.087 0.809 0.237 0.266 1.484 0.687 2.984 1.228 4.3 0.044 0.103 0.084 0.206 0.128 0.306-0.422-0.1-0.953-0.256-1.481-0.497zM9.387 7.775c-0.725-1.759-1.219-3.891-1.353-5.775h5.919c-0.116 1.403-0.459 3-0.95 4.378l-0.169 0.472 0.941 0.334 0.169-0.472c0.528-1.481 0.894-3.206 1.013-4.716h1.003c-0.134 1.884-0.628 4.016-1.353 5.775-0.8 1.962-1.825 3.228-2.606 3.228s-1.806-1.266-2.613-3.225zM11.403 14.194c0.231-0.616 0.456-0.953 0.597-1.109 0.138 0.156 0.366 0.497 0.597 1.109 0.103 0.278 0.188 0.553 0.25 0.806h-1.694c0.063-0.253 0.147-0.528 0.25-0.806zM7 18c0-0.55 0.45-1 1-1h8c0.55 0 1 0.45 1 1v2h-10v-2zM5 23c0-0.55 0.45-1 1-1h12c0.55 0 1 0.45 1 1h-14z" })
        );
    }
    function Trophy({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TrophySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Trophy.SVG = TrophySVG;
    return Trophy;
})();
export const Trowel = /*#__PURE__*/ (() => {
    function TrowelSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.269 0.731c-0.972-0.972-2.559-0.972-3.537 0l-6 6c-0.722 0.722-0.909 1.781-0.559 2.681l-2.525 2.525-3.456-3.453c-0.409-0.409-0.991-0.572-1.556-0.434-0.563 0.138-1.003 0.55-1.175 1.106l-4.437 14.194c-0.056 0.178-0.009 0.372 0.125 0.503 0.094 0.094 0.222 0.147 0.353 0.147 0.050 0 0.1-0.006 0.15-0.022l14.2-4.434c0.553-0.172 0.966-0.612 1.103-1.175s-0.022-1.147-0.434-1.556l-3.459-3.459 2.525-2.525c0.294 0.113 0.603 0.172 0.912 0.172 0.641 0 1.278-0.244 1.769-0.728 0 0 0 0 0.003-0.003l6-6c0.972-0.975 0.972-2.559 0-3.537zM14.813 17.519c0.162 0.162 0.225 0.384 0.169 0.609s-0.213 0.391-0.431 0.459l-13.287 4.15 4.153-13.287c0.069-0.219 0.237-0.378 0.459-0.431 0.053-0.012 0.106-0.019 0.159-0.019 0.169 0 0.325 0.066 0.45 0.191l3.456 3.456-2.897 2.897 1.416 1.416 2.897-2.897 3.456 3.456zM21.853 2.853l-6 6c-0.197 0.194-0.516 0.197-0.706 0.003-0.197-0.197-0.197-0.516-0.003-0.709l6-6c0.1-0.1 0.228-0.147 0.359-0.147 0.128 0 0.253 0.047 0.35 0.144 0.194 0.197 0.197 0.516 0 0.709z" })
        );
    }
    function Trowel({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TrowelSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Trowel.SVG = TrowelSVG;
    return Trowel;
})();
export const TruckArrow = /*#__PURE__*/ (() => {
        function TruckArrowSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.894 12.831l-1.15-0.575-1.575-3.147c-0.341-0.684-1.025-1.106-1.788-1.106h-3.381c0-1.103-0.897-2-2-2h-0.5c-0.981-2.35-3.3-4.003-6-4.003-3.584 0-6.5 2.916-6.5 6.5v10.5c0 1.103 0.897 2 2 2h1.5v-0.003c0.456 0.606 1.184 1.003 2 1.003s1.544-0.394 2-1l9-0.003c0.456 0.606 1.184 1.003 2 1.003s1.544-0.394 2-1.003v0.003h1.5c1.103 0 2-0.897 2-2v-4.381c0-0.75-0.434-1.453-1.106-1.788zM6.5 3c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM5.5 21c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM13 19h-5.050c-0.231-1.141-1.244-2-2.45-2s-2.219 0.859-2.45 2h-1.050v-5.813c1.169 1.122 2.756 1.812 4.5 1.812 3.584 0 6.5-2.916 6.5-6.5 0-0.169-0.006-0.334-0.019-0.5h0.019v11zM19.881 13h-2.881v-1h2.381l0.5 1zM18.5 21c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM20.95 19c-0.231-1.141-1.244-2-2.45-2s-2.219 0.859-2.45 2h-1.050v-9h3.381c0 0 0 0 0 0l0.5 1h-2.381c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h4.263l1.238 0.619v1.381h-1v1h1v2h-1.050z" }),
_('path', { d: "M6.794 10.5l0.706 0.706 2.353-2.353c0.194-0.194 0.194-0.513 0-0.706l-2.353-2.353-0.706 0.706 1.5 1.5h-5.294v1h5.294l-1.5 1.5z" })
            );
        }
        function TruckArrow({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TruckArrowSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TruckArrow.SVG = TruckArrowSVG;
        return TruckArrow;
    })();
export const TruckCheck = /*#__PURE__*/ (() => {
        function TruckCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.894 12.831l-1.15-0.575-1.575-3.147c-0.341-0.684-1.025-1.106-1.788-1.106h-3.381c0-1.103-0.897-2-2-2h-0.5c-0.981-2.35-3.3-4.003-6-4.003-3.584 0-6.5 2.916-6.5 6.5v10.5c0 1.103 0.897 2 2 2h1.5v-0.003c0.456 0.606 1.184 1.003 2 1.003s1.544-0.394 2-1l9-0.003c0.456 0.606 1.184 1.003 2 1.003s1.544-0.394 2-1.003v0.003h1.5c1.103 0 2-0.897 2-2v-4.381c0-0.75-0.434-1.453-1.106-1.788zM6.5 3c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM5.5 21c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM13 19h-5.050c-0.231-1.141-1.244-2-2.45-2s-2.219 0.859-2.45 2h-1.050v-5.813c1.169 1.122 2.756 1.812 4.5 1.812 3.584 0 6.5-2.916 6.5-6.5 0-0.169-0.006-0.334-0.019-0.5h0.019v11zM19.881 13h-2.881v-1h2.381l0.5 1zM18.5 21c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM20.95 19c-0.231-1.141-1.244-2-2.45-2s-2.219 0.859-2.45 2h-1.050v-9h3.381c0 0 0 0 0 0l0.5 1h-2.381c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h4.263l1.238 0.619v1.381h-1v1h1v2h-1.050z" }),
_('path', { d: "M5.5 11c0.128 0 0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147z" })
            );
        }
        function TruckCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TruckCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TruckCheck.SVG = TruckCheckSVG;
        return TruckCheck;
    })();
export const TruckCross = /*#__PURE__*/ (() => {
        function TruckCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.894 12.831l-1.15-0.575-1.575-3.147c-0.341-0.684-1.025-1.106-1.788-1.106h-3.381c0-1.103-0.897-2-2-2h-0.5c-0.981-2.35-3.3-4.003-6-4.003-3.584 0-6.5 2.916-6.5 6.5v10.5c0 1.103 0.897 2 2 2h1.5v-0.003c0.456 0.606 1.184 1.003 2 1.003s1.544-0.394 2-1l9-0.003c0.456 0.606 1.184 1.003 2 1.003s1.544-0.394 2-1.003v0.003h1.5c1.103 0 2-0.897 2-2v-4.381c0-0.75-0.434-1.453-1.106-1.788zM6.5 3c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5zM5.5 21c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM13 19h-5.050c-0.231-1.141-1.244-2-2.45-2s-2.219 0.859-2.45 2h-1.050v-5.813c1.169 1.122 2.756 1.812 4.5 1.812 3.584 0 6.5-2.916 6.5-6.5 0-0.169-0.006-0.334-0.019-0.5h0.019v11zM19.881 13h-2.881v-1h2.381l0.5 1zM18.5 21c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM20.95 19c-0.231-1.141-1.244-2-2.45-2s-2.219 0.859-2.45 2h-1.050v-9h3.381c0 0 0 0 0 0l0.5 1h-2.381c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h4.263l1.238 0.619v1.381h-1v1h1v2h-1.050z" }),
_('path', { d: "M4.5 11.206l2-2 2 2 0.706-0.706-2-2 2-2-0.706-0.706-2 2-2-2-0.706 0.706 2 2-2 2z" })
            );
        }
        function TruckCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TruckCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TruckCross.SVG = TruckCrossSVG;
        return TruckCross;
    })();
export const TruckScale = /*#__PURE__*/ (() => {
        function TruckScaleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.894 10.831l-1.15-0.575-1.575-3.147c-0.341-0.684-1.025-1.106-1.788-1.106h-3.381c0-1.103-0.897-2-2-2h-11c-1.103 0-2 0.897-2 2v11c0 1.103 0.897 2 2 2h1.5v-0.003c0.456 0.606 1.184 1.003 2 1.003s1.544-0.394 2-1l9-0.003c0.456 0.606 1.184 1.003 2 1.003s1.544-0.394 2-1.003v0.003h1.5c1.103 0 2-0.897 2-2v-4.384c0-0.75-0.434-1.453-1.106-1.788zM5.5 19c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM13 17h-5.050c-0.231-1.141-1.244-2-2.45-2s-2.219 0.859-2.45 2h-1.050v-11h11v11zM19.881 11h-2.881v-1h2.381l0.5 1zM18.5 19c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM20.95 17c-0.231-1.141-1.244-2-2.45-2s-2.219 0.859-2.45 2h-1.050v-9h3.381c0 0 0 0 0 0l0.5 1h-2.381c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h4.263l1.238 0.619v1.381h-1v1h1v2h-1.050z" }),
_('path', { d: "M4.5 14h6c0.153 0 0.3-0.072 0.394-0.194s0.128-0.278 0.091-0.428l-1-4c-0.056-0.222-0.256-0.378-0.484-0.378h-0.584c0.056-0.156 0.084-0.325 0.084-0.5 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.175 0.031 0.344 0.084 0.5h-0.584c-0.228 0-0.428 0.156-0.484 0.378l-1 4c-0.037 0.15-0.003 0.306 0.091 0.428s0.241 0.194 0.394 0.194zM7 8.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5zM5.891 10h3.219l0.75 3h-4.719l0.75-3z" })
            );
        }
        function TruckScale({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TruckScaleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TruckScale.SVG = TruckScaleSVG;
        return TruckScale;
    })();
export const TruckTime = /*#__PURE__*/ (() => {
        function TruckTimeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.894 12.831l-1.15-0.575-1.575-3.147c-0.341-0.684-1.025-1.106-1.788-1.106h-3.381c0-1.103-0.897-2-2-2h-0.5c-0.981-2.35-3.3-4.003-6-4.003-3.584 0-6.5 2.916-6.5 6.5v10.5c0 1.103 0.897 2 2 2h1.5v-0.003c0.456 0.606 1.184 1.003 2 1.003s1.544-0.394 2-1l9-0.003c0.456 0.606 1.184 1.003 2 1.003s1.544-0.394 2-1.003v0.003h1.5c1.103 0 2-0.897 2-2v-4.381c0-0.75-0.434-1.453-1.106-1.788zM6 3.022v1.978h1v-1.978c2.634 0.237 4.737 2.344 4.978 4.978h-1.978v1h1.978c-0.237 2.634-2.344 4.737-4.978 4.978v-1.978h-1v1.978c-2.634-0.237-4.737-2.344-4.978-4.978h1.978v-1h-1.978c0.241-2.634 2.344-4.737 4.978-4.978zM5.5 21c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM13 19h-5.050c-0.231-1.141-1.244-2-2.45-2s-2.219 0.859-2.45 2h-1.050v-5.813c1.169 1.122 2.756 1.812 4.5 1.812 3.416 0 6.225-2.65 6.481-6h0.019v10zM19.881 13h-2.881v-1h2.381l0.5 1zM18.5 21c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM20.95 19c-0.231-1.141-1.244-2-2.45-2s-2.219 0.859-2.45 2h-1.050v-9h3.381c0 0 0 0 0 0l0.5 1h-2.381c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h4.263l1.238 0.619v1.381h-1v1h1v2h-1.050z" }),
_('path', { d: "M6.5 10c0.016 0 0.034 0 0.050-0.003 0.15-0.016 0.284-0.097 0.366-0.219l2.278-3.416-0.831-0.556-1.938 2.909-1.925-1.922-0.706 0.706 2.353 2.353c0.094 0.094 0.222 0.147 0.353 0.147z" })
            );
        }
        function TruckTime({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TruckTimeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TruckTime.SVG = TruckTimeSVG;
        return TruckTime;
    })();
export const Truck = /*#__PURE__*/ (() => {
    function TruckSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22.894 10.831l-1.15-0.575-1.575-3.147c-0.341-0.684-1.025-1.106-1.788-1.106h-3.381c0-1.103-0.897-2-2-2h-11c-1.103 0-2 0.897-2 2v11c0 1.103 0.897 2 2 2h1.5v-0.003c0.456 0.606 1.184 1.003 2 1.003s1.544-0.394 2-1l9-0.003c0.456 0.606 1.184 1.003 2 1.003s1.544-0.394 2-1.003v0.003h1.5c1.103 0 2-0.897 2-2v-4.384c0-0.75-0.434-1.453-1.106-1.788zM5.5 19c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM13 17h-5.050c-0.231-1.141-1.244-2-2.45-2s-2.219 0.859-2.45 2h-1.050v-11h11v11zM19.881 11h-2.881v-1h2.381l0.5 1zM18.5 19c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM20.95 17c-0.231-1.141-1.244-2-2.45-2s-2.219 0.859-2.45 2h-1.050v-9h3.381c0 0 0 0 0 0l0.5 1h-2.381c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h4.263l1.238 0.619v1.381h-1v1h1v2h-1.050z" })
        );
    }
    function Truck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TruckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Truck.SVG = TruckSVG;
    return Truck;
})();
export const TuningFork = /*#__PURE__*/ (() => {
        function TuningForkSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.544 3.044l-11.5 11.5c-0.684 0.684-1.338 0.519-1.722 0.134s-0.55-1.038 0.134-1.722l11.5-11.5-1.413-1.413-11.5 11.5c-0.884 0.884-1.059 1.803-1.050 2.419 0.006 0.459 0.119 0.906 0.322 1.313l-4.797 4.794c-0.166-0.044-0.341-0.069-0.519-0.069-0.534 0-1.038 0.209-1.416 0.584-0.781 0.781-0.781 2.050 0 2.828 0.378 0.378 0.881 0.588 1.416 0.588s1.038-0.209 1.416-0.584c0.522-0.522 0.694-1.263 0.519-1.931l4.794-4.797c0.406 0.203 0.853 0.316 1.313 0.322 0.016 0 0.031 0 0.047 0 0.612 0 1.509-0.188 2.372-1.050l11.5-11.5-1.416-1.416zM2.706 22.706c-0.188 0.188-0.441 0.294-0.706 0.294s-0.519-0.103-0.706-0.294c-0.391-0.391-0.391-1.025 0-1.416 0 0 0 0 0 0 0.188-0.188 0.441-0.294 0.706-0.294s0.519 0.103 0.706 0.294c0.391 0.391 0.391 1.025 0 1.416z" }),
_('path', { d: "M14 17v1c2.138 0 4.147-0.831 5.656-2.344s2.344-3.519 2.344-5.656h-1c0 3.859-3.141 7-7 7z" }),
_('path', { d: "M7 10c0-3.859 3.141-7 7-7v-1c-2.138 0-4.147 0.831-5.656 2.344s-2.344 3.519-2.344 5.656h1z" }),
_('path', { d: "M23 10c0 4.962-4.038 9-9 9v1c2.672 0 5.181-1.041 7.072-2.928 1.887-1.891 2.928-4.4 2.928-7.072h-1z" }),
_('path', { d: "M14 1v-1c-2.672 0-5.181 1.041-7.072 2.928-1.887 1.891-2.928 4.4-2.928 7.072h1c0-4.962 4.038-9 9-9z" })
            );
        }
        function TuningFork({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TuningForkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TuningFork.SVG = TuningForkSVG;
        return TuningFork;
    })();
export const Turntable = /*#__PURE__*/ (() => {
        function TurntableSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 2h-20c-1.103 0-2 0.897-2 2v16c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-16c0-1.103-0.897-2-2-2zM22 20h-20v-16h20v16c0 0 0 0 0 0z" }),
_('path', { d: "M9 10c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2c0-1.103-0.897-2-2-2zM9 13c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1c0 0.55-0.45 1-1 1z" }),
_('path', { d: "M20 13.084v-1.084h-1v1.084c-0.581 0.206-1 0.762-1 1.416s0.419 1.209 1 1.416v3.084h1v-3.084c0.581-0.206 1-0.762 1-1.416s-0.419-1.209-1-1.416zM19.5 15c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M14 18h1v1h-1v-1z" }),
_('path', { d: "M19.5 5h-2c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h0.453l-1.828 4.113-1.153 0.462c0.019-0.188 0.028-0.378 0.028-0.572 0-3.309-2.691-6-6-6s-6 2.688-6 5.997 2.691 6 6 6c2.703 0 4.994-1.797 5.744-4.259l1.944-0.778c0.122-0.047 0.219-0.141 0.272-0.263l2.088-4.7h0.453c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5zM9 17c-2.756 0-5-2.244-5-5s2.244-5 5-5 5 2.244 5 5c0 0.344-0.034 0.678-0.1 1.003l-3.050 1.219 0.372 0.928 2.241-0.897c-0.825 1.628-2.516 2.747-4.463 2.747zM19.5 7h-2c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h2c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M16 18h2v1h-2v-1z" })
            );
        }
        function Turntable({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TurntableSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Turntable.SVG = TurntableSVG;
        return Turntable;
    })();
export const Tv = /*#__PURE__*/ (() => {
        function TvSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 5h-20c-1.103 0-2 0.897-2 2v14c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-14c0-1.103-0.897-2-2-2zM22 21h-20v-14h20v14z" }),
_('path', { d: "M3.5 20h13c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5h-13c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5zM4 9h12v10h-12v-10z" }),
_('path', { d: "M19.5 12c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM19.5 10c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M18 18h3v1h-3v-1z" }),
_('path', { d: "M18 16h3v1h-3v-1z" }),
_('path', { d: "M17.187 1.672l-0.516-0.859-5.141 3.084-4.131-3.097-0.6 0.8 4.4 3.3c0.087 0.066 0.194 0.1 0.3 0.1 0.087 0 0.178-0.025 0.256-0.072l5.431-3.256z" })
            );
        }
        function Tv({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TvSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Tv.SVG = TvSVG;
        return Tv;
    })();
export const Ul = /*#__PURE__*/ (() => {
        function UlSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3 6c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM3 7c0 0 0 0 0 0v0z" }),
_('path', { d: "M3 11c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1c0-0.55-0.45-1-1-1zM3 12c0 0 0 0 0 0v0z" }),
_('path', { d: "M3 16c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM3 17c0 0 0 0 0 0v0z" }),
_('path', { d: "M6 6h16v2h-16v-2z" }),
_('path', { d: "M6 11h16v2h-16v-2z" }),
_('path', { d: "M6 16h16v2h-16v-2z" })
            );
        }
        function Ul({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UlSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ul.SVG = UlSVG;
        return Ul;
    })();
export const Ul2 = /*#__PURE__*/ (() => {
        function Ul2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 5h16v2h-16v-2z" }),
_('path', { d: "M7 11h16v2h-16v-2z" }),
_('path', { d: "M7 17h16v2h-16v-2z" }),
_('path', { d: "M3 4c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM3 7c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" }),
_('path', { d: "M3 10c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2c0-1.103-0.897-2-2-2zM3 13c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1c0 0.55-0.45 1-1 1z" }),
_('path', { d: "M3 16c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM3 19c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
            );
        }
        function Ul2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Ul2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ul2.SVG = Ul2SVG;
        return Ul2;
    })();
export const UmbrellaRain = /*#__PURE__*/ (() => {
        function UmbrellaRainSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0.792 4.501l2.707-2.707 0.707 0.707-2.707 2.707-0.707-0.707z" }),
_('path', { d: "M6.792 3.501l2.707-2.707 0.707 0.707-2.707 2.707-0.707-0.707z" }),
_('path', { d: "M12.792 3.501l2.707-2.707 0.707 0.707-2.707 2.707-0.707-0.707z" }),
_('path', { d: "M18.792 3.501l2.707-2.707 0.707 0.707-2.707 2.707-0.707-0.707z" }),
_('path', { d: "M7.792 7.501l2.707-2.707 0.707 0.707-2.707 2.707-0.707-0.707z" }),
_('path', { d: "M1.792 8.501l2.707-2.707 0.707 0.707-2.707 2.707-0.707-0.707z" }),
_('path', { d: "M13.792 7.501l2.707-2.707 0.707 0.707-2.707 2.707-0.707-0.707z" }),
_('path', { d: "M19.792 8.501l2.707-2.707 0.707 0.707-2.707 2.707-0.707-0.707z" }),
_('path', { d: "M17.559 10.878c-1.575-1.209-3.55-1.878-5.559-1.878s-3.984 0.669-5.559 1.878c-1.528 1.175-2.441 2.716-2.441 4.122 0 0.553 0.447 1 1 1h6v5c0 0.55-0.45 1-1 1s-1-0.45-1-1h-2c0 1.653 1.347 3 3 3s3-1.347 3-3v-5h6c0.553 0 1-0.447 1-1 0-1.406-0.912-2.947-2.441-4.122zM6.294 14c0.284-0.525 0.759-1.072 1.366-1.534 1.209-0.931 2.794-1.466 4.341-1.466s3.131 0.534 4.341 1.466c0.606 0.466 1.081 1.009 1.366 1.534h-11.412z" })
            );
        }
        function UmbrellaRain({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UmbrellaRainSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UmbrellaRain.SVG = UmbrellaRainSVG;
        return UmbrellaRain;
    })();
export const Umbrella = /*#__PURE__*/ (() => {
    function UmbrellaSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.025 8.037c-0.616-1.194-1.497-2.262-2.613-3.175-2.019-1.65-4.619-2.637-7.413-2.828v-0.034c0-0.55-0.45-1-1-1s-1 0.45-1 1v0.034c-2.794 0.191-5.394 1.178-7.413 2.828-1.116 0.912-1.994 1.981-2.613 3.175-0.647 1.253-0.975 2.584-0.975 3.963v1h2v-0.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5v0.5h1v-0.5c0-0.628 0.391-1.234 1.097-1.706 0.531-0.353 1.188-0.597 1.903-0.716v9.922c0 0.55-0.45 1-1 1s-1-0.45-1-1h-2c0 1.653 1.347 3 3 3s3-1.347 3-3v-9.919c0.719 0.119 1.375 0.363 1.903 0.716 0.706 0.472 1.097 1.078 1.097 1.706v0.5h1v-0.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5v0.5h2v-1c0-1.381-0.328-2.712-0.975-3.966zM4.5 9c-0.775 0-1.491 0.253-2.072 0.681 1.006-2.65 3.684-4.719 7.047-5.422-0.403 0.444-0.775 0.997-1.106 1.653-0.606 1.209-1.025 2.688-1.228 4.297-0.641-0.741-1.587-1.209-2.641-1.209zM15.459 9.963c-0.931-0.622-2.159-0.963-3.459-0.963s-2.528 0.341-3.459 0.963c-0.141 0.094-0.275 0.194-0.397 0.297 0.194-1.466 0.575-2.806 1.122-3.9 0.384-0.766 0.822-1.362 1.306-1.772 0.462-0.391 0.944-0.588 1.428-0.588s0.966 0.197 1.428 0.588c0.484 0.409 0.922 1.006 1.306 1.772 0.547 1.094 0.928 2.434 1.122 3.9-0.122-0.103-0.256-0.203-0.397-0.297zM19.5 9c-1.053 0-2 0.469-2.644 1.206-0.203-1.606-0.622-3.084-1.228-4.297-0.328-0.656-0.7-1.212-1.106-1.653 3.363 0.703 6.044 2.775 7.047 5.422-0.578-0.425-1.294-0.678-2.069-0.678z" })
        );
    }
    function Umbrella({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( UmbrellaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Umbrella.SVG = UmbrellaSVG;
    return Umbrella;
})();
export const Underline = /*#__PURE__*/ (() => {
        function UnderlineSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3 23h18v1h-18v-1z" }),
_('path', { d: "M12 20c3.859 0 7-3.141 7-7v-13h-2v13c0 2.756-2.244 5-5 5s-5-2.244-5-5v-13h-2v13c0 3.859 3.141 7 7 7z" })
            );
        }
        function Underline({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UnderlineSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Underline.SVG = UnderlineSVG;
        return Underline;
    })();
export const Underwear = /*#__PURE__*/ (() => {
    function UnderwearSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.641 4.231c-0.228-0.191-0.528-0.269-0.819-0.216-7.181 1.306-14.463 1.306-21.644 0-0.291-0.053-0.591 0.025-0.819 0.216s-0.359 0.472-0.359 0.769v6c0 0.041 0.003 0.078 0.006 0.116 0.031 0.409 0.159 0.806 0.381 1.153 1.887 2.981 4.359 5.453 7.341 7.341 0.35 0.222 0.744 0.35 1.153 0.381 0.037 0.003 0.078 0.006 0.116 0.006h6c0.041 0 0.078-0.003 0.116-0.006 0.409-0.031 0.806-0.159 1.153-0.381 2.981-1.887 5.453-4.359 7.341-7.341 0.222-0.35 0.35-0.744 0.381-1.153 0.003-0.038 0.006-0.078 0.006-0.116v-6c0.006-0.297-0.125-0.578-0.353-0.769zM17.072 11.637c-0.912-0.912-1.047-2.897-1.069-4.769 2-0.131 4.003-0.359 5.997-0.681v3.847c-1.362 0.091-2.575 0.378-3.616 0.85-0.472 0.213-0.909 0.466-1.313 0.753zM2 6.188c1.991 0.325 3.997 0.55 5.997 0.681-0.022 1.872-0.156 3.859-1.069 4.769-0.403-0.291-0.841-0.544-1.313-0.756-1.041-0.472-2.253-0.756-3.616-0.847v-3.847zM1.406 12.006c5.941 0.175 6.594 4.228 6.594 5.994v0.597c-2.65-1.728-4.866-3.944-6.594-6.591zM14 18h-4c0-0.85-0.153-3.028-1.578-4.906-0.219-0.291-0.459-0.559-0.722-0.809 0.491-0.525 0.834-1.281 1.038-2.288 0.194-0.956 0.244-2.034 0.256-3.069 1.003 0.050 2.006 0.075 3.003 0.075s2-0.025 3.003-0.075c0.012 1.034 0.063 2.112 0.256 3.069 0.203 1.006 0.547 1.763 1.038 2.288-0.259 0.25-0.5 0.522-0.722 0.809-1.419 1.878-1.572 4.056-1.572 4.906zM16 18.597v-0.597c0-1.766 0.653-5.819 6.594-5.994-1.728 2.647-3.944 4.863-6.594 6.591z" })
        );
    }
    function Underwear({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( UnderwearSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Underwear.SVG = UnderwearSVG;
    return Underwear;
})();
export const Underwear2 = /*#__PURE__*/ (() => {
    function Underwear2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M24 7c-0.487 0-1.003 0.119-1.538 0.35-0.075-0.063-0.156-0.119-0.244-0.166 0.266-0.819 0.675-1.378 0.681-1.384l0.3-0.4-0.8-0.6-0.3 0.4c-0.025 0.034-0.566 0.762-0.878 1.825-0.588 0.109-1.053 0.563-1.184 1.144-5.881 1.109-10.191 1.109-16.075 0-0.15-0.669-0.75-1.169-1.463-1.169-0.041 0-0.084 0.003-0.125 0.006-0.194-0.559-0.375-1.275-0.375-2.006h-1c0 0.859 0.206 1.681 0.428 2.322-0.516-0.213-0.994-0.322-1.428-0.322v1c0.294 0 0.641 0.081 1.022 0.237-0.016 0.084-0.022 0.172-0.022 0.262 0 0.653 0.419 1.209 1 1.416v2.084c0 0.469 0.325 0.875 0.781 0.975 2.525 0.566 4.516 1.628 5.913 3.162 1.006 1.106 1.325 2.072 1.347 2.137 0.119 0.434 0.509 0.722 0.959 0.722h2c0.45 0 0.841-0.288 0.959-0.722 0.022-0.066 0.341-1.034 1.347-2.137 1.397-1.534 3.384-2.6 5.913-3.162 0.456-0.103 0.781-0.506 0.781-0.975v-2.084c0.581-0.206 1-0.762 1-1.416 0-0.097-0.009-0.191-0.025-0.281 0.366-0.144 0.716-0.219 1.025-0.219v-1zM3 8.5c0 0.275-0.225 0.5-0.5 0.5s-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5zM16.406 12.709c-1.031 0.612-1.931 1.35-2.675 2.191-0.725 0.819-1.159 1.575-1.406 2.1h-0.65c-0.247-0.525-0.684-1.281-1.406-2.1-0.744-0.841-1.641-1.575-2.675-2.191-1.062-0.631-2.269-1.131-3.594-1.494v-1.009c2.959 0.537 5.522 0.791 8 0.791s5.041-0.253 8-0.791v1.013c-1.325 0.359-2.531 0.859-3.594 1.491zM21.5 9c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" })
        );
    }
    function Underwear2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Underwear2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Underwear2.SVG = Underwear2SVG;
    return Underwear2;
})();
export const Undo = /*#__PURE__*/ (() => {
        function UndoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 9v1c4.413 0 8 3.588 8 8h1c0-2.403-0.938-4.662-2.637-6.363s-3.959-2.637-6.363-2.637z" }),
_('path', { d: "M12 8c3.394 0 6.528 1.7 8.384 4.547l1.675-1.094c-2.228-3.416-5.988-5.453-10.059-5.453-1.956 0-3.9 0.481-5.616 1.394-0.856 0.456-1.659 1.016-2.384 1.666v-3.059h-2v6c0 0.553 0.447 1 1 1h6v-2h-4.141c1.869-1.9 4.437-3 7.141-3z" })
            );
        }
        function Undo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UndoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Undo.SVG = UndoSVG;
        return Undo;
    })();
export const Unfold = /*#__PURE__*/ (() => {
        function UnfoldSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 4h-4v-3c0-0.356-0.191-0.687-0.497-0.866-0.309-0.178-0.687-0.181-0.997-0.003l-7 4c-0.312 0.178-0.503 0.509-0.503 0.869v18c0 0.356 0.191 0.687 0.497 0.866 0.156 0.091 0.328 0.134 0.503 0.134h12c1.103 0 2-0.897 2-2v-16c-0.003-1.103-0.9-2-2.003-2zM11 5.581l5-2.856v15.697l-5 2.856v-15.697zM22 22h-8.234l3.731-2.131c0.312-0.178 0.503-0.509 0.503-0.869v-13h4v16z" }),
_('path', { d: "M6 4h2v1h-2v-1z" }),
_('path', { d: "M3 4h2v1h-2v-1z" }),
_('path', { d: "M0 6h1c0-0.55 0.45-1 1-1v-1c-1.103 0-2 0.897-2 2z" }),
_('path', { d: "M1 22h-1c0 1.103 0.897 2 2 2v-1c-0.55 0-1-0.45-1-1z" }),
_('path', { d: "M6 23h2v1h-2v-1z" }),
_('path', { d: "M3 23h2v1h-2v-1z" }),
_('path', { d: "M0 19h1v2h-1v-2z" }),
_('path', { d: "M0 16h1v2h-1v-2z" }),
_('path', { d: "M0 13h1v2h-1v-2z" }),
_('path', { d: "M0 10h1v2h-1v-2z" }),
_('path', { d: "M0 7h1v2h-1v-2z" }),
_('path', { d: "M4.006 12.3l-0.506-0.506-0.706 0.706 1.353 1.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l1.353-1.353-0.706-0.706-0.491 0.491c0.109-1.278 1.184-2.284 2.491-2.284h0.5v-1h-0.5c-1.863 0-3.391 1.463-3.494 3.3z" })
            );
        }
        function Unfold({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UnfoldSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Unfold.SVG = UnfoldSVG;
        return Unfold;
    })();
export const Unlink = /*#__PURE__*/ (() => {
        function UnlinkSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16.792 17.499l0.707-0.707 2.707 2.707-0.707 0.707-2.707-2.707z" }),
_('path', { d: "M15 18h1v4h-1v-4z" }),
_('path', { d: "M18 15h4v1h-4v-1z" }),
_('path', { d: "M3.792 4.499l0.707-0.707 2.707 2.707-0.707 0.707-2.707-2.707z" }),
_('path', { d: "M8 2h1v4h-1v-4z" }),
_('path', { d: "M2 8h4v1h-4v-1z" }),
_('path', { d: "M12.003 15.25c0 0.869-0.338 1.684-0.95 2.297l-1.503 1.503c-1.266 1.266-3.328 1.266-4.594 0-0.612-0.612-0.953-1.428-0.953-2.297s0.338-1.684 0.953-2.297l1.503-1.503c0.612-0.612 1.428-0.95 2.297-0.95h0.247v-2h-0.247c-1.403 0-2.719 0.547-3.709 1.537l-1.503 1.503c-0.997 0.987-1.541 2.306-1.541 3.706s0.547 2.722 1.538 3.713c1.022 1.025 2.366 1.534 3.709 1.534s2.688-0.513 3.713-1.534l1.503-1.503c0.991-0.991 1.538-2.309 1.538-3.709v-0.25h-2v0.25z" }),
_('path', { d: "M19.047 4.95c0.612 0.612 0.953 1.428 0.953 2.297s-0.338 1.684-0.953 2.297l-1.503 1.503c-0.612 0.612-1.428 0.95-2.297 0.95h-0.247v2h0.247c1.403 0 2.719-0.547 3.709-1.537l1.503-1.503c0.991-0.991 1.538-2.309 1.538-3.713s-0.547-2.722-1.538-3.713c-2.047-2.047-5.378-2.047-7.425 0l-1.503 1.503c0 0-0.003 0.003-0.003 0.003-0.987 0.994-1.531 2.313-1.531 3.706v0.25h2v-0.25c0-0.866 0.337-1.681 0.95-2.297l1.503-1.503c1.269-1.259 3.328-1.259 4.597 0.006z" })
            );
        }
        function Unlink({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UnlinkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Unlink.SVG = UnlinkSVG;
        return Unlink;
    })();
export const Unlink2 = /*#__PURE__*/ (() => {
        function Unlink2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9.547 19.050c-1.266 1.266-3.328 1.266-4.594 0s-1.266-3.328-0.003-4.594l2.006-1.997-1.409-1.419-2.009 2c-2.047 2.047-2.047 5.378 0 7.425 1.022 1.022 2.366 1.534 3.712 1.534 1.344 0 2.691-0.513 3.716-1.538l1.997-2.006-1.419-1.409-1.997 2.003z" }),
_('path', { d: "M19.050 9.544l-2.006 1.997 1.409 1.419 2.009-2c2.047-2.047 2.047-5.378 0-7.425s-5.378-2.047-7.425 0.003l-1.997 2.006 1.419 1.409 1.994-2.003c1.266-1.266 3.328-1.266 4.594 0 1.269 1.269 1.269 3.328 0.003 4.594z" }),
_('path', { d: "M16.792 17.499l0.707-0.707 2.707 2.707-0.707 0.707-2.707-2.707z" }),
_('path', { d: "M15 18h1v4h-1v-4z" }),
_('path', { d: "M18 15h4v1h-4v-1z" }),
_('path', { d: "M3.792 4.499l0.707-0.707 2.707 2.707-0.707 0.707-2.707-2.707z" }),
_('path', { d: "M8 2h1v4h-1v-4z" }),
_('path', { d: "M2 8h4v1h-4v-1z" })
            );
        }
        function Unlink2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Unlink2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Unlink2.SVG = Unlink2SVG;
        return Unlink2;
    })();
export const Unlock = /*#__PURE__*/ (() => {
        function UnlockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 12h-10v-6c0-2.206 1.794-4 4-4s4 1.794 4 4v2h2v-2c0-1.603-0.625-3.109-1.756-4.244-1.134-1.131-2.641-1.756-4.244-1.756s-3.109 0.625-4.244 1.756-1.756 2.641-1.756 4.244v6c-1.103 0-2 0.897-2 2v8c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2v-8c0-1.103-0.897-2-2-2zM18 22h-12v-8h12v8c0.003 0 0 0 0 0z" }),
_('path', { d: "M9 17c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM9 18c0 0 0 0 0 0v0z" }),
_('path', { d: "M12 17c-0.55 0-1 0.45-1 1s0.45 1 1 1c0.55 0 1-0.45 1-1s-0.45-1-1-1zM12 18c0 0 0 0 0 0v0z" }),
_('path', { d: "M15 17c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM15 18c0 0 0 0 0 0v0z" })
            );
        }
        function Unlock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UnlockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Unlock.SVG = UnlockSVG;
        return Unlock;
    })();
export const Unlock2 = /*#__PURE__*/ (() => {
        function Unlock2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 11h-10v-4c0-3.309-2.691-6-6-6s-6 2.691-6 6v4h2v-4c0-2.206 1.794-4 4-4s4 1.794 4 4v4c-1.103 0-2 0.897-2 2v8c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2v-8c0-1.103-0.897-2-2-2zM22 21h-12v-8h12v8c0.003 0 0 0 0 0z" }),
_('path', { d: "M13 16c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM13 17c0 0 0 0 0 0v0z" }),
_('path', { d: "M16 16c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM16 17c0 0 0 0 0 0v0z" }),
_('path', { d: "M19 16c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM19 17c0 0 0 0 0 0v0z" })
            );
        }
        function Unlock2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Unlock2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Unlock2.SVG = Unlock2SVG;
        return Unlock2;
    })();
export const Unlock3 = /*#__PURE__*/ (() => {
        function Unlock3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M18 12h-10v-6c0-2.206 1.794-4 4-4s4 1.794 4 4v2h2v-2c0-3.309-2.691-6-6-6s-6 2.691-6 6v6c-1.103 0-2 0.897-2 2v8c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2v-8c0-1.103-0.897-2-2-2zM18 22h-12v-8h12v8c0.003 0 0 0 0 0z" }),
_('path', { d: "M12 15c-1.103 0-2 0.897-2 2v3.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-3.5c0-1.103-0.897-2-2-2zM13 20h-2v-3c0-0.55 0.45-1 1-1s1 0.45 1 1v3z" })
            );
        }
        function Unlock3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Unlock3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Unlock3.SVG = Unlock3SVG;
        return Unlock3;
    })();
export const Unlock4 = /*#__PURE__*/ (() => {
        function Unlock4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 11h-10v-4c0-3.309-2.691-6-6-6s-6 2.691-6 6v4h2v-4c0-2.206 1.794-4 4-4s4 1.794 4 4v4c-1.103 0-2 0.897-2 2v8c0 1.103 0.897 2 2 2h12c1.103 0 2-0.897 2-2v-8c0-1.103-0.897-2-2-2zM22 21h-12v-8h12v8c0.003 0 0 0 0 0z" }),
_('path', { d: "M16 14c-1.103 0-2 0.897-2 2v3.5c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-3.5c0-1.103-0.897-2-2-2zM17 19h-2v-3c0-0.55 0.45-1 1-1s1 0.45 1 1v3z" })
            );
        }
        function Unlock4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Unlock4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Unlock4.SVG = Unlock4SVG;
        return Unlock4;
    })();
export const UploadCircle = /*#__PURE__*/ (() => {
        function UploadCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M15.544 11.956l1.416-1.416-4.25-4.25c-0.391-0.391-1.025-0.391-1.416 0l-4.25 4.25 1.416 1.416 2.544-2.544v7.587h-3v1h8v-1h-3v-7.584l2.541 2.541z" })
            );
        }
        function UploadCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UploadCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UploadCircle.SVG = UploadCircleSVG;
        return UploadCircle;
    })();
export const UploadSquare = /*#__PURE__*/ (() => {
        function UploadSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20l20-0.003c0 0 0 0 0 0.003v20z" }),
_('path', { d: "M11 9.416v7.584h-3v1h8v-1h-3v-7.584l2.544 2.544 1.416-1.416-4.25-4.25c-0.391-0.391-1.025-0.391-1.416 0l-4.25 4.25 1.416 1.416 2.541-2.544z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" })
            );
        }
        function UploadSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UploadSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UploadSquare.SVG = UploadSquareSVG;
        return UploadSquare;
    })();
export const Upload = /*#__PURE__*/ (() => {
        function UploadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 17v-2c0-0.475-0.166-0.909-0.444-1.253v0l-3.666-4.559c-0.094-0.119-0.237-0.188-0.391-0.188h-3.5v1h3.259l2.412 3h-17.347l2.412-3h3.262v-1h-3.5c-0.15 0-0.294 0.069-0.391 0.188l-3.669 4.559c-0.275 0.344-0.441 0.778-0.441 1.253v2c0 0.597 0.263 1.134 0.678 1.5-0.416 0.366-0.678 0.903-0.678 1.5v2c0 1.103 0.897 2 2 2h18c1.103 0 2-0.897 2-2v-2c0-0.597-0.262-1.134-0.678-1.5 0.416-0.366 0.678-0.903 0.678-1.5zM21 22h-18v-2c0 0 0 0 0 0v-1h18v3zM3 18v-3h18v3h-18z" }),
_('path', { d: "M17 16h3v1h-3v-1z" }),
_('path', { d: "M15 16h1v1h-1v-1z" }),
_('path', { d: "M17 20h3v1h-3v-1z" }),
_('path', { d: "M15 20h1v1h-1v-1z" }),
_('path', { d: "M11 3.416v8.584h2v-8.584l2.544 2.544 1.416-1.416-4.25-4.25c-0.391-0.391-1.025-0.391-1.416 0l-4.25 4.25 1.416 1.416 2.541-2.544z" })
            );
        }
        function Upload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UploadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Upload.SVG = UploadSVG;
        return Upload;
    })();
export const Upload2 = /*#__PURE__*/ (() => {
        function Upload2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 18v4h-20v-4h-2v4c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-4h-2z" }),
_('path', { d: "M11 3.416v14.584h2v-14.584l3.544 3.544 1.416-1.416-5.25-5.25c-0.391-0.391-1.025-0.391-1.416 0l-5.25 5.25 1.416 1.416 3.541-3.544z" })
            );
        }
        function Upload2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Upload2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Upload2.SVG = Upload2SVG;
        return Upload2;
    })();
export const UsbCheck = /*#__PURE__*/ (() => {
        function UsbCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.853 5.147l-5-5c-0.194-0.194-0.513-0.194-0.706 0l-4.387 4.387c-0.784-0.722-2.009-0.703-2.769 0.059l-6.406 6.406c-0.378 0.378-0.588 0.881-0.588 1.413v2.172l-2.406 2.406c-0.781 0.781-0.781 2.050 0 2.831l0.588 0.584-2.134 2.137 1.416 1.416 2.134-2.134 0.581 0.581c0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584l2.406-2.406h1.088c0.981 2.344 3.3 4 6 4 3.584 0 6.5-2.916 6.5-6.5 0-2.316-1.219-4.353-3.047-5.503 0.128-0.625-0.044-1.275-0.488-1.753l4.387-4.387c0.197-0.197 0.197-0.516 0-0.709zM22 17.5c0 3.031-2.469 5.5-5.5 5.5s-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5zM16.5 11c-3.584 0-6.5 2.916-6.5 6.5 0 0.166 0.006 0.334 0.019 0.497h-0.609c-0.534 0-1.034 0.209-1.413 0.588l-2.406 2.406-2.584-2.584 2.406-2.406c0.378-0.378 0.588-0.881 0.588-1.413v-2.172l6.406-6.406 5.066 5.066c-0.319-0.050-0.641-0.075-0.972-0.075zM18.759 9.534l-4.294-4.294 4.034-4.034 4.294 4.294-4.034 4.034z" }),
_('path', { d: "M16.793 4.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M18.793 6.5l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M13.5 16.794l-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4-2-2z" })
            );
        }
        function UsbCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UsbCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UsbCheck.SVG = UsbCheckSVG;
        return UsbCheck;
    })();
export const UsbCross = /*#__PURE__*/ (() => {
        function UsbCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.853 5.147l-5-5c-0.194-0.194-0.513-0.194-0.706 0l-4.387 4.387c-0.369-0.341-0.847-0.528-1.353-0.528-0.534 0-1.038 0.209-1.416 0.584l-6.406 6.406c-0.378 0.378-0.584 0.881-0.584 1.416v2.172l-2.406 2.406c-0.378 0.378-0.584 0.881-0.584 1.416s0.209 1.038 0.584 1.416l0.584 0.584-2.134 2.137 1.416 1.416 2.138-2.138 0.584 0.584c0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584l2.406-2.406h1.081c0.981 2.347 3.3 4 6 4 3.584 0 6.5-2.916 6.5-6.5 0-2.316-1.219-4.356-3.050-5.506 0.125-0.619-0.050-1.278-0.484-1.753l4.387-4.387c0.197-0.194 0.197-0.513 0-0.706zM22 17.5c0 3.031-2.469 5.5-5.5 5.5s-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5zM16.5 11c-3.584 0-6.5 2.916-6.5 6.5 0 0.169 0.006 0.334 0.019 0.5h-0.606c-0.534 0-1.038 0.209-1.416 0.584l-2.406 2.406-2.581-2.584 2.406-2.406c0.378-0.378 0.584-0.881 0.584-1.416v-2.172l6.406-6.406 5.063 5.066c-0.316-0.047-0.641-0.072-0.969-0.072zM18.759 9.534l-4.294-4.294 4.034-4.034 4.294 4.294-4.034 4.034z" }),
_('path', { d: "M16.793 4.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M18.793 6.5l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M14.5 14.794l-0.706 0.706 2 2-2 2 0.706 0.706 2-2 1.978 1.978 0.706-0.706-1.978-1.978 1.978-1.975-0.706-0.709-1.978 1.978z" })
            );
        }
        function UsbCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UsbCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UsbCross.SVG = UsbCrossSVG;
        return UsbCross;
    })();
export const UsbDrive = /*#__PURE__*/ (() => {
        function UsbDriveSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.853 5.147l-5-5c-0.194-0.194-0.513-0.194-0.706 0l-4.387 4.387c-0.369-0.341-0.847-0.528-1.353-0.528-0.534 0-1.038 0.209-1.416 0.588l-9.247 9.25c-1.125 1.122-1.744 2.619-1.744 4.206s0.619 3.084 1.744 4.206c1.159 1.159 2.684 1.741 4.206 1.741 1.525 0 3.047-0.581 4.206-1.741l9.247-9.25c0.378-0.378 0.584-0.881 0.584-1.416 0-0.506-0.184-0.981-0.525-1.35l4.387-4.387c0.2-0.194 0.2-0.513 0.003-0.706zM8.744 20.844c-0.769 0.769-1.781 1.156-2.794 1.156s-2.022-0.384-2.794-1.156c-0.747-0.747-1.156-1.737-1.156-2.794s0.409-2.047 1.156-2.794c0 0 0 0 0 0l9.247-9.25 5.588 5.588-9.247 9.25zM18.759 9.534l-4.294-4.294 4.034-4.034 4.294 4.294-4.034 4.034z" }),
_('path', { d: "M16.793 4.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M18.793 6.5l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M6 15c-0.8 0-1.556 0.312-2.122 0.878v0c-1.169 1.169-1.169 3.072 0 4.244 0.566 0.566 1.322 0.878 2.122 0.878s1.556-0.312 2.122-0.878c1.169-1.169 1.169-3.072 0-4.244-0.566-0.566-1.322-0.878-2.122-0.878zM7.416 19.416c-0.378 0.375-0.881 0.584-1.416 0.584s-1.038-0.209-1.416-0.584c-0.781-0.781-0.781-2.050 0-2.828 0.378-0.378 0.881-0.584 1.416-0.584s1.038 0.209 1.416 0.584c0.778 0.778 0.778 2.047 0 2.828z" })
            );
        }
        function UsbDrive({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UsbDriveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UsbDrive.SVG = UsbDriveSVG;
        return UsbDrive;
    })();
export const UsbMinus = /*#__PURE__*/ (() => {
        function UsbMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.853 5.147l-5-5c-0.194-0.194-0.513-0.194-0.706 0l-4.387 4.387c-0.369-0.341-0.847-0.528-1.353-0.528-0.534 0-1.038 0.209-1.416 0.584l-6.406 6.406c-0.378 0.378-0.584 0.881-0.584 1.416v2.172l-2.406 2.406c-0.378 0.378-0.584 0.881-0.584 1.416s0.209 1.038 0.584 1.416l0.584 0.584-2.134 2.137 1.416 1.416 2.138-2.138 0.584 0.584c0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584l2.406-2.406h1.081c0.981 2.347 3.3 4 6 4 3.584 0 6.5-2.916 6.5-6.5 0-2.316-1.219-4.356-3.050-5.506 0.125-0.619-0.050-1.278-0.484-1.753l4.387-4.387c0.197-0.194 0.197-0.513 0-0.706zM22 17.5c0 3.031-2.469 5.5-5.5 5.5s-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5zM16.5 11c-3.584 0-6.5 2.916-6.5 6.5 0 0.169 0.006 0.334 0.019 0.5h-0.606c-0.534 0-1.038 0.209-1.416 0.584l-2.406 2.406-2.581-2.584 2.406-2.406c0.378-0.378 0.584-0.881 0.584-1.416v-2.172l6.406-6.406 5.063 5.066c-0.316-0.047-0.641-0.072-0.969-0.072zM18.759 9.534l-4.294-4.294 4.034-4.034 4.294 4.294-4.034 4.034z" }),
_('path', { d: "M16.793 4.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M18.793 6.5l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M14 17h5v1h-5v-1z" })
            );
        }
        function UsbMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UsbMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UsbMinus.SVG = UsbMinusSVG;
        return UsbMinus;
    })();
export const UsbPlus = /*#__PURE__*/ (() => {
        function UsbPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.853 5.147l-5-5c-0.194-0.194-0.513-0.194-0.706 0l-4.387 4.387c-0.784-0.722-2.009-0.703-2.769 0.059l-6.406 6.406c-0.378 0.378-0.588 0.881-0.588 1.413v2.172l-2.406 2.406c-0.781 0.781-0.781 2.050 0 2.831l0.588 0.584-2.134 2.137 1.416 1.416 2.134-2.134 0.581 0.581c0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584l2.406-2.406h1.088c0.981 2.344 3.3 4 6 4 3.584 0 6.5-2.916 6.5-6.5 0-2.316-1.219-4.353-3.047-5.503 0.128-0.625-0.044-1.275-0.488-1.753l4.387-4.387c0.197-0.197 0.197-0.516 0-0.709zM22 17.5c0 3.031-2.469 5.5-5.5 5.5s-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5zM16.5 11c-3.584 0-6.5 2.916-6.5 6.5 0 0.166 0.006 0.334 0.019 0.497h-0.609c-0.534 0-1.034 0.209-1.413 0.588l-2.406 2.406-2.584-2.584 2.406-2.406c0.378-0.378 0.588-0.881 0.588-1.413v-2.172l6.406-6.406 5.066 5.066c-0.319-0.050-0.641-0.075-0.972-0.075zM18.759 9.534l-4.294-4.294 4.034-4.034 4.294 4.294-4.034 4.034z" }),
_('path', { d: "M16.793 4.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M18.793 6.5l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M16 15v2h-2v1h2v2h1v-2h2v-1h-2v-2z" })
            );
        }
        function UsbPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UsbPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UsbPlus.SVG = UsbPlusSVG;
        return UsbPlus;
    })();
export const UsbQuestion = /*#__PURE__*/ (() => {
        function UsbQuestionSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.853 5.147l-5-5c-0.194-0.194-0.513-0.194-0.706 0l-4.387 4.387c-0.784-0.722-2.009-0.703-2.769 0.059l-6.406 6.406c-0.378 0.378-0.588 0.881-0.588 1.413v2.172l-2.406 2.406c-0.781 0.781-0.781 2.050 0 2.831l0.588 0.584-2.134 2.137 1.416 1.416 2.134-2.134 0.581 0.581c0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584l2.406-2.406h1.088c0.978 2.347 3.3 4 6 4 3.584 0 6.5-2.916 6.5-6.5 0-2.316-1.219-4.353-3.047-5.506 0.128-0.625-0.047-1.275-0.488-1.753l4.387-4.387c0.197-0.194 0.197-0.513 0-0.706zM22 17.5c0 3.031-2.469 5.5-5.5 5.5s-5.5-2.469-5.5-5.5 2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5zM16.5 11c-3.584 0-6.5 2.916-6.5 6.5 0 0.166 0.006 0.334 0.019 0.497h-0.609c-0.534 0-1.034 0.209-1.413 0.588l-2.406 2.406-2.584-2.584 2.406-2.406c0.378-0.378 0.588-0.881 0.588-1.413v-2.172l6.406-6.406 5.066 5.066c-0.319-0.050-0.641-0.075-0.972-0.075zM18.759 9.534l-4.294-4.294 4.034-4.034 4.294 4.294-4.034 4.034z" }),
_('path', { d: "M16.793 4.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M18.793 6.5l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M16 21h1v1h-1v-1z" }),
_('path', { d: "M14 16.5v0.5h1v-0.5c0-1.103 0.809-1.494 1.503-1.494 0.4 0 0.787 0.125 1.062 0.344 0.288 0.228 0.434 0.531 0.434 0.903 0 0.712-0.434 1.084-0.941 1.519-0.497 0.422-1.059 0.903-1.059 1.728v0.5h1v-0.5c0-0.347 0.256-0.584 0.709-0.972 0.575-0.491 1.291-1.103 1.291-2.278 0-1.459-1.287-2.244-2.497-2.244-0.65 0-1.256 0.216-1.706 0.606-0.363 0.316-0.797 0.9-0.797 1.887z" })
            );
        }
        function UsbQuestion({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UsbQuestionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UsbQuestion.SVG = UsbQuestionSVG;
        return UsbQuestion;
    })();
export const UsbWarning = /*#__PURE__*/ (() => {
        function UsbWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.853 5.147l-5-5c-0.194-0.194-0.513-0.194-0.706 0l-4.387 4.387c-0.784-0.722-2.009-0.703-2.769 0.059l-6.406 6.406c-0.378 0.378-0.588 0.881-0.588 1.413v2.172l-2.406 2.406c-0.781 0.781-0.781 2.050 0 2.831l0.588 0.584-2.134 2.137 1.416 1.416 2.134-2.134 0.581 0.581c0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584l2.406-2.406h1.166l-0.416 0.831c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h8c0.828 0 1.5-0.672 1.5-1.5 0-0.234-0.056-0.466-0.159-0.672l-3.084-6.169 1.65-1.65c0.759-0.759 0.778-1.984 0.059-2.766l4.391-4.391c0.191-0.197 0.191-0.516-0.006-0.709zM19.95 21.281c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5h-8c-0.275 0-0.5-0.225-0.5-0.5 0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003zM16.812 12.775c-0.259-0.472-0.769-0.775-1.313-0.775-0.566 0-1.091 0.325-1.341 0.828l-2.584 5.169h-2.166c-0.534 0-1.034 0.209-1.413 0.588l-2.406 2.406-2.584-2.584 2.406-2.406c0.378-0.378 0.588-0.881 0.588-1.413v-2.172l6.406-6.406 5.584 5.591-1.178 1.175zM18.759 9.534l-4.294-4.294 4.034-4.034 4.294 4.294-4.034 4.034z" }),
_('path', { d: "M16.793 4.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M18.793 6.5l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M15 20h1v1h-1v-1z" }),
_('path', { d: "M15 15h1v4h-1v-4z" })
            );
        }
        function UsbWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UsbWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UsbWarning.SVG = UsbWarningSVG;
        return UsbWarning;
    })();
export const Usb = /*#__PURE__*/ (() => {
        function UsbSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.853 5.147l-5-5c-0.194-0.194-0.513-0.194-0.706 0l-4.387 4.387c-0.369-0.341-0.847-0.528-1.353-0.528-0.534 0-1.038 0.209-1.416 0.584l-6.406 6.406c-0.378 0.378-0.584 0.881-0.584 1.416v2.172l-2.406 2.406c-0.378 0.378-0.584 0.881-0.584 1.416s0.209 1.038 0.584 1.416l0.584 0.584-2.134 2.137 1.416 1.416 2.138-2.138 0.584 0.584c0.391 0.391 0.903 0.584 1.416 0.584s1.025-0.194 1.416-0.584c0 0 0 0 0 0l2.406-2.406h2.172c0.534 0 1.038-0.209 1.416-0.584l6.406-6.406c0.759-0.759 0.778-1.981 0.059-2.766l4.387-4.387c0.191-0.197 0.191-0.516-0.006-0.709zM11.584 18h-2.172c-0.534 0-1.038 0.209-1.416 0.584l-2.406 2.406-2.581-2.584 2.406-2.406c0.378-0.378 0.584-0.881 0.584-1.416v-2.172l6.406-6.406 5.584 5.588-6.406 6.406zM18.759 9.534l-4.294-4.294 4.034-4.034 4.294 4.294-4.034 4.034z" }),
_('path', { d: "M16.793 4.499l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" }),
_('path', { d: "M18.793 6.5l1.708-1.708 0.707 0.707-1.708 1.708-0.707-0.707z" })
            );
        }
        function Usb({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UsbSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Usb.SVG = UsbSVG;
        return Usb;
    })();
export const User24 = /*#__PURE__*/ (() => {
        function User24SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zM9 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z" }),
_('path', { d: "M17.5 11c-1.962 0-3.728 0.875-4.919 2.256-1.028-0.172-2.231-0.256-3.581-0.256-3.806 0-6.328 0.675-7.709 2.069-1.291 1.3-1.291 2.884-1.291 3.931v0.5c0 0.275 0.225 0.5 0.5 0.5h11c0.981 2.347 3.3 4 6 4 3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5zM2 19c0-0.888 0-1.809 0.709-2.522 0.422-0.425 1.072-0.762 1.938-1.006 1.106-0.312 2.572-0.472 4.353-0.472 0.897 0 1.716 0.041 2.45 0.122-0.291 0.738-0.45 1.541-0.45 2.378 0 0.516 0.059 1.019 0.175 1.5h-9.175zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17 16.5c0-0.45-0.172-0.85-0.481-1.125-0.272-0.244-0.634-0.378-1.019-0.378s-0.747 0.134-1.019 0.378c-0.309 0.275-0.481 0.675-0.481 1.125v0.5h1v-0.5c0-0.478 0.416-0.5 0.5-0.5 0.138 0 0.266 0.044 0.356 0.125 0.097 0.084 0.144 0.213 0.144 0.378 0 0.612-0.341 0.9-0.897 1.319-0.491 0.366-1.103 0.822-1.103 1.678 0 0.275 0.225 0.5 0.5 0.5h2.5v-1h-1.766c0.116-0.116 0.272-0.234 0.466-0.381 0.55-0.413 1.3-0.975 1.3-2.119z" }),
_('path', { d: "M20 18h-0.806l0.938-2.816-0.95-0.316-1.159 3.475c-0.050 0.153-0.025 0.319 0.069 0.45s0.244 0.206 0.406 0.206h1.5v1h1v-3h-1v1z" })
            );
        }
        function User24({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( User24SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        User24.SVG = User24SVG;
        return User24;
    })();
export const UserBubble = /*#__PURE__*/ (() => {
        function UserBubbleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 17c-3.806 0-6.328 0.675-7.709 2.069-1.291 1.3-1.291 2.884-1.291 3.931v0.5c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-0.5c0-1.047 0-2.631-1.291-3.931-1.381-1.394-3.903-2.069-7.709-2.069zM2 23c0-0.888 0-1.809 0.709-2.522 0.422-0.425 1.072-0.762 1.938-1.006 1.106-0.312 2.572-0.472 4.353-0.472s3.247 0.159 4.353 0.472c0.866 0.244 1.516 0.581 1.938 1.006 0.709 0.713 0.709 1.634 0.709 2.522h-14z" }),
_('path', { d: "M23.5 0h-13c-0.275 0-0.5 0.225-0.5 0.5v3.584c-0.325-0.056-0.659-0.084-1-0.084-3.309 0-6 2.691-6 6s2.691 6 6 6c2.969 0 5.441-2.166 5.916-5h2.084v2.5c0 0.203 0.122 0.384 0.309 0.462 0.063 0.025 0.128 0.037 0.191 0.037 0.131 0 0.259-0.050 0.353-0.147l2.853-2.853h2.794c0.275 0 0.5-0.225 0.5-0.5v-10c0-0.275-0.225-0.5-0.5-0.5zM9 14c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4c0 2.206-1.794 4-4 4zM23 10h-2.5c-0.131 0-0.259 0.053-0.353 0.147l-2.147 2.147v-1.794c0-0.275-0.225-0.5-0.5-0.5h-2.5c0-2.606-1.672-4.831-4-5.656v-3.344h12v9z" }),
_('path', { d: "M14 3h7v1h-7v-1z" }),
_('path', { d: "M15 5h6v1h-6v-1z" }),
_('path', { d: "M16 7h5v1h-5v-1z" })
            );
        }
        function UserBubble({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserBubbleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserBubble.SVG = UserBubbleSVG;
        return UserBubble;
    })();
export const UserCheck = /*#__PURE__*/ (() => {
        function UserCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zM9 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z" }),
_('path', { d: "M17.5 11c-1.962 0-3.728 0.875-4.919 2.256-1.028-0.172-2.231-0.256-3.581-0.256-3.806 0-6.328 0.675-7.709 2.069-1.291 1.3-1.291 2.884-1.291 3.931v0.5c0 0.275 0.225 0.5 0.5 0.5h11c0.981 2.347 3.3 4 6 4 3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5zM2 19c0-0.888 0-1.809 0.709-2.522 0.422-0.425 1.072-0.762 1.938-1.006 1.106-0.312 2.572-0.472 4.353-0.472 0.897 0 1.716 0.041 2.45 0.122-0.291 0.738-0.45 1.541-0.45 2.378 0 0.516 0.059 1.019 0.175 1.5h-9.175zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M16.5 18.794l-2-2-0.706 0.706 2.353 2.353c0.097 0.097 0.225 0.147 0.353 0.147s0.256-0.050 0.353-0.147l4.353-4.353-0.706-0.706-4 4z" })
            );
        }
        function UserCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserCheck.SVG = UserCheckSVG;
        return UserCheck;
    })();
export const UserCross = /*#__PURE__*/ (() => {
        function UserCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zM9 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z" }),
_('path', { d: "M17.5 11c-1.962 0-3.728 0.875-4.919 2.256-1.028-0.172-2.231-0.256-3.581-0.256-3.806 0-6.328 0.675-7.709 2.069-1.291 1.3-1.291 2.884-1.291 3.931v0.5c0 0.275 0.225 0.5 0.5 0.5h11c0.981 2.347 3.3 4 6 4 3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5zM2 19c0-0.888 0-1.809 0.709-2.522 0.422-0.425 1.072-0.762 1.938-1.006 1.106-0.312 2.572-0.472 4.353-0.472 0.897 0 1.716 0.041 2.45 0.122-0.291 0.738-0.45 1.541-0.45 2.378 0 0.516 0.059 1.019 0.175 1.5h-9.175zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 14.794l-2 2-2-2-0.706 0.706 2 2-2 2 0.706 0.706 2-2 2 2 0.706-0.706-2-2 2-2z" })
            );
        }
        function UserCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserCross.SVG = UserCrossSVG;
        return UserCross;
    })();
export const UserEdit = /*#__PURE__*/ (() => {
        function UserEditSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 14c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zM9 4c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z" }),
_('path', { d: "M15.972 20.088c0.028 0.306 0.028 0.612 0.028 0.912h-14c0-0.888 0-1.809 0.709-2.522 0.422-0.425 1.072-0.762 1.938-1.006 1.106-0.312 2.572-0.472 4.353-0.472 1.066 0 2.028 0.059 2.866 0.172l0.272-1.981c-0.928-0.128-1.981-0.191-3.138-0.191-3.806 0-6.328 0.675-7.709 2.069-1.291 1.3-1.291 2.884-1.291 3.931v0.5c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-0.5c0-0.325 0-0.694-0.034-1.087l-1.994 0.175z" }),
_('path', { d: "M23.438 8.562c-0.747-0.747-1.959-0.747-2.706 0l-7.084 7.084c-0.069 0.069-0.119 0.159-0.138 0.256l-0.5 2.5c-0.031 0.162 0.019 0.334 0.138 0.453 0.094 0.094 0.222 0.147 0.353 0.147 0.031 0 0.066-0.003 0.097-0.009l2.5-0.5c0.097-0.019 0.184-0.066 0.256-0.138l7.084-7.087c0.363-0.363 0.563-0.844 0.563-1.353s-0.2-0.991-0.563-1.353zM15.753 17.541l-1.616 0.322 0.322-1.616 6.041-6.041 1.294 1.294-6.041 6.041zM22.731 10.563l-0.231 0.231-1.294-1.294 0.231-0.231c0.356-0.356 0.938-0.356 1.294 0 0.172 0.172 0.269 0.403 0.269 0.647s-0.097 0.472-0.269 0.647z" })
            );
        }
        function UserEdit({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserEditSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserEdit.SVG = UserEditSVG;
        return UserEdit;
    })();
export const UserGear = /*#__PURE__*/ (() => {
        function UserGearSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 13c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zM9 3c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z" }),
_('path', { d: "M4.647 16.472c1.106-0.312 2.572-0.472 4.353-0.472 1.066 0 2.028 0.059 2.866 0.172l0.272-1.981c-0.928-0.128-1.981-0.191-3.138-0.191-3.806 0-6.328 0.675-7.709 2.069-1.291 1.3-1.291 2.884-1.291 3.931v0.5c0 0.275 0.225 0.5 0.5 0.5h11.5v-1h-10c0-0.888 0-1.809 0.709-2.522 0.422-0.425 1.072-0.762 1.938-1.006z" }),
_('path', { d: "M18.5 16c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5zM18.5 18c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5 0.5 0.225 0.5 0.5-0.225 0.5-0.5 0.5z" }),
_('path', { d: "M23.581 18.694l-1.591-0.919c0.006-0.091 0.009-0.184 0.009-0.281 0-0.094-0.003-0.188-0.009-0.281l1.591-0.919c0.116-0.066 0.2-0.175 0.234-0.303s0.016-0.266-0.050-0.378l-1-1.731c-0.138-0.237-0.444-0.322-0.681-0.184l-1.591 0.919c-0.078-0.053-0.156-0.103-0.241-0.153s-0.166-0.094-0.25-0.131v-1.837c0-0.275-0.225-0.5-0.5-0.5h-2c-0.275 0-0.5 0.225-0.5 0.5v1.837c-0.081 0.041-0.166 0.084-0.25 0.131-0.081 0.047-0.162 0.1-0.241 0.153l-1.591-0.912c-0.237-0.138-0.544-0.056-0.681 0.184l-1 1.731c-0.066 0.116-0.084 0.25-0.050 0.378s0.119 0.237 0.234 0.303l1.591 0.919c-0.006 0.091-0.009 0.184-0.009 0.281 0 0.094 0.003 0.188 0.009 0.281l-1.591 0.919c-0.116 0.066-0.2 0.175-0.234 0.303s-0.016 0.266 0.050 0.378l1 1.731c0.138 0.237 0.444 0.322 0.681 0.184l1.591-0.919c0.078 0.053 0.156 0.103 0.241 0.153s0.166 0.094 0.25 0.131v1.837c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-1.837c0.081-0.041 0.166-0.084 0.25-0.131 0.081-0.047 0.162-0.1 0.241-0.153l1.591 0.912c0.237 0.138 0.544 0.056 0.681-0.184l1-1.731c0.066-0.116 0.084-0.25 0.050-0.378-0.034-0.125-0.119-0.234-0.234-0.303zM22.147 20.178l-1.45-0.831c-0.184-0.106-0.416-0.084-0.575 0.056-0.113 0.097-0.237 0.188-0.372 0.266-0.144 0.081-0.278 0.144-0.412 0.191-0.203 0.069-0.338 0.259-0.338 0.472v1.672h-1v-1.672c0-0.213-0.134-0.403-0.338-0.472-0.134-0.047-0.272-0.109-0.412-0.191-0.134-0.078-0.259-0.166-0.372-0.266-0.162-0.138-0.394-0.159-0.575-0.056l-1.447 0.834-0.5-0.866 1.447-0.834c0.184-0.106 0.281-0.319 0.241-0.528-0.028-0.141-0.041-0.294-0.041-0.453 0-0.162 0.012-0.312 0.041-0.45 0.041-0.209-0.056-0.422-0.241-0.528l-1.45-0.834 0.5-0.866 1.45 0.831c0.184 0.106 0.416 0.084 0.575-0.056 0.113-0.097 0.237-0.188 0.372-0.266 0.144-0.081 0.278-0.144 0.412-0.191 0.203-0.069 0.338-0.259 0.338-0.472v-1.672h1v1.672c0 0.213 0.134 0.403 0.338 0.472 0.134 0.047 0.272 0.109 0.412 0.191 0.134 0.078 0.259 0.166 0.372 0.266 0.162 0.138 0.394 0.159 0.575 0.056l1.447-0.834 0.5 0.866-1.447 0.834c-0.184 0.106-0.281 0.319-0.241 0.528 0.028 0.141 0.041 0.294 0.041 0.453 0 0.162-0.012 0.312-0.041 0.45-0.041 0.209 0.056 0.422 0.241 0.528l1.447 0.834-0.497 0.866z" })
            );
        }
        function UserGear({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserGearSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserGear.SVG = UserGearSVG;
        return UserGear;
    })();
export const UserHeart = /*#__PURE__*/ (() => {
        function UserHeartSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zM9 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z" }),
_('path', { d: "M17.5 11c-1.962 0-3.728 0.875-4.919 2.256-1.028-0.172-2.231-0.256-3.581-0.256-3.806 0-6.328 0.675-7.709 2.069-1.291 1.3-1.291 2.884-1.291 3.931v0.5c0 0.275 0.225 0.5 0.5 0.5h11c0.981 2.347 3.3 4 6 4 3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5zM2 19c0-0.888 0-1.809 0.709-2.522 0.422-0.425 1.072-0.762 1.938-1.006 1.106-0.312 2.572-0.472 4.353-0.472 0.897 0 1.716 0.041 2.45 0.122-0.291 0.738-0.45 1.541-0.45 2.378 0 0.516 0.059 1.019 0.175 1.5h-9.175zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M19.5 14c-0.816 0-1.544 0.394-2 1-0.456-0.606-1.184-1-2-1-1.378 0-2.5 1.122-2.5 2.5 0 1.181 0.725 2.459 2.159 3.803 1.025 0.959 2.034 1.594 2.078 1.622 0.081 0.050 0.172 0.075 0.266 0.075s0.184-0.025 0.266-0.075c0.044-0.028 1.053-0.663 2.078-1.622 1.431-1.344 2.159-2.622 2.159-3.803-0.006-1.378-1.128-2.5-2.506-2.5zM17.5 20.903c-1.178-0.8-3.5-2.722-3.5-4.403 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5v0.5h1v-0.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 1.681-2.322 3.603-3.5 4.403z" })
            );
        }
        function UserHeart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserHeartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserHeart.SVG = UserHeartSVG;
        return UserHeart;
    })();
export const UserInfo = /*#__PURE__*/ (() => {
        function UserInfoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zM9 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z" }),
_('path', { d: "M17.5 11c-1.962 0-3.728 0.875-4.919 2.256-1.025-0.169-2.231-0.256-3.581-0.256-3.806 0-6.328 0.675-7.709 2.069-1.291 1.3-1.291 2.884-1.291 3.931v0.5c0 0.275 0.225 0.5 0.5 0.5h11c0.981 2.347 3.3 4 6 4 3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5zM2 19c0-0.888 0-1.809 0.709-2.522 0.422-0.425 1.072-0.762 1.938-1.006 1.106-0.312 2.572-0.472 4.353-0.472 0.897 0 1.719 0.041 2.45 0.122-0.291 0.738-0.45 1.541-0.45 2.378 0 0.516 0.059 1.019 0.175 1.5h-9.175zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18 16.5c0-0.275-0.225-0.5-0.5-0.5h-1.5v1h1v3h-1v1h3v-1h-1v-3.5z" }),
_('path', { d: "M17 14h1v1h-1v-1z" })
            );
        }
        function UserInfo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserInfoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserInfo.SVG = UserInfoSVG;
        return UserInfo;
    })();
export const UserLock = /*#__PURE__*/ (() => {
        function UserLockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zM9 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z" }),
_('path', { d: "M17.5 11c-1.962 0-3.728 0.875-4.919 2.256-1.025-0.169-2.231-0.256-3.581-0.256-3.806 0-6.328 0.675-7.709 2.069-1.291 1.3-1.291 2.884-1.291 3.931v0.5c0 0.275 0.225 0.5 0.5 0.5h11c0.981 2.347 3.3 4 6 4 3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5zM2 19c0-0.888 0-1.809 0.709-2.522 0.422-0.425 1.072-0.762 1.938-1.006 1.106-0.312 2.572-0.472 4.353-0.472 0.897 0 1.719 0.041 2.45 0.122-0.291 0.738-0.45 1.541-0.45 2.378 0 0.516 0.059 1.019 0.175 1.5h-9.175zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M20.5 17h-0.5v-0.5c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5v0.5h-0.5c-0.275 0-0.5 0.225-0.5 0.5v3c0 0.275 0.225 0.5 0.5 0.5h6c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.275-0.225-0.5-0.5-0.5zM16 16.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5v0.5h-3v-0.5zM20 20h-5v-2h5v2z" })
            );
        }
        function UserLock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserLockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserLock.SVG = UserLockSVG;
        return UserLock;
    })();
export const UserMinus = /*#__PURE__*/ (() => {
        function UserMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zM9 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z" }),
_('path', { d: "M17.5 11c-1.962 0-3.728 0.875-4.919 2.256-1.028-0.172-2.231-0.256-3.581-0.256-3.806 0-6.328 0.675-7.709 2.069-1.291 1.3-1.291 2.884-1.291 3.931v0.5c0 0.275 0.225 0.5 0.5 0.5h11c0.981 2.347 3.3 4 6 4 3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5zM2 19c0-0.888 0-1.809 0.709-2.522 0.422-0.425 1.072-0.762 1.938-1.006 1.106-0.312 2.572-0.472 4.353-0.472 0.897 0 1.716 0.041 2.45 0.122-0.291 0.738-0.45 1.541-0.45 2.378 0 0.516 0.059 1.019 0.175 1.5h-9.175zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M15 17h5v1h-5v-1z" })
            );
        }
        function UserMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserMinus.SVG = UserMinusSVG;
        return UserMinus;
    })();
export const UserPlus = /*#__PURE__*/ (() => {
        function UserPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zM9 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z" }),
_('path', { d: "M17.5 11c-1.962 0-3.728 0.875-4.919 2.256-1.025-0.169-2.231-0.256-3.581-0.256-3.806 0-6.328 0.675-7.709 2.069-1.291 1.3-1.291 2.884-1.291 3.931v0.5c0 0.275 0.225 0.5 0.5 0.5h11c0.981 2.347 3.3 4 6 4 3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5zM2 19c0-0.888 0-1.809 0.709-2.522 0.422-0.425 1.072-0.762 1.938-1.006 1.106-0.312 2.572-0.472 4.353-0.472 0.897 0 1.719 0.041 2.45 0.122-0.291 0.738-0.45 1.541-0.45 2.378 0 0.516 0.059 1.019 0.175 1.5h-9.175zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M18 15h-1v2h-2v1h2v2h1v-2h2v-1h-2z" })
            );
        }
        function UserPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserPlus.SVG = UserPlusSVG;
        return UserPlus;
    })();
export const UserQuestion = /*#__PURE__*/ (() => {
        function UserQuestionSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zM9 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z" }),
_('path', { d: "M17.5 11c-1.962 0-3.728 0.875-4.919 2.256-1.028-0.172-2.231-0.256-3.581-0.256-3.806 0-6.328 0.675-7.709 2.069-1.291 1.3-1.291 2.884-1.291 3.931v0.5c0 0.275 0.225 0.5 0.5 0.5h11c0.981 2.347 3.3 4 6 4 3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5zM2 19c0-0.888 0-1.809 0.709-2.522 0.422-0.425 1.072-0.762 1.938-1.006 1.106-0.312 2.572-0.472 4.353-0.472 0.897 0 1.716 0.041 2.45 0.122-0.291 0.738-0.45 1.541-0.45 2.378 0 0.516 0.059 1.019 0.175 1.5h-9.175zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17 21h1v1h-1v-1z" }),
_('path', { d: "M17.503 14.006c-0.65 0-1.256 0.216-1.706 0.606-0.363 0.316-0.797 0.9-0.797 1.887v0.5h1v-0.5c0-1.103 0.809-1.494 1.503-1.494 0.4 0 0.788 0.125 1.062 0.344 0.288 0.228 0.434 0.531 0.434 0.903 0 0.712-0.434 1.084-0.941 1.519-0.497 0.422-1.059 0.903-1.059 1.728v0.5h1v-0.5c0-0.347 0.256-0.584 0.709-0.972 0.575-0.491 1.291-1.103 1.291-2.278 0-1.459-1.287-2.244-2.497-2.244z" })
            );
        }
        function UserQuestion({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserQuestionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserQuestion.SVG = UserQuestionSVG;
        return UserQuestion;
    })();
export const User = /*#__PURE__*/ (() => {
        function UserSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 14c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zM12 4c2.206 0 4 1.794 4 4s-1.794 4-4 4c-2.206 0-4-1.794-4-4s1.794-4 4-4z" }),
_('path', { d: "M19.709 17.069c-1.381-1.394-3.903-2.069-7.709-2.069s-6.328 0.675-7.709 2.069c-1.291 1.3-1.291 2.884-1.291 3.931v0.5c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-0.5c0-1.047 0-2.631-1.291-3.931zM5 21c0-0.888 0-1.809 0.709-2.522 0.422-0.425 1.072-0.762 1.938-1.006 1.106-0.312 2.572-0.472 4.353-0.472s3.247 0.159 4.353 0.472c0.866 0.244 1.516 0.581 1.938 1.006 0.709 0.712 0.709 1.634 0.709 2.522h-14z" })
            );
        }
        function User({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        User.SVG = UserSVG;
        return User;
    })();
export const Victory = /*#__PURE__*/ (() => {
        function VictorySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 5c1.103 0 2-0.897 2-2s-0.897-2-2-2c-1.103 0-2 0.897-2 2s0.897 2 2 2zM12 2c0.55 0 1 0.45 1 1s-0.45 1-1 1c-0.55 0-1-0.45-1-1s0.45-1 1-1z" }),
_('path', { d: "M13 8.416l5.956-5.959-1.413-1.413-5.544 5.541-5.544-5.541-1.413 1.413 5.956 5.959v5.372l-3.912 8.806 1.825 0.813 3.087-6.944 3.087 6.944 1.825-0.813-3.912-8.806z" })
            );
        }
        function Victory({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VictorySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Victory.SVG = VictorySVG;
        return Victory;
    })();
export const Voicemail = /*#__PURE__*/ (() => {
    function VoicemailSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19 7c-2.756 0-5 2.244-5 5 0 1.125 0.372 2.163 1.003 3h-6.006c0.628-0.837 1.003-1.875 1.003-3 0-2.756-2.244-5-5-5s-5 2.244-5 5c0 2.756 2.244 5 5 5h14c2.756 0 5-2.244 5-5s-2.244-5-5-5zM2 12c0-1.653 1.347-3 3-3s3 1.347 3 3-1.347 3-3 3-3-1.347-3-3zM19 15c-1.653 0-3-1.347-3-3s1.347-3 3-3 3 1.347 3 3-1.347 3-3 3z" })
        );
    }
    function Voicemail({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( VoicemailSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Voicemail.SVG = VoicemailSVG;
    return Voicemail;
})();
export const Volcano = /*#__PURE__*/ (() => {
        function VolcanoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.644 22.234c-2.15-1.8-5.262-4.706-7.478-9.128-0.337-0.672-1.041-1.106-1.791-1.106h-4.75c-0.75 0-1.453 0.434-1.788 1.106-2.216 4.419-5.331 7.325-7.481 9.128-0.322 0.269-0.441 0.712-0.297 1.109 0.144 0.394 0.519 0.656 0.941 0.656h22c0.422 0 0.797-0.263 0.941-0.659 0.144-0.394 0.025-0.837-0.297-1.106zM14.375 14c0.563 1.122 1.178 2.153 1.819 3.097l-0.556 0.559-0.691-1.378c-0.081-0.159-0.237-0.266-0.416-0.275-0.178-0.012-0.347 0.072-0.447 0.222l-1.584 2.375-1.584-2.375c-0.084-0.125-0.219-0.206-0.366-0.219-0.15-0.016-0.297 0.038-0.403 0.144l-0.744 0.744-1.1-0.55c0.462-0.731 0.906-1.512 1.322-2.341l4.75-0.003zM7.75 17.184l1.528 0.762c0.194 0.097 0.425 0.059 0.578-0.094l0.569-0.569 1.662 2.494c0.094 0.141 0.25 0.222 0.416 0.222s0.322-0.084 0.416-0.222l1.522-2.284 0.616 1.228c0.072 0.144 0.209 0.244 0.366 0.269 0.159 0.025 0.319-0.025 0.434-0.141l0.925-0.925c1.575 2.15 3.259 3.813 4.688 5.072h-18.934c1.591-1.4 3.494-3.297 5.216-5.813z" }),
_('path', { d: "M9 6v-1c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1v6h1v-6c0-1.103-0.897-2-2-2s-2 0.897-2 2 0.897 2 2 2z" }),
_('path', { d: "M13 2c0-0.55 0.45-1 1-1s1 0.45 1 1-0.45 1-1 1v1c1.103 0 2-0.897 2-2s-0.897-2-2-2-2 0.897-2 2v8h1v-8z" }),
_('path', { d: "M14 8.5v0.5h1v-0.5c0-1.641 0.769-3.063 2.281-4.225 1.169-0.897 2.363-1.294 2.375-1.3l0.475-0.153-0.309-0.95-0.475 0.153c-0.053 0.019-1.347 0.444-2.65 1.437-1.766 1.344-2.697 3.087-2.697 5.037z" }),
_('path', { d: "M19.962 6c-0.987 0.009-1.953 0.397-2.791 1.122l-0.378 0.328 0.656 0.756 0.378-0.328c1.356-1.175 2.981-1.175 4.347 0l0.378 0.325 0.653-0.756-0.378-0.325c-0.866-0.744-1.856-1.134-2.866-1.122z" }),
_('path', { d: "M1.825 6.878c0.853-0.731 1.928-1.016 2.878-0.759 1.034 0.278 1.838 1.159 2.325 2.547l0.166 0.472 0.944-0.331-0.166-0.472c-0.306-0.875-0.731-1.597-1.266-2.141-0.503-0.516-1.091-0.866-1.744-1.041-1.269-0.341-2.684 0.022-3.787 0.966l-0.378 0.325 0.65 0.759 0.378-0.325z" })
            );
        }
        function Volcano({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VolcanoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Volcano.SVG = VolcanoSVG;
        return Volcano;
    })();
export const Volume0 = /*#__PURE__*/ (() => {
    function Volume0SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.434 4.1c-0.347-0.166-0.756-0.119-1.059 0.122l-4.725 3.778h-2.65c-1.103 0-2 0.897-2 2v4c0 1.103 0.897 2 2 2h2.65l4.725 3.781c0.181 0.144 0.403 0.219 0.625 0.219 0.147 0 0.294-0.031 0.434-0.1 0.347-0.166 0.566-0.516 0.566-0.9v-14c0-0.384-0.222-0.734-0.566-0.9zM2 14v-4h3v4h-3zM9 16.919l-3-2.4v-5.037l3-2.4v9.837z" })
        );
    }
    function Volume0({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Volume0SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Volume0.SVG = Volume0SVG;
    return Volume0;
})();
export const Volume100 = /*#__PURE__*/ (() => {
        function Volume100SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.434 4.1c-0.347-0.166-0.756-0.119-1.059 0.122l-4.725 3.778h-2.65c-1.103 0-2 0.897-2 2v4c0 1.103 0.897 2 2 2h2.65l4.725 3.781c0.181 0.144 0.403 0.219 0.625 0.219 0.147 0 0.294-0.031 0.434-0.1 0.347-0.166 0.566-0.516 0.566-0.9v-14c0-0.384-0.222-0.734-0.566-0.9zM2 14v-4h3v4h-3zM9 16.919l-3-2.4v-5.037l3-2.4v9.837z" }),
_('path', { d: "M18.784 2.1l-0.413-0.284-0.566 0.825 0.413 0.284c2.994 2.056 4.781 5.447 4.781 9.075s-1.788 7.019-4.784 9.075l-0.412 0.284 0.566 0.825 0.413-0.284c3.269-2.244 5.219-5.944 5.219-9.9s-1.95-7.656-5.216-9.9z" }),
_('path', { d: "M21 12c0-2.969-1.462-5.744-3.916-7.425l-0.413-0.281-0.566 0.825 0.412 0.281c2.181 1.494 3.481 3.959 3.481 6.6s-1.3 5.106-3.478 6.6l-0.413 0.281 0.566 0.825 0.413-0.281c2.45-1.681 3.912-4.456 3.912-7.425z" }),
_('path', { d: "M18 12c0-1.978-0.975-3.828-2.606-4.95l-0.412-0.284-0.566 0.825 0.413 0.284c1.359 0.934 2.172 2.475 2.172 4.125s-0.813 3.191-2.175 4.125l-0.412 0.284 0.566 0.825 0.413-0.284c1.634-1.122 2.609-2.972 2.609-4.95z" }),
_('path', { d: "M13.694 9.525l-0.412-0.281-0.563 0.822 0.412 0.281c0.544 0.375 0.869 0.991 0.869 1.65s-0.325 1.275-0.869 1.65l-0.412 0.281 0.566 0.825 0.413-0.281c0.816-0.559 1.306-1.484 1.306-2.475-0.003-0.987-0.491-1.912-1.309-2.472z" })
            );
        }
        function Volume100({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Volume100SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Volume100.SVG = Volume100SVG;
        return Volume100;
    })();
export const Volume25 = /*#__PURE__*/ (() => {
        function Volume25SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.434 4.1c-0.347-0.166-0.756-0.119-1.059 0.122l-4.725 3.778h-2.65c-1.103 0-2 0.897-2 2v4c0 1.103 0.897 2 2 2h2.65l4.725 3.781c0.181 0.144 0.403 0.219 0.625 0.219 0.147 0 0.294-0.031 0.434-0.1 0.347-0.166 0.566-0.516 0.566-0.9v-14c0-0.384-0.222-0.734-0.566-0.9zM2 14v-4h3v4h-3zM9 16.919l-3-2.4v-5.037l3-2.4v9.837z" }),
_('path', { d: "M13.694 9.525l-0.412-0.281-0.563 0.822 0.412 0.281c0.544 0.375 0.869 0.991 0.869 1.65s-0.325 1.275-0.869 1.65l-0.412 0.281 0.566 0.825 0.413-0.281c0.816-0.559 1.306-1.484 1.306-2.475-0.003-0.987-0.491-1.912-1.309-2.472z" })
            );
        }
        function Volume25({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Volume25SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Volume25.SVG = Volume25SVG;
        return Volume25;
    })();
export const Volume50 = /*#__PURE__*/ (() => {
        function Volume50SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.434 4.1c-0.347-0.166-0.756-0.119-1.059 0.122l-4.725 3.778h-2.65c-1.103 0-2 0.897-2 2v4c0 1.103 0.897 2 2 2h2.65l4.725 3.781c0.181 0.144 0.403 0.219 0.625 0.219 0.147 0 0.294-0.031 0.434-0.1 0.347-0.166 0.566-0.516 0.566-0.9v-14c0-0.384-0.222-0.734-0.566-0.9zM2 14v-4h3v4h-3zM9 16.919l-3-2.4v-5.037l3-2.4v9.837z" }),
_('path', { d: "M15.394 7.050l-0.412-0.284-0.566 0.825 0.413 0.284c1.359 0.934 2.172 2.475 2.172 4.125s-0.813 3.191-2.175 4.125l-0.412 0.284 0.566 0.825 0.413-0.284c1.634-1.122 2.609-2.972 2.609-4.95s-0.975-3.828-2.606-4.95z" }),
_('path', { d: "M13.694 9.525l-0.412-0.281-0.563 0.822 0.412 0.281c0.544 0.375 0.869 0.991 0.869 1.65s-0.325 1.275-0.869 1.65l-0.412 0.281 0.566 0.825 0.413-0.281c0.816-0.559 1.306-1.484 1.306-2.475-0.003-0.987-0.491-1.912-1.309-2.472z" })
            );
        }
        function Volume50({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Volume50SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Volume50.SVG = Volume50SVG;
        return Volume50;
    })();
export const Volume75 = /*#__PURE__*/ (() => {
        function Volume75SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.434 4.1c-0.347-0.166-0.756-0.119-1.059 0.122l-4.725 3.778h-2.65c-1.103 0-2 0.897-2 2v4c0 1.103 0.897 2 2 2h2.65l4.725 3.781c0.181 0.144 0.403 0.219 0.625 0.219 0.147 0 0.294-0.031 0.434-0.1 0.347-0.166 0.566-0.516 0.566-0.9v-14c0-0.384-0.222-0.734-0.566-0.9zM2 14v-4h3v4h-3zM9 16.919l-3-2.4v-5.037l3-2.4v9.837z" }),
_('path', { d: "M17.084 4.575l-0.413-0.281-0.566 0.825 0.412 0.281c2.181 1.494 3.481 3.959 3.481 6.6s-1.3 5.106-3.478 6.6l-0.413 0.281 0.566 0.825 0.413-0.281c2.45-1.681 3.912-4.456 3.912-7.425s-1.463-5.744-3.916-7.425z" }),
_('path', { d: "M18 12c0-1.978-0.975-3.828-2.606-4.95l-0.412-0.284-0.566 0.825 0.413 0.284c1.359 0.934 2.172 2.475 2.172 4.125s-0.813 3.191-2.175 4.125l-0.412 0.284 0.566 0.825 0.413-0.284c1.634-1.122 2.609-2.972 2.609-4.95z" }),
_('path', { d: "M13.694 9.525l-0.412-0.281-0.563 0.822 0.412 0.281c0.544 0.375 0.869 0.991 0.869 1.65s-0.325 1.275-0.869 1.65l-0.412 0.281 0.566 0.825 0.413-0.281c0.816-0.559 1.306-1.484 1.306-2.475-0.003-0.987-0.491-1.912-1.309-2.472z" })
            );
        }
        function Volume75({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Volume75SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Volume75.SVG = Volume75SVG;
        return Volume75;
    })();
export const VolumeCross = /*#__PURE__*/ (() => {
        function VolumeCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.434 4.1c-0.347-0.166-0.756-0.119-1.059 0.122l-4.725 3.778h-2.65c-1.103 0-2 0.897-2 2v4c0 1.103 0.897 2 2 2h2.65l4.725 3.781c0.181 0.144 0.403 0.219 0.625 0.219 0.147 0 0.294-0.031 0.434-0.1 0.347-0.166 0.566-0.516 0.566-0.9v-14c0-0.384-0.222-0.734-0.566-0.9zM2 14v-4h3v4h-3zM9 16.919l-3-2.4v-5.037l3-2.4v9.837z" }),
_('path', { d: "M20.206 9.5l-0.706-0.706-2.5 2.5-2.5-2.5-0.706 0.706 2.5 2.5-2.5 2.5 0.706 0.706 2.5-2.5 2.5 2.5 0.706-0.706-2.5-2.5z" })
            );
        }
        function VolumeCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VolumeCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        VolumeCross.SVG = VolumeCrossSVG;
        return VolumeCross;
    })();
export const Walking = /*#__PURE__*/ (() => {
    function WalkingSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.969 9.997c1.116 0.694 2.394 0.903 3.969 1l0.125-1.997c-2.609-0.162-3.656-0.484-5.172-3.456-0.172-0.338-0.516-0.541-0.881-0.547 1.097-0.006 1.987-0.9 1.987-2 0-1.103-0.897-2-2-2s-2 0.897-2 2c0 1.1 0.891 1.994 1.988 2-0.075 0-0.147 0.009-0.222 0.028-0.063 0.016-0.119 0.034-0.175 0.059-1.881 0.816-3.069 1.744-3.731 2.916-0.622 1.1-0.719 2.287-0.825 3.544-0.009 0.119-0.019 0.244-0.031 0.366l1.994 0.175c0.012-0.125 0.022-0.25 0.031-0.372 0.094-1.122 0.169-2.009 0.575-2.728 0.194-0.344 0.541-0.813 1.4-1.35v5.234c-0.691 2.587-2.234 6.391-4.047 8.775l1.591 1.209c1.719-2.262 3.178-5.562 4.034-8.262 1.022 0.775 1.928 1.716 2.334 2.434l-1.841 4.6 1.856 0.744 2-5c0.091-0.228 0.097-0.484 0.009-0.719-0.591-1.6-2.522-3.275-3.938-4.209v-3.209c0.306 0.303 0.625 0.553 0.969 0.766zM11 3c0-0.55 0.45-1 1-1s1 0.45 1 1-0.45 1-1 1c-0.55 0-1-0.45-1-1z" })
        );
    }
    function Walking({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WalkingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Walking.SVG = WalkingSVG;
    return Walking;
})();
export const Wallet = /*#__PURE__*/ (() => {
        function WalletSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 13.269v-1.269c0-1.653-1.347-3-3-3v-7.5c0-0.275-0.225-0.5-0.5-0.5h-10c-0.275 0-0.5 0.225-0.5 0.5v3.5h-3.997c-0.809 0-1.569 0.319-2.138 0.894-0.559 0.569-0.866 1.316-0.863 2.106h-0.003v12c0 1.653 1.347 3 3 3h15c1.653 0 3-1.347 3-3v-1.269c0.597-0.347 1-0.994 1-1.731v-2c0-0.738-0.403-1.384-1-1.731zM18 3c-0.55 0-1-0.45-1-1h1v1zM18 4v5h-3.084c0.056-0.156 0.084-0.325 0.084-0.5 0-0.828-0.675-1.503-1.506-1.5-0.272-0.003-0.494-0.225-0.494-0.5s0.225-0.5 0.5-0.5h1.5v-1h-1v-1h-1v1.084c-0.581 0.206-1 0.762-1 1.416 0 0.828 0.672 1.5 1.5 1.5 0.003 0 0.003 0 0.006 0 0.272 0.003 0.494 0.225 0.494 0.5 0 0.272-0.219 0.497-0.494 0.5h-4.506v-5c1.103 0 2-0.897 2-2h5c0 1.103 0.897 2 2 2zM9 2h1c0 0.55-0.45 1-1 1v-1zM3.291 7.3c0.191-0.194 0.444-0.3 0.713-0.3h3.997v2h-3.969c-0.559 0-1.022-0.444-1.028-0.987-0.003-0.269 0.097-0.522 0.288-0.713zM19 21h-15c-0.55 0-1-0.45-1-1v-9.181c0.322 0.116 0.669 0.181 1.031 0.181h14.969c0.55 0 1 0.45 1 1v1h-3.969c-1.659 0-3.019 1.334-3.031 2.978-0.006 0.806 0.303 1.566 0.872 2.137 0.566 0.569 1.322 0.884 2.128 0.884h4v1c0 0.55-0.45 1-1 1zM22 17c0 0.55-0.45 1-1 1h-5c-0.537 0-1.041-0.209-1.419-0.591s-0.584-0.888-0.581-1.425c0.006-1.094 0.919-1.984 2.031-1.984h4.969c0.55 0 1 0.45 1 1v2z" }),
_('path', { d: "M16 15c-0.55 0-1 0.45-1 1s0.45 1 1 1 1-0.45 1-1-0.45-1-1-1zM16 16c0 0 0 0 0 0v0z" })
            );
        }
        function Wallet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WalletSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Wallet.SVG = WalletSVG;
        return Wallet;
    })();
export const WarningCircle = /*#__PURE__*/ (() => {
        function WarningCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M12 3c-2.403 0-4.666 0.938-6.363 2.637s-2.637 3.959-2.637 6.363 0.938 4.666 2.637 6.363c1.697 1.7 3.959 2.637 6.363 2.637s4.666-0.938 6.363-2.637c1.7-1.697 2.637-3.959 2.637-6.363s-0.938-4.666-2.637-6.363c-1.697-1.7-3.959-2.637-6.363-2.637zM12 20c-4.413 0-8-3.588-8-8s3.588-8 8-8c4.413 0 8 3.588 8 8s-3.588 8-8 8z" }),
_('path', { d: "M11 6h2v8h-2v-8z" }),
_('path', { d: "M11 16h2v2h-2v-2z" })
            );
        }
        function WarningCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WarningCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WarningCircle.SVG = WarningCircleSVG;
        return WarningCircle;
    })();
export const WarningOctagon = /*#__PURE__*/ (() => {
        function WarningOctagonSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.706 6.738l-6.444-6.444c-0.188-0.188-0.441-0.294-0.706-0.294h-9.113c-0.266 0-0.519 0.106-0.706 0.294l-6.444 6.444c-0.188 0.188-0.294 0.441-0.294 0.706v9.112c0 0.266 0.106 0.519 0.294 0.706l6.444 6.444c0.188 0.188 0.441 0.294 0.706 0.294h9.113c0.266 0 0.519-0.106 0.706-0.294l6.444-6.444c0.188-0.188 0.294-0.441 0.294-0.706v-9.112c0-0.266-0.106-0.519-0.294-0.706zM22 16.141l-5.859 5.859h-8.281l-5.859-5.859v-8.281l5.859-5.859h8.284l5.856 5.859v8.281z" }),
_('path', { d: "M15.522 3h-7.044c-0.131 0-0.259 0.053-0.353 0.147l-4.978 4.978c-0.094 0.094-0.147 0.222-0.147 0.353v7.044c0 0.131 0.053 0.259 0.147 0.353l4.978 4.978c0.094 0.094 0.222 0.147 0.353 0.147h7.044c0.131 0 0.259-0.053 0.353-0.147l4.978-4.978c0.094-0.094 0.147-0.222 0.147-0.353v-7.044c0-0.131-0.053-0.259-0.147-0.353l-4.978-4.978c-0.094-0.094-0.222-0.147-0.353-0.147zM20 15.316l-4.684 4.684h-6.631l-4.684-4.684v-6.631l4.684-4.684h6.628l4.688 4.684v6.631z" }),
_('path', { d: "M11 6h2v8h-2v-8z" }),
_('path', { d: "M11 16h2v2h-2v-2z" })
            );
        }
        function WarningOctagon({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WarningOctagonSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WarningOctagon.SVG = WarningOctagonSVG;
        return WarningOctagon;
    })();
export const WarningSquare = /*#__PURE__*/ (() => {
        function WarningSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM22 22h-20v-20h20v20c0.003 0 0 0 0 0z" }),
_('path', { d: "M20.5 3h-17c-0.275 0-0.5 0.225-0.5 0.5v17c0 0.275 0.225 0.5 0.5 0.5h17c0.275 0 0.5-0.225 0.5-0.5v-17c0-0.275-0.225-0.5-0.5-0.5zM20 20h-16v-16h16v16z" }),
_('path', { d: "M11 6h2v8h-2v-8z" }),
_('path', { d: "M11 16h2v2h-2v-2z" })
            );
        }
        function WarningSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WarningSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WarningSquare.SVG = WarningSquareSVG;
        return WarningSquare;
    })();
export const Warning = /*#__PURE__*/ (() => {
        function WarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.787 21.103l-10-19.997c-0.337-0.681-1.025-1.106-1.788-1.106-0.766 0-1.45 0.425-1.788 1.106l-10 19.997c-0.138 0.275-0.213 0.584-0.213 0.897 0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2 0-0.312-0.075-0.622-0.213-0.897zM2 22l10-20c0 0 0 0 0 0l10 20h-20zM22 22c0 0 0 0 0 0s0.003 0 0 0c0.003 0 0 0 0 0z" }),
_('path', { d: "M11.553 5.128l-7.572 15.147c-0.078 0.156-0.069 0.337 0.022 0.487 0.091 0.147 0.253 0.237 0.425 0.237h4.572v-1h-3.762l6.762-13.528 6.762 13.528h-3.762v1h4.572c0.172 0 0.334-0.091 0.425-0.237s0.1-0.331 0.022-0.487l-7.572-15.147c-0.084-0.169-0.259-0.275-0.447-0.275-0.191 0-0.363 0.106-0.447 0.275z" }),
_('path', { d: "M11 11h2v7h-2v-7z" }),
_('path', { d: "M11 19h2v2h-2v-2z" })
            );
        }
        function Warning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Warning.SVG = WarningSVG;
        return Warning;
    })();
export const WashingMachine = /*#__PURE__*/ (() => {
        function WashingMachineSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 0h-16c-1.103 0-2 0.897-2 2v20c0 1.103 0.897 2 2 2h16c1.103 0 2-0.897 2-2v-20c0-1.103-0.897-2-2-2zM20 2v3.997c-2.216-0.637-5.053-0.997-8-0.997s-5.784 0.359-8 0.997v-3.997h16zM20 22h-16v-14.959c2.159-0.666 5.016-1.041 8-1.041s5.841 0.375 8 1.041v14.959c0 0 0 0 0 0z" }),
_('path', { d: "M12 7c-1.869 0-3.628 0.728-4.95 2.050s-2.050 3.081-2.050 4.95 0.728 3.628 2.050 4.95c1.322 1.322 3.081 2.050 4.95 2.050s3.628-0.728 4.95-2.050c1.322-1.322 2.050-3.081 2.050-4.95s-0.728-3.628-2.050-4.95c-1.322-1.322-3.081-2.050-4.95-2.050zM12 19c-2.756 0-5-2.244-5-5s2.244-5 5-5c2.756 0 5 2.244 5 5s-2.244 5-5 5z" }),
_('path', { d: "M9 14h-1c0 2.206 1.794 4 4 4v-1c-1.653 0-3-1.347-3-3z" }),
_('path', { d: "M18 3h1v1h-1v-1z" }),
_('path', { d: "M5 3h2v1h-2v-1z" }),
_('path', { d: "M8 3h1v1h-1v-1z" }),
_('path', { d: "M10 3h1v1h-1v-1z" })
            );
        }
        function WashingMachine({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WashingMachineSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WashingMachine.SVG = WashingMachineSVG;
        return WashingMachine;
    })();
export const WatchHandles = /*#__PURE__*/ (() => {
        function WatchHandlesSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 11h-1.072c-0.213-1.491-0.897-2.866-1.981-3.95-0.003-0.003-0.006-0.006-0.009-0.009l-0.759-5.325c-0.069-0.475-0.306-0.912-0.669-1.225-0.363-0.316-0.828-0.491-1.309-0.491h-4.4c-0.481 0-0.947 0.175-1.309 0.491s-0.6 0.75-0.669 1.228l-0.759 5.322c-0.003 0.003-0.006 0.006-0.009 0.009-1.325 1.322-2.053 3.081-2.053 4.95s0.728 3.628 2.050 4.95c0.003 0.003 0.006 0.006 0.009 0.009l0.759 5.322c0.069 0.475 0.306 0.912 0.669 1.225 0.363 0.316 0.828 0.491 1.309 0.491h4.397c0.481 0 0.947-0.175 1.309-0.491s0.6-0.75 0.669-1.228l0.759-5.319c0.006-0.006 0.009-0.009 0.016-0.016 1.084-1.084 1.769-2.459 1.981-3.95h1.072v-1.994zM12 17c-2.756 0-5-2.244-5-5s2.244-5 5-5c2.756 0 5 2.244 5 5s-2.244 5-5 5zM8.809 1.859c0.072-0.491 0.497-0.859 0.991-0.859h4.4c0.494 0 0.919 0.369 0.991 0.859l0.606 4.259c-1.122-0.728-2.428-1.119-3.797-1.119s-2.675 0.391-3.797 1.116l0.606-4.256zM15.188 22.141c-0.072 0.491-0.497 0.859-0.991 0.859h-4.397c-0.494 0-0.919-0.369-0.991-0.859l-0.606-4.259c1.122 0.728 2.428 1.119 3.797 1.119 1.366 0 2.672-0.387 3.794-1.116l-0.606 4.256z" }),
_('path', { d: "M11.847 11.9l-2.628-1.050-0.372 0.928 2.966 1.184c0.059 0.025 0.122 0.034 0.184 0.034 0.147 0 0.288-0.063 0.384-0.181l2.822-3.378-0.766-0.641-2.591 3.103z" })
            );
        }
        function WatchHandles({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WatchHandlesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WatchHandles.SVG = WatchHandlesSVG;
        return WatchHandles;
    })();
export const WatchHandles2 = /*#__PURE__*/ (() => {
        function WatchHandles2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 11h-1v-3c0-0.813-0.487-1.512-1.184-1.825l-0.637-4.459c-0.069-0.475-0.306-0.912-0.669-1.225-0.363-0.316-0.828-0.491-1.309-0.491h-4.4c-0.481 0-0.947 0.175-1.309 0.491s-0.6 0.75-0.669 1.228l-0.637 4.456c-0.697 0.312-1.184 1.013-1.184 1.825v8c0 0.813 0.488 1.512 1.184 1.825l0.637 4.459c0.069 0.475 0.306 0.912 0.669 1.225 0.363 0.316 0.828 0.491 1.309 0.491h4.397c0.481 0 0.947-0.175 1.309-0.491s0.6-0.75 0.669-1.228l0.638-4.453c0.7-0.312 1.188-1.012 1.188-1.828v-3h1v-2zM16 16h-8v-8h8v8c0.003 0 0 0 0 0zM8.809 1.859c0.072-0.491 0.497-0.859 0.991-0.859h4.4c0.494 0 0.919 0.369 0.991 0.859l0.591 4.141h-7.563l0.591-4.141zM15.188 22.141c-0.072 0.491-0.497 0.859-0.991 0.859h-4.397c-0.494 0-0.919-0.369-0.991-0.859l-0.591-4.141h7.559l-0.591 4.141z" }),
_('path', { d: "M11.847 11.9l-2.628-1.050-0.372 0.928 2.966 1.184c0.059 0.025 0.122 0.034 0.184 0.034 0.147 0 0.288-0.063 0.384-0.181l2.822-3.378-0.766-0.641-2.591 3.103z" })
            );
        }
        function WatchHandles2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WatchHandles2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WatchHandles2.SVG = WatchHandles2SVG;
        return WatchHandles2;
    })();
export const WatchHealth = /*#__PURE__*/ (() => {
        function WatchHealthSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M20 11h-1.072c-0.213-1.491-0.897-2.866-1.981-3.95-0.003-0.003-0.006-0.006-0.009-0.009l-0.759-5.325c-0.069-0.475-0.306-0.912-0.669-1.228s-0.828-0.488-1.309-0.488h-4.4c-0.481 0-0.947 0.175-1.309 0.491s-0.6 0.75-0.669 1.228l-0.759 5.322c-0.003 0.003-0.006 0.006-0.009 0.009-1.325 1.322-2.053 3.081-2.053 4.95s0.728 3.628 2.050 4.95c0.003 0.003 0.006 0.006 0.009 0.009l0.759 5.322c0.069 0.475 0.306 0.912 0.669 1.228s0.828 0.491 1.309 0.491h4.397c0.481 0 0.947-0.175 1.309-0.491s0.6-0.75 0.669-1.228l0.759-5.322c0.003-0.003 0.006-0.006 0.009-0.009 1.084-1.084 1.769-2.459 1.981-3.95h1.078v-2zM12 17c-2.756 0-5-2.244-5-5s2.244-5 5-5c2.756 0 5 2.244 5 5s-2.244 5-5 5zM8.813 1.859c0.069-0.491 0.497-0.859 0.991-0.859h4.397c0.494 0 0.919 0.369 0.991 0.859l0.609 4.259c-1.125-0.728-2.431-1.119-3.8-1.119s-2.675 0.391-3.797 1.116l0.609-4.256zM15.188 22.141c-0.069 0.491-0.497 0.859-0.991 0.859h-4.397c-0.494 0-0.919-0.369-0.991-0.859l-0.609-4.259c1.125 0.728 2.431 1.119 3.8 1.119s2.675-0.391 3.797-1.116l-0.609 4.256z" }),
_('path', { d: "M13.053 12.275l-0.312 0.625-0.747-4.484c-0.038-0.234-0.237-0.409-0.472-0.419-0.237-0.009-0.447 0.15-0.506 0.378l-0.906 3.622h-2.109v1h2.5c0.228 0 0.428-0.156 0.484-0.378l0.416-1.669 0.606 3.628c0.034 0.213 0.203 0.381 0.419 0.413 0.025 0.003 0.050 0.006 0.075 0.006 0.188 0 0.363-0.106 0.447-0.275l0.862-1.725h2.191v-1h-2.5c-0.191 0.003-0.363 0.109-0.447 0.278z" })
            );
        }
        function WatchHealth({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WatchHealthSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WatchHealth.SVG = WatchHealthSVG;
        return WatchHealth;
    })();
export const WatchWarning = /*#__PURE__*/ (() => {
        function WatchWarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23 11h-1.072c-0.213-1.491-0.897-2.866-1.981-3.95-0.003-0.003-0.006-0.006-0.009-0.009l-0.759-5.325c-0.069-0.475-0.306-0.912-0.669-1.225-0.363-0.316-0.828-0.491-1.309-0.491h-4.4c-0.481 0-0.947 0.175-1.309 0.491s-0.6 0.75-0.669 1.228l-0.759 5.316c-0.375 0.372-0.709 0.791-0.994 1.247l-1.225-2.45c-0.25-0.506-0.778-0.831-1.341-0.831s-1.091 0.325-1.341 0.828l-4 7.997c-0.103 0.206-0.159 0.438-0.159 0.672 0 0.828 0.672 1.5 1.5 1.5h6.756c0.091 0.128 0.184 0.253 0.281 0.375v0c0.166 0.206 0.341 0.403 0.525 0.584l0.759 5.322c0.069 0.475 0.306 0.912 0.669 1.225 0.363 0.316 0.828 0.491 1.309 0.491h4.397c0.481 0 0.947-0.175 1.309-0.491s0.6-0.75 0.669-1.228l0.759-5.319c0.006-0.006 0.009-0.009 0.016-0.016 1.084-1.084 1.769-2.459 1.981-3.95h1.066v-1.991zM15 17c-1.313 0-2.547-0.506-3.475-1.406 0.294-0.275 0.475-0.663 0.475-1.094 0-0.234-0.056-0.466-0.159-0.672l-1.631-3.263c0.053-0.178 0.116-0.35 0.188-0.519v0c0.075-0.172 0.156-0.341 0.247-0.5 0.003-0.003 0.003-0.006 0.006-0.009 0-0.003 0.003-0.003 0.003-0.006 0.128-0.228 0.278-0.444 0.444-0.653v0c0.934-1.169 2.359-1.878 3.906-1.878 2.756 0 5 2.244 5 5-0.003 2.756-2.247 5-5.003 5zM11.809 1.859c0.072-0.491 0.497-0.859 0.991-0.859h4.4c0.494 0 0.919 0.369 0.991 0.859l0.606 4.259c-1.122-0.728-2.428-1.119-3.797-1.119-1.378 0-2.691 0.403-3.797 1.116l0.606-4.256zM2 14.5c0-0.078 0.019-0.153 0.050-0.219l4.003-8.006c0.081-0.166 0.256-0.275 0.447-0.275s0.363 0.109 0.447 0.278l4.003 8.003c0.034 0.066 0.050 0.141 0.050 0.219 0 0.275-0.225 0.5-0.5 0.5h-8c-0.275 0-0.5-0.225-0.5-0.5zM18.188 22.141c-0.072 0.491-0.497 0.859-0.991 0.859h-4.397c-0.494 0-0.919-0.369-0.991-0.859l-0.606-4.259c1.116 0.725 2.428 1.119 3.797 1.119 1.366 0 2.672-0.387 3.794-1.116l-0.606 4.256z" }),
_('path', { d: "M6 13h1v1h-1v-1z" }),
_('path', { d: "M6 8h1v4h-1v-4z" })
            );
        }
        function WatchWarning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WatchWarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WatchWarning.SVG = WatchWarningSVG;
        return WatchWarning;
    })();
export const Watch = /*#__PURE__*/ (() => {
    function WatchSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M20 11h-1.072c-0.213-1.491-0.897-2.866-1.981-3.95-0.003-0.003-0.006-0.006-0.009-0.009l-0.759-5.325c-0.069-0.475-0.306-0.912-0.669-1.228s-0.828-0.488-1.309-0.488h-4.4c-0.481 0-0.947 0.175-1.309 0.491s-0.6 0.75-0.669 1.228l-0.759 5.322c-0.003 0.003-0.006 0.006-0.009 0.009-1.325 1.322-2.053 3.081-2.053 4.95s0.728 3.628 2.050 4.95c0.003 0.003 0.006 0.006 0.009 0.009l0.759 5.322c0.069 0.475 0.306 0.912 0.669 1.228s0.828 0.491 1.309 0.491h4.397c0.481 0 0.947-0.175 1.309-0.491s0.6-0.75 0.669-1.228l0.759-5.322c0.003-0.003 0.006-0.006 0.009-0.009 1.084-1.084 1.769-2.459 1.981-3.95h1.078v-2zM12 17c-2.756 0-5-2.244-5-5s2.244-5 5-5c2.756 0 5 2.244 5 5s-2.244 5-5 5zM8.813 1.859c0.069-0.491 0.497-0.859 0.991-0.859h4.397c0.494 0 0.919 0.369 0.991 0.859l0.609 4.259c-1.125-0.728-2.431-1.119-3.8-1.119s-2.675 0.391-3.797 1.116l0.609-4.256zM15.188 22.141c-0.069 0.491-0.497 0.859-0.991 0.859h-4.397c-0.494 0-0.919-0.369-0.991-0.859l-0.609-4.259c1.125 0.728 2.431 1.119 3.8 1.119s2.675-0.391 3.797-1.116l-0.609 4.256z" })
        );
    }
    function Watch({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WatchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Watch.SVG = WatchSVG;
    return Watch;
})();
export const Watch2 = /*#__PURE__*/ (() => {
    function Watch2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19 11h-1v-3c0-0.813-0.487-1.512-1.184-1.825l-0.637-4.459c-0.069-0.475-0.306-0.912-0.669-1.228s-0.828-0.488-1.309-0.488h-4.4c-0.481 0-0.947 0.175-1.309 0.491s-0.6 0.75-0.669 1.228l-0.637 4.456c-0.697 0.312-1.184 1.013-1.184 1.825v8c0 0.813 0.488 1.512 1.184 1.825l0.637 4.456c0.069 0.475 0.306 0.912 0.669 1.228s0.828 0.491 1.309 0.491h4.397c0.481 0 0.947-0.175 1.309-0.491s0.6-0.75 0.669-1.228l0.638-4.456c0.697-0.312 1.184-1.012 1.184-1.825v-3h1v-2zM16 16h-8v-8h8v8c0 0 0 0 0 0zM8.813 1.859c0.069-0.491 0.497-0.859 0.991-0.859h4.397c0.494 0 0.919 0.369 0.991 0.859l0.591 4.141h-7.563l0.594-4.141zM15.188 22.141c-0.069 0.491-0.497 0.859-0.991 0.859h-4.397c-0.494 0-0.919-0.369-0.991-0.859l-0.591-4.141h7.563l-0.594 4.141z" })
        );
    }
    function Watch2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Watch2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Watch2.SVG = Watch2SVG;
    return Watch2;
})();
export const Waving = /*#__PURE__*/ (() => {
        function WavingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 6c1.103 0 2-0.897 2-2s-0.897-2-2-2c-1.103 0-2 0.897-2 2s0.897 2 2 2zM13 3c0.55 0 1 0.45 1 1s-0.45 1-1 1-1-0.45-1-1 0.45-1 1-1z" }),
_('path', { d: "M16.484 13.894l1.531-1.287-5.25-6.25c-0.091-0.109-0.203-0.194-0.325-0.253l-3.441-1.719v-4.384h-2v5c0 0.378 0.213 0.725 0.553 0.894l3.447 1.725v6.219l-2.95 8.847 1.897 0.631 2.053-6.153 2.050 6.153 1.897-0.631-2.947-8.847v-4.094l3.484 4.15z" })
            );
        }
        function Waving({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WavingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Waving.SVG = WavingSVG;
        return Waving;
    })();
export const Webcam = /*#__PURE__*/ (() => {
        function WebcamSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.472 18.053l-2.438-2.441c1.275-1.587 1.966-3.547 1.966-5.613 0-2.403-0.938-4.666-2.637-6.363-1.697-1.7-3.959-2.637-6.363-2.637s-4.666 0.938-6.363 2.637-2.637 3.959-2.637 6.363c0 2.066 0.691 4.025 1.966 5.616l-2.438 2.441c-0.484 0.484-0.65 1.191-0.434 1.841 0.216 0.653 0.772 1.119 1.453 1.219 1.128 0.166 2.103 0.491 3.138 0.834 1.55 0.516 3.153 1.050 5.316 1.050s3.766-0.534 5.316-1.050c1.034-0.344 2.009-0.669 3.138-0.834 0.681-0.1 1.237-0.569 1.453-1.219 0.216-0.653 0.050-1.356-0.434-1.844zM12 3c3.859 0 7 3.141 7 7s-3.141 7-7 7c-3.859 0-7-3.141-7-7s3.141-7 7-7zM16.684 20.050c-1.462 0.491-2.847 0.95-4.684 0.95s-3.222-0.459-4.684-0.95c-0.966-0.322-1.959-0.653-3.1-0.856l2.163-2.166c1.591 1.278 3.553 1.972 5.622 1.972s4.031-0.694 5.622-1.972l2.163 2.166c-1.141 0.203-2.134 0.537-3.1 0.856z" }),
_('path', { d: "M12 14c2.206 0 4-1.794 4-4s-1.794-4-4-4c-2.206 0-4 1.794-4 4s1.794 4 4 4zM12 7c1.653 0 3 1.347 3 3s-1.347 3-3 3-3-1.347-3-3 1.347-3 3-3z" }),
_('path', { d: "M12 11c0.55 0 1-0.45 1-1s-0.45-1-1-1c-0.55 0-1 0.45-1 1s0.45 1 1 1zM12 10v0c0 0 0 0 0 0z" }),
_('path', { d: "M17 10h1c0-3.309-2.691-6-6-6v1c2.756 0 5 2.244 5 5z" })
            );
        }
        function Webcam({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WebcamSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Webcam.SVG = WebcamSVG;
        return Webcam;
    })();
export const Weight1Kg = /*#__PURE__*/ (() => {
        function Weight1KgSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 6c0-1.653-1.347-3-3-3s-3 1.347-3 3 1.347 3 3 3 3-1.347 3-3zM10 6c0-1.103 0.897-2 2-2s2 0.897 2 2-0.897 2-2 2c-1.103 0-2-0.897-2-2z" }),
_('path', { d: "M23.875 21.359l-3.7-10.997c-0.269-0.816-1.028-1.362-1.894-1.362h-1.084c0.053-0.091 0.103-0.181 0.15-0.275 0.428-0.837 0.653-1.781 0.653-2.725 0-1.591-0.616-3.087-1.731-4.216s-2.603-1.763-4.191-1.784c-1.603-0.022-3.122 0.588-4.275 1.719-1.153 1.128-1.794 2.631-1.803 4.234-0.006 0.953 0.216 1.906 0.644 2.753 0.050 0.1 0.103 0.197 0.159 0.294h-1.084c-0.856 0-1.619 0.547-1.894 1.362l-3.703 10.994c-0.206 0.609-0.106 1.284 0.269 1.806s0.981 0.834 1.625 0.834h19.966c0.644 0 1.25-0.312 1.625-0.834s0.475-1.197 0.269-1.803zM18.281 11c0 0 0 0 0 0v0zM2.016 21.997l3.703-11h3.281c0.431 0 0.813-0.275 0.95-0.684s-0.003-0.859-0.35-1.116c-1.025-0.769-1.609-1.947-1.6-3.231 0.006-1.066 0.434-2.066 1.203-2.819 0.756-0.741 1.747-1.147 2.794-1.147 0.019 0 0.037 0 0.056 0 2.175 0.031 3.947 1.825 3.947 4 0 1.272-0.584 2.438-1.6 3.2-0.344 0.259-0.484 0.709-0.347 1.116s0.516 0.684 0.947 0.684h3.278l3.703 10.997h-19.966z" }),
_('path', { d: "M11.206 15.456l-0.75-0.663-1.456 1.647v-3.441h-1v6h1v-1.047l0.116-0.131 1.384 1.384 0.706-0.706-1.428-1.428z" }),
_('path', { d: "M15 15.269c-0.294-0.172-0.638-0.269-1-0.269-1.103 0-2 0.897-2 2s0.897 2 2 2c0.363 0 0.706-0.097 1-0.269v0.269c0 0.55-0.45 1-1 1h-2v1h2c1.103 0 2-0.897 2-2v-4h-1v0.269zM14 18c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
            );
        }
        function Weight1Kg({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Weight1KgSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Weight1Kg.SVG = Weight1KgSVG;
        return Weight1Kg;
    })();
export const Weight1Lb = /*#__PURE__*/ (() => {
        function Weight1LbSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 6c0-1.653-1.347-3-3-3s-3 1.347-3 3 1.347 3 3 3 3-1.347 3-3zM10 6c0-1.103 0.897-2 2-2s2 0.897 2 2-0.897 2-2 2c-1.103 0-2-0.897-2-2z" }),
_('path', { d: "M23.875 21.359l-3.7-10.997c-0.269-0.816-1.028-1.362-1.894-1.362h-1.084c0.053-0.091 0.103-0.181 0.15-0.275 0.428-0.837 0.653-1.781 0.653-2.725 0-1.591-0.616-3.087-1.731-4.216s-2.603-1.763-4.191-1.784c-1.603-0.022-3.122 0.588-4.275 1.719-1.153 1.128-1.794 2.631-1.803 4.234-0.006 0.953 0.216 1.906 0.644 2.753 0.050 0.1 0.103 0.197 0.159 0.294h-1.084c-0.856 0-1.619 0.547-1.894 1.362l-3.703 10.994c-0.206 0.609-0.106 1.284 0.269 1.806s0.981 0.834 1.625 0.834h19.966c0.644 0 1.25-0.312 1.625-0.834s0.475-1.197 0.269-1.803zM18.281 11c0 0 0 0 0 0v0zM2.016 21.997l3.703-11h3.281c0.431 0 0.813-0.275 0.95-0.684s-0.003-0.859-0.35-1.116c-1.025-0.769-1.609-1.947-1.6-3.231 0.006-1.066 0.434-2.066 1.203-2.819 0.756-0.741 1.747-1.147 2.794-1.147 0.019 0 0.037 0 0.056 0 2.175 0.031 3.947 1.825 3.947 4 0 1.272-0.584 2.438-1.6 3.2-0.344 0.259-0.484 0.709-0.347 1.116s0.516 0.684 0.947 0.684h3.278l3.703 10.997h-19.966z" }),
_('path', { d: "M9 13h1v6h-1v-6z" }),
_('path', { d: "M16 18h1v1h-1v-1z" }),
_('path', { d: "M13 15c-0.363 0-0.706 0.097-1 0.269v-2.269h-1v6h1v-0.269c0.294 0.172 0.638 0.269 1 0.269 1.103 0 2-0.897 2-2s-0.897-2-2-2zM13 18c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
            );
        }
        function Weight1Lb({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Weight1LbSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Weight1Lb.SVG = Weight1LbSVG;
        return Weight1Lb;
    })();
export const Weight1Oz = /*#__PURE__*/ (() => {
        function Weight1OzSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 6c0-1.653-1.347-3-3-3s-3 1.347-3 3 1.347 3 3 3 3-1.347 3-3zM10 6c0-1.103 0.897-2 2-2s2 0.897 2 2-0.897 2-2 2c-1.103 0-2-0.897-2-2z" }),
_('path', { d: "M23.875 21.359l-3.7-10.997c-0.269-0.816-1.028-1.362-1.894-1.362h-1.084c0.053-0.091 0.103-0.181 0.15-0.275 0.428-0.837 0.653-1.781 0.653-2.725 0-1.591-0.616-3.087-1.731-4.216s-2.603-1.763-4.191-1.784c-1.603-0.022-3.122 0.588-4.275 1.719-1.153 1.128-1.794 2.631-1.803 4.234-0.006 0.953 0.216 1.906 0.644 2.753 0.050 0.1 0.103 0.197 0.159 0.294h-1.084c-0.856 0-1.619 0.547-1.894 1.362l-3.703 10.994c-0.206 0.609-0.106 1.284 0.269 1.806s0.981 0.834 1.625 0.834h19.966c0.644 0 1.25-0.312 1.625-0.834s0.475-1.197 0.269-1.803zM18.281 11c0 0 0 0 0 0v0zM2.016 21.997l3.703-11h3.281c0.431 0 0.813-0.275 0.95-0.684s-0.003-0.859-0.35-1.116c-1.025-0.769-1.609-1.947-1.6-3.231 0.006-1.066 0.434-2.066 1.203-2.819 0.756-0.741 1.747-1.147 2.794-1.147 0.019 0 0.037 0 0.056 0 2.175 0.031 3.947 1.825 3.947 4 0 1.272-0.584 2.438-1.6 3.2-0.344 0.259-0.484 0.709-0.347 1.116s0.516 0.684 0.947 0.684h3.278l3.703 10.997h-19.966z" }),
_('path', { d: "M15.963 15.309c-0.078-0.188-0.259-0.309-0.462-0.309h-3.5v1h2.294l-2.147 2.147c-0.144 0.144-0.184 0.359-0.109 0.544s0.259 0.309 0.462 0.309h3.5v-1h-2.294l2.147-2.147c0.144-0.144 0.188-0.356 0.109-0.544z" }),
_('path', { d: "M17 18h1v1h-1v-1z" }),
_('path', { d: "M9 15c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2zM9 18c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1z" })
            );
        }
        function Weight1Oz({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Weight1OzSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Weight1Oz.SVG = Weight1OzSVG;
        return Weight1Oz;
    })();
export const WeightLifting = /*#__PURE__*/ (() => {
        function WeightLiftingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 4c0-1.103-0.897-2-2-2s-2 0.897-2 2 0.897 2 2 2c1.103 0 2-0.897 2-2zM12 5c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M22.5 4h-0.5v-1h-2v4h-6.462l-0.884-0.759c-0.188-0.159-0.419-0.241-0.65-0.241s-0.462 0.081-0.65 0.241l-0.891 0.759h-6.462v-4h-2v1h-0.5c-0.828 0-1.5 0.672-1.5 1.5v4c0 0.828 0.672 1.5 1.5 1.5h0.5v1h2v-3.984l3.919 2.8c0.375 0.269 0.881 0.244 1.231-0.053l1.85-1.584v4.313l-3.081 2.197c-0.222 0.156-0.369 0.4-0.409 0.666-0.019 0.141-0.509 3.472-0.509 5.647h2c0-1.597 0.3-3.981 0.431-4.934l2.569-1.834 2.569 1.834c0.131 0.953 0.431 3.337 0.431 4.934h2c0-2.175-0.491-5.506-0.509-5.647-0.041-0.269-0.188-0.509-0.409-0.666l-3.081-2.203v-4.313l1.85 1.584c0.188 0.159 0.419 0.241 0.65 0.241 0.203 0 0.406-0.063 0.581-0.188l3.919-2.8v3.991h2v-1h0.5c0.828 0 1.5-0.672 1.5-1.5v-4c0-0.828-0.672-1.5-1.5-1.5zM1.5 10c-0.275 0-0.5-0.225-0.5-0.5v-4c0-0.275 0.225-0.5 0.5-0.5h0.5v5h-0.5zM8.444 8.731l-1.022-0.731h1.875l-0.853 0.731zM15.556 8.731l-0.853-0.731h1.875l-1.022 0.731zM23 9.5c0 0.275-0.225 0.5-0.5 0.5h-0.5v-5h0.5c0.275 0 0.5 0.225 0.5 0.5v4z" })
            );
        }
        function WeightLifting({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WeightLiftingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WeightLifting.SVG = WeightLiftingSVG;
        return WeightLifting;
    })();
export const Weight = /*#__PURE__*/ (() => {
        function WeightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 6c0-1.653-1.347-3-3-3s-3 1.347-3 3 1.347 3 3 3 3-1.347 3-3zM12 8c-1.103 0-2-0.897-2-2s0.897-2 2-2c1.103 0 2 0.897 2 2s-0.897 2-2 2z" }),
_('path', { d: "M23.875 21.359l-3.7-10.997c-0.269-0.816-1.028-1.362-1.894-1.362h-1.084c0.053-0.091 0.103-0.181 0.15-0.275 0.428-0.837 0.653-1.781 0.653-2.725 0-1.591-0.616-3.087-1.731-4.216s-2.603-1.763-4.191-1.784c-1.603-0.022-3.122 0.588-4.275 1.719-1.153 1.128-1.794 2.631-1.803 4.234-0.006 0.953 0.216 1.906 0.644 2.753 0.050 0.1 0.103 0.197 0.159 0.294h-1.084c-0.856 0-1.619 0.547-1.894 1.362l-3.703 10.994c-0.206 0.609-0.106 1.284 0.269 1.806s0.981 0.834 1.625 0.834h19.966c0.644 0 1.25-0.312 1.625-0.834s0.475-1.197 0.269-1.803zM18.281 11c0 0 0 0 0 0v0zM2.016 21.997l3.703-11h3.281c0.431 0 0.813-0.275 0.95-0.684s-0.003-0.859-0.35-1.116c-1.025-0.769-1.609-1.947-1.6-3.231 0.006-1.066 0.434-2.066 1.203-2.819 0.756-0.741 1.747-1.147 2.794-1.147 0.019 0 0.037 0 0.056 0 2.175 0.031 3.947 1.825 3.947 4 0 1.272-0.584 2.438-1.6 3.2-0.344 0.259-0.484 0.709-0.347 1.116s0.516 0.684 0.947 0.684h3.278l3.703 10.997h-19.966z" })
            );
        }
        function Weight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WeightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Weight.SVG = WeightSVG;
        return Weight;
    })();
export const Wheelchair = /*#__PURE__*/ (() => {
        function WheelchairSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 7c1.103 0 2-0.897 2-2s-0.897-2-2-2c-1.103 0-2 0.897-2 2s0.897 2 2 2zM12 4c0.55 0 1 0.45 1 1s-0.45 1-1 1c-0.55 0-1-0.45-1-1s0.45-1 1-1z" }),
_('path', { d: "M18.928 14.628c-0.091-0.225-0.259-0.409-0.478-0.522-1.313-0.666-3.669-0.616-5.453-0.334v-3.931c1.559 0.831 3.219 1.212 5.031 1.159l-0.059-2c-1.997 0.059-3.7-0.509-5.359-1.791-0.303-0.234-0.709-0.275-1.053-0.106s-0.556 0.516-0.556 0.897v7c0 0.312 0.144 0.606 0.394 0.794 0.247 0.191 0.569 0.253 0.869 0.172 1.606-0.434 3.888-0.509 4.972-0.194l1.841 4.6 1.856-0.744-2.003-5z" }),
_('path', { d: "M16.066 19.219c-1.109 1.741-3.003 2.781-5.066 2.781-3.309 0-6-2.691-6-6 0-2.934 2.181-5.481 5.075-5.928l-0.153-0.987c-1.634 0.253-3.134 1.084-4.219 2.341-1.097 1.269-1.703 2.894-1.703 4.575 0 1.869 0.728 3.628 2.050 4.95s3.081 2.050 4.95 2.050c2.406 0 4.616-1.212 5.909-3.244l0.269-0.422-0.844-0.537-0.269 0.422z" })
            );
        }
        function Wheelchair({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WheelchairSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Wheelchair.SVG = WheelchairSVG;
        return Wheelchair;
    })();
export const Whistle = /*#__PURE__*/ (() => {
        function WhistleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0.867 5.816l0.316-0.949 3.949 1.316-0.316 0.949-3.949-1.316z" }),
_('path', { d: "M1.792 1.5l0.707-0.707 3.708 3.708-0.707 0.707-3.708-3.708z" }),
_('path', { d: "M7 0h1v4h-1v-4z" }),
_('path', { d: "M22.894 4.553l-2-4c-0.125-0.25-0.347-0.434-0.616-0.513s-0.556-0.041-0.794 0.103l-10.131 6.094c-0.003 0-0.003 0.003-0.006 0.003-0.341 0.213-0.45 0.656-0.244 0.997l0.762 1.266c0.272 0.475 0.109 1.087-0.369 1.362s-1.091 0.113-1.366-0.369c0-0.003-0.003-0.006-0.003-0.006l-0.619-1.025c-0.269-0.45-0.856-0.6-1.309-0.331l-1.459 0.875c-1.731 1-2.969 2.616-3.487 4.55s-0.253 3.956 0.75 5.691c0.162 0.281 0.341 0.55 0.534 0.803-0.878 0.209-1.537 1.003-1.537 1.947 0 1.103 0.897 2 2 2 1.059 0 1.928-0.825 1.997-1.866 0.491 0.259 1.016 0.462 1.563 0.609 0.647 0.172 1.3 0.259 1.953 0.259 1.3 0 2.581-0.341 3.738-1.006 1.734-1 2.975-2.619 3.494-4.553 0.516-1.928 0.253-3.941-0.741-5.672-0.006-0.078 0.050-0.353 0.363-0.791 0.303-0.425 0.747-0.853 1.188-1.147l6-4c0.422-0.281 0.566-0.831 0.341-1.281zM3 23c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM15.447 8.169c-0.719 0.478-1.416 1.181-1.859 1.875-0.863 1.347-0.572 2.275-0.325 2.706 0.734 1.272 0.928 2.756 0.55 4.175-0.381 1.419-1.291 2.603-2.562 3.337s-2.756 0.928-4.175 0.55c-1.419-0.381-2.603-1.291-3.338-2.562s-0.928-2.756-0.55-4.175c0.381-1.419 1.291-2.603 2.562-3.337 0.006-0.003 0.009-0.006 0.016-0.009l1.422-0.853 0.078 0.131c0.372 0.638 1.044 0.997 1.734 0.997 0.341 0 0.681-0.087 0.997-0.269 0.956-0.553 1.284-1.778 0.731-2.734 0-0.003-0.003-0.006-0.003-0.006l-0.109-0.181 8.972-5.397 1.122 2.244-5.262 3.509z" })
            );
        }
        function Whistle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WhistleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Whistle.SVG = WhistleSVG;
        return Whistle;
    })();
export const WidescreenPlay = /*#__PURE__*/ (() => {
        function WidescreenPlaySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 2h-20c-1.103 0-2 0.897-2 2v11c0 1.103 0.897 2 2 2h9v2c0 0.472-0.387 0.956-1.062 1.331-0.778 0.431-1.822 0.669-2.937 0.669v1h10v-1c-1.119 0-2.163-0.237-2.937-0.669-0.675-0.375-1.062-0.859-1.062-1.331v-2h9c1.103 0 2-0.897 2-2v-11c0-1.103-0.897-2-2-2zM13.244 21h-2.487c0.778-0.528 1.244-1.225 1.244-2 0 0.775 0.466 1.472 1.244 2zM2 4h20v9h-20v-9c-0.003 0 0 0 0 0zM2 15v-1h20v1h-20z" }),
_('path', { d: "M9.237 11.925c0.081 0.050 0.172 0.075 0.262 0.075 0.075 0 0.153-0.019 0.225-0.053l6-3c0.169-0.084 0.275-0.259 0.275-0.447s-0.106-0.363-0.275-0.447l-6-3c-0.156-0.078-0.337-0.069-0.488 0.022-0.147 0.091-0.237 0.253-0.237 0.425v6c0 0.172 0.091 0.334 0.237 0.425zM10 6.309l4.381 2.191-4.381 2.191v-4.381z" })
            );
        }
        function WidescreenPlay({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WidescreenPlaySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WidescreenPlay.SVG = WidescreenPlaySVG;
        return WidescreenPlay;
    })();
export const WidescreenUser = /*#__PURE__*/ (() => {
    function WidescreenUserSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 2h-20c-1.103 0-2 0.897-2 2v11c0 1.103 0.897 2 2 2h9v2c0 0.472-0.387 0.956-1.062 1.331-0.778 0.431-1.822 0.669-2.937 0.669v1h10v-1c-1.119 0-2.163-0.237-2.937-0.669-0.675-0.375-1.062-0.859-1.062-1.331v-2h9c1.103 0 2-0.897 2-2v-11c0-1.103-0.897-2-2-2zM13.244 21h-2.487c0.778-0.528 1.244-1.225 1.244-2 0 0.775 0.466 1.472 1.244 2zM2 4h20v9h-6.225c-0.416-0.625-0.894-1.094-1.453-1.422-0.147-0.087-0.3-0.162-0.456-0.231 0.691-0.55 1.134-1.397 1.134-2.347 0-1.653-1.347-3-3-3s-3 1.347-3 3c0 0.95 0.444 1.797 1.134 2.347-0.156 0.066-0.309 0.144-0.456 0.231-0.559 0.328-1.038 0.797-1.453 1.422h-6.225v-9c-0.003 0 0 0 0 0zM10 9c0-1.103 0.897-2 2-2s2 0.897 2 2-0.897 2-2 2c-1.103 0-2-0.897-2-2zM14.506 13h-5.013c0.644-0.687 1.447-1 2.506-1s1.863 0.312 2.506 1zM2 15v-1h20v1h-20z" })
        );
    }
    function WidescreenUser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WidescreenUserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    WidescreenUser.SVG = WidescreenUserSVG;
    return WidescreenUser;
})();
export const Widescreen = /*#__PURE__*/ (() => {
    function WidescreenSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M22 2h-20c-1.103 0-2 0.897-2 2v11c0 1.103 0.897 2 2 2h9v2c0 0.472-0.387 0.956-1.062 1.331-0.778 0.431-1.822 0.669-2.937 0.669v1h10v-1c-1.119 0-2.163-0.237-2.937-0.669-0.675-0.375-1.062-0.859-1.062-1.331v-2h9c1.103 0 2-0.897 2-2v-11c0-1.103-0.897-2-2-2zM13.244 21h-2.487c0.778-0.528 1.244-1.225 1.244-2 0 0.775 0.466 1.472 1.244 2zM2 4h20v9h-20v-9c-0.003 0 0 0 0 0zM2 15v-1h20v1h-20z" })
        );
    }
    function Widescreen({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WidescreenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Widescreen.SVG = WidescreenSVG;
    return Widescreen;
})();
export const Wifi100Warning = /*#__PURE__*/ (() => {
        function Wifi100WarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 17c1.653 0 3 1.347 3 3s-1.347 3-3 3-3-1.347-3-3 1.347-3 3-3zM12 21c0.55 0 1-0.45 1-1s-0.45-1-1-1c-0.55 0-1 0.45-1 1s0.45 1 1 1z" }),
_('path', { d: "M15.663 15.247l0.397 0.306-0.612 0.791-0.397-0.306c-1.797-1.391-4.306-1.391-6.103 0l-0.397 0.306-0.612-0.791 0.397-0.306c2.156-1.666 5.172-1.666 7.328 0z" }),
_('path', { d: "M18 9h-1v1h1v-1z" }),
_('path', { d: "M18 4h-1v4h1v-4z" }),
_('path', { d: "M1.922 8.891c2.766-2.509 6.344-3.891 10.078-3.891 0.831 0 1.662 0.069 2.472 0.203l1.688-3.372c0.25-0.506 0.775-0.831 1.341-0.831s1.091 0.325 1.341 0.828l4 7.997c0.103 0.206 0.159 0.438 0.159 0.672 0 0.828-0.672 1.5-1.5 1.5h-5.378c0.606 0.312 1.175 0.691 1.7 1.137l0.381 0.325-0.647 0.762-0.381-0.325c-3-2.55-7.353-2.547-10.353 0.003l-0.381 0.325-0.647-0.762 0.381-0.325c1.619-1.378 3.687-2.137 5.822-2.137h0.003c0.028 0 0.056 0 0.084 0-0.056-0.156-0.087-0.325-0.087-0.503 0-0.234 0.056-0.466 0.159-0.672l0.406-0.813c-2.869-0.147-5.694 0.834-7.85 2.744l-0.375 0.331-0.663-0.75 0.375-0.331c2.459-2.178 5.722-3.25 8.997-2.963l0.953-1.906c-0.659-0.094-1.331-0.141-2.003-0.141-3.488 0-6.825 1.287-9.403 3.628l-0.369 0.338-0.675-0.738 0.372-0.334zM22 10.5c0-0.078-0.019-0.153-0.050-0.219l-4.003-8.006c-0.081-0.166-0.256-0.275-0.447-0.275s-0.363 0.109-0.447 0.278l-4.003 8.003c-0.034 0.066-0.050 0.141-0.050 0.219 0 0.275 0.225 0.5 0.5 0.5h8c0.275 0 0.5-0.225 0.5-0.5z" })
            );
        }
        function Wifi100Warning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Wifi100WarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Wifi100Warning.SVG = Wifi100WarningSVG;
        return Wifi100Warning;
    })();
export const Wifi100 = /*#__PURE__*/ (() => {
        function Wifi100SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 15c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM12 19c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M8.337 13.247l-0.397 0.306 0.612 0.791 0.397-0.306c1.797-1.391 4.306-1.391 6.103 0l0.397 0.306 0.612-0.791-0.397-0.306c-2.156-1.666-5.172-1.666-7.328 0z" }),
_('path', { d: "M12 9.003h-0.003c-2.134 0-4.2 0.759-5.822 2.134l-0.381 0.325 0.647 0.762 0.381-0.325c3-2.55 7.353-2.547 10.353 0.003l0.381 0.325 0.647-0.762-0.381-0.325c-1.619-1.378-3.684-2.137-5.822-2.137z" }),
_('path', { d: "M4.053 9.009l-0.375 0.331 0.663 0.75 0.375-0.331c4.153-3.678 10.416-3.678 14.569 0l0.375 0.331 0.663-0.75-0.375-0.331c-4.531-4.012-11.363-4.012-15.894 0z" }),
_('path', { d: "M22.078 6.888c-2.766-2.506-6.344-3.888-10.078-3.888s-7.313 1.381-10.078 3.888l-0.369 0.337 0.672 0.741 0.369-0.338c2.581-2.341 5.922-3.628 9.406-3.628s6.825 1.287 9.406 3.628l0.369 0.338 0.672-0.741-0.369-0.337z" })
            );
        }
        function Wifi100({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Wifi100SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Wifi100.SVG = Wifi100SVG;
        return Wifi100;
    })();
export const Wifi25Warning = /*#__PURE__*/ (() => {
        function Wifi25WarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 17c1.653 0 3 1.347 3 3s-1.347 3-3 3-3-1.347-3-3 1.347-3 3-3zM12 21c0.55 0 1-0.45 1-1s-0.45-1-1-1c-0.55 0-1 0.45-1 1s0.45 1 1 1z" }),
_('path', { d: "M8.334 15.247c2.156-1.669 5.169-1.669 7.328 0l0.397 0.306-0.612 0.791-0.397-0.306c-1.797-1.391-4.306-1.391-6.103 0l-0.397 0.306-0.612-0.791 0.397-0.306z" }),
_('path', { d: "M18 9h-1v1h1v-1z" }),
_('path', { d: "M18 4h-1v4h1v-4z" }),
_('path', { d: "M12 10.5c0-0.234 0.056-0.466 0.159-0.672l4-7.997c0.25-0.506 0.775-0.831 1.341-0.831s1.091 0.325 1.341 0.828l4 7.997c0.103 0.206 0.159 0.438 0.159 0.672 0 0.828-0.672 1.5-1.5 1.5h-8c-0.828 0.003-1.5-0.669-1.5-1.497zM22 10.5c0-0.078-0.019-0.153-0.050-0.219l-4.003-8.006c-0.081-0.166-0.256-0.275-0.447-0.275s-0.363 0.109-0.447 0.278l-4.003 8.003c-0.034 0.066-0.050 0.141-0.050 0.219 0 0.275 0.225 0.5 0.5 0.5h8c0.275 0 0.5-0.225 0.5-0.5z" })
            );
        }
        function Wifi25Warning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Wifi25WarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Wifi25Warning.SVG = Wifi25WarningSVG;
        return Wifi25Warning;
    })();
export const Wifi25 = /*#__PURE__*/ (() => {
        function Wifi25SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 15c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM12 19c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M15.666 13.247c-2.156-1.669-5.169-1.669-7.328 0l-0.397 0.306 0.612 0.791 0.397-0.306c1.797-1.391 4.306-1.391 6.103 0l0.397 0.306 0.612-0.791-0.397-0.306z" })
            );
        }
        function Wifi25({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Wifi25SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Wifi25.SVG = Wifi25SVG;
        return Wifi25;
    })();
export const Wifi50Warning = /*#__PURE__*/ (() => {
        function Wifi50WarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 17c1.653 0 3 1.347 3 3s-1.347 3-3 3-3-1.347-3-3 1.347-3 3-3zM12 21c0.55 0 1-0.45 1-1s-0.45-1-1-1c-0.55 0-1 0.45-1 1s0.45 1 1 1z" }),
_('path', { d: "M15.663 15.247l0.397 0.306-0.612 0.791-0.397-0.306c-1.797-1.391-4.306-1.391-6.103 0l-0.397 0.306-0.612-0.791 0.397-0.306c2.156-1.666 5.172-1.666 7.328 0z" }),
_('path', { d: "M18 9h-1v1h1v-1z" }),
_('path', { d: "M18 4h-1v4h1v-4z" }),
_('path', { d: "M6.175 13.141c1.619-1.378 3.687-2.138 5.822-2.138h0.003c0.028 0 0.056 0 0.084 0-0.056-0.156-0.087-0.325-0.087-0.503 0-0.234 0.056-0.466 0.159-0.672l4.003-7.997c0.25-0.506 0.775-0.831 1.341-0.831s1.091 0.325 1.341 0.828l4 7.997c0.103 0.206 0.159 0.438 0.159 0.672 0 0.828-0.672 1.5-1.5 1.5h-5.378c0.606 0.312 1.175 0.691 1.7 1.137l0.381 0.325-0.647 0.762-0.381-0.325c-3-2.55-7.353-2.547-10.353 0.003l-0.381 0.325-0.647-0.762 0.381-0.322zM22 10.5c0-0.078-0.019-0.153-0.050-0.219l-4.003-8.006c-0.081-0.166-0.256-0.275-0.447-0.275s-0.363 0.109-0.447 0.278l-4.003 8.003c-0.034 0.066-0.050 0.141-0.050 0.219 0 0.275 0.225 0.5 0.5 0.5h8c0.275 0 0.5-0.225 0.5-0.5z" })
            );
        }
        function Wifi50Warning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Wifi50WarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Wifi50Warning.SVG = Wifi50WarningSVG;
        return Wifi50Warning;
    })();
export const Wifi50 = /*#__PURE__*/ (() => {
        function Wifi50SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 15c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM12 19c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M8.337 13.247l-0.397 0.306 0.612 0.791 0.397-0.306c1.797-1.391 4.306-1.391 6.103 0l0.397 0.306 0.612-0.791-0.397-0.306c-2.156-1.666-5.172-1.666-7.328 0z" }),
_('path', { d: "M17.825 11.141c-1.619-1.378-3.687-2.137-5.822-2.137h-0.003c-2.134 0-4.2 0.759-5.822 2.134l-0.381 0.325 0.647 0.762 0.381-0.325c3-2.55 7.353-2.547 10.353 0.003l0.381 0.325 0.647-0.762-0.381-0.325z" })
            );
        }
        function Wifi50({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Wifi50SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Wifi50.SVG = Wifi50SVG;
        return Wifi50;
    })();
export const Wifi75Warning = /*#__PURE__*/ (() => {
        function Wifi75WarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 17c1.653 0 3 1.347 3 3s-1.347 3-3 3-3-1.347-3-3 1.347-3 3-3zM12 21c0.55 0 1-0.45 1-1s-0.45-1-1-1c-0.55 0-1 0.45-1 1s0.45 1 1 1z" }),
_('path', { d: "M15.663 15.247l0.397 0.306-0.612 0.791-0.397-0.306c-1.797-1.391-4.306-1.391-6.103 0l-0.397 0.306-0.612-0.791 0.397-0.306c2.156-1.666 5.172-1.666 7.328 0z" }),
_('path', { d: "M18 9h-1v1h1v-1z" }),
_('path', { d: "M18 4h-1v4h1v-4z" }),
_('path', { d: "M4.053 11.009c2.459-2.178 5.722-3.25 8.997-2.963l3.109-6.216c0.25-0.506 0.775-0.831 1.341-0.831s1.091 0.325 1.341 0.828l4 7.997c0.103 0.206 0.159 0.438 0.159 0.672 0 0.828-0.672 1.5-1.5 1.5h-5.378c0.606 0.312 1.175 0.691 1.7 1.137l0.381 0.325-0.647 0.762-0.381-0.325c-3-2.55-7.353-2.547-10.353 0.003l-0.381 0.325-0.647-0.762 0.381-0.325c1.619-1.378 3.687-2.137 5.822-2.137h0.003c0.028 0 0.056 0 0.084 0-0.056-0.156-0.087-0.325-0.087-0.503 0-0.234 0.056-0.466 0.159-0.672l0.406-0.813c-2.869-0.147-5.694 0.834-7.85 2.744l-0.375 0.331-0.663-0.75 0.378-0.328zM22 10.5c0-0.078-0.019-0.153-0.050-0.219l-4.003-8.006c-0.081-0.166-0.256-0.275-0.447-0.275s-0.363 0.109-0.447 0.278l-4.003 8.003c-0.034 0.066-0.050 0.141-0.050 0.219 0 0.275 0.225 0.5 0.5 0.5h8c0.275 0 0.5-0.225 0.5-0.5z" })
            );
        }
        function Wifi75Warning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Wifi75WarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Wifi75Warning.SVG = Wifi75WarningSVG;
        return Wifi75Warning;
    })();
export const Wifi75 = /*#__PURE__*/ (() => {
        function Wifi75SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 15c-1.653 0-3 1.347-3 3s1.347 3 3 3 3-1.347 3-3-1.347-3-3-3zM12 19c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z" }),
_('path', { d: "M8.337 13.247l-0.397 0.306 0.612 0.791 0.397-0.306c1.797-1.391 4.306-1.391 6.103 0l0.397 0.306 0.612-0.791-0.397-0.306c-2.156-1.666-5.172-1.666-7.328 0z" }),
_('path', { d: "M12 9.003h-0.003c-2.134 0-4.2 0.759-5.822 2.134l-0.381 0.325 0.647 0.762 0.381-0.325c3-2.55 7.353-2.547 10.353 0.003l0.381 0.325 0.647-0.762-0.381-0.325c-1.619-1.378-3.684-2.137-5.822-2.137z" }),
_('path', { d: "M19.947 9.009c-4.531-4.012-11.363-4.012-15.894 0l-0.375 0.331 0.663 0.75 0.375-0.331c4.153-3.678 10.416-3.678 14.569 0l0.375 0.331 0.663-0.75-0.375-0.331z" })
            );
        }
        function Wifi75({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Wifi75SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Wifi75.SVG = Wifi75SVG;
        return Wifi75;
    })();
export const WifiCross = /*#__PURE__*/ (() => {
        function WifiCrossSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 17c1.653 0 3 1.347 3 3s-1.347 3-3 3-3-1.347-3-3 1.347-3 3-3zM12 21c0.55 0 1-0.45 1-1s-0.45-1-1-1c-0.55 0-1 0.45-1 1s0.45 1 1 1z" }),
_('path', { d: "M15.663 15.247l0.397 0.306-0.612 0.791-0.397-0.306c-1.797-1.391-4.306-1.391-6.103 0l-0.397 0.306-0.612-0.791 0.397-0.306c2.156-1.666 5.172-1.666 7.328 0z" }),
_('path', { d: "M1.922 8.891c1.203-1.094 2.566-1.978 4.050-2.628 1.428-0.628 2.941-1.025 4.497-1.184 0.963-2.388 3.303-4.078 6.031-4.078 3.584 0 6.5 2.916 6.5 6.5s-2.916 6.5-6.5 6.5c-1.837 0-3.5-0.766-4.681-1.997-1.831 0.044-3.6 0.713-4.994 1.897l-0.381 0.325-0.65-0.762 0.381-0.325c1.381-1.175 3.087-1.9 4.881-2.091-0.378-0.578-0.669-1.219-0.847-1.903-2.047 0.334-3.941 1.231-5.497 2.613l-0.375 0.331-0.663-0.75 0.375-0.331c1.694-1.5 3.753-2.478 5.981-2.847-0.022-0.219-0.034-0.441-0.034-0.663 0-0.472 0.050-0.934 0.147-1.378-2.825 0.372-5.422 1.575-7.55 3.506l-0.369 0.338-0.675-0.738 0.372-0.334zM16.5 13c3.031 0 5.5-2.469 5.5-5.5s-2.469-5.5-5.5-5.5-5.5 2.469-5.5 5.5 2.469 5.5 5.5 5.5z" }),
_('path', { d: "M14.5 4.794l2 2 2-2 0.706 0.706-2 2 2 2-0.706 0.706-2-2-2 2-0.706-0.706 2-2-2-2z" })
            );
        }
        function WifiCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WifiCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WifiCross.SVG = WifiCrossSVG;
        return WifiCross;
    })();
export const WifiLock = /*#__PURE__*/ (() => {
        function WifiLockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 17c1.653 0 3 1.347 3 3s-1.347 3-3 3-3-1.347-3-3 1.347-3 3-3zM12 21c0.55 0 1-0.45 1-1s-0.45-1-1-1c-0.55 0-1 0.45-1 1s0.45 1 1 1z" }),
_('path', { d: "M15.663 15.247l0.397 0.306-0.612 0.791-0.397-0.306c-1.797-1.391-4.306-1.391-6.103 0l-0.397 0.306-0.612-0.791 0.397-0.306c2.156-1.666 5.172-1.666 7.328 0z" }),
_('path', { d: "M1.922 8.891c1.203-1.094 2.566-1.978 4.050-2.628 1.428-0.628 2.941-1.025 4.497-1.184 0.963-2.388 3.303-4.078 6.031-4.078 3.584 0 6.5 2.916 6.5 6.5s-2.916 6.5-6.5 6.5c-1.837 0-3.5-0.766-4.681-1.997-1.831 0.044-3.6 0.713-4.994 1.897l-0.381 0.325-0.65-0.762 0.381-0.325c1.381-1.175 3.087-1.9 4.881-2.091-0.378-0.578-0.669-1.219-0.847-1.903-2.047 0.334-3.941 1.231-5.497 2.613l-0.375 0.331-0.663-0.75 0.375-0.331c1.694-1.5 3.753-2.478 5.981-2.847-0.022-0.219-0.034-0.441-0.034-0.663 0-0.472 0.050-0.934 0.147-1.378-2.825 0.372-5.422 1.575-7.55 3.506l-0.369 0.338-0.675-0.738 0.372-0.334zM16.5 13c3.031 0 5.5-2.469 5.5-5.5s-2.469-5.5-5.5-5.5-5.5 2.469-5.5 5.5 2.469 5.5 5.5 5.5z" }),
_('path', { d: "M13.5 7h0.5v-0.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5v0.5h0.5c0.275 0 0.5 0.225 0.5 0.5v3c0 0.275-0.225 0.5-0.5 0.5h-6c-0.275 0-0.5-0.225-0.5-0.5v-3c0-0.275 0.225-0.5 0.5-0.5zM18 6.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5v0.5h3v-0.5zM14 10h5v-2h-5v2z" })
            );
        }
        function WifiLock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WifiLockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WifiLock.SVG = WifiLockSVG;
        return WifiLock;
    })();
export const Wind = /*#__PURE__*/ (() => {
        function WindSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5.756 14.006c0.55 0 1.125-0.053 1.728-0.156 2.384-0.413 4.747-1.566 7.028-2.678 3.866-1.884 6.319-2.925 7.781-1.463l0.25 0.25 1.416-1.416-0.25-0.25c-0.641-0.641-1.416-1.044-2.297-1.2-0.753-0.131-1.581-0.087-2.531 0.134-1.631 0.384-3.384 1.238-5.241 2.144-4.25 2.072-8.641 4.212-11.934 0.922l-0.25-0.25-1.413 1.413 0.25 0.25c1.025 1.025 2.197 1.713 3.481 2.050 0.631 0.166 1.291 0.25 1.981 0.25z" }),
_('path', { d: "M6.5 10c2.719 0 4.697-1.137 6.794-2.341 2.275-1.306 4.628-2.659 8.206-2.659h0.5v-1h-0.5c-1.722 0-3.337 0.294-4.934 0.9-1.4 0.531-2.606 1.222-3.772 1.891-1.975 1.137-3.844 2.209-6.294 2.209-1.931 0-3.5-1.569-3.5-3.5 0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5c0 0.828-0.672 1.5-1.5 1.5-0.175 0-0.344-0.031-0.5-0.084 0.581-0.206 1-0.762 1-1.416 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5c0-1.931-1.569-3.5-3.5-3.5-1.759 0-3.222 1.306-3.466 3h-0.034v0.5c0 2.481 2.019 4.5 4.5 4.5zM5.5 5c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5c-0.275 0-0.497-0.222-0.5-0.494 0-0.003 0-0.003 0-0.006 0-0.275 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M19.231 11.031c-1.159-0.053-2.363 0.222-3.578 0.819-1.2 0.591-2.416 1.497-3.612 2.694l1.416 1.413c1.991-1.994 3.953-3.006 5.681-2.925 1.247 0.059 2.372 0.684 3.341 1.856l1.541-1.275c-1.325-1.603-2.981-2.497-4.788-2.581z" }),
_('path', { d: "M7 15c-2.206 0-4 1.794-4 4 0 0.781 0.247 1.519 0.697 2.081 0.475 0.594 1.116 0.919 1.803 0.919 1.378 0 2.5-1.122 2.5-2.5 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.653 0.419 1.209 1 1.416-0.156 0.056-0.325 0.084-0.5 0.084-0.378 0-0.744-0.194-1.025-0.544-0.306-0.384-0.475-0.9-0.475-1.456 0-1.653 1.347-3 3-3 2.072 0 3 1.759 3 3.5v0.5h1v-0.5c0-1.222-0.369-2.341-1.038-3.147-0.731-0.884-1.756-1.353-2.963-1.353zM6.5 19c0.275 0 0.5 0.225 0.5 0.5 0 0.003 0 0.003 0 0.006-0.003 0.272-0.225 0.494-0.5 0.494s-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" })
            );
        }
        function Wind({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WindSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Wind.SVG = WindSVG;
        return Wind;
    })();
export const WindowTabPlus = /*#__PURE__*/ (() => {
        function WindowTabPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 0h-20c-1.103 0-2 0.897-2 2v18c0 1.103 0.897 2 2 2h10.812c1.184 1.231 2.847 2 4.687 2 3.584 0 6.5-2.916 6.5-6.5v-15.5c0-1.103-0.897-2-2-2zM11.019 18h-9.019v-11h10.5c0.216 0 0.406-0.138 0.475-0.341l0.888-2.659h5.278l0.888 2.659c0.069 0.203 0.259 0.341 0.475 0.341h1.5v5.812c-1.169-1.122-2.756-1.812-4.5-1.812-3.584 0-6.5 2.916-6.5 6.5-0.003 0.169 0.003 0.334 0.016 0.5zM22 2v4h-1.141l-0.888-2.659c-0.066-0.203-0.256-0.341-0.472-0.341h-6c-0.216 0-0.406 0.138-0.475 0.341l-0.884 2.659h-10.141v-4h20zM2 19h9.175c0.081 0.344 0.191 0.678 0.325 1h-9.5v-1zM17.5 23c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M5 4c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" }),
_('path', { d: "M8 4c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" }),
_('path', { d: "M11 4c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" }),
_('path', { d: "M18 15h-1v2h-2v1h2v2h1v-2h2v-1h-2z" })
            );
        }
        function WindowTabPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WindowTabPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WindowTabPlus.SVG = WindowTabPlusSVG;
        return WindowTabPlus;
    })();
export const WindowTab = /*#__PURE__*/ (() => {
        function WindowTabSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 1h-20c-1.103 0-2 0.897-2 2v18c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-18c0-1.103-0.897-2-2-2zM22 3v4h-1.141l-0.888-2.659c-0.069-0.203-0.259-0.341-0.475-0.341h-5.997c-0.216 0-0.406 0.138-0.475 0.341l-0.884 2.659h-10.141v-4h20zM22 8v11h-20v-11h10.5c0.216 0 0.406-0.138 0.475-0.341l0.888-2.659h5.278l0.888 2.659c0.069 0.203 0.259 0.341 0.475 0.341h1.497zM22 21h-20v-1h20.003l-0.003 1c0.003 0 0 0 0 0z" }),
_('path', { d: "M5 5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" }),
_('path', { d: "M8 5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" }),
_('path', { d: "M11 5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" })
            );
        }
        function WindowTab({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WindowTabSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WindowTab.SVG = WindowTabSVG;
        return WindowTab;
    })();
export const Window = /*#__PURE__*/ (() => {
    function WindowSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.584 3.188c-0.259-0.188-0.597-0.241-0.9-0.138l-5.847 1.95h-9.675l-5.847-1.95c-0.306-0.103-0.641-0.050-0.9 0.138-0.262 0.191-0.416 0.491-0.416 0.813v16c0 0.322 0.153 0.622 0.416 0.813 0.172 0.125 0.378 0.188 0.584 0.188 0.106 0 0.213-0.016 0.316-0.050l5.847-1.95h9.675l5.847 1.95c0.103 0.034 0.209 0.050 0.316 0.050 0.206 0 0.412-0.066 0.584-0.188 0.259-0.188 0.416-0.491 0.416-0.813v-16c0-0.322-0.153-0.622-0.416-0.813zM19 6.387v2.303l-1 0.2v-2.169l1-0.334zM18 15.109l1 0.2v2.303l-1-0.334v-2.169zM18 14.091v-4.181l1-0.2v4.581l-1-0.2zM20 9.509l2-0.4v5.781l-2-0.4v-4.981zM22 8.091l-2 0.4v-2.438l2-0.666v2.703zM5 9.709l1 0.2v4.181l-1 0.2v-4.581zM4 14.491l-2 0.4v-5.781l2 0.4v4.981zM6 8.891l-1-0.2v-2.303l1 0.334v2.169zM6 15.109v2.169l-1 0.334v-2.303l1-0.2zM8 12.766c0.828-0.378 1.675-1.197 2.422-2.372 0.881-1.384 1.447-2.991 1.556-4.394h1.009c-0.138 2.763-1.387 4.441-2.447 5.375-0.869 0.766-1.803 1.219-2.541 1.444v-0.053zM10.978 6c-0.197 2.241-1.656 4.684-2.978 5.613v-5.613h2.978zM4 6.053v2.438l-2-0.4v-2.703l2 0.666zM2 15.909l2-0.4v2.437l-2 0.666v-2.703zM8 14.1c0.909 0.197 1.628 0.675 2.15 1.431 0.584 0.847 0.772 1.822 0.828 2.466h-2.978v-3.897zM11.981 18c-0.081-1.125-0.441-2.206-1.006-3.034-0.469-0.684-1.078-1.197-1.803-1.528 0.672-0.306 1.378-0.741 2.031-1.316 1.212-1.069 2.647-2.988 2.787-6.125h2.009v12h-4.019zM20 17.947v-2.437l2 0.4v2.703l-2-0.666z" })
        );
    }
    function Window({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WindowSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Window.SVG = WindowSVG;
    return Window;
})();
export const Window2 = /*#__PURE__*/ (() => {
        function Window2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22 1h-20c-1.103 0-2 0.897-2 2v18c0 1.103 0.897 2 2 2h20c1.103 0 2-0.897 2-2v-18c0-1.103-0.897-2-2-2zM22 3v4h-20v-4h20zM22 8v11h-20v-11h20zM22 21h-20v-1h20.003l-0.003 1c0.003 0 0 0 0 0z" }),
_('path', { d: "M5 5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" }),
_('path', { d: "M8 5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" }),
_('path', { d: "M11 5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" })
            );
        }
        function Window2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Window2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Window2.SVG = Window2SVG;
        return Window2;
    })();
export const Wink = /*#__PURE__*/ (() => {
        function WinkSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M15.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM15.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M12 19c-3.859 0-7-3.141-7-7h-1c0 4.413 3.588 8 8 8s8-3.588 8-8h-1c0 3.859-3.141 7-7 7z" }),
_('path', { d: "M10.5 9h0.5v-1h-0.5c-1.441 0-2.819-0.325-3.784-0.894l-0.431-0.253-0.506 0.862 0.431 0.253c1.128 0.666 2.653 1.031 4.291 1.031z" })
            );
        }
        function Wink({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WinkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Wink.SVG = WinkSVG;
        return Wink;
    })();
export const WitchHat = /*#__PURE__*/ (() => {
    function WitchHatSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.362 15.575c-0.363-0.5-0.884-0.956-1.55-1.356-1-0.603-2.363-1.109-4.153-1.547l-2.556-8.487c-0.178-0.594-0.631-1.078-1.212-1.297l-7.541-2.825c-0.397-0.15-0.847-0.031-1.119 0.297s-0.309 0.791-0.091 1.153l2.781 4.638-1.759 6.569c-1.737 0.441-3.059 0.947-4.025 1.538-1.419 0.866-2.138 1.956-2.138 3.244 0 0.912 0.384 1.837 1.106 2.678 0.644 0.747 1.537 1.419 2.656 1.997 2.275 1.175 5.203 1.825 8.238 1.825s5.962-0.65 8.238-1.825c1.119-0.578 2.013-1.25 2.656-1.997 0.725-0.841 1.106-1.766 1.106-2.678 0-0.694-0.216-1.341-0.637-1.925zM16.975 17.334v0c-0.003 0-0.003 0 0 0-3.266 0.897-6.716 0.894-9.975-0.009v0l0.497-1.856c0.725 0.2 1.578 0.35 2.503 0.441v0.594c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-0.594c0.888-0.087 1.713-0.231 2.416-0.422l0.559 1.847zM11 16v-1h2v1h-2zM9.641 5.122l-1.306-2.178 4.853 1.819 2.944 9.766c-0.619 0.166-1.341 0.291-2.128 0.372v-0.4c0-0.275-0.225-0.5-0.5-0.5h-3c-0.275 0-0.5 0.225-0.5 0.5v0.403c-0.837-0.084-1.603-0.222-2.247-0.4l2.1-7.834c0.141-0.522 0.059-1.084-0.216-1.547zM19.319 20.397c-1.969 1.019-4.638 1.603-7.319 1.603s-5.35-0.584-7.319-1.603c-1.653-0.856-2.681-1.966-2.681-2.897 0-0.95 1.222-1.816 3.559-2.534l-0.494 1.844c-0.284 1.056 0.341 2.153 1.394 2.444 1.788 0.494 3.644 0.747 5.519 0.747 0.006 0 0.016 0 0.022 0 1.869 0 3.719-0.247 5.5-0.738 0.528-0.144 0.963-0.488 1.225-0.963s0.322-1.022 0.162-1.544l-0.55-1.828c2.403 0.719 3.663 1.597 3.663 2.572 0 0.931-1.028 2.041-2.681 2.897z" })
        );
    }
    function WitchHat({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WitchHatSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    WitchHat.SVG = WitchHatSVG;
    return WitchHat;
})();
export const Wondering = /*#__PURE__*/ (() => {
        function WonderingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M8.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM8.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M15.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM15.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M6.867 14.816l0.316-0.949 9.95 3.316-0.316 0.949-9.95-3.316z" })
            );
        }
        function Wondering({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WonderingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Wondering.SVG = WonderingSVG;
        return Wondering;
    })();
export const WrenchScrewdriver = /*#__PURE__*/ (() => {
    function WrenchScrewdriverSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M18.237 13.737c0 0 0-0.003 0 0-0.697-0.694-1.703-0.894-2.578-0.597-0.181-0.291-0.325-0.609-0.431-0.953l2.381-2.381c0.441 0.128 0.906 0.197 1.391 0.197 2.756 0 5-2.244 5-5 0-0.491-0.072-0.981-0.216-1.45-0.050-0.169-0.188-0.297-0.356-0.341-0.172-0.044-0.35 0.006-0.475 0.131l-1.662 1.656h-2.294v-2.294l1.662-1.659c0.125-0.125 0.175-0.303 0.131-0.475s-0.172-0.306-0.341-0.356c-0.469-0.144-0.959-0.216-1.45-0.216-2.756 0-5 2.244-5 5 0 0.481 0.069 0.947 0.197 1.391l-3.55 3.55-4.894-4.894c0.419-0.731 0.319-1.681-0.306-2.306-0.019-0.019-0.041-0.038-0.059-0.053l-3.594-2.594c-0.2-0.144-0.475-0.122-0.647 0.053l-1 1c-0.175 0.172-0.197 0.447-0.053 0.647l2.594 3.594c0.016 0.022 0.034 0.041 0.053 0.059 0.372 0.372 0.862 0.559 1.353 0.559 0.328 0 0.659-0.084 0.953-0.253l4.894 4.894-3.55 3.55c-0.441-0.128-0.906-0.197-1.391-0.197-2.756 0-5 2.244-5 5 0 0.788 0.178 1.544 0.531 2.247 0.072 0.144 0.209 0.244 0.366 0.269 0.159 0.025 0.319-0.025 0.434-0.141l2.375-2.375h1.294v1.294l-2.375 2.375c-0.112 0.113-0.166 0.275-0.141 0.431 0.025 0.159 0.125 0.294 0.269 0.369 0.687 0.347 1.466 0.531 2.247 0.531 2.756 0 5-2.244 5-5 0-0.481-0.069-0.947-0.197-1.391l2.381-2.381c0.347 0.106 0.663 0.25 0.956 0.434-0.297 0.875-0.097 1.881 0.597 2.578l5.031 5.031c0.488 0.487 1.125 0.728 1.766 0.728s1.281-0.244 1.769-0.728l0.966-0.966c0.972-0.972 0.972-2.556 0-3.537l-5.031-5.031zM3.472 4.766l-2.319-3.213 0.397-0.397 3.213 2.319c0.331 0.359 0.322 0.919-0.025 1.266s-0.906 0.356-1.266 0.025zM19 1c0.094 0 0.188 0.003 0.281 0.009l-1.137 1.137c-0.094 0.094-0.147 0.222-0.147 0.353v3c0 0.275 0.225 0.5 0.5 0.5h3c0.131 0 0.259-0.053 0.353-0.147l1.141-1.137c0.006 0.094 0.009 0.191 0.009 0.284 0 2.206-1.794 4-4 4s-4-1.794-4-4 1.794-4 4-4zM5 23c-0.391 0-0.769-0.053-1.131-0.159l1.984-1.984c0.094-0.094 0.147-0.222 0.147-0.353v-2c0-0.275-0.225-0.5-0.5-0.5h-2c-0.131 0-0.259 0.053-0.353 0.147l-1.984 1.984c-0.109-0.369-0.162-0.747-0.162-1.134 0-2.206 1.794-4 4-4s4 1.794 4 4-1.794 4-4 4zM8.228 15.184l6.956-6.956c0.178 0.213 0.375 0.406 0.584 0.584l-6.953 6.959c-0.181-0.213-0.375-0.406-0.588-0.588zM13.734 14.703c-0.031 0.031-0.063 0.063-0.091 0.097-0.216-0.134-0.444-0.25-0.681-0.35l1.488-1.488c0.1 0.237 0.216 0.466 0.35 0.681-0.034 0.028-0.066 0.059-0.097 0.091l-0.969 0.969zM21.856 20.891l-0.963 0.963c-0.197 0.197-0.516 0.197-0.709 0.003l-5.031-5.031c-0.194-0.194-0.194-0.513 0-0.706l0.966-0.966c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.356 0.147l5.028 5.028c0.194 0.197 0.194 0.513 0 0.709z" })
        );
    }
    function WrenchScrewdriver({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WrenchScrewdriverSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    WrenchScrewdriver.SVG = WrenchScrewdriverSVG;
    return WrenchScrewdriver;
})();
export const Wrench = /*#__PURE__*/ (() => {
    function WrenchSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M23.159 17.391l-12.297-9.666c0.234-1.022 0.172-2.091-0.191-3.097-1.034-2.85-4.194-4.331-7.044-3.297-0.159 0.059-0.281 0.194-0.319 0.363-0.037 0.166 0.012 0.341 0.134 0.462l2.553 2.553v2.291h-2.294l-2.553-2.553c-0.122-0.122-0.297-0.172-0.462-0.134s-0.303 0.156-0.363 0.319c-0.438 1.209-0.438 2.538 0 3.744 0.5 1.381 1.509 2.484 2.838 3.109 0.741 0.347 1.534 0.522 2.328 0.522 0.534 0 1.072-0.078 1.597-0.237l11.547 10.634c0.416 0.394 0.959 0.603 1.516 0.603 0.275 0 0.553-0.053 0.819-0.156 0 0 0.003 0 0.003 0 1.503-0.609 2.491-1.681 2.937-3.188 0.25-0.831-0.050-1.741-0.75-2.272zM3.591 10.575c-1.087-0.513-1.912-1.416-2.322-2.544-0.263-0.725-0.334-1.506-0.209-2.262l2.084 2.084c0.094 0.094 0.222 0.147 0.353 0.147h3c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.131-0.053-0.259-0.147-0.353l-2.081-2.084c2.097-0.347 4.212 0.841 4.962 2.909 0.409 1.131 0.353 2.35-0.156 3.438s-1.413 1.913-2.544 2.322c-1.131 0.406-2.353 0.353-3.441-0.156zM21.997 19.081c-0.275 0.919-0.837 1.525-1.772 1.903-0.072 0.028-0.156 0.012-0.209-0.041-0.006-0.006-0.009-0.009-0.016-0.016l-11.031-10.159c0.406-0.331 0.766-0.716 1.062-1.153l11.9 9.353c0.006 0.003 0.009 0.009 0.016 0.012 0.038 0.028 0.059 0.069 0.050 0.1z" })
        );
    }
    function Wrench({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WrenchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Wrench.SVG = WrenchSVG;
    return Wrench;
})();
export const Wrench2 = /*#__PURE__*/ (() => {
    function Wrench2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 24 : '1em',
                height: originalSize ? 24 : '1em',
                viewBox: "0 0 24 24",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M19 14c-0.481 0-0.947 0.069-1.391 0.197l-7.806-7.806c0.128-0.441 0.197-0.906 0.197-1.391 0-2.756-2.244-5-5-5-0.494 0-0.984 0.072-1.453 0.216-0.169 0.050-0.297 0.187-0.341 0.356-0.044 0.172 0.006 0.35 0.131 0.475l1.662 1.659v2.294h-2.291l-1.662-1.662c-0.125-0.125-0.303-0.175-0.475-0.131s-0.306 0.172-0.356 0.341c-0.144 0.469-0.216 0.959-0.216 1.453 0 2.756 2.244 5 5 5 0.481 0 0.947-0.069 1.391-0.197l7.806 7.806c-0.128 0.441-0.197 0.906-0.197 1.391 0 2.756 2.244 5 5 5 0.791 0 1.547-0.178 2.247-0.531 0.144-0.072 0.244-0.209 0.269-0.369s-0.028-0.319-0.141-0.434l-2.375-2.375v-1.291h1.294l2.375 2.375c0.112 0.113 0.275 0.166 0.434 0.141s0.294-0.125 0.369-0.269c0.353-0.7 0.531-1.456 0.531-2.247-0.003-2.756-2.247-5-5.003-5zM1 5c0-0.094 0.003-0.191 0.009-0.284l1.141 1.137c0.094 0.094 0.222 0.147 0.353 0.147h3c0.275 0 0.5-0.225 0.5-0.5v-3c0-0.131-0.053-0.259-0.147-0.353l-1.137-1.137c0.094-0.006 0.188-0.009 0.281-0.009 2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4zM8.228 8.816c0.213-0.178 0.406-0.375 0.584-0.584l6.956 6.956c-0.213 0.178-0.406 0.375-0.584 0.584l-6.956-6.956zM22.837 20.131l-1.984-1.984c-0.094-0.094-0.222-0.147-0.353-0.147h-2c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.131 0.053 0.259 0.147 0.353l1.984 1.984c-0.366 0.106-0.744 0.162-1.131 0.162-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4c0 0.387-0.053 0.769-0.162 1.131z" })
        );
    }
    function Wrench2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Wrench2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Wrench2.SVG = Wrench2SVG;
    return Wrench2;
})();
export const Yacht = /*#__PURE__*/ (() => {
        function YachtSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M22.222 16.584c-0.35 0.231-0.625 0.416-1.222 0.416-0.203 0-0.369-0.022-0.516-0.059 0.334-0.381 0.725-0.891 1.097-1.528 0.941-1.616 1.419-3.438 1.419-5.412 0-0.319-0.153-0.619-0.409-0.806s-0.591-0.241-0.894-0.144c-0.544 0.175-1.128 0.331-1.744 0.478l-3.084-3.363c-0.094-0.103-0.228-0.162-0.369-0.162h-0.731l-1.853-2.778c-0.094-0.141-0.25-0.222-0.416-0.222h-3c-0.184 0-0.353 0.1-0.441 0.266-0.087 0.162-0.078 0.359 0.025 0.513l1.481 2.222h-4.066c-0.275 0-0.5 0.225-0.5 0.5v1.5h-3.5c-0.275 0-0.5 0.225-0.5 0.5v1.847l-0.441 0.65c-0.188 0-0.375 0-0.559 0-0.553 0-1 0.447-1 1 0 1.972 0.303 3.475 0.594 4.463-0.363-0.228-0.828-0.462-1.594-0.462v1c0.6 0 0.875 0.184 1.222 0.416 0.391 0.259 0.875 0.584 1.778 0.584s1.388-0.325 1.778-0.584c0.35-0.231 0.625-0.416 1.222-0.416s0.875 0.184 1.222 0.416c0.391 0.259 0.875 0.584 1.778 0.584s1.387-0.325 1.778-0.584c0.35-0.231 0.625-0.416 1.222-0.416 0.6 0 0.875 0.184 1.222 0.416 0.391 0.259 0.875 0.584 1.778 0.584s1.388-0.325 1.778-0.584c0.35-0.231 0.625-0.416 1.222-0.416s0.875 0.184 1.222 0.416c0.391 0.259 0.875 0.584 1.778 0.584s1.388-0.325 1.778-0.584c0.35-0.231 0.625-0.416 1.222-0.416v-1c-0.9 0-1.388 0.325-1.778 0.584zM11.434 4h1.797l1.334 2h-1.797l-1.334-2zM16.281 7l0.919 1h-6.2v1h7.116l0.706 0.772c-2.741 0.544-5.975 0.863-9.184 1.038l-1.638-2.459v-1.35h8.281zM3.912 10.781c0.056-0.081 0.087-0.181 0.087-0.281v-1.5h3.231l1.241 1.866c-1.613 0.072-3.203 0.109-4.703 0.125l0.144-0.209zM16.222 16.584c-0.35 0.231-0.625 0.416-1.222 0.416s-0.875-0.184-1.222-0.416c-0.391-0.259-0.875-0.584-1.778-0.584-0.9 0-1.387 0.325-1.778 0.584-0.35 0.231-0.625 0.416-1.222 0.416s-0.875-0.184-1.222-0.416c-0.391-0.259-0.875-0.584-1.778-0.584s-1.387 0.325-1.778 0.584c-0.131 0.087-0.25 0.166-0.381 0.234-0.156-0.347-0.681-1.659-0.813-3.819 5.672-0.034 12.85-0.375 17.875-1.647-0.156 1.1-0.509 2.122-1.053 3.056-0.491 0.844-1.013 1.388-1.284 1.644-0.169-0.031-0.359-0.050-0.572-0.050-0.894-0.003-1.381 0.322-1.772 0.581z" }),
_('path', { d: "M18 19c-0.9 0-1.388 0.325-1.778 0.584-0.35 0.231-0.625 0.416-1.222 0.416s-0.875-0.184-1.222-0.416c-0.391-0.259-0.875-0.584-1.778-0.584-0.9 0-1.387 0.325-1.778 0.584-0.35 0.231-0.625 0.416-1.222 0.416s-0.875-0.184-1.222-0.416c-0.391-0.259-0.875-0.584-1.778-0.584s-1.387 0.325-1.778 0.584c-0.347 0.231-0.622 0.416-1.222 0.416v1c0.9 0 1.388-0.325 1.778-0.584 0.35-0.231 0.625-0.416 1.222-0.416s0.875 0.184 1.222 0.416c0.391 0.259 0.875 0.584 1.778 0.584s1.388-0.325 1.778-0.584c0.35-0.231 0.625-0.416 1.222-0.416 0.6 0 0.875 0.184 1.222 0.416 0.391 0.259 0.875 0.584 1.778 0.584s1.388-0.325 1.778-0.584c0.35-0.231 0.625-0.416 1.222-0.416s0.875 0.184 1.222 0.416c0.391 0.259 0.875 0.584 1.778 0.584v-1c-0.6 0-0.875-0.184-1.222-0.416-0.391-0.259-0.878-0.584-1.778-0.584z" }),
_('path', { d: "M5 14h2v1h-2v-1z" }),
_('path', { d: "M9 14h2v1h-2v-1z" }),
_('path', { d: "M13 14h2v1h-2v-1z" }),
_('path', { d: "M17 14h2v1h-2v-1z" })
            );
        }
        function Yacht({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( YachtSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Yacht.SVG = YachtSVG;
        return Yacht;
    })();
export const Zipped = /*#__PURE__*/ (() => {
        function ZippedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M23.056 7.328c-0.603-1.428-1.469-2.712-2.572-3.813-1.103-1.103-2.384-1.966-3.813-2.572-1.481-0.625-3.053-0.944-4.672-0.944s-3.191 0.319-4.672 0.944c-1.428 0.603-2.712 1.469-3.813 2.572-1.103 1.103-1.966 2.384-2.572 3.813-0.625 1.481-0.944 3.053-0.944 4.672s0.319 3.191 0.944 4.672c0.603 1.428 1.469 2.712 2.572 3.813 1.103 1.103 2.384 1.966 3.813 2.572 1.481 0.625 3.053 0.944 4.672 0.944s3.191-0.319 4.672-0.944c1.428-0.603 2.712-1.469 3.813-2.572 1.103-1.103 1.966-2.384 2.572-3.813 0.625-1.481 0.944-3.053 0.944-4.672s-0.319-3.191-0.944-4.672zM12 22c-5.512 0-10-4.488-10-10s4.488-10 10-10c5.513 0 10 4.488 10 10s-4.488 10-10 10z" }),
_('path', { d: "M8.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM8.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M15.5 9c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5zM15.5 7c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5-0.5-0.225-0.5-0.5 0.225-0.5 0.5-0.5z" }),
_('path', { d: "M18 11h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-0.5c0-0.275-0.225-0.5-0.5-0.5h-2c-0.275 0-0.5 0.225-0.5 0.5v2c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-0.5h2v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1.084c-0.056 0.156-0.084 0.325-0.084 0.5v2c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-2c0-0.828-0.672-1.5-1.5-1.5h-1.5v-1zM5 13h-1v-1h1v1zM20 13.5v1.5h-1v-1.5c0-0.275 0.225-0.5 0.5-0.5s0.5 0.225 0.5 0.5z" })
            );
        }
        function Zipped({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ZippedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Zipped.SVG = ZippedSVG;
        return Zipped;
    })();
export const ZoomIn = /*#__PURE__*/ (() => {
        function ZoomInSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.803 2.197c-1.416-1.416-3.3-2.197-5.303-2.197s-3.888 0.781-5.303 2.197c-1.416 1.416-2.197 3.3-2.197 5.303 0 1.666 0.541 3.25 1.538 4.55l-1.125 1.125c-0.897-0.35-1.956-0.166-2.681 0.559l-6 6c-0.472 0.469-0.731 1.097-0.731 1.766s0.259 1.297 0.731 1.769c0.487 0.488 1.128 0.731 1.769 0.731s1.281-0.244 1.769-0.731l6-6c0.472-0.472 0.731-1.1 0.731-1.769 0-0.319-0.059-0.625-0.172-0.912l1.122-1.122c1.3 0.994 2.884 1.534 4.55 1.534 2.003 0 3.888-0.781 5.303-2.197s2.197-3.3 2.197-5.303-0.781-3.888-2.197-5.303zM8.853 15.853l-6 6c-0.194 0.194-0.513 0.194-0.706 0-0.128-0.128-0.147-0.275-0.147-0.353s0.019-0.225 0.147-0.353l6-6c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.128 0.128 0.147 0.275 0.147 0.353s-0.019 0.225-0.147 0.353zM16.5 13c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M17 4h-1v3h-3v1h3v3h1v-3h3v-1h-3z" })
            );
        }
        function ZoomIn({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ZoomInSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ZoomIn.SVG = ZoomInSVG;
        return ZoomIn;
    })();
export const ZoomOut = /*#__PURE__*/ (() => {
        function ZoomOutSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 24 : '1em',
                    viewBox: "0 0 24 24",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M21.803 2.197c-1.416-1.416-3.3-2.197-5.303-2.197s-3.888 0.781-5.303 2.197c-1.416 1.416-2.197 3.3-2.197 5.303 0 1.666 0.541 3.25 1.538 4.55l-1.125 1.125c-0.897-0.35-1.956-0.166-2.681 0.559l-6 6c-0.472 0.469-0.731 1.097-0.731 1.766s0.259 1.297 0.731 1.769c0.487 0.488 1.128 0.731 1.769 0.731s1.281-0.244 1.769-0.731l6-6c0.472-0.472 0.731-1.1 0.731-1.769 0-0.319-0.059-0.625-0.172-0.912l1.122-1.122c1.3 0.994 2.884 1.534 4.55 1.534 2.003 0 3.888-0.781 5.303-2.197s2.197-3.3 2.197-5.303-0.781-3.888-2.197-5.303zM8.853 15.853l-6 6c-0.194 0.194-0.513 0.194-0.706 0-0.128-0.128-0.147-0.275-0.147-0.353s0.019-0.225 0.147-0.353l6-6c0.097-0.097 0.225-0.147 0.353-0.147s0.256 0.050 0.353 0.147c0.128 0.128 0.147 0.275 0.147 0.353s-0.019 0.225-0.147 0.353zM16.5 13c-3.031 0-5.5-2.469-5.5-5.5s2.469-5.5 5.5-5.5 5.5 2.469 5.5 5.5-2.469 5.5-5.5 5.5z" }),
_('path', { d: "M13 7h7v1h-7v-1z" })
            );
        }
        function ZoomOut({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ZoomOutSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ZoomOut.SVG = ZoomOutSVG;
        return ZoomOut;
    })();
